var N2 = Object.defineProperty;
var $2 = (e, t, n) => t in e ? N2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ae = (e, t, n) => $2(e, typeof t != "symbol" ? t + "" : t, n);
import { createI18n as Wv, useI18n as fn } from "vue-i18n";
import { onBeforeUnmount as io, nextTick as Xe, defineComponent as de, shallowRef as Qe, computed as D, openBlock as v, createBlock as z, resolveDynamicComponent as Ot, mergeProps as at, onMounted as Et, onUnmounted as ks, normalizeProps as pi, guardReactiveProps as Sa, unref as T, reactive as Uv, ref as W, hasInjectionContext as qd, toValue as xe, watchEffect as jd, getCurrentInstance as $n, inject as Mi, watch as Re, getCurrentScope as Yd, onScopeDispose as ro, useTemplateRef as tn, toRefs as Kv, useModel as lt, markRaw as z2, createElementBlock as y, mergeModels as dt, mergeDefaults as W2, toRaw as Ff, isRef as Yo, isReactive as U2, isProxy as K2, createVNode as te, render as dr, shallowReadonly as Zs, toRef as Z2, readonly as Qo, customRef as q2, normalizeClass as x, createElementVNode as R, createCommentVNode as V, useCssVars as Ls, normalizeStyle as Ke, useSlots as rn, Fragment as Se, renderSlot as ve, createTextVNode as Oe, toDisplayString as se, Teleport as qi, withCtx as Q, renderList as We, h as vo, withModifiers as Ge, onUpdated as j2, resolveDirective as gg, withDirectives as Tn, provide as pg, createSlots as Wn, withKeys as Uo, TransitionGroup as Y2, vModelText as Qd, Transition as ad, createApp as Q2, vShow as cr, useId as Es, onActivated as J2, onDeactivated as X2, defineAsyncComponent as e8, useAttrs as t8, Comment as Zv, useCssModule as n8 } from "vue";
import { useModal as o8, useSnack as s8, useSnackbar as i8 } from "vue-haystack";
const r8 = [
  { bgColor: "#DEE3E7", textColor: "#272E35", hoverBgColor: "#555F6D", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FCDEC0", textColor: "#7A4510", hoverBgColor: "#F59638", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FCD9D9", textColor: "#6F2020", hoverBgColor: "#C53434", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FBD5E2", textColor: "#671E36", hoverBgColor: "#C03060", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FBD5EE", textColor: "#671E4E", hoverBgColor: "#B12F86", hoverTextColor: "#FFFFFF" },
  { bgColor: "#F5D5FB", textColor: "#5B1E67", hoverBgColor: "#9939AC", hoverTextColor: "#FFFFFF" },
  { bgColor: "#EDDBFF", textColor: "#4C2277", hoverBgColor: "#8040BF", hoverTextColor: "#FFFFFF" },
  { bgColor: "#E3E0FF", textColor: "#39288A", hoverBgColor: "#634ECA", hoverTextColor: "#FFFFFF" },
  { bgColor: "#D7E4FF", textColor: "#113997", hoverBgColor: "#3062D4", hoverTextColor: "#FFFFFF" },
  { bgColor: "#CCE7FF", textColor: "#0C456E", hoverBgColor: "#0870BA", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C5ECF7", textColor: "#0A495C", hoverBgColor: "#077597", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C5F2EC", textColor: "#0D4A42", hoverBgColor: "#097C69", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C6F1DA", textColor: "#0E4E30", hoverBgColor: "#1D7C4D", hoverTextColor: "#FFFFFF" },
  { bgColor: "#CFF2CF", textColor: "#135315", hoverBgColor: "#347434", hoverTextColor: "#FFFFFF" }
], a8 = { label: { optional: "(optional)", help: "Hilfe", maxSizeOf: "Maximale Grösse von {size}.", and: "UND", autosizeColumns: "Alle Spalten automatisch anpassen", autosizeColumn: "Diese Spalte automatisch anpassen", contains: "Enthält", false: "Falsch", greaterEquals: "Grösser oder gleich", lessEquals: "Weniger oder gleich", options: "Mehr Optionen", pin: "Kein pin", contains2: "Enthält nicht", equals: "Entspricht nicht", or: "ODER", pinColumn: "Spalte anheften", pinLeft: "Links anheften", pinRight: "Rechts anheften", pleaseConfirmAction: "Bitte bestätigen Sie Ihre Aktion.", selected: "Ausgewählt", tabLabel: "Tab-Bezeichnung", tabRenameReorderHint: "Doppelklicken zum Umbenennen & Ziehen zum Neuordnen", stepCannotUndone: "Dieser Schritt kann nicht rückgängig gemacht werden.", true: "Wahr", valuesBracketsRepresent: "Werte in Klammern stellen verschachtelte Datensätze dar", unsavedChangesLike: "Sie haben ungesicherte Änderungen. Möchten Sie diese vor dem Verlassen speichern?", moreDragged: "(+ {count} weitere)" }, action: { selectAll: "(Alle auswählen)", start: "Start", end: "Ende", addFilter: "Filter hinzufügen", addFilter2: "Filter oder Gruppe hinzufügen", addGroup2: "Gruppe hinzufügen", addTab2: "Neuen Tab hinzufügen", apply: "Anwenden", cancel: "Abbrechen", clear: "Zurücksetzen", close: "Schliessen", collapseRow: "Alle Zeilengruppen einklappen", confirm: "Bestätigen", continueEditing: "Bearbeitung fortsetzen", delete: "Löschen", deleteRecord: "Beleg löschen?", dragDrop: "Ziehen & Loslassen oder", enterValue: "Wert eingeben", expandRow: "Alle Zeilengruppen ausklappen", filter: "Filter...", hideColumn: "Spalte ausblenden", moveDown: "Nach unten bewegen", moveUp: "Nach oben bewegen", ok: "OK", remove: "Entfernen", removeTab: "Tab entfernen", resetColumns: "Spalten zurücksetzen", save: "Speichern", saveChanges: "Änderung speichern?", search: "Suchen", selectColumn: "Spalte auswählen", selectOption: "Option auswählen", showLess: "Weniger anzeigen", show: "Mehr anzeigen", sortAscending: "Aufsteigend sortieren", sortDescending: "Absteigend sortieren", upload2: "Hochladen" }, message: { confirmDiscardChanges: "Sind Sie sicher, dass Sie Ihre Änderungen verwerfen möchten? Dieser schritt kann nicht Rückgängig gemacht werden.", errorError2: "Fehler!" }, placeholder: { file: "Anhang auswählen" }, emptyState: { empty2: "Keine Einträge vorhanden" } }, l8 = { today: "Heute", settings: "Kalendereinstellungen", months: "Monate", columns: "Spalten", start: "Start", end: "Ende", h: "h", hours: "Stunden", m: "min", minutes: "Minuten", seconds: "Sekunden", allDay: "Ganztg.", weekShort: "KW", previousMonth: "Voriger Monat", nextMonth: "Nächster Monat", sectionChars: { day: "T", month: "M", year: "J" }, sectionNames: { day: "Tag", month: "Monat", year: "Jahr", hours: "Stunden", minutes: "Minuten", seconds: "Sekunden", milliseconds: "Millisekunden", meridiem: "AM/PM" } }, d8 = { tableBar: { label: { discard: "Verwerfen", discardChanges2: "Änderungen verwerfen?" } } }, c8 = { src: { label: { equals: "Entspricht", greater: "Grösser als", less: "Kleiner als" } } }, u8 = { plainFallbackNotice: "Die Formatierung ist derzeit nicht verfügbar, daher wird der zugrunde liegende HTML-Code als reiner Text angezeigt.", toolbar: { label: "Formatierung", tableLabel: "Tabelle", undo: "Rückgängig", redo: "Wiederholen", bold: "Fett", italic: "Kursiv", highlight: "Hintergrundfarbe", removeColor: "Farbe entfernen", link: "Link", align: { left: "Linksbündig", center: "Zentriert", right: "Rechtsbündig", justify: "Blocksatz" }, bulletList: "Aufzählung", orderedList: "Nummerierung", outdent: "Einzug verkleinern", indent: "Einzug vergrößern", clearFormatting: "Formatierung entfernen", help: "Tastenkombinationen", source: "Quellcode", customColor: "Benutzerdefinierte Farbe", more: "Mehr" }, listStyle: { default: "Standard", circle: "Kreis", disc: "Punkt", square: "Quadrat", lowerAlpha: "Kleinbuchstaben", lowerGreek: "Griechisch", lowerRoman: "Römisch klein", upperAlpha: "Großbuchstaben", upperRoman: "Römisch groß" }, link: { title: "Link", url: "URL", text: "Anzeigetext", newWindow: "In neuem Fenster öffnen" }, source: { title: "Quellcode" }, wordCount: { count: "Anzahl", document: "Dokument", selection: "Auswahl", words: "Wörter", charactersNoSpaces: "Zeichen (ohne Leerzeichen)", characters: "Zeichen" }, help: { title: "Tastenkombinationen", underline: "Unterstrichen" }, menu: { file: "Datei", newDocument: "Neues Dokument", preview: "Vorschau", print: "Drucken...", edit: "Bearbeiten", cut: "Ausschneiden", copy: "Kopieren", paste: "Einfügen", pasteAsText: "Als Text einfügen", selectAll: "Alles auswählen", pasteBlocked: "Ihr Browser hat den Zugriff auf die Zwischenablage nicht erlaubt. Fügen Sie mit Strg+V ein, als reinen Text mit Strg+Umschalt+V.", view: "Ansicht", insert: "Einfügen", horizontalLine: "Horizontale Linie", format: "Format", underline: "Unterstrichen", strikethrough: "Durchgestrichen", code: "Code", help: "Hilfe", insertTable: "Tabelle...", table: "Tabelle", tools: "Werkzeuge", wordCount: "Anzahl der Wörter", mergeCells: "Zellen verbinden", splitCell: "Zelle aufteilen", insertRowBefore: "Neue Zeile oberhalb einfügen", insertRowAfter: "Neue Zeile unterhalb einfügen", deleteRow: "Zeile löschen", insertColumnBefore: "Neue Spalte links einfügen", insertColumnAfter: "Neue Spalte rechts einfügen", deleteColumn: "Spalte löschen", cutRow: "Zeile ausschneiden", copyRow: "Zeile kopieren", pasteRowBefore: "Zeile oberhalb einfügen", pasteRowAfter: "Zeile unterhalb einfügen", cutColumn: "Spalte ausschneiden", copyColumn: "Spalte kopieren", pasteColumnBefore: "Spalte links einfügen", pasteColumnAfter: "Spalte rechts einfügen", deleteTable: "Tabelle löschen", cellProperties: "Zelleneigenschaften", rowProperties: "Zeileneigenschaften", tableProperties: "Tabelleneigenschaften", cell: "Zelle", row: "Zeile", column: "Spalte", superscript: "Hochgestellt", subscript: "Tiefgestellt", formats: "Formate", blocks: "Blöcke", fonts: "Schriftarten", fontSizes: "Schriftgrößen", align: "Ausrichtung", lineHeight: "Zeilenhöhe", textColor: "Textfarbe", backgroundColor: "Hintergrundfarbe", image: "Bild..." }, table: { insertTitle: "Tabelle einfügen", rows: "Zeilen", columns: "Spalten", tableTitle: "Tabelleneigenschaften", rowTitle: "Zeileneigenschaften", cellTitle: "Zelleneigenschaften", general: "Allgemein", advanced: "Erweitert", width: "Breite", height: "Höhe", cellSpacing: "Zellenabstand", cellPadding: "Zelleninnenabstand", borderWidth: "Rahmenbreite", borderStyle: "Rahmenstil", borderColor: "Rahmenfarbe", backgroundColor: "Hintergrundfarbe", pickColor: "Farbe auswählen", alignment: "Ausrichtung", rowType: "Zeilentyp", cellType: "Zelltyp", scope: "Bereich", horizontalAlign: "Horizontale Ausrichtung", verticalAlign: "Vertikale Ausrichtung", none: "Keine", select: "Auswählen...", left: "Links", center: "Zentriert", right: "Rechts", top: "Oben", middle: "Mitte", bottom: "Unten", header: "Kopfzeile", body: "Hauptteil", footer: "Fußzeile", cell: "Zelle", headerCell: "Kopfzelle", scopeRow: "Zeile", scopeColumn: "Spalte", scopeRowGroup: "Zeilengruppe", scopeColumnGroup: "Spaltengruppe", borderStyles: { solid: "Durchgezogen", dotted: "Gepunktet", dashed: "Gestrichelt", double: "Doppelt", groove: "Gerillt", ridge: "Gerippt", inset: "Eingelassen", outset: "Hervorstehend", none: "Keine", hidden: "Ausgeblendet" } }, format: { headings: "Überschriften", inline: "Zeichenformate", blocks: "Blöcke", align: "Ausrichtung", paragraph: "Absatz", heading1: "Überschrift 1", heading2: "Überschrift 2", heading3: "Überschrift 3", heading4: "Überschrift 4", heading5: "Überschrift 5", heading6: "Überschrift 6", blockquote: "Blockzitat", div: "Div", pre: "Präformatiert", preformatted: "Vorformatiert", left: "Links", center: "Zentriert", right: "Rechts", justify: "Blocksatz" }, image: { title: "Bild einfügen/bearbeiten", source: "Quelle", alt: "Alternative Beschreibung", width: "Breite", height: "Höhe", constrain: "Seitenverhältnis beibehalten" } }, h8 = { operator: { contains: "Enthält", notContains: "Enthält nicht", equals: "Entspricht", notEquals: "Entspricht nicht", startsWith: "Beginnt mit", endsWith: "Endet mit", greaterThan: "Größer als", greaterOrEquals: "Größer als oder gleich", lessThan: "Kleiner als", lessOrEquals: "Kleiner als oder gleich", before: "Vor", after: "Nach", between: "Zwischen", blank: "Leer", notBlank: "Nicht leer" }, condition: { remove: "Bedingung entfernen" }, range: { from: "Von", to: "Bis", invalidNumber: "Von darf nicht größer als Bis sein", invalidDate: "Der Anfang darf nicht nach dem Ende liegen" }, list: { openConditions: "Textbedingungen", noOptions: "Keine Optionen", blank: "(Leer)", allExcept: "Alle außer {values}" } }, g8 = {
  common: a8,
  datetimePicker: l8,
  settings: d8,
  record: c8,
  richText: u8,
  columnFilter: h8
}, p8 = { label: { optional: "(optional)", help: "Help", maxSizeOf: "Max Size of {size}.", and: "AND", autosizeColumns: "Autosize all columns", autosizeColumn: "Autosize this column", contains: "Contains", false: "False", greaterEquals: "Greater or equals", lessEquals: "Less or equals", options: "More options", pin: "No pin", contains2: "Not contains", equals: "Not equals", or: "OR", pinColumn: "Pin column", pinLeft: "Pin left", pinRight: "Pin right", pleaseConfirmAction: "Please confirm your action.", selected: "Selected", tabLabel: "Tab label", tabRenameReorderHint: "Rename on double click & Drag to reorder", stepCannotUndone: "This step cannot be undone.", true: "True", valuesBracketsRepresent: "Values in brackets represent nested records", unsavedChangesLike: "You have unsaved changes. Would you like to save them before leaving?", moreDragged: "(+ {count} more)" }, action: { selectAll: "(Select All)", start: "Start", end: "End", addFilter: "Add filter", addFilter2: "Add filter or group", addGroup2: "Add group", addTab2: "Add new tab", apply: "Apply", cancel: "Cancel", clear: "Clear", close: "Close", collapseRow: "Collapse all row groups", confirm: "Confirm", continueEditing: "Continue editing", delete: "Delete", deleteRecord: "Delete record?", dragDrop: "Drag & Drop or", enterValue: "Enter value", expandRow: "Expand all row groups", filter: "Filter…", hideColumn: "Hide column", moveDown: "Move down", moveUp: "Move up", ok: "OK", remove: "Remove", removeTab: "Remove tab", resetColumns: "Reset columns", save: "Save", saveChanges: "Save changes before leaving?", search: "Search", selectColumn: "Select a column", selectOption: "Select an option", showLess: "Show less", show: "Show more", sortAscending: "Sort ascending", sortDescending: "Sort descending", upload2: "to upload" }, message: { confirmDiscardChanges: "Are you sure you want to discard your changes? These changes cannot be undone.", errorError2: "Error!" }, placeholder: { file: "Choose attachment" }, emptyState: { empty2: "No items available" } }, f8 = { today: "Today", settings: "Calendar settings", months: "Months", columns: "Columns", start: "Start", end: "End", h: "h", hours: "Hours", m: "min", minutes: "Minutes", seconds: "Seconds", allDay: "All day", weekShort: "Wk", previousMonth: "Previous month", nextMonth: "Next month", sectionChars: { day: "D", month: "M", year: "Y" }, sectionNames: { day: "Day", month: "Month", year: "Year", hours: "Hours", minutes: "Minutes", seconds: "Seconds", milliseconds: "Milliseconds", meridiem: "AM/PM" } }, m8 = { tableBar: { label: { discard: "Discard", discardChanges2: "Discard changes?" } } }, v8 = { src: { label: { equals: "Equals", greater: "Greater than", less: "Less than" } } }, C8 = { plainFallbackNotice: "Formatting is unavailable right now, so this shows the underlying HTML as plain text.", toolbar: { label: "Formatting", tableLabel: "Table", undo: "Undo", redo: "Redo", bold: "Bold", italic: "Italic", highlight: "Background color", removeColor: "Remove color", link: "Link", align: { left: "Align left", center: "Align center", right: "Align right", justify: "Justify" }, bulletList: "Bullet list", orderedList: "Numbered list", outdent: "Decrease indent", indent: "Increase indent", clearFormatting: "Clear formatting", help: "Keyboard shortcuts", source: "Source code", customColor: "Custom color", more: "More" }, listStyle: { default: "Default", circle: "Circle", disc: "Disc", square: "Square", lowerAlpha: "Lower alpha", lowerGreek: "Lower Greek", lowerRoman: "Lower Roman", upperAlpha: "Upper alpha", upperRoman: "Upper Roman" }, link: { title: "Link", url: "URL", text: "Text to display", newWindow: "Open in new window" }, source: { title: "Source code" }, wordCount: { count: "Count", document: "Document", selection: "Selection", words: "Words", charactersNoSpaces: "Characters (no spaces)", characters: "Characters" }, help: { title: "Keyboard shortcuts", underline: "Underline" }, menu: { file: "File", newDocument: "New document", preview: "Preview", print: "Print...", edit: "Edit", cut: "Cut", copy: "Copy", paste: "Paste", pasteAsText: "Paste as text", selectAll: "Select all", pasteBlocked: "Your browser did not allow access to the clipboard. Paste with Ctrl+V, or Ctrl+Shift+V for plain text.", view: "View", insert: "Insert", horizontalLine: "Horizontal line", format: "Format", underline: "Underline", strikethrough: "Strikethrough", code: "Code", help: "Help", insertTable: "Table...", table: "Table", tools: "Tools", wordCount: "Word count", mergeCells: "Merge cells", splitCell: "Split cell", insertRowBefore: "Insert row before", insertRowAfter: "Insert row after", deleteRow: "Delete row", insertColumnBefore: "Insert column before", insertColumnAfter: "Insert column after", deleteColumn: "Delete column", cutRow: "Cut row", copyRow: "Copy row", pasteRowBefore: "Paste row before", pasteRowAfter: "Paste row after", cutColumn: "Cut column", copyColumn: "Copy column", pasteColumnBefore: "Paste column before", pasteColumnAfter: "Paste column after", deleteTable: "Delete table", cellProperties: "Cell properties", rowProperties: "Row properties", tableProperties: "Table properties", cell: "Cell", row: "Row", column: "Column", superscript: "Superscript", subscript: "Subscript", formats: "Formats", blocks: "Blocks", fonts: "Fonts", fontSizes: "Font sizes", align: "Align", lineHeight: "Line height", textColor: "Text color", backgroundColor: "Background color", image: "Image..." }, table: { insertTitle: "Insert table", rows: "Rows", columns: "Columns", tableTitle: "Table properties", rowTitle: "Row properties", cellTitle: "Cell properties", general: "General", advanced: "Advanced", width: "Width", height: "Height", cellSpacing: "Cell spacing", cellPadding: "Cell padding", borderWidth: "Border width", borderStyle: "Border style", borderColor: "Border color", backgroundColor: "Background color", pickColor: "Pick a color", alignment: "Alignment", rowType: "Row type", cellType: "Cell type", scope: "Scope", horizontalAlign: "Horizontal align", verticalAlign: "Vertical align", none: "None", select: "Select...", left: "Left", center: "Center", right: "Right", top: "Top", middle: "Middle", bottom: "Bottom", header: "Header", body: "Body", footer: "Footer", cell: "Cell", headerCell: "Header cell", scopeRow: "Row", scopeColumn: "Column", scopeRowGroup: "Row group", scopeColumnGroup: "Column group", borderStyles: { solid: "Solid", dotted: "Dotted", dashed: "Dashed", double: "Double", groove: "Groove", ridge: "Ridge", inset: "Inset", outset: "Outset", none: "None", hidden: "Hidden" } }, format: { headings: "Headings", inline: "Inline", blocks: "Blocks", align: "Align", paragraph: "Paragraph", heading1: "Heading 1", heading2: "Heading 2", heading3: "Heading 3", heading4: "Heading 4", heading5: "Heading 5", heading6: "Heading 6", blockquote: "Blockquote", div: "Div", pre: "Pre", preformatted: "Preformatted", left: "Left", center: "Center", right: "Right", justify: "Justify" }, image: { title: "Insert/Edit Image", source: "Source", alt: "Alternative description", width: "Width", height: "Height", constrain: "Constrain proportions" } }, w8 = { operator: { contains: "Contains", notContains: "Does not contain", equals: "Equals", notEquals: "Does not equal", startsWith: "Starts with", endsWith: "Ends with", greaterThan: "Greater than", greaterOrEquals: "Greater than or equal", lessThan: "Less than", lessOrEquals: "Less than or equal", before: "Before", after: "After", between: "Between", blank: "Blank", notBlank: "Not blank" }, condition: { remove: "Remove condition" }, range: { from: "From", to: "To", invalidNumber: "From must not be greater than To", invalidDate: "The start must not be after the end" }, list: { openConditions: "Text conditions", noOptions: "No options", blank: "(Blank)", allExcept: "All except {values}" } }, y8 = {
  common: p8,
  datetimePicker: f8,
  settings: m8,
  record: v8,
  richText: C8,
  columnFilter: w8
}, fg = Wv({
  legacy: !1,
  locale: "en",
  fallbackLocale: "en",
  messages: { de: g8, en: y8 },
  missingWarn: !1,
  fallbackWarn: !1
}), Un = (e, t) => fg.global.t(e, t ?? {}), yMe = (e) => {
  fg.global.locale.value = e;
};
var ot = /* @__PURE__ */ ((e) => (e.AND = "AND", e.OR = "OR", e))(ot || {});
function to(e) {
  return Array.isArray(e.conditions);
}
function b8(e) {
  return e.flatMap((t) => to(t) ? b8(t.conditions) : [t]);
}
var De = /* @__PURE__ */ ((e) => (e.EQUALS = "EQ", e.NOT_EQUALS = "NEQ", e.GREATER_THAN = "GT", e.LESS_THAN = "LT", e.GREATER_OR_EQUALS = "GTE", e.LESS_OR_EQUALS = "LTE", e.CONTAINS = "CONTAINS", e.NOT_CONTAINS = "NOT_CONTAINS", e.STARTS_WITH = "STARTS_WITH", e.ENDS_WITH = "ENDS_WITH", e.BLANK = "BLANK", e.NOT_BLANK = "NOT_BLANK", e.IN_RANGE = "IN_RANGE", e))(De || {});
const xa = {
  [De.CONTAINS]: { labelKey: "columnFilter.operator.contains", icon: "phosphor/brackets-square", arity: 1 },
  [De.NOT_CONTAINS]: {
    labelKey: "columnFilter.operator.notContains",
    icon: "phosphor/text-t-slash",
    arity: 1
  },
  [De.EQUALS]: { labelKey: "columnFilter.operator.equals", icon: "phosphor/equals", arity: 1 },
  [De.NOT_EQUALS]: { labelKey: "columnFilter.operator.notEquals", icon: "phosphor/not-equals", arity: 1 },
  [De.GREATER_THAN]: {
    labelKey: "columnFilter.operator.greaterThan",
    icon: "phosphor/greater-than",
    arity: 1
  },
  [De.GREATER_OR_EQUALS]: {
    labelKey: "columnFilter.operator.greaterOrEquals",
    icon: "phosphor/greater-than-or-equal",
    arity: 1
  },
  [De.LESS_THAN]: { labelKey: "columnFilter.operator.lessThan", icon: "phosphor/less-than", arity: 1 },
  [De.LESS_OR_EQUALS]: {
    labelKey: "columnFilter.operator.lessOrEquals",
    icon: "phosphor/less-than-or-equal",
    arity: 1
  },
  [De.STARTS_WITH]: {
    labelKey: "columnFilter.operator.startsWith",
    icon: "phosphor/arrow-bend-left-down",
    arity: 1
  },
  [De.ENDS_WITH]: {
    labelKey: "columnFilter.operator.endsWith",
    icon: "phosphor/arrow-bend-right-down",
    arity: 1
  },
  [De.BLANK]: { labelKey: "columnFilter.operator.blank", icon: "phosphor/circle-dashed", arity: 0 },
  [De.NOT_BLANK]: { labelKey: "columnFilter.operator.notBlank", icon: "phosphor/circle", arity: 0 },
  [De.IN_RANGE]: {
    labelKey: "columnFilter.operator.between",
    icon: "phosphor/arrows-horizontal",
    arity: 2
  }
}, $l = {
  text: [
    De.CONTAINS,
    De.NOT_CONTAINS,
    De.EQUALS,
    De.NOT_EQUALS,
    De.STARTS_WITH,
    De.ENDS_WITH,
    De.BLANK,
    De.NOT_BLANK
  ],
  number: [
    De.EQUALS,
    De.NOT_EQUALS,
    De.GREATER_THAN,
    De.GREATER_OR_EQUALS,
    De.LESS_THAN,
    De.LESS_OR_EQUALS,
    De.IN_RANGE,
    De.BLANK,
    De.NOT_BLANK
  ],
  date: [
    De.EQUALS,
    De.NOT_EQUALS,
    De.LESS_THAN,
    De.GREATER_THAN,
    De.IN_RANGE
  ]
};
function qv(e) {
  return e.blankConditions ? [] : Yv;
}
const jv = De.CONTAINS, S8 = {
  date: {
    [De.LESS_THAN]: "columnFilter.operator.before",
    [De.GREATER_THAN]: "columnFilter.operator.after"
  }
};
De.IN_RANGE;
const Yv = Object.keys(xa).filter(
  (e) => xa[e].arity === 0
);
function fi(e) {
  return Yv.includes(e);
}
function mg(e, t) {
  var n;
  return Un((t && ((n = S8[t]) == null ? void 0 : n[e])) ?? xa[e].labelKey);
}
function ld(e) {
  return Un(e === ot.OR ? "common.label.or" : "common.label.and");
}
function x8(e) {
  if (e.kind === "list") {
    if (!e.textConditions) return [];
    const n = qv(e);
    return $l.text.filter((o) => !n.includes(o));
  }
  if (e.kind === "date") return $l.date;
  const t = e.disabledOperators ?? [];
  return $l[e.kind].filter(
    (n) => !e.excludedOperators.includes(n) && !t.includes(n)
  );
}
function oh(e, t = [], n = []) {
  return $l[e].filter((o) => !t.includes(o)).map((o) => ({
    value: o,
    label: mg(o, e),
    icon: xa[o].icon,
    disabled: n.includes(o)
  }));
}
const R8 = "dd.MM.yyyy", E8 = "HH:mm", A8 = 4, F8 = 400, Qv = 6048e5, M8 = 864e5, I8 = 6e4, P8 = 36e5, D8 = 1e3, Mf = Symbol.for("constructDateFrom");
function Rt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Mf in e ? e[Mf](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function it(e, t) {
  return Rt(t || e, e);
}
function ji(e, t, n) {
  const o = it(e, n == null ? void 0 : n.in);
  return isNaN(t) ? Rt((n == null ? void 0 : n.in) || e, NaN) : (t && o.setDate(o.getDate() + t), o);
}
function If(e, t, n) {
  const o = it(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return Rt(e, NaN);
  if (!t)
    return o;
  const s = o.getDate(), i = Rt(e, o.getTime());
  i.setMonth(o.getMonth() + t + 1, 0);
  const r = i.getDate();
  return s >= r ? i : (o.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), o);
}
function T8(e, t) {
  const n = it(e, t == null ? void 0 : t.in).getDay();
  return n === 0 || n === 6;
}
let k8 = {};
function Dr() {
  return k8;
}
function Mo(e, t) {
  var a, l, d, c;
  const n = Dr(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = it(e, t == null ? void 0 : t.in), i = s.getDay(), r = (i < o ? 7 : 0) + i - o;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function ur(e, t) {
  return Mo(e, { ...t, weekStartsOn: 1 });
}
function Jv(e, t) {
  const n = it(e, t == null ? void 0 : t.in), o = n.getFullYear(), s = Rt(n, 0);
  s.setFullYear(o + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = ur(s), r = Rt(n, 0);
  r.setFullYear(o, 0, 4), r.setHours(0, 0, 0, 0);
  const a = ur(r);
  return n.getTime() >= i.getTime() ? o + 1 : n.getTime() >= a.getTime() ? o : o - 1;
}
function dd(e) {
  const t = it(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Xv(e, ...t) {
  const n = Rt.bind(
    null,
    t.find((o) => typeof o == "object")
  );
  return t.map(n);
}
function mt(e, t) {
  const n = it(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function e1(e, t, n) {
  const [o, s] = Xv(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = mt(o), r = mt(s), a = +i - dd(i), l = +r - dd(r);
  return Math.round((a - l) / M8);
}
function L8(e, t) {
  const n = Jv(e, t), o = Rt(e, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), ur(o);
}
function B8(e) {
  return Rt(e, Date.now());
}
function gs(e, t, n) {
  const [o, s] = Xv(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +mt(o) == +mt(s);
}
function O8(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function vg(e) {
  return !(!O8(e) && typeof e != "number" || isNaN(+it(e)));
}
function Pf(e, t) {
  const n = it(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function G8(e, t) {
  const n = it(e, t == null ? void 0 : t.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Yr(e, t) {
  const n = it(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function H8(e, t) {
  const n = it(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const V8 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, _8 = (e, t, n) => {
  let o;
  const s = V8[e];
  return typeof s == "string" ? o = s : t === 1 ? o = s.one : o = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function Yi(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const N8 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, $8 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, z8 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, W8 = {
  date: Yi({
    formats: N8,
    defaultWidth: "full"
  }),
  time: Yi({
    formats: $8,
    defaultWidth: "full"
  }),
  dateTime: Yi({
    formats: z8,
    defaultWidth: "full"
  })
}, U8 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, K8 = (e, t, n, o) => U8[e];
function Co(e) {
  return (t, n) => {
    const o = n != null && n.context ? String(n.context) : "standalone";
    let s;
    if (o === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : r;
      s = e.formattingValues[a] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      s = e.values[a] || e.values[r];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[i];
  };
}
const Z8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, q8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, j8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Y8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Q8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, J8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, X8 = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, e6 = {
  ordinalNumber: X8,
  era: Co({
    values: Z8,
    defaultWidth: "wide"
  }),
  quarter: Co({
    values: q8,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Co({
    values: j8,
    defaultWidth: "wide"
  }),
  day: Co({
    values: Y8,
    defaultWidth: "wide"
  }),
  dayPeriod: Co({
    values: Q8,
    defaultWidth: "wide",
    formattingValues: J8,
    defaultFormattingWidth: "wide"
  })
};
function wo(e) {
  return (t, n = {}) => {
    const o = n.width, s = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], i = t.match(s);
    if (!i)
      return null;
    const r = i[0], a = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? n6(a, (u) => u.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      t6(a, (u) => u.test(r))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const c = t.slice(r.length);
    return { value: d, rest: c };
  };
}
function t6(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function n6(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function t1(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const s = o[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let r = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    r = n.valueCallback ? n.valueCallback(r) : r;
    const a = t.slice(s.length);
    return { value: r, rest: a };
  };
}
const o6 = /^(\d+)(th|st|nd|rd)?/i, s6 = /\d+/i, i6 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, r6 = {
  any: [/^b/i, /^(a|c)/i]
}, a6 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, l6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, d6 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, c6 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, u6 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, h6 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, g6 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, p6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, f6 = {
  ordinalNumber: t1({
    matchPattern: o6,
    parsePattern: s6,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: wo({
    matchPatterns: i6,
    defaultMatchWidth: "wide",
    parsePatterns: r6,
    defaultParseWidth: "any"
  }),
  quarter: wo({
    matchPatterns: a6,
    defaultMatchWidth: "wide",
    parsePatterns: l6,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: wo({
    matchPatterns: d6,
    defaultMatchWidth: "wide",
    parsePatterns: c6,
    defaultParseWidth: "any"
  }),
  day: wo({
    matchPatterns: u6,
    defaultMatchWidth: "wide",
    parsePatterns: h6,
    defaultParseWidth: "any"
  }),
  dayPeriod: wo({
    matchPatterns: g6,
    defaultMatchWidth: "any",
    parsePatterns: p6,
    defaultParseWidth: "any"
  })
}, Cg = {
  code: "en-US",
  formatDistance: _8,
  formatLong: W8,
  formatRelative: K8,
  localize: e6,
  match: f6,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function m6(e, t) {
  const n = it(e, t == null ? void 0 : t.in);
  return e1(n, H8(n)) + 1;
}
function n1(e, t) {
  const n = it(e, t == null ? void 0 : t.in), o = +ur(n) - +L8(n);
  return Math.round(o / Qv) + 1;
}
function wg(e, t) {
  var c, u, h, g;
  const n = it(e, t == null ? void 0 : t.in), o = n.getFullYear(), s = Dr(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((g = (h = s.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, r = Rt((t == null ? void 0 : t.in) || e, 0);
  r.setFullYear(o + 1, 0, i), r.setHours(0, 0, 0, 0);
  const a = Mo(r, t), l = Rt((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(o, 0, i), l.setHours(0, 0, 0, 0);
  const d = Mo(l, t);
  return +n >= +a ? o + 1 : +n >= +d ? o : o - 1;
}
function v6(e, t) {
  var a, l, d, c;
  const n = Dr(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = wg(e, t), i = Rt((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(s, 0, o), i.setHours(0, 0, 0, 0), Mo(i, t);
}
function yg(e, t) {
  const n = it(e, t == null ? void 0 : t.in), o = +Mo(n, t) - +v6(n, t);
  return Math.round(o / Qv) + 1;
}
function ct(e, t) {
  const n = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return n + o;
}
const rs = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
    return ct(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ct(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ct(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ct(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ct(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ct(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ct(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, o = e.getMilliseconds(), s = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return ct(s, t.length);
  }
}, Oi = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Df = {
  // Era
  G: function(e, t, n) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const o = e.getFullYear(), s = o > 0 ? o : 1 - o;
      return n.ordinalNumber(s, { unit: "year" });
    }
    return rs.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, o) {
    const s = wg(e, o), i = s > 0 ? s : 1 - s;
    if (t === "YY") {
      const r = i % 100;
      return ct(r, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : ct(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Jv(e);
    return ct(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ct(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return ct(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return ct(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return rs.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return ct(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, o) {
    const s = yg(e, o);
    return t === "wo" ? n.ordinalNumber(s, { unit: "week" }) : ct(s, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const o = n1(e);
    return t === "Io" ? n.ordinalNumber(o, { unit: "week" }) : ct(o, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : rs.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const o = m6(e);
    return t === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : ct(o, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const o = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, o) {
    const s = e.getDay(), i = (s - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return ct(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, o) {
    const s = e.getDay(), i = (s - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return ct(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const o = e.getDay(), s = o === 0 ? 7 : o;
    switch (t) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return ct(s, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const o = e.getHours();
    let s;
    switch (o === 12 ? s = Oi.noon : o === 0 ? s = Oi.midnight : s = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const o = e.getHours();
    let s;
    switch (o >= 17 ? s = Oi.evening : o >= 12 ? s = Oi.afternoon : o >= 4 ? s = Oi.morning : s = Oi.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return rs.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : rs.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const o = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : ct(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : ct(o, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : rs.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : rs.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return rs.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return kf(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return qs(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return qs(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return kf(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return qs(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return qs(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Tf(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + qs(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Tf(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + qs(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const o = Math.trunc(+e / 1e3);
    return ct(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return ct(+e, t.length);
  }
};
function Tf(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), s = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(s) : n + String(s) + t + ct(i, 2);
}
function kf(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ct(Math.abs(e) / 60, 2) : qs(e, t);
}
function qs(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), s = ct(Math.trunc(o / 60), 2), i = ct(o % 60, 2);
  return n + s + t + i;
}
const Lf = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, o1 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, C6 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], o = n[1], s = n[2];
  if (!s)
    return Lf(e, t);
  let i;
  switch (o) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Lf(o, t)).replace("{{time}}", o1(s, t));
}, sh = {
  p: o1,
  P: C6
}, w6 = /^D+$/, y6 = /^Y+$/, b6 = ["D", "DD", "YY", "YYYY"];
function s1(e) {
  return w6.test(e);
}
function i1(e) {
  return y6.test(e);
}
function ih(e, t, n) {
  const o = S6(e, t, n);
  if (console.warn(o), b6.includes(e)) throw new RangeError(o);
}
function S6(e, t, n) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const x6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, R6 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, E6 = /^'([^]*?)'?$/, A6 = /''/g, F6 = /[a-zA-Z]/;
function As(e, t, n) {
  var c, u, h, g, p, f, m, C;
  const o = Dr(), s = (n == null ? void 0 : n.locale) ?? o.locale ?? Cg, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((g = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, r = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : f.weekStartsOn) ?? o.weekStartsOn ?? ((C = (m = o.locale) == null ? void 0 : m.options) == null ? void 0 : C.weekStartsOn) ?? 0, a = it(e, n == null ? void 0 : n.in);
  if (!vg(a))
    throw new RangeError("Invalid time value");
  let l = t.match(R6).map((w) => {
    const b = w[0];
    if (b === "p" || b === "P") {
      const A = sh[b];
      return A(w, s.formatLong);
    }
    return w;
  }).join("").match(x6).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const b = w[0];
    if (b === "'")
      return { isToken: !1, value: M6(w) };
    if (Df[b])
      return { isToken: !0, value: w };
    if (b.match(F6))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: w };
  });
  s.localize.preprocessor && (l = s.localize.preprocessor(a, l));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: r,
    locale: s
  };
  return l.map((w) => {
    if (!w.isToken) return w.value;
    const b = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && i1(b) || !(n != null && n.useAdditionalDayOfYearTokens) && s1(b)) && ih(b, t, String(e));
    const A = Df[b[0]];
    return A(a, b, s.localize, d);
  }).join("");
}
function M6(e) {
  const t = e.match(E6);
  return t ? t[1].replace(A6, "'") : e;
}
function I6(e, t) {
  return it(e, t == null ? void 0 : t.in).getDate();
}
function P6(e, t) {
  const n = it(e, t == null ? void 0 : t.in), o = n.getFullYear(), s = n.getMonth(), i = Rt(n, 0);
  return i.setFullYear(o, s + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function D6() {
  return Object.assign({}, Dr());
}
function T6(e, t) {
  const n = it(e, t == null ? void 0 : t.in).getDay();
  return n === 0 ? 7 : n;
}
function pl(e, t) {
  return +it(e) > +it(t);
}
function fl(e, t) {
  return +it(e) < +it(t);
}
function k6(e, t) {
  const n = L6(t) ? new t(0) : Rt(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function L6(e) {
  var t;
  return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
}
const B6 = 10;
class r1 {
  constructor() {
    Ae(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class O6 extends r1 {
  constructor(t, n, o, s, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = o, this.priority = s, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, o) {
    return this.setValue(t, n, this.value, o);
  }
}
class G6 extends r1 {
  constructor(n, o) {
    super();
    Ae(this, "priority", B6);
    Ae(this, "subPriority", -1);
    this.context = n || ((s) => Rt(o, s));
  }
  set(n, o) {
    return o.timestampIsSet ? n : Rt(n, k6(n, this.context));
  }
}
class rt {
  run(t, n, o, s) {
    const i = this.parse(t, n, o, s);
    return i ? {
      setter: new O6(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, o) {
    return !0;
  }
}
class H6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 140);
    Ae(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(n, { width: "abbreviated" }) || s.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(n, { width: "wide" }) || s.era(n, { width: "abbreviated" }) || s.era(n, { width: "narrow" });
    }
  }
  set(n, o, s) {
    return o.era = s, n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Tt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, yo = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function kt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function xt(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function bo(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const o = n[1] === "+" ? 1 : -1, s = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, r = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: o * (s * P8 + i * I8 + r * D8),
    rest: t.slice(n[0].length)
  };
}
function a1(e) {
  return xt(Tt.anyDigitsSigned, e);
}
function Mt(e, t) {
  switch (e) {
    case 1:
      return xt(Tt.singleDigit, t);
    case 2:
      return xt(Tt.twoDigits, t);
    case 3:
      return xt(Tt.threeDigits, t);
    case 4:
      return xt(Tt.fourDigits, t);
    default:
      return xt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function cd(e, t) {
  switch (e) {
    case 1:
      return xt(Tt.singleDigitSigned, t);
    case 2:
      return xt(Tt.twoDigitsSigned, t);
    case 3:
      return xt(Tt.threeDigitsSigned, t);
    case 4:
      return xt(Tt.fourDigitsSigned, t);
    default:
      return xt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function bg(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function l1(e, t) {
  const n = t > 0, o = n ? t : 1 - t;
  let s;
  if (o <= 50)
    s = e || 100;
  else {
    const i = o + 50, r = Math.trunc(i / 100) * 100, a = e >= i % 100;
    s = e + r - (a ? 100 : 0);
  }
  return n ? s : 1 - s;
}
function d1(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class V6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 130);
    Ae(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, o, s) {
    const i = (r) => ({
      year: r,
      isTwoDigitYear: o === "yy"
    });
    switch (o) {
      case "y":
        return kt(Mt(4, n), i);
      case "yo":
        return kt(
          s.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return kt(Mt(o.length, n), i);
    }
  }
  validate(n, o) {
    return o.isTwoDigitYear || o.year > 0;
  }
  set(n, o, s) {
    const i = n.getFullYear();
    if (s.isTwoDigitYear) {
      const a = l1(
        s.year,
        i
      );
      return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const r = !("era" in o) || o.era === 1 ? s.year : 1 - s.year;
    return n.setFullYear(r, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class _6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 130);
    Ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    const i = (r) => ({
      year: r,
      isTwoDigitYear: o === "YY"
    });
    switch (o) {
      case "Y":
        return kt(Mt(4, n), i);
      case "Yo":
        return kt(
          s.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return kt(Mt(o.length, n), i);
    }
  }
  validate(n, o) {
    return o.isTwoDigitYear || o.year > 0;
  }
  set(n, o, s, i) {
    const r = wg(n, i);
    if (s.isTwoDigitYear) {
      const l = l1(
        s.year,
        r
      );
      return n.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Mo(n, i);
    }
    const a = !("era" in o) || o.era === 1 ? s.year : 1 - s.year;
    return n.setFullYear(a, 0, i.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Mo(n, i);
  }
}
class N6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 130);
    Ae(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o) {
    return cd(o === "R" ? 4 : o.length, n);
  }
  set(n, o, s) {
    const i = Rt(n, 0);
    return i.setFullYear(s, 0, 4), i.setHours(0, 0, 0, 0), ur(i);
  }
}
class $6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 130);
    Ae(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, o) {
    return cd(o === "u" ? 4 : o.length, n);
  }
  set(n, o, s) {
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class z6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 120);
    Ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    switch (o) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Mt(o.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 4;
  }
  set(n, o, s) {
    return n.setMonth((s - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class W6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 120);
    Ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    switch (o) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Mt(o.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 4;
  }
  set(n, o, s) {
    return n.setMonth((s - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class U6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Ae(this, "priority", 110);
  }
  parse(n, o, s) {
    const i = (r) => r - 1;
    switch (o) {
      // 1, 2, ..., 12
      case "M":
        return kt(
          xt(Tt.month, n),
          i
        );
      // 01, 02, ..., 12
      case "MM":
        return kt(Mt(2, n), i);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return kt(
          s.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(n, { width: "wide", context: "formatting" }) || s.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 11;
  }
  set(n, o, s) {
    return n.setMonth(s, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class K6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 110);
    Ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    const i = (r) => r - 1;
    switch (o) {
      // 1, 2, ..., 12
      case "L":
        return kt(
          xt(Tt.month, n),
          i
        );
      // 01, 02, ..., 12
      case "LL":
        return kt(Mt(2, n), i);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return kt(
          s.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(n, { width: "wide", context: "standalone" }) || s.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 11;
  }
  set(n, o, s) {
    return n.setMonth(s, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function Z6(e, t, n) {
  const o = it(e, n == null ? void 0 : n.in), s = yg(o, n) - t;
  return o.setDate(o.getDate() - s * 7), it(o, n == null ? void 0 : n.in);
}
class q6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 100);
    Ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    switch (o) {
      case "w":
        return xt(Tt.week, n);
      case "wo":
        return s.ordinalNumber(n, { unit: "week" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 53;
  }
  set(n, o, s, i) {
    return Mo(Z6(n, s, i), i);
  }
}
function j6(e, t, n) {
  const o = it(e, n == null ? void 0 : n.in), s = n1(o, n) - t;
  return o.setDate(o.getDate() - s * 7), o;
}
class Y6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 100);
    Ae(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    switch (o) {
      case "I":
        return xt(Tt.week, n);
      case "Io":
        return s.ordinalNumber(n, { unit: "week" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 53;
  }
  set(n, o, s) {
    return ur(j6(n, s));
  }
}
const Q6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], J6 = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class X6 extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 90);
    Ae(this, "subPriority", 1);
    Ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    switch (o) {
      case "d":
        return xt(Tt.date, n);
      case "do":
        return s.ordinalNumber(n, { unit: "date" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    const s = n.getFullYear(), i = d1(s), r = n.getMonth();
    return i ? o >= 1 && o <= J6[r] : o >= 1 && o <= Q6[r];
  }
  set(n, o, s) {
    return n.setDate(s), n.setHours(0, 0, 0, 0), n;
  }
}
class ex extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 90);
    Ae(this, "subpriority", 1);
    Ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    switch (o) {
      case "D":
      case "DD":
        return xt(Tt.dayOfYear, n);
      case "Do":
        return s.ordinalNumber(n, { unit: "date" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    const s = n.getFullYear();
    return d1(s) ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
  }
  set(n, o, s) {
    return n.setMonth(0, s), n.setHours(0, 0, 0, 0), n;
  }
}
function Sg(e, t, n) {
  var u, h, g, p;
  const o = Dr(), s = (n == null ? void 0 : n.weekStartsOn) ?? ((h = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : h.weekStartsOn) ?? o.weekStartsOn ?? ((p = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : p.weekStartsOn) ?? 0, i = it(e, n == null ? void 0 : n.in), r = i.getDay(), l = (t % 7 + 7) % 7, d = 7 - s, c = t < 0 || t > 6 ? t - (r + d) % 7 : (l + d) % 7 - (r + d) % 7;
  return ji(i, c, n);
}
class tx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 90);
    Ae(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(n, { width: "wide", context: "formatting" }) || s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 6;
  }
  set(n, o, s, i) {
    return n = Sg(n, s, i), n.setHours(0, 0, 0, 0), n;
  }
}
class nx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 90);
    Ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s, i) {
    const r = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (o) {
      // 3
      case "e":
      case "ee":
        return kt(Mt(o.length, n), r);
      // 3rd
      case "eo":
        return kt(
          s.ordinalNumber(n, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "eee":
        return s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(n, { width: "wide", context: "formatting" }) || s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 6;
  }
  set(n, o, s, i) {
    return n = Sg(n, s, i), n.setHours(0, 0, 0, 0), n;
  }
}
class ox extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 90);
    Ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, o, s, i) {
    const r = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (o) {
      // 3
      case "c":
      case "cc":
        return kt(Mt(o.length, n), r);
      // 3rd
      case "co":
        return kt(
          s.ordinalNumber(n, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "ccc":
        return s.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(n, { width: "short", context: "standalone" }) || s.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(n, { width: "short", context: "standalone" }) || s.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(n, { width: "wide", context: "standalone" }) || s.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(n, { width: "short", context: "standalone" }) || s.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 6;
  }
  set(n, o, s, i) {
    return n = Sg(n, s, i), n.setHours(0, 0, 0, 0), n;
  }
}
function sx(e, t, n) {
  const o = it(e, n == null ? void 0 : n.in), s = T6(o, n), i = t - s;
  return ji(o, i, n);
}
class ix extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 90);
    Ae(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, o, s) {
    const i = (r) => r === 0 ? 7 : r;
    switch (o) {
      // 2
      case "i":
      case "ii":
        return Mt(o.length, n);
      // 2nd
      case "io":
        return s.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return kt(
          s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // T
      case "iiiii":
        return kt(
          s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tu
      case "iiiiii":
        return kt(
          s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tuesday
      case "iiii":
      default:
        return kt(
          s.day(n, {
            width: "wide",
            context: "formatting"
          }) || s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 7;
  }
  set(n, o, s) {
    return n = sx(n, s), n.setHours(0, 0, 0, 0), n;
  }
}
class rx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 80);
    Ae(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, o, s) {
    return n.setHours(bg(s), 0, 0, 0), n;
  }
}
class ax extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 80);
    Ae(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, o, s) {
    return n.setHours(bg(s), 0, 0, 0), n;
  }
}
class lx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 80);
    Ae(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, o, s) {
    return n.setHours(bg(s), 0, 0, 0), n;
  }
}
class dx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 70);
    Ae(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "h":
        return xt(Tt.hour12h, n);
      case "ho":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 12;
  }
  set(n, o, s) {
    const i = n.getHours() >= 12;
    return i && s < 12 ? n.setHours(s + 12, 0, 0, 0) : !i && s === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(s, 0, 0, 0), n;
  }
}
class cx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 70);
    Ae(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "H":
        return xt(Tt.hour23h, n);
      case "Ho":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 23;
  }
  set(n, o, s) {
    return n.setHours(s, 0, 0, 0), n;
  }
}
class ux extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 70);
    Ae(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "K":
        return xt(Tt.hour11h, n);
      case "Ko":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 11;
  }
  set(n, o, s) {
    return n.getHours() >= 12 && s < 12 ? n.setHours(s + 12, 0, 0, 0) : n.setHours(s, 0, 0, 0), n;
  }
}
class hx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 70);
    Ae(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "k":
        return xt(Tt.hour24h, n);
      case "ko":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 1 && o <= 24;
  }
  set(n, o, s) {
    const i = s <= 24 ? s % 24 : s;
    return n.setHours(i, 0, 0, 0), n;
  }
}
class gx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 60);
    Ae(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "m":
        return xt(Tt.minute, n);
      case "mo":
        return s.ordinalNumber(n, { unit: "minute" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 59;
  }
  set(n, o, s) {
    return n.setMinutes(s, 0, 0), n;
  }
}
class px extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 50);
    Ae(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, o, s) {
    switch (o) {
      case "s":
        return xt(Tt.second, n);
      case "so":
        return s.ordinalNumber(n, { unit: "second" });
      default:
        return Mt(o.length, n);
    }
  }
  validate(n, o) {
    return o >= 0 && o <= 59;
  }
  set(n, o, s) {
    return n.setSeconds(s, 0), n;
  }
}
class fx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 30);
    Ae(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, o) {
    const s = (i) => Math.trunc(i * Math.pow(10, -o.length + 3));
    return kt(Mt(o.length, n), s);
  }
  set(n, o, s) {
    return n.setMilliseconds(s), n;
  }
}
class mx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 10);
    Ae(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, o) {
    switch (o) {
      case "X":
        return bo(
          yo.basicOptionalMinutes,
          n
        );
      case "XX":
        return bo(yo.basic, n);
      case "XXXX":
        return bo(
          yo.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return bo(
          yo.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return bo(yo.extended, n);
    }
  }
  set(n, o, s) {
    return o.timestampIsSet ? n : Rt(
      n,
      n.getTime() - dd(n) - s
    );
  }
}
class vx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 10);
    Ae(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, o) {
    switch (o) {
      case "x":
        return bo(
          yo.basicOptionalMinutes,
          n
        );
      case "xx":
        return bo(yo.basic, n);
      case "xxxx":
        return bo(
          yo.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return bo(
          yo.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return bo(yo.extended, n);
    }
  }
  set(n, o, s) {
    return o.timestampIsSet ? n : Rt(
      n,
      n.getTime() - dd(n) - s
    );
  }
}
class Cx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 40);
    Ae(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return a1(n);
  }
  set(n, o, s) {
    return [Rt(n, s * 1e3), { timestampIsSet: !0 }];
  }
}
class wx extends rt {
  constructor() {
    super(...arguments);
    Ae(this, "priority", 20);
    Ae(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return a1(n);
  }
  set(n, o, s) {
    return [Rt(n, s), { timestampIsSet: !0 }];
  }
}
const yx = {
  G: new H6(),
  y: new V6(),
  Y: new _6(),
  R: new N6(),
  u: new $6(),
  Q: new z6(),
  q: new W6(),
  M: new U6(),
  L: new K6(),
  w: new q6(),
  I: new Y6(),
  d: new X6(),
  D: new ex(),
  E: new tx(),
  e: new nx(),
  c: new ox(),
  i: new ix(),
  a: new rx(),
  b: new ax(),
  B: new lx(),
  h: new dx(),
  H: new cx(),
  K: new ux(),
  k: new hx(),
  m: new gx(),
  s: new px(),
  S: new fx(),
  X: new mx(),
  x: new vx(),
  t: new Cx(),
  T: new wx()
}, bx = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Sx = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, xx = /^'([^]*?)'?$/, Rx = /''/g, Ex = /\S/, Ax = /[a-zA-Z]/;
function Fx(e, t, n, o) {
  var m, C, w, b, A, S, F, E;
  const s = () => Rt((o == null ? void 0 : o.in) || n, NaN), i = D6(), r = (o == null ? void 0 : o.locale) ?? i.locale ?? Cg, a = (o == null ? void 0 : o.firstWeekContainsDate) ?? ((C = (m = o == null ? void 0 : o.locale) == null ? void 0 : m.options) == null ? void 0 : C.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((b = (w = i.locale) == null ? void 0 : w.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, l = (o == null ? void 0 : o.weekStartsOn) ?? ((S = (A = o == null ? void 0 : o.locale) == null ? void 0 : A.options) == null ? void 0 : S.weekStartsOn) ?? i.weekStartsOn ?? ((E = (F = i.locale) == null ? void 0 : F.options) == null ? void 0 : E.weekStartsOn) ?? 0;
  if (!t)
    return e ? s() : it(n, o == null ? void 0 : o.in);
  const d = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: r
  }, c = [new G6(o == null ? void 0 : o.in, n)], u = t.match(Sx).map((M) => {
    const I = M[0];
    if (I in sh) {
      const P = sh[I];
      return P(M, r.formatLong);
    }
    return M;
  }).join("").match(bx), h = [];
  for (let M of u) {
    !(o != null && o.useAdditionalWeekYearTokens) && i1(M) && ih(M, t, e), !(o != null && o.useAdditionalDayOfYearTokens) && s1(M) && ih(M, t, e);
    const I = M[0], P = yx[I];
    if (P) {
      const { incompatibleTokens: k } = P;
      if (Array.isArray(k)) {
        const j = h.find(
          (N) => k.includes(N.token) || N.token === I
        );
        if (j)
          throw new RangeError(
            `The format string mustn't contain \`${j.fullToken}\` and \`${M}\` at the same time`
          );
      } else if (P.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${M}\` and any other token at the same time`
        );
      h.push({ token: I, fullToken: M });
      const B = P.run(
        e,
        M,
        r.match,
        d
      );
      if (!B)
        return s();
      c.push(B.setter), e = B.rest;
    } else {
      if (I.match(Ax))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + I + "`"
        );
      if (M === "''" ? M = "'" : I === "'" && (M = Mx(M)), e.indexOf(M) === 0)
        e = e.slice(M.length);
      else
        return s();
    }
  }
  if (e.length > 0 && Ex.test(e))
    return s();
  const g = c.map((M) => M.priority).sort((M, I) => I - M).filter((M, I, P) => P.indexOf(M) === I).map(
    (M) => c.filter((I) => I.priority === M).sort((I, P) => P.subPriority - I.subPriority)
  ).map((M) => M[0]);
  let p = it(n, o == null ? void 0 : o.in);
  if (isNaN(+p)) return s();
  const f = {};
  for (const M of g) {
    if (!M.validate(p, d))
      return s();
    const I = M.set(p, f, d);
    Array.isArray(I) ? (p = I[0], Object.assign(f, I[1])) : p = I;
  }
  return p;
}
function Mx(e) {
  return e.match(xx)[1].replace(Rx, "'");
}
function Ix(e, t) {
  return gs(
    Rt(e, e),
    B8(e)
  );
}
const Px = {
  d: "day",
  M: "month",
  y: "year",
  H: "hours",
  h: "hours",
  m: "minutes",
  s: "seconds",
  S: "milliseconds",
  a: "meridiem"
}, Dx = ["day", "month", "year"], Tx = ["hours", "minutes", "seconds", "milliseconds"];
function kx(e, t) {
  const n = e === "hours" && t.startsWith("h");
  let o, s, i;
  return e === "meridiem" ? (o = 2, s = 0) : e === "milliseconds" ? (o = 3, s = 3) : e === "year" ? (o = t.length === 2 ? 2 : 4, s = o) : e === "month" && t.length >= 3 ? (i = t.length >= 4 ? "long" : "short", o = 2, s = 2) : (o = Math.min(t.length, 2), s = 2), { kind: "section", type: e, token: t, padLength: o, maxDigits: s, twelveHour: n, monthStyle: i };
}
function c1(e) {
  const t = [], n = (s) => {
    if (!s) return;
    const i = t[t.length - 1];
    (i == null ? void 0 : i.kind) === "literal" ? i.text += s : t.push({ kind: "literal", text: s });
  };
  let o = 0;
  for (; o < e.length; ) {
    const s = e[o];
    if (s === "'") {
      let a = o + 1, l = "";
      for (; a < e.length; ) {
        if (e[a] === "'") {
          if (e[a + 1] === "'") {
            l += "'", a += 2;
            continue;
          }
          break;
        }
        l += e[a], a += 1;
      }
      n(l || "'"), o = a + 1;
      continue;
    }
    const i = Px[s];
    if (!i) {
      n(s), o += 1;
      continue;
    }
    let r = o;
    for (; r < e.length && e[r] === s; ) r += 1;
    t.push(kx(i, e.slice(o, r))), o = r;
  }
  return t;
}
function u1(e) {
  return e.filter((t) => t.kind === "section");
}
function Hr(e, t = {}) {
  switch (e.type) {
    case "day": {
      const n = t.month ?? null;
      return n == null ? { min: 1, max: 31 } : { min: 1, max: P6(new Date(t.year ?? 2e3, n - 1)) };
    }
    case "month":
      return { min: 1, max: 12 };
    case "year":
      return e.maxDigits === 2 ? { min: 0, max: 99 } : { min: 1, max: 9999 };
    case "hours":
      return e.twelveHour ? { min: 1, max: 12 } : { min: 0, max: 23 };
    case "minutes":
    case "seconds":
      return { min: 0, max: 59 };
    case "milliseconds":
      return { min: 0, max: 999 };
    case "meridiem":
      return { min: 0, max: 1 };
  }
}
function Lx(e, t, n, o, s) {
  const i = t > 0 && t < s && e != null;
  let r = (i ? e : 0) * 10 + n, a = i ? t + 1 : 1;
  r > o.max && (r = n, a = 1);
  const l = a >= s || r * 10 > o.max;
  return { value: r, typed: a, complete: l };
}
function Bx(e, t, n) {
  if (e == null) return t > 0 ? n.min : n.max;
  const o = n.max - n.min + 1;
  return n.min + ((e - n.min + t) % o + o) % o;
}
function Ox(e, t) {
  return Math.min(t.max, Math.max(t.min, e));
}
function h1(e) {
  return e + (e >= 69 ? 1900 : 2e3);
}
function Bf(e, t) {
  const n = e.map((c) => c.type), o = n.filter((c) => Dx.includes(c)), s = Tx.filter((c) => n.includes(c)), i = o.filter((c) => t[c] != null).length, r = s.map((c) => t[c] != null), a = n.includes("meridiem") && t.meridiem != null;
  if (!(i > 0 || r.some(Boolean) || a)) return "empty";
  if (i < o.length) return "partial";
  const d = r.indexOf(!1);
  return d !== -1 && r.slice(d).some(Boolean) || s.includes("hours") && t.hours == null && a || o.length === 0 && s.includes("hours") && t.hours == null ? "partial" : "complete";
}
function Of(e, t, n = {}) {
  const o = (f) => e.some((m) => m.type === f), s = o("year") || o("month") || o("day"), i = n.baseDate ?? /* @__PURE__ */ new Date();
  let r;
  t.year != null ? r = t.year < 100 ? h1(t.year) : t.year : r = i.getFullYear();
  const a = t.month ?? (s ? 1 : i.getMonth() + 1), l = t.day ?? (s ? 1 : i.getDate());
  let d = t.hours ?? 0;
  const c = e.find((f) => f.type === "hours");
  c != null && c.twelveHour && (d = d % 12 + (t.meridiem === 1 ? 12 : 0));
  const u = t.minutes ?? 0, h = t.seconds ?? 0, g = t.milliseconds ?? 0, p = new Date(r, a - 1, l, d, u, h, g);
  return r >= 0 && r < 100 && p.setFullYear(r), p.getFullYear() !== r || p.getMonth() !== a - 1 || p.getDate() !== l ? null : p;
}
function Zc(e, t) {
  const n = {};
  for (const o of t)
    switch (o.type) {
      case "day":
        n.day = e.getDate();
        break;
      case "month":
        n.month = e.getMonth() + 1;
        break;
      case "year":
        n.year = o.maxDigits === 2 ? e.getFullYear() % 100 : e.getFullYear();
        break;
      case "hours": {
        const s = e.getHours();
        n.hours = o.twelveHour ? s % 12 || 12 : s, o.twelveHour && (n.meridiem = s >= 12 ? 1 : 0);
        break;
      }
      case "minutes":
        n.minutes = e.getMinutes();
        break;
      case "seconds":
        n.seconds = e.getSeconds();
        break;
      case "milliseconds":
        n.milliseconds = e.getMilliseconds();
        break;
      case "meridiem":
        n.meridiem = e.getHours() >= 12 ? 1 : 0;
        break;
    }
  return n;
}
function Gx(e, t, n) {
  return e.type === "meridiem" ? t === 1 ? "PM" : "AM" : e.type === "month" && e.monthStyle && n ? n[t - 1] ?? String(t).padStart(e.padLength, "0") : String(t).padStart(e.padLength, "0");
}
function Gf(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function Hf(e, t) {
  const n = Gf(e.trim());
  if (!n) return null;
  const o = [];
  return t.forEach((s, i) => {
    Gf(s).startsWith(n) && o.push(i + 1);
  }), o.length === 0 ? null : { month: o[0], complete: o.length === 1 };
}
const ta = ["year", "month", "day"], Ra = ["hour", "minute", "second", "millisecond"], rh = {
  year: 4,
  month: 2,
  day: 2,
  hour: 2,
  minute: 2,
  second: 2,
  millisecond: 3
}, Hx = {
  year: "year",
  month: "month",
  day: "day",
  hours: "hour",
  minutes: "minute",
  seconds: "second",
  milliseconds: "millisecond"
}, Vx = "X", _x = /(Z|[+-]\d{2}:\d{2})(?:\[([A-Za-z0-9_+\-/]+)\])?$/;
function Nx(e) {
  const t = As(e, "xxx"), n = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return n ? `${t}[${n}]` : t;
}
function $x(e, t, n) {
  const o = /* @__PURE__ */ new Set(), s = (i, r) => {
    for (const a of u1(c1(i))) {
      const l = Hx[a.type];
      l && r.includes(l) && o.add(l);
    }
  };
  return e !== "time" && s(t, ta), e !== "date" && s(n, Ra), o;
}
function Vf(e) {
  return Ra.some((t) => e.has(t));
}
function g1(e, t) {
  let n = -1;
  return e.forEach((o, s) => {
    t.has(o) && (n = s);
  }), n;
}
function p1(e, t, n) {
  const o = {
    year: e.getFullYear(),
    month: e.getMonth() + 1,
    day: e.getDate(),
    hour: e.getHours(),
    minute: e.getMinutes(),
    second: e.getSeconds(),
    millisecond: e.getMilliseconds()
  }, s = (d) => n.has(d) ? String(o[d]).padStart(rh[d], "0") : Vx.repeat(rh[d]), i = zx(n, s);
  if (t === "time") return i;
  const r = g1(ta, n), a = (i ? ta : ta.slice(0, r + 1)).map(s).join("-");
  if (!a) return "";
  const l = [a];
  return i && l.push("T", i), t === "datetime" && l.push(Nx(e)), l.join("");
}
function zx(e, t) {
  const n = g1(Ra, e);
  if (n < 0) return "";
  let o = t("hour");
  return n >= 1 && (o += `:${t("minute")}`), n >= 2 && (o += `:${t("second")}`), n >= 3 && (o += `.${t("millisecond")}`), o;
}
const Wx = (e) => /^X+$/.test(e);
function f1(e, t) {
  const n = t === "time" ? null : _x.exec(e), o = (n == null ? void 0 : n[1]) ?? "", s = (n == null ? void 0 : n[2]) ?? "", i = n ? e.slice(0, n.index) : e, [r, a = ""] = t === "time" ? ["", i] : i.split("T"), l = {};
  let d = !1;
  const c = (u, h) => u ? Wx(h) ? (d = !0, !0) : /^\d+$/.test(h) ? (l[u] = Number(h), !0) : !1 : !1;
  if (t !== "time") {
    const u = r ? r.split("-") : [];
    if (!u.length) return null;
    const h = u.length === 1 && u[0].length <= 2 ? ["month"] : ta;
    if (u.length > h.length) return null;
    for (const [g, p] of u.entries())
      if (!c(h[g], p)) return null;
  }
  if (a) {
    const u = a.split(/[:.]/);
    if (u.length > Ra.length) return null;
    for (const [h, g] of u.entries())
      if (!c(Ra[h], g)) return null;
  }
  return { values: l, zone: o, zoneName: s, masked: d };
}
const Ws = (e, t = 2) => String(e).padStart(t, "0");
function xg(e, t) {
  if (!e) return null;
  const n = f1(e, t);
  if (!n) {
    const f = new Date(e);
    return isNaN(f.getTime()) ? null : f;
  }
  const { values: o, zone: s, masked: i } = n, r = o.year ?? (/* @__PURE__ */ new Date()).getFullYear(), a = o.month ?? 1, l = o.day ?? 1, d = o.hour ?? 0, c = o.minute ?? 0, u = o.second ?? 0, h = o.millisecond ?? 0, g = `${Ws(r, 4)}-${Ws(a)}-${Ws(l)}T${Ws(d)}:${Ws(c)}:${Ws(u)}`, p = s && !i ? /* @__PURE__ */ new Date(`${g}.${Ws(h, 3)}${s}`) : new Date(r, a - 1, l, d, c, u, h);
  return isNaN(p.getTime()) ? null : p;
}
function Ux(e, t, n) {
  const o = xg(e, t);
  return o ? p1(o, t, n) : "";
}
const Kx = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Zx = /^(\d{4})-(\d{2})-(\d{2})$/, _f = /* @__PURE__ */ new Map();
function qx(e) {
  const t = Zx.exec(e), n = t ? new Date(+t[1], +t[2] - 1, +t[3]) : new Date(e);
  return isNaN(n.getTime()) ? null : n;
}
function jx(e, t) {
  let n = _f.get(t);
  n || (n = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hourCycle: "h23",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), _f.set(t, n));
  const o = Object.fromEntries(n.formatToParts(e).map((s) => [s.type, Number(s.value)]));
  return {
    year: o.year,
    month: o.month,
    day: o.day,
    hour: o.hour,
    minute: o.minute,
    second: o.second,
    millisecond: e.getUTCMilliseconds()
  };
}
function Yx(e, t) {
  const n = /^([+-])(\d{2}):(\d{2})$/.exec(t), o = n ? (n[1] === "-" ? -1 : 1) * (Number(n[2]) * 60 + Number(n[3])) : 0, s = new Date(e.getTime() + o * 6e4);
  return {
    year: s.getUTCFullYear(),
    month: s.getUTCMonth() + 1,
    day: s.getUTCDate(),
    hour: s.getUTCHours(),
    minute: s.getUTCMinutes(),
    second: s.getUTCSeconds(),
    millisecond: s.getUTCMilliseconds()
  };
}
function Qx(e) {
  return {
    year: e.getFullYear(),
    month: e.getMonth() + 1,
    day: e.getDate(),
    hour: e.getHours(),
    minute: e.getMinutes(),
    second: e.getSeconds(),
    millisecond: e.getMilliseconds()
  };
}
function Jx(e, t, n) {
  if (n)
    try {
      return jx(e, n);
    } catch {
    }
  return t ? Yx(e, t) : Qx(e);
}
function bMe(e, t, n) {
  const o = n, s = o === De.NOT_EQUALS || o === De.NOT_CONTAINS, i = f1(t, "datetime"), r = qx(e), a = i ? Kx.filter((u) => i.values[u] !== void 0) : [];
  if (!i || !r || a.length === 0) return s;
  const l = (u) => a.map((h) => String(u[h]).padStart(rh[h], "0")).join(""), d = l(Jx(r, i.zone, i.zoneName)), c = l(i.values);
  switch (o) {
    case De.NOT_EQUALS:
    case De.NOT_CONTAINS:
      return d !== c;
    case De.GREATER_THAN:
      return d > c;
    case De.GREATER_OR_EQUALS:
      return d >= c;
    case De.LESS_THAN:
      return d < c;
    case De.LESS_OR_EQUALS:
      return d <= c;
    default:
      return d === c;
  }
}
function Xx(e, t) {
  return JSON.stringify([e, t]);
}
function m1(e) {
  if (!e.startsWith("[")) return null;
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return null;
  }
  if (!Array.isArray(t) || t.length !== 2) return null;
  const [n, o] = t;
  return typeof n != "string" || typeof o != "string" ? null : { term: n, pairTerm: o };
}
const eR = ".ag-row[row-id]", tR = ".ag-cell[col-id]", nR = [
  ".ag-popup",
  ".ag-menu",
  ".ag-virtual-list-viewport",
  ".ag-body-horizontal-scroll",
  ".ag-body-vertical-scroll"
].join(", "), oR = ".ag-group-expanded, .ag-group-contracted, .expandIcon";
function ja(e) {
  return e instanceof Element ? e : null;
}
function sR(e) {
  var t;
  return ((t = e.getAttribute("row-id")) == null ? void 0 : t.replace(/&gt;/g, ">")) ?? null;
}
function iR(e) {
  return [.../* @__PURE__ */ new Set([e, e.replace(/>/g, "&gt;")])].map((n) => `.ag-row[row-id="${CSS.escape(n)}"]`).join(", ");
}
function rR(e, t) {
  var o;
  const n = (o = ja(e)) == null ? void 0 : o.closest(eR);
  return !n || !(t != null && t.contains(n)) || n.classList.contains("ag-row-pinned") ? null : n;
}
function v1(e, t) {
  const n = rR(e, t), o = n ? sR(n) : null;
  return n && o !== null ? { rowId: o, element: n } : null;
}
function aR(e, t) {
  var i;
  const n = (i = ja(e)) == null ? void 0 : i.closest(tR), o = v1(n ?? null, t), s = n == null ? void 0 : n.getAttribute("col-id");
  return o && s ? { rowId: o.rowId, columnId: s } : null;
}
function C1(e, t) {
  return t ? Array.from(t.querySelectorAll(iR(e))) : [];
}
function w1(e) {
  var t;
  return !!((t = ja(e)) != null && t.closest(nR));
}
function lR(e) {
  var t;
  return !!((t = ja(e)) != null && t.closest(oR));
}
function dR(e, t) {
  const n = ja(e);
  return n ? !!(t != null && t.contains(n)) || w1(n) : !1;
}
function y1(e) {
  return e.tabIndex !== -1 && e.getAttribute("aria-hidden") !== "true" && !e.closest("[inert]");
}
function b1(e) {
  const t = e.querySelectorAll("input, textarea, select, button, [tabindex]");
  return Array.from(t).find(y1) ?? null;
}
function Rg(e, t, n) {
  for (const o of C1(e, n)) {
    const s = o.querySelector(`[col-id="${CSS.escape(t)}"]`);
    if (s) return s;
  }
  return null;
}
function cR(e, t, n) {
  const o = Rg(e, t, n), s = o ? b1(o) : null;
  return !!s && !s.matches(":disabled");
}
function uR(e, t, n, o = {}) {
  const s = Rg(e, t, n);
  if (!s) return;
  if (o.onlyIfLost) {
    const r = document.activeElement;
    if (r instanceof HTMLElement && r !== s && s.contains(r) && y1(r)) return;
  }
  const i = b1(s);
  i == null || i.focus(), o.open && (i == null || i.click());
}
const ud = /* @__PURE__ */ new WeakMap(), qc = /* @__PURE__ */ new WeakMap(), na = /* @__PURE__ */ new WeakMap(), jc = /* @__PURE__ */ new WeakMap();
function hR(e, t, n, o) {
  const s = t.id;
  if (s === void 0) return;
  let i = ud.get(e);
  i || ud.set(e, i = /* @__PURE__ */ new Map());
  let r = i.get(s);
  r || i.set(s, r = /* @__PURE__ */ new Map()), r.set(n, o), fR(e, t), x1(e, s);
}
function gR(e, t, n) {
  if (t === void 0) return;
  const o = ud.get(e), s = o == null ? void 0 : o.get(t);
  s && (s.delete(n), s.size === 0 && (o == null || o.delete(t)), x1(e, t));
}
function S1(e, t, n) {
  var s;
  const o = e && t !== void 0 ? (s = ud.get(e)) == null ? void 0 : s.get(t) : void 0;
  return o ? Object.assign({}, n, ...o.values()) : n;
}
function pR(e, t) {
  let n = na.get(e);
  return n || na.set(e, n = /* @__PURE__ */ new Set()), n.add(t), () => {
    var o;
    return (o = na.get(e)) == null ? void 0 : o.delete(t);
  };
}
function x1(e, t) {
  var o;
  if (!((o = na.get(e)) != null && o.size)) return;
  let n = jc.get(e);
  if (n) {
    n.add(t);
    return;
  }
  n = /* @__PURE__ */ new Set([t]), jc.set(e, n), queueMicrotask(() => {
    jc.delete(e), !e.isDestroyed() && n.forEach((s) => {
      var i;
      return (i = na.get(e)) == null ? void 0 : i.forEach((r) => r(s));
    });
  });
}
function fR(e, t) {
  let n = qc.get(e);
  if (n) {
    n.add(t);
    return;
  }
  n = /* @__PURE__ */ new Set([t]), qc.set(e, n), queueMicrotask(() => {
    qc.delete(e), !e.isDestroyed() && e.refreshCells({ rowNodes: [...n] });
  });
}
const hr = (e, t) => {
  if (!e || !t) return;
  let n = e;
  const o = t.replace(/\[/g, ".").replace(/]/g, "").split(".");
  for (const s of o) {
    if (n == null)
      return;
    n = n[s];
  }
  return n;
}, R1 = Symbol("serverRowGroup");
function mR(e) {
  return { [R1]: e };
}
function gr(e) {
  return typeof e == "object" && e !== null ? e[R1] : void 0;
}
function oo(e) {
  return !!(e != null && e.group) && (!e.data || !!gr(e.data));
}
function vR(e, t, n) {
  return typeof e.valueGetter == "function" ? e.valueGetter({
    api: n.api,
    context: n.context,
    node: n.node,
    data: t,
    colDef: e,
    column: n.node.rowGroupColumn ?? n.column,
    getValue: (o) => hr(t, o)
  }) : e.field ? hr(t, e.field) : void 0;
}
const CR = /* @__PURE__ */ new Set(["toolPanelUi", "columnMenu", "contextMenu"]);
function Bs(e) {
  if (e !== void 0)
    return e.startsWith("ui") || CR.has(e) ? "user" : e === "autosizeColumns" ? "autosize" : e === "sizeColumnsToFit" || e === "flex" ? "fit" : e === "gridOptionsChanged" ? "definitions" : "api";
}
function Eg(e) {
  return (e.columns ?? (e.column ? [e.column] : [])).map((n) => n.getColId());
}
function Tr(e, t) {
  if (!(!e || e.rowPinned || t === void 0 || e.id === void 0))
    return { row: t, rowId: e.id };
}
function Yc(e) {
  return { source: Bs(e.source) };
}
function E1(e) {
  return { sort: e.api.getColumnState().filter((n) => n.sort === "asc" || n.sort === "desc").sort((n, o) => (n.sortIndex ?? 0) - (o.sortIndex ?? 0)).map((n) => ({ columnId: n.colId, direction: n.sort })), source: Bs(e.source) };
}
function wR(e) {
  const t = e.pinned === !0 ? "left" : e.pinned === "left" || e.pinned === "right" ? e.pinned : null;
  return { columnIds: Eg(e), pinned: t, source: Bs(e.source) };
}
function A1(e) {
  return { columnIds: Eg(e), visible: e.visible ?? !1, source: Bs(e.source) };
}
function F1(e) {
  var t;
  return {
    columnId: ((t = e.column) == null ? void 0 : t.getColId()) ?? "",
    toIndex: e.toIndex ?? -1,
    finished: e.finished,
    source: Bs(e.source)
  };
}
function M1(e) {
  return { columnIds: Eg(e), finished: e.finished, source: Bs(e.source) };
}
function yR(e) {
  const t = Tr(e.node, e.node.data);
  return t && { ...t, expanded: e.expanded };
}
function bR(e) {
  return { direction: e.direction };
}
function I1(e) {
  return e.getSelectedNodes().filter((t) => !oo(t)).map((t) => t.data);
}
function P1(e) {
  return { rows: I1(e.api), source: Bs(e.source) };
}
function D1(e) {
  const t = Tr(e.node, e.data);
  if (t)
    return {
      ...t,
      columnId: e.column.getColId(),
      oldValue: e.oldValue,
      newValue: e.newValue,
      source: Bs(e.source)
    };
}
function SR(e) {
  if ("column" in e) return e.column.getColId();
  const t = e.api.getFocusedCell();
  if (!(!t || t.rowPinned || t.rowIndex !== e.node.rowIndex))
    return t.column.getColId();
}
function T1(e) {
  const t = Tr(e.node, e.data);
  if (!t) return;
  const n = SR(e);
  return n === void 0 ? t : { ...t, columnId: n };
}
function k1(e) {
  return Tr(e.node, e.data);
}
function xR(e, t) {
  if (e.data !== void 0)
    return { row: e.data, rowId: t(e.data), event: e.event ?? null };
}
function RR(e) {
  return Tr(e.node, e.data);
}
function ER(e) {
  const t = Tr(e.node, e.data);
  if (t)
    return { ...t, columnId: e.column.getColId(), event: e.event ?? null };
}
const AR = {
  sortChanged: E1,
  newColumnsLoaded: Yc,
  columnPinned: wR,
  columnMoved: F1,
  columnResized: M1,
  columnVisible: A1,
  modelUpdated: Yc,
  rowDataUpdated: Yc,
  rowGroupOpened: yR,
  bodyScroll: bR,
  selectionChanged: P1,
  rowEditingStarted: T1,
  rowEditingStopped: k1,
  cellValueChanged: D1
};
function FR(e, t) {
  const n = AR[e];
  return n(t);
}
const MR = /* @__PURE__ */ new Set([
  "text",
  "number",
  "boolean",
  "date",
  "dateString",
  "dateTime",
  "dateTimeString",
  "object"
]);
function L1(e) {
  if (!e) return null;
  if (e.filterType === "join") {
    const t = e.conditions.map(L1).filter((n) => n !== null);
    return t.length > 0 || e.conditions.length === 0 ? { filterType: "join", type: e.type, conditions: t } : null;
  }
  return MR.has(e.filterType) ? e : null;
}
const Ea = "ag-Grid-AutoColumn", B1 = "ag-Grid-SelectionColumn", SMe = "sca-cell-fills-width";
function xMe(e) {
  return e === Ea || e === B1;
}
const IR = (e) => e.getColDef().context;
function PR(e, t, n) {
  var s;
  const o = IR(e);
  return (o == null ? void 0 : o.navigable) !== !1 && e.isCellEditable(t) ? !0 : !!(o != null && o.control) && !!((s = n.hasControl) != null && s.call(n, e.getColId()));
}
function Nf(e, t, n = {}) {
  const o = e.getRowNode(t);
  return !o || o.rowPinned ? [] : e.getAllDisplayedColumns().filter((s) => s.getColId() !== B1 && PR(s, o, n)).map((s) => s.getColId());
}
const hd = /* @__PURE__ */ new WeakMap();
function DR(e, t) {
  t ? hd.set(e, t) : hd.delete(e);
}
function TR(e, t) {
  const n = hd.get(e);
  return !n || n.rowId !== t.rowId || n.columnId !== t.columnId ? !1 : (hd.delete(e), !0);
}
function kR(e, t) {
  return t !== "cell" ? e : e === "rowEditingStarted" ? "cellEditingStarted" : e === "rowEditingStopped" ? "cellEditingStopped" : e;
}
const $f = "rowEditingDraftChanged", LR = ".ag-body-viewport";
function BR(e, t = {}) {
  const n = () => {
    var c;
    return ((c = t.root) == null ? void 0 : c.call(t)) ?? null;
  }, o = () => {
    var c;
    return ((c = t.editMode) == null ? void 0 : c.call(t)) ?? "none";
  }, s = (c) => e.getRowNode(c), i = (c) => c == null ? void 0 : c.map(s).filter((u) => u !== void 0), r = (c) => {
    const u = s(c);
    return u && !u.rowPinned ? u.rowIndex : null;
  }, a = () => {
    var c;
    return ((c = n()) == null ? void 0 : c.querySelector(LR)) ?? null;
  }, l = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
  return {
    isDestroyed: () => e.isDestroyed(),
    getColumnState: () => e.getColumnState(),
    applyColumnState: (c) => e.applyColumnState(c),
    resetColumnState: () => e.resetColumnState(),
    setColumnsVisible: (c, u) => e.setColumnsVisible(c, u),
    getAllGridColumns: () => e.getAllGridColumns(),
    getColumn: (c) => e.getColumn(c),
    getFilterModel: () => e.getFilterModel(),
    setFilterModel: (c) => {
      e.isDestroyed() || e.getGridOption("enableAdvancedFilter") || e.setFilterModel(c);
    },
    getAdvancedFilterModel: () => e.getAdvancedFilterModel(),
    setAdvancedFilterModel: (c) => {
      e.isDestroyed() || e.setAdvancedFilterModel(L1(c));
    },
    getColumnFilterInstance: (c) => {
      if (!(e.isDestroyed() || e.getGridOption("enableAdvancedFilter")))
        return e.getColumnFilterInstance(c);
    },
    onFilterChanged: () => e.onFilterChanged(),
    getGridOption: ((c) => e.getGridOption(c)),
    setGridOption: ((c, u) => e.setGridOption(c, u)),
    getSelectedRows: () => I1(e),
    deselectAll: () => e.deselectAll(),
    getRow: (c) => {
      var u;
      return (u = s(c)) == null ? void 0 : u.data;
    },
    getEditingRow: (c) => {
      var h;
      const u = (h = s(c)) == null ? void 0 : h.data;
      return u === void 0 ? void 0 : S1(e, c, u);
    },
    forEachRow: (c) => e.forEachNode((u) => {
      u.data !== void 0 && u.id !== void 0 && c(u.data, u.id);
    }),
    getDisplayedRowCount: () => e.getDisplayedRowCount(),
    getRenderedNodes: () => e.getRenderedNodes(),
    getDisplayedRowIndex: r,
    getDisplayedRowAtIndex: (c) => {
      const u = e.getDisplayedRowAtIndex(c);
      if (!((u == null ? void 0 : u.data) === void 0 || u.id === void 0))
        return { rowId: u.id, row: u.data };
    },
    ensureRowVisible: (c, u) => {
      const h = s(c);
      h && e.ensureNodeVisible(h, u);
    },
    refreshCells: ({ rowIds: c, ...u } = {}) => e.refreshCells({ ...u, rowNodes: i(c) }),
    redrawRows: ({ rowIds: c } = {}) => e.redrawRows({ rowNodes: i(c) }),
    refreshHeader: () => e.refreshHeader(),
    sizeColumnsToFit: () => e.sizeColumnsToFit(),
    resetRowHeights: () => e.resetRowHeights(),
    getAllDisplayedColumns: () => e.getAllDisplayedColumns(),
    expandAll: () => e.expandAll(),
    collapseAll: () => e.collapseAll(),
    refreshRowGroups: () => {
      e.getGridOption("rowModelType") === "serverSide" && e.getServerSideGroupLevelState().forEach(({ route: c }) => e.refreshServerSide({ route: c, purge: !1 }));
    },
    isRowExpanded: (c) => {
      var u;
      return ((u = s(c)) == null ? void 0 : u.expanded) ?? !1;
    },
    hasChildren: (c) => {
      var u;
      return ((u = s(c)) == null ? void 0 : u.isExpandable()) ?? !1;
    },
    setRowExpanded: (c, u) => {
      const h = s(c);
      h && e.setRowNodeExpanded(h, u);
    },
    applyTransaction: ({ add: c, update: u, remove: h }) => {
      const g = h == null ? void 0 : h.flatMap((p) => {
        var m;
        const f = (m = s(p)) == null ? void 0 : m.data;
        return f === void 0 ? [] : [f];
      });
      e.applyTransaction({ add: c, update: u, remove: g });
    },
    updateRow: (c, u) => {
      var h;
      return (h = s(c)) == null ? void 0 : h.setData(u);
    },
    getDisplayedRowRange: () => {
      const c = e.getFirstDisplayedRowIndex(), u = e.getLastDisplayedRowIndex();
      return c < 0 || u < 0 ? null : { first: c, last: u };
    },
    getBodyScrollTop: () => {
      var c;
      return ((c = a()) == null ? void 0 : c.scrollTop) ?? 0;
    },
    setBodyScrollTop: (c) => {
      const u = a();
      u && (u.scrollTop = c);
    },
    clearActiveRow: () => {
      var c;
      return (c = t.clearActiveRow) == null ? void 0 : c.call(t);
    },
    showNoRowsOverlay: () => e.showNoRowsOverlay(),
    resetTreeColumn: () => {
      const c = e.getGridOption("autoGroupColumnDef");
      c && e.setGridOption("autoGroupColumnDef", { ...c });
    },
    startEditing: (c, u, h) => {
      const g = r(c), p = u ?? Nf(e, c)[0];
      g === null || p === void 0 || (DR(e, h != null && h.quiet ? { rowId: c, columnId: p } : null), e.startEditingCell({ rowIndex: g, colKey: p }));
    },
    stopEditing: (c) => e.stopEditing(c),
    getEditingCells: () => e.getEditingCells().flatMap((c) => {
      var g, p;
      const u = c.rowPinned || (g = e.getDisplayedRowAtIndex(c.rowIndex)) == null ? void 0 : g.id, h = (p = c.column) == null ? void 0 : p.getColId();
      return u === void 0 || h === void 0 ? [] : [{ rowId: u, columnId: h }];
    }),
    getNavigableColumnIds: (c, u) => Nf(e, c, {
      hasControl: u != null && u.controls ? (h) => cR(c, h, n()) : void 0
    }),
    setFocusedCell: (c, u) => {
      const h = r(c);
      h !== null && e.setFocusedCell(h, u);
    },
    focusEditor: (c, u, h) => uR(c, u, n(), h),
    cellAt: (c) => aR(c, n()),
    rowAt: (c) => v1(c, n()),
    getRowElements: (c) => C1(c, n()),
    getCellElement: (c, u) => Rg(c, u, n()),
    isInsideGrid: (c) => dR(c, n()),
    isGridOverlay: w1,
    isTreeToggle: lR,
    addEventListener(c, u) {
      var C;
      if (c === $f) {
        (C = d.get(u)) == null || C();
        const w = pR(e, (b) => u({ rowId: b }));
        d.set(u, w);
        return;
      }
      const h = c, g = (w) => {
        const b = FR(h, w);
        b !== void 0 && u(b);
      }, p = l.get(h) ?? /* @__PURE__ */ new Map(), f = p.get(u);
      f && !e.isDestroyed() && e.removeEventListener(f.agType, f.agListener);
      const m = kR(h, o());
      p.set(u, { agType: m, agListener: g }), l.set(h, p), e.addEventListener(m, g);
    },
    removeEventListener(c, u) {
      var p, f, m;
      if (c === $f) {
        (p = d.get(u)) == null || p(), d.delete(u);
        return;
      }
      const h = c, g = (f = l.get(h)) == null ? void 0 : f.get(u);
      g && ((m = l.get(h)) == null || m.delete(u), e.isDestroyed() || e.removeEventListener(g.agType, g.agListener));
    }
  };
}
function OR(e, t, n) {
  return Math.max(0, n, ...e, ...t);
}
const zf = "editable-table-cell-content-resized";
function GR(e = {}) {
  const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  let r = null, a = null, l = !1;
  const d = (F, E) => {
    F.style.height !== E && (F.style.height = E);
  }, c = (F) => Array.from(document.querySelectorAll(`.ag-row[row-id="${CSS.escape(F)}"] .ag-cell`)), u = (F) => Array.from(
    document.querySelectorAll(`.ag-row[row-id="${CSS.escape(F)}"] .ag-cell textarea`)
  ), h = (F) => Array.from(document.querySelectorAll(`.ag-row[row-id="${CSS.escape(F)}"]`));
  function g(F, E, M, I) {
    let P = s.get(F);
    return P || (P = /* @__PURE__ */ new Map(), s.set(F, P)), E.forEach((k, B) => {
      const j = k.getAttribute("col-id");
      j && P.set(j, M[B]);
    }), P.forEach((k, B) => {
      I.has(B) || P.delete(B);
    }), P;
  }
  function p(F) {
    F.forEach((M) => {
      M.style.minHeight = "0px", M.style.height = "auto";
    });
    const E = F.map((M) => M.scrollHeight);
    F.forEach((M, I) => {
      M.style.height = "", M.style.minHeight = `${E[I]}px`;
    });
  }
  function f(F) {
    var N;
    if (!a || a.isDestroyed() || !t.has(F)) return;
    const E = a.getRowNode(F), M = c(F);
    if (!E || !M.length) return;
    M.forEach((re) => d(re, "")), p(u(F));
    const I = M.map((re) => re.scrollHeight), P = new Set(a.getAllDisplayedColumns().map((re) => re.getColId())), k = g(F, M, I, P), B = Math.max(i.get(F) ?? 0, ((N = e.minRowHeight) == null ? void 0 : N.call(e)) ?? 0), j = OR(I, k.values(), B);
    j <= 0 || (Math.abs(j - (E.rowHeight ?? 0)) > 1 && (E.setRowHeight(j), a.onRowHeightChanged()), M.forEach((re, H) => d(re, I[H] < j ? `${j}px` : "")));
  }
  function m(F) {
    o.add(F), r === null && (r = requestAnimationFrame(() => {
      r = null;
      const E = [...o];
      o.clear(), E.forEach(f);
    }));
  }
  function C(F) {
    var B;
    (B = n.get(F)) == null || B();
    const E = c(F);
    if (!E.length) return;
    const M = new ResizeObserver(() => m(F));
    E.forEach((j) => M.observe(j));
    const I = h(F), P = new ResizeObserver(() => m(F));
    I.forEach((j) => P.observe(j));
    const k = () => m(F);
    I.forEach((j) => {
      j.addEventListener("input", k), j.addEventListener(zf, k);
    }), n.set(F, () => {
      M.disconnect(), P.disconnect(), I.forEach((j) => {
        j.removeEventListener("input", k), j.removeEventListener(zf, k);
      });
    });
  }
  function w(F) {
    var E;
    t.delete(F), (E = n.get(F)) == null || E(), n.delete(F), s.delete(F), i.delete(F);
  }
  function b(F) {
    "finished" in F && !F.finished || !t.size || Xe(() => t.forEach(C));
  }
  function A(F) {
    const E = F.node.id;
    E != null && (a = F.api, l || (l = !0, a.addEventListener("columnMoved", b), a.addEventListener("columnResized", b), a.addEventListener("virtualColumnsChanged", b)), w(E), t.add(E), i.set(E, F.node.rowHeight ?? 0), Xe(() => {
      t.has(E) && !F.api.isDestroyed() && C(E);
    }));
  }
  function S(F) {
    var k;
    const { node: E, api: M } = F, I = E.id;
    if (I != null && w(I), M.isDestroyed()) return;
    I != null && c(I).forEach((B) => d(B, "")), E.setRowHeight(void 0), ((k = M.getColumns()) == null ? void 0 : k.some((B) => B.getColDef().autoHeight)) ?? !1 ? M.redrawRows({ rowNodes: [E] }) : M.onRowHeightChanged();
  }
  return io(() => {
    r !== null && (cancelAnimationFrame(r), r = null), a && !a.isDestroyed() && l && (a.removeEventListener("columnMoved", b), a.removeEventListener("columnResized", b), a.removeEventListener("virtualColumnsChanged", b)), n.forEach((F) => F()), n.clear(), t.clear(), o.clear(), s.clear(), i.clear();
  }), { onRowEditingStarted: A, onRowEditingStopped: S };
}
function Aa(e) {
  return e == null ? "" : Array.isArray(e) ? e.map(Aa).join(",") : typeof e == "object" ? "" : String(e);
}
function HR(e) {
  var i, r, a;
  const t = e.horizontalAlign, n = (i = e.colDef) == null ? void 0 : i.cellRendererParams, o = n && typeof n == "object" ? n.horizontalAlign : void 0, s = (a = (r = e.colDef) == null ? void 0 : r.context) == null ? void 0 : a.defaultAlignment;
  return t ?? o ?? s ?? "left";
}
function VR(e) {
  const { node: t } = e;
  return t.rowPinned || e.api.isDestroyed() ? !1 : e.api.getEditingCells().some((n) => !n.rowPinned && n.rowIndex === t.rowIndex);
}
function _R(e) {
  return ("eParentOfValue" in e ? e.eParentOfValue : void 0) ?? e.eGridCell ?? null;
}
function O1(e) {
  var t;
  return {
    row: e.data,
    rowId: e.node.id ?? "",
    columnId: ((t = e.column) == null ? void 0 : t.getColId()) ?? "",
    align: HR(e),
    options: e.gridCell.options(e),
    getCellElement: () => _R(e)
  };
}
function Ag(e) {
  var t;
  return ((t = e.column) == null ? void 0 : t.getColId()) === Ea;
}
function G1(e) {
  var n;
  const { node: t } = e;
  return {
    level: t.level,
    expanded: !!t.expanded,
    hasChildren: (((n = t.childrenAfterGroup) == null ? void 0 : n.length) ?? 0) > 0,
    setExpanded: (o) => t.setExpanded(o)
  };
}
function NR(e) {
  return {
    ...O1(e),
    value: e.value,
    formatted: e.valueFormatted ?? Aa(e.value),
    editing: VR(e),
    ...Ag(e) ? { tree: G1(e) } : {},
    ...oo(e.node) ? { groupRow: !0 } : {}
  };
}
function $R(e, t, n = e.cellStartedEdit) {
  const o = e.formatValue(t);
  return {
    ...O1(e),
    value: t,
    formatted: o == null ? Aa(t) : Aa(o),
    editing: !0,
    startedHere: n,
    ...Ag(e) ? { tree: G1(e) } : {}
  };
}
function zR(e, t) {
  return t.patch && e.data && Object.assign(e.data, t.patch), t.dirty ? e.parseValue(t.value) : e.value;
}
const H1 = /* @__PURE__ */ de({
  __name: "AgGridCellEditorBridge",
  props: {
    params: {}
  },
  setup(e, { expose: t }) {
    const n = e, o = Qe(n.params.value), s = n.params.cellStartedEdit && !TR(n.params.api, {
      rowId: n.params.node.id ?? "",
      columnId: n.params.column.getColId()
    });
    let i = !1, r;
    const a = D(() => $R(n.params, o.value, s));
    function l(u) {
      o.value = u, i = u !== n.params.value, c();
    }
    function d(u) {
      r = { ...r, ...u }, c();
    }
    function c() {
      const { params: u } = n, { field: h, valueSetter: g } = u.colDef, p = { ...r };
      i && h && !g && (p[h] = u.parseValue(o.value)), hR(u.api, u.node, u.column.getColId(), p);
    }
    return io(() => gR(n.params.api, n.params.node.id, n.params.column.getColId())), t({
      getValue: () => zR(n.params, { value: o.value, dirty: i, patch: r })
    }), (u, h) => (v(), z(Ot(e.params.gridCell.component), at(a.value, {
      "onUpdate:value": l,
      onPatchRow: d
    }), null, 16));
  }
}), Fg = /* @__PURE__ */ de({
  __name: "AgGridCellRendererBridge",
  props: {
    params: {}
  },
  setup(e, { expose: t }) {
    const n = e, o = Qe(n.params), s = Qe(0), i = D(() => (s.value, NR(o.value))), r = ["expandedChanged", "hasChildrenChanged"], a = () => s.value++, l = Ag(n.params);
    return Et(() => {
      l && r.forEach((d) => o.value.node.addEventListener(d, a));
    }), ks(() => {
      l && r.forEach((d) => o.value.node.removeEventListener(d, a));
    }), t({
      /** `refreshInPlace: false` in the options makes ag-Grid rebuild the cell instead. */
      refresh(d) {
        return d.gridCell.options(d).refreshInPlace === !1 ? !1 : (o.value = d, !0);
      }
    }), (d, c) => (v(), z(Ot(o.value.gridCell.component), pi(Sa(i.value)), null, 16));
  }
}), V1 = /* @__PURE__ */ de({
  __name: "AgGridFullWidthBridge",
  props: {
    params: {}
  },
  setup(e, { expose: t }) {
    const o = Qe(e.params), s = D(() => o.value.fullWidth.options());
    return t({
      refresh(i) {
        return o.value = i, !0;
      }
    }), (i, r) => (v(), z(Ot(o.value.fullWidth.component), {
      row: o.value.data,
      "row-id": o.value.node.id ?? "",
      options: s.value
    }, null, 8, ["row", "row-id", "options"]));
  }
});
function _1(e, t) {
  return {
    gridCell: {
      component: e,
      options: (n) => typeof t == "function" ? t(n) : t ?? {}
    }
  };
}
function RMe(e, t) {
  return { cellEditor: H1, cellEditorParams: _1(e, t) };
}
function EMe(e, t) {
  return {
    fullWidthCellRenderer: V1,
    fullWidthCellRendererParams: { fullWidth: { component: e, options: () => t } }
  };
}
function AMe(e, t) {
  return { cellRenderer: Fg, cellRendererParams: _1(e, t) };
}
function FMe(e, t) {
  return !!t.rowGroup || N1(e) === t.colId;
}
function N1(e) {
  var t;
  if (e.getColumnState().some((n) => n.rowGroup))
    return (t = e.getGridOption("autoGroupColumnDef")) == null ? void 0 : t.field;
}
function MMe(e) {
  const t = N1(e);
  return e.getColumnState().filter((n) => n.sort != null).sort((n, o) => (n.sortIndex ?? 0) - (o.sortIndex ?? 0)).map((n) => ({
    id: n.colId === Ea && t ? t : n.colId,
    desc: n.sort === "desc"
  }));
}
function Wf(e) {
  return typeof e == "string" ? e === "" ? null : e : typeof e == "number" || typeof e == "boolean" ? String(e) : e != null && typeof e == "object" ? JSON.stringify(e) : null;
}
function WR(e) {
  if (!Array.isArray(e)) return Wf(e);
  const t = e.map(Wf).filter((n) => n !== null);
  return t.length > 0 ? [...new Set(t)].sort().join("|") : null;
}
const Uf = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, UR = (e, t, n) => {
  let o;
  const s = n != null && n.addSuffix ? Uf[e].withPreposition : Uf[e].standalone;
  return typeof s == "string" ? o = s : t === 1 ? o = s.one : o = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : "vor " + o : o;
}, KR = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, ZR = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, qR = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, jR = {
  date: Yi({
    formats: KR,
    defaultWidth: "full"
  }),
  time: Yi({
    formats: ZR,
    defaultWidth: "full"
  }),
  dateTime: Yi({
    formats: qR,
    defaultWidth: "full"
  })
}, YR = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, QR = (e, t, n, o) => YR[e], JR = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, XR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, ah = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, eE = {
  narrow: ah.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: ah.wide
}, tE = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, nE = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, oE = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, sE = (e) => Number(e) + ".", iE = {
  ordinalNumber: sE,
  era: Co({
    values: JR,
    defaultWidth: "wide"
  }),
  quarter: Co({
    values: XR,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Co({
    values: ah,
    formattingValues: eE,
    defaultWidth: "wide"
  }),
  day: Co({
    values: tE,
    defaultWidth: "wide"
  }),
  dayPeriod: Co({
    values: nE,
    defaultWidth: "wide",
    formattingValues: oE,
    defaultFormattingWidth: "wide"
  })
}, rE = /^(\d+)(\.)?/i, aE = /\d+/i, lE = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, dE = {
  any: [/^v/i, /^n/i]
}, cE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, uE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, gE = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, pE = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, fE = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, mE = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, vE = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, CE = {
  ordinalNumber: t1({
    matchPattern: rE,
    parsePattern: aE,
    valueCallback: (e) => parseInt(e)
  }),
  era: wo({
    matchPatterns: lE,
    defaultMatchWidth: "wide",
    parsePatterns: dE,
    defaultParseWidth: "any"
  }),
  quarter: wo({
    matchPatterns: cE,
    defaultMatchWidth: "wide",
    parsePatterns: uE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: wo({
    matchPatterns: hE,
    defaultMatchWidth: "wide",
    parsePatterns: gE,
    defaultParseWidth: "any"
  }),
  day: wo({
    matchPatterns: pE,
    defaultMatchWidth: "wide",
    parsePatterns: fE,
    defaultParseWidth: "any"
  }),
  dayPeriod: wo({
    matchPatterns: mE,
    defaultMatchWidth: "wide",
    parsePatterns: vE,
    defaultParseWidth: "any"
  })
}, $1 = {
  code: "de",
  formatDistance: UR,
  formatLong: jR,
  formatRelative: QR,
  localize: iE,
  match: CE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, wE = "captureStackTrace" in Error;
class Mg extends Error {
  constructor(n = "Unspecified AssertionError", o, s) {
    super(n);
    Ae(this, "message");
    this.message = n, wE && Error.captureStackTrace(this, s || Mg);
    for (const i in o)
      i in this || (this[i] = o[i]);
  }
  get name() {
    return "AssertionError";
  }
  get ok() {
    return !1;
  }
  toJSON(n) {
    return {
      ...this,
      name: this.name,
      message: this.message,
      ok: !1,
      stack: n !== !1 ? this.stack : void 0
    };
  }
}
function Kf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Fa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kf(Object(n), !0).forEach(function(o) {
      yE(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kf(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function yE(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function gd(e) {
  return typeof e == "function";
}
function lh(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Jd(e) {
  return gd(e.$validator) ? Fa({}, e) : {
    $validator: e
  };
}
function z1(e) {
  return typeof e == "object" ? e.$valid : e;
}
function W1(e) {
  return e.$validator || e;
}
function bE(e, t) {
  if (!lh(e)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof e}`);
  if (!lh(t) && !gd(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const n = Jd(t);
  return n.$params = Fa(Fa({}, n.$params || {}), e), n;
}
function SE(e, t) {
  if (!gd(e) && typeof T(e) != "string") throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof e}`);
  if (!lh(t) && !gd(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const n = Jd(t);
  return n.$message = e, n;
}
function xE(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const n = Jd(e);
  return Fa(Fa({}, n), {}, {
    $async: !0,
    $watchTargets: t
  });
}
function RE(e) {
  return {
    $validator(t) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
        o[s - 1] = arguments[s];
      return T(t).reduce((i, r, a) => {
        const l = Object.entries(r).reduce((d, c) => {
          let [u, h] = c;
          const g = e[u] || {}, p = Object.entries(g).reduce((f, m) => {
            let [C, w] = m;
            const A = W1(w).call(this, h, r, a, ...o), S = z1(A);
            if (f.$data[C] = A, f.$data.$invalid = !S || !!f.$data.$invalid, f.$data.$error = f.$data.$invalid, !S) {
              let F = w.$message || "";
              const E = w.$params || {};
              typeof F == "function" && (F = F({
                $pending: !1,
                $invalid: !S,
                $params: E,
                $model: h,
                $response: A
              })), f.$errors.push({
                $property: u,
                $message: F,
                $params: E,
                $response: A,
                $model: h,
                $pending: !1,
                $validator: C
              });
            }
            return {
              $valid: f.$valid && S,
              $data: f.$data,
              $errors: f.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return d.$data[u] = p.$data, d.$errors[u] = p.$errors, {
            $valid: d.$valid && p.$valid,
            $data: d.$data,
            $errors: d.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: i.$valid && l.$valid,
          $data: i.$data.concat(l.$data),
          $errors: i.$errors.concat(l.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (t) => {
      let {
        $response: n
      } = t;
      return n ? n.$errors.map((o) => Object.values(o).map((s) => s.map((i) => i.$message)).reduce((s, i) => s.concat(i), [])) : [];
    }
  };
}
const Ig = (e) => {
  if (e = T(e), Array.isArray(e)) return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, EE = (e) => (e = T(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function Os() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return (o) => (o = T(o), !Ig(o) || t.every((s) => (s.lastIndex = 0, s.test(o))));
}
var Pg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: RE,
  len: EE,
  normalizeValidatorObject: Jd,
  regex: Os,
  req: Ig,
  unwrap: T,
  unwrapNormalizedValidator: W1,
  unwrapValidatorResponse: z1,
  withAsync: xE,
  withMessage: SE,
  withParams: bE
});
Os(/^[a-zA-Z]*$/);
Os(/^[a-zA-Z0-9]*$/);
Os(/^\d*(\.\d+)?$/);
const AE = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var FE = Os(AE), ME = {
  $validator: FE,
  $message: "Value is not a valid email address",
  $params: {
    type: "email"
  }
};
function IE(e) {
  return typeof e == "string" && (e = e.trim()), Ig(e);
}
var PE = {
  $validator: IE,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const DE = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
var TE = Os(DE), kE = {
  $validator: TE,
  $message: "The value is not a valid URL address",
  $params: {
    type: "url"
  }
};
Os(/(^[0-9]*$)|(^-[0-9]+$)/);
Os(/^[-]?\d*(\.\d+)?$/);
var Qc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function LE(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var s = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
function BE(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var zl = { exports: {} };
const OE = {}, GE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OE
}, Symbol.toStringTag, { value: "Module" })), HE = /* @__PURE__ */ LE(GE);
var VE = zl.exports, Zf;
function Xd() {
  return Zf || (Zf = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(VE, function() {
      var n = n || (function(o, s) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof Qc < "u" && Qc.crypto && (i = Qc.crypto), !i && typeof BE == "function")
          try {
            i = HE;
          } catch {
          }
        var r = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, a = Object.create || /* @__PURE__ */ (function() {
          function w() {
          }
          return function(b) {
            var A;
            return w.prototype = b, A = new w(), w.prototype = null, A;
          };
        })(), l = {}, d = l.lib = {}, c = d.Base = /* @__PURE__ */ (function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(w) {
              var b = a(this);
              return w && b.mixIn(w), (!b.hasOwnProperty("init") || this.init === b.init) && (b.init = function() {
                b.$super.init.apply(this, arguments);
              }), b.init.prototype = b, b.$super = this, b;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var w = this.extend();
              return w.init.apply(w, arguments), w;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(w) {
              for (var b in w)
                w.hasOwnProperty(b) && (this[b] = w[b]);
              w.hasOwnProperty("toString") && (this.toString = w.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        })(), u = d.WordArray = c.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(w, b) {
            w = this.words = w || [], b != s ? this.sigBytes = b : this.sigBytes = w.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(w) {
            return (w || g).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(w) {
            var b = this.words, A = w.words, S = this.sigBytes, F = w.sigBytes;
            if (this.clamp(), S % 4)
              for (var E = 0; E < F; E++) {
                var M = A[E >>> 2] >>> 24 - E % 4 * 8 & 255;
                b[S + E >>> 2] |= M << 24 - (S + E) % 4 * 8;
              }
            else
              for (var I = 0; I < F; I += 4)
                b[S + I >>> 2] = A[I >>> 2];
            return this.sigBytes += F, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var w = this.words, b = this.sigBytes;
            w[b >>> 2] &= 4294967295 << 32 - b % 4 * 8, w.length = o.ceil(b / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var w = c.clone.call(this);
            return w.words = this.words.slice(0), w;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(w) {
            for (var b = [], A = 0; A < w; A += 4)
              b.push(r());
            return new u.init(b, w);
          }
        }), h = l.enc = {}, g = h.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(w) {
            for (var b = w.words, A = w.sigBytes, S = [], F = 0; F < A; F++) {
              var E = b[F >>> 2] >>> 24 - F % 4 * 8 & 255;
              S.push((E >>> 4).toString(16)), S.push((E & 15).toString(16));
            }
            return S.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(w) {
            for (var b = w.length, A = [], S = 0; S < b; S += 2)
              A[S >>> 3] |= parseInt(w.substr(S, 2), 16) << 24 - S % 8 * 4;
            return new u.init(A, b / 2);
          }
        }, p = h.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(w) {
            for (var b = w.words, A = w.sigBytes, S = [], F = 0; F < A; F++) {
              var E = b[F >>> 2] >>> 24 - F % 4 * 8 & 255;
              S.push(String.fromCharCode(E));
            }
            return S.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(w) {
            for (var b = w.length, A = [], S = 0; S < b; S++)
              A[S >>> 2] |= (w.charCodeAt(S) & 255) << 24 - S % 4 * 8;
            return new u.init(A, b);
          }
        }, f = h.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(w) {
            try {
              return decodeURIComponent(escape(p.stringify(w)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(w) {
            return p.parse(unescape(encodeURIComponent(w)));
          }
        }, m = d.BufferedBlockAlgorithm = c.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new u.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(w) {
            typeof w == "string" && (w = f.parse(w)), this._data.concat(w), this._nDataBytes += w.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(w) {
            var b, A = this._data, S = A.words, F = A.sigBytes, E = this.blockSize, M = E * 4, I = F / M;
            w ? I = o.ceil(I) : I = o.max((I | 0) - this._minBufferSize, 0);
            var P = I * E, k = o.min(P * 4, F);
            if (P) {
              for (var B = 0; B < P; B += E)
                this._doProcessBlock(S, B);
              b = S.splice(0, P), A.sigBytes -= k;
            }
            return new u.init(b, k);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var w = c.clone.call(this);
            return w._data = this._data.clone(), w;
          },
          _minBufferSize: 0
        });
        d.Hasher = m.extend({
          /**
           * Configuration options.
           */
          cfg: c.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(w) {
            this.cfg = this.cfg.extend(w), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            m.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(w) {
            return this._append(w), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(w) {
            w && this._append(w);
            var b = this._doFinalize();
            return b;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(w) {
            return function(b, A) {
              return new w.init(A).finalize(b);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(w) {
            return function(b, A) {
              return new C.HMAC.init(w, A).finalize(b);
            };
          }
        });
        var C = l.algo = {};
        return l;
      })(Math);
      return n;
    });
  })(zl)), zl.exports;
}
Xd();
var Wl = { exports: {} }, _E = Wl.exports, qf;
function NE() {
  return qf || (qf = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o(Xd());
    })(_E, function(n) {
      return (function(o) {
        var s = n, i = s.lib, r = i.WordArray, a = i.Hasher, l = s.algo, d = [], c = [];
        (function() {
          function g(C) {
            for (var w = o.sqrt(C), b = 2; b <= w; b++)
              if (!(C % b))
                return !1;
            return !0;
          }
          function p(C) {
            return (C - (C | 0)) * 4294967296 | 0;
          }
          for (var f = 2, m = 0; m < 64; )
            g(f) && (m < 8 && (d[m] = p(o.pow(f, 1 / 2))), c[m] = p(o.pow(f, 1 / 3)), m++), f++;
        })();
        var u = [], h = l.SHA256 = a.extend({
          _doReset: function() {
            this._hash = new r.init(d.slice(0));
          },
          _doProcessBlock: function(g, p) {
            for (var f = this._hash.words, m = f[0], C = f[1], w = f[2], b = f[3], A = f[4], S = f[5], F = f[6], E = f[7], M = 0; M < 64; M++) {
              if (M < 16)
                u[M] = g[p + M] | 0;
              else {
                var I = u[M - 15], P = (I << 25 | I >>> 7) ^ (I << 14 | I >>> 18) ^ I >>> 3, k = u[M - 2], B = (k << 15 | k >>> 17) ^ (k << 13 | k >>> 19) ^ k >>> 10;
                u[M] = P + u[M - 7] + B + u[M - 16];
              }
              var j = A & S ^ ~A & F, N = m & C ^ m & w ^ C & w, re = (m << 30 | m >>> 2) ^ (m << 19 | m >>> 13) ^ (m << 10 | m >>> 22), H = (A << 26 | A >>> 6) ^ (A << 21 | A >>> 11) ^ (A << 7 | A >>> 25), _ = E + H + j + c[M] + u[M], ne = re + N;
              E = F, F = S, S = A, A = b + _ | 0, b = w, w = C, C = m, m = _ + ne | 0;
            }
            f[0] = f[0] + m | 0, f[1] = f[1] + C | 0, f[2] = f[2] + w | 0, f[3] = f[3] + b | 0, f[4] = f[4] + A | 0, f[5] = f[5] + S | 0, f[6] = f[6] + F | 0, f[7] = f[7] + E | 0;
          },
          _doFinalize: function() {
            var g = this._data, p = g.words, f = this._nDataBytes * 8, m = g.sigBytes * 8;
            return p[m >>> 5] |= 128 << 24 - m % 32, p[(m + 64 >>> 9 << 4) + 14] = o.floor(f / 4294967296), p[(m + 64 >>> 9 << 4) + 15] = f, g.sigBytes = p.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var g = a.clone.call(this);
            return g._hash = this._hash.clone(), g;
          }
        });
        s.SHA256 = a._createHelper(h), s.HmacSHA256 = a._createHmacHelper(h);
      })(Math), n.SHA256;
    });
  })(Wl)), Wl.exports;
}
NE();
var Ul = { exports: {} }, $E = Ul.exports, jf;
function zE() {
  return jf || (jf = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o(Xd());
    })($E, function(n) {
      return (function() {
        var o = n, s = o.lib, i = s.WordArray, r = o.enc;
        r.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(l) {
            var d = l.words, c = l.sigBytes, u = this._map;
            l.clamp();
            for (var h = [], g = 0; g < c; g += 3)
              for (var p = d[g >>> 2] >>> 24 - g % 4 * 8 & 255, f = d[g + 1 >>> 2] >>> 24 - (g + 1) % 4 * 8 & 255, m = d[g + 2 >>> 2] >>> 24 - (g + 2) % 4 * 8 & 255, C = p << 16 | f << 8 | m, w = 0; w < 4 && g + w * 0.75 < c; w++)
                h.push(u.charAt(C >>> 6 * (3 - w) & 63));
            var b = u.charAt(64);
            if (b)
              for (; h.length % 4; )
                h.push(b);
            return h.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(l) {
            var d = l.length, c = this._map, u = this._reverseMap;
            if (!u) {
              u = this._reverseMap = [];
              for (var h = 0; h < c.length; h++)
                u[c.charCodeAt(h)] = h;
            }
            var g = c.charAt(64);
            if (g) {
              var p = l.indexOf(g);
              p !== -1 && (d = p);
            }
            return a(l, d, u);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function a(l, d, c) {
          for (var u = [], h = 0, g = 0; g < d; g++)
            if (g % 4) {
              var p = c[l.charCodeAt(g - 1)] << g % 4 * 2, f = c[l.charCodeAt(g)] >>> 6 - g % 4 * 2, m = p | f;
              u[h >>> 2] |= m << 24 - h % 4 * 8, h++;
            }
          return i.create(u, h);
        }
      })(), n.enc.Base64;
    });
  })(Ul)), Ul.exports;
}
zE();
var Kl = { exports: {} }, WE = Kl.exports, Yf;
function UE() {
  return Yf || (Yf = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o(Xd());
    })(WE, function(n) {
      return n.enc.Utf8;
    });
  })(Kl)), Kl.exports;
}
UE();
function dh(e) {
  this.message = e;
}
dh.prototype = new Error(), dh.prototype.name = "InvalidCharacterError";
typeof window < "u" && window.atob && window.atob.bind(window);
function Qf(e) {
  this.message = e;
}
Qf.prototype = new Error(), Qf.prototype.name = "InvalidTokenError";
var KE = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, ho, go, pd = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(pd || {});
((e) => {
  function t() {
    ho = 3, go = KE;
  }
  e.reset = t;
  function n(s) {
    if (!(0 <= s && s <= 4))
      throw new Error("Invalid log level");
    ho = s;
  }
  e.setLevel = n;
  function o(s) {
    go = s;
  }
  e.setLogger = o;
})(pd || (pd = {}));
var uo = class {
  constructor(e) {
    this._name = e;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...e) {
    ho >= 4 && go.debug(uo._format(this._name, this._method), ...e);
  }
  info(...e) {
    ho >= 3 && go.info(uo._format(this._name, this._method), ...e);
  }
  warn(...e) {
    ho >= 2 && go.warn(uo._format(this._name, this._method), ...e);
  }
  error(...e) {
    ho >= 1 && go.error(uo._format(this._name, this._method), ...e);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(e) {
    throw this.error(e), e;
  }
  create(e) {
    const t = Object.create(this);
    return t._method = e, t.debug("begin"), t;
  }
  static createStatic(e, t) {
    const n = new uo(`${e}.${t}`);
    return n.debug("begin"), n;
  }
  static _format(e, t) {
    const n = `[${e}]`;
    return t ? `${n} ${t}:` : n;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(e, ...t) {
    ho >= 4 && go.debug(uo._format(e), ...t);
  }
  static info(e, ...t) {
    ho >= 3 && go.info(uo._format(e), ...t);
  }
  static warn(e, ...t) {
    ho >= 2 && go.warn(uo._format(e), ...t);
  }
  static error(e, ...t) {
    ho >= 1 && go.error(uo._format(e), ...t);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
pd.reset();
var Jf = class {
  constructor({
    prefix: e = "oidc.",
    store: t = localStorage
  } = {}) {
    this._logger = new uo("WebStorageStateStore"), this._store = t, this._prefix = e;
  }
  async set(e, t) {
    this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, t);
  }
  async get(e) {
    return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
  }
  async remove(e) {
    this._logger.create(`remove('${e}')`), e = this._prefix + e;
    const t = await this._store.getItem(e);
    return await this._store.removeItem(e), t;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const e = await this._store.length, t = [];
    for (let n = 0; n < e; n++) {
      const o = await this._store.key(n);
      o && o.indexOf(this._prefix) === 0 && t.push(o.substr(this._prefix.length));
    }
    return t;
  }
}, ei = Uv({
  settings: null,
  oidcSettings: null,
  userManager: null,
  refreshUserManager: null,
  user: null,
  token: D(() => {
    var e;
    return ((e = ei.user) == null ? void 0 : e.access_token) || null;
  }),
  hasExpiresAt: D(
    () => {
      var e;
      return Date.now() / 1e3 > ((e = ei.user) == null ? void 0 : e.expires_at) || !1;
    }
  ),
  redirect_uri: ""
}), ZE = {
  setUser(e) {
    var t;
    ei.user = e, (t = ei.userManager) == null || t.storeUser(e);
  },
  async removeUser() {
    var e;
    ei.user = null, await ((e = ei.userManager) == null ? void 0 : e.removeUser());
  }
};
function Dg() {
  return {
    state: D(() => ei),
    actions: D(() => ZE)
  };
}
Dg();
W("OIDC_REDIRECT_URI");
Dg();
const Jc = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_APP_AG_GRID_LICENSE: "Using_this_{AG_Grid}_Enterprise_key_{AG-114672}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Scayla_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Scayla}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Scayla}_need_to_be_licensed___{Scayla}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_December_2026}____[v3]_[01]_MTc5NjQyODgwMDAwMA==b963acb9189af440c44f6833bc375657", VITE_APP_OIDC_AUTHORITY: "https://login.scayla.com", VITE_APP_OIDC_CLIENT_ID: "355514447269206610", VITE_APP_SCAYLA_API_URL: "https://api.int.scayla.com", VITE_APP_SENTRY_DSN: "https://72329bf821e847c38a4c79be93849f23@glitchtip.scayla.com/2", VITE_APP_SENTRY_ENABLED: "true", VITE_APP_SENTRY_ENVIRONMENT: "integration", VITE_APP_SENTRY_PROJECT_NAME: "scayla-frontend", VITE_APP_SENTRY_VERSION: "dev", VITE_APP_SHOW_EMAIL_FEATURE: "true", VITE_APP_TINY_MCE_API_KEY: "nb1o9f0z1w7lvkth993fzrhi1fnjqfry6wnprsqnvke5kht4", VITE_APP_URL: "https://app.int.scayla.com" };
var qE = Object.create, U1 = Object.defineProperty, jE = Object.getOwnPropertyDescriptor, K1 = Object.getOwnPropertyNames, YE = Object.getPrototypeOf, QE = Object.prototype.hasOwnProperty, ec = (e, t) => function() {
  return t || (0, e[K1(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, JE = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let s of K1(t))
      !QE.call(e, s) && s !== n && U1(e, s, { get: () => t[s], enumerable: !(o = jE(t, s)) || o.enumerable });
  return e;
}, XE = (e, t, n) => (n = e != null ? qE(YE(e)) : {}, JE(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  U1(n, "default", { value: e, enumerable: !0 }),
  e
)), eA = ec({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/codes.json"(e, t) {
    t.exports = [
      ["AF", "AFG", "004", "ISO 3166-2:AF"],
      ["AL", "ALB", "008", "ISO 3166-2:AL"],
      ["DZ", "DZA", "012", "ISO 3166-2:DZ"],
      ["AS", "ASM", "016", "ISO 3166-2:AS"],
      ["AD", "AND", "020", "ISO 3166-2:AD"],
      ["AO", "AGO", "024", "ISO 3166-2:AO"],
      ["AI", "AIA", "660", "ISO 3166-2:AI"],
      ["AQ", "ATA", "010", "ISO 3166-2:AQ"],
      ["AG", "ATG", "028", "ISO 3166-2:AG"],
      ["AR", "ARG", "032", "ISO 3166-2:AR"],
      ["AM", "ARM", "051", "ISO 3166-2:AM"],
      ["AW", "ABW", "533", "ISO 3166-2:AW"],
      ["AU", "AUS", "036", "ISO 3166-2:AU"],
      ["AT", "AUT", "040", "ISO 3166-2:AT"],
      ["AZ", "AZE", "031", "ISO 3166-2:AZ"],
      ["BS", "BHS", "044", "ISO 3166-2:BS"],
      ["BH", "BHR", "048", "ISO 3166-2:BH"],
      ["BD", "BGD", "050", "ISO 3166-2:BD"],
      ["BB", "BRB", "052", "ISO 3166-2:BB"],
      ["BY", "BLR", "112", "ISO 3166-2:BY"],
      ["BE", "BEL", "056", "ISO 3166-2:BE"],
      ["BZ", "BLZ", "084", "ISO 3166-2:BZ"],
      ["BJ", "BEN", "204", "ISO 3166-2:BJ"],
      ["BM", "BMU", "060", "ISO 3166-2:BM"],
      ["BT", "BTN", "064", "ISO 3166-2:BT"],
      ["BO", "BOL", "068", "ISO 3166-2:BO"],
      ["BA", "BIH", "070", "ISO 3166-2:BA"],
      ["BW", "BWA", "072", "ISO 3166-2:BW"],
      ["BV", "BVT", "074", "ISO 3166-2:BV"],
      ["BR", "BRA", "076", "ISO 3166-2:BR"],
      ["IO", "IOT", "086", "ISO 3166-2:IO"],
      ["BN", "BRN", "096", "ISO 3166-2:BN"],
      ["BG", "BGR", "100", "ISO 3166-2:BG"],
      ["BF", "BFA", "854", "ISO 3166-2:BF"],
      ["BI", "BDI", "108", "ISO 3166-2:BI"],
      ["KH", "KHM", "116", "ISO 3166-2:KH"],
      ["CM", "CMR", "120", "ISO 3166-2:CM"],
      ["CA", "CAN", "124", "ISO 3166-2:CA"],
      ["CV", "CPV", "132", "ISO 3166-2:CV"],
      ["KY", "CYM", "136", "ISO 3166-2:KY"],
      ["CF", "CAF", "140", "ISO 3166-2:CF"],
      ["TD", "TCD", "148", "ISO 3166-2:TD"],
      ["CL", "CHL", "152", "ISO 3166-2:CL"],
      ["CN", "CHN", "156", "ISO 3166-2:CN"],
      ["CX", "CXR", "162", "ISO 3166-2:CX"],
      ["CC", "CCK", "166", "ISO 3166-2:CC"],
      ["CO", "COL", "170", "ISO 3166-2:CO"],
      ["KM", "COM", "174", "ISO 3166-2:KM"],
      ["CG", "COG", "178", "ISO 3166-2:CG"],
      ["CD", "COD", "180", "ISO 3166-2:CD"],
      ["CK", "COK", "184", "ISO 3166-2:CK"],
      ["CR", "CRI", "188", "ISO 3166-2:CR"],
      ["CI", "CIV", "384", "ISO 3166-2:CI"],
      ["HR", "HRV", "191", "ISO 3166-2:HR"],
      ["CU", "CUB", "192", "ISO 3166-2:CU"],
      ["CY", "CYP", "196", "ISO 3166-2:CY"],
      ["CZ", "CZE", "203", "ISO 3166-2:CZ"],
      ["DK", "DNK", "208", "ISO 3166-2:DK"],
      ["DJ", "DJI", "262", "ISO 3166-2:DJ"],
      ["DM", "DMA", "212", "ISO 3166-2:DM"],
      ["DO", "DOM", "214", "ISO 3166-2:DO"],
      ["EC", "ECU", "218", "ISO 3166-2:EC"],
      ["EG", "EGY", "818", "ISO 3166-2:EG"],
      ["SV", "SLV", "222", "ISO 3166-2:SV"],
      ["GQ", "GNQ", "226", "ISO 3166-2:GQ"],
      ["ER", "ERI", "232", "ISO 3166-2:ER"],
      ["EE", "EST", "233", "ISO 3166-2:EE"],
      ["ET", "ETH", "231", "ISO 3166-2:ET"],
      ["FK", "FLK", "238", "ISO 3166-2:FK"],
      ["FO", "FRO", "234", "ISO 3166-2:FO"],
      ["FJ", "FJI", "242", "ISO 3166-2:FJ"],
      ["FI", "FIN", "246", "ISO 3166-2:FI"],
      ["FR", "FRA", "250", "ISO 3166-2:FR"],
      ["GF", "GUF", "254", "ISO 3166-2:GF"],
      ["PF", "PYF", "258", "ISO 3166-2:PF"],
      ["TF", "ATF", "260", "ISO 3166-2:TF"],
      ["GA", "GAB", "266", "ISO 3166-2:GA"],
      ["GM", "GMB", "270", "ISO 3166-2:GM"],
      ["GE", "GEO", "268", "ISO 3166-2:GE"],
      ["DE", "DEU", "276", "ISO 3166-2:DE"],
      ["GH", "GHA", "288", "ISO 3166-2:GH"],
      ["GI", "GIB", "292", "ISO 3166-2:GI"],
      ["GR", "GRC", "300", "ISO 3166-2:GR"],
      ["GL", "GRL", "304", "ISO 3166-2:GL"],
      ["GD", "GRD", "308", "ISO 3166-2:GD"],
      ["GP", "GLP", "312", "ISO 3166-2:GP"],
      ["GU", "GUM", "316", "ISO 3166-2:GU"],
      ["GT", "GTM", "320", "ISO 3166-2:GT"],
      ["GN", "GIN", "324", "ISO 3166-2:GN"],
      ["GW", "GNB", "624", "ISO 3166-2:GW"],
      ["GY", "GUY", "328", "ISO 3166-2:GY"],
      ["HT", "HTI", "332", "ISO 3166-2:HT"],
      ["HM", "HMD", "334", "ISO 3166-2:HM"],
      ["VA", "VAT", "336", "ISO 3166-2:VA"],
      ["HN", "HND", "340", "ISO 3166-2:HN"],
      ["HK", "HKG", "344", "ISO 3166-2:HK"],
      ["HU", "HUN", "348", "ISO 3166-2:HU"],
      ["IS", "ISL", "352", "ISO 3166-2:IS"],
      ["IN", "IND", "356", "ISO 3166-2:IN"],
      ["ID", "IDN", "360", "ISO 3166-2:ID"],
      ["IR", "IRN", "364", "ISO 3166-2:IR"],
      ["IQ", "IRQ", "368", "ISO 3166-2:IQ"],
      ["IE", "IRL", "372", "ISO 3166-2:IE"],
      ["IL", "ISR", "376", "ISO 3166-2:IL"],
      ["IT", "ITA", "380", "ISO 3166-2:IT"],
      ["JM", "JAM", "388", "ISO 3166-2:JM"],
      ["JP", "JPN", "392", "ISO 3166-2:JP"],
      ["JO", "JOR", "400", "ISO 3166-2:JO"],
      ["KZ", "KAZ", "398", "ISO 3166-2:KZ"],
      ["KE", "KEN", "404", "ISO 3166-2:KE"],
      ["KI", "KIR", "296", "ISO 3166-2:KI"],
      ["KP", "PRK", "408", "ISO 3166-2:KP"],
      ["KR", "KOR", "410", "ISO 3166-2:KR"],
      ["KW", "KWT", "414", "ISO 3166-2:KW"],
      ["KG", "KGZ", "417", "ISO 3166-2:KG"],
      ["LA", "LAO", "418", "ISO 3166-2:LA"],
      ["LV", "LVA", "428", "ISO 3166-2:LV"],
      ["LB", "LBN", "422", "ISO 3166-2:LB"],
      ["LS", "LSO", "426", "ISO 3166-2:LS"],
      ["LR", "LBR", "430", "ISO 3166-2:LR"],
      ["LY", "LBY", "434", "ISO 3166-2:LY"],
      ["LI", "LIE", "438", "ISO 3166-2:LI"],
      ["LT", "LTU", "440", "ISO 3166-2:LT"],
      ["LU", "LUX", "442", "ISO 3166-2:LU"],
      ["MO", "MAC", "446", "ISO 3166-2:MO"],
      ["MG", "MDG", "450", "ISO 3166-2:MG"],
      ["MW", "MWI", "454", "ISO 3166-2:MW"],
      ["MY", "MYS", "458", "ISO 3166-2:MY"],
      ["MV", "MDV", "462", "ISO 3166-2:MV"],
      ["ML", "MLI", "466", "ISO 3166-2:ML"],
      ["MT", "MLT", "470", "ISO 3166-2:MT"],
      ["MH", "MHL", "584", "ISO 3166-2:MH"],
      ["MQ", "MTQ", "474", "ISO 3166-2:MQ"],
      ["MR", "MRT", "478", "ISO 3166-2:MR"],
      ["MU", "MUS", "480", "ISO 3166-2:MU"],
      ["YT", "MYT", "175", "ISO 3166-2:YT"],
      ["MX", "MEX", "484", "ISO 3166-2:MX"],
      ["FM", "FSM", "583", "ISO 3166-2:FM"],
      ["MD", "MDA", "498", "ISO 3166-2:MD"],
      ["MC", "MCO", "492", "ISO 3166-2:MC"],
      ["MN", "MNG", "496", "ISO 3166-2:MN"],
      ["MS", "MSR", "500", "ISO 3166-2:MS"],
      ["MA", "MAR", "504", "ISO 3166-2:MA"],
      ["MZ", "MOZ", "508", "ISO 3166-2:MZ"],
      ["MM", "MMR", "104", "ISO 3166-2:MM"],
      ["NA", "NAM", "516", "ISO 3166-2:NA"],
      ["NR", "NRU", "520", "ISO 3166-2:NR"],
      ["NP", "NPL", "524", "ISO 3166-2:NP"],
      ["NL", "NLD", "528", "ISO 3166-2:NL"],
      ["NC", "NCL", "540", "ISO 3166-2:NC"],
      ["NZ", "NZL", "554", "ISO 3166-2:NZ"],
      ["NI", "NIC", "558", "ISO 3166-2:NI"],
      ["NE", "NER", "562", "ISO 3166-2:NE"],
      ["NG", "NGA", "566", "ISO 3166-2:NG"],
      ["NU", "NIU", "570", "ISO 3166-2:NU"],
      ["NF", "NFK", "574", "ISO 3166-2:NF"],
      ["MP", "MNP", "580", "ISO 3166-2:MP"],
      ["MK", "MKD", "807", "ISO 3166-2:MK"],
      ["NO", "NOR", "578", "ISO 3166-2:NO"],
      ["OM", "OMN", "512", "ISO 3166-2:OM"],
      ["PK", "PAK", "586", "ISO 3166-2:PK"],
      ["PW", "PLW", "585", "ISO 3166-2:PW"],
      ["PS", "PSE", "275", "ISO 3166-2:PS"],
      ["PA", "PAN", "591", "ISO 3166-2:PA"],
      ["PG", "PNG", "598", "ISO 3166-2:PG"],
      ["PY", "PRY", "600", "ISO 3166-2:PY"],
      ["PE", "PER", "604", "ISO 3166-2:PE"],
      ["PH", "PHL", "608", "ISO 3166-2:PH"],
      ["PN", "PCN", "612", "ISO 3166-2:PN"],
      ["PL", "POL", "616", "ISO 3166-2:PL"],
      ["PT", "PRT", "620", "ISO 3166-2:PT"],
      ["PR", "PRI", "630", "ISO 3166-2:PR"],
      ["QA", "QAT", "634", "ISO 3166-2:QA"],
      ["RE", "REU", "638", "ISO 3166-2:RE"],
      ["RO", "ROU", "642", "ISO 3166-2:RO"],
      ["RU", "RUS", "643", "ISO 3166-2:RU"],
      ["RW", "RWA", "646", "ISO 3166-2:RW"],
      ["SH", "SHN", "654", "ISO 3166-2:SH"],
      ["KN", "KNA", "659", "ISO 3166-2:KN"],
      ["LC", "LCA", "662", "ISO 3166-2:LC"],
      ["PM", "SPM", "666", "ISO 3166-2:PM"],
      ["VC", "VCT", "670", "ISO 3166-2:VC"],
      ["WS", "WSM", "882", "ISO 3166-2:WS"],
      ["SM", "SMR", "674", "ISO 3166-2:SM"],
      ["ST", "STP", "678", "ISO 3166-2:ST"],
      ["SA", "SAU", "682", "ISO 3166-2:SA"],
      ["SN", "SEN", "686", "ISO 3166-2:SN"],
      ["SC", "SYC", "690", "ISO 3166-2:SC"],
      ["SL", "SLE", "694", "ISO 3166-2:SL"],
      ["SG", "SGP", "702", "ISO 3166-2:SG"],
      ["SK", "SVK", "703", "ISO 3166-2:SK"],
      ["SI", "SVN", "705", "ISO 3166-2:SI"],
      ["SB", "SLB", "090", "ISO 3166-2:SB"],
      ["SO", "SOM", "706", "ISO 3166-2:SO"],
      ["ZA", "ZAF", "710", "ISO 3166-2:ZA"],
      ["GS", "SGS", "239", "ISO 3166-2:GS"],
      ["ES", "ESP", "724", "ISO 3166-2:ES"],
      ["LK", "LKA", "144", "ISO 3166-2:LK"],
      ["SD", "SDN", "729", "ISO 3166-2:SD"],
      ["SR", "SUR", "740", "ISO 3166-2:SR"],
      ["SJ", "SJM", "744", "ISO 3166-2:SJ"],
      ["SZ", "SWZ", "748", "ISO 3166-2:SZ"],
      ["SE", "SWE", "752", "ISO 3166-2:SE"],
      ["CH", "CHE", "756", "ISO 3166-2:CH"],
      ["SY", "SYR", "760", "ISO 3166-2:SY"],
      ["TW", "TWN", "158", "ISO 3166-2:TW"],
      ["TJ", "TJK", "762", "ISO 3166-2:TJ"],
      ["TZ", "TZA", "834", "ISO 3166-2:TZ"],
      ["TH", "THA", "764", "ISO 3166-2:TH"],
      ["TL", "TLS", "626", "ISO 3166-2:TL"],
      ["TG", "TGO", "768", "ISO 3166-2:TG"],
      ["TK", "TKL", "772", "ISO 3166-2:TK"],
      ["TO", "TON", "776", "ISO 3166-2:TO"],
      ["TT", "TTO", "780", "ISO 3166-2:TT"],
      ["TN", "TUN", "788", "ISO 3166-2:TN"],
      ["TR", "TUR", "792", "ISO 3166-2:TR"],
      ["TM", "TKM", "795", "ISO 3166-2:TM"],
      ["TC", "TCA", "796", "ISO 3166-2:TC"],
      ["TV", "TUV", "798", "ISO 3166-2:TV"],
      ["UG", "UGA", "800", "ISO 3166-2:UG"],
      ["UA", "UKR", "804", "ISO 3166-2:UA"],
      ["AE", "ARE", "784", "ISO 3166-2:AE"],
      ["GB", "GBR", "826", "ISO 3166-2:GB"],
      ["US", "USA", "840", "ISO 3166-2:US"],
      ["UM", "UMI", "581", "ISO 3166-2:UM"],
      ["UY", "URY", "858", "ISO 3166-2:UY"],
      ["UZ", "UZB", "860", "ISO 3166-2:UZ"],
      ["VU", "VUT", "548", "ISO 3166-2:VU"],
      ["VE", "VEN", "862", "ISO 3166-2:VE"],
      ["VN", "VNM", "704", "ISO 3166-2:VN"],
      ["VG", "VGB", "092", "ISO 3166-2:VG"],
      ["VI", "VIR", "850", "ISO 3166-2:VI"],
      ["WF", "WLF", "876", "ISO 3166-2:WF"],
      ["EH", "ESH", "732", "ISO 3166-2:EH"],
      ["YE", "YEM", "887", "ISO 3166-2:YE"],
      ["ZM", "ZMB", "894", "ISO 3166-2:ZM"],
      ["ZW", "ZWE", "716", "ISO 3166-2:ZW"],
      ["AX", "ALA", "248", "ISO 3166-2:AX"],
      ["BQ", "BES", "535", "ISO 3166-2:BQ"],
      ["CW", "CUW", "531", "ISO 3166-2:CW"],
      ["GG", "GGY", "831", "ISO 3166-2:GG"],
      ["IM", "IMN", "833", "ISO 3166-2:IM"],
      ["JE", "JEY", "832", "ISO 3166-2:JE"],
      ["ME", "MNE", "499", "ISO 3166-2:ME"],
      ["BL", "BLM", "652", "ISO 3166-2:BL"],
      ["MF", "MAF", "663", "ISO 3166-2:MF"],
      ["RS", "SRB", "688", "ISO 3166-2:RS"],
      ["SX", "SXM", "534", "ISO 3166-2:SX"],
      ["SS", "SSD", "728", "ISO 3166-2:SS"],
      ["XK", "XKK", "983", "ISO 3166-2:XK"]
    ];
  }
}), tA = ec({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/supportedLocales.json"(e, t) {
    t.exports = [
      "br",
      "cy",
      "dv",
      "sw",
      "eu",
      "af",
      "am",
      "ha",
      "ku",
      "ml",
      "mt",
      "no",
      "ps",
      "sd",
      "so",
      "sq",
      "ta",
      "tg",
      "tt",
      "ug",
      "ur",
      "vi",
      "ar",
      "az",
      "be",
      "bg",
      "bn",
      "bs",
      "ca",
      "cs",
      "da",
      "de",
      "el",
      "en",
      "es",
      "et",
      "fa",
      "fi",
      "fr",
      "ga",
      "gl",
      "he",
      "hi",
      "hr",
      "hu",
      "hy",
      "id",
      "is",
      "it",
      "ja",
      "ka",
      "kk",
      "km",
      "ko",
      "ky",
      "lt",
      "lv",
      "mk",
      "mn",
      "mr",
      "ms",
      "nb",
      "nl",
      "nn",
      "pl",
      "pt",
      "ro",
      "ru",
      "sk",
      "sl",
      "sr",
      "sv",
      "th",
      "tk",
      "tr",
      "uk",
      "uz",
      "zh"
    ];
  }
}), nA = ec({
  "../../common/temp/node_modules/.pnpm/diacritics@1.3.0/node_modules/diacritics/index.js"(e) {
    e.remove = r;
    var t = [
      {
        base: " ",
        chars: " "
      },
      {
        base: "0",
        chars: "߀"
      },
      {
        base: "A",
        chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
      },
      {
        base: "AA",
        chars: "Ꜳ"
      },
      {
        base: "AE",
        chars: "ÆǼǢ"
      },
      {
        base: "AO",
        chars: "Ꜵ"
      },
      {
        base: "AU",
        chars: "Ꜷ"
      },
      {
        base: "AV",
        chars: "ꜸꜺ"
      },
      {
        base: "AY",
        chars: "Ꜽ"
      },
      {
        base: "B",
        chars: "ⒷＢḂḄḆɃƁ"
      },
      {
        base: "C",
        chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
      },
      {
        base: "D",
        chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
      },
      {
        base: "Dh",
        chars: "Ð"
      },
      {
        base: "DZ",
        chars: "ǱǄ"
      },
      {
        base: "Dz",
        chars: "ǲǅ"
      },
      {
        base: "E",
        chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
      },
      {
        base: "F",
        chars: "ꝼⒻＦḞƑꝻ"
      },
      {
        base: "G",
        chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
      },
      {
        base: "H",
        chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
      },
      {
        base: "I",
        chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
      },
      {
        base: "J",
        chars: "ⒿＪĴɈȷ"
      },
      {
        base: "K",
        chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
      },
      {
        base: "L",
        chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
      },
      {
        base: "LJ",
        chars: "Ǉ"
      },
      {
        base: "Lj",
        chars: "ǈ"
      },
      {
        base: "M",
        chars: "ⓂＭḾṀṂⱮƜϻ"
      },
      {
        base: "N",
        chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
      },
      {
        base: "NJ",
        chars: "Ǌ"
      },
      {
        base: "Nj",
        chars: "ǋ"
      },
      {
        base: "O",
        chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
      },
      {
        base: "OE",
        chars: "Œ"
      },
      {
        base: "OI",
        chars: "Ƣ"
      },
      {
        base: "OO",
        chars: "Ꝏ"
      },
      {
        base: "OU",
        chars: "Ȣ"
      },
      {
        base: "P",
        chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
      },
      {
        base: "Q",
        chars: "ⓆＱꝖꝘɊ"
      },
      {
        base: "R",
        chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
      },
      {
        base: "S",
        chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
      },
      {
        base: "T",
        chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
      },
      {
        base: "Th",
        chars: "Þ"
      },
      {
        base: "TZ",
        chars: "Ꜩ"
      },
      {
        base: "U",
        chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
      },
      {
        base: "V",
        chars: "ⓋＶṼṾƲꝞɅ"
      },
      {
        base: "VY",
        chars: "Ꝡ"
      },
      {
        base: "W",
        chars: "ⓌＷẀẂŴẆẄẈⱲ"
      },
      {
        base: "X",
        chars: "ⓍＸẊẌ"
      },
      {
        base: "Y",
        chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
      },
      {
        base: "Z",
        chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
      },
      {
        base: "a",
        chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
      },
      {
        base: "aa",
        chars: "ꜳ"
      },
      {
        base: "ae",
        chars: "æǽǣ"
      },
      {
        base: "ao",
        chars: "ꜵ"
      },
      {
        base: "au",
        chars: "ꜷ"
      },
      {
        base: "av",
        chars: "ꜹꜻ"
      },
      {
        base: "ay",
        chars: "ꜽ"
      },
      {
        base: "b",
        chars: "ⓑｂḃḅḇƀƃɓƂ"
      },
      {
        base: "c",
        chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
      },
      {
        base: "d",
        chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
      },
      {
        base: "dh",
        chars: "ð"
      },
      {
        base: "dz",
        chars: "ǳǆ"
      },
      {
        base: "e",
        chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
      },
      {
        base: "f",
        chars: "ⓕｆḟƒ"
      },
      {
        base: "ff",
        chars: "ﬀ"
      },
      {
        base: "fi",
        chars: "ﬁ"
      },
      {
        base: "fl",
        chars: "ﬂ"
      },
      {
        base: "ffi",
        chars: "ﬃ"
      },
      {
        base: "ffl",
        chars: "ﬄ"
      },
      {
        base: "g",
        chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
      },
      {
        base: "h",
        chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
      },
      {
        base: "hv",
        chars: "ƕ"
      },
      {
        base: "i",
        chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
      },
      {
        base: "j",
        chars: "ⓙｊĵǰɉ"
      },
      {
        base: "k",
        chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
      },
      {
        base: "l",
        chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
      },
      {
        base: "lj",
        chars: "ǉ"
      },
      {
        base: "m",
        chars: "ⓜｍḿṁṃɱɯ"
      },
      {
        base: "n",
        chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
      },
      {
        base: "nj",
        chars: "ǌ"
      },
      {
        base: "o",
        chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
      },
      {
        base: "oe",
        chars: "œ"
      },
      {
        base: "oi",
        chars: "ƣ"
      },
      {
        base: "oo",
        chars: "ꝏ"
      },
      {
        base: "ou",
        chars: "ȣ"
      },
      {
        base: "p",
        chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
      },
      {
        base: "q",
        chars: "ⓠｑɋꝗꝙ"
      },
      {
        base: "r",
        chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
      },
      {
        base: "s",
        chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
      },
      {
        base: "ss",
        chars: "ß"
      },
      {
        base: "t",
        chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
      },
      {
        base: "th",
        chars: "þ"
      },
      {
        base: "tz",
        chars: "ꜩ"
      },
      {
        base: "u",
        chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
      },
      {
        base: "v",
        chars: "ⓥｖṽṿʋꝟʌ"
      },
      {
        base: "vy",
        chars: "ꝡ"
      },
      {
        base: "w",
        chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
      },
      {
        base: "x",
        chars: "ⓧｘẋẍ"
      },
      {
        base: "y",
        chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
      },
      {
        base: "z",
        chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
      }
    ], n = {};
    for (i = 0; i < t.length; i += 1)
      for (o = t[i].chars, s = 0; s < o.length; s += 1)
        n[o[s]] = t[i].base;
    var o, s, i;
    function r(a) {
      return a.replace(/[^\u0000-\u007e]/g, function(l) {
        return n[l] || l;
      });
    }
    e.replacementList = t, e.diacriticsMap = n;
  }
}), oA = ec({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/index.js"(e) {
    var t = eA(), n = tA(), o = nA().remove, s = {}, i = {}, r = {}, a = {}, l = {};
    t.forEach(function(S) {
      const F = S;
      i[F[0]] = F[1], r[F[1]] = F[0], a[F[2]] = F[0], l[F[0]] = F[2];
    });
    function d(S) {
      return ("000" + (S || "")).slice(-3);
    }
    function c(S, F) {
      return Object.prototype.hasOwnProperty.call(S, F);
    }
    function u(S, F) {
      return Object.keys(S).reduce(function(E, M) {
        const I = S[M];
        return E[M] = F(I, M), E;
      }, {});
    }
    function h(S, F) {
      switch (S) {
        case "official":
          return Array.isArray(F) ? F[0] : F;
        case "all":
          return typeof F == "string" ? [F] : F;
        case "alias":
          return Array.isArray(F) ? F[1] || F[0] : F;
        default:
          throw new TypeError(
            "LocaleNameType must be one of these: all, official, alias!"
          );
      }
    }
    e.registerLocale = function(S) {
      if (!S.locale)
        throw new TypeError("Missing localeData.locale");
      if (!S.countries)
        throw new TypeError("Missing localeData.countries");
      s[S.locale] = S.countries;
    };
    function g(S) {
      return r[S];
    }
    e.alpha3ToAlpha2 = g;
    function p(S) {
      return i[S];
    }
    e.alpha2ToAlpha3 = p;
    function f(S) {
      return l[g(S)];
    }
    e.alpha3ToNumeric = f;
    function m(S) {
      return l[S];
    }
    e.alpha2ToNumeric = m;
    function C(S) {
      const F = d(S);
      return p(a[F]);
    }
    e.numericToAlpha3 = C;
    function w(S) {
      const F = d(S);
      return a[F];
    }
    e.numericToAlpha2 = w;
    function b(S) {
      if (typeof S == "string") {
        if (/^[0-9]*$/.test(S))
          return C(S);
        if (S.length === 2)
          return p(S.toUpperCase());
        if (S.length === 3)
          return S.toUpperCase();
      }
      if (typeof S == "number")
        return C(S);
    }
    e.toAlpha3 = b;
    function A(S) {
      if (typeof S == "string") {
        if (/^[0-9]*$/.test(S))
          return w(S);
        if (S.length === 2)
          return S.toUpperCase();
        if (S.length === 3)
          return g(S.toUpperCase());
      }
      if (typeof S == "number")
        return w(S);
    }
    e.toAlpha2 = A, e.getName = function(S, F, E = {}) {
      "select" in E || (E.select = "official");
      try {
        const I = s[F.toLowerCase()][A(S)];
        return h(E.select, I);
      } catch {
        return;
      }
    }, e.getNames = function(S, F = {}) {
      "select" in F || (F.select = "official");
      const E = s[S.toLowerCase()];
      return E === void 0 ? {} : u(E, function(M) {
        return h(F.select, M);
      });
    }, e.getAlpha2Code = function(S, F) {
      const E = (I) => I.toLowerCase(), M = (I, P) => E(I) === E(P);
      try {
        const I = s[F.toLowerCase()];
        for (const P in I)
          if (c(I, P)) {
            if (typeof I[P] == "string" && M(I[P], S))
              return P;
            if (Array.isArray(I[P])) {
              for (const k of I[P])
                if (M(k, S))
                  return P;
            }
          }
        return;
      } catch {
        return;
      }
    }, e.getSimpleAlpha2Code = function(S, F) {
      const E = (I) => o(I.toLowerCase()), M = (I, P) => E(I) === E(P);
      try {
        const I = s[F.toLowerCase()];
        for (const P in I)
          if (c(I, P)) {
            if (typeof I[P] == "string" && M(I[P], S))
              return P;
            if (Array.isArray(I[P])) {
              for (const k of I[P])
                if (M(k, S))
                  return P;
            }
          }
        return;
      } catch {
        return;
      }
    }, e.getAlpha2Codes = function() {
      return i;
    }, e.getAlpha3Code = function(S, F) {
      const E = e.getAlpha2Code(S, F);
      if (E)
        return e.toAlpha3(E);
    }, e.getSimpleAlpha3Code = function(S, F) {
      const E = e.getSimpleAlpha2Code(S, F);
      if (E)
        return e.toAlpha3(E);
    }, e.getAlpha3Codes = function() {
      return r;
    }, e.getNumericCodes = function() {
      return a;
    }, e.langs = function() {
      return Object.keys(s);
    }, e.getSupportedLanguages = function() {
      return n;
    }, e.isValid = function(S) {
      if (!S)
        return !1;
      const F = S.toString().toUpperCase();
      return c(r, F) || c(i, F) || c(a, F);
    };
  }
}), sA = class {
  /**
   * Creates a new ErrorService instance
   *
   * @param logger - LoggerFactory instance for creating the error logger
   */
  constructor(e) {
    /** Logger instance for error reporting */
    Ae(this, "logger");
    /**
     * Logs an error message and re-throws the error
     *
     * This method provides a centralized point for error handling that ensures
     * all errors are logged before being propagated. It supports both standard
     * Error objects and ContextAwareError objects.
     *
     * @param error - The error to log and throw (standard Error or ContextAwareError)
     * @throws The same error that was passed in, after logging
     *
     * @example
     * ```typescript
     * try {
     *   await apiCall();
     * } catch (error) {
     *   errorService.throwError(error); // Logs error message and re-throws
     * }
     * ```
     */
    Ae(this, "throwError", (e) => {
      throw this.logger.error(e.message)(), e;
    });
    this.logger = e.getLogger("error");
  }
}, ml = {
  log_raise_error: 1,
  log_with_warnings: 2,
  trace: 3,
  debug: 4,
  info: 5,
  warn: 6,
  error: 7,
  disable: 8
}, iA = class Z1 {
  /**
   * Creates a new LoggerFactory with the specified configuration
   *
   * @param logLevel - Global logging level (defaults to "log_with_warnings")
   * @param mockConsole - Console implementation to use (defaults to window.console)
   * @throws Error if the provided logLevel is invalid
   */
  constructor(t = "log_with_warnings", n = null) {
    /**
     * Current global logging level that determines which messages are displayed
     */
    Ae(this, "logLevel");
    /**
     * Console implementation used for actual output (allows for testing/mocking)
     */
    Ae(this, "mockConsole");
    if (this.logLevel = t, !ml[t])
      throw Error(`Invalid log level ${t} allowed: ${JSON.stringify(ml)}`);
    n ? this.mockConsole = n : this.mockConsole = console;
  }
  /**
   * No-op function used when log messages are filtered out by level
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dummy() {
  }
  /**
   * Updates the global logging level for all loggers created by this factory
   *
   * @param logWarnings - New logging level to apply
   */
  setLogWarnings(t) {
    this.logLevel = t;
  }
  /**
   * Gets the current global logging level
   *
   * @returns The current LogLevel setting
   */
  getLogWarnings() {
    return this.logLevel;
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param name - badge string, that every log will be marked with
   * @param color - css color of badge, e.g. #FFFAAA
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   */
  getSingleLoggerColor(t, n, o) {
    return this.getSingleLoggerStyle(t, this.getColorStyle(n), o);
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param name - badge string, that every log will be marked with
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   */
  getSingleLogger(t, n) {
    const o = this.getRandomColor(t);
    return this.getSingleLoggerStyle(t, this.getColorStyle(o), n);
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   * @param name - badge string, that every log will be marked with
   * @param minLevel - initial logging level, .e.g 2
   * @param style - css style, e.g. `font-size: 10px; border-color: red`
   */
  getSingleLoggerStyle(t, n, o, s = "log_with_warnings") {
    return (...i) => {
      if (ml[this.logLevel] > ml[s])
        return this.dummy;
      const r = Array.prototype.slice.call(i), a = r.shift().split("{}"), l = [this.mockConsole, "%c" + t, n];
      for (let d = 0; d < a.length; d++)
        l.push(a[d]), typeof r[d] < "u" && l.push(r[d]);
      if (a.length - 1 !== r.length) {
        if (this.logLevel === "log_with_warnings")
          this.mockConsole.error("MissMatch amount of arguments");
        else if (this.logLevel === "log_raise_error")
          throw new Error("MissMatch amount of arguments");
      }
      return Function.prototype.bind.apply(o, l);
    };
  }
  /**
   * @return logger with badged tag
   * @param name - badge string, that every log will be marked with
   * @param color - css color of badge, e.g. #FFFAAA
   */
  getLoggerColor(t, n) {
    return this.getLoggerStyle(t, this.getColorStyle(n));
  }
  /**
   * @return css for badge
   * @param color - css color, e.g. #FFFAAA
   */
  getColorStyle(t) {
    return `color: white; background-color: ${t}; padding: 2px 6px; border-radius: 2px; font-size: 10px`;
  }
  /**
   * Hash function from https://stackoverflow.com/a/52171480/3872976
   */
  static getHash(t, n = 0) {
    let o = 3735928559 ^ n, s = 1103547991 ^ n;
    for (let i = 0, r; i < t.length; i++)
      r = t.charCodeAt(i), o = Math.imul(o ^ r, 2654435761), s = Math.imul(s ^ r, 1597334677);
    return o = Math.imul(o ^ o >>> 16, 2246822507) ^ Math.imul(s ^ s >>> 13, 3266489909), s = Math.imul(s ^ s >>> 16, 2246822507) ^ Math.imul(o ^ o >>> 13, 3266489909), 4294967296 * (2097151 & s) + (o >>> 0);
  }
  /**
   * Generates a random color based on the hash of the string
   **/
  getRandomColor(t = "") {
    const n = Z1.getHash(t);
    let o = "#";
    for (let s = 0; s < 3; s++)
      o += ("00" + ((n >> s * 7 & 127) + 8).toString(16)).substr(-2);
    return o;
  }
  /**
   * @return a logger object with generated colored tag by hash of name
   * @param name - badge string, that every log will be marked with
   */
  getLogger(t) {
    return this.getLoggerColor(t, this.getRandomColor(t));
  }
  /**
   * @return a logger object
   * @param name - badge string, that every log will be marked with
   * @param style - css style, e.g. `font-size: 10px; border-color: red`
   */
  getLoggerStyle(t, n) {
    return {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      trace: this.getSingleLoggerStyle(t, n, this.mockConsole.trace, "trace"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      debug: this.getSingleLoggerStyle(t, n, this.mockConsole.debug, "debug"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      log: this.getSingleLoggerStyle(t, n, this.mockConsole.log, "info"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      warn: this.getSingleLoggerStyle(t, n, this.mockConsole.warn, "warn"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      error: this.getSingleLoggerStyle(t, n, this.mockConsole.error, "error")
    };
  }
}, q1 = new iA("debug"), rA = new sA(q1);
function Tg(e) {
  return q1.getLogger(e);
}
function aA() {
  return rA;
}
function fd(e, t) {
  const { placeholder: n = "?", charCount: o = 2 } = t ?? {};
  if (!e) return n;
  const s = e.trim().split(/\s+/).map((l) => [...l]), i = new Array(s.length).fill("");
  let r = 0, a = s.reduce((l, d) => l + d.length, 0);
  for (; i.join("").length < o && a > 0; ) {
    for (; s[r].length === 0; )
      r = (r + 1) % s.length;
    i[r] += s[r].shift(), a--, r = (r + 1) % s.length;
  }
  return i.join("").toUpperCase();
}
var lA = XE(oA()), dA = {
  locale: "de",
  countries: {
    AF: "Afghanistan",
    EG: "Ägypten",
    AX: "Åland",
    AL: "Albanien",
    DZ: "Algerien",
    AS: "Amerikanisch-Samoa",
    VI: "Amerikanische Jungferninseln",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarktis",
    AG: "Antigua und Barbuda",
    GQ: "Äquatorialguinea",
    AR: "Argentinien",
    AM: "Armenien",
    AW: "Aruba",
    AZ: "Aserbaidschan",
    ET: "Äthiopien",
    AU: "Australien",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesch",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgien",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivien",
    BQ: "Bonaire",
    BA: "Bosnien und Herzegowina",
    BW: "Botswana",
    BV: "Bouvetinsel",
    BR: "Brasilien",
    VG: "Britische Jungferninseln",
    IO: "Britisches Territorium im Indischen Ozean",
    BN: "Brunei Darussalam",
    BG: "Bulgarien",
    BF: "Burkina Faso",
    BI: "Burundi",
    CL: "Chile",
    CN: "China",
    CK: "Cookinseln",
    CR: "Costa Rica",
    CI: "Elfenbeinküste",
    CW: "Curaçao",
    DK: "Dänemark",
    DE: "Deutschland",
    DM: "Dominica",
    DO: "Dominikanische Republik",
    DJ: "Dschibuti",
    EC: "Ecuador",
    SV: "El Salvador",
    ER: "Eritrea",
    EE: "Estland",
    FK: "Falklandinseln",
    FO: "Färöer",
    FJ: "Fidschi",
    FI: "Finnland",
    FR: "Frankreich",
    GF: "Französisch-Guayana",
    PF: "Französisch-Polynesien",
    TF: "Französische Süd- und Antarktisgebiete",
    GA: "Gabun",
    GM: "Gambia",
    GE: "Georgien",
    GH: "Ghana",
    GI: "Gibraltar",
    GD: "Grenada",
    GR: "Griechenland",
    GL: "Grönland",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard und McDonaldinseln",
    HN: "Honduras",
    HK: ["Hongkong", "Hong Kong"],
    IN: "Indien",
    ID: "Indonesien",
    IM: "Insel Man",
    IQ: "Irak",
    IR: "Iran",
    IE: "Irland",
    IS: "Island",
    IL: "Israel",
    IT: "Italien",
    JM: "Jamaika",
    JP: "Japan",
    YE: "Jemen",
    JE: "Jersey",
    JO: "Jordanien",
    KY: "Kaimaninseln",
    KH: "Kambodscha",
    CM: "Kamerun",
    CA: "Kanada",
    CV: "Kap Verde",
    KZ: "Kasachstan",
    QA: "Katar",
    KE: "Kenia",
    KG: "Kirgisistan",
    KI: "Kiribati",
    CC: "Kokosinseln",
    CO: "Kolumbien",
    KM: "Komoren",
    CD: "Kongo",
    KP: "Nordkorea",
    KR: "Südkorea",
    HR: "Kroatien",
    CU: "Kuba",
    KW: "Kuwait",
    LA: "Laos",
    LS: "Lesotho",
    LV: "Lettland",
    LB: "Libanon",
    LR: "Liberia",
    LY: "Libyen",
    LI: "Liechtenstein",
    LT: "Litauen",
    LU: "Luxemburg",
    MO: "Macao",
    MG: "Madagaskar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Malediven",
    ML: "Mali",
    MT: "Malta",
    MA: "Marokko",
    MH: "Marshallinseln",
    MQ: "Martinique",
    MR: "Mauretanien",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexiko",
    FM: "Mikronesien",
    MD: "Moldawien",
    MC: "Monaco",
    MN: "Mongolei",
    ME: "Montenegro",
    MS: "Montserrat",
    MZ: "Mosambik",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NC: "Neukaledonien",
    NZ: "Neuseeland",
    NI: "Nicaragua",
    NL: "Niederlande",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    MK: "Nordmazedonien",
    MP: "Nördliche Marianen",
    NF: "Norfolkinsel",
    NO: "Norwegen",
    OM: "Oman",
    AT: "Österreich",
    TL: "Osttimor",
    PK: "Pakistan",
    PS: "Staat Palästina",
    PW: "Palau",
    PA: "Panama",
    PG: "Papua-Neuguinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippinen",
    PN: "Pitcairninseln",
    PL: "Polen",
    PT: "Portugal",
    PR: "Puerto Rico",
    TW: "Taiwan",
    CG: "Republik Kongo",
    RE: "Réunion",
    RW: "Ruanda",
    RO: "Rumänien",
    RU: ["Russische Föderation", "Russland"],
    BL: "Saint-Barthélemy",
    MF: "Saint-Martin",
    SB: "Salomonen",
    ZM: "Sambia",
    WS: "Samoa",
    SM: "San Marino",
    ST: "São Tomé und Príncipe",
    SA: "Saudi-Arabien",
    SE: "Schweden",
    CH: "Schweiz",
    SN: "Senegal",
    RS: "Serbien",
    SC: "Seychellen",
    SL: "Sierra Leone",
    ZW: "Simbabwe",
    SG: "Singapur",
    SX: "Sint Maarten",
    SK: "Slowakei",
    SI: "Slowenien",
    SO: "Somalia",
    ES: "Spanien",
    LK: "Sri Lanka",
    SH: "St. Helena",
    KN: "St. Kitts und Nevis",
    LC: "St. Lucia",
    PM: "Saint-Pierre und Miquelon",
    VC: "St. Vincent und die Grenadinen",
    ZA: "Südafrika",
    SD: "Sudan",
    GS: "Südgeorgien und die Südlichen Sandwichinseln",
    SS: "Südsudan",
    SR: "Suriname",
    SJ: "Svalbard und Jan Mayen",
    SZ: "Eswatini",
    SY: "Syrien, Arabische Republik",
    TJ: "Tadschikistan",
    TZ: ["Tansania, Vereinigte Republik", "Tansania"],
    TH: "Thailand",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad und Tobago",
    TD: "Tschad",
    CZ: ["Tschechische Republik", "Tschechien"],
    TN: "Tunesien",
    TR: "Türkei",
    TM: "Turkmenistan",
    TC: "Turks- und Caicosinseln",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    HU: "Ungarn",
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VU: "Vanuatu",
    VA: "Vatikanstadt",
    VE: "Venezuela",
    AE: "Vereinigte Arabische Emirate",
    US: ["Vereinigte Staaten von Amerika", "Vereinigte Staaten", "USA"],
    GB: ["Vereinigtes Königreich", "Großbritannien"],
    VN: "Vietnam",
    WF: "Wallis und Futuna",
    CX: "Weihnachtsinsel",
    EH: "Westsahara",
    CF: "Zentralafrikanische Republik",
    CY: "Zypern",
    XK: "Kosovo"
  }
}, j1 = {
  locale: "en",
  countries: {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: ["People's Republic of China", "China"],
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: ["Republic of the Congo", "Congo"],
    CD: ["Democratic Republic of the Congo", "Congo"],
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: ["Cote d'Ivoire", "Côte d'Ivoire", "Ivory Coast"],
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: ["Czech Republic", "Czechia"],
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: ["Republic of The Gambia", "The Gambia", "Gambia"],
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island and McDonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: ["Islamic Republic of Iran", "Iran"],
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "North Korea",
    KR: ["South Korea", "Korea, Republic of", "Republic of Korea"],
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States of",
    MD: "Moldova, Republic of",
    MC: "Monaco",
    MN: "Mongolia",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"],
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MK: ["The Republic of North Macedonia", "North Macedonia"],
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: ["State of Palestine", "Palestine"],
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: ["Pitcairn", "Pitcairn Islands"],
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: ["Russian Federation", "Russia"],
    RW: "Rwanda",
    SH: "Saint Helena",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    PM: "Saint Pierre and Miquelon",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia and the South Sandwich Islands",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SZ: "Eswatini",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: ["Taiwan, Province of China", "Taiwan"],
    TJ: "Tajikistan",
    TZ: ["United Republic of Tanzania", "Tanzania"],
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: ["Türkiye", "Turkey"],
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: ["United Arab Emirates", "UAE"],
    GB: ["United Kingdom", "UK", "Great Britain"],
    US: ["United States of America", "United States", "USA", "U.S.A.", "US", "U.S."],
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis and Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    AX: ["Åland Islands", "Aland Islands"],
    BQ: "Bonaire, Sint Eustatius and Saba",
    CW: "Curaçao",
    GG: "Guernsey",
    IM: "Isle of Man",
    JE: "Jersey",
    ME: "Montenegro",
    BL: "Saint Barthélemy",
    MF: "Saint Martin (French part)",
    RS: "Serbia",
    SX: "Sint Maarten (Dutch part)",
    SS: "South Sudan",
    XK: "Kosovo"
  }
};
j1.locale;
for (const e of [j1, dA])
  lA.default.registerLocale(e);
var cA = {
  common: {
    validation: {
      empty: "Dieses Feld kann nicht leer sein.",
      fieldRequired: "Dieses Feld darf nicht leer sein.",
      containLeast: "Dieses Feld benötigt mindestens {length} Zeichen.",
      labelRequired: "{label} darf nicht leer sein."
    },
    label: {
      fieldNeedsValid: "Dieses Feld benötigt eine gültige URL.",
      fieldNeedsValid2: "Dieses Feld benötigt eine gültige E-Mail Adresse.",
      welcomeApp: "Willkommen zu unserer Applikation"
    },
    message: {
      paramCompletedSuccess: "{action} erfolgreich abgeschlossen.",
      paramError: "Fehler: {error}"
    }
  }
}, uA = {
  common: {
    validation: {
      empty: "Field can not be empty.",
      fieldRequired: "Field can't be empty.",
      containLeast: "Field must contain at least {length} characters.",
      labelRequired: "{label} can't be empty."
    },
    label: {
      fieldNeedsValid: "Field needs to be a valid URI.",
      fieldNeedsValid2: "Field needs to be a valid email address.",
      welcomeApp: "Welcome to our app"
    },
    message: {
      paramCompletedSuccess: "{action} completed successfully.",
      paramError: "Error: {error}"
    }
  }
}, Y1 = Wv({
  legacy: !1,
  locale: "en",
  fallbackLocale: "en",
  messages: { de: cA, en: uA },
  missingWarn: !1,
  fallbackWarn: !1
}), kg = (e, t) => Y1.global.t(e, {}), hA = () => Y1.global.locale.value;
function Xc(e) {
  return e.replace(/([.\-/ ])\1+/g, "$1").replace(/^[.\-/ ]+|[.\-/ ]+$/g, "");
}
function tc(e, t) {
  return t === "yy" ? Xc(e.replace(/d+/g, "").replace(/M+/g, "")) : t === "mm" ? Xc(e.replace(/d+/g, "").replace(/y+/g, "")) : t === "yy_mm" ? Xc(e.replace(/d+/g, "")) : e;
}
var gA = { hh: 1, hh_mm: 2, hh_mm_ss: 3, hh_mm_ss_ms: 4 };
function Lg(e, t) {
  var i;
  const n = t ? gA[t] : void 0;
  if (!n) return e;
  const o = ((i = /\s*a+$/.exec(e)) == null ? void 0 : i[0]) ?? "";
  let s = o ? e.slice(0, -o.length) : e;
  return n < 4 && (s = s.replace(/\.S+/, "")), n < 3 && (s = s.replace(/:s+/, "")), n < 2 && (s = s.replace(/:m+/, "")), s + o;
}
function nc(e) {
  return e.toLowerCase().startsWith("de") ? $1 : Cg;
}
function pA(e) {
  if (e == null || e === "") return;
  const t = e instanceof Date ? e : new Date(e);
  return Number.isNaN(t.getTime()) ? void 0 : t;
}
function Bg(e) {
  return nc(e ?? hA());
}
function oc(e, t, n = {}) {
  const o = pA(e);
  return o ? As(o, t, { locale: Bg(n.locale) }) : "";
}
function fA(e) {
  return Bg(e) === $1 ? "EEE dd. MMM yyyy, HH:mm" : "EEE dd. MMM. yyyy, HH:mm";
}
function Xf(e, t, n = {}) {
  const o = Fx(e, t, /* @__PURE__ */ new Date(), { locale: Bg(n.locale) });
  return vg(o) ? o : void 0;
}
function Og(e, t, n = {}) {
  return oc(e, tc(t, n.precision), n);
}
function mA(e, t, n, o = {}) {
  const s = tc(t, o.datePrecision), i = Lg(n, o.timePrecision);
  return oc(e, `${s}${o.separator ?? " "}${i}`, o);
}
function ch(e, t = 2) {
  if (e === 0) return "0 Bytes";
  const n = 1024, o = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], s = Math.floor(Math.log(e) / Math.log(n));
  return `${parseFloat((e / Math.pow(n, s)).toFixed(t))} ${o[s]}`;
}
async function vA(e) {
  var s;
  const t = (s = e.dataTransfer) == null ? void 0 : s.items;
  if (!t) return [];
  const n = [], o = async (i, r = "") => {
    if (i.isFile && await new Promise((a) => {
      i.file((l) => {
        n.push(new File([l], r + l.name, { type: l.type })), a();
      });
    }), i.isDirectory) {
      const a = i.createReader(), d = await (async () => {
        const c = [], u = () => new Promise((g) => {
          a.readEntries((p) => {
            g(p);
          });
        });
        let h = await u();
        for (; h.length > 0; )
          c.push(...h), h = await u();
        return c;
      })();
      await Promise.all(d.map((c) => o(c, r + i.name + "/")));
    }
  };
  return await Promise.all(
    Array.from(t).map(async (i) => {
      var a;
      const r = (a = i.webkitGetAsEntry) == null ? void 0 : a.call(i);
      r && await o(r);
    })
  ), n;
}
var uh = Tg("core/runtimeData");
function CA(e) {
  try {
    if (typeof document > "u")
      return {};
    const t = document.querySelector(`script[type="application/json"][data-selector="${e}"]`);
    return t != null && t.textContent ? t.textContent.trim() === "// RUNTIME_CONFIGURATION" ? {} : JSON.parse(t.textContent) : {};
  } catch (t) {
    return uh.error(`Couldn't read JSON data from ${e}`, t)(), {};
  }
}
function wA() {
  try {
    const e = CA("runtime-config");
    return uh.debug("Runtime config was fetched from meta tag.", e)(), e;
  } catch (e) {
    return uh.debug("Runtime config could not be fetched from meta tag.", e)(), {};
  }
}
function yA(e, t) {
  if (!t || !e) return [e];
  const n = t.trim().toLowerCase();
  if (!n) return [e];
  const o = Array.from(new Set(n.split(/\s+/).filter(Boolean)));
  if (!o.length) return [e];
  o.sort((d, c) => c.length - d.length);
  const s = (d) => d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), i = o.map(s).join("|"), r = new RegExp(`(${i})`, "gi"), a = [];
  let l = 0;
  for (const d of e.matchAll(r)) {
    const c = d.index ?? 0, u = d[0];
    if (c > l) {
      const h = e.substring(l, c);
      h.length > 0 && a.push(h);
    }
    a.push({ highlight: u }), l = c + u.length;
  }
  if (l < e.length) {
    const d = e.substring(l);
    d.length > 0 && a.push(d);
  }
  return a.length ? a : [e];
}
function eo(e, t) {
  if (e == null)
    throw new Mg(`Expected ${t} to be defined, but received ${e}`);
}
var hh = W(/* @__PURE__ */ new Date()), vl = 0, Zl;
function Q1() {
  const e = 6e4 - Date.now() % 6e4;
  Zl = setTimeout(() => {
    hh.value = /* @__PURE__ */ new Date(), Q1();
  }, e);
}
function bA() {
  return vl += 1, vl === 1 && (hh.value = /* @__PURE__ */ new Date(), Q1()), ro(() => {
    vl -= 1, vl === 0 && Zl && (clearTimeout(Zl), Zl = void 0);
  }), hh;
}
function SA(e) {
  return Yd() ? (ro(e), !0) : !1;
}
var eu = /* @__PURE__ */ new WeakMap(), xA = (...e) => {
  var t;
  const n = e[0], o = (t = $n()) == null ? void 0 : t.proxy;
  if (o == null && !qd())
    throw new Error("injectLocal must be called in setup");
  return o && eu.has(o) && n in eu.get(o) ? eu.get(o)[n] : Mi(...e);
}, RA = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var EA = Object.prototype.toString, AA = (e) => EA.call(e) === "[object Object]";
function FA(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const o = ((n = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", s = e.slice(o.length), i = Number.parseFloat(o) + t;
  return Number.isNaN(i) ? e : i + s;
}
function oa(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function tu(e) {
  return Array.isArray(e) ? e : [e];
}
function MA(e) {
  return $n();
}
function IA(e, t = !0, n) {
  MA() ? Et(e, n) : t ? e() : Xe(e);
}
function PA(e, t, n) {
  return Re(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
var Gg = RA ? window : void 0;
function DA(e) {
  var t;
  const n = xe(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function TA(...e) {
  const t = [], n = () => {
    t.forEach((a) => a()), t.length = 0;
  }, o = (a, l, d, c) => (a.addEventListener(l, d, c), () => a.removeEventListener(l, d, c)), s = D(() => {
    const a = tu(xe(e[0])).filter((l) => l != null);
    return a.every((l) => typeof l != "string") ? a : void 0;
  }), i = PA(
    () => {
      var a, l;
      return [
        (l = (a = s.value) == null ? void 0 : a.map((d) => DA(d))) != null ? l : [Gg].filter((d) => d != null),
        tu(xe(s.value ? e[1] : e[0])),
        tu(T(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        xe(s.value ? e[3] : e[2])
      ];
    },
    ([a, l, d, c]) => {
      if (n(), !(a != null && a.length) || !(l != null && l.length) || !(d != null && d.length))
        return;
      const u = AA(c) ? { ...c } : c;
      t.push(
        ...a.flatMap(
          (h) => l.flatMap(
            (g) => d.map((p) => o(h, g, p, u))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    i(), n();
  };
  return SA(n), r;
}
function kA() {
  const e = Qe(!1), t = $n();
  return t && Et(() => {
    e.value = !0;
  }, t), e;
}
function LA(e) {
  const t = kA();
  return D(() => (t.value, !!e()));
}
var BA = Symbol("vueuse-ssr-width");
function J1() {
  const e = qd() ? xA(BA, null) : null;
  return typeof e == "number" ? e : void 0;
}
function Vr(e, t = {}) {
  const { window: n = Gg, ssrWidth: o = J1() } = t, s = LA(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), i = Qe(typeof o == "number"), r = Qe(), a = Qe(!1), l = (d) => {
    a.value = d.matches;
  };
  return jd(() => {
    if (i.value) {
      i.value = !s.value;
      const d = xe(e).split(",");
      a.value = d.some((c) => {
        const u = c.includes("not all"), h = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), g = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let p = !!(h || g);
        return h && p && (p = o >= oa(h[1])), g && p && (p = o <= oa(g[1])), u ? !p : p;
      });
      return;
    }
    s.value && (r.value = n.matchMedia(xe(e)), a.value = r.value.matches);
  }), TA(r, "change", l, { passive: !0 }), D(() => a.value);
}
function OA(e, t = {}) {
  function n(g, p) {
    let f = xe(e[xe(g)]);
    return p != null && (f = FA(f, p)), typeof f == "number" && (f = `${f}px`), f;
  }
  const { window: o = Gg, strategy: s = "min-width", ssrWidth: i = J1() } = t, r = typeof i == "number", a = r ? Qe(!1) : { value: !0 };
  r && IA(() => a.value = !!o);
  function l(g, p) {
    return !a.value && r ? g === "min" ? i >= oa(p) : i <= oa(p) : o ? o.matchMedia(`(${g}-width: ${p})`).matches : !1;
  }
  const d = (g) => Vr(() => `(min-width: ${n(g)})`, t), c = (g) => Vr(() => `(max-width: ${n(g)})`, t), u = Object.keys(e).reduce((g, p) => (Object.defineProperty(g, p, {
    get: () => s === "min-width" ? d(p) : c(p),
    enumerable: !0,
    configurable: !0
  }), g), {});
  function h() {
    const g = Object.keys(e).map((p) => [p, u[p], oa(n(p))]).sort((p, f) => p[2] - f[2]);
    return D(() => g.filter(([, p]) => p.value).map(([p]) => p));
  }
  return Object.assign(u, {
    greaterOrEqual: d,
    smallerOrEqual: c,
    greater(g) {
      return Vr(() => `(min-width: ${n(g, 0.1)})`, t);
    },
    smaller(g) {
      return Vr(() => `(max-width: ${n(g, -0.1)})`, t);
    },
    between(g, p) {
      return Vr(() => `(min-width: ${n(g)}) and (max-width: ${n(p, -0.1)})`, t);
    },
    isGreater(g) {
      return l("min", n(g, 0.1));
    },
    isGreaterOrEqual(g) {
      return l("min", n(g));
    },
    isSmaller(g) {
      return l("max", n(g, -0.1));
    },
    isSmallerOrEqual(g) {
      return l("max", n(g));
    },
    isInBetween(g, p) {
      return l("min", n(g)) && l("max", n(p, -0.1));
    },
    current: h,
    active() {
      const g = h();
      return D(() => g.value.length === 0 ? "" : g.value.at(s === "min-width" ? -1 : 0));
    }
  });
}
var GA = {
  /** Small mobile devices: 440px and up */
  sm: "440px",
  /** Large mobile devices: 600px and up */
  md: "600px",
  /** Small tablets: 760px and up */
  lg: "760px",
  /** Large tablets/small desktops: 1024px and up */
  xl: "1024px",
  /** Large desktops: 1400px and up */
  "2xl": "1400px"
}, HA = () => {
  const e = OA(GA), t = D(
    () => e.greaterOrEqual("2xl").value ? "DESKTOP" : e.between("lg", "2xl").value ? "TABLET" : "MOBILE"
    /* MOBILE */
  ), n = D(
    () => t.value === "DESKTOP"
    /* DESKTOP */
  ), o = D(() => e.greaterOrEqual("xl").value), s = D(
    () => t.value === "TABLET"
    /* TABLET */
  ), i = D(
    () => t.value === "MOBILE"
    /* MOBILE */
  );
  return {
    /** VueUse breakpoints instance for fine-grained breakpoint control */
    breakpoints: e,
    /** Reactive device category (DESKTOP, TABLET, or MOBILE) */
    currentDevice: t,
    /** Reactive boolean for desktop detection */
    isDesktop: n,
    /** Reactive boolean for XL+ screen detection */
    isAtLeastXL: o,
    /** Reactive boolean for tablet detection */
    isTablet: s,
    /** Reactive boolean for mobile detection */
    isMobile: i
  };
};
Pg.withMessage(() => kg("common.validation.empty"), PE);
Pg.withMessage(() => kg("common.label.fieldNeedsValid"), kE);
Pg.withMessage(() => kg("common.label.fieldNeedsValid2"), ME);
var ii = Tg("core/config"), nu = wA(), ou = {
  NODE_ENV: "development",
  VITE_APP_URL: "http://localhost:8080"
}, X1 = {
  nodeEnv: zn("NODE_ENV", ou),
  appUrl: zn("VITE_APP_URL", ou),
  scaylaApiUrl: zn("VITE_APP_SCAYLA_API_URL", ou, !0)
};
ii.debug("baseConfig", X1)();
var em = {
  VITE_APP_OIDC_CLIENT_ID: void 0,
  VITE_APP_OIDC_AUTHORITY: void 0
}, md = {
  VITE_APP_OIDC_CLIENT_ID: zn("VITE_APP_OIDC_CLIENT_ID", em, !0),
  VITE_APP_OIDC_AUTHORITY: zn("VITE_APP_OIDC_AUTHORITY", em, !0)
};
eo(md.VITE_APP_OIDC_CLIENT_ID, "rawAuthConfig.VITE_APP_OIDC_CLIENT_ID");
eo(md.VITE_APP_OIDC_AUTHORITY, "rawAuthConfig.VITE_APP_OIDC_AUTHORITY");
var gh = {
  oidcClientId: md.VITE_APP_OIDC_CLIENT_ID,
  oidcAuthority: md.VITE_APP_OIDC_AUTHORITY
};
ii.debug("authConfig", gh)();
var _r = {
  VITE_APP_SENTRY_ENABLED: "false"
}, Jn = {
  VITE_APP_SENTRY_ENABLED: nC("VITE_APP_SENTRY_ENABLED", _r, !0),
  VITE_APP_SENTRY_DSN: zn("VITE_APP_SENTRY_DSN", _r),
  VITE_APP_SENTRY_ENVIRONMENT: zn("VITE_APP_SENTRY_ENVIRONMENT", _r),
  VITE_APP_SENTRY_PROJECT_NAME: zn("VITE_APP_SENTRY_PROJECT_NAME", _r),
  VITE_APP_SENTRY_VERSION: zn("VITE_APP_SENTRY_VERSION", _r)
};
eo(Jn.VITE_APP_SENTRY_ENABLED, "rawSentryConfig.VITE_APP_SENTRY_ENABLED");
Jn.VITE_APP_SENTRY_ENABLED === !0 && (eo(Jn.VITE_APP_SENTRY_DSN, "VITE_APP_SENTRY_DSN"), eo(Jn.VITE_APP_SENTRY_ENVIRONMENT, "VITE_APP_SENTRY_ENVIRONMENT"), eo(Jn.VITE_APP_SENTRY_PROJECT_NAME, "VITE_APP_SENTRY_PROJECT_NAME"), eo(Jn.VITE_APP_SENTRY_VERSION, "VITE_APP_SENTRY_VERSION"));
var VA = {
  enabled: Jn.VITE_APP_SENTRY_ENABLED,
  dsn: Jn.VITE_APP_SENTRY_DSN,
  projectName: Jn.VITE_APP_SENTRY_PROJECT_NAME,
  env: Jn.VITE_APP_SENTRY_ENVIRONMENT,
  version: Jn.VITE_APP_SENTRY_VERSION
};
ii.debug("sentryConfig", VA)();
var _A = {
  VITE_APP_SHOW_EMAIL_FEATURE: "false"
}, eC = {
  VITE_APP_SHOW_EMAIL_FEATURE: nC("VITE_APP_SHOW_EMAIL_FEATURE", _A, !1)
};
eC.VITE_APP_SHOW_EMAIL_FEATURE;
ii.debug("emailFeatureConfig", eC)();
var NA = {
  VITE_APP_AG_GRID_LICENSE: ""
}, tC = {
  VITE_APP_AG_GRID_LICENSE: zn("VITE_APP_AG_GRID_LICENSE", NA)
};
eo(tC.VITE_APP_AG_GRID_LICENSE, "rawAgGridlicenseKey.VITE_APP_AG_GRID_LICENSE");
var $A = {
  licenseKey: tC.VITE_APP_AG_GRID_LICENSE
}, zA = {
  VITE_APP_TINY_MCE_API_KEY: ""
}, WA = {
  VITE_APP_TINY_MCE_API_KEY: zn("VITE_APP_TINY_MCE_API_KEY", zA)
}, Hg = {
  apiKey: WA.VITE_APP_TINY_MCE_API_KEY
};
function zn(e, t, n = !1) {
  if (typeof e == "number") return;
  let o;
  if (t[e] !== void 0 && (ii.debug("Checking for key in defaultConfig: ", e, t[e]), o = String(t[e])), Jc[e] !== void 0 && (ii.debug("Checking for key in import.meta.env: ", e, Jc[e]), o = String(Jc[e])), nu[e] !== void 0 && (ii.debug("Checking for key in dynamicRuntimeConfig: ", e, nu[e]), o = String(nu[e])), n && (eo(o, e), !o))
    throw new Error(`Missing required value for config variable "${e}"`);
  return o;
}
function nC(e, t, n = !1) {
  if (typeof e == "number") return;
  const o = zn(e, t, n);
  let s;
  if (typeof o == "string" && (s = o.toLowerCase() === "true"), n && (eo(s, e), !s && typeof s != "boolean"))
    throw new Error(`Missing required value for config variable "${e}"`);
  if (typeof s != "boolean" && n)
    throw new Error(
      `Value for config variable "${e}" is required and expected to be a boolean or a string, is "${typeof s}"`
    );
  return s;
}
var Vg = X1.appUrl ?? "";
Tg("core/oidc");
Dg();
new URL("/oidc-callback", Vg).toString();
new URL("/silent-renew.html", Vg).toString();
new URL("/sign-out", Vg).toString();
gh.oidcAuthority, gh.oidcClientId, typeof window < "u" && new Jf({ store: window.localStorage }), typeof window < "u" && new Jf({ prefix: "oidc.state.", store: window.localStorage });
var Fs = class {
  constructor() {
    this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
  }
  setFrameworkOverrides(e) {
    this.frameworkOverrides = e;
  }
  getListeners(e, t, n) {
    const o = t ? this.allAsyncListeners : this.allSyncListeners;
    let s = o.get(e);
    return !s && n && (s = /* @__PURE__ */ new Set(), o.set(e, s)), s;
  }
  noRegisteredListenersExist() {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  }
  addEventListener(e, t, n = !1) {
    this.getListeners(e, n, !0).add(t);
  }
  removeEventListener(e, t, n = !1) {
    const o = this.getListeners(e, n, !1);
    o && (o.delete(t), o.size === 0 && (n ? this.allAsyncListeners : this.allSyncListeners).delete(e));
  }
  addGlobalListener(e, t = !1) {
    this.getGlobalListeners(t).add(e);
  }
  removeGlobalListener(e, t = !1) {
    this.getGlobalListeners(t).delete(e);
  }
  dispatchEvent(e) {
    this.dispatchToListeners(e, !0), this.dispatchToListeners(e, !1), this.firedEvents[e.type] = !0;
  }
  dispatchEventOnce(e) {
    this.firedEvents[e.type] || this.dispatchEvent(e);
  }
  dispatchToListeners(e, t) {
    const n = e.type;
    if (t && "event" in e) {
      const a = e.event;
      a instanceof Event && (e.eventPath = a.composedPath());
    }
    const { frameworkOverrides: o } = this, s = (a) => {
      const l = o ? () => o.wrapIncoming(a) : a;
      t ? this.dispatchAsync(l) : l();
    }, i = this.getListeners(n, t, !1);
    if (((i == null ? void 0 : i.size) ?? 0) > 0) {
      const a = new Set(i);
      for (const l of a)
        i != null && i.has(l) && s(() => l(e));
    }
    const r = this.getGlobalListeners(t);
    if (r.size > 0) {
      const a = new Set(r);
      for (const l of a)
        s(() => l(n, e));
    }
  }
  getGlobalListeners(e) {
    return e ? this.globalAsyncListeners : this.globalSyncListeners;
  }
  // this gets called inside the grid's thread, for each event that it
  // wants to set async. the grid then batches the events into one setTimeout()
  // because setTimeout() is an expensive operation. ideally we would have
  // each event in it's own setTimeout(), but we batch for performance.
  dispatchAsync(e) {
    if (this.asyncFunctionsQueue.push(e), !this.scheduled) {
      const t = () => {
        window.setTimeout(this.flushAsyncQueue.bind(this), 0);
      };
      this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(t) : t(), this.scheduled = !0;
    }
  }
  // this happens in the next VM turn only, and empties the queue of events
  flushAsyncQueue() {
    this.scheduled = !1;
    const e = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [], e.forEach((t) => t());
  }
};
function Gt(e) {
  return e == null || e === "" ? null : e;
}
function ue(e) {
  return e != null && e !== "";
}
function st(e) {
  return !ue(e);
}
function Pn(e) {
  return e != null && typeof e.toString == "function" ? e.toString() : null;
}
function pr(e, t) {
  const n = e ? JSON.stringify(e) : null, o = t ? JSON.stringify(t) : null;
  return n === o;
}
function vd(e, t, n = !1) {
  const o = e == null, s = t == null;
  if (e && e.toNumber && (e = e.toNumber()), t && t.toNumber && (t = t.toNumber()), o && s)
    return 0;
  if (o)
    return -1;
  if (s)
    return 1;
  function i(r, a) {
    return r > a ? 1 : r < a ? -1 : 0;
  }
  if (typeof e != "string" || !n)
    return i(e, t);
  try {
    return e.localeCompare(t);
  } catch {
    return i(e, t);
  }
}
var UA = /[&<>"']/g, KA = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function Ii(e) {
  return (e == null ? void 0 : e.toString().toString()) ?? null;
}
function sa(e) {
  var t;
  return ((t = Ii(e)) == null ? void 0 : t.replace(UA, (n) => KA[n])) ?? null;
}
function mi(e) {
  return e.eRootDiv.getRootNode();
}
function je(e) {
  return mi(e).activeElement;
}
function Bt(e) {
  const { gos: t, eRootDiv: n } = e;
  let o = null;
  const s = t.get("getDocument");
  return s && ue(s) ? o = s() : n && (o = n.ownerDocument), o && ue(o) ? o : document;
}
function fr(e) {
  const t = je(e);
  return t === null || t === Bt(e).body;
}
function oC(e) {
  return Bt(e).defaultView || window;
}
function sc(e) {
  let t = null, n = null;
  try {
    t = Bt(e).fullscreenElement;
  } catch {
  } finally {
    t || (t = mi(e));
    const o = t.querySelector("body");
    o ? n = o : t instanceof ShadowRoot ? n = t : t instanceof Document ? n = t == null ? void 0 : t.documentElement : n = t;
  }
  return n;
}
function ZA(e) {
  const t = sc(e);
  return (t == null ? void 0 : t.clientWidth) ?? (window.innerWidth || -1);
}
function qA(e) {
  const t = sc(e);
  return (t == null ? void 0 : t.clientHeight) ?? (window.innerHeight || -1);
}
function mn(e, t, n) {
  n == null || typeof n == "string" && n == "" ? _g(e, t) : On(e, t, n);
}
function On(e, t, n) {
  e.setAttribute(sC(t), n.toString());
}
function _g(e, t) {
  e.removeAttribute(sC(t));
}
function sC(e) {
  return `aria-${e}`;
}
function hn(e, t) {
  t ? e.setAttribute("role", t) : e.removeAttribute("role");
}
function jA(e) {
  let t;
  return e === "asc" ? t = "ascending" : e === "desc" ? t = "descending" : e === "mixed" ? t = "other" : t = "none", t;
}
function YA(e) {
  return parseInt(e.getAttribute("aria-posinset"), 10);
}
function QA(e) {
  return e.getAttribute("aria-label");
}
function yt(e, t) {
  mn(e, "label", t);
}
function Ms(e, t) {
  mn(e, "labelledby", t);
}
function ic(e, t) {
  mn(e, "describedby", t);
}
function iC(e, t) {
  mn(e, "live", t);
}
function JA(e, t) {
  mn(e, "atomic", t);
}
function XA(e, t) {
  mn(e, "relevant", t);
}
function e3(e, t) {
  mn(e, "invalid", t);
}
function rc(e, t) {
  mn(e, "level", t);
}
function Cd(e, t) {
  mn(e, "disabled", t);
}
function Ng(e, t) {
  mn(e, "hidden", t);
}
function rC(e, t) {
  mn(e, "activedescendant", t);
}
function Zn(e, t) {
  On(e, "expanded", t);
}
function aC(e) {
  _g(e, "expanded");
}
function ac(e, t) {
  On(e, "setsize", t);
}
function lc(e, t) {
  On(e, "posinset", t);
}
function t3(e, t) {
  On(e, "multiselectable", t);
}
function n3(e, t) {
  On(e, "rowcount", t);
}
function Ma(e, t) {
  On(e, "rowindex", t);
}
function o3(e, t) {
  On(e, "rowspan", t);
}
function s3(e, t) {
  On(e, "colcount", t);
}
function $g(e, t) {
  On(e, "colindex", t);
}
function lC(e, t) {
  On(e, "colspan", t);
}
function i3(e, t) {
  On(e, "sort", t);
}
function r3(e) {
  _g(e, "sort");
}
function zg(e, t) {
  mn(e, "selected", t);
}
function dC(e, t) {
  On(e, "checked", t === void 0 ? "mixed" : t);
}
function a3(e, t) {
  mn(e, "controls", t);
}
function Wg(e, t) {
  a3(e, t.id), Ms(t, e.id);
}
function tm(e, t) {
  mn(e, "owns", t);
}
function l3(e, t) {
  mn(e, "haspopup", t === !1 ? null : t);
}
function dc(e, t) {
  return t === void 0 ? e("ariaIndeterminate", "indeterminate") : t === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked");
}
function nm(e, t, n) {
  const o = e.parentElement;
  let s = o && o.firstChild;
  for (; s; )
    t && s.classList.toggle(t, s === e), s = s.nextSibling;
}
var d3 = "[tabindex], input, select, button, textarea, [href]", cC = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function Ug(e) {
  const t = Element.prototype.matches || Element.prototype.msMatchesSelector, o = t.call(e, "input, select, button, textarea"), s = t.call(e, cC), i = vn(e);
  return o && !s && i;
}
function He(e, t, n = {}) {
  const { skipAriaHidden: o } = n;
  e.classList.toggle("ag-hidden", !t), o || Ng(e, !t);
}
function uC(e, t, n = {}) {
  const { skipAriaHidden: o } = n;
  e.classList.toggle("ag-invisible", !t), o || Ng(e, !t);
}
function vi(e, t) {
  const n = "disabled", o = t ? (i) => i.setAttribute(n, "") : (i) => i.removeAttribute(n);
  o(e);
  const s = e.querySelectorAll("input") ?? [];
  for (const i of s)
    o(i);
}
function ri(e, t, n) {
  let o = 0;
  for (; e; ) {
    if (e.classList.contains(t))
      return !0;
    if (e = e.parentElement, typeof n == "number") {
      if (++o > n)
        break;
    } else if (e === n)
      break;
  }
  return !1;
}
function Pi(e) {
  const {
    height: t,
    width: n,
    borderTopWidth: o,
    borderRightWidth: s,
    borderBottomWidth: i,
    borderLeftWidth: r,
    paddingTop: a,
    paddingRight: l,
    paddingBottom: d,
    paddingLeft: c,
    marginTop: u,
    marginRight: h,
    marginBottom: g,
    marginLeft: p,
    boxSizing: f
  } = window.getComputedStyle(e);
  return {
    height: parseFloat(t || "0"),
    width: parseFloat(n || "0"),
    borderTopWidth: parseFloat(o || "0"),
    borderRightWidth: parseFloat(s || "0"),
    borderBottomWidth: parseFloat(i || "0"),
    borderLeftWidth: parseFloat(r || "0"),
    paddingTop: parseFloat(a || "0"),
    paddingRight: parseFloat(l || "0"),
    paddingBottom: parseFloat(d || "0"),
    paddingLeft: parseFloat(c || "0"),
    marginTop: parseFloat(u || "0"),
    marginRight: parseFloat(h || "0"),
    marginBottom: parseFloat(g || "0"),
    marginLeft: parseFloat(p || "0"),
    boxSizing: f
  };
}
function cc(e) {
  const t = Pi(e);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function mr(e) {
  const t = Pi(e);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function Kg(e) {
  const { height: t, marginBottom: n, marginTop: o } = Pi(e);
  return Math.floor(t + n + o);
}
function Ia(e) {
  const { width: t, marginLeft: n, marginRight: o } = Pi(e);
  return Math.floor(t + n + o);
}
function hC(e) {
  const t = e.getBoundingClientRect(), { borderTopWidth: n, borderLeftWidth: o, borderRightWidth: s, borderBottomWidth: i } = Pi(e);
  return {
    top: t.top + (n || 0),
    left: t.left + (o || 0),
    right: t.right + (s || 0),
    bottom: t.bottom + (i || 0)
  };
}
function wd(e, t) {
  let n = e.scrollLeft;
  return t && (n = Math.abs(n)), n;
}
function yd(e, t, n) {
  n && (t *= -1), e.scrollLeft = t;
}
function ht(e) {
  for (; e && e.firstChild; )
    e.removeChild(e.firstChild);
}
function nn(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function gC(e) {
  return !!e.offsetParent;
}
function vn(e) {
  const t = e;
  return t.checkVisibility ? t.checkVisibility({ checkVisibilityCSS: !0 }) : !(!gC(e) || window.getComputedStyle(e).visibility !== "visible");
}
function Zg(e) {
  const t = document.createElement("div");
  return t.innerHTML = (e || "").trim(), t.firstChild;
}
function pC(e, t, n) {
  n && n.nextSibling === t || (e.firstChild ? n ? n.nextSibling ? e.insertBefore(t, n.nextSibling) : e.appendChild(t) : e.firstChild && e.firstChild !== t && e.insertAdjacentElement("afterbegin", t) : e.appendChild(t));
}
function fC(e, t) {
  for (let n = 0; n < t.length; n++) {
    const o = t[n], s = e.children[n];
    s !== o && e.insertBefore(o, s);
  }
}
function c3(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLocaleLowerCase()}`);
}
function Ya(e, t) {
  if (t)
    for (const n of Object.keys(t)) {
      const o = t[n];
      if (!n || !n.length || o == null)
        continue;
      const s = c3(n), i = o.toString(), r = i.replace(/\s*!important/g, ""), a = r.length != i.length ? "important" : void 0;
      e.style.setProperty(s, r, a);
    }
}
function ai(e) {
  return () => {
    const t = e();
    return t ? qg(t) || mC(t) : !0;
  };
}
function qg(e) {
  return e.clientWidth < e.scrollWidth;
}
function mC(e) {
  return e.clientHeight < e.scrollHeight;
}
function bd(e, t) {
  t === "flex" ? (e.style.removeProperty("width"), e.style.removeProperty("minWidth"), e.style.removeProperty("maxWidth"), e.style.flex = "1 1 auto") : Ro(e, t);
}
function Ro(e, t) {
  t = jg(t), e.style.width = t, e.style.maxWidth = t, e.style.minWidth = t;
}
function ia(e, t) {
  t = jg(t), e.style.height = t, e.style.maxHeight = t, e.style.minHeight = t;
}
function jg(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function uc(e) {
  return e instanceof Node || e instanceof HTMLElement;
}
function Mn(e, t, n) {
  n == null || n === "" ? e.removeAttribute(t) : e.setAttribute(t, n.toString());
}
function Bo(e, t, n) {
  const s = oC(e).ResizeObserver, i = s ? new s(n) : null;
  return i == null || i.observe(t), () => i == null ? void 0 : i.disconnect();
}
function kn(e, t) {
  const n = oC(e);
  n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.webkitRequestAnimationFrame ? n.webkitRequestAnimationFrame(t) : n.setTimeout(t, 0);
}
var vC = "data-ref", su;
function om() {
  return su ?? (su = document.createTextNode(" ")), su.cloneNode();
}
function Qa(e) {
  const { attrs: t, children: n, cls: o, ref: s, role: i, tag: r } = e, a = document.createElement(r);
  if (o && (a.className = o), s && a.setAttribute(vC, s), i && a.setAttribute("role", i), t)
    for (const l of Object.keys(t))
      a.setAttribute(l, t[l]);
  if (n)
    if (typeof n == "string")
      a.textContent = n;
    else {
      let l = !0;
      for (const d of n)
        d && (typeof d == "string" ? (a.appendChild(document.createTextNode(d)), l = !1) : typeof d == "function" ? a.appendChild(d()) : (l && (a.appendChild(om()), l = !1), a.append(Qa(d)), a.appendChild(om())));
    }
  return a;
}
var u3 = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], h3 = ["wheel"], iu = {}, CC = /* @__PURE__ */ (() => {
  const e = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  };
  return (n) => {
    if (typeof iu[n] == "boolean")
      return iu[n];
    const o = document.createElement(e[n] || "div");
    return n = "on" + n, iu[n] = n in o;
  };
})();
function ph(e, t) {
  return !t || !e ? !1 : p3(t).indexOf(e) >= 0;
}
function g3(e) {
  const t = [];
  let n = e.target;
  for (; n; )
    t.push(n), n = n.parentElement;
  return t;
}
function p3(e) {
  const t = e;
  return t.path ? t.path : t.composedPath ? t.composedPath() : g3(t);
}
function f3(e, t, n) {
  const o = m3(t);
  let s;
  o != null && (s = { passive: o }), e.addEventListener(t, n, s);
}
var m3 = (e) => {
  const t = u3.includes(e), n = h3.includes(e);
  if (t)
    return !0;
  if (n)
    return !1;
};
function wC(e, t, n) {
  if (n === 0)
    return !1;
  const o = Math.abs(e.clientX - t.clientX), s = Math.abs(e.clientY - t.clientY);
  return Math.max(o, s) <= n;
}
function Pa(e, t) {
  return e.gos.isElementInThisInstance(t.target);
}
function fh(e, t, n) {
  const s = e.getBoundingClientRect().height, i = ZA(n) - 2, r = qA(n) - 2;
  if (!e.offsetParent)
    return;
  const l = hC(e.offsetParent), { clientY: d, clientX: c } = t;
  let u = d - l.top - s / 2, h = c - l.left - 10;
  const g = Bt(n), p = g.defaultView || window, f = p.pageYOffset || g.documentElement.scrollTop, m = p.pageXOffset || g.documentElement.scrollLeft;
  i > 0 && h + e.clientWidth > i + m && (h = i + m - e.clientWidth), h < 0 && (h = 0), r > 0 && u + e.clientHeight > r + f && (u = r + f - e.clientHeight), u < 0 && (u = 0), e.style.left = `${h}px`, e.style.top = `${u}px`;
}
function v3(e, t) {
  return t;
}
function yC(e) {
  return (e == null ? void 0 : e.getLocaleTextFunc()) ?? v3;
}
function bC(e, t, n, o) {
  const s = t[n];
  return e.getLocaleTextFunc()(
    n,
    typeof s == "function" ? s(o) : s,
    o
  );
}
function C3(e) {
  return (t, n, o) => e({
    key: t,
    defaultValue: n,
    variableValues: o
  });
}
function w3(e) {
  return (t, n, o) => {
    let s = e && e[t];
    if (s && o && o.length) {
      let i = 0;
      for (; !(i >= o.length || s.indexOf("${variable}") === -1); )
        s = s.replace("${variable}", o[i++]);
    }
    return s ?? n;
  };
}
var Oo = class {
  constructor() {
    this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.propertyListenerId = 0, this.lastChangeSetIdLookup = {}, this.isAlive = () => !this.destroyed;
  }
  preWireBeans(e) {
    this.beans = e, this.stubContext = e.context, this.eventSvc = e.eventSvc, this.gos = e.gos;
  }
  // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
  // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
  // points to a bean or component that was not properly disposed of.
  // constructor() {
  //     setTimeout(()=> {
  //         if (this.isAlive()) {
  //             let prototype: any = Object.getPrototypeOf(this);
  //             const constructor: any = prototype.constructor;
  //             const constructorString = constructor.toString();
  //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
  //             console.log('is alive ' + beanName);
  //         }
  //     }, 5000);
  // }
  destroy() {
    const { destroyFunctions: e } = this;
    for (let t = 0; t < e.length; t++)
      e[t]();
    e.length = 0, this.destroyed = !0, this.dispatchLocalEvent({ type: "destroyed" });
  }
  /** Add a local event listener against this BeanStub */
  addEventListener(e, t, n) {
    this.localEventService || (this.localEventService = new Fs()), this.localEventService.addEventListener(e, t, n);
  }
  /** Remove a local event listener from this BeanStub */
  removeEventListener(e, t, n) {
    var o;
    (o = this.localEventService) == null || o.removeEventListener(e, t, n);
  }
  dispatchLocalEvent(e) {
    var t;
    (t = this.localEventService) == null || t.dispatchEvent(e);
  }
  addManagedElementListeners(e, t) {
    return this._setupListeners(e, t);
  }
  addManagedEventListeners(e) {
    return this._setupListeners(this.eventSvc, e);
  }
  addManagedListeners(e, t) {
    return this._setupListeners(e, t);
  }
  _setupListeners(e, t) {
    const n = [];
    for (const o of Object.keys(t)) {
      const s = t[o];
      s && n.push(this._setupListener(e, o, s));
    }
    return n;
  }
  _setupListener(e, t, n) {
    if (this.destroyed)
      return () => null;
    let o;
    if (y3(e))
      e.__addEventListener(t, n), o = () => (e.__removeEventListener(t, n), null);
    else {
      const s = b3(e);
      e instanceof HTMLElement ? f3(e, t, n) : s ? e.addListener(t, n) : e.addEventListener(t, n), o = s ? () => (e.removeListener(t, n), null) : () => (e.removeEventListener(t, n), null);
    }
    return this.destroyFunctions.push(o), () => (o(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== o), null);
  }
  /**
   * Setup a managed property listener for the given property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the properties service is destroyed.
   */
  setupPropertyListener(e, t) {
    const { gos: n } = this;
    n.addPropertyEventListener(e, t);
    const o = () => (n.removePropertyEventListener(e, t), null);
    return this.destroyFunctions.push(o), () => (o(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== o), null);
  }
  /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */
  addManagedPropertyListener(e, t) {
    return this.destroyed ? () => null : this.setupPropertyListener(e, t);
  }
  /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */
  addManagedPropertyListeners(e, t) {
    if (this.destroyed)
      return;
    const n = e.join("-") + this.propertyListenerId++, o = (s) => {
      if (s.changeSet) {
        if (s.changeSet && s.changeSet.id === this.lastChangeSetIdLookup[n])
          return;
        this.lastChangeSetIdLookup[n] = s.changeSet.id;
      }
      const i = {
        type: "propertyChanged",
        changeSet: s.changeSet,
        source: s.source
      };
      t(i);
    };
    e.forEach((s) => this.setupPropertyListener(s, o));
  }
  getLocaleTextFunc() {
    return yC(this.beans.localeSvc);
  }
  addDestroyFunc(e) {
    this.isAlive() ? this.destroyFunctions.push(e) : e();
  }
  /** doesn't throw an error if `bean` is undefined */
  createOptionalManagedBean(e, t) {
    return e ? this.createManagedBean(e, t) : void 0;
  }
  createManagedBean(e, t) {
    const n = this.createBean(e, t);
    return this.addDestroyFunc(this.destroyBean.bind(this, e, t)), n;
  }
  createBean(e, t, n) {
    return (t || this.stubContext).createBean(e, n);
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e, t) {
    return (t || this.stubContext).destroyBean(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e, t) {
    return (t || this.stubContext).destroyBeans(e);
  }
};
function y3(e) {
  return e.__addEventListener !== void 0;
}
function b3(e) {
  return e.eventServiceType === "global";
}
var U = class extends Oo {
}, sm = {};
function hc(e, t) {
  sm[t] || (e(), sm[t] = !0);
}
var S3 = {
  pending: !1,
  funcs: []
}, x3 = {
  pending: !1,
  funcs: []
};
function mh(e, t = "setTimeout", n) {
  const o = t === "raf" ? x3 : S3;
  if (o.funcs.push(e), o.pending)
    return;
  o.pending = !0;
  const s = () => {
    const i = o.funcs.slice();
    o.funcs.length = 0, o.pending = !1, i.forEach((r) => r());
  };
  t === "raf" ? kn(n, s) : window.setTimeout(s, 0);
}
function Lt(e, t, n) {
  let o;
  return function(...s) {
    const i = this;
    window.clearTimeout(o), o = window.setTimeout(function() {
      e.isAlive() && t.apply(i, s);
    }, n);
  };
}
function im(e, t) {
  let n = 0;
  return function(...o) {
    const s = this, i = Date.now();
    i - n < t || (n = i, e.apply(s, o));
  };
}
function SC(e, t, n, o = 100) {
  const s = Date.now();
  let i = null, r = !1;
  const a = () => {
    i != null && (window.clearInterval(i), i = null);
  };
  e.addDestroyFunc(a);
  const l = () => {
    const d = Date.now() - s > o;
    (t() || d) && (n(), r = !0, a());
  };
  l(), r || (i = window.setInterval(l, 10));
}
var xC = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
function R3(e, t) {
  if (e != null) {
    if (Array.isArray(e)) {
      for (let n = 0; n < e.length; n++)
        t(n.toString(), e[n]);
      return;
    }
    for (const n of Object.keys(e).filter((o) => !xC.has(o)))
      t(n, e[n]);
  }
}
function on(e, t, n = !0, o = !1) {
  ue(t) && R3(t, (s, i) => {
    let r = e[s];
    r !== i && (o && r == null && i != null && typeof i == "object" && i.constructor === Object && (r = {}, e[s] = r), rm(i) && rm(r) && !Array.isArray(r) ? on(r, i, n, o) : (n || i !== void 0) && (e[s] = i));
  });
}
function rm(e) {
  return typeof e == "object" && e !== null;
}
var Yg = class js {
  /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */
  static applyGlobalGridOptions(t) {
    if (!js.gridOptions)
      return { ...t };
    let n = {};
    return on(n, js.gridOptions, !0, !0), js.mergeStrategy === "deep" ? on(n, t, !0, !0) : n = { ...n, ...t }, js.gridOptions.context && (n.context = js.gridOptions.context), t.context && (js.mergeStrategy === "deep" && n.context && on(t.context, n.context, !0, !0), n.context = t.context), n;
  }
};
Yg.gridOptions = void 0;
Yg.mergeStrategy = "shallow";
var E3 = Yg, A3 = {
  suppressContextMenu: !1,
  preventDefaultOnContextMenu: !1,
  allowContextMenuWithControlKey: !1,
  suppressMenuHide: !0,
  enableBrowserTooltips: !1,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: !1,
  tooltipShowMode: "standard",
  tooltipInteraction: !1,
  copyHeadersToClipboard: !1,
  copyGroupHeadersToClipboard: !1,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: !1,
  suppressCopySingleCellRanges: !1,
  suppressLastEmptyLineOnPaste: !1,
  suppressClipboardPaste: !1,
  suppressClipboardApi: !1,
  suppressCutToClipboard: !1,
  maintainColumnOrder: !1,
  enableStrictPivotColumnOrder: !1,
  suppressFieldDotNotation: !1,
  allowDragFromColumnsToolPanel: !1,
  suppressMovableColumns: !1,
  suppressColumnMoveAnimation: !1,
  suppressMoveWhenColumnDragging: !1,
  suppressDragLeaveHidesColumns: !1,
  suppressRowGroupHidesColumns: !1,
  suppressAutoSize: !1,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: !1,
  singleClickEdit: !1,
  suppressClickEdit: !1,
  readOnlyEdit: !1,
  stopEditingWhenCellsLoseFocus: !1,
  enterNavigatesVertically: !1,
  enterNavigatesVerticallyAfterEdit: !1,
  enableCellEditingOnBackspace: !1,
  undoRedoCellEditing: !1,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: !1,
  suppressExcelExport: !1,
  cacheQuickFilter: !1,
  includeHiddenColumnsInQuickFilter: !1,
  excludeChildrenWhenTreeDataFiltering: !1,
  enableAdvancedFilter: !1,
  includeHiddenColumnsInAdvancedFilter: !1,
  enableCharts: !1,
  masterDetail: !1,
  keepDetailRows: !1,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: !1,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: !1,
  valueCacheNeverExpires: !1,
  enableCellExpressions: !1,
  suppressTouch: !1,
  suppressFocusAfterRefresh: !1,
  suppressBrowserResizeObserver: !1,
  suppressPropertyNamesCheck: !1,
  suppressChangeDetection: !1,
  debug: !1,
  suppressLoadingOverlay: !1,
  suppressNoRowsOverlay: !1,
  pagination: !1,
  paginationPageSize: 100,
  paginationPageSizeSelector: !0,
  paginationAutoPageSize: !1,
  paginateChildRows: !1,
  suppressPaginationPanel: !1,
  pivotMode: !1,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: !1,
  suppressExpandablePivotGroups: !1,
  functionsReadOnly: !1,
  suppressAggFuncInHeader: !1,
  alwaysAggregateAtRootLevel: !1,
  aggregateOnlyChangedColumns: !1,
  suppressAggFilteredOnly: !1,
  removePivotHeaderRowWhenSingleValueColumn: !1,
  animateRows: !0,
  cellFlashDuration: 500,
  cellFadeDuration: 1e3,
  allowShowChangeAfterFilter: !1,
  domLayout: "normal",
  ensureDomOrder: !1,
  enableRtl: !1,
  suppressColumnVirtualisation: !1,
  suppressMaxRenderedRowRestriction: !1,
  suppressRowVirtualisation: !1,
  rowDragManaged: !1,
  rowDragInsertDelay: 500,
  suppressRowDrag: !1,
  suppressMoveWhenRowDragging: !1,
  rowDragEntireRow: !1,
  rowDragMultiRow: !1,
  embedFullWidthRows: !1,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: !1,
  groupSelectsChildren: !1,
  groupSuppressBlankHeader: !1,
  groupSelectsFiltered: !1,
  showOpenedGroup: !1,
  groupRemoveSingleChildren: !1,
  groupRemoveLowestSingleChildren: !1,
  groupHideOpenParents: !1,
  groupAllowUnbalanced: !1,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: !1,
  treeData: !1,
  rowGroupPanelSuppressSort: !1,
  suppressGroupRowsSticky: !1,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: !1,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: !1,
  serverSideSortAllLevels: !1,
  serverSideOnlyRefreshFilteredGroups: !1,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: !1,
  alwaysShowVerticalScroll: !1,
  debounceVerticalScrollbar: !1,
  suppressHorizontalScroll: !1,
  suppressScrollOnNewData: !1,
  suppressScrollWhenPopupsAreOpen: !1,
  suppressAnimationFrame: !1,
  suppressMiddleClickScrolls: !1,
  suppressPreventDefaultOnMouseWheel: !1,
  rowMultiSelectWithClick: !1,
  suppressRowDeselection: !1,
  suppressRowClickSelection: !1,
  suppressCellFocus: !1,
  suppressHeaderFocus: !1,
  suppressMultiRangeSelection: !1,
  enableCellTextSelection: !1,
  enableRangeSelection: !1,
  enableRangeHandle: !1,
  enableFillHandle: !1,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: !1,
  accentedSort: !1,
  unSortIcon: !1,
  suppressMultiSort: !1,
  alwaysMultiSort: !1,
  suppressMaintainUnsortedOrder: !1,
  suppressRowHoverHighlight: !1,
  suppressRowTransform: !1,
  columnHoverHighlight: !1,
  deltaSort: !1,
  enableGroupEdit: !1,
  groupLockGroupColumns: 0,
  serverSideEnableClientSideSort: !1,
  suppressServerSideFullWidthLoadingRow: !1,
  pivotMaxGeneratedColumns: -1,
  columnMenu: "new",
  reactiveCustomComponents: !0,
  suppressSetFilterByDefault: !1,
  rowNumbers: !1,
  enableFilterHandlers: !1
}, RC = "https://www.ag-grid.com";
function Is(e, t, ...n) {
  e.get("debug") && console.log("AG Grid: " + t, ...n);
}
function ra(e, ...t) {
  hc(() => console.warn("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
function Qi(e, ...t) {
  hc(() => console.error("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
var Ee = "34.2.0", am = 2e3, lm = 100, EC = "_version_", ql = null, Ji = `${RC}/javascript-data-grid`;
function F3(e) {
  ql = e;
}
function M3(e) {
  Ji = e;
}
function AC(e, t, n) {
  return (ql == null ? void 0 : ql(e, t)) ?? [T3(e, t, n)];
}
function Qg(e, t, n, o, s) {
  e(`${o ? "warning" : "error"} #${t}`, ...AC(t, n, s));
}
function I3(e) {
  if (!e)
    return String(e);
  const t = {};
  for (const n of Object.keys(e))
    typeof e[n] != "object" && typeof e[n] != "function" && (t[n] = e[n]);
  return JSON.stringify(t);
}
function P3(e) {
  let t = e;
  return e instanceof Error ? t = e.toString() : typeof e == "object" && (t = I3(e)), t;
}
function Sd(e) {
  return e === void 0 ? "undefined" : e === null ? "null" : e;
}
function vh(e, t) {
  return `${e}?${t.toString()}`;
}
function D3(e, t, n) {
  const o = Array.from(t.entries()).sort((i, r) => r[1].length - i[1].length);
  let s = vh(e, t);
  for (const [i, r] of o) {
    if (i === EC)
      continue;
    const a = s.length - n;
    if (a <= 0)
      break;
    const l = "...", d = a + l.length, c = r.length - d > lm ? r.slice(0, r.length - d) + l : r.slice(0, lm) + l;
    t.set(i, c), s = vh(e, t);
  }
  return s;
}
function FC(e, t) {
  const n = new URLSearchParams();
  if (n.append(EC, Ee), t)
    for (const i of Object.keys(t))
      n.append(i, P3(t[i]));
  const o = `${Ji}/errors/${e}`, s = vh(o, n);
  return s.length <= am ? s : D3(o, n, am);
}
var T3 = (e, t, n) => {
  const o = FC(e, t);
  return `${n ? n + ` 
` : ""}Visit ${o}${n ? "" : ` 
  Alternatively register the ValidationModule to see the full message in the console.`}`;
};
function Z(...e) {
  Qg(ra, e[0], e[1], !0);
}
function $e(...e) {
  Qg(Qi, e[0], e[1], !1);
}
function Qr(e, t, n) {
  Qg(Qi, e, t, !1, n);
}
function k3(e, t) {
  const n = t[0];
  return `error #${n} ` + AC(n, t[1], e).join(" ");
}
function Eo(...e) {
  return k3(void 0, e);
}
function MC(e, t) {
  return e.get("rowModelType") === t;
}
function Ct(e, t) {
  return MC(e, "clientSide");
}
function gn(e, t) {
  return MC(e, "serverSide");
}
function jt(e, t) {
  return e.get("domLayout") === t;
}
function In(e) {
  return Cr(e) !== void 0;
}
function Jg(e) {
  return typeof e.get("getRowHeight") == "function";
}
function L3(e, t) {
  return t ? !e.get("enableStrictPivotColumnOrder") : e.get("maintainColumnOrder");
}
function qt(e, t, n = !1, o) {
  const { gos: s, environment: i } = e;
  if (o == null && (o = i.getDefaultRowHeight()), Jg(s)) {
    if (n)
      return { height: o, estimated: !0 };
    const l = {
      node: t,
      data: t.data
    }, d = s.getCallback("getRowHeight")(l);
    if (Ch(d))
      return d === 0 && Z(23), { height: Math.max(1, d), estimated: !1 };
  }
  if (t.detail && s.get("masterDetail"))
    return B3(s);
  const r = s.get("rowHeight");
  return { height: r && Ch(r) ? r : o, estimated: !1 };
}
function B3(e) {
  if (e.get("detailRowAutoHeight"))
    return { height: 1, estimated: !1 };
  const t = e.get("detailRowHeight");
  return Ch(t) ? { height: t, estimated: !1 } : { height: 300, estimated: !1 };
}
function Kn(e) {
  const { environment: t, gos: n } = e, o = n.get("rowHeight");
  if (!o || st(o))
    return t.getDefaultRowHeight();
  const s = t.refreshRowHeightVariable();
  return s !== -1 ? s : (Z(24), t.getDefaultRowHeight());
}
function Ch(e) {
  return !isNaN(e) && typeof e == "number" && isFinite(e);
}
function IC(e, t, n) {
  const o = t[e.getDomDataKey()];
  return o ? o[n] : void 0;
}
function Ci(e, t, n, o) {
  const s = e.getDomDataKey();
  let i = t[s];
  st(i) && (i = {}, t[s] = i), i[n] = o;
}
function Xi(e) {
  return e.get("ensureDomOrder") ? !1 : e.get("animateRows");
}
function gc(e) {
  return !(e.get("paginateChildRows") || e.get("groupHideOpenParents") || jt(e, "print"));
}
function Xn(e) {
  const t = e.get("autoGroupColumnDef");
  return !(t != null && t.comparator) && !e.get("treeData");
}
function Da(e) {
  const t = e.get("groupAggFiltering");
  if (typeof t == "function")
    return e.getCallback("groupAggFiltering");
  if (t === !0)
    return () => !0;
}
function kr(e) {
  return e.get("grandTotalRow");
}
function vr(e) {
  const t = e.get("groupTotalRow");
  return typeof t == "function" ? e.getCallback("groupTotalRow") : () => t ?? void 0;
}
function PC(e) {
  return e.get("groupHideOpenParents") ? !0 : e.get("groupDisplayType") === "multipleColumns";
}
function Xg(e, t) {
  return t ? !1 : e.get("groupDisplayType") === "groupRows";
}
function DC(e, t, n) {
  return !!t.group && !t.footer && Xg(e, n);
}
function Jo(e) {
  const t = e.getCallback("getRowId");
  return t === void 0 ? t : (n) => {
    let o = t(n);
    return typeof o != "string" && (hc(() => Z(25, { id: o }), "getRowIdString"), o = String(o)), o;
  };
}
function O3(e, t) {
  const n = e.get("groupHideParentOfSingleChild");
  return !!(n === !0 || n === "leafGroupsOnly" && t.leafGroup || e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") && t.leafGroup);
}
function TC(e) {
  const t = e.get("maxConcurrentDatasourceRequests");
  return t > 0 ? t : void 0;
}
function kC(e, t) {
  const n = e.get("suppressGroupChangesColumnVisibility");
  if (n === !0 || t && n === "suppressHideOnGroup" || !t && n === "suppressShowOnUngroup")
    return !1;
  const o = e.get("suppressRowGroupHidesColumns");
  if (t && o === !0)
    return !1;
  const s = e.get("suppressMakeColumnVisibleAfterUnGroup");
  return !(!t && s === !0);
}
function li(e) {
  return (e == null ? void 0 : e.checkboxes) ?? !0;
}
function jl(e) {
  return (e == null ? void 0 : e.mode) === "multiRow" && (e.headerCheckbox ?? !0);
}
function Ta(e) {
  if (typeof e == "object")
    return e.checkboxLocation ?? "selectionColumn";
}
function ru(e) {
  return (e == null ? void 0 : e.hideDisabledCheckboxes) ?? !1;
}
function ep(e) {
  return typeof e.get("rowSelection") != "string";
}
function Xo(e) {
  const t = e.get("cellSelection");
  return t !== void 0 ? !!t : e.get("enableRangeSelection");
}
function LC(e) {
  const t = e.get("rowSelection") ?? "single";
  if (typeof t == "string") {
    const n = e.get("suppressRowClickSelection"), o = e.get("suppressRowDeselection");
    return n && o ? !1 : n ? "enableDeselection" : o ? "enableSelection" : !0;
  }
  return t.mode === "singleRow" || t.mode === "multiRow" ? t.enableClickSelection ?? !1 : !1;
}
function G3(e) {
  const t = LC(e);
  return t === !0 || t === "enableSelection";
}
function H3(e) {
  const t = LC(e);
  return t === !0 || t === "enableDeselection";
}
function wh(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("isRowSelectable") : t == null ? void 0 : t.isRowSelectable;
}
function Cr(e) {
  const t = "beanName" in e && e.beanName === "gos" ? e.get("rowSelection") : e.rowSelection;
  if (typeof t == "string")
    switch (t) {
      case "multiple":
        return "multiRow";
      case "single":
        return "singleRow";
      default:
        return;
    }
  switch (t == null ? void 0 : t.mode) {
    case "multiRow":
    case "singleRow":
      return t.mode;
    default:
      return;
  }
}
function es(e) {
  return Cr(e) === "multiRow";
}
function V3(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("rowMultiSelectWithClick") : (t == null ? void 0 : t.enableSelectionWithoutKeys) ?? !1;
}
function xd(e) {
  const t = e.get("rowSelection");
  if (typeof t == "string") {
    const n = e.get("groupSelectsChildren"), o = e.get("groupSelectsFiltered");
    return n && o ? "filteredDescendants" : n ? "descendants" : "self";
  }
  return (t == null ? void 0 : t.mode) === "multiRow" ? t.groupSelects : void 0;
}
function BC(e, t = !0) {
  const n = e.get("rowSelection");
  return typeof n != "object" ? t ? "all" : void 0 : n.mode === "multiRow" ? n.selectAll : "all";
}
function wi(e) {
  const t = xd(e);
  return t === "descendants" || t === "filteredDescendants";
}
function dm(e) {
  const t = e.get("rowSelection");
  return typeof t == "object" && t.masterSelects || "self";
}
function _3(e) {
  return e.isModuleRegistered("SetFilter") && !e.get("suppressSetFilterByDefault");
}
function Nt(e) {
  return e.get("columnMenu") === "legacy";
}
function OC(e) {
  return !Nt(e);
}
function N3(e) {
  return !e || e.length < 2 ? e : "on" + e[0].toUpperCase() + e.substring(1);
}
function $3(e, t, n) {
  typeof e != "object" && (e = {});
  const o = { ...e };
  return n.forEach((s) => {
    const i = t[s];
    typeof i < "u" && (o[s] = i);
  }), o;
}
function z3(e, t) {
  if (!e)
    return;
  const n = {};
  let o = !1;
  if (Object.keys(e).forEach((r) => {
    n[r] = e[r], o = !0;
  }), !o)
    return;
  const s = {
    type: "gridOptionsChanged",
    options: n
  };
  t.dispatchEvent(s);
  const i = {
    type: "componentStateChanged",
    ...n
  };
  t.dispatchEvent(i);
}
function ke(e, t) {
  return e.addCommon(t);
}
function tp(e) {
  return e.get("treeData") ? e.get("treeDataParentIdField") ? "treeSelfRef" : e.get("treeDataChildrenField") ? "treeNested" : "treePath" : "group";
}
function cm({ gos: e }, t) {
  return t.button === 2 || t.ctrlKey && e.get("allowContextMenuWithControlKey");
}
var W3 = {
  resizable: !0,
  sortable: !0
}, U3 = 0;
function GC() {
  return U3++;
}
function Io(e) {
  return e instanceof Go;
}
var Go = class extends U {
  constructor(e, t, n, o) {
    super(), this.colDef = e, this.userProvidedColDef = t, this.colId = n, this.primary = o, this.isColumn = !0, this.instanceId = GC(), this.autoHeaderHeight = null, this.moving = !1, this.resizing = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.colEventSvc = new Fs(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.flex = null, this.colIdSanitised = sa(n);
  }
  destroy() {
    var e;
    super.destroy(), (e = this.beans.rowSpanSvc) == null || e.deregister(this);
  }
  getInstanceId() {
    return this.instanceId;
  }
  setState() {
    const {
      colDef: e,
      beans: { sortSvc: t, pinnedCols: n, colFlex: o }
    } = this;
    t == null || t.initCol(this);
    const s = e.hide;
    s !== void 0 ? this.visible = !s : this.visible = !e.initialHide, n == null || n.initCol(this), o == null || o.initCol(this);
  }
  // gets called when user provides an alternative colDef, eg
  setColDef(e, t, n) {
    var s;
    const o = e.spanRows !== this.colDef.spanRows;
    this.colDef = e, this.userProvidedColDef = t, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), o && ((s = this.beans.rowSpanSvc) == null || s.deregister(this), this.initRowSpan()), this.dispatchColEvent("colDefChanged", n);
  }
  getUserProvidedColDef() {
    return this.userProvidedColDef;
  }
  getParent() {
    return this.parent;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  // this is done after constructor as it uses gridOptionsService
  postConstruct() {
    this.setState(), this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip(), this.initRowSpan(), this.addPivotListener();
  }
  initDotNotation() {
    const {
      gos: e,
      colDef: { field: t, tooltipField: n }
    } = this, o = e.get("suppressFieldDotNotation");
    this.fieldContainsDots = ue(t) && t.indexOf(".") >= 0 && !o, this.tooltipFieldContainsDots = ue(n) && n.indexOf(".") >= 0 && !o;
  }
  initMinAndMaxWidths() {
    const e = this.colDef;
    this.minWidth = e.minWidth ?? this.beans.environment.getDefaultColumnMinWidth(), this.maxWidth = e.maxWidth ?? Number.MAX_SAFE_INTEGER;
  }
  initTooltip() {
    var e;
    (e = this.beans.tooltipSvc) == null || e.initCol(this);
  }
  initRowSpan() {
    var e;
    this.colDef.spanRows && ((e = this.beans.rowSpanSvc) == null || e.register(this));
  }
  addPivotListener() {
    const e = this.beans.pivotColDefSvc, t = this.colDef.pivotValueColumn;
    !e || !t || this.addManagedListeners(t, {
      colDefChanged: (n) => {
        const o = e.recreateColDef(this.colDef);
        this.setColDef(o, o, n.source);
      }
    });
  }
  resetActualWidth(e) {
    const t = this.calculateColInitialWidth(this.colDef);
    this.setActualWidth(t, e, !0);
  }
  calculateColInitialWidth(e) {
    let t;
    const n = e.width, o = e.initialWidth;
    return n != null ? t = n : o != null ? t = o : t = 200, Math.max(Math.min(t, this.maxWidth), this.minWidth);
  }
  isEmptyGroup() {
    return !1;
  }
  isRowGroupDisplayed(e) {
    var t;
    return ((t = this.beans.showRowGroupCols) == null ? void 0 : t.isRowGroupDisplayed(this, e)) ?? !1;
  }
  isPrimary() {
    return this.primary;
  }
  isFilterAllowed() {
    return !!this.colDef.filter;
  }
  isFieldContainsDots() {
    return this.fieldContainsDots;
  }
  isTooltipEnabled() {
    return this.tooltipEnabled;
  }
  isTooltipFieldContainsDots() {
    return this.tooltipFieldContainsDots;
  }
  getHighlighted() {
    return this.highlighted;
  }
  __addEventListener(e, t) {
    this.colEventSvc.addEventListener(e, t);
  }
  __removeEventListener(e, t) {
    this.colEventSvc.removeEventListener(e, t);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  addEventListener(e, t) {
    var o, s, i;
    this.frameworkEventListenerService = (s = (o = this.beans.frameworkOverrides).createLocalEventListenerWrapper) == null ? void 0 : s.call(
      o,
      this.frameworkEventListenerService,
      this.colEventSvc
    );
    const n = ((i = this.frameworkEventListenerService) == null ? void 0 : i.wrap(e, t)) ?? t;
    this.colEventSvc.addEventListener(e, n);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  removeEventListener(e, t) {
    var o;
    const n = ((o = this.frameworkEventListenerService) == null ? void 0 : o.unwrap(e, t)) ?? t;
    this.colEventSvc.removeEventListener(e, n);
  }
  createColumnFunctionCallbackParams(e) {
    return ke(this.gos, {
      node: e,
      data: e.data,
      column: this,
      colDef: this.colDef
    });
  }
  isSuppressNavigable(e) {
    var t;
    return ((t = this.beans.cellNavigation) == null ? void 0 : t.isSuppressNavigable(this, e)) ?? !1;
  }
  isCellEditable(e) {
    var t;
    return ((t = this.beans.editSvc) == null ? void 0 : t.isCellEditable({ rowNode: e, column: this })) ?? !1;
  }
  isSuppressFillHandle() {
    return !!this.colDef.suppressFillHandle;
  }
  isAutoHeight() {
    return !!this.colDef.autoHeight;
  }
  isAutoHeaderHeight() {
    return !!this.colDef.autoHeaderHeight;
  }
  isRowDrag(e) {
    return this.isColumnFunc(e, this.colDef.rowDrag);
  }
  isDndSource(e) {
    return this.isColumnFunc(e, this.colDef.dndSource);
  }
  isCellCheckboxSelection(e) {
    var t;
    return ((t = this.beans.selectionSvc) == null ? void 0 : t.isCellCheckboxSelection(this, e)) ?? !1;
  }
  isSuppressPaste(e) {
    var t;
    return this.isColumnFunc(e, ((t = this.colDef) == null ? void 0 : t.suppressPaste) ?? null);
  }
  isResizable() {
    return !!this.getColDefValue("resizable");
  }
  /** Get value from ColDef or default if it exists. */
  getColDefValue(e) {
    return this.colDef[e] ?? W3[e];
  }
  isColumnFunc(e, t) {
    if (typeof t == "boolean")
      return t;
    if (typeof t == "function") {
      const n = this.createColumnFunctionCallbackParams(e);
      return t(n);
    }
    return !1;
  }
  createColumnEvent(e, t) {
    return ke(this.gos, {
      type: e,
      column: this,
      columns: [this],
      source: t
    });
  }
  isMoving() {
    return this.moving;
  }
  getSort() {
    return this.sort;
  }
  isSortable() {
    return !!this.getColDefValue("sortable");
  }
  /** @deprecated v32 use col.getSort() === 'asc */
  isSortAscending() {
    return this.sort === "asc";
  }
  /** @deprecated v32 use col.getSort() === 'desc */
  isSortDescending() {
    return this.sort === "desc";
  }
  /** @deprecated v32 use col.getSort() === undefined */
  isSortNone() {
    return st(this.sort);
  }
  /** @deprecated v32 use col.getSort() !== undefined */
  isSorting() {
    return ue(this.sort);
  }
  getSortIndex() {
    return this.sortIndex;
  }
  isMenuVisible() {
    return this.menuVisible;
  }
  getAggFunc() {
    return this.aggFunc;
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  getRight() {
    return this.left + this.actualWidth;
  }
  setLeft(e, t) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchColEvent("leftChanged", t));
  }
  isFilterActive() {
    return this.filterActive;
  }
  /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */
  isHovered() {
    var e;
    return Z(261), !!((e = this.beans.colHover) != null && e.isHovered(this));
  }
  setFirstRightPinned(e, t) {
    this.firstRightPinned !== e && (this.firstRightPinned = e, this.dispatchColEvent("firstRightPinnedChanged", t));
  }
  setLastLeftPinned(e, t) {
    this.lastLeftPinned !== e && (this.lastLeftPinned = e, this.dispatchColEvent("lastLeftPinnedChanged", t));
  }
  isFirstRightPinned() {
    return this.firstRightPinned;
  }
  isLastLeftPinned() {
    return this.lastLeftPinned;
  }
  isPinned() {
    return this.pinned === "left" || this.pinned === "right";
  }
  isPinnedLeft() {
    return this.pinned === "left";
  }
  isPinnedRight() {
    return this.pinned === "right";
  }
  getPinned() {
    return this.pinned;
  }
  setVisible(e, t) {
    const n = e === !0;
    this.visible !== n && (this.visible = n, this.dispatchColEvent("visibleChanged", t)), this.dispatchStateUpdatedEvent("hide");
  }
  isVisible() {
    return this.visible;
  }
  isSpanHeaderHeight() {
    return !this.getColDef().suppressSpanHeaderHeight;
  }
  /**
   * Returns the first parent that is not a padding group.
   */
  getFirstRealParent() {
    let e = this.getOriginalParent();
    for (; e && e.isPadding(); )
      e = e.getOriginalParent();
    return e;
  }
  getColumnGroupPaddingInfo() {
    let e = this.getParent();
    if (!e || !e.isPadding())
      return { numberOfParents: 0, isSpanningTotal: !1 };
    const t = e.getPaddingLevel() + 1;
    let n = !0;
    for (; e; ) {
      if (!e.isPadding()) {
        n = !1;
        break;
      }
      e = e.getParent();
    }
    return { numberOfParents: t, isSpanningTotal: n };
  }
  getColDef() {
    return this.colDef;
  }
  getDefinition() {
    return this.colDef;
  }
  getColumnGroupShow() {
    return this.colDef.columnGroupShow;
  }
  getColId() {
    return this.colId;
  }
  getId() {
    return this.colId;
  }
  getUniqueId() {
    return this.colId;
  }
  getActualWidth() {
    return this.actualWidth;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  createBaseColDefParams(e) {
    return ke(this.gos, {
      node: e,
      data: e.data,
      colDef: this.colDef,
      column: this
    });
  }
  getColSpan(e) {
    if (st(this.colDef.colSpan))
      return 1;
    const t = this.createBaseColDefParams(e), n = this.colDef.colSpan(t);
    return Math.max(n, 1);
  }
  getRowSpan(e) {
    if (st(this.colDef.rowSpan))
      return 1;
    const t = this.createBaseColDefParams(e), n = this.colDef.rowSpan(t);
    return Math.max(n, 1);
  }
  setActualWidth(e, t, n = !1) {
    e = Math.max(e, this.minWidth), e = Math.min(e, this.maxWidth), this.actualWidth !== e && (this.actualWidth = e, this.flex != null && t !== "flex" && t !== "gridInitializing" && (this.flex = null), n || this.fireColumnWidthChangedEvent(t)), this.dispatchStateUpdatedEvent("width");
  }
  fireColumnWidthChangedEvent(e) {
    this.dispatchColEvent("widthChanged", e);
  }
  isGreaterThanMax(e) {
    return e > this.maxWidth;
  }
  getMinWidth() {
    return this.minWidth;
  }
  getMaxWidth() {
    return this.maxWidth;
  }
  getFlex() {
    return this.flex;
  }
  isRowGroupActive() {
    return this.rowGroupActive;
  }
  isPivotActive() {
    return this.pivotActive;
  }
  isAnyFunctionActive() {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  }
  isAnyFunctionAllowed() {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  }
  isValueActive() {
    return this.aggregationActive;
  }
  isAllowPivot() {
    return this.colDef.enablePivot === !0;
  }
  isAllowValue() {
    return this.colDef.enableValue === !0;
  }
  isAllowRowGroup() {
    return this.colDef.enableRowGroup === !0;
  }
  dispatchColEvent(e, t, n) {
    const o = this.createColumnEvent(e, t);
    n && on(o, n), this.colEventSvc.dispatchEvent(o);
  }
  dispatchStateUpdatedEvent(e) {
    this.colEventSvc.dispatchEvent({
      type: "columnStateUpdated",
      key: e
    });
  }
};
function Pt(e) {
  return e instanceof er;
}
var er = class extends U {
  constructor(e, t, n, o) {
    super(), this.colGroupDef = e, this.groupId = t, this.padding = n, this.level = o, this.isColumn = !1, this.expandable = !1, this.instanceId = GC(), this.expandableListenerRemoveCallback = null, this.expanded = !!(e != null && e.openByDefault);
  }
  destroy() {
    this.expandableListenerRemoveCallback && this.reset(null, void 0), super.destroy();
  }
  reset(e, t) {
    this.colGroupDef = e, this.level = t, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
  }
  getInstanceId() {
    return this.instanceId;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  getLevel() {
    return this.level;
  }
  isVisible() {
    return this.children ? this.children.some((e) => e.isVisible()) : !1;
  }
  isPadding() {
    return this.padding;
  }
  setExpanded(e) {
    this.expanded = e === void 0 ? !1 : e, this.dispatchLocalEvent({ type: "expandedChanged" });
  }
  isExpandable() {
    return this.expandable;
  }
  isExpanded() {
    return this.expanded;
  }
  getGroupId() {
    return this.groupId;
  }
  getId() {
    return this.getGroupId();
  }
  setChildren(e) {
    this.children = e;
  }
  getChildren() {
    return this.children;
  }
  getColGroupDef() {
    return this.colGroupDef;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  forEachLeafColumn(e) {
    if (this.children)
      for (const t of this.children)
        Io(t) ? e(t) : Pt(t) && t.forEachLeafColumn(e);
  }
  addLeafColumns(e) {
    this.children && this.children.forEach((t) => {
      Io(t) ? e.push(t) : Pt(t) && t.addLeafColumns(e);
    });
  }
  getColumnGroupShow() {
    const e = this.colGroupDef;
    if (e)
      return e.columnGroupShow;
  }
  // need to check that this group has at least one col showing when both expanded and contracted.
  // if not, then we don't allow expanding and contracting on this group
  setupExpandable() {
    this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
    const e = this.onColumnVisibilityChanged.bind(this);
    this.getLeafColumns().forEach((t) => t.__addEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = () => {
      this.getLeafColumns().forEach((t) => t.__removeEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = null;
    };
  }
  setExpandable() {
    if (this.isPadding())
      return;
    let e = !1, t = !1, n = !1;
    const o = this.findChildrenRemovingPadding();
    for (let i = 0, r = o.length; i < r; i++) {
      const a = o[i];
      if (!a.isVisible())
        continue;
      const l = a.getColumnGroupShow();
      l === "open" ? (e = !0, n = !0) : l === "closed" ? (t = !0, n = !0) : (e = !0, t = !0);
    }
    const s = e && t && n;
    this.expandable !== s && (this.expandable = s, this.dispatchLocalEvent({ type: "expandableChanged" }));
  }
  findChildrenRemovingPadding() {
    const e = [], t = (n) => {
      n.forEach((o) => {
        Pt(o) && o.isPadding() ? t(o.children) : e.push(o);
      });
    };
    return t(this.children), e;
  }
  onColumnVisibilityChanged() {
    this.setExpandable();
  }
}, K3 = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
};
function yh(e, t, n) {
  const o = {}, s = e.gos;
  return Object.assign(o, s.get("defaultColGroupDef")), Object.assign(o, t), s.validateColDef(o, n), o;
}
var Z3 = class {
  constructor() {
    this.existingKeys = {};
  }
  addExistingKeys(e) {
    for (let t = 0; t < e.length; t++)
      this.existingKeys[e[t]] = !0;
  }
  getUniqueKey(e, t) {
    e = Pn(e);
    let n = 0;
    for (; ; ) {
      let o = e ?? t;
      if (o ? n !== 0 && (o += "_" + n) : o = n, !this.existingKeys[o]) {
        const s = String(o);
        return e && n > 0 && Z(273, { providedId: e, usedId: s }), this.existingKeys[s] = !0, s;
      }
      n++;
    }
  }
}, Vo = Object.freeze([]);
function Je(e) {
  if (e != null && e.length)
    return e[e.length - 1];
}
function Yn(e, t, n) {
  if (e === t)
    return !0;
  if (!e || !t)
    return e == null && t == null;
  const o = e.length;
  if (o !== t.length)
    return !1;
  for (let s = 0; s < o; s++)
    if (e[s] !== t[s] && !(n != null && n(e[s], t[s])))
      return !1;
  return !0;
}
function Nr(e, t) {
  if (e)
    for (const n of e)
      t(n);
}
function $t(e, t) {
  const n = e.indexOf(t);
  n >= 0 && e.splice(n, 1);
}
function um(e, t, n) {
  for (let o = 0; o < t.length; o++)
    $t(e, t[o]);
  for (let o = t.length - 1; o >= 0; o--)
    e.splice(n, 0, t[o]);
}
var wr = "ag-Grid-AutoColumn", HC = "ag-Grid-SelectionColumn", VC = "ag-Grid-RowNumbersColumn", q3 = "ag-Grid-HierarchyColumn";
function np(e) {
  const t = [], n = (o) => {
    for (let s = 0; s < o.length; s++) {
      const i = o[s];
      Io(i) ? t.push(i) : Pt(i) && n(i.getChildren());
    }
  };
  return n(e), t;
}
function _o(e) {
  return e.reduce((t, n) => t + n.getActualWidth(), 0);
}
function ts(e, t, n) {
  const o = {};
  if (!t)
    return;
  Ao(null, t, (i) => {
    o[i.getInstanceId()] = i;
  }), n && Ao(null, n, (i) => {
    o[i.getInstanceId()] = null;
  });
  const s = Object.values(o).filter((i) => i != null);
  e.context.destroyBeans(s);
}
function pc(e) {
  return e.getId().startsWith(wr);
}
function Gs(e) {
  const t = typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId;
  return (t == null ? void 0 : t.startsWith(HC)) ?? !1;
}
function bs(e) {
  const t = typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId;
  return (t == null ? void 0 : t.startsWith(VC)) ?? !1;
}
function j3(e) {
  return Gs(e) || bs(e);
}
function Rd(e) {
  let t = [];
  return e instanceof Array ? t = e : typeof e == "string" && (t = e.split(",")), t;
}
function op(e, t) {
  return Yn(e, t, (n, o) => n.getColId() === o.getColId());
}
function sp(e) {
  e.map = {}, e.list.forEach((t) => e.map[t.getId()] = t);
}
function di(e) {
  return e === "optionsUpdated" ? "gridOptionsChanged" : e;
}
function ka(e, t) {
  const n = e === t, o = e.getColDef() === t, s = e.getColId() == t;
  return n || o || s;
}
var Y3 = (e, t) => (n, o) => {
  const s = {
    value1: void 0,
    value2: void 0
  };
  let i = !1;
  return e && (e[n] !== void 0 && (s.value1 = e[n], i = !0), ue(o) && e[o] !== void 0 && (s.value2 = e[o], i = !0)), !i && t && (t[n] !== void 0 && (s.value1 = t[n]), ue(o) && t[o] !== void 0 && (s.value2 = t[o])), s;
};
function Q3(e, t = null, n, o, s) {
  const { existingCols: i, existingGroups: r } = NC(o), a = new Map(i.map((m) => [m.getId(), m])), l = new Map(r.map((m) => [m.getId(), m]));
  let d = 0;
  const c = (m, C) => {
    var S;
    if (d = Math.max(d, C), UC(m)) {
      if (!e.colGroupSvc)
        return null;
      const F = m.groupId, E = l.get(F), M = yh(e, m, F), I = new er(M, F, !1, C);
      return e.context.createBean(I), E && I.setExpanded(E.isExpanded()), I.setChildren(m.children.map((P) => c(P, C + 1))), I;
    }
    const w = m.colId;
    let b = a.get(w);
    const A = yi(e, m, (b == null ? void 0 : b.getColId()) ?? w);
    return b ? (b.setColDef(A, m, s), WC(e, b, A, s)) : (b = new Go(A, m, w, n), e.context.createBean(b)), (S = e.dataTypeSvc) == null || S.addColumnListeners(b), b;
  }, u = (t == null ? void 0 : t.map((m) => c(m, 0))) ?? [];
  let h = 0;
  const g = {
    getUniqueKey: (m, C) => String(++h)
  }, p = e.colGroupSvc ? e.colGroupSvc.balanceColumnTree(u, 0, d, g) : u;
  return Ao(null, p, (m, C) => {
    Pt(m) && m.setupExpandable(), m.originalParent = C;
  }), {
    columnTree: p,
    treeDepth: d
  };
}
function _C(e, t = null, n, o, s) {
  const i = new Z3(), { existingCols: r, existingGroups: a, existingColKeys: l } = NC(o);
  i.addExistingKeys(l);
  const d = $C(
    e,
    t,
    0,
    n,
    r,
    i,
    a,
    s
  ), { colGroupSvc: c } = e, u = (c == null ? void 0 : c.findMaxDepth(d, 0)) ?? 0, h = c ? c.balanceColumnTree(d, 0, u, i) : d;
  return Ao(null, h, (p, f) => {
    Pt(p) && p.setupExpandable(), p.originalParent = f;
  }), {
    columnTree: h,
    treeDepth: u
  };
}
function NC(e) {
  const t = [], n = [], o = [];
  return e && Ao(null, e, (s) => {
    if (Pt(s)) {
      const i = s;
      n.push(i);
    } else {
      const i = s;
      o.push(i.getId()), t.push(i);
    }
  }), { existingCols: t, existingGroups: n, existingColKeys: o };
}
function $C(e, t, n, o, s, i, r, a) {
  if (!t)
    return [];
  const { colGroupSvc: l } = e, d = new Array(t.length);
  for (let c = 0; c < d.length; c++) {
    const u = t[c];
    l && UC(u) ? d[c] = l.createProvidedColumnGroup(
      o,
      u,
      n,
      s,
      i,
      r,
      a
    ) : d[c] = J3(e, o, u, s, i, a);
  }
  return d;
}
function J3(e, t, n, o, s, i) {
  var l;
  const r = X3(n, o);
  r && (o == null || o.splice(r.idx, 1));
  let a = r == null ? void 0 : r.column;
  if (a) {
    const d = yi(e, n, a.getColId());
    a.setColDef(d, n, i), WC(e, a, d, i);
  } else {
    const d = s.getUniqueKey(n.colId, n.field), c = yi(e, n, d);
    a = new Go(c, n, d, t), e.context.createBean(a);
  }
  return (l = e.dataTypeSvc) == null || l.addColumnListeners(a), a;
}
function zC(e, t, n, o, s, i, r, a) {
  const { sortSvc: l, pinnedCols: d, colFlex: c } = e;
  n !== void 0 && t.setVisible(!n, a), l && (l.updateColSort(t, o, a), s !== void 0 && l.setColSortIndex(t, s)), i !== void 0 && (d == null || d.setColPinned(t, i)), r !== void 0 && (c == null || c.setColFlex(t, r));
}
function WC(e, t, n, o) {
  zC(
    e,
    t,
    n.hide,
    n.sort,
    n.sortIndex,
    n.pinned,
    n.flex,
    o
  );
  const s = t.getFlex();
  if (!(s != null && s > 0))
    if (n.width != null)
      t.setActualWidth(n.width, o);
    else {
      const i = t.getActualWidth();
      t.setActualWidth(i, o);
    }
}
function X3(e, t) {
  if (t)
    for (let n = 0; n < t.length; n++) {
      const o = t[n].getUserProvidedColDef();
      if (!o)
        continue;
      if (e.colId != null) {
        if (t[n].getId() === e.colId)
          return { idx: n, column: t[n] };
        continue;
      }
      if (e.field != null) {
        if (o.field === e.field)
          return { idx: n, column: t[n] };
        continue;
      }
      if (o === e)
        return { idx: n, column: t[n] };
    }
}
function yi(e, t, n, o) {
  const { gos: s, dataTypeSvc: i } = e, r = {}, a = s.get("defaultColDef");
  on(r, a, !1, !0);
  const l = eF(e, r, t, n);
  l && tF(e, l, r);
  const d = r.cellDataType;
  on(r, t, !1, !0), d !== void 0 && (r.cellDataType = d);
  const c = s.get("autoGroupColumnDef"), u = Xn(s);
  return t.rowGroup && c && u && on(
    r,
    { sort: c.sort, initialSort: c.initialSort },
    !1,
    !0
  ), i && (i.postProcess(r), i.validateColDef(r)), s.validateColDef(r, n, o), r;
}
function eF(e, t, n, o) {
  var r;
  const s = (r = e.dataTypeSvc) == null ? void 0 : r.updateColDefAndGetColumnType(t, n, o), i = n.type ?? s ?? t.type;
  return t.type = i, i ? Rd(i) : void 0;
}
function tF(e, t, n) {
  if (!t.length)
    return;
  const o = Object.assign({}, K3), s = e.gos.get("columnTypes") || {};
  for (const i of Object.keys(s)) {
    const r = s[i];
    i in o ? Z(34, { key: i }) : (r.type && Z(35), o[i] = r);
  }
  t.forEach((i) => {
    const r = o[i.trim()];
    r ? on(n, r, !1, !0) : Z(36, { t: i });
  });
}
function UC(e) {
  return e.children !== void 0;
}
function Ao(e, t, n) {
  if (t)
    for (let o = 0; o < t.length; o++) {
      const s = t[o];
      Pt(s) && Ao(s, s.getChildren(), n), n(s, e);
    }
}
function KC(e, t) {
  const n = [], o = [], s = [];
  return e.forEach((r) => {
    const a = r.getColDef().lockPosition;
    a === "right" ? s.push(r) : a === "left" || a === !0 ? n.push(r) : o.push(r);
  }), t.get("enableRtl") ? [...s, ...o, ...n] : [...n, ...o, ...s];
}
function ZC(e, t) {
  let n = !0;
  return Ao(null, t, (o) => {
    if (!Pt(o))
      return;
    const s = o, i = s.getColGroupDef();
    if (!(i && i.marryChildren))
      return;
    const a = [];
    s.getLeafColumns().forEach((h) => {
      const g = e.indexOf(h);
      a.push(g);
    });
    const l = Math.max.apply(Math, a), d = Math.min.apply(Math, a), c = l - d, u = s.getLeafColumns().length - 1;
    c > u && (n = !1);
  }), n;
}
function qC(e, t) {
  if (!e || e.length == 0)
    return;
  const n = t(e[0]);
  for (let o = 1; o < e.length; o++)
    if (n !== t(e[o]))
      return;
  return n;
}
function jC(e, t, n) {
  if (!t.length)
    return;
  const o = t.length === 1 ? t[0] : null, s = qC(t, (i) => i.getPinned());
  e.dispatchEvent({
    type: "columnPinned",
    // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
    pinned: s ?? null,
    columns: t,
    column: o,
    source: n
  });
}
function nF(e, t, n) {
  if (!t.length)
    return;
  const o = t.length === 1 ? t[0] : null, s = qC(t, (i) => i.isVisible());
  e.dispatchEvent({
    type: "columnVisible",
    visible: s,
    columns: t,
    column: o,
    source: n
  });
}
function YC(e, t, n, o) {
  e.dispatchEvent({
    type: t,
    columns: n,
    column: n && n.length == 1 ? n[0] : null,
    source: o
  });
}
function yr(e, t, n, o, s = null) {
  t != null && t.length && e.dispatchEvent({
    type: "columnResized",
    columns: t,
    column: t.length === 1 ? t[0] : null,
    flexColumns: s,
    finished: n,
    source: o
  });
}
function cn(e, t, n) {
  var S;
  const {
    colModel: o,
    rowGroupColsSvc: s,
    pivotColsSvc: i,
    autoColSvc: r,
    selectionColSvc: a,
    colAnimation: l,
    visibleCols: d,
    pivotResultCols: c,
    environment: u,
    valueColsSvc: h,
    eventSvc: g,
    gos: p
  } = e, f = o.getColDefCols() ?? [], m = a == null ? void 0 : a.getColumns();
  if (!f.length && !(m != null && m.length))
    return !1;
  if (t != null && t.state && !t.state.forEach)
    return Z(32), !1;
  const C = (F, E, M, I, P) => {
    if (!F)
      return;
    const k = Y3(E, t.defaultState), B = k("flex").value1;
    if (zC(
      e,
      F,
      k("hide").value1,
      k("sort").value1,
      k("sortIndex").value1,
      k("pinned").value1,
      B,
      n
    ), B == null) {
      const j = k("width").value1;
      if (j != null) {
        const N = F.getColDef().minWidth ?? u.getDefaultColumnMinWidth();
        N != null && j >= N && F.setActualWidth(j, n);
      }
    }
    P || !F.isPrimary() || (h == null || h.syncColumnWithState(F, n, k), s == null || s.syncColumnWithState(F, n, k, M), i == null || i.syncColumnWithState(F, n, k, I));
  }, w = (F, E, M) => {
    var Ie, L;
    const I = JC(e, n), P = E.slice(), k = {}, B = {}, j = [], N = [], re = [];
    let H = 0;
    const _ = (s == null ? void 0 : s.columns.slice()) ?? [], ne = (i == null ? void 0 : i.columns.slice()) ?? [];
    F.forEach((oe) => {
      const K = oe.colId;
      if (K.startsWith(wr)) {
        j.push(oe), re.push(oe);
        return;
      }
      if (Gs(K)) {
        N.push(oe), re.push(oe);
        return;
      }
      const le = M(K);
      le ? (C(le, oe, k, B, !1), $t(P, le)) : (re.push(oe), H += 1);
    });
    const ce = (oe) => C(oe, null, k, B, !1);
    P.forEach(ce), s == null || s.sortColumns(hm.bind(s, k, _)), i == null || i.sortColumns(hm.bind(i, B, ne)), o.refreshCols(!1);
    const me = (oe, K, G = []) => {
      K.forEach((le) => {
        const be = oe(le.colId);
        $t(G, be), C(be, le, null, null, !0);
      }), G.forEach(ce);
    };
    return me(
      (oe) => (r == null ? void 0 : r.getColumn(oe)) ?? null,
      j,
      (Ie = r == null ? void 0 : r.getColumns()) == null ? void 0 : Ie.slice()
    ), me(
      (oe) => (a == null ? void 0 : a.getColumn(oe)) ?? null,
      N,
      (L = a == null ? void 0 : a.getColumns()) == null ? void 0 : L.slice()
    ), oF(t, o, p), d.refresh(n), g.dispatchEvent({
      type: "columnEverythingChanged",
      source: n
    }), I(), { unmatchedAndAutoStates: re, unmatchedCount: H };
  };
  l == null || l.start();
  let { unmatchedAndAutoStates: b, unmatchedCount: A } = w(
    t.state || [],
    f,
    (F) => o.getColDefCol(F)
  );
  if (b.length > 0 || ue(t.defaultState)) {
    const F = ((S = c == null ? void 0 : c.getPivotResultCols()) == null ? void 0 : S.list) ?? [];
    A = w(
      b,
      F,
      (E) => (c == null ? void 0 : c.getPivotResultCol(E)) ?? null
    ).unmatchedCount;
  }
  return l == null || l.finish(), A === 0;
}
function QC(e, t) {
  var w, b;
  const { colModel: n, autoColSvc: o, selectionColSvc: s, eventSvc: i, gos: r } = e, a = n.getColDefCols();
  if (!(a != null && a.length))
    return;
  const l = n.getColDefColTree(), d = np(l), c = [];
  let u = 1e3, h = 1e3;
  const g = (A) => {
    const S = XC(A);
    st(S.rowGroupIndex) && S.rowGroup && (S.rowGroupIndex = u++), st(S.pivotIndex) && S.pivot && (S.pivotIndex = h++), c.push(S);
  };
  (w = o == null ? void 0 : o.getColumns()) == null || w.forEach(g), (b = s == null ? void 0 : s.getColumns()) == null || b.forEach(g), d == null || d.forEach(g), cn(e, { state: c }, t);
  const p = (o == null ? void 0 : o.getColumns()) ?? [], C = [...(s == null ? void 0 : s.getColumns()) ?? [], ...p, ...a].map((A) => ({ colId: A.colId }));
  cn(e, { state: C, applyOrder: !0 }, t), i.dispatchEvent(ke(r, { type: "columnsReset", source: t }));
}
function JC(e, t) {
  const { rowGroupColsSvc: n, pivotColsSvc: o, valueColsSvc: s, colModel: i, sortSvc: r, eventSvc: a } = e, l = {
    rowGroupColumns: (n == null ? void 0 : n.columns.slice()) ?? [],
    pivotColumns: (o == null ? void 0 : o.columns.slice()) ?? [],
    valueColumns: (s == null ? void 0 : s.columns.slice()) ?? []
  }, d = Ed(e), c = {};
  return d.forEach((u) => {
    c[u.colId] = u;
  }), () => {
    const u = (F, E, M, I) => {
      const P = E.map(I), k = M.map(I);
      if (Yn(P, k))
        return;
      const j = new Set(E);
      M.forEach((re) => {
        j.delete(re) || j.add(re);
      });
      const N = [...j];
      a.dispatchEvent({
        type: F,
        columns: N,
        column: N.length === 1 ? N[0] : null,
        source: t
      });
    }, h = (F) => {
      const E = [];
      return i.forAllCols((M) => {
        const I = c[M.getColId()];
        I && F(I, M) && E.push(M);
      }), E;
    }, g = (F) => F.getColId();
    u(
      "columnRowGroupChanged",
      l.rowGroupColumns,
      (n == null ? void 0 : n.columns) ?? [],
      g
    ), u(
      "columnPivotChanged",
      l.pivotColumns,
      (o == null ? void 0 : o.columns) ?? [],
      g
    );
    const f = h((F, E) => {
      const M = F.aggFunc != null, I = M != E.isValueActive(), P = M && F.aggFunc != E.getAggFunc();
      return I || P;
    });
    f.length > 0 && YC(a, "columnValueChanged", f, t), yr(a, h((F, E) => F.width != E.getActualWidth()), !0, t), jC(a, h((F, E) => F.pinned != E.getPinned()), t), nF(a, h((F, E) => F.hide == E.isVisible()), t);
    const A = h((F, E) => F.sort != E.getSort() || F.sortIndex != E.getSortIndex());
    A.length > 0 && (r == null || r.dispatchSortChangedEvents(t, A));
    const S = Ed(e);
    iF(d, S, t, i, a);
  };
}
function Ed(e) {
  const { colModel: t, rowGroupColsSvc: n, pivotColsSvc: o } = e, s = t.getColDefCols();
  if (st(s) || !t.isAlive())
    return [];
  const i = n == null ? void 0 : n.columns, r = o == null ? void 0 : o.columns, a = [], l = (c) => {
    const u = c.isRowGroupActive() && i ? i.indexOf(c) : null, h = c.isPivotActive() && r ? r.indexOf(c) : null, g = c.isValueActive() ? c.getAggFunc() : null, p = c.getSort() != null ? c.getSort() : null, f = c.getSortIndex() != null ? c.getSortIndex() : null;
    a.push({
      colId: c.getColId(),
      width: c.getActualWidth(),
      hide: !c.isVisible(),
      pinned: c.getPinned(),
      sort: p,
      sortIndex: f,
      aggFunc: g,
      rowGroup: c.isRowGroupActive(),
      rowGroupIndex: u,
      pivot: c.isPivotActive(),
      pivotIndex: h,
      flex: c.getFlex() ?? null
    });
  };
  t.forAllCols((c) => l(c));
  const d = new Map(
    t.getCols().map((c, u) => [c.getColId(), u])
  );
  return a.sort((c, u) => {
    const h = d.has(c.colId) ? d.get(c.colId) : -1, g = d.has(u.colId) ? d.get(u.colId) : -1;
    return h - g;
  }), a;
}
function XC(e) {
  const t = (p, f) => p ?? f ?? null, n = e.getColDef(), o = t(n.sort, n.initialSort), s = t(n.sortIndex, n.initialSortIndex), i = t(n.hide, n.initialHide), r = t(n.pinned, n.initialPinned), a = t(n.width, n.initialWidth), l = t(n.flex, n.initialFlex);
  let d = t(n.rowGroupIndex, n.initialRowGroupIndex), c = t(n.rowGroup, n.initialRowGroup);
  d == null && (c == null || c == !1) && (d = null, c = null);
  let u = t(n.pivotIndex, n.initialPivotIndex), h = t(n.pivot, n.initialPivot);
  u == null && (h == null || h == !1) && (u = null, h = null);
  const g = t(n.aggFunc, n.initialAggFunc);
  return {
    colId: e.getColId(),
    sort: o,
    sortIndex: s,
    hide: i,
    pinned: r,
    width: a,
    flex: l,
    rowGroup: c,
    rowGroupIndex: d,
    pivot: h,
    pivotIndex: u,
    aggFunc: g
  };
}
function oF(e, t, n) {
  if (!e.applyOrder || !e.state)
    return;
  const o = [];
  e.state.forEach((s) => {
    s.colId != null && o.push(s.colId);
  }), sF(t.cols, o, t, n);
}
function sF(e, t, n, o) {
  if (e == null)
    return;
  let s = [];
  const i = {};
  t.forEach((a) => {
    if (i[a])
      return;
    const l = e.map[a];
    l && (s.push(l), i[a] = !0);
  });
  let r = 0;
  if (e.list.forEach((a) => {
    const l = a.getColId();
    if (i[l] != null)
      return;
    l.startsWith(wr) ? s.splice(r++, 0, a) : s.push(a);
  }), s = KC(s, o), !ZC(s, n.getColTree())) {
    Z(39);
    return;
  }
  e.list = s;
}
function iF(e, t, n, o, s) {
  const i = {};
  t.forEach((c) => i[c.colId] = c);
  const r = {};
  e.forEach((c) => {
    i[c.colId] && (r[c.colId] = !0);
  });
  const a = e.filter((c) => r[c.colId]), l = t.filter((c) => r[c.colId]), d = [];
  l.forEach((c, u) => {
    const h = a && a[u];
    if (h && h.colId !== c.colId) {
      const g = o.getCol(h.colId);
      g && d.push(g);
    }
  }), d.length && s.dispatchEvent({
    type: "columnMoved",
    columns: d,
    column: d.length === 1 ? d[0] : null,
    finished: !0,
    source: n
  });
}
var hm = (e, t, n, o) => {
  const s = e[n.getId()], i = e[o.getId()], r = s != null, a = i != null;
  if (r && a)
    return s - i;
  if (r)
    return -1;
  if (a)
    return 1;
  const l = t.indexOf(n), d = t.indexOf(o), c = l >= 0, u = d >= 0;
  return c && u ? l - d : c ? -1 : 1;
}, rF = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colModel", this.pivotMode = !1, this.ready = !1, this.changeEventsDispatching = !1;
  }
  postConstruct() {
    this.pivotMode = this.gos.get("pivotMode"), this.addManagedPropertyListeners(
      [
        "groupDisplayType",
        "treeData",
        "treeDataDisplayType",
        "groupHideOpenParents",
        "rowNumbers",
        "hidePaddedHeaderRows"
      ],
      (e) => this.refreshAll(di(e.source))
    ), this.addManagedPropertyListeners(
      ["defaultColDef", "defaultColGroupDef", "columnTypes", "suppressFieldDotNotation"],
      this.recreateColumnDefs.bind(this)
    ), this.addManagedPropertyListener(
      "pivotMode",
      (e) => this.setPivotMode(this.gos.get("pivotMode"), di(e.source))
    );
  }
  // called from SyncService, when grid has finished initialising
  createColsFromColDefs(e) {
    var w, b, A;
    const { beans: t } = this, {
      valueCache: n,
      colAutosize: o,
      rowGroupColsSvc: s,
      pivotColsSvc: i,
      valueColsSvc: r,
      visibleCols: a,
      eventSvc: l,
      groupHierarchyColSvc: d
    } = t, c = this.colDefs ? JC(t, e) : void 0;
    n == null || n.expire();
    const u = (w = this.colDefCols) == null ? void 0 : w.list, h = (b = this.colDefCols) == null ? void 0 : b.tree, g = _C(t, this.colDefs, !0, h, e);
    ts(t, (A = this.colDefCols) == null ? void 0 : A.tree, g.columnTree);
    const p = g.columnTree, f = g.treeDepth, m = np(p), C = {};
    m.forEach((S) => C[S.getId()] = S), this.colDefCols = { tree: p, treeDepth: f, list: m, map: C }, this.createColumnsForService([d], this.colDefCols), s == null || s.extractCols(e, u), i == null || i.extractCols(e, u), r == null || r.extractCols(e, u), this.ready = !0, this.refreshCols(!0), a.refresh(e), l.dispatchEvent({
      type: "columnEverythingChanged",
      source: e
    }), c && (this.changeEventsDispatching = !0, c(), this.changeEventsDispatching = !1), l.dispatchEvent({
      type: "newColumnsLoaded",
      source: e
    }), e === "gridInitializing" && (o == null || o.applyAutosizeStrategy());
  }
  // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
  // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
  // setPivotMode, applyColumnState,
  // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
  // pivotResultCols.setPivotResultCols
  refreshCols(e) {
    var f;
    if (!this.colDefCols)
      return;
    const t = (f = this.cols) == null ? void 0 : f.tree;
    this.saveColOrder();
    const {
      autoColSvc: n,
      selectionColSvc: o,
      rowNumbersSvc: s,
      quickFilter: i,
      pivotResultCols: r,
      showRowGroupCols: a,
      rowAutoHeight: l,
      visibleCols: d,
      colViewport: c,
      eventSvc: u
    } = this.beans, h = this.selectCols(r, this.colDefCols);
    this.createColumnsForService([n, o, s], h);
    const g = L3(this.gos, this.showingPivotResult);
    (!e || g) && this.restoreColOrder(h), this.positionLockedCols(h), a == null || a.refresh(), i == null || i.refreshCols(), this.setColSpanActive(), l == null || l.setAutoHeightActive(h), d.clear(), c.clear(), !Yn(t, this.cols.tree) && u.dispatchEvent({
      type: "gridColumnsChanged"
    });
  }
  createColumnsForService(e, t) {
    for (const n of e)
      n && (n.createColumns(t, (o) => {
        this.lastOrder = o(this.lastOrder), this.lastPivotOrder = o(this.lastPivotOrder);
      }), n.addColumns(t));
  }
  selectCols(e, t) {
    const n = (e == null ? void 0 : e.getPivotResultCols()) ?? null;
    this.showingPivotResult = n != null;
    const { map: o, list: s, tree: i, treeDepth: r } = n ?? t;
    return this.cols = {
      list: s.slice(),
      map: { ...o },
      tree: i.slice(),
      treeDepth: r
    }, n && (n.list.some((l) => {
      var d;
      return ((d = this.cols) == null ? void 0 : d.map[l.getColId()]) !== void 0;
    }) || (this.lastPivotOrder = null)), this.cols;
  }
  getColsToShow() {
    if (!this.cols)
      return [];
    const { valueColsSvc: e, selectionColSvc: t, gos: n } = this.beans, o = this.isPivotMode() && !this.showingPivotResult, s = t == null ? void 0 : t.isSelectionColumnEnabled(), i = n.get("rowNumbers"), r = e == null ? void 0 : e.columns;
    return this.cols.list.filter((l) => {
      const d = pc(l);
      if (o) {
        const c = r == null ? void 0 : r.includes(l);
        return d || c || s && Gs(l) || i && bs(l);
      } else
        return d || l.isVisible();
    });
  }
  // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
  refreshAll(e) {
    this.ready && (this.refreshCols(!1), this.beans.visibleCols.refresh(e));
  }
  setColsVisible(e, t = !1, n) {
    cn(
      this.beans,
      {
        state: e.map((o) => ({
          colId: typeof o == "string" ? o : o.getColId(),
          hide: !t
        }))
      },
      n
    );
  }
  /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */
  restoreColOrder(e) {
    const t = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
    if (!t)
      return;
    const n = t.filter((u) => e.map[u.getId()] != null);
    if (n.length === 0)
      return;
    if (n.length === e.list.length) {
      e.list = n;
      return;
    }
    const o = (u) => {
      const h = u.getOriginalParent();
      return h ? h.getChildren().length > 1 ? !0 : o(h) : !1;
    };
    if (!n.some((u) => o(u))) {
      const u = new Set(n);
      for (const h of e.list)
        u.has(h) || n.push(h);
      e.list = n;
      return;
    }
    const s = /* @__PURE__ */ new Map();
    for (let u = 0; u < n.length; u++) {
      const h = n[u];
      s.set(h, u);
    }
    const i = e.list.filter((u) => !s.has(u));
    if (i.length === 0) {
      e.list = n;
      return;
    }
    const r = (u, h) => {
      const g = h ? h.getOriginalParent() : u.getOriginalParent();
      if (!g)
        return null;
      let p = null, f = null;
      for (const m of g.getChildren())
        if (!(m === h || m === u)) {
          if (m instanceof Go) {
            const C = s.get(m);
            if (C == null)
              continue;
            (p == null || p < C) && (p = C, f = m);
            continue;
          }
          m.forEachLeafColumn((C) => {
            const w = s.get(C);
            w != null && (p == null || p < w) && (p = w, f = C);
          });
        }
      return f ?? r(u, g);
    }, a = [], l = /* @__PURE__ */ new Map();
    for (const u of i) {
      const h = r(u, null);
      if (h == null) {
        a.push(u);
        continue;
      }
      const g = l.get(h);
      g === void 0 ? l.set(h, u) : Array.isArray(g) ? g.push(u) : l.set(h, [g, u]);
    }
    const d = new Array(e.list.length);
    let c = d.length - 1;
    for (let u = a.length - 1; u >= 0; u--)
      d[c--] = a[u];
    for (let u = n.length - 1; u >= 0; u--) {
      const h = n[u], g = l.get(h);
      if (g)
        if (Array.isArray(g))
          for (let p = g.length - 1; p >= 0; p--) {
            const f = g[p];
            d[c--] = f;
          }
        else
          d[c--] = g;
      d[c--] = h;
    }
    e.list = d;
  }
  positionLockedCols(e) {
    e.list = KC(e.list, this.gos);
  }
  saveColOrder() {
    var e, t;
    this.showingPivotResult ? this.lastPivotOrder = ((e = this.cols) == null ? void 0 : e.list) ?? null : this.lastOrder = ((t = this.cols) == null ? void 0 : t.list) ?? null;
  }
  getColumnDefs() {
    var e, t;
    return this.colDefCols ? (t = this.beans.colDefFactory) == null ? void 0 : t.getColumnDefs(
      this.colDefCols.list,
      this.showingPivotResult,
      this.lastOrder,
      ((e = this.cols) == null ? void 0 : e.list) ?? []
    ) : void 0;
  }
  setColSpanActive() {
    var e;
    this.colSpanActive = !!((e = this.cols) != null && e.list.some((t) => t.getColDef().colSpan != null));
  }
  isPivotMode() {
    return this.pivotMode;
  }
  setPivotMode(e, t) {
    if (e === this.pivotMode || (this.pivotMode = e, !this.ready))
      return;
    this.refreshCols(!1);
    const { visibleCols: n, eventSvc: o } = this.beans;
    n.refresh(t), o.dispatchEvent({
      type: "columnPivotModeChanged"
    });
  }
  // + clientSideRowModel
  isPivotActive() {
    var t;
    const e = (t = this.beans.pivotColsSvc) == null ? void 0 : t.columns;
    return this.pivotMode && !!(e != null && e.length);
  }
  // called when dataTypes change
  recreateColumnDefs(e) {
    var n;
    if (!this.cols)
      return;
    (n = this.beans.autoColSvc) == null || n.updateColumns(e);
    const t = di(e.source);
    this.createColsFromColDefs(t);
  }
  setColumnDefs(e, t) {
    this.colDefs = e, this.createColsFromColDefs(t);
  }
  destroy() {
    var e;
    ts(this.beans, (e = this.colDefCols) == null ? void 0 : e.tree), super.destroy();
  }
  getColTree() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.tree) ?? [];
  }
  // + columnSelectPanel
  getColDefColTree() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.tree) ?? [];
  }
  // + clientSideRowController -> sorting, building quick filter text
  // + headerRenderer -> sorting (clearing icon)
  getColDefCols() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.list) ?? null;
  }
  // + moveColumnController
  getCols() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.list) ?? [];
  }
  forAllCols(e) {
    var i, r, a, l, d;
    const { pivotResultCols: t, autoColSvc: n, selectionColSvc: o, groupHierarchyColSvc: s } = this.beans;
    Nr((i = this.colDefCols) == null ? void 0 : i.list, e), Nr((r = n == null ? void 0 : n.columns) == null ? void 0 : r.list, e), Nr((a = o == null ? void 0 : o.columns) == null ? void 0 : a.list, e), Nr((l = s == null ? void 0 : s.columns) == null ? void 0 : l.list, e), Nr((d = t == null ? void 0 : t.getPivotResultCols()) == null ? void 0 : d.list, e);
  }
  getColsForKeys(e) {
    return e ? e.map((t) => this.getCol(t)).filter((t) => t != null) : [];
  }
  getColDefCol(e) {
    var t;
    return (t = this.colDefCols) != null && t.list ? this.getColFromCollection(e, this.colDefCols) : null;
  }
  getCol(e) {
    return e == null ? null : this.getColFromCollection(e, this.cols);
  }
  /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */
  getColById(e) {
    var t;
    return ((t = this.cols) == null ? void 0 : t.map[e]) ?? null;
  }
  getColFromCollection(e, t) {
    if (t == null)
      return null;
    const { map: n, list: o } = t;
    if (typeof e == "string" && n[e])
      return n[e];
    for (let a = 0; a < o.length; a++)
      if (ka(o[a], e))
        return o[a];
    const { autoColSvc: s, selectionColSvc: i, groupHierarchyColSvc: r } = this.beans;
    return (s == null ? void 0 : s.getColumn(e)) ?? (i == null ? void 0 : i.getColumn(e)) ?? (r == null ? void 0 : r.getColumn(e)) ?? null;
  }
}, ip = class extends U {
  constructor() {
    super(...arguments), this.dispatchColumnChangedEvent = YC, this.columns = [], this.columnIndexMap = {}, this.updateIndexMap = () => {
      this.columnIndexMap = {}, this.columns.forEach((e, t) => this.columnIndexMap[e.getId()] = t);
    };
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.aggFuncSvc = e.aggFuncSvc, this.visibleCols = e.visibleCols, this.groupHierarchCols = e.groupHierarchyColSvc;
  }
  sortColumns(e) {
    const { groupHierarchCols: t } = this;
    this.columns.sort((n, o) => (t == null ? void 0 : t.compareVirtualColumns(n, o)) ?? e(n, o)), this.updateIndexMap();
  }
  setColumns(e, t) {
    this.setColList(e, this.columns, this.eventName, !0, !0, this.columnProcessors.set, t);
  }
  addColumns(e, t) {
    this.updateColList(e, this.columns, !0, !0, this.columnProcessors.add, this.eventName, t);
  }
  removeColumns(e, t) {
    this.updateColList(e, this.columns, !1, !0, this.columnProcessors.remove, this.eventName, t);
  }
  getColumnIndex(e) {
    return this.columnIndexMap[e];
  }
  setColList(e = [], t, n, o, s, i, r) {
    const a = this.colModel.getCols();
    if (!a || a.length === 0)
      return;
    const l = /* @__PURE__ */ new Map();
    t.forEach((c, u) => l.set(c, u)), t.length = 0, ue(e) && e.forEach((c) => {
      const u = this.colModel.getColDefCol(c);
      u && t.push(u);
    }), t.forEach((c, u) => {
      const h = l.get(c);
      if (h === void 0) {
        l.set(c, 0);
        return;
      }
      o && h !== u || l.delete(c);
    }), this.updateIndexMap();
    const d = this.colModel.getColDefCols();
    d == null || d.forEach((c) => {
      const u = t.indexOf(c) >= 0;
      i(c, u, r);
    }), s && this.colModel.refreshCols(!1), this.visibleCols.refresh(r), this.dispatchColumnChangedEvent(this.eventSvc, n, [...l.keys()], r);
  }
  updateColList(e = [], t, n, o, s, i, r) {
    if (!e || e.length === 0)
      return;
    let a = !1;
    const l = /* @__PURE__ */ new Set();
    if (e.forEach((c) => {
      if (!c)
        return;
      const u = this.colModel.getColDefCol(c);
      if (u) {
        if (l.add(u), n) {
          if (t.indexOf(u) >= 0)
            return;
          t.push(u);
        } else {
          const h = t.indexOf(u);
          if (h < 0)
            return;
          for (let g = h + 1; g < t.length; g++)
            l.add(t[g]);
          $t(t, u);
        }
        s(u, n, r), a = !0;
      }
    }), !a)
      return;
    this.updateIndexMap(), o && this.colModel.refreshCols(!1), this.visibleCols.refresh(r);
    const d = Array.from(l);
    this.eventSvc.dispatchEvent({
      type: i,
      columns: d,
      column: d.length === 1 ? d[0] : null,
      source: r
    });
  }
  extractCols(e, t = []) {
    const n = this.columns, o = [], s = [], { setFlagFunc: i, getIndexFunc: r, getInitialIndexFunc: a, getValueFunc: l, getInitialValueFunc: d } = this.columnExtractors, c = this.colModel.getColDefCols();
    c == null || c.forEach((g) => {
      const p = !t.includes(g), f = g.getColDef(), m = l(f), C = d(f), w = r(f), b = a(f);
      let A;
      m !== void 0 ? A = m : w !== void 0 ? w === null ? A = !1 : A = w >= 0 : p ? C !== void 0 ? A = C : b !== void 0 ? A = b != null && b >= 0 : A = !1 : A = n.indexOf(g) >= 0, A && ((p ? w != null || b != null : w != null) ? o.push(g) : s.push(g));
    });
    const u = (g) => {
      const p = g.getColDef();
      return r(p) ?? a(p);
    };
    o.sort((g, p) => u(g) - u(p));
    const h = [...o];
    return n.forEach((g) => {
      var p;
      s.indexOf(g) >= 0 && ((p = this.groupHierarchCols) == null || p.expandColumnInto(h, g));
    }), s.forEach((g) => {
      h.indexOf(g) < 0 && h.push(g);
    }), n.forEach((g) => {
      h.indexOf(g) < 0 && i(g, !1, e);
    }), h.forEach((g) => {
      n.indexOf(g) < 0 && i(g, !0, e);
    }), this.columns = h, this.updateIndexMap(), this.columns;
  }
  restoreColumnOrder(e, t) {
    const n = this.columns, o = this.colModel.getColDefCols();
    if (!n.length || !o)
      return e;
    const s = Object.keys(t), i = new Set(s), r = new Set(s), a = new Set(
      n.map((b) => {
        const A = b.getColId();
        return r.delete(A), A;
      }).concat(s)
    ), l = [], d = {};
    let c = 0;
    for (let b = 0; b < o.length; b++) {
      const A = o[b].getColId();
      a.has(A) && (l.push(A), d[A] = c++);
    }
    let u = 1e3, h = !1, g = 0;
    const p = this.columnOrdering.enableProp, f = this.columnOrdering.initialEnableProp, m = this.columnOrdering.indexProp, C = this.columnOrdering.initialIndexProp, w = (b) => {
      const A = d[b];
      for (let S = g; S < A; S++) {
        const F = l[S];
        r.has(F) && (t[F][m] = u++, r.delete(F));
      }
      g = A;
    };
    return n.forEach((b) => {
      const A = b.getColId();
      if (i.has(A))
        w(A), t[A][m] = u++;
      else {
        const S = b.getColDef();
        (S[m] === null || S[m] === void 0 && S[C] == null) && (h || (S[p] || S[p] === void 0 && S[f] ? w(A) : (r.forEach((M) => {
          t[M][m] = u + d[M];
        }), u += l.length, h = !0)), e[A] || (e[A] = { colId: A }), e[A][m] = u++);
      }
    }), e;
  }
}, ew = class {
  constructor() {
    this.existingIds = {};
  }
  getInstanceIdForKey(e) {
    const t = this.existingIds[e];
    let n;
    return typeof t != "number" ? n = 0 : n = t + 1, this.existingIds[e] = n, n;
  }
};
function Ja(e, t, n) {
  return n && e.addDestroyFunc(() => t.destroyBean(n)), n ?? e;
}
var X = null;
function gm(e) {
  return typeof (e == null ? void 0 : e.getGui) == "function";
}
var tw = class {
  constructor(e) {
    this.cssClassStates = {}, this.getGui = e;
  }
  toggleCss(e, t) {
    var o;
    if (!e)
      return;
    if (e.indexOf(" ") >= 0) {
      const s = (e || "").split(" ");
      if (s.length > 1) {
        s.forEach((i) => this.toggleCss(i, t));
        return;
      }
    }
    this.cssClassStates[e] !== t && e.length && ((o = this.getGui()) == null || o.classList.toggle(e, t), this.cssClassStates[e] = t);
  }
}, aF = 0, Xa = class extends Oo {
  constructor(e, t) {
    super(), this.suppressDataRefValidation = !1, this.displayed = !0, this.visible = !0, this.compId = aF++, this.cssManager = new tw(() => this.eGui), this.componentSelectors = new Map((t ?? []).map((n) => [n.selector, n])), e && this.setTemplate(e);
  }
  preConstruct() {
    var t, n, o;
    this.wireTemplate(this.getGui());
    const e = "component-" + ((n = (t = Object.getPrototypeOf(this)) == null ? void 0 : t.constructor) == null ? void 0 : n.name);
    (o = this.css) == null || o.forEach((s) => this.beans.environment.addGlobalCSS(s, e));
  }
  wireTemplate(e, t) {
    e && this.gos && (this.applyElementsToComponent(e), this.createChildComponentsFromTags(e, t));
  }
  getCompId() {
    return this.compId;
  }
  getDataRefAttribute(e) {
    return e.getAttribute ? e.getAttribute(vC) : null;
  }
  applyElementsToComponent(e, t, n, o = null) {
    if (t === void 0 && (t = this.getDataRefAttribute(e)), t) {
      const s = this[t];
      if (s === X)
        this[t] = o ?? e;
      else {
        const i = n && n[t];
        if (!this.suppressDataRefValidation && !i)
          throw new Error(`data-ref: ${t} on ${this.constructor.name} with ${s}`);
      }
    }
  }
  // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
  createChildComponentsFromTags(e, t) {
    const n = [];
    for (const o of e.childNodes ?? [])
      n.push(o);
    n.forEach((o) => {
      if (!(o instanceof HTMLElement))
        return;
      const s = this.createComponentFromElement(
        o,
        (i) => {
          const r = i.getGui();
          if (r)
            for (const a of o.attributes ?? [])
              r.setAttribute(a.name, a.value);
        },
        t
      );
      if (s) {
        if (s.addItems && o.children.length) {
          this.createChildComponentsFromTags(o, t);
          const i = Array.prototype.slice.call(o.children);
          s.addItems(i);
        }
        this.swapComponentForNode(s, e, o);
      } else o.childNodes && this.createChildComponentsFromTags(o, t);
    });
  }
  createComponentFromElement(e, t, n) {
    const o = e.nodeName, s = this.getDataRefAttribute(e), i = o.indexOf("AG-") === 0, r = i ? this.componentSelectors.get(o) : null;
    let a = null;
    if (r) {
      const l = n && s ? n[s] : void 0;
      a = new r.component(l), a.setParentComponent(
        this
      ), this.createBean(a, null, t);
    } else if (i)
      throw new Error(`selector: ${o}`);
    return this.applyElementsToComponent(e, s, n, a), a;
  }
  swapComponentForNode(e, t, n) {
    const o = e.getGui();
    t.replaceChild(o, n), t.insertBefore(document.createComment(n.nodeName), o), this.addDestroyFunc(this.destroyBean.bind(this, e));
  }
  activateTabIndex(e) {
    const t = this.gos.get("tabIndex");
    e || (e = []), e.length || e.push(this.getGui()), e.forEach((n) => n.setAttribute("tabindex", t.toString()));
  }
  setTemplate(e, t, n) {
    let o;
    typeof e == "string" || e == null ? o = Zg(e) : o = Qa(e), this.setTemplateFromElement(o, t, n);
  }
  setTemplateFromElement(e, t, n, o = !1) {
    if (this.eGui = e, this.suppressDataRefValidation = o, t)
      for (let s = 0; s < t.length; s++) {
        const i = t[s];
        this.componentSelectors.set(i.selector, i);
      }
    this.wireTemplate(e, n);
  }
  getGui() {
    return this.eGui;
  }
  getFocusableElement() {
    return this.eGui;
  }
  getAriaElement() {
    return this.getFocusableElement();
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getParentComponent() {
    return this.parentComponent;
  }
  // this method is for older code, that wants to provide the gui element,
  // it is not intended for this to be in ag-Stack
  setGui(e) {
    this.eGui = e;
  }
  queryForHtmlElement(e) {
    return this.eGui.querySelector(e);
  }
  getContainerAndElement(e, t) {
    let n = t;
    return e == null ? null : (n || (n = this.eGui), uc(e) ? {
      element: e,
      parent: n
    } : {
      element: e.getGui(),
      parent: n
    });
  }
  prependChild(e, t) {
    const { element: n, parent: o } = this.getContainerAndElement(e, t) || {};
    !n || !o || o.insertAdjacentElement("afterbegin", n);
  }
  appendChild(e, t) {
    const { element: n, parent: o } = this.getContainerAndElement(e, t) || {};
    !n || !o || o.appendChild(n);
  }
  isDisplayed() {
    return this.displayed;
  }
  setVisible(e, t = {}) {
    if (e !== this.visible) {
      this.visible = e;
      const { skipAriaHidden: n } = t;
      uC(this.eGui, e, { skipAriaHidden: n });
    }
  }
  setDisplayed(e, t = {}) {
    if (e !== this.displayed) {
      this.displayed = e;
      const { skipAriaHidden: n } = t;
      He(this.eGui, e, { skipAriaHidden: n });
      const o = {
        type: "displayChanged",
        visible: this.displayed
      };
      this.dispatchLocalEvent(o);
    }
  }
  destroy() {
    this.parentComponent && (this.parentComponent = void 0), super.destroy();
  }
  addGuiEventListener(e, t, n) {
    this.eGui.addEventListener(e, t, n), this.addDestroyFunc(() => this.eGui.removeEventListener(e, t));
  }
  addCss(e) {
    this.cssManager.toggleCss(e, !0);
  }
  removeCss(e) {
    this.cssManager.toggleCss(e, !1);
  }
  toggleCss(e, t) {
    this.cssManager.toggleCss(e, t);
  }
  registerCSS(e) {
    this.css || (this.css = []), this.css.push(e);
  }
}, Te = class extends Xa {
};
function nw(e) {
  return typeof e == "object" && !!e.component;
}
function lF(e) {
  return typeof e.then == "function";
}
function dF(e, t) {
  return new tt((n) => {
    n(window.setInterval(e, t));
  });
}
var tt = class Jr {
  constructor(t) {
    this.status = 0, this.resolution = null, this.waiters = [], t(
      (n) => this.onDone(n),
      (n) => this.onReject(n)
    );
  }
  static all(t) {
    return t.length ? new Jr((n) => {
      let o = t.length;
      const s = new Array(o);
      t.forEach((i, r) => {
        i.then((a) => {
          s[r] = a, o--, o === 0 && n(s);
        });
      });
    }) : Jr.resolve();
  }
  static resolve(t = null) {
    return new Jr((n) => n(t));
  }
  then(t) {
    return new Jr((n) => {
      this.status === 1 ? n(t(this.resolution)) : this.waiters.push((o) => n(t(o)));
    });
  }
  onDone(t) {
    this.status = 1, this.resolution = t, this.waiters.forEach((n) => n(t));
  }
  onReject(t) {
  }
};
function cF(e) {
  return e ? e.prototype && "getGui" in e.prototype : !1;
}
function ow(e, t, n, o) {
  const { name: s } = n;
  let i, r, a, l, d, c;
  if (t) {
    const u = t, h = u[s + "Selector"], g = h ? h(o) : null, p = (f) => {
      typeof f == "string" ? i = f : f != null && f !== !0 && (e.isFrameworkComponent(f) ? a = f : r = f);
    };
    g ? (p(g.component), l = g.params, d = g.popup, c = g.popupPosition) : p(u[s]);
  }
  return { compName: i, jsComp: r, fwComp: a, paramsFromSelector: l, popupFromSelector: d, popupPositionFromSelector: c };
}
var uF = class extends U {
  constructor() {
    super(...arguments), this.beanName = "userCompFactory";
  }
  wireBeans(e) {
    this.agCompUtils = e.agCompUtils, this.registry = e.registry, this.frameworkCompWrapper = e.frameworkCompWrapper, this.gridOptions = e.gridOptions;
  }
  getCompDetailsFromGridOptions(e, t, n, o = !1) {
    return this.getCompDetails(this.gridOptions, e, t, n, o);
  }
  getCompDetails(e, t, n, o, s = !1) {
    var b;
    const { name: i, cellRenderer: r } = t;
    let { compName: a, jsComp: l, fwComp: d, paramsFromSelector: c, popupFromSelector: u, popupPositionFromSelector: h } = ow(this.beans.frameworkOverrides, e, t, o), g, p;
    const f = (A) => {
      const S = this.registry.getUserComponent(i, A);
      S && (l = S.componentFromFramework ? void 0 : S.component, d = S.componentFromFramework ? S.component : void 0, g = S.params, p = S.processParams);
    };
    if (a != null && f(a), l == null && d == null && n != null && f(n), l && r && !cF(l) && (l = (b = this.agCompUtils) == null ? void 0 : b.adaptFunction(t, l)), !l && !d) {
      const { validation: A } = this.beans;
      s && (a !== n || !n) ? a ? A != null && A.isProvidedUserComp(a) || $e(50, { compName: a }) : n ? A || $e(260, {
        ...this.gos.getModuleErrorParams(),
        propName: i,
        compName: n
      }) : $e(216, { name: i }) : n && !A && $e(146, { comp: n });
      return;
    }
    const m = this.mergeParams(
      e,
      t,
      o,
      c,
      g,
      p
    ), C = l == null, w = l ?? d;
    return {
      componentFromFramework: C,
      componentClass: w,
      params: m,
      type: t,
      popupFromSelector: u,
      popupPositionFromSelector: h,
      newAgStackInstance: () => this.newAgStackInstance(w, C, m, t)
    };
  }
  newAgStackInstance(e, t, n, o) {
    var a;
    const s = !t;
    let i;
    s ? i = new e() : i = this.frameworkCompWrapper.wrap(
      e,
      o.mandatoryMethods,
      o.optionalMethods,
      o
    ), this.createBean(i);
    const r = (a = i.init) == null ? void 0 : a.call(i, n);
    return r == null ? tt.resolve(i) : r.then(() => i);
  }
  /**
   * merges params with application provided params
   * used by Floating Filter
   */
  mergeParams(e, t, n, o = null, s, i) {
    const r = { ...n, ...s }, a = e, l = a && a[t.name + "Params"];
    if (typeof l == "function") {
      const d = l(n);
      on(r, d);
    } else typeof l == "object" && on(r, l);
    return on(r, o), i ? i(r) : r;
  }
}, hF = {
  name: "dateComponent",
  mandatoryMethods: ["getDate", "setDate"],
  optionalMethods: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "refresh"]
}, gF = {
  name: "dragAndDropImageComponent",
  mandatoryMethods: ["setIcon", "setLabel"]
}, pF = { name: "headerComponent", optionalMethods: ["refresh"] }, fF = { name: "innerHeaderComponent" }, mF = { name: "innerHeaderGroupComponent" }, vF = { name: "headerGroupComponent" }, CF = {
  name: "innerRenderer",
  cellRenderer: !0,
  optionalMethods: ["afterGuiAttached"]
}, wF = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, yF = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"]
}, bF = { name: "loadingCellRenderer", cellRenderer: !0 }, SF = {
  name: "cellEditor",
  mandatoryMethods: ["getValue"],
  optionalMethods: [
    "isPopup",
    "isCancelBeforeStart",
    "isCancelAfterEnd",
    "getPopupPosition",
    "focusIn",
    "focusOut",
    "afterGuiAttached",
    "refresh"
  ]
}, xF = { name: "loadingOverlayComponent", optionalMethods: ["refresh"] }, RF = { name: "noRowsOverlayComponent", optionalMethods: ["refresh"] }, EF = { name: "tooltipComponent" }, rp = {
  name: "filter",
  mandatoryMethods: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
  optionalMethods: [
    "afterGuiAttached",
    "afterGuiDetached",
    "onNewRowsLoaded",
    "getModelAsString",
    "onFloatingFilterChanged",
    "onAnyFilterChanged",
    "refresh"
  ]
}, AF = {
  name: "floatingFilterComponent",
  mandatoryMethods: ["onParentModelChanged"],
  optionalMethods: ["afterGuiAttached", "refresh"]
}, FF = {
  name: "fullWidthCellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, MF = { name: "loadingCellRenderer", cellRenderer: !0 }, IF = {
  name: "groupRowRenderer",
  optionalMethods: ["afterGuiAttached"],
  cellRenderer: !0
}, PF = { name: "detailCellRenderer", optionalMethods: ["refresh"], cellRenderer: !0 };
function DF(e, t) {
  return e.getCompDetailsFromGridOptions(gF, "agDragAndDropImage", t, !0);
}
function Cl(e, t, n) {
  return e.getCompDetails(t, CF, void 0, n);
}
function TF(e, t, n) {
  return e.getCompDetails(t, pF, "agColumnHeader", n);
}
function kF(e, t, n) {
  return e.getCompDetails(t, fF, void 0, n);
}
function LF(e, t) {
  const n = t.columnGroup.getColGroupDef();
  return e.getCompDetails(n, vF, "agColumnGroupHeader", t);
}
function BF(e, t, n) {
  return e.getCompDetails(t, mF, void 0, n);
}
function OF(e, t) {
  return e.getCompDetailsFromGridOptions(FF, void 0, t, !0);
}
function GF(e, t) {
  return e.getCompDetailsFromGridOptions(MF, "agLoadingCellRenderer", t, !0);
}
function HF(e, t) {
  return e.getCompDetailsFromGridOptions(IF, "agGroupRowRenderer", t, !0);
}
function VF(e, t) {
  return e.getCompDetailsFromGridOptions(PF, "agDetailCellRenderer", t, !0);
}
function br(e, t, n) {
  return e.getCompDetails(t, wF, void 0, n);
}
function sw(e, t, n) {
  return e.getCompDetails(
    t,
    yF,
    void 0,
    n
  );
}
function pm(e, t, n) {
  return e.getCompDetails(t, bF, "agSkeletonCellRenderer", n, !0);
}
function iw(e, t, n) {
  return e.getCompDetails(t, SF, "agCellEditor", n, !0);
}
function _F(e, t, n, o) {
  const s = t.filter;
  return nw(s) && (t = {
    filter: s.component,
    filterParams: t.filterParams
  }), e.getCompDetails(t, rp, o, n, !0);
}
function NF(e, t, n) {
  return e.getCompDetails(t, hF, "agDateInput", n, !0);
}
function $F(e, t) {
  return e.getCompDetailsFromGridOptions(xF, "agLoadingOverlay", t, !0);
}
function zF(e, t) {
  return e.getCompDetailsFromGridOptions(RF, "agNoRowsOverlay", t, !0);
}
function WF(e, t) {
  return e.getCompDetails(t.colDef, EF, "agTooltipComponent", t, !0);
}
function UF(e, t, n, o) {
  return e.getCompDetails(t, AF, o, n);
}
function rw(e, t) {
  return ow(e, t, rp);
}
function au(e, t, n) {
  return e.mergeParams(t, rp, n);
}
function Sr(e) {
  const t = e;
  return t != null && t.getFrameworkComponentInstance != null ? t.getFrameworkComponentInstance() : e;
}
function KF(e) {
  return typeof e == "object" && !!e.getComp;
}
var O = {
  BACKSPACE: "Backspace",
  TAB: "Tab",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " ",
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown",
  DELETE: "Delete",
  F2: "F2",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",
  PAGE_HOME: "Home",
  PAGE_END: "End",
  // these should be used with `event.code` instead of `event.key`
  // as `event.key` changes when non-latin keyboards are used
  A: "KeyA",
  C: "KeyC",
  D: "KeyD",
  V: "KeyV",
  X: "KeyX",
  Y: "KeyY",
  Z: "KeyZ"
}, fc = class extends Xa {
  isPopup() {
    return !0;
  }
  setParentComponent(e) {
    e.addCss("ag-has-popup"), super.setParentComponent(e);
  }
  destroy() {
    const e = this.parentComponent;
    e && e.isAlive() && e.getGui().classList.remove("ag-has-popup"), super.destroy();
  }
}, lu, du, cu, uu, bh, Sh, hu;
function os() {
  return lu === void 0 && (lu = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), lu;
}
function ap() {
  return du === void 0 && (du = /(firefox)/i.test(navigator.userAgent)), du;
}
function aw() {
  return cu === void 0 && (cu = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), cu;
}
function Ss() {
  return uu === void 0 && (uu = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), uu;
}
function xh(e) {
  if (!e)
    return null;
  const t = e.tabIndex, n = e.getAttribute("tabIndex");
  return t === -1 && (n === null || n === "" && !ap()) ? null : t.toString();
}
function ZF() {
  if (hu !== void 0)
    return hu;
  if (!document.body)
    return -1;
  let e = 1e6;
  const t = ap() ? 6e6 : 1e9, n = document.createElement("div");
  for (document.body.appendChild(n); ; ) {
    const o = e * 2;
    if (n.style.height = o + "px", o > t || n.clientHeight !== o)
      break;
    e = o;
  }
  return document.body.removeChild(n), hu = e, e;
}
function qF() {
  return Sh == null && lw(), Sh;
}
function lw() {
  const e = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", e.appendChild(t);
  let n = t.offsetWidth - t.clientWidth;
  n === 0 && t.clientWidth === 0 && (n = null), t.parentNode && t.parentNode.removeChild(t), n != null && (Sh = n, bh = n === 0);
}
function dw() {
  return bh == null && lw(), bh;
}
var lp = "T", jF = new RegExp(`[${lp} ]`), YF = new RegExp(`^\\d{4}-\\d{2}-\\d{2}(${lp}\\d{2}:\\d{2}:\\d{2}\\D?)?`);
function So(e, t) {
  return e.toString().padStart(t, "0");
}
function un(e, t = !0, n = lp) {
  if (!e)
    return null;
  let o = [e.getFullYear(), e.getMonth() + 1, e.getDate()].map((s) => So(s, 2)).join("-");
  return t && (o += n + [e.getHours(), e.getMinutes(), e.getSeconds()].map((s) => So(s, 2)).join(":")), o;
}
function zi(e, t = !0) {
  return e ? t ? [
    String(e.getFullYear()),
    String(e.getMonth() + 1),
    So(e.getDate(), 2),
    So(e.getHours(), 2),
    `:${So(e.getMinutes(), 2)}`,
    `:${So(e.getSeconds(), 2)}`
  ] : [e.getFullYear(), e.getMonth() + 1, So(e.getDate(), 2)].map(String) : null;
}
var gu = (e) => {
  if (e > 3 && e < 21)
    return "th";
  switch (e % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
}, Ad = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], pu = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
function Rh(e, t) {
  if (t == null)
    return un(e, !1);
  const n = So(e.getFullYear(), 4), o = {
    YYYY: () => n.slice(n.length - 4, n.length),
    YY: () => n.slice(n.length - 2, n.length),
    Y: () => `${e.getFullYear()}`,
    MMMM: () => Ad[e.getMonth()],
    MMM: () => Ad[e.getMonth()].slice(0, 3),
    MM: () => So(e.getMonth() + 1, 2),
    Mo: () => `${e.getMonth() + 1}${gu(e.getMonth() + 1)}`,
    M: () => `${e.getMonth() + 1}`,
    Do: () => `${e.getDate()}${gu(e.getDate())}`,
    DD: () => So(e.getDate(), 2),
    D: () => `${e.getDate()}`,
    dddd: () => pu[e.getDay()],
    ddd: () => pu[e.getDay()].slice(0, 3),
    dd: () => pu[e.getDay()].slice(0, 2),
    do: () => `${e.getDay()}${gu(e.getDay())}`,
    d: () => `${e.getDay()}`
  }, s = new RegExp(Object.keys(o).join("|"), "g");
  return t.replace(s, (i) => i in o ? o[i]() : i);
}
function Yl(e, t = !1) {
  return !!Qt(e, t);
}
function QF(e) {
  return Yl(e, !0);
}
function Qt(e, t = !1, n) {
  if (!e || !n && !YF.test(e))
    return null;
  const [o, s] = e.split(jF);
  if (!o)
    return null;
  const i = o.split("-").map((g) => parseInt(g, 10));
  if (i.filter((g) => !isNaN(g)).length !== 3)
    return null;
  const [r, a, l] = i, d = new Date(r, a - 1, l);
  if (d.getFullYear() !== r || d.getMonth() !== a - 1 || d.getDate() !== l || !s && t)
    return null;
  if (!s || s === "00:00:00")
    return d;
  const [c, u, h] = s.split(":").map((g) => parseInt(g, 10));
  if (c >= 0 && c < 24)
    d.setHours(c);
  else if (t)
    return null;
  if (u >= 0 && u < 60)
    d.setMinutes(u);
  else if (t)
    return null;
  if (h >= 0 && h < 60)
    d.setSeconds(h);
  else if (t)
    return null;
  return d;
}
function La(e) {
  const { inputValue: t, allSuggestions: n, hideIrrelevant: o, filterByPercentageOfBestMatch: s } = e;
  let i = (n ?? []).map(
    (l, d) => ({
      value: l,
      relevance: JF(t, l),
      idx: d
    })
  );
  if (i.sort((l, d) => l.relevance - d.relevance), o && (i = i.filter(
    (l) => l.relevance < Math.max(l.value.length, t.length)
  )), i.length > 0 && s && s > 0) {
    const d = i[0].relevance * s;
    i = i.filter((c) => d - c.relevance < 0);
  }
  const r = [], a = [];
  for (const l of i)
    r.push(l.value), a.push(l.idx);
  return { values: r, indices: a };
}
function JF(e, t) {
  e.length < t.length && ([e, t] = [t, e]);
  let n = [], o = [];
  const s = e.length, i = t.length;
  for (let a = 0; a <= i; a++)
    n[a] = a;
  let r = 0;
  for (let a = 1; a <= s; a++) {
    o[0] = a;
    for (let l = 1; l <= i; l++) {
      const d = e[a - 1], c = t[l - 1];
      if (d.toLocaleLowerCase() === c.toLocaleLowerCase())
        ++r, d === c && ++r, a > 1 && l > 1 && e[a - 2].toLocaleLowerCase() === t[l - 2].toLocaleLowerCase() && (++r, e[a - 2] === t[l - 2] && ++r), a < s / 2 - 10 && ++r, o[l] = n[l - 1];
      else {
        const u = o[l - 1], h = n[l], g = n[l - 1];
        o[l] = 1 + Math.min(u, h, g);
      }
    }
    [n, o] = [o, n];
  }
  return n[i] / (r + 1);
}
function dp(e) {
  var n;
  return e.altKey || e.ctrlKey || e.metaKey ? !1 : ((n = e.key) == null ? void 0 : n.length) === 1;
}
var Eh = !1, Fd = 0;
function XF(e) {
  Fd > 0 || (e.addEventListener("keydown", Md), e.addEventListener("mousedown", Md));
}
function eM(e) {
  Fd > 0 || (e.removeEventListener("keydown", Md), e.removeEventListener("mousedown", Md));
}
function Md(e) {
  const t = Eh, n = e.type === "keydown";
  n && (e.ctrlKey || e.metaKey || e.altKey) || t !== n && (Eh = n);
}
function tM(e) {
  const t = Bt(e);
  return XF(t), Fd++, () => {
    Fd--, eM(t);
  };
}
function mc() {
  return Eh;
}
function Ko(e, t, n = !1) {
  const o = d3;
  let s = cC;
  t && (s += ", " + t), n && (s += ', [tabindex="-1"]');
  const i = Array.prototype.slice.apply(e.querySelectorAll(o)).filter((l) => vn(l)), r = Array.prototype.slice.apply(e.querySelectorAll(s));
  return r.length ? ((l, d) => l.filter((c) => d.indexOf(c) === -1))(i, r) : i;
}
function pn(e, t = !1, n = !1, o = !1) {
  const s = Ko(
    e,
    o ? ".ag-tab-guard" : null,
    n
  ), i = t ? Je(s) : s[0];
  return i ? (i.focus({ preventScroll: !0 }), !0) : !1;
}
function sn(e, t, n, o) {
  const s = Ko(t, n ? ':not([tabindex="-1"])' : null), i = je(e);
  let r;
  n ? r = s.findIndex((l) => l.contains(i)) : r = s.indexOf(i);
  const a = r + (o ? -1 : 1);
  return a < 0 || a >= s.length ? null : s[a];
}
function cp(e, t = 5) {
  let n = 0;
  for (; e && xh(e) === null && ++n <= t; )
    e = e.parentElement;
  return xh(e) === null ? null : e;
}
var nM = (
  /*css*/
  ".ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}"
), oM = class extends Xa {
  constructor(e, t, n) {
    super(t, n), this.labelSeparator = "", this.labelAlignment = "left", this.disabled = !1, this.label = "", this.config = e || {}, this.registerCSS(nM);
  }
  postConstruct() {
    this.addCss("ag-labeled"), this.eLabel.classList.add("ag-label");
    const { labelSeparator: e, label: t, labelWidth: n, labelAlignment: o, disabled: s } = this.config;
    s != null && this.setDisabled(s), e != null && this.setLabelSeparator(e), t != null && this.setLabel(t), n != null && this.setLabelWidth(n), this.setLabelAlignment(o || this.labelAlignment), this.refreshLabel();
  }
  refreshLabel() {
    const { label: e, eLabel: t } = this;
    ht(t), typeof e == "string" ? t.innerText = e + this.labelSeparator : e && t.appendChild(e), e === "" ? (He(t, !1), hn(t, "presentation")) : (He(t, !0), hn(t, null));
  }
  setLabelSeparator(e) {
    return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
  }
  getLabelId() {
    const e = this.eLabel;
    return e.id = e.id || `ag-${this.getCompId()}-label`, e.id;
  }
  getLabel() {
    return this.label;
  }
  setLabel(e) {
    return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
  }
  setLabelAlignment(e) {
    const n = this.getGui().classList;
    return n.toggle("ag-label-align-left", e === "left"), n.toggle("ag-label-align-right", e === "right"), n.toggle("ag-label-align-top", e === "top"), this;
  }
  setLabelEllipsis(e) {
    return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
  }
  setLabelWidth(e) {
    return this.label == null ? this : (bd(this.eLabel, e), this);
  }
  setDisabled(e) {
    e = !!e;
    const t = this.getGui();
    return vi(t, e), t.classList.toggle("ag-disabled", e), this.disabled = e, this;
  }
  isDisabled() {
    return !!this.disabled;
  }
}, cw = class extends oM {
  constructor(e, t, n, o) {
    super(e, t, n), this.className = o;
  }
  postConstruct() {
    super.postConstruct();
    const { width: e, value: t, onValueChange: n } = this.config;
    e != null && this.setWidth(e), t != null && this.setValue(t), n != null && this.onValueChange(n), this.className && this.addCss(this.className), this.refreshAriaLabelledBy();
  }
  setLabel(e) {
    return super.setLabel(e), this.refreshAriaLabelledBy(), this;
  }
  refreshAriaLabelledBy() {
    const e = this.getAriaElement(), t = this.getLabelId(), n = this.getLabel();
    n == null || n == "" || QA(e) !== null ? Ms(e, "") : Ms(e, t ?? "");
  }
  setAriaLabel(e) {
    return yt(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
  }
  onValueChange(e) {
    return this.addManagedListeners(this, { fieldValueChanged: () => e(this.getValue()) }), this;
  }
  getWidth() {
    return this.getGui().clientWidth;
  }
  setWidth(e) {
    return Ro(this.getGui(), e), this;
  }
  getPreviousValue() {
    return this.previousValue;
  }
  getValue() {
    return this.value;
  }
  setValue(e, t) {
    return this.value === e ? this : (this.previousValue = this.value, this.value = e, t || this.dispatchLocalEvent({ type: "fieldValueChanged" }), this);
  }
};
function sM(e) {
  return {
    tag: "div",
    role: "presentation",
    children: [
      { tag: "div", ref: "eLabel", cls: "ag-input-field-label" },
      {
        tag: "div",
        ref: "eWrapper",
        cls: "ag-wrapper ag-input-wrapper",
        role: "presentation",
        children: [{ tag: e, ref: "eInput", cls: "ag-input-field-input" }]
      }
    ]
  };
}
var ti = class extends cw {
  constructor(e, t, n = "text", o = "input") {
    super(e, (e == null ? void 0 : e.template) ?? sM(o), [], t), this.inputType = n, this.displayFieldTag = o, this.eLabel = X, this.eWrapper = X, this.eInput = X;
  }
  postConstruct() {
    super.postConstruct(), this.setInputType(this.inputType);
    const { eLabel: e, eWrapper: t, eInput: n, className: o } = this;
    e.classList.add(`${o}-label`), t.classList.add(`${o}-input-wrapper`), n.classList.add(`${o}-input`), this.addCss("ag-input-field"), n.id = n.id || `ag-${this.getCompId()}-input`;
    const { inputName: s, inputWidth: i } = this.config;
    s != null && this.setInputName(s), i != null && this.setInputWidth(i), this.addInputListeners(), this.activateTabIndex([n]);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, {
      input: (e) => this.setValue(e.target.value)
    });
  }
  setInputType(e) {
    this.displayFieldTag === "input" && (this.inputType = e, Mn(this.eInput, "type", e));
  }
  getInputElement() {
    return this.eInput;
  }
  setInputWidth(e) {
    return bd(this.eWrapper, e), this;
  }
  setInputName(e) {
    return this.getInputElement().setAttribute("name", e), this;
  }
  getFocusableElement() {
    return this.eInput;
  }
  setMaxLength(e) {
    const t = this.eInput;
    return t.maxLength = e, this;
  }
  setInputPlaceholder(e) {
    return Mn(this.eInput, "placeholder", e), this;
  }
  setInputAriaLabel(e) {
    return yt(this.eInput, e), this.refreshAriaLabelledBy(), this;
  }
  setDisabled(e) {
    return vi(this.eInput, e), super.setDisabled(e);
  }
  setAutoComplete(e) {
    if (e === !0)
      Mn(this.eInput, "autocomplete", null);
    else {
      const t = typeof e == "string" ? e : "off";
      Mn(this.eInput, "autocomplete", t);
    }
    return this;
  }
}, vc = class extends ti {
  constructor(e, t = "ag-checkbox", n = "checkbox") {
    super(e, t, n), this.labelAlignment = "right", this.selected = !1, this.readOnly = !1, this.passive = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { readOnly: e, passive: t } = this.config;
    typeof e == "boolean" && this.setReadOnly(e), typeof t == "boolean" && this.setPassive(t);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { click: this.onCheckboxClick.bind(this) }), this.addManagedElementListeners(this.eLabel, { click: this.toggle.bind(this) });
  }
  getNextValue() {
    return this.selected === void 0 ? !0 : !this.selected;
  }
  setPassive(e) {
    this.passive = e;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setReadOnly(e) {
    this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
  }
  setDisabled(e) {
    return this.eWrapper.classList.toggle("ag-disabled", e), super.setDisabled(e);
  }
  toggle() {
    if (this.eInput.disabled)
      return;
    const e = this.isSelected(), t = this.getNextValue();
    this.passive ? this.dispatchChange(t, e) : this.setValue(t);
  }
  getValue() {
    return this.isSelected();
  }
  setValue(e, t) {
    return this.refreshSelectedClass(e), this.setSelected(e, t), this;
  }
  setName(e) {
    const t = this.getInputElement();
    return t.name = e, this;
  }
  isSelected() {
    return this.selected;
  }
  setSelected(e, t) {
    if (this.isSelected() === e)
      return;
    this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0;
    const n = this.eInput;
    n.checked = e, n.indeterminate = e === void 0, t || this.dispatchChange(this.selected, this.previousValue);
  }
  dispatchChange(e, t, n) {
    this.dispatchLocalEvent({ type: "fieldValueChanged", selected: e, previousValue: t, event: n });
    const o = this.getInputElement();
    this.eventSvc.dispatchEvent({
      type: "checkboxChanged",
      id: o.id,
      name: o.name,
      selected: e,
      previousValue: t
    });
  }
  onCheckboxClick(e) {
    if (this.passive || this.eInput.disabled)
      return;
    const t = this.isSelected(), n = this.selected = e.target.checked;
    this.refreshSelectedClass(n), this.dispatchChange(n, t, e);
  }
  refreshSelectedClass(e) {
    const t = this.eWrapper.classList;
    t.toggle("ag-checked", e === !0), t.toggle("ag-indeterminate", e == null);
  }
}, Di = {
  selector: "AG-CHECKBOX",
  component: vc
}, iM = class extends vc {
  constructor(e) {
    super(e, "ag-radio-button", "radio");
  }
  isSelected() {
    return this.eInput.checked;
  }
  toggle() {
    this.eInput.disabled || this.isSelected() || this.setValue(!0);
  }
  addInputListeners() {
    super.addInputListeners(), this.addManagedEventListeners({ checkboxChanged: this.onChange.bind(this) });
  }
  /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */
  onChange(e) {
    const t = this.eInput;
    e.selected && e.name && t.name && t.name === e.name && e.id && t.id !== e.id && this.setValue(!1, !0);
  }
}, rM = (
  /*css*/
  '.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}'
), aM = class extends vc {
  constructor(e) {
    super(e, "ag-toggle-button"), this.registerCSS(rM);
  }
  setValue(e, t) {
    return super.setValue(e, t), this.toggleCss("ag-selected", this.getValue()), this;
  }
}, lM = {
  selector: "AG-TOGGLE-BUTTON",
  component: aM
}, Fo = class extends ti {
  constructor(e, t = "ag-text-field", n = "text") {
    super(e, t, n);
  }
  postConstruct() {
    super.postConstruct(), this.config.allowedCharPattern && this.preventDisallowedCharacters();
  }
  setValue(e, t) {
    const n = this.eInput;
    return n.value !== e && (n.value = ue(e) ? e : ""), super.setValue(e, t);
  }
  /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */
  setStartValue(e) {
    this.setValue(e, !0);
  }
  preventDisallowedCharacters() {
    const e = new RegExp(`[${this.config.allowedCharPattern}]`), t = (n) => {
      dp(n) && n.key && !e.test(n.key) && n.preventDefault();
    };
    this.addManagedListeners(this.eInput, {
      keydown: t,
      paste: (n) => {
        var s;
        const o = (s = n.clipboardData) == null ? void 0 : s.getData("text");
        o && o.split("").some((i) => !e.test(i)) && n.preventDefault();
      }
    });
  }
}, ao = {
  selector: "AG-INPUT-TEXT-FIELD",
  component: Fo
}, dM = class extends ti {
  constructor(e) {
    super(e, "ag-text-area", null, "textarea");
  }
  setValue(e, t) {
    const n = super.setValue(e, t);
    return this.eInput.value = e, n;
  }
  setCols(e) {
    return this.eInput.cols = e, this;
  }
  setRows(e) {
    return this.eInput.rows = e, this;
  }
}, cM = {
  selector: "AG-INPUT-TEXT-AREA",
  component: dM
}, Cc = class extends Fo {
  constructor(e) {
    super(e, "ag-number-field", "number");
  }
  postConstruct() {
    super.postConstruct();
    const e = this.eInput;
    this.addManagedListeners(e, {
      blur: () => {
        const i = parseFloat(e.value), r = isNaN(i) ? "" : this.normalizeValue(i.toString());
        this.value !== r && this.setValue(r);
      },
      wheel: this.onWheel.bind(this)
    }), e.step = "any";
    const { precision: t, min: n, max: o, step: s } = this.config;
    typeof t == "number" && this.setPrecision(t), typeof n == "number" && this.setMin(n), typeof o == "number" && this.setMax(o), typeof s == "number" && this.setStep(s);
  }
  onWheel(e) {
    je(this.beans) === this.eInput && e.preventDefault();
  }
  normalizeValue(e) {
    return e === "" ? "" : (this.precision != null && (e = this.adjustPrecision(e)), e);
  }
  adjustPrecision(e, t) {
    const n = this.precision;
    if (n == null)
      return e;
    if (t) {
      const s = parseFloat(e).toFixed(n);
      return parseFloat(s).toString();
    }
    const o = String(e).split(".");
    if (o.length > 1) {
      if (o[1].length <= n)
        return e;
      if (n > 0)
        return `${o[0]}.${o[1].slice(0, n)}`;
    }
    return o[0];
  }
  setMin(e) {
    return this.min === e ? this : (this.min = e, Mn(this.eInput, "min", e), this);
  }
  setMax(e) {
    return this.max === e ? this : (this.max = e, Mn(this.eInput, "max", e), this);
  }
  setPrecision(e) {
    return this.precision = e, this;
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, Mn(this.eInput, "step", e), this);
  }
  setValue(e, t) {
    return this.setValueOrInputValue(
      (n) => super.setValue(n, t),
      () => this,
      e
    );
  }
  setStartValue(e) {
    return this.setValueOrInputValue(
      (t) => super.setValue(t, !0),
      (t) => {
        this.eInput.value = t;
      },
      e
    );
  }
  setValueOrInputValue(e, t, n) {
    if (ue(n)) {
      let o = this.isScientificNotation(n);
      if (o && this.eInput.validity.valid)
        return e(n);
      if (!o) {
        n = this.adjustPrecision(n);
        const s = this.normalizeValue(n);
        o = n != s;
      }
      if (o)
        return t(n);
    }
    return e(n);
  }
  getValue() {
    const e = this.eInput;
    if (!e.validity.valid)
      return;
    const t = e.value;
    return this.isScientificNotation(t) ? this.adjustPrecision(t, !0) : super.getValue();
  }
  isScientificNotation(e) {
    return typeof e == "string" && e.includes("e");
  }
}, uM = {
  selector: "AG-INPUT-NUMBER-FIELD",
  component: Cc
}, Xr = class extends Fo {
  constructor(e) {
    super(e, "ag-date-field", "date");
  }
  postConstruct() {
    super.postConstruct();
    const e = os();
    this.addManagedListeners(this.eInput, {
      wheel: this.onWheel.bind(this),
      mousedown: () => {
        this.isDisabled() || e || this.eInput.focus();
      }
    }), this.eInput.step = "any";
  }
  onWheel(e) {
    je(this.beans) === this.eInput && e.preventDefault();
  }
  setMin(e) {
    const t = e instanceof Date ? un(e ?? null, !!this.includeTime) ?? void 0 : e;
    return this.min === t ? this : (this.min = t, Mn(this.eInput, "min", t), this);
  }
  setMax(e) {
    const t = e instanceof Date ? un(e ?? null, !!this.includeTime) ?? void 0 : e;
    return this.max === t ? this : (this.max = t, Mn(this.eInput, "max", t), this);
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, Mn(this.eInput, "step", e), this);
  }
  setIncludeTime(e) {
    return this.includeTime === e ? this : (this.includeTime = e, super.setInputType(e ? "datetime-local" : "date"), e && this.setStep(1), this);
  }
  getDate() {
    if (this.eInput.validity.valid)
      return Qt(this.getValue()) ?? void 0;
  }
  setDate(e, t) {
    this.setValue(un(e ?? null, this.includeTime), t);
  }
}, uw = {
  selector: "AG-INPUT-DATE-FIELD",
  component: Xr
}, hM = (
  /*css*/
  ".ag-list-item{align-items:center;display:flex;height:var(--ag-list-item-height);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}"
), gM = "ag-active-item", pM = (e, t) => ({
  tag: "div",
  cls: `ag-list-item ag-${e}-list-item`,
  attrs: { role: "option" },
  children: [
    {
      tag: "span",
      ref: "eText",
      children: t
    }
  ]
}), fM = class extends Xa {
  constructor(e, t, n) {
    super(pM(e, t)), this.label = t, this.value = n, this.eText = X;
  }
  postConstruct() {
    this.createTooltip(), this.addEventListeners();
  }
  setHighlighted(e) {
    const t = this.getGui();
    t.classList.toggle(gM, e), zg(t, e), this.dispatchLocalEvent({
      type: "itemHighlighted",
      highlighted: e
    });
  }
  getHeight() {
    return this.getGui().clientHeight;
  }
  setIndex(e, t) {
    const n = this.getGui();
    lc(n, e), ac(n, t);
  }
  createTooltip() {
    const e = {
      getTooltipValue: () => this.label,
      getGui: () => this.getGui(),
      getLocation: () => "UNKNOWN",
      // only show tooltips for items where the text cannot be fully displayed
      shouldDisplayTooltip: () => qg(this.eText)
    }, t = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean(
        "highlightTooltipFeature",
        !1,
        e,
        this
      )
    );
    t && (this.tooltipFeature = t);
  }
  addEventListeners() {
    const e = this.getParentComponent();
    e && (this.addGuiEventListener("mouseover", () => {
      e.highlightItem(this);
    }), this.addGuiEventListener("mousedown", (t) => {
      t.preventDefault(), t.stopPropagation(), e.setValue(this.value);
    }));
  }
}, mM = class extends Xa {
  constructor(e = "default") {
    super({ tag: "div", cls: `ag-list ag-${e}-list` }), this.cssIdentifier = e, this.options = [], this.listItems = [], this.highlightedItem = null, this.registerCSS(hM);
  }
  postConstruct() {
    const e = this.getGui();
    this.addManagedElementListeners(e, { mouseleave: () => this.clearHighlighted() });
  }
  handleKeyDown(e) {
    const t = e.key;
    switch (t) {
      case O.ENTER:
        if (!this.highlightedItem)
          this.setValue(this.getValue());
        else {
          const n = this.listItems.indexOf(this.highlightedItem);
          this.setValueByIndex(n);
        }
        break;
      case O.DOWN:
      case O.UP:
        e.preventDefault(), this.navigate(t);
        break;
      case O.PAGE_DOWN:
      case O.PAGE_UP:
      case O.PAGE_HOME:
      case O.PAGE_END:
        e.preventDefault(), this.navigateToPage(t);
        break;
    }
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    const { value: t, text: n } = e, o = n ?? t;
    return this.options.push({ value: t, text: o }), this.renderOption(t, o), this.updateIndices(), this;
  }
  clearOptions() {
    this.options = [], this.reset(!0), this.listItems.forEach((e) => {
      e.destroy();
    }), ht(this.getGui()), this.listItems = [], this.refreshAriaRole();
  }
  setValue(e, t) {
    if (this.value === e)
      return this.fireItemSelected(), this;
    if (e == null)
      return this.reset(t), this;
    const n = this.options.findIndex((o) => o.value === e);
    if (n !== -1) {
      const o = this.options[n];
      this.value = o.value, this.displayValue = o.text, this.highlightItem(this.listItems[n]), t || this.fireChangeEvent();
    }
    return this;
  }
  setValueByIndex(e) {
    return this.setValue(this.options[e].value);
  }
  getValue() {
    return this.value;
  }
  getDisplayValue() {
    return this.displayValue;
  }
  refreshHighlighted() {
    this.clearHighlighted();
    const e = this.options.findIndex((t) => t.value === this.value);
    e !== -1 && this.highlightItem(this.listItems[e]);
  }
  highlightItem(e) {
    const t = e.getGui();
    if (!vn(t))
      return;
    this.clearHighlighted(), e.setHighlighted(!0), this.highlightedItem = e;
    const n = this.getGui(), { scrollTop: o, clientHeight: s } = n, { offsetTop: i, offsetHeight: r } = t;
    (i + r > o + s || i < o) && t.scrollIntoView({ block: "nearest" });
  }
  hideItemTooltip() {
    var e, t;
    (t = (e = this.highlightedItem) == null ? void 0 : e.tooltipFeature) == null || t.attemptToHideTooltip();
  }
  destroy() {
    this.hideItemTooltip(), super.destroy();
  }
  reset(e) {
    this.value = null, this.displayValue = null, this.clearHighlighted(), e || this.fireChangeEvent();
  }
  clearHighlighted() {
    var e;
    (e = this.highlightedItem) == null || e.setHighlighted(!1), this.highlightedItem = null;
  }
  renderOption(e, t) {
    const n = new fM(this.cssIdentifier, t, e);
    n.setParentComponent(this);
    const o = this.createManagedBean(n);
    this.listItems.push(o), this.getGui().appendChild(o.getGui());
  }
  navigate(e) {
    const t = e === O.DOWN;
    let n;
    const { listItems: o, highlightedItem: s } = this;
    if (!s)
      n = t ? o[0] : Je(o);
    else {
      let r = o.indexOf(s) + (t ? 1 : -1);
      r = Math.min(Math.max(r, 0), o.length - 1), n = o[r];
    }
    this.highlightItem(n);
  }
  navigateToPage(e) {
    const { listItems: t, highlightedItem: n } = this;
    if (!n || t.length === 0)
      return;
    const o = t.indexOf(n), s = this.options.length - 1, i = t[0].getHeight(), r = Math.floor(this.getGui().clientHeight / i);
    let a = -1;
    e === O.PAGE_HOME ? a = 0 : e === O.PAGE_END ? a = s : e === O.PAGE_DOWN ? a = Math.min(o + r, s) : e === O.PAGE_UP && (a = Math.max(o - r, 0)), a !== -1 && this.highlightItem(t[a]);
  }
  refreshAriaRole() {
    hn(this.getGui(), this.options.length === 0 ? "presentation" : "listbox");
  }
  updateIndices() {
    this.refreshAriaRole();
    const e = this.listItems, t = e.length;
    e.forEach((n, o) => {
      n.setIndex(o + 1, t);
    });
  }
  fireChangeEvent() {
    this.dispatchLocalEvent({ type: "fieldValueChanged" }), this.fireItemSelected();
  }
  fireItemSelected() {
    this.dispatchLocalEvent({ type: "selectedItem" });
  }
}, vM = (
  /*css*/
  ".ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:where(.ag-picker-has-focus),&:where(:focus-within){background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow);&:where(.invalid){box-shadow:var(--ag-focus-error-shadow)}}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:disabled{opacity:.5}}"
), CM = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
      children: [
        { tag: "div", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, hw = class extends cw {
  constructor(e) {
    if (super(e, (e == null ? void 0 : e.template) || CM, (e == null ? void 0 : e.agComponents) || [], e == null ? void 0 : e.className), this.isPickerDisplayed = !1, this.skipClick = !1, this.pickerGap = 4, this.hideCurrentPicker = null, this.eLabel = X, this.eWrapper = X, this.eDisplayField = X, this.eIcon = X, this.registerCSS(vM), this.ariaRole = e == null ? void 0 : e.ariaRole, this.onPickerFocusIn = this.onPickerFocusIn.bind(this), this.onPickerFocusOut = this.onPickerFocusOut.bind(this), !e)
      return;
    const { pickerGap: t, maxPickerHeight: n, variableWidth: o, minPickerWidth: s, maxPickerWidth: i } = e;
    t != null && (this.pickerGap = t), this.variableWidth = !!o, n != null && this.setPickerMaxHeight(n), s != null && this.setPickerMinWidth(s), i != null && this.setPickerMaxWidth(i);
  }
  postConstruct() {
    super.postConstruct(), this.setupAria();
    const e = `ag-${this.getCompId()}-display`;
    this.eDisplayField.setAttribute("id", e);
    const t = this.getAriaElement();
    this.addManagedElementListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedElementListeners(this.eLabel, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) }), this.addManagedElementListeners(this.eWrapper, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) });
    const { pickerIcon: n, inputWidth: o } = this.config;
    if (n) {
      const s = this.beans.iconSvc.createIconNoSpan(n);
      s && this.eIcon.appendChild(s);
    }
    o != null && this.setInputWidth(o);
  }
  setupAria() {
    const e = this.getAriaElement();
    e.setAttribute("tabindex", this.gos.get("tabIndex").toString()), Zn(e, !1), this.ariaRole && hn(e, this.ariaRole);
  }
  onLabelOrWrapperMouseDown(e) {
    if (e) {
      const t = this.getFocusableElement();
      if (t !== this.eWrapper && (e == null ? void 0 : e.target) === t)
        return;
      e.preventDefault(), this.getFocusableElement().focus();
    }
    if (this.skipClick) {
      this.skipClick = !1;
      return;
    }
    this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
  }
  onKeyDown(e) {
    switch (e.key) {
      case O.UP:
      case O.DOWN:
      case O.ENTER:
      case O.SPACE:
        e.preventDefault(), this.onLabelOrWrapperMouseDown();
        break;
      case O.ESCAPE:
        this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
        break;
    }
  }
  showPicker() {
    this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
    const e = this.pickerComponent.getGui();
    e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
  }
  renderAndPositionPicker() {
    const e = this.pickerComponent.getGui();
    this.gos.get("suppressScrollWhenPopupsAreOpen") || ([this.destroyMouseWheelFunc] = this.addManagedEventListeners({
      bodyScroll: () => {
        this.hidePicker();
      }
    }));
    const t = this.getLocaleTextFunc(), {
      config: { pickerAriaLabelKey: n, pickerAriaLabelValue: o, modalPicker: s = !0 },
      maxPickerHeight: i,
      minPickerWidth: r,
      maxPickerWidth: a,
      variableWidth: l,
      beans: d,
      eWrapper: c
    } = this, u = {
      modal: s,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: () => {
        const f = fr(d);
        this.beforeHidePicker(), f && this.isAlive() && this.getFocusableElement().focus();
      },
      ariaLabel: t(n, o),
      anchorToElement: c
    };
    e.style.position = "absolute";
    const h = d.popupSvc, g = h.addPopup(u);
    l ? (r && (e.style.minWidth = r), e.style.width = jg(Ia(c)), a && (e.style.maxWidth = a)) : bd(e, a ?? Ia(c));
    const p = i ?? `${cc(h.getPopupParent())}px`;
    return e.style.setProperty("max-height", p), this.alignPickerToComponent(), g.hideFunc;
  }
  alignPickerToComponent() {
    if (!this.pickerComponent)
      return;
    const {
      pickerGap: e,
      config: { pickerType: t },
      beans: { popupSvc: n, gos: o },
      eWrapper: s,
      pickerComponent: i
    } = this, r = o.get("enableRtl") ? "right" : "left";
    n.positionPopupByComponent({
      type: t,
      eventSource: s,
      ePopup: i.getGui(),
      position: "under",
      alignSide: r,
      keepWithinBounds: !0,
      nudgeY: e
    });
  }
  beforeHidePicker() {
    this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
    const e = this.pickerComponent.getGui();
    e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
  }
  toggleExpandedStyles(e) {
    if (!this.isAlive())
      return;
    const t = this.getAriaElement();
    Zn(t, e);
    const n = this.eWrapper.classList;
    n.toggle("ag-picker-expanded", e), n.toggle("ag-picker-collapsed", !e);
  }
  onPickerFocusIn() {
    this.togglePickerHasFocus(!0);
  }
  onPickerFocusOut(e) {
    var t;
    (t = this.pickerComponent) != null && t.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
  }
  togglePickerHasFocus(e) {
    this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
  }
  hidePicker() {
    this.hideCurrentPicker && (this.hideCurrentPicker(), this.dispatchLocalEvent({
      type: "pickerHidden"
    }));
  }
  setInputWidth(e) {
    return bd(this.eWrapper, e), this;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  setPickerGap(e) {
    return this.pickerGap = e, this;
  }
  setPickerMinWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.minPickerWidth = e ?? void 0, this;
  }
  setPickerMaxWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerWidth = e ?? void 0, this;
  }
  setPickerMaxHeight(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerHeight = e ?? void 0, this;
  }
  destroy() {
    this.hidePicker(), super.destroy();
  }
}, wM = (
  /*css*/
  ".ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}"
), up = class extends hw {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelSelectField",
      pickerAriaLabelValue: "Select Field",
      pickerType: "ag-list",
      className: "ag-select",
      pickerIcon: "selectOpen",
      ariaRole: "combobox",
      ...e
    }), this.registerCSS(wM);
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean(
        "tooltipFeature",
        !1,
        {
          shouldDisplayTooltip: ai(() => this.eDisplayField),
          getGui: () => this.getGui()
        }
      )
    ), super.postConstruct(), this.createListComponent(), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { options: e, value: t, placeholder: n } = this.config;
    e != null && this.addOptions(e), t != null && this.setValue(t, !0), n && t == null && (this.eDisplayField.textContent = n), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) });
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  createListComponent() {
    const e = this.createBean(
      new mM("select")
    );
    this.listComponent = e, e.setParentComponent(this);
    const t = e.getAriaElement(), n = `ag-select-list-${e.getCompId()}`;
    t.setAttribute("id", n), Wg(this.getAriaElement(), t), e.addManagedElementListeners(e.getGui(), {
      mousedown: (o) => {
        o == null || o.preventDefault();
      }
    }), e.addManagedListeners(e, {
      selectedItem: () => {
        this.hidePicker(), this.dispatchLocalEvent({ type: "selectedItem" });
      },
      fieldValueChanged: () => {
        this.listComponent && (this.setValue(this.listComponent.getValue(), !1, !0), this.hidePicker());
      }
    });
  }
  createPickerComponent() {
    return this.listComponent;
  }
  beforeHidePicker() {
    var e;
    (e = this.listComponent) == null || e.hideItemTooltip(), super.beforeHidePicker();
  }
  onKeyDown(e) {
    var n;
    const { key: t } = e;
    switch (t === O.TAB && this.hidePicker(), t) {
      case O.ENTER:
      case O.UP:
      case O.DOWN:
      case O.PAGE_UP:
      case O.PAGE_DOWN:
      case O.PAGE_HOME:
      case O.PAGE_END:
        e.preventDefault(), this.isPickerDisplayed ? (n = this.listComponent) == null || n.handleKeyDown(e) : super.onKeyDown(e);
        break;
      case O.ESCAPE:
        super.onKeyDown(e);
        break;
      case O.SPACE:
        this.isPickerDisplayed ? e.preventDefault() : super.onKeyDown(e);
        break;
    }
  }
  showPicker() {
    const e = this.listComponent;
    e && (super.showPicker(), e.refreshHighlighted());
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    return this.listComponent.addOption(e), this;
  }
  clearOptions() {
    var e;
    return (e = this.listComponent) == null || e.clearOptions(), this.setValue(void 0, !0), this;
  }
  setValue(e, t, n) {
    const {
      listComponent: o,
      config: { placeholder: s },
      eDisplayField: i,
      tooltipFeature: r
    } = this;
    if (this.value === e || !o)
      return this;
    if (n || o.setValue(e, !0), o.getValue() === this.getValue())
      return this;
    let l = o.getDisplayValue();
    return l == null && s && (l = s), i.textContent = l, r == null || r.setTooltipAndRefresh(l ?? null), super.setValue(e, t);
  }
  destroy() {
    this.listComponent = this.destroyBean(this.listComponent), super.destroy();
  }
}, yM = {
  selector: "AG-SELECT",
  component: up
}, bM = (
  /*css*/
  ':where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none;&:where(.invalid){box-shadow:inset var(--ag-focus-error-shadow)}}&:where(button){color:inherit}}:where(.ag-root-wrapper,ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-chart,.ag-dnd-ghost,.ag-external,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-resizer{pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}'
), $v, zv, hp = typeof window != "object" || !((zv = ($v = window == null ? void 0 : window.document) == null ? void 0 : $v.fonts) != null && zv.forEach), xr = (e, t, n, o, s, i) => {
  if (hp)
    return;
  o && (e = `@layer ${CSS.escape(o)} { ${e} }`);
  let r = tr.map.get(t);
  if (r || (r = [], tr.map.set(t, r)), r.find((c) => c.css === e))
    return;
  const a = document.createElement("style");
  i && a.setAttribute("nonce", i), a.dataset.agGlobalCss = n, a.textContent = e;
  const l = { css: e, el: a, priority: s };
  let d;
  for (const c of r) {
    if (c.priority > s)
      break;
    d = c;
  }
  if (d) {
    d.el.insertAdjacentElement("afterend", a);
    const c = r.indexOf(d);
    r.splice(c + 1, 0, l);
  } else
    t.insertBefore(a, t.querySelector(":not(title, meta)")), r.push(l);
}, gw = (e, t, n, o) => {
  xr(bM, e, "shared", t, 0, n), o == null || o.forEach(
    (s, i) => s.forEach((r) => xr(r, e, i, t, 0, n))
  );
}, SM = (e) => {
  tr.grids.add(e);
}, xM = (e) => {
  if (tr.grids.delete(e), tr.grids.size === 0) {
    tr.map = /* @__PURE__ */ new WeakMap();
    for (const t of document.head.querySelectorAll("style[data-ag-global-css]"))
      t.remove();
  }
}, fm, tr = (fm = typeof window == "object" ? window : {}).agStyleInjectionState ?? (fm.agStyleInjectionState = {
  map: /* @__PURE__ */ new WeakMap(),
  grids: /* @__PURE__ */ new Set()
}), qn = (e) => new pw(e), fs = "$default", RM = 0, pw = class {
  constructor({ feature: e, params: t, modeParams: n = {}, css: o, cssImports: s }) {
    this.feature = e, this.css = o, this.cssImports = s, this.modeParams = {
      // NOTE: it's important that default is defined first, putting it
      // first in iteration order, because when merging params the default
      // params override any prior modal params, so modal params in this
      // part need to come after default params to prevent them from being
      // immediately overridden.
      [fs]: {
        ...n[fs] ?? {},
        ...t ?? {}
      },
      ...n
    };
  }
  use(e, t, n) {
    let o = this._inject;
    if (o == null) {
      let { css: s } = this;
      if (s) {
        const i = `ag-theme-${this.feature ?? "part"}-${++RM}`;
        typeof s == "function" && (s = s()), s = `:where(.${i}) {
${s}
}
`;
        for (const r of this.cssImports ?? [])
          s = `@import url(${JSON.stringify(r)});
${s}`;
        o = { css: s, class: i };
      } else
        o = !1;
      this._inject = o;
    }
    return o && e && xr(o.css, e, o.class, t, 1, n), o ? o.class : !1;
  }
}, EM = (e) => e.replace(/[A-Z]/g, (t) => `-${t}`).toLowerCase(), fw = (e) => `--ag-${EM(e)}`, Po = (e) => `var(${fw(e)})`, AM = (e, t, n) => Math.max(t, Math.min(n, e)), FM = (e) => {
  const t = /* @__PURE__ */ new Map();
  return (n) => {
    const o = n;
    return t.has(o) || t.set(o, e(n)), t.get(o);
  };
}, fo = (e) => ({ ref: "accentColor", mix: e }), Hn = (e) => ({ ref: "foregroundColor", mix: e }), Nn = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "backgroundColor"
}), MM = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "headerBackgroundColor"
}), Rn = { ref: "backgroundColor" }, Wi = { ref: "foregroundColor" }, $o = { ref: "accentColor" }, Id = {
  backgroundColor: "#fff",
  foregroundColor: "#181d1f",
  borderColor: Hn(0.15),
  chromeBackgroundColor: Nn(0.02),
  browserColorScheme: "light"
}, IM = {
  ...Id,
  textColor: Wi,
  accentColor: "#2196f3",
  invalidColor: "#e02525",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu",
    "Cantarell",
    "Helvetica Neue",
    "sans-serif"
  ],
  subtleTextColor: {
    ref: "textColor",
    mix: 0.5
  },
  borderWidth: 1,
  borderRadius: 4,
  spacing: 8,
  fontSize: 14,
  focusShadow: {
    spread: 3,
    color: fo(0.5)
  },
  focusErrorShadow: {
    spread: 3,
    color: {
      ref: "invalidColor",
      onto: "backgroundColor",
      mix: 0.5
    }
  },
  popupShadow: "0 0 16px #00000026",
  cardShadow: "0 1px 4px 1px #00000018",
  dropdownShadow: { ref: "cardShadow" },
  listItemHeight: {
    calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
  },
  dragAndDropImageBackgroundColor: Rn,
  dragAndDropImageBorder: !0,
  dragAndDropImageNotAllowedBorder: {
    color: {
      ref: "invalidColor",
      onto: "dragAndDropImageBackgroundColor",
      mix: 0.5
    }
  },
  dragAndDropImageShadow: {
    ref: "popupShadow"
  },
  iconSize: 16,
  iconColor: "inherit",
  toggleButtonWidth: 28,
  toggleButtonHeight: 18,
  toggleButtonOnBackgroundColor: $o,
  toggleButtonOffBackgroundColor: Nn(0.3),
  toggleButtonSwitchBackgroundColor: Rn,
  toggleButtonSwitchInset: 2,
  tooltipBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  tooltipErrorBackgroundColor: {
    ref: "invalidColor",
    onto: "backgroundColor",
    mix: 0.1
  },
  tooltipTextColor: {
    ref: "textColor"
  },
  tooltipErrorTextColor: {
    ref: "invalidColor"
  },
  tooltipBorder: !0,
  tooltipErrorBorder: {
    color: {
      ref: "invalidColor",
      onto: "backgroundColor",
      mix: 0.25
    }
  }
}, PM = [
  "colorScheme",
  "color",
  "length",
  "scale",
  "borderStyle",
  "border",
  "shadow",
  "image",
  "fontFamily",
  "fontWeight",
  "duration"
], DM = FM((e) => (e = e.toLowerCase(), PM.find((t) => e.endsWith(t.toLowerCase())) ?? "length")), wc = (e) => typeof e == "object" && (e != null && e.ref) ? Po(e.ref) : typeof e == "string" ? e : typeof e == "number" ? String(e) : !1, yc = (e) => {
  if (typeof e == "string")
    return e;
  if (e && "ref" in e) {
    const t = Po(e.ref);
    return e.mix == null ? t : `color-mix(in srgb, ${e.onto ? Po(e.onto) : "transparent"}, ${t} ${AM(e.mix * 100, 0, 100)}%)`;
  }
  return !1;
}, TM = wc, Ui = (e) => typeof e == "string" ? e : typeof e == "number" ? `${e}px` : e && "calc" in e ? `calc(${e.calc.replace(/ ?[*/+] ?/g, " $& ").replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (n) => n[0] === "-" ? n : ` ${Po(n)} `)})` : e && "ref" in e ? Po(e.ref) : !1, kM = wc, Ah = (e, t) => typeof e == "string" ? e : e === !0 ? Ah({}, t) : e === !1 ? t === "columnBorder" ? Ah({ color: "transparent" }, t) : "none" : e && "ref" in e ? Po(e.ref) : mw(e.style ?? "solid") + " " + Ui(e.width ?? { ref: "borderWidth" }) + " " + yc(e.color ?? { ref: "borderColor" }), LM = (e) => typeof e == "string" ? e : e === !1 ? "none" : e && "ref" in e ? Po(e.ref) : [
  Ui(e.offsetX ?? 0),
  Ui(e.offsetY ?? 0),
  Ui(e.radius ?? 0),
  Ui(e.spread ?? 0),
  yc(e.color ?? { ref: "foregroundColor" })
].join(" "), mw = wc, gp = (e) => typeof e == "string" ? e.includes(",") ? e : mm(e) : e && "googleFont" in e ? gp(e.googleFont) : e && "ref" in e ? Po(e.ref) : Array.isArray(e) ? e.map((t) => (typeof t == "object" && "googleFont" in t && (t = t.googleFont), mm(t))).join(", ") : !1, mm = (e) => (
  // don't quote var() expressions or quote safe identifier names, so that
  // people can specify fonts like sans-serif which are keywords not strings,
  // or var(--my-var)
  /^[\w-]+$|\w\(/.test(e) ? e : JSON.stringify(e)
), vw = wc, pp = (e) => typeof e == "string" ? e : e && "url" in e ? `url(${JSON.stringify(e.url)})` : e && "svg" in e ? pp({ url: `data:image/svg+xml,${encodeURIComponent(e.svg)}` }) : e && "ref" in e ? Po(e.ref) : !1, BM = (e, t, n) => typeof e == "string" ? e : typeof e == "number" ? (e >= 10 && n.warn(104, { value: e, param: t }), `${e}s`) : e && "ref" in e ? Po(e.ref) : !1, OM = {
  color: yc,
  colorScheme: TM,
  length: Ui,
  scale: kM,
  border: Ah,
  borderStyle: mw,
  shadow: LM,
  image: pp,
  fontFamily: gp,
  fontWeight: vw,
  duration: BM
}, GM = (e, t, n) => {
  const o = DM(e);
  return OM[o](t, e, n);
}, HM = (e) => new Cw(e), Cw = class ww {
  constructor(t, n = []) {
    this.themeLogger = t, this.parts = n;
  }
  withPart(t) {
    return typeof t == "function" && (t = t()), t instanceof pw ? new ww(this.themeLogger, [...this.parts, t]) : (this.themeLogger.preInitErr(259, "Invalid part", { part: t }), this);
  }
  withoutPart(t) {
    return this.withPart(qn({ feature: t }));
  }
  withParams(t, n = fs) {
    return this.withPart(
      qn({
        modeParams: { [n]: t }
      })
    );
  }
  /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */
  _startUse({ styleContainer: t, cssLayer: n, nonce: o, loadThemeGoogleFonts: s, moduleCss: i }) {
    if (hp)
      return;
    _M(), gw(t, n, o, i);
    const r = VM(this);
    if (r.length > 0)
      for (const a of r)
        s && $M(a, o);
    for (const a of this.parts)
      a.use(t, n, o);
  }
  /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */
  _getCssClass() {
    return this._cssClassCache ?? (this._cssClassCache = vm(this.parts).map((t) => t.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
  }
  _getModeParams() {
    let t = this._paramsCache;
    if (!t) {
      const n = {
        // NOTE: defining the default mode here is important, it ensures
        // that the default mode is first in iteration order, which puts
        // it first in outputted CSS, allowing other modes to override it
        [fs]: { ...IM }
      };
      for (const o of vm(this.parts))
        for (const s of Object.keys(o.modeParams)) {
          const i = o.modeParams[s];
          if (i) {
            const r = n[s] ?? (n[s] = {}), a = /* @__PURE__ */ new Set();
            for (const l of Object.keys(i)) {
              const d = i[l];
              d !== void 0 && (r[l] = d, a.add(l));
            }
            if (s === fs)
              for (const l of Object.keys(n)) {
                const d = n[l];
                if (l !== fs)
                  for (const c of a)
                    delete d[c];
              }
          }
        }
      this._paramsCache = t = n;
    }
    return t;
  }
  /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */
  _getPerInstanceCss(t) {
    const n = "##SELECTOR##";
    let o = this._paramsCssCache;
    if (!o) {
      let s = "", i = "";
      const r = this._getModeParams();
      for (const l of Object.keys(r)) {
        const d = r[l];
        if (l !== fs) {
          const u = `:where([data-ag-theme-mode="${typeof CSS == "object" ? CSS.escape(l) : l}"]) & {
`;
          s += u, i += u;
        }
        for (const c of Object.keys(d).sort()) {
          const u = d[c], h = GM(c, u, this.themeLogger);
          if (h === !1)
            this.themeLogger.error(107, { key: c, value: u });
          else {
            const g = fw(c), p = g.replace("--ag-", "--ag-inherited-");
            s += `	${g}: var(${p}, ${h});
`, i += `	${p}: var(${g});
`;
          }
        }
        l !== fs && (s += `}
`, i += `}
`);
      }
      let a = `${n} {
${s}}
`;
      a += `:has(> ${n}):not(${n}) {
${i}}
`, this._paramsCssCache = o = a;
    }
    return o.replaceAll(n, `:where(.${t})`);
  }
}, vm = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const o of e)
    t.set(o.feature, o);
  const n = [];
  for (const o of e)
    (!o.feature || t.get(o.feature) === o) && n.push(o);
  return n;
}, VM = (e) => {
  const t = /* @__PURE__ */ new Set(), n = (i) => {
    if (Array.isArray(i))
      i.forEach(n);
    else {
      const r = i == null ? void 0 : i.googleFont;
      typeof r == "string" && t.add(r);
    }
  };
  return Object.values(e._getModeParams()).flatMap((i) => Object.values(i)).forEach(n), Array.from(t).sort();
}, Cm = !1, _M = () => {
  if (!Cm) {
    Cm = !0;
    for (const e of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))
      e.remove();
  }
}, NM = /* @__PURE__ */ new Set(), $M = async (e, t) => {
  NM.add(e);
  const n = `@import url('https://${zM}/css2?family=${encodeURIComponent(e)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
  xr(n, document.head, `googleFont:${e}`, void 0, 0, t);
}, zM = "fonts.googleapis.com", WM = 1, UM = class {
  constructor(e) {
    this.beans = {}, this.createdBeans = [], this.destroyed = !1, this.instanceId = WM++, !(!e || !e.beanClasses) && (this.beanDestroyComparator = e.beanDestroyComparator, this.init(e));
  }
  init(e) {
    var t;
    this.id = e.id, this.beans.context = this, this.destroyCallback = e.destroyCallback;
    for (const n of Object.keys(e.providedBeanInstances))
      this.beans[n] = e.providedBeanInstances[n];
    e.beanClasses.forEach((n) => {
      const o = new n();
      o.beanName ? this.beans[o.beanName] = o : console.error(`Bean ${n.name} is missing beanName`), this.createdBeans.push(o);
    }), (t = e.derivedBeans) == null || t.forEach((n) => {
      const { beanName: o, bean: s } = n(this);
      this.beans[o] = s, this.createdBeans.push(s);
    }), e.beanInitComparator && this.createdBeans.sort(e.beanInitComparator), this.initBeans(this.createdBeans);
  }
  getBeanInstances() {
    return Object.values(this.beans);
  }
  createBean(e, t) {
    return this.initBeans([e], t), e;
  }
  initBeans(e, t) {
    const n = this.beans;
    e.forEach((o) => {
      var s, i;
      (s = o.preWireBeans) == null || s.call(o, n), (i = o.wireBeans) == null || i.call(o, n);
    }), e.forEach((o) => {
      var s;
      return (s = o.preConstruct) == null ? void 0 : s.call(o);
    }), t && e.forEach(t), e.forEach((o) => {
      var s;
      return (s = o.postConstruct) == null ? void 0 : s.call(o);
    });
  }
  getBeans() {
    return this.beans;
  }
  getBean(e) {
    return this.beans[e];
  }
  getId() {
    return this.id;
  }
  destroy() {
    var t;
    if (this.destroyed)
      return;
    this.destroyed = !0;
    const e = this.getBeanInstances();
    this.beanDestroyComparator && e.sort(this.beanDestroyComparator), this.destroyBeans(e), this.beans = {}, this.createdBeans = [], (t = this.destroyCallback) == null || t.call(this);
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e) {
    var t;
    (t = e == null ? void 0 : e.destroy) == null || t.call(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e) {
    if (e)
      for (let t = 0; t < e.length; t++)
        this.destroyBean(e[t]);
    return [];
  }
  isDestroyed() {
    return this.destroyed;
  }
}, KM = 0, ZM = class extends Oo {
  constructor() {
    super(...arguments), this.beanName = "environment", this.paramsClass = `ag-theme-params-${++KM}`, this.globalCSS = [];
  }
  wireBeans(e) {
    this.eRootDiv = e.eRootDiv;
  }
  postConstruct() {
    const { gos: e, eRootDiv: t } = this;
    e.setInstanceDomData(t), this.eStyleContainer = e.get("themeStyleContainer") ?? (t.getRootNode() === document ? document.head : t), this.cssLayer = e.get("themeCssLayer"), this.styleNonce = e.get("styleNonce"), this.addManagedPropertyListener("theme", () => this.handleThemeChange()), this.handleThemeChange(), this.initVariables(), this.addDestroyFunc(() => xM(this)), this.mutationObserver = new MutationObserver(() => {
      this.fireStylesChangedEvent("themeChanged");
    }), this.addDestroyFunc(() => this.mutationObserver.disconnect());
  }
  applyThemeClasses(e, t = []) {
    const { theme: n } = this;
    let o;
    n ? o = `${this.paramsClass} ${n._getCssClass()}` : o = this.applyLegacyThemeClasses();
    for (const s of Array.from(e.classList))
      s.startsWith("ag-theme-") && e.classList.remove(s);
    if (o) {
      const s = e.className;
      e.className = `${s}${s ? " " : ""}${o}${t != null && t.length ? ` ${t.join(" ")}` : ""}`;
    }
  }
  applyLegacyThemeClasses() {
    let e = "";
    this.mutationObserver.disconnect();
    let t = this.eRootDiv;
    for (; t; ) {
      let n = !1;
      for (const o of Array.from(t.classList))
        o.startsWith("ag-theme-") && (n = !0, e = e ? `${e} ${o}` : o);
      n && this.mutationObserver.observe(t, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t = t.parentElement;
    }
    return e;
  }
  addGlobalCSS(e, t) {
    this.theme ? xr(e, this.eStyleContainer, t, this.cssLayer, 0, this.styleNonce) : this.globalCSS.push([e, t]);
  }
  handleThemeChange() {
    const { gos: e, theme: t } = this, n = e.get("theme");
    let o;
    if (n === "legacy")
      o = void 0;
    else {
      const s = n ?? this.getDefaultTheme();
      s instanceof Cw ? o = s : this.themeError(s);
    }
    o !== t && this.handleNewTheme(o), this.postProcessThemeChange(o, n);
  }
  handleNewTheme(e) {
    const { gos: t, eRootDiv: n, globalCSS: o } = this, s = this.getAdditionalCss();
    if (e) {
      SM(this), gw(this.eStyleContainer, this.cssLayer, this.styleNonce, s);
      for (const [r, a] of o)
        xr(r, this.eStyleContainer, a, this.cssLayer, 0, this.styleNonce);
      o.length = 0;
    }
    this.theme = e, e == null || e._startUse({
      loadThemeGoogleFonts: t.get("loadThemeGoogleFonts"),
      styleContainer: this.eStyleContainer,
      cssLayer: this.cssLayer,
      nonce: this.styleNonce,
      moduleCss: s
    });
    let i = this.eParamsStyle;
    if (!i) {
      i = this.eParamsStyle = Qa({ tag: "style" });
      const r = t.get("styleNonce");
      r && i.setAttribute("nonce", r), n.appendChild(i);
    }
    hp || (i.textContent = (e == null ? void 0 : e._getPerInstanceCss(this.paramsClass)) || ""), this.applyThemeClasses(n), this.fireStylesChangedEvent("themeChanged");
  }
}, qM = class extends Oo {
  constructor() {
    super(...arguments), this.beanName = "registry";
  }
  registerDynamicBeans(e) {
    if (e) {
      this.dynamicBeans ?? (this.dynamicBeans = {});
      for (const t of Object.keys(e))
        this.dynamicBeans[t] = e[t];
    }
  }
  createDynamicBean(e, t, ...n) {
    if (!this.dynamicBeans)
      throw new Error(this.getDynamicError(e, !0));
    const o = this.dynamicBeans[e];
    if (o == null) {
      if (t)
        throw new Error(this.getDynamicError(e, !1));
      return;
    }
    return new o(...n);
  }
}, jM = class extends Oo {
  constructor() {
    super(...arguments), this.beanName = "eventSvc", this.eventServiceType = "global", this.globalSvc = new Fs();
  }
  addListener(e, t, n) {
    this.globalSvc.addEventListener(e, t, n);
  }
  removeListener(e, t, n) {
    this.globalSvc.removeEventListener(e, t, n);
  }
  addGlobalListener(e, t = !1) {
    this.globalSvc.addGlobalListener(e, t);
  }
  removeGlobalListener(e, t = !1) {
    this.globalSvc.removeGlobalListener(e, t);
  }
  dispatchEvent(e) {
    this.globalSvc.dispatchEvent(this.gos.addCommon(e));
  }
  dispatchEventOnce(e) {
    this.globalSvc.dispatchEventOnce(this.gos.addCommon(e));
  }
}, yw = class extends Oo {
  constructor(e, t) {
    super(), this.ctrl = e, t && (this.beans = t);
  }
  postConstruct() {
    this.refreshTooltip();
  }
  /**
   *
   * @param tooltip The tooltip value
   * @param allowEmptyString Set it to true to allow the title to be set to `''`. This is necessary
   * when the browser adds a default tooltip the element and the tooltip service will be displayed
   * next to a browser tooltip causing confusion.
   */
  setBrowserTooltip(e, t) {
    const n = "title", o = this.ctrl.getGui();
    o && (e != null && (e != "" || t) ? o.setAttribute(n, e) : o.removeAttribute(n));
  }
  updateTooltipText() {
    const { getTooltipValue: e } = this.ctrl;
    e && (this.tooltip = e());
  }
  createTooltipFeatureIfNeeded() {
    if (this.tooltipManager == null) {
      const e = this.beans.registry.createDynamicBean("tooltipStateManager", !0, this.ctrl, () => this.tooltip);
      e && (this.tooltipManager = this.createBean(e, this.beans.context));
    }
  }
  attemptToShowTooltip() {
    var e;
    (e = this.tooltipManager) == null || e.prepareToShowTooltip();
  }
  attemptToHideTooltip() {
    var e;
    (e = this.tooltipManager) == null || e.hideTooltip();
  }
  setTooltipAndRefresh(e) {
    this.tooltip = e, this.refreshTooltip();
  }
  refreshTooltip(e) {
    this.browserTooltips = this.beans.gos.get("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? (this.setBrowserTooltip(this.tooltip), this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context)) : (this.setBrowserTooltip(e ? "" : null, e), this.createTooltipFeatureIfNeeded());
  }
  destroy() {
    this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context), super.destroy();
  }
}, YM = 1e3, QM = 1e3, wm = 100, ym, wl = !1, JM = class extends Oo {
  constructor(e, t) {
    super(), this.tooltipCtrl = e, this.getTooltipValue = t, this.interactionEnabled = !1, this.isInteractingWithTooltip = !1, this.state = 0, this.tooltipInstanceCount = 0, this.tooltipMouseTrack = !1;
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    this.gos.get("tooltipInteraction") && (this.interactionEnabled = !0), this.tooltipTrigger = this.getTooltipTrigger(), this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
    const e = this.tooltipCtrl.getGui();
    this.tooltipTrigger === 0 && this.addManagedListeners(e, {
      mouseenter: this.onMouseEnter.bind(this),
      mouseleave: this.onMouseLeave.bind(this)
    }), this.tooltipTrigger === 1 && this.addManagedListeners(e, {
      focusin: this.onFocusIn.bind(this),
      focusout: this.onFocusOut.bind(this)
    }), this.addManagedListeners(e, { mousemove: this.onMouseMove.bind(this) }), this.interactionEnabled || this.addManagedListeners(e, {
      mousedown: this.onMouseDown.bind(this),
      keydown: this.onKeyDown.bind(this)
    });
  }
  getGridOptionsTooltipDelay(e) {
    const t = this.gos.get(e);
    return Math.max(200, t);
  }
  getTooltipDelay(e) {
    var t, n, o, s;
    return e === "show" ? ((n = (t = this.tooltipCtrl).getTooltipShowDelayOverride) == null ? void 0 : n.call(t)) ?? this.getGridOptionsTooltipDelay("tooltipShowDelay") : ((s = (o = this.tooltipCtrl).getTooltipHideDelayOverride) == null ? void 0 : s.call(o)) ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
  }
  destroy() {
    this.setToDoNothing(), super.destroy();
  }
  getTooltipTrigger() {
    const e = this.gos.get("tooltipTrigger");
    return !e || e === "hover" ? 0 : 1;
  }
  onMouseEnter(e) {
    this.interactionEnabled && this.interactiveTooltipTimeoutId && (this.unlockService(), this.startHideTimeout()), !Ss() && (wl ? this.showTooltipTimeoutId = window.setTimeout(() => {
      this.prepareToShowTooltip(e);
    }, wm) : this.prepareToShowTooltip(e));
  }
  onMouseMove(e) {
    this.lastMouseEvent && (this.lastMouseEvent = e), this.tooltipMouseTrack && this.state === 2 && this.tooltipComp && this.positionTooltip();
  }
  onMouseDown() {
    this.setToDoNothing();
  }
  onMouseLeave() {
    this.interactionEnabled ? this.lockService() : this.setToDoNothing();
  }
  onFocusIn() {
    this.prepareToShowTooltip();
  }
  onFocusOut(e) {
    var s;
    const t = e.relatedTarget, n = this.tooltipCtrl.getGui(), o = (s = this.tooltipComp) == null ? void 0 : s.getGui();
    this.isInteractingWithTooltip || n.contains(t) || this.interactionEnabled && (o != null && o.contains(t)) || this.setToDoNothing();
  }
  onKeyDown() {
    this.isInteractingWithTooltip && (this.isInteractingWithTooltip = !1), this.setToDoNothing();
  }
  prepareToShowTooltip(e) {
    if (this.state != 0 || wl)
      return;
    let t = 0;
    e && (t = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show")), this.lastMouseEvent = e || null, this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), t), this.state = 1;
  }
  isLastTooltipHiddenRecently() {
    return Date.now() - ym < YM;
  }
  setToDoNothing(e) {
    !e && this.state === 2 && this.hideTooltip(), this.onBodyScrollEventCallback && (this.onBodyScrollEventCallback(), this.onBodyScrollEventCallback = void 0), this.clearEventHandlers(), this.onDocumentKeyDownCallback && (this.onDocumentKeyDownCallback(), this.onDocumentKeyDownCallback = void 0), this.clearTimeouts(), this.state = 0, this.lastMouseEvent = null;
  }
  showTooltip() {
    var s, i;
    const e = this.getTooltipValue(), t = this.tooltipCtrl;
    if (!ue(e) || t.shouldDisplayTooltip && !t.shouldDisplayTooltip()) {
      this.setToDoNothing();
      return;
    }
    const n = this.gos.addCommon({
      location: ((s = t.getLocation) == null ? void 0 : s.call(t)) ?? "UNKNOWN",
      value: e,
      hideTooltipCallback: () => this.hideTooltip(!0),
      ...(i = t.getAdditionalParams) == null ? void 0 : i.call(t)
    });
    this.state = 2, this.tooltipInstanceCount++;
    const o = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
    this.createTooltipComp(n, o);
  }
  hideTooltip(e) {
    !e && this.isInteractingWithTooltip || (this.tooltipComp && (this.destroyTooltipComp(), ym = Date.now()), this.eventSvc.dispatchEvent({
      type: "tooltipHide",
      parentGui: this.tooltipCtrl.getGui()
    }), e && (this.isInteractingWithTooltip = !1), this.setToDoNothing(!0));
  }
  newTooltipComponentCallback(e, t) {
    var r;
    if (this.state !== 2 || this.tooltipInstanceCount !== e) {
      this.destroyBean(t);
      return;
    }
    const o = t.getGui();
    this.tooltipComp = t, o.classList.contains("ag-tooltip") || o.classList.add("ag-tooltip-custom"), this.tooltipTrigger === 0 && o.classList.add("ag-tooltip-animate"), this.interactionEnabled && o.classList.add("ag-tooltip-interactive");
    const s = this.getLocaleTextFunc(), i = (r = this.popupSvc) == null ? void 0 : r.addPopup({
      eChild: o,
      ariaLabel: s("ariaLabelTooltip", "Tooltip")
    });
    if (i && (this.tooltipPopupDestroyFunc = i.hideFunc), this.positionTooltip(), this.tooltipTrigger === 1) {
      const a = () => this.setToDoNothing();
      [this.onBodyScrollEventCallback] = this.addManagedEventListeners({
        bodyScroll: a
      }), this.setEventHandlers(a);
    }
    this.interactionEnabled && ([this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(o, {
      mouseenter: this.onTooltipMouseEnter.bind(this),
      mouseleave: this.onTooltipMouseLeave.bind(this)
    }), [this.onDocumentKeyDownCallback] = this.addManagedElementListeners(Bt(this.beans), {
      keydown: (a) => {
        o.contains(a == null ? void 0 : a.target) || this.onKeyDown();
      }
    }), this.tooltipTrigger === 1 && ([this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(o, {
      focusin: this.onTooltipFocusIn.bind(this),
      focusout: this.onTooltipFocusOut.bind(this)
    }))), this.eventSvc.dispatchEvent({
      type: "tooltipShow",
      tooltipGui: o,
      parentGui: this.tooltipCtrl.getGui()
    }), this.startHideTimeout();
  }
  onTooltipMouseEnter() {
    this.isInteractingWithTooltip = !0, this.unlockService();
  }
  onTooltipMouseLeave() {
    this.isTooltipFocused() || (this.isInteractingWithTooltip = !1, this.lockService());
  }
  onTooltipFocusIn() {
    this.isInteractingWithTooltip = !0;
  }
  isTooltipFocused() {
    var n;
    const e = (n = this.tooltipComp) == null ? void 0 : n.getGui(), t = je(this.beans);
    return !!e && e.contains(t);
  }
  onTooltipFocusOut(e) {
    const t = this.tooltipCtrl.getGui();
    this.isTooltipFocused() || (this.isInteractingWithTooltip = !1, t.contains(e.relatedTarget) ? this.startHideTimeout() : this.hideTooltip());
  }
  positionTooltip() {
    var t, n;
    const e = {
      type: "tooltip",
      ePopup: this.tooltipComp.getGui(),
      nudgeY: 18,
      skipObserver: this.tooltipMouseTrack
    };
    this.lastMouseEvent ? (t = this.popupSvc) == null || t.positionPopupUnderMouseEvent({
      ...e,
      mouseEvent: this.lastMouseEvent
    }) : (n = this.popupSvc) == null || n.positionPopupByComponent({
      ...e,
      eventSource: this.tooltipCtrl.getGui(),
      position: "under",
      keepWithinBounds: !0,
      nudgeY: 5
    });
  }
  destroyTooltipComp() {
    this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
    const e = this.tooltipPopupDestroyFunc, t = this.tooltipComp, n = this.tooltipTrigger === 0 ? QM : 0;
    window.setTimeout(() => {
      e(), this.destroyBean(t);
    }, n), this.clearTooltipListeners(), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
  }
  clearTooltipListeners() {
    [
      this.tooltipMouseEnterListener,
      this.tooltipMouseLeaveListener,
      this.tooltipFocusInListener,
      this.tooltipFocusOutListener
    ].forEach((e) => {
      e && e();
    }), this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
  }
  lockService() {
    wl = !0, this.interactiveTooltipTimeoutId = window.setTimeout(() => {
      this.unlockService(), this.setToDoNothing();
    }, wm);
  }
  unlockService() {
    wl = !1, this.clearInteractiveTimeout();
  }
  startHideTimeout() {
    this.clearHideTimeout(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
  }
  clearShowTimeout() {
    this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0);
  }
  clearHideTimeout() {
    this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
  }
  clearInteractiveTimeout() {
    this.interactiveTooltipTimeoutId && (window.clearTimeout(this.interactiveTooltipTimeoutId), this.interactiveTooltipTimeoutId = void 0);
  }
  clearTimeouts() {
    this.clearShowTimeout(), this.clearHideTimeout(), this.clearInteractiveTimeout();
  }
}, XM = class extends yw {
  constructor(e, t, n) {
    super(e, n), this.highlightTracker = t, this.onHighlight = this.onHighlight.bind(this);
  }
  postConstruct() {
    super.postConstruct(), this.wireHighlightListeners();
  }
  wireHighlightListeners() {
    this.addManagedPropertyListener("tooltipTrigger", ({ currentValue: e }) => {
      this.setTooltipMode(e);
    }), this.setTooltipMode(this.gos.get("tooltipTrigger")), this.highlightTracker.addEventListener("itemHighlighted", this.onHighlight);
  }
  onHighlight(e) {
    this.tooltipMode === 1 && (e.highlighted ? this.attemptToShowTooltip() : this.attemptToHideTooltip());
  }
  setTooltipMode(e = "focus") {
    this.tooltipMode = e === "focus" ? 1 : 0;
  }
  destroy() {
    this.highlightTracker.removeEventListener("itemHighlighted", this.onHighlight), super.destroy();
  }
}, yl = 0, eI = 200, tI = class extends Oo {
  constructor() {
    super(...arguments), this.beanName = "popupSvc", this.popupList = [];
  }
  getPopupParent() {
    const e = this.gos.get("popupParent");
    return e || this.getDefaultPopupParent();
  }
  positionPopupUnderMouseEvent(e) {
    const { ePopup: t, nudgeX: n, nudgeY: o, skipObserver: s } = e;
    this.positionPopup({
      ePopup: t,
      nudgeX: n,
      nudgeY: o,
      keepWithinBounds: !0,
      skipObserver: s,
      updatePosition: () => this.calculatePointerAlign(e.mouseEvent),
      postProcessCallback: () => this.callPostProcessPopup(e, e.type, e.ePopup, null, e.mouseEvent)
    });
  }
  calculatePointerAlign(e) {
    const t = this.getParentRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  positionPopupByComponent(e) {
    const {
      ePopup: t,
      nudgeX: n,
      nudgeY: o,
      keepWithinBounds: s,
      eventSource: i,
      alignSide: r = "left",
      position: a = "over",
      type: l
    } = e, d = i.getBoundingClientRect(), c = this.getParentRect();
    this.setAlignedTo(i, t);
    const u = () => {
      let h = d.left - c.left;
      r === "right" && (h -= t.offsetWidth - d.width);
      let g;
      return a === "over" ? (g = d.top - c.top, this.setAlignedStyles(t, "over")) : (this.setAlignedStyles(t, "under"), this.shouldRenderUnderOrAbove(t, d, c, e.nudgeY || 0) === "under" ? g = d.top - c.top + d.height : g = d.top - t.offsetHeight - (o || 0) * 2 - c.top), { x: h, y: g };
    };
    this.positionPopup({
      ePopup: t,
      nudgeX: n,
      nudgeY: o,
      keepWithinBounds: s,
      updatePosition: u,
      postProcessCallback: () => this.callPostProcessPopup(e, l, t, i, null)
    });
  }
  shouldRenderUnderOrAbove(e, t, n, o) {
    const s = n.bottom - t.bottom, i = t.top - n.top, r = e.offsetHeight + o;
    return s > r ? "under" : i > r || i > s ? "above" : "under";
  }
  setAlignedStyles(e, t) {
    const n = this.getPopupIndex(e);
    if (n === -1)
      return;
    const o = this.popupList[n], { alignedToElement: s } = o;
    !s || (["right", "left", "over", "above", "under"].forEach((r) => {
      s.classList.remove(`ag-has-popup-positioned-${r}`), e.classList.remove(`ag-popup-positioned-${r}`);
    }), !t) || (s.classList.add(`ag-has-popup-positioned-${t}`), e.classList.add(`ag-popup-positioned-${t}`));
  }
  setAlignedTo(e, t) {
    const n = this.getPopupIndex(t);
    if (n !== -1) {
      const o = this.popupList[n];
      o.alignedToElement = e;
    }
  }
  positionPopup(e) {
    const { ePopup: t, keepWithinBounds: n, nudgeX: o, nudgeY: s, skipObserver: i, updatePosition: r } = e, a = { width: 0, height: 0 }, l = (d = !1) => {
      let { x: c, y: u } = r();
      d && t.clientWidth === a.width && t.clientHeight === a.height || (a.width = t.clientWidth, a.height = t.clientHeight, o && (c += o), s && (u += s), n && (c = this.keepXYWithinBounds(
        t,
        c,
        1
        /* Horizontal */
      ), u = this.keepXYWithinBounds(
        t,
        u,
        0
        /* Vertical */
      )), t.style.left = `${c}px`, t.style.top = `${u}px`, e.postProcessCallback && e.postProcessCallback());
    };
    if (l(), !i) {
      const d = Bo(this.beans, t, () => l(!0));
      setTimeout(() => d(), eI);
    }
  }
  getParentRect() {
    const e = Bt(this.beans);
    let t = this.getPopupParent();
    return t === e.body ? t = e.documentElement : getComputedStyle(t).position === "static" && (t = t.offsetParent), hC(t);
  }
  keepXYWithinBounds(e, t, n) {
    const o = n === 0, s = o ? "clientHeight" : "clientWidth", i = o ? "top" : "left", r = o ? "height" : "width", a = o ? "scrollTop" : "scrollLeft", l = Bt(this.beans), d = l.documentElement, c = this.getPopupParent(), u = e.getBoundingClientRect(), h = c.getBoundingClientRect(), g = l.documentElement.getBoundingClientRect(), p = c === l.body, f = Math.ceil(u[r]);
    let C = p ? (o ? Kg : Ia)(d) + d[a] : c[s];
    p && (C -= Math.abs(g[i] - h[i]));
    const w = C - f;
    return Math.min(Math.max(t, 0), Math.abs(w));
  }
  addPopup(e) {
    const { eChild: t, ariaLabel: n, ariaOwns: o, alwaysOnTop: s, positionCallback: i, anchorToElement: r } = e, a = this.getPopupIndex(t);
    if (a !== -1)
      return { hideFunc: this.popupList[a].hideFunc };
    this.initialisePopupPosition(t);
    const l = this.createPopupWrapper(t, !!s, n, o), d = this.addEventListenersToPopup({ ...e, wrapperEl: l });
    return i && i(), this.addPopupToPopupList(t, l, d, r), {
      hideFunc: d
    };
  }
  initialisePopupPosition(e) {
    const n = this.getPopupParent().getBoundingClientRect();
    ue(e.style.top) || (e.style.top = `${n.top * -1}px`), ue(e.style.left) || (e.style.left = `${n.left * -1}px`);
  }
  createPopupWrapper(e, t, n, o) {
    const s = this.getPopupParent(), { environment: i, gos: r } = this.beans, a = Qa({ tag: "div" });
    return i.applyThemeClasses(a), a.classList.add("ag-popup"), e.classList.add(r.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), e.hasAttribute("role") || hn(e, "dialog"), n ? yt(e, n) : o && (e.id || (e.id = `popup-component-${yl}`), tm(o, e.id)), a.appendChild(e), s.appendChild(a), t ? this.setAlwaysOnTop(e, !0) : this.bringPopupToFront(e), a;
  }
  addEventListenersToPopup(e) {
    const t = this.beans, n = Bt(t), o = this.getPopupParent(), { wrapperEl: s, eChild: i, closedCallback: r, afterGuiAttached: a, closeOnEsc: l, modal: d, ariaOwns: c } = e;
    let u = !1;
    const h = (m) => {
      if (!s.contains(je(t)))
        return;
      m.key === O.ESCAPE && !this.isStopPropagation(m) && f({ keyboardEvent: m });
    }, g = (m) => f({ mouseEvent: m }), p = (m) => f({ touchEvent: m }), f = (m = {}) => {
      const { mouseEvent: C, touchEvent: w, keyboardEvent: b, forceHide: A } = m;
      !A && // we don't hide popup if the event was on the child, or any
      // children of this child
      (this.isEventFromCurrentPopup({ mouseEvent: C, touchEvent: w }, i) || // this method should only be called once. the client can have different
      // paths, each one wanting to close, so this method may be called multiple times.
      u) || (u = !0, o.removeChild(s), n.removeEventListener("keydown", h), n.removeEventListener("mousedown", g), n.removeEventListener("touchstart", p), n.removeEventListener("contextmenu", g), this.eventSvc.removeListener("dragStarted", g), r && r(C || w || b), this.removePopupFromPopupList(i, c));
    };
    return a && a({ hidePopup: f }), window.setTimeout(() => {
      l && n.addEventListener("keydown", h), d && (n.addEventListener("mousedown", g), this.eventSvc.addListener("dragStarted", g), n.addEventListener("touchstart", p), n.addEventListener("contextmenu", g));
    }, 0), f;
  }
  addPopupToPopupList(e, t, n, o) {
    this.popupList.push({
      element: e,
      wrapper: t,
      hideFunc: n,
      instanceId: yl,
      isAnchored: !!o
    }), o && this.setPopupPositionRelatedToElement(e, o), yl = yl + 1;
  }
  getPopupIndex(e) {
    return this.popupList.findIndex((t) => t.element === e);
  }
  setPopupPositionRelatedToElement(e, t) {
    const n = this.getPopupIndex(e);
    if (n === -1)
      return;
    const o = this.popupList[n];
    if (o.stopAnchoringPromise && o.stopAnchoringPromise.then((i) => i && i()), o.stopAnchoringPromise = void 0, o.isAnchored = !1, !t)
      return;
    const s = this.keepPopupPositionedRelativeTo({
      element: t,
      ePopup: e,
      hidePopup: o.hideFunc
    });
    return o.stopAnchoringPromise = s, o.isAnchored = !0, s;
  }
  removePopupFromPopupList(e, t) {
    this.setAlignedStyles(e, null), this.setPopupPositionRelatedToElement(e, null), t && tm(t, null), this.popupList = this.popupList.filter((n) => n.element !== e);
  }
  keepPopupPositionedRelativeTo(e) {
    const t = this.getPopupParent(), n = t.getBoundingClientRect(), { element: o, ePopup: s } = e, i = o.getBoundingClientRect(), r = (u) => parseInt(u.substring(0, u.length - 1), 10), a = (u, h) => {
      const g = n[u] - i[u], p = r(s.style[u]);
      return {
        initialDiff: g,
        lastDiff: g,
        initial: p,
        last: p,
        direction: h
      };
    }, l = a(
      "top",
      0
      /* Vertical */
    ), d = a(
      "left",
      1
      /* Horizontal */
    ), c = this.beans.frameworkOverrides;
    return new tt((u) => {
      c.wrapIncoming(() => {
        dF(() => {
          const h = t.getBoundingClientRect(), g = o.getBoundingClientRect();
          if (g.top == 0 && g.left == 0 && g.height == 0 && g.width == 0) {
            e.hidePopup();
            return;
          }
          const f = (m, C) => {
            const w = r(s.style[C]);
            m.last !== w && (m.initial = w, m.last = w);
            const b = h[C] - g[C];
            if (b != m.lastDiff) {
              const A = this.keepXYWithinBounds(
                s,
                m.initial + m.initialDiff - b,
                m.direction
              );
              s.style[C] = `${A}px`, m.last = A;
            }
            m.lastDiff = b;
          };
          f(l, "top"), f(d, "left");
        }, 200).then((h) => {
          u(() => {
            h != null && window.clearInterval(h);
          });
        });
      }, "popupPositioning");
    });
  }
  isEventFromCurrentPopup(e, t) {
    const { mouseEvent: n, touchEvent: o } = e, s = n || o;
    if (!s)
      return !1;
    const i = this.getPopupIndex(t);
    if (i === -1)
      return !1;
    for (let r = i; r < this.popupList.length; r++) {
      const a = this.popupList[r];
      if (ph(a.element, s))
        return !0;
    }
    return this.isElementWithinCustomPopup(s.target);
  }
  isElementWithinCustomPopup(e) {
    const t = Bt(this.beans);
    for (; e && e !== t.body; ) {
      if (e.classList.contains("ag-custom-component-popup") || e.parentElement === null)
        return !0;
      e = e.parentElement;
    }
    return !1;
  }
  getWrapper(e) {
    for (; !e.classList.contains("ag-popup") && e.parentElement; )
      e = e.parentElement;
    return e.classList.contains("ag-popup") ? e : null;
  }
  setAlwaysOnTop(e, t) {
    const n = this.getWrapper(e);
    n && (n.classList.toggle("ag-always-on-top", !!t), t && this.bringPopupToFront(n));
  }
  /** @returns true if moved */
  bringPopupToFront(e) {
    const t = this.getPopupParent(), n = Array.prototype.slice.call(t.querySelectorAll(".ag-popup")), o = n.length, s = this.getWrapper(e);
    if (!s || o <= 1 || !t.contains(e))
      return;
    const i = [], r = [];
    for (const h of n)
      h !== s && (h.classList.contains("ag-always-on-top") ? r.push(h) : i.push(h));
    const a = [], l = r.length, u = s.classList.contains("ag-always-on-top") || !l ? [...i, ...r, s] : [...i, s, ...r];
    for (let h = 0; h <= o; h++) {
      const g = u[h];
      if (n[h] === u[h] || g === s)
        continue;
      g.querySelectorAll("div").forEach((f) => {
        f.scrollTop !== 0 && a.push([f, f.scrollTop]);
      }), h === 0 ? t.insertAdjacentElement("afterbegin", g) : u[h - 1].insertAdjacentElement("afterend", g);
    }
    for (; a.length; ) {
      const h = a.pop();
      h[0].scrollTop = h[1];
    }
  }
}, nI = class extends fc {
  constructor() {
    super({ tag: "div", cls: "ag-tooltip" });
  }
  // will need to type params
  init(e) {
    const { value: t } = e, n = this.getGui();
    n.textContent = Ii(t);
    const o = e.location.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
    n.classList.add(`ag-${o}-tooltip`);
  }
}, oI = class extends Oo {
  constructor() {
    super(...arguments), this.beanName = "dragSvc", this.dragEndFunctions = [], this.dragSources = [];
  }
  destroy() {
    const { dragSources: e } = this;
    e.forEach(this.removeListener.bind(this)), e.length = 0, super.destroy();
  }
  removeListener(e) {
    const t = e.dragSource.eElement, n = e.mouseDownListener;
    if (t.removeEventListener("mousedown", n), e.touchEnabled) {
      const o = e.touchStartListener;
      t.removeEventListener("touchstart", o, { passive: !0 });
    }
  }
  removeDragSource(e) {
    const { dragSources: t } = this, n = t.find((o) => o.dragSource === e);
    n && (this.removeListener(n), $t(t, n));
  }
  addDragSource(e) {
    const t = this.onMouseDown.bind(this, e), { eElement: n, includeTouch: o, stopPropagationForTouch: s } = e;
    n.addEventListener("mousedown", t);
    let i = null;
    const r = this.gos.get("suppressTouch");
    o && !r && (i = (a) => {
      Ug(a.target) || (s && a.stopPropagation(), this.onTouchStart(e, a));
    }, n.addEventListener("touchstart", i, { passive: !1 })), this.dragSources.push({
      dragSource: e,
      mouseDownListener: t,
      touchStartListener: i,
      touchEnabled: !!o
    });
  }
  // gets called whenever mouse down on any drag source
  onTouchStart(e, t) {
    this.currentDragParams = e, this.dragging = !1;
    const n = t.touches[0];
    this.touchLastTime = n, this.touchStart = n;
    const o = (l) => this.onTouchMove(l, e.eElement), s = (l) => this.onTouchUp(l, e.eElement), i = (l) => {
      l.cancelable && l.preventDefault();
    }, r = t.target, a = [
      // Prevents the page document from moving while we are dragging items around.
      // preventDefault needs to be called in the touchmove listener and never inside the
      // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
      {
        target: mi(this.beans),
        type: "touchmove",
        listener: i,
        options: { passive: !1 }
      },
      { target: r, type: "touchmove", listener: o, options: { passive: !0 } },
      { target: r, type: "touchend", listener: s, options: { passive: !0 } },
      { target: r, type: "touchcancel", listener: s, options: { passive: !0 } }
    ];
    this.addTemporaryEvents(a), e.dragStartPixels === 0 && this.onCommonMove(n, this.touchStart, e.eElement);
  }
  // gets called whenever mouse down on any drag source
  onMouseDown(e, t) {
    const n = t;
    if (e.skipMouseEvent && e.skipMouseEvent(t) || n._alreadyProcessedByDragService || (n._alreadyProcessedByDragService = !0, t.button !== 0))
      return;
    this.shouldPreventMouseEvent(t) && t.preventDefault(), this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = t, this.startTarget = t.target;
    const o = (d) => this.onMouseMove(d, e.eElement), s = (d) => this.onMouseUp(d, e.eElement), i = (d) => d.preventDefault(), r = (d) => {
      d.key === O.ESCAPE && this.cancelDrag(e.eElement);
    }, a = mi(this.beans), l = [
      { target: a, type: "mousemove", listener: o },
      { target: a, type: "mouseup", listener: s },
      { target: a, type: "contextmenu", listener: i },
      { target: a, type: "keydown", listener: r }
    ];
    this.addTemporaryEvents(l), e.dragStartPixels === 0 && this.onMouseMove(t, e.eElement);
  }
  addTemporaryEvents(e) {
    e.forEach((t) => {
      const { target: n, type: o, listener: s, options: i } = t;
      n.addEventListener(o, s, i);
    }), this.dragEndFunctions.push(() => {
      e.forEach((t) => {
        const { target: n, type: o, listener: s, options: i } = t;
        n.removeEventListener(o, s, i);
      });
    });
  }
  // returns true if the event is close to the original event by X pixels either vertically or horizontally.
  // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
  isEventNearStartEvent(e, t) {
    const { dragStartPixels: n } = this.currentDragParams, o = ue(n) ? n : 4;
    return wC(e, t, o);
  }
  getFirstActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  onCommonMove(e, t, n) {
    var o;
    if (!this.dragging) {
      if (this.isEventNearStartEvent(e, t))
        return;
      if (this.dragging = !0, this.eventSvc.dispatchEvent({
        type: "dragStarted",
        target: n
      }), this.currentDragParams.onDragStart(t), !this.currentDragParams) {
        this.dragging = !1;
        return;
      }
      this.currentDragParams.onDragging(t);
    }
    (o = this.currentDragParams) == null || o.onDragging(e);
  }
  onTouchMove(e, t) {
    const n = this.getFirstActiveTouch(e.touches);
    n && this.onCommonMove(n, this.touchStart, t);
  }
  // only gets called after a mouse down - as this is only added after mouseDown
  // and is removed when mouseUp happens
  onMouseMove(e, t) {
    var n;
    os() && ((n = Bt(this.beans).getSelection()) == null || n.removeAllRanges()), this.shouldPreventMouseEvent(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, t);
  }
  shouldPreventMouseEvent(e) {
    const t = e.type === "mousemove", n = (o) => {
      const s = o.target, i = s == null ? void 0 : s.tagName.toLocaleLowerCase();
      return !!(i != null && i.match("^a$|textarea|input|select|button"));
    };
    return t && e.cancelable && Pa(this.beans, e) && !n(e);
  }
  onTouchUp(e, t) {
    let n = this.getFirstActiveTouch(e.changedTouches);
    n || (n = this.touchLastTime), this.onUpCommon(n, t);
  }
  onMouseUp(e, t) {
    this.onUpCommon(e, t);
  }
  onUpCommon(e, t) {
    this.dragging && (this.dragging = !1, this.currentDragParams.onDragStop(e), this.eventSvc.dispatchEvent({
      type: "dragStopped",
      target: t
    })), this.resetDragProperties();
  }
  cancelDrag(e) {
    var t, n;
    this.eventSvc.dispatchEvent({
      type: "dragCancelled",
      target: e
    }), (n = (t = this.currentDragParams) == null ? void 0 : t.onDragCancel) == null || n.call(t), this.resetDragProperties();
  }
  resetDragProperties() {
    this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null;
    const { dragEndFunctions: e } = this;
    e.forEach((t) => t()), e.length = 0;
  }
}, sI = class extends Oo {
  constructor() {
    super(...arguments), this.beanName = "dragAndDrop", this.dragSourceAndParamsList = [], this.dragItem = null, this.lastMouseEvent = null, this.lastDraggingEvent = null, this.dragSource = null, this.dragImageParent = null, this.dragImageCompPromise = null, this.dragImageComp = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0, this.dropTargets = [], this.lastDropTarget = null;
  }
  addDragSource(e, t = !1) {
    const n = {
      dragSource: e,
      eElement: e.eElement,
      dragStartPixels: e.dragStartPixels,
      onDragStart: (o) => this.onDragStart(e, o),
      onDragStop: this.onDragStop.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      includeTouch: t
    };
    this.dragSourceAndParamsList.push(n), this.beans.dragSvc.addDragSource(n);
  }
  setDragImageCompIcon(e, t = !1) {
    const n = this.dragImageComp;
    n && (t || this.dragImageLastIcon !== e) && (this.dragImageLastIcon = e, n.setIcon(e, t));
  }
  removeDragSource(e) {
    var s;
    const { dragSourceAndParamsList: t, beans: n } = this, o = t.find((i) => i.dragSource === e);
    o && ((s = n.dragSvc) == null || s.removeDragSource(o), $t(t, o));
  }
  destroy() {
    const { dragSourceAndParamsList: e, dropTargets: t, beans: n } = this, o = n.dragSvc;
    for (const s of e)
      o == null || o.removeDragSource(s);
    e.length = 0, t.length = 0, this.clearDragAndDropProperties(), super.destroy();
  }
  nudge() {
    const e = this.lastMouseEvent;
    e && this.onDragging(e, !0);
  }
  onDragStart(e, t) {
    var n;
    this.lastMouseEvent = t, this.dragSource = e, this.dragItem = e.getDragItem(), (n = e.onDragStarted) == null || n.call(e), this.createAndUpdateDragImageComp(e);
  }
  onDragStop(e) {
    var o, s;
    const { dragSource: t, lastDropTarget: n } = this;
    if ((o = t == null ? void 0 : t.onDragStopped) == null || o.call(t), n) {
      const i = this.dropTargetEvent(n, e, !1);
      (s = n.onDragStop) == null || s.call(n, i);
    }
    this.clearDragAndDropProperties();
  }
  onDragCancel() {
    var o, s;
    const { dragSource: e, lastDropTarget: t, lastMouseEvent: n } = this;
    if ((o = e == null ? void 0 : e.onDragCancelled) == null || o.call(e), t && n) {
      const i = this.dropTargetEvent(t, n, !1);
      (s = t.onDragCancel) == null || s.call(t, i);
    }
    this.clearDragAndDropProperties();
  }
  onDragging(e, t = !1) {
    var a, l, d;
    this.positionDragImageComp(e);
    const n = this.findCurrentDropTarget(e), { lastDropTarget: o, dragSource: s, dragItem: i } = this;
    let r = !1;
    if (n !== o) {
      if (r = !0, o) {
        const c = this.dropTargetEvent(o, e, t);
        (a = o.onDragLeave) == null || a.call(o, c);
      }
      if (o !== null && !n ? this.handleExit(s, i) : o === null && n && this.handleEnter(s, i), n) {
        const c = this.dropTargetEvent(n, e, t);
        (l = n.onDragEnter) == null || l.call(n, c);
      }
      this.lastDropTarget = n;
    } else if (n) {
      const c = this.dropTargetEvent(n, e, t);
      (d = n.onDragging) == null || d.call(n, c), c != null && c.changed && (r = !0);
    }
    this.lastMouseEvent = e, r && this.updateDragImageComp();
  }
  clearDragAndDropProperties() {
    this.removeDragImageComp(this.dragImageComp), this.dragImageCompPromise = null, this.dragImageParent = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0, this.lastMouseEvent = null, this.lastDraggingEvent = null, this.lastDropTarget = null, this.dragItem = null, this.dragSource = null;
  }
  getAllContainersFromDropTarget(e) {
    const t = e.getSecondaryContainers ? e.getSecondaryContainers() : null, n = [[e.getContainer()]];
    return t ? n.concat(t) : n;
  }
  // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
  isMouseOnDropTarget(e, t) {
    const n = this.getAllContainersFromDropTarget(t);
    let o = !1;
    const s = (a, l) => {
      for (const d of l) {
        const { width: c, height: u, left: h, right: g, top: p, bottom: f } = d.getBoundingClientRect();
        if (c === 0 || u === 0)
          return !1;
        const m = a.clientX >= h && a.clientX < g, C = a.clientY >= p && a.clientY < f;
        if (!m || !C)
          return !1;
      }
      return !0;
    };
    for (const a of n)
      if (s(e, a)) {
        o = !0;
        break;
      }
    const { eElement: i, type: r } = this.dragSource;
    return t.targetContainsSource && !t.getContainer().contains(i) ? !1 : o && t.isInterestedIn(r, i);
  }
  findCurrentDropTarget(e) {
    const t = this.dropTargets.filter((i) => this.isMouseOnDropTarget(e, i)), n = t.length;
    if (n === 0)
      return null;
    if (n === 1)
      return t[0];
    const s = mi(this.beans).elementsFromPoint(e.clientX, e.clientY);
    for (const i of s)
      for (const r of t)
        if (this.getAllContainersFromDropTarget(r).flatMap((l) => l).indexOf(i) !== -1)
          return r;
    return null;
  }
  addDropTarget(e) {
    this.dropTargets.push(e);
  }
  removeDropTarget(e) {
    this.dropTargets = this.dropTargets.filter((t) => t.getContainer() !== e.getContainer());
  }
  hasExternalDropZones() {
    return this.dropTargets.some((e) => e.external);
  }
  findExternalZone(e) {
    return this.dropTargets.find((t) => t.external && t.getContainer() === e) || null;
  }
  dropTargetEvent(e, t, n) {
    const { dragSource: o, dragItem: s, lastDraggingEvent: i, lastMouseEvent: r } = this, a = e.getContainer(), l = a.getBoundingClientRect(), { clientX: d, clientY: c } = t, u = d - ((r == null ? void 0 : r.clientX) || 0), h = c - ((r == null ? void 0 : r.clientY) || 0), g = this.createEvent({
      event: t,
      x: d - l.left,
      // relative x
      y: c - l.top,
      // relative y
      vDirection: h > 0 ? "down" : h < 0 ? "up" : null,
      hDirection: u < 0 ? "left" : u > 0 ? "right" : null,
      dragSource: o,
      fromNudge: n,
      dragItem: s,
      dropZoneTarget: a,
      dropTarget: (i == null ? void 0 : i.dropTarget) ?? null,
      // updated by rowDragFeature
      changed: !!(i != null && i.changed)
    });
    return this.lastDraggingEvent = g, g;
  }
  positionDragImageComp(e) {
    var n;
    const t = (n = this.dragImageComp) == null ? void 0 : n.getGui();
    t && fh(t, e, this.beans);
  }
  removeDragImageComp(e) {
    var t;
    if (this.dragImageComp === e && (this.dragImageComp = null), e) {
      const n = e.getGui();
      (t = this.dragImageParent) == null || t.removeChild(n), this.destroyBean(e);
    }
  }
  createAndUpdateDragImageComp(e) {
    const t = this.createDragImageComp(e) ?? null;
    this.dragImageCompPromise = t, t == null || t.then((n) => {
      if (t !== this.dragImageCompPromise || !this.lastMouseEvent || !this.isAlive()) {
        this.destroyBean(n);
        return;
      }
      this.dragImageCompPromise = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0;
      const o = this.dragImageComp;
      o !== n && (this.dragImageComp = n, this.removeDragImageComp(o)), n && (this.appendDragImageComp(n), this.updateDragImageComp());
    });
  }
  appendDragImageComp(e) {
    const t = e.getGui(), n = t.style;
    n.setProperty("position", "absolute"), n.setProperty("z-index", "9999"), this.gos.setInstanceDomData(t), this.beans.environment.applyThemeClasses(t), n.top = "20px", n.left = "20px";
    const o = sc(this.beans);
    this.dragImageParent = o, o ? o.appendChild(t) : this.warnNoBody();
  }
  updateDragImageComp() {
    var r;
    const { dragImageComp: e, dragSource: t, lastDropTarget: n, lastDraggingEvent: o, dragImageLastLabel: s } = this;
    if (!e)
      return;
    this.setDragImageCompIcon(((r = n == null ? void 0 : n.getIconName) == null ? void 0 : r.call(n, o)) ?? null);
    let i = t == null ? void 0 : t.dragItemName;
    typeof i == "function" && (i = i(o)), i || (i = ""), s !== i && (this.dragImageLastLabel = i, e.setLabel(i));
  }
}, ns = /* @__PURE__ */ ((e) => (e[e.ToolPanel = 0] = "ToolPanel", e[e.HeaderCell = 1] = "HeaderCell", e[e.RowDrag = 2] = "RowDrag", e[e.ChartPanel = 3] = "ChartPanel", e[e.AdvancedFilterBuilder = 4] = "AdvancedFilterBuilder", e))(ns || {}), iI = class extends sI {
  createEvent(e) {
    return ke(this.gos, e);
  }
  createDragImageComp(e) {
    const { gos: t, beans: n } = this, o = DF(
      n.userCompFactory,
      ke(t, {
        dragSource: e
      })
    );
    return o == null ? void 0 : o.newAgStackInstance();
  }
  handleEnter(e, t) {
    var n;
    (n = e == null ? void 0 : e.onGridEnter) == null || n.call(e, t);
  }
  handleExit(e, t) {
    var n;
    (n = e == null ? void 0 : e.onGridExit) == null || n.call(e, t);
  }
  warnNoBody() {
    Z(54);
  }
  isDropZoneWithinThisGrid(e) {
    return this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody.contains(e.dropZoneTarget);
  }
  registerGridDropTarget(e, t) {
    const n = {
      getContainer: e,
      isInterestedIn: (o) => o === 1 || o === 0,
      getIconName: () => "notAllowed"
    };
    this.addDropTarget(n), t.addDestroyFunc(() => this.removeDropTarget(n));
  }
};
function bw(e, t) {
  return e + "_" + t;
}
function Dt(e) {
  return e instanceof Ba;
}
var Ba = class extends U {
  constructor(e, t, n, o) {
    super(), this.providedColumnGroup = e, this.groupId = t, this.partId = n, this.pinned = o, this.isColumn = !1, this.displayedChildren = [], this.autoHeaderHeight = null, this.parent = null, this.colIdSanitised = sa(this.getUniqueId());
  }
  // as the user is adding and removing columns, the groups are recalculated.
  // this reset clears out all children, ready for children to be added again
  reset() {
    this.parent = null, this.children = null, this.displayedChildren = null;
  }
  getParent() {
    return this.parent;
  }
  getUniqueId() {
    return bw(this.groupId, this.partId);
  }
  isEmptyGroup() {
    return this.displayedChildren.length === 0;
  }
  isMoving() {
    const e = this.getProvidedColumnGroup().getLeafColumns();
    return !e || e.length === 0 ? !1 : e.every((t) => t.isMoving());
  }
  checkLeft() {
    if (this.displayedChildren.forEach((e) => {
      Dt(e) && e.checkLeft();
    }), this.displayedChildren.length > 0)
      if (this.gos.get("enableRtl")) {
        const t = Je(this.displayedChildren).getLeft();
        this.setLeft(t);
      } else {
        const e = this.displayedChildren[0].getLeft();
        this.setLeft(e);
      }
    else
      this.setLeft(null);
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  setLeft(e) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchLocalEvent({ type: "leftChanged" }));
  }
  getPinned() {
    return this.pinned;
  }
  getGroupId() {
    return this.groupId;
  }
  getPartId() {
    return this.partId;
  }
  getActualWidth() {
    var t;
    let e = 0;
    return (t = this.displayedChildren) == null || t.forEach((n) => {
      e += n.getActualWidth();
    }), e;
  }
  isResizable() {
    if (!this.displayedChildren)
      return !1;
    let e = !1;
    return this.displayedChildren.forEach((t) => {
      t.isResizable() && (e = !0);
    }), e;
  }
  getMinWidth() {
    let e = 0;
    return this.displayedChildren.forEach((t) => {
      e += t.getMinWidth();
    }), e;
  }
  addChild(e) {
    this.children || (this.children = []), this.children.push(e);
  }
  getDisplayedChildren() {
    return this.displayedChildren;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  getDisplayedLeafColumns() {
    const e = [];
    return this.addDisplayedLeafColumns(e), e;
  }
  getDefinition() {
    return this.providedColumnGroup.getColGroupDef();
  }
  getColGroupDef() {
    return this.providedColumnGroup.getColGroupDef();
  }
  isPadding() {
    return this.providedColumnGroup.isPadding();
  }
  isExpandable() {
    return this.providedColumnGroup.isExpandable();
  }
  isExpanded() {
    return this.providedColumnGroup.isExpanded();
  }
  setExpanded(e) {
    this.providedColumnGroup.setExpanded(e);
  }
  isAutoHeaderHeight() {
    var e;
    return !!((e = this.getColGroupDef()) != null && e.autoHeaderHeight);
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  addDisplayedLeafColumns(e) {
    this.displayedChildren.forEach((t) => {
      Io(t) ? e.push(t) : Dt(t) && t.addDisplayedLeafColumns(e);
    });
  }
  addLeafColumns(e) {
    this.children.forEach((t) => {
      Io(t) ? e.push(t) : Dt(t) && t.addLeafColumns(e);
    });
  }
  getChildren() {
    return this.children;
  }
  getColumnGroupShow() {
    return this.providedColumnGroup.getColumnGroupShow();
  }
  getProvidedColumnGroup() {
    return this.providedColumnGroup;
  }
  getPaddingLevel() {
    const e = this.getParent();
    return !this.isPadding() || !e || !e.isPadding() ? 0 : 1 + e.getPaddingLevel();
  }
  calculateDisplayedColumns() {
    this.displayedChildren = [];
    let e = this;
    for (; e != null && e.isPadding(); )
      e = e.getParent();
    if (!(e ? e.getProvidedColumnGroup().isExpandable() : !1)) {
      this.displayedChildren = this.children, this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
      return;
    }
    this.children.forEach((n) => {
      var i;
      if (Dt(n) && !((i = n.displayedChildren) != null && i.length))
        return;
      switch (n.getColumnGroupShow()) {
        case "open":
          e.getProvidedColumnGroup().isExpanded() && this.displayedChildren.push(n);
          break;
        case "closed":
          e.getProvidedColumnGroup().isExpanded() || this.displayedChildren.push(n);
          break;
        default:
          this.displayedChildren.push(n);
          break;
      }
    }), this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
  }
}, Pd = "row-group-", fp = "t-", mp = "b-", rI = 0, Ln = class {
  constructor(e) {
    this.master = !1, this.detail = void 0, this.rowIndex = null, this.key = null, this.sourceRowIndex = -1, this.childrenMapped = null, this.treeParent = null, this.treeNodeFlags = 0, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = rI++, this.alreadyRendered = !1, this.hovered = !1, this.__selected = !1, this.beans = e;
  }
  /**
   * Replaces the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */
  setData(e) {
    this.setDataCommon(e, !1);
  }
  // similar to setRowData, however it is expected that the data is the same data item. this
  // is intended to be used with Redux type stores, where the whole data can be changed. we are
  // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
  // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
  // dataChanged event, refreshes the cells rather than rip them all out (so user can show transitions).
  /**
   * Updates the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */
  updateData(e) {
    this.setDataCommon(e, !0);
  }
  setDataCommon(e, t) {
    var a, l, d;
    const { valueCache: n, eventSvc: o } = this.beans, s = this.data;
    this.data = e, n == null || n.onDataChanged(), this.updateDataOnDetailNode(), this.resetQuickFilterAggregateText();
    const i = this.createDataChangedEvent(e, s, t);
    if ((a = this.__localEventService) == null || a.dispatchEvent(i), this.sibling) {
      this.sibling.data = e;
      const c = this.sibling.createDataChangedEvent(e, s, t);
      (l = this.sibling.__localEventService) == null || l.dispatchEvent(c);
    }
    o.dispatchEvent({ type: "rowNodeDataChanged", node: this });
    const r = this.pinnedSibling;
    r && (r.data = e, (d = r.__localEventService) == null || d.dispatchEvent(
      r.createDataChangedEvent(e, s, t)
    ), o.dispatchEvent({ type: "rowNodeDataChanged", node: r }));
  }
  // when we are doing master / detail, the detail node is lazy created, but then kept around.
  // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
  // in sync, otherwise expand/collapse of the detail would still show the old values.
  updateDataOnDetailNode() {
    this.detailNode && (this.detailNode.data = this.data);
  }
  createDataChangedEvent(e, t, n) {
    return {
      type: "dataChanged",
      node: this,
      oldData: t,
      newData: e,
      update: n
    };
  }
  getRowIndexString() {
    return this.rowIndex == null ? ($e(13), null) : this.rowPinned === "top" ? fp + this.rowIndex : this.rowPinned === "bottom" ? mp + this.rowIndex : this.rowIndex.toString();
  }
  setDataAndId(e, t) {
    var r, a;
    const { selectionSvc: n } = this.beans, o = (r = n == null ? void 0 : n.createDaemonNode) == null ? void 0 : r.call(n, this), s = this.data;
    this.data = e, this.updateDataOnDetailNode(), this.setId(t), n && (n.updateRowSelectable(this), n.syncInRowNode(this, o));
    const i = this.createDataChangedEvent(e, s, !1);
    (a = this.__localEventService) == null || a.dispatchEvent(i);
  }
  setId(e) {
    var n;
    const t = Jo(this.beans.gos);
    if (t)
      if (this.data) {
        const o = ((n = this.parent) == null ? void 0 : n.getRoute()) ?? [];
        this.id = t({
          data: this.data,
          parentKeys: o.length > 0 ? o : void 0,
          level: this.level,
          rowPinned: this.rowPinned
        }), this.id.startsWith(Pd) && $e(14, {
          groupPrefix: Pd
        });
      } else
        this.id = void 0;
    else
      this.id = e;
  }
  setRowTop(e) {
    this.oldRowTop = this.rowTop, this.rowTop !== e && (this.rowTop = e, this.dispatchRowEvent("topChanged"), this.setDisplayed(e !== null));
  }
  clearRowTopAndRowIndex() {
    this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
  }
  setHovered(e) {
    this.hovered = e;
  }
  isHovered() {
    return this.hovered;
  }
  /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */
  setRowHeight(e, t = !1) {
    this.rowHeight = e, this.rowHeightEstimated = t, this.dispatchRowEvent("heightChanged");
  }
  setExpanded(e, t, n) {
    var o;
    (o = this.beans.expansionSvc) == null || o.setExpanded(this, e, t, n);
  }
  /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid refreshes the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   * **Note**: This method defers to EditModule if available and batches the edit when `fullRow` or `batchEdit` is enabled.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */
  setDataValue(e, t, n) {
    const { colModel: o, valueSvc: s, gos: i, editSvc: r } = this.beans, a = typeof e != "string" ? e : o.getCol(e) ?? o.getColDefCol(e);
    if (!a)
      return !1;
    const l = s.getValueForDisplay(a, this, void 0, void 0, "api").value;
    if (i.get("readOnlyEdit")) {
      const {
        beans: { eventSvc: u },
        data: h,
        rowIndex: g,
        rowPinned: p
      } = this;
      return u.dispatchEvent({
        type: "cellEditRequest",
        event: null,
        rowIndex: g,
        rowPinned: p,
        column: a,
        colDef: a.colDef,
        data: h,
        node: this,
        oldValue: l,
        newValue: t,
        value: t,
        source: n
      }), !1;
    }
    if (r && !r.committing) {
      const u = r.setDataValue({ rowNode: this, column: a }, t, n);
      if (u != null)
        return u;
    }
    const d = s.setValue(this, a, t, n);
    this.dispatchCellChangedEvent(a, t, l);
    const c = this.pinnedSibling;
    return c && d && c.dispatchCellChangedEvent(a, t, l), d;
  }
  updateHasChildren() {
    let e = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
    const { rowChildrenSvc: t } = this.beans;
    t && (e = t.getHasChildrenValue(this)), e !== this.__hasChildren && (this.__hasChildren = !!e, this.dispatchRowEvent("hasChildrenChanged"));
  }
  hasChildren() {
    return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
  }
  dispatchCellChangedEvent(e, t, n) {
    var s;
    const o = {
      type: "cellChanged",
      node: this,
      column: e,
      newValue: t,
      oldValue: n
    };
    (s = this.__localEventService) == null || s.dispatchEvent(o);
  }
  /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However, if you edit without using grid editing, you need to clear this string down for the row to be updated with the new values.
   * Otherwise, new values would not work with the `quickFilter`. */
  resetQuickFilterAggregateText() {
    this.quickFilterAggregateText = null;
  }
  /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */
  isExpandable() {
    var e;
    return ((e = this.beans.expansionSvc) == null ? void 0 : e.isExpandable(this)) ?? !1;
  }
  /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */
  isSelected() {
    return this.footer ? this.sibling.isSelected() : this.rowPinned && this.pinnedSibling ? this.pinnedSibling.isSelected() : this.__selected;
  }
  /** Perform a depth-first search of this node and its children. */
  depthFirstSearch(e) {
    var t;
    (t = this.childrenAfterGroup) == null || t.forEach((n) => n.depthFirstSearch(e)), e(this);
  }
  dispatchRowEvent(e) {
    var t;
    (t = this.__localEventService) == null || t.dispatchEvent({
      type: e,
      node: this
    });
  }
  /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` selects the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that appears in the `selectionChanged` event.
   */
  setSelected(e, t = !1, n = "api") {
    var o;
    (o = this.beans.selectionSvc) == null || o.setNodesSelected({
      nodes: [this],
      newValue: e,
      clearSelection: t,
      source: n
    });
  }
  /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */
  isRowPinned() {
    return !!this.rowPinned;
  }
  __addEventListener(e, t) {
    this.__localEventService || (this.__localEventService = new Fs()), this.__localEventService.addEventListener(e, t);
  }
  __removeEventListener(e, t) {
    this.removeLocalListener(e, t);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  addEventListener(e, t) {
    var o, s, i, r;
    (o = this.beans.validation) == null || o.checkRowEvents(e), this.__localEventService || (this.__localEventService = new Fs()), this.frameworkEventListenerService = (i = (s = this.beans.frameworkOverrides).createLocalEventListenerWrapper) == null ? void 0 : i.call(
      s,
      this.frameworkEventListenerService,
      this.__localEventService
    );
    const n = ((r = this.frameworkEventListenerService) == null ? void 0 : r.wrap(e, t)) ?? t;
    this.__localEventService.addEventListener(e, n);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  removeEventListener(e, t) {
    var o;
    const n = ((o = this.frameworkEventListenerService) == null ? void 0 : o.unwrap(e, t)) ?? t;
    this.removeLocalListener(e, n);
  }
  removeLocalListener(e, t) {
    var n, o;
    (n = this.__localEventService) == null || n.removeEventListener(e, t), (o = this.__localEventService) != null && o.noRegisteredListenersExist() && (this.__localEventService = null);
  }
  /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */
  isFullWidthCell() {
    if (Z(61), this.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this }) : !1;
  }
  /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */
  getRoute() {
    if (this.level === -1)
      return [];
    if (this.key == null)
      return;
    const e = [];
    let t = this;
    for (; t && t.key != null; )
      e.push(t.key), t = t.parent;
    return e.reverse();
  }
  setDisplayed(e) {
    this.displayed !== e && (this.displayed = e, this.dispatchRowEvent("displayedChanged"));
  }
  setRowIndex(e) {
    this.rowIndex !== e && (this.rowIndex = e, this.dispatchRowEvent("rowIndexChanged"));
  }
  setAllChildrenCount(e) {
    this.allChildrenCount !== e && (this.allChildrenCount = e, this.dispatchRowEvent("allChildrenCountChanged"));
  }
  setUiLevel(e) {
    this.uiLevel !== e && (this.uiLevel = e, this.dispatchRowEvent("uiLevelChanged"));
  }
  getFirstChild() {
    var e;
    return this.childStore ? this.childStore.getFirstNode() : ((e = this.childrenAfterSort) == null ? void 0 : e[0]) ?? null;
  }
};
function Sw(e, t, n) {
  return ke(t, {
    type: n,
    node: e,
    data: e.data,
    rowIndex: e.rowIndex,
    rowPinned: e.rowPinned
  });
}
var aI = /* @__PURE__ */ new Set(["__localEventService", "__objectId", "sticky", "__autoHeights", "__checkAutoHeightsDebounced", "childStore"]);
function xw(e, t) {
  const n = new Ln(t);
  return Object.keys(e).forEach((o) => {
    aI.has(o) || (n[o] = e[o]);
  }), n.oldRowTop = null, n;
}
var Rw = {
  agSetColumnFilter: "agSetColumnFilterHandler",
  agMultiColumnFilter: "agMultiColumnFilterHandler",
  agGroupColumnFilter: "agGroupColumnFilterHandler",
  agNumberColumnFilter: "agNumberColumnFilterHandler",
  agDateColumnFilter: "agDateColumnFilterHandler",
  agTextColumnFilter: "agTextColumnFilterHandler"
}, lI = new Set(Object.values(Rw));
function as(e, t) {
  const n = e.filterUi;
  if (!n)
    return null;
  if (n.created)
    return n.promise;
  if (t)
    return null;
  const o = n.create(n.refreshed), s = n;
  return s.created = !0, s.promise = o, o;
}
function dI(e, t, n, o, s, i) {
  var r;
  return (r = t.refresh) == null || r.call(t, { ...n, model: o, source: i }), e().then((a) => {
    if (a) {
      const { filter: l, filterParams: d } = a;
      Ew(l, d, o, s, i);
    }
  });
}
function Ew(e, t, n, o, s) {
  var i;
  (i = e == null ? void 0 : e.refresh) == null || i.call(e, {
    ...t,
    model: n,
    state: o,
    source: s
  });
}
function Aw(e, t, n) {
  const o = e();
  o != null && o.created && o.promise.then((s) => {
    const i = t();
    Ew(s, o.filterParams, i, n() ?? { model: i }, "ui");
  });
}
function bm(e, t, n, o, s, i, r) {
  let a, l = !1, d;
  switch (e) {
    case "apply": {
      const c = o();
      d = (c == null ? void 0 : c.model) ?? null, r && (d = r(d)), a = {
        // keep the other UI state
        state: c == null ? void 0 : c.state,
        model: d
      }, l = !0;
      break;
    }
    case "clear": {
      a = {
        // wipe other UI state
        model: null
      };
      break;
    }
    case "reset": {
      a = {
        // wipe other UI state
        model: null
      }, l = !0, d = null;
      break;
    }
    case "cancel": {
      a = {
        // wipe other UI state
        model: n()
      };
      break;
    }
  }
  s(a), l ? i(d) : Aw(t, n, o);
}
function _t(e, t) {
  return e[t] ?? null;
}
function Ue(e) {
  return Qa(e);
}
function cI(e) {
  return {
    tag: "div",
    cls: e
  };
}
var vp = class extends Te {
  constructor(e) {
    const { className: t = "ag-filter-apply-panel" } = e ?? {};
    super(cI(t)), this.listeners = [], this.validationMessage = null, this.className = t;
  }
  updateButtons(e, t) {
    const n = this.buttons;
    if (this.buttons = e, n === e)
      return;
    const o = this.getGui();
    ht(o);
    let s;
    this.destroyListeners();
    const i = document.createDocumentFragment(), r = this.className, a = ({ type: d, label: c }) => {
      const u = (C) => {
        this.dispatchLocalEvent({
          type: d,
          event: C
        });
      };
      ["apply", "clear", "reset", "cancel"].includes(d) || Z(75);
      const h = d === "apply", p = Ue({
        tag: "button",
        attrs: { type: h && t ? "submit" : "button" },
        ref: `${d}FilterButton`,
        cls: `ag-button ag-standard-button ${r}-button${h ? " " + r + "-apply-button" : ""}`,
        children: c
      });
      this.activateTabIndex([p]), h && (s = p);
      const f = (C) => {
        C.key === O.ENTER && (C.preventDefault(), u(C));
      }, m = this.listeners;
      p.addEventListener("click", u), m.push(() => p.removeEventListener("click", u)), p.addEventListener("keydown", f), m.push(() => p.removeEventListener("keydown", f)), i.append(p);
    };
    e.forEach((d) => a(d)), this.eApply = s;
    const l = this.validationTooltipFeature;
    s && !l ? this.validationTooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eApply,
        getLocation: () => "advancedFilter",
        getTooltipShowDelayOverride: () => 1e3
      })
    ) : !s && l && (this.validationTooltipFeature = this.destroyBean(l)), o.append(i);
  }
  getApplyButton() {
    return this.eApply;
  }
  updateValidity(e, t = null) {
    var o;
    const n = this.eApply;
    n && (vi(n, e === !1), this.validationMessage = t ?? null, (o = this.validationTooltipFeature) == null || o.setTooltipAndRefresh(this.validationMessage));
  }
  destroyListeners() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  destroy() {
    this.destroyListeners(), super.destroy();
  }
}, uI = {
  selector: "AG-FILTER-BUTTON",
  component: vp
}, hI = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose one",
  equals: "Equals",
  notEqual: "Does not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "Between",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equal to",
  greaterThanOrEqual: "Greater than or equal to",
  contains: "Contains",
  notContains: "Does not contain",
  startsWith: "Begins with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  before: "Before",
  after: "After",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd",
  filterSummaryInactive: "is (All)",
  filterSummaryContains: "contains",
  filterSummaryNotContains: "does not contain",
  filterSummaryTextEquals: "equals",
  filterSummaryTextNotEqual: "does not equal",
  filterSummaryStartsWith: "begins with",
  filterSummaryEndsWith: "ends with",
  filterSummaryBlank: "is blank",
  filterSummaryNotBlank: "is not blank",
  filterSummaryEquals: "=",
  filterSummaryNotEqual: "!=",
  filterSummaryGreaterThan: ">",
  filterSummaryGreaterThanOrEqual: ">=",
  filterSummaryLessThan: "<",
  filterSummaryLessThanOrEqual: "<=",
  filterSummaryInRange: "between",
  filterSummaryInRangeValues: (e) => `(${e[0]}, ${e[1]})`,
  filterSummaryTextQuote: (e) => `"${e[0]}"`
};
function ws(e, t, n) {
  return bC(e, hI, t, n);
}
function Cp(e, t) {
  const { debounceMs: n } = e;
  return bc(e) ? (n != null && Z(71), 0) : n ?? t;
}
function bc(e) {
  var t;
  return (((t = e.buttons) == null ? void 0 : t.indexOf("apply")) ?? -1) >= 0;
}
var gI = class extends Te {
  constructor(e, t, n, o, s, i) {
    super(), this.column = e, this.wrapper = t, this.eventParent = n, this.updateModel = o, this.isGlobalButtons = s, this.enableGlobalButtonCheck = i, this.hidePopup = null, this.applyActive = !1;
  }
  postConstruct() {
    const { comp: e, params: t } = this.wrapper, n = t, o = n.useForm, s = o ? "form" : "div";
    this.setTemplate({
      tag: s,
      cls: "ag-filter-wrapper"
    }), o && this.addManagedElementListeners(this.getGui(), {
      submit: (i) => {
        i == null || i.preventDefault();
      },
      keydown: this.handleKeyDown.bind(this)
    }), this.appendChild(e.getGui()), this.params = n, this.resetButtonsPanel(n), this.addManagedListeners(this.eventParent, {
      filterParamsChanged: ({ column: i, params: r }) => {
        i === this.column && this.resetButtonsPanel(r, this.params);
      },
      filterStateChanged: ({ column: i, state: r }) => {
        var a;
        i === this.column && ((a = this.eButtons) == null || a.updateValidity(r.valid !== !1));
      },
      filterAction: ({ column: i, action: r, event: a }) => {
        i === this.column && this.afterAction(r, a);
      },
      ...this.enableGlobalButtonCheck ? {
        filterGlobalButtons: ({ isGlobal: i }) => {
          if (i !== this.isGlobalButtons) {
            this.isGlobalButtons = i;
            const r = this.params;
            this.resetButtonsPanel(r, r, !0);
          }
        }
      } : void 0
    });
  }
  afterGuiAttached(e) {
    e && (this.hidePopup = e.hidePopup);
  }
  resetButtonsPanel(e, t, n) {
    const { buttons: o, readOnly: s } = t ?? {}, { buttons: i, readOnly: r, useForm: a } = e;
    if (!n && s === r && pr(o, i))
      return;
    const l = i && i.length > 0 && !e.readOnly && !this.isGlobalButtons;
    let d = this.eButtons;
    if (l) {
      const c = i.map((u) => {
        const h = `${u}Filter`;
        return { type: u, label: ws(this, h) };
      });
      if (this.applyActive = bc(this.params), !d) {
        d = this.createBean(new vp()), this.appendChild(d.getGui());
        const u = this.column, h = (g) => ({ event: p }) => {
          this.updateModel(u, g), this.afterAction(g, p);
        };
        d == null || d.addManagedListeners(d, {
          apply: h("apply"),
          clear: h("clear"),
          reset: h("reset"),
          cancel: h("cancel")
        }), this.eButtons = d;
      }
      d.updateButtons(c, a);
    } else
      this.applyActive = !1, d && (nn(d.getGui()), this.eButtons = this.destroyBean(d));
  }
  close(e) {
    const t = this.hidePopup;
    if (!t)
      return;
    const n = e, o = n && n.key;
    let s;
    (o === O.ENTER || o === O.SPACE) && (s = { keyboardEvent: n }), t(s), this.hidePopup = null;
  }
  afterAction(e, t) {
    const { params: n, applyActive: o } = this, s = n == null ? void 0 : n.closeOnApply;
    switch (e) {
      case "apply": {
        t == null || t.preventDefault(), s && o && this.close(t);
        break;
      }
      case "reset": {
        s && o && this.close();
        break;
      }
      case "cancel": {
        s && this.close(t);
        break;
      }
    }
  }
  handleKeyDown(e) {
    !e.defaultPrevented && e.key === O.ENTER && this.applyActive && (this.updateModel(this.column, "apply"), this.afterAction("apply", e));
  }
  destroy() {
    this.hidePopup = null, this.eButtons = this.destroyBean(this.eButtons);
  }
}, pI = { tag: "div", cls: "ag-filter" }, Fw = class extends Te {
  constructor(e, t, n) {
    super(pI), this.column = e, this.source = t, this.enableGlobalButtonCheck = n, this.wrapper = null;
  }
  postConstruct() {
    var e;
    (e = this.beans.colFilter) == null || e.activeFilterComps.add(this), this.createFilter(!0), this.addManagedEventListeners({ filterDestroyed: this.onFilterDestroyed.bind(this) });
  }
  hasFilter() {
    return this.wrapper != null;
  }
  getFilter() {
    var e;
    return ((e = this.wrapper) == null ? void 0 : e.then((t) => t.comp)) ?? null;
  }
  afterInit() {
    var e;
    return ((e = this.wrapper) == null ? void 0 : e.then(() => {
    })) ?? tt.resolve();
  }
  afterGuiAttached(e) {
    var t;
    this.afterGuiAttachedParams = e, (t = this.wrapper) == null || t.then((n) => {
      var o, s, i;
      (o = this.comp) == null || o.afterGuiAttached(e), (i = (s = n == null ? void 0 : n.comp) == null ? void 0 : s.afterGuiAttached) == null || i.call(s, e);
    });
  }
  afterGuiDetached() {
    var e;
    (e = this.wrapper) == null || e.then((t) => {
      var n, o;
      (o = (n = t == null ? void 0 : t.comp) == null ? void 0 : n.afterGuiDetached) == null || o.call(n);
    });
  }
  createFilter(e) {
    const {
      column: t,
      source: n,
      beans: { colFilter: o }
    } = this, s = o.getFilterUiForDisplay(t) ?? null;
    this.wrapper = s, s == null || s.then((i) => {
      var d;
      if (!i)
        return;
      const { isHandler: r, comp: a } = i;
      let l;
      if (r) {
        const c = !!this.enableGlobalButtonCheck, u = this.createBean(
          new gI(
            t,
            i,
            o,
            o.updateModel.bind(o),
            c && o.isGlobalButtons,
            c
          )
        );
        this.comp = u, l = u.getGui();
      } else
        l = a.getGui(), ue(l) || Z(69, { guiFromFilter: l });
      this.appendChild(l), e ? this.eventSvc.dispatchEvent({
        type: "filterOpened",
        column: t,
        source: n,
        eGui: this.getGui()
      }) : (d = a.afterGuiAttached) == null || d.call(a, this.afterGuiAttachedParams);
    });
  }
  onFilterDestroyed(e) {
    const { source: t, column: n } = e;
    (t === "api" || t === "paramsUpdated") && n.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column) && (ht(this.getGui()), this.comp = this.destroyBean(this.comp), this.createFilter());
  }
  destroy() {
    var e;
    (e = this.beans.colFilter) == null || e.activeFilterComps.delete(this), this.eventSvc.dispatchEvent({
      type: "filterClosed",
      column: this.column
    }), this.wrapper = null, this.comp = this.destroyBean(this.comp), this.afterGuiAttachedParams = void 0, super.destroy();
  }
}, Sm = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, xm = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december"
];
function fI(e, t) {
  return e == null ? -1 : t == null ? 1 : parseFloat(e) - parseFloat(t);
}
function Rm(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
var Fh = {
  number: () => {
  },
  boolean: () => ({
    maxNumConditions: 1,
    debounceMs: 0,
    filterOptions: [
      "empty",
      {
        displayKey: "true",
        displayName: "True",
        predicate: (e, t) => t,
        numberOfInputs: 0
      },
      {
        displayKey: "false",
        displayName: "False",
        predicate: (e, t) => t === !1,
        numberOfInputs: 0
      }
    ]
  }),
  date: () => ({ isValidDate: Rm }),
  dateString: ({ dataTypeDefinition: e }) => ({
    comparator: (t, n) => {
      const o = e.dateParser(n);
      return n == null || o < t ? -1 : o > t ? 1 : 0;
    },
    isValidDate: (t) => typeof t == "string" && Rm(e.dateParser(t))
  }),
  dateTime: (e) => Fh.date(e),
  dateTimeString: (e) => Fh.dateString(e),
  object: () => {
  },
  text: () => {
  }
}, Mh = {
  number: () => ({ comparator: fI }),
  boolean: ({ t: e }) => ({
    valueFormatter: (t) => ue(t.value) ? e(String(t.value), t.value ? "True" : "False") : e("blanks", "(Blanks)")
  }),
  date: ({ formatValue: e, t }) => ({
    valueFormatter: (n) => {
      const o = e(n);
      return ue(o) ? o : t("blanks", "(Blanks)");
    },
    treeList: !0,
    treeListFormatter: (n, o) => {
      if (n === "NaN")
        return t("invalidDate", "Invalid Date");
      if (o === 1 && n != null) {
        const s = xm[Number(n) - 1];
        return t(s, Sm[s]);
      }
      return n ?? t("blanks", "(Blanks)");
    },
    treeListPathGetter: (n) => zi(n, !1)
  }),
  dateString: ({ formatValue: e, dataTypeDefinition: t, t: n }) => ({
    valueFormatter: (o) => {
      const s = e(o);
      return ue(s) ? s : n("blanks", "(Blanks)");
    },
    treeList: !0,
    treeListPathGetter: (o) => zi(t.dateParser(o ?? void 0), !1),
    treeListFormatter: (o, s) => {
      if (s === 1 && o != null) {
        const i = xm[Number(o) - 1];
        return n(i, Sm[i]);
      }
      return o ?? n("blanks", "(Blanks)");
    }
  }),
  dateTime: (e) => {
    const t = Mh.date(e);
    return t.treeListPathGetter = zi, t;
  },
  dateTimeString(e) {
    const t = e.dataTypeDefinition.dateParser, n = Mh.dateString(e);
    return n.treeListPathGetter = (o) => zi(t(o ?? void 0)), n;
  },
  object: ({ formatValue: e, t }) => ({
    valueFormatter: (n) => {
      const o = e(n);
      return ue(o) ? o : t("blanks", "(Blanks)");
    }
  }),
  text: () => {
  }
};
function mI(e, t, n, o, s, i, r) {
  let a = t, l = n;
  const d = e === "agSetColumnFilter";
  !l && o.baseDataType === "object" && !d && (l = ({ column: g, node: p }) => s({ column: g, node: p, value: i.valueSvc.getValue(g, p) }));
  const u = (d ? Mh : Fh)[o.baseDataType], h = u({ dataTypeDefinition: o, formatValue: s, t: r });
  return a = typeof t == "object" ? {
    ...h,
    ...t
  } : h, { filterParams: a, filterValueGetter: l };
}
var vI = {
  boolean: "agTextColumnFilter",
  date: "agDateColumnFilter",
  dateString: "agDateColumnFilter",
  dateTime: "agDateColumnFilter",
  dateTimeString: "agDateColumnFilter",
  number: "agNumberColumnFilter",
  object: "agTextColumnFilter",
  text: "agTextColumnFilter"
}, CI = {
  boolean: "agTextColumnFloatingFilter",
  date: "agDateColumnFloatingFilter",
  dateString: "agDateColumnFloatingFilter",
  dateTime: "agDateColumnFloatingFilter",
  dateTimeString: "agDateColumnFloatingFilter",
  number: "agNumberColumnFloatingFilter",
  object: "agTextColumnFloatingFilter",
  text: "agTextColumnFloatingFilter"
};
function wI(e, t = !1) {
  return (t ? CI : vI)[e ?? "text"];
}
var Mw = "ag-resizer-wrapper", ls = (e, t) => ({
  tag: "div",
  ref: `${e}Resizer`,
  cls: `ag-resizer ag-resizer-${t}`
}), yI = {
  tag: "div",
  cls: Mw,
  children: [
    ls("eTopLeft", "topLeft"),
    ls("eTop", "top"),
    ls("eTopRight", "topRight"),
    ls("eRight", "right"),
    ls("eBottomRight", "bottomRight"),
    ls("eBottom", "bottom"),
    ls("eBottomLeft", "bottomLeft"),
    ls("eLeft", "left")
  ]
}, Sc = class extends U {
  constructor(e, t) {
    super(), this.element = e, this.dragStartPosition = {
      x: 0,
      y: 0
    }, this.position = {
      x: 0,
      y: 0
    }, this.lastSize = {
      width: -1,
      height: -1
    }, this.positioned = !1, this.resizersAdded = !1, this.resizeListeners = [], this.boundaryEl = null, this.isResizing = !1, this.isMoving = !1, this.resizable = {}, this.movable = !1, this.currentResizer = null, this.config = Object.assign({}, { popup: !1 }, t);
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.dragSvc = e.dragSvc;
  }
  center(e) {
    const { clientHeight: t, clientWidth: n } = this.offsetParent, o = n / 2 - this.getWidth() / 2, s = t / 2 - this.getHeight() / 2;
    this.offsetElement(o, s, e);
  }
  initialisePosition(e) {
    if (this.positioned)
      return;
    const { centered: t, forcePopupParentAsOffsetParent: n, minWidth: o, width: s, minHeight: i, height: r, x: a, y: l } = this.config;
    this.offsetParent || this.setOffsetParent();
    let d = 0, c = 0;
    const u = vn(this.element);
    if (u) {
      const h = this.findBoundaryElement(), g = window.getComputedStyle(h);
      if (g.minWidth != null) {
        const p = h.offsetWidth - this.element.offsetWidth;
        c = parseInt(g.minWidth, 10) - p;
      }
      if (g.minHeight != null) {
        const p = h.offsetHeight - this.element.offsetHeight;
        d = parseInt(g.minHeight, 10) - p;
      }
    }
    if (this.minHeight = i || d, this.minWidth = o || c, s && this.setWidth(s), r && this.setHeight(r), (!s || !r) && this.refreshSize(), t)
      this.center(e);
    else if (a || l)
      this.offsetElement(a, l, e);
    else if (u && n) {
      let h = this.boundaryEl, g = !0;
      if (h || (h = this.findBoundaryElement(), g = !1), h) {
        const p = parseFloat(h.style.top), f = parseFloat(h.style.left);
        g ? this.offsetElement(isNaN(f) ? 0 : f, isNaN(p) ? 0 : p, e) : this.setPosition(f, p);
      }
    }
    this.positioned = !!this.offsetParent;
  }
  isPositioned() {
    return this.positioned;
  }
  getPosition() {
    return this.position;
  }
  setMovable(e, t) {
    var o, s;
    if (!this.config.popup || e === this.movable)
      return;
    this.movable = e;
    const n = this.moveElementDragListener || {
      eElement: t,
      onDragStart: this.onMoveStart.bind(this),
      onDragging: this.onMove.bind(this),
      onDragStop: this.onMoveEnd.bind(this)
    };
    e ? ((o = this.dragSvc) == null || o.addDragSource(n), this.moveElementDragListener = n) : ((s = this.dragSvc) == null || s.removeDragSource(n), this.moveElementDragListener = void 0);
  }
  setResizable(e) {
    if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
      if (e === !1)
        return;
      e = {
        topLeft: e,
        top: e,
        topRight: e,
        right: e,
        bottomRight: e,
        bottom: e,
        bottomLeft: e,
        left: e
      };
    }
    Object.keys(e).forEach((t) => {
      var r;
      const o = !!e[t], s = this.getResizerElement(t), i = {
        dragStartPixels: 0,
        eElement: s,
        onDragStart: (a) => this.onResizeStart(a, t),
        onDragging: this.onResize.bind(this),
        onDragStop: (a) => this.onResizeEnd(a, t)
      };
      (o || !this.isAlive() && !o) && (o ? ((r = this.dragSvc) == null || r.addDragSource(i), this.resizeListeners.push(i), s.style.pointerEvents = "all") : s.style.pointerEvents = "none", this.resizable[t] = o);
    });
  }
  removeSizeFromEl() {
    this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
  }
  restoreLastSize() {
    this.element.style.flex = "0 0 auto";
    const { height: e, width: t } = this.lastSize;
    t !== -1 && (this.element.style.width = `${t}px`), e !== -1 && (this.element.style.height = `${e}px`);
  }
  getHeight() {
    return this.element.offsetHeight;
  }
  setHeight(e) {
    const { popup: t } = this.config, n = this.element;
    let o = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      ia(n, e), e = Kg(n), o = !0;
    else if (e = Math.max(this.minHeight, e), this.positioned) {
      const s = this.getAvailableHeight();
      s && e > s && (e = s);
    }
    this.getHeight() !== e && (o ? (n.style.maxHeight = "unset", n.style.minHeight = "unset") : t ? ia(n, e) : (n.style.height = `${e}px`, n.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
  }
  getAvailableHeight() {
    const { popup: e, forcePopupParentAsOffsetParent: t } = this.config;
    this.positioned || this.initialisePosition();
    const { clientHeight: n } = this.offsetParent;
    if (!n)
      return null;
    const o = this.element.getBoundingClientRect(), s = this.offsetParent.getBoundingClientRect(), i = e ? this.position.y : o.top, r = e ? 0 : s.top;
    let a = 0;
    if (t) {
      const d = this.element.parentElement;
      if (d) {
        const { bottom: c } = d.getBoundingClientRect();
        a = c - o.bottom;
      }
    }
    return n + r - i - a;
  }
  getWidth() {
    return this.element.offsetWidth;
  }
  setWidth(e) {
    const t = this.element, { popup: n } = this.config;
    let o = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      Ro(t, e), e = Ia(t), o = !0;
    else if (this.positioned) {
      e = Math.max(this.minWidth, e);
      const { clientWidth: s } = this.offsetParent, i = n ? this.position.x : this.element.getBoundingClientRect().left;
      s && e + i > s && (e = s - i);
    }
    this.getWidth() !== e && (o ? (t.style.maxWidth = "unset", t.style.minWidth = "unset") : this.config.popup ? Ro(t, e) : (t.style.width = `${e}px`, t.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
  }
  offsetElement(e = 0, t = 0, n) {
    var i;
    const { forcePopupParentAsOffsetParent: o } = this.config, s = o ? this.boundaryEl : this.element;
    s && ((i = this.popupSvc) == null || i.positionPopup({
      ePopup: s,
      keepWithinBounds: !0,
      skipObserver: this.movable || this.isResizable(),
      updatePosition: () => ({ x: e, y: t }),
      postProcessCallback: n
    }), this.setPosition(parseFloat(s.style.left), parseFloat(s.style.top)));
  }
  constrainSizeToAvailableHeight(e) {
    var n, o;
    if (!this.config.forcePopupParentAsOffsetParent)
      return;
    const t = () => {
      const s = this.getAvailableHeight();
      this.element.style.setProperty("max-height", `${s}px`);
    };
    e && this.popupSvc ? ((n = this.resizeObserverSubscriber) == null || n.call(this), this.resizeObserverSubscriber = Bo(
      this.beans,
      (o = this.popupSvc) == null ? void 0 : o.getPopupParent(),
      t
    )) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0));
  }
  setPosition(e, t) {
    this.position.x = e, this.position.y = t;
  }
  updateDragStartPosition(e, t) {
    this.dragStartPosition = { x: e, y: t };
  }
  calculateMouseMovement(e) {
    const { e: t, isLeft: n, isTop: o, anywhereWithin: s, topBuffer: i } = e, r = t.clientX - this.dragStartPosition.x, a = t.clientY - this.dragStartPosition.y, l = this.shouldSkipX(t, !!n, !!s, r) ? 0 : r, d = this.shouldSkipY(t, !!o, i, a) ? 0 : a;
    return { movementX: l, movementY: d };
  }
  shouldSkipX(e, t, n, o) {
    const s = this.element.getBoundingClientRect(), i = this.offsetParent.getBoundingClientRect(), r = this.boundaryEl.getBoundingClientRect(), a = this.config.popup ? this.position.x : s.left;
    let l = a <= 0 && i.left >= e.clientX || i.right <= e.clientX && i.right <= r.right;
    return l ? !0 : (t ? l = // skip if we are moving to the left and the cursor
    // is positioned to the right of the left side anchor
    o < 0 && e.clientX > a + i.left || // skip if we are moving to the right and the cursor
    // is positioned to the left of the dialog
    o > 0 && e.clientX < a + i.left : n ? l = o < 0 && e.clientX > r.right || o > 0 && e.clientX < a + i.left : l = // if the movement is bound to the right side of the dialog
    // we skip if we are moving to the left and the cursor
    // is to the right of the dialog
    o < 0 && e.clientX > r.right || // or skip if we are moving to the right and the cursor
    // is to the left of the right side anchor
    o > 0 && e.clientX < r.right, l);
  }
  shouldSkipY(e, t, n = 0, o) {
    const s = this.element.getBoundingClientRect(), i = this.offsetParent.getBoundingClientRect(), r = this.boundaryEl.getBoundingClientRect(), a = this.config.popup ? this.position.y : s.top;
    let l = a <= 0 && i.top >= e.clientY || i.bottom <= e.clientY && i.bottom <= r.bottom;
    return l ? !0 : (t ? l = // skip if we are moving to towards top and the cursor is
    // below the top anchor + topBuffer
    // note: topBuffer is used when moving the dialog using the title bar
    o < 0 && e.clientY > a + i.top + n || // skip if we are moving to the bottom and the cursor is
    // above the top anchor
    o > 0 && e.clientY < a + i.top : l = // skip if we are moving towards the top and the cursor
    // is below the bottom anchor
    o < 0 && e.clientY > r.bottom || // skip if we are moving towards the bottom and the cursor
    // is above the bottom anchor
    o > 0 && e.clientY < r.bottom, l);
  }
  createResizeMap() {
    const e = (t) => ({
      element: this.element.querySelector(`[data-ref=${t}Resizer]`)
    });
    this.resizerMap = {
      topLeft: e("eTopLeft"),
      top: e("eTop"),
      topRight: e("eTopRight"),
      right: e("eRight"),
      bottomRight: e("eBottomRight"),
      bottom: e("eBottom"),
      bottomLeft: e("eBottomLeft"),
      left: e("eLeft")
    };
  }
  addResizers() {
    if (this.resizersAdded)
      return;
    const e = this.element;
    e && (e.appendChild(Ue(yI)), this.createResizeMap(), this.resizersAdded = !0);
  }
  removeResizers() {
    this.resizerMap = void 0;
    const e = this.element.querySelector(`.${Mw}`);
    e && this.element.removeChild(e), this.resizersAdded = !1;
  }
  getResizerElement(e) {
    return this.resizerMap[e].element;
  }
  onResizeStart(e, t) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = {
      isTop: !!t.match(/top/i),
      isRight: !!t.match(/right/i),
      isBottom: !!t.match(/bottom/i),
      isLeft: !!t.match(/left/i)
    }, this.element.classList.add("ag-resizing"), this.resizerMap[t].element.classList.add("ag-active");
    const { popup: n, forcePopupParentAsOffsetParent: o } = this.config;
    !n && !o && this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
  }
  getSiblings() {
    const t = this.element.parentElement;
    return t ? Array.prototype.slice.call(t.children).filter((n) => !n.classList.contains("ag-hidden")) : null;
  }
  getMinSizeOfSiblings() {
    const e = this.getSiblings() || [];
    let t = 0, n = 0;
    for (let o = 0; o < e.length; o++) {
      const s = e[o], i = !!s.style.flex && s.style.flex !== "0 0 auto";
      if (s === this.element)
        continue;
      let r = this.minHeight || 0, a = this.minWidth || 0;
      if (i) {
        const l = window.getComputedStyle(s);
        l.minHeight && (r = parseInt(l.minHeight, 10)), l.minWidth && (a = parseInt(l.minWidth, 10));
      } else
        r = s.offsetHeight, a = s.offsetWidth;
      t += r, n += a;
    }
    return { height: t, width: n };
  }
  applySizeToSiblings(e) {
    let t = null;
    const n = this.getSiblings();
    if (n) {
      for (let o = 0; o < n.length; o++) {
        const s = n[o];
        s !== t && (e ? s.style.height = `${s.offsetHeight}px` : s.style.width = `${s.offsetWidth}px`, s.style.flex = "0 0 auto", s === this.element && (t = n[o + 1]));
      }
      t && (t.style.removeProperty("height"), t.style.removeProperty("min-height"), t.style.removeProperty("max-height"), t.style.flex = "1 1 auto");
    }
  }
  isResizable() {
    return Object.values(this.resizable).some((e) => e);
  }
  onResize(e) {
    if (!this.isResizing || !this.currentResizer)
      return;
    const { popup: t, forcePopupParentAsOffsetParent: n } = this.config, { isTop: o, isRight: s, isBottom: i, isLeft: r } = this.currentResizer, a = s || r, l = i || o, { movementX: d, movementY: c } = this.calculateMouseMovement({ e, isLeft: r, isTop: o }), u = this.position.x, h = this.position.y;
    let g = 0, p = 0;
    if (a && d) {
      const f = r ? -1 : 1, m = this.getWidth(), C = m + d * f;
      let w = !1;
      r && (g = m - C, (u + g <= 0 || C <= this.minWidth) && (w = !0, g = 0)), w || this.setWidth(C);
    }
    if (l && c) {
      const f = o ? -1 : 1, m = this.getHeight(), C = m + c * f;
      let w = !1;
      o ? (p = m - C, (h + p <= 0 || C <= this.minHeight) && (w = !0, p = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && m < C && this.getMinSizeOfSiblings().height + C > this.element.parentElement.offsetHeight && (w = !0), w || this.setHeight(C);
    }
    this.updateDragStartPosition(e.clientX, e.clientY), ((t || n) && g || p) && this.offsetElement(u + g, h + p);
  }
  onResizeEnd(e, t) {
    this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null, this.element.classList.remove("ag-resizing"), this.resizerMap[t].element.classList.remove("ag-active"), this.dispatchLocalEvent({ type: "resize" });
  }
  refreshSize() {
    const e = this.element;
    this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
  }
  onMoveStart(e) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMove(e) {
    if (!this.isMoving)
      return;
    const { x: t, y: n } = this.position;
    let o;
    this.config.calculateTopBuffer && (o = this.config.calculateTopBuffer());
    const { movementX: s, movementY: i } = this.calculateMouseMovement({
      e,
      isTop: !0,
      anywhereWithin: !0,
      topBuffer: o
    });
    this.offsetElement(t + s, n + i), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMoveEnd() {
    this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
  }
  setOffsetParent() {
    this.config.forcePopupParentAsOffsetParent && this.popupSvc ? this.offsetParent = this.popupSvc.getPopupParent() : this.offsetParent = this.element.offsetParent;
  }
  findBoundaryElement() {
    let e = this.element;
    for (; e; ) {
      if (window.getComputedStyle(e).position !== "static")
        return e;
      e = e.parentElement;
    }
    return this.element;
  }
  clearResizeListeners() {
    var e;
    for (; this.resizeListeners.length; ) {
      const t = this.resizeListeners.pop();
      (e = this.dragSvc) == null || e.removeDragSource(t);
    }
  }
  destroy() {
    var e;
    super.destroy(), this.moveElementDragListener && ((e = this.dragSvc) == null || e.removeDragSource(this.moveElementDragListener)), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
  }
}, Iw = "__ag_Grid_Stop_Propagation";
function bt(e) {
  e[Iw] = !0;
}
function Dn(e) {
  return e[Iw] === !0;
}
var Pw = "ag-focus-managed", Hs = class extends U {
  constructor(e, t = {}) {
    super(), this.eFocusable = e, this.callbacks = t, this.callbacks = {
      shouldStopEventPropagation: () => !1,
      onTabKeyDown: (n) => {
        if (n.defaultPrevented)
          return;
        const o = sn(this.beans, this.eFocusable, !1, n.shiftKey);
        o && (o.focus(), n.preventDefault());
      },
      ...t
    };
  }
  postConstruct() {
    const {
      eFocusable: e,
      callbacks: { onFocusIn: t, onFocusOut: n }
    } = this;
    e.classList.add(Pw), this.addKeyDownListeners(e), t && this.addManagedElementListeners(e, { focusin: t }), n && this.addManagedElementListeners(e, { focusout: n });
  }
  addKeyDownListeners(e) {
    this.addManagedElementListeners(e, {
      keydown: (t) => {
        if (t.defaultPrevented || Dn(t))
          return;
        const { callbacks: n } = this;
        if (n.shouldStopEventPropagation(t)) {
          bt(t);
          return;
        }
        t.key === O.TAB ? n.onTabKeyDown(t) : n.handleKeyDown && n.handleKeyDown(t);
      }
    });
  }
}, Dw = class extends Te {
  constructor(e, t) {
    super(), this.filterNameKey = e, this.cssIdentifier = t, this.applyActive = !1, this.debouncePending = !1, this.defaultDebounceMs = 0;
  }
  postConstruct() {
    const e = {
      tag: "div",
      cls: `ag-filter-body-wrapper ag-${this.cssIdentifier}-body-wrapper`,
      children: [this.createBodyTemplate()]
    };
    this.setTemplate(e, this.getAgComponents()), this.createManagedBean(
      new Hs(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      })
    ), this.positionableFeature = this.createBean(
      new Sc(this.getPositionableElement(), {
        forcePopupParentAsOffsetParent: !0
      })
    );
  }
  handleKeyDown(e) {
  }
  init(e) {
    const t = e;
    this.setParams(t), this.setModelIntoUi(t.state.model, !0).then(() => this.updateUiVisibility());
  }
  refresh(e) {
    const t = e, n = this.params;
    this.params = t, t.source === "colDef" && this.updateParams(t, n);
    const s = t.state, i = this.state;
    return this.state = s, (s.model !== i.model || s.state !== i.state) && this.setModelIntoUi(s.model), !0;
  }
  /** Called on init only. Override in subclasses */
  setParams(e) {
    this.params = e, this.state = e.state, this.commonUpdateParams(e);
  }
  /** Called on refresh only. Override in subclasses */
  updateParams(e, t) {
    this.commonUpdateParams(e, t);
  }
  commonUpdateParams(e, t) {
    this.applyActive = bc(e), this.setupApplyDebounced();
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  doesFilterPass(e) {
    Z(283);
    const { getHandler: t, model: n, column: o } = this.params;
    return t().doesFilterPass({
      ...e,
      model: n,
      handlerParams: this.beans.colFilter.getHandlerParams(o)
    });
  }
  getFilterTitle() {
    return this.translate(this.filterNameKey);
  }
  /**
   * @deprecated v34 Filters are active when they have a model. Use `api.getColumnFilterModel()` instead.
   */
  isFilterActive() {
    return Z(284), this.params.model != null;
  }
  setupApplyDebounced() {
    const e = Cp(this.params, this.defaultDebounceMs), t = Lt(this, this.checkApplyDebounce.bind(this), e);
    this.applyDebounced = () => {
      this.debouncePending = !0, t();
    };
  }
  checkApplyDebounce() {
    this.debouncePending && (this.debouncePending = !1, this.doApplyModel());
  }
  /**
   * @deprecated v34 Use (`api.getColumnFilterModel()`) instead.
   */
  getModel() {
    return Z(285), this.params.model;
  }
  /**
   * @deprecated v34 Use (`api.setColumnFilterModel()`) instead.
   */
  setModel(e) {
    Z(286);
    const { beans: t, params: n } = this;
    return t.colFilter.setModelForColumnLegacy(n.column, e);
  }
  /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */
  applyModel(e = "api") {
    return this.doApplyModel();
  }
  canApply(e) {
    return !0;
  }
  doApplyModel(e) {
    const { params: t, state: n } = this, o = !this.areModelsEqual(t.model, n.model);
    return o && t.onAction("apply", e), o;
  }
  /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */
  onNewRowsLoaded() {
  }
  /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */
  onUiChanged(e, t = !1) {
    this.updateUiVisibility();
    const n = this.getModelFromUi(), o = {
      model: n,
      state: this.getState(),
      valid: this.canApply(n)
    };
    this.state = o;
    const s = this.params;
    s.onStateChange(o), s.onUiChange(this.getUiChangeEventParams()), this.gos.get("enableFilterHandlers") || this.eventSvc.dispatchEvent({
      type: "filterModified",
      column: s.column,
      filterInstance: this
    }), e ?? (e = this.applyActive ? void 0 : "debounce"), e === "immediately" ? this.doApplyModel({ afterFloatingFilter: t, afterDataChange: !1 }) : e === "debounce" && this.applyDebounced();
  }
  getState() {
  }
  getUiChangeEventParams() {
  }
  afterGuiAttached(e) {
    this.lastContainerType = e == null ? void 0 : e.container, this.refreshFilterResizer(e == null ? void 0 : e.container);
  }
  refreshFilterResizer(e) {
    const { positionableFeature: t, gos: n } = this;
    if (!t)
      return;
    const o = e === "floatingFilter" || e === "columnFilter";
    o ? (t.restoreLastSize(), t.setResizable(
      n.get("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 }
    )) : (t.removeSizeFromEl(), t.setResizable(!1)), t.constrainSizeToAvailableHeight(o);
  }
  afterGuiDetached() {
    var e;
    this.checkApplyDebounce(), (e = this.positionableFeature) == null || e.constrainSizeToAvailableHeight(!1);
  }
  destroy() {
    this.positionableFeature = this.destroyBean(this.positionableFeature), super.destroy();
  }
  translate(e) {
    return ws(this, e);
  }
  // override to control positionable feature
  getPositionableElement() {
    return this.getGui();
  }
  areModelsEqual(e, t) {
    return e === t || e == null && t == null ? !0 : e == null || t == null ? !1 : this.areNonNullModelsEqual(e, t);
  }
};
function Tw(e) {
  return !!e.operator;
}
function bI(e, t, n) {
  if (t == null)
    return null;
  let o = null;
  const { compName: s, jsComp: i, fwComp: r } = rw(e, t);
  return s ? o = {
    agSetColumnFilter: "agSetColumnFloatingFilter",
    agMultiColumnFilter: "agMultiColumnFloatingFilter",
    agGroupColumnFilter: "agGroupColumnFloatingFilter",
    agNumberColumnFilter: "agNumberColumnFloatingFilter",
    agDateColumnFilter: "agDateColumnFloatingFilter",
    agTextColumnFilter: "agTextColumnFloatingFilter"
  }[s] : i == null && r == null && t.filter === !0 && (o = n()), o;
}
var Qn = {
  AUTO_HEIGHT: "ag-layout-auto-height",
  NORMAL: "ag-layout-normal",
  PRINT: "ag-layout-print"
}, wp = class extends U {
  constructor(e) {
    super(), this.view = e;
  }
  postConstruct() {
    this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
  }
  updateLayoutClasses() {
    const e = this.gos.get("domLayout"), t = {
      autoHeight: e === "autoHeight",
      normal: e === "normal",
      print: e === "print"
    }, n = t.autoHeight ? Qn.AUTO_HEIGHT : t.print ? Qn.PRINT : Qn.NORMAL;
    this.view.updateLayoutClasses(n, t);
  }
}, ds = "Viewport", Em = "fakeVScrollComp", fu = [
  "fakeHScrollComp",
  "centerHeader",
  "topCenter",
  "bottomCenter",
  "stickyTopCenter",
  "stickyBottomCenter"
], Am = 100, mu = 150, SI = class extends U {
  constructor(e) {
    super(), this.clearRetryListenerFncs = [], this.lastScrollSource = [null, null], this.scrollLeft = -1, this.nextScrollTop = -1, this.scrollTop = -1, this.lastOffsetHeight = -1, this.lastScrollTop = -1, this.lastIsHorizontalScrollShowing = !1, this.scrollTimer = 0, this.isScrollActive = !1, this.isVerticalPositionInvalidated = !0, this.isHorizontalPositionInvalidated = !0, this.eBodyViewport = e, this.resetLastHScrollDebounced = Lt(
      this,
      () => this.lastScrollSource[
        1
        /* Horizontal */
      ] = null,
      mu
    ), this.resetLastVScrollDebounced = Lt(
      this,
      () => this.lastScrollSource[
        0
        /* Vertical */
      ] = null,
      mu
    );
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.animationFrameSvc = e.animationFrameSvc, this.visibleCols = e.visibleCols;
  }
  destroy() {
    super.destroy(), this.clearRetryListenerFncs = [], window.clearTimeout(this.scrollTimer);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl");
    const e = this.invalidateVerticalScroll.bind(this), t = this.invalidateHorizontalScroll.bind(this);
    this.addManagedEventListeners({
      displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
      gridSizeChanged: e,
      // We only invalidate horizontal scrolling when the viewport switches
      // between scrollable and non-scrollable, avoiding unnecessary
      // invalidation on every gridSizeChanged event. If more properties
      // require invalidation, read/write DOM cycles may be needed.
      scrollGapChanged: t
    }), this.addManagedElementListeners(this.eBodyViewport, {
      scroll: e
    }), this.ctrlsSvc.whenReady(this, (n) => {
      this.centerRowsCtrl = n.center, this.onDisplayedColumnsWidthChanged(), this.addScrollListener();
    });
  }
  invalidateHorizontalScroll() {
    this.isHorizontalPositionInvalidated = !0;
  }
  invalidateVerticalScroll() {
    this.isVerticalPositionInvalidated = !0;
  }
  addScrollListener() {
    this.addHorizontalScrollListeners(), this.addVerticalScrollListeners();
  }
  addHorizontalScrollListeners() {
    this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
      scroll: this.onHScroll.bind(this, ds)
    });
    for (const e of fu) {
      const t = this.ctrlsSvc.get(e);
      this.registerScrollPartner(t, this.onHScroll.bind(this, e));
    }
  }
  addVerticalScrollListeners() {
    const e = this.ctrlsSvc.get("fakeVScrollComp"), t = this.gos.get("debounceVerticalScrollbar"), n = t ? Lt(this, this.onVScroll.bind(this, ds), Am) : this.onVScroll.bind(this, ds), o = t ? Lt(this, this.onVScroll.bind(this, Em), Am) : this.onVScroll.bind(this, Em);
    this.addManagedElementListeners(this.eBodyViewport, { scroll: n }), this.registerScrollPartner(e, o);
  }
  registerScrollPartner(e, t) {
    e.onScrollCallback(t);
  }
  onDisplayedColumnsWidthChanged() {
    this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
  }
  horizontallyScrollHeaderCenterAndFloatingCenter(e) {
    this.centerRowsCtrl != null && (e === void 0 && (e = this.centerRowsCtrl.getCenterViewportScrollLeft()), this.setScrollLeftForAllContainersExceptCurrent(Math.abs(e)));
  }
  setScrollLeftForAllContainersExceptCurrent(e) {
    for (const t of [...fu, ds]) {
      if (this.lastScrollSource[
        1
        /* Horizontal */
      ] === t)
        continue;
      const n = this.getViewportForSource(t);
      yd(n, e, this.enableRtl);
    }
  }
  getViewportForSource(e) {
    return e === ds ? this.centerRowsCtrl.eViewport : this.ctrlsSvc.get(e).eViewport;
  }
  isControllingScroll(e, t) {
    return this.lastScrollSource[t] == null ? (t === 0 ? this.lastScrollSource[0] = e : this.lastScrollSource[1] = e, !0) : this.lastScrollSource[t] === e;
  }
  onHScroll(e) {
    if (!this.isControllingScroll(
      e,
      1
      /* Horizontal */
    ))
      return;
    const t = this.centerRowsCtrl.eViewport, { scrollLeft: n } = t;
    if (this.shouldBlockScrollUpdate(1, n, !0))
      return;
    const o = wd(this.getViewportForSource(e), this.enableRtl);
    this.doHorizontalScroll(o), this.resetLastHScrollDebounced();
  }
  onVScroll(e) {
    if (!this.isControllingScroll(
      e,
      0
      /* Vertical */
    ))
      return;
    let t;
    if (e === ds ? t = this.eBodyViewport.scrollTop : t = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition(), this.shouldBlockScrollUpdate(0, t, !0))
      return;
    const { animationFrameSvc: n } = this;
    n == null || n.setScrollTop(t), this.nextScrollTop = t, e === ds ? this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(t) : this.eBodyViewport.scrollTop = t, n != null && n.active ? n.schedule() : this.scrollGridIfNeeded(!0), this.resetLastVScrollDebounced();
  }
  doHorizontalScroll(e) {
    const t = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
    this.scrollLeft === e && e === t || (this.scrollLeft = e, this.fireScrollEvent(
      1
      /* Horizontal */
    ), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowsCtrl.onHorizontalViewportChanged(!0));
  }
  isScrolling() {
    return this.isScrollActive;
  }
  fireScrollEvent(e) {
    const t = {
      type: "bodyScroll",
      direction: e === 1 ? "horizontal" : "vertical",
      left: this.scrollLeft,
      top: this.scrollTop
    };
    this.isScrollActive = !0, this.eventSvc.dispatchEvent(t), window.clearTimeout(this.scrollTimer), this.scrollTimer = window.setTimeout(() => {
      this.scrollTimer = 0, this.isScrollActive = !1, this.eventSvc.dispatchEvent({
        ...t,
        type: "bodyScrollEnd"
      });
    }, mu);
  }
  shouldBlockScrollUpdate(e, t, n = !1) {
    return n && !Ss() ? !1 : e === 0 ? this.shouldBlockVerticalScroll(t) : this.shouldBlockHorizontalScroll(t);
  }
  shouldBlockVerticalScroll(e) {
    const t = cc(this.eBodyViewport), { scrollHeight: n } = this.eBodyViewport;
    return e < 0 || e + t > n;
  }
  shouldBlockHorizontalScroll(e) {
    const t = this.centerRowsCtrl.getCenterWidth(), { scrollWidth: n } = this.centerRowsCtrl.eViewport;
    if (this.enableRtl) {
      if (e > 0)
        return !0;
    } else if (e < 0)
      return !0;
    return Math.abs(e) + t > n;
  }
  redrawRowsAfterScroll() {
    this.fireScrollEvent(
      0
      /* Vertical */
    );
  }
  // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
  // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
  // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
  // back to the left to be kept in sync.
  // adding and removing the grid from the DOM both resets the scroll position and
  // triggers a resize event, so notify listeners if the scroll position has changed
  checkScrollLeft() {
    const e = this.scrollLeft;
    let t = !1;
    for (const n of fu)
      if (this.getViewportForSource(n).scrollLeft !== e) {
        t = !0;
        break;
      }
    t && this.onHScroll(ds);
  }
  scrollGridIfNeeded(e = !1) {
    const t = this.scrollTop != this.nextScrollTop;
    return t && (this.scrollTop = this.nextScrollTop, e && this.invalidateVerticalScroll(), this.redrawRowsAfterScroll()), t;
  }
  // called by scrollHorizontally method and alignedGridsService
  setHorizontalScrollPosition(e, t = !1) {
    const o = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
    !t && this.shouldBlockScrollUpdate(1, e) && (this.enableRtl ? e = e > 0 ? 0 : o : e = Math.min(Math.max(e, 0), o)), yd(this.centerRowsCtrl.eViewport, Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
  }
  setVerticalScrollPosition(e) {
    this.invalidateVerticalScroll(), this.eBodyViewport.scrollTop = e;
  }
  getVScrollPosition() {
    if (!this.isVerticalPositionInvalidated) {
      const { lastOffsetHeight: n, lastScrollTop: o } = this;
      return {
        top: o,
        bottom: o + n
      };
    }
    this.isVerticalPositionInvalidated = !1;
    const { scrollTop: e, offsetHeight: t } = this.eBodyViewport;
    return this.lastScrollTop = e, this.lastOffsetHeight = t, {
      top: e,
      bottom: e + t
    };
  }
  /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */
  getApproximateVScollPosition() {
    return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? {
      top: this.scrollTop,
      bottom: this.scrollTop + this.lastOffsetHeight
    } : this.getVScrollPosition();
  }
  getHScrollPosition() {
    return this.centerRowsCtrl.getHScrollPosition();
  }
  isHorizontalScrollShowing() {
    return this.isHorizontalPositionInvalidated && (this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing(), this.isHorizontalPositionInvalidated = !1), this.lastIsHorizontalScrollShowing;
  }
  // called by the headerRootComp and moveColumnController
  scrollHorizontally(e) {
    const t = this.centerRowsCtrl.eViewport.scrollLeft;
    return this.setHorizontalScrollPosition(t + e), this.centerRowsCtrl.eViewport.scrollLeft - t;
  }
  // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
  scrollToTop() {
    this.eBodyViewport.scrollTop = 0;
  }
  // Valid values for position are bottom, middle and top
  ensureNodeVisible(e, t = null) {
    const { rowModel: n } = this.beans, o = n.getRowCount();
    let s = -1;
    for (let i = 0; i < o; i++) {
      const r = n.getRow(i);
      if (typeof e == "function") {
        if (r && e(r)) {
          s = i;
          break;
        }
      } else if (e === r || e === r.data) {
        s = i;
        break;
      }
    }
    s >= 0 && this.ensureIndexVisible(s, t);
  }
  // Valid values for position are bottom, middle and top
  // position should be {'top','middle','bottom', or undefined/null}.
  // if undefined/null, then the grid will to the minimal amount of scrolling,
  // eg if grid needs to scroll up, it scrolls until row is on top,
  //    if grid needs to scroll down, it scrolls until row is on bottom,
  //    if row is already in view, grid does not scroll
  ensureIndexVisible(e, t, n = 0) {
    if (jt(this.gos, "print"))
      return;
    const { rowModel: o } = this.beans, s = o.getRowCount();
    if (typeof e != "number" || e < 0 || e >= s) {
      Z(88, { index: e });
      return;
    }
    this.clearRetryListeners();
    const { frameworkOverrides: i, pageBounds: r, rowContainerHeight: a, rowRenderer: l } = this.beans;
    i.wrapIncoming(() => {
      var p, f;
      const d = this.ctrlsSvc.getGridBodyCtrl(), c = o.getRow(e);
      let u, h, g = 0;
      this.invalidateVerticalScroll();
      do {
        const { stickyTopHeight: m, stickyBottomHeight: C } = d, w = c.rowTop, b = c.rowHeight, A = r.getPixelOffset(), S = c.rowTop - A, F = S + c.rowHeight, E = this.getVScrollPosition(), M = a.divStretchOffset, I = E.top + M, P = E.bottom + M, k = P - I, B = a.getScrollPositionForPixel(S), j = a.getScrollPositionForPixel(F - k), N = Math.min((B + j) / 2, S), re = I + m > S, H = P - C < F;
        let _ = null;
        t === "top" ? _ = B - m : t === "bottom" ? _ = j + C : t === "middle" ? _ = N : re ? _ = B - m : H && (j - B > k ? _ = B - m : _ = j + C), _ !== null && (this.setVerticalScrollPosition(_), l.redraw({ afterScroll: !0 })), u = w !== c.rowTop || b !== c.rowHeight, h = m !== d.stickyTopHeight || C !== d.stickyBottomHeight, g++;
      } while ((u || h) && g < 10);
      if ((p = this.animationFrameSvc) == null || p.flushAllFrames(), n < 10 && (c != null && c.stub || !((f = this.beans.rowAutoHeight) != null && f.areRowsMeasured()))) {
        const m = this.getVScrollPosition().top;
        this.clearRetryListenerFncs = this.addManagedEventListeners({
          bodyScroll: () => {
            const C = this.getVScrollPosition().top;
            m !== C && this.clearRetryListeners();
          },
          modelUpdated: () => {
            this.clearRetryListeners(), !(e >= o.getRowCount()) && this.ensureIndexVisible(e, t, n + 1);
          }
        });
      }
    });
  }
  clearRetryListeners() {
    this.clearRetryListenerFncs.forEach((e) => e()), this.clearRetryListenerFncs = [];
  }
  ensureColumnVisible(e, t = "auto") {
    const { colModel: n, frameworkOverrides: o } = this.beans, s = n.getCol(e);
    if (!s || s.isPinned() || !this.visibleCols.isColDisplayed(s))
      return;
    const i = this.getPositionedHorizontalScroll(s, t);
    o.wrapIncoming(() => {
      var r;
      i !== null && this.centerRowsCtrl.setCenterViewportScrollLeft(i), this.centerRowsCtrl.onHorizontalViewportChanged(), (r = this.animationFrameSvc) == null || r.flushAllFrames();
    });
  }
  getPositionedHorizontalScroll(e, t) {
    const { columnBeforeStart: n, columnAfterEnd: o } = this.isColumnOutsideViewport(e), s = this.centerRowsCtrl.getCenterWidth() < e.getActualWidth(), i = this.centerRowsCtrl.getCenterWidth(), r = this.enableRtl;
    let a = (r ? n : o) || s, l = r ? o : n;
    t !== "auto" && (a = t === "start", l = t === "end");
    const d = t === "middle";
    if (a || l || d) {
      const { colLeft: c, colMiddle: u, colRight: h } = this.getColumnBounds(e);
      return d ? u - i / 2 : a ? r ? h : c : r ? c - i : h - i;
    }
    return null;
  }
  isColumnOutsideViewport(e) {
    const { start: t, end: n } = this.getViewportBounds(), { colLeft: o, colRight: s } = this.getColumnBounds(e), i = this.enableRtl, r = i ? t > s : n < s, a = i ? n < o : t > o;
    return { columnBeforeStart: r, columnAfterEnd: a };
  }
  getColumnBounds(e) {
    const t = this.enableRtl, n = this.visibleCols.bodyWidth, o = e.getActualWidth(), s = e.getLeft(), i = t ? -1 : 1, r = t ? n - s : s, a = r + o * i, l = r + o / 2 * i;
    return { colLeft: r, colMiddle: l, colRight: a };
  }
  getViewportBounds() {
    const e = this.centerRowsCtrl.getCenterWidth(), t = this.centerRowsCtrl.getCenterViewportScrollLeft(), n = t, o = e + t;
    return { start: n, end: o, width: e };
  }
}, yp = class extends U {
  constructor(e, t = !1) {
    super(), this.callback = e, this.addSpacer = t;
  }
  postConstruct() {
    const e = this.setWidth.bind(this);
    this.addManagedPropertyListener("domLayout", e), this.addManagedEventListeners({
      columnContainerWidthChanged: e,
      displayedColumnsChanged: e,
      leftPinnedWidthChanged: e
    }), this.addSpacer && this.addManagedEventListeners({
      rightPinnedWidthChanged: e,
      scrollVisibilityChanged: e,
      scrollbarWidthChanged: e
    }), this.setWidth();
  }
  setWidth() {
    const e = jt(this.gos, "print"), { visibleCols: t, scrollVisibleSvc: n } = this.beans, o = t.bodyWidth, s = t.getColsLeftWidth(), i = t.getDisplayedColumnsRightWidth();
    let r;
    e ? r = o + s + i : (r = o, this.addSpacer && (this.gos.get("enableRtl") ? s : i) === 0 && n.verticalScrollShowing && (r += n.getScrollbarWidth())), this.callback(r);
  }
}, xI = class extends U {
  constructor(e) {
    super(), this.centerContainerCtrl = e;
  }
  wireBeans(e) {
    this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.listenForResize();
    }), this.addManagedEventListeners({ scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this) }), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], () => {
      this.checkViewportAndScrolls();
    });
  }
  listenForResize() {
    const { beans: e, centerContainerCtrl: t, gridBodyCtrl: n } = this, o = () => {
      kn(e, () => {
        this.onCenterViewportResized();
      });
    };
    t.registerViewportResizeListener(o), n.registerBodyViewportResizeListener(o);
  }
  onScrollbarWidthChanged() {
    this.checkViewportAndScrolls();
  }
  onCenterViewportResized() {
    if (this.scrollVisibleSvc.updateScrollGap(), this.centerContainerCtrl.isViewportInTheDOMTree()) {
      const { pinnedCols: e, colFlex: t } = this.beans;
      e == null || e.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
      const n = this.centerContainerCtrl.getCenterWidth();
      n !== this.centerWidth && (this.centerWidth = n, t == null || t.refreshFlexedColumns({
        viewportWidth: this.centerWidth,
        updateBodyWidths: !0,
        fireResizedEvent: !0
      }));
    } else
      this.bodyHeight = 0;
  }
  // gets called every time the viewport size changes. we use this to check visibility of scrollbars
  // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
  checkViewportAndScrolls() {
    this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.scrollFeature.checkScrollLeft();
  }
  getBodyHeight() {
    return this.bodyHeight;
  }
  checkBodyHeight() {
    const e = this.gridBodyCtrl.eBodyViewport, t = cc(e);
    this.bodyHeight !== t && (this.bodyHeight = t, this.eventSvc.dispatchEvent({
      type: "bodyHeightChanged"
    }));
  }
  updateScrollVisibleService() {
    this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  }
  updateScrollVisibleServiceImpl() {
    if (!this.isAlive())
      return;
    const e = {
      horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
      verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
    };
    this.scrollVisibleSvc.setScrollsVisible(e);
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged() {
    const e = this.centerContainerCtrl.getCenterWidth(), t = this.centerContainerCtrl.getViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(e, t);
  }
};
function Ql(e, t, n, o) {
  var i;
  const s = (i = t.getColDef().cellRendererParams) == null ? void 0 : i.suppressMouseEventHandling;
  return kw(e, t, n, o, s);
}
function RI(e, t, n, o) {
  const s = t == null ? void 0 : t.suppressMouseEventHandling;
  return kw(e, void 0, n, o, s);
}
function kw(e, t, n, o, s) {
  return s ? s(
    ke(e, {
      column: t,
      node: n,
      event: o
    })
  ) : !1;
}
function Lw(e, t, n) {
  let o = t;
  for (; o; ) {
    const s = IC(e, o, n);
    if (s)
      return s;
    o = o.parentElement;
  }
  return null;
}
var Dd = "cellCtrl";
function bp(e, t) {
  return Lw(e, t, Dd);
}
var Td = "renderedRow";
function EI(e, t) {
  return Lw(e, t, Td);
}
function Ih(e, t, n, o, s) {
  const i = o ? o.getColDef().suppressKeyboardEvent : void 0;
  if (!i)
    return !1;
  const r = ke(e, {
    event: t,
    editing: s,
    column: o,
    node: n,
    data: n.data,
    colDef: o.getColDef()
  });
  return !!(i && i(r));
}
function AI(e) {
  const { pinnedRowModel: t, rowModel: n } = e, [o, s] = [
    (t == null ? void 0 : t.isEmpty("top")) ?? !0,
    (t == null ? void 0 : t.isEmpty("bottom")) ?? !0
  ], i = o ? null : "top";
  let r, a;
  s ? (r = null, a = n.getRowCount() - 1) : (r = "bottom", a = (t == null ? void 0 : t.getPinnedBottomRowCount()) ?? -1);
  const { visibleCols: l, rangeSvc: d } = e, c = l.allCols;
  !d || !(c != null && c.length) || d.setCellRange({
    rowStartIndex: 0,
    rowStartPinned: i,
    rowEndIndex: a,
    rowEndPinned: r
  });
}
var FI = 65, MI = 67, II = 86, PI = 68, DI = 90, TI = 89;
function kI(e) {
  const { keyCode: t } = e;
  let n;
  switch (t) {
    case FI:
      n = O.A;
      break;
    case MI:
      n = O.C;
      break;
    case II:
      n = O.V;
      break;
    case PI:
      n = O.D;
      break;
    case DI:
      n = O.Z;
      break;
    case TI:
      n = O.Y;
      break;
    default:
      n = e.code;
  }
  return n;
}
var LI = class extends U {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    var e;
    this.addKeyboardListeners(), this.addMouseListeners(), (e = this.beans.touchSvc) == null || e.mockRowContextMenu(this), this.editSvc = this.beans.editSvc;
  }
  addKeyboardListeners() {
    const e = "keydown", t = this.processKeyboardEvent.bind(this, e);
    this.addManagedElementListeners(this.element, { [e]: t });
  }
  addMouseListeners() {
    ["dblclick", "contextmenu", "mouseover", "mouseout", "click", CC("touchstart") ? "touchstart" : "mousedown"].forEach((n) => {
      const o = this.processMouseEvent.bind(this, n);
      this.addManagedElementListeners(this.element, { [n]: o });
    });
  }
  processMouseEvent(e, t) {
    var s;
    if (!Pa(this.beans, t) || Dn(t))
      return;
    const { cellCtrl: n, rowCtrl: o } = this.getControlsForEventTarget(t.target);
    e === "contextmenu" ? (n != null && n.column && n.dispatchCellContextMenuEvent(t), (s = this.beans.contextMenuSvc) == null || s.handleContextMenuMouseEvent(t, void 0, o, n)) : (n && n.onMouseEvent(e, t), o && o.onMouseEvent(e, t));
  }
  getControlsForEventTarget(e) {
    const { gos: t } = this;
    return {
      cellCtrl: bp(t, e),
      rowCtrl: EI(t, e)
    };
  }
  processKeyboardEvent(e, t) {
    const { cellCtrl: n, rowCtrl: o } = this.getControlsForEventTarget(t.target);
    t.defaultPrevented || (n ? this.processCellKeyboardEvent(n, e, t) : o != null && o.isFullWidth() && this.processFullWidthRowKeyboardEvent(o, e, t));
  }
  processCellKeyboardEvent(e, t, n) {
    var i, r;
    const o = ((i = this.editSvc) == null ? void 0 : i.isEditing(e, { withOpenEditor: !0 })) ?? !1;
    !Ih(
      this.gos,
      n,
      e.rowNode,
      e.column,
      o
    ) && t === "keydown" && (!o && ((r = this.beans.navigation) != null && r.handlePageScrollingKey(n)) || e.onKeyDown(n), this.doGridOperations(n, o), dp(n) && e.processCharacter(n)), t === "keydown" && this.eventSvc.dispatchEvent(e.createEvent(n, "cellKeyDown"));
  }
  processFullWidthRowKeyboardEvent(e, t, n) {
    const { rowNode: o } = e, { focusSvc: s, navigation: i } = this.beans, r = s.getFocusedCell(), a = r == null ? void 0 : r.column;
    if (!Ih(this.gos, n, o, a, !1)) {
      const d = n.key;
      if (t === "keydown")
        switch (d) {
          case O.PAGE_HOME:
          case O.PAGE_END:
          case O.PAGE_UP:
          case O.PAGE_DOWN:
            i == null || i.handlePageScrollingKey(n, !0);
            break;
          case O.LEFT:
          case O.RIGHT:
            if (!this.gos.get("embedFullWidthRows"))
              break;
          case O.UP:
          case O.DOWN:
            e.onKeyboardNavigate(n);
            break;
          case O.TAB:
            e.onTabKeyDown(n);
            break;
        }
    }
    t === "keydown" && this.eventSvc.dispatchEvent(e.createRowEvent("cellKeyDown", n));
  }
  doGridOperations(e, t) {
    if (!e.ctrlKey && !e.metaKey || t || !Pa(this.beans, e))
      return;
    const n = kI(e), { clipboardSvc: o, undoRedo: s } = this.beans;
    if (n === O.A)
      return this.onCtrlAndA(e);
    if (n === O.C)
      return this.onCtrlAndC(o, e);
    if (n === O.D)
      return this.onCtrlAndD(o, e);
    if (n === O.V)
      return this.onCtrlAndV(o, e);
    if (n === O.X)
      return this.onCtrlAndX(o, e);
    if (n === O.Y)
      return this.onCtrlAndY(s);
    if (n === O.Z)
      return this.onCtrlAndZ(s, e);
  }
  onCtrlAndA(e) {
    const {
      beans: { rowModel: t, rangeSvc: n, selectionSvc: o },
      gos: s
    } = this;
    n && Xo(s) && t.isRowsToRender() ? AI(this.beans) : o && (o == null || o.selectAllRowNodes({ source: "keyboardSelectAll", selectAll: BC(s) })), e.preventDefault();
  }
  onCtrlAndC(e, t) {
    var o;
    if (!e || this.gos.get("enableCellTextSelection"))
      return;
    const { cellCtrl: n } = this.getControlsForEventTarget(t.target);
    (o = this.editSvc) != null && o.isEditing(n, { withOpenEditor: !0 }) || (t.preventDefault(), e.copyToClipboard());
  }
  onCtrlAndX(e, t) {
    var o;
    if (!e || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard"))
      return;
    const { cellCtrl: n } = this.getControlsForEventTarget(t.target);
    (o = this.editSvc) != null && o.isEditing(n, { withOpenEditor: !0 }) || (t.preventDefault(), e.cutToClipboard(void 0, "ui"));
  }
  onCtrlAndV(e, t) {
    var o;
    const { cellCtrl: n } = this.getControlsForEventTarget(t.target);
    (o = this.editSvc) != null && o.isEditing(n, { withOpenEditor: !0 }) || e && !this.gos.get("suppressClipboardPaste") && e.pasteFromClipboard();
  }
  onCtrlAndD(e, t) {
    e && !this.gos.get("suppressClipboardPaste") && e.copyRangeDown(), t.preventDefault();
  }
  onCtrlAndZ(e, t) {
    !this.gos.get("undoRedoCellEditing") || !e || (t.preventDefault(), t.shiftKey ? e.redo("ui") : e.undo("ui"));
  }
  onCtrlAndY(e) {
    e == null || e.redo("ui");
  }
}, Bw = class extends U {
  constructor(e, t) {
    super(), this.eContainer = e, this.eViewport = t;
  }
  postConstruct() {
    this.addManagedEventListeners({
      rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
    });
  }
  onHeightChanged(e) {
    const t = e.uiContainerHeight, n = t != null ? `${t}px` : "";
    this.eContainer.style.height = n, this.eViewport && (this.eViewport.style.height = n);
  }
}, bl = (e) => e.topRowCtrls, Sl = (e) => e.getStickyTopRowCtrls(), xl = (e) => e.getStickyBottomRowCtrls(), Rl = (e) => e.bottomRowCtrls, El = (e) => e.allRowCtrls, vu = (e) => e.getCtrls("top"), Cu = (e) => e.getCtrls("center"), wu = (e) => e.getCtrls("bottom"), BI = {
  center: {
    type: "center",
    name: "center-cols",
    getRowCtrls: El,
    getSpannedRowCtrls: Cu
  },
  left: {
    type: "left",
    name: "pinned-left-cols",
    pinnedType: "left",
    getRowCtrls: El,
    getSpannedRowCtrls: Cu
  },
  right: {
    type: "right",
    name: "pinned-right-cols",
    pinnedType: "right",
    getRowCtrls: El,
    getSpannedRowCtrls: Cu
  },
  fullWidth: {
    type: "fullWidth",
    name: "full-width",
    fullWidth: !0,
    getRowCtrls: El
  },
  topCenter: {
    type: "center",
    name: "floating-top",
    getRowCtrls: bl,
    getSpannedRowCtrls: vu
  },
  topLeft: {
    type: "left",
    name: "pinned-left-floating",
    container: "ag-pinned-left-floating-top",
    pinnedType: "left",
    getRowCtrls: bl,
    getSpannedRowCtrls: vu
  },
  topRight: {
    type: "right",
    name: "pinned-right-floating",
    container: "ag-pinned-right-floating-top",
    pinnedType: "right",
    getRowCtrls: bl,
    getSpannedRowCtrls: vu
  },
  topFullWidth: {
    type: "fullWidth",
    name: "floating-top-full-width",
    fullWidth: !0,
    getRowCtrls: bl
  },
  stickyTopCenter: {
    type: "center",
    name: "sticky-top",
    getRowCtrls: Sl
  },
  stickyTopLeft: {
    type: "left",
    name: "pinned-left-sticky-top",
    container: "ag-pinned-left-sticky-top",
    pinnedType: "left",
    getRowCtrls: Sl
  },
  stickyTopRight: {
    type: "right",
    name: "pinned-right-sticky-top",
    container: "ag-pinned-right-sticky-top",
    pinnedType: "right",
    getRowCtrls: Sl
  },
  stickyTopFullWidth: {
    type: "fullWidth",
    name: "sticky-top-full-width",
    fullWidth: !0,
    getRowCtrls: Sl
  },
  stickyBottomCenter: {
    type: "center",
    name: "sticky-bottom",
    getRowCtrls: xl
  },
  stickyBottomLeft: {
    type: "left",
    name: "pinned-left-sticky-bottom",
    container: "ag-pinned-left-sticky-bottom",
    pinnedType: "left",
    getRowCtrls: xl
  },
  stickyBottomRight: {
    type: "right",
    name: "pinned-right-sticky-bottom",
    container: "ag-pinned-right-sticky-bottom",
    pinnedType: "right",
    getRowCtrls: xl
  },
  stickyBottomFullWidth: {
    type: "fullWidth",
    name: "sticky-bottom-full-width",
    fullWidth: !0,
    getRowCtrls: xl
  },
  bottomCenter: {
    type: "center",
    name: "floating-bottom",
    getRowCtrls: Rl,
    getSpannedRowCtrls: wu
  },
  bottomLeft: {
    type: "left",
    name: "pinned-left-floating-bottom",
    container: "ag-pinned-left-floating-bottom",
    pinnedType: "left",
    getRowCtrls: Rl,
    getSpannedRowCtrls: wu
  },
  bottomRight: {
    type: "right",
    name: "pinned-right-floating-bottom",
    container: "ag-pinned-right-floating-bottom",
    pinnedType: "right",
    getRowCtrls: Rl,
    getSpannedRowCtrls: wu
  },
  bottomFullWidth: {
    type: "fullWidth",
    name: "floating-bottom-full-width",
    fullWidth: !0,
    getRowCtrls: Rl
  }
};
function Ow(e) {
  return `ag-${el(e).name}-viewport`;
}
function Jl(e) {
  const t = el(e);
  return t.container ?? `ag-${t.name}-container`;
}
function OI(e) {
  return `ag-${el(e).name}-spanned-cells-container`;
}
function el(e) {
  return BI[e];
}
var GI = ["topCenter", "topLeft", "topRight"], HI = ["bottomCenter", "bottomLeft", "bottomRight"], VI = ["center", "left", "right"], _I = ["center", "left", "right", "fullWidth"], NI = ["stickyTopCenter", "stickyBottomCenter", "center", "topCenter", "bottomCenter"], $I = ["left", "bottomLeft", "topLeft", "stickyTopLeft", "stickyBottomLeft"], zI = ["right", "bottomRight", "topRight", "stickyTopRight", "stickyBottomRight"], Gw = ["stickyTopCenter", "stickyTopLeft", "stickyTopRight"], Hw = ["stickyBottomCenter", "stickyBottomLeft", "stickyBottomRight"], WI = [
  ...Gw,
  "stickyTopFullWidth",
  ...Hw,
  "stickyBottomFullWidth"
], UI = [
  ...GI,
  ...HI,
  ...VI,
  ...Gw,
  ...Hw
], KI = class extends U {
  constructor(e) {
    super(), this.name = e, this.visible = !0, this.EMPTY_CTRLS = [], this.options = el(e);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.forContainers(["center"], () => {
      this.viewportSizeFeature = this.createManagedBean(new xI(this)), this.addManagedEventListeners({
        stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
      });
    });
  }
  onStickyTopOffsetChanged(e) {
    this.comp.setOffsetTop(`${e.offset}px`);
  }
  registerWithCtrlsService() {
    this.options.fullWidth || this.beans.ctrlsSvc.register(this.name, this);
  }
  forContainers(e, t) {
    e.indexOf(this.name) >= 0 && t();
  }
  setComp(e, t, n, o) {
    this.comp = e, this.eContainer = t, this.eSpannedContainer = n, this.eViewport = o, this.createManagedBean(new LI(this.eViewport ?? this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder();
    const { pinnedCols: s, rangeSvc: i } = this.beans, r = () => this.onPinnedWidthChanged();
    this.forContainers($I, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        s == null ? void 0 : s.createPinnedWidthFeature(!0, this.eContainer, this.eSpannedContainer)
      ), this.addManagedEventListeners({ leftPinnedWidthChanged: r });
    }), this.forContainers(zI, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        s == null ? void 0 : s.createPinnedWidthFeature(!1, this.eContainer, this.eSpannedContainer)
      ), this.addManagedEventListeners({ rightPinnedWidthChanged: r });
    }), this.forContainers(
      _I,
      () => this.createManagedBean(
        new Bw(this.eContainer, this.name === "center" ? o : void 0)
      )
    ), i && this.forContainers(
      UI,
      () => this.createManagedBean(i.createDragListenerFeature(this.eContainer))
    ), this.forContainers(
      NI,
      () => this.createManagedBean(new yp((a) => this.comp.setContainerWidth(`${a}px`)))
    ), this.visible = this.isContainerVisible(), this.addListeners(), this.registerWithCtrlsService();
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  addListeners() {
    const { spannedRowRenderer: e, gos: t } = this.beans, n = this.onDisplayedColumnsChanged.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: n,
      displayedColumnsWidthChanged: n,
      displayedRowsChanged: (o) => this.onDisplayedRowsChanged(o.afterScroll)
    }), n(), this.onDisplayedRowsChanged(), e && this.options.getSpannedRowCtrls && t.get("enableCellSpan") && this.addManagedListeners(e, {
      spannedRowsUpdated: () => {
        const o = this.options.getSpannedRowCtrls(e);
        o && this.comp.setSpannedRowCtrls(o, !1);
      }
    });
  }
  listenOnDomOrder() {
    if (WI.indexOf(this.name) >= 0) {
      this.comp.setDomOrder(!0);
      return;
    }
    const t = () => {
      const n = this.gos.get("ensureDomOrder"), o = jt(this.gos, "print");
      this.comp.setDomOrder(n || o);
    };
    this.addManagedPropertyListener("domLayout", t), t();
  }
  onDisplayedColumnsChanged() {
    this.forContainers(["center"], () => this.onHorizontalViewportChanged());
  }
  // this methods prevents the grid views from being scrolled while the dragService is being used
  // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
  addPreventScrollWhileDragging() {
    const { dragSvc: e } = this.beans;
    if (!e)
      return;
    const t = (n) => {
      e.dragging && n.cancelable && n.preventDefault();
    };
    this.eContainer.addEventListener("touchmove", t, { passive: !1 }), this.addDestroyFunc(() => this.eContainer.removeEventListener("touchmove", t));
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged(e = !1) {
    const t = this.getCenterWidth(), n = this.getCenterViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(t, n, e);
  }
  hasHorizontalScrollGap() {
    return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
  }
  hasVerticalScrollGap() {
    return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
  }
  getCenterWidth() {
    return mr(this.eViewport);
  }
  getCenterViewportScrollLeft() {
    return wd(this.eViewport, this.enableRtl);
  }
  registerViewportResizeListener(e) {
    const t = Bo(this.beans, this.eViewport, e);
    this.addDestroyFunc(() => t());
  }
  isViewportInTheDOMTree() {
    return gC(this.eViewport);
  }
  getViewportScrollLeft() {
    return wd(this.eViewport, this.enableRtl);
  }
  isHorizontalScrollShowing() {
    return this.gos.get("alwaysShowHorizontalScroll") || qg(this.eViewport);
  }
  setHorizontalScroll(e) {
    this.comp.setHorizontalScroll(e);
  }
  getHScrollPosition() {
    return {
      left: this.eViewport.scrollLeft,
      right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
    };
  }
  setCenterViewportScrollLeft(e) {
    yd(this.eViewport, e, this.enableRtl);
  }
  isContainerVisible() {
    return !(this.options.pinnedType != null) || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
  }
  onPinnedWidthChanged() {
    const e = this.isContainerVisible();
    this.visible != e && (this.visible = e, this.onDisplayedRowsChanged());
  }
  onDisplayedRowsChanged(e = !1) {
    const t = this.options.getRowCtrls(this.beans.rowRenderer);
    if (!this.visible || t.length === 0) {
      this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
      return;
    }
    const n = jt(this.gos, "print"), s = this.gos.get("embedFullWidthRows") || n, i = t.filter((r) => {
      const a = r.isFullWidth();
      return this.options.fullWidth ? !s && a : s || !a;
    });
    this.comp.setRowCtrls({ rowCtrls: i, useFlushSync: e });
  }
}, Vw = "ag-force-vertical-scroll", ZI = "ag-selectable", qI = "ag-column-moving", jI = class extends U {
  constructor() {
    super(...arguments), this.stickyTopHeight = 0, this.stickyBottomHeight = 0;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colModel = e.colModel, this.scrollVisibleSvc = e.scrollVisibleSvc, this.pinnedRowModel = e.pinnedRowModel, this.filterManager = e.filterManager, this.rowGroupColsSvc = e.rowGroupColsSvc;
  }
  setComp(e, t, n, o, s, i, r) {
    var a, l;
    this.comp = e, this.eGridBody = t, this.eBodyViewport = n, this.eTop = o, this.eBottom = s, this.eStickyTop = i, this.eStickyBottom = r, this.eCenterColsViewport = n.querySelector(`.${Ow("center")}`), this.eFullWidthContainer = n.querySelector(`.${Jl("fullWidth")}`), this.eStickyTopFullWidthContainer = i.querySelector(
      `.${Jl("stickyTopFullWidth")}`
    ), this.eStickyBottomFullWidthContainer = r.querySelector(
      `.${Jl("stickyBottomFullWidth")}`
    ), this.setCellTextSelection(this.gos.get("enableCellTextSelection")), this.addManagedPropertyListener(
      "enableCellTextSelection",
      (d) => this.setCellTextSelection(d.currentValue)
    ), this.createManagedBean(new wp(this.comp)), this.scrollFeature = this.createManagedBean(new SI(n)), (a = this.beans.rowDragSvc) == null || a.setupRowDrag(n, this), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([o, n, s, i, r]), this.setGridRootRole(), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.updateScrollingClasses(), (l = this.filterManager) == null || l.setupAdvFilterHeaderComp(o), this.ctrlsSvc.register("gridBodyCtrl", this);
  }
  addEventListeners() {
    const e = this.setFloatingHeights.bind(this), t = this.setGridRootRole.bind(this), n = this.toggleRowResizeStyles.bind(this);
    this.addManagedEventListeners({
      gridColumnsChanged: this.onGridColumnsChanged.bind(this),
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
      scrollGapChanged: this.updateScrollingClasses.bind(this),
      pinnedRowDataChanged: e,
      pinnedHeightChanged: e,
      pinnedRowsChanged: e,
      headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
      columnRowGroupChanged: t,
      columnPivotChanged: t,
      rowResizeStarted: n,
      rowResizeEnded: n
    }), this.addManagedPropertyListener("treeData", t);
  }
  toggleRowResizeStyles(e) {
    const t = e.type === "rowResizeStarted";
    this.eBodyViewport.classList.toggle("ag-prevent-animation", t);
  }
  onGridColumnsChanged() {
    const e = this.beans.colModel.getCols();
    this.comp.setColumnCount(e.length);
  }
  onScrollVisibilityChanged() {
    const { scrollVisibleSvc: e } = this, t = e.verticalScrollShowing;
    this.setVerticalScrollPaddingVisible(t), this.setStickyWidth(t), this.setStickyBottomOffsetBottom();
    const n = t && e.getScrollbarWidth() || 0, o = dw() ? 16 : 0, s = `calc(100% + ${n + o}px)`;
    kn(this.beans, () => this.comp.setBodyViewportWidth(s)), this.updateScrollingClasses();
  }
  setGridRootRole() {
    const { rowGroupColsSvc: e, colModel: t } = this;
    let n = this.gos.get("treeData");
    if (!n) {
      const o = t.isPivotMode();
      n = (e ? e.columns.length : 0) >= (o ? 2 : 1);
    }
    this.comp.setGridRootRole(n ? "treegrid" : "grid");
  }
  addFocusListeners(e) {
    e.forEach((t) => {
      this.addManagedElementListeners(t, {
        focusin: (n) => {
          const { target: o } = n, s = ri(o, "ag-root", t);
          t.classList.toggle("ag-has-focus", !s);
        },
        focusout: (n) => {
          const { target: o, relatedTarget: s } = n, i = t.contains(s), r = ri(
            s,
            "ag-root",
            t
          );
          ri(o, "ag-root", t) || (!i || r) && t.classList.remove("ag-has-focus");
        }
      });
    });
  }
  // used by ColumnAnimationService
  setColumnMovingCss(e) {
    this.comp.setColumnMovingCss(qI, e);
  }
  setCellTextSelection(e = !1) {
    this.comp.setCellSelectableCss(ZI, e);
  }
  updateScrollingClasses() {
    const {
      eGridBody: { classList: e },
      scrollVisibleSvc: t
    } = this;
    e.toggle("ag-body-vertical-content-no-gap", !t.verticalScrollGap), e.toggle("ag-body-horizontal-content-no-gap", !t.horizontalScrollGap);
  }
  // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
  // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
  disableBrowserDragging() {
    this.addManagedElementListeners(this.eGridBody, {
      dragstart: (e) => {
        if (e.target instanceof HTMLImageElement)
          return e.preventDefault(), !1;
      }
    });
  }
  addStopEditingWhenGridLosesFocus() {
    var e;
    (e = this.beans.editSvc) == null || e.addStopEditingWhenGridLosesFocus([
      this.eBodyViewport,
      this.eBottom,
      this.eTop,
      this.eStickyTop,
      this.eStickyBottom
    ]);
  }
  updateRowCount() {
    var s, i;
    const e = (((s = this.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : s.getRowCount()) ?? 0) + (((i = this.filterManager) == null ? void 0 : i.getHeaderRowCount()) ?? 0), { rowModel: t } = this.beans, n = t.isLastRowIndexKnown() ? t.getRowCount() : -1, o = n === -1 ? -1 : e + n;
    this.comp.setRowCount(o);
  }
  registerBodyViewportResizeListener(e) {
    this.comp.registerBodyViewportResizeListener(e);
  }
  setVerticalScrollPaddingVisible(e) {
    const t = e ? "scroll" : "hidden";
    this.comp.setPinnedTopBottomOverflowY(t);
  }
  isVerticalScrollShowing() {
    const e = this.gos.get("alwaysShowVerticalScroll"), t = e ? Vw : null, n = jt(this.gos, "normal");
    return this.comp.setAlwaysVerticalScrollClass(t, e), e || n && mC(this.eBodyViewport);
  }
  setupRowAnimationCssClass() {
    const { rowContainerHeight: e, environment: t } = this.beans;
    let n = t.sizesMeasured;
    const o = () => {
      const s = n && Xi(this.gos) && !e.stretching, i = s ? "ag-row-animation" : "ag-row-no-animation";
      this.comp.setRowAnimationCssOnBodyViewport(i, s);
    };
    o(), this.addManagedEventListeners({ heightScaleChanged: o }), this.addManagedPropertyListener("animateRows", o), this.addManagedEventListeners({
      gridStylesChanged: () => {
        !n && t.sizesMeasured && (n = !0, o());
      }
    });
  }
  addBodyViewportListener() {
    const {
      eBodyViewport: e,
      eStickyTop: t,
      eStickyBottom: n,
      eTop: o,
      eBottom: s,
      beans: { popupSvc: i, touchSvc: r }
    } = this, a = this.onBodyViewportContextMenu.bind(this);
    this.addManagedElementListeners(e, { contextmenu: a }), r == null || r.mockBodyContextMenu(this, a), this.addManagedElementListeners(e, {
      wheel: this.onBodyViewportWheel.bind(this, i)
    });
    const l = this.onStickyWheel.bind(this);
    for (const c of [t, n, o, s])
      this.addManagedElementListeners(c, { wheel: l });
    const d = this.onHorizontalWheel.bind(this);
    for (const c of ["left", "right", "topLeft", "topRight", "bottomLeft", "bottomRight"])
      this.addManagedElementListeners(this.ctrlsSvc.get(c).eContainer, {
        wheel: d
      });
    this.addFullWidthContainerWheelListener();
  }
  addFullWidthContainerWheelListener() {
    this.addManagedElementListeners(this.eFullWidthContainer, {
      wheel: (e) => this.onFullWidthContainerWheel(e)
    });
  }
  onFullWidthContainerWheel(e) {
    const { deltaX: t, deltaY: n, shiftKey: o } = e;
    (o || Math.abs(t) > Math.abs(n)) && Pa(this.beans, e) && this.scrollGridBodyToMatchEvent(e);
  }
  onStickyWheel(e) {
    const { deltaY: t } = e;
    this.scrollVertically(t) > 0 && e.preventDefault();
  }
  onHorizontalWheel(e) {
    const { deltaX: t, deltaY: n, shiftKey: o } = e;
    (o || Math.abs(t) > Math.abs(n)) && this.scrollGridBodyToMatchEvent(e);
  }
  scrollGridBodyToMatchEvent(e) {
    const { deltaX: t, deltaY: n } = e;
    e.preventDefault(), this.eCenterColsViewport.scrollBy({ left: t || n });
  }
  onBodyViewportContextMenu(e, t, n) {
    var s;
    if (!e && !n)
      return;
    this.gos.get("preventDefaultOnContextMenu") && (e || n).preventDefault();
    const { target: o } = e || t;
    (o === this.eBodyViewport || o === this.ctrlsSvc.get("center").eViewport) && ((s = this.beans.contextMenuSvc) == null || s.showContextMenu({
      mouseEvent: e,
      touchEvent: n,
      value: null,
      anchorToElement: this.eGridBody,
      source: "ui"
    }));
  }
  onBodyViewportWheel(e, t) {
    this.gos.get("suppressScrollWhenPopupsAreOpen") && e != null && e.hasAnchoredPopup() && t.preventDefault();
  }
  // called by rowDragFeature
  scrollVertically(e) {
    const t = this.eBodyViewport.scrollTop;
    return this.scrollFeature.setVerticalScrollPosition(t + e), this.eBodyViewport.scrollTop - t;
  }
  setFloatingHeights() {
    const {
      pinnedRowModel: e,
      beans: { environment: t }
    } = this, n = e == null ? void 0 : e.getPinnedTopTotalHeight(), o = e == null ? void 0 : e.getPinnedBottomTotalHeight(), s = t.getPinnedRowBorderWidth(), i = t.getRowBorderWidth(), r = s - i, a = n ? r + n : 0, l = o ? r + o : 0;
    this.comp.setTopHeight(a), this.comp.setBottomHeight(l), this.comp.setTopInvisible(a <= 0), this.comp.setBottomInvisible(l <= 0), this.setStickyTopOffsetTop(), this.setStickyBottomOffsetBottom();
  }
  setStickyTopHeight(e = 0) {
    this.comp.setStickyTopHeight(`${e}px`), this.stickyTopHeight = e;
  }
  setStickyBottomHeight(e = 0) {
    this.comp.setStickyBottomHeight(`${e}px`), this.stickyBottomHeight = e;
  }
  setStickyWidth(e) {
    if (!e)
      this.comp.setStickyTopWidth("100%"), this.comp.setStickyBottomWidth("100%");
    else {
      const t = this.scrollVisibleSvc.getScrollbarWidth();
      this.comp.setStickyTopWidth(`calc(100% - ${t}px)`), this.comp.setStickyBottomWidth(`calc(100% - ${t}px)`);
    }
  }
  setStickyTopOffsetTop() {
    var s, i;
    const t = this.ctrlsSvc.get("gridHeaderCtrl").headerHeight + (((s = this.filterManager) == null ? void 0 : s.getHeaderHeight()) ?? 0), n = ((i = this.pinnedRowModel) == null ? void 0 : i.getPinnedTopTotalHeight()) ?? 0;
    let o = 0;
    t > 0 && (o += t), n > 0 && (o += n), o > 0 && (o += 1), this.comp.setStickyTopTop(`${o}px`);
  }
  setStickyBottomOffsetBottom() {
    const { pinnedRowModel: e, scrollVisibleSvc: t, comp: n } = this, o = (e == null ? void 0 : e.getPinnedBottomTotalHeight()) ?? 0, i = t.horizontalScrollShowing && t.getScrollbarWidth() || 0, r = o + i;
    n.setStickyBottomBottom(`${r}px`);
  }
};
function YI(e, t) {
  var n;
  return ((n = bp(e, t.target)) == null ? void 0 : n.getFocusedCellPosition()) ?? null;
}
function Fm(e, t) {
  const n = jt(e.gos, "normal"), o = t;
  let s, i;
  o.clientX != null || o.clientY != null ? (s = o.clientX, i = o.clientY) : (s = o.x, i = o.y);
  const { pageFirstPixel: r } = e.pageBounds.getCurrentPagePixelRange();
  if (i += r, n) {
    const a = e.ctrlsSvc.getScrollFeature(), l = a.getVScrollPosition(), d = a.getHScrollPosition();
    s += d.left, i += l.top;
  }
  return { x: s, y: i };
}
var _w = class extends Te {
  constructor(e, t) {
    super(), this.direction = t, this.eViewport = X, this.eContainer = X, this.hideTimeout = 0, this.setTemplate(e);
  }
  postConstruct() {
    this.addManagedEventListeners({
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
    }), this.onScrollVisibilityChanged(), this.toggleCss("ag-apple-scrollbar", aw() || Ss());
  }
  destroy() {
    super.destroy(), window.clearTimeout(this.hideTimeout);
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = dw(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
  }
  addActiveListenerToggles() {
    const e = this.getGui(), t = () => this.toggleCss("ag-scrollbar-active", !0), n = () => this.toggleCss("ag-scrollbar-active", !1);
    this.addManagedListeners(e, {
      mouseenter: t,
      mousedown: t,
      touchstart: t,
      mouseleave: n,
      touchend: n
    });
  }
  onScrollVisibilityChanged() {
    this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), kn(this.beans, () => this.setScrollVisible());
  }
  hideAndShowInvisibleScrollAsNeeded() {
    this.addManagedEventListeners({
      bodyScroll: (e) => {
        e.direction === this.direction && (this.hideTimeout && (window.clearTimeout(this.hideTimeout), this.hideTimeout = 0), this.toggleCss("ag-scrollbar-scrolling", !0));
      },
      bodyScrollEnd: () => {
        this.hideTimeout = window.setTimeout(() => {
          this.toggleCss("ag-scrollbar-scrolling", !1), this.hideTimeout = 0;
        }, 400);
      }
    });
  }
  attemptSettingScrollPosition(e) {
    const t = this.eViewport;
    SC(
      this,
      () => vn(t),
      () => this.setScrollPosition(e),
      100
    );
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
}, QI = {
  tag: "div",
  cls: "ag-body-horizontal-scroll",
  attrs: { "aria-hidden": "true" },
  children: [
    { tag: "div", ref: "eLeftSpacer", cls: "ag-horizontal-left-spacer" },
    {
      tag: "div",
      ref: "eViewport",
      cls: "ag-body-horizontal-scroll-viewport",
      children: [{ tag: "div", ref: "eContainer", cls: "ag-body-horizontal-scroll-container" }]
    },
    { tag: "div", ref: "eRightSpacer", cls: "ag-horizontal-right-spacer" }
  ]
}, JI = class extends _w {
  constructor() {
    super(QI, "horizontal"), this.eLeftSpacer = X, this.eRightSpacer = X, this.setScrollVisibleDebounce = 0;
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    super.postConstruct();
    const e = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e,
      pinnedRowDataChanged: this.refreshCompBottom.bind(this)
    }), this.addManagedPropertyListener("domLayout", e), this.beans.ctrlsSvc.register("fakeHScrollComp", this), this.createManagedBean(new yp((t) => this.eContainer.style.width = `${t}px`)), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
  }
  destroy() {
    window.clearTimeout(this.setScrollVisibleDebounce), super.destroy();
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.enableRtl = this.gos.get("enableRtl"), super.initialiseInvisibleScrollbar(), this.invisibleScrollbar && this.refreshCompBottom());
  }
  refreshCompBottom() {
    var t;
    if (!this.invisibleScrollbar)
      return;
    const e = ((t = this.beans.pinnedRowModel) == null ? void 0 : t.getPinnedBottomTotalHeight()) ?? 0;
    this.getGui().style.bottom = `${e}px`;
  }
  onScrollVisibilityChanged() {
    super.onScrollVisibilityChanged(), this.setFakeHScrollSpacerWidths();
  }
  setFakeHScrollSpacerWidths() {
    const e = this.scrollVisibleSvc.verticalScrollShowing;
    let t = this.visibleCols.getDisplayedColumnsRightWidth();
    const n = !this.enableRtl && e, o = this.scrollVisibleSvc.getScrollbarWidth();
    n && (t += o), Ro(this.eRightSpacer, t), this.eRightSpacer.classList.toggle("ag-scroller-corner", t <= o);
    let s = this.visibleCols.getColsLeftWidth();
    this.enableRtl && e && (s += o), Ro(this.eLeftSpacer, s), this.eLeftSpacer.classList.toggle("ag-scroller-corner", s <= o);
  }
  setScrollVisible() {
    const e = this.scrollVisibleSvc.horizontalScrollShowing, t = this.invisibleScrollbar, n = this.gos.get("suppressHorizontalScroll"), o = e && this.scrollVisibleSvc.getScrollbarWidth() || 0, i = n ? 0 : o === 0 && t ? 16 : o, r = () => {
      this.setScrollVisibleDebounce = 0, this.toggleCss("ag-scrollbar-invisible", t), ia(this.getGui(), i), ia(this.eViewport, i), ia(this.eContainer, i), i || this.eContainer.style.setProperty("min-height", "1px"), this.setVisible(e, { skipAriaHidden: !0 });
    };
    window.clearTimeout(this.setScrollVisibleDebounce), e ? this.setScrollVisibleDebounce = window.setTimeout(r, 100) : r();
  }
  getScrollPosition() {
    return wd(this.eViewport, this.enableRtl);
  }
  setScrollPosition(e) {
    vn(this.eViewport) || this.attemptSettingScrollPosition(e), yd(this.eViewport, e, this.enableRtl);
  }
}, XI = {
  selector: "AG-FAKE-HORIZONTAL-SCROLL",
  component: JI
}, eP = {
  tag: "div",
  cls: "ag-body-vertical-scroll",
  attrs: { "aria-hidden": "true" },
  children: [
    {
      tag: "div",
      ref: "eViewport",
      cls: "ag-body-vertical-scroll-viewport",
      children: [{ tag: "div", ref: "eContainer", cls: "ag-body-vertical-scroll-container" }]
    }
  ]
}, tP = class extends _w {
  constructor() {
    super(eP, "vertical");
  }
  postConstruct() {
    super.postConstruct(), this.createManagedBean(new Bw(this.eContainer));
    const { ctrlsSvc: e } = this.beans;
    e.register("fakeVScrollComp", this), this.addManagedEventListeners({
      rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, e)
    });
  }
  setScrollVisible() {
    const { scrollVisibleSvc: e } = this.beans, t = e.verticalScrollShowing, n = this.invisibleScrollbar, o = t && e.getScrollbarWidth() || 0, s = o === 0 && n ? 16 : o;
    this.toggleCss("ag-scrollbar-invisible", n), Ro(this.getGui(), s), Ro(this.eViewport, s), Ro(this.eContainer, s), this.setDisplayed(t, { skipAriaHidden: !0 });
  }
  onRowContainerHeightChanged(e) {
    const n = e.getGridBodyCtrl().eBodyViewport, o = this.getScrollPosition(), s = n.scrollTop;
    o != s && this.setScrollPosition(s, !0);
  }
  getScrollPosition() {
    return this.eViewport.scrollTop;
  }
  setScrollPosition(e, t) {
    !t && !vn(this.eViewport) && this.attemptSettingScrollPosition(e), this.eViewport.scrollTop = e;
  }
}, nP = {
  selector: "AG-FAKE-VERTICAL-SCROLL",
  component: tP
}, oP = "ag-column-first", sP = "ag-column-last";
function Nw(e, t, n, o) {
  return st(e) ? [] : Ww(e.headerClass, e, t, n, o);
}
function $w(e, t, n, o) {
  return st(e) ? [] : Ww(e.toolPanelClass, e, t, n, o);
}
function zw(e, t, n) {
  e.toggleCss(oP, n.isColAtEdge(t, "first")), e.toggleCss(sP, n.isColAtEdge(t, "last"));
}
function iP(e, t, n, o) {
  return ke(t, {
    // bad naming, as colDef here can be a group or a column,
    // however most people won't appreciate the difference,
    // so keeping it as colDef to avoid confusion.
    colDef: e,
    column: n,
    columnGroup: o
  });
}
function Ww(e, t, n, o, s) {
  if (st(e))
    return [];
  let i;
  if (typeof e == "function") {
    const r = iP(t, n, o, s);
    i = e(r);
  } else
    i = e;
  return typeof i == "string" ? [i] : Array.isArray(i) ? [...i] : [];
}
function Uw(e, t, n) {
  t.addManagedElementListeners(n, {
    keydown: (o) => {
      if (!o.defaultPrevented && o.key === O.TAB) {
        const s = o.shiftKey;
        sn(e, n, !1, s) || Do(e, s) && o.preventDefault();
      }
    }
  });
}
function rP(e, t) {
  return e.ctrlsSvc.get("gridCtrl").focusInnerElement(t);
}
function ci(e) {
  var t;
  return e.gos.get("suppressHeaderFocus") || !!((t = e.overlays) != null && t.isExclusive());
}
function xc(e) {
  var t;
  return e.gos.get("suppressCellFocus") || !!((t = e.overlays) != null && t.isExclusive());
}
function Do(e, t, n = !1) {
  const o = e.ctrlsSvc.get("gridCtrl");
  return !n && o.focusNextInnerContainer(t) ? !0 : ((n || !t && !o.isDetailGrid()) && o.forceFocusOutOfContainer(t), !1);
}
function xo(e) {
  var t;
  return ((t = e.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : t.getRowCount()) ?? 0;
}
function Sp(e) {
  const t = [], n = e.ctrlsSvc.getHeaderRowContainerCtrls();
  for (const o of n) {
    if (!o)
      continue;
    const s = o.getGroupRowCount() || 0;
    for (let i = 0; i < s; i++) {
      const r = o.getGroupRowCtrlAtIndex(i), a = t[i];
      if (r) {
        const l = aP(e, r);
        (a == null || l > a) && (t[i] = l);
      }
    }
  }
  return t;
}
function aP(e, t) {
  let o = e.colModel.isPivotMode() ? dP(e) : Kw(e);
  const s = t.getHeaderCellCtrls();
  for (const i of s) {
    const { column: r } = i, a = r.getAutoHeaderHeight();
    a != null && a > o && r.isAutoHeaderHeight() && (o = a);
  }
  return o;
}
function xp(e) {
  let n = e.colModel.isPivotMode() ? lP(e) : tl(e);
  return e.colModel.forAllCols((o) => {
    const s = o.getAutoHeaderHeight();
    s != null && s > n && o.isAutoHeaderHeight() && (n = s);
  }), n;
}
function tl(e) {
  return e.gos.get("headerHeight") ?? e.environment.getDefaultHeaderHeight();
}
function Rp(e) {
  return e.gos.get("floatingFiltersHeight") ?? tl(e);
}
function Kw(e) {
  return e.gos.get("groupHeaderHeight") ?? tl(e);
}
function lP(e) {
  return e.gos.get("pivotHeaderHeight") ?? tl(e);
}
function dP(e) {
  return e.gos.get("pivotGroupHeaderHeight") ?? Kw(e);
}
var cP = class extends U {
  setComp(e, t, n) {
    this.comp = e, this.eGui = t;
    const { beans: o } = this, { headerNavigation: s, touchSvc: i, ctrlsSvc: r } = o;
    s && this.createManagedBean(
      new Hs(n, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addManagedEventListeners({
      columnPivotModeChanged: this.onPivotModeChanged.bind(this, o),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, o)
    }), this.onPivotModeChanged(o), this.setupHeaderHeight();
    const a = this.onHeaderContextMenu.bind(this);
    this.addManagedElementListeners(this.eGui, { contextmenu: a }), i == null || i.mockHeaderContextMenu(this, a), r.register("gridHeaderCtrl", this);
  }
  setupHeaderHeight() {
    const e = this.setHeaderHeight.bind(this);
    e(), this.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      e
    ), this.addManagedEventListeners({
      headerRowsChanged: e,
      columnHeaderHeightChanged: e,
      // add this to the animation frame to avoid a feedback loop
      columnGroupHeaderHeightChanged: () => kn(this.beans, () => e()),
      gridStylesChanged: e,
      advancedFilterEnabledChanged: e
    });
  }
  setHeaderHeight() {
    var i;
    const { beans: e } = this;
    let t = 0;
    const n = Sp(e).reduce((r, a) => r + a, 0), o = xp(e);
    if ((i = e.filterManager) != null && i.hasFloatingFilters() && (t += Rp(e)), t += n, t += o, this.headerHeight === t)
      return;
    this.headerHeight = t;
    const s = `${t + 1}px`;
    this.comp.setHeightAndMinHeight(s), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  onPivotModeChanged(e) {
    const t = e.colModel.isPivotMode();
    this.comp.toggleCss("ag-pivot-on", t), this.comp.toggleCss("ag-pivot-off", !t);
  }
  onDisplayedColumnsChanged(e) {
    const n = e.visibleCols.allCols.some((o) => o.isSpanHeaderHeight());
    this.comp.toggleCss("ag-header-allow-overflow", n);
  }
  onTabKeyDown(e) {
    const t = this.gos.get("enableRtl"), n = e.shiftKey, o = n !== t ? "LEFT" : "RIGHT", { beans: s } = this, { headerNavigation: i, focusSvc: r } = s;
    (i.navigateHorizontally(o, !0, e) || !n && r.focusOverlay(!1) || Do(s, n, !0)) && e.preventDefault();
  }
  handleKeyDown(e) {
    let t = null;
    const { headerNavigation: n } = this.beans;
    switch (e.key) {
      case O.LEFT:
        t = "LEFT";
      case O.RIGHT: {
        ue(t) || (t = "RIGHT"), n.navigateHorizontally(t, !1, e) && e.preventDefault();
        break;
      }
      case O.UP:
        t = "UP";
      case O.DOWN: {
        ue(t) || (t = "DOWN"), n.navigateVertically(t, e) && e.preventDefault();
        break;
      }
      default:
        return;
    }
  }
  onFocusOut(e) {
    const { relatedTarget: t } = e, { eGui: n, beans: o } = this;
    !t && n.contains(je(o)) || n.contains(t) || (o.focusSvc.focusedHeader = null);
  }
  onHeaderContextMenu(e, t, n) {
    var r;
    const { menuSvc: o, ctrlsSvc: s } = this.beans;
    if (!e && !n || !(o != null && o.isHeaderContextMenuEnabled()))
      return;
    const { target: i } = e ?? t;
    (i === this.eGui || i === ((r = s.getHeaderRowContainerCtrl()) == null ? void 0 : r.eViewport)) && o.showHeaderContextMenu(void 0, e, n);
  }
}, Ep = class extends Te {
  constructor(e, t) {
    super(e), this.ctrl = t;
  }
  getCtrl() {
    return this.ctrl;
  }
}, uP = {
  tag: "div",
  cls: "ag-header-cell",
  role: "columnheader",
  children: [
    { tag: "div", ref: "eResize", cls: "ag-header-cell-resize", role: "presentation" },
    { tag: "div", ref: "eHeaderCompWrapper", cls: "ag-header-cell-comp-wrapper", role: "presentation" }
  ]
}, hP = class extends Ep {
  constructor(e) {
    super(uP, e), this.eResize = X, this.eHeaderCompWrapper = X, this.headerCompVersion = 0;
  }
  postConstruct() {
    const e = this.getGui(), t = () => {
      const o = this.ctrl.getSelectAllGui();
      o && (this.eResize.insertAdjacentElement("afterend", o), this.addDestroyFunc(() => o.remove()));
    }, n = {
      setWidth: (o) => e.style.width = o,
      toggleCss: (o, s) => this.toggleCss(o, s),
      setUserStyles: (o) => Ya(e, o),
      setAriaSort: (o) => o ? i3(e, o) : r3(e),
      setUserCompDetails: (o) => this.setUserCompDetails(o),
      getUserCompInstance: () => this.headerComp,
      refreshSelectAllGui: t,
      removeSelectAllGui: () => {
        var o;
        return (o = this.ctrl.getSelectAllGui()) == null ? void 0 : o.remove();
      }
    };
    this.ctrl.setComp(n, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0), t();
  }
  destroy() {
    this.destroyHeaderComp(), super.destroy();
  }
  destroyHeaderComp() {
    this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
  }
  setUserCompDetails(e) {
    this.headerCompVersion++;
    const t = this.headerCompVersion;
    e.newAgStackInstance().then((n) => this.afterCompCreated(t, n));
  }
  afterCompCreated(e, t) {
    if (e != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(t);
      return;
    }
    this.destroyHeaderComp(), this.headerComp = t, this.headerCompGui = t.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
  }
}, gP = {
  tag: "div",
  cls: "ag-header-group-cell",
  role: "columnheader",
  children: [
    { tag: "div", ref: "eHeaderCompWrapper", cls: "ag-header-cell-comp-wrapper", role: "presentation" },
    { tag: "div", ref: "eResize", cls: "ag-header-cell-resize", role: "presentation" }
  ]
}, pP = class extends Ep {
  constructor(e) {
    super(gP, e), this.eResize = X, this.eHeaderCompWrapper = X;
  }
  postConstruct() {
    const e = this.getGui(), t = (o, s) => s != null ? e.setAttribute(o, s) : e.removeAttribute(o), n = {
      toggleCss: (o, s) => this.toggleCss(o, s),
      setUserStyles: (o) => Ya(e, o),
      setHeaderWrapperHidden: (o) => {
        o ? this.eHeaderCompWrapper.style.setProperty("display", "none") : this.eHeaderCompWrapper.style.removeProperty("display");
      },
      setHeaderWrapperMaxHeight: (o) => {
        o != null ? this.eHeaderCompWrapper.style.setProperty("max-height", `${o}px`) : this.eHeaderCompWrapper.style.removeProperty("max-height"), this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", o != null);
      },
      setResizableDisplayed: (o) => He(this.eResize, o),
      setWidth: (o) => e.style.width = o,
      setAriaExpanded: (o) => t("aria-expanded", o),
      setUserCompDetails: (o) => this.setUserCompDetails(o),
      getUserCompInstance: () => this.headerGroupComp
    };
    this.ctrl.setComp(n, e, this.eResize, this.eHeaderCompWrapper, void 0);
  }
  setUserCompDetails(e) {
    e.newAgStackInstance().then((t) => this.afterHeaderCompCreated(t));
  }
  afterHeaderCompCreated(e) {
    const t = () => this.destroyBean(e);
    if (!this.isAlive()) {
      t();
      return;
    }
    const n = this.getGui(), o = e.getGui();
    this.eHeaderCompWrapper.appendChild(o), this.addDestroyFunc(t), this.headerGroupComp = e, this.ctrl.setDragSource(n);
  }
}, fP = {
  tag: "div",
  cls: "ag-header-cell ag-floating-filter",
  role: "gridcell",
  children: [
    { tag: "div", ref: "eFloatingFilterBody", role: "presentation" },
    {
      tag: "div",
      ref: "eButtonWrapper",
      cls: "ag-floating-filter-button ag-hidden",
      role: "presentation",
      children: [
        {
          tag: "button",
          ref: "eButtonShowMainFilter",
          cls: "ag-button ag-floating-filter-button-button",
          attrs: { type: "button", tabindex: "-1" }
        }
      ]
    }
  ]
}, mP = class extends Ep {
  constructor(e) {
    super(fP, e), this.eFloatingFilterBody = X, this.eButtonWrapper = X, this.eButtonShowMainFilter = X;
  }
  postConstruct() {
    const e = this.getGui(), t = {
      toggleCss: (n, o) => this.toggleCss(n, o),
      setUserStyles: (n) => Ya(e, n),
      addOrRemoveBodyCssClass: (n, o) => this.eFloatingFilterBody.classList.toggle(n, o),
      setButtonWrapperDisplayed: (n) => He(this.eButtonWrapper, n),
      setCompDetails: (n) => this.setCompDetails(n),
      getFloatingFilterComp: () => this.compPromise,
      setWidth: (n) => e.style.width = n,
      setMenuIcon: (n) => this.eButtonShowMainFilter.appendChild(n)
    };
    this.ctrl.setComp(t, e, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
  }
  setCompDetails(e) {
    if (!e) {
      this.destroyFloatingFilterComp(), this.compPromise = null;
      return;
    }
    this.compPromise = e.newAgStackInstance(), this.compPromise.then((t) => this.afterCompCreated(t));
  }
  destroy() {
    this.destroyFloatingFilterComp(), super.destroy();
  }
  destroyFloatingFilterComp() {
    this.floatingFilterComp && (this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui()), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
  }
  afterCompCreated(e) {
    if (e) {
      if (!this.isAlive()) {
        this.destroyBean(e);
        return;
      }
      this.destroyFloatingFilterComp(), this.floatingFilterComp = e, this.eFloatingFilterBody.appendChild(e.getGui()), e.afterGuiAttached && e.afterGuiAttached();
    }
  }
}, vP = class extends Te {
  constructor(e) {
    super({ tag: "div", cls: e.headerRowClass, role: "row" }), this.ctrl = e, this.headerComps = {};
  }
  postConstruct() {
    this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex"))), Ma(this.getGui(), this.ctrl.getAriaRowIndex());
    const t = {
      setHeight: (n) => this.getGui().style.height = n,
      setTop: (n) => this.getGui().style.top = n,
      setHeaderCtrls: (n, o) => this.setHeaderCtrls(n, o),
      setWidth: (n) => this.getGui().style.width = n,
      setRowIndex: (n) => Ma(this.getGui(), n)
    };
    this.ctrl.setComp(t, void 0);
  }
  destroy() {
    this.setHeaderCtrls([], !1), super.destroy();
  }
  setHeaderCtrls(e, t) {
    if (!this.isAlive())
      return;
    const n = this.headerComps;
    if (this.headerComps = {}, e.forEach((o) => {
      const s = o.instanceId;
      let i = n[s];
      delete n[s], i == null && (i = this.createHeaderComp(o), this.getGui().appendChild(i.getGui())), this.headerComps[s] = i;
    }), Object.values(n).forEach((o) => {
      this.getGui().removeChild(o.getGui()), this.destroyBean(o);
    }), t) {
      const o = Object.values(this.headerComps);
      o.sort(
        (i, r) => {
          const a = i.getCtrl().column.getLeft(), l = r.getCtrl().column.getLeft();
          return a - l;
        }
      );
      const s = o.map((i) => i.getGui());
      fC(this.getGui(), s);
    }
  }
  createHeaderComp(e) {
    let t;
    switch (this.ctrl.type) {
      case "group":
        t = new pP(e);
        break;
      case "filter":
        t = new mP(e);
        break;
      default:
        t = new hP(e);
        break;
    }
    return this.createBean(t), t.setParentComponent(this), t;
  }
}, Ap = class extends U {
  constructor(e, t, n, o) {
    super(), this.columnOrGroup = e, this.eCell = t, this.colsSpanning = o, this.columnOrGroup = e, this.ariaEl = t.querySelector("[role=columnheader]") || t, this.beans = n;
  }
  setColsSpanning(e) {
    this.colsSpanning = e, this.onLeftChanged();
  }
  getColumnOrGroup() {
    const { beans: e, colsSpanning: t } = this;
    return e.gos.get("enableRtl") && t ? Je(t) : this.columnOrGroup;
  }
  postConstruct() {
    const e = this.onLeftChanged.bind(this);
    this.addManagedListeners(this.columnOrGroup, { leftChanged: e }), this.setLeftFirstTime(), this.addManagedEventListeners({ displayedColumnsWidthChanged: e }), this.addManagedPropertyListener("domLayout", e);
  }
  setLeftFirstTime() {
    const { gos: e, colAnimation: t } = this.beans, n = e.get("suppressColumnMoveAnimation"), o = ue(this.columnOrGroup.getOldLeft());
    (t == null ? void 0 : t.isActive()) && o && !n ? this.animateInLeft() : this.onLeftChanged();
  }
  animateInLeft() {
    const e = this.getColumnOrGroup(), t = this.modifyLeftForPrintLayout(e, e.getOldLeft()), n = this.modifyLeftForPrintLayout(e, e.getLeft());
    this.setLeft(t), this.actualLeft = n, this.beans.colAnimation.executeNextVMTurn(() => {
      this.actualLeft === n && this.setLeft(n);
    });
  }
  onLeftChanged() {
    const e = this.getColumnOrGroup(), t = e.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(e, t), this.setLeft(this.actualLeft);
  }
  modifyLeftForPrintLayout(e, t) {
    const { gos: n, visibleCols: o } = this.beans;
    if (!jt(n, "print") || e.getPinned() === "left")
      return t;
    const i = o.getColsLeftWidth();
    if (e.getPinned() === "right") {
      const r = o.bodyWidth;
      return i + r + t;
    }
    return i + t;
  }
  setLeft(e) {
    if (ue(e) && (this.eCell.style.left = `${e}px`), Dt(this.columnOrGroup)) {
      const t = this.columnOrGroup.getLeafColumns();
      if (!t.length)
        return;
      t.length > 1 && lC(this.ariaEl, t.length);
    }
  }
}, CP = 0, Zw = "headerCtrl", Fp = class extends U {
  constructor(e, t) {
    super(), this.column = e, this.rowCtrl = t, this.resizeToggleTimeout = 0, this.resizeMultiplier = 1, this.resizeFeature = null, this.lastFocusEvent = null, this.dragSource = null, this.reAttemptToFocus = !1, this.instanceId = e.getUniqueId() + "-" + CP++;
  }
  postConstruct() {
    const e = this.refreshTabIndex.bind(this);
    this.addManagedPropertyListeners(["suppressHeaderFocus"], e), this.addManagedEventListeners({
      overlayExclusiveChanged: e
    });
  }
  setComp(e, t, n, o, s) {
    t.setAttribute("col-id", this.column.colIdSanitised), this.wireComp(e, t, n, o, s), this.reAttemptToFocus && (this.reAttemptToFocus = !1, this.focus(this.lastFocusEvent ?? void 0));
  }
  shouldStopEventPropagation(e) {
    const { headerRowIndex: t, column: n } = this.beans.focusSvc.focusedHeader, o = n.getDefinition(), s = o && o.suppressHeaderKeyboardEvent;
    if (!ue(s))
      return !1;
    const i = ke(this.gos, {
      colDef: o,
      column: n,
      headerRowIndex: t,
      event: e
    });
    return !!s(i);
  }
  getWrapperHasFocus() {
    return je(this.beans) === this.eGui;
  }
  setGui(e, t) {
    this.eGui = e, this.addDomData(t), t.addManagedListeners(this.beans.eventSvc, {
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
    }), t.addManagedElementListeners(this.eGui, {
      focus: this.onGuiFocus.bind(this)
    }), this.onDisplayedColumnsChanged(), this.refreshTabIndex();
  }
  refreshHeaderStyles() {
    const e = this.column.getDefinition();
    if (!e)
      return;
    const { headerStyle: t } = e;
    let n;
    if (typeof t == "function") {
      const o = this.getHeaderClassParams();
      n = t(o);
    } else
      n = t;
    n && this.comp.setUserStyles(n);
  }
  onGuiFocus() {
    this.eventSvc.dispatchEvent({
      type: "headerFocused",
      column: this.column
    });
  }
  setupAutoHeight(e) {
    const { wrapperElement: t, checkMeasuringCallback: n, compBean: o } = e, { beans: s } = this, i = (u) => {
      if (!this.isAlive() || !o.isAlive())
        return;
      const { paddingTop: h, paddingBottom: g, borderBottomWidth: p, borderTopWidth: f } = Pi(this.eGui), m = h + g + p + f, w = t.offsetHeight + m;
      if (u < 5) {
        const b = Bt(s), A = !b || !b.contains(t), S = w == 0;
        if (A || S) {
          mh(() => i(u + 1), "raf", s);
          return;
        }
      }
      this.setColHeaderHeight(this.column, w);
    };
    let r = !1, a;
    const l = () => {
      const u = this.column.isAutoHeaderHeight();
      u && !r && d(), !u && r && c();
    }, d = () => {
      r = !0, this.comp.toggleCss("ag-header-cell-auto-height", !0), i(0), a = Bo(this.beans, t, () => i(0));
    }, c = () => {
      r = !1, a && a(), this.comp.toggleCss("ag-header-cell-auto-height", !1), a = void 0;
    };
    l(), o.addDestroyFunc(() => c()), o.addManagedListeners(this.column, { widthChanged: () => r && i(0) }), o.addManagedEventListeners({
      sortChanged: () => {
        r && window.setTimeout(() => i(0));
      }
    }), n && n(l);
  }
  onDisplayedColumnsChanged() {
    const { comp: e, column: t, beans: n, eGui: o } = this;
    !e || !t || !o || (zw(e, t, n.visibleCols), $g(o, n.visibleCols.getAriaColIndex(t)));
  }
  addResizeAndMoveKeyboardListeners(e) {
    e.addManagedListeners(this.eGui, {
      keydown: this.onGuiKeyDown.bind(this),
      keyup: this.onGuiKeyUp.bind(this)
    });
  }
  refreshTabIndex() {
    const e = ci(this.beans);
    this.eGui && Mn(this.eGui, "tabindex", e ? null : "-1");
  }
  onGuiKeyDown(e) {
    var i;
    const t = je(this.beans), n = e.key === O.LEFT || e.key === O.RIGHT;
    if (this.isResizing && (e.preventDefault(), e.stopImmediatePropagation()), // if elements within the header are focused, we don't process the event
    t !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
    !e.shiftKey && !e.altKey || ((this.isResizing || n) && (e.preventDefault(), e.stopImmediatePropagation()), !n))
      return;
    const s = e.key === O.LEFT !== this.gos.get("enableRtl") ? "left" : "right";
    if (e.altKey) {
      this.isResizing = !0, this.resizeMultiplier += 1;
      const r = this.getViewportAdjustedResizeDiff(e);
      this.resizeHeader(r, e.shiftKey), (i = this.resizeFeature) == null || i.toggleColumnResizing(!0);
    } else
      this.moveHeader(s);
  }
  moveHeader(e) {
    var t;
    (t = this.beans.colMoves) == null || t.moveHeader(e, this.eGui, this.column, this.rowCtrl.pinned, this);
  }
  getViewportAdjustedResizeDiff(e) {
    const t = this.getResizeDiff(e), { pinnedCols: n } = this.beans;
    return n ? n.getHeaderResizeDiff(t, this.column) : t;
  }
  getResizeDiff(e) {
    const { gos: t, column: n } = this;
    let o = e.key === O.LEFT !== t.get("enableRtl");
    const s = n.getPinned(), i = t.get("enableRtl");
    return s && i !== (s === "right") && (o = !o), (o ? -1 : 1) * this.resizeMultiplier;
  }
  onGuiKeyUp() {
    this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = window.setTimeout(() => {
      var e;
      (e = this.resizeFeature) == null || e.toggleColumnResizing(!1);
    }, 150));
  }
  handleKeyDown(e) {
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case O.PAGE_DOWN:
      case O.PAGE_UP:
      case O.PAGE_HOME:
      case O.PAGE_END:
        t && e.preventDefault();
    }
  }
  addDomData(e) {
    const t = Zw, { eGui: n, gos: o } = this;
    Ci(o, n, t, this), e.addDestroyFunc(() => Ci(o, n, t, null));
  }
  focus(e) {
    if (!this.isAlive())
      return !1;
    const { eGui: t } = this;
    return t ? (t.focus(), this.lastFocusEvent = e || null) : this.reAttemptToFocus = !0, !0;
  }
  focusThis() {
    this.beans.focusSvc.focusedHeader = { headerRowIndex: this.rowCtrl.rowIndex, column: this.column };
  }
  removeDragSource() {
    var e;
    this.dragSource && ((e = this.beans.dragAndDrop) == null || e.removeDragSource(this.dragSource), this.dragSource = null);
  }
  handleContextMenuMouseEvent(e, t, n) {
    const o = e ?? t, { menuSvc: s, gos: i } = this.beans;
    i.get("preventDefaultOnContextMenu") && o.preventDefault(), s != null && s.isHeaderContextMenuEnabled(n) && s.showHeaderContextMenu(n, e, t), this.dispatchColumnMouseEvent("columnHeaderContextMenu", n);
  }
  dispatchColumnMouseEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: e,
      column: t
    });
  }
  setColHeaderHeight(e, t) {
    if (!e.setAutoHeaderHeight(t))
      return;
    const { eventSvc: n } = this;
    e.isColumn ? n.dispatchEvent({
      type: "columnHeaderHeightChanged",
      column: e,
      columns: [e],
      source: "autosizeColumnHeaderHeight"
    }) : n.dispatchEvent({
      type: "columnGroupHeaderHeightChanged",
      columnGroup: e,
      source: "autosizeColumnGroupHeaderHeight"
    });
  }
  clearComponent() {
    this.removeDragSource(), this.resizeFeature = null, this.comp = null, this.eGui = null;
  }
  destroy() {
    super.destroy(), this.column = null, this.lastFocusEvent = null, this.rowCtrl = null;
  }
}, wP = class extends Fp {
  constructor() {
    super(...arguments), this.refreshFunctions = {}, this.userHeaderClasses = /* @__PURE__ */ new Set(), this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
  }
  wireComp(e, t, n, o, s) {
    this.comp = e;
    const { rowCtrl: i, column: r, beans: a } = this, { colResize: l, context: d, colHover: c, rangeSvc: u } = a, h = Ja(this, d, s);
    this.setGui(t, h), this.updateState(), this.setupWidth(h), this.setupMovingCss(h), this.setupMenuClass(h), this.setupSortableClass(h), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight({
      wrapperElement: o,
      checkMeasuringCallback: (p) => this.setRefreshFunction("measuring", p),
      compBean: h
    }), this.addColumnHoverListener(h), this.setupFilterClass(h), this.setupStylesFromColDef(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(h), this.setupSelectAll(h), this.setupUserComp(), this.refreshAria(), l ? this.resizeFeature = h.createManagedBean(
      l.createResizeFeature(i.pinned, r, n, e, this)
    ) : He(n, !1), c == null || c.createHoverFeature(h, [r], t), u == null || u.createRangeHighlightFeature(h, r, e), h.createManagedBean(new Ap(r, t, a)), h.createManagedBean(
      new Hs(t, {
        shouldStopEventPropagation: (p) => this.shouldStopEventPropagation(p),
        onTabKeyDown: () => null,
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addResizeAndMoveKeyboardListeners(h), h.addManagedPropertyListeners(
      ["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader", "enableAdvancedFilter"],
      () => this.refresh()
    ), h.addManagedListeners(r, { colDefChanged: () => this.refresh() }), h.addManagedListeners(r, { headerHighlightChanged: this.onHeaderHighlightChanged.bind(this) });
    const g = () => this.checkDisplayName();
    h.addManagedEventListeners({
      columnValueChanged: g,
      columnRowGroupChanged: g,
      columnPivotChanged: g,
      headerHeightChanged: this.onHeaderHeightChanged.bind(this)
    }), h.addDestroyFunc(() => {
      this.refreshFunctions = {}, this.selectAllFeature = null, this.dragSourceElement = void 0, this.userCompDetails = null, this.userHeaderClasses.clear(), this.ariaDescriptionProperties.clear(), this.clearComponent();
    });
  }
  resizeHeader(e, t) {
    var n;
    (n = this.beans.colResize) == null || n.resizeHeader(this.column, e, t);
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, n = e.colDef;
    return ke(t.gos, {
      colDef: n,
      column: e,
      floatingFilter: !1
    });
  }
  setupUserComp() {
    const e = this.lookupUserCompDetails();
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setUserCompDetails(e);
  }
  lookupUserCompDetails() {
    const e = this.createParams(), t = this.column.getColDef();
    return TF(this.beans.userCompFactory, t, e);
  }
  createParams() {
    const { menuSvc: e, sortSvc: t, colFilter: n, gos: o } = this.beans;
    return ke(o, {
      column: this.column,
      displayName: this.displayName,
      enableSorting: this.column.isSortable(),
      enableMenu: this.menuEnabled,
      enableFilterButton: this.openFilterEnabled && !!(e != null && e.isHeaderFilterButtonEnabled(this.column)),
      enableFilterIcon: !!n && (!this.openFilterEnabled || Nt(this.gos)),
      showColumnMenu: (i, r) => {
        e == null || e.showColumnMenu({
          column: this.column,
          buttonElement: i,
          positionBy: "button",
          onClosedCallback: r
        });
      },
      showColumnMenuAfterMouseClick: (i, r) => {
        e == null || e.showColumnMenu({
          column: this.column,
          mouseEvent: i,
          positionBy: "mouse",
          onClosedCallback: r
        });
      },
      showFilter: (i) => {
        e == null || e.showFilterMenu({
          column: this.column,
          buttonElement: i,
          containerType: "columnFilter",
          positionBy: "button"
        });
      },
      progressSort: (i) => {
        t == null || t.progressSort(this.column, !!i, "uiColumnSorted");
      },
      setSort: (i, r) => {
        t == null || t.setSortForColumn(this.column, i, !!r, "uiColumnSorted");
      },
      eGridHeader: this.eGui,
      setTooltip: (i, r) => {
        o.assertModuleRegistered("Tooltip", 3), this.setupTooltip(i, r);
      }
    });
  }
  setupSelectAll(e) {
    var n;
    const { selectionSvc: t } = this.beans;
    t && (this.selectAllFeature = e.createOptionalManagedBean(t.createSelectAllFeature(this.column)), (n = this.selectAllFeature) == null || n.setComp(this), e.addManagedPropertyListener("rowSelection", () => {
      var s;
      const o = t.createSelectAllFeature(this.column);
      o && !this.selectAllFeature ? (this.selectAllFeature = e.createManagedBean(o), (s = this.selectAllFeature) == null || s.setComp(this), this.comp.refreshSelectAllGui()) : this.selectAllFeature && !o && (this.comp.removeSelectAllGui(), this.selectAllFeature = this.destroyBean(this.selectAllFeature));
    }));
  }
  getSelectAllGui() {
    var e;
    return (e = this.selectAllFeature) == null ? void 0 : e.getCheckboxGui();
  }
  handleKeyDown(e) {
    var t;
    super.handleKeyDown(e), e.key === O.SPACE && ((t = this.selectAllFeature) == null || t.onSpaceKeyDown(e)), e.key === O.ENTER && this.onEnterKeyDown(e), e.key === O.DOWN && e.altKey && this.showMenuOnKeyPress(e, !1);
  }
  onEnterKeyDown(e) {
    var t;
    e.ctrlKey || e.metaKey ? this.showMenuOnKeyPress(e, !0) : this.sortable && ((t = this.beans.sortSvc) == null || t.progressSort(this.column, e.shiftKey, "uiColumnSorted"));
  }
  showMenuOnKeyPress(e, t) {
    const n = this.comp.getUserCompInstance();
    Mm(n) && n.onMenuKeyboardShortcut(t) && e.preventDefault();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || (this.focusThis(), this.announceAriaDescription()), mc() && this.setActiveHeader(!0);
  }
  onFocusOut(e) {
    this.eGui.contains(e.relatedTarget) || this.setActiveHeader(!1);
  }
  setupTooltip(e, t) {
    var n;
    this.tooltipFeature = (n = this.beans.tooltipSvc) == null ? void 0 : n.setupHeaderTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupStylesFromColDef() {
    this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this)), this.refreshHeaderStyles();
  }
  setupClassesFromColDef() {
    const e = () => {
      const t = this.column.getColDef(), n = Nw(t, this.gos, this.column, null), o = this.userHeaderClasses;
      this.userHeaderClasses = new Set(n), n.forEach((s) => {
        o.has(s) ? o.delete(s) : this.comp.toggleCss(s, !0);
      }), o.forEach((s) => this.comp.toggleCss(s, !1));
    };
    this.setRefreshFunction("headerClasses", e), e();
  }
  setDragSource(e) {
    var t;
    this.dragSourceElement = e, this.removeDragSource(), !(!e || !this.draggable) && (this.dragSource = ((t = this.beans.colMoves) == null ? void 0 : t.setDragSourceForHeader(e, this.column, this.displayName)) ?? null);
  }
  updateState() {
    const { menuSvc: e } = this.beans;
    this.menuEnabled = !!(e != null && e.isColumnMenuInHeaderEnabled(this.column)), this.openFilterEnabled = !!(e != null && e.isFilterMenuInHeaderEnabled(this.column)), this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
  }
  setRefreshFunction(e, t) {
    this.refreshFunctions[e] = t;
  }
  refresh() {
    this.updateState(), this.refreshHeaderComp(), this.refreshAria(), Object.values(this.refreshFunctions).forEach((e) => e());
  }
  refreshHeaderComp() {
    const e = this.lookupUserCompDetails();
    if (!e)
      return;
    (this.comp.getUserCompInstance() != null && this.userCompDetails.componentClass == e.componentClass ? this.attemptHeaderCompRefresh(e.params) : !1) ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
  }
  attemptHeaderCompRefresh(e) {
    const t = this.comp.getUserCompInstance();
    return !t || !t.refresh ? !1 : t.refresh(e);
  }
  calculateDisplayName() {
    return this.beans.colNames.getDisplayNameForColumn(this.column, "header", !0);
  }
  checkDisplayName() {
    this.displayName !== this.calculateDisplayName() && this.refresh();
  }
  workOutDraggable() {
    const e = this.column.getColDef();
    return !!(!this.gos.get("suppressMovableColumns") && !e.suppressMovable && !e.lockPosition) || !!e.enableRowGroup || !!e.enablePivot;
  }
  setupWidth(e) {
    const t = () => {
      const n = this.column.getActualWidth();
      this.comp.setWidth(`${n}px`);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupMovingCss(e) {
    const t = () => {
      this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
    };
    e.addManagedListeners(this.column, { movingChanged: t }), t();
  }
  setupMenuClass(e) {
    const t = () => {
      var n;
      (n = this.comp) == null || n.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
    };
    e.addManagedListeners(this.column, { menuVisibleChanged: t }), t();
  }
  setupSortableClass(e) {
    const t = () => {
      this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
    };
    t(), this.setRefreshFunction("updateSortable", t), e.addManagedEventListeners({ sortChanged: this.refreshAriaSort.bind(this) });
  }
  setupFilterClass(e) {
    const t = () => {
      const n = this.column.isFilterActive();
      this.comp.toggleCss("ag-header-cell-filtered", n), this.refreshAria();
    };
    e.addManagedListeners(this.column, { filterActiveChanged: t }), t();
  }
  setupWrapTextClass() {
    const e = () => {
      const t = !!this.column.getColDef().wrapHeaderText;
      this.comp.toggleCss("ag-header-cell-wrap-text", t);
    };
    e(), this.setRefreshFunction("wrapText", e);
  }
  onHeaderHighlightChanged() {
    const e = this.column.getHighlighted(), t = e === 0, n = e === 1;
    this.comp.toggleCss("ag-header-highlight-before", t), this.comp.toggleCss("ag-header-highlight-after", n);
  }
  onDisplayedColumnsChanged() {
    super.onDisplayedColumnsChanged(), this.isAlive() && this.onHeaderHeightChanged();
  }
  onHeaderHeightChanged() {
    this.refreshSpanHeaderHeight();
  }
  refreshSpanHeaderHeight() {
    var h;
    const { eGui: e, column: t, comp: n, beans: o } = this, s = Sp(this.beans), i = s.reduce((g, p) => g += p, 0) === 0;
    if (n.toggleCss("ag-header-parent-hidden", i), !t.isSpanHeaderHeight()) {
      e.style.removeProperty("top"), e.style.removeProperty("height"), n.toggleCss("ag-header-span-height", !1), n.toggleCss("ag-header-span-total", !1);
      return;
    }
    const { numberOfParents: r, isSpanningTotal: a } = this.column.getColumnGroupPaddingInfo();
    n.toggleCss("ag-header-span-height", r > 0);
    const l = xp(o);
    if (r === 0) {
      n.toggleCss("ag-header-span-total", !1), e.style.setProperty("top", "0px"), e.style.setProperty("height", `${l}px`);
      return;
    }
    n.toggleCss("ag-header-span-total", a);
    const d = (((h = this.column.getFirstRealParent()) == null ? void 0 : h.getLevel()) ?? -1) + 1, c = s.length - d;
    let u = 0;
    for (let g = 0; g < c; g++)
      u += s[s.length - 1 - g];
    e.style.setProperty("top", `${-u}px`), e.style.setProperty("height", `${l + u}px`);
  }
  refreshAriaSort() {
    var e;
    if (this.sortable) {
      const t = this.getLocaleTextFunc(), n = ((e = this.beans.sortSvc) == null ? void 0 : e.getDisplaySortForColumn(this.column)) || null;
      this.comp.setAriaSort(jA(n)), this.setAriaDescriptionProperty("sort", t("ariaSortableColumn", "Press ENTER to sort"));
    } else
      this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
  }
  refreshAriaMenu() {
    if (this.menuEnabled) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press ALT DOWN to open column menu"));
    } else
      this.setAriaDescriptionProperty("menu", null);
  }
  refreshAriaFilterButton() {
    if (this.openFilterEnabled && !Nt(this.gos)) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty(
        "filterButton",
        e("ariaFilterColumn", "Press CTRL ENTER to open filter")
      );
    } else
      this.setAriaDescriptionProperty("filterButton", null);
  }
  refreshAriaFiltered() {
    const e = this.getLocaleTextFunc();
    this.column.isFilterActive() ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
  }
  setAriaDescriptionProperty(e, t) {
    t != null ? this.ariaDescriptionProperties.set(e, t) : this.ariaDescriptionProperties.delete(e);
  }
  announceAriaDescription() {
    var t;
    if (!this.eGui.contains(je(this.beans)))
      return;
    const e = Array.from(this.ariaDescriptionProperties.keys()).sort((n, o) => n === "filter" ? -1 : o.charCodeAt(0) - n.charCodeAt(0)).map((n) => this.ariaDescriptionProperties.get(n)).join(". ");
    (t = this.beans.ariaAnnounce) == null || t.announceValue(e, "columnHeader");
  }
  refreshAria() {
    this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFilterButton(), this.refreshAriaFiltered();
  }
  addColumnHoverListener(e) {
    var t;
    (t = this.beans.colHover) == null || t.addHeaderColumnHoverListener(e, this.comp, this.column);
  }
  addActiveHeaderMouseListeners(e) {
    const t = (s) => this.handleMouseOverChange(s.type === "mouseenter"), n = () => {
      this.setActiveHeader(!0), this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
    }, o = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column);
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: n,
      contextmenu: o
    });
  }
  handleMouseOverChange(e) {
    this.setActiveHeader(e), this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column
    });
  }
  setActiveHeader(e) {
    this.comp.toggleCss("ag-header-active", e);
  }
  getAnchorElementForMenu(e) {
    const t = this.comp.getUserCompInstance();
    return Mm(t) ? t.getAnchorElementForMenu(e) : this.eGui;
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function Mm(e) {
  return typeof (e == null ? void 0 : e.getAnchorElementForMenu) == "function" && typeof e.onMenuKeyboardShortcut == "function";
}
var yP = 0, yu = class extends U {
  constructor(e, t, n) {
    super(), this.rowIndex = e, this.pinned = t, this.type = n, this.instanceId = yP++, this.comp = null, this.allCtrls = [];
    let o = "ag-header-row-column";
    n === "group" ? o = "ag-header-row-group" : n === "filter" && (o = "ag-header-row-filter"), this.headerRowClass = `ag-header-row ${o}`;
  }
  setRowIndex(e) {
    var t;
    this.rowIndex = e, (t = this.comp) == null || t.setRowIndex(this.getAriaRowIndex()), this.onRowHeightChanged();
  }
  postConstruct() {
    this.isPrintLayout = jt(this.gos, "print"), this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
  }
  /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */
  areCellsRendered() {
    return this.comp ? this.allCtrls.every((e) => e.eGui != null) : !1;
  }
  /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */
  setComp(e, t, n = !0) {
    this.comp = e, t = Ja(this, this.beans.context, t), n && (this.setRowIndex(this.rowIndex), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners(t);
  }
  getAriaRowIndex() {
    return this.rowIndex + 1;
  }
  addEventListeners(e) {
    const t = this.onRowHeightChanged.bind(this), n = this.onDisplayedColumnsChanged.bind(this);
    e.addManagedEventListeners({
      columnResized: this.setWidth.bind(this),
      displayedColumnsChanged: n,
      virtualColumnsChanged: (o) => this.onVirtualColumnsChanged(o.afterScroll),
      columnGroupHeaderHeightChanged: t,
      columnHeaderHeightChanged: t,
      gridStylesChanged: t,
      advancedFilterEnabledChanged: t
    }), e.addManagedPropertyListener("domLayout", n), e.addManagedPropertyListener("ensureDomOrder", (o) => this.isEnsureDomOrder = o.currentValue), e.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      t
    );
  }
  onDisplayedColumnsChanged() {
    this.isPrintLayout = jt(this.gos, "print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
  }
  setWidth() {
    if (!this.comp)
      return;
    const e = this.getWidthForRow();
    this.comp.setWidth(`${e}px`);
  }
  getWidthForRow() {
    const { visibleCols: e } = this.beans;
    return this.isPrintLayout ? this.pinned != null ? 0 : e.getContainerWidth("right") + e.getContainerWidth("left") + e.getContainerWidth(null) : e.getContainerWidth(this.pinned);
  }
  onRowHeightChanged() {
    if (!this.comp)
      return;
    const { topOffset: e, rowHeight: t } = this.getTopAndHeight();
    this.comp.setTop(e + "px"), this.comp.setHeight(t + "px");
  }
  getTopAndHeight() {
    let e = 0;
    const t = Sp(this.beans);
    for (let s = 0; s < t.length; s++) {
      if (s === this.rowIndex && this.type === "group")
        return { topOffset: e, rowHeight: t[s] };
      e += t[s];
    }
    const n = xp(this.beans);
    if (this.type === "column")
      return { topOffset: e, rowHeight: n };
    e += n;
    const o = Rp(this.beans);
    return { topOffset: e, rowHeight: o };
  }
  onVirtualColumnsChanged(e = !1) {
    if (!this.comp)
      return;
    const t = this.getUpdatedHeaderCtrls(), n = this.isEnsureDomOrder || this.isPrintLayout;
    this.comp.setHeaderCtrls(t, n, e);
  }
  /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */
  getUpdatedHeaderCtrls() {
    const e = this.ctrlsById;
    this.ctrlsById = /* @__PURE__ */ new Map();
    const t = this.getColumnsInViewport();
    for (const o of t)
      this.recycleAndCreateHeaderCtrls(o, this.ctrlsById, e);
    const n = (o) => {
      const { focusSvc: s, visibleCols: i } = this.beans;
      return s.isHeaderWrapperFocused(o) ? i.isVisible(o.column) : !1;
    };
    if (e)
      for (const [o, s] of e)
        n(s) ? this.ctrlsById.set(o, s) : this.destroyBean(s);
    return this.allCtrls = Array.from(this.ctrlsById.values()), this.allCtrls;
  }
  /** Get the current header cell ctrls */
  getHeaderCellCtrls() {
    return this.allCtrls;
  }
  recycleAndCreateHeaderCtrls(e, t, n) {
    if (e.isEmptyGroup())
      return;
    const o = e.getUniqueId();
    let s;
    if (n && (s = n.get(o), n.delete(o)), s && s.column != e && (this.destroyBean(s), s = void 0), s == null)
      switch (this.type) {
        case "filter": {
          s = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerFilterCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        }
        case "group":
          s = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerGroupCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        default:
          s = this.createBean(new wP(e, this));
          break;
      }
    t.set(o, s);
  }
  getColumnsInViewport() {
    if (!this.isPrintLayout)
      return this.getComponentsToRender();
    if (this.pinned)
      return [];
    const e = [];
    return ["left", null, "right"].forEach((t) => {
      e.push(...this.getComponentsToRender(t));
    }), e;
  }
  getComponentsToRender(e = this.pinned) {
    return this.type === "group" ? this.beans.colViewport.getHeadersToRender(e, this.rowIndex) : this.beans.colViewport.getColumnHeadersToRender(e);
  }
  focusHeader(e, t) {
    const n = this.allCtrls.find((s) => s.column == e);
    return n ? n.focus(t) : !1;
  }
  destroy() {
    this.allCtrls = this.destroyBeans(this.allCtrls), this.ctrlsById = void 0, this.comp = null, super.destroy();
  }
}, bP = class extends U {
  constructor(e) {
    super(), this.pinned = e, this.hidden = !1, this.includeFloatingFilter = !1, this.groupsRowCtrls = [];
  }
  setComp(e, t) {
    this.comp = e, this.eViewport = t;
    const { pinnedCols: n, ctrlsSvc: o, colModel: s, colMoves: i } = this.beans;
    this.setupCenterWidth(), n == null || n.setupHeaderPinnedWidth(this), this.setupDragAndDrop(i, this.eViewport);
    const r = this.refresh.bind(this, !0);
    this.addManagedEventListeners({
      displayedColumnsChanged: r,
      advancedFilterEnabledChanged: r
    });
    const a = `${typeof this.pinned == "string" ? this.pinned : "center"}Header`;
    o.register(a, this), s.ready && this.refresh();
  }
  getAllCtrls() {
    const e = [...this.groupsRowCtrls];
    return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
  }
  refresh(e = !1) {
    const { focusSvc: t, filterManager: n, visibleCols: o } = this.beans;
    let s = 0;
    const i = t.getFocusHeaderToUseAfterRefresh(), r = () => {
      const u = o.headerGroupRowCount;
      s = u;
      const h = this.groupsRowCtrls.length;
      if (h !== u) {
        if (h > u) {
          for (let g = u; g < h; g++)
            this.destroyBean(this.groupsRowCtrls[g]);
          this.groupsRowCtrls.length = u;
          return;
        }
        for (let g = h; g < u; g++) {
          const p = this.createBean(new yu(g, this.pinned, "group"));
          this.groupsRowCtrls.push(p);
        }
      }
    }, a = () => {
      const u = s++;
      if (this.hidden) {
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        return;
      }
      this.columnsRowCtrl == null || !e ? (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.columnsRowCtrl = this.createBean(new yu(u, this.pinned, "column"))) : this.columnsRowCtrl.rowIndex !== u && this.columnsRowCtrl.setRowIndex(u);
    }, l = () => {
      this.includeFloatingFilter = !!(n != null && n.hasFloatingFilters()) && !this.hidden;
      const u = () => {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      };
      if (!this.includeFloatingFilter) {
        u();
        return;
      }
      e || u();
      const h = s++;
      this.filtersRowCtrl ? this.filtersRowCtrl.rowIndex !== h && this.filtersRowCtrl.setRowIndex(h) : this.filtersRowCtrl = this.createBean(new yu(h, this.pinned, "filter"));
    }, d = this.getAllCtrls();
    r(), a(), l();
    const c = this.getAllCtrls();
    this.comp.setCtrls(c), this.restoreFocusOnHeader(t, i), d.length !== c.length && this.beans.eventSvc.dispatchEvent({
      type: "headerRowsChanged"
    });
  }
  getHeaderCtrlForColumn(e) {
    const t = (n) => n == null ? void 0 : n.getHeaderCellCtrls().find((o) => o.column === e);
    if (Io(e))
      return t(this.columnsRowCtrl);
    if (this.groupsRowCtrls.length !== 0)
      for (let n = 0; n < this.groupsRowCtrls.length; n++) {
        const o = t(this.groupsRowCtrls[n]);
        if (o)
          return o;
      }
  }
  getHtmlElementForColumnHeader(e) {
    var t;
    return ((t = this.getHeaderCtrlForColumn(e)) == null ? void 0 : t.eGui) ?? null;
  }
  getRowType(e) {
    var t;
    return (t = this.getAllCtrls()[e]) == null ? void 0 : t.type;
  }
  focusHeader(e, t, n) {
    const s = this.getAllCtrls()[e];
    return s ? s.focusHeader(t, n) : !1;
  }
  getGroupRowCount() {
    return this.groupsRowCtrls.length;
  }
  getGroupRowCtrlAtIndex(e) {
    return this.groupsRowCtrls[e];
  }
  getRowCount() {
    return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
  }
  setHorizontalScroll(e) {
    this.comp.setViewportScrollLeft(e);
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  destroy() {
    this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl), this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls), super.destroy();
  }
  setupDragAndDrop(e, t) {
    const n = e == null ? void 0 : e.createBodyDropTarget(this.pinned, t);
    n && this.createManagedBean(n);
  }
  restoreFocusOnHeader(e, t) {
    if (!t)
      return;
    const { column: n } = t;
    n.getPinned() == this.pinned && e.focusHeaderPosition({ headerPosition: t });
  }
  setupCenterWidth() {
    this.pinned == null && this.createManagedBean(new yp((e) => this.comp.setCenterWidth(`${e}px`), !0));
  }
}, SP = class extends U {
  constructor() {
    super(...arguments), this.beanName = "menuSvc";
  }
  postConstruct() {
    const { enterpriseMenuFactory: e, filterMenuFactory: t } = this.beans;
    this.activeMenuFactory = e ?? t;
  }
  showColumnMenu(e) {
    this.showColumnMenuCommon(this.activeMenuFactory, e, "columnMenu");
  }
  showFilterMenu(e) {
    this.showColumnMenuCommon(Im(this.beans), e, e.containerType, !0);
  }
  showHeaderContextMenu(e, t, n) {
    var o;
    (o = this.activeMenuFactory) == null || o.showMenuAfterContextMenuEvent(e, t, n);
  }
  hidePopupMenu() {
    var e, t;
    (e = this.beans.contextMenuSvc) == null || e.hideActiveMenu(), (t = this.activeMenuFactory) == null || t.hideActiveMenu();
  }
  hideFilterMenu() {
    var e;
    (e = Im(this.beans)) == null || e.hideActiveMenu();
  }
  isColumnMenuInHeaderEnabled(e) {
    var n;
    const { suppressHeaderMenuButton: t } = e.getColDef();
    return !t && !!((n = this.activeMenuFactory) != null && n.isMenuEnabled(e)) && (Nt(this.gos) || !!this.beans.enterpriseMenuFactory);
  }
  isFilterMenuInHeaderEnabled(e) {
    var t;
    return !e.getColDef().suppressHeaderFilterButton && !!((t = this.beans.filterManager) != null && t.isFilterAllowed(e));
  }
  isHeaderContextMenuEnabled(e) {
    const t = e && Io(e) ? e.getColDef() : e == null ? void 0 : e.getColGroupDef();
    return !(t != null && t.suppressHeaderContextMenu) && this.gos.get("columnMenu") === "new";
  }
  isHeaderMenuButtonAlwaysShowEnabled() {
    return this.isSuppressMenuHide();
  }
  isHeaderMenuButtonEnabled() {
    const e = !this.isSuppressMenuHide();
    return !(Ss() && e);
  }
  isHeaderFilterButtonEnabled(e) {
    return this.isFilterMenuInHeaderEnabled(e) && !Nt(this.gos) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFilterMenuItemEnabled(e) {
    var t;
    return !!((t = this.beans.filterManager) != null && t.isFilterAllowed(e)) && !Nt(this.gos) && !this.isFilterMenuInHeaderEnabled(e) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFloatingFilterButtonEnabled(e) {
    return !e.getColDef().suppressFloatingFilterButton;
  }
  isFloatingFilterButtonDisplayed(e) {
    return !!e.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(e);
  }
  isSuppressMenuHide() {
    const e = this.gos, t = e.get("suppressMenuHide");
    return Nt(e) ? e.exists("suppressMenuHide") ? t : !1 : t;
  }
  showColumnMenuCommon(e, t, n, o) {
    const { positionBy: s, onClosedCallback: i } = t, r = t.column;
    if (s === "button") {
      const { buttonElement: a } = t;
      e == null || e.showMenuAfterButtonClick(r, a, n, i, o);
    } else if (s === "mouse") {
      const { mouseEvent: a } = t;
      e == null || e.showMenuAfterMouseEvent(r, a, n, i, o);
    } else if (r) {
      const a = this.beans, l = a.ctrlsSvc;
      l.getScrollFeature().ensureColumnVisible(r, "auto"), kn(a, () => {
        var c;
        const d = (c = l.getHeaderRowContainerCtrl(r.getPinned())) == null ? void 0 : c.getHeaderCtrlForColumn(r);
        d && (e == null || e.showMenuAfterButtonClick(
          r,
          d.getAnchorElementForMenu(o),
          n,
          i,
          o
        ));
      });
    }
  }
};
function kd(e, t, n) {
  e.menuVisible !== t && (e.menuVisible = t, e.dispatchColEvent("menuVisibleChanged", n));
}
function Im(e) {
  const { enterpriseMenuFactory: t, filterMenuFactory: n, gos: o } = e;
  return t && Nt(o) ? t : n;
}
var Rc = class extends fc {
  constructor() {
    super(...arguments), this.errorMessages = null;
  }
  init(e) {
    this.params = e, this.initialiseEditor(e), this.eEditor.onValueChange(() => e.validate());
  }
  destroy() {
    this.errorMessages = null;
  }
}, qw = class extends Te {
  constructor() {
    super();
  }
}, xP = {
  tag: "span",
  cls: "ag-overlay-loading-center"
}, RP = class extends qw {
  init() {
    var t;
    const e = Gt((t = this.gos.get("overlayLoadingTemplate")) == null ? void 0 : t.trim());
    if (this.setTemplate(e ?? xP), !e) {
      const o = this.getLocaleTextFunc()("loadingOoo", "Loading...");
      this.getGui().textContent = o, this.beans.ariaAnnounce.announceValue(o, "overlay");
    }
  }
}, EP = { tag: "span", cls: "ag-overlay-no-rows-center" }, AP = class extends qw {
  init() {
    var t;
    const e = Gt((t = this.gos.get("overlayNoRowsTemplate")) == null ? void 0 : t.trim());
    if (this.setTemplate(e ?? EP), !e) {
      const o = this.getLocaleTextFunc()("noRowsToShow", "No Rows To Show");
      this.getGui().textContent = o, this.beans.ariaAnnounce.announceValue(o, "overlay");
    }
  }
};
function nr(e, t, n) {
  const o = Le(e, t, n);
  if (o) {
    const { className: i } = o;
    if (typeof i == "string" && i.indexOf("ag-icon") > -1 || typeof i == "object" && i["ag-icon"])
      return o;
  }
  const s = Ue({ tag: "span" });
  return s.appendChild(o), s;
}
function Le(e, t, n) {
  var i;
  let o = null;
  e === "smallDown" ? Z(262) : e === "smallLeft" ? Z(263) : e === "smallRight" && Z(264);
  const s = n && n.getColDef().icons;
  if (s && (o = s[e]), t.gos && !o) {
    const r = t.gos.get("icons");
    r && (o = r[e]);
  }
  if (o) {
    let r;
    if (typeof o == "function")
      r = o();
    else if (typeof o == "string")
      r = o;
    else {
      Z(38, { iconName: e });
      return;
    }
    if (typeof r == "string")
      return Zg(r);
    if (uc(r))
      return r;
    Z(133, { iconName: e });
    return;
  } else {
    const r = t.registry.getIcon(e);
    return r || (i = t.validation) == null || i.validateIcon(e), Ue({
      tag: "span",
      cls: `ag-icon ag-icon-${r ?? e}`,
      role: "presentation",
      attrs: { unselectable: "on" }
    });
  }
}
var FP = (
  /*css*/
  ".ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}.ag-dnd-ghost-not-allowed{border:var(--ag-drag-and-drop-image-not-allowed-border)}"
), MP = {
  tag: "div",
  children: [
    {
      tag: "div",
      ref: "eGhost",
      cls: "ag-dnd-ghost ag-unselectable",
      children: [
        { tag: "span", ref: "eIcon", cls: "ag-dnd-ghost-icon ag-shake-left-to-right" },
        { tag: "div", ref: "eLabel", cls: "ag-dnd-ghost-label" }
      ]
    }
  ]
}, IP = class extends Te {
  constructor() {
    super(), this.dragSource = null, this.eIcon = X, this.eLabel = X, this.eGhost = X, this.registerCSS(FP);
  }
  postConstruct() {
    const e = (t) => nr(t, this.beans, null);
    this.dropIconMap = {
      pinned: e("columnMovePin"),
      hide: e("columnMoveHide"),
      move: e("columnMoveMove"),
      left: e("columnMoveLeft"),
      right: e("columnMoveRight"),
      group: e("columnMoveGroup"),
      aggregate: e("columnMoveValue"),
      pivot: e("columnMovePivot"),
      notAllowed: e("dropNotAllowed")
    };
  }
  init(e) {
    this.dragSource = e.dragSource, this.setTemplate(MP), this.beans.environment.applyThemeClasses(this.eGhost);
  }
  destroy() {
    this.dragSource = null, super.destroy();
  }
  setIcon(e, t) {
    const { eGhost: n, eIcon: o, dragSource: s, dropIconMap: i, gos: r } = this;
    ht(o);
    let a = null;
    e || (e = s != null && s.getDefaultIconName ? s.getDefaultIconName() : "notAllowed"), a = i[e], n.classList.toggle("ag-dnd-ghost-not-allowed", e === "notAllowed"), o.classList.toggle("ag-shake-left-to-right", t), !(a === i.hide && r.get("suppressDragLeaveHidesColumns")) && a && o.appendChild(a);
  }
  setLabel(e) {
    this.eLabel.textContent = e;
  }
}, PP = (
  /*css*/
  ".ag-checkbox-cell{height:100%}"
), DP = {
  tag: "div",
  cls: "ag-cell-wrapper ag-checkbox-cell",
  role: "presentation",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eCheckbox",
      role: "presentation"
    }
  ]
}, TP = class extends Te {
  constructor() {
    super(DP, [Di]), this.eCheckbox = X, this.registerCSS(PP);
  }
  init(e) {
    this.refresh(e);
    const { eCheckbox: t, beans: n } = this, o = t.getInputElement();
    o.setAttribute("tabindex", "-1"), iC(o, "polite"), this.addManagedListeners(o, {
      click: (s) => {
        if (bt(s), t.isDisabled())
          return;
        const i = t.getValue();
        this.onCheckboxChanged(i);
      },
      dblclick: (s) => {
        bt(s);
      }
    }), this.addManagedElementListeners(e.eGridCell, {
      keydown: (s) => {
        if (s.key === O.SPACE && !t.isDisabled()) {
          e.eGridCell === je(n) && t.toggle();
          const i = t.getValue();
          this.onCheckboxChanged(i), s.preventDefault();
        }
      }
    });
  }
  refresh(e) {
    return this.params = e, this.updateCheckbox(e), !0;
  }
  updateCheckbox(e) {
    let t, n = !0;
    const { value: o, column: s, node: i } = e;
    if (i.group && s)
      if (typeof o == "boolean")
        t = o;
      else {
        const u = s.getColId();
        u.startsWith(wr) ? t = o == null || o === "" ? void 0 : o === "true" : i.aggData && i.aggData[u] !== void 0 || i.sourceRowIndex >= 0 ? t = o ?? void 0 : n = !1;
      }
    else
      t = o ?? void 0;
    const { eCheckbox: r } = this;
    if (!n) {
      r.setDisplayed(!1);
      return;
    }
    r.setValue(t);
    const a = e.disabled ?? !(s != null && s.isCellEditable(i));
    r.setDisabled(a);
    const l = this.getLocaleTextFunc(), d = dc(l, t), c = a ? d : `${l("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${d})`;
    r.setInputAriaLabel(c);
  }
  onCheckboxChanged(e) {
    var r, a, l, d;
    const { params: t } = this, { column: n, node: o, value: s } = t;
    (a = (r = this.beans) == null ? void 0 : r.editSvc) == null || a.setEditingCells(
      [
        {
          column: n,
          colId: n.getColId(),
          rowIndex: o.rowIndex,
          rowPinned: o.rowPinned,
          state: "changed",
          oldValue: s,
          newValue: s
        }
      ],
      { update: !0, forceRefreshOfEditCellsOnly: !0 }
    );
    const i = o.setDataValue(n, e, "renderer");
    (d = this.beans.editSvc) == null || d.stopEditing(
      {
        rowNode: o,
        column: n
      },
      { source: (l = this.beans.editSvc) != null && l.isBatchEditing() ? "ui" : "api" }
    ), i || this.updateCheckbox(t);
  }
}, Pm = class {
  constructor(e, t) {
    this.beans = e, this.floating = t, this.all = /* @__PURE__ */ new Set(), this.visible = /* @__PURE__ */ new Set(), this.order = [], this.queued = /* @__PURE__ */ new Set();
  }
  size() {
    return this.visible.size;
  }
  add(e) {
    const { all: t, visible: n, order: o } = this;
    t.has(e) || (t.add(e), n.add(e), o.push(e), this.sort());
  }
  delete(e) {
    this.all.delete(e), this.visible.delete(e), this.queued.delete(e.id), $t(this.order, e);
  }
  has(e) {
    return this.visible.has(e);
  }
  forEach(e) {
    this.order.forEach(e);
  }
  getByIndex(e) {
    return this.order[e];
  }
  getById(e) {
    for (const t of this.visible)
      if (t.id == e)
        return t;
  }
  clear() {
    const { all: e, visible: t, order: n, queued: o } = this;
    e.clear(), o.clear(), t.clear(), n.length = 0;
  }
  sort() {
    const { sortSvc: e, rowNodeSorter: t, gos: n } = this.beans, o = (e == null ? void 0 : e.getSortOptions()) ?? [], s = BP(this.order);
    if (this.order.sort((r, a) => {
      var l, d;
      return (((l = r.pinnedSibling) == null ? void 0 : l.rowIndex) ?? 0) - (((d = a.pinnedSibling) == null ? void 0 : d.rowIndex) ?? 0);
    }), this.order = (t == null ? void 0 : t.doFullSort(this.order, o)) ?? this.order, !s)
      return;
    const i = kr(n);
    i === "bottom" || i === "pinnedBottom" ? this.order.push(s) : this.order.unshift(s);
  }
  hide(e) {
    const { all: t, visible: n } = this;
    t.forEach((o) => e(o) ? n.delete(o) : n.add(o)), this.order = Array.from(n), this.sort();
  }
  queue(e) {
    this.queued.add(e);
  }
  unqueue(e) {
    this.queued.delete(e);
  }
  forEachQueued(e) {
    this.queued.forEach(e);
  }
};
function jw(e) {
  var n;
  if (e.level === -1)
    return !0;
  const t = e.parent;
  return (n = t == null ? void 0 : t.childrenAfterSort) != null && n.some((o) => o == e) ? jw(t) : !1;
}
function bu(e, t) {
  const { gos: n, rowModel: o, filterManager: s } = e;
  return gn(n) ? !o.getRowNode(t.id) : s != null && s.isAnyFilterPresent() ? !jw(t) : n.get("pivotMode") ? !t.group : !1;
}
function kP(e) {
  return !!e.footer && e.level === -1;
}
function LP(e) {
  return !!e.pinnedSibling && kP(e.pinnedSibling);
}
function BP(e) {
  var n;
  const t = e.findIndex(LP);
  if (t > -1)
    return (n = e.splice(t, 1)) == null ? void 0 : n[0];
}
var Dm = class extends U {
  postConstruct() {
    const { gos: e, beans: t } = this;
    this.top = new Pm(t, "top"), this.bottom = new Pm(t, "bottom");
    const n = (s) => bu(t, s.pinnedSibling), o = () => {
      const s = e.get("isRowPinned");
      s && e.get("enableRowPinning") && t.rowModel.forEachNode((i) => this.pinRow(i, s(i)), !0), this.refreshRowPositions(), this.dispatchRowPinnedEvents();
    };
    this.addManagedEventListeners({
      gridStylesChanged: this.onGridStylesChanges.bind(this),
      modelUpdated: ({ keepRenderedRows: s }) => {
        this.tryToEmptyQueues(), this.pinGrandTotalRow(), this.forContainers((r) => r.hide(n));
        const i = this.refreshRowPositions();
        (!s || i) && this.dispatchRowPinnedEvents();
      },
      columnRowGroupChanged: () => {
        this.forContainers(GP), this.refreshRowPositions();
      },
      rowNodeDataChanged: ({ node: s }) => {
        const i = e.get("isRowPinnable");
        ((i == null ? void 0 : i(s)) ?? !0) || this.pinRow(s, null);
      },
      firstDataRendered: o
    }), this.addManagedPropertyListener("pivotMode", () => {
      this.forContainers((s) => s.hide(n)), this.dispatchRowPinnedEvents();
    }), this.addManagedPropertyListener("grandTotalRow", ({ currentValue: s }) => {
      this._grandTotalPinned = s === "pinnedBottom" ? "bottom" : s === "pinnedTop" ? "top" : null;
    }), this.addManagedPropertyListener("isRowPinned", o);
  }
  destroy() {
    this.reset(!1), super.destroy();
  }
  reset(e = !0) {
    this.forContainers((t) => {
      const n = [];
      t.forEach((o) => n.push(o)), n.forEach((o) => this.pinRow(o, null)), t.clear();
    }), e && this.dispatchRowPinnedEvents();
  }
  pinRow(e, t, n) {
    var r;
    if (e.footer && e.level > -1)
      return;
    if (e.footer && e.level === -1) {
      this._grandTotalPinned = t, VP(this.beans);
      return;
    }
    const o = e.rowPinned ?? ((r = e.pinnedSibling) == null ? void 0 : r.rowPinned);
    if (o != null && t != null && t != o) {
      const a = e.rowPinned ? e : e.pinnedSibling, l = e.rowPinned ? e.pinnedSibling : e;
      this.pinRow(a, null, n), this.pinRow(l, t, n);
      return;
    }
    const i = n && HP(this.beans, e, n);
    if (i) {
      i.forEach((a) => this.pinRow(a, t));
      return;
    }
    if (t == null) {
      const a = e.rowPinned ? e : e.pinnedSibling, l = this.findPinnedRowNode(a);
      if (!l)
        return;
      l.delete(a);
      const d = a.pinnedSibling;
      Su(a), this.refreshRowPositions(t), this.dispatchRowPinnedEvents(d);
    } else {
      const a = Tm(this.beans, e, t), l = this.getContainer(t);
      l.add(a), bu(this.beans, e) && l.hide((d) => bu(this.beans, d.pinnedSibling)), this.refreshRowPositions(t), this.dispatchRowPinnedEvents(e);
    }
  }
  isManual() {
    return !0;
  }
  isEmpty(e) {
    return this.getContainer(e).size() === 0;
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  ensureRowHeightsValid() {
    let e = !1, t = 0;
    const n = (o) => {
      if (o.rowHeightEstimated) {
        const s = qt(this.beans, o);
        o.setRowTop(t), o.setRowHeight(s.height), t += s.height, e = !0;
      }
    };
    return this.bottom.forEach(n), t = 0, this.top.forEach(n), this.eventSvc.dispatchEvent({
      type: "pinnedHeightChanged"
    }), e;
  }
  getPinnedTopTotalHeight() {
    return km(this.top);
  }
  getPinnedBottomTotalHeight() {
    return km(this.bottom);
  }
  getPinnedTopRowCount() {
    return this.top.size();
  }
  getPinnedBottomRowCount() {
    return this.bottom.size();
  }
  getPinnedTopRow(e) {
    return this.top.getByIndex(e);
  }
  getPinnedBottomRow(e) {
    return this.bottom.getByIndex(e);
  }
  getPinnedRowById(e, t) {
    return this.getContainer(t).getById(e);
  }
  forEachPinnedRow(e, t) {
    this.getContainer(e).forEach(t);
  }
  getPinnedState() {
    const e = (t) => {
      const n = [];
      return this.forEachPinnedRow(t, (o) => n.push(o.pinnedSibling.id)), n;
    };
    return {
      top: e("top"),
      bottom: e("bottom")
    };
  }
  setPinnedState(e) {
    this.forContainers((t, n) => {
      for (const o of e[n]) {
        const s = this.beans.rowModel.getRowNode(o);
        s ? this.pinRow(s, n) : t.queue(o);
      }
    });
  }
  getGrandTotalPinned() {
    return this._grandTotalPinned;
  }
  setGrandTotalPinned(e) {
    this._grandTotalPinned = e;
  }
  tryToEmptyQueues() {
    this.forContainers((e, t) => {
      const n = /* @__PURE__ */ new Set();
      e.forEachQueued((o) => {
        const s = this.beans.rowModel.getRowNode(o);
        s && n.add(s);
      });
      for (const o of n)
        e.unqueue(o.id), this.pinRow(o, t);
    });
  }
  pinGrandTotalRow() {
    var a;
    const { gos: e, beans: t, _grandTotalPinned: n } = this, o = t.rowModel;
    if (!Ct(e))
      return;
    const s = (a = o.rootNode) == null ? void 0 : a.sibling;
    if (!s)
      return;
    const i = s.pinnedSibling, r = i && this.findPinnedRowNode(i);
    if (n) {
      if (r && r.floating !== n && (r.delete(i), Su(i)), !r || r.floating !== n) {
        const l = Tm(t, s, n);
        this.getContainer(n).add(l);
      }
    } else {
      if (!r)
        return;
      r.delete(i), Su(i);
    }
  }
  onGridStylesChanges(e) {
    e.rowHeightChanged && this.forContainers(
      (t) => t.forEach((n) => n.setRowHeight(n.rowHeight, !0))
    );
  }
  getContainer(e) {
    return e === "top" ? this.top : this.bottom;
  }
  findPinnedRowNode(e) {
    if (this.top.has(e))
      return this.top;
    if (this.bottom.has(e))
      return this.bottom;
  }
  refreshRowPositions(e) {
    const t = (o) => OP(this.beans, o);
    if (e)
      return t(this.getContainer(e));
    let n = !1;
    return this.forContainers((o) => {
      const s = t(o);
      n || (n = s);
    }), n;
  }
  forContainers(e) {
    e(this.top, "top"), e(this.bottom, "bottom");
  }
  dispatchRowPinnedEvents(e) {
    this.eventSvc.dispatchEvent({ type: "pinnedRowsChanged" }), e == null || e.dispatchRowEvent("rowPinned");
  }
};
function OP(e, t) {
  let n = 0, o = !1;
  return t.forEach((s, i) => {
    if (o || (o = s.rowTop !== n), s.setRowTop(n), s.rowHeightEstimated || s.rowHeight == null) {
      const r = qt(e, s).height;
      o || (o = s.rowHeight !== r), s.setRowHeight(r);
    }
    s.setRowIndex(i), n += s.rowHeight;
  }), o;
}
function Tm(e, t, n) {
  if (t.pinnedSibling)
    return t.pinnedSibling;
  const o = xw(t, e);
  o.setRowTop(null), o.setRowIndex(null), o.rowPinned = n;
  const s = n === "top" ? fp : mp;
  return o.id = `${s}${n}-${t.id}`, o.pinnedSibling = t, t.pinnedSibling = o, o;
}
function Su(e) {
  if (!e.pinnedSibling)
    return;
  e.rowPinned = null, e.setRowTop(null), e.setRowIndex(null);
  const t = e.pinnedSibling;
  e.pinnedSibling = void 0, t && (t.pinnedSibling = void 0, t.rowPinned = null);
}
function GP(e) {
  const t = /* @__PURE__ */ new Set();
  e.forEach((n) => {
    n.group && t.add(n);
  }), t.forEach((n) => e.delete(n));
}
function HP(e, t, n) {
  var i;
  const { rowSpanSvc: o } = e, s = (n && (o == null ? void 0 : o.isCellSpanning(n, t))) ?? !1;
  if (n && s)
    return (i = o == null ? void 0 : o.getCellSpan(n, t)) == null ? void 0 : i.spannedNodes;
}
function km(e) {
  const t = e.size();
  if (t === 0)
    return 0;
  const n = e.getByIndex(t - 1);
  return n === void 0 ? 0 : n.rowTop + n.rowHeight;
}
function VP({ gos: e, rowModel: t }) {
  Ct(e) && t.refreshModel({ step: "map" });
}
var Lm = class extends U {
  constructor() {
    super(...arguments), this.nextId = 0, this.pinnedTopRows = { cache: {}, order: [] }, this.pinnedBottomRows = { cache: {}, order: [] };
  }
  postConstruct() {
    const e = this.gos;
    this.setPinnedRowData(e.get("pinnedTopRowData"), "top"), this.setPinnedRowData(e.get("pinnedBottomRowData"), "bottom"), this.addManagedPropertyListener("pinnedTopRowData", (t) => this.setPinnedRowData(t.currentValue, "top")), this.addManagedPropertyListener("pinnedBottomRowData", (t) => this.setPinnedRowData(t.currentValue, "bottom")), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanges.bind(this) });
  }
  reset() {
  }
  isEmpty(e) {
    return this.getCache(e).order.length === 0;
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  isManual() {
    return !1;
  }
  pinRow(e, t) {
  }
  onGridStylesChanges(e) {
    if (e.rowHeightChanged) {
      const t = (n) => {
        n.setRowHeight(n.rowHeight, !0);
      };
      $r(this.pinnedBottomRows, t), $r(this.pinnedTopRows, t);
    }
  }
  ensureRowHeightsValid() {
    let e = !1, t = 0;
    const n = (o) => {
      if (o.rowHeightEstimated) {
        const s = qt(this.beans, o);
        o.setRowTop(t), o.setRowHeight(s.height), t += s.height, e = !0;
      }
    };
    return $r(this.pinnedBottomRows, n), t = 0, $r(this.pinnedTopRows, n), this.eventSvc.dispatchEvent({
      type: "pinnedHeightChanged"
    }), e;
  }
  setPinnedRowData(e, t) {
    this.updateNodesFromRowData(e, t), this.eventSvc.dispatchEvent({
      type: "pinnedRowDataChanged"
    });
  }
  /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */
  updateNodesFromRowData(e, t) {
    const n = this.getCache(t);
    if (e === void 0) {
      n.order.length = 0, n.cache = {};
      return;
    }
    const o = Jo(this.gos), s = t === "top" ? fp : mp, i = new Set(n.order), r = [], a = /* @__PURE__ */ new Set();
    let l = 0, d = -1;
    for (const c of e) {
      const u = (o == null ? void 0 : o({ data: c, level: 0, rowPinned: t })) ?? s + this.nextId++;
      if (a.has(u)) {
        Z(96, { id: u, data: c });
        continue;
      }
      d++, a.add(u), r.push(u);
      const h = aa(n, u);
      if (h !== void 0)
        h.data !== c && h.updateData(c), l += this.setRowTopAndRowIndex(h, l, d), i.delete(u);
      else {
        const g = new Ln(this.beans);
        g.id = u, g.data = c, g.rowPinned = t, l += this.setRowTopAndRowIndex(g, l, d), n.cache[u] = g, n.order.push(u);
      }
    }
    i.forEach((c) => {
      var u;
      (u = aa(n, c)) == null || u.clearRowTopAndRowIndex(), delete n.cache[c];
    }), n.order = r;
  }
  setRowTopAndRowIndex(e, t, n) {
    return e.setRowTop(t), e.setRowHeight(qt(this.beans, e).height), e.setRowIndex(n), e.rowHeight;
  }
  getPinnedTopTotalHeight() {
    return Bm(this.pinnedTopRows);
  }
  getPinnedBottomTotalHeight() {
    return Bm(this.pinnedBottomRows);
  }
  getPinnedTopRowCount() {
    return Dh(this.pinnedTopRows);
  }
  getPinnedBottomRowCount() {
    return Dh(this.pinnedBottomRows);
  }
  getPinnedTopRow(e) {
    return Ph(this.pinnedTopRows, e);
  }
  getPinnedBottomRow(e) {
    return Ph(this.pinnedBottomRows, e);
  }
  getPinnedRowById(e, t) {
    return aa(this.getCache(t), e);
  }
  forEachPinnedRow(e, t) {
    return $r(this.getCache(e), t);
  }
  getCache(e) {
    return e === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
  }
  getPinnedState() {
    return { top: [], bottom: [] };
  }
  setPinnedState() {
  }
  getGrandTotalPinned() {
  }
  setGrandTotalPinned() {
  }
};
function Bm(e) {
  const t = Dh(e);
  if (t === 0)
    return 0;
  const n = Ph(e, t - 1);
  return n === void 0 ? 0 : n.rowTop + n.rowHeight;
}
function aa(e, t) {
  return e.cache[t];
}
function Ph(e, t) {
  return aa(e, e.order[t]);
}
function $r(e, t) {
  e.order.forEach((n, o) => {
    const s = aa(e, n);
    s && t(s, o);
  });
}
function Dh(e) {
  return e.order.length;
}
var _P = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pinnedRowModel";
  }
  postConstruct() {
    const { gos: e } = this, t = () => {
      const n = e.get("enableRowPinning"), o = kr(e), i = !!n || (o === "pinnedBottom" || o === "pinnedTop"), r = i ? this.inner instanceof Lm : this.inner instanceof Dm;
      this.inner && r && this.destroyBean(this.inner), (r || !this.inner) && (this.inner = this.createManagedBean(
        i ? new Dm() : new Lm()
      ));
    };
    this.addManagedPropertyListeners(["enableRowPinning", "grandTotalRow"], t), t();
  }
  reset() {
    return this.inner.reset();
  }
  isEmpty(e) {
    return this.inner.isEmpty(e);
  }
  isManual() {
    return this.inner.isManual();
  }
  isRowsToRender(e) {
    return this.inner.isRowsToRender(e);
  }
  pinRow(e, t, n) {
    return this.inner.pinRow(e, t, n);
  }
  ensureRowHeightsValid() {
    return this.inner.ensureRowHeightsValid();
  }
  getPinnedRowById(e, t) {
    return this.inner.getPinnedRowById(e, t);
  }
  getPinnedTopTotalHeight() {
    return this.inner.getPinnedTopTotalHeight();
  }
  getPinnedBottomTotalHeight() {
    return this.inner.getPinnedBottomTotalHeight();
  }
  getPinnedTopRowCount() {
    return this.inner.getPinnedTopRowCount();
  }
  getPinnedBottomRowCount() {
    return this.inner.getPinnedBottomRowCount();
  }
  getPinnedTopRow(e) {
    return this.inner.getPinnedTopRow(e);
  }
  getPinnedBottomRow(e) {
    return this.inner.getPinnedBottomRow(e);
  }
  forEachPinnedRow(e, t) {
    return this.inner.forEachPinnedRow(e, t);
  }
  getPinnedState() {
    return this.inner.getPinnedState();
  }
  setPinnedState(e) {
    return this.inner.setPinnedState(e);
  }
  setGrandTotalPinned(e) {
    return this.inner.setGrandTotalPinned(e);
  }
  getGrandTotalPinned() {
    return this.inner.getGrandTotalPinned();
  }
}, NP = "ROOT_NODE_ID", Yw = class extends U {
  constructor() {
    super(...arguments), this.nextId = 0, this.allNodesMap = {}, this.rootNode = null;
  }
  getRowNode(e) {
    return this.allNodesMap[e];
  }
  extractRowData() {
    var e, t;
    return (t = (e = this.rootNode) == null ? void 0 : e.allLeafChildren) == null ? void 0 : t.map((n) => n.data);
  }
  activate(e) {
    this.rootNode = e, e.group = !0, e.level = -1, e.id = NP, e.allLeafChildren = [], e.childrenAfterGroup = [], e.childrenAfterSort = [], e.childrenAfterAggFilter = [], e.childrenAfterFilter = [], this.updateRootSiblingArrays(e);
  }
  deactivate() {
    this.rootNode && (this.allNodesMap = {}, this.rootNode = null);
  }
  destroy() {
    super.destroy(), this.allNodesMap = {}, this.rootNode = null;
  }
  setNewRowData(e) {
    const t = this.rootNode;
    t && (this.dispatchRowDataUpdateStartedEvent(e), t.childrenAfterFilter = null, t.childrenAfterGroup = null, t.childrenAfterAggFilter = null, t.childrenAfterSort = null, t.childrenMapped = null, t.updateHasChildren(), this.allNodesMap = {}, this.nextId = 0, this.loadNewRowData(e), this.updateRootSiblingArrays(t));
  }
  updateRootSiblingArrays(e) {
    const t = e.sibling;
    t && (t.childrenAfterFilter = e.childrenAfterFilter, t.childrenAfterGroup = e.childrenAfterGroup, t.childrenAfterAggFilter = e.childrenAfterAggFilter, t.childrenAfterSort = e.childrenAfterSort, t.childrenMapped = e.childrenMapped, t.allLeafChildren = e.allLeafChildren);
  }
  loadNewRowData(e) {
    this.rootNode.allLeafChildren = (e == null ? void 0 : e.map((t, n) => this.createRowNode(t, n))) ?? [];
  }
  setImmutableRowData(e, t) {
    var p;
    const n = Jo(this.gos), o = !this.gos.get("suppressMaintainUnsortedOrder"), s = e.changedRowNodes, i = /* @__PURE__ */ new Set(), r = this.rootNode, a = r.allLeafChildren, l = a.length;
    let d = !1, c = !1, u = !1, h = !1;
    for (let f = 0, m = -1, C = t.length; f < C; f++) {
      const w = t[f];
      let b = this.getRowNode(
        n({ data: w, level: 0 })
      );
      if (!b)
        d = !0, b = this.createRowNode(w, -1), s.add(b);
      else {
        if (o) {
          const A = b.sourceRowIndex;
          h || (h = A <= m || // A node was moved up, so order changed
          d), m = A;
        }
        b.data !== w && (u = !0, b.updateData(w), s.update(b));
      }
      i.add(b);
    }
    const g = [];
    for (let f = 0; f < l; f++) {
      const m = a[f];
      i.has(m) || (c = !0, m.isSelected() && g.push(m), m.pinnedSibling && ((p = this.beans.pinnedRowModel) == null || p.pinRow(m.pinnedSibling, null)), this.rowNodeDeleted(m), s.remove(m));
    }
    if (d || c || h) {
      const f = new Array(i.size);
      let m = 0;
      if (!o)
        for (let w = 0; w < l; ++w) {
          const b = a[w];
          i.delete(b) && (b.sourceRowIndex = m, f[m++] = b);
        }
      for (const w of i)
        w.sourceRowIndex = m, f[m++] = w;
      r.allLeafChildren = f;
      const C = r.sibling;
      C && (C.allLeafChildren = f), e.rowNodesOrderChanged || (e.rowNodesOrderChanged = h);
    }
    (d || c || h || u) && (this.deselectNodes(g), e.rowDataUpdated = !0);
  }
  /** Called when a node needs to be deleted */
  rowNodeDeleted(e) {
    e.clearRowTopAndRowIndex();
    const t = e.id, n = this.allNodesMap;
    n[t] === e && delete n[t];
  }
  updateRowData(e, t) {
    this.dispatchRowDataUpdateStartedEvent(e.add);
    const n = {
      changedRowNodes: t,
      rowNodeTransaction: { remove: [], update: [], add: [] },
      rowsInserted: !1
    }, o = [], s = Jo(this.gos);
    return this.executeRemove(s, e, n, o), this.executeUpdate(s, e, n, o), this.executeAdd(e, n), this.deselectNodes(o), n;
  }
  executeAdd(e, t) {
    const n = e.add;
    if (!(n != null && n.length))
      return;
    let o = this.rootNode.allLeafChildren, s = o.length;
    if (typeof e.addIndex == "number" && (s = this.sanitizeAddIndex(e.addIndex), s > 0 && this.gos.get("treeData") && this.gos.get("getDataPath")))
      for (let u = 0; u < o.length; u++) {
        const h = o[u];
        if ((h == null ? void 0 : h.rowIndex) == s - 1) {
          s = u + 1;
          break;
        }
      }
    const i = n.length, r = t.changedRowNodes, a = new Array(i);
    for (let c = 0; c < i; c++) {
      const u = this.createRowNode(n[c], s + c);
      r.add(u), a[c] = u;
    }
    const l = this.rootNode;
    if (s < o.length) {
      const c = o.slice(0, s), u = o.slice(s, o.length), h = c.length + a.length;
      for (let g = 0, p = u.length; g < p; ++g)
        u[g].sourceRowIndex = h + g;
      o = [...c, ...a, ...u], t.rowsInserted = !0;
    } else
      o = o.concat(a);
    l.allLeafChildren = o;
    const d = l.sibling;
    d && (d.allLeafChildren = o), t.rowNodeTransaction.add = a;
  }
  executeRemove(e, t, { changedRowNodes: n, rowNodeTransaction: o }, s) {
    var d, c;
    const { remove: i } = t;
    if (!(i != null && i.length))
      return;
    const r = {};
    i.forEach((u) => {
      var g;
      const h = this.lookupRowNode(e, u);
      h && (h.isSelected() && s.push(h), h.pinnedSibling && ((g = this.beans.pinnedRowModel) == null || g.pinRow(h.pinnedSibling, null)), h.clearRowTopAndRowIndex(), r[h.id] = !0, delete this.allNodesMap[h.id], o.remove.push(h), n.remove(h));
    });
    const a = this.rootNode;
    a.allLeafChildren = ((d = a.allLeafChildren) == null ? void 0 : d.filter((u) => !r[u.id])) ?? null, (c = a.allLeafChildren) == null || c.forEach((u, h) => {
      u.sourceRowIndex = h;
    });
    const l = a.sibling;
    l && (l.allLeafChildren = a.allLeafChildren);
  }
  executeUpdate(e, t, { changedRowNodes: n, rowNodeTransaction: o }, s) {
    const { update: i } = t;
    i != null && i.length && i.forEach((r) => {
      const a = this.lookupRowNode(e, r);
      a && (a.updateData(r), !a.selectable && a.isSelected() && s.push(a), o.update.push(a), n.update(a));
    });
  }
  dispatchRowDataUpdateStartedEvent(e) {
    this.eventSvc.dispatchEvent({
      type: "rowDataUpdateStarted",
      firstRowData: e != null && e.length ? e[0] : null
    });
  }
  deselectNodes(e) {
    var s;
    const t = "rowDataChanged", n = this.beans.selectionSvc, o = e.length > 0;
    o && (n == null || n.setNodesSelected({
      newValue: !1,
      nodes: e,
      suppressFinishActions: !0,
      source: t
    })), (s = n == null ? void 0 : n.updateGroupsFromChildrenSelections) == null || s.call(n, t), o && this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: t,
      selectedNodes: (n == null ? void 0 : n.getSelectedNodes()) ?? null,
      serverSideState: null
    });
  }
  sanitizeAddIndex(e) {
    var n;
    const t = ((n = this.rootNode.allLeafChildren) == null ? void 0 : n.length) ?? 0;
    return e < 0 || e >= t || Number.isNaN(e) ? t : Math.ceil(e);
  }
  createRowNode(e, t) {
    const n = new Ln(this.beans);
    return n.parent = this.rootNode, n.level = 0, n.group = !1, n.expanded = !1, n.sourceRowIndex = t, n.setDataAndId(e, String(this.nextId)), this.allNodesMap[n.id] && Z(2, { nodeId: n.id }), this.allNodesMap[n.id] = n, this.nextId++, n;
  }
  lookupRowNode(e, t) {
    var o, s;
    let n;
    if (e) {
      const i = e({ data: t, level: 0 });
      if (n = this.allNodesMap[i], !n)
        return $e(4, { id: i }), null;
    } else if (n = (s = (o = this.rootNode) == null ? void 0 : o.allLeafChildren) == null ? void 0 : s.find((i) => i.data === t), !n)
      return $e(5, { data: t }), null;
    return n || null;
  }
}, mo = /* @__PURE__ */ ((e) => (e.Applied = "Applied", e.StoreNotFound = "StoreNotFound", e.StoreLoading = "StoreLoading", e.StoreWaitingToLoad = "StoreWaitingToLoad", e.StoreLoadingFailed = "StoreLoadingFailed", e.StoreWrongType = "StoreWrongType", e.Cancelled = "Cancelled", e.StoreNotStarted = "StoreNotStarted", e))(mo || {});
function nl(e) {
  return !!(e.rowPinned && e.pinnedSibling);
}
function Vn(e, t, n, o) {
  const s = t === "top";
  if (!n)
    return Vn(
      e,
      t,
      s ? e.getPinnedTopRow(0) : e.getPinnedBottomRow(0),
      o
    );
  if (!o) {
    const l = s ? e.getPinnedTopRowCount() : e.getPinnedBottomRowCount();
    return Vn(
      e,
      t,
      n,
      s ? e.getPinnedTopRow(l - 1) : e.getPinnedBottomRow(l - 1)
    );
  }
  let i = !1, r = !1;
  const a = [];
  return e.forEachPinnedRow(t, (l) => {
    if (l === n && !i) {
      i = !0, a.push(l);
      return;
    }
    if (i && l === o) {
      r = !0, a.push(l);
      return;
    }
    i && !r && a.push(l);
  }), a;
}
var $P = {
  tag: "div",
  cls: "ag-selection-checkbox",
  role: "presentation",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eCheckbox",
      role: "presentation"
    }
  ]
}, zP = class extends Te {
  constructor() {
    super($P, [Di]), this.eCheckbox = X;
  }
  postConstruct() {
    this.eCheckbox.setPassive(!0);
  }
  onDataChanged() {
    this.onSelectionChanged();
  }
  onSelectableChanged() {
    this.showOrHideSelect();
  }
  onSelectionChanged() {
    const e = this.getLocaleTextFunc(), { rowNode: t, eCheckbox: n } = this, o = t.isSelected(), s = dc(e, o), [i, r] = t.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"], a = e(i, r);
    n.setValue(o, !0), n.setInputAriaLabel(`${a} (${s})`);
  }
  init(e) {
    if (this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListeners(this.eCheckbox.getInputElement(), {
      // we don't want double click on this icon to open a group
      dblclick: bt,
      click: (o) => {
        var s;
        bt(o), (s = this.beans.selectionSvc) == null || s.handleSelectionEvent(o, this.rowNode, "checkboxSelected");
      }
    }), this.addManagedListeners(this.rowNode, {
      rowSelected: this.onSelectionChanged.bind(this),
      dataChanged: this.onDataChanged.bind(this),
      selectableChanged: this.onSelectableChanged.bind(this)
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: o, previousValue: s }) => {
      const i = typeof o == "object" ? ru(o) : void 0, r = typeof s == "object" ? ru(s) : void 0;
      i !== r && this.onSelectableChanged();
    }), wh(this.gos) || typeof this.getIsVisible() == "function") {
      const o = this.showOrHideSelect.bind(this);
      this.addManagedEventListeners({ displayedColumnsChanged: o }), this.addManagedListeners(this.rowNode, {
        dataChanged: o,
        cellChanged: o
      }), this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
  }
  showOrHideSelect() {
    const { column: e, rowNode: t, overrides: n, gos: o } = this, s = t.selectable, i = this.getIsVisible();
    let r;
    if (typeof i == "function") {
      const u = n == null ? void 0 : n.callbackParams;
      if (!e)
        r = i({ ...u, node: t, data: t.data });
      else {
        const h = e.createColumnFunctionCallbackParams(t);
        r = i({ ...u, ...h });
      }
    } else
      r = i ?? !1;
    const a = s && !r || !s && r, l = s || r, d = o.get("rowSelection"), c = d && typeof d != "string" ? !ru(d) : !!(e != null && e.getColDef().showDisabledCheckboxes);
    if (this.setVisible(l && (a ? c : !0)), this.setDisplayed(l && (a ? c : !0)), l && this.eCheckbox.setDisabled(a), n != null && n.removeHidden) {
      this.setDisplayed(l);
      return;
    }
  }
  getIsVisible() {
    var n, o;
    const e = this.overrides;
    if (e)
      return e.isVisible;
    const t = this.gos.get("rowSelection");
    return t && typeof t != "string" ? li(t) : (o = (n = this.column) == null ? void 0 : n.getColDef()) == null ? void 0 : o.checkboxSelection;
  }
}, WP = class {
  constructor(e, t) {
    this.rowModel = e, this.pinnedRowModel = t, this.selectAll = !1, this.rootId = null, this.endId = null, this.cachedRange = [];
  }
  reset() {
    this.rootId = null, this.endId = null, this.cachedRange.length = 0;
  }
  setRoot(e) {
    this.rootId = e.id, this.endId = null, this.cachedRange.length = 0;
  }
  setEndRange(e) {
    this.endId = e.id, this.cachedRange.length = 0;
  }
  getRange() {
    if (this.cachedRange.length === 0) {
      const e = this.getRoot(), t = this.getEnd();
      if (e == null || t == null)
        return this.cachedRange;
      this.cachedRange = this.getNodesInRange(e, t) ?? [];
    }
    return this.cachedRange;
  }
  isInRange(e) {
    return this.rootId === null ? !1 : this.getRange().some((t) => t.id === e.id);
  }
  getRoot(e) {
    if (this.rootId)
      return this.getRowNode(this.rootId);
    if (e)
      return this.setRoot(e), e;
  }
  getEnd() {
    if (this.endId)
      return this.getRowNode(this.endId);
  }
  getRowNode(e) {
    let t;
    const { rowModel: n, pinnedRowModel: o } = this;
    return t ?? (t = n.getRowNode(e)), o != null && o.isManual() && (t ?? (t = o.getPinnedRowById(e, "top")), t ?? (t = o.getPinnedRowById(e, "bottom"))), t;
  }
  /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  truncate(e) {
    const t = this.getRange();
    if (t.length === 0)
      return { keep: [], discard: [] };
    const n = t[0].id === this.rootId, o = t.findIndex((s) => s.id === e.id);
    if (o > -1) {
      const s = t.slice(0, o), i = t.slice(o + 1);
      return this.setEndRange(e), n ? { keep: s, discard: i } : { keep: i, discard: s };
    } else
      return { keep: t, discard: [] };
  }
  /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  extend(e, t = !1) {
    const n = this.getRoot();
    if (n == null) {
      const s = this.getRange().slice();
      return t && e.depthFirstSearch((i) => !i.group && s.push(i)), s.push(e), this.setRoot(e), { keep: s, discard: [] };
    }
    const o = this.getNodesInRange(n, e);
    if (!o)
      return this.setRoot(e), { keep: [e], discard: [] };
    if (o.find((s) => s.id === this.endId))
      return this.setEndRange(e), { keep: this.getRange(), discard: [] };
    {
      const s = this.getRange().slice();
      return this.setEndRange(e), { keep: this.getRange(), discard: s };
    }
  }
  getNodesInRange(e, t) {
    const { pinnedRowModel: n, rowModel: o } = this;
    if (!(n != null && n.isManual()))
      return o.getNodesInRangeForSelection(e, t);
    if (e.rowPinned === "top" && !t.rowPinned)
      return Vn(n, "top", e, void 0).concat(o.getNodesInRangeForSelection(o.getRow(0), t) ?? []);
    if (e.rowPinned === "bottom" && !t.rowPinned) {
      const s = Vn(n, "bottom", void 0, e), i = o.getRowCount(), r = o.getRow(i - 1);
      return (o.getNodesInRangeForSelection(t, r) ?? []).concat(s);
    }
    if (!e.rowPinned && !t.rowPinned)
      return o.getNodesInRangeForSelection(e, t);
    if (e.rowPinned === "top" && t.rowPinned === "top")
      return Vn(n, "top", e, t);
    if (e.rowPinned === "bottom" && t.rowPinned === "top") {
      const s = Vn(n, "top", t, void 0), i = Vn(n, "bottom", void 0, e), r = o.getRow(0), a = o.getRow(o.getRowCount() - 1);
      return s.concat(o.getNodesInRangeForSelection(r, a) ?? []).concat(i);
    }
    if (!e.rowPinned && t.rowPinned === "top")
      return Vn(n, "top", t, void 0).concat(o.getNodesInRangeForSelection(o.getRow(0), e) ?? []);
    if (e.rowPinned === "top" && t.rowPinned === "bottom") {
      const s = Vn(n, "top", e, void 0), i = Vn(n, "bottom", void 0, t), r = o.getRow(0), a = o.getRow(o.getRowCount() - 1);
      return s.concat(o.getNodesInRangeForSelection(r, a) ?? []).concat(i);
    }
    if (e.rowPinned === "bottom" && t.rowPinned === "bottom")
      return Vn(n, "bottom", e, t);
    if (!e.rowPinned && t.rowPinned === "bottom") {
      const s = Vn(n, "bottom", void 0, t), i = o.getRow(o.getRowCount());
      return (o.getNodesInRangeForSelection(e, i) ?? []).concat(s);
    }
    return null;
  }
}, UP = class extends U {
  constructor(e) {
    super(), this.column = e, this.cbSelectAllVisible = !1, this.processingEventFromCheckbox = !1;
  }
  onSpaceKeyDown(e) {
    const t = this.cbSelectAll;
    t.isDisplayed() && !t.getGui().contains(je(this.beans)) && (e.preventDefault(), t.setValue(!t.getValue()));
  }
  getCheckboxGui() {
    return this.cbSelectAll.getGui();
  }
  setComp(e) {
    this.headerCellCtrl = e;
    const t = this.createManagedBean(new vc());
    this.cbSelectAll = t, t.addCss("ag-header-select-all"), hn(t.getGui(), "presentation"), this.showOrHideSelectAll();
    const n = this.updateStateOfCheckbox.bind(this);
    this.addManagedEventListeners({
      newColumnsLoaded: () => this.showOrHideSelectAll(),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      selectionChanged: n,
      paginationChanged: n,
      modelUpdated: n
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: o, previousValue: s }) => {
      const i = (r) => typeof r == "string" || !r || r.mode === "singleRow" ? void 0 : r.selectAll;
      i(o) !== i(s) && this.showOrHideSelectAll(), this.updateStateOfCheckbox();
    }), this.addManagedListeners(t, { fieldValueChanged: this.onCbSelectAll.bind(this) }), t.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
  }
  onDisplayedColumnsChanged(e) {
    this.isAlive() && this.showOrHideSelectAll(e.source === "uiColumnMoved");
  }
  showOrHideSelectAll(e = !1) {
    const t = this.isCheckboxSelection();
    this.cbSelectAllVisible = t, this.cbSelectAll.setDisplayed(t), t && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel(e);
  }
  updateStateOfCheckbox() {
    if (!this.cbSelectAllVisible || this.processingEventFromCheckbox)
      return;
    this.processingEventFromCheckbox = !0;
    const e = this.getSelectAllMode(), t = this.beans.selectionSvc, n = this.cbSelectAll, o = t.getSelectAllState(e);
    n.setValue(o);
    const s = t.hasNodesToSelect(e);
    n.setDisabled(!s), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
  }
  refreshSelectAllLabel(e = !1) {
    const t = this.getLocaleTextFunc(), { headerCellCtrl: n, cbSelectAll: o, cbSelectAllVisible: s } = this, i = o.getValue(), r = dc(t, i), a = t("ariaRowSelectAll", "Press Space to toggle all rows selection");
    n.setAriaDescriptionProperty(
      "selectAll",
      s ? `${a} (${r})` : null
    ), o.setInputAriaLabel(t("ariaHeaderSelection", "Column with Header Selection")), e || n.announceAriaDescription();
  }
  checkSelectionType(e) {
    return es(this.gos) ? !0 : (Z(128, { feature: e }), !1);
  }
  checkRightRowModelType(e) {
    const { gos: t, rowModel: n } = this.beans;
    return Ct(t) || gn(t) ? !0 : (Z(129, { feature: e, rowModel: n.getType() }), !1);
  }
  onCbSelectAll() {
    if (this.processingEventFromCheckbox || !this.cbSelectAllVisible)
      return;
    const e = this.cbSelectAll.getValue(), t = this.getSelectAllMode();
    let n = "uiSelectAll";
    t === "currentPage" ? n = "uiSelectAllCurrentPage" : t === "filtered" && (n = "uiSelectAllFiltered");
    const o = { source: n, selectAll: t }, s = this.beans.selectionSvc;
    e ? s.selectAllRowNodes(o) : s.deselectAllRowNodes(o);
  }
  /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */
  isCheckboxSelection() {
    const { column: e, gos: t, beans: n } = this, i = typeof t.get("rowSelection") == "object" ? "headerCheckbox" : "headerCheckboxSelection";
    return Qw(n, e) && this.checkRightRowModelType(i) && this.checkSelectionType(i);
  }
  getSelectAllMode() {
    const e = BC(this.gos, !1);
    if (e)
      return e;
    const { headerCheckboxSelectionCurrentPageOnly: t, headerCheckboxSelectionFilteredOnly: n } = this.column.getColDef();
    return t ? "currentPage" : n ? "filtered" : "all";
  }
  destroy() {
    super.destroy(), this.cbSelectAll = void 0, this.headerCellCtrl = void 0;
  }
};
function Qw({ gos: e, selectionColSvc: t }, n) {
  const o = e.get("rowSelection"), s = n.getColDef(), { headerCheckboxSelection: i } = s;
  let r = !1;
  if (typeof o == "object") {
    const l = Gs(n), d = pc(n);
    (Ta(o) === "autoGroupColumn" && d || l && (t != null && t.isSelectionColumnEnabled())) && (r = jl(o));
  } else
    typeof i == "function" ? r = i(ke(e, { column: n, colDef: s })) : r = !!i;
  return r;
}
var Jw = class extends U {
  postConstruct() {
    const { gos: e, beans: t } = this;
    this.selectionCtx = new WP(t.rowModel, t.pinnedRowModel), this.addManagedPropertyListeners(["isRowSelectable", "rowSelection"], () => {
      const n = wh(e);
      n !== this.isRowSelectable && (this.isRowSelectable = n, this.updateSelectable());
    }), this.isRowSelectable = wh(e), this.addManagedEventListeners({
      cellValueChanged: (n) => this.updateRowSelectable(n.node),
      rowNodeDataChanged: (n) => this.updateRowSelectable(n.node)
    });
  }
  destroy() {
    super.destroy(), this.selectionCtx.reset();
  }
  createCheckboxSelectionComponent() {
    return new zP();
  }
  createSelectAllFeature(e) {
    if (Qw(this.beans, e))
      return new UP(e);
  }
  isMultiSelect() {
    return es(this.gos);
  }
  onRowCtrlSelected(e, t, n) {
    const o = !!e.rowNode.isSelected();
    e.forEachGui(n, (s) => {
      s.rowComp.toggleCss("ag-row-selected", o);
      const i = s.element;
      zg(i, o), i.contains(je(this.beans)) && t(s);
    });
  }
  announceAriaRowSelection(e) {
    var s;
    if (this.isRowSelectionBlocked(e))
      return;
    const t = e.isSelected();
    if (!e.selectable)
      return;
    const o = this.getLocaleTextFunc()(
      t ? "ariaRowDeselect" : "ariaRowSelect",
      `Press SPACE to ${t ? "deselect" : "select"} this row`
    );
    (s = this.beans.ariaAnnounce) == null || s.announceValue(o, "rowSelection");
  }
  isRowSelectionBlocked(e) {
    return !e.selectable || e.rowPinned && !nl(e) || !In(this.gos);
  }
  updateRowSelectable(e, t) {
    var o;
    const n = e.rowPinned && e.pinnedSibling ? (
      // If row node is pinned sibling, copy selectable status over from sibling row node
      e.pinnedSibling.selectable
    ) : (
      // otherwise calculate selectable state directly
      ((o = this.isRowSelectable) == null ? void 0 : o.call(this, e)) ?? !0
    );
    return this.setRowSelectable(e, n, t), n;
  }
  setRowSelectable(e, t, n) {
    if (e.selectable !== t) {
      if (e.selectable = t, e.dispatchRowEvent("selectableChanged"), n)
        return;
      if (wi(this.gos)) {
        const s = this.calculateSelectedFromChildren(e);
        this.setNodesSelected({ nodes: [e], newValue: s ?? !1, source: "selectableChanged" });
        return;
      }
      e.isSelected() && !e.selectable && this.setNodesSelected({ nodes: [e], newValue: !1, source: "selectableChanged" });
    }
  }
  calculateSelectedFromChildren(e) {
    var o;
    let t = !1, n = !1;
    if (!((o = e.childrenAfterGroup) != null && o.length))
      return e.selectable ? e.__selected : null;
    for (let s = 0; s < e.childrenAfterGroup.length; s++) {
      const i = e.childrenAfterGroup[s];
      let r = i.isSelected();
      if (!i.selectable) {
        const a = this.calculateSelectedFromChildren(i);
        if (a === null)
          continue;
        r = a;
      }
      switch (r) {
        case !0:
          t = !0;
          break;
        case !1:
          n = !0;
          break;
        default:
          return;
      }
    }
    if (!(t && n))
      return t ? !0 : n ? !1 : e.selectable ? e.__selected : null;
  }
  selectRowNode(e, t, n, o = "api") {
    const s = !e.selectable && t, i = e.__selected === t;
    if (s || i)
      return !1;
    e.__selected = t, e.dispatchRowEvent("rowSelected");
    const r = e.sibling;
    r && r.footer && r.__localEventService && r.dispatchRowEvent("rowSelected");
    const a = e.pinnedSibling;
    return a && a.rowPinned && a.__localEventService && a.dispatchRowEvent("rowSelected"), this.eventSvc.dispatchEvent({
      ...Sw(e, this.gos, "rowSelected"),
      event: n || null,
      source: o
    }), !0;
  }
  isCellCheckboxSelection(e, t) {
    const n = this.gos.get("rowSelection");
    if (n && typeof n != "string") {
      const o = Gs(e) && li(n);
      return e.isColumnFunc(t, o);
    } else
      return e.isColumnFunc(t, e.colDef.checkboxSelection);
  }
  inferNodeSelections(e, t, n, o) {
    const { gos: s, selectionCtx: i } = this, r = e.isSelected(), a = wi(s), l = G3(s), d = H3(s), c = this.isMultiSelect(), u = o === "rowClicked";
    if (u && !(l || d))
      return null;
    if (t && n && c) {
      const h = i.getRoot();
      if (h)
        if (h.isSelected()) {
          const g = i.isInRange(e) ? i.truncate(e) : i.extend(e, a);
          return {
            deselect: g.discard,
            select: g.keep,
            reset: !1
          };
        } else {
          const g = i.extend(e, a);
          return {
            select: [],
            deselect: g.keep,
            reset: !1
          };
        }
      else return null;
    } else if (t && c) {
      const h = i.selectAll ? this.beans.rowModel.getRow(0) : void 0, g = i.getRoot(h), p = i.isInRange(e) ? i.truncate(e) : i.extend(e, a);
      return {
        select: p.keep,
        deselect: p.discard,
        reset: i.selectAll || !!(g && !g.isSelected())
      };
    } else if (n) {
      if (u) {
        const h = !r;
        return h && !l || !h && !d ? null : (i.setRoot(e), {
          node: e,
          newValue: h,
          clearSelection: !1
        });
      }
      return i.setRoot(e), {
        node: e,
        newValue: !r,
        clearSelection: !c
      };
    } else {
      i.setRoot(e);
      const h = V3(s), g = xd(s) === "filteredDescendants", p = u && (!h || !l);
      if (g && r === void 0 && Ct(s))
        return {
          node: e,
          newValue: !1,
          checkFilteredNodes: !0,
          clearSelection: !c || p
        };
      if (u) {
        const f = r ? !h : l;
        return f === r && !p || f && !l || !f && !d ? null : {
          node: e,
          newValue: f,
          clearSelection: !c || p,
          keepDescendants: e.group && a
        };
      }
      return {
        node: e,
        newValue: !r,
        clearSelection: !c || p
      };
    }
  }
}, Xl = {
  TAB_GUARD: "ag-tab-guard",
  TAB_GUARD_TOP: "ag-tab-guard-top",
  TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
}, KP = class extends U {
  constructor(e) {
    super(), this.skipTabGuardFocus = !1, this.forcingFocusOut = !1, this.allowFocus = !1;
    const {
      comp: t,
      eTopGuard: n,
      eBottomGuard: o,
      focusTrapActive: s,
      forceFocusOutWhenTabGuardsAreEmpty: i,
      isFocusableContainer: r,
      focusInnerElement: a,
      onFocusIn: l,
      onFocusOut: d,
      shouldStopEventPropagation: c,
      onTabKeyDown: u,
      handleKeyDown: h,
      isEmpty: g,
      eFocusableElement: p
    } = e;
    this.comp = t, this.eTopGuard = n, this.eBottomGuard = o, this.providedFocusInnerElement = a, this.eFocusableElement = p, this.focusTrapActive = !!s, this.forceFocusOutWhenTabGuardsAreEmpty = !!i, this.isFocusableContainer = !!r, this.providedFocusIn = l, this.providedFocusOut = d, this.providedShouldStopEventPropagation = c, this.providedOnTabKeyDown = u, this.providedHandleKeyDown = h, this.providedIsEmpty = g;
  }
  postConstruct() {
    this.createManagedBean(
      new Hs(this.eFocusableElement, {
        shouldStopEventPropagation: () => this.shouldStopEventPropagation(),
        onTabKeyDown: (e) => this.onTabKeyDown(e),
        handleKeyDown: (e) => this.handleKeyDown(e),
        onFocusIn: (e) => this.onFocusIn(e),
        onFocusOut: (e) => this.onFocusOut(e)
      })
    ), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach(
      (e) => this.addManagedElementListeners(e, { focus: this.onFocus.bind(this) })
    );
  }
  handleKeyDown(e) {
    this.providedHandleKeyDown && this.providedHandleKeyDown(e);
  }
  tabGuardsAreActive() {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
  }
  shouldStopEventPropagation() {
    return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
  }
  activateTabGuards() {
    if (this.forcingFocusOut)
      return;
    const e = this.gos.get("tabIndex");
    this.comp.setTabIndex(e.toString());
  }
  deactivateTabGuards() {
    this.comp.setTabIndex();
  }
  onFocus(e) {
    if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget) && !this.allowFocus) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.skipTabGuardFocus) {
      this.skipTabGuardFocus = !1;
      return;
    }
    if (this.forceFocusOutWhenTabGuardsAreEmpty && (this.providedIsEmpty ? this.providedIsEmpty() : Ko(this.eFocusableElement, ".ag-tab-guard").length === 0)) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget))
      return;
    const t = e.target === this.eBottomGuard;
    !(this.providedFocusInnerElement ? this.providedFocusInnerElement(t) : this.focusInnerElement(t)) && this.forceFocusOutWhenTabGuardsAreEmpty && this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
  }
  findNextElementOutsideAndFocus(e) {
    var l;
    const t = Bt(this.beans), n = Ko(t.body, null, !0), o = n.indexOf(e ? this.eTopGuard : this.eBottomGuard);
    if (o === -1)
      return;
    let s, i;
    e ? (s = 0, i = o) : (s = o + 1, i = n.length);
    const r = n.slice(s, i), a = this.gos.get("tabIndex");
    r.sort((d, c) => {
      const u = parseInt(d.getAttribute("tabindex") || "0"), h = parseInt(c.getAttribute("tabindex") || "0");
      return h === a ? 1 : u === a ? -1 : u === 0 ? 1 : h === 0 ? -1 : u - h;
    }), (l = r[e ? r.length - 1 : 0]) == null || l.focus();
  }
  onFocusIn(e) {
    this.focusTrapActive || this.forcingFocusOut || (this.providedFocusIn && this.providedFocusIn(e), this.isFocusableContainer || this.deactivateTabGuards());
  }
  onFocusOut(e) {
    this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
  }
  onTabKeyDown(e) {
    if (this.providedOnTabKeyDown) {
      this.providedOnTabKeyDown(e);
      return;
    }
    if (this.focusTrapActive || e.defaultPrevented)
      return;
    const t = this.tabGuardsAreActive();
    t && this.deactivateTabGuards();
    const n = this.getNextFocusableElement(e.shiftKey);
    t && setTimeout(() => this.activateTabGuards(), 0), n && (n.focus(), e.preventDefault());
  }
  focusInnerElement(e = !1) {
    const t = Ko(this.eFocusableElement);
    return this.tabGuardsAreActive() && (t.splice(0, 1), t.splice(t.length - 1, 1)), t.length ? (t[e ? t.length - 1 : 0].focus({ preventScroll: !0 }), !0) : !1;
  }
  getNextFocusableElement(e) {
    return sn(this.beans, this.eFocusableElement, !1, e);
  }
  forceFocusOutOfContainer(e = !1) {
    if (this.forcingFocusOut)
      return;
    const t = e ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards(), this.skipTabGuardFocus = !0, this.forcingFocusOut = !0, t.focus(), window.setTimeout(() => {
      this.forcingFocusOut = !1, this.activateTabGuards();
    });
  }
  isTabGuard(e, t) {
    return e === this.eTopGuard && !t || e === this.eBottomGuard && (t ?? !0);
  }
  setAllowFocus(e) {
    this.allowFocus = e;
  }
}, Xw = class extends U {
  constructor(e) {
    super(), this.comp = e;
  }
  initialiseTabGuard(e) {
    this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.comp.getFocusableElement();
    const { eTopGuard: t, eBottomGuard: n, eFocusableElement: o } = this, s = [t, n], i = {
      setTabIndex: (m) => {
        s.forEach(
          (C) => m != null ? C.setAttribute("tabindex", m) : C.removeAttribute("tabindex")
        );
      }
    };
    this.addTabGuards(t, n);
    const {
      focusTrapActive: r = !1,
      onFocusIn: a,
      onFocusOut: l,
      focusInnerElement: d,
      handleKeyDown: c,
      onTabKeyDown: u,
      shouldStopEventPropagation: h,
      isEmpty: g,
      forceFocusOutWhenTabGuardsAreEmpty: p,
      isFocusableContainer: f
    } = e;
    this.tabGuardCtrl = this.createManagedBean(
      new KP({
        comp: i,
        focusTrapActive: r,
        eTopGuard: t,
        eBottomGuard: n,
        eFocusableElement: o,
        onFocusIn: a,
        onFocusOut: l,
        focusInnerElement: d,
        handleKeyDown: c,
        onTabKeyDown: u,
        shouldStopEventPropagation: h,
        isEmpty: g,
        forceFocusOutWhenTabGuardsAreEmpty: p,
        isFocusableContainer: f
      })
    );
  }
  getTabGuardCtrl() {
    return this.tabGuardCtrl;
  }
  createTabGuard(e) {
    const t = Bt(this.beans).createElement("div"), n = e === "top" ? Xl.TAB_GUARD_TOP : Xl.TAB_GUARD_BOTTOM;
    return t.classList.add(Xl.TAB_GUARD, n), hn(t, "presentation"), t;
  }
  addTabGuards(e, t) {
    const n = this.eFocusableElement;
    n.insertAdjacentElement("afterbegin", e), n.insertAdjacentElement("beforeend", t);
  }
  removeAllChildrenExceptTabGuards() {
    const e = [this.eTopGuard, this.eBottomGuard];
    ht(this.comp.getFocusableElement()), this.addTabGuards(...e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardCtrl.forceFocusOutOfContainer(e);
  }
  appendChild(e, t, n) {
    uc(t) || (t = t.getGui());
    const { eBottomGuard: o } = this;
    o ? o.insertAdjacentElement("beforebegin", t) : e(t, n);
  }
  destroy() {
    const { eTopGuard: e, eBottomGuard: t } = this;
    nn(e), nn(t), super.destroy();
  }
}, Ti = class extends Te {
  initialiseTabGuard(e) {
    this.tabGuardFeature = this.createManagedBean(new Xw(this)), this.tabGuardFeature.initialiseTabGuard(e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardFeature.forceFocusOutOfContainer(e);
  }
  appendChild(e, t) {
    this.tabGuardFeature.appendChild(super.appendChild.bind(this), e, t);
  }
}, No = class {
  constructor(e, t = !1) {
    this.DOUBLE_TAP_MILLIS = 500, this.destroyFuncs = [], this.touching = !1, this.localEventService = new Fs(), this.preventMouseClick = t;
    const n = this.onTouchStart.bind(this), o = this.onTouchMove.bind(this), s = this.onTouchEnd.bind(this);
    e.addEventListener("touchstart", n, { passive: !0 }), e.addEventListener("touchmove", o, { passive: !0 }), e.addEventListener("touchend", s, { passive: !1 }), this.destroyFuncs.push(() => {
      e.removeEventListener("touchstart", n, { passive: !0 }), e.removeEventListener("touchmove", o, { passive: !0 }), e.removeEventListener("touchend", s, { passive: !1 });
    });
  }
  getActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
  onTouchStart(e) {
    if (this.touching)
      return;
    this.touchStart = e.touches[0], this.touching = !0, this.moved = !1;
    const t = this.touchStart;
    window.setTimeout(() => {
      const n = this.touchStart === t;
      if (this.touching && n && !this.moved) {
        this.moved = !0;
        const o = {
          type: "longTap",
          touchStart: this.touchStart,
          touchEvent: e
        };
        this.localEventService.dispatchEvent(o);
      }
    }, 500);
  }
  onTouchMove(e) {
    if (!this.touching)
      return;
    const t = this.getActiveTouch(e.touches);
    if (!t)
      return;
    !wC(t, this.touchStart, 4) && (this.moved = !0);
  }
  onTouchEnd(e) {
    if (this.touching) {
      if (!this.moved) {
        const t = {
          type: "tap",
          touchStart: this.touchStart
        };
        this.localEventService.dispatchEvent(t), this.checkForDoubleTap();
      }
      this.preventMouseClick && e.cancelable && e.preventDefault(), this.touching = !1;
    }
  }
  checkForDoubleTap() {
    const e = Date.now();
    if (this.lastTapTime && this.lastTapTime > 0)
      if (e - this.lastTapTime > this.DOUBLE_TAP_MILLIS) {
        const n = {
          type: "doubleTap",
          touchStart: this.touchStart
        };
        this.localEventService.dispatchEvent(n), this.lastTapTime = null;
      } else
        this.lastTapTime = e;
    else
      this.lastTapTime = e;
  }
  destroy() {
    this.destroyFuncs.forEach((e) => e());
  }
}, ey = class {
  constructor(e) {
    this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = e.scrollContainer, this.scrollHorizontally = e.scrollAxis.indexOf("x") !== -1, this.scrollVertically = e.scrollAxis.indexOf("y") !== -1, this.scrollByTick = e.scrollByTick != null ? e.scrollByTick : 20, e.onScrollCallback && (this.onScrollCallback = e.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = e.getVerticalPosition, this.setVerticalPosition = e.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = e.getHorizontalPosition, this.setHorizontalPosition = e.setHorizontalPosition), this.shouldSkipVerticalScroll = e.shouldSkipVerticalScroll || (() => !1), this.shouldSkipHorizontalScroll = e.shouldSkipHorizontalScroll || (() => !1);
  }
  check(e, t = !1) {
    const n = t || this.shouldSkipVerticalScroll();
    if (n && this.shouldSkipHorizontalScroll())
      return;
    const o = this.scrollContainer.getBoundingClientRect(), s = this.scrollByTick;
    this.tickLeft = e.clientX < o.left + s, this.tickRight = e.clientX > o.right - s, this.tickUp = e.clientY < o.top + s && !n, this.tickDown = e.clientY > o.bottom - s && !n, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
  }
  ensureTickingStarted() {
    this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
  }
  doTick() {
    this.tickCount++;
    const e = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
    if (this.scrollVertically) {
      const t = this.getVerticalPosition();
      this.tickUp && this.setVerticalPosition(t - e), this.tickDown && this.setVerticalPosition(t + e);
    }
    if (this.scrollHorizontally) {
      const t = this.getHorizontalPosition();
      this.tickLeft && this.setHorizontalPosition(t - e), this.tickRight && this.setHorizontalPosition(t + e);
    }
    this.onScrollCallback && this.onScrollCallback();
  }
  ensureCleared() {
    this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
  }
}, ty = class {
  constructor(e = "javascript") {
    this.frameworkName = e, this.renderingEngine = "vanilla", this.batchFrameworkComps = !1, this.wrapIncoming = (t) => t(), this.wrapOutgoing = (t) => t(), this.baseDocLink = `${RC}/${this.frameworkName}-data-grid`, M3(this.baseDocLink);
  }
  frameworkComponent(e) {
    return null;
  }
  isFrameworkComponent(e) {
    return !1;
  }
  getDocLink(e) {
    return `${this.baseDocLink}${e ? `/${e}` : ""}`;
  }
};
function ZP(e) {
  return {
    beanName: "gridApi",
    bean: e.getBean("apiFunctionSvc").api
  };
}
var qP = [
  // Validate license first
  "licenseManager",
  // core beans only
  "environment",
  "eventSvc",
  "gos",
  "paginationAutoPageSizeSvc",
  "apiFunctionSvc",
  "gridApi",
  "registry",
  "agCompUtils",
  "userCompFactory",
  "rowContainerHeight",
  "horizontalResizeSvc",
  "localeSvc",
  "pinnedRowModel",
  "dragSvc",
  "colGroupSvc",
  "visibleCols",
  "popupSvc",
  "selectionSvc",
  "colFilter",
  "quickFilter",
  "filterManager",
  "colModel",
  "headerNavigation",
  "pageBounds",
  "pagination",
  "pageBoundsListener",
  "rowSpanSvc",
  "stickyRowSvc",
  "rowRenderer",
  "expressionSvc",
  "alignedGridsSvc",
  "navigation",
  "valueCache",
  "valueSvc",
  "autoWidthCalc",
  "filterMenuFactory",
  "dragAndDrop",
  "focusSvc",
  "cellNavigation",
  "cellStyles",
  "scrollVisibleSvc",
  "sortSvc",
  "colHover",
  "colAnimation",
  "autoColSvc",
  "selectionColSvc",
  "changeDetectionSvc",
  "animationFrameSvc",
  "undoRedo",
  "colDefFactory",
  "rowStyleSvc",
  "rowNodeBlockLoader",
  "rowNodeSorter",
  "ctrlsSvc",
  "pinnedCols",
  "dataTypeSvc",
  "syncSvc",
  "overlays",
  "stateSvc",
  "expansionSvc",
  "apiEventSvc",
  "ariaAnnounce",
  "menuSvc",
  "colMoves",
  "colAutosize",
  "colFlex",
  "colResize",
  "pivotColsSvc",
  "valueColsSvc",
  "rowGroupColsSvc",
  "colNames",
  "colViewport",
  "pivotResultCols",
  "showRowGroupCols",
  "validation"
  // Have validations run last
], Om = Object.fromEntries(
  qP.map((e, t) => [e, t])
);
function jP(e, t) {
  const n = (e.beanName ? Om[e.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER, o = (t.beanName ? Om[t.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
  return n - o;
}
function YP(e, t) {
  return (e == null ? void 0 : e.beanName) === "gridDestroySvc" ? -1 : (t == null ? void 0 : t.beanName) === "gridDestroySvc" ? 1 : 0;
}
var QP = { tag: "div", cls: "ag-pinned-left-header", role: "rowgroup" }, JP = { tag: "div", cls: "ag-pinned-right-header", role: "rowgroup" }, XP = {
  tag: "div",
  cls: "ag-header-viewport",
  role: "rowgroup",
  attrs: { tabindex: "-1" },
  children: [{ tag: "div", ref: "eCenterContainer", cls: "ag-header-container", role: "presentation" }]
}, xu = class extends Te {
  constructor(e) {
    super(), this.eCenterContainer = X, this.headerRowComps = {}, this.rowCompsList = [], this.pinned = e;
  }
  postConstruct() {
    this.selectAndSetTemplate();
    const e = {
      setDisplayed: (n) => this.setDisplayed(n),
      setCtrls: (n) => this.setCtrls(n),
      // only gets called for center section
      setCenterWidth: (n) => this.eCenterContainer.style.width = n,
      setViewportScrollLeft: (n) => this.getGui().scrollLeft = n,
      // only gets called for pinned sections
      setPinnedContainerWidth: (n) => {
        const o = this.getGui();
        o.style.width = n, o.style.maxWidth = n, o.style.minWidth = n;
      }
    };
    this.createManagedBean(new bP(this.pinned)).setComp(e, this.getGui());
  }
  selectAndSetTemplate() {
    const e = this.pinned == "left", t = this.pinned == "right", n = e ? QP : t ? JP : XP;
    this.setTemplate(n), this.eRowContainer = this.eCenterContainer !== X ? this.eCenterContainer : this.getGui();
  }
  destroy() {
    this.setCtrls([]), super.destroy();
  }
  destroyRowComp(e) {
    this.destroyBean(e), this.eRowContainer.removeChild(e.getGui());
  }
  setCtrls(e) {
    const t = this.headerRowComps;
    this.headerRowComps = {}, this.rowCompsList = [];
    let n;
    const o = (s) => {
      const i = s.getGui();
      i.parentElement != this.eRowContainer && this.eRowContainer.appendChild(i), n && pC(this.eRowContainer, i, n), n = i;
    };
    e.forEach((s) => {
      const i = s.instanceId, r = t[i];
      delete t[i];
      const a = r || this.createBean(new vP(s));
      this.headerRowComps[i] = a, this.rowCompsList.push(a), o(a);
    }), Object.values(t).forEach((s) => this.destroyRowComp(s));
  }
}, eD = { tag: "div", cls: "ag-header", role: "presentation" }, tD = class extends Te {
  constructor() {
    super(eD);
  }
  postConstruct() {
    const e = {
      toggleCss: (o, s) => this.toggleCss(o, s),
      setHeightAndMinHeight: (o) => {
        this.getGui().style.height = o, this.getGui().style.minHeight = o;
      }
    };
    this.createManagedBean(new cP()).setComp(e, this.getGui(), this.getFocusableElement());
    const n = (o) => {
      this.createManagedBean(o), this.appendChild(o);
    };
    n(new xu("left")), n(new xu(null)), n(new xu("right"));
  }
}, nD = {
  selector: "AG-HEADER-ROOT",
  component: tD
}, oD = class extends Te {
  constructor(e, t, n, o, s) {
    super(), this.cellCtrl = t, this.rendererVersion = 0, this.editorVersion = 0, this.beans = e, this.gos = e.gos, this.column = t.column, this.rowNode = t.rowNode, this.eRow = o;
    const i = Ue({
      tag: "div",
      role: t.getCellAriaRole(),
      attrs: {
        "comp-id": `${this.getCompId()}`,
        "col-id": t.column.colIdSanitised
      }
    });
    this.eCell = i;
    let r;
    t.isCellSpanning() ? (r = Ue({
      tag: "div",
      cls: "ag-spanned-cell-wrapper",
      role: "presentation"
    }), r.appendChild(i), this.setTemplateFromElement(r)) : this.setTemplateFromElement(i), this.cellCssManager = new tw(() => i), this.forceWrapper = t.isForceWrapper(), this.refreshWrapper(!1);
    const a = {
      toggleCss: (l, d) => this.cellCssManager.toggleCss(l, d),
      setUserStyles: (l) => Ya(i, l),
      getFocusableElement: () => i,
      setIncludeSelection: (l) => this.includeSelection = l,
      setIncludeRowDrag: (l) => this.includeRowDrag = l,
      setIncludeDndSource: (l) => this.includeDndSource = l,
      setRenderDetails: (l, d, c) => this.setRenderDetails(l, d, c),
      setEditDetails: (l, d, c) => this.setEditDetails(l, d, c),
      getCellEditor: () => this.cellEditor || null,
      getCellRenderer: () => this.cellRenderer || null,
      getParentOfValue: () => this.getParentOfValue(),
      refreshEditStyles: (l, d) => this.refreshEditStyles(l, d)
    };
    t.setComp(a, i, r, this.eCellWrapper, n, s, void 0);
  }
  getParentOfValue() {
    return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
  }
  setRenderDetails(e, t, n) {
    var i;
    if (this.cellEditor && !this.cellEditorPopupWrapper)
      return;
    this.firstRender = this.firstRender == null;
    const s = this.refreshWrapper(!1);
    this.refreshEditStyles(!1), e ? !(n || s) && this.refreshCellRenderer(e) || (this.destroyRenderer(), this.createCellRendererInstance(e)) : (this.destroyRenderer(), this.insertValueWithoutCellRenderer(t)), (i = this.rowDraggingComp) == null || i.refreshVisibility();
  }
  setEditDetails(e, t, n) {
    e ? this.createCellEditorInstance(e, t, n) : this.destroyEditor();
  }
  removeControls() {
    const e = this.beans.context;
    this.checkboxSelectionComp = e.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = e.destroyBean(this.dndSourceComp), this.rowDraggingComp = e.destroyBean(this.rowDraggingComp);
  }
  // returns true if wrapper was changed
  refreshWrapper(e) {
    const t = this.includeRowDrag || this.includeDndSource || this.includeSelection, n = t || this.forceWrapper, o = n && this.eCellWrapper == null;
    o && (this.eCellWrapper = Ue({ tag: "div", cls: "ag-cell-wrapper", role: "presentation" }), this.eCell.appendChild(this.eCellWrapper));
    const s = !n && this.eCellWrapper != null;
    s && (nn(this.eCellWrapper), this.eCellWrapper = void 0), this.cellCssManager.toggleCss("ag-cell-value", !n);
    const i = !e && n, r = i && this.eCellValue == null;
    r && (this.eCellValue = Ue({ tag: "span", cls: "ag-cell-value", role: "presentation" }), this.eCellWrapper.appendChild(this.eCellValue));
    const a = !i && this.eCellValue != null;
    a && (nn(this.eCellValue), this.eCellValue = void 0);
    const l = o || s || r || a;
    return l && this.removeControls(), !e && t && this.addControls(), l;
  }
  addControls() {
    const { cellCtrl: e, eCellWrapper: t, eCellValue: n, includeRowDrag: o, includeDndSource: s, includeSelection: i } = this, r = (a) => {
      a && t.insertBefore(a.getGui(), n);
    };
    o && this.rowDraggingComp == null && (this.rowDraggingComp = e.createRowDragComp(), r(this.rowDraggingComp)), s && this.dndSourceComp == null && (this.dndSourceComp = e.createDndSource(), r(this.dndSourceComp)), i && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = e.createSelectionCheckbox(), r(this.checkboxSelectionComp));
  }
  createCellEditorInstance(e, t, n) {
    const o = this.editorVersion, s = e.newAgStackInstance(), { params: i } = e;
    s.then((a) => this.afterCellEditorCreated(o, a, i, t, n)), st(this.cellEditor) && i.cellStartedEdit && this.cellCtrl.focusCell(!0);
  }
  insertValueWithoutCellRenderer(e) {
    const t = this.getParentOfValue();
    ht(t);
    const n = Ii(e);
    n != null && (t.textContent = n);
  }
  destroyRenderer() {
    const { context: e } = this.beans;
    this.cellRenderer = e.destroyBean(this.cellRenderer), nn(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
  }
  destroyEditor() {
    var n, o;
    const { context: e } = this.beans;
    (((n = this.cellEditorPopupWrapper) == null ? void 0 : n.getGui().contains(je(this.beans))) || this.cellCtrl.hasBrowserFocus()) && this.eCell.focus({ preventScroll: !0 }), (o = this.hideEditorPopup) == null || o.call(this), this.hideEditorPopup = void 0, this.cellEditor = e.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = e.destroyBean(this.cellEditorPopupWrapper), nn(this.cellEditorGui), this.cellCtrl.disableEditorTooltipFeature(), this.cellEditorGui = null, this.editorVersion++;
  }
  refreshCellRenderer(e) {
    var n;
    if (((n = this.cellRenderer) == null ? void 0 : n.refresh) == null || this.cellRendererClass !== e.componentClass)
      return !1;
    const t = this.cellRenderer.refresh(e.params);
    return t === !0 || t === void 0;
  }
  createCellRendererInstance(e) {
    var i;
    const t = this.rendererVersion, n = (r) => (a) => {
      if (this.rendererVersion !== t || !this.isAlive())
        return;
      const d = r.newAgStackInstance(), c = this.afterCellRendererCreated.bind(
        this,
        t,
        r.componentClass
      );
      d == null || d.then(c);
    }, { animationFrameSvc: o } = this.beans;
    let s;
    if (o != null && o.active && this.firstRender ? s = (r, a = !1) => {
      o.createTask(
        n(r),
        this.rowNode.rowIndex,
        "p2",
        r.componentFromFramework,
        a
      );
    } : s = (r) => n(r)(), (i = e.params) != null && i.deferRender && !this.cellCtrl.rowNode.group) {
      const { loadingComp: r, onReady: a } = this.cellCtrl.getDeferLoadingCellRenderer();
      r && (s(r), a.then(() => s(e, !0)));
    } else
      s(e);
  }
  afterCellRendererCreated(e, t, n) {
    if (!this.isAlive() || e !== this.rendererVersion) {
      this.beans.context.destroyBean(n);
      return;
    }
    this.cellRenderer = n, this.cellRendererClass = t;
    const s = n.getGui();
    if (this.cellRendererGui = s, s != null) {
      const i = this.getParentOfValue();
      ht(i), i.appendChild(s);
    }
  }
  afterCellEditorCreated(e, t, n, o, s) {
    var d;
    const i = e !== this.editorVersion, { context: r } = this.beans;
    if (i) {
      r.destroyBean(t);
      return;
    }
    if (t.isCancelBeforeStart && t.isCancelBeforeStart()) {
      r.destroyBean(t), this.cellCtrl.stopEditing(!0);
      return;
    }
    if (!t.getGui) {
      Z(97, { colId: this.column.getId() }), r.destroyBean(t);
      return;
    }
    this.cellEditor = t, this.cellEditorGui = t.getGui();
    const l = o || t.isPopup !== void 0 && t.isPopup();
    l ? this.addPopupCellEditor(n, s) : this.addInCellEditor(), this.refreshEditStyles(!0, l), (d = t.afterGuiAttached) == null || d.call(t), this.cellCtrl.enableEditorTooltipFeature(t), this.cellCtrl.cellEditorAttached();
  }
  refreshEditStyles(e, t) {
    const { cellCssManager: n } = this;
    n.toggleCss("ag-cell-inline-editing", e && !t), n.toggleCss("ag-cell-popup-editing", e && !!t), n.toggleCss("ag-cell-not-inline-editing", !e || !!t);
  }
  addInCellEditor() {
    const { eCell: e } = this;
    e.contains(je(this.beans)) && e.focus(), this.destroyRenderer(), this.refreshWrapper(!0), ht(this.getParentOfValue()), this.cellEditorGui && this.getParentOfValue().appendChild(this.cellEditorGui);
  }
  addPopupCellEditor(e, t) {
    var A;
    const { gos: n, context: o, popupSvc: s, editSvc: i } = this.beans;
    n.get("editType") === "fullRow" && Z(98);
    const r = this.cellEditorPopupWrapper = o.createBean(
      i.createPopupEditorWrapper(e)
    ), { cellEditor: a, cellEditorGui: l, eCell: d, rowNode: c, column: u, cellCtrl: h } = this, g = r.getGui();
    l && g.appendChild(l);
    const p = n.get("stopEditingWhenCellsLoseFocus"), f = t ?? ((A = a.getPopupPosition) == null ? void 0 : A.call(a)) ?? "over", m = n.get("enableRtl"), C = {
      ePopup: g,
      column: u,
      rowNode: c,
      type: "popupCellEditor",
      eventSource: d,
      position: f,
      alignSide: m ? "right" : "left",
      keepWithinBounds: !0
    }, w = s.positionPopupByComponent.bind(s, C), b = s.addPopup({
      modal: p,
      eChild: g,
      closeOnEsc: !0,
      closedCallback: () => {
        h.onPopupEditorClosed();
      },
      anchorToElement: d,
      positionCallback: w,
      ariaOwns: d
    });
    b && (this.hideEditorPopup = b.hideFunc);
  }
  detach() {
    this.eRow.removeChild(this.getGui());
  }
  // if the row is also getting destroyed, then we don't need to remove from dom,
  // as the row will also get removed, so no need to take out the cells from the row
  // if the row is going (removing is an expensive operation, so only need to remove
  // the top part)
  //
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroy() {
    this.destroyRenderer(), this.destroyEditor(), this.removeControls(), super.destroy();
  }
}, sD = class extends Te {
  constructor(e, t, n) {
    super(), this.cellComps = /* @__PURE__ */ new Map(), this.beans = t, this.rowCtrl = e;
    const o = Ue({ tag: "div", role: "row", attrs: { "comp-id": `${this.getCompId()}` } });
    this.setInitialStyle(o, n), this.setTemplateFromElement(o);
    const s = o.style;
    this.domOrder = this.rowCtrl.getDomOrder();
    const i = {
      setDomOrder: (r) => this.domOrder = r,
      setCellCtrls: (r) => this.setCellCtrls(r),
      showFullWidth: (r) => this.showFullWidth(r),
      getFullWidthCellRenderer: () => this.fullWidthCellRenderer,
      getFullWidthCellRendererParams: () => this.fullWidthCellRendererParams,
      toggleCss: (r, a) => this.toggleCss(r, a),
      setUserStyles: (r) => Ya(o, r),
      setTop: (r) => s.top = r,
      setTransform: (r) => s.transform = r,
      setRowIndex: (r) => o.setAttribute("row-index", r),
      setRowId: (r) => o.setAttribute("row-id", r),
      setRowBusinessKey: (r) => o.setAttribute("row-business-key", r),
      refreshFullWidth: (r) => {
        var l, d;
        const a = r();
        return this.fullWidthCellRendererParams = a, ((d = (l = this.fullWidthCellRenderer) == null ? void 0 : l.refresh) == null ? void 0 : d.call(l, a)) ?? !1;
      }
    };
    e.setComp(i, this.getGui(), n, void 0), this.addDestroyFunc(() => {
      e.unsetComp(n);
    });
  }
  setInitialStyle(e, t) {
    const n = this.rowCtrl.getInitialTransform(t);
    if (n)
      e.style.setProperty("transform", n);
    else {
      const o = this.rowCtrl.getInitialRowTop(t);
      o && e.style.setProperty("top", o);
    }
  }
  showFullWidth(e) {
    const t = (o) => {
      if (this.isAlive()) {
        const s = o.getGui();
        this.getGui().appendChild(s), this.rowCtrl.setupDetailRowAutoHeight(s), this.setFullWidthRowComp(o, e.params);
      } else
        this.beans.context.destroyBean(o);
    };
    e.newAgStackInstance().then(t);
  }
  setCellCtrls(e) {
    const t = new Map(this.cellComps);
    for (const n of e) {
      const o = n.instanceId;
      this.cellComps.has(o) ? t.delete(o) : this.newCellComp(n);
    }
    this.destroyCells(t), this.ensureDomOrder(e);
  }
  ensureDomOrder(e) {
    if (!this.domOrder)
      return;
    const t = [];
    for (const n of e) {
      const o = this.cellComps.get(n.instanceId);
      o && t.push(o.getGui());
    }
    fC(this.getGui(), t);
  }
  newCellComp(e) {
    var o;
    const t = ((o = this.beans.editSvc) == null ? void 0 : o.isEditing(e, { withOpenEditor: !0 })) ?? !1, n = new oD(this.beans, e, this.rowCtrl.printLayout, this.getGui(), t);
    this.cellComps.set(e.instanceId, n), this.getGui().appendChild(n.getGui());
  }
  destroy() {
    super.destroy(), this.destroyCells(this.cellComps);
  }
  setFullWidthRowComp(e, t) {
    this.fullWidthCellRenderer = e, this.fullWidthCellRendererParams = t, this.addDestroyFunc(() => {
      this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer), this.fullWidthCellRendererParams = void 0;
    });
  }
  destroyCells(e) {
    for (const t of e.values()) {
      if (!t)
        return;
      const n = t.cellCtrl.instanceId;
      if (this.cellComps.get(n) !== t)
        return;
      t.detach(), t.destroy(), this.cellComps.delete(n);
    }
  }
};
function iD(e, t, n) {
  const o = !!n.gos.get("enableCellSpan") && !!t.getSpannedRowCtrls, s = {
    tag: "div",
    ref: "eContainer",
    cls: Jl(e),
    role: "rowgroup"
  };
  if (t.type === "center" || o) {
    const i = {
      tag: "div",
      ref: "eSpannedContainer",
      cls: `ag-spanning-container ${OI(e)}`,
      role: "presentation"
    };
    return s.role = "presentation", {
      tag: "div",
      ref: "eViewport",
      cls: `ag-viewport ${Ow(e)}`,
      role: "rowgroup",
      children: [s, o ? i : null]
    };
  }
  return s;
}
var rD = class extends Te {
  constructor(e) {
    super(), this.eViewport = X, this.eContainer = X, this.eSpannedContainer = X, this.rowCompsNoSpan = {}, this.rowCompsWithSpan = {}, this.name = e == null ? void 0 : e.name, this.options = el(this.name);
  }
  postConstruct() {
    this.setTemplate(iD(this.name, this.options, this.beans));
    const e = {
      setHorizontalScroll: (n) => this.eViewport.scrollLeft = n,
      setViewportHeight: (n) => this.eViewport.style.height = n,
      setRowCtrls: ({ rowCtrls: n }) => this.setRowCtrls(n),
      setSpannedRowCtrls: (n) => this.setRowCtrls(n, !0),
      setDomOrder: (n) => {
        this.domOrder = n;
      },
      setContainerWidth: (n) => {
        this.eContainer.style.width = n, this.eSpannedContainer && (this.eSpannedContainer.style.width = n);
      },
      setOffsetTop: (n) => {
        const o = `translateY(${n})`;
        this.eContainer.style.transform = o, this.eSpannedContainer && (this.eSpannedContainer.style.transform = o);
      }
    };
    this.createManagedBean(new KI(this.name)).setComp(e, this.eContainer, this.eSpannedContainer, this.eViewport);
  }
  destroy() {
    this.setRowCtrls([]), this.setRowCtrls([], !0), super.destroy(), this.lastPlacedElement = null;
  }
  setRowCtrls(e, t) {
    const { beans: n, options: o } = this, s = t ? this.eSpannedContainer : this.eContainer, i = t ? { ...this.rowCompsWithSpan } : { ...this.rowCompsNoSpan }, r = {};
    t ? this.rowCompsWithSpan = r : this.rowCompsNoSpan = r, this.lastPlacedElement = null;
    const a = [];
    for (const l of e) {
      const d = l.instanceId, c = i[d];
      let u;
      if (c)
        u = c, delete i[d];
      else {
        if (!l.rowNode.displayed)
          continue;
        u = new sD(l, n, o.type);
      }
      r[d] = u, a.push([u, !c]);
    }
    this.removeOldRows(Object.values(i), s), this.addRowNodes(a, s);
  }
  addRowNodes(e, t) {
    const { domOrder: n } = this;
    for (const [o, s] of e) {
      const i = o.getGui();
      n ? this.ensureDomOrder(i, t) : s && t.appendChild(i);
    }
  }
  removeOldRows(e, t) {
    for (const n of e)
      t.removeChild(n.getGui()), n.destroy();
  }
  ensureDomOrder(e, t) {
    pC(t, e, this.lastPlacedElement), this.lastPlacedElement = e;
  }
}, aD = {
  selector: "AG-ROW-CONTAINER",
  component: rD
};
function zr(e, t) {
  return t.map((n) => {
    const o = `e${n[0].toUpperCase() + n.substring(1)}RowContainer`;
    return e[o] = { name: n }, {
      tag: "ag-row-container",
      ref: o,
      attrs: { name: n }
    };
  });
}
function lD(e) {
  const t = {}, n = {
    tag: "div",
    ref: "eGridRoot",
    cls: "ag-root ag-unselectable",
    children: [
      { tag: "ag-header-root" },
      {
        tag: "div",
        ref: "eTop",
        cls: "ag-floating-top",
        role: "presentation",
        children: zr(t, ["topLeft", "topCenter", "topRight", "topFullWidth"])
      },
      {
        tag: "div",
        ref: "eBody",
        cls: "ag-body",
        role: "presentation",
        children: [
          {
            tag: "div",
            ref: "eBodyViewport",
            cls: "ag-body-viewport",
            role: "presentation",
            children: zr(t, ["left", "center", "right", "fullWidth"])
          },
          { tag: "ag-fake-vertical-scroll" }
        ]
      },
      {
        tag: "div",
        ref: "eStickyTop",
        cls: "ag-sticky-top",
        role: "presentation",
        children: zr(t, [
          "stickyTopLeft",
          "stickyTopCenter",
          "stickyTopRight",
          "stickyTopFullWidth"
        ])
      },
      {
        tag: "div",
        ref: "eStickyBottom",
        cls: "ag-sticky-bottom",
        role: "presentation",
        children: zr(t, [
          "stickyBottomLeft",
          "stickyBottomCenter",
          "stickyBottomRight",
          "stickyBottomFullWidth"
        ])
      },
      {
        tag: "div",
        ref: "eBottom",
        cls: "ag-floating-bottom",
        role: "presentation",
        children: zr(t, [
          "bottomLeft",
          "bottomCenter",
          "bottomRight",
          "bottomFullWidth"
        ])
      },
      { tag: "ag-fake-horizontal-scroll" },
      e ? { tag: "ag-overlay-wrapper" } : null
    ]
  };
  return { paramsMap: t, elementParams: n };
}
var dD = class extends Te {
  constructor() {
    super(...arguments), this.eGridRoot = X, this.eBodyViewport = X, this.eStickyTop = X, this.eStickyBottom = X, this.eTop = X, this.eBottom = X, this.eBody = X;
  }
  postConstruct() {
    const { overlays: e, rangeSvc: t } = this.beans, n = e == null ? void 0 : e.getOverlayWrapperSelector(), { paramsMap: o, elementParams: s } = lD(!!n);
    this.setTemplate(
      s,
      [
        ...n ? [n] : [],
        XI,
        nP,
        nD,
        aD
      ],
      o
    );
    const i = (a, l) => {
      const d = `${a}px`;
      l.style.minHeight = d, l.style.height = d;
    }, r = {
      setRowAnimationCssOnBodyViewport: (a, l) => this.setRowAnimationCssOnBodyViewport(a, l),
      setColumnCount: (a) => s3(this.getGui(), a),
      setRowCount: (a) => n3(this.getGui(), a),
      setTopHeight: (a) => i(a, this.eTop),
      setBottomHeight: (a) => i(a, this.eBottom),
      setTopInvisible: (a) => this.eTop.classList.toggle("ag-invisible", a),
      setBottomInvisible: (a) => this.eBottom.classList.toggle("ag-invisible", a),
      setStickyTopHeight: (a) => this.eStickyTop.style.height = a,
      setStickyTopTop: (a) => this.eStickyTop.style.top = a,
      setStickyTopWidth: (a) => this.eStickyTop.style.width = a,
      setStickyBottomHeight: (a) => {
        this.eStickyBottom.style.height = a, this.eStickyBottom.classList.toggle("ag-invisible", a === "0px");
      },
      setStickyBottomBottom: (a) => this.eStickyBottom.style.bottom = a,
      setStickyBottomWidth: (a) => this.eStickyBottom.style.width = a,
      setColumnMovingCss: (a, l) => this.toggleCss(a, l),
      updateLayoutClasses: (a, l) => {
        const d = [this.eBodyViewport.classList, this.eBody.classList];
        for (const c of d)
          c.toggle(Qn.AUTO_HEIGHT, l.autoHeight), c.toggle(Qn.NORMAL, l.normal), c.toggle(Qn.PRINT, l.print);
        this.toggleCss(Qn.AUTO_HEIGHT, l.autoHeight), this.toggleCss(Qn.NORMAL, l.normal), this.toggleCss(Qn.PRINT, l.print);
      },
      setAlwaysVerticalScrollClass: (a, l) => this.eBodyViewport.classList.toggle(Vw, l),
      registerBodyViewportResizeListener: (a) => {
        const l = Bo(this.beans, this.eBodyViewport, a);
        this.addDestroyFunc(() => l());
      },
      setPinnedTopBottomOverflowY: (a) => this.eTop.style.overflowY = this.eBottom.style.overflowY = a,
      setCellSelectableCss: (a, l) => {
        [this.eTop, this.eBodyViewport, this.eBottom].forEach(
          (d) => d.classList.toggle(a, l)
        );
      },
      setBodyViewportWidth: (a) => this.eBodyViewport.style.width = a,
      setGridRootRole: (a) => hn(this.eGridRoot, a)
    };
    this.ctrl = this.createManagedBean(new jI()), this.ctrl.setComp(
      r,
      this.getGui(),
      this.eBodyViewport,
      this.eTop,
      this.eBottom,
      this.eStickyTop,
      this.eStickyBottom
    ), (t && Xo(this.gos) || es(this.gos)) && t3(this.getGui(), !0);
  }
  setRowAnimationCssOnBodyViewport(e, t) {
    const n = this.eBodyViewport.classList;
    n.toggle("ag-row-animation", t), n.toggle("ag-row-no-animation", !t);
  }
}, cD = {
  selector: "AG-GRID-BODY",
  component: dD
}, uD = class extends U {
  constructor() {
    super(...arguments), this.additionalFocusableContainers = /* @__PURE__ */ new Set();
  }
  setComp(e, t, n) {
    this.view = e, this.eGridHostDiv = t, this.eGui = n, this.eGui.setAttribute("grid-id", this.beans.context.getId());
    const { dragAndDrop: o, ctrlsSvc: s } = this.beans;
    o == null || o.registerGridDropTarget(() => this.eGui, this), this.createManagedBean(new wp(this.view)), this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
    const i = Bo(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
    this.addDestroyFunc(() => i()), s.register("gridCtrl", this);
  }
  isDetailGrid() {
    var t;
    const e = cp(this.getGui());
    return ((t = e == null ? void 0 : e.getAttribute("row-id")) == null ? void 0 : t.startsWith("detail")) || !1;
  }
  getOptionalSelectors() {
    var t, n, o, s, i;
    const e = this.beans;
    return {
      paginationSelector: (t = e.pagination) == null ? void 0 : t.getPaginationSelector(),
      gridHeaderDropZonesSelector: (n = e.registry) == null ? void 0 : n.getSelector("AG-GRID-HEADER-DROP-ZONES"),
      sideBarSelector: (o = e.sideBar) == null ? void 0 : o.getSelector(),
      statusBarSelector: (s = e.registry) == null ? void 0 : s.getSelector("AG-STATUS-BAR"),
      watermarkSelector: (i = e.licenseManager) == null ? void 0 : i.getWatermarkSelector()
    };
  }
  onGridSizeChanged() {
    this.eventSvc.dispatchEvent({
      type: "gridSizeChanged",
      clientWidth: this.eGridHostDiv.clientWidth,
      clientHeight: this.eGridHostDiv.clientHeight
    });
  }
  destroyGridUi() {
    this.view.destroyGridUi();
  }
  getGui() {
    return this.eGui;
  }
  setResizeCursor(e) {
    const { view: t } = this;
    if (e === !1)
      t.setCursor(null);
    else {
      const n = e === 1 ? "ew-resize" : "ns-resize";
      t.setCursor(n);
    }
  }
  disableUserSelect(e) {
    this.view.setUserSelect(e ? "none" : null);
  }
  focusNextInnerContainer(e) {
    const t = this.getFocusableContainers(), { indexWithFocus: n, nextIndex: o } = this.getNextFocusableIndex(t, e);
    if (o < 0 || o >= t.length)
      return !1;
    if (o === 0) {
      if (n > 0) {
        const { visibleCols: s, focusSvc: i } = this.beans, r = s.allCols, a = Je(r);
        if (i.focusGridView({ column: a, backwards: !0 }))
          return !0;
      }
      return !1;
    }
    return this.focusContainer(t[o], e);
  }
  focusInnerElement(e) {
    const t = this.gos.getCallback("focusGridInnerElement");
    if (t && t({ fromBottom: !!e }))
      return !0;
    const n = this.getFocusableContainers(), { focusSvc: o, visibleCols: s } = this.beans, i = s.allCols;
    if (e) {
      if (n.length > 1)
        return this.focusContainer(Je(n), e);
      const r = Je(i);
      if (o.focusGridView({ column: r, backwards: e }))
        return !0;
    }
    if (this.gos.get("headerHeight") === 0 || ci(this.beans)) {
      if (o.focusGridView({ column: i[0], backwards: e }))
        return !0;
      for (let r = 1; r < n.length; r++)
        if (pn(n[r].getGui(), e))
          return !0;
      return !1;
    }
    return o.focusFirstHeader();
  }
  forceFocusOutOfContainer(e = !1) {
    this.view.forceFocusOutOfContainer(e);
  }
  addFocusableContainer(e) {
    this.additionalFocusableContainers.add(e);
  }
  removeFocusableContainer(e) {
    this.additionalFocusableContainers.delete(e);
  }
  allowFocusForNextCoreContainer(e) {
    var i;
    const t = this.view.getFocusableContainers(), { nextIndex: n, indexWithFocus: o } = this.getNextFocusableIndex(t, e);
    if (o === -1 || n < 0 || n >= t.length)
      return;
    const s = t[n];
    (i = s.setAllowFocus) == null || i.call(s, !0), setTimeout(() => {
      var r;
      (r = s.setAllowFocus) == null || r.call(s, !1);
    });
  }
  isFocusable() {
    var t, n;
    const e = this.beans;
    return !xc(e) || !ci(e) || !!((n = (t = e.sideBar) == null ? void 0 : t.comp) != null && n.isDisplayed());
  }
  getNextFocusableIndex(e, t) {
    const n = je(this.beans), o = e.findIndex((i) => i.getGui().contains(n)), s = o + (t ? -1 : 1);
    return {
      indexWithFocus: o,
      nextIndex: s
    };
  }
  focusContainer(e, t) {
    var o, s;
    (o = e.setAllowFocus) == null || o.call(e, !0);
    const n = pn(e.getGui(), t, !1, !0);
    return (s = e.setAllowFocus) == null || s.call(e, !1), n;
  }
  getFocusableContainers() {
    return [...this.view.getFocusableContainers(), ...this.additionalFocusableContainers];
  }
  destroy() {
    this.additionalFocusableContainers.clear(), super.destroy();
  }
}, hD = class extends Ti {
  constructor(e) {
    super(), this.gridBody = X, this.sideBar = X, this.pagination = X, this.rootWrapperBody = X, this.eGridDiv = e;
  }
  postConstruct() {
    const e = {
      destroyGridUi: () => this.destroyBean(this),
      setRtlClass: (i) => this.addCss(i),
      forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
      updateLayoutClasses: this.updateLayoutClasses.bind(this),
      getFocusableContainers: this.getFocusableContainers.bind(this),
      setUserSelect: (i) => {
        this.getGui().style.userSelect = i ?? "", this.getGui().style.webkitUserSelect = i ?? "";
      },
      setCursor: (i) => {
        this.getGui().style.cursor = i ?? "";
      }
    }, t = this.createManagedBean(new uD()), n = t.getOptionalSelectors(), o = this.createTemplate(n), s = [cD, ...Object.values(n).filter((i) => !!i)];
    this.setTemplate(o, s), t.setComp(e, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
      // we want to override the default behaviour to do nothing for onTabKeyDown
      onTabKeyDown: () => {
      },
      focusInnerElement: (i) => t.focusInnerElement(i),
      forceFocusOutWhenTabGuardsAreEmpty: !0,
      isEmpty: () => !t.isFocusable()
    });
  }
  insertGridIntoDom() {
    const e = this.getGui();
    this.eGridDiv.appendChild(e), this.addDestroyFunc(() => {
      this.eGridDiv.removeChild(e), Is(this.gos, "Grid removed from DOM");
    });
  }
  updateLayoutClasses(e, t) {
    const n = this.rootWrapperBody.classList, { AUTO_HEIGHT: o, NORMAL: s, PRINT: i } = Qn, { autoHeight: r, normal: a, print: l } = t;
    n.toggle(o, r), n.toggle(s, a), n.toggle(i, l), this.toggleCss(o, r), this.toggleCss(s, a), this.toggleCss(i, l);
  }
  createTemplate(e) {
    const t = e.gridHeaderDropZonesSelector ? { tag: "ag-grid-header-drop-zones" } : null, n = e.sideBarSelector ? {
      tag: "ag-side-bar",
      ref: "sideBar"
    } : null, o = e.statusBarSelector ? { tag: "ag-status-bar" } : null, s = e.watermarkSelector ? { tag: "ag-watermark" } : null, i = e.paginationSelector ? { tag: "ag-pagination", ref: "pagination" } : null;
    return {
      tag: "div",
      cls: "ag-root-wrapper",
      role: "presentation",
      children: [
        t,
        {
          tag: "div",
          ref: "rootWrapperBody",
          cls: "ag-root-wrapper-body",
          role: "presentation",
          children: [{ tag: "ag-grid-body", ref: "gridBody" }, n]
        },
        o,
        i,
        s
      ]
    };
  }
  getFocusableElement() {
    return this.rootWrapperBody;
  }
  forceFocusOutOfContainer(e = !1) {
    var t;
    if (!e && ((t = this.pagination) != null && t.isDisplayed())) {
      this.pagination.forceFocusOutOfContainer(e);
      return;
    }
    super.forceFocusOutOfContainer(e);
  }
  getFocusableContainers() {
    const e = [this.gridBody];
    return [this.sideBar, this.pagination].forEach((t) => {
      t && e.push(t);
    }), e.filter((t) => vn(t.getGui()));
  }
}, ze = (e, t) => {
  for (const n of Object.keys(t))
    t[n] = e;
  return t;
}, Gm = {
  dispatchEvent: "CommunityCore",
  // this is always registered
  ...ze("CommunityCore", {
    destroy: 0,
    getGridId: 0,
    getGridOption: 0,
    isDestroyed: 0,
    setGridOption: 0,
    updateGridOptions: 0,
    isModuleRegistered: 0
  }),
  ...ze("GridState", {
    getState: 0,
    setState: 0
  }),
  ...ze("SharedRowSelection", {
    setNodesSelected: 0,
    selectAll: 0,
    deselectAll: 0,
    selectAllFiltered: 0,
    deselectAllFiltered: 0,
    selectAllOnCurrentPage: 0,
    deselectAllOnCurrentPage: 0,
    getSelectedNodes: 0,
    getSelectedRows: 0
  }),
  ...ze("RowApi", {
    redrawRows: 0,
    setRowNodeExpanded: 0,
    getRowNode: 0,
    addRenderedRowListener: 0,
    getRenderedNodes: 0,
    forEachNode: 0,
    getFirstDisplayedRowIndex: 0,
    getLastDisplayedRowIndex: 0,
    getDisplayedRowAtIndex: 0,
    getDisplayedRowCount: 0
  }),
  ...ze("ScrollApi", {
    getVerticalPixelRange: 0,
    getHorizontalPixelRange: 0,
    ensureColumnVisible: 0,
    ensureIndexVisible: 0,
    ensureNodeVisible: 0
  }),
  ...ze("KeyboardNavigation", {
    getFocusedCell: 0,
    clearFocusedCell: 0,
    setFocusedCell: 0,
    tabToNextCell: 0,
    tabToPreviousCell: 0,
    setFocusedHeader: 0
  }),
  ...ze("EventApi", {
    addEventListener: 0,
    addGlobalListener: 0,
    removeEventListener: 0,
    removeGlobalListener: 0
  }),
  ...ze("ValueCache", {
    expireValueCache: 0
  }),
  ...ze("CellApi", {
    getCellValue: 0
  }),
  ...ze("SharedMenu", {
    showColumnMenu: 0,
    hidePopupMenu: 0
  }),
  ...ze("Sort", {
    onSortChanged: 0
  }),
  ...ze("PinnedRow", {
    getPinnedTopRowCount: 0,
    getPinnedBottomRowCount: 0,
    getPinnedTopRow: 0,
    getPinnedBottomRow: 0,
    forEachPinnedRow: 0
  }),
  ...ze("Overlay", {
    showLoadingOverlay: 0,
    showNoRowsOverlay: 0,
    hideOverlay: 0
  }),
  ...ze("RenderApi", {
    setGridAriaProperty: 0,
    refreshCells: 0,
    refreshHeader: 0,
    isAnimationFrameQueueEmpty: 0,
    flushAllAnimationFrames: 0,
    getSizesForCurrentTheme: 0,
    getCellRendererInstances: 0
  }),
  ...ze("HighlightChanges", {
    flashCells: 0
  }),
  ...ze("RowDrag", {
    addRowDropZone: 0,
    removeRowDropZone: 0,
    getRowDropZoneParams: 0,
    getRowDropPositionIndicator: 0,
    setRowDropPositionIndicator: 0
  }),
  ...ze("ColumnApi", {
    getColumnDefs: 0,
    getColumnDef: 0,
    getDisplayNameForColumn: 0,
    getColumn: 0,
    getColumns: 0,
    applyColumnState: 0,
    getColumnState: 0,
    resetColumnState: 0,
    isPinning: 0,
    isPinningLeft: 0,
    isPinningRight: 0,
    getDisplayedColAfter: 0,
    getDisplayedColBefore: 0,
    setColumnsVisible: 0,
    setColumnsPinned: 0,
    getAllGridColumns: 0,
    getDisplayedLeftColumns: 0,
    getDisplayedCenterColumns: 0,
    getDisplayedRightColumns: 0,
    getAllDisplayedColumns: 0,
    getAllDisplayedVirtualColumns: 0
  }),
  ...ze("ColumnAutoSize", {
    sizeColumnsToFit: 0,
    autoSizeColumns: 0,
    autoSizeAllColumns: 0
  }),
  ...ze("ColumnGroup", {
    setColumnGroupOpened: 0,
    getColumnGroup: 0,
    getProvidedColumnGroup: 0,
    getDisplayNameForColumnGroup: 0,
    getColumnGroupState: 0,
    setColumnGroupState: 0,
    resetColumnGroupState: 0,
    getLeftDisplayedColumnGroups: 0,
    getCenterDisplayedColumnGroups: 0,
    getRightDisplayedColumnGroups: 0,
    getAllDisplayedColumnGroups: 0
  }),
  ...ze("ColumnMove", {
    moveColumnByIndex: 0,
    moveColumns: 0
  }),
  ...ze("ColumnResize", {
    setColumnWidths: 0
  }),
  ...ze("ColumnHover", {
    isColumnHovered: 0
  }),
  ...ze("EditCore", {
    getCellEditorInstances: 0,
    getEditingCells: 0,
    getEditRowValues: 0,
    stopEditing: 0,
    startEditingCell: 0,
    isEditing: 0,
    validateEdit: 0
  }),
  ...ze("BatchEdit", {
    startBatchEdit: 0,
    cancelBatchEdit: 0,
    commitBatchEdit: 0,
    isBatchEditing: 0
  }),
  ...ze("UndoRedoEdit", {
    undoCellEditing: 0,
    redoCellEditing: 0,
    getCurrentUndoSize: 0,
    getCurrentRedoSize: 0
  }),
  ...ze("FilterCore", {
    isAnyFilterPresent: 0,
    onFilterChanged: 0
  }),
  ...ze("ColumnFilter", {
    isColumnFilterPresent: 0,
    getColumnFilterInstance: 0,
    destroyFilter: 0,
    setFilterModel: 0,
    getFilterModel: 0,
    getColumnFilterModel: 0,
    setColumnFilterModel: 0,
    showColumnFilter: 0,
    hideColumnFilter: 0,
    getColumnFilterHandler: 0,
    doFilterAction: 0
  }),
  ...ze("QuickFilter", {
    isQuickFilterPresent: 0,
    getQuickFilter: 0,
    resetQuickFilter: 0
  }),
  ...ze("Find", {
    findGetActiveMatch: 0,
    findGetTotalMatches: 0,
    findGoTo: 0,
    findNext: 0,
    findPrevious: 0,
    findGetNumMatches: 0,
    findGetParts: 0,
    findClearActive: 0,
    findRefresh: 0
  }),
  ...ze("Pagination", {
    paginationIsLastPageFound: 0,
    paginationGetPageSize: 0,
    paginationGetCurrentPage: 0,
    paginationGetTotalPages: 0,
    paginationGetRowCount: 0,
    paginationGoToNextPage: 0,
    paginationGoToPreviousPage: 0,
    paginationGoToFirstPage: 0,
    paginationGoToLastPage: 0,
    paginationGoToPage: 0
  }),
  ...ze("CsrmSsrmSharedApi", {
    expandAll: 0,
    collapseAll: 0
  }),
  ...ze("SsrmInfiniteSharedApi", {
    setRowCount: 0,
    getCacheBlockState: 0,
    isLastRowIndexKnown: 0
  }),
  ...ze("ClientSideRowModelApi", {
    onGroupExpandedOrCollapsed: 0,
    refreshClientSideRowModel: 0,
    isRowDataEmpty: 0,
    forEachLeafNode: 0,
    forEachNodeAfterFilter: 0,
    forEachNodeAfterFilterAndSort: 0,
    applyTransaction: 0,
    applyTransactionAsync: 0,
    flushAsyncTransactions: 0,
    getBestCostNodeSelection: 0,
    onRowHeightChanged: 0,
    resetRowHeights: 0
  }),
  ...ze("CsvExport", {
    getDataAsCsv: 0,
    exportDataAsCsv: 0
  }),
  ...ze("InfiniteRowModel", {
    refreshInfiniteCache: 0,
    purgeInfiniteCache: 0,
    getInfiniteRowCount: 0
  }),
  ...ze("AdvancedFilter", {
    getAdvancedFilterModel: 0,
    setAdvancedFilterModel: 0,
    showAdvancedFilterBuilder: 0,
    hideAdvancedFilterBuilder: 0
  }),
  ...ze("IntegratedCharts", {
    getChartModels: 0,
    getChartRef: 0,
    getChartImageDataURL: 0,
    downloadChart: 0,
    openChartToolPanel: 0,
    closeChartToolPanel: 0,
    createRangeChart: 0,
    createPivotChart: 0,
    createCrossFilterChart: 0,
    updateChart: 0,
    restoreChart: 0
  }),
  ...ze("Clipboard", {
    copyToClipboard: 0,
    cutToClipboard: 0,
    copySelectedRowsToClipboard: 0,
    copySelectedRangeToClipboard: 0,
    copySelectedRangeDown: 0,
    pasteFromClipboard: 0
  }),
  ...ze("ExcelExport", {
    getDataAsExcel: 0,
    exportDataAsExcel: 0,
    getSheetDataForExcel: 0,
    getMultipleSheetsAsExcel: 0,
    exportMultipleSheetsAsExcel: 0
  }),
  ...ze("SharedMasterDetail", {
    addDetailGridInfo: 0,
    removeDetailGridInfo: 0,
    getDetailGridInfo: 0,
    forEachDetailGridInfo: 0
  }),
  ...ze("ContextMenu", {
    showContextMenu: 0
  }),
  ...ze("ColumnMenu", {
    showColumnChooser: 0,
    hideColumnChooser: 0
  }),
  ...ze("CellSelection", {
    getCellRanges: 0,
    addCellRange: 0,
    clearRangeSelection: 0,
    clearCellSelection: 0
  }),
  ...ze("SharedRowGrouping", {
    setRowGroupColumns: 0,
    removeRowGroupColumns: 0,
    addRowGroupColumns: 0,
    getRowGroupColumns: 0,
    moveRowGroupColumn: 0
  }),
  ...ze("SharedAggregation", {
    addAggFuncs: 0,
    clearAggFuncs: 0,
    setColumnAggFunc: 0
  }),
  ...ze("SharedPivot", {
    isPivotMode: 0,
    getPivotResultColumn: 0,
    setValueColumns: 0,
    getValueColumns: 0,
    removeValueColumns: 0,
    addValueColumns: 0,
    setPivotColumns: 0,
    removePivotColumns: 0,
    addPivotColumns: 0,
    getPivotColumns: 0,
    setPivotResultColumns: 0,
    getPivotResultColumns: 0
  }),
  ...ze("ServerSideRowModelApi", {
    getServerSideSelectionState: 0,
    setServerSideSelectionState: 0,
    applyServerSideTransaction: 0,
    applyServerSideTransactionAsync: 0,
    applyServerSideRowData: 0,
    retryServerSideLoads: 0,
    flushServerSideAsyncTransactions: 0,
    refreshServerSide: 0,
    getServerSideGroupLevelState: 0,
    onRowHeightChanged: 0,
    resetRowHeights: 0
  }),
  ...ze("SideBar", {
    isSideBarVisible: 0,
    setSideBarVisible: 0,
    setSideBarPosition: 0,
    openToolPanel: 0,
    closeToolPanel: 0,
    getOpenedToolPanel: 0,
    refreshToolPanel: 0,
    isToolPanelShowing: 0,
    getToolPanelInstance: 0,
    getSideBar: 0
  }),
  ...ze("StatusBar", {
    getStatusPanel: 0
  })
}, Ru = {
  isDestroyed: () => !0,
  destroy() {
  },
  preConstruct() {
  },
  postConstruct() {
  },
  preWireBeans() {
  },
  wireBeans() {
  }
}, gD = (e, t) => e.eventSvc.dispatchEvent(t), ny = class {
};
Reflect.defineProperty(ny, "name", { value: "GridApi" });
var pD = class extends U {
  constructor() {
    super(), this.beanName = "apiFunctionSvc", this.api = new ny(), this.fns = {
      ...Ru,
      // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
      dispatchEvent: gD
    }, this.preDestroyLink = "";
    const { api: e } = this;
    for (const t of Object.keys(Gm))
      e[t] = this.makeApi(t)[t];
  }
  postConstruct() {
    this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
  }
  addFunction(e, t) {
    var s;
    const { fns: n, beans: o } = this;
    n !== Ru && (n[e] = ((s = o == null ? void 0 : o.validation) == null ? void 0 : s.validateApiFunction(e, t)) ?? t);
  }
  makeApi(e) {
    return {
      [e]: (...t) => {
        const {
          beans: n,
          fns: { [e]: o }
        } = this;
        return o ? o(n, ...t) : this.apiNotFound(e);
      }
    };
  }
  apiNotFound(e) {
    const { beans: t, gos: n, preDestroyLink: o } = this;
    if (!t)
      Z(26, { fnName: e, preDestroyLink: o });
    else {
      const s = Gm[e];
      n.assertModuleRegistered(s, `api.${e}`) && Z(27, { fnName: e, module: s });
    }
  }
  destroy() {
    super.destroy(), this.fns = Ru, this.beans = null;
  }
};
function fD(e) {
  return e.context.getId();
}
function mD(e) {
  e.gridDestroySvc.destroy();
}
function vD(e) {
  return e.gridDestroySvc.destroyCalled;
}
function CD(e, t) {
  return e.gos.get(t);
}
function wD(e, t, n) {
  oy(e, { [t]: n });
}
function oy(e, t) {
  e.gos.updateGridOptions({ options: t });
}
function yD(e, t) {
  const n = t.replace(/Module$/, "");
  return e.gos.isModuleRegistered(n);
}
var bD = { tag: "div", cls: "ag-drag-handle ag-row-drag", attrs: { draggable: "true" } }, SD = class extends Te {
  constructor(e, t, n) {
    super(bD), this.rowNode = e, this.column = t, this.eCell = n;
  }
  postConstruct() {
    this.getGui().appendChild(Le("rowDrag", this.beans, null)), this.addGuiEventListener("mousedown", (t) => {
      t.stopPropagation();
    }), this.addDragSource(), this.checkVisibility();
  }
  addDragSource() {
    this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
  }
  onDragStart(e) {
    const { rowNode: t, column: n, eCell: o, gos: s } = this, i = n.getColDef().dndSourceOnRowDrag, r = e.dataTransfer;
    if (r.setDragImage(o, 0, 0), i) {
      const a = ke(s, {
        rowNode: t,
        dragEvent: e
      });
      i(a);
    } else
      try {
        const a = JSON.stringify(t.data);
        r.setData("application/json", a), r.setData("text/plain", a);
      } catch {
      }
  }
  checkVisibility() {
    const e = this.column.isDndSource(this.rowNode);
    this.setDisplayed(e);
  }
};
function xD(e, t) {
  var n, o;
  (o = (n = e.rowDragSvc) == null ? void 0 : n.rowDragFeature) == null || o.addRowDropZone(t);
}
function RD(e, t) {
  var o, s;
  const n = (o = e.dragAndDrop) == null ? void 0 : o.findExternalZone(t.getContainer());
  n && ((s = e.dragAndDrop) == null || s.removeDropTarget(n));
}
function ED(e, t) {
  var n, o;
  return (o = (n = e.rowDragSvc) == null ? void 0 : n.rowDragFeature) == null ? void 0 : o.getRowDropZone(t);
}
function AD(e) {
  const t = e.rowDropHighlightSvc;
  return t ? { row: t.row, dropIndicatorPosition: t.position } : { row: null, dropIndicatorPosition: "none" };
}
function FD(e, t) {
  const n = e.rowDropHighlightSvc;
  if (!n)
    return;
  const o = t == null ? void 0 : t.row;
  let s = t == null ? void 0 : t.dropIndicatorPosition;
  s !== "above" && s !== "below" && s !== "inside" && (s = "none");
  const i = o == null ? void 0 : o.rowIndex;
  i == null || s === "none" ? n.clear() : n.set(o, s);
}
var MD = class extends oI {
  shouldPreventMouseEvent(e) {
    return this.gos.get("enableCellTextSelection") && super.shouldPreventMouseEvent(e);
  }
}, ID = class extends U {
  constructor() {
    super(...arguments), this.beanName = "horizontalResizeSvc";
  }
  addResizeBar(e) {
    const t = {
      dragStartPixels: e.dragStartPixels || 0,
      eElement: e.eResizeBar,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this, e),
      onDragging: this.onDragging.bind(this, e),
      onDragCancel: this.onDragStop.bind(this, e),
      includeTouch: !0,
      stopPropagationForTouch: !0
    }, { dragSvc: n } = this.beans;
    return n.addDragSource(t), () => n.removeDragSource(t);
  }
  onDragStart(e, t) {
    this.dragStartX = t.clientX, this.setResizeIcons();
    const n = t instanceof MouseEvent && t.shiftKey === !0;
    e.onResizeStart(n);
  }
  setResizeIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(
      1
      /* Horizontal */
    ), e.disableUserSelect(!0);
  }
  onDragStop(e) {
    e.onResizeEnd(this.resizeAmount), this.resetIcons();
  }
  resetIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(!1), e.disableUserSelect(!1);
  }
  onDragging(e, t) {
    this.resizeAmount = t.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
  }
}, PD = {
  tag: "div",
  cls: "ag-drag-handle ag-row-drag",
  attrs: { "aria-hidden": "true" }
}, DD = class extends Te {
  constructor(e, t, n, o, s, i = !1) {
    super(), this.cellValueFn = e, this.rowNode = t, this.column = n, this.customGui = o, this.dragStartPixels = s, this.alwaysVisible = i, this.dragSource = null;
  }
  isCustomGui() {
    return this.customGui != null;
  }
  postConstruct() {
    const { beans: e, customGui: t } = this;
    t ? this.setDragElement(t, this.dragStartPixels) : (this.setTemplate(PD), this.getGui().appendChild(Le("rowDrag", e, null)), this.addDragSource()), this.alwaysVisible || this.initCellDrag();
  }
  initCellDrag() {
    const { beans: e, gos: t, rowNode: n } = this, o = this.refreshVisibility.bind(this);
    this.addManagedPropertyListener("suppressRowDrag", o), this.addManagedListeners(n, {
      dataChanged: o,
      cellChanged: o
    }), this.addManagedListeners(
      e.eventSvc,
      // For managed row drag, we do not show the component if sort, filter or grouping is active
      t.get("rowDragManaged") ? {
        sortChanged: o,
        filterChanged: o,
        columnRowGroupChanged: o,
        newColumnsLoaded: o
      } : { newColumnsLoaded: o }
    );
  }
  setDragElement(e, t) {
    this.setTemplateFromElement(e, void 0, void 0, !0), this.addDragSource(t);
  }
  refreshVisibility() {
    if (this.alwaysVisible)
      return;
    const e = { skipAriaHidden: !0 };
    if (this.isNeverDisplayed()) {
      this.setDisplayed(!1, e);
      return;
    }
    const t = this.column;
    let n = typeof (t == null ? void 0 : t.getColDef().rowDrag) == "function", o = !t || this.isCustomGui() || t.isRowDrag(this.rowNode);
    o && this.rowNode.footer && this.gos.get("rowDragManaged") && (o = !1, n = !0), this.setDisplayed(n || o, e), this.setVisible(o, e);
  }
  isNeverDisplayed() {
    var n, o;
    const { gos: e, beans: t } = this;
    return !!(e.get("suppressRowDrag") || e.get("rowDragManaged") && ((n = t.rowDragSvc.rowDragFeature) != null && n.shouldPreventRowMove()) && !((o = t.dragAndDrop) != null && o.hasExternalDropZones()));
  }
  getSelectedNodes() {
    var o;
    const e = this.rowNode;
    if (!this.gos.get("rowDragMultiRow"))
      return [e];
    const n = ((o = this.beans.selectionSvc) == null ? void 0 : o.getSelectedNodes()) ?? [];
    return n.indexOf(e) !== -1 ? n : [e];
  }
  getDragItem() {
    const { column: e, rowNode: t } = this;
    return {
      rowNode: t,
      rowNodes: this.getSelectedNodes(),
      columns: e ? [e] : void 0,
      defaultTextValue: this.cellValueFn()
    };
  }
  getRowDragText(e) {
    if (e) {
      const t = e.getColDef();
      if (t.rowDragText)
        return t.rowDragText;
    }
    return this.gos.get("rowDragText");
  }
  addDragSource(e = 4) {
    if (this.dragSource && this.removeDragSource(), this.gos.get("rowDragManaged") && this.rowNode.footer)
      return;
    const t = this.getGui();
    this.gos.get("enableCellTextSelection") && (this.removeMouseDownListener(), this.mouseDownListener = this.addManagedElementListeners(t, {
      mousedown: (o) => {
        o == null || o.preventDefault();
      }
    })[0]);
    const n = this.getLocaleTextFunc();
    this.dragSource = {
      type: 2,
      eElement: t,
      dragItemName: (o) => {
        var a, l;
        const s = (o == null ? void 0 : o.dragItem) || this.getDragItem(), i = (((a = o == null ? void 0 : o.dropTarget) == null ? void 0 : a.rows.length) ?? ((l = s.rowNodes) == null ? void 0 : l.length)) || 1, r = this.getRowDragText(this.column);
        return r ? r(s, i) : i === 1 ? this.cellValueFn() : `${i} ${n("rowDragRows", "rows")}`;
      },
      getDragItem: () => this.getDragItem(),
      dragStartPixels: e,
      dragSourceDomDataKey: this.gos.getDomDataKey()
    }, this.beans.dragAndDrop.addDragSource(this.dragSource, !0);
  }
  destroy() {
    this.removeDragSource(), this.removeMouseDownListener(), super.destroy();
  }
  removeDragSource() {
    this.dragSource && (this.beans.dragAndDrop.removeDragSource(this.dragSource), this.dragSource = null);
  }
  removeMouseDownListener() {
    this.mouseDownListener && (this.mouseDownListener(), this.mouseDownListener = void 0);
  }
};
function Ho(e) {
  const t = e.rowModel;
  return t.getType() === "clientSide" ? t : void 0;
}
function Ec(e) {
  const t = e.rowModel;
  return t.getType() === "infinite" ? t : void 0;
}
function ol(e) {
  const t = e.rowModel;
  return t.getType() === "serverSide" ? t : void 0;
}
function TD(e) {
  const { rowIndex: t, rowPinned: n, column: o } = e;
  return `${t}.${n ?? "null"}.${o.getId()}`;
}
function Mp(e, t) {
  const n = e.column === t.column, o = e.rowPinned === t.rowPinned, s = e.rowIndex === t.rowIndex;
  return n && o && s;
}
function kD(e, t) {
  switch (e.rowPinned) {
    case "top":
      if (t.rowPinned !== "top")
        return !0;
      break;
    case "bottom":
      if (t.rowPinned !== "bottom")
        return !1;
      break;
    default:
      if (ue(t.rowPinned))
        return t.rowPinned !== "top";
      break;
  }
  return e.rowIndex < t.rowIndex;
}
function sy(e, t) {
  return !e && !t ? !0 : e && !t || !e && t ? !1 : e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned;
}
function LD(e) {
  let t = 0, n;
  const { pinnedRowModel: o, rowModel: s, pageBounds: i } = e;
  return o != null && o.getPinnedTopRowCount() ? n = "top" : s.getRowCount() ? (n = null, t = i.getFirstRow()) : o != null && o.getPinnedBottomRowCount() && (n = "bottom"), n === void 0 ? null : { rowIndex: t, rowPinned: n };
}
function BD(e) {
  let t, n = null;
  const { pinnedRowModel: o, pageBounds: s } = e, i = o == null ? void 0 : o.getPinnedBottomRowCount(), r = o == null ? void 0 : o.getPinnedTopRowCount();
  return i ? (n = "bottom", t = i - 1) : e.rowModel.getRowCount() ? (n = null, t = s.getLastRow()) : r && (n = "top", t = r - 1), t === void 0 ? null : { rowIndex: t, rowPinned: n };
}
function To(e, t) {
  var n, o;
  switch (t.rowPinned) {
    case "top":
      return (n = e.pinnedRowModel) == null ? void 0 : n.getPinnedTopRow(t.rowIndex);
    case "bottom":
      return (o = e.pinnedRowModel) == null ? void 0 : o.getPinnedBottomRow(t.rowIndex);
    default:
      return e.rowModel.getRow(t.rowIndex);
  }
}
function Ki(e, t) {
  var s;
  const n = (s = e.spannedRowRenderer) == null ? void 0 : s.getCellByPosition(t);
  if (n)
    return n;
  const o = e.rowRenderer.getRowByPosition(t);
  return o ? o.getCellCtrl(t.column) : null;
}
function OD(e, t, n) {
  const { rowModel: o, pinnedRowModel: s } = e;
  let i;
  return i ?? (i = o == null ? void 0 : o.getRowNode(t)), n ? i ?? (i = s == null ? void 0 : s.getPinnedRowById(t, n)) : (i ?? (i = s == null ? void 0 : s.getPinnedRowById(t, "top")), i ?? (i = s == null ? void 0 : s.getPinnedRowById(t, "bottom"))), i;
}
function Ld(e, t, n = !1) {
  const { rowIndex: o, rowPinned: s } = t, { pageBounds: i, pinnedRowModel: r, rowModel: a } = e;
  if (o === 0)
    return s === "top" ? null : s === "bottom" && a.isRowsToRender() ? { rowIndex: i.getLastRow(), rowPinned: null } : r != null && r.isRowsToRender("top") ? { rowIndex: r.getPinnedTopRowCount() - 1, rowPinned: "top" } : null;
  if (n) {
    const l = s ? void 0 : a.getRow(o);
    return iy(e, l, !0) ?? { rowIndex: o - 1, rowPinned: s };
  }
  return { rowIndex: o - 1, rowPinned: s };
}
function Hm(e, t, n = !1) {
  const { rowIndex: o, rowPinned: s } = t, { pageBounds: i, pinnedRowModel: r, rowModel: a } = e;
  if (GD(e, t))
    return s === "bottom" ? null : s === "top" && a.isRowsToRender() ? { rowIndex: i.getFirstRow(), rowPinned: null } : r != null && r.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
  if (n) {
    const l = s ? void 0 : a.getRow(o);
    return iy(e, l) ?? { rowIndex: o + 1, rowPinned: s };
  }
  return { rowIndex: o + 1, rowPinned: s };
}
function iy(e, t, n = !1) {
  const { gos: o, rowRenderer: s } = e;
  if (!(t != null && t.sticky) || !gc(o))
    return;
  const i = s.getStickyTopRowCtrls(), r = s.getStickyBottomRowCtrls(), a = !r.some((u) => u.rowNode.rowIndex === t.rowIndex), l = a ? i : r, d = (n ? -1 : 1) * (a ? -1 : 1);
  let c;
  for (let u = 0; u < l.length; u++)
    if (l[u].rowNode.rowIndex === t.rowIndex) {
      c = l[u + d];
      break;
    }
  return c ? { rowIndex: c.rowNode.rowIndex, rowPinned: null } : void 0;
}
function GD(e, t) {
  const { rowPinned: n, rowIndex: o } = t, { pinnedRowModel: s, pageBounds: i } = e;
  return n === "top" ? ((s == null ? void 0 : s.getPinnedTopRowCount()) ?? 0) - 1 <= o : n === "bottom" ? ((s == null ? void 0 : s.getPinnedBottomRowCount()) ?? 0) - 1 <= o : i.getLastRow() <= o;
}
var Rr = class {
  constructor(e, t) {
    this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = e, this.pathRoot = {
      rowNode: t,
      children: null
    }, this.mapToItems[t.id] = this.pathRoot;
  }
  depthFirstSearchChangedPath(e, t) {
    const { rowNode: n, children: o } = e;
    if (o)
      for (let s = 0; s < o.length; ++s)
        this.depthFirstSearchChangedPath(o[s], t);
    t(n);
  }
  depthFirstSearchEverything(e, t, n) {
    const o = e.childrenAfterGroup;
    if (o)
      for (let s = 0, i = o.length; s < i; ++s) {
        const r = o[s];
        r.childrenAfterGroup ? this.depthFirstSearchEverything(r, t, n) : n && t(r);
      }
    t(e);
  }
  // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
  // will be called for child nodes in addition to parent nodes.
  forEachChangedNodeDepthFirst(e, t = !1, n = !1) {
    this.active && !n ? this.depthFirstSearchChangedPath(this.pathRoot, e) : this.depthFirstSearchEverything(this.pathRoot.rowNode, e, t);
  }
  executeFromRootNode(e) {
    e(this.pathRoot.rowNode);
  }
  createPathItems(e) {
    let t = e, n = 0;
    for (; !this.mapToItems[t.id]; ) {
      const o = {
        rowNode: t,
        children: null
      };
      this.mapToItems[t.id] = o, n++, t = t.parent;
    }
    return n;
  }
  populateColumnsMap(e, t) {
    if (!this.keepingColumns || !t)
      return;
    let n = e;
    for (; n; )
      this.nodeIdsToColumns[n.id] || (this.nodeIdsToColumns[n.id] = {}), t.forEach((o) => this.nodeIdsToColumns[n.id][o.getId()] = !0), n = n.parent;
  }
  linkPathItems(e, t) {
    let n = e;
    for (let o = 0; o < t; o++) {
      const s = this.mapToItems[n.id], i = this.mapToItems[n.parent.id];
      i.children || (i.children = []), i.children.push(s), n = n.parent;
    }
  }
  // called by
  // 1) change detection (provides cols) and
  // 2) groupStage if doing transaction update (doesn't provide cols)
  addParentNode(e, t) {
    if (!e || e.isRowPinned())
      return;
    const n = this.createPathItems(e);
    this.linkPathItems(e, n), this.populateColumnsMap(e, t);
  }
  canSkip(e) {
    return this.active && !this.mapToItems[e.id];
  }
  getValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return t;
    const n = this.nodeIdsToColumns[e.id];
    return t.filter((s) => n[s.getId()]);
  }
  getNotValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return null;
    const n = this.nodeIdsToColumns[e.id];
    return t.filter((s) => !n[s.getId()]);
  }
}, HD = class {
  constructor(e, t) {
    this.beans = e, this.groupThrottled = !1, this.oldVScroll = null, this.groupTimer = null, this.groupTarget = null, this.onGroupThrottle = () => {
      var o;
      this.groupTimer = null, this.groupThrottled = !0, (o = this.beans.dragAndDrop) == null || o.nudge();
    };
    const n = () => t.scrollFeature.getVScrollPosition().top;
    this.autoScroll = new ey({
      scrollContainer: t.eBodyViewport,
      scrollAxis: "y",
      getVerticalPosition: n,
      setVerticalPosition: (o) => t.scrollFeature.setVerticalScrollPosition(o),
      onScrollCallback: () => {
        var i;
        const o = n(), s = this.oldVScroll;
        this.oldVScroll = o, s !== null && s !== o && ((i = this.beans.dragAndDrop) == null || i.nudge());
      }
    });
  }
  updateGroup(e, t) {
    var n, o;
    this.groupTarget && this.groupTarget !== e && this.clearGroup(), e && (t && this.groupThrottled && !e.expanded && ((n = e.childrenAfterSort) != null && n.length) && e.isExpandable() && e.setExpanded(!0, void 0, !0), e.expanded && ((o = e.childrenAfterSort) != null && o.length) && (this.groupThrottled = !0, this.groupTarget = e));
  }
  startGroup(e) {
    this.groupTarget = e, this.groupTimer === null && (this.groupTimer = window.setTimeout(this.onGroupThrottle, this.beans.gos.get("rowDragInsertDelay")));
  }
  clearGroup() {
    this.groupThrottled = !1, this.groupTarget = null;
    const e = this.groupTimer;
    e !== null && (this.groupTimer = null, window.clearTimeout(e));
  }
  clear() {
    this.clearGroup(), this.autoScroll.ensureCleared(), this.oldVScroll = null;
  }
}, VD = class extends U {
  constructor(e) {
    super(), this.eContainer = e, this.lastDraggingEvent = null, this.nudger = null;
  }
  postConstruct() {
    const e = this.beans;
    this.clientSideRowModel = Ho(e), e.ctrlsSvc.whenReady(this, (t) => {
      this.nudger = new HD(e, t.gridBodyCtrl);
    });
  }
  destroy() {
    var e;
    super.destroy(), (e = this.nudger) == null || e.clear(), this.nudger = null, this.lastDraggingEvent = null, this.eContainer = null;
  }
  getContainer() {
    return this.eContainer;
  }
  isInterestedIn(e) {
    return e === 2;
  }
  getIconName(e) {
    var t;
    return ((t = e == null ? void 0 : e.dropTarget) == null ? void 0 : t.allowed) === !1 || this.gos.get("rowDragManaged") && this.shouldPreventRowMove() ? "notAllowed" : "move";
  }
  shouldPreventRowMove() {
    const { rowGroupColsSvc: e, filterManager: t, sortSvc: n } = this.beans;
    return !!(((e == null ? void 0 : e.columns) ?? []).length || (t == null ? void 0 : t.isAnyFilterPresent()) || (n == null ? void 0 : n.isSortActive()));
  }
  getRowNodes(e) {
    var n;
    if (!this.isFromThisGrid(e))
      return e.dragItem.rowNodes || [];
    const t = e.dragItem.rowNode;
    if (this.gos.get("rowDragMultiRow")) {
      const o = (n = this.beans.selectionSvc) == null ? void 0 : n.getSelectedNodes();
      if (o && o.indexOf(t) >= 0)
        return o.slice().sort($D);
    }
    return [t];
  }
  onDragEnter(e) {
    this.dragging(e, !0);
  }
  onDragging(e) {
    this.dragging(e, !1);
  }
  dragging(e, t) {
    var r, a;
    const { lastDraggingEvent: n, beans: o } = this;
    if (t) {
      const l = this.getRowNodes(e);
      e.dragItem.rowNodes = l, Nm(l, !0);
    }
    this.lastDraggingEvent = e;
    const s = e.fromNudge, i = this.makeRowsDrop(n, e, s, !1);
    (r = o.rowDropHighlightSvc) == null || r.fromDrag(e), t && this.dispatchGridEvent("rowDragEnter", e), this.dispatchGridEvent("rowDragMove", e), !s && (i != null && i.rowDragManaged) && i.moved && i.allowed && i.sameGrid && !i.suppressMoveWhenRowDragging && this.dropRows(i), (a = this.nudger) == null || a.autoScroll.check(e.event);
  }
  isFromThisGrid(e) {
    return e.dragSource.dragSourceDomDataKey === this.gos.getDomDataKey();
  }
  makeRowsDrop(e, t, n, o) {
    var A;
    const { beans: s, gos: i, clientSideRowModel: r } = this, a = this.newRowsDrop(t, o);
    if (t.dropTarget = a, t.changed = !1, !a)
      return null;
    let { sameGrid: l, rootNode: d, source: c, target: u, rows: h } = a;
    u ?? (u = r.getRow(r.getRowCount() - 1) ?? null);
    const p = (
      // We don't yet support drag and drop with grouping
      tp(i) !== "group" && // We don't yet support moving tree rows from a different grid in a structured way
      l
    );
    let f = null;
    if (u != null && u.footer) {
      const S = ed(r, -1, u) ?? ed(r, 1, u);
      f = u.sibling ?? d, u = S ?? null;
    }
    u != null && u.detail && (u = u.parent), a.moved && (a.moved = c !== u);
    let m = 0.5;
    if (u && (l && a.moved && (f || !p) ? m = c.rowIndex > u.rowIndex ? -0.5 : 0.5 : m = (a.y - u.rowTop - u.rowHeight / 2) / u.rowHeight || 0), !p && l && u && a.moved) {
      const S = zD(r, a);
      S && (m = c.rowIndex > S.rowIndex ? -0.5 : 0.5, u = S, a.moved && (a.moved = c !== u));
    }
    const C = this.nudger;
    C == null || C.updateGroup(u, n), p && !f && C && (!u || m >= 0.5 && u.rowIndex === s.pageBounds.getLastRow() ? f = d : a.moved && this.targetShouldBeParent(u, m, h) && (C.groupThrottled && (f = u), !n && (!f || u && !u.expanded && ((A = u.childrenAfterSort) != null && A.length)) && C.startGroup(u)), f ?? (f = (u == null ? void 0 : u.parent) ?? d));
    let w = !1;
    if (f) {
      if (f === u && f !== d) {
        const S = f.expanded ? ed(r, 1, u) : null;
        (S == null ? void 0 : S.parent) === f ? (u = S, m = -0.5) : w = !0;
      }
      if (u && !w) {
        let S = u;
        for (; S && S !== d && S !== f; )
          u = S, S = S.parent;
      }
    }
    a.target = u, a.newParent = f, a.moved && (a.moved = c !== u);
    const b = m < 0 ? "above" : "below";
    return a.position = a.moved ? w ? "inside" : b : "none", this.validateRowsDrop(a, p, b, o), t.changed || (t.changed = ND(e == null ? void 0 : e.dropTarget, a)), a;
  }
  newRowsDrop(e, t) {
    const { beans: n, gos: o, clientSideRowModel: s } = this, i = s.rootNode, r = o.get("rowDragManaged"), a = o.get("suppressMoveWhenRowDragging"), l = this.isFromThisGrid(e);
    let { rowNode: d, rowNodes: c } = e.dragItem;
    if (c || (c = d ? [d] : []), d || (d = c[0]), !d || !i)
      return null;
    const u = this.beans.dragAndDrop.isDropZoneWithinThisGrid(e);
    let h = !0;
    r && (!c.length || this.shouldPreventRowMove() || (a || !l) && !u) && (h = !1);
    const g = Fm(n, e).y, p = this.getOverNode(g);
    return {
      api: n.gridApi,
      context: n.gridOptions.context,
      draggingEvent: e,
      rowDragManaged: r,
      suppressMoveWhenRowDragging: a,
      sameGrid: l,
      withinGrid: u,
      rootNode: i,
      moved: d !== p,
      y: g,
      overNode: p,
      overIndex: (p == null ? void 0 : p.rowIndex) ?? -1,
      position: "none",
      source: d,
      target: p ?? null,
      newParent: null,
      rows: c,
      allowed: h,
      highlight: !t && r && a && (u || !l)
    };
  }
  validateRowsDrop(e, t, n, o) {
    const { rowDragManaged: s, suppressMoveWhenRowDragging: i } = e;
    t || (e.newParent = null), i && !e.moved && (e.allowed = !1);
    const r = (!s || e.allowed) && this.gos.get("isRowValidDropPosition");
    if (r) {
      t && e.newParent && Vm(e.rows, e.newParent) && (e.newParent = null);
      const a = r(e);
      if (!a)
        e.allowed = !1;
      else if (typeof a == "object") {
        a.rows !== void 0 && (e.rows = a.rows ?? []), t && a.newParent !== void 0 && (e.newParent = a.newParent), a.target !== void 0 && (e.target = a.target), a.position && (e.position = a.position), a.allowed !== void 0 ? e.allowed = a.allowed : s || (e.allowed = !0);
        const l = e.draggingEvent;
        a.changed && l && (l.changed = !0), !o && a.highlight !== void 0 && (e.highlight = a.highlight);
      }
    }
    s && (e.rows = this.filterRows(e)), t && e.newParent && Vm(e.rows, e.newParent) && (e.newParent = null), i && (!e.rows.length || e.position === "none") && (e.allowed = !1), (!e.allowed || !e.newParent) && e.position === "inside" && (e.position = n);
  }
  targetShouldBeParent(e, t, n) {
    const o = e.rowIndex, s = 0.25;
    if (t < -0.5 + s)
      return !1;
    if (t < 0.5 - s)
      return !0;
    let i, r = o + 1;
    const a = this.clientSideRowModel;
    do
      i = a.getRow(r++);
    while (i && i.footer);
    const l = e.childrenAfterGroup;
    if (i && i.parent === e && (l != null && l.length)) {
      const d = new Set(n);
      for (const c of l)
        if (c.rowIndex !== null && !d.has(c))
          return !0;
    }
    return !1;
  }
  addRowDropZone(e) {
    if (!e.getContainer()) {
      Z(55);
      return;
    }
    const t = this.beans.dragAndDrop;
    if (t.findExternalZone(e.getContainer())) {
      Z(56);
      return;
    }
    const n = e.fromGrid ? e : {
      getContainer: e.getContainer,
      onDragEnter: e.onDragEnter && ((s) => e.onDragEnter(this.rowDragEvent("rowDragEnter", s))),
      onDragLeave: e.onDragLeave && ((s) => e.onDragLeave(this.rowDragEvent("rowDragLeave", s))),
      onDragging: e.onDragging && ((s) => e.onDragging(this.rowDragEvent("rowDragMove", s))),
      onDragStop: e.onDragStop && ((s) => e.onDragStop(this.rowDragEvent("rowDragEnd", s))),
      onDragCancel: e.onDragCancel && ((s) => e.onDragCancel(this.rowDragEvent("rowDragCancel", s)))
    }, o = {
      isInterestedIn: (s) => s === 2,
      getIconName: () => "move",
      external: !0,
      ...n
    };
    t.addDropTarget(o), this.addDestroyFunc(() => t.removeDropTarget(o));
  }
  getRowDropZone(e) {
    return {
      getContainer: this.getContainer.bind(this),
      onDragEnter: (n) => {
        var o;
        this.onDragEnter(n), (o = e == null ? void 0 : e.onDragEnter) == null || o.call(e, this.rowDragEvent("rowDragEnter", n));
      },
      onDragLeave: (n) => {
        var o;
        this.onDragLeave(n), (o = e == null ? void 0 : e.onDragLeave) == null || o.call(e, this.rowDragEvent("rowDragLeave", n));
      },
      onDragging: (n) => {
        var o;
        this.onDragging(n), (o = e == null ? void 0 : e.onDragging) == null || o.call(e, this.rowDragEvent("rowDragMove", n));
      },
      onDragStop: (n) => {
        var o;
        this.onDragStop(n), (o = e == null ? void 0 : e.onDragStop) == null || o.call(e, this.rowDragEvent("rowDragEnd", n));
      },
      onDragCancel: (n) => {
        var o;
        this.onDragCancel(n), (o = e == null ? void 0 : e.onDragCancel) == null || o.call(e, this.rowDragEvent("rowDragCancel", n));
      },
      fromGrid: !0
    };
  }
  getOverNode(e) {
    const { pageBounds: t, rowModel: n } = this.beans, s = e > t.getCurrentPagePixelRange().pageLastPixel ? -1 : n.getRowIndexAtPixel(e);
    return s >= 0 ? n.getRow(s) : void 0;
  }
  rowDragEvent(e, t) {
    const n = this.beans, { dragItem: o, dropTarget: s, event: i, vDirection: r } = t, a = (s == null ? void 0 : s.rootNode) === this.clientSideRowModel.rootNode, l = a ? s.y : Fm(n, t).y, d = a ? s.overNode : this.getOverNode(l), c = a ? s.overIndex : (d == null ? void 0 : d.rowIndex) ?? -1;
    return {
      api: n.gridApi,
      context: n.gridOptions.context,
      type: e,
      event: i,
      node: o.rowNode,
      nodes: o.rowNodes,
      overIndex: c,
      overNode: d,
      y: l,
      vDirection: r,
      rowsDrop: s
    };
  }
  dispatchGridEvent(e, t) {
    const n = this.rowDragEvent(e, t);
    this.eventSvc.dispatchEvent(n);
  }
  onDragLeave(e) {
    this.dispatchGridEvent("rowDragLeave", e), this.stopDragging(e);
  }
  onDragStop(e) {
    const t = this.makeRowsDrop(this.lastDraggingEvent, e, !1, !0);
    this.dispatchGridEvent("rowDragEnd", e), t != null && t.allowed && t.rowDragManaged && (t.suppressMoveWhenRowDragging || !t.sameGrid) && this.dropRows(t), this.stopDragging(e);
  }
  onDragCancel(e) {
    this.dispatchGridEvent("rowDragCancel", e), this.stopDragging(e);
  }
  stopDragging(e) {
    var t, n;
    (t = this.nudger) == null || t.clear(), (n = this.beans.rowDropHighlightSvc) == null || n.fromDrag(null), Nm(e.dragItem.rowNodes, !1);
  }
  /** Drag and drop. Returns false if at least a row was moved, otherwise true */
  dropRows(e) {
    return e.sameGrid ? this.moveRows(e) : this.addRows(e);
  }
  addRows({ position: e, target: t, rows: n }) {
    const o = Jo(this.gos), s = this.clientSideRowModel, i = n.filter(
      ({ data: a, rowPinned: l }) => !s.getRowNode((o == null ? void 0 : o({ data: a, level: 0, rowPinned: l })) ?? a.id)
    ).map(({ data: a }) => a);
    if (i.length === 0)
      return !1;
    const r = t ? _m(t) + (e === "above" ? 0 : 1) : void 0;
    return s.updateRowData({ add: i, addIndex: r }), !0;
  }
  filterRows({ newParent: e, rows: t }) {
    const n = this.clientSideRowModel;
    let o;
    for (let s = 0, i = t.length; s < i; ++s) {
      let r = !0;
      const a = t[s];
      !a || a.footer || a.rowTop === null && a !== n.getRowNode(a.id) || e && a.parent !== e && _D(a, e) ? r = !1 : Th(a) || (r = !1), r ? o == null || o.push(a) : o ?? (o = t.slice(0, s));
    }
    return o ?? t;
  }
  moveRows({ position: e, target: t, rows: n, newParent: o, rootNode: s }) {
    let i = !1;
    const r = /* @__PURE__ */ new Set();
    for (const c of n) {
      o && c.parent !== o && (c.treeParent = o, i = !0);
      const u = Th(c);
      u && r.add(u);
    }
    if (!i && r.size === 0)
      return !1;
    const a = this.beans.focusSvc, l = a.getFocusedCell(), d = l && Ki(this.beans, l);
    return r.size && this.reorderLeafChildren(r, ...this.getMoveRowsBounds(r, t, e === "above")) && (i = !0), i ? (this.clientSideRowModel.refreshModel({
      step: "group",
      keepRenderedRows: !0,
      animate: !this.gos.get("suppressAnimationFrame"),
      changedPath: new Rr(!1, s),
      rowNodesOrderChanged: !0
    }), d ? d.focusCell() : a.clearFocusedCell(), !0) : !1;
  }
  /** For reorderLeafChildren, returns min index of the rows to move, the target index and the max index of the rows to move. */
  getMoveRowsBounds(e, t, n) {
    var a;
    const o = ((a = this.clientSideRowModel.rootNode) == null ? void 0 : a.allLeafChildren.length) ?? 0;
    let s = _m(t);
    s < 0 || s >= o ? s = o : n || ++s;
    let i = s, r = Math.min(s, o - 1);
    for (const l of e) {
      const d = l.sourceRowIndex;
      d < i && (i = d), d > r && (r = d);
    }
    return [i, s, r];
  }
  /** Reorders the children of the root node, so that the rows to move are in the correct order.
   * @param leafs The valid set of rows to move, as returned by getValidRowsToMove
   * @param firstAffectedLeafIdx The first index of the rows to move
   * @param targetPositionIdx The target index, where the rows will be moved
   * @param lastAffectedLeafIndex The last index of the rows to move
   * @returns True if the order of the rows changed, false otherwise
   */
  reorderLeafChildren(e, t, n, o) {
    var l;
    let s = !1;
    const i = (l = this.clientSideRowModel.rootNode) == null ? void 0 : l.allLeafChildren;
    if (!e.size || !i)
      return !1;
    let r = t;
    for (let d = t; d < n; ++d) {
      const c = i[d];
      e.has(c) || (c.sourceRowIndex !== r && (c.sourceRowIndex = r, i[r] = c, s = !0), ++r);
    }
    let a = o;
    for (let d = o; d >= n; --d) {
      const c = i[d];
      e.has(c) || (c.sourceRowIndex !== a && (c.sourceRowIndex = a, i[a] = c, s = !0), --a);
    }
    for (const d of e)
      d.sourceRowIndex !== r && (d.sourceRowIndex = r, i[r] = d, s = !0), ++r;
    return s;
  }
}, ed = (e, t, n) => {
  if (n) {
    const o = e.getRowCount();
    let s = n.rowIndex + t;
    for (; s >= 0 && s < o; ) {
      const i = e.getRow(s);
      if (!i || !i.footer && !i.detail)
        return i;
      s += t;
    }
  }
}, _D = (e, t) => {
  let n = t;
  for (; n; ) {
    if (n === e)
      return !0;
    n = n.parent;
  }
  return !1;
}, Vm = (e, t) => {
  for (let n = 0, o = e.length; n < o; ++n)
    if (e[n].parent !== t)
      return !1;
  return !0;
}, _m = (e) => {
  const t = Th(e);
  return t !== void 0 ? t.sourceRowIndex : -1;
}, Th = (e) => {
  for (; e; ) {
    if (e.sourceRowIndex >= 0)
      return e;
    const t = e.childrenAfterGroup;
    if (!(t != null && t.length))
      return;
    e = t[0];
  }
}, ND = (e, t) => e !== t && (!e || e.sameGrid !== t.sameGrid || e.allowed !== t.allowed || e.position !== t.position || e.target !== t.target || e.source !== t.source || e.newParent !== t.newParent || !Yn(e.rows, t.rows)), $D = ({ rowIndex: e }, { rowIndex: t }) => e !== null && t !== null ? e - t : 0, Nm = (e, t) => {
  for (let n = 0, o = (e == null ? void 0 : e.length) || 0; n < o; ++n) {
    const s = e[n];
    s.dragging !== t && (s.dragging = t, s.dispatchRowEvent("draggingChanged"));
  }
}, zD = (e, t) => {
  let n = null, o = t.target;
  if (o && t.rows.indexOf(o) < 0)
    return null;
  const s = t.source;
  if (!o || !s)
    return null;
  let i = o.rowIndex - s.rowIndex;
  const r = i < 0 ? -1 : 1;
  i = t.suppressMoveWhenRowDragging ? Math.abs(i) : 1;
  const a = new Set(t.rows);
  do {
    const l = ed(e, r, o);
    if (!l)
      break;
    a.has(l) || (n = l, --i), o = l;
  } while (i > 0);
  return n;
}, WD = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowDragSvc";
  }
  setupRowDrag(e, t) {
    const n = t.createManagedBean(new VD(e)), o = this.beans.dragAndDrop;
    o.addDropTarget(n), t.addDestroyFunc(() => o.removeDropTarget(n)), this.rowDragFeature = n;
  }
  createRowDragComp(e, t, n, o, s, i) {
    return new DD(e, t, n, o, s, i);
  }
  createRowDragCompForRow(e, t) {
    if (Xo(this.gos))
      return;
    const n = this.getLocaleTextFunc();
    return this.createRowDragComp(
      () => `1 ${n("rowDragRow", "row")}`,
      e,
      void 0,
      t,
      void 0,
      !0
    );
  }
  createRowDragCompForCell(e, t, n, o, s, i) {
    const r = this.gos;
    return r.get("rowDragManaged") && (!Ct(r) || r.get("pagination")) ? void 0 : this.createRowDragComp(
      n,
      e,
      t,
      o,
      s,
      i
    );
  }
}, UD = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowDropHighlightSvc", this.uiLevel = 0, this.dragging = !1, this.row = null, this.position = "none";
  }
  postConstruct() {
    this.addManagedEventListeners({
      modelUpdated: this.onModelUpdated.bind(this)
    });
  }
  onModelUpdated() {
    const e = this.row, t = this.dragging;
    !e || e.rowIndex === null || this.position === "none" ? this.clear() : this.set(e, this.position), this.dragging = t;
  }
  destroy() {
    this.clear(), super.destroy();
  }
  clear() {
    const e = this.row;
    this.dragging = !1, e && (this.uiLevel = 0, this.position = "none", this.row = null, e.dispatchRowEvent("rowHighlightChanged"));
  }
  set(e, t) {
    const n = e !== this.row, o = e.uiLevel, s = t !== this.position, i = o !== this.uiLevel;
    this.dragging = !1, (n || s || i) && (n && this.clear(), this.uiLevel = o, this.position = t, this.row = e, e.dispatchRowEvent("rowHighlightChanged"));
  }
  fromDrag(e) {
    const t = e == null ? void 0 : e.dropTarget;
    if (t) {
      const { highlight: n, target: o, position: s } = t;
      if (n && o && s !== "none") {
        this.set(o, s), this.dragging = !0;
        return;
      }
    }
    this.dragging && this.clear();
  }
}, ry = {
  moduleName: "Drag",
  version: Ee,
  beans: [MD]
}, KD = {
  moduleName: "DragAndDrop",
  version: Ee,
  dynamicBeans: {
    dndSourceComp: SD
  },
  icons: {
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, sl = {
  moduleName: "SharedDragAndDrop",
  version: Ee,
  beans: [iI],
  dependsOn: [ry],
  userComponents: {
    agDragAndDropImage: IP
  },
  icons: {
    // shown on drag and drop image component icon while dragging column to the side of the grid to pin
    columnMovePin: "pin",
    // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
    columnMoveHide: "eye-slash",
    // shown on drag and drop image component icon while dragging columns to reorder
    columnMoveMove: "arrows",
    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
    columnMoveLeft: "left",
    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
    columnMoveRight: "right",
    // shown on drag and drop image component icon while dragging over Row Groups drop zone
    columnMoveGroup: "group",
    // shown on drag and drop image component icon while dragging over Values drop zone
    columnMoveValue: "aggregation",
    // shown on drag and drop image component icon while dragging over pivot drop zone
    columnMovePivot: "pivot",
    // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
    // string column over aggregation drop zone
    dropNotAllowed: "not-allowed",
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, ZD = {
  moduleName: "RowDrag",
  version: Ee,
  beans: [UD, WD],
  apiFunctions: {
    addRowDropZone: xD,
    removeRowDropZone: RD,
    getRowDropZoneParams: ED,
    getRowDropPositionIndicator: AD,
    setRowDropPositionIndicator: FD
  },
  dependsOn: [sl]
}, ay = {
  moduleName: "HorizontalResize",
  version: Ee,
  beans: [ID],
  dependsOn: [ry]
}, qD = (
  /*css*/
  ":where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}"
), jD = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colAnimation", this.executeNextFuncs = [], this.executeLaterFuncs = [], this.active = !1, this.activeNext = !1, this.suppressAnimation = !1, this.animationThreadCount = 0;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => this.gridBodyCtrl = e.gridBodyCtrl);
  }
  isActive() {
    return this.active && !this.suppressAnimation;
  }
  setSuppressAnimation(e) {
    this.suppressAnimation = e;
  }
  start() {
    if (this.active)
      return;
    const { gos: e } = this;
    e.get("suppressColumnMoveAnimation") || e.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0, this.activeNext = !0);
  }
  finish() {
    this.active && this.flush(
      () => this.activeNext = !1,
      () => this.active = !1
    );
  }
  executeNextVMTurn(e) {
    this.activeNext ? this.executeNextFuncs.push(e) : e();
  }
  executeLaterVMTurn(e) {
    this.active ? this.executeLaterFuncs.push(e) : e();
  }
  ensureAnimationCssClassPresent() {
    this.animationThreadCount++;
    const e = this.animationThreadCount, { gridBodyCtrl: t } = this;
    t.setColumnMovingCss(!0), this.executeLaterFuncs.push(() => {
      this.animationThreadCount === e && t.setColumnMovingCss(!1);
    });
  }
  flush(e, t) {
    const { executeNextFuncs: n, executeLaterFuncs: o } = this;
    if (n.length === 0 && o.length === 0) {
      e(), t();
      return;
    }
    const s = (i) => {
      for (; i.length; ) {
        const r = i.pop();
        r && r();
      }
    };
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e(), s(n);
      }, 0), window.setTimeout(() => {
        t(), s(o);
      }, 200);
    });
  }
};
function YD(e, t, n) {
  var o;
  (o = e.colMoves) == null || o.moveColumnByIndex(t, n, "api");
}
function QD(e, t, n) {
  var o;
  (o = e.colMoves) == null || o.moveColumns(t, n, "api");
}
var JD = class extends U {
  constructor(e) {
    super(), this.pinned = e, this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [];
  }
  /** Callback for when drag enters */
  onDragEnter(e) {
    if (this.clearColumnsList(), this.gos.get("functionsReadOnly"))
      return;
    const t = e.dragItem.columns;
    t && t.forEach((n) => {
      n.isPrimary() && (n.isAnyFunctionActive() || (n.isAllowValue() ? this.columnsToAggregate.push(n) : n.isAllowRowGroup() ? this.columnsToGroup.push(n) : n.isAllowPivot() && this.columnsToPivot.push(n)));
    });
  }
  getIconName() {
    return this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length > 0 ? this.pinned ? "pinned" : "move" : null;
  }
  /** Callback for when drag leaves */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragLeave(e) {
    this.clearColumnsList();
  }
  clearColumnsList() {
    this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
  }
  /** Callback for when dragging */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragging(e) {
  }
  /** Callback for when drag stops */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragStop(e) {
    const { valueColsSvc: t, rowGroupColsSvc: n, pivotColsSvc: o } = this.beans;
    this.columnsToAggregate.length > 0 && (t == null || t.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop")), this.columnsToGroup.length > 0 && (n == null || n.addColumns(this.columnsToGroup, "toolPanelDragAndDrop")), this.columnsToPivot.length > 0 && (o == null || o.addColumns(this.columnsToPivot, "toolPanelDragAndDrop"));
  }
  onDragCancel() {
    this.clearColumnsList();
  }
};
function XD(e, t) {
  !t || t.length <= 1 || t.filter((o) => e.indexOf(o) < 0).length > 0 || t.sort((o, s) => {
    const i = e.indexOf(o), r = e.indexOf(s);
    return i - r;
  });
}
function eT(e) {
  const t = [...e];
  return e.forEach((n) => {
    var i;
    let o = null, s = n.getParent();
    for (; s != null && s.getDisplayedLeafColumns().length === 1; )
      o = s, s = s.getParent();
    o != null && (!!((i = o.getColGroupDef()) != null && i.marryChildren) ? (
      // when marry children is true, we also have to move hidden
      // columns within the group, so grab them from the `providedColumnGroup`
      o.getProvidedColumnGroup().getLeafColumns()
    ) : o.getLeafColumns()).forEach((l) => {
      t.includes(l) || t.push(l);
    });
  }), t;
}
function tT(e, t, n, o) {
  const s = o.allCols;
  let i = null, r = null;
  for (let a = 0; a < e.length; a++) {
    const l = e[a], d = n.getProposedColumnOrder(t, l);
    if (!n.doesOrderPassRules(d))
      continue;
    const c = d.filter((h) => s.includes(h));
    if (r === null)
      r = c;
    else if (!Yn(c, r))
      break;
    const u = oT(d);
    (i === null || u < i.fragCount) && (i = { move: l, fragCount: u });
  }
  return i;
}
function ly(e) {
  const { isFromHeader: t, fromLeft: n, xPosition: o, fromEnter: s, fakeEvent: i, pinned: r, gos: a, colModel: l, colMoves: d, visibleCols: c } = e;
  let { allMovingColumns: u } = e;
  t && (u = eT(u));
  const h = u.slice();
  XD(l.getCols(), h);
  const g = iT({
    movingCols: h,
    draggingRight: n,
    xPosition: o,
    pinned: r,
    gos: a,
    colModel: l,
    visibleCols: c
  }), p = nT(h, l);
  if (g.length === 0)
    return;
  const f = g[0];
  if (p !== null && (t || !s) && !i && (!n && f >= p || n && f <= p))
    return;
  const C = tT(g, h, d, c);
  if (!C)
    return;
  const w = C.move;
  if (!(w > l.getCols().length - h.length))
    return { columns: h, toIndex: w };
}
function dy(e) {
  const { columns: t, toIndex: n } = ly(e) || {}, { finished: o, colMoves: s } = e;
  return !t || n == null ? null : (s.moveColumns(t, n, "uiColumnMoved", o), o ? null : { columns: t, toIndex: n });
}
function nT(e, t) {
  const n = t.getCols(), o = e.map((l) => n.indexOf(l)).sort((l, d) => l - d), s = o[0];
  return Je(o) - s !== o.length - 1 ? null : s;
}
function oT(e) {
  function t(o) {
    const s = [];
    let i = o.getOriginalParent();
    for (; i != null; )
      s.push(i), i = i.getOriginalParent();
    return s;
  }
  let n = 0;
  for (let o = 0; o < e.length - 1; o++) {
    let s = t(e[o]), i = t(e[o + 1]);
    [s, i] = s.length > i.length ? [s, i] : [i, s], s.forEach((r) => {
      i.indexOf(r) === -1 && n++;
    });
  }
  return n;
}
function sT(e, t) {
  switch (t) {
    case "left":
      return e.leftCols;
    case "right":
      return e.rightCols;
    default:
      return e.centerCols;
  }
}
function iT(e) {
  const { movingCols: t, draggingRight: n, xPosition: o, pinned: s, gos: i, colModel: r, visibleCols: a } = e;
  if (i.get("suppressMovableColumns") || t.some((b) => b.getColDef().suppressMovable))
    return [];
  const d = sT(a, s), c = r.getCols(), u = d.filter((b) => t.includes(b)), h = d.filter((b) => !t.includes(b)), g = c.filter((b) => !t.includes(b));
  let p = 0, f = o;
  if (n) {
    let b = 0;
    u.forEach((A) => b += A.getActualWidth()), f -= b;
  }
  if (f > 0) {
    for (let b = 0; b < h.length; b++) {
      const A = h[b];
      if (f -= A.getActualWidth(), f < 0)
        break;
      p++;
    }
    n && p++;
  }
  let m;
  if (p > 0) {
    const b = h[p - 1];
    m = g.indexOf(b) + 1;
  } else
    m = g.indexOf(h[0]), m === -1 && (m = 0);
  const C = [m], w = (b, A) => b - A;
  if (n) {
    let b = m + 1;
    const A = c.length - 1;
    for (; b <= A; )
      C.push(b), b++;
    C.sort(w);
  } else {
    let b = m;
    const A = c.length - 1;
    let S = c[b];
    for (; b <= A && d.indexOf(S) < 0; )
      b++, C.push(b), S = c[b];
    b = m - 1;
    const F = 0;
    for (; b >= F; )
      C.push(b), b--;
    C.sort(w).reverse();
  }
  return C;
}
function kh(e) {
  var d;
  const { pinned: t, fromKeyboard: n, gos: o, ctrlsSvc: s, useHeaderRow: i, skipScrollPadding: r } = e;
  let a = (d = s.getHeaderRowContainerCtrl(t)) == null ? void 0 : d.eViewport, { x: l } = e;
  return a ? (n && (l -= a.getBoundingClientRect().left), o.get("enableRtl") && (i && (a = a.querySelector(".ag-header-row")), l = a.clientWidth - l), t == null && !r && (l += s.get("center").getCenterViewportScrollLeft()), l) : 0;
}
function Eu(e, t) {
  for (const n of e)
    n.moving = t, n.dispatchColEvent("movingChanged", "uiColumnMoved");
}
var $m = 7, Lh = 100, Al = Lh / 2, rT = 5, aT = 100, lT = class extends U {
  constructor(e) {
    super(), this.pinned = e, this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.isCenterContainer = !ue(e);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  getIconName() {
    const { pinned: e, lastDraggingEvent: t } = this, { dragItem: n } = t || {}, o = (n == null ? void 0 : n.columns) ?? [];
    for (const s of o) {
      const i = s.getPinned();
      if (s.getColDef().lockPinned) {
        if (i == e)
          return "move";
        continue;
      }
      const r = n == null ? void 0 : n.containerType;
      if (r === e || !e)
        return "move";
      if (e && (!i || r !== e))
        return "pinned";
    }
    return "notAllowed";
  }
  onDragEnter(e) {
    const t = e.dragItem, n = t.columns;
    if (e.dragSource.type === 0)
      this.setColumnsVisible(n, !0, "uiColumnDragged");
    else {
      const s = t.visibleState, i = (n || []).filter(
        (r) => s[r.getId()] && !r.isVisible()
      );
      this.setColumnsVisible(i, !0, "uiColumnDragged");
    }
    this.gos.get("suppressMoveWhenColumnDragging") || this.attemptToPinColumns(n, this.pinned), this.onDragging(e, !0, !0);
  }
  onDragging(e = this.lastDraggingEvent, t = !1, n = !1, o = !1) {
    const { gos: s, ctrlsSvc: i } = this.beans, r = s.get("suppressMoveWhenColumnDragging");
    if (o && !r) {
      this.finishColumnMoving();
      return;
    }
    if (this.lastDraggingEvent = e, !e || !o && st(e.hDirection))
      return;
    const a = kh({
      x: e.x,
      pinned: this.pinned,
      gos: s,
      ctrlsSvc: i
    });
    t || this.checkCenterForScrolling(a), r ? this.handleColumnDragWhileSuppressingMovement(e, t, n, a, o) : this.handleColumnDragWhileAllowingMovement(e, t, n, a, o);
  }
  onDragLeave() {
    this.ensureIntervalCleared(), this.clearHighlighted(), this.updateDragItemContainerType(), this.lastMovedInfo = null;
  }
  onDragStop() {
    this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  onDragCancel() {
    this.clearHighlighted(), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  setColumnsVisible(e, t, n) {
    if (!(e != null && e.length))
      return;
    const o = e.filter((s) => !s.getColDef().lockVisible);
    o.length && this.beans.colModel.setColsVisible(o, t, n);
  }
  finishColumnMoving() {
    this.clearHighlighted();
    const e = this.lastMovedInfo;
    if (!e)
      return;
    const { columns: t, toIndex: n } = e;
    this.beans.colMoves.moveColumns(t, n, "uiColumnMoved", !0);
  }
  updateDragItemContainerType() {
    const { lastDraggingEvent: e } = this;
    if (this.gos.get("suppressMoveWhenColumnDragging") || !e)
      return;
    const t = e.dragItem;
    t && (t.containerType = this.pinned);
  }
  handleColumnDragWhileSuppressingMovement(e, t, n, o, s) {
    const i = this.getAllMovingColumns(e, !0);
    if (s) {
      const r = this.isAttemptingToPin(i);
      r && this.attemptToPinColumns(i, void 0, !0);
      const { fromLeft: a, xPosition: l } = this.getNormalisedXPositionInfo(i, r) || {};
      if (a == null || l == null) {
        this.finishColumnMoving();
        return;
      }
      this.moveColumnsAfterHighlight({
        allMovingColumns: i,
        xPosition: l,
        fromEnter: t,
        fakeEvent: n,
        fromLeft: a
      });
    } else {
      if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(e))
        return;
      this.highlightHoveredColumn(i, o);
    }
  }
  handleColumnDragWhileAllowingMovement(e, t, n, o, s) {
    const i = this.getAllMovingColumns(e), r = this.normaliseDirection(e.hDirection) === "right", a = e.dragSource.type === 1, l = this.getMoveColumnParams({
      allMovingColumns: i,
      isFromHeader: a,
      xPosition: o,
      fromLeft: r,
      fromEnter: t,
      fakeEvent: n
    }), d = dy({ ...l, finished: s });
    d && (this.lastMovedInfo = d);
  }
  getAllMovingColumns(e, t = !1) {
    const n = e.dragSource.getDragItem();
    let o = null;
    t ? (o = n.columnsInSplit, o || (o = n.columns)) : o = n.columns;
    const s = (i) => i.getColDef().lockPinned ? i.getPinned() == this.pinned : !0;
    return o ? o.filter(s) : [];
  }
  getMoveColumnParams(e) {
    const { allMovingColumns: t, isFromHeader: n, xPosition: o, fromLeft: s, fromEnter: i, fakeEvent: r } = e, { gos: a, colModel: l, colMoves: d, visibleCols: c } = this.beans;
    return {
      allMovingColumns: t,
      isFromHeader: n,
      fromLeft: s,
      xPosition: o,
      pinned: this.pinned,
      fromEnter: i,
      fakeEvent: r,
      gos: a,
      colModel: l,
      colMoves: d,
      visibleCols: c
    };
  }
  highlightHoveredColumn(e, t) {
    var c;
    const { gos: n, colModel: o } = this.beans, s = n.get("enableRtl"), i = o.getCols().filter((u) => u.isVisible() && u.getPinned() === this.pinned);
    let r = null, a = null, l = null;
    for (const u of i) {
      if (a = u.getActualWidth(), r = this.getNormalisedColumnLeft(u, 0, s), r != null) {
        const h = r + a;
        if (r <= t && h >= t) {
          l = u;
          break;
        }
      }
      r = null, a = null;
    }
    if (l)
      e.indexOf(l) !== -1 && (l = null);
    else {
      for (let u = i.length - 1; u >= 0; u--) {
        const h = i[u], g = i[u].getParent();
        if (!g) {
          l = h;
          break;
        }
        const p = g == null ? void 0 : g.getDisplayedLeafColumns();
        if (p.length) {
          l = Je(p);
          break;
        }
      }
      if (!l)
        return;
      r = this.getNormalisedColumnLeft(l, 0, s), a = l.getActualWidth();
    }
    if (((c = this.lastHighlightedColumn) == null ? void 0 : c.column) !== l && this.clearHighlighted(), l == null || r == null || a == null)
      return;
    let d;
    t - r < a / 2 !== s ? d = 0 : d = 1, zm(l, d), this.lastHighlightedColumn = { column: l, position: d };
  }
  getNormalisedXPositionInfo(e, t) {
    const { gos: n, visibleCols: o } = this.beans, s = n.get("enableRtl"), { firstMovingCol: i, column: r, position: a } = this.getColumnMoveAndTargetInfo(
      e,
      t,
      s
    );
    if (!i || !r || a == null)
      return;
    const l = o.allCols, d = l.indexOf(i), c = l.indexOf(r), u = a === 0 !== s, h = d < c || d === c && !u;
    let g = 0;
    if (u ? h && (g -= 1) : h || (g += 1), c + g === d)
      return;
    const p = l[c + g];
    if (!p)
      return;
    const f = this.getNormalisedColumnLeft(p, 20, s);
    return { fromLeft: h, xPosition: f };
  }
  getColumnMoveAndTargetInfo(e, t, n) {
    const o = this.lastHighlightedColumn || {}, { firstMovingCol: s, lastMovingCol: i } = dT(e);
    if (!s || !i || o.column || !t)
      return {
        firstMovingCol: s,
        ...o
      };
    const a = this.getPinDirection() === "left";
    return {
      firstMovingCol: s,
      position: a ? 1 : 0,
      column: a !== n ? s : i
    };
  }
  normaliseDirection(e) {
    if (this.gos.get("enableRtl"))
      switch (e) {
        case "left":
          return "right";
        case "right":
          return "left";
      }
    return e;
  }
  getNormalisedColumnLeft(e, t, n) {
    const { gos: o, ctrlsSvc: s } = this.beans, i = e.getLeft();
    if (i == null)
      return null;
    const r = e.getActualWidth();
    return kh({
      x: n ? i + r - t : i + t,
      pinned: e.getPinned(),
      useHeaderRow: n,
      skipScrollPadding: !0,
      gos: o,
      ctrlsSvc: s
    });
  }
  isAttemptingToPin(e) {
    const t = this.needToMoveLeft || this.needToMoveRight, n = this.failedMoveAttempts > $m;
    return t && n || e.some((o) => o.getPinned() !== this.pinned);
  }
  moveColumnsAfterHighlight(e) {
    const { allMovingColumns: t, xPosition: n, fromEnter: o, fakeEvent: s, fromLeft: i } = e, r = this.getMoveColumnParams({
      allMovingColumns: t,
      isFromHeader: !0,
      xPosition: n,
      fromLeft: i,
      fromEnter: o,
      fakeEvent: s
    }), { columns: a, toIndex: l } = ly(r) || {};
    a && l != null && (this.lastMovedInfo = {
      columns: a,
      toIndex: l
    }), this.finishColumnMoving();
  }
  clearHighlighted() {
    const { lastHighlightedColumn: e } = this;
    e && (zm(e.column, null), this.lastHighlightedColumn = null);
  }
  checkCenterForScrolling(e) {
    if (!this.isCenterContainer)
      return;
    const t = this.beans.ctrlsSvc.get("center"), n = t.getCenterViewportScrollLeft(), o = n + t.getCenterWidth();
    let s, i;
    this.gos.get("enableRtl") ? (s = e < n + Al, i = e > o - Al) : (i = e < n + Al, s = e > o - Al), this.needToMoveRight = s, this.needToMoveLeft = i, i || s ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
  }
  ensureIntervalStarted() {
    this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), aT), this.beans.dragAndDrop.setDragImageCompIcon(this.needToMoveLeft ? "left" : "right", !0));
  }
  ensureIntervalCleared() {
    this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.failedMoveAttempts = 0, this.beans.dragAndDrop.setDragImageCompIcon(this.getIconName()));
  }
  moveInterval() {
    var o;
    let e;
    this.intervalCount++, e = 10 + this.intervalCount * rT, e > Lh && (e = Lh);
    let t = null;
    const n = this.gridBodyCon.scrollFeature;
    if (this.needToMoveLeft ? t = n.scrollHorizontally(-e) : this.needToMoveRight && (t = n.scrollHorizontally(e)), t !== 0)
      this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
    else {
      this.failedMoveAttempts++;
      const { pinnedCols: s, dragAndDrop: i, gos: r } = this.beans;
      if (this.failedMoveAttempts <= $m + 1 || !s)
        return;
      if (i.setDragImageCompIcon("pinned"), !r.get("suppressMoveWhenColumnDragging")) {
        const a = (o = this.lastDraggingEvent) == null ? void 0 : o.dragItem.columns;
        this.attemptToPinColumns(a, void 0, !0);
      }
    }
  }
  getPinDirection() {
    if (this.needToMoveLeft || this.pinned === "left")
      return "left";
    if (this.needToMoveRight || this.pinned === "right")
      return "right";
  }
  attemptToPinColumns(e, t, n = !1) {
    const o = (e || []).filter((r) => !r.getColDef().lockPinned);
    if (!o.length)
      return 0;
    n && (t = this.getPinDirection());
    const { pinnedCols: s, dragAndDrop: i } = this.beans;
    return s == null || s.setColsPinned(o, t, "uiColumnDragged"), n && i.nudge(), o.length;
  }
  destroy() {
    super.destroy(), this.lastDraggingEvent = null, this.clearHighlighted(), this.lastMovedInfo = null;
  }
};
function zm(e, t) {
  e.highlighted !== t && (e.highlighted = t, e.dispatchColEvent("headerHighlightChanged", "uiColumnMoved"));
}
function dT(e) {
  const t = e.length;
  let n, o;
  for (let s = 0; s < t; s++) {
    if (!n) {
      const i = e[s];
      i.getLeft() != null && (n = i);
    }
    if (!o) {
      const i = e[t - 1 - s];
      i.getLeft() != null && (o = i);
    }
    if (n && o)
      break;
  }
  return { firstMovingCol: n, lastMovingCol: o };
}
var cT = class extends U {
  constructor(e, t) {
    super(), this.pinned = e, this.eContainer = t;
  }
  postConstruct() {
    const { ctrlsSvc: e, dragAndDrop: t } = this.beans, n = this.pinned;
    e.whenReady(this, (o) => {
      let s;
      const i = o.gridBodyCtrl.eBodyViewport;
      switch (n) {
        case "left":
          s = [
            [i, o.left.eContainer],
            [o.bottomLeft.eContainer],
            [o.topLeft.eContainer]
          ];
          break;
        case "right":
          s = [
            [i, o.right.eContainer],
            [o.bottomRight.eContainer],
            [o.topRight.eContainer]
          ];
          break;
        default:
          s = [
            [i, o.center.eViewport],
            [o.bottomCenter.eViewport],
            [o.topCenter.eViewport]
          ];
          break;
      }
      this.eSecondaryContainers = s;
    }), this.moveColumnFeature = this.createManagedBean(new lT(n)), this.bodyDropPivotTarget = this.createManagedBean(new JD(n)), t.addDropTarget(this), this.addDestroyFunc(() => t.removeDropTarget(this));
  }
  isInterestedIn(e) {
    return e === 1 || e === 0 && this.gos.get("allowDragFromColumnsToolPanel");
  }
  getSecondaryContainers() {
    return this.eSecondaryContainers;
  }
  getContainer() {
    return this.eContainer;
  }
  getIconName() {
    return this.currentDropListener.getIconName();
  }
  // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
  // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
  // dropped into the grid's body.
  isDropColumnInPivotMode(e) {
    return this.beans.colModel.isPivotMode() && e.dragSource.type === 0;
  }
  onDragEnter(e) {
    this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
  }
  onDragLeave(e) {
    this.currentDropListener.onDragLeave(e);
  }
  onDragging(e) {
    this.currentDropListener.onDragging(e);
  }
  onDragStop(e) {
    this.currentDropListener.onDragStop(e);
  }
  onDragCancel() {
    this.currentDropListener.onDragCancel();
  }
}, uT = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colMoves";
  }
  moveColumnByIndex(e, t, n) {
    const o = this.beans.colModel.getCols();
    if (!o)
      return;
    const s = o[e];
    this.moveColumns([s], t, n);
  }
  moveColumns(e, t, n, o = !0) {
    const { colModel: s, colAnimation: i, visibleCols: r, eventSvc: a } = this.beans, l = s.getCols();
    if (!l)
      return;
    if (t > l.length - e.length) {
      Z(30, { toIndex: t });
      return;
    }
    i == null || i.start();
    const d = s.getColsForKeys(e);
    this.doesMovePassRules(d, t) && (um(s.getCols(), d, t), r.refresh(n), a.dispatchEvent({
      type: "columnMoved",
      columns: d,
      column: d.length === 1 ? d[0] : null,
      toIndex: t,
      finished: o,
      source: n
    })), i == null || i.finish();
  }
  doesMovePassRules(e, t) {
    const n = this.getProposedColumnOrder(e, t);
    return this.doesOrderPassRules(n);
  }
  doesOrderPassRules(e) {
    const { colModel: t, gos: n } = this.beans;
    return !(!ZC(e, t.getColTree()) || !((s) => {
      const i = (d) => d ? d === "left" || d === !0 ? -1 : 1 : 0, r = n.get("enableRtl");
      let a = r ? 1 : -1, l = !0;
      return s.forEach((d) => {
        const c = i(d.getColDef().lockPosition);
        r ? c > a && (l = !1) : c < a && (l = !1), a = c;
      }), l;
    })(e));
  }
  getProposedColumnOrder(e, t) {
    const o = this.beans.colModel.getCols().slice();
    return um(o, e, t), o;
  }
  createBodyDropTarget(e, t) {
    return new cT(e, t);
  }
  moveHeader(e, t, n, o, s) {
    const { ctrlsSvc: i, gos: r, colModel: a, visibleCols: l, focusSvc: d } = this.beans, c = t.getBoundingClientRect(), u = c.left, h = Dt(n), g = h ? c.width : n.getActualWidth(), p = e === "left" !== r.get("enableRtl"), f = kh({
      x: p ? u - 20 : u + g + 20,
      pinned: o,
      fromKeyboard: !0,
      gos: r,
      ctrlsSvc: i
    }), m = d.focusedHeader;
    dy({
      allMovingColumns: h ? n.getLeafColumns() : [n],
      isFromHeader: !0,
      fromLeft: e === "right",
      xPosition: f,
      pinned: o,
      fromEnter: !1,
      fakeEvent: !1,
      gos: r,
      colModel: a,
      colMoves: this,
      visibleCols: l,
      finished: !0
    });
    let C;
    if (h) {
      const w = n.getDisplayedLeafColumns();
      C = p ? w[0] : Je(w);
    } else
      C = n;
    if (i.getScrollFeature().ensureColumnVisible(C, "auto"), (!s.isAlive() || r.get("ensureDomOrder")) && m) {
      let w;
      if (h) {
        const b = n.getGroupId(), A = n.getLeafColumns();
        if (!A.length)
          return;
        const S = A[0].getParent();
        if (!S)
          return;
        w = hT(S, b);
      } else
        w = n;
      w && d.focusHeaderPosition({
        headerPosition: {
          ...m,
          column: w
        }
      });
    }
  }
  setDragSourceForHeader(e, t, n) {
    const { gos: o, colModel: s, dragAndDrop: i, visibleCols: r } = this.beans;
    let a = !o.get("suppressDragLeaveHidesColumns");
    const l = Dt(t), d = l ? t.getProvidedColumnGroup().getLeafColumns() : [t], u = {
      type: 1,
      eElement: e,
      getDefaultIconName: () => a ? "hide" : "notAllowed",
      getDragItem: l ? () => pT(t, r.allCols) : () => gT(t),
      dragItemName: n,
      onDragStarted: () => {
        a = !o.get("suppressDragLeaveHidesColumns"), Eu(d, !0);
      },
      onDragStopped: () => Eu(d, !1),
      onDragCancelled: () => Eu(d, !1),
      onGridEnter: (h) => {
        if (a) {
          const { columns: g = [], visibleState: p } = h ?? {}, f = l ? (C) => !p || p[C.getColId()] : () => !0, m = g.filter(
            (C) => !C.getColDef().lockVisible && f(C)
          );
          s.setColsVisible(m, !0, "uiColumnMoved");
        }
      },
      onGridExit: (h) => {
        var g;
        if (a) {
          const p = ((g = h == null ? void 0 : h.columns) == null ? void 0 : g.filter((f) => !f.getColDef().lockVisible)) || [];
          s.setColsVisible(p, !1, "uiColumnMoved");
        }
      }
    };
    return i.addDragSource(u, !0), u;
  }
};
function hT(e, t) {
  for (; e; ) {
    if (e.getGroupId() === t)
      return e;
    e = e.getParent();
  }
}
function gT(e) {
  const t = {};
  return t[e.getId()] = e.isVisible(), {
    columns: [e],
    visibleState: t,
    containerType: e.pinned
  };
}
function pT(e, t) {
  var a;
  const n = e.getProvidedColumnGroup().getLeafColumns(), o = {};
  n.forEach((l) => o[l.getId()] = l.isVisible());
  const s = [];
  t.forEach((l) => {
    n.indexOf(l) >= 0 && (s.push(l), $t(n, l));
  }), n.forEach((l) => s.push(l));
  const i = [], r = e.getLeafColumns();
  for (const l of s)
    r.indexOf(l) !== -1 && i.push(l);
  return {
    columns: s,
    columnsInSplit: i,
    visibleState: o,
    containerType: (a = i[0]) == null ? void 0 : a.pinned
  };
}
var Ip = {
  moduleName: "ColumnMove",
  version: Ee,
  beans: [uT, jD],
  apiFunctions: {
    moveColumnByIndex: YD,
    moveColumns: QD
  },
  dependsOn: [sl],
  css: [qD]
}, fT = class extends U {
  constructor() {
    super(...arguments), this.beanName = "autoWidthCalc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowContainerCtrl = e.center;
    });
  }
  // this is the trick: we create a dummy container and clone all the cells
  // into the dummy, then check the dummy's width. then destroy the dummy
  // as we don't need it any more.
  // drawback: only the cells visible on the screen are considered
  getPreferredWidthForColumn(e, t) {
    const n = this.getHeaderCellForColumn(e);
    if (!n)
      return -1;
    const o = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(e);
    return t || o.push(n), this.getPreferredWidthForElements(o);
  }
  getPreferredWidthForColumnGroup(e) {
    const t = this.getHeaderCellForColumn(e);
    return t ? this.getPreferredWidthForElements([t]) : -1;
  }
  getPreferredWidthForElements(e, t) {
    const n = document.createElement("form");
    n.style.position = "fixed";
    const o = this.centerRowContainerCtrl.eContainer;
    e.forEach((i) => this.cloneItemIntoDummy(i, n)), o.appendChild(n);
    const s = n.offsetWidth;
    return o.removeChild(n), t = t ?? this.gos.get("autoSizePadding"), s + t;
  }
  getHeaderCellForColumn(e) {
    let t = null;
    return this.beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((n) => {
      const o = n.getHtmlElementForColumnHeader(e);
      o != null && (t = o);
    }), t;
  }
  cloneItemIntoDummy(e, t) {
    const n = e.cloneNode(!0);
    n.style.width = "", n.style.position = "static", n.style.left = "";
    const o = document.createElement("div"), s = o.classList;
    ["ag-header-cell", "ag-header-group-cell"].some((a) => n.classList.contains(a)) ? (s.add("ag-header", "ag-header-row"), o.style.position = "static") : s.add("ag-row");
    let r = e.parentElement;
    for (; r; ) {
      if (["ag-header-row", "ag-row"].some((l) => r.classList.contains(l))) {
        for (let l = 0; l < r.classList.length; l++) {
          const d = r.classList[l];
          d != "ag-row-position-absolute" && s.add(d);
        }
        break;
      }
      r = r.parentElement;
    }
    o.appendChild(n), t.appendChild(o);
  }
}, cy = {
  moduleName: "AutoWidth",
  version: Ee,
  beans: [fT]
};
function mT(e, t, n = !0, o = "api") {
  var s;
  (s = e.colResize) == null || s.setColumnWidths(t, !1, n, o);
}
var vT = class extends U {
  constructor(e, t, n, o) {
    super(), this.comp = e, this.eResize = t, this.pinned = n, this.columnGroup = o;
  }
  postConstruct() {
    if (!this.columnGroup.isResizable()) {
      this.comp.setResizableDisplayed(!1);
      return;
    }
    const { horizontalResizeSvc: e, gos: t, colAutosize: n } = this.beans, o = e.addResizeBar({
      eResizeBar: this.eResize,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this, !1),
      onResizeEnd: this.onResizing.bind(this, !0)
    });
    this.addDestroyFunc(o), !t.get("suppressAutoSize") && n && this.addDestroyFunc(
      n.addColumnGroupResize(
        this.eResize,
        this.columnGroup,
        () => this.resizeLeafColumnsToFit("uiColumnResized")
      )
    );
  }
  onResizeStart(e) {
    const {
      columnsToResize: t,
      resizeStartWidth: n,
      resizeRatios: o,
      groupAfterColumns: s,
      groupAfterStartWidth: i,
      groupAfterRatios: r
    } = this.getInitialValues(e);
    this.resizeCols = t, this.resizeStartWidth = n, this.resizeRatios = o, this.resizeTakeFromCols = s, this.resizeTakeFromStartWidth = i, this.resizeTakeFromRatios = r, this.toggleColumnResizing(!0);
  }
  onResizing(e, t, n = "uiColumnResized") {
    const o = this.normaliseDragChange(t), s = this.resizeStartWidth + o;
    this.resizeColumnsFromLocalValues(s, n, e);
  }
  getInitialValues(e) {
    var l;
    const t = (d) => d.reduce((c, u) => c + u.getActualWidth(), 0), n = (d, c) => d.map((u) => u.getActualWidth() / c), o = this.getColumnsToResize(), s = t(o), i = n(o, s), r = {
      columnsToResize: o,
      resizeStartWidth: s,
      resizeRatios: i
    };
    let a = null;
    if (e && (a = ((l = this.beans.colGroupSvc) == null ? void 0 : l.getGroupAtDirection(this.columnGroup, "After")) ?? null), a) {
      const d = a.getDisplayedLeafColumns(), c = r.groupAfterColumns = d.filter(
        (h) => h.isResizable()
      ), u = r.groupAfterStartWidth = t(c);
      r.groupAfterRatios = n(c, u);
    } else
      r.groupAfterColumns = void 0, r.groupAfterStartWidth = void 0, r.groupAfterRatios = void 0;
    return r;
  }
  resizeLeafColumnsToFit(e) {
    const t = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup), n = this.getInitialValues();
    t > n.resizeStartWidth && this.resizeColumns(n, t, e, !0);
  }
  resizeColumnsFromLocalValues(e, t, n = !0) {
    if (!this.resizeCols || !this.resizeRatios)
      return;
    const o = {
      columnsToResize: this.resizeCols,
      resizeStartWidth: this.resizeStartWidth,
      resizeRatios: this.resizeRatios,
      groupAfterColumns: this.resizeTakeFromCols,
      groupAfterStartWidth: this.resizeTakeFromStartWidth,
      groupAfterRatios: this.resizeTakeFromRatios
    };
    this.resizeColumns(o, e, t, n);
  }
  resizeColumns(e, t, n, o = !0) {
    var u;
    const {
      columnsToResize: s,
      resizeStartWidth: i,
      resizeRatios: r,
      groupAfterColumns: a,
      groupAfterStartWidth: l,
      groupAfterRatios: d
    } = e, c = [];
    if (c.push({
      columns: s,
      ratios: r,
      width: t
    }), a) {
      const h = t - i;
      c.push({
        columns: a,
        ratios: d,
        width: l - h
      });
    }
    (u = this.beans.colResize) == null || u.resizeColumnSets({
      resizeSets: c,
      finished: o,
      source: n
    }), o && this.toggleColumnResizing(!1);
  }
  toggleColumnResizing(e) {
    this.comp.toggleCss("ag-column-resizing", e);
  }
  getColumnsToResize() {
    return this.columnGroup.getDisplayedLeafColumns().filter((t) => t.isResizable());
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderCell - should refactor out?
  normaliseDragChange(e) {
    let t = e;
    return this.gos.get("enableRtl") ? this.pinned !== "left" && (t *= -1) : this.pinned === "right" && (t *= -1), t;
  }
  destroy() {
    super.destroy(), this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
  }
}, CT = class extends U {
  constructor(e, t, n, o, s) {
    super(), this.pinned = e, this.column = t, this.eResize = n, this.comp = o, this.ctrl = s;
  }
  postConstruct() {
    const e = [];
    let t, n;
    const o = () => {
      if (He(this.eResize, t), !t)
        return;
      const { horizontalResizeSvc: r, colAutosize: a } = this.beans, l = r.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      e.push(l), n && a && e.push(a.addColumnAutosize(this.eResize, this.column));
    }, s = () => {
      e.forEach((r) => r()), e.length = 0;
    }, i = () => {
      const r = this.column.isResizable(), a = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
      (r !== t || a !== n) && (t = r, n = a, s(), o());
    };
    i(), this.addDestroyFunc(s), this.ctrl.setRefreshFunction("resize", i);
  }
  onResizing(e, t) {
    const { column: n, lastResizeAmount: o, resizeStartWidth: s, beans: i } = this, r = this.normaliseResizeAmount(t), a = s + r, l = [{ key: n, newWidth: a }], { pinnedCols: d, ctrlsSvc: c, colResize: u } = i;
    if (this.column.getPinned()) {
      const h = (d == null ? void 0 : d.leftWidth) ?? 0, g = (d == null ? void 0 : d.rightWidth) ?? 0, p = mr(c.getGridBodyCtrl().eBodyViewport) - 50;
      if (h + g + (r - o) > p)
        return;
    }
    this.lastResizeAmount = r, u == null || u.setColumnWidths(l, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1);
  }
  onResizeStart(e) {
    this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
  }
  toggleColumnResizing(e) {
    this.column.resizing = e, this.comp.toggleCss("ag-column-resizing", e);
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
  normaliseResizeAmount(e) {
    let t = e;
    const n = this.pinned !== "left", o = this.pinned === "right";
    return this.gos.get("enableRtl") ? n && (t *= -1) : o && (t *= -1), t;
  }
}, wT = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colResize";
  }
  setColumnWidths(e, t, n, o) {
    const s = [], { colModel: i, gos: r, visibleCols: a } = this.beans;
    e.forEach((l) => {
      const d = i.getColDefCol(l.key) || i.getCol(l.key);
      if (!d)
        return;
      if (s.push({
        width: l.newWidth,
        ratios: [1],
        columns: [d]
      }), r.get("colResizeDefault") === "shift" && (t = !t), t) {
        const u = a.getColAfter(d);
        if (!u)
          return;
        const h = d.getActualWidth() - l.newWidth, g = u.getActualWidth() + h;
        s.push({
          width: g,
          ratios: [1],
          columns: [u]
        });
      }
    }), s.length !== 0 && this.resizeColumnSets({
      resizeSets: s,
      finished: n,
      source: o
    });
  }
  // method takes sets of columns and resizes them. either all sets will be resized, or nothing
  // be resized. this is used for example when user tries to resize a group and holds shift key,
  // then both the current group (grows), and the adjacent group (shrinks), will get resized,
  // so that's two sets for this method.
  resizeColumnSets(e) {
    const { resizeSets: t, finished: n, source: o } = e;
    if (!(!t || t.every((c) => yT(c)))) {
      if (n) {
        const c = t && t.length > 0 ? t[0].columns : null;
        yr(this.eventSvc, c, n, o);
      }
      return;
    }
    const i = [], r = [];
    t.forEach((c) => {
      const { width: u, columns: h, ratios: g } = c, p = {}, f = {};
      h.forEach((w) => r.push(w));
      let m = !0, C = 0;
      for (; m; ) {
        if (C++, C > 1e3) {
          $e(31);
          break;
        }
        m = !1;
        const w = [];
        let b = 0, A = u;
        h.forEach((F, E) => {
          if (f[F.getId()])
            A -= p[F.getId()];
          else {
            w.push(F);
            const I = g[E];
            b += I;
          }
        });
        const S = 1 / b;
        w.forEach((F, E) => {
          const M = E === w.length - 1;
          let I;
          M ? I = A : (I = Math.round(g[E] * u * S), A -= I);
          const P = F.getMinWidth(), k = F.getMaxWidth();
          I < P ? (I = P, f[F.getId()] = !0, m = !0) : k > 0 && I > k && (I = k, f[F.getId()] = !0, m = !0), p[F.getId()] = I;
        });
      }
      h.forEach((w) => {
        const b = p[w.getId()];
        w.getActualWidth() !== b && (w.setActualWidth(b, o), i.push(w));
      });
    });
    const a = i.length > 0;
    let l = [];
    if (a) {
      const { colFlex: c, visibleCols: u, colViewport: h } = this.beans;
      l = (c == null ? void 0 : c.refreshFlexedColumns({
        resizingCols: r,
        skipSetLeft: !0
      })) ?? [], u.setLeftValues(o), u.updateBodyWidths(), h.checkViewportColumns();
    }
    const d = r.concat(l);
    (a || n) && yr(this.eventSvc, d, n, o, l);
  }
  resizeHeader(e, t, n) {
    if (!e.isResizable())
      return;
    const o = e.getActualWidth(), s = e.getMinWidth(), i = e.getMaxWidth(), r = Math.min(Math.max(o + t, s), i);
    this.setColumnWidths([{ key: e, newWidth: r }], n, !0, "uiColumnResized");
  }
  createResizeFeature(e, t, n, o, s) {
    return new CT(e, t, n, o, s);
  }
  createGroupResizeFeature(e, t, n, o) {
    return new vT(e, t, n, o);
  }
};
function yT(e) {
  const { columns: t, width: n } = e;
  let o = 0, s = 0, i = !0;
  t.forEach((l) => {
    const d = l.getMinWidth();
    o += d || 0;
    const c = l.getMaxWidth();
    c > 0 ? s += c : i = !1;
  });
  const r = n >= o, a = !i || n <= s;
  return r && a;
}
var bT = {
  moduleName: "ColumnResize",
  version: Ee,
  beans: [wT],
  apiFunctions: {
    setColumnWidths: mT
  },
  dependsOn: [ay, cy]
}, ST = class extends U {
  constructor(e, t) {
    super(), this.removeChildListenersFuncs = [], this.columnGroup = t, this.comp = e;
  }
  postConstruct() {
    this.addListenersToChildrenColumns(), this.addManagedListeners(this.columnGroup, {
      displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
    }), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  }
  addListenersToChildrenColumns() {
    this.removeListenersOnChildrenColumns();
    const e = this.onWidthChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      t.__addEventListener("widthChanged", e), t.__addEventListener("visibleChanged", e), this.removeChildListenersFuncs.push(() => {
        t.__removeEventListener("widthChanged", e), t.__removeEventListener("visibleChanged", e);
      });
    });
  }
  removeListenersOnChildrenColumns() {
    this.removeChildListenersFuncs.forEach((e) => e()), this.removeChildListenersFuncs = [];
  }
  onDisplayedChildrenChanged() {
    this.addListenersToChildrenColumns(), this.onWidthChanged();
  }
  onWidthChanged() {
    const e = this.columnGroup.getActualWidth();
    this.comp.setWidth(`${e}px`), this.comp.toggleCss("ag-hidden", e === 0);
  }
}, xT = class extends Fp {
  constructor() {
    super(...arguments), this.onSuppressColMoveChange = () => {
      !this.isAlive() || this.isSuppressMoving() ? this.removeDragSource() : this.dragSource || this.setDragSource(this.eGui);
    };
  }
  wireComp(e, t, n, o, s) {
    const { column: i, beans: r } = this, { context: a, colNames: l, colHover: d, rangeSvc: c, colResize: u } = r;
    this.comp = e, s = Ja(this, a, s), this.setGui(t, s), this.displayName = l.getDisplayNameForColumnGroup(i, "header"), this.refreshHeaderStyles(), this.addClasses(), this.setupMovingCss(s), this.setupExpandable(s), this.setupTooltip(), this.setupAutoHeight({
      wrapperElement: o,
      compBean: s
    }), this.setupUserComp(), this.addHeaderMouseListeners(s), this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this)), this.refreshMaxHeaderHeight();
    const h = this.rowCtrl.pinned, g = i.getProvidedColumnGroup().getLeafColumns();
    d == null || d.createHoverFeature(s, g, t), c == null || c.createRangeHighlightFeature(s, i, e), s.createManagedBean(new Ap(i, t, r)), s.createManagedBean(new ST(e, i)), u ? this.resizeFeature = s.createManagedBean(
      u.createGroupResizeFeature(e, n, h, i)
    ) : e.setResizableDisplayed(!1), s.createManagedBean(
      new Hs(t, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: () => {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    ), this.addHighlightListeners(s, g), s.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners(s), s.addDestroyFunc(() => this.clearComponent());
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, n = e.getDefinition();
    return ke(t.gos, {
      colDef: n,
      columnGroup: e,
      floatingFilter: !1
    });
  }
  refreshMaxHeaderHeight() {
    const { gos: e, comp: t } = this, n = e.get("groupHeaderHeight");
    n != null ? n === 0 ? t.setHeaderWrapperHidden(!0) : t.setHeaderWrapperMaxHeight(n) : (t.setHeaderWrapperHidden(!1), t.setHeaderWrapperMaxHeight(null));
  }
  addHighlightListeners(e, t) {
    if (this.beans.gos.get("suppressMoveWhenColumnDragging"))
      for (const n of t)
        e.addManagedListeners(n, {
          headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, n)
        });
  }
  onLeafColumnHighlightChanged(e) {
    const t = this.column.getDisplayedLeafColumns(), n = t[0] === e, o = Je(t) === e;
    if (!n && !o)
      return;
    const s = e.getHighlighted(), i = !!this.rowCtrl.getHeaderCellCtrls().find((l) => l.column.isMoving());
    let r = !1, a = !1;
    if (i) {
      const l = this.beans.gos.get("enableRtl"), d = s === 1, c = s === 0;
      n && (l ? a = d : r = c), o && (l ? r = c : a = d);
    }
    this.comp.toggleCss("ag-header-highlight-before", r), this.comp.toggleCss("ag-header-highlight-after", a);
  }
  resizeHeader(e, t) {
    const { resizeFeature: n } = this;
    if (!n)
      return;
    const o = n.getInitialValues(t);
    n.resizeColumns(o, o.resizeStartWidth + e, "uiColumnResized", !0);
  }
  resizeLeafColumnsToFit(e) {
    var t;
    (t = this.resizeFeature) == null || t.resizeLeafColumnsToFit(e);
  }
  setupUserComp() {
    const { colGroupSvc: e, userCompFactory: t, gos: n, enterpriseMenuFactory: o } = this.beans, s = this.column, i = s.getProvidedColumnGroup(), r = ke(n, {
      displayName: this.displayName,
      columnGroup: s,
      setExpanded: (l) => {
        e.setColumnGroupOpened(i, l, "gridInitializing");
      },
      setTooltip: (l, d) => {
        n.assertModuleRegistered("Tooltip", 3), this.setupTooltip(l, d);
      },
      showColumnMenu: (l, d) => o == null ? void 0 : o.showMenuAfterButtonClick(
        i,
        l,
        "columnMenu",
        d
      ),
      showColumnMenuAfterMouseClick: (l, d) => o == null ? void 0 : o.showMenuAfterMouseEvent(
        i,
        l,
        "columnMenu",
        d
      ),
      eGridHeader: this.eGui
    }), a = LF(t, r);
    a && this.comp.setUserCompDetails(a);
  }
  addHeaderMouseListeners(e) {
    const t = (s) => this.handleMouseOverChange(s.type === "mouseenter"), n = () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup()), o = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column.getProvidedColumnGroup());
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: n,
      contextmenu: o
    });
  }
  handleMouseOverChange(e) {
    this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column.getProvidedColumnGroup()
    });
  }
  setupTooltip(e, t) {
    var n;
    this.tooltipFeature = (n = this.beans.tooltipSvc) == null ? void 0 : n.setupHeaderGroupTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupExpandable(e) {
    const t = this.column.getProvidedColumnGroup();
    this.refreshExpanded();
    const n = this.refreshExpanded.bind(this);
    e.addManagedListeners(t, {
      expandedChanged: n,
      expandableChanged: n
    });
  }
  refreshExpanded() {
    const { column: e } = this;
    this.expandable = e.isExpandable();
    const t = e.isExpanded();
    this.expandable ? this.comp.setAriaExpanded(t ? "true" : "false") : this.comp.setAriaExpanded(void 0), this.refreshHeaderStyles();
  }
  addClasses() {
    const { column: e } = this, t = e.getColGroupDef(), n = Nw(t, this.gos, null, e);
    e.isPadding() ? (n.push("ag-header-group-cell-no-group"), e.getLeafColumns().every((s) => s.isSpanHeaderHeight()) && n.push("ag-header-span-height")) : (n.push("ag-header-group-cell-with-group"), t != null && t.wrapHeaderText && n.push("ag-header-cell-wrap-text")), n.forEach((o) => this.comp.toggleCss(o, !0));
  }
  setupMovingCss(e) {
    const { column: t } = this, o = t.getProvidedColumnGroup().getLeafColumns(), s = () => this.comp.toggleCss("ag-header-cell-moving", t.isMoving());
    o.forEach((i) => {
      e.addManagedListeners(i, { movingChanged: s });
    }), s();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || this.focusThis();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    if (!(!this.expandable || !t) && e.key === O.ENTER) {
      const n = this.column, o = !n.isExpanded();
      this.beans.colGroupSvc.setColumnGroupOpened(
        n.getProvidedColumnGroup(),
        o,
        "uiColumnExpanded"
      );
    }
  }
  // unlike columns, this will only get called once, as we don't react on props on column groups
  // (we will always destroy and recreate this comp if something changes)
  setDragSource(e) {
    var t;
    !this.isAlive() || this.isSuppressMoving() || (this.removeDragSource(), e && (this.dragSource = ((t = this.beans.colMoves) == null ? void 0 : t.setDragSourceForHeader(e, this.column, this.displayName)) ?? null));
  }
  isSuppressMoving() {
    return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((e) => e.getColDef().suppressMovable || e.getColDef().lockPosition);
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function RT(e, t, n) {
  var o;
  (o = e.colGroupSvc) == null || o.setColumnGroupOpened(t, n, "api");
}
function ET(e, t, n) {
  var o;
  return ((o = e.colGroupSvc) == null ? void 0 : o.getColumnGroup(t, n)) ?? null;
}
function AT(e, t) {
  var n;
  return ((n = e.colGroupSvc) == null ? void 0 : n.getProvidedColGroup(t)) ?? null;
}
function FT(e, t, n) {
  return e.colNames.getDisplayNameForColumnGroup(t, n) || "";
}
function MT(e) {
  var t;
  return ((t = e.colGroupSvc) == null ? void 0 : t.getColumnGroupState()) ?? [];
}
function IT(e, t) {
  var n;
  (n = e.colGroupSvc) == null || n.setColumnGroupState(t, "api");
}
function PT(e) {
  var t;
  (t = e.colGroupSvc) == null || t.resetColumnGroupState("api");
}
function DT(e) {
  return e.visibleCols.treeLeft;
}
function TT(e) {
  return e.visibleCols.treeCenter;
}
function kT(e) {
  return e.visibleCols.treeRight;
}
function LT(e) {
  return e.visibleCols.getAllTrees();
}
function BT(e, t) {
  for (let n = 0; n < t.length; n++) {
    const o = e.indexOf(t[n]);
    o >= 0 && (e[o] = e[e.length - 1], e.pop());
  }
}
var OT = class extends U {
  constructor() {
    super(...arguments), this.beanName = "visibleCols", this.colsAndGroupsMap = {}, this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.headerGroupRowCount = 0, this.bodyWidth = 0, this.leftWidth = 0, this.rightWidth = 0, this.isBodyWidthDirty = !0;
  }
  refresh(e, t = !1) {
    const { colFlex: n, colModel: o, colGroupSvc: s, colViewport: i, selectionColSvc: r } = this.beans;
    t || this.buildTrees(o, s), s == null || s.updateOpenClosedVisibility(), this.leftCols = Au(this.treeLeft), this.centerCols = Au(this.treeCenter), this.rightCols = Au(this.treeRight), r == null || r.refreshVisibility(this.leftCols, this.centerCols, this.rightCols), this.joinColsAriaOrder(o), this.joinCols(), this.headerGroupRowCount = this.getHeaderRowCount(), this.setLeftValues(e), this.autoHeightCols = this.allCols.filter((a) => a.isAutoHeight()), n == null || n.refreshFlexedColumns(), this.updateBodyWidths(), this.setFirstRightAndLastLeftPinned(o, this.leftCols, this.rightCols, e), i.checkViewportColumns(!1), this.eventSvc.dispatchEvent({
      type: "displayedColumnsChanged",
      source: e
    });
  }
  getHeaderRowCount() {
    if (!this.gos.get("hidePaddedHeaderRows"))
      return this.beans.colModel.cols.treeDepth;
    let e = 0;
    for (const t of this.allCols) {
      let n = t.getParent();
      for (; n; ) {
        if (!n.isPadding()) {
          const o = n.getProvidedColumnGroup().getLevel() + 1;
          o > e && (e = o);
          break;
        }
        n = n.getParent();
      }
    }
    return e;
  }
  // after setColumnWidth or updateGroupsAndPresentedCols
  updateBodyWidths() {
    const e = _o(this.centerCols), t = _o(this.leftCols), n = _o(this.rightCols);
    this.isBodyWidthDirty = this.bodyWidth !== e, (this.bodyWidth !== e || this.leftWidth !== t || this.rightWidth !== n) && (this.bodyWidth = e, this.leftWidth = t, this.rightWidth = n, this.eventSvc.dispatchEvent({
      type: "columnContainerWidthChanged"
    }), this.eventSvc.dispatchEvent({
      type: "displayedColumnsWidthChanged"
    }));
  }
  // sets the left pixel position of each column
  setLeftValues(e) {
    this.setLeftValuesOfCols(e), this.setLeftValuesOfGroups();
  }
  setFirstRightAndLastLeftPinned(e, t, n, o) {
    let s, i;
    this.gos.get("enableRtl") ? (s = t ? t[0] : null, i = n ? Je(n) : null) : (s = t ? Je(t) : null, i = n ? n[0] : null), e.getCols().forEach((r) => {
      r.setLastLeftPinned(r === s, o), r.setFirstRightPinned(r === i, o);
    });
  }
  buildTrees(e, t) {
    const n = e.getColsToShow(), o = n.filter((l) => l.getPinned() == "left"), s = n.filter((l) => l.getPinned() == "right"), i = n.filter((l) => l.getPinned() != "left" && l.getPinned() != "right"), r = new ew(), a = (l) => t ? t.createColumnGroups(l) : l.columns;
    this.treeLeft = a({
      columns: o,
      idCreator: r,
      pinned: "left",
      oldDisplayedGroups: this.treeLeft
    }), this.treeRight = a({
      columns: s,
      idCreator: r,
      pinned: "right",
      oldDisplayedGroups: this.treeRight
    }), this.treeCenter = a({
      columns: i,
      idCreator: r,
      pinned: null,
      oldDisplayedGroups: this.treeCenter
    }), this.updateColsAndGroupsMap();
  }
  clear() {
    this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.ariaOrderColumns = [];
  }
  joinColsAriaOrder(e) {
    const t = e.getCols(), n = [], o = [], s = [];
    for (const i of t) {
      const r = i.getPinned();
      r ? r === !0 || r === "left" ? n.push(i) : s.push(i) : o.push(i);
    }
    this.ariaOrderColumns = n.concat(o).concat(s);
  }
  getAriaColIndex(e) {
    let t;
    return Dt(e) ? t = e.getLeafColumns()[0] : t = e, this.ariaOrderColumns.indexOf(t) + 1;
  }
  setLeftValuesOfGroups() {
    [this.treeLeft, this.treeRight, this.treeCenter].forEach((e) => {
      e.forEach((t) => {
        Dt(t) && t.checkLeft();
      });
    });
  }
  setLeftValuesOfCols(e) {
    const { colModel: t } = this.beans;
    if (!t.getColDefCols())
      return;
    const o = t.getCols().slice(0), s = this.gos.get("enableRtl");
    [this.leftCols, this.rightCols, this.centerCols].forEach((i) => {
      if (s) {
        let r = _o(i);
        i.forEach((a) => {
          r -= a.getActualWidth(), a.setLeft(r, e);
        });
      } else {
        let r = 0;
        i.forEach((a) => {
          a.setLeft(r, e), r += a.getActualWidth();
        });
      }
      BT(o, i);
    }), o.forEach((i) => {
      i.setLeft(null, e);
    });
  }
  joinCols() {
    this.gos.get("enableRtl") ? this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols) : this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
  }
  getAllTrees() {
    return this.treeLeft && this.treeRight && this.treeCenter ? this.treeLeft.concat(this.treeCenter).concat(this.treeRight) : null;
  }
  // gridPanel -> ensureColumnVisible
  isColDisplayed(e) {
    return this.allCols.indexOf(e) >= 0;
  }
  getLeftColsForRow(e) {
    const {
      leftCols: t,
      beans: { colModel: n }
    } = this;
    return n.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getRightColsForRow(e) {
    const {
      rightCols: t,
      beans: { colModel: n }
    } = this;
    return n.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getColsForRow(e, t, n, o) {
    const s = [];
    let i = null;
    for (let r = 0; r < t.length; r++) {
      const a = t[r], l = t.length - r, d = Math.min(a.getColSpan(e), l), c = [a];
      if (d > 1) {
        const h = d - 1;
        for (let g = 1; g <= h; g++)
          c.push(t[r + g]);
        r += h;
      }
      let u;
      n ? (u = !1, c.forEach((h) => {
        n(h) && (u = !0);
      })) : u = !0, u && (s.length === 0 && i && (o && o(a)) && s.push(i), s.push(a)), i = a;
    }
    return s;
  }
  getContainerWidth(e) {
    switch (e) {
      case "left":
        return this.leftWidth;
      case "right":
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  }
  getColBefore(e) {
    const t = this.allCols, n = t.indexOf(e);
    return n > 0 ? t[n - 1] : null;
  }
  isPinningLeft() {
    return this.leftCols.length > 0;
  }
  isPinningRight() {
    return this.rightCols.length > 0;
  }
  updateColsAndGroupsMap() {
    this.colsAndGroupsMap = {};
    const e = (t) => {
      this.colsAndGroupsMap[t.getUniqueId()] = t;
    };
    ui(this.treeCenter, !1, e), ui(this.treeLeft, !1, e), ui(this.treeRight, !1, e);
  }
  isVisible(e) {
    return this.colsAndGroupsMap[e.getUniqueId()] === e;
  }
  getFirstColumn() {
    const e = this.gos.get("enableRtl"), t = ["leftCols", "centerCols", "rightCols"];
    e && t.reverse();
    for (let n = 0; n < t.length; n++) {
      const o = this[t[n]];
      if (o.length)
        return e ? Je(o) : o[0];
    }
    return null;
  }
  // used by:
  // + rowRenderer -> for navigation
  getColAfter(e) {
    const t = this.allCols, n = t.indexOf(e);
    return n < t.length - 1 ? t[n + 1] : null;
  }
  // used by:
  // + angularGrid -> setting pinned body width
  // note: this should be cached
  getColsLeftWidth() {
    return _o(this.leftCols);
  }
  // note: this should be cached
  getDisplayedColumnsRightWidth() {
    return _o(this.rightCols);
  }
  isColAtEdge(e, t) {
    const n = this.allCols;
    if (!n.length)
      return !1;
    const o = t === "first";
    let s;
    if (Dt(e)) {
      const i = e.getDisplayedLeafColumns();
      if (!i.length)
        return !1;
      s = o ? i[0] : Je(i);
    } else
      s = e;
    return (o ? n[0] : Je(n)) === s;
  }
};
function ui(e, t, n) {
  if (e)
    for (let o = 0; o < e.length; o++) {
      const s = e[o];
      if (Dt(s)) {
        const i = t ? s.getDisplayedChildren() : s.getChildren();
        ui(i, t, n);
      }
      n(s);
    }
}
function Au(e) {
  const t = [];
  return ui(e, !0, (n) => {
    Io(n) && t.push(n);
  }), t;
}
var GT = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colGroupSvc";
  }
  getColumnGroupState() {
    const e = [], t = this.beans.colModel.getColTree();
    return Ao(null, t, (n) => {
      Pt(n) && e.push({
        groupId: n.getGroupId(),
        open: n.isExpanded()
      });
    }), e;
  }
  resetColumnGroupState(e) {
    const t = this.beans.colModel.getColDefColTree();
    if (!t)
      return;
    const n = [];
    Ao(null, t, (o) => {
      if (Pt(o)) {
        const s = o.getColGroupDef(), i = {
          groupId: o.getGroupId(),
          open: s ? s.openByDefault : void 0
        };
        n.push(i);
      }
    }), this.setColumnGroupState(n, e);
  }
  setColumnGroupState(e, t) {
    const { colModel: n, colAnimation: o, visibleCols: s, eventSvc: i } = this.beans;
    if (!n.getColTree().length)
      return;
    o == null || o.start();
    const a = [];
    e.forEach((l) => {
      const d = l.groupId, c = l.open, u = this.getProvidedColGroup(d);
      u && u.isExpanded() !== c && (u.setExpanded(c), a.push(u));
    }), s.refresh(t, !0), a.length && i.dispatchEvent({
      type: "columnGroupOpened",
      columnGroup: a.length === 1 ? a[0] : void 0,
      columnGroups: a
    }), o == null || o.finish();
  }
  // called by headerRenderer - when a header is opened or closed
  setColumnGroupOpened(e, t, n) {
    let o;
    Pt(e) ? o = e.getId() : o = e || "", this.setColumnGroupState([{ groupId: o, open: t }], n);
  }
  getProvidedColGroup(e) {
    let t = null;
    return Ao(null, this.beans.colModel.getColTree(), (n) => {
      Pt(n) && n.getId() === e && (t = n);
    }), t;
  }
  getGroupAtDirection(e, t) {
    const n = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), o = e.getDisplayedLeafColumns(), s = t === "After" ? Je(o) : o[0], i = `getCol${t}`;
    for (; ; ) {
      const r = this.beans.visibleCols[i](s);
      if (!r)
        return null;
      const a = this.getColGroupAtLevel(r, n);
      if (a !== e)
        return a;
    }
  }
  getColGroupAtLevel(e, t) {
    let n = e.getParent(), o, s;
    for (; o = n.getProvidedColumnGroup().getLevel(), s = n.getPaddingLevel(), !(o + s <= t); )
      n = n.getParent();
    return n;
  }
  updateOpenClosedVisibility() {
    const e = this.beans.visibleCols.getAllTrees();
    ui(e, !1, (t) => {
      Dt(t) && t.calculateDisplayedColumns();
    });
  }
  // returns the group with matching colId and instanceId. If instanceId is missing,
  // matches only on the colId.
  getColumnGroup(e, t) {
    if (!e)
      return null;
    if (Dt(e))
      return e;
    const n = this.beans.visibleCols.getAllTrees(), o = typeof t == "number";
    let s = null;
    return ui(n, !1, (i) => {
      if (Dt(i)) {
        const r = i;
        let a;
        o ? a = e === r.getGroupId() && t === r.getPartId() : a = e === r.getGroupId(), a && (s = r);
      }
    }), s;
  }
  createColumnGroups(e) {
    const { columns: t, idCreator: n, pinned: o, oldDisplayedGroups: s, isStandaloneStructure: i } = e, r = this.mapOldGroupsById(s), a = [];
    let l = t;
    for (; l.length; ) {
      const d = l;
      l = [];
      let c = 0;
      const u = (h) => {
        const g = c;
        c = h;
        const p = d[g], m = (Dt(p) ? p.getProvidedColumnGroup() : p).getOriginalParent();
        if (m == null) {
          for (let w = g; w < h; w++)
            a.push(d[w]);
          return;
        }
        const C = this.createColumnGroup(
          m,
          n,
          r,
          o,
          i
        );
        for (let w = g; w < h; w++)
          C.addChild(d[w]);
        l.push(C);
      };
      for (let h = 1; h < d.length; h++) {
        const g = d[h], f = (Dt(g) ? g.getProvidedColumnGroup() : g).getOriginalParent(), m = d[c], w = (Dt(m) ? m.getProvidedColumnGroup() : m).getOriginalParent();
        f !== w && u(h);
      }
      c < d.length && u(d.length);
    }
    return i || this.setupParentsIntoCols(a, null), a;
  }
  createProvidedColumnGroup(e, t, n, o, s, i, r) {
    const a = s.getUniqueKey(t.groupId || null, null), l = yh(this.beans, t, a), d = new er(l, a, !1, n);
    this.createBean(d);
    const c = this.findExistingGroup(t, i);
    c && i.splice(c.idx, 1);
    const u = c == null ? void 0 : c.group;
    u && d.setExpanded(u.isExpanded());
    const h = $C(
      this.beans,
      l.children,
      n + 1,
      e,
      o,
      s,
      i,
      r
    );
    return d.setChildren(h), d;
  }
  balanceColumnTree(e, t, n, o) {
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const r = e[i];
      if (Pt(r)) {
        const a = r, l = this.balanceColumnTree(
          a.getChildren(),
          t + 1,
          n,
          o
        );
        a.setChildren(l), s.push(a);
      } else {
        let a, l;
        for (let d = t; d < n; d++) {
          const c = o.getUniqueKey(null, null), u = yh(this.beans, null, c), h = new er(u, c, !0, d);
          this.createBean(h), l && l.setChildren([h]), l = h, a || (a = l);
        }
        if (a && l)
          if (s.push(a), e.some((c) => Pt(c))) {
            l.setChildren([r]);
            continue;
          } else {
            l.setChildren(e);
            break;
          }
        s.push(r);
      }
    }
    return s;
  }
  findDepth(e) {
    let t = 0, n = e;
    for (; n && n[0] && Pt(n[0]); )
      t++, n = n[0].getChildren();
    return t;
  }
  findMaxDepth(e, t) {
    let n = t;
    for (let o = 0; o < e.length; o++) {
      const s = e[o];
      if (Pt(s)) {
        const i = s, r = this.findMaxDepth(i.getChildren(), t + 1);
        n < r && (n = r);
      }
    }
    return n;
  }
  /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */
  balanceTreeForAutoCols(e, t) {
    const n = [];
    return e.forEach((o) => {
      let s = o;
      for (let i = t - 1; i >= 0; i--) {
        const r = new er(null, `FAKE_PATH_${o.getId()}}_${i}`, !0, i);
        this.createBean(r), r.setChildren([s]), s.originalParent = r, s = r;
      }
      t === 0 && (o.originalParent = null), n.push(s);
    }), n;
  }
  findExistingGroup(e, t) {
    if (e.groupId != null)
      for (let o = 0; o < t.length; o++) {
        const s = t[o];
        if (s.getColGroupDef() && s.getId() === e.groupId)
          return { idx: o, group: s };
      }
  }
  createColumnGroup(e, t, n, o, s) {
    const i = e.getGroupId(), r = t.getInstanceIdForKey(i), a = bw(i, r);
    let l = n[a];
    return l && l.getProvidedColumnGroup() !== e && (l = null), ue(l) ? l.reset() : (l = new Ba(e, i, r, o), s || this.createBean(l)), l;
  }
  // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
  mapOldGroupsById(e) {
    const t = {}, n = (o) => {
      o.forEach((s) => {
        if (Dt(s)) {
          const i = s;
          t[s.getUniqueId()] = i, n(i.getChildren());
        }
      });
    };
    return e && n(e), t;
  }
  setupParentsIntoCols(e, t) {
    e.forEach((n) => {
      if (n.parent !== t && (this.beans.colViewport.colsWithinViewportHash = ""), n.parent = t, Dt(n)) {
        const o = n;
        this.setupParentsIntoCols(o.getChildren(), o);
      }
    });
  }
}, uy = {
  moduleName: "ColumnGroup",
  version: Ee,
  dynamicBeans: { headerGroupCellCtrl: xT },
  beans: [GT],
  apiFunctions: {
    getAllDisplayedColumnGroups: LT,
    getCenterDisplayedColumnGroups: TT,
    getColumnGroup: ET,
    getColumnGroupState: MT,
    getDisplayNameForColumnGroup: FT,
    getLeftDisplayedColumnGroups: DT,
    getProvidedColumnGroup: AT,
    getRightDisplayedColumnGroups: kT,
    resetColumnGroupState: PT,
    setColumnGroupOpened: RT,
    setColumnGroupState: IT
  }
}, HT = { tag: "div", cls: "ag-skeleton-container" }, VT = class extends Te {
  constructor() {
    super(HT);
  }
  init(e) {
    const t = `ag-cell-skeleton-renderer-${this.getCompId()}`;
    this.getGui().setAttribute("id", t), this.addDestroyFunc(() => Ms(e.eParentOfValue)), Ms(e.eParentOfValue, t), e.deferRender ? this.setupLoading(e) : e.node.failedLoad ? this.setupFailed() : this.setupLoading(e);
  }
  setupFailed() {
    const e = this.getLocaleTextFunc();
    this.getGui().textContent = e("loadingError", "ERR");
    const t = e("ariaSkeletonCellLoadingFailed", "Row failed to load");
    yt(this.getGui(), t);
  }
  setupLoading(e) {
    const t = Ue({
      tag: "div",
      cls: "ag-skeleton-effect"
    }), n = e.node.rowIndex;
    if (n != null) {
      const i = 75 + 25 * (n % 2 === 0 ? Math.sin(n) : Math.cos(n));
      t.style.width = `${i}%`;
    }
    this.getGui().appendChild(t);
    const o = this.getLocaleTextFunc(), s = e.deferRender ? o("ariaDeferSkeletonCellLoading", "Cell is loading") : o("ariaSkeletonCellLoading", "Row data is loading");
    yt(this.getGui(), s);
  }
  refresh(e) {
    return !1;
  }
}, _T = {
  moduleName: "CheckboxCellRenderer",
  version: Ee,
  userComponents: {
    agCheckboxCellRenderer: TP
  }
}, NT = {
  moduleName: "SkeletonCellRenderer",
  version: Ee,
  userComponents: {
    agSkeletonCellRenderer: VT
  }
};
function $T(e, t) {
  const n = e.colModel.getColDefCol(t);
  return n ? n.getColDef() : null;
}
function zT(e) {
  return e.colModel.getColumnDefs();
}
function WT(e, t, n) {
  return e.colNames.getDisplayNameForColumn(t, n) || "";
}
function UT(e, t) {
  return e.colModel.getColDefCol(t);
}
function KT(e) {
  return e.colModel.getColDefCols();
}
function ZT(e, t) {
  return cn(e, t, "api");
}
function qT(e) {
  return Ed(e);
}
function jT(e) {
  QC(e, "api");
}
function YT(e) {
  return e.visibleCols.isPinningLeft() || e.visibleCols.isPinningRight();
}
function QT(e) {
  return e.visibleCols.isPinningLeft();
}
function JT(e) {
  return e.visibleCols.isPinningRight();
}
function XT(e, t) {
  return e.visibleCols.getColAfter(t);
}
function e4(e, t) {
  return e.visibleCols.getColBefore(t);
}
function t4(e, t, n) {
  e.colModel.setColsVisible(t, n, "api");
}
function n4(e, t, n) {
  var o;
  (o = e.pinnedCols) == null || o.setColsPinned(t, n, "api");
}
function o4(e) {
  return e.colModel.getCols();
}
function s4(e) {
  return e.visibleCols.leftCols;
}
function i4(e) {
  return e.visibleCols.centerCols;
}
function r4(e) {
  return e.visibleCols.rightCols;
}
function a4(e) {
  return e.visibleCols.allCols;
}
function l4(e) {
  return e.colViewport.getViewportColumns();
}
function Bh(e, t) {
  if (!e)
    return;
  const n = e, o = {};
  return Object.keys(n).forEach((s) => {
    if (t && t.indexOf(s) >= 0 || xC.has(s))
      return;
    const i = n[s];
    typeof i == "object" && i !== null && i.constructor === Object ? o[s] = Bh(i) : o[s] = i;
  }), o;
}
var d4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colDefFactory";
  }
  wireBeans(e) {
    this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc;
  }
  getColumnDefs(e, t, n, o) {
    var a, l;
    const s = e.slice();
    t ? s.sort((d, c) => n.indexOf(d) - n.indexOf(c)) : n && s.sort((d, c) => o.indexOf(d) - o.indexOf(c));
    const i = (a = this.rowGroupColsSvc) == null ? void 0 : a.columns, r = (l = this.pivotColsSvc) == null ? void 0 : l.columns;
    return this.buildColumnDefs(s, i, r);
  }
  buildColumnDefs(e, t = [], n = []) {
    const o = [], s = {};
    return e.forEach((i) => {
      const r = this.createDefFromColumn(i, t, n);
      let a = !0, l = r, d = i.getOriginalParent(), c = null;
      for (; d; ) {
        let u = null;
        if (d.isPadding()) {
          d = d.getOriginalParent();
          continue;
        }
        const h = s[d.getGroupId()];
        if (h) {
          h.children.push(l), a = !1;
          break;
        }
        if (u = this.createDefFromGroup(d), u && (u.children = [l], s[u.groupId] = u, l = u, d = d.getOriginalParent()), d != null && c === d) {
          a = !1;
          break;
        }
        c = d;
      }
      a && o.push(l);
    }), o;
  }
  createDefFromGroup(e) {
    const t = Bh(e.getColGroupDef(), ["children"]);
    return t && (t.groupId = e.getGroupId()), t;
  }
  createDefFromColumn(e, t, n) {
    const o = Bh(e.getColDef());
    return o.colId = e.getColId(), o.width = e.getActualWidth(), o.rowGroup = e.isRowGroupActive(), o.rowGroupIndex = e.isRowGroupActive() ? t.indexOf(e) : null, o.pivot = e.isPivotActive(), o.pivotIndex = e.isPivotActive() ? n.indexOf(e) : null, o.aggFunc = e.isValueActive() ? e.getAggFunc() : null, o.hide = e.isVisible() ? void 0 : !0, o.pinned = e.isPinned() ? e.getPinned() : null, o.sort = e.getSort() ? e.getSort() : null, o.sortIndex = e.getSortIndex() != null ? e.getSortIndex() : null, o;
  }
}, c4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colFlex";
  }
  refreshFlexedColumns(e = {}) {
    const t = e.source ?? "flex";
    e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth);
    const n = this.flexViewportWidth, { visibleCols: o, colDelayRenderSvc: s } = this.beans, i = o.centerCols;
    let r = -1;
    if (e.resizingCols) {
      const f = new Set(e.resizingCols);
      for (let m = i.length - 1; m >= 0; m--)
        if (f.has(i[m])) {
          r = m;
          break;
        }
    }
    let a = !1;
    const l = i.map((f, m) => {
      const C = f.getFlex(), w = C != null && C > 0 && m > r;
      return a || (a = w), {
        col: f,
        isFlex: w,
        flex: Math.max(0, C ?? 0),
        initialSize: f.getActualWidth(),
        min: f.getMinWidth(),
        max: f.getMaxWidth(),
        targetSize: 0
      };
    });
    if (a && (s == null || s.hideColumns("colFlex")), !n || !a)
      return [];
    let d = l.length, c = l.reduce((f, m) => f + m.flex, 0), u = n;
    const h = (f, m) => {
      f.frozenSize = m, f.col.setActualWidth(m, t), u -= m, c -= f.flex, d -= 1;
    }, g = (f) => f.frozenSize != null;
    for (const f of l)
      f.isFlex || h(f, f.initialSize);
    for (; d > 0; ) {
      const f = Math.round(c < 1 ? u * c : u);
      let m, C = 0, w = 0;
      for (const S of l) {
        if (g(S))
          continue;
        m = S, w += f * (S.flex / c);
        const F = w - C, E = Math.round(F);
        S.targetSize = E, C += E;
      }
      m && (m.targetSize += f - C);
      let b = 0;
      for (const S of l) {
        if (g(S))
          continue;
        const F = S.targetSize, E = Math.min(Math.max(F, S.min), S.max);
        b += E - F, S.violationType = E === F ? void 0 : E < F ? "max" : "min", S.targetSize = E;
      }
      const A = b === 0 ? "all" : b > 0 ? "min" : "max";
      for (const S of l)
        g(S) || (A === "all" || S.violationType === A) && h(S, S.targetSize);
    }
    e.skipSetLeft || o.setLeftValues(t), e.updateBodyWidths && o.updateBodyWidths();
    const p = l.filter((f) => f.isFlex && !f.violationType).map((f) => f.col);
    if (e.fireResizedEvent) {
      const f = l.filter((C) => C.initialSize !== C.frozenSize).map((C) => C.col), m = l.filter((C) => C.flex).map((C) => C.col);
      yr(this.eventSvc, f, !0, t, m);
    }
    return s == null || s.revealColumns("colFlex"), p;
  }
  initCol(e) {
    const { flex: t, initialFlex: n } = e.colDef;
    t !== void 0 ? e.flex = t : n !== void 0 && (e.flex = n);
  }
  // this method should only be used by the colModel to
  // change flex when required by the applyColumnState method.
  setColFlex(e, t) {
    e.flex = t ?? null, e.dispatchStateUpdatedEvent("flex");
  }
};
function la(e, t, n) {
  if (!t || !e)
    return;
  if (!n)
    return e[t];
  const o = t.split(".");
  let s = e;
  for (let i = 0; i < o.length; i++) {
    if (s == null)
      return;
    s = s[o[i]];
  }
  return s;
}
var u4 = [
  "dateTimeString",
  "dateString",
  "text",
  "number",
  "boolean",
  "date"
], h4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "dataTypeSvc", this.dataTypeDefinitions = {}, this.isPendingInference = !1, this.isColumnTypeOverrideInDataTypeDefinitions = !1, this.columnStateUpdatesPendingInference = {}, this.columnStateUpdateListenerDestroyFuncs = [], this.columnDefinitionPropsPerDataType = {
      number() {
        return { cellEditor: "agNumberCellEditor" };
      },
      boolean() {
        return {
          cellEditor: "agCheckboxCellEditor",
          cellRenderer: "agCheckboxCellRenderer",
          getFindText: () => null,
          suppressKeyboardEvent: (e) => !!e.colDef.editable && e.event.key === O.SPACE
        };
      },
      date({ formatValue: e }) {
        return { cellEditor: "agDateCellEditor", keyCreator: e };
      },
      dateString({ formatValue: e }) {
        return { cellEditor: "agDateStringCellEditor", keyCreator: e };
      },
      dateTime(e) {
        return this.date(e);
      },
      dateTimeString(e) {
        return this.dateString(e);
      },
      object({ formatValue: e, colModel: t, colId: n }) {
        return {
          cellEditorParams: {
            useFormatter: !0
          },
          comparator: (o, s) => {
            const i = t.getColDefCol(n), r = i == null ? void 0 : i.getColDef();
            if (!i || !r)
              return 0;
            const a = o == null ? "" : e({ column: i, node: null, value: o }), l = s == null ? "" : e({ column: i, node: null, value: s });
            return a === l ? 0 : a > l ? 1 : -1;
          },
          keyCreator: e
        };
      },
      text() {
        return {};
      }
    };
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  postConstruct() {
    this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", (e) => {
      this.processDataTypeDefinitions(), this.colModel.recreateColumnDefs(e);
    });
  }
  processDataTypeDefinitions() {
    const e = this.getDefaultDataTypes(), t = {}, n = {}, o = (c) => (u) => {
      const { column: h, node: g, value: p } = u;
      let f = h.getColDef().valueFormatter;
      return f === c.groupSafeValueFormatter && (f = c.valueFormatter), this.beans.valueSvc.formatValue(h, g, p, f);
    };
    for (const c of Object.keys(e)) {
      const u = e[c], h = {
        ...u,
        groupSafeValueFormatter: Km(u, this.gos)
      };
      t[c] = h, n[c] = o(h);
    }
    const s = this.gos.get("dataTypeDefinitions") ?? {}, i = {};
    for (const c of Object.keys(s)) {
      const u = s[c], h = this.processDataTypeDefinition(
        u,
        s,
        [c],
        e
      );
      h && (t[c] = h, u.dataTypeMatcher && (i[c] = u.dataTypeMatcher), n[c] = o(h));
    }
    const { valueParser: r, valueFormatter: a } = e.object, { valueParser: l, valueFormatter: d } = t.object;
    this.hasObjectValueParser = l !== r, this.hasObjectValueFormatter = d !== a, this.formatValueFuncs = n, this.dataTypeDefinitions = t, this.dataTypeMatchers = this.sortKeysInMatchers(i, e);
  }
  /**
   * Sorts the keys in the matchers object.
   * Does not mutate the original object, creates a copy of it with sorted keys instead.
   */
  sortKeysInMatchers(e, t) {
    const n = { ...e };
    for (const o of u4)
      delete n[o], n[o] = e[o] ?? t[o].dataTypeMatcher;
    return n;
  }
  processDataTypeDefinition(e, t, n, o) {
    let s;
    const i = e.extendsDataType;
    if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
      let r = o[i];
      const a = t[i];
      if (r && a && (r = a), !Um(e, r, i))
        return;
      s = Wm(r, e);
    } else {
      if (n.includes(i)) {
        Z(44);
        return;
      }
      const r = t[i];
      if (!Um(e, r, i))
        return;
      const a = this.processDataTypeDefinition(
        r,
        t,
        [...n, i],
        o
      );
      if (!a)
        return;
      s = Wm(a, e);
    }
    return {
      ...s,
      groupSafeValueFormatter: Km(s, this.gos)
    };
  }
  updateColDefAndGetColumnType(e, t, n) {
    let { cellDataType: o } = t;
    const { field: s } = t;
    if (o === void 0 && (o = e.cellDataType), (o == null || o === !0) && (o = this.canInferCellDataType(e, t) ? this.inferCellDataType(s, n) : !1), !o) {
      e.cellDataType = !1;
      return;
    }
    const i = this.dataTypeDefinitions[o];
    if (!i) {
      Z(47, { cellDataType: o });
      return;
    }
    return e.cellDataType = o, i.groupSafeValueFormatter && (e.valueFormatter = i.groupSafeValueFormatter), i.valueParser && (e.valueParser = i.valueParser), i.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, o, i, n), i.columnTypes;
  }
  addColumnListeners(e) {
    if (!this.isPendingInference)
      return;
    const t = this.columnStateUpdatesPendingInference[e.getColId()];
    if (!t)
      return;
    const n = (o) => {
      t.add(o.key);
    };
    e.__addEventListener("columnStateUpdated", n), this.columnStateUpdateListenerDestroyFuncs.push(
      () => e.__removeEventListener("columnStateUpdated", n)
    );
  }
  canInferCellDataType(e, t) {
    const { gos: n } = this;
    if (!Ct(n))
      return !1;
    const o = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
    if (Fu(t, o))
      return !1;
    const s = t.type === null ? e.type : t.type;
    if (s) {
      const i = n.get("columnTypes") ?? {};
      if (Rd(s).some((a) => {
        const l = i[a.trim()];
        return l && Fu(l, o);
      }))
        return !1;
    }
    return !Fu(e, o);
  }
  inferCellDataType(e, t) {
    if (!e)
      return;
    let n;
    const o = this.getInitialData();
    if (o) {
      const i = e.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
      n = la(o, e, i);
    } else
      this.initWaitForRowData(t);
    return n == null ? void 0 : Object.keys(this.dataTypeMatchers).find(
      (i) => this.dataTypeMatchers[i](n)
    ) ?? "object";
  }
  getInitialData() {
    var t;
    const e = this.gos.get("rowData");
    if (e != null && e.length)
      return e[0];
    if (this.initialData)
      return this.initialData;
    {
      const n = (t = this.beans.rowModel.rootNode) == null ? void 0 : t.allLeafChildren;
      if (n != null && n.length)
        return n[0].data;
    }
    return null;
  }
  initWaitForRowData(e) {
    if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), this.isPendingInference)
      return;
    this.isPendingInference = !0;
    const t = this.isColumnTypeOverrideInDataTypeDefinitions, { colAutosize: n, eventSvc: o } = this.beans;
    t && n && (n.shouldQueueResizeOperations = !0);
    const [s] = this.addManagedEventListeners({
      rowDataUpdateStarted: (i) => {
        const { firstRowData: r } = i;
        r && (s == null || s(), this.isPendingInference = !1, this.processColumnsPendingInference(r, t), this.columnStateUpdatesPendingInference = {}, t && (n == null || n.processResizeOperations()), o.dispatchEvent({
          type: "dataTypesInferred"
        }));
      }
    });
  }
  processColumnsPendingInference(e, t) {
    this.initialData = e;
    const n = [];
    this.destroyColumnStateUpdateListeners();
    const o = {}, s = {};
    for (const i of Object.keys(this.columnStateUpdatesPendingInference)) {
      const r = this.columnStateUpdatesPendingInference[i], a = this.colModel.getCol(i);
      if (!a)
        return;
      const l = a.getColDef();
      if (!this.resetColDefIntoCol(a, "cellDataTypeInferred"))
        return;
      const d = a.getColDef();
      if (t && d.type && d.type !== l.type) {
        const c = p4(a, r);
        c.rowGroup && c.rowGroupIndex == null && (o[i] = c), c.pivot && c.pivotIndex == null && (s[i] = c), n.push(c);
      }
    }
    t && n.push(
      ...this.generateColumnStateForRowGroupAndPivotIndexes(
        o,
        s
      )
    ), n.length && cn(this.beans, { state: n }, "cellDataTypeInferred"), this.initialData = null;
  }
  generateColumnStateForRowGroupAndPivotIndexes(e, t) {
    const n = {}, { rowGroupColsSvc: o, pivotColsSvc: s } = this.beans;
    return o == null || o.restoreColumnOrder(n, e), s == null || s.restoreColumnOrder(n, t), Object.values(n);
  }
  resetColDefIntoCol(e, t) {
    const n = e.getUserProvidedColDef();
    if (!n)
      return !1;
    const o = yi(this.beans, n, e.getColId());
    return e.setColDef(o, n, t), !0;
  }
  getDateStringTypeDefinition(e) {
    const { dateString: t } = this.dataTypeDefinitions;
    return e ? this.getDataTypeDefinition(e) ?? t : t;
  }
  getDateParserFunction(e) {
    return this.getDateStringTypeDefinition(e).dateParser;
  }
  getDateFormatterFunction(e) {
    return this.getDateStringTypeDefinition(e).dateFormatter;
  }
  getDateIncludesTimeFlag(e) {
    return e === "dateTime" || e === "dateTimeString";
  }
  getDataTypeDefinition(e) {
    const t = e.getColDef();
    if (t.cellDataType)
      return this.dataTypeDefinitions[t.cellDataType];
  }
  getBaseDataType(e) {
    var t;
    return (t = this.getDataTypeDefinition(e)) == null ? void 0 : t.baseDataType;
  }
  checkType(e, t) {
    var o;
    if (t == null)
      return !0;
    const n = (o = this.getDataTypeDefinition(e)) == null ? void 0 : o.dataTypeMatcher;
    return n ? n(t) : !0;
  }
  validateColDef(e) {
    const t = (n) => Z(48, { property: n });
    if (e.cellDataType === "object") {
      const { object: n } = this.dataTypeDefinitions;
      e.valueFormatter === n.groupSafeValueFormatter && !this.hasObjectValueFormatter && t("Formatter"), e.editable && e.valueParser === n.valueParser && !this.hasObjectValueParser && t("Parser");
    }
  }
  postProcess(e) {
    var r;
    const t = e.cellDataType;
    if (!t || typeof t != "string")
      return;
    const { dataTypeDefinitions: n, beans: o, formatValueFuncs: s } = this, i = n[t];
    i && ((r = o.colFilter) == null || r.setColDefPropsForDataType(e, i, s[t]));
  }
  // noinspection JSUnusedGlobalSymbols
  getFormatValue(e) {
    return this.formatValueFuncs[e];
  }
  isColPendingInference(e) {
    return this.isPendingInference && !!this.columnStateUpdatesPendingInference[e];
  }
  setColDefPropertiesForBaseDataType(e, t, n, o) {
    const s = this.formatValueFuncs[t], i = this.columnDefinitionPropsPerDataType[n.baseDataType]({
      colDef: e,
      cellDataType: t,
      colModel: this.colModel,
      dataTypeDefinition: n,
      colId: o,
      formatValue: s
    });
    Object.assign(e, i);
  }
  getDateObjectTypeDef(e) {
    const t = this.getLocaleTextFunc(), n = this.getDateIncludesTimeFlag(e);
    return {
      baseDataType: e,
      valueParser: (o) => Qt(o.newValue && String(o.newValue)),
      valueFormatter: (o) => o.value == null ? "" : !(o.value instanceof Date) || isNaN(o.value.getTime()) ? t("invalidDate", "Invalid Date") : un(o.value, n) ?? "",
      dataTypeMatcher: (o) => o instanceof Date
    };
  }
  getDateStringTypeDef(e) {
    const t = this.getDateIncludesTimeFlag(e);
    return {
      baseDataType: e,
      dateParser: (n) => Qt(n) ?? void 0,
      dateFormatter: (n) => un(n ?? null, t) ?? void 0,
      valueParser: (n) => Yl(String(n.newValue)) ? n.newValue : null,
      valueFormatter: (n) => Yl(String(n.value)) ? String(n.value) : "",
      dataTypeMatcher: (n) => typeof n == "string" && Yl(n)
    };
  }
  getDefaultDataTypes() {
    const e = this.getLocaleTextFunc();
    return {
      number: {
        baseDataType: "number",
        // can be empty space with legacy copy
        valueParser: (t) => {
          var n, o;
          return ((o = (n = t.newValue) == null ? void 0 : n.trim) == null ? void 0 : o.call(n)) === "" ? null : Number(t.newValue);
        },
        valueFormatter: (t) => t.value == null ? "" : typeof t.value != "number" || isNaN(t.value) ? e("invalidNumber", "Invalid Number") : String(t.value),
        dataTypeMatcher: (t) => typeof t == "number"
      },
      text: {
        baseDataType: "text",
        valueParser: (t) => t.newValue === "" ? null : Pn(t.newValue),
        dataTypeMatcher: (t) => typeof t == "string"
      },
      boolean: {
        baseDataType: "boolean",
        valueParser: (t) => {
          var n, o;
          return t.newValue == null ? t.newValue : ((o = (n = t.newValue) == null ? void 0 : n.trim) == null ? void 0 : o.call(n)) === "" ? null : String(t.newValue).toLowerCase() === "true";
        },
        valueFormatter: (t) => t.value == null ? "" : String(t.value),
        dataTypeMatcher: (t) => typeof t == "boolean"
      },
      date: this.getDateObjectTypeDef("date"),
      dateString: this.getDateStringTypeDef("dateString"),
      dateTime: this.getDateObjectTypeDef("dateTime"),
      dateTimeString: {
        ...this.getDateStringTypeDef("dateTimeString"),
        dataTypeMatcher: (t) => typeof t == "string" && QF(t)
      },
      object: {
        baseDataType: "object",
        valueParser: () => null,
        valueFormatter: (t) => Pn(t.value) ?? ""
      }
    };
  }
  destroyColumnStateUpdateListeners() {
    this.columnStateUpdateListenerDestroyFuncs.forEach((e) => e()), this.columnStateUpdateListenerDestroyFuncs = [];
  }
  destroy() {
    this.dataTypeDefinitions = {}, this.dataTypeMatchers = {}, this.formatValueFuncs = {}, this.columnStateUpdatesPendingInference = {}, this.destroyColumnStateUpdateListeners(), super.destroy();
  }
};
function Wm(e, t) {
  const n = {
    ...e,
    ...t
  };
  return e.columnTypes && t.columnTypes && t.appendColumnTypes && (n.columnTypes = [
    ...Rd(e.columnTypes),
    ...Rd(t.columnTypes)
  ]), n;
}
function Um(e, t, n) {
  return t ? t.baseDataType !== e.baseDataType ? (Z(46), !1) : !0 : (Z(45, { parentCellDataType: n }), !1);
}
function Km(e, t) {
  if (e.valueFormatter)
    return (n) => {
      var o, s;
      if ((o = n.node) != null && o.group) {
        const i = (n.colDef.pivotValueColumn ?? n.column).getAggFunc();
        if (i) {
          if (i === "first" || i === "last")
            return e.valueFormatter(n);
          if (e.baseDataType === "number" && i !== "count") {
            if (typeof n.value == "number")
              return e.valueFormatter(n);
            if (typeof n.value == "object") {
              if (!n.value)
                return;
              if ("toNumber" in n.value)
                return e.valueFormatter({
                  ...n,
                  value: n.value.toNumber()
                });
              if ("value" in n.value)
                return e.valueFormatter({
                  ...n,
                  value: n.value.value
                });
            }
          }
          return;
        }
      } else if (t.get("groupHideOpenParents") && n.column.isRowGroupActive() && typeof n.value == "string" && !((s = e.dataTypeMatcher) != null && s.call(e, n.value)))
        return;
      return e.valueFormatter(n);
    };
}
function g4(e, t, n, o) {
  if (!t[n])
    return !1;
  const s = e[n];
  return s === null ? (t[n] = !1, !1) : o === void 0 ? !!s : s === o;
}
function Fu(e, t) {
  return [
    ["cellRenderer", "agSparklineCellRenderer"],
    ["valueGetter", void 0],
    ["valueParser", void 0],
    ["refData", void 0]
  ].some(
    ([n, o]) => g4(e, t, n, o)
  );
}
function p4(e, t) {
  const n = XC(e);
  return t.forEach((o) => {
    delete n[o], o === "rowGroup" ? delete n.rowGroupIndex : o === "pivot" && delete n.pivotIndex;
  }), n;
}
var f4 = {
  moduleName: "DataType",
  version: Ee,
  beans: [h4],
  dependsOn: [_T]
}, m4 = {
  moduleName: "ColumnFlex",
  version: Ee,
  beans: [c4]
}, hy = {
  moduleName: "ColumnApi",
  version: Ee,
  beans: [d4],
  apiFunctions: {
    getColumnDef: $T,
    getDisplayNameForColumn: WT,
    getColumn: UT,
    getColumns: KT,
    applyColumnState: ZT,
    getColumnState: qT,
    resetColumnState: jT,
    isPinning: YT,
    isPinningLeft: QT,
    isPinningRight: JT,
    getDisplayedColAfter: XT,
    getDisplayedColBefore: e4,
    setColumnsVisible: t4,
    setColumnsPinned: n4,
    getAllGridColumns: o4,
    getDisplayedLeftColumns: s4,
    getDisplayedCenterColumns: i4,
    getDisplayedRightColumns: r4,
    getAllDisplayedColumns: a4,
    getAllDisplayedVirtualColumns: l4,
    getColumnDefs: zT
  }
};
function v4(e) {
  if (!e || e == null)
    return null;
  const t = /([a-z])([A-Z])/g, n = /([A-Z]+)([A-Z])([a-z])/g;
  return e.replace(t, "$1 $2").replace(n, "$1 $2$3").replace(/\./g, " ").split(" ").map((s) => s.substring(0, 1).toUpperCase() + (s.length > 1 ? s.substring(1, s.length) : "")).join(" ");
}
var C4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colNames";
  }
  getDisplayNameForColumn(e, t, n = !1) {
    if (!e)
      return null;
    const o = this.getHeaderName(e.getColDef(), e, null, null, t), { aggColNameSvc: s } = this.beans;
    return n && s ? s.getHeaderName(e, o) : o;
  }
  getDisplayNameForProvidedColumnGroup(e, t, n) {
    const o = t == null ? void 0 : t.getColGroupDef();
    return o ? this.getHeaderName(o, null, e, t, n) : null;
  }
  getDisplayNameForColumnGroup(e, t) {
    return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), t);
  }
  // location is where the column is going to appear, ie who is calling us
  getHeaderName(e, t, n, o, s) {
    var r;
    const i = e.headerValueGetter;
    if (i) {
      const a = ke(this.gos, {
        colDef: e,
        column: t,
        columnGroup: n,
        providedColumnGroup: o,
        location: s
      });
      return typeof i == "function" ? i(a) : typeof i == "string" ? ((r = this.beans.expressionSvc) == null ? void 0 : r.evaluate(i, a)) ?? null : "";
    } else {
      if (e.headerName != null)
        return e.headerName;
      if (e.field)
        return v4(e.field);
    }
    return "";
  }
}, w4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colViewport", this.colsWithinViewport = [], this.headerColsWithinViewport = [], this.colsWithinViewportHash = "", this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.columnsToRenderLeft = [], this.columnsToRenderRight = [], this.columnsToRenderCenter = [];
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel;
  }
  postConstruct() {
    this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
  }
  setScrollPosition(e, t, n = !1) {
    const { visibleCols: o } = this, s = o.isBodyWidthDirty;
    if (!(e === this.scrollWidth && t === this.scrollPosition && !s)) {
      if (this.scrollWidth = e, this.scrollPosition = t, o.isBodyWidthDirty = !0, this.gos.get("enableRtl")) {
        const r = o.bodyWidth;
        this.viewportLeft = r - t - e, this.viewportRight = r - t;
      } else
        this.viewportLeft = t, this.viewportRight = e + t;
      this.colModel.ready && this.checkViewportColumns(n);
    }
  }
  /**
   * Returns the columns that are currently rendered in the viewport.
   */
  getColumnHeadersToRender(e) {
    switch (e) {
      case "left":
        return this.columnsToRenderLeft;
      case "right":
        return this.columnsToRenderRight;
      default:
        return this.columnsToRenderCenter;
    }
  }
  /**
   * Returns the column groups that are currently rendered in the viewport at a specific header row index.
   */
  getHeadersToRender(e, t) {
    let n;
    switch (e) {
      case "left":
        n = this.rowsOfHeadersToRenderLeft[t];
        break;
      case "right":
        n = this.rowsOfHeadersToRenderRight[t];
        break;
      default:
        n = this.rowsOfHeadersToRenderCenter[t];
        break;
    }
    return n ?? [];
  }
  extractViewportColumns() {
    const e = this.visibleCols.centerCols;
    this.isColumnVirtualisationSuppressed() ? (this.colsWithinViewport = e, this.headerColsWithinViewport = e) : (this.colsWithinViewport = e.filter(this.isColumnInRowViewport.bind(this)), this.headerColsWithinViewport = e.filter(this.isColumnInHeaderViewport.bind(this)));
  }
  isColumnVirtualisationSuppressed() {
    return this.suppressColumnVirtualisation || this.viewportRight === 0;
  }
  clear() {
    this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.colsWithinViewportHash = "";
  }
  isColumnInHeaderViewport(e) {
    return e.isAutoHeaderHeight() || y4(e) ? !0 : this.isColumnInRowViewport(e);
  }
  isColumnInRowViewport(e) {
    if (e.isAutoHeight())
      return !0;
    const t = e.getLeft() || 0, n = t + e.getActualWidth(), o = this.viewportLeft - 200, s = this.viewportRight + 200, i = t < o && n < o, r = t > s && n > s;
    return !i && !r;
  }
  // used by Grid API only
  getViewportColumns() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    return this.colsWithinViewport.concat(e).concat(t);
  }
  // + rowRenderer
  // if we are not column spanning, this just returns back the virtual centre columns,
  // however if we are column spanning, then different rows can have different virtual
  // columns, so we have to work out the list for each individual row.
  getColsWithinViewport(e) {
    if (!this.colModel.colSpanActive)
      return this.colsWithinViewport;
    const t = (i) => {
      const r = i.getLeft();
      return ue(r) && r > this.viewportLeft;
    }, n = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this), { visibleCols: o } = this, s = o.centerCols;
    return o.getColsForRow(e, s, n, t);
  }
  // checks what columns are currently displayed due to column virtualisation. dispatches an event
  // if the list of columns has changed.
  // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
  checkViewportColumns(e = !1) {
    this.extractViewport() && this.eventSvc.dispatchEvent({
      type: "virtualColumnsChanged",
      afterScroll: e
    });
  }
  calculateHeaderRows() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    this.columnsToRenderLeft = e, this.columnsToRenderRight = t, this.columnsToRenderCenter = this.colsWithinViewport;
    const n = (o) => {
      const s = /* @__PURE__ */ new Set(), i = {};
      for (const r of o) {
        let a = r.getParent();
        const l = r.isSpanHeaderHeight();
        for (; a && !s.has(a); ) {
          if (l && a.isPadding()) {
            a = a.getParent();
            continue;
          }
          const c = a.getProvidedColumnGroup().getLevel();
          i[c] ?? (i[c] = []), i[c].push(a), s.add(a), a = a.getParent();
        }
      }
      return i;
    };
    this.rowsOfHeadersToRenderLeft = n(e), this.rowsOfHeadersToRenderRight = n(t), this.rowsOfHeadersToRenderCenter = n(this.headerColsWithinViewport);
  }
  extractViewport() {
    const e = (o) => `${o.getId()}-${o.getPinned() || "normal"}`;
    this.extractViewportColumns();
    const t = this.getViewportColumns().map(e).join("#"), n = this.colsWithinViewportHash !== t;
    return n && (this.colsWithinViewportHash = t, this.calculateHeaderRows()), n;
  }
};
function y4(e) {
  for (; e; ) {
    if (e.isAutoHeaderHeight())
      return !0;
    e = e.getParent();
  }
  return !1;
}
var b4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "agCompUtils";
  }
  adaptFunction(e, t) {
    if (!e.cellRenderer)
      return null;
    class n {
      refresh() {
        return !1;
      }
      getGui() {
        return this.eGui;
      }
      init(s) {
        const i = t(s), r = typeof i;
        if (r === "string" || r === "number" || r === "boolean") {
          this.eGui = Zg("<span>" + i + "</span>");
          return;
        }
        if (i == null) {
          this.eGui = Ue({ tag: "span" });
          return;
        }
        this.eGui = i;
      }
    }
    return n;
  }
}, S4 = {
  moduleName: "CellRendererFunction",
  version: Ee,
  beans: [b4]
}, x4 = class extends qM {
  constructor() {
    super(...arguments), this.agGridDefaults = {}, this.agGridDefaultOverrides = {}, this.jsComps = {}, this.selectors = {}, this.icons = {};
  }
  postConstruct() {
    const e = this.gos.get("components");
    if (e != null)
      for (const t of Object.keys(e))
        this.jsComps[t] = e[t];
  }
  registerModule(e) {
    const { icons: t, userComponents: n, dynamicBeans: o, selectors: s } = e;
    if (n) {
      const i = (r, a, l, d) => {
        this.agGridDefaults[r] = a, (l || d) && (this.agGridDefaultOverrides[r] = { params: l, processParams: d });
      };
      for (const r of Object.keys(n)) {
        let a = n[r];
        if (KF(a) && (a = a.getComp(this.beans)), typeof a == "object") {
          const { classImp: l, params: d, processParams: c } = a;
          i(r, l, d, c);
        } else
          i(r, a);
      }
    }
    if (this.registerDynamicBeans(o), s == null || s.forEach((i) => {
      this.selectors[i.selector] = i;
    }), t)
      for (const i of Object.keys(t))
        this.icons[i] = t[i];
  }
  getUserComponent(e, t) {
    var a;
    const n = (l, d, c, u) => ({
      componentFromFramework: d,
      component: l,
      params: c,
      processParams: u
    }), { frameworkOverrides: o } = this.beans, s = o.frameworkComponent(t, this.gos.get("components"));
    if (s != null)
      return n(s, !0);
    const i = this.jsComps[t];
    if (i) {
      const l = o.isFrameworkComponent(i);
      return n(i, l);
    }
    const r = this.agGridDefaults[t];
    if (r) {
      const l = this.agGridDefaultOverrides[t];
      return n(r, !1, l == null ? void 0 : l.params, l == null ? void 0 : l.processParams);
    }
    return (a = this.beans.validation) == null || a.missingUserComponent(e, t, this.agGridDefaults, this.jsComps), null;
  }
  getSelector(e) {
    return this.selectors[e];
  }
  getIcon(e) {
    return this.icons[e];
  }
  getDynamicError(e, t) {
    var n;
    return t ? Eo(279, { name: e }) : ((n = this.beans.validation) == null ? void 0 : n.missingDynamicBean(e)) ?? Eo(256);
  }
}, R4 = 23, E4 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ctrlsSvc", this.params = {}, this.ready = !1, this.readyCallbacks = [];
  }
  postConstruct() {
    var e, t;
    this.addEventListener(
      "ready",
      () => {
        this.updateReady(), this.ready && (this.readyCallbacks.forEach((n) => n(this.params)), this.readyCallbacks.length = 0);
      },
      ((t = (e = this.beans.frameworkOverrides).runWhenReadyAsync) == null ? void 0 : t.call(e)) ?? !1
    );
  }
  updateReady() {
    const e = Object.values(this.params);
    this.ready = e.length === R4 && e.every((t) => (t == null ? void 0 : t.isAlive()) ?? !1);
  }
  whenReady(e, t) {
    this.ready ? t(this.params) : this.readyCallbacks.push(t), e.addDestroyFunc(() => {
      const n = this.readyCallbacks.indexOf(t);
      n >= 0 && this.readyCallbacks.splice(n, 1);
    });
  }
  register(e, t) {
    this.params[e] = t, this.updateReady(), this.ready && this.dispatchLocalEvent({ type: "ready" }), t.addDestroyFunc(() => {
      this.updateReady();
    });
  }
  get(e) {
    return this.params[e];
  }
  getGridBodyCtrl() {
    return this.params.gridBodyCtrl;
  }
  getHeaderRowContainerCtrls() {
    const { leftHeader: e, centerHeader: t, rightHeader: n } = this.params;
    return [e, n, t];
  }
  getHeaderRowContainerCtrl(e) {
    const t = this.params;
    switch (e) {
      case "left":
        return t.leftHeader;
      case "right":
        return t.rightHeader;
      default:
        return t.centerHeader;
    }
  }
  getScrollFeature() {
    return this.getGridBodyCtrl().scrollFeature;
  }
}, gy = /* @__PURE__ */ new Set(), Bd = {}, hi = {}, td, py = !1, fy = !1, A4 = !1;
function F4(e) {
  const [t, n] = e.version.split(".") || [], [o, s] = td.split(".") || [];
  return t === o && n === s;
}
function M4(e) {
  td || (td = e.version);
  const t = (n) => `You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${n} Please update all modules to the same version.`;
  if (e.version ? F4(e) || Qi(
    t(
      `'${e.moduleName}' is version ${e.version} but the other modules are version ${td}.`
    )
  ) : Qi(t(`'${e.moduleName}' is incompatible.`)), e.validate) {
    const n = e.validate();
    n.isValid || Qi(`${n.message}`);
  }
}
function Er(e, t, n = !1) {
  n || (py = !0), M4(e);
  const o = e.rowModels ?? ["all"];
  gy.add(e);
  let s;
  t !== void 0 ? (fy = !0, hi[t] === void 0 && (hi[t] = {}), s = hi[t]) : s = Bd, o.forEach((i) => {
    s[i] === void 0 && (s[i] = {}), s[i][e.moduleName] = e;
  }), e.dependsOn && e.dependsOn.forEach((i) => Er(i, t, n));
}
function I4(e) {
  delete hi[e];
}
function Oh(e, t, n) {
  const o = (s) => {
    var i, r, a;
    return !!((i = Bd[s]) != null && i[e]) || !!((a = (r = hi[t]) == null ? void 0 : r[s]) != null && a[e]);
  };
  return o(n) || o("all");
}
function Pp() {
  return fy;
}
function P4(e, t) {
  const n = hi[e] ?? {};
  return [
    ...Object.values(Bd.all ?? {}),
    ...Object.values(n.all ?? {}),
    ...Object.values(Bd[t] ?? {}),
    ...Object.values(n[t] ?? {})
  ];
}
function D4() {
  return new Set(gy);
}
function T4(e, t) {
  const n = hi[e] ?? {};
  return [...Object.values(n.all ?? {}), ...Object.values(n[t] ?? {})];
}
function k4() {
  return py;
}
function L4() {
  return A4;
}
var Gh = class {
  /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */
  static register(e) {
    Er(e, void 0);
  }
  /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */
  static registerModules(e) {
    e.forEach((t) => Er(t, void 0));
  }
}, B4 = (
  /*css*/
  '.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%;&.ag-row-editing-invalid{background-color:var(--ag-full-row-edit-invalid-background-color)}}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after,.ag-row-highlight-inside:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;pointer-events:none;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after,:where(.ag-ltr) .ag-row-highlight-inside:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after,:where(.ag-rtl) .ag-row-highlight-inside:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-highlight-indent:after{display:block;width:auto}:where(.ag-ltr) .ag-row-highlight-indent:after{left:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size));right:1px}:where(.ag-rtl) .ag-row-highlight-indent:after{left:1px;right:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size))}.ag-row-highlight-inside:after{background-color:var(--ag-selected-row-background-color);border:1px solid var(--ag-range-selection-border-color);display:block;height:auto;inset:0;width:auto}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{background-color:var(--ag-row-loading-skeleton-effect-color)}50%{background-color:color-mix(in srgb,transparent,var(--ag-row-loading-skeleton-effect-color) 40%)}to{background-color:var(--ag-row-loading-skeleton-effect-color)}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-virtual-list-item{height:var(--ag-list-item-height);position:absolute;width:100%}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab;:where(.ag-icon){color:var(--ag-drag-handle-color)}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);position:relative;&:after{background-color:var(--ag-icon-button-active-indicator-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}'
), O4 = {
  wrapperBorder: !0,
  rowBorder: !0,
  headerRowBorder: !0,
  footerRowBorder: {
    ref: "rowBorder"
  },
  columnBorder: {
    style: "solid",
    width: 1,
    color: "transparent"
  },
  headerColumnBorder: !1,
  headerColumnBorderHeight: "100%",
  pinnedColumnBorder: !0,
  pinnedRowBorder: !0,
  sidePanelBorder: !0,
  sideBarPanelWidth: 250,
  sideBarBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  sideButtonBarBackgroundColor: {
    ref: "sideBarBackgroundColor"
  },
  sideButtonBarTopPadding: 0,
  sideButtonSelectedUnderlineWidth: 2,
  sideButtonSelectedUnderlineColor: "transparent",
  sideButtonSelectedUnderlineTransitionDuration: 0,
  sideButtonBackgroundColor: "transparent",
  sideButtonTextColor: { ref: "textColor" },
  sideButtonHoverBackgroundColor: { ref: "sideButtonBackgroundColor" },
  sideButtonHoverTextColor: { ref: "sideButtonTextColor" },
  sideButtonSelectedBackgroundColor: Rn,
  sideButtonSelectedTextColor: { ref: "sideButtonTextColor" },
  sideButtonBorder: "solid 1px transparent",
  sideButtonSelectedBorder: !0,
  sideButtonLeftPadding: { ref: "spacing" },
  sideButtonRightPadding: { ref: "spacing" },
  sideButtonVerticalPadding: { calc: "spacing * 3" },
  headerBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  headerFontFamily: {
    ref: "fontFamily"
  },
  cellFontFamily: {
    ref: "fontFamily"
  },
  headerFontWeight: 500,
  headerFontSize: {
    ref: "fontSize"
  },
  dataFontSize: {
    ref: "fontSize"
  },
  headerTextColor: {
    ref: "textColor"
  },
  headerCellHoverBackgroundColor: "transparent",
  headerCellMovingBackgroundColor: { ref: "headerCellHoverBackgroundColor" },
  headerCellBackgroundTransitionDuration: "0.2s",
  cellTextColor: {
    ref: "textColor"
  },
  rangeSelectionBorderStyle: "solid",
  rangeSelectionBorderColor: $o,
  rangeSelectionBackgroundColor: fo(0.2),
  rangeSelectionChartBackgroundColor: "#0058FF1A",
  rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
  rangeSelectionHighlightColor: fo(0.5),
  rangeHeaderHighlightColor: MM(0.08),
  rowNumbersSelectedColor: fo(0.5),
  rowHoverColor: fo(0.08),
  columnHoverColor: fo(0.05),
  selectedRowBackgroundColor: fo(0.12),
  modalOverlayBackgroundColor: {
    ref: "backgroundColor",
    mix: 0.66
  },
  oddRowBackgroundColor: Rn,
  wrapperBorderRadius: 8,
  cellHorizontalPadding: {
    calc: "spacing * 2 * cellHorizontalPaddingScale"
  },
  cellWidgetSpacing: {
    calc: "spacing * 1.5"
  },
  cellHorizontalPaddingScale: 1,
  rowGroupIndentSize: {
    calc: "cellWidgetSpacing + iconSize"
  },
  valueChangeDeltaUpColor: "#43a047",
  valueChangeDeltaDownColor: "#e53935",
  valueChangeValueHighlightBackgroundColor: "#16a08580",
  rowHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
  },
  rowVerticalPaddingScale: 1,
  headerHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
  },
  headerVerticalPaddingScale: 1,
  paginationPanelHeight: {
    ref: "rowHeight",
    calc: "max(rowHeight, 22px)"
  },
  dragHandleColor: Hn(0.7),
  headerColumnResizeHandleHeight: "30%",
  headerColumnResizeHandleWidth: 2,
  headerColumnResizeHandleColor: {
    ref: "borderColor"
  },
  widgetContainerHorizontalPadding: {
    calc: "spacing * 1.5"
  },
  widgetContainerVerticalPadding: {
    calc: "spacing * 1.5"
  },
  widgetHorizontalSpacing: {
    calc: "spacing * 1.5"
  },
  widgetVerticalSpacing: {
    ref: "spacing"
  },
  iconButtonColor: { ref: "iconColor" },
  iconButtonBackgroundColor: "transparent",
  iconButtonBackgroundSpread: 4,
  iconButtonBorderRadius: 1,
  iconButtonHoverColor: { ref: "iconButtonColor" },
  iconButtonHoverBackgroundColor: Hn(0.1),
  iconButtonActiveColor: $o,
  iconButtonActiveBackgroundColor: fo(0.28),
  iconButtonActiveIndicatorColor: $o,
  menuBorder: {
    color: Hn(0.2)
  },
  menuBackgroundColor: Nn(0.03),
  menuTextColor: Nn(0.95),
  menuShadow: {
    ref: "popupShadow"
  },
  menuSeparatorColor: {
    ref: "borderColor"
  },
  setFilterIndentSize: {
    ref: "iconSize"
  },
  chartMenuPanelWidth: 260,
  chartMenuLabelColor: Hn(0.8),
  dialogShadow: {
    ref: "popupShadow"
  },
  cellEditingBorder: {
    color: $o
  },
  cellEditingShadow: { ref: "cardShadow" },
  fullRowEditInvalidBackgroundColor: {
    ref: "invalidColor",
    onto: "backgroundColor",
    mix: 0.25
  },
  dialogBorder: {
    color: Hn(0.2)
  },
  panelBackgroundColor: Rn,
  panelTitleBarBackgroundColor: {
    ref: "headerBackgroundColor"
  },
  panelTitleBarIconColor: {
    ref: "headerTextColor"
  },
  panelTitleBarTextColor: {
    ref: "headerTextColor"
  },
  panelTitleBarFontWeight: {
    ref: "headerFontWeight"
  },
  panelTitleBarBorder: !0,
  columnSelectIndentSize: {
    ref: "iconSize"
  },
  toolPanelSeparatorBorder: !0,
  columnDropCellBackgroundColor: Hn(0.07),
  columnDropCellTextColor: {
    ref: "textColor"
  },
  columnDropCellDragHandleColor: {
    ref: "textColor"
  },
  columnDropCellBorder: {
    color: Hn(0.13)
  },
  selectCellBackgroundColor: Hn(0.07),
  selectCellBorder: {
    color: Hn(0.13)
  },
  advancedFilterBuilderButtonBarBorder: !0,
  advancedFilterBuilderIndentSize: {
    calc: "spacing * 2 + iconSize"
  },
  advancedFilterBuilderJoinPillColor: "#f08e8d",
  advancedFilterBuilderColumnPillColor: "#a6e194",
  advancedFilterBuilderOptionPillColor: "#f3c08b",
  advancedFilterBuilderValuePillColor: "#85c0e4",
  filterPanelApplyButtonColor: Rn,
  filterPanelApplyButtonBackgroundColor: $o,
  filterPanelCardSubtleColor: {
    ref: "textColor",
    mix: 0.7
  },
  filterPanelCardSubtleHoverColor: { ref: "textColor" },
  findMatchColor: Wi,
  findMatchBackgroundColor: "#ffff00",
  findActiveMatchColor: Wi,
  findActiveMatchBackgroundColor: "#ffa500",
  filterToolPanelGroupIndent: {
    ref: "spacing"
  },
  rowLoadingSkeletonEffectColor: Hn(0.15),
  statusBarLabelColor: Wi,
  statusBarLabelFontWeight: 500,
  statusBarValueColor: Wi,
  statusBarValueFontWeight: 500,
  pinnedSourceRowTextColor: {
    ref: "textColor"
  },
  pinnedSourceRowBackgroundColor: {
    ref: "backgroundColor"
  },
  pinnedSourceRowFontWeight: 600,
  pinnedRowFontWeight: 600,
  pinnedRowBackgroundColor: {
    ref: "backgroundColor"
  },
  pinnedRowTextColor: {
    ref: "textColor"
  }
}, G4 = (
  /*css*/
  ".ag-cell-batch-edit{background-color:var(--ag-cell-batch-edit-background-color);color:var(--ag-cell-batch-edit-text-color);display:inherit}.ag-row-batch-edit{background-color:var(--ag-row-batch-edit-background-color);color:var(--ag-row-batch-edit-text-color)}"
), my = {
  cellBatchEditBackgroundColor: "rgba(220 181 139 / 16%)",
  cellBatchEditTextColor: "#422f00",
  rowBatchEditBackgroundColor: {
    ref: "cellBatchEditBackgroundColor"
  },
  rowBatchEditTextColor: {
    ref: "cellBatchEditTextColor"
  }
}, H4 = {
  ...my,
  cellBatchEditTextColor: "#f3d0b3"
}, V4 = () => qn({
  feature: "batchEditStyle",
  params: my,
  css: G4
}), _4 = /* @__PURE__ */ V4(), N4 = (
  /*css*/
  ":where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}"
), $4 = {
  buttonTextColor: "inherit",
  buttonFontWeight: "normal",
  buttonBackgroundColor: "transparent",
  buttonBorder: !1,
  buttonBorderRadius: { ref: "borderRadius" },
  buttonHorizontalPadding: { calc: "spacing * 2" },
  buttonVerticalPadding: { ref: "spacing" },
  buttonHoverTextColor: { ref: "buttonTextColor" },
  buttonHoverBackgroundColor: { ref: "buttonBackgroundColor" },
  buttonHoverBorder: { ref: "buttonBorder" },
  buttonActiveTextColor: { ref: "buttonHoverTextColor" },
  buttonActiveBackgroundColor: { ref: "buttonHoverBackgroundColor" },
  buttonActiveBorder: { ref: "buttonHoverBorder" },
  buttonDisabledTextColor: { ref: "inputDisabledTextColor" },
  buttonDisabledBackgroundColor: { ref: "inputDisabledBackgroundColor" },
  buttonDisabledBorder: { ref: "inputDisabledBorder" }
}, z4 = () => qn({
  feature: "buttonStyle",
  params: {
    ...$4,
    buttonBackgroundColor: Rn,
    buttonBorder: !0,
    buttonHoverBackgroundColor: { ref: "rowHoverColor" },
    buttonActiveBorder: { color: $o }
  },
  css: N4
}), W4 = /* @__PURE__ */ z4(), U4 = (
  /*css*/
  ".ag-column-drop-vertical-empty-message{align-items:center;border:dashed var(--ag-border-width);border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}"
), K4 = () => qn({
  feature: "columnDropStyle",
  css: U4
}), vy = /* @__PURE__ */ K4(), Z4 = {
  warn: (...e) => {
    Z(e[0], e[1]);
  },
  error: (...e) => {
    $e(e[0], e[1]);
  },
  preInitErr: (...e) => {
    Qr(e[0], e[2], e[1]);
  }
}, q4 = () => HM(Z4).withParams(O4).withPart(W4).withPart(vy).withPart(_4), j4 = (
  /*css*/
  '.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within{box-shadow:var(--ag-focus-error-shadow)}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}'
), Y4 = () => qn({
  feature: "checkboxStyle",
  params: {
    checkboxBorderWidth: 1,
    checkboxBorderRadius: {
      ref: "borderRadius"
    },
    checkboxUncheckedBackgroundColor: Rn,
    checkboxUncheckedBorderColor: Nn(0.3),
    checkboxCheckedBackgroundColor: $o,
    checkboxCheckedBorderColor: { ref: "checkboxCheckedBackgroundColor" },
    checkboxCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
    },
    checkboxCheckedShapeColor: Rn,
    checkboxIndeterminateBackgroundColor: Nn(0.3),
    checkboxIndeterminateBorderColor: { ref: "checkboxIndeterminateBackgroundColor" },
    checkboxIndeterminateShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
    },
    checkboxIndeterminateShapeColor: Rn,
    radioCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
    }
  },
  css: j4
}), Q4 = /* @__PURE__ */ Y4(), Cy = () => ({
  ...Id,
  ...H4,
  backgroundColor: "hsl(217, 0%, 17%)",
  foregroundColor: "#FFF",
  chromeBackgroundColor: Nn(0.05),
  rowHoverColor: fo(0.15),
  selectedRowBackgroundColor: fo(0.2),
  menuBackgroundColor: Nn(0.1),
  browserColorScheme: "dark",
  popupShadow: "0 0px 20px #000A",
  cardShadow: "0 1px 4px 1px #000A",
  advancedFilterBuilderJoinPillColor: "#7a3a37",
  advancedFilterBuilderColumnPillColor: "#355f2d",
  advancedFilterBuilderOptionPillColor: "#5a3168",
  advancedFilterBuilderValuePillColor: "#374c86",
  filterPanelApplyButtonColor: Wi,
  findMatchColor: Rn,
  findActiveMatchColor: Rn,
  checkboxUncheckedBorderColor: Nn(0.4),
  toggleButtonOffBackgroundColor: Nn(0.4),
  rowBatchEditBackgroundColor: Nn(0.1)
}), J4 = () => ({
  ...Cy(),
  backgroundColor: "#1f2836"
}), X4 = () => qn({
  feature: "colorScheme",
  params: Id,
  modeParams: {
    light: Id,
    dark: Cy(),
    "dark-blue": J4()
  }
}), ek = /* @__PURE__ */ X4(), tk = (
  /*css*/
  `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`
), nk = /* @__PURE__ */ qn({
  feature: "iconSet",
  css: tk
}), wy = (e) => {
  const t = [];
  if (e.type === "image") {
    const { icons: n, mask: o } = e;
    for (const s of Object.keys(n)) {
      const i = pp(n[s]);
      o ? t.push(`.ag-icon-${s}::before { mask-image: ${i}; }`) : t.push(`.ag-icon-${s}::before { background-image: ${i}; ${Zm} }`);
    }
  }
  if (e.type === "font") {
    const { family: n, weight: o, color: s, icons: i } = e;
    let r = Zm;
    n && (r += ` font-family: ${gp(n)};`), o && (r += ` font-weight: ${vw(o)};`), s && (r += ` color: ${yc(s)};`);
    for (const a of Object.keys(i))
      t.push(`.ag-icon-${a}::before { content: ${JSON.stringify(i[a])}; ${r} }`);
  }
  return qn({
    css: t.join(`;
`),
    cssImports: e.cssImports
  });
}, Zm = "background-color: unset; mask-image: unset; -webkit-mask-image: unset;", yy = {
  aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
  arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
  asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
  chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
  "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
  columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
  contracted: '<path d="m9 18 6-6-6-6"/>',
  copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
  cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
  csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
  desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  expanded: '<path d="m15 18-6-6 6-6"/>',
  "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
  eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
  filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
  first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
  group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
  last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
  left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
  linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
  loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
  maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
  menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
  "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
  minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
  minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
  next: '<path d="m9 18 6-6-6-6"/>',
  none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
  "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
  paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
  pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
  pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
  plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
  previous: '<path d="m15 18-6-6 6-6"/>',
  right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
  save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
  "small-left": '<path d="m15 18-6-6 6-6"/>',
  "small-right": '<path d="m9 18 6-6-6-6"/>',
  tick: '<path d="M20 6 9 17l-5-5"/>',
  "tree-closed": '<path d="m9 18 6-6-6-6"/>',
  "tree-indeterminate": '<path d="M5 12h14"/>',
  "tree-open": '<path d="m6 9 6 6 6-6"/>',
  unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
  up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
  settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
}, by = {
  "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
  "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
  "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
  "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
  "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
  "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>',
  "chevron-down": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L8 10L4 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-up": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-left": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-right": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "filter-add": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.12126 7.75L10.8517 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6.65934 11.748L9.32778 11.748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12.2943 1.04872V6.19184M14.9886 3.74341H9.68478" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8.25488 3C8.04799 3.18323 7.91706 3.45099 7.91699 3.74902C7.91713 4.04868 8.04988 4.31681 8.25879 4.5H2C1.58579 4.5 1.25 4.16421 1.25 3.75C1.25 3.33579 1.58579 3 2 3H8.25488Z" fill="currentColor"/></svg>',
  edit: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.6262V12.5012H5.375L10.905 6.97122L9.03 5.09622L3.5 10.6262ZM12.355 5.52122C12.4014 5.47497 12.4381 5.42002 12.4632 5.35953C12.4883 5.29905 12.5012 5.23421 12.5012 5.16872C12.5012 5.10324 12.4883 5.0384 12.4632 4.97791C12.4381 4.91742 12.4014 4.86248 12.355 4.81622L11.185 3.64622C11.1387 3.59987 11.0838 3.5631 11.0233 3.53801C10.9628 3.51291 10.898 3.5 10.8325 3.5C10.767 3.5 10.7022 3.51291 10.6417 3.53801C10.5812 3.5631 10.5263 3.59987 10.48 3.64622L9.565 4.56122L11.44 6.43622L12.355 5.52122Z" fill="currentColor"/></svg>'
}, ok = (e = {}) => {
  let t = "";
  for (const n of [...Object.keys(yy), ...Object.keys(by)]) {
    const o = sk(n, e.strokeWidth);
    t += `.ag-icon-${n}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(o)}'); }
`;
  }
  return t;
}, sk = (e, t = 1.5) => {
  const n = by[e];
  if (n)
    return n;
  const o = yy[e];
  if (!o)
    throw new Error(`Missing icon data for ${e}`);
  return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${t}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + o + "</svg>";
}, ik = (e = {}) => qn({
  feature: "iconSet",
  css: () => ok(e)
}), rk = /* @__PURE__ */ ik(), ak = (
  /*css*/
  ':where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}'
), lk = (
  /*css*/
  ".ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow);&:where(.invalid),&:where(:invalid){box-shadow:var(--ag-focus-error-shadow)}}}"
), dk = {
  inputBackgroundColor: "transparent",
  inputBorder: !1,
  inputBorderRadius: 0,
  inputTextColor: {
    ref: "textColor"
  },
  inputPlaceholderTextColor: {
    ref: "inputTextColor",
    mix: 0.5
  },
  inputPaddingStart: 0,
  inputHeight: {
    calc: "max(iconSize, fontSize) + spacing * 2"
  },
  inputFocusBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputFocusBorder: {
    ref: "inputBorder"
  },
  inputFocusShadow: "none",
  inputFocusTextColor: {
    ref: "inputTextColor"
  },
  inputDisabledBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputDisabledBorder: {
    ref: "inputBorder"
  },
  inputDisabledTextColor: {
    ref: "inputTextColor"
  },
  inputInvalidBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputInvalidBorder: {
    ref: "inputBorder"
  },
  inputInvalidTextColor: {
    ref: "inputTextColor"
  },
  inputIconColor: {
    ref: "inputTextColor"
  },
  pickerButtonBorder: !1,
  pickerButtonFocusBorder: { ref: "inputFocusBorder" },
  pickerButtonBackgroundColor: { ref: "backgroundColor" },
  pickerButtonFocusBackgroundColor: { ref: "backgroundColor" },
  pickerListBorder: !1,
  pickerListBackgroundColor: { ref: "backgroundColor" },
  colorPickerThumbSize: 18,
  colorPickerTrackSize: 12,
  colorPickerThumbBorderWidth: 3,
  colorPickerTrackBorderRadius: 12,
  colorPickerColorBorderRadius: 4
}, ck = () => qn({
  feature: "inputStyle",
  params: {
    ...dk,
    inputBackgroundColor: Rn,
    inputBorder: !0,
    inputBorderRadius: {
      ref: "borderRadius"
    },
    inputPaddingStart: {
      ref: "spacing"
    },
    inputFocusBorder: {
      color: $o
    },
    inputFocusShadow: {
      ref: "focusShadow"
    },
    inputDisabledBackgroundColor: Nn(0.06),
    inputDisabledTextColor: {
      ref: "textColor",
      mix: 0.5
    },
    inputInvalidBorder: {
      color: { ref: "invalidColor" }
    },
    pickerButtonBorder: !0,
    pickerListBorder: !0
  },
  css: () => ak + lk
}), uk = /* @__PURE__ */ ck(), hk = (
  /*css*/
  '.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:solid var(--ag-border-width) var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}'
), gk = {
  tabBarBackgroundColor: "transparent",
  tabBarHorizontalPadding: 0,
  tabBarTopPadding: 0,
  tabBackgroundColor: "transparent",
  tabTextColor: {
    ref: "textColor"
  },
  tabHorizontalPadding: {
    ref: "spacing"
  },
  tabTopPadding: {
    ref: "spacing"
  },
  tabBottomPadding: {
    ref: "spacing"
  },
  tabSpacing: "0",
  tabHoverBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabHoverTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabSelectedTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBorderWidth: { ref: "borderWidth" },
  tabSelectedBorderColor: "transparent",
  tabSelectedUnderlineColor: "transparent",
  tabSelectedUnderlineWidth: 0,
  tabSelectedUnderlineTransitionDuration: 0,
  tabBarBorder: !1
}, pk = () => qn({
  feature: "tabStyle",
  params: {
    ...gk,
    tabBarBorder: !0,
    tabBarBackgroundColor: Hn(0.05),
    tabTextColor: {
      ref: "textColor",
      mix: 0.7
    },
    tabSelectedTextColor: {
      ref: "textColor"
    },
    tabHoverTextColor: {
      ref: "textColor"
    },
    tabSelectedBorderColor: {
      ref: "borderColor"
    },
    tabSelectedBackgroundColor: Rn
  },
  css: hk
}), fk = /* @__PURE__ */ pk(), mk = () => q4().withPart(Q4).withPart(ek).withPart(rk).withPart(fk).withPart(uk).withPart(vy).withParams({
  fontFamily: [
    { googleFont: "IBM Plex Sans" },
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu"
  ]
}), Sy = /* @__PURE__ */ mk(), vk = {
  cssName: "--ag-cell-horizontal-padding",
  changeKey: "cellHorizontalPaddingChanged",
  defaultValue: 16
}, Ck = {
  cssName: "--ag-indentation-level",
  changeKey: "indentationLevelChanged",
  defaultValue: 0,
  noWarn: !0,
  cacheDefault: !0
}, wk = {
  cssName: "--ag-row-group-indent-size",
  changeKey: "rowGroupIndentSizeChanged",
  defaultValue: 0
}, qm = {
  cssName: "--ag-row-height",
  changeKey: "rowHeightChanged",
  defaultValue: 42
}, jm = {
  cssName: "--ag-header-height",
  changeKey: "headerHeightChanged",
  defaultValue: 48
}, Ym = {
  cssName: "--ag-list-item-height",
  changeKey: "listItemHeightChanged",
  defaultValue: 24
}, Mu = {
  cssName: "--ag-row-border",
  changeKey: "rowBorderWidthChanged",
  defaultValue: 1,
  border: !0
}, Qm = {
  cssName: "--ag-pinned-row-border",
  changeKey: "pinnedRowBorderWidthChanged",
  defaultValue: 1,
  border: !0
};
function yk(e, t) {
  t.sort((n, o) => n.moduleName.localeCompare(o.moduleName)).forEach((n) => {
    const o = n.css;
    o && e.set(`module-${n.moduleName}`, o);
  });
}
var bk = class extends ZM {
  constructor() {
    super(...arguments), this.sizeEls = /* @__PURE__ */ new Map(), this.lastKnownValues = /* @__PURE__ */ new Map(), this.sizesMeasured = !1;
  }
  initVariables() {
    this.addManagedPropertyListener("rowHeight", () => this.refreshRowHeightVariable()), this.getSizeEl(qm), this.getSizeEl(jm), this.getSizeEl(Ym), this.getSizeEl(Mu), this.getSizeEl(Qm), this.refreshRowBorderWidthVariable();
  }
  getPinnedRowBorderWidth() {
    return this.getCSSVariablePixelValue(Qm);
  }
  getRowBorderWidth() {
    return this.getCSSVariablePixelValue(Mu);
  }
  getDefaultRowHeight() {
    return this.getCSSVariablePixelValue(qm);
  }
  getDefaultHeaderHeight() {
    return this.getCSSVariablePixelValue(jm);
  }
  getDefaultCellHorizontalPadding() {
    return this.getCSSVariablePixelValue(vk);
  }
  getCellPaddingLeft() {
    const e = this.getDefaultCellHorizontalPadding(), t = this.getCSSVariablePixelValue(Ck), n = this.getCSSVariablePixelValue(wk);
    return e - 1 + n * t;
  }
  getCellPadding() {
    const e = this.getDefaultCellHorizontalPadding() - 1;
    return this.getCellPaddingLeft() + e;
  }
  getDefaultColumnMinWidth() {
    return Math.min(36, this.getDefaultRowHeight());
  }
  getDefaultListItemHeight() {
    return this.getCSSVariablePixelValue(Ym);
  }
  refreshRowHeightVariable() {
    const { eRootDiv: e } = this, t = e.style.getPropertyValue("--ag-line-height").trim(), n = this.gos.get("rowHeight");
    if (n == null || isNaN(n) || !isFinite(n))
      return t !== null && e.style.setProperty("--ag-line-height", null), -1;
    const o = `${n}px`;
    return t != o ? (e.style.setProperty("--ag-line-height", o), n) : t != "" ? parseFloat(t) : -1;
  }
  getCSSVariablePixelValue(e) {
    const t = this.lastKnownValues.get(e);
    if (t != null)
      return t;
    const n = this.measureSizeEl(e);
    return n === "detached" || n === "no-styles" ? (e.cacheDefault && this.lastKnownValues.set(e, e.defaultValue), e.defaultValue) : (this.lastKnownValues.set(e, n), n);
  }
  measureSizeEl(e) {
    const t = this.getSizeEl(e);
    if (t.offsetParent == null)
      return "detached";
    const n = t.offsetWidth;
    return n === Iu ? "no-styles" : (this.sizesMeasured = !0, n);
  }
  getMeasurementContainer() {
    let e = this.eMeasurementContainer;
    return e || (e = this.eMeasurementContainer = Ue({ tag: "div", cls: "ag-measurement-container" }), this.eRootDiv.appendChild(e)), e;
  }
  getSizeEl(e) {
    let t = this.sizeEls.get(e);
    if (t)
      return t;
    const n = this.getMeasurementContainer();
    t = Ue({ tag: "div" });
    const { border: o, noWarn: s } = e;
    o ? (t.className = "ag-measurement-element-border", t.style.setProperty(
      "--ag-internal-measurement-border",
      `var(${e.cssName}, solid ${Iu}px)`
    )) : t.style.width = `var(${e.cssName}, ${Iu}px)`, n.appendChild(t), this.sizeEls.set(e, t);
    let i = this.measureSizeEl(e);
    i === "no-styles" && !s && Z(9, { variable: e });
    const r = Bo(this.beans, t, () => {
      const a = this.measureSizeEl(e);
      a === "detached" || a === "no-styles" || (this.lastKnownValues.set(e, a), a !== i && (i = a, this.fireStylesChangedEvent(e.changeKey)));
    });
    return this.addDestroyFunc(() => r()), t;
  }
  fireStylesChangedEvent(e) {
    e === "rowBorderWidthChanged" && this.refreshRowBorderWidthVariable(), this.eventSvc.dispatchEvent({
      type: "gridStylesChanged",
      [e]: !0
    });
  }
  refreshRowBorderWidthVariable() {
    const e = this.getCSSVariablePixelValue(Mu);
    this.eRootDiv.style.setProperty("--ag-internal-row-border-width", `${e}px`);
  }
  postProcessThemeChange(e, t) {
    e && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded") && $e(t ? 106 : 239);
  }
  getAdditionalCss() {
    const e = /* @__PURE__ */ new Map();
    return e.set("core", [B4]), yk(e, Array.from(D4())), e;
  }
  getDefaultTheme() {
    return Sy;
  }
  themeError(e) {
    $e(240, { theme: e });
  }
}, Iu = 15538, Sk = class extends jM {
  postConstruct() {
    const { globalListener: e, globalSyncListener: t } = this.beans;
    e && this.addGlobalListener(e, !0), t && this.addGlobalListener(t, !1);
  }
};
function xy(e, t, n) {
  const o = e.visibleCols.headerGroupRowCount;
  if (n >= o)
    return {
      column: t,
      headerRowIndex: n
    };
  let s = t.getParent();
  for (; s && s.getProvidedColumnGroup().getLevel() > n; )
    s = s.getParent();
  const i = t.isSpanHeaderHeight();
  return !s || i && s.isPadding() ? {
    column: t,
    headerRowIndex: o
  } : {
    column: s,
    headerRowIndex: s.getProvidedColumnGroup().getLevel()
  };
}
var xk = class extends U {
  constructor() {
    super(...arguments), this.beanName = "headerNavigation", this.currentHeaderRowWithoutSpan = -1;
  }
  postConstruct() {
    const e = this.beans;
    e.ctrlsSvc.whenReady(this, (n) => {
      this.gridBodyCon = n.gridBodyCtrl;
    });
    const t = Bt(e);
    this.addManagedElementListeners(t, {
      mousedown: () => {
        this.currentHeaderRowWithoutSpan = -1;
      }
    });
  }
  getHeaderPositionForColumn(e, t) {
    let n;
    const { colModel: o, colGroupSvc: s, ctrlsSvc: i } = this.beans;
    if (typeof e == "string" ? (n = o.getCol(e), n || (n = (s == null ? void 0 : s.getColumnGroup(e)) ?? null)) : n = e, !n)
      return null;
    const r = i.getHeaderRowContainerCtrl(), a = r == null ? void 0 : r.getAllCtrls(), l = Je(a || []).type === "filter", d = xo(this.beans) - 1;
    let c = -1, u = n;
    for (; u; )
      c++, u = u.getParent();
    let h = c;
    return t && l && h === d - 1 && h++, h === -1 ? null : {
      headerRowIndex: h,
      column: n
    };
  }
  /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateVertically(e, t) {
    const { focusSvc: n, visibleCols: o } = this.beans, { focusedHeader: s } = n;
    if (!s)
      return !1;
    const { headerRowIndex: i } = s, r = s.column, a = xo(this.beans), l = this.getHeaderRowType(i), d = o.headerGroupRowCount;
    let {
      headerRowIndex: c,
      column: u,
      headerRowIndexWithoutSpan: h
    } = e === "UP" ? Rk(l, r, i) : Ek(r, i, d), g = !1;
    return c < 0 && (c = 0, u = r, g = !0), c >= a ? (c = -1, this.currentHeaderRowWithoutSpan = -1) : h !== void 0 && (this.currentHeaderRowWithoutSpan = h), !g && !u ? !1 : n.focusHeaderPosition({
      headerPosition: { headerRowIndex: c, column: u },
      allowUserOverride: !0,
      event: t
    });
  }
  /*
   * This method navigates grid header horizontally
   * @returns {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateHorizontally(e, t = !1, n) {
    const { focusSvc: o, gos: s } = this.beans, i = { ...o.focusedHeader };
    let r, a;
    this.currentHeaderRowWithoutSpan !== -1 ? i.headerRowIndex = this.currentHeaderRowWithoutSpan : this.currentHeaderRowWithoutSpan = i.headerRowIndex, e === "LEFT" !== s.get("enableRtl") ? (a = "Before", r = this.findHeader(i, a)) : (a = "After", r = this.findHeader(i, a));
    const l = s.getCallback("tabToNextHeader");
    if (t && l) {
      const d = o.focusHeaderPositionFromUserFunc({
        userFunc: l,
        headerPosition: r,
        direction: a
      });
      if (d) {
        const { headerRowIndex: c } = o.focusedHeader || {};
        c != null && c != i.headerRowIndex && (this.currentHeaderRowWithoutSpan = c);
      }
      return d;
    }
    return r || !t ? o.focusHeaderPosition({
      headerPosition: r,
      direction: a,
      fromTab: t,
      allowUserOverride: !0,
      event: n
    }) : this.focusNextHeaderRow(i, a, n);
  }
  focusNextHeaderRow(e, t, n) {
    const o = this.beans, s = e.headerRowIndex;
    let i = null, r;
    const a = xo(o), l = this.beans.visibleCols.allCols;
    if (t === "Before") {
      if (s <= 0)
        return !1;
      i = Je(l), r = s - 1, this.currentHeaderRowWithoutSpan -= 1;
    } else
      i = l[0], r = s + 1, this.currentHeaderRowWithoutSpan < a ? this.currentHeaderRowWithoutSpan += 1 : this.currentHeaderRowWithoutSpan = -1;
    let { column: d, headerRowIndex: c } = xy(this.beans, i, r);
    return c >= a && (c = -1), o.focusSvc.focusHeaderPosition({
      headerPosition: { column: d, headerRowIndex: c },
      direction: t,
      fromTab: !0,
      allowUserOverride: !0,
      event: n
    });
  }
  scrollToColumn(e, t = "After") {
    if (e.getPinned())
      return;
    let n;
    if (Dt(e)) {
      const o = e.getDisplayedLeafColumns();
      n = t === "Before" ? Je(o) : o[0];
    } else
      n = e;
    this.gridBodyCon.scrollFeature.ensureColumnVisible(n);
  }
  findHeader(e, t) {
    const { colGroupSvc: n, visibleCols: o } = this.beans;
    let s = e.column;
    if (s instanceof Ba) {
      const l = s.getDisplayedLeafColumns();
      s = t === "Before" ? l[0] : l[l.length - 1];
    }
    const i = t === "Before" ? o.getColBefore(s) : o.getColAfter(s);
    if (!i)
      return;
    const r = o.headerGroupRowCount;
    if (e.headerRowIndex >= r)
      return {
        headerRowIndex: e.headerRowIndex,
        column: i
      };
    const a = n == null ? void 0 : n.getColGroupAtLevel(i, e.headerRowIndex);
    return a ? a.isPadding() && i.isSpanHeaderHeight() ? {
      headerRowIndex: o.headerGroupRowCount,
      column: i
    } : {
      headerRowIndex: e.headerRowIndex,
      column: a ?? i
    } : {
      headerRowIndex: i instanceof Go && i.isSpanHeaderHeight() ? o.headerGroupRowCount : e.headerRowIndex,
      column: i
    };
  }
  getHeaderRowType(e) {
    const t = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
    if (t)
      return t.getRowType(e);
  }
};
function Rk(e, t, n) {
  const o = n - 1;
  if (e !== "filter") {
    const s = t instanceof Go && t.isSpanHeaderHeight();
    let i = t.getParent();
    for (; i && // skip if row isn't visible or col is padding and spanned
    (i.getProvidedColumnGroup().getLevel() > o || s && i.isPadding()); )
      i = i.getParent();
    if (i)
      return s ? {
        column: i,
        headerRowIndex: i.getProvidedColumnGroup().getLevel(),
        headerRowIndexWithoutSpan: o
      } : {
        column: i,
        headerRowIndex: o,
        headerRowIndexWithoutSpan: o
      };
  }
  return {
    column: t,
    headerRowIndex: o,
    headerRowIndexWithoutSpan: o
  };
}
function Ek(e, t, n) {
  const o = t + 1, s = {
    column: e,
    headerRowIndex: o,
    headerRowIndexWithoutSpan: o
  };
  if (e instanceof Ba) {
    if (o >= n)
      return {
        column: e.getDisplayedLeafColumns()[0],
        headerRowIndex: n,
        headerRowIndexWithoutSpan: o
      };
    let r = e.getDisplayedChildren()[0];
    if (r instanceof Ba && r.isPadding()) {
      const l = r.getDisplayedLeafColumns()[0];
      l.isSpanHeaderHeight() && (r = l);
    }
    s.column = r, r instanceof Go && r.isSpanHeaderHeight() && (s.headerRowIndex = n, s.headerRowIndexWithoutSpan = o);
  }
  return s;
}
var Ak = class extends U {
  constructor() {
    super(...arguments), this.beanName = "focusSvc", this.focusFallbackTimeout = null, this.needsFocusRestored = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.visibleCols = e.visibleCols, this.rowRenderer = e.rowRenderer, this.navigation = e.navigation, this.filterManager = e.filterManager, this.overlays = e.overlays;
  }
  postConstruct() {
    const e = this.clearFocusedCell.bind(this);
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
      columnGroupOpened: e,
      columnRowGroupChanged: e
    }), this.addDestroyFunc(tM(this.beans));
  }
  attemptToRecoverFocus() {
    this.needsFocusRestored = !0, this.focusFallbackTimeout != null && clearTimeout(this.focusFallbackTimeout), this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
  }
  setFocusRecovered() {
    this.needsFocusRestored = !1, this.focusFallbackTimeout != null && (clearTimeout(this.focusFallbackTimeout), this.focusFallbackTimeout = null);
  }
  /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */
  shouldTakeFocus() {
    return this.gos.get("suppressFocusAfterRefresh") ? (this.setFocusRecovered(), !1) : this.needsFocusRestored ? (this.setFocusRecovered(), !0) : this.doesRowOrCellHaveBrowserFocus();
  }
  onColumnEverythingChanged() {
    if (!this.focusedCell)
      return;
    const e = this.focusedCell.column, t = this.colModel.getCol(e.getId());
    e !== t && this.clearFocusedCell();
  }
  // we check if the browser is focusing something, and if it is, and
  // it's the cell we think is focused, then return the cell. so this
  // methods returns the cell if a) we think it has focus and b) the
  // browser thinks it has focus. this then returns nothing if we
  // first focus a cell, then second click outside the grid, as then the
  // grid cell will still be focused as far as the grid is concerned,
  // however the browser focus will have moved somewhere else.
  getFocusCellToUseAfterRefresh() {
    const { gos: e, focusedCell: t } = this;
    return e.get("suppressFocusAfterRefresh") || e.get("suppressCellFocus") || !t || !this.doesRowOrCellHaveBrowserFocus() ? null : t;
  }
  getFocusHeaderToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader || !this.isDomDataPresentInHierarchy(je(this.beans), Zw) ? null : this.focusedHeader;
  }
  /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */
  doesRowOrCellHaveBrowserFocus() {
    const e = je(this.beans);
    return this.isDomDataPresentInHierarchy(e, Dd) ? !0 : this.isDomDataPresentInHierarchy(e, Td);
  }
  isDomDataPresentInHierarchy(e, t) {
    let n = e;
    for (; n; ) {
      if (IC(this.gos, n, t))
        return !0;
      n = n.parentNode;
    }
    return !1;
  }
  getFocusedCell() {
    return this.focusedCell;
  }
  getFocusEventParams(e) {
    const { rowIndex: t, rowPinned: n, column: o } = e, s = {
      rowIndex: t,
      rowPinned: n,
      column: o,
      isFullWidthCell: !1
    }, i = this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: n });
    return i && (s.isFullWidthCell = i.isFullWidth()), s;
  }
  clearFocusedCell() {
    if (this.focusedCell == null)
      return;
    const e = this.getFocusEventParams(this.focusedCell);
    this.focusedCell = null, this.eventSvc.dispatchEvent({
      type: "cellFocusCleared",
      ...e
    });
  }
  setFocusedCell(e) {
    this.setFocusRecovered();
    const {
      column: t,
      rowIndex: n,
      rowPinned: o,
      forceBrowserFocus: s = !1,
      preventScrollOnBrowserFocus: i = !1,
      sourceEvent: r
    } = e, a = this.colModel.getCol(t);
    if (!a) {
      this.focusedCell = null;
      return;
    }
    this.focusedCell = {
      rowIndex: n,
      rowPinned: Gt(o),
      column: a
    };
    const l = this.getFocusEventParams(this.focusedCell);
    this.eventSvc.dispatchEvent({
      type: "cellFocused",
      ...l,
      ...this.previousCellFocusParams && { previousParams: this.previousCellFocusParams },
      forceBrowserFocus: s,
      preventScrollOnBrowserFocus: i,
      sourceEvent: r
    }), this.previousCellFocusParams = l;
  }
  isCellFocused(e) {
    return this.focusedCell == null ? !1 : Mp(e, this.focusedCell);
  }
  isHeaderWrapperFocused(e) {
    if (this.focusedHeader == null)
      return !1;
    const {
      column: t,
      rowCtrl: { rowIndex: n, pinned: o }
    } = e, { column: s, headerRowIndex: i } = this.focusedHeader;
    return t === s && n === i && o == s.getPinned();
  }
  focusHeaderPosition(e) {
    var l;
    if (this.setFocusRecovered(), ci(this.beans))
      return !1;
    const { direction: t, fromTab: n, allowUserOverride: o, event: s, fromCell: i, rowWithoutSpanValue: r } = e;
    let { headerPosition: a } = e;
    if (i && ((l = this.filterManager) != null && l.isAdvFilterHeaderActive()))
      return this.focusAdvancedFilter(a);
    if (o) {
      const d = this.focusedHeader, c = xo(this.beans);
      if (n) {
        const u = this.gos.getCallback("tabToNextHeader");
        u && (a = this.getHeaderPositionFromUserFunc({
          userFunc: u,
          direction: t,
          currentPosition: d,
          headerPosition: a,
          headerRowCount: c
        }));
      } else {
        const u = this.gos.getCallback("navigateToNextHeader");
        if (u && s) {
          const h = {
            key: s.key,
            previousHeaderPosition: d,
            nextHeaderPosition: a,
            headerRowCount: c,
            event: s
          };
          a = u(h);
        }
      }
    }
    return a ? this.focusProvidedHeaderPosition({
      headerPosition: a,
      direction: t,
      event: s,
      fromCell: i,
      rowWithoutSpanValue: r
    }) : !1;
  }
  focusHeaderPositionFromUserFunc(e) {
    if (ci(this.beans))
      return !1;
    const { userFunc: t, headerPosition: n, direction: o, event: s } = e, i = this.focusedHeader, r = xo(this.beans), a = this.getHeaderPositionFromUserFunc({
      userFunc: t,
      direction: o,
      currentPosition: i,
      headerPosition: n,
      headerRowCount: r
    });
    return !!a && this.focusProvidedHeaderPosition({
      headerPosition: a,
      direction: o,
      event: s
    });
  }
  getHeaderPositionFromUserFunc(e) {
    const { userFunc: t, direction: n, currentPosition: o, headerPosition: s, headerRowCount: i } = e, a = t({
      backwards: n === "Before",
      previousHeaderPosition: o,
      nextHeaderPosition: s,
      headerRowCount: i
    });
    return a === !0 ? o : a === !1 ? null : a;
  }
  focusProvidedHeaderPosition(e) {
    const { headerPosition: t, direction: n, fromCell: o, rowWithoutSpanValue: s, event: i } = e, { column: r, headerRowIndex: a } = t, { filterManager: l, ctrlsSvc: d, headerNavigation: c } = this.beans;
    if (a === -1)
      return l != null && l.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(t) : this.focusGridView({ column: r, event: i });
    c == null || c.scrollToColumn(r, n);
    const u = d.getHeaderRowContainerCtrl(r.getPinned()), h = (u == null ? void 0 : u.focusHeader(t.headerRowIndex, r, i)) || !1;
    return c && h && (s != null || o) && (c.currentHeaderRowWithoutSpan = s ?? -1), h;
  }
  focusFirstHeader() {
    var n;
    if ((n = this.overlays) != null && n.isExclusive() && this.focusOverlay())
      return !0;
    const e = this.visibleCols.allCols[0];
    if (!e)
      return !1;
    const t = xy(this.beans, e, 0);
    return this.focusHeaderPosition({
      headerPosition: t,
      rowWithoutSpanValue: 0
    });
  }
  focusLastHeader(e) {
    var o;
    if ((o = this.overlays) != null && o.isExclusive() && this.focusOverlay(!0))
      return !0;
    const t = xo(this.beans) - 1, n = Je(this.visibleCols.allCols);
    return this.focusHeaderPosition({
      headerPosition: { headerRowIndex: t, column: n },
      rowWithoutSpanValue: -1,
      event: e
    });
  }
  focusPreviousFromFirstCell(e) {
    var t;
    return (t = this.filterManager) != null && t.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(e);
  }
  isAnyCellFocused() {
    return !!this.focusedCell;
  }
  isRowFocused(e, t) {
    return this.focusedCell == null ? !1 : this.focusedCell.rowIndex === e && this.focusedCell.rowPinned === Gt(t);
  }
  focusOverlay(e) {
    var n, o;
    const t = ((n = this.overlays) == null ? void 0 : n.isVisible()) && ((o = this.overlays.eWrapper) == null ? void 0 : o.getGui());
    return !!t && pn(t, e);
  }
  focusGridView(e) {
    var i, r, a, l, d, c;
    const { backwards: t = !1, canFocusOverlay: n = !0, event: o } = e;
    if ((i = this.overlays) != null && i.isExclusive())
      return n && this.focusOverlay(t);
    if (xc(this.beans))
      return t && !ci(this.beans) ? this.focusLastHeader() : n && this.focusOverlay(t) ? !0 : t ? !1 : Do(this.beans, t);
    const s = t ? BD(this.beans) : LD(this.beans);
    if (s) {
      const u = e.column ?? ((r = this.focusedHeader) == null ? void 0 : r.column), { rowIndex: h, rowPinned: g } = s, p = To(this.beans, s);
      if (!u || !p || h == null)
        return !1;
      if (u.isSuppressNavigable(p)) {
        const f = this.gos.get("enableRtl");
        let m;
        return !o || o.key === O.TAB ? m = f ? O.LEFT : O.RIGHT : m = o.key, (a = this.beans.navigation) == null || a.navigateToNextCell(
          null,
          m,
          { rowIndex: h, column: u, rowPinned: g || null },
          !0
        ), !0;
      }
      if ((l = this.navigation) == null || l.ensureCellVisible({ rowIndex: h, column: u, rowPinned: g }), t) {
        const f = this.rowRenderer.getRowByPosition(s);
        if (f != null && f.isFullWidth() && ((d = this.navigation) != null && d.tryToFocusFullWidthRow(s, t)))
          return !0;
      }
      return this.setFocusedCell({
        rowIndex: h,
        column: u,
        rowPinned: Gt(g),
        forceBrowserFocus: !0
      }), (c = this.beans.rangeSvc) == null || c.setRangeToCell({ rowIndex: h, rowPinned: g, column: u }), !0;
    }
    return !!(n && this.focusOverlay(t) || t && this.focusLastHeader());
  }
  focusAdvancedFilter(e) {
    var t;
    return this.advFilterFocusColumn = e == null ? void 0 : e.column, ((t = this.beans.advancedFilter) == null ? void 0 : t.getCtrl().focusHeaderComp()) ?? !1;
  }
  focusNextFromAdvancedFilter(e, t) {
    var o;
    const n = (t ? void 0 : this.advFilterFocusColumn) ?? ((o = this.visibleCols.allCols) == null ? void 0 : o[0]);
    return e ? this.focusHeaderPosition({
      headerPosition: {
        column: n,
        headerRowIndex: xo(this.beans) - 1
      }
    }) : this.focusGridView({ column: n });
  }
  clearAdvancedFilterColumn() {
    this.advFilterFocusColumn = void 0;
  }
}, Fk = class extends U {
  constructor() {
    super(...arguments), this.beanName = "scrollVisibleSvc";
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colAnimation = e.colAnimation;
  }
  postConstruct() {
    this.horizontalScrollShowing = this.gos.get("alwaysShowHorizontalScroll") === !0, this.verticalScrollShowing = this.gos.get("alwaysShowVerticalScroll") === !0, this.getScrollbarWidth(), this.addManagedEventListeners({
      displayedColumnsChanged: this.updateScrollVisible.bind(this),
      displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
    });
  }
  updateScrollVisible() {
    const { colAnimation: e } = this;
    e != null && e.isActive() ? e.executeLaterVMTurn(() => {
      e.executeLaterVMTurn(() => this.updateScrollVisibleImpl());
    }) : this.updateScrollVisibleImpl();
  }
  updateScrollVisibleImpl() {
    var n;
    const e = this.ctrlsSvc.get("center");
    if (!e || (n = this.colAnimation) != null && n.isActive())
      return;
    const t = {
      horizontalScrollShowing: e.isHorizontalScrollShowing(),
      verticalScrollShowing: this.verticalScrollShowing
    };
    this.setScrollsVisible(t), this.updateScrollGap();
  }
  updateScrollGap() {
    const e = this.ctrlsSvc.get("center"), t = e.hasHorizontalScrollGap(), n = e.hasVerticalScrollGap();
    (this.horizontalScrollGap !== t || this.verticalScrollGap !== n) && (this.horizontalScrollGap = t, this.verticalScrollGap = n, this.eventSvc.dispatchEvent({
      type: "scrollGapChanged"
    }));
  }
  setScrollsVisible(e) {
    (this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing) && (this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing, this.eventSvc.dispatchEvent({
      type: "scrollVisibilityChanged"
    }));
  }
  // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
  // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
  // allow the user to provide the scroll width before we work it out.
  getScrollbarWidth() {
    if (this.scrollbarWidth == null) {
      const e = this.gos.get("scrollbarWidth"), n = typeof e == "number" && e >= 0 ? e : qF();
      n != null && (this.scrollbarWidth = n, this.eventSvc.dispatchEvent({
        type: "scrollbarWidthChanged"
      }));
    }
    return this.scrollbarWidth;
  }
}, Mk = class extends U {
  constructor() {
    super(...arguments), this.beanName = "gridDestroySvc", this.destroyCalled = !1;
  }
  destroy() {
    var o;
    if (this.destroyCalled)
      return;
    const { stateSvc: e, ctrlsSvc: t, context: n } = this.beans;
    this.eventSvc.dispatchEvent({
      type: "gridPreDestroyed",
      state: (e == null ? void 0 : e.getState()) ?? {}
    }), this.destroyCalled = !0, (o = t.get("gridCtrl")) == null || o.destroyGridUi(), n.destroy(), super.destroy();
  }
}, da = /* @__PURE__ */ new Set(["gridPreDestroyed", "fillStart", "pasteStart"]), Ik = [
  "columnEverythingChanged",
  "newColumnsLoaded",
  "columnPivotModeChanged",
  "pivotMaxColumnsExceeded",
  "columnRowGroupChanged",
  "expandOrCollapseAll",
  "columnPivotChanged",
  "gridColumnsChanged",
  "columnValueChanged",
  "columnMoved",
  "columnVisible",
  "columnPinned",
  "columnGroupOpened",
  "columnResized",
  "displayedColumnsChanged",
  "virtualColumnsChanged",
  "columnHeaderMouseOver",
  "columnHeaderMouseLeave",
  "columnHeaderClicked",
  "columnHeaderContextMenu",
  "asyncTransactionsFlushed",
  "rowGroupOpened",
  "rowDataUpdated",
  "pinnedRowDataChanged",
  "pinnedRowsChanged",
  "rangeSelectionChanged",
  "cellSelectionChanged",
  "chartCreated",
  "chartRangeSelectionChanged",
  "chartOptionsChanged",
  "chartDestroyed",
  "toolPanelVisibleChanged",
  "toolPanelSizeChanged",
  "modelUpdated",
  "cutStart",
  "cutEnd",
  "pasteStart",
  "pasteEnd",
  "fillStart",
  "fillEnd",
  "cellSelectionDeleteStart",
  "cellSelectionDeleteEnd",
  "rangeDeleteStart",
  "rangeDeleteEnd",
  "undoStarted",
  "undoEnded",
  "redoStarted",
  "redoEnded",
  "cellClicked",
  "cellDoubleClicked",
  "cellMouseDown",
  "cellContextMenu",
  "cellValueChanged",
  "cellEditRequest",
  "rowValueChanged",
  "headerFocused",
  "cellFocused",
  "rowSelected",
  "selectionChanged",
  "tooltipShow",
  "tooltipHide",
  "cellKeyDown",
  "cellMouseOver",
  "cellMouseOut",
  "filterChanged",
  "filterModified",
  "filterUiChanged",
  "filterOpened",
  "floatingFilterUiChanged",
  "advancedFilterBuilderVisibleChanged",
  "sortChanged",
  "virtualRowRemoved",
  "rowClicked",
  "rowDoubleClicked",
  "gridReady",
  "gridPreDestroyed",
  "gridSizeChanged",
  "viewportChanged",
  "firstDataRendered",
  "dragStarted",
  "dragStopped",
  "dragCancelled",
  "rowEditingStarted",
  "rowEditingStopped",
  "cellEditingStarted",
  "cellEditingStopped",
  "bodyScroll",
  "bodyScrollEnd",
  "paginationChanged",
  "componentStateChanged",
  "storeRefreshed",
  "stateUpdated",
  "columnMenuVisibleChanged",
  "contextMenuVisibleChanged",
  "rowDragEnter",
  "rowDragMove",
  "rowDragLeave",
  "rowDragEnd",
  "rowDragCancel",
  "findChanged",
  "rowResizeStarted",
  "rowResizeEnded",
  "columnsReset",
  "bulkEditingStarted",
  "bulkEditingStopped",
  "batchEditingStarted",
  "batchEditingStopped"
], Ac = Ik.reduce(
  (e, t) => (e[t] = N3(t), e),
  {}
), Wr = (e, t) => ({
  tag: "span",
  ref: `eSort${e}`,
  cls: `ag-sort-indicator-icon ag-sort-${t} ag-hidden`,
  attrs: { "aria-hidden": "true" }
}), Pk = {
  tag: "span",
  cls: "ag-sort-indicator-container",
  children: [
    Wr("Order", "order"),
    Wr("Asc", "ascending-icon"),
    Wr("Desc", "descending-icon"),
    Wr("Mixed", "mixed-icon"),
    Wr("None", "none-icon")
  ]
}, Dp = class extends Te {
  constructor(e) {
    super(), this.eSortOrder = X, this.eSortAsc = X, this.eSortDesc = X, this.eSortMixed = X, this.eSortNone = X, e || this.setTemplate(Pk);
  }
  attachCustomElements(e, t, n, o, s) {
    this.eSortOrder = e, this.eSortAsc = t, this.eSortDesc = n, this.eSortMixed = o, this.eSortNone = s;
  }
  setupSort(e, t = !1) {
    if (this.column = e, this.suppressOrder = t, this.setupMultiSortIndicator(), !e.isSortable() && !e.getColDef().showRowGroup)
      return;
    this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e);
    const n = this.updateIcons.bind(this), o = this.onSortChanged.bind(this);
    this.addManagedPropertyListener("unSortIcon", n), this.addManagedEventListeners({
      newColumnsLoaded: n,
      // Watch global events, as row group columns can effect their display column.
      sortChanged: o,
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: o
    }), this.onSortChanged();
  }
  addInIcon(e, t, n) {
    if (t == null)
      return;
    const o = Le(e, this.beans, n);
    o && t.appendChild(o);
  }
  onSortChanged() {
    this.updateIcons(), this.suppressOrder || this.updateSortOrder();
  }
  updateIcons() {
    const { eSortAsc: e, eSortDesc: t, eSortNone: n, column: o, gos: s, beans: i } = this, r = i.sortSvc.getDisplaySortForColumn(o);
    if (e && He(e, r === "asc", { skipAriaHidden: !0 }), t && He(t, r === "desc", { skipAriaHidden: !0 }), n) {
      const a = !o.getColDef().unSortIcon && !s.get("unSortIcon"), l = r == null;
      He(n, !a && l, { skipAriaHidden: !0 });
    }
  }
  setupMultiSortIndicator() {
    const { eSortMixed: e, column: t, gos: n } = this;
    this.addInIcon("sortUnSort", e, t);
    const o = t.getColDef().showRowGroup;
    Xn(n) && o && (this.addManagedEventListeners({
      // Watch global events, as row group columns can effect their display column.
      sortChanged: this.updateMultiSortIndicator.bind(this),
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
    }), this.updateMultiSortIndicator());
  }
  updateMultiSortIndicator() {
    const { eSortMixed: e, beans: t, column: n } = this;
    if (e) {
      const o = t.sortSvc.getDisplaySortForColumn(n) === "mixed";
      He(e, o, { skipAriaHidden: !0 });
    }
  }
  // we listen here for global sort events, NOT column sort events, as we want to do this
  // when sorting has been set on all column (if we listened just for our col (where we
  // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
  updateSortOrder() {
    const {
      eSortOrder: e,
      column: t,
      beans: { sortSvc: n }
    } = this;
    if (!e)
      return;
    const o = n.getColumnsWithSortingOrdered(), s = n.getDisplaySortIndexForColumn(t) ?? -1, i = o.some(
      (a) => n.getDisplaySortIndexForColumn(a) ?? !1
    ), r = s >= 0 && i;
    He(e, r, { skipAriaHidden: !0 }), s >= 0 ? e.textContent = (s + 1).toString() : ht(e);
  }
}, Dk = {
  selector: "AG-SORT-INDICATOR",
  component: Dp
}, Oa = ["asc", "desc", null], Tk = class extends U {
  constructor() {
    super(...arguments), this.beanName = "sortSvc";
  }
  progressSort(e, t, n) {
    const o = this.getNextSortDirection(e);
    this.setSortForColumn(e, o, t, n);
  }
  progressSortFromEvent(e, t) {
    const o = this.gos.get("multiSortKey") === "ctrl" ? t.ctrlKey || t.metaKey : t.shiftKey;
    this.progressSort(e, o, "uiColumnSorted");
  }
  setSortForColumn(e, t, n, o) {
    var c;
    t !== "asc" && t !== "desc" && (t = null);
    const { gos: s, showRowGroupCols: i } = this.beans, r = Xn(s);
    let a = [e];
    if (r && e.getColDef().showRowGroup) {
      const u = (c = i == null ? void 0 : i.getSourceColumnsForGroupColumn) == null ? void 0 : c.call(i, e), h = u == null ? void 0 : u.filter((g) => g.isSortable());
      h && (a = [e, ...h]);
    }
    a.forEach((u) => this.setColSort(u, t, o));
    const l = (n || s.get("alwaysMultiSort")) && !s.get("suppressMultiSort"), d = [];
    if (!l) {
      const u = this.clearSortBarTheseColumns(a, o);
      d.push(...u);
    }
    this.updateSortIndex(e), d.push(...a), this.dispatchSortChangedEvents(o, d);
  }
  updateSortIndex(e) {
    const { gos: t, colModel: n, showRowGroupCols: o } = this.beans, s = Xn(t), i = o == null ? void 0 : o.getShowRowGroupCol(e.getId()), r = s && i || e, a = this.getColumnsWithSortingOrdered();
    n.forAllCols((c) => this.setColSortIndex(c, null));
    const l = a.filter((c) => s && c.getColDef().showRowGroup ? !1 : c !== r);
    (r.getSort() ? [...l, r] : l).forEach((c, u) => this.setColSortIndex(c, u));
  }
  // gets called by API, so if data changes, use can call this, which will end up
  // working out the sort order again of the rows.
  onSortChanged(e, t) {
    this.dispatchSortChangedEvents(e, t);
  }
  isSortActive() {
    let e = !1;
    return this.beans.colModel.forAllCols((t) => {
      t.getSort() && (e = !0);
    }), e;
  }
  dispatchSortChangedEvents(e, t) {
    const n = {
      type: "sortChanged",
      source: e
    };
    t && (n.columns = t), this.eventSvc.dispatchEvent(n);
  }
  clearSortBarTheseColumns(e, t) {
    const n = [];
    return this.beans.colModel.forAllCols((o) => {
      e.includes(o) || (o.getSort() && n.push(o), this.setColSort(o, void 0, t));
    }), n;
  }
  getNextSortDirection(e) {
    const t = e.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? Oa, n = t.indexOf(e.getSort()), o = n < 0, s = n == t.length - 1;
    return o || s ? t[0] : t[n + 1];
  }
  /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */
  getIndexedSortMap() {
    const { gos: e, colModel: t, showRowGroupCols: n, rowGroupColsSvc: o } = this.beans;
    let s = [];
    if (t.forAllCols((d) => {
      d.getSort() && s.push(d);
    }), t.isPivotMode()) {
      const d = Xn(e);
      s = s.filter((c) => {
        const u = !!c.getAggFunc(), h = !c.isPrimary(), g = d ? n == null ? void 0 : n.getShowRowGroupCol(c.getId()) : c.getColDef().showRowGroup;
        return u || h || g;
      });
    }
    const i = (o == null ? void 0 : o.columns.filter((d) => !!d.getSort())) ?? [], r = {};
    s.forEach((d, c) => r[d.getId()] = c), s.sort((d, c) => {
      const u = d.getSortIndex(), h = c.getSortIndex();
      if (u != null && h != null)
        return u - h;
      if (u == null && h == null) {
        const g = r[d.getId()], p = r[c.getId()];
        return g > p ? 1 : -1;
      } else return h == null ? -1 : 1;
    });
    const a = Xn(e) && !!i.length;
    a && (s = [
      ...new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        s.map((d) => (n == null ? void 0 : n.getShowRowGroupCol(d.getId())) ?? d)
      )
    ]);
    const l = /* @__PURE__ */ new Map();
    return s.forEach((d, c) => l.set(d, c)), a && i.forEach((d) => {
      const c = n.getShowRowGroupCol(d.getId());
      l.set(d, l.get(c));
    }), l;
  }
  getColumnsWithSortingOrdered() {
    return [...this.getIndexedSortMap().entries()].sort(([, e], [, t]) => e - t).map(([e]) => e);
  }
  // used by server side row models, to sent sort to server
  getSortModel() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      colId: e.getId()
    }));
  }
  getSortOptions() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      column: e
    }));
  }
  canColumnDisplayMixedSort(e) {
    const t = Xn(this.gos), n = !!e.getColDef().showRowGroup;
    return t && n;
  }
  getDisplaySortForColumn(e) {
    var r;
    const t = (r = this.beans.showRowGroupCols) == null ? void 0 : r.getSourceColumnsForGroupColumn(e);
    if (!this.canColumnDisplayMixedSort(e) || !(t != null && t.length))
      return e.getSort();
    const o = e.getColDef().field != null || !!e.getColDef().valueGetter ? [e, ...t] : t, s = o[0].getSort();
    return o.every((a) => a.getSort() == s) ? s : "mixed";
  }
  getDisplaySortIndexForColumn(e) {
    return this.getIndexedSortMap().get(e);
  }
  setupHeader(e, t, n) {
    let o = 0;
    e.addManagedListeners(t, {
      movingChanged: () => {
        o = Date.now();
      }
    }), n && e.addManagedElementListeners(n, {
      click: (i) => {
        const r = t.isMoving(), l = Date.now() - o < 50;
        r || l || this.progressSortFromEvent(t, i);
      }
    });
    const s = () => {
      var r;
      const i = t.getSort();
      if (e.toggleCss("ag-header-cell-sorted-asc", i === "asc"), e.toggleCss("ag-header-cell-sorted-desc", i === "desc"), e.toggleCss("ag-header-cell-sorted-none", !i), t.getColDef().showRowGroup) {
        const a = (r = this.beans.showRowGroupCols) == null ? void 0 : r.getSourceColumnsForGroupColumn(t), d = !(a == null ? void 0 : a.every(
          (c) => t.getSort() == c.getSort()
        ));
        e.toggleCss("ag-header-cell-sorted-mixed", d);
      }
    };
    e.addManagedEventListeners({
      sortChanged: s,
      columnRowGroupChanged: s
    });
  }
  initCol(e) {
    const { sort: t, initialSort: n, sortIndex: o, initialSortIndex: s } = e.colDef;
    t !== void 0 ? (t === "asc" || t === "desc") && (e.sort = t) : (n === "asc" || n === "desc") && (e.sort = n), o !== void 0 ? o !== null && (e.sortIndex = o) : s !== null && (e.sortIndex = s);
  }
  updateColSort(e, t, n) {
    t !== void 0 && (t === "desc" || t === "asc" ? this.setColSort(e, t, n) : this.setColSort(e, void 0, n));
  }
  setColSort(e, t, n) {
    e.sort !== t && (e.sort = t, e.dispatchColEvent("sortChanged", n)), e.dispatchStateUpdatedEvent("sort");
  }
  setColSortIndex(e, t) {
    e.sortIndex = t, e.dispatchStateUpdatedEvent("sortIndex");
  }
  createSortIndicator(e) {
    return new Dp(e);
  }
  getSortIndicatorSelector() {
    return Dk;
  }
}, or = {
  agSetColumnFilter: "SetFilter",
  agSetColumnFloatingFilter: "SetFilter",
  agMultiColumnFilter: "MultiFilter",
  agMultiColumnFloatingFilter: "MultiFilter",
  agGroupColumnFilter: "GroupFilter",
  agGroupColumnFloatingFilter: "GroupFilter",
  agGroupCellRenderer: "GroupCellRenderer",
  agGroupRowRenderer: "GroupCellRenderer",
  agRichSelect: "RichSelect",
  agRichSelectCellEditor: "RichSelect",
  agDetailCellRenderer: "SharedMasterDetail",
  agSparklineCellRenderer: "Sparklines",
  agDragAndDropImage: "SharedDragAndDrop",
  agColumnHeader: "ColumnHeaderComp",
  agColumnGroupHeader: "ColumnGroupHeaderComp",
  agSortIndicator: "Sort",
  agAnimateShowChangeCellRenderer: "HighlightChanges",
  agAnimateSlideCellRenderer: "HighlightChanges",
  agLoadingCellRenderer: "LoadingCellRenderer",
  agSkeletonCellRenderer: "SkeletonCellRenderer",
  agCheckboxCellRenderer: "CheckboxCellRenderer",
  agLoadingOverlay: "Overlay",
  agNoRowsOverlay: "Overlay",
  agTooltipComponent: "Tooltip",
  agReadOnlyFloatingFilter: "CustomFilter",
  agTextColumnFilter: "TextFilter",
  agNumberColumnFilter: "NumberFilter",
  agDateColumnFilter: "DateFilter",
  agDateInput: "DateFilter",
  agTextColumnFloatingFilter: "TextFilter",
  agNumberColumnFloatingFilter: "NumberFilter",
  agDateColumnFloatingFilter: "DateFilter",
  agCellEditor: "TextEditor",
  agSelectCellEditor: "SelectEditor",
  agTextCellEditor: "TextEditor",
  agNumberCellEditor: "NumberEditor",
  agDateCellEditor: "DateEditor",
  agDateStringCellEditor: "DateEditor",
  agCheckboxCellEditor: "CheckboxEditor",
  agLargeTextCellEditor: "LargeTextEditor",
  agMenuItem: "MenuItem",
  agColumnsToolPanel: "ColumnsToolPanel",
  agFiltersToolPanel: "FiltersToolPanel",
  agNewFiltersToolPanel: "NewFiltersToolPanel",
  agAggregationComponent: "StatusBar",
  agSelectedRowCountComponent: "StatusBar",
  agTotalRowCountComponent: "StatusBar",
  agFilteredRowCountComponent: "StatusBar",
  agTotalAndFilteredRowCountComponent: "StatusBar",
  agFindCellRenderer: "Find"
}, kk = () => ({
  checkboxSelection: { version: "32.2", message: "Use `rowSelection.checkboxes` in `GridOptions` instead." },
  headerCheckboxSelection: {
    version: "32.2",
    message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
  },
  headerCheckboxSelectionFilteredOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
  },
  headerCheckboxSelectionCurrentPageOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
  },
  showDisabledCheckboxes: {
    version: "32.2",
    message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
  }
}), Lk = {
  aggFunc: "SharedAggregation",
  autoHeight: "RowAutoHeight",
  cellClass: "CellStyle",
  cellClassRules: "CellStyle",
  cellEditor: ({ cellEditor: e, editable: t }) => t ? typeof e == "string" ? or[e] ?? "CustomEditor" : "CustomEditor" : null,
  cellRenderer: ({ cellRenderer: e }) => typeof e != "string" ? null : or[e],
  cellStyle: "CellStyle",
  columnChooserParams: "ColumnMenu",
  contextMenuItems: "ContextMenu",
  dndSource: "DragAndDrop",
  dndSourceOnRowDrag: "DragAndDrop",
  editable: ({ editable: e, cellEditor: t }) => e && !t ? "TextEditor" : null,
  enableCellChangeFlash: "HighlightChanges",
  enablePivot: "SharedPivot",
  enableRowGroup: "SharedRowGrouping",
  enableValue: "SharedAggregation",
  filter: ({ filter: e }) => e && typeof e != "string" && typeof e != "boolean" ? "CustomFilter" : typeof e == "string" ? or[e] ?? "ColumnFilter" : "ColumnFilter",
  floatingFilter: "ColumnFilter",
  getQuickFilterText: "QuickFilter",
  headerTooltip: "Tooltip",
  mainMenuItems: "ColumnMenu",
  menuTabs: (e) => {
    var n;
    const t = ["columnsMenuTab", "generalMenuTab"];
    return (n = e.menuTabs) != null && n.some((o) => t.includes(o)) ? "ColumnMenu" : null;
  },
  pivot: "SharedPivot",
  pivotIndex: "SharedPivot",
  rowDrag: "RowDrag",
  rowGroup: "SharedRowGrouping",
  rowGroupIndex: "SharedRowGrouping",
  tooltipField: "Tooltip",
  tooltipValueGetter: "Tooltip",
  spanRows: "CellSpan",
  rowGroupingHierarchy: "SharedRowGrouping"
}, Bk = () => ({
  autoHeight: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (t, { paginationAutoPageSize: n }) => n ? "colDef.autoHeight is not supported with paginationAutoPageSize." : null
  },
  cellRendererParams: {
    validate: (t) => (t.rowGroup != null || t.rowGroupIndex != null || t.cellRenderer === "agGroupCellRenderer") && "checkbox" in t.cellRendererParams ? 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.' : null
  },
  flex: {
    validate: (t, n) => n.autoSizeStrategy ? "colDef.flex is not supported with gridOptions.autoSizeStrategy" : null
  },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (t, { rowSelection: n }) => n === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    validate: (t, { rowSelection: n }) => n === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    validate: (t, { rowSelection: n }) => n === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
  },
  headerValueGetter: {
    validate: (t) => {
      const n = t.headerValueGetter;
      return typeof n == "function" || typeof n == "string" ? null : "headerValueGetter must be a function or a valid string expression";
    }
  },
  icons: {
    validate: ({ icons: t }) => {
      if (t) {
        if (t.smallDown)
          return Eo(262);
        if (t.smallLeft)
          return Eo(263);
        if (t.smallRight)
          return Eo(264);
      }
      return null;
    }
  },
  sortingOrder: {
    validate: (t) => {
      const n = t.sortingOrder;
      if (Array.isArray(n) && n.length > 0) {
        const o = n.filter((s) => !Oa.includes(s));
        if (o.length > 0)
          return `sortingOrder must be an array with elements from [${Oa.map(Sd).join()}], currently it includes [${o.map(Sd).join()}]`;
      } else if (!Array.isArray(n) || n.length <= 0)
        return `sortingOrder must be an array with at least one element, currently it's ${n}`;
      return null;
    }
  },
  type: {
    validate: (t) => {
      const n = t.type;
      return n instanceof Array ? n.some((s) => typeof s != "string") ? "if colDef.type is supplied an array it should be of type 'string[]'" : null : typeof n == "string" ? null : "colDef.type should be of type 'string' | 'string[]'";
    }
  },
  rowSpan: {
    validate: (t, { suppressRowTransform: n }) => n ? null : "colDef.rowSpan requires suppressRowTransform to be enabled."
  },
  spanRows: {
    dependencies: {
      editable: { required: [!1, void 0] },
      rowDrag: { required: [!1, void 0] },
      colSpan: { required: [void 0] },
      rowSpan: { required: [void 0] }
    },
    validate: (t, {
      rowSelection: n,
      cellSelection: o,
      suppressRowTransform: s,
      enableCellSpan: i,
      rowDragEntireRow: r,
      enableCellTextSelection: a
    }) => typeof n == "object" && (n == null ? void 0 : n.mode) === "singleRow" && n != null && n.enableClickSelection ? "colDef.spanRows is not supported with rowSelection.clickSelection" : o ? "colDef.spanRows is not supported with cellSelection." : s ? "colDef.spanRows is not supported with suppressRowTransform." : i ? r ? "colDef.spanRows is not supported with rowDragEntireRow." : a ? "colDef.spanRows is not supported with enableCellTextSelection." : null : "colDef.spanRows requires enableCellSpan to be enabled."
  },
  rowGroupingHierarchy: {
    validate(t, { groupHierarchyConfig: n = {} }, o) {
      var r;
      const s = /* @__PURE__ */ new Set([
        "year",
        "quarter",
        "month",
        "formattedMonth",
        "day",
        "hour",
        "minute",
        "second"
      ]), i = [];
      if ((r = t.rowGroupingHierarchy) == null || r.forEach((a) => {
        var l;
        if (typeof a == "object")
          return (l = o.validation) == null || l.validateColDef(a), null;
        !s.has(a) && !(a in n) && i.push(a);
      }), i.length > 0) {
        const a = `The following parts of colDef.rowGroupingHierarchy are not recognised: ${i.map((d) => `"${d}"`).join(", ")}.`, l = `Choose one of ${[...s].map((d) => `"${d}"`).join(", ")}, or define your own parts in gridOptions.groupHierarchyConfig.`;
        return `${a}
${l}`;
      }
      return null;
    }
  }
}), Ok = {
  headerName: void 0,
  columnGroupShow: void 0,
  headerStyle: void 0,
  headerClass: void 0,
  toolPanelClass: void 0,
  headerValueGetter: void 0,
  pivotKeys: void 0,
  groupId: void 0,
  colId: void 0,
  sort: void 0,
  initialSort: void 0,
  field: void 0,
  type: void 0,
  cellDataType: void 0,
  tooltipComponent: void 0,
  tooltipField: void 0,
  headerTooltip: void 0,
  cellClass: void 0,
  showRowGroup: void 0,
  filter: void 0,
  initialAggFunc: void 0,
  defaultAggFunc: void 0,
  aggFunc: void 0,
  pinned: void 0,
  initialPinned: void 0,
  chartDataType: void 0,
  cellAriaRole: void 0,
  cellEditorPopupPosition: void 0,
  headerGroupComponent: void 0,
  headerGroupComponentParams: void 0,
  cellStyle: void 0,
  cellRenderer: void 0,
  cellRendererParams: void 0,
  cellEditor: void 0,
  cellEditorParams: void 0,
  filterParams: void 0,
  pivotValueColumn: void 0,
  headerComponent: void 0,
  headerComponentParams: void 0,
  floatingFilterComponent: void 0,
  floatingFilterComponentParams: void 0,
  tooltipComponentParams: void 0,
  refData: void 0,
  columnChooserParams: void 0,
  children: void 0,
  sortingOrder: void 0,
  allowedAggFuncs: void 0,
  menuTabs: void 0,
  pivotTotalColumnIds: void 0,
  cellClassRules: void 0,
  icons: void 0,
  sortIndex: void 0,
  initialSortIndex: void 0,
  flex: void 0,
  initialFlex: void 0,
  width: void 0,
  initialWidth: void 0,
  minWidth: void 0,
  maxWidth: void 0,
  rowGroupIndex: void 0,
  initialRowGroupIndex: void 0,
  pivotIndex: void 0,
  initialPivotIndex: void 0,
  suppressColumnsToolPanel: void 0,
  suppressFiltersToolPanel: void 0,
  openByDefault: void 0,
  marryChildren: void 0,
  suppressStickyLabel: void 0,
  hide: void 0,
  initialHide: void 0,
  rowGroup: void 0,
  initialRowGroup: void 0,
  pivot: void 0,
  initialPivot: void 0,
  checkboxSelection: void 0,
  showDisabledCheckboxes: void 0,
  headerCheckboxSelection: void 0,
  headerCheckboxSelectionFilteredOnly: void 0,
  headerCheckboxSelectionCurrentPageOnly: void 0,
  suppressHeaderMenuButton: void 0,
  suppressMovable: void 0,
  lockPosition: void 0,
  lockVisible: void 0,
  lockPinned: void 0,
  unSortIcon: void 0,
  suppressSizeToFit: void 0,
  suppressAutoSize: void 0,
  enableRowGroup: void 0,
  enablePivot: void 0,
  enableValue: void 0,
  editable: void 0,
  suppressPaste: void 0,
  suppressNavigable: void 0,
  enableCellChangeFlash: void 0,
  rowDrag: void 0,
  dndSource: void 0,
  autoHeight: void 0,
  wrapText: void 0,
  sortable: void 0,
  resizable: void 0,
  singleClickEdit: void 0,
  floatingFilter: void 0,
  cellEditorPopup: void 0,
  suppressFillHandle: void 0,
  wrapHeaderText: void 0,
  autoHeaderHeight: void 0,
  dndSourceOnRowDrag: void 0,
  valueGetter: void 0,
  valueSetter: void 0,
  filterValueGetter: void 0,
  keyCreator: void 0,
  valueFormatter: void 0,
  valueParser: void 0,
  comparator: void 0,
  equals: void 0,
  pivotComparator: void 0,
  suppressKeyboardEvent: void 0,
  suppressHeaderKeyboardEvent: void 0,
  colSpan: void 0,
  rowSpan: void 0,
  spanRows: void 0,
  getQuickFilterText: void 0,
  onCellValueChanged: void 0,
  onCellClicked: void 0,
  onCellDoubleClicked: void 0,
  onCellContextMenu: void 0,
  rowDragText: void 0,
  tooltipValueGetter: void 0,
  cellRendererSelector: void 0,
  cellEditorSelector: void 0,
  suppressSpanHeaderHeight: void 0,
  useValueFormatterForExport: void 0,
  useValueParserForImport: void 0,
  mainMenuItems: void 0,
  contextMenuItems: void 0,
  suppressFloatingFilterButton: void 0,
  suppressHeaderFilterButton: void 0,
  suppressHeaderContextMenu: void 0,
  loadingCellRenderer: void 0,
  loadingCellRendererParams: void 0,
  loadingCellRendererSelector: void 0,
  context: void 0,
  dateComponent: void 0,
  dateComponentParams: void 0,
  getFindText: void 0,
  rowGroupingHierarchy: void 0
}, Gk = () => Object.keys(Ok), Hk = () => ({
  objectName: "colDef",
  allProperties: Gk(),
  docsUrl: "column-properties/",
  deprecations: kk(),
  validations: Bk()
}), Vk = [
  "overlayLoadingTemplate",
  "overlayNoRowsTemplate",
  "gridId",
  "quickFilterText",
  "rowModelType",
  "editType",
  "domLayout",
  "clipboardDelimiter",
  "rowGroupPanelShow",
  "multiSortKey",
  "pivotColumnGroupTotals",
  "pivotRowTotals",
  "pivotPanelShow",
  "fillHandleDirection",
  "groupDisplayType",
  "treeDataDisplayType",
  "treeDataChildrenField",
  "treeDataParentIdField",
  "colResizeDefault",
  "tooltipTrigger",
  "serverSidePivotResultFieldSeparator",
  "columnMenu",
  "tooltipShowMode",
  "invalidEditValueMode",
  "grandTotalRow",
  "themeCssLayer",
  "findSearchValue",
  "styleNonce",
  "renderingMode"
], _k = [
  "components",
  "rowStyle",
  "context",
  "autoGroupColumnDef",
  "localeText",
  "icons",
  "datasource",
  "dragAndDropImageComponentParams",
  "serverSideDatasource",
  "viewportDatasource",
  "groupRowRendererParams",
  "aggFuncs",
  "fullWidthCellRendererParams",
  "defaultColGroupDef",
  "defaultColDef",
  "defaultCsvExportParams",
  "defaultExcelExportParams",
  "columnTypes",
  "rowClassRules",
  "detailCellRendererParams",
  "loadingCellRendererParams",
  "loadingOverlayComponentParams",
  "noRowsOverlayComponentParams",
  "popupParent",
  "themeStyleContainer",
  "statusBar",
  "chartThemeOverrides",
  "customChartThemes",
  "chartToolPanelsDef",
  "dataTypeDefinitions",
  "advancedFilterParent",
  "advancedFilterBuilderParams",
  "advancedFilterParams",
  "initialState",
  "autoSizeStrategy",
  "selectionColumnDef",
  "findOptions",
  "filterHandlers",
  "groupHierarchyConfig"
], Nk = [
  "sortingOrder",
  "alignedGrids",
  "rowData",
  "columnDefs",
  "excelStyles",
  "pinnedTopRowData",
  "pinnedBottomRowData",
  "chartThemes",
  "rowClass",
  "paginationPageSizeSelector"
], Ry = [
  "rowHeight",
  "detailRowHeight",
  "rowBuffer",
  "headerHeight",
  "groupHeaderHeight",
  "groupLockGroupColumns",
  "floatingFiltersHeight",
  "pivotHeaderHeight",
  "pivotGroupHeaderHeight",
  "groupDefaultExpanded",
  "pivotDefaultExpanded",
  "viewportRowModelPageSize",
  "viewportRowModelBufferSize",
  "autoSizePadding",
  "maxBlocksInCache",
  "maxConcurrentDatasourceRequests",
  "tooltipShowDelay",
  "tooltipHideDelay",
  "cacheOverflowSize",
  "paginationPageSize",
  "cacheBlockSize",
  "infiniteInitialRowCount",
  "serverSideInitialRowCount",
  "scrollbarWidth",
  "asyncTransactionWaitMillis",
  "blockLoadDebounceMillis",
  "keepDetailRowsCount",
  "undoRedoCellEditingLimit",
  "cellFlashDuration",
  "cellFadeDuration",
  "tabIndex",
  "pivotMaxGeneratedColumns",
  "rowDragInsertDelay"
], $k = ["theme", "rowSelection"], zk = [
  "cellSelection",
  "sideBar",
  "rowNumbers",
  "suppressGroupChangesColumnVisibility",
  "groupAggFiltering",
  "suppressStickyTotalRow",
  "groupHideParentOfSingleChild",
  "enableRowPinning"
], Ey = [
  "loadThemeGoogleFonts",
  "suppressMakeColumnVisibleAfterUnGroup",
  "suppressRowClickSelection",
  "suppressCellFocus",
  "suppressHeaderFocus",
  "suppressHorizontalScroll",
  "groupSelectsChildren",
  "alwaysShowHorizontalScroll",
  "alwaysShowVerticalScroll",
  "debug",
  "enableBrowserTooltips",
  "enableCellExpressions",
  "groupSuppressBlankHeader",
  "suppressMenuHide",
  "suppressRowDeselection",
  "unSortIcon",
  "suppressMultiSort",
  "alwaysMultiSort",
  "singleClickEdit",
  "suppressLoadingOverlay",
  "suppressNoRowsOverlay",
  "suppressAutoSize",
  "skipHeaderOnAutoSize",
  "suppressColumnMoveAnimation",
  "suppressMoveWhenColumnDragging",
  "suppressMovableColumns",
  "suppressFieldDotNotation",
  "enableRangeSelection",
  "enableRangeHandle",
  "enableFillHandle",
  "suppressClearOnFillReduction",
  "deltaSort",
  "suppressTouch",
  "allowContextMenuWithControlKey",
  "suppressContextMenu",
  "suppressDragLeaveHidesColumns",
  "suppressRowGroupHidesColumns",
  "suppressMiddleClickScrolls",
  "suppressPreventDefaultOnMouseWheel",
  "suppressCopyRowsToClipboard",
  "copyHeadersToClipboard",
  "copyGroupHeadersToClipboard",
  "pivotMode",
  "suppressAggFuncInHeader",
  "suppressColumnVirtualisation",
  "alwaysAggregateAtRootLevel",
  "suppressFocusAfterRefresh",
  "functionsReadOnly",
  "animateRows",
  "groupSelectsFiltered",
  "groupRemoveSingleChildren",
  "groupRemoveLowestSingleChildren",
  "enableRtl",
  "enableCellSpan",
  "suppressClickEdit",
  "rowDragEntireRow",
  "rowDragManaged",
  "suppressRowDrag",
  "suppressMoveWhenRowDragging",
  "rowDragMultiRow",
  "enableGroupEdit",
  "embedFullWidthRows",
  "suppressPaginationPanel",
  "groupHideOpenParents",
  "groupAllowUnbalanced",
  "pagination",
  "paginationAutoPageSize",
  "suppressScrollOnNewData",
  "suppressScrollWhenPopupsAreOpen",
  "purgeClosedRowNodes",
  "cacheQuickFilter",
  "includeHiddenColumnsInQuickFilter",
  "ensureDomOrder",
  "accentedSort",
  "suppressChangeDetection",
  "valueCache",
  "valueCacheNeverExpires",
  "aggregateOnlyChangedColumns",
  "suppressAnimationFrame",
  "suppressExcelExport",
  "suppressCsvExport",
  "includeHiddenColumnsInAdvancedFilter",
  "suppressMultiRangeSelection",
  "enterNavigatesVerticallyAfterEdit",
  "enterNavigatesVertically",
  "suppressPropertyNamesCheck",
  "rowMultiSelectWithClick",
  "suppressRowHoverHighlight",
  "suppressRowTransform",
  "suppressClipboardPaste",
  "suppressLastEmptyLineOnPaste",
  "enableCharts",
  "suppressMaintainUnsortedOrder",
  "enableCellTextSelection",
  "suppressBrowserResizeObserver",
  "suppressMaxRenderedRowRestriction",
  "excludeChildrenWhenTreeDataFiltering",
  "tooltipMouseTrack",
  "tooltipInteraction",
  "keepDetailRows",
  "paginateChildRows",
  "preventDefaultOnContextMenu",
  "undoRedoCellEditing",
  "allowDragFromColumnsToolPanel",
  "pivotSuppressAutoColumn",
  "suppressExpandablePivotGroups",
  "debounceVerticalScrollbar",
  "detailRowAutoHeight",
  "serverSideSortAllLevels",
  "serverSideEnableClientSideSort",
  "serverSideOnlyRefreshFilteredGroups",
  "suppressAggFilteredOnly",
  "showOpenedGroup",
  "suppressClipboardApi",
  "suppressModelUpdateAfterUpdateTransaction",
  "stopEditingWhenCellsLoseFocus",
  "groupMaintainOrder",
  "columnHoverHighlight",
  "readOnlyEdit",
  "suppressRowVirtualisation",
  "enableCellEditingOnBackspace",
  "resetRowDataOnUpdate",
  "removePivotHeaderRowWhenSingleValueColumn",
  "suppressCopySingleCellRanges",
  "suppressGroupRowsSticky",
  "suppressCutToClipboard",
  "rowGroupPanelSuppressSort",
  "allowShowChangeAfterFilter",
  "enableAdvancedFilter",
  "masterDetail",
  "treeData",
  "reactiveCustomComponents",
  "applyQuickFilterBeforePivotOrAgg",
  "suppressServerSideFullWidthLoadingRow",
  "suppressAdvancedFilterEval",
  "loading",
  "maintainColumnOrder",
  "enableStrictPivotColumnOrder",
  "suppressSetFilterByDefault",
  "enableFilterHandlers",
  "suppressStartEditOnTab",
  "hidePaddedHeaderRows",
  "ssrmExpandAllAffectsAllRows"
], Wk = [
  "doesExternalFilterPass",
  "processPivotResultColDef",
  "processPivotResultColGroupDef",
  "getBusinessKeyForNode",
  "isRowSelectable",
  "rowDragText",
  "groupRowRenderer",
  "dragAndDropImageComponent",
  "fullWidthCellRenderer",
  "loadingCellRenderer",
  "loadingOverlayComponent",
  "noRowsOverlayComponent",
  "detailCellRenderer",
  "quickFilterParser",
  "quickFilterMatcher",
  "getLocaleText",
  "isExternalFilterPresent",
  "getRowHeight",
  "getRowClass",
  "getRowStyle",
  "getFullRowEditValidationErrors",
  "getContextMenuItems",
  "getMainMenuItems",
  "processRowPostCreate",
  "processCellForClipboard",
  "getGroupRowAgg",
  "isFullWidthRow",
  "sendToClipboard",
  "focusGridInnerElement",
  "navigateToNextHeader",
  "tabToNextHeader",
  "navigateToNextCell",
  "tabToNextCell",
  "processCellFromClipboard",
  "getDocument",
  "postProcessPopup",
  "getChildCount",
  "getDataPath",
  "isRowMaster",
  "postSortRows",
  "processHeaderForClipboard",
  "processUnpinnedColumns",
  "processGroupHeaderForClipboard",
  "paginationNumberFormatter",
  "processDataFromClipboard",
  "getServerSideGroupKey",
  "isServerSideGroup",
  "createChartContainer",
  "getChartToolbarItems",
  "fillOperation",
  "isApplyServerSideTransaction",
  "getServerSideGroupLevelParams",
  "isServerSideGroupOpenByDefault",
  "isGroupOpenByDefault",
  "initialGroupOrderComparator",
  "loadingCellRendererSelector",
  "getRowId",
  "chartMenuItems",
  "groupTotalRow",
  "alwaysPassFilter",
  "isRowPinnable",
  "isRowPinned",
  "isRowValidDropPosition"
], Hh = () => [
  ...Nk,
  ..._k,
  ...Vk,
  ...Ry,
  ...Wk,
  ...Ey,
  ...zk,
  ...$k
], Uk = () => ({
  suppressLoadingOverlay: { version: "32", message: "Use `loading`=false instead." },
  enableFillHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeSelection: { version: "32.2", message: "Use `cellSelection = true` instead." },
  suppressMultiRangeSelection: {
    version: "32.2",
    message: "Use `cellSelection.suppressMultiRanges` instead."
  },
  suppressClearOnFillReduction: {
    version: "32.2",
    message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
  },
  fillHandleDirection: { version: "32.2", message: "Use `cellSelection.handle.direction` instead." },
  fillOperation: { version: "32.2", message: "Use `cellSelection.handle.setFillValue` instead." },
  suppressRowClickSelection: {
    version: "32.2",
    message: "Use `rowSelection.enableClickSelection` instead."
  },
  suppressRowDeselection: { version: "32.2", message: "Use `rowSelection.enableClickSelection` instead." },
  rowMultiSelectWithClick: {
    version: "32.2",
    message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
  },
  groupSelectsChildren: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
  },
  groupSelectsFiltered: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
  },
  isRowSelectable: { version: "32.2", message: "Use `selectionOptions.isRowSelectable` instead." },
  suppressCopySingleCellRanges: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  suppressCopyRowsToClipboard: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  onRangeSelectionChanged: { version: "32.2", message: "Use `onCellSelectionChanged` instead." },
  onRangeDeleteStart: { version: "32.2", message: "Use `onCellSelectionDeleteStart` instead." },
  onRangeDeleteEnd: { version: "32.2", message: "Use `onCellSelectionDeleteEnd` instead." },
  suppressBrowserResizeObserver: {
    version: "32.2",
    message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
  },
  onColumnEverythingChanged: {
    version: "32.2",
    message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
  },
  groupRemoveSingleChildren: {
    version: "33",
    message: "Use `groupHideParentOfSingleChild` instead."
  },
  groupRemoveLowestSingleChildren: {
    version: "33",
    message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
  },
  suppressRowGroupHidesColumns: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
  },
  suppressMakeColumnVisibleAfterUnGroup: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
  },
  unSortIcon: { version: "33", message: "Use `defaultColDef.unSortIcon` instead." },
  sortingOrder: { version: "33", message: "Use `defaultColDef.sortingOrder` instead." },
  suppressPropertyNamesCheck: {
    version: "33",
    message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
  },
  suppressAdvancedFilterEval: {
    version: "34",
    message: "Advanced filter no longer uses function evaluation, so this option has no effect."
  }
});
function co(e, t, n) {
  return typeof t == "number" || t == null ? t == null || t >= n ? null : `${e}: value should be greater than or equal to ${n}` : `${e}: value should be a number`;
}
var Kk = {
  alignedGrids: "AlignedGrids",
  allowContextMenuWithControlKey: "ContextMenu",
  autoSizeStrategy: "ColumnAutoSize",
  cellSelection: "CellSelection",
  columnHoverHighlight: "ColumnHover",
  datasource: "InfiniteRowModel",
  doesExternalFilterPass: "ExternalFilter",
  editType: "EditCore",
  invalidEditValueMode: "EditCore",
  enableAdvancedFilter: "AdvancedFilter",
  enableCellSpan: "CellSpan",
  enableCharts: "IntegratedCharts",
  enableRangeSelection: "CellSelection",
  enableRowPinning: "PinnedRow",
  findSearchValue: "Find",
  getFullRowEditValidationErrors: "EditCore",
  getContextMenuItems: "ContextMenu",
  getLocaleText: "Locale",
  getMainMenuItems: "ColumnMenu",
  getRowClass: "RowStyle",
  getRowStyle: "RowStyle",
  groupTotalRow: "SharedRowGrouping",
  grandTotalRow: "SharedRowGrouping",
  initialState: "GridState",
  isExternalFilterPresent: "ExternalFilter",
  isRowPinnable: "PinnedRow",
  isRowPinned: "PinnedRow",
  localeText: "Locale",
  masterDetail: "SharedMasterDetail",
  pagination: "Pagination",
  pinnedBottomRowData: "PinnedRow",
  pinnedTopRowData: "PinnedRow",
  pivotMode: "SharedPivot",
  pivotPanelShow: "RowGroupingPanel",
  quickFilterText: "QuickFilter",
  rowClass: "RowStyle",
  rowClassRules: "RowStyle",
  rowData: "ClientSideRowModel",
  rowDragManaged: "RowDrag",
  rowGroupPanelShow: "RowGroupingPanel",
  rowNumbers: "RowNumbers",
  rowSelection: "SharedRowSelection",
  rowStyle: "RowStyle",
  serverSideDatasource: "ServerSideRowModel",
  sideBar: "SideBar",
  statusBar: "StatusBar",
  treeData: "SharedTreeData",
  undoRedoCellEditing: "UndoRedoEdit",
  valueCache: "ValueCache",
  viewportDatasource: "ViewportRowModel"
}, Zk = () => {
  const e = {
    autoSizePadding: {
      validate({ autoSizePadding: n }) {
        return co("autoSizePadding", n, 0);
      }
    },
    cacheBlockSize: {
      supportedRowModels: ["serverSide", "infinite"],
      validate({ cacheBlockSize: n }) {
        return co("cacheBlockSize", n, 1);
      }
    },
    cacheOverflowSize: {
      validate({ cacheOverflowSize: n }) {
        return co("cacheOverflowSize", n, 1);
      }
    },
    datasource: {
      supportedRowModels: ["infinite"]
    },
    domLayout: {
      validate: (n) => {
        const o = n.domLayout, s = ["autoHeight", "normal", "print"];
        return o && !s.includes(o) ? `domLayout must be one of [${s.join()}], currently it's ${o}` : null;
      }
    },
    enableFillHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeSelection: {
      dependencies: {
        rowDragEntireRow: { required: [!1, void 0] }
      }
    },
    enableRowPinning: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: n, pinnedTopRowData: o, pinnedBottomRowData: s }) {
        return n && (o || s) ? "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : null;
      }
    },
    isRowPinnable: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: n, isRowPinnable: o, pinnedTopRowData: s, pinnedBottomRowData: i }) {
        return o && (s || i) ? "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : !n && o ? "`isRowPinnable` requires `enableRowPinning` to be set." : null;
      }
    },
    isRowPinned: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: n, isRowPinned: o, pinnedTopRowData: s, pinnedBottomRowData: i }) {
        return o && (s || i) ? "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : !n && o ? "`isRowPinned` requires `enableRowPinning` to be set." : null;
      }
    },
    groupDefaultExpanded: {
      supportedRowModels: ["clientSide"]
    },
    groupHideOpenParents: {
      supportedRowModels: ["clientSide", "serverSide"],
      dependencies: {
        groupTotalRow: { required: [void 0, "bottom"] },
        treeData: {
          required: [void 0, !1],
          reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
        }
      }
    },
    groupHideParentOfSingleChild: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] }
      }
    },
    groupRemoveLowestSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveSingleChildren: { required: [void 0, !1] }
      }
    },
    groupRemoveSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveLowestSingleChildren: { required: [void 0, !1] }
      }
    },
    groupSelectsChildren: {
      dependencies: {
        rowSelection: { required: ["multiple"] }
      }
    },
    groupHierarchyConfig: {
      validate({ groupHierarchyConfig: n = {} }, o, s) {
        var i;
        for (const r of Object.keys(n))
          (i = s.validation) == null || i.validateColDef(n[r]);
        return null;
      }
    },
    icons: {
      validate: ({ icons: n }) => {
        if (n) {
          if (n.smallDown)
            return Eo(262);
          if (n.smallLeft)
            return Eo(263);
          if (n.smallRight)
            return Eo(264);
        }
        return null;
      }
    },
    infiniteInitialRowCount: {
      validate({ infiniteInitialRowCount: n }) {
        return co("infiniteInitialRowCount", n, 1);
      }
    },
    initialGroupOrderComparator: {
      supportedRowModels: ["clientSide"]
    },
    ssrmExpandAllAffectsAllRows: {
      validate: (n) => {
        if (typeof n.ssrmExpandAllAffectsAllRows == "boolean") {
          if (n.rowModelType !== "serverSide")
            return "'ssrmExpandAllAffectsAllRows' is only supported with the Server Side Row Model.";
          if (n.ssrmExpandAllAffectsAllRows && typeof n.getRowId != "function")
            return "'getRowId' callback must be provided for Server Side Row Model grouping to work correctly.";
        }
        return null;
      }
    },
    keepDetailRowsCount: {
      validate({ keepDetailRowsCount: n }) {
        return co("keepDetailRowsCount", n, 1);
      }
    },
    paginationPageSize: {
      validate({ paginationPageSize: n }) {
        return co("paginationPageSize", n, 1);
      }
    },
    paginationPageSizeSelector: {
      validate: (n) => {
        const o = n.paginationPageSizeSelector;
        return typeof o == "boolean" || o == null || o.length ? null : `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
      }
    },
    pivotMode: {
      dependencies: {
        treeData: {
          required: [!1, void 0],
          reason: "Pivot Mode is not supported with Tree Data."
        }
      }
    },
    quickFilterText: {
      supportedRowModels: ["clientSide"]
    },
    rowBuffer: {
      validate({ rowBuffer: n }) {
        return co("rowBuffer", n, 0);
      }
    },
    rowClass: {
      validate: (n) => typeof n.rowClass == "function" ? "rowClass should not be a function, please use getRowClass instead" : null
    },
    rowData: {
      supportedRowModels: ["clientSide"]
    },
    rowDragManaged: {
      supportedRowModels: ["clientSide"],
      dependencies: {
        pagination: {
          required: [!1, void 0]
        }
      }
    },
    rowSelection: {
      validate({ rowSelection: n }) {
        return n && typeof n == "string" ? 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.' : n && typeof n != "object" ? "Expected `RowSelectionOptions` object for the `rowSelection` property." : n && n.mode !== "multiRow" && n.mode !== "singleRow" ? `Selection mode "${n.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.` : null;
      }
    },
    rowStyle: {
      validate: (n) => {
        const o = n.rowStyle;
        return o && typeof o == "function" ? "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead" : null;
      }
    },
    serverSideDatasource: {
      supportedRowModels: ["serverSide"]
    },
    serverSideInitialRowCount: {
      supportedRowModels: ["serverSide"],
      validate({ serverSideInitialRowCount: n }) {
        return co("serverSideInitialRowCount", n, 1);
      }
    },
    serverSideOnlyRefreshFilteredGroups: {
      supportedRowModels: ["serverSide"]
    },
    serverSideSortAllLevels: {
      supportedRowModels: ["serverSide"]
    },
    sortingOrder: {
      validate: (n) => {
        const o = n.sortingOrder;
        if (Array.isArray(o) && o.length > 0) {
          const s = o.filter((i) => !Oa.includes(i));
          if (s.length > 0)
            return `sortingOrder must be an array with elements from [${Oa.map(Sd).join()}], currently it includes [${s.map(Sd).join()}]`;
        } else if (!Array.isArray(o) || o.length <= 0)
          return `sortingOrder must be an array with at least one element, currently it's ${o}`;
        return null;
      }
    },
    tooltipHideDelay: {
      validate: (n) => n.tooltipHideDelay && n.tooltipHideDelay < 0 ? "tooltipHideDelay should not be lower than 0" : null
    },
    tooltipShowDelay: {
      validate: (n) => n.tooltipShowDelay && n.tooltipShowDelay < 0 ? "tooltipShowDelay should not be lower than 0" : null
    },
    treeData: {
      supportedRowModels: ["clientSide", "serverSide"],
      validate: (n) => {
        const o = n.rowModelType ?? "clientSide";
        switch (o) {
          case "clientSide": {
            const { treeDataChildrenField: s, treeDataParentIdField: i, getDataPath: r, getRowId: a } = n;
            if (!s && !i && !r)
              return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
            if (s) {
              if (r)
                return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
              if (i)
                return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
            }
            if (i) {
              if (!a)
                return "getRowId callback not provided, tree data with parent id cannot be built.";
              if (r)
                return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
            }
            return null;
          }
          case "serverSide": {
            const s = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${o} row model.`;
            return n.isServerSideGroup && n.getServerSideGroupKey ? null : s;
          }
        }
        return null;
      }
    },
    viewportDatasource: {
      supportedRowModels: ["viewport"]
    },
    viewportRowModelBufferSize: {
      validate({ viewportRowModelBufferSize: n }) {
        return co("viewportRowModelBufferSize", n, 0);
      }
    },
    viewportRowModelPageSize: {
      validate({ viewportRowModelPageSize: n }) {
        return co("viewportRowModelPageSize", n, 1);
      }
    },
    rowDragEntireRow: {
      dependencies: {
        cellSelection: { required: [void 0] }
      }
    },
    autoGroupColumnDef: {
      validate({ autoGroupColumnDef: n, showOpenedGroup: o }) {
        return n != null && n.field && o ? "autoGroupColumnDef.field and showOpenedGroup are not supported when used together." : n != null && n.valueGetter && o ? "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together." : null;
      }
    },
    renderingMode: {
      validate: (n) => {
        const o = n.renderingMode, s = ["default", "legacy"];
        return o && !s.includes(o) ? `renderingMode must be one of [${s.join()}], currently it's ${o}` : null;
      }
    }
  }, t = {};
  return Ey.forEach((n) => {
    t[n] = { expectedType: "boolean" };
  }), Ry.forEach((n) => {
    t[n] = { expectedType: "number" };
  }), on(t, e), t;
}, qk = () => ({
  objectName: "gridOptions",
  allProperties: [...Hh(), ...Object.values(Ac)],
  propertyExceptions: ["api"],
  docsUrl: "grid-options/",
  deprecations: Uk(),
  validations: Zk()
}), jk = 0, Yk = 0, Jm = "__ag_grid_instance", Qk = class extends U {
  constructor() {
    super(...arguments), this.beanName = "gos", this.domDataKey = "__AG_" + Math.random().toString(), this.instanceId = Yk++, this.gridReadyFired = !1, this.queueEvents = [], this.propEventSvc = new Fs(), this.globalEventHandlerFactory = (e) => (t, n) => {
      if (!this.isAlive())
        return;
      const o = da.has(t);
      if (o && !e || !o && e || !Jk(t))
        return;
      const s = (i, r) => {
        const a = Ac[i], l = this.gridOptions[a];
        typeof l == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => l(r));
      };
      if (this.gridReadyFired)
        s(t, n);
      else if (t === "gridReady") {
        s(t, n), this.gridReadyFired = !0;
        for (const i of this.queueEvents)
          s(i.eventName, i.event);
        this.queueEvents = [];
      } else
        this.queueEvents.push({ eventName: t, event: n });
    };
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, this.validation = e.validation, this.api = e.gridApi, this.gridId = e.context.getId();
  }
  // This is quicker then having code call gridOptionsService.get('context')
  get gridOptionsContext() {
    return this.gridOptions.context;
  }
  postConstruct() {
    this.validateGridOptions(this.gridOptions), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), !0), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides), this.addManagedEventListeners({
      gridOptionsChanged: ({ options: e }) => {
        this.updateGridOptions({ options: e, force: !0, source: "optionsUpdated" });
      }
    });
  }
  destroy() {
    super.destroy(), this.queueEvents = [];
  }
  /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */
  get(e) {
    return this.gridOptions[e] ?? A3[e];
  }
  /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */
  getCallback(e) {
    return this.mergeGridCommonParams(this.gridOptions[e]);
  }
  /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */
  exists(e) {
    return ue(this.gridOptions[e]);
  }
  /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */
  mergeGridCommonParams(e) {
    return e && ((n) => e(this.addCommon(n)));
  }
  updateGridOptions({
    options: e,
    force: t,
    source: n = "api"
  }) {
    const o = { id: jk++, properties: [] }, s = [], { gridOptions: i, validation: r } = this;
    for (const a of Object.keys(e)) {
      const l = e[a];
      r == null || r.warnOnInitialPropertyUpdate(n, a);
      const d = t || typeof l == "object" && n === "api", c = i[a];
      if (d || c !== l) {
        i[a] = l;
        const u = {
          type: a,
          currentValue: l,
          previousValue: c,
          changeSet: o,
          source: n
        };
        s.push(u);
      }
    }
    this.validateGridOptions(this.gridOptions), o.properties = s.map((a) => a.type), s.forEach((a) => {
      Is(this, `Updated property ${a.type} from`, a.previousValue, " to ", a.currentValue), this.propEventSvc.dispatchEvent(a);
    });
  }
  addPropertyEventListener(e, t) {
    this.propEventSvc.addEventListener(e, t);
  }
  removePropertyEventListener(e, t) {
    this.propEventSvc.removeEventListener(e, t);
  }
  getDomDataKey() {
    return this.domDataKey;
  }
  /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */
  addCommon(e) {
    return e.api = this.api, e.context = this.gridOptionsContext, e;
  }
  validateOptions(e, t) {
    for (const n of Object.keys(e)) {
      const o = e[n];
      if (o == null || o === !1)
        continue;
      let s = t[n];
      typeof s == "function" && (s = s(e, this.gridOptions, this.beans)), s && this.assertModuleRegistered(s, n);
    }
  }
  validateGridOptions(e) {
    var t;
    this.validateOptions(e, Kk), (t = this.validation) == null || t.processGridOptions(e);
  }
  validateColDef(e, t, n) {
    var o, s;
    (n || !((o = this.beans.dataTypeSvc) != null && o.isColPendingInference(t))) && (this.validateOptions(e, Lk), (s = this.validation) == null || s.validateColDef(e));
  }
  assertModuleRegistered(e, t) {
    const n = Array.isArray(e) ? e.some((o) => this.isModuleRegistered(o)) : this.isModuleRegistered(e);
    return n || $e(200, {
      ...this.getModuleErrorParams(),
      moduleName: e,
      reasonOrId: t
    }), n;
  }
  getModuleErrorParams() {
    return {
      gridId: this.gridId,
      gridScoped: Pp(),
      rowModelType: this.get("rowModelType"),
      isUmd: L4()
    };
  }
  isModuleRegistered(e) {
    return Oh(e, this.gridId, this.get("rowModelType"));
  }
  setInstanceDomData(e) {
    e[Jm] = this.instanceId;
  }
  isElementInThisInstance(e) {
    let t = e;
    for (; t; ) {
      const n = t[Jm];
      if (ue(n))
        return n === this.instanceId;
      t = t.parentElement;
    }
    return !1;
  }
};
function Jk(e) {
  return !!Ac[e];
}
function Ay(e) {
  const t = { "aria-hidden": "true" };
  return {
    tag: "div",
    cls: "ag-cell-label-container",
    role: "presentation",
    children: [
      {
        tag: "span",
        ref: "eMenu",
        cls: "ag-header-icon ag-header-cell-menu-button",
        attrs: t
      },
      {
        tag: "span",
        ref: "eFilterButton",
        cls: "ag-header-icon ag-header-cell-filter-button",
        attrs: t
      },
      {
        tag: "div",
        ref: "eLabel",
        cls: "ag-header-cell-label",
        role: "presentation",
        children: [
          { tag: "span", ref: "eText", cls: "ag-header-cell-text" },
          {
            tag: "span",
            ref: "eFilter",
            cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
            attrs: t
          },
          e ? { tag: "ag-sort-indicator", ref: "eSortIndicator" } : null
        ]
      }
    ]
  };
}
var Xk = Ay(!0), eL = Ay(!1), tL = class extends Te {
  constructor() {
    super(...arguments), this.eFilter = X, this.eFilterButton = X, this.eSortIndicator = X, this.eMenu = X, this.eLabel = X, this.eText = X, this.eSortOrder = X, this.eSortAsc = X, this.eSortDesc = X, this.eSortMixed = X, this.eSortNone = X, this.isLoadingInnerComponent = !1;
  }
  refresh(e) {
    var n, o, s;
    const t = this.params;
    if (this.params = e, this.workOutTemplate(e, !!((n = this.beans) != null && n.sortSvc)) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || e.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || t.enableFilterButton != e.enableFilterButton || t.enableFilterIcon != e.enableFilterIcon)
      return !1;
    if (this.innerHeaderComponent) {
      const i = { ...e };
      on(i, e.innerHeaderComponentParams), (s = (o = this.innerHeaderComponent).refresh) == null || s.call(o, i);
    } else
      this.setDisplayName(e);
    return !0;
  }
  workOutTemplate(e, t) {
    const n = e.template;
    return n ? n != null && n.trim ? n.trim() : n : t ? Xk : eL;
  }
  init(e) {
    this.params = e;
    const { sortSvc: t, touchSvc: n, rowNumbersSvc: o, userCompFactory: s } = this.beans, i = t == null ? void 0 : t.getSortIndicatorSelector();
    this.currentTemplate = this.workOutTemplate(e, !!i), this.setTemplate(this.currentTemplate, i ? [i] : void 0), n == null || n.setupForHeader(this), this.setMenu(), this.setupSort(), o == null || o.setupForHeader(this), this.setupFilterIcon(), this.setupFilterButton(), this.workOutInnerHeaderComponent(s, e), this.setDisplayName(e);
  }
  workOutInnerHeaderComponent(e, t) {
    const n = kF(e, t, t);
    n && (this.isLoadingInnerComponent = !0, n.newAgStackInstance().then((o) => {
      this.isLoadingInnerComponent = !1, o && (this.isAlive() ? (this.innerHeaderComponent = o, this.eText && this.eText.appendChild(o.getGui())) : this.destroyBean(o));
    }));
  }
  setDisplayName(e) {
    const { displayName: t } = e, n = this.currentDisplayName;
    this.currentDisplayName = t, !(!this.eText || n === t || this.innerHeaderComponent || this.isLoadingInnerComponent) && (this.eText.textContent = Ii(t));
  }
  addInIcon(e, t, n) {
    const o = Le(e, this.beans, n);
    o && t.appendChild(o);
  }
  workOutShowMenu() {
    var e;
    return this.params.enableMenu && !!((e = this.beans.menuSvc) != null && e.isHeaderMenuButtonEnabled());
  }
  shouldSuppressMenuHide() {
    var e;
    return !!((e = this.beans.menuSvc) != null && e.isHeaderMenuButtonAlwaysShowEnabled());
  }
  setMenu() {
    if (!this.eMenu)
      return;
    if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
      nn(this.eMenu), this.eMenu = void 0;
      return;
    }
    const { gos: e, eMenu: t, params: n } = this, o = Nt(e);
    this.addInIcon(o ? "menu" : "menuAlt", t, n.column), t.classList.toggle("ag-header-menu-icon", !o);
    const s = this.shouldSuppressMenuHide();
    this.currentSuppressMenuHide = s, this.addManagedElementListeners(t, { click: () => this.showColumnMenu(this.eMenu) }), this.toggleMenuAlwaysShow(s);
  }
  toggleMenuAlwaysShow(e) {
    var t;
    (t = this.eMenu) == null || t.classList.toggle("ag-header-menu-always-show", e);
  }
  showColumnMenu(e) {
    const { currentSuppressMenuHide: t, params: n } = this;
    t || this.toggleMenuAlwaysShow(!0), n.showColumnMenu(e, () => {
      t || this.toggleMenuAlwaysShow(!1);
    });
  }
  onMenuKeyboardShortcut(e) {
    var l;
    const { params: t, gos: n, beans: o, eMenu: s, eFilterButton: i } = this, r = t.column, a = Nt(n);
    if (e && !a) {
      if ((l = o.menuSvc) != null && l.isFilterMenuInHeaderEnabled(r))
        return t.showFilter(i ?? s ?? this.getGui()), !0;
    } else if (t.enableMenu)
      return this.showColumnMenu(s ?? i ?? this.getGui()), !0;
    return !1;
  }
  setupSort() {
    const { sortSvc: e } = this.beans;
    if (!e)
      return;
    const { enableSorting: t, column: n } = this.params;
    if (this.currentSort = t, !this.eSortIndicator) {
      this.eSortIndicator = this.createBean(e.createSortIndicator(!0));
      const { eSortIndicator: o, eSortOrder: s, eSortAsc: i, eSortDesc: r, eSortMixed: a, eSortNone: l } = this;
      o.attachCustomElements(s, i, r, a, l);
    }
    this.eSortIndicator.setupSort(n), this.currentSort && e.setupHeader(this, n, this.eLabel);
  }
  setupFilterIcon() {
    const { eFilter: e, params: t } = this;
    if (!e)
      return;
    const n = () => {
      const o = t.column.isFilterActive();
      He(e, o, { skipAriaHidden: !0 });
    };
    this.configureFilter(t.enableFilterIcon, e, n, "filterActive");
  }
  setupFilterButton() {
    const { eFilterButton: e, params: t } = this;
    if (!e)
      return;
    this.configureFilter(
      t.enableFilterButton,
      e,
      this.onFilterChangedButton.bind(this),
      "filter"
    ) ? this.addManagedElementListeners(e, {
      click: () => t.showFilter(e)
    }) : this.eFilterButton = void 0;
  }
  configureFilter(e, t, n, o) {
    if (!e)
      return nn(t), !1;
    const s = this.params.column;
    return this.addInIcon(o, t, s), this.addManagedListeners(s, { filterChanged: n }), n(), !0;
  }
  onFilterChangedButton() {
    const e = this.params.column.isFilterActive();
    this.eFilterButton.classList.toggle("ag-filter-active", e);
  }
  getAnchorElementForMenu(e) {
    const { eFilterButton: t, eMenu: n } = this;
    return e ? t ?? n ?? this.getGui() : n ?? t ?? this.getGui();
  }
  destroy() {
    super.destroy(), this.innerHeaderComponent && (this.destroyBean(this.innerHeaderComponent), this.innerHeaderComponent = void 0);
  }
}, nL = {
  tag: "div",
  cls: "ag-header-group-cell-label",
  role: "presentation",
  children: [
    { tag: "span", ref: "agLabel", cls: "ag-header-group-text", role: "presentation" },
    { tag: "span", ref: "agOpened", cls: "ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded" },
    { tag: "span", ref: "agClosed", cls: "ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed" }
  ]
}, oL = class extends Te {
  constructor() {
    super(nL), this.agOpened = X, this.agClosed = X, this.agLabel = X, this.isLoadingInnerComponent = !1;
  }
  init(e) {
    const { userCompFactory: t, touchSvc: n } = this.beans;
    this.params = e, this.checkWarnings(), this.workOutInnerHeaderGroupComponent(t, e), this.setupLabel(e), this.addGroupExpandIcon(e), this.setupExpandIcons(), n == null || n.setupForHeaderGroup(this);
  }
  checkWarnings() {
    this.params.template && Z(89);
  }
  workOutInnerHeaderGroupComponent(e, t) {
    const n = BF(e, t, t);
    n && (this.isLoadingInnerComponent = !0, n.newAgStackInstance().then((o) => {
      this.isLoadingInnerComponent = !1, o && (this.isAlive() ? (this.innerHeaderGroupComponent = o, this.agLabel.appendChild(o.getGui())) : this.destroyBean(o));
    }));
  }
  setupExpandIcons() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: n },
      beans: o
    } = this;
    this.addInIcon("columnGroupOpened", e), this.addInIcon("columnGroupClosed", t);
    const s = (l) => {
      if (Dn(l))
        return;
      const d = !n.isExpanded();
      o.colGroupSvc.setColumnGroupOpened(
        n.getProvidedColumnGroup(),
        d,
        "uiColumnExpanded"
      );
    };
    this.addTouchAndClickListeners(o, t, s), this.addTouchAndClickListeners(o, e, s);
    const i = (l) => {
      bt(l);
    };
    this.addManagedElementListeners(t, { dblclick: i }), this.addManagedElementListeners(e, { dblclick: i }), this.addManagedElementListeners(this.getGui(), { dblclick: s }), this.updateIconVisibility();
    const r = n.getProvidedColumnGroup(), a = this.updateIconVisibility.bind(this);
    this.addManagedListeners(r, {
      expandedChanged: a,
      expandableChanged: a
    });
  }
  addTouchAndClickListeners(e, t, n) {
    var o;
    (o = e.touchSvc) == null || o.setupForHeaderGroupElement(this, t, n), this.addManagedElementListeners(t, { click: n });
  }
  updateIconVisibility() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: n }
    } = this;
    if (n.isExpandable()) {
      const o = n.isExpanded();
      He(e, o), He(t, !o);
    } else
      He(e, !1), He(t, !1);
  }
  addInIcon(e, t) {
    const n = Le(e, this.beans, null);
    n && t.appendChild(n);
  }
  addGroupExpandIcon(e) {
    if (!e.columnGroup.isExpandable()) {
      const { agOpened: t, agClosed: n } = this;
      He(t, !1), He(n, !1);
      return;
    }
  }
  setupLabel(e) {
    var s;
    const { displayName: t, columnGroup: n } = e, o = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
    ue(t) && !o && (this.agLabel.textContent = Ii(t)), this.toggleCss("ag-sticky-label", !((s = n.getColGroupDef()) != null && s.suppressStickyLabel));
  }
  destroy() {
    super.destroy(), this.innerHeaderGroupComponent && (this.destroyBean(this.innerHeaderGroupComponent), this.innerHeaderGroupComponent = void 0);
  }
}, sL = {
  moduleName: "ColumnHeaderComp",
  version: Ee,
  userComponents: {
    agColumnHeader: tL
  },
  icons: {
    // button to launch legacy column menu
    menu: "menu",
    // button to launch new enterprise column menu
    menuAlt: "menu-alt"
  }
}, iL = {
  moduleName: "ColumnGroupHeaderComp",
  version: Ee,
  userComponents: {
    agColumnGroupHeader: oL
  },
  icons: {
    // header column group shown when expanded (click to contract)
    columnGroupOpened: "expanded",
    // header column group shown when contracted (click to expand)
    columnGroupClosed: "contracted"
  }
}, rL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "animationFrameSvc", this.p1 = { list: [], sorted: !1 }, this.p2 = { list: [], sorted: !1 }, this.f1 = { list: [], sorted: !1 }, this.destroyTasks = [], this.ticking = !1, this.scrollGoingDown = !0, this.lastScrollTop = 0, this.taskCount = 0;
  }
  setScrollTop(e) {
    this.scrollGoingDown = e >= this.lastScrollTop, e === 0 && (this.scrollGoingDown = !0), this.lastScrollTop = e;
  }
  postConstruct() {
    this.active = !this.gos.get("suppressAnimationFrame"), this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
  }
  // this method is for our AG Grid sanity only - if animation frames are turned off,
  // then no place in the code should be looking to add any work to be done in animation
  // frames. this stops bugs - where some code is asking for a frame to be executed
  // when it should not.
  verify() {
    this.active === !1 && Z(92);
  }
  createTask(e, t, n, o, s = !1) {
    this.verify();
    let i = n;
    o && this.batchFrameworkComps && (i = "f1");
    const r = { task: e, index: t, createOrder: ++this.taskCount, deferred: s };
    this.addTaskToList(this[i], r), this.schedule();
  }
  addTaskToList(e, t) {
    e.list.push(t), e.sorted = !1;
  }
  sortTaskList(e) {
    if (e.sorted)
      return;
    const t = this.scrollGoingDown ? 1 : -1;
    e.list.sort((n, o) => n.deferred !== o.deferred ? n.deferred ? -1 : 1 : n.index !== o.index ? t * (o.index - n.index) : o.createOrder - n.createOrder), e.sorted = !0;
  }
  addDestroyTask(e) {
    this.verify(), this.destroyTasks.push(e), this.schedule();
  }
  executeFrame(e) {
    const { p1: t, p2: n, f1: o, destroyTasks: s, beans: i } = this, { ctrlsSvc: r, frameworkOverrides: a } = i, l = t.list, d = n.list, c = o.list, u = Date.now();
    let h = 0;
    const g = e <= 0, p = r.getScrollFeature();
    for (; g || h < e; ) {
      if (!p.scrollGridIfNeeded()) {
        let m;
        if (l.length)
          this.sortTaskList(t), m = l.pop().task;
        else if (d.length)
          this.sortTaskList(n), m = d.pop().task;
        else if (c.length)
          a.wrapOutgoing(() => {
            for (; (g || h < e) && !p.scrollGridIfNeeded(); ) {
              if (c.length)
                this.sortTaskList(o), m = c.pop().task, m();
              else
                break;
              h = Date.now() - u;
            }
          }), m = () => {
          };
        else if (s.length)
          m = s.pop();
        else
          break;
        m();
      }
      h = Date.now() - u;
    }
    l.length || d.length || c.length || s.length ? this.requestFrame() : this.ticking = !1;
  }
  flushAllFrames() {
    this.active && this.executeFrame(-1);
  }
  schedule() {
    this.active && (this.ticking || (this.ticking = !0, this.requestFrame()));
  }
  requestFrame() {
    const e = this.executeFrame.bind(this, 60);
    kn(this.beans, e);
  }
  isQueueEmpty() {
    return !this.ticking;
  }
}, aL = {
  moduleName: "AnimationFrame",
  version: Ee,
  beans: [rL]
}, lL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "iconSvc";
  }
  createIconNoSpan(e, t) {
    return Le(e, this.beans, t == null ? void 0 : t.column);
  }
}, dL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "touchSvc";
  }
  mockBodyContextMenu(e, t) {
    this.mockContextMenu(e, e.eBodyViewport, t);
  }
  mockHeaderContextMenu(e, t) {
    this.mockContextMenu(e, e.eGui, t);
  }
  mockRowContextMenu(e) {
    if (!Ss())
      return;
    const t = (n, o, s) => {
      var a;
      const { rowCtrl: i, cellCtrl: r } = e.getControlsForEventTarget((s == null ? void 0 : s.target) ?? null);
      r != null && r.column && r.dispatchCellContextMenuEvent(s ?? null), (a = this.beans.contextMenuSvc) == null || a.handleContextMenuMouseEvent(void 0, s, i, r);
    };
    this.mockContextMenu(e, e.element, t);
  }
  handleCellDoubleClick(e, t) {
    return (() => {
      if (!Ss() || CC("dblclick"))
        return !1;
      const o = Date.now(), s = o - e.lastIPadMouseClickEvent < 200;
      return e.lastIPadMouseClickEvent = o, s;
    })() ? (e.onCellDoubleClicked(t), t.preventDefault(), !0) : !1;
  }
  setupForHeader(e) {
    const { gos: t, sortSvc: n, menuSvc: o } = this.beans;
    if (t.get("suppressTouch"))
      return;
    const { params: s, eMenu: i, eFilterButton: r } = e, a = new No(e.getGui(), !0), l = e.shouldSuppressMenuHide(), d = l && ue(i) && s.enableMenu, c = d ? new No(i, !0) : a;
    if (s.enableMenu || o != null && o.isHeaderContextMenuEnabled(s.column)) {
      const u = d ? "tap" : "longTap", h = (g) => s.showColumnMenuAfterMouseClick(g.touchStart);
      e.addManagedListeners(c, { [u]: h });
    }
    if (s.enableSorting) {
      const u = (h) => {
        const g = h.touchStart.target;
        l && (i != null && i.contains(g) || r != null && r.contains(g)) || n == null || n.progressSort(s.column, !1, "uiColumnSorted");
      };
      e.addManagedListeners(a, { tap: u });
    }
    if (s.enableFilterButton && r) {
      const u = new No(r, !0);
      e.addManagedListeners(u, {
        tap: () => s.showFilter(r)
      }), e.addDestroyFunc(() => u.destroy());
    }
    e.addDestroyFunc(() => a.destroy()), d && e.addDestroyFunc(() => c.destroy());
  }
  setupForHeaderGroup(e) {
    var n;
    const t = e.params;
    if ((n = this.beans.menuSvc) != null && n.isHeaderContextMenuEnabled(
      t.columnGroup.getProvidedColumnGroup()
    )) {
      const o = new No(t.eGridHeader, !0), s = (i) => t.showColumnMenuAfterMouseClick(i.touchStart);
      e.addManagedListeners(o, { longTap: s }), e.addDestroyFunc(() => o.destroy());
    }
  }
  setupForHeaderGroupElement(e, t, n) {
    const o = new No(t, !0);
    e.addManagedListeners(o, { tap: n }), e.addDestroyFunc(() => o.destroy());
  }
  mockContextMenu(e, t, n) {
    if (!Ss())
      return;
    const o = new No(t), s = (i) => {
      Pa(this.beans, i.touchEvent) && n(void 0, i.touchStart, i.touchEvent);
    };
    e.addManagedListeners(o, { longTap: s }), e.addDestroyFunc(() => o.destroy());
  }
}, cL = {
  moduleName: "Touch",
  version: Ee,
  beans: [dL]
}, uL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "cellNavigation";
  }
  wireBeans(e) {
    this.rowSpanSvc = e.rowSpanSvc;
  }
  // returns null if no cell to focus on, ie at the end of the grid
  getNextCellToFocus(e, t, n = !1) {
    return n ? this.getNextCellToFocusWithCtrlPressed(e, t) : this.getNextCellToFocusWithoutCtrlPressed(e, t);
  }
  getNextCellToFocusWithCtrlPressed(e, t) {
    const n = e === O.UP, o = e === O.DOWN, s = e === O.LEFT;
    let i, r;
    const { pageBounds: a, gos: l, visibleCols: d, pinnedRowModel: c } = this.beans, { rowPinned: u } = t;
    if (n || o)
      u && c ? n ? r = 0 : r = u === "top" ? c.getPinnedTopRowCount() - 1 : c.getPinnedBottomRowCount() - 1 : r = n ? a.getFirstRow() : a.getLastRow(), i = t.column;
    else {
      const h = l.get("enableRtl");
      r = t.rowIndex, i = (s !== h ? d.allCols : [...d.allCols].reverse()).find(
        (p) => this.isCellGoodToFocusOn({
          rowIndex: r,
          rowPinned: null,
          column: p
        })
      );
    }
    return i ? {
      rowIndex: r,
      rowPinned: u,
      column: i
    } : null;
  }
  getNextCellToFocusWithoutCtrlPressed(e, t) {
    let n = t, o = !1;
    for (; !o; ) {
      switch (e) {
        case O.UP:
          n = this.getCellAbove(n);
          break;
        case O.DOWN:
          n = this.getCellBelow(n);
          break;
        case O.RIGHT:
          n = this.gos.get("enableRtl") ? this.getCellToLeft(n) : this.getCellToRight(n);
          break;
        case O.LEFT:
          n = this.gos.get("enableRtl") ? this.getCellToRight(n) : this.getCellToLeft(n);
          break;
        default:
          n = null, Z(8, { key: e });
          break;
      }
      n ? o = this.isCellGoodToFocusOn(n) : o = !0;
    }
    return n;
  }
  isCellGoodToFocusOn(e) {
    const t = e.column;
    let n;
    const { pinnedRowModel: o, rowModel: s } = this.beans;
    switch (e.rowPinned) {
      case "top":
        n = o == null ? void 0 : o.getPinnedTopRow(e.rowIndex);
        break;
      case "bottom":
        n = o == null ? void 0 : o.getPinnedBottomRow(e.rowIndex);
        break;
      default:
        n = s.getRow(e.rowIndex);
        break;
    }
    return n ? !this.isSuppressNavigable(t, n) : !1;
  }
  getCellToLeft(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColBefore(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellToRight(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColAfter(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellBelow(e) {
    var o;
    if (!e)
      return null;
    const t = ((o = this.rowSpanSvc) == null ? void 0 : o.getCellEnd(e)) ?? e, n = Hm(this.beans, t, !0);
    return n ? {
      rowIndex: n.rowIndex,
      column: e.column,
      rowPinned: n.rowPinned
    } : null;
  }
  getCellAbove(e) {
    var o;
    if (!e)
      return null;
    const t = ((o = this.rowSpanSvc) == null ? void 0 : o.getCellStart(e)) ?? e, n = Ld(
      this.beans,
      {
        rowIndex: t.rowIndex,
        rowPinned: t.rowPinned
      },
      !0
    );
    return n ? {
      rowIndex: n.rowIndex,
      column: e.column,
      rowPinned: n.rowPinned
    } : null;
  }
  getNextTabbedCell(e, t) {
    return t ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
  }
  getNextTabbedCellForwards(e) {
    const { visibleCols: t, pagination: n } = this.beans, o = t.allCols;
    let s = e.rowIndex, i = e.rowPinned, r = t.getColAfter(e.column);
    if (!r) {
      r = o[0];
      const a = Hm(this.beans, e, !0);
      if (st(a) || !a.rowPinned && !((n == null ? void 0 : n.isRowInPage(a.rowIndex)) ?? !0))
        return null;
      s = a ? a.rowIndex : null, i = a ? a.rowPinned : null;
    }
    return { rowIndex: s, column: r, rowPinned: i };
  }
  getNextTabbedCellBackwards(e) {
    const { beans: t } = this, { visibleCols: n, pagination: o } = t, s = n.allCols;
    let i = e.rowIndex, r = e.rowPinned, a = n.getColBefore(e.column);
    if (!a) {
      a = Je(s);
      const l = Ld(t, { rowIndex: e.rowIndex, rowPinned: e.rowPinned }, !0);
      if (st(l) || !l.rowPinned && !((o == null ? void 0 : o.isRowInPage(l.rowIndex)) ?? !0))
        return null;
      i = l ? l.rowIndex : null, r = l ? l.rowPinned : null;
    }
    return { rowIndex: i, column: a, rowPinned: r };
  }
  isSuppressNavigable(e, t) {
    const { suppressNavigable: n } = e.colDef;
    if (typeof n == "boolean")
      return n;
    if (typeof n == "function") {
      const o = e.createColumnFunctionCallbackParams(t);
      return n(o);
    }
    return !1;
  }
};
function hL(e) {
  return e.focusSvc.getFocusedCell();
}
function gL(e) {
  return e.focusSvc.clearFocusedCell();
}
function pL(e, t, n, o) {
  e.focusSvc.setFocusedCell({ rowIndex: t, column: n, rowPinned: o, forceBrowserFocus: !0 });
}
function fL(e, t) {
  var n;
  return ((n = e.navigation) == null ? void 0 : n.tabToNextCell(!1, t)) ?? !1;
}
function mL(e, t) {
  var n;
  return ((n = e.navigation) == null ? void 0 : n.tabToNextCell(!0, t)) ?? !1;
}
function vL(e, t, n = !1) {
  var s;
  const o = (s = e.headerNavigation) == null ? void 0 : s.getHeaderPositionForColumn(t, n);
  o && e.focusSvc.focusHeaderPosition({ headerPosition: o });
}
var CL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "editModelSvc", this.edits = /* @__PURE__ */ new Map(), this.cellValidations = new Fy(), this.rowValidations = new My(), this.suspendEdits = !1;
  }
  suspend(e) {
    this.suspendEdits = e;
  }
  removeEdits({ rowNode: e, column: t }) {
    if (!this.hasEdits({ rowNode: e }) || !e)
      return;
    const n = this.getEditRow(e);
    t ? n.delete(t) : n.clear(), n.size === 0 && this.edits.delete(e);
  }
  getEditRow(e, t = {}) {
    if (this.suspendEdits || this.edits.size === 0)
      return;
    const n = e && this.edits.get(e);
    if (n)
      return n;
    if (t.checkSiblings) {
      const o = e.pinnedSibling;
      if (o)
        return this.getEditRow(o);
    }
  }
  getEditRowDataValue(e, { checkSiblings: t } = {}) {
    if (!e || this.edits.size === 0)
      return;
    const n = this.getEditRow(e), o = e.pinnedSibling, s = t && o && this.getEditRow(o);
    if (!n && !s)
      return;
    const i = Object.assign({}, e.data), r = (a, l) => a.forEach(({ pendingValue: d }, c) => {
      d !== jn && (l[c.getColId()] = d);
    });
    return n && r(n, i), s && r(s, i), i;
  }
  getEdit(e, t) {
    const n = this._getEdit(e);
    return t && n ? { ...n } : n;
  }
  _getEdit(e) {
    var t;
    if (!this.suspendEdits && this.edits.size !== 0)
      return e.rowNode && e.column && ((t = this.getEditRow(e.rowNode)) == null ? void 0 : t.get(e.column));
  }
  getEditMap(e = !0) {
    if (this.suspendEdits || this.edits.size === 0)
      return /* @__PURE__ */ new Map();
    if (!e)
      return this.edits;
    const t = /* @__PURE__ */ new Map();
    return this.edits.forEach((n, o) => {
      const s = /* @__PURE__ */ new Map();
      n.forEach(
        ({ editorState: i, ...r }, a) => (
          // Ensure we copy the cell data to avoid reference issues
          s.set(a, { ...r })
        )
      ), t.set(o, s);
    }), t;
  }
  setEditMap(e) {
    this.edits.clear(), e.forEach((t, n) => {
      const o = /* @__PURE__ */ new Map();
      t.forEach(
        (s, i) => (
          // Ensure we copy the cell data to avoid reference issues
          o.set(i, { ...s })
        )
      ), this.edits.set(n, o);
    });
  }
  setEdit(e, t) {
    (this.edits.size === 0 || !this.edits.has(e.rowNode)) && this.edits.set(e.rowNode, /* @__PURE__ */ new Map());
    const n = this._getEdit(e), o = Object.assign({
      editorState: {
        isCancelAfterEnd: void 0,
        isCancelBeforeStart: void 0
      },
      ...n,
      ...t
    });
    return this.getEditRow(e.rowNode).set(e.column, o), o;
  }
  clearEditValue(e) {
    var o;
    const { rowNode: t, column: n } = e;
    if (t)
      if (n) {
        const s = this._getEdit(e);
        s && (s.editorValue = void 0, s.pendingValue = s.sourceValue, s.state = "changed");
      } else
        (o = this.getEditRow(t)) == null || o.forEach((s) => {
          s.editorValue = void 0, s.pendingValue = s.sourceValue, s.state = "changed";
        });
  }
  getState(e) {
    var t;
    if (!this.suspendEdits)
      return (t = this.getEdit(e)) == null ? void 0 : t.state;
  }
  getEditPositions(e) {
    if (this.suspendEdits || (e ?? this.edits).size === 0)
      return [];
    const t = [];
    return (e ?? this.edits).forEach((n, o) => {
      for (const s of n.keys()) {
        const { editorState: i, ...r } = n.get(s);
        t.push({
          rowNode: o,
          column: s,
          ...r
        });
      }
    }), t;
  }
  hasRowEdits(e, t) {
    return this.suspendEdits || this.edits.size === 0 ? !1 : !!this.getEditRow(e, t);
  }
  hasEdits(e = {}, t = {}) {
    var i;
    if (this.suspendEdits || this.edits.size === 0)
      return !1;
    const { rowNode: n, column: o } = e, { withOpenEditor: s } = t;
    if (n) {
      const r = this.getEditRow(n, t);
      return r ? o ? s ? ((i = this.getEdit(e)) == null ? void 0 : i.state) === "editing" : r.has(o) ?? !1 : r.size !== 0 ? s ? Array.from(r.values()).some(({ state: a }) => a === "editing") : !0 : !1 : !1;
    }
    return s ? this.getEditPositions().some(({ state: r }) => r === "editing") : this.edits.size > 0;
  }
  start(e) {
    const t = this.getEditRow(e.rowNode) ?? /* @__PURE__ */ new Map(), { rowNode: n, column: o } = e;
    o && !t.has(o) && t.set(o, {
      editorValue: void 0,
      pendingValue: jn,
      sourceValue: this.beans.valueSvc.getValue(o, n, !1, "api"),
      state: "editing",
      editorState: {
        isCancelAfterEnd: void 0,
        isCancelBeforeStart: void 0
      }
    }), this.edits.set(n, t);
  }
  stop(e) {
    this.hasEdits(e) && (e ? this.removeEdits(e) : this.clear());
  }
  clear() {
    for (const e of this.edits.values())
      e.clear();
    this.edits.clear();
  }
  getCellValidationModel() {
    return this.cellValidations;
  }
  getRowValidationModel() {
    return this.rowValidations;
  }
  setCellValidationModel(e) {
    this.cellValidations = e;
  }
  setRowValidationModel(e) {
    this.rowValidations = e;
  }
  destroy() {
    super.destroy(), this.clear();
  }
}, Fy = class {
  constructor() {
    this.cellValidations = /* @__PURE__ */ new Map();
  }
  getCellValidation(e) {
    var o, s;
    const { rowNode: t, column: n } = e || {};
    return (s = (o = this.cellValidations) == null ? void 0 : o.get(t)) == null ? void 0 : s.get(n);
  }
  hasCellValidation(e) {
    return !e || !e.rowNode || !e.column ? this.cellValidations.size > 0 : !!this.getCellValidation(e);
  }
  setCellValidation(e, t) {
    const { rowNode: n, column: o } = e;
    this.cellValidations.has(n) || this.cellValidations.set(n, /* @__PURE__ */ new Map()), this.cellValidations.get(n).set(o, t);
  }
  clearCellValidation(e) {
    var o;
    const { rowNode: t, column: n } = e;
    (o = this.cellValidations.get(t)) == null || o.delete(n);
  }
  setCellValidationMap(e) {
    this.cellValidations = e;
  }
  getCellValidationMap() {
    return this.cellValidations;
  }
  clearCellValidationMap() {
    this.cellValidations.clear();
  }
}, My = class {
  constructor() {
    this.rowValidations = /* @__PURE__ */ new Map();
  }
  getRowValidation(e) {
    const { rowNode: t } = e || {};
    return this.rowValidations.get(t);
  }
  hasRowValidation(e) {
    return !e || !e.rowNode ? this.rowValidations.size > 0 : !!this.getRowValidation(e);
  }
  setRowValidation({ rowNode: e }, t) {
    this.rowValidations.set(e, t);
  }
  clearRowValidation({ rowNode: e }) {
    this.rowValidations.delete(e);
  }
  setRowValidationMap(e) {
    this.rowValidations = e;
  }
  getRowValidationMap() {
    return this.rowValidations;
  }
  clearRowValidationMap() {
    this.rowValidations.clear();
  }
};
function Tp(e, t = {}) {
  var d;
  const { rowIndex: n, rowId: o, rowCtrl: s, rowPinned: i } = t;
  if (s)
    return s;
  const { rowModel: r, rowRenderer: a } = e;
  let { rowNode: l } = t;
  return l || (o ? l = OD(e, o, i) : n != null && (l = r.getRow(n))), (d = a.getRowCtrls(l ? [l] : [])) == null ? void 0 : d[0];
}
function wt(e, t = {}) {
  var c;
  const { cellCtrl: n, colId: o, columnId: s, column: i } = t;
  if (n)
    return n;
  const r = e.colModel.getCol(o ?? s ?? Vh(i)), a = t.rowCtrl ?? Tp(e, t), l = (a == null ? void 0 : a.getCellCtrl(r)) ?? void 0;
  if (l)
    return l;
  const d = t.rowNode ?? (a == null ? void 0 : a.rowNode);
  if (d)
    return (c = e.rowRenderer.getCellCtrls([d], [r])) == null ? void 0 : c[0];
}
function Xm(e) {
  const { editSvc: t } = e;
  t != null && t.isBatchEditing() ? sr(e) : t == null || t.stopEditing(void 0, { source: "api" });
}
function wL(e, t, n) {
  const { gos: o, popupSvc: s } = t;
  if (!o.get("stopEditingWhenCellsLoseFocus"))
    return;
  const i = (r) => {
    const a = r.relatedTarget;
    if (xh(a) === null) {
      Xm(t);
      return;
    }
    let l = (
      // see if click came from inside the viewports
      n.some((d) => d.contains(a)) && // and also that it's not from a detail grid
      o.isElementInThisInstance(a)
    );
    l || (l = !!s && (s.getActivePopups().some((d) => d.contains(a)) || s.isElementWithinCustomPopup(a))), l || Xm(t);
  };
  n.forEach((r) => e.addManagedElementListeners(r, { focusout: i }));
}
function Vh(e) {
  if (e)
    return typeof e == "string" ? e : e.getColId();
}
var jn = Symbol("unedited");
function Iy(e, t = {}) {
  var s;
  const n = [], o = e.rowRenderer.getCellCtrls(t.rowNodes, t.columns);
  for (const i of o) {
    const r = (s = i.comp) == null ? void 0 : s.getCellEditor();
    r && n.push({
      ctrl: i,
      editor: Sr(r)
    });
  }
  return n;
}
var yL = (e, t = {}) => Iy(e, t).map((n) => n.editor);
function bL(e, t, n, o, s, i) {
  var u;
  t.length === 0 && (n != null && n.rowNode) && (n != null && n.column) && Ar(e, n, { key: o, event: s, cellStartedEdit: i });
  const { valueSvc: r, editSvc: a, editModelSvc: l } = e, { rowNode: d, column: c } = n ?? {};
  for (const h of t) {
    const { rowNode: g, column: p } = h, f = wt(e, h);
    if (!f) {
      if (g && p) {
        const C = r.getValue(p, g, void 0, "api"), A = ((n == null ? void 0 : n.rowNode) === g && (n == null ? void 0 : n.column) === p && o || void 0) ?? (a == null ? void 0 : a.getCellDataValue(h, !1)) ?? ((u = r.getValueForDisplay(p, g)) == null ? void 0 : u.value) ?? C ?? jn;
        l == null || l.setEdit(h, {
          pendingValue: A,
          sourceValue: C,
          state: "editing"
        });
      }
      continue;
    }
    const m = i && d === f.rowNode && f.column === c;
    Ar(
      e,
      { rowNode: d, column: f.column },
      {
        key: m ? o : null,
        event: m ? s : null,
        cellStartedEdit: m && i
      }
    );
  }
}
function zo({
  pendingValue: e,
  sourceValue: t
}) {
  return e === jn && (e = t), e !== t;
}
function Ar(e, t, n) {
  var C, w, b, A, S, F, E, M, I, P;
  const o = e.gos.get("enableGroupEdit"), { key: s, event: i, cellStartedEdit: r, silent: a } = n ?? {}, l = wt(e, t), d = (C = l == null ? void 0 : l.comp) == null ? void 0 : C.getCellEditor(), c = Dy(e, t, s, r && !a), u = (w = e.editModelSvc) == null ? void 0 : w.getEdit(t);
  let h = c.value;
  if (h === void 0 && (h = u == null ? void 0 : u.sourceValue), (b = e.editModelSvc) == null || b.setEdit(t, {
    editorValue: h,
    state: "editing"
  }), d) {
    (A = d.refresh) == null || A.call(d, c);
    return;
  }
  const g = t.column.getColDef(), p = iw(e.userCompFactory, g, c), f = (p == null ? void 0 : p.popupFromSelector) != null ? p.popupFromSelector : !!g.cellEditorPopup, m = (p == null ? void 0 : p.popupPositionFromSelector) != null ? p.popupPositionFromSelector : g.cellEditorPopupPosition;
  if (Ty(p.params, i), l) {
    l.editCompDetails = p, (S = l.comp) == null || S.setEditDetails(p, f, m, e.gos.get("reactiveCustomComponents")), (F = l == null ? void 0 : l.rowCtrl) == null || F.refreshRow({ suppressFlash: !0 });
    const k = (E = e.editModelSvc) == null ? void 0 : E.getEdit(t, !0);
    !a && !((M = k == null ? void 0 : k.editorState) != null && M.cellStartedEditing) && ((I = e.editSvc) == null || I.dispatchCellEvent(
      t,
      i,
      "cellEditingStarted",
      o ? { value: h } : {}
    ), (P = e.editModelSvc) == null || P.setEdit(t, { editorState: { cellStartedEditing: !0 } }));
  }
}
function Py(e, t, n) {
  var i, r;
  const o = { editorValueExists: !1 };
  if (kp(e)) {
    const a = (i = t.getValidationErrors) == null ? void 0 : i.call(t);
    if (((a == null ? void 0 : a.length) ?? 0) > 0)
      return o;
  }
  if (n != null && n.isCancelling)
    return o;
  if (n != null && n.isStopping) {
    const a = (r = t == null ? void 0 : t.isCancelAfterEnd) == null ? void 0 : r.call(t);
    if (a)
      return { ...o, isCancelAfterEnd: a };
  }
  return {
    editorValue: t.getValue(),
    editorValueExists: !0
  };
}
function Dy(e, t, n, o) {
  var C, w, b, A;
  const { valueSvc: s, gos: i, editSvc: r } = e, a = e.gos.get("enableGroupEdit"), l = wt(e, t), d = ((C = t.rowNode) == null ? void 0 : C.rowIndex) ?? void 0, c = r == null ? void 0 : r.isBatchEditing(), u = e.colModel.getCol(t.column.getId()), { rowNode: h, column: g } = t, p = (w = l.comp) == null ? void 0 : w.getCellEditor(), f = (r == null ? void 0 : r.getCellDataValue(t, !1)) ?? (p ? (b = Py(e, p)) == null ? void 0 : b.editorValue : void 0), m = f === jn ? (A = s.getValueForDisplay(u, h)) == null ? void 0 : A.value : f;
  return ke(i, {
    value: a ? f : m,
    eventKey: n ?? null,
    column: g,
    colDef: g.getColDef(),
    rowIndex: d,
    node: h,
    data: h.data,
    cellStartedEdit: o ?? !1,
    onKeyDown: l == null ? void 0 : l.onKeyDown.bind(l),
    stopEditing: (S) => {
      r.stopEditing(t, { source: c ? "ui" : "api", suppressNavigateAfterEdit: S }), Od(e, t);
    },
    eGridCell: l == null ? void 0 : l.eGui,
    parseValue: (S) => s.parseValue(u, h, S, l == null ? void 0 : l.value),
    formatValue: l == null ? void 0 : l.formatValue.bind(l),
    validate: () => {
      r == null || r.validateEdit();
    }
  });
}
function _h(e, t) {
  const { editModelSvc: n } = e;
  n == null || n.getEditMap().forEach((o, s) => {
    o.forEach((i, r) => {
      !t && (i.state === "editing" || i.pendingValue === jn) || !zo(i) && (i.state !== "editing" || t) && (n == null || n.removeEdits({ rowNode: s, column: r }));
    });
  });
}
function SL(e, t) {
  var d;
  const n = (d = t.comp) == null ? void 0 : d.getCellEditor();
  if (!(n != null && n.refresh))
    return;
  const { eventKey: o, cellStartedEdit: s } = t.editCompDetails.params, { column: i } = t, r = Dy(e, t, o, s), a = i.getColDef(), l = iw(e.userCompFactory, a, r);
  n.refresh(Ty(l.params, o));
}
function Ty(e, t) {
  var n;
  return t instanceof KeyboardEvent && e.column.getColDef().cellEditor === "agNumberCellEditor" ? e.suppressPreventDefault = ["-", "+", ".", "e"].includes((t == null ? void 0 : t.key) ?? "") || e.suppressPreventDefault : (n = t == null ? void 0 : t.preventDefault) == null || n.call(t), e;
}
function ni(e, t) {
  var n;
  (n = e.editModelSvc) == null || n.getEditPositions().forEach((o) => {
    var d, c;
    const s = wt(e, o);
    if (!s)
      return;
    const i = (d = s.comp) == null ? void 0 : d.getCellEditor();
    if (!i)
      return;
    const { editorValue: r, editorValueExists: a, isCancelAfterEnd: l } = Py(e, i, t);
    l && ((c = e.editModelSvc) == null || c.setEdit(o, { editorState: { isCancelAfterEnd: l } })), nd(e, o, r, void 0, !a, t);
  });
}
function nd(e, t, n, o, s, i) {
  const { editModelSvc: r, valueSvc: a } = e;
  if (!r)
    return;
  const { rowNode: l, column: d } = t;
  if (!(l && d))
    return;
  let c = r.getEdit(t, !0);
  c != null && c.sourceValue || (c = r.setEdit(t, {
    sourceValue: a.getValue(d, l, void 0, "api"),
    pendingValue: c ? c.editorValue : jn
  })), r.setEdit(t, {
    editorValue: s ? c.sourceValue : n
  }), i != null && i.persist && xL(e, t);
}
function xL(e, t) {
  const { editModelSvc: n } = e, o = n == null ? void 0 : n.getEdit(t, !0);
  n == null || n.setEdit(t, {
    pendingValue: o == null ? void 0 : o.editorValue
  });
}
function sr(e, t, n) {
  var o;
  t || (t = (o = e.editModelSvc) == null ? void 0 : o.getEditPositions()), t.forEach((s) => Od(e, s, n));
}
function Od(e, t, n) {
  var d, c;
  const o = e.gos.get("enableGroupEdit"), { editModelSvc: s } = e, i = wt(e, t), r = s == null ? void 0 : s.getEdit(t, !0);
  if (!i) {
    r && (s == null || s.setEdit(t, { state: "changed" }));
    return;
  }
  const { comp: a } = i;
  if (a && !a.getCellEditor()) {
    if (i == null || i.refreshCell(), r) {
      s == null || s.setEdit(t, { state: "changed" });
      const u = o ? e0(n, r) : {
        valueChanged: !1,
        newValue: void 0,
        oldValue: r.sourceValue
      };
      t0(e, t, u, n);
    }
    return;
  }
  if (kp(e)) {
    const u = (c = (d = a == null ? void 0 : a.getCellEditor()) == null ? void 0 : d.getValidationErrors) == null ? void 0 : c.call(d), h = s == null ? void 0 : s.getCellValidationModel();
    u != null && u.length ? h == null || h.setCellValidation(t, { errorMessages: u }) : h == null || h.clearCellValidation(t);
  }
  s == null || s.setEdit(t, { state: "changed" }), a == null || a.setEditDetails(), a == null || a.refreshEditStyles(!1, !1), i == null || i.refreshCell({ force: !0, suppressFlash: !0 });
  const l = s == null ? void 0 : s.getEdit(t);
  if (l && l.state === "changed") {
    const u = o ? e0(n, l) : {
      valueChanged: zo(l) && !(n != null && n.cancel),
      newValue: n != null && n.cancel || l.editorState.isCancelAfterEnd ? void 0 : (l == null ? void 0 : l.editorValue) ?? (r == null ? void 0 : r.pendingValue),
      oldValue: l == null ? void 0 : l.sourceValue
    };
    t0(e, t, u, n);
  }
}
function e0(e, t) {
  return e != null && e.cancel ? {
    valueChanged: !1,
    oldValue: t.sourceValue,
    newValue: void 0,
    value: t.sourceValue
  } : {
    valueChanged: !1,
    oldValue: t.sourceValue,
    newValue: t.pendingValue,
    value: t.sourceValue
  };
}
function t0(e, t, n, { silent: o, event: s } = {}) {
  const { editSvc: i, editModelSvc: r } = e, a = r == null ? void 0 : r.getEdit(t), { editorState: l } = a || {}, { isCancelBeforeStart: d } = l || {};
  !o && !d && (i == null || i.dispatchCellEvent(t, s, "cellEditingStopped", n), r == null || r.setEdit(t, { editorState: { cellStoppedEditing: !0 } }));
}
function kp(e) {
  var r;
  const { gos: t, colModel: n } = e, o = !!t.get("getFullRowEditValidationErrors"), s = (r = n.getColumnDefs()) == null ? void 0 : r.filter((a) => a.editable).some(({ cellEditorParams: a }) => {
    const { minLength: l, maxLength: d, getValidationErrors: c, min: u, max: h } = a || {};
    return l !== void 0 || d !== void 0 || c !== void 0 || u !== void 0 || h !== void 0;
  }), i = e.gridApi.getCellEditorInstances().some((a) => a.getValidationElement || a.getValidationErrors);
  return s || o || i;
}
function bi(e, t) {
  var h, g, p, f, m, C, w, b;
  if (!(t || kp(e)))
    return;
  const n = Iy(e), o = new Fy(), { ariaAnnounce: s, localeSvc: i, editModelSvc: r, gos: a } = e, l = a.get("editType") === "fullRow", c = yC(i)("ariaValidationErrorPrefix", "Cell Editor Validation");
  for (const A of n) {
    const { ctrl: S, editor: F } = A, { rowNode: E, column: M } = S, I = ((h = F.getValidationErrors) == null ? void 0 : h.call(F)) ?? [], P = ((g = F.getValidationElement) == null ? void 0 : g.call(F, !1)) || !((p = F.isPopup) != null && p.call(F)) && S.eGui;
    if (P) {
      const k = I != null && I.length > 0, B = k ? I.join(". ") : "";
      e3(P, k), k && s.announceValue(`${c} ${I}`, "editorValidation"), P instanceof HTMLInputElement ? P.setCustomValidity(B) : P.classList.toggle("invalid", k);
    }
    (I == null ? void 0 : I.length) > 0 && o.setCellValidation(
      {
        rowNode: E,
        column: M
      },
      {
        errorMessages: I
      }
    );
  }
  ni(e, { persist: !1 }), r == null || r.setCellValidationModel(o);
  const u = /* @__PURE__ */ new Set();
  for (const { ctrl: A } of n)
    u.add(A.rowCtrl);
  if (l) {
    const A = RL(e);
    r == null || r.setRowValidationModel(A);
  }
  for (const A of u.values()) {
    (f = A.rowEditStyleFeature) == null || f.applyRowStyles();
    for (const S of A.getAllCellCtrls())
      (m = S.tooltipFeature) == null || m.refreshTooltip(!0), (C = S.editorTooltipFeature) == null || C.refreshTooltip(!0), (b = (w = S.editStyleFeature) == null ? void 0 : w.applyCellStyles) == null || b.call(w);
  }
}
var RL = (e) => {
  var s;
  const t = new My(), n = e.gos.get("getFullRowEditValidationErrors"), o = (s = e.editModelSvc) == null ? void 0 : s.getEditMap();
  if (!o)
    return t;
  for (const i of o.keys()) {
    const r = o.get(i);
    if (!r)
      continue;
    const a = [], { rowIndex: l, rowPinned: d } = i;
    for (const u of r.keys()) {
      const h = r.get(u);
      if (!h)
        continue;
      const { editorValue: g, pendingValue: p, sourceValue: f } = h, m = g ?? (p === jn ? void 0 : p) ?? f;
      a.push({
        column: u,
        colId: u.getColId(),
        rowIndex: l,
        rowPinned: d,
        oldValue: f,
        newValue: m
      });
    }
    const c = (n == null ? void 0 : n({ editorsState: a })) ?? [];
    c.length > 0 && t.setRowValidation(
      {
        rowNode: i
      },
      { errorMessages: c }
    );
  }
  return t;
};
function EL(e) {
  var o;
  bi(e, !0);
  const t = (o = e.editModelSvc) == null ? void 0 : o.getCellValidationModel().getCellValidationMap();
  if (!t)
    return null;
  const n = [];
  return t.forEach((s, i) => {
    s.forEach(({ errorMessages: r }, a) => {
      n.push({
        column: a,
        rowIndex: i.rowIndex,
        rowPinned: i.rowPinned,
        messages: r ?? null
      });
    });
  }), n;
}
function AL(e, t, n, { rowNode: o, column: s }, i) {
  return ke(e.gos, {
    type: n,
    node: o,
    data: o.data,
    value: i,
    column: s,
    colDef: s.getColDef(),
    rowPinned: o.rowPinned,
    event: t,
    rowIndex: o.rowIndex
  });
}
function FL(e, t = !1) {
  return e === O.DELETE ? !0 : !t && e === O.BACKSPACE ? aw() : !1;
}
var ML = class extends U {
  constructor(e, t, n, o) {
    super(), this.cellCtrl = e, this.rowNode = n, this.rowCtrl = o, this.beans = t;
  }
  init() {
    this.eGui = this.cellCtrl.eGui;
  }
  onKeyDown(e) {
    const t = e.key;
    switch (t) {
      case O.ENTER:
        this.onEnterKeyDown(e);
        break;
      case O.F2:
        this.onF2KeyDown(e);
        break;
      case O.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case O.TAB:
        this.onTabKeyDown(e);
        break;
      case O.BACKSPACE:
      case O.DELETE:
        this.onBackspaceOrDeleteKeyDown(t, e);
        break;
      case O.DOWN:
      case O.UP:
      case O.RIGHT:
      case O.LEFT:
        this.onNavigationKeyDown(e, t);
        break;
    }
  }
  onNavigationKeyDown(e, t) {
    var s, i;
    const { cellCtrl: n, beans: o } = this;
    if (!((s = o.editSvc) != null && s.isEditing(n, { withOpenEditor: !0 }))) {
      if (e.shiftKey && n.isRangeSelectionEnabled())
        this.onShiftRangeSelect(e);
      else {
        const r = n.getFocusedCellPosition();
        (i = o.navigation) == null || i.navigateToNextCell(e, t, r, !0);
      }
      e.preventDefault();
    }
  }
  onShiftRangeSelect(e) {
    const { rangeSvc: t, navigation: n } = this.beans;
    if (!t)
      return;
    const o = t.extendLatestRangeInDirection(e);
    o && (e.key === O.LEFT || e.key === O.RIGHT ? n == null || n.ensureColumnVisible(o.column) : n == null || n.ensureRowVisible(o.rowIndex));
  }
  onTabKeyDown(e) {
    var t;
    (t = this.beans.navigation) == null || t.onTabKeyDown(this.cellCtrl, e);
  }
  onBackspaceOrDeleteKeyDown(e, t) {
    var d;
    const { cellCtrl: n, beans: o, rowNode: s } = this, { gos: i, rangeSvc: r, eventSvc: a, editSvc: l } = o;
    if (a.dispatchEvent({ type: "keyShortcutChangedCellStart" }), FL(e, i.get("enableCellEditingOnBackspace")) && !(l != null && l.isEditing(n, { withOpenEditor: !0 }))) {
      if (r && Xo(i))
        r.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" });
      else if (n.isCellEditable()) {
        const { column: c } = n, u = this.beans.valueSvc.getDeleteValue(c, s);
        s.setDataValue(c, u, "cellClear");
      }
    } else l != null && l.isEditing(n, { withOpenEditor: !0 }) || (d = o.editSvc) == null || d.startEditing(n, { startedEdit: !0, event: t });
    a.dispatchEvent({ type: "keyShortcutChangedCellEnd" });
  }
  onEnterKeyDown(e) {
    var d;
    const { cellCtrl: t, beans: n } = this, { editSvc: o, navigation: s } = n, i = o == null ? void 0 : o.isEditing(t, { withOpenEditor: !0 }), r = t.rowNode, a = o == null ? void 0 : o.isRowEditing(r, { withOpenEditor: !0 }), l = (c) => {
      (o == null ? void 0 : o.startEditing(c, {
        startedEdit: !0,
        event: e,
        source: "edit"
      })) && e.preventDefault();
    };
    if (i || a) {
      if (this.isCtrlEnter(e)) {
        o == null || o.applyBulkEdit(t, ((d = n == null ? void 0 : n.rangeSvc) == null ? void 0 : d.getCellRanges()) || []);
        return;
      }
      if (bi(n), (o == null ? void 0 : o.checkNavWithValidation(void 0, e)) === "block-stop")
        return;
      o != null && o.isEditing(t, { withOpenEditor: !0 }) ? o == null || o.stopEditing(t, {
        event: e,
        source: "edit"
      }) : a && !t.isCellEditable() ? o == null || o.stopEditing({ rowNode: r }, { event: e, source: "edit" }) : l(t);
    } else if (n.gos.get("enterNavigatesVertically")) {
      const c = e.shiftKey ? O.UP : O.DOWN;
      s == null || s.navigateToNextCell(null, c, t.cellPosition, !1);
    } else {
      if (o != null && o.hasValidationErrors())
        return;
      o != null && o.hasValidationErrors(t) && o.revertSingleCellEdit(t, !0), l(t);
    }
  }
  isCtrlEnter(e) {
    return (e.ctrlKey || e.metaKey) && e.key === O.ENTER;
  }
  onF2KeyDown(e) {
    const {
      cellCtrl: t,
      beans: { editSvc: n }
    } = this;
    n != null && n.isEditing() && (bi(this.beans), (n == null ? void 0 : n.checkNavWithValidation(void 0, e)) === "block-stop") || n == null || n.startEditing(t, { startedEdit: !0, event: e });
  }
  onEscapeKeyDown(e) {
    const {
      cellCtrl: t,
      beans: { editSvc: n }
    } = this;
    (n == null ? void 0 : n.checkNavWithValidation(t, e)) === "block-stop" && n.revertSingleCellEdit(t), n == null || n.stopEditing(t, {
      event: e,
      cancel: !0
    });
  }
  processCharacter(e) {
    var r;
    const n = e.target !== this.eGui, {
      beans: { editSvc: o },
      cellCtrl: s
    } = this;
    if (n || o != null && o.isEditing(s, { withOpenEditor: !0 }))
      return;
    if (e.key === O.SPACE)
      this.onSpaceKeyDown(e);
    else if (o != null && o.isCellEditable(s, "ui")) {
      if (o != null && o.hasValidationErrors() && !(o != null && o.hasValidationErrors(s)))
        return;
      o == null || o.startEditing(s, { startedEdit: !0, event: e, source: "api" });
      const a = s.editCompDetails;
      !((r = a == null ? void 0 : a.params) != null && r.suppressPreventDefault) && e.preventDefault();
    }
  }
  onSpaceKeyDown(e) {
    var s;
    const { gos: t, editSvc: n } = this.beans, { rowNode: o } = this.cellCtrl;
    !(n != null && n.isEditing(this.cellCtrl, { withOpenEditor: !0 })) && In(t) && ((s = this.beans.selectionSvc) == null || s.handleSelectionEvent(e, o, "spaceKey")), e.preventDefault();
  }
}, IL = class extends U {
  constructor(e, t, n) {
    super(), this.cellCtrl = e, this.column = n, this.beans = t;
  }
  onMouseEvent(e, t) {
    if (!Dn(t))
      switch (e) {
        case "click":
          this.onCellClicked(t);
          break;
        case "mousedown":
        case "touchstart":
          this.onMouseDown(t);
          break;
        case "dblclick":
          this.onCellDoubleClicked(t);
          break;
        case "mouseout":
          this.onMouseOut(t);
          break;
        case "mouseover":
          this.onMouseOver(t);
          break;
      }
  }
  onCellClicked(e) {
    var f;
    if ((f = this.beans.touchSvc) != null && f.handleCellDoubleClick(this, e))
      return;
    const { eventSvc: t, rangeSvc: n, editSvc: o, editModelSvc: s, frameworkOverrides: i, gos: r } = this.beans, a = e.ctrlKey || e.metaKey, { cellCtrl: l } = this, { column: d, cellPosition: c, rowNode: u } = l, h = Ql(r, d, u, e);
    n && a && !h && n.getCellRangeCount(c) > 1 && n.intersectLastRange(!0);
    const g = l.createEvent(e, "cellClicked");
    g.isEventHandlingSuppressed = h, t.dispatchEvent(g);
    const p = d.getColDef();
    if (p.onCellClicked && window.setTimeout(() => {
      i.wrapOutgoing(() => {
        p.onCellClicked(g);
      });
    }, 0), !h && (s == null ? void 0 : s.getState(l)) !== "editing") {
      const m = o == null ? void 0 : o.isEditing(), C = (s == null ? void 0 : s.getCellValidationModel().getCellValidationMap().size) ?? 0, w = (s == null ? void 0 : s.getRowValidationModel().getRowValidationMap().size) ?? 0;
      if (m && (C > 0 || w > 0))
        return;
      o != null && o.shouldStartEditing(l, e) ? o == null || o.startEditing(l, { event: e }) : o != null && o.shouldStopEditing(l, e) && (this.beans.gos.get("editType") === "fullRow" ? o == null || o.stopEditing(l, {
        event: e,
        source: "edit"
      }) : o == null || o.stopEditing(void 0, {
        event: e,
        source: "edit"
      }));
    }
  }
  onCellDoubleClicked(e) {
    const { column: t, beans: n, cellCtrl: o } = this, { eventSvc: s, frameworkOverrides: i, editSvc: r, editModelSvc: a, gos: l } = n, d = Ql(l, o.column, o.rowNode, e), c = t.getColDef(), u = o.createEvent(
      e,
      "cellDoubleClicked"
    );
    if (u.isEventHandlingSuppressed = d, s.dispatchEvent(u), typeof c.onCellDoubleClicked == "function" && window.setTimeout(() => {
      i.wrapOutgoing(() => {
        c.onCellDoubleClicked(u);
      });
    }, 0), !d && r != null && r.shouldStartEditing(o, e) && (a == null ? void 0 : a.getState(o)) !== "editing") {
      const h = r == null ? void 0 : r.isEditing(), g = (a == null ? void 0 : a.getCellValidationModel().getCellValidationMap().size) ?? 0, p = (a == null ? void 0 : a.getRowValidationModel().getRowValidationMap().size) ?? 0;
      if (h && (g > 0 || p > 0))
        return;
      r == null || r.startEditing(o, { event: e });
    }
  }
  onMouseDown(e) {
    const { ctrlKey: t, metaKey: n, shiftKey: o } = e, s = e.target, { cellCtrl: i, beans: r } = this, { eventSvc: a, rangeSvc: l, rowNumbersSvc: d, focusSvc: c, gos: u, editSvc: h } = r, { column: g, rowNode: p, cellPosition: f } = i, m = Ql(u, g, p, e), C = () => {
      const S = i.createEvent(e, "cellMouseDown");
      S.isEventHandlingSuppressed = m, a.dispatchEvent(S);
    };
    if (m) {
      C();
      return;
    }
    if (this.isRightClickInExistingRange(e))
      return;
    const w = l && !l.isEmpty(), b = this.containsWidget(s), A = bs(g);
    if (d && A && !d.handleMouseDownOnCell(f, e)) {
      l && e.preventDefault(), e.stopImmediatePropagation();
      return;
    }
    if (!o || !w) {
      const S = h == null ? void 0 : h.isEditing(i), E = u.get("enableCellTextSelection") && e.defaultPrevented, M = (os() || E) && !S && !Ug(s) && !b;
      i.focusCell(M, e);
    }
    if (o && w && !c.isCellFocused(f)) {
      e.preventDefault();
      const S = c.getFocusedCell();
      if (S) {
        const { column: F, rowIndex: E, rowPinned: M } = S;
        h != null && h.isEditing(S) && (h == null || h.stopEditing(S)), c.setFocusedCell({
          column: F,
          rowIndex: E,
          rowPinned: M,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0,
          sourceEvent: e
        });
      }
    }
    if (!b) {
      if (l) {
        A && e.preventDefault();
        const S = cm(r, e) && A;
        if (o)
          l.extendLatestRangeToCell(f);
        else if (!S) {
          const F = t || n;
          l.setRangeToCell(f, F);
        }
      }
      C();
    }
  }
  isRightClickInExistingRange(e) {
    const { rangeSvc: t } = this.beans;
    if (t) {
      const n = t.isCellInAnyRange(this.cellCtrl.cellPosition), o = cm(this.beans, e);
      if (n && o)
        return !0;
    }
    return !1;
  }
  containsWidget(e) {
    return ri(e, "ag-selection-checkbox", 3) || ri(e, "ag-drag-handle", 3);
  }
  onMouseOut(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: n } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOut")), n == null || n.clearMouseOver();
  }
  onMouseOver(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: n } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOver")), n == null || n.setMouseOver([this.column]);
  }
  mouseStayingInsideCell(e) {
    if (!e.target || !e.relatedTarget)
      return !1;
    const t = this.cellCtrl.eGui, n = t.contains(e.target), o = t.contains(e.relatedTarget);
    return n && o;
  }
}, PL = class extends U {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.column = e.column, this.rowNode = e.rowNode;
  }
  setupRowSpan() {
    this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListeners(this.beans.eventSvc, { newColumnsLoaded: () => this.onNewColumnsLoaded() });
  }
  init() {
    this.eSetLeft = this.cellCtrl.getRootElement(), this.eContent = this.cellCtrl.eGui;
    const e = this.cellCtrl.getCellSpan();
    if (e || (this.setupColSpan(), this.setupRowSpan()), this.onLeftChanged(), this.onWidthChanged(), e || this._legacyApplyRowSpan(), e) {
      const t = this.refreshSpanHeight.bind(this, e);
      t(), this.addManagedListeners(this.beans.eventSvc, {
        paginationChanged: t,
        recalculateRowBounds: t,
        pinnedHeightChanged: t
      });
    }
  }
  refreshSpanHeight(e) {
    const t = e.getCellHeight();
    t != null && (this.eContent.style.height = `${t}px`);
  }
  onNewColumnsLoaded() {
    const e = this.column.getRowSpan(this.rowNode);
    this.rowSpan !== e && (this.rowSpan = e, this._legacyApplyRowSpan(!0));
  }
  onDisplayColumnsChanged() {
    const e = this.getColSpanningList();
    Yn(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
  }
  setupColSpan() {
    this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListeners(this.beans.eventSvc, {
      // because we are col spanning, a reorder of the cols can change what cols we are spanning over
      displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
      // because we are spanning over multiple cols, we check for width any time any cols width changes.
      // this is expensive - really we should be explicitly checking only the cols we are spanning over
      // instead of every col, however it would be tricky code to track the cols we are spanning over, so
      // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
      displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
    }));
  }
  onWidthChanged() {
    if (!this.eContent)
      return;
    const e = this.getCellWidth();
    this.eContent.style.width = `${e}px`;
  }
  getCellWidth() {
    return this.colsSpanning ? this.colsSpanning.reduce((e, t) => e + t.getActualWidth(), 0) : this.column.getActualWidth();
  }
  getColSpanningList() {
    const { column: e, rowNode: t } = this, n = e.getColSpan(t), o = [];
    if (n === 1)
      o.push(e);
    else {
      let s = e;
      const i = e.getPinned();
      for (let r = 0; s && r < n && (o.push(s), s = this.beans.visibleCols.getColAfter(s), !(!s || st(s) || i !== s.getPinned())); r++)
        ;
    }
    return o;
  }
  onLeftChanged() {
    if (!this.eSetLeft)
      return;
    const e = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.eSetLeft.style.left = e + "px";
  }
  getCellLeft() {
    let e;
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? e = Je(this.colsSpanning) : e = this.column, e.getLeft();
  }
  modifyLeftForPrintLayout(e) {
    if (!this.cellCtrl.printLayout || this.column.getPinned() === "left")
      return e;
    const { visibleCols: t } = this.beans, n = t.getColsLeftWidth();
    if (this.column.getPinned() === "right") {
      const o = t.bodyWidth;
      return n + o + (e || 0);
    }
    return n + (e || 0);
  }
  _legacyApplyRowSpan(e) {
    if (this.rowSpan === 1 && !e)
      return;
    const n = Kn(this.beans) * this.rowSpan;
    this.eContent.style.height = `${n}px`, this.eContent.style.zIndex = "1";
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    super.destroy();
  }
}, DL = "ag-cell", TL = "ag-cell-auto-height", kL = "ag-cell-normal-height", LL = "ag-cell-focus", BL = "ag-cell-first-right-pinned", OL = "ag-cell-last-left-pinned", GL = "ag-cell-not-inline-editing", HL = "ag-cell-wrap-text", VL = 0, ir = class extends U {
  constructor(e, t, n, o) {
    super(), this.column = e, this.rowNode = t, this.rowCtrl = o, this.rangeFeature = void 0, this.rowResizeFeature = void 0, this.positionFeature = void 0, this.customStyleFeature = void 0, this.editStyleFeature = void 0, this.mouseListener = void 0, this.keyboardListener = void 0, this.suppressRefreshCell = !1, this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.focusEventWhileNotReady = null, this.hasBeenFocused = !1, this.hasEdit = !1, this.tooltipFeature = void 0, this.editorTooltipFeature = void 0, this.beans = n, this.gos = n.gos, this.editSvc = n.editSvc, this.hasEdit = !!n.editSvc;
    const { colId: s } = e;
    this.instanceId = s + "-" + VL++, this.createCellPosition(), this.updateAndFormatValue(!1);
  }
  addFeatures() {
    var o, s;
    const { beans: e } = this;
    this.positionFeature = new PL(this, e), this.customStyleFeature = (o = e.cellStyles) == null ? void 0 : o.createCellCustomStyleFeature(this, e), this.editStyleFeature = (s = e.editSvc) == null ? void 0 : s.createCellStyleFeature(this, e), this.mouseListener = new IL(this, e, this.column), this.keyboardListener = new ML(this, e, this.rowNode, this.rowCtrl), this.enableTooltipFeature();
    const { rangeSvc: t } = e;
    t && Xo(e.gos) && (this.rangeFeature = t.createCellRangeFeature(e, this)), bs(this.column) && (this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(e, this));
  }
  isCellSpanning() {
    return !1;
  }
  getCellSpan() {
  }
  removeFeatures() {
    const e = this.beans.context;
    this.positionFeature = e.destroyBean(this.positionFeature), this.editorTooltipFeature = e.destroyBean(this.editorTooltipFeature), this.customStyleFeature = e.destroyBean(this.customStyleFeature), this.editStyleFeature = e.destroyBean(this.editStyleFeature), this.mouseListener = e.destroyBean(this.mouseListener), this.keyboardListener = e.destroyBean(this.keyboardListener), this.rangeFeature = e.destroyBean(this.rangeFeature), this.rowResizeFeature = e.destroyBean(this.rowResizeFeature), this.disableTooltipFeature();
  }
  enableTooltipFeature(e, t) {
    var n;
    this.tooltipFeature = (n = this.beans.tooltipSvc) == null ? void 0 : n.enableCellTooltipFeature(this, e, t);
  }
  disableTooltipFeature() {
    this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
  }
  enableEditorTooltipFeature(e) {
    var t;
    this.editorTooltipFeature && this.disableEditorTooltipFeature(), this.editorTooltipFeature = (t = this.beans.tooltipSvc) == null ? void 0 : t.setupCellEditorTooltip(this, e), bi(this.beans);
  }
  disableEditorTooltipFeature() {
    this.editorTooltipFeature = this.beans.context.destroyBean(this.editorTooltipFeature);
  }
  setComp(e, t, n, o, s, i, r) {
    var a, l, d, c, u, h, g, p, f;
    this.comp = e, this.eGui = t, this.printLayout = s, r ?? (r = this), this.addDomData(r), this.addFeatures(), r.addDestroyFunc(() => this.removeFeatures()), this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.setupFocus(), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(o, r), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), (a = this.positionFeature) == null || a.init(), (l = this.customStyleFeature) == null || l.setComp(e), (d = this.editStyleFeature) == null || d.setComp(e), (c = this.tooltipFeature) == null || c.refreshTooltip(), (u = this.keyboardListener) == null || u.init(), (h = this.rangeFeature) == null || h.setComp(e), (g = this.rowResizeFeature) == null || g.refreshRowResizer(), i && this.isCellEditable() || this.hasEdit && ((p = this.editSvc) != null && p.isEditing(this, { withOpenEditor: !0 })) ? (f = this.editSvc) == null || f.startEditing(this, {
      startedEdit: !1,
      source: "api",
      silent: !0,
      continueEditing: !0
    }) : this.showValue(!1, !0), this.onCompAttachedFuncs.length && (this.onCompAttachedFuncs.forEach((m) => m()), this.onCompAttachedFuncs = []);
  }
  setupAutoHeight(e, t) {
    var n;
    this.isAutoHeight = ((n = this.beans.rowAutoHeight) == null ? void 0 : n.setupCellAutoHeight(this, e, t)) ?? !1;
  }
  getCellAriaRole() {
    return this.column.getColDef().cellAriaRole ?? "gridcell";
  }
  isCellRenderer() {
    const e = this.column.getColDef();
    return e.cellRenderer != null || e.cellRendererSelector != null;
  }
  getValueToDisplay() {
    return this.valueFormatted ?? this.value;
  }
  getDeferLoadingCellRenderer() {
    var l, d;
    const { beans: e, column: t } = this, { userCompFactory: n, ctrlsSvc: o, eventSvc: s } = e, i = t.getColDef(), r = this.createCellRendererParams();
    r.deferRender = !0;
    const a = pm(n, i, r);
    if ((d = (l = o.getGridBodyCtrl()) == null ? void 0 : l.scrollFeature) != null && d.isScrolling()) {
      let c;
      const u = new tt((h) => {
        c = h;
      });
      return this.addManagedListeners(s, {
        bodyScrollEnd: () => c()
      }), { loadingComp: a, onReady: u };
    }
    return { loadingComp: a, onReady: tt.resolve() };
  }
  showValue(e, t) {
    var u, h, g, p;
    const { beans: n, column: o, rowNode: s, rangeFeature: i } = this, { userCompFactory: r } = n;
    let a = this.getValueToDisplay(), l;
    const d = s.stub && ((u = s.groupData) == null ? void 0 : u[o.getId()]) == null, c = o.getColDef();
    if (d || this.isCellRenderer()) {
      const f = this.createCellRendererParams();
      !d || bs(o) ? l = br(r, c, f) : l = pm(r, c, f);
    }
    if (!l && !d && ((h = n.findSvc) != null && h.isMatch(s, o))) {
      const f = this.createCellRendererParams();
      l = br(
        r,
        { ...o.getColDef(), cellRenderer: "agFindCellRenderer" },
        f
      );
    }
    if (this.hasEdit && this.editSvc.isBatchEditing() && this.editSvc.isRowEditing(s, { checkSiblings: !0 })) {
      const f = this.editSvc.prepDetailsDuringBatch(this, { compDetails: l, valueToDisplay: a });
      f && (f.compDetails ? l = f.compDetails : f.valueToDisplay && (a = f.valueToDisplay));
    }
    this.comp.setRenderDetails(l, a, e), (g = this.customRowDragComp) == null || g.refreshVisibility(), !t && i && kn(n, () => i == null ? void 0 : i.refreshHandle()), (p = this.rowResizeFeature) == null || p.refreshRowResizer();
  }
  setupControlComps() {
    const e = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(e), !0), this.includeRowDrag = this.isIncludeControl(e.rowDrag), this.includeDndSource = this.isIncludeControl(e.dndSource), this.comp.setIncludeSelection(this.includeSelection), this.comp.setIncludeDndSource(this.includeDndSource), this.comp.setIncludeRowDrag(this.includeRowDrag);
  }
  isForceWrapper() {
    return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
  }
  /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  isIncludeControl(e, t = !1) {
    return (this.rowNode.rowPinned == null || t && nl(this.rowNode)) && !!e;
  }
  isCheckboxSelection(e) {
    const { rowSelection: t, groupDisplayType: n } = this.beans.gridOptions, o = Ta(t), s = Gs(this.column);
    return n === "custom" && o !== "selectionColumn" && s ? !1 : e.checkboxSelection || s && typeof t == "object" && li(t);
  }
  refreshShouldDestroy() {
    const e = this.column.getColDef(), t = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(e), !0), n = this.includeRowDrag != this.isIncludeControl(e.rowDrag), o = this.includeDndSource != this.isIncludeControl(e.dndSource), s = this.isAutoHeight != this.column.isAutoHeight();
    return t || n || o || s;
  }
  onPopupEditorClosed() {
    const { editSvc: e } = this.beans;
    e != null && e.isEditing(this, { withOpenEditor: !0 }) && (e == null || e.stopEditing(this, { source: e != null && e.isBatchEditing() ? "ui" : "api" }));
  }
  /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */
  stopEditing(e = !1) {
    const { editSvc: t } = this.beans;
    return (t == null ? void 0 : t.stopEditing(this, { cancel: e, source: t != null && t.isBatchEditing() ? "ui" : "api" })) ?? !1;
  }
  createCellRendererParams() {
    const {
      value: e,
      valueFormatted: t,
      column: n,
      rowNode: o,
      comp: s,
      eGui: i,
      beans: { valueSvc: r, gos: a, editSvc: l }
    } = this;
    return ke(a, {
      value: e,
      valueFormatted: t,
      getValue: () => r.getValueForDisplay(n, o).value,
      setValue: (c) => (l == null ? void 0 : l.setDataValue({ rowNode: o, column: n }, c)) || o.setDataValue(n, c),
      formatValue: this.formatValue.bind(this),
      data: o.data,
      node: o,
      pinned: n.getPinned(),
      colDef: n.getColDef(),
      column: n,
      refreshCell: this.refreshCell.bind(this),
      eGridCell: i,
      eParentOfValue: s.getParentOfValue(),
      registerRowDragger: (c, u, h, g) => this.registerRowDragger(c, u, g),
      setTooltip: (c, u) => {
        var h;
        a.assertModuleRegistered("Tooltip", 3), this.tooltipFeature && this.disableTooltipFeature(), this.enableTooltipFeature(c, u), (h = this.tooltipFeature) == null || h.refreshTooltip();
      }
    });
  }
  onCellChanged(e) {
    e.column === this.column && this.refreshCell({});
  }
  refreshOrDestroyCell(e) {
    var t;
    if (this.refreshShouldDestroy() ? (t = this.rowCtrl) == null || t.recreateCell(this) : this.refreshCell(e), this.hasEdit && this.editCompDetails) {
      const { editSvc: n, comp: o } = this;
      !(o != null && o.getCellEditor()) && n.isEditing(this, { withOpenEditor: !0 }) && n.startEditing(this, { startedEdit: !1, source: "api", silent: !0 });
    }
  }
  // + stop editing {force: true, suppressFlash: true}
  // + event cellChanged {}
  // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
  // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
  // + rowCtrl: api refreshCells() {animate: true/false}
  // + rowRenderer: api softRefreshView() {}
  refreshCell({ force: e, suppressFlash: t, newData: n } = {}) {
    var d, c, u, h, g, p, f, m;
    if (this.suppressRefreshCell)
      return;
    const o = this.column.getColDef(), s = o.field == null && o.valueGetter == null && o.showRowGroup == null, i = e || s || n, r = !!this.comp, a = this.updateAndFormatValue(r), l = i || a;
    if (r) {
      if (l) {
        this.showValue(!!n, !1);
        const C = (d = this.beans.filterManager) == null ? void 0 : d.isSuppressFlashingCellsBecauseFiltering();
        !t && !C && o.enableCellChangeFlash && ((c = this.beans.cellFlashSvc) == null || c.flashCell(this)), (h = (u = this.editStyleFeature) == null ? void 0 : u.applyCellStyles) == null || h.call(u), (g = this.customStyleFeature) == null || g.applyUserStyles(), (p = this.customStyleFeature) == null || p.applyClassesFromColDef();
      }
      (f = this.tooltipFeature) == null || f.refreshTooltip(), (m = this.customStyleFeature) == null || m.applyCellClassRules();
    }
  }
  isCellEditable() {
    return this.column.isCellEditable(this.rowNode);
  }
  formatValue(e) {
    return this.callValueFormatter(e) ?? e;
  }
  callValueFormatter(e) {
    return this.beans.valueSvc.formatValue(this.column, this.rowNode, e);
  }
  updateAndFormatValue(e) {
    const t = this.value, n = this.valueFormatted, { value: o, valueFormatted: s } = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode, !0);
    return this.value = o, this.valueFormatted = s, e ? !this.valuesAreEqual(t, this.value) || this.valueFormatted != n : !0;
  }
  valuesAreEqual(e, t) {
    const n = this.column.getColDef();
    return n.equals ? n.equals(e, t) : e === t;
  }
  addDomData(e) {
    const t = this.eGui;
    Ci(this.beans.gos, t, Dd, this), e.addDestroyFunc(() => Ci(this.beans.gos, t, Dd, null));
  }
  createEvent(e, t) {
    const { rowNode: n, column: o, value: s, beans: i } = this;
    return AL(i, e, t, { rowNode: n, column: o }, s);
  }
  processCharacter(e) {
    var t;
    (t = this.keyboardListener) == null || t.processCharacter(e);
  }
  onKeyDown(e) {
    var t;
    (t = this.keyboardListener) == null || t.onKeyDown(e);
  }
  onMouseEvent(e, t) {
    var n;
    (n = this.mouseListener) == null || n.onMouseEvent(e, t);
  }
  getColSpanningList() {
    var e;
    return ((e = this.positionFeature) == null ? void 0 : e.getColSpanningList()) ?? [];
  }
  onLeftChanged() {
    var e;
    this.comp && ((e = this.positionFeature) == null || e.onLeftChanged());
  }
  onDisplayedColumnsChanged() {
    this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
  }
  refreshFirstAndLastStyles() {
    const { comp: e, column: t, beans: n } = this;
    zw(e, t, n.visibleCols);
  }
  refreshAriaColIndex() {
    const e = this.beans.visibleCols.getAriaColIndex(this.column);
    $g(this.eGui, e);
  }
  onWidthChanged() {
    var e;
    return (e = this.positionFeature) == null ? void 0 : e.onWidthChanged();
  }
  getRowPosition() {
    const { rowIndex: e, rowPinned: t } = this.cellPosition;
    return {
      rowIndex: e,
      rowPinned: t
    };
  }
  updateRangeBordersIfRangeCount() {
    var e;
    this.comp && ((e = this.rangeFeature) == null || e.updateRangeBordersIfRangeCount());
  }
  onCellSelectionChanged() {
    var e;
    this.comp && ((e = this.rangeFeature) == null || e.onCellSelectionChanged());
  }
  isRangeSelectionEnabled() {
    return this.rangeFeature != null;
  }
  focusCell(e = !1, t) {
    var o;
    const n = (o = this.editSvc) == null ? void 0 : o.allowedFocusTargetOnValidation(this);
    n && n !== this || this.beans.focusSvc.setFocusedCell({
      ...this.getFocusedCellPosition(),
      forceBrowserFocus: e,
      sourceEvent: t
    });
  }
  /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */
  restoreFocus(e = !1) {
    const {
      beans: { editSvc: t, focusSvc: n },
      comp: o
    } = this;
    if (!o || t != null && t.isEditing(this) || !this.isCellFocused() || !n.shouldTakeFocus())
      return;
    const s = () => {
      if (!this.isAlive())
        return;
      const i = o.getFocusableElement();
      this.isCellFocused() && i.focus({ preventScroll: !0 });
    };
    if (e) {
      setTimeout(s, 0);
      return;
    }
    s();
  }
  onRowIndexChanged() {
    var e, t;
    this.createCellPosition(), this.onCellFocused(), this.restoreFocus(), (e = this.rangeFeature) == null || e.onCellSelectionChanged(), (t = this.rowResizeFeature) == null || t.refreshRowResizer();
  }
  onSuppressCellFocusChanged(e) {
    const t = this.eGui;
    t && (bs(this.column) && (e = !0), Mn(t, "tabindex", e ? void 0 : -1));
  }
  onFirstRightPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isFirstRightPinned();
    this.comp.toggleCss(BL, e);
  }
  onLastLeftPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isLastLeftPinned();
    this.comp.toggleCss(OL, e);
  }
  /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */
  checkCellFocused() {
    return this.beans.focusSvc.isCellFocused(this.cellPosition);
  }
  isCellFocused() {
    const e = this.checkCellFocused();
    return this.hasBeenFocused || (this.hasBeenFocused = e), e;
  }
  setupFocus() {
    this.restoreFocus(!0), this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
  }
  onCellFocused(e) {
    var s;
    const { beans: t } = this;
    if (xc(t))
      return;
    if (!this.comp) {
      e && (this.focusEventWhileNotReady = e);
      return;
    }
    const n = this.isCellFocused(), o = ((s = t.editSvc) == null ? void 0 : s.isEditing(this)) ?? !1;
    if (this.comp.toggleCss(LL, n), n && e && e.forceBrowserFocus) {
      let i = this.comp.getFocusableElement();
      if (o) {
        const r = Ko(i, null, !0);
        r.length && (i = r[0]);
      }
      i.focus({ preventScroll: !!e.preventScrollOnBrowserFocus });
    }
    n && this.rowCtrl.announceDescription();
  }
  createCellPosition() {
    const { rowIndex: e, rowPinned: t } = this.rowNode;
    this.cellPosition = {
      rowIndex: e,
      rowPinned: Gt(t),
      column: this.column
    };
  }
  // CSS Classes that only get applied once, they never change
  applyStaticCssClasses() {
    const { comp: e } = this;
    e.toggleCss(DL, !0), e.toggleCss(GL, !0);
    const t = this.column.isAutoHeight() == !0;
    e.toggleCss(TL, t), e.toggleCss(kL, !t);
  }
  onColumnHover() {
    var e;
    (e = this.beans.colHover) == null || e.onCellColumnHover(this.column, this.comp);
  }
  onColDefChanged() {
    var e, t;
    this.comp && (this.column.isTooltipEnabled() ? (this.disableTooltipFeature(), this.enableTooltipFeature()) : this.disableTooltipFeature(), this.setWrapText(), (e = this.editSvc) != null && e.isEditing(this) ? (t = this.editSvc) == null || t.handleColDefChanged(this) : this.refreshOrDestroyCell({ force: !0, suppressFlash: !0 }));
  }
  setWrapText() {
    const e = this.column.getColDef().wrapText == !0;
    this.comp.toggleCss(HL, e);
  }
  dispatchCellContextMenuEvent(e) {
    const t = this.column.getColDef(), n = this.createEvent(e, "cellContextMenu"), { beans: o } = this;
    o.eventSvc.dispatchEvent(n), t.onCellContextMenu && window.setTimeout(() => {
      o.frameworkOverrides.wrapOutgoing(() => {
        t.onCellContextMenu(n);
      });
    }, 0);
  }
  getCellRenderer() {
    var e;
    return ((e = this.comp) == null ? void 0 : e.getCellRenderer()) ?? null;
  }
  destroy() {
    this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.isCellFocused() && this.hasBrowserFocus() && this.beans.focusSvc.attemptToRecoverFocus(), super.destroy();
  }
  hasBrowserFocus() {
    var e;
    return ((e = this.eGui) == null ? void 0 : e.contains(je(this.beans))) ?? !1;
  }
  createSelectionCheckbox() {
    var t;
    const e = (t = this.beans.selectionSvc) == null ? void 0 : t.createCheckboxSelectionComponent();
    if (e)
      return this.beans.context.createBean(e), e.init({ rowNode: this.rowNode, column: this.column }), e;
  }
  createDndSource() {
    const e = this.beans.registry.createDynamicBean(
      "dndSourceComp",
      !1,
      this.rowNode,
      this.column,
      this.eGui
    );
    return e && this.beans.context.createBean(e), e;
  }
  registerRowDragger(e, t, n) {
    if (this.customRowDragComp) {
      this.customRowDragComp.setDragElement(e, t);
      return;
    }
    const o = this.createRowDragComp(e, t, n);
    o && (this.customRowDragComp = o, this.addDestroyFunc(() => {
      this.beans.context.destroyBean(o), this.customRowDragComp = null;
    }), o.refreshVisibility());
  }
  createRowDragComp(e, t, n) {
    var s;
    const o = (s = this.beans.rowDragSvc) == null ? void 0 : s.createRowDragCompForCell(
      this.rowNode,
      this.column,
      () => this.value,
      e,
      t,
      n
    );
    if (o)
      return this.beans.context.createBean(o), o;
  }
  cellEditorAttached() {
    this.onEditorAttachedFuncs.forEach((e) => e()), this.onEditorAttachedFuncs = [];
  }
  setFocusedCellPosition(e) {
  }
  getFocusedCellPosition() {
    return this.cellPosition;
  }
  // used by spannedCellCtrl
  refreshAriaRowIndex() {
  }
  /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */
  getRootElement() {
    return this.eGui;
  }
};
function Lp(e, t, n, o, s, i) {
  if (n == null && t == null)
    return;
  const r = {}, a = {}, l = (d, c) => {
    d.split(" ").forEach((u) => {
      u.trim() != "" && c(u);
    });
  };
  if (n) {
    const d = Object.keys(n);
    for (let c = 0; c < d.length; c++) {
      const u = d[c], h = n[u];
      let g;
      typeof h == "string" ? g = e ? e.evaluate(h, o) : !0 : typeof h == "function" && (g = h(o)), l(u, (p) => {
        g ? r[p] = !0 : a[p] = !0;
      });
    }
  }
  t && i && Object.keys(t).forEach(
    (d) => l(d, (c) => {
      r[c] || (a[c] = !0);
    })
  ), i && Object.keys(a).forEach(i), Object.keys(r).forEach(s);
}
function n0(e) {
  if (e.group)
    return e.level;
  const t = e.parent;
  return t ? t.level + 1 : 0;
}
var _L = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowStyleSvc";
  }
  processClassesFromGridOptions(e, t) {
    const n = this.gos, o = (r) => {
      typeof r == "string" ? e.push(r) : Array.isArray(r) && r.forEach((a) => e.push(a));
    }, s = n.get("rowClass");
    s && o(s);
    const i = n.getCallback("getRowClass");
    if (i) {
      const r = {
        data: t.data,
        node: t,
        rowIndex: t.rowIndex
      }, a = i(r);
      o(a);
    }
  }
  preProcessRowClassRules(e, t) {
    this.processRowClassRules(
      t,
      (n) => {
        e.push(n);
      },
      () => {
      }
    );
  }
  processRowClassRules(e, t, n) {
    const { gos: o, expressionSvc: s } = this.beans, i = ke(o, {
      data: e.data,
      node: e,
      rowIndex: e.rowIndex
    });
    Lp(
      s,
      void 0,
      o.get("rowClassRules"),
      i,
      t,
      n
    );
  }
  processStylesFromGridOptions(e) {
    const t = this.gos, n = t.get("rowStyle"), o = t.getCallback("getRowStyle");
    let s;
    if (o) {
      const i = {
        data: e.data,
        node: e,
        rowIndex: e.rowIndex
      };
      s = o(i);
    }
    if (s || n)
      return Object.assign({}, n, s);
  }
}, NL = 0, Gd = class extends U {
  constructor(e, t, n, o, s) {
    var i, r;
    super(), this.rowNode = e, this.useAnimationFrameForCreate = o, this.printLayout = s, this.allRowGuis = [], this.active = !0, this.centerCellCtrls = { list: [], map: {} }, this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} }, this.slideInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.fadeInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.rowDragComps = [], this.lastMouseDownOnDragger = !1, this.emptyStyle = {}, this.updateColumnListsPending = !1, this.rowId = null, this.businessKey = null, this.beans = t, this.gos = t.gos, this.paginationPage = ((i = t.pagination) == null ? void 0 : i.getCurrentPage()) ?? 0, this.suppressRowTransform = this.gos.get("suppressRowTransform"), this.instanceId = e.id + "-" + NL++, this.rowId = sa(e.id), this.initRowBusinessKey(), this.rowFocused = t.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned), this.rowLevel = n0(this.rowNode), this.setRowType(), this.setAnimateFlags(n), this.rowStyles = this.processStylesFromGridOptions(), this.rowEditStyleFeature = (r = t.editSvc) == null ? void 0 : r.createRowStyleFeature(this, t), this.addListeners();
  }
  initRowBusinessKey() {
    this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
  }
  updateRowBusinessKey() {
    if (typeof this.businessKeyForNodeFunc != "function")
      return;
    const e = this.businessKeyForNodeFunc(this.rowNode);
    this.businessKey = sa(e);
  }
  updateGui(e, t) {
    e === "left" ? this.leftGui = t : e === "right" ? this.rightGui = t : e === "fullWidth" ? this.fullWidthGui = t : this.centerGui = t;
  }
  setComp(e, t, n, o) {
    var u, h;
    const { context: s, focusSvc: i } = this.beans;
    o = Ja(this, s, o);
    const r = { rowComp: e, element: t, containerType: n, compBean: o };
    this.allRowGuis.push(r), this.updateGui(n, r), this.initialiseRowComp(r);
    const a = this.rowNode, l = this.rowType === "FullWidthLoading" || a.stub, d = !a.data && this.beans.rowModel.getType() === "infinite";
    !l && !d && !a.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    const c = (u = this.fullWidthGui) == null ? void 0 : u.element;
    c && !((h = this.beans.editSvc) != null && h.isEditing(this)) && i.isRowFocused(a.rowIndex, a.rowPinned) && i.shouldTakeFocus() && setTimeout(() => c.focus({ preventScroll: !0 }), 0);
  }
  unsetComp(e) {
    this.allRowGuis = this.allRowGuis.filter((t) => t.containerType !== e), this.updateGui(e, void 0);
  }
  isCacheable() {
    return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
  }
  setCached(e) {
    const t = e ? "none" : "";
    this.allRowGuis.forEach((n) => n.element.style.display = t);
  }
  initialiseRowComp(e) {
    const t = this.gos;
    this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.listenOnDomOrder(e), this.onRowHeightChanged(e), this.updateRowIndexes(e), this.setFocusedClasses(e), this.setStylesFromGridOptions(!1, e), In(t) && this.rowNode.selectable && this.onRowSelected(e), this.updateColumnLists(!this.useAnimationFrameForCreate);
    const n = e.rowComp;
    this.getInitialRowClasses(e.containerType).forEach((s) => n.toggleCss(s, !0)), this.executeSlideAndFadeAnimations(e), this.rowNode.group && Zn(e.element, this.rowNode.expanded == !0), this.setRowCompRowId(n), this.setRowCompRowBusinessKey(n), Ci(t, e.element, Td, this), e.compBean.addDestroyFunc(() => Ci(t, e.element, Td, null)), this.useAnimationFrameForCreate ? this.beans.animationFrameSvc.createTask(
      this.addHoverFunctionality.bind(this, e),
      this.rowNode.rowIndex,
      "p2",
      !1
    ) : this.addHoverFunctionality(e), this.isFullWidth() && this.setupFullWidth(e), t.get("rowDragEntireRow") && this.addRowDraggerToRow(e), this.useAnimationFrameForCreate && this.beans.animationFrameSvc.addDestroyTask(() => {
      this.isAlive() && e.rowComp.toggleCss("ag-after-created", !0);
    }), this.executeProcessRowPostCreateFunc();
  }
  setRowCompRowBusinessKey(e) {
    this.businessKey != null && e.setRowBusinessKey(this.businessKey);
  }
  setRowCompRowId(e) {
    const t = sa(this.rowNode.id);
    this.rowId = t, t != null && e.setRowId(t);
  }
  executeSlideAndFadeAnimations(e) {
    const { containerType: t } = e;
    this.slideInAnimation[t] && (mh(() => {
      this.onTopChanged();
    }), this.slideInAnimation[t] = !1), this.fadeInAnimation[t] && (mh(() => {
      e.rowComp.toggleCss("ag-opacity-zero", !1);
    }), this.fadeInAnimation[t] = !1);
  }
  addRowDraggerToRow(e) {
    var o;
    const t = (o = this.beans.rowDragSvc) == null ? void 0 : o.createRowDragCompForRow(this.rowNode, e.element);
    if (!t)
      return;
    const n = this.createBean(t, this.beans.context);
    this.rowDragComps.push(n), e.compBean.addDestroyFunc(() => {
      this.rowDragComps = this.rowDragComps.filter((s) => s !== n), this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, this.beans.context), this.destroyBean(n, this.beans.context);
    });
  }
  setupFullWidth(e) {
    const t = this.getPinnedForContainer(e.containerType), n = this.createFullWidthCompDetails(e.element, t);
    e.rowComp.showFullWidth(n);
  }
  getFullWidthCellRenderers() {
    var e, t;
    return this.gos.get("embedFullWidthRows") ? this.allRowGuis.map((n) => {
      var o;
      return (o = n == null ? void 0 : n.rowComp) == null ? void 0 : o.getFullWidthCellRenderer();
    }) : [(t = (e = this.fullWidthGui) == null ? void 0 : e.rowComp) == null ? void 0 : t.getFullWidthCellRenderer()];
  }
  executeProcessRowPostCreateFunc() {
    const e = this.gos.getCallback("processRowPostCreate");
    if (!e || !this.areAllContainersReady())
      return;
    const t = {
      // areAllContainersReady asserts that centerGui is not null
      eRow: this.centerGui.element,
      ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
      ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
      node: this.rowNode,
      rowIndex: this.rowNode.rowIndex,
      addRenderedRowListener: this.addEventListener.bind(this)
    };
    e(t);
  }
  areAllContainersReady() {
    const {
      leftGui: e,
      centerGui: t,
      rightGui: n,
      beans: { visibleCols: o }
    } = this, s = !!e || !o.isPinningLeft(), i = !!t, r = !!n || !o.isPinningRight();
    return s && i && r;
  }
  isNodeFullWidthCell() {
    if (this.rowNode.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this.rowNode }) : !1;
  }
  setRowType() {
    const e = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents"), t = this.isNodeFullWidthCell(), n = this.gos.get("masterDetail") && this.rowNode.detail, o = this.beans.colModel.isPivotMode(), s = DC(this.gos, this.rowNode, o);
    e ? this.rowType = "FullWidthLoading" : n ? this.rowType = "FullWidthDetail" : t ? this.rowType = "FullWidth" : s ? this.rowType = "FullWidthGroup" : this.rowType = "Normal";
  }
  updateColumnLists(e = !1, t = !1) {
    if (this.isFullWidth())
      return;
    const { animationFrameSvc: n } = this.beans;
    if (!(n != null && n.active) || e || this.printLayout) {
      this.updateColumnListsImpl(t);
      return;
    }
    this.updateColumnListsPending || (n.createTask(
      () => {
        this.active && this.updateColumnListsImpl(!0);
      },
      this.rowNode.rowIndex,
      "p1",
      !1
    ), this.updateColumnListsPending = !0);
  }
  /**
   * Overridden by SpannedRowCtrl
   */
  getNewCellCtrl(e) {
    var n;
    if (!((n = this.beans.rowSpanSvc) != null && n.isCellSpanning(e, this.rowNode)))
      return new ir(e, this.rowNode, this.beans, this);
  }
  /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */
  isCorrectCtrlForSpan(e) {
    var t;
    return !((t = this.beans.rowSpanSvc) != null && t.isCellSpanning(e.column, this.rowNode));
  }
  createCellCtrls(e, t, n = null) {
    const o = {
      list: [],
      map: {}
    }, s = (d, c, u) => {
      u != null ? o.list.splice(u, 0, c) : o.list.push(c), o.map[d] = c;
    }, i = [];
    for (const d of t) {
      const c = d.getInstanceId();
      let u = e.map[c];
      u && !this.isCorrectCtrlForSpan(u) && (u.destroy(), u = void 0), u || (u = this.getNewCellCtrl(d)), u && s(c, u);
    }
    for (const d of e.list) {
      const c = d.column.getInstanceId();
      if (o.map[c] != null)
        continue;
      !this.isCellEligibleToBeRemoved(d, n) ? i.push([c, d]) : d.destroy();
    }
    if (i.length)
      for (const [d, c] of i) {
        const u = o.list.findIndex((g) => g.column.getLeft() > c.column.getLeft()), h = u === -1 ? void 0 : Math.max(u - 1, 0);
        s(d, c, h);
      }
    const { focusSvc: r, visibleCols: a } = this.beans, l = r.getFocusedCell();
    if (l && l.column.getPinned() == n) {
      const d = l.column.getInstanceId();
      if (!o.map[d] && a.allCols.includes(l.column)) {
        const u = this.createFocusedCellCtrl();
        if (u) {
          const h = o.list.findIndex((p) => p.column.getLeft() > u.column.getLeft()), g = h === -1 ? void 0 : Math.max(h - 1, 0);
          s(d, u, g);
        }
      }
    }
    return o;
  }
  /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */
  createFocusedCellCtrl() {
    const { focusSvc: e, rowSpanSvc: t } = this.beans, n = e.getFocusedCell();
    if (!n)
      return;
    const o = t == null ? void 0 : t.getCellSpan(n.column, this.rowNode);
    if (o) {
      if (o.firstNode !== this.rowNode || !o.doesSpanContain(n))
        return;
    } else if (!e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned))
      return;
    return this.getNewCellCtrl(n.column);
  }
  updateColumnListsImpl(e) {
    this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(e);
  }
  setCellCtrls(e) {
    this.allRowGuis.forEach((t) => {
      const n = this.getCellCtrlsForContainer(t.containerType);
      t.rowComp.setCellCtrls(n, e);
    });
  }
  getCellCtrlsForContainer(e) {
    switch (e) {
      case "left":
        return this.leftCellCtrls.list;
      case "right":
        return this.rightCellCtrls.list;
      case "fullWidth":
        return [];
      case "center":
        return this.centerCellCtrls.list;
    }
  }
  createAllCellCtrls() {
    const e = this.beans.colViewport, t = this.beans.visibleCols;
    if (this.printLayout)
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, t.allCols), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
    else {
      const n = e.getColsWithinViewport(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, n);
      const o = t.getLeftColsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, o, "left");
      const s = t.getRightColsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, s, "right");
    }
  }
  isCellEligibleToBeRemoved(e, t) {
    const { column: s } = e;
    if (s.getPinned() != t || !this.isCorrectCtrlForSpan(e))
      return !0;
    const { visibleCols: i, editSvc: r } = this.beans, a = r == null ? void 0 : r.isEditing(e), l = e.isCellFocused();
    return a || l ? !(i.allCols.indexOf(s) >= 0) : !0;
  }
  getDomOrder() {
    return this.gos.get("ensureDomOrder") || jt(this.gos, "print");
  }
  listenOnDomOrder(e) {
    const t = () => {
      e.rowComp.setDomOrder(this.getDomOrder());
    };
    e.compBean.addManagedPropertyListeners(["domLayout", "ensureDomOrder"], t);
  }
  setAnimateFlags(e) {
    if (this.rowNode.sticky || !e)
      return;
    const t = ue(this.rowNode.oldRowTop), { visibleCols: n } = this.beans, o = n.isPinningLeft(), s = n.isPinningRight();
    if (t) {
      const { slideInAnimation: i } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        i.fullWidth = !0;
        return;
      }
      i.center = !0, i.left = o, i.right = s;
    } else {
      const { fadeInAnimation: i } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        i.fullWidth = !0;
        return;
      }
      i.center = !0, i.left = o, i.right = s;
    }
  }
  isFullWidth() {
    return this.rowType !== "Normal";
  }
  refreshFullWidth() {
    const e = (r, a) => r ? r.rowComp.refreshFullWidth(() => this.createFullWidthCompDetails(r.element, a).params) : !0, t = e(this.fullWidthGui, null), n = e(this.centerGui, null), o = e(this.leftGui, "left"), s = e(this.rightGui, "right");
    return t && n && o && s;
  }
  addListeners() {
    const { beans: e, gos: t, rowNode: n } = this, { expansionSvc: o, eventSvc: s, context: i, rowSpanSvc: r } = e;
    this.addManagedListeners(this.rowNode, {
      heightChanged: () => this.onRowHeightChanged(),
      rowSelected: () => this.onRowSelected(),
      rowIndexChanged: this.onRowIndexChanged.bind(this),
      topChanged: this.onTopChanged.bind(this),
      ...(o == null ? void 0 : o.getRowExpandedListeners(this)) ?? {}
    }), n.detail && this.addManagedListeners(n.parent, { dataChanged: this.onRowNodeDataChanged.bind(this) }), this.addManagedListeners(n, {
      dataChanged: this.onRowNodeDataChanged.bind(this),
      cellChanged: this.postProcessCss.bind(this),
      rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
      draggingChanged: this.postProcessRowDragging.bind(this),
      uiLevelChanged: this.onUiLevelChanged.bind(this),
      rowPinned: this.onRowPinned.bind(this)
    }), this.addManagedListeners(s, {
      paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
      heightScaleChanged: this.onTopChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
      cellFocused: this.onCellFocusChanged.bind(this),
      cellFocusCleared: this.onCellFocusChanged.bind(this),
      paginationChanged: this.onPaginationChanged.bind(this),
      modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
      columnMoved: () => this.updateColumnLists()
    }), r && this.addManagedListeners(r, {
      spannedCellsUpdated: ({ pinned: a }) => {
        a && !n.rowPinned || this.updateColumnLists();
      }
    }), this.addDestroyFunc(() => {
      this.rowDragComps = this.destroyBeans(this.rowDragComps, i), this.tooltipFeature = this.destroyBean(this.tooltipFeature, i), this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, i);
    }), this.addManagedPropertyListeners(
      ["rowStyle", "getRowStyle", "rowClass", "getRowClass", "rowClassRules"],
      this.postProcessCss.bind(this)
    ), this.addManagedPropertyListener("rowDragEntireRow", () => {
      if (t.get("rowDragEntireRow")) {
        this.allRowGuis.forEach((l) => {
          this.addRowDraggerToRow(l);
        });
        return;
      }
      this.rowDragComps = this.destroyBeans(this.rowDragComps, i);
    }), this.addListenersForCellComps();
  }
  addListenersForCellComps() {
    this.addManagedListeners(this.rowNode, {
      rowIndexChanged: () => this.getAllCellCtrls().forEach((e) => e.onRowIndexChanged()),
      cellChanged: (e) => this.getAllCellCtrls().forEach((t) => t.onCellChanged(e))
    });
  }
  /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */
  onRowPinned() {
    for (const e of this.allRowGuis)
      e.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
  }
  onRowNodeDataChanged(e) {
    this.refreshRow({
      suppressFlash: !e.update,
      newData: !e.update
    });
  }
  refreshRow(e) {
    if (this.isFullWidth() !== !!this.isNodeFullWidthCell()) {
      this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    if (this.isFullWidth()) {
      this.refreshFullWidth() || this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    this.getAllCellCtrls().forEach((n) => n.refreshCell(e)), this.allRowGuis.forEach((n) => {
      this.setRowCompRowId(n.rowComp), this.updateRowBusinessKey(), this.setRowCompRowBusinessKey(n.rowComp);
    }), this.onRowSelected(), this.postProcessCss();
  }
  postProcessCss() {
    var e;
    this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), (e = this.rowEditStyleFeature) == null || e.applyRowStyles(), this.postProcessRowDragging();
  }
  onRowNodeHighlightChanged() {
    const e = this.beans.rowDropHighlightSvc, t = (e == null ? void 0 : e.row) === this.rowNode ? e.position : "none", n = t === "above", o = t === "inside", s = t === "below", r = this.gos.get("treeData") && (s || n), a = this.rowNode.uiLevel.toString();
    this.allRowGuis.forEach((l) => {
      const d = l.rowComp;
      d.toggleCss("ag-row-highlight-above", n), d.toggleCss("ag-row-highlight-inside", o), d.toggleCss("ag-row-highlight-below", s), d.toggleCss("ag-row-highlight-indent", r), r ? l.element.style.setProperty("--ag-row-highlight-level", a) : l.element.style.removeProperty("--ag-row-highlight-level");
    });
  }
  postProcessRowDragging() {
    const e = this.rowNode.dragging;
    this.allRowGuis.forEach((t) => t.rowComp.toggleCss("ag-row-dragging", e));
  }
  onDisplayedColumnsChanged() {
    var e;
    this.updateColumnLists(!0), (e = this.beans.rowAutoHeight) == null || e.requestCheckAutoHeight();
  }
  onVirtualColumnsChanged() {
    this.updateColumnLists(!1, !0);
  }
  getRowPosition() {
    return {
      rowPinned: Gt(this.rowNode.rowPinned),
      rowIndex: this.rowNode.rowIndex
    };
  }
  onKeyboardNavigate(e) {
    const t = this.findFullWidthInfoForEvent(e);
    if (!t)
      return;
    const { rowGui: n, column: o } = t;
    if (!(n.element === e.target))
      return;
    const r = this.rowNode, { focusSvc: a, navigation: l } = this.beans, d = a.getFocusedCell(), c = {
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      column: (d == null ? void 0 : d.column) ?? o
    };
    l == null || l.navigateToNextCell(e, e.key, c, !0), e.preventDefault();
  }
  onTabKeyDown(e) {
    var a;
    if (e.defaultPrevented || Dn(e))
      return;
    const t = this.allRowGuis.find(
      (l) => l.element.contains(e.target)
    ), n = t ? t.element : null, o = n === e.target, s = je(this.beans);
    let i = !1;
    n && s && (i = n.contains(s) && s.classList.contains("ag-cell"));
    let r = null;
    !o && !i && (r = sn(this.beans, n, !1, e.shiftKey)), (this.isFullWidth() && o || !r) && ((a = this.beans.navigation) == null || a.onTabKeyDown(this, e));
  }
  getFullWidthElement() {
    return this.fullWidthGui ? this.fullWidthGui.element : null;
  }
  getRowYPosition() {
    var t;
    const e = (t = this.allRowGuis.find((n) => vn(n.element))) == null ? void 0 : t.element;
    return e ? e.getBoundingClientRect().top : 0;
  }
  onSuppressCellFocusChanged(e) {
    const t = this.isFullWidth() && e ? void 0 : this.gos.get("tabIndex");
    this.allRowGuis.forEach((n) => {
      Mn(n.element, "tabindex", t);
    });
  }
  onFullWidthRowFocused(e) {
    var s, i, r;
    const t = this.rowNode, n = e ? this.isFullWidth() && e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned : !1;
    let o;
    if (this.fullWidthGui)
      o = this.fullWidthGui.element;
    else {
      const a = this.beans.colModel.getCol(e == null ? void 0 : e.column), l = a == null ? void 0 : a.pinned;
      l ? o = l === "right" ? (s = this.rightGui) == null ? void 0 : s.element : (i = this.leftGui) == null ? void 0 : i.element : o = (r = this.centerGui) == null ? void 0 : r.element;
    }
    o && (o.classList.toggle("ag-full-width-focus", n), n && (e != null && e.forceBrowserFocus) && o.focus({ preventScroll: !0 }));
  }
  recreateCell(e) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, e), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, e), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, e), e.destroy(), this.updateColumnLists();
  }
  removeCellCtrl(e, t) {
    const n = {
      list: [],
      map: {}
    };
    return e.list.forEach((o) => {
      o !== t && (n.list.push(o), n.map[o.column.getInstanceId()] = o);
    }), n;
  }
  onMouseEvent(e, t) {
    switch (e) {
      case "dblclick":
        this.onRowDblClick(t);
        break;
      case "click":
        this.onRowClick(t);
        break;
      case "touchstart":
      case "mousedown":
        this.onRowMouseDown(t);
        break;
    }
  }
  createRowEvent(e, t) {
    const { rowNode: n } = this;
    return ke(this.gos, {
      type: e,
      node: n,
      data: n.data,
      rowIndex: n.rowIndex,
      rowPinned: n.rowPinned,
      event: t
    });
  }
  createRowEventWithSource(e, t) {
    const n = this.createRowEvent(e, t);
    return n.source = this, n;
  }
  onRowDblClick(e) {
    if (Dn(e))
      return;
    const t = this.createRowEventWithSource("rowDoubleClicked", e);
    t.isEventHandlingSuppressed = this.isSuppressMouseEvent(e), this.beans.eventSvc.dispatchEvent(t);
  }
  findFullWidthInfoForEvent(e) {
    if (!e)
      return;
    const t = this.findFullWidthRowGui(e.target), n = this.getColumnForFullWidth(t);
    if (!(!t || !n))
      return { rowGui: t, column: n };
  }
  findFullWidthRowGui(e) {
    return this.allRowGuis.find((t) => t.element.contains(e));
  }
  getColumnForFullWidth(e) {
    const { visibleCols: t } = this.beans;
    switch (e == null ? void 0 : e.containerType) {
      case "center":
        return t.centerCols[0];
      case "left":
        return t.leftCols[0];
      case "right":
        return t.rightCols[0];
      default:
        return t.allCols[0];
    }
  }
  onRowMouseDown(e) {
    if (this.lastMouseDownOnDragger = ri(e.target, "ag-row-drag", 3), !this.isFullWidth() || this.isSuppressMouseEvent(e))
      return;
    const { rangeSvc: t, focusSvc: n } = this.beans;
    t == null || t.removeAllCellRanges();
    const o = this.findFullWidthInfoForEvent(e);
    if (!o)
      return;
    const { rowGui: s, column: i } = o, r = s.element, a = e.target, l = this.rowNode;
    let d = e.defaultPrevented || os();
    r && r.contains(a) && Ug(a) && (d = !1), n.setFocusedCell({
      rowIndex: l.rowIndex,
      column: i,
      rowPinned: l.rowPinned,
      forceBrowserFocus: d
    });
  }
  isSuppressMouseEvent(e) {
    const { gos: t, rowNode: n } = this;
    if (this.isFullWidth()) {
      const s = this.findFullWidthRowGui(e.target);
      return RI(
        t,
        s == null ? void 0 : s.rowComp.getFullWidthCellRendererParams(),
        n,
        e
      );
    }
    const o = bp(t, e.target);
    return o != null && Ql(t, o.column, n, e);
  }
  onRowClick(e) {
    if (Dn(e) || this.lastMouseDownOnDragger)
      return;
    const n = this.isSuppressMouseEvent(e), { eventSvc: o, selectionSvc: s } = this.beans, i = this.createRowEventWithSource("rowClicked", e);
    i.isEventHandlingSuppressed = n, o.dispatchEvent(i), !n && (s == null || s.handleSelectionEvent(e, this.rowNode, "rowClicked"));
  }
  setupDetailRowAutoHeight(e) {
    var t;
    this.rowType === "FullWidthDetail" && ((t = this.beans.masterDetailSvc) == null || t.setupDetailRowAutoHeight(this, e));
  }
  createFullWidthCompDetails(e, t) {
    const { gos: n, rowNode: o } = this, s = ke(n, {
      fullWidth: !0,
      data: o.data,
      node: o,
      value: o.key,
      valueFormatted: o.key,
      // these need to be taken out, as part of 'afterAttached' now
      eGridCell: e,
      eParentOfValue: e,
      pinned: t,
      addRenderedRowListener: this.addEventListener.bind(this),
      // This is not on the type of ICellRendererParams
      registerRowDragger: (r, a, l, d) => this.addFullWidthRowDragging(r, a, l, d),
      setTooltip: (r, a) => {
        n.assertModuleRegistered("Tooltip", 3), this.setupFullWidthRowTooltip(r, a);
      }
    }), i = this.beans.userCompFactory;
    switch (this.rowType) {
      case "FullWidthDetail":
        return VF(i, s);
      case "FullWidthGroup": {
        const { value: r, valueFormatted: a } = this.beans.valueSvc.getValueForDisplay(void 0, this.rowNode, !0);
        return s.value = r, s.valueFormatted = a, HF(i, s);
      }
      case "FullWidthLoading":
        return GF(i, s);
      default:
        return OF(i, s);
    }
  }
  setupFullWidthRowTooltip(e, t) {
    var n;
    this.fullWidthGui && (this.tooltipFeature = (n = this.beans.tooltipSvc) == null ? void 0 : n.setupFullWidthRowTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    ));
  }
  addFullWidthRowDragging(e, t, n = "", o) {
    const { rowDragSvc: s, context: i } = this.beans;
    if (!s || !this.isFullWidth())
      return;
    const r = s.createRowDragComp(
      () => n,
      this.rowNode,
      void 0,
      e,
      t,
      o
    );
    this.createBean(r, i), this.addDestroyFunc(() => {
      this.destroyBean(r, i);
    });
  }
  onUiLevelChanged() {
    const e = n0(this.rowNode);
    if (this.rowLevel != e) {
      const t = "ag-row-level-" + e, n = "ag-row-level-" + this.rowLevel;
      this.allRowGuis.forEach((o) => {
        o.rowComp.toggleCss(t, !0), o.rowComp.toggleCss(n, !1);
      });
    }
    this.rowLevel = e;
  }
  isFirstRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
  }
  isLastRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
  }
  refreshFirstAndLastRowStyles() {
    const e = this.isFirstRowOnPage(), t = this.isLastRowOnPage();
    this.firstRowOnPage !== e && (this.firstRowOnPage = e, this.allRowGuis.forEach((n) => n.rowComp.toggleCss("ag-row-first", e))), this.lastRowOnPage !== t && (this.lastRowOnPage = t, this.allRowGuis.forEach((n) => n.rowComp.toggleCss("ag-row-last", t)));
  }
  getAllCellCtrls() {
    return this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0 ? this.centerCellCtrls.list : [...this.centerCellCtrls.list, ...this.leftCellCtrls.list, ...this.rightCellCtrls.list];
  }
  postProcessClassesFromGridOptions() {
    var t;
    const e = [];
    (t = this.beans.rowStyleSvc) == null || t.processClassesFromGridOptions(e, this.rowNode), e.length && e.forEach((n) => {
      this.allRowGuis.forEach((o) => o.rowComp.toggleCss(n, !0));
    });
  }
  postProcessRowClassRules() {
    var e;
    (e = this.beans.rowStyleSvc) == null || e.processRowClassRules(
      this.rowNode,
      (t) => {
        this.allRowGuis.forEach((n) => n.rowComp.toggleCss(t, !0));
      },
      (t) => {
        this.allRowGuis.forEach((n) => n.rowComp.toggleCss(t, !1));
      }
    );
  }
  setStylesFromGridOptions(e, t) {
    e && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(t, (n) => n.rowComp.setUserStyles(this.rowStyles));
  }
  getPinnedForContainer(e) {
    return e === "left" || e === "right" ? e : null;
  }
  getInitialRowClasses(e) {
    var a, l;
    const t = this.getPinnedForContainer(e), n = this.isFullWidth(), { rowNode: o, beans: s } = this, i = [];
    i.push("ag-row"), i.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), this.fadeInAnimation[e] && i.push("ag-opacity-zero"), i.push(o.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd"), o.isRowPinned() && (i.push("ag-row-pinned"), (a = s.pinnedRowModel) != null && a.isManual() && i.push("ag-row-pinned-manual")), !o.isRowPinned() && o.pinnedSibling && i.push("ag-row-pinned-source"), o.isSelected() && i.push("ag-row-selected"), o.footer && i.push("ag-row-footer"), i.push("ag-row-level-" + this.rowLevel), o.stub && i.push("ag-row-loading"), n && i.push("ag-full-width-row"), (l = s.expansionSvc) == null || l.addExpandedCss(i, o), o.dragging && i.push("ag-row-dragging");
    const { rowStyleSvc: r } = s;
    return r && (r.processClassesFromGridOptions(i, o), r.preProcessRowClassRules(i, o)), i.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), this.isFirstRowOnPage() && i.push("ag-row-first"), this.isLastRowOnPage() && i.push("ag-row-last"), n && (t === "left" && i.push("ag-cell-last-left-pinned"), t === "right" && i.push("ag-cell-first-right-pinned")), i;
  }
  processStylesFromGridOptions() {
    var e;
    return ((e = this.beans.rowStyleSvc) == null ? void 0 : e.processStylesFromGridOptions(this.rowNode)) ?? this.emptyStyle;
  }
  onRowSelected(e) {
    var t;
    (t = this.beans.selectionSvc) == null || t.onRowCtrlSelected(
      this,
      (n) => {
        (n === this.centerGui || n === this.fullWidthGui) && this.announceDescription();
      },
      e
    );
  }
  announceDescription() {
    var e;
    (e = this.beans.selectionSvc) == null || e.announceAriaRowSelection(this.rowNode);
  }
  addHoverFunctionality(e) {
    if (!this.active)
      return;
    const { element: t, compBean: n } = e, { rowNode: o, beans: s, gos: i } = this;
    n.addManagedListeners(t, {
      // We use pointer events here instead of mouse events, as pointer events
      // are more reliable for hover detection, especially with touch devices
      // or hybrid touch + mouse devices.
      pointerenter: (r) => {
        r.pointerType === "mouse" && o.dispatchRowEvent("mouseEnter");
      },
      pointerleave: (r) => {
        r.pointerType === "mouse" && o.dispatchRowEvent("mouseLeave");
      }
    }), n.addManagedListeners(o, {
      mouseEnter: () => {
        var r;
        !((r = s.dragSvc) != null && r.dragging) && !i.get("suppressRowHoverHighlight") && (t.classList.add("ag-row-hover"), o.setHovered(!0));
      },
      mouseLeave: () => {
        this.resetHoveredStatus(t);
      }
    });
  }
  resetHoveredStatus(e) {
    const t = e ? [e] : this.allRowGuis.map((n) => n.element);
    for (const n of t)
      n.classList.remove("ag-row-hover");
    this.rowNode.setHovered(!1);
  }
  // for animation, we don't want to animate entry or exit to a very far away pixel,
  // otherwise the row would move so fast, it would appear to disappear. so this method
  // moves the row closer to the viewport if it is far away, so the row slide in / out
  // at a speed the user can see.
  roundRowTopToBounds(e) {
    const t = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition(), n = this.applyPaginationOffset(t.top, !0) - 100, o = this.applyPaginationOffset(t.bottom, !0) + 100;
    return Math.min(Math.max(n, e), o);
  }
  forEachGui(e, t) {
    e ? t(e) : this.allRowGuis.forEach(t);
  }
  isRowRendered() {
    return this.allRowGuis.length > 0;
  }
  onRowHeightChanged(e) {
    if (this.rowNode.rowHeight == null)
      return;
    const t = this.rowNode.rowHeight, n = this.beans.environment.getDefaultRowHeight(), s = Jg(this.gos) ? qt(this.beans, this.rowNode).height : void 0, i = s ? `${Math.min(n, s) - 2}px` : void 0;
    this.forEachGui(e, (r) => {
      r.element.style.height = `${t}px`, i && r.element.style.setProperty("--ag-line-height", i);
    });
  }
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroyFirstPass(e = !1) {
    var o;
    this.active = !1;
    const { rowNode: t } = this;
    if (!e && Xi(this.gos) && !t.sticky)
      if (t.rowTop != null) {
        const i = this.roundRowTopToBounds(t.rowTop);
        this.setRowTop(i);
      } else
        this.allRowGuis.forEach((i) => i.rowComp.toggleCss("ag-opacity-zero", !0));
    (o = this.fullWidthGui) != null && o.element.contains(je(this.beans)) && this.beans.focusSvc.attemptToRecoverFocus(), t.setHovered(!1);
    const n = this.createRowEvent("virtualRowRemoved");
    this.dispatchLocalEvent(n), this.beans.eventSvc.dispatchEvent(n), super.destroy();
  }
  destroySecondPass() {
    this.allRowGuis.length = 0;
    const e = (t) => (t.list.forEach((n) => n.destroy()), { list: [], map: {} });
    this.centerCellCtrls = e(this.centerCellCtrls), this.leftCellCtrls = e(this.leftCellCtrls), this.rightCellCtrls = e(this.rightCellCtrls);
  }
  setFocusedClasses(e) {
    this.forEachGui(e, (t) => {
      t.rowComp.toggleCss("ag-row-focus", this.rowFocused), t.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
    });
  }
  onCellFocusChanged() {
    const { focusSvc: e } = this.beans, t = e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    t !== this.rowFocused && (this.rowFocused = t, this.setFocusedClasses());
  }
  onPaginationChanged() {
    var t;
    const e = ((t = this.beans.pagination) == null ? void 0 : t.getCurrentPage()) ?? 0;
    this.paginationPage !== e && (this.paginationPage = e, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
  }
  onTopChanged() {
    this.setRowTop(this.rowNode.rowTop);
  }
  onPaginationPixelOffsetChanged() {
    this.onTopChanged();
  }
  // applies pagination offset, eg if on second page, and page height is 500px, then removes
  // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
  // reverse will take the offset away rather than add.
  applyPaginationOffset(e, t = !1) {
    if (this.rowNode.isRowPinned() || this.rowNode.sticky)
      return e;
    const n = this.beans.pageBounds.getPixelOffset();
    return e + n * (t ? 1 : -1);
  }
  setRowTop(e) {
    if (!this.printLayout && ue(e)) {
      const t = this.applyPaginationOffset(e), s = `${this.rowNode.isRowPinned() || this.rowNode.sticky ? t : this.beans.rowContainerHeight.getRealPixelPosition(t)}px`;
      this.setRowTopStyle(s);
    }
  }
  // the top needs to be set into the DOM element when the element is created, not updated afterwards.
  // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
  // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
  // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
  // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
  // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
  // time, the row would animate down (ie from position zero).
  getInitialRowTop(e) {
    return this.suppressRowTransform ? this.getInitialRowTopShared(e) : void 0;
  }
  getInitialTransform(e) {
    return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(e)})`;
  }
  getInitialRowTopShared(e) {
    if (this.printLayout)
      return "";
    const t = this.rowNode;
    let n;
    if (t.sticky)
      n = t.stickyRowTop;
    else {
      const o = this.slideInAnimation[e] ? this.roundRowTopToBounds(t.oldRowTop) : t.rowTop, s = this.applyPaginationOffset(o);
      n = t.isRowPinned() ? s : this.beans.rowContainerHeight.getRealPixelPosition(s);
    }
    return n + "px";
  }
  setRowTopStyle(e) {
    this.allRowGuis.forEach(
      (t) => this.suppressRowTransform ? t.rowComp.setTop(e) : t.rowComp.setTransform(`translateY(${e})`)
    );
  }
  getCellCtrl(e, t = !1) {
    let n = null;
    return this.getAllCellCtrls().forEach((o) => {
      o.column == e && (n = o);
    }), n != null || t || this.getAllCellCtrls().forEach((o) => {
      (o == null ? void 0 : o.getColSpanningList().indexOf(e)) >= 0 && (n = o);
    }), n;
  }
  onRowIndexChanged() {
    this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
  }
  updateRowIndexes(e) {
    var i, r;
    const t = this.rowNode.getRowIndexString();
    if (t === null)
      return;
    const n = (((i = this.beans.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : i.getRowCount()) ?? 0) + (((r = this.beans.filterManager) == null ? void 0 : r.getHeaderRowCount()) ?? 0), o = this.rowNode.rowIndex % 2 === 0, s = n + this.rowNode.rowIndex + 1;
    this.forEachGui(e, (a) => {
      a.rowComp.setRowIndex(t), a.rowComp.toggleCss("ag-row-even", o), a.rowComp.toggleCss("ag-row-odd", !o), Ma(a.element, s);
    });
  }
}, $L = class extends U {
  constructor() {
    super(), this.beanName = "navigation", this.onPageDown = im(this.onPageDown, 100), this.onPageUp = im(this.onPageUp, 100);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  handlePageScrollingKey(e, t = !1) {
    const n = e.key, o = e.altKey, s = e.ctrlKey || e.metaKey, i = !!this.beans.rangeSvc && e.shiftKey, r = YI(this.gos, e);
    let a = !1;
    switch (n) {
      case O.PAGE_HOME:
      case O.PAGE_END:
        !s && !o && (this.onHomeOrEndKey(n), a = !0);
        break;
      case O.LEFT:
      case O.RIGHT:
      case O.UP:
      case O.DOWN:
        if (!r)
          return !1;
        s && !o && !i && (this.onCtrlUpDownLeftRight(n, r), a = !0);
        break;
      case O.PAGE_DOWN:
      case O.PAGE_UP:
        !s && !o && (a = this.handlePageUpDown(n, r, t));
        break;
    }
    return a && e.preventDefault(), a;
  }
  handlePageUpDown(e, t, n) {
    return n && (t = this.beans.focusSvc.getFocusedCell()), t ? (e === O.PAGE_UP ? this.onPageUp(t) : this.onPageDown(t), !0) : !1;
  }
  navigateTo({
    scrollIndex: e,
    scrollType: t,
    scrollColumn: n,
    focusIndex: o,
    focusColumn: s,
    isAsync: i,
    rowPinned: r
  }) {
    const { scrollFeature: a } = this.gridBodyCon;
    ue(n) && !n.isPinned() && a.ensureColumnVisible(n), ue(e) && a.ensureIndexVisible(e, t), i || a.ensureIndexVisible(o);
    const { focusSvc: l, rangeSvc: d } = this.beans;
    l.setFocusedCell({
      rowIndex: o,
      column: s,
      rowPinned: r,
      forceBrowserFocus: !0
    }), d == null || d.setRangeToCell({ rowIndex: o, rowPinned: r, column: s });
  }
  // this method is throttled, see the `constructor`
  onPageDown(e) {
    const t = this.beans, n = Pu(t), o = this.getViewportHeight(), { pageBounds: s, rowModel: i, rowAutoHeight: r } = t, a = s.getPixelOffset(), l = n.top + o, d = i.getRowIndexAtPixel(l + a);
    r != null && r.active ? this.navigateToNextPageWithAutoHeight(e, d) : this.navigateToNextPage(e, d);
  }
  // this method is throttled, see the `constructor`
  onPageUp(e) {
    const t = this.beans, n = Pu(t), { pageBounds: o, rowModel: s, rowAutoHeight: i } = t, r = o.getPixelOffset(), a = n.top, l = s.getRowIndexAtPixel(a + r);
    i != null && i.active ? this.navigateToNextPageWithAutoHeight(e, l, !0) : this.navigateToNextPage(e, l, !0);
  }
  navigateToNextPage(e, t, n = !1) {
    const { pageBounds: o, rowModel: s } = this.beans, i = this.getViewportHeight(), r = o.getFirstRow(), a = o.getLastRow(), l = o.getPixelOffset(), d = s.getRow(e.rowIndex), c = n ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      (d == null ? void 0 : d.rowHeight) - i - l
    ) : i - l, u = (d == null ? void 0 : d.rowTop) + c;
    let h = s.getRowIndexAtPixel(u + l);
    if (h === e.rowIndex) {
      const p = n ? -1 : 1;
      t = h = e.rowIndex + p;
    }
    let g;
    n ? (g = "bottom", h < r && (h = r), t < r && (t = r)) : (g = "top", h > a && (h = a), t > a && (t = a)), this.isRowTallerThanView(s.getRow(h)) && (t = h, g = "top"), this.navigateTo({
      scrollIndex: t,
      scrollType: g,
      scrollColumn: null,
      focusIndex: h,
      focusColumn: e.column
    });
  }
  navigateToNextPageWithAutoHeight(e, t, n = !1) {
    this.navigateTo({
      scrollIndex: t,
      scrollType: n ? "bottom" : "top",
      scrollColumn: null,
      focusIndex: t,
      focusColumn: e.column
    }), setTimeout(() => {
      const o = this.getNextFocusIndexForAutoHeight(e, n);
      this.navigateTo({
        scrollIndex: t,
        scrollType: n ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: o,
        focusColumn: e.column,
        isAsync: !0
      });
    }, 50);
  }
  getNextFocusIndexForAutoHeight(e, t = !1) {
    const n = t ? -1 : 1, o = this.getViewportHeight(), { pageBounds: s, rowModel: i } = this.beans, r = s.getLastRow();
    let a = 0, l = e.rowIndex;
    for (; l >= 0 && l <= r; ) {
      const d = i.getRow(l);
      if (d) {
        const c = d.rowHeight ?? 0;
        if (a + c > o)
          break;
        a += c;
      }
      l += n;
    }
    return Math.max(0, Math.min(l, r));
  }
  getViewportHeight() {
    const e = this.beans, t = Pu(e), n = this.beans.scrollVisibleSvc.getScrollbarWidth();
    let o = t.bottom - t.top;
    return e.ctrlsSvc.get("center").isHorizontalScrollShowing() && (o -= n), o;
  }
  isRowTallerThanView(e) {
    if (!e)
      return !1;
    const t = e.rowHeight;
    return typeof t != "number" ? !1 : t > this.getViewportHeight();
  }
  onCtrlUpDownLeftRight(e, t) {
    const n = this.beans.cellNavigation.getNextCellToFocus(e, t, !0), o = this.getNormalisedPosition(n), { rowIndex: s, rowPinned: i, column: r } = o ?? n, a = r;
    this.navigateTo({
      scrollIndex: s,
      scrollType: null,
      scrollColumn: a,
      focusIndex: s,
      focusColumn: a,
      rowPinned: i
    });
  }
  // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
  // same cell into view (which means either scroll all the way up, or all the way down).
  onHomeOrEndKey(e) {
    const t = e === O.PAGE_HOME, { visibleCols: n, pageBounds: o, rowModel: s } = this.beans, i = n.allCols, r = t ? o.getFirstRow() : o.getLastRow(), a = s.getRow(r);
    if (!a)
      return;
    const l = (t ? i : [...i].reverse()).find(
      (d) => !d.isSuppressNavigable(a)
    );
    l && this.navigateTo({
      scrollIndex: r,
      scrollType: null,
      scrollColumn: l,
      focusIndex: r,
      focusColumn: l
    });
  }
  // result of keyboard event
  onTabKeyDown(e, t) {
    const n = t.shiftKey, o = this.tabToNextCellCommon(e, n, t), s = this.beans, { ctrlsSvc: i, pageBounds: r, focusSvc: a, gos: l } = s;
    if (o !== !1) {
      o ? t.preventDefault() : o === null && i.get("gridCtrl").allowFocusForNextCoreContainer(n);
      return;
    }
    if (n) {
      const { rowIndex: d, rowPinned: c } = e.getRowPosition();
      (c ? d === 0 : d === r.getFirstRow()) && (l.get("headerHeight") === 0 || ci(s) ? Do(s, !0, !0) : (t.preventDefault(), a.focusPreviousFromFirstCell(t)));
    } else
      e instanceof ir && e.focusCell(!0), (!n && a.focusOverlay(!1) || Do(s, n)) && t.preventDefault();
  }
  // comes from API
  tabToNextCell(e, t) {
    const n = this.beans, { focusSvc: o, rowRenderer: s } = n, i = o.getFocusedCell();
    if (!i)
      return !1;
    let r = Ki(n, i);
    return !r && (r = s.getRowByPosition(i), !r || !r.isFullWidth()) ? !1 : !!this.tabToNextCellCommon(r, e, t, "api");
  }
  tabToNextCellCommon(e, t, n, o = "ui") {
    var l;
    const { editSvc: s, focusSvc: i } = this.beans;
    let r;
    const a = e instanceof ir ? e : (l = e.getAllCellCtrls()) == null ? void 0 : l[0];
    return s != null && s.isEditing() ? r = s == null ? void 0 : s.moveToNextCell(a, t, n, o) : r = this.moveToNextCellNotEditing(e, t, n), r === null ? r : r || !!i.focusedHeader;
  }
  // returns null if no navigation should be performed
  moveToNextCellNotEditing(e, t, n) {
    const o = this.beans.visibleCols.allCols;
    let s;
    if (e instanceof Gd) {
      if (s = {
        ...e.getRowPosition(),
        column: t ? o[0] : Je(o)
      }, this.gos.get("embedFullWidthRows") && n) {
        const r = e.findFullWidthInfoForEvent(n);
        r && (s.column = r.column);
      }
    } else
      s = e.getFocusedCellPosition();
    const i = this.findNextCellToFocusOn(s, { backwards: t, startEditing: !1 });
    if (i === !1)
      return null;
    if (i instanceof ir)
      i.focusCell(!0);
    else if (i)
      return this.tryToFocusFullWidthRow(i, t);
    return ue(i);
  }
  /**
   * called by the cell, when tab is pressed while editing.
   * @returns RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */
  findNextCellToFocusOn(e, { backwards: t, startEditing: n, skipToNextEditableCell: o }) {
    let s = e;
    const i = this.beans, { cellNavigation: r, gos: a, focusSvc: l, rowRenderer: d, rangeSvc: c } = i;
    for (; ; ) {
      e !== s && (e = s), t || (s = this.getLastCellOfColSpan(s)), s = r.getNextTabbedCell(s, t);
      const u = a.getCallback("tabToNextCell");
      if (ue(u)) {
        const f = u({
          backwards: t,
          editing: n,
          previousCellPosition: e,
          nextCellPosition: s || null
        });
        if (f === !0)
          s = e;
        else {
          if (f === !1)
            return !1;
          s = {
            rowIndex: f.rowIndex,
            column: f.column,
            rowPinned: f.rowPinned
          };
        }
      }
      if (!s)
        return null;
      if (s.rowIndex < 0) {
        const p = xo(i);
        return l.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: p + s.rowIndex,
            column: s.column
          },
          fromCell: !0
        }), null;
      }
      const h = a.get("editType") === "fullRow";
      if (n && (!h || o) && !this.isCellEditable(s))
        continue;
      this.ensureCellVisible(s);
      const g = Ki(i, s);
      if (!g) {
        const p = d.getRowByPosition(s);
        if (!p || !p.isFullWidth() || n)
          continue;
        return { ...p.getRowPosition(), column: s == null ? void 0 : s.column };
      }
      if (!r.isSuppressNavigable(g.column, g.rowNode))
        return g.setFocusedCellPosition(s), c == null || c.setRangeToCell(s), g;
    }
  }
  isCellEditable(e) {
    const t = this.lookupRowNodeForCell(e);
    return t ? e.column.isCellEditable(t) : !1;
  }
  lookupRowNodeForCell({ rowIndex: e, rowPinned: t }) {
    const { pinnedRowModel: n, rowModel: o } = this.beans;
    return t === "top" ? n == null ? void 0 : n.getPinnedTopRow(e) : t === "bottom" ? n == null ? void 0 : n.getPinnedBottomRow(e) : o.getRow(e);
  }
  // we use index for rows, but column object for columns, as the next column (by index) might not
  // be visible (header grouping) so it's not reliable, so using the column object instead.
  navigateToNextCell(e, t, n, o) {
    let s = n, i = !1;
    const r = this.beans, { cellNavigation: a, focusSvc: l, gos: d } = r;
    for (; s && (s === n || !this.isValidNavigateCell(s)); )
      d.get("enableRtl") ? t === O.LEFT && (s = this.getLastCellOfColSpan(s)) : t === O.RIGHT && (s = this.getLastCellOfColSpan(s)), s = a.getNextCellToFocus(t, s), i = st(s);
    if (i && e && e.key === O.UP && (s = {
      rowIndex: -1,
      rowPinned: null,
      column: n.column
    }), o) {
      const u = d.getCallback("navigateToNextCell");
      if (ue(u)) {
        const g = u({
          key: t,
          previousCellPosition: n,
          nextCellPosition: s || null,
          event: e
        });
        ue(g) ? s = {
          rowPinned: g.rowPinned,
          rowIndex: g.rowIndex,
          column: g.column
        } : s = null;
      }
    }
    if (!s)
      return;
    if (s.rowIndex < 0) {
      const u = xo(r);
      l.focusHeaderPosition({
        headerPosition: { headerRowIndex: u + s.rowIndex, column: n.column },
        event: e || void 0,
        fromCell: !0
      });
      return;
    }
    const c = this.getNormalisedPosition(s);
    c ? this.focusPosition(c) : this.tryToFocusFullWidthRow(s);
  }
  getNormalisedPosition(e) {
    var o;
    if (!!((o = this.beans.spannedRowRenderer) != null && o.getCellByPosition(e)))
      return e;
    this.ensureCellVisible(e);
    const n = Ki(this.beans, e);
    return n ? (e = n.getFocusedCellPosition(), this.ensureCellVisible(e), e) : null;
  }
  tryToFocusFullWidthRow(e, t) {
    const { visibleCols: n, rowRenderer: o, focusSvc: s, eventSvc: i } = this.beans, r = n.allCols, a = o.getRowByPosition(e);
    if (!a || !a.isFullWidth())
      return !1;
    const l = s.getFocusedCell(), d = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column || (t ? Je(r) : r[0])
    };
    this.focusPosition(d);
    const c = t ?? (l != null && kD(d, l));
    return i.dispatchEvent({
      type: "fullWidthRowFocused",
      rowIndex: d.rowIndex,
      rowPinned: d.rowPinned,
      column: d.column,
      isFullWidthCell: !0,
      fromBelow: c
    }), !0;
  }
  focusPosition(e) {
    const { focusSvc: t, rangeSvc: n } = this.beans;
    t.setFocusedCell({
      rowIndex: e.rowIndex,
      column: e.column,
      rowPinned: e.rowPinned,
      forceBrowserFocus: !0
    }), n == null || n.setRangeToCell(e);
  }
  isValidNavigateCell(e) {
    return !!To(this.beans, e);
  }
  getLastCellOfColSpan(e) {
    const t = Ki(this.beans, e);
    if (!t)
      return e;
    const n = t.getColSpanningList();
    return n.length === 1 ? e : {
      rowIndex: e.rowIndex,
      column: Je(n),
      rowPinned: e.rowPinned
    };
  }
  ensureCellVisible(e) {
    const t = gc(this.gos), n = this.beans.rowModel.getRow(e.rowIndex), o = t && (n == null ? void 0 : n.sticky), { scrollFeature: s } = this.gridBodyCon;
    !o && st(e.rowPinned) && s.ensureIndexVisible(e.rowIndex), e.column.isPinned() || s.ensureColumnVisible(e.column);
  }
  ensureColumnVisible(e) {
    const t = this.gridBodyCon.scrollFeature;
    e.isPinned() || t.ensureColumnVisible(e);
  }
  ensureRowVisible(e) {
    this.gridBodyCon.scrollFeature.ensureIndexVisible(e);
  }
};
function Pu(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
var zL = {
  moduleName: "KeyboardNavigation",
  version: Ee,
  beans: [$L, uL, xk],
  apiFunctions: {
    getFocusedCell: hL,
    clearFocusedCell: gL,
    setFocusedCell: pL,
    setFocusedHeader: vL,
    tabToNextCell: fL,
    tabToPreviousCell: mL
  }
}, WL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pageBoundsListener";
  }
  postConstruct() {
    this.addManagedEventListeners({
      modelUpdated: this.onModelUpdated.bind(this),
      recalculateRowBounds: this.calculatePages.bind(this)
    }), this.onModelUpdated();
  }
  onModelUpdated(e) {
    this.calculatePages(), this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: (e == null ? void 0 : e.animate) ?? !1,
      newData: (e == null ? void 0 : e.newData) ?? !1,
      newPage: (e == null ? void 0 : e.newPage) ?? !1,
      newPageSize: (e == null ? void 0 : e.newPageSize) ?? !1,
      keepRenderedRows: (e == null ? void 0 : e.keepRenderedRows) ?? !1
    });
  }
  calculatePages() {
    const { pageBounds: e, pagination: t, rowModel: n } = this.beans;
    t ? t.calculatePages() : e.calculateBounds(0, n.getRowCount() - 1);
  }
}, UL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pageBounds", this.pixelOffset = 0;
  }
  getFirstRow() {
    var e;
    return ((e = this.topRowBounds) == null ? void 0 : e.rowIndex) ?? -1;
  }
  getLastRow() {
    var e;
    return ((e = this.bottomRowBounds) == null ? void 0 : e.rowIndex) ?? -1;
  }
  getCurrentPageHeight() {
    const { topRowBounds: e, bottomRowBounds: t } = this;
    return !e || !t ? 0 : Math.max(t.rowTop + t.rowHeight - e.rowTop, 0);
  }
  getCurrentPagePixelRange() {
    const { topRowBounds: e, bottomRowBounds: t } = this, n = (e == null ? void 0 : e.rowTop) ?? 0, o = t ? t.rowTop + t.rowHeight : 0;
    return { pageFirstPixel: n, pageLastPixel: o };
  }
  calculateBounds(e, t) {
    const { rowModel: n } = this.beans, o = n.getRowBounds(e);
    o && (o.rowIndex = e), this.topRowBounds = o;
    const s = n.getRowBounds(t);
    s && (s.rowIndex = t), this.bottomRowBounds = s, this.calculatePixelOffset();
  }
  getPixelOffset() {
    return this.pixelOffset;
  }
  calculatePixelOffset() {
    var t;
    const e = ((t = this.topRowBounds) == null ? void 0 : t.rowTop) ?? 0;
    this.pixelOffset !== e && (this.pixelOffset = e, this.eventSvc.dispatchEvent({ type: "paginationPixelOffsetChanged" }));
  }
}, KL = (
  /*css*/
  ".ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}"
), ZL = class extends U {
  constructor(e, t) {
    super(), this.isLeft = e, this.elements = t, this.getWidth = e ? () => this.beans.pinnedCols.leftWidth : () => this.beans.pinnedCols.rightWidth;
  }
  postConstruct() {
    this.addManagedEventListeners({
      [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
    });
  }
  onPinnedWidthChanged() {
    const e = this.getWidth(), t = e > 0;
    for (const n of this.elements)
      n && (He(n, t), Ro(n, e));
  }
}, qL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pinnedCols";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (t) => {
      this.gridBodyCtrl = t.gridBodyCtrl;
    });
    const e = this.checkContainerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e
    }), this.addManagedPropertyListener("domLayout", e);
  }
  checkContainerWidths() {
    const { gos: e, visibleCols: t, eventSvc: n } = this.beans, o = jt(e, "print"), s = o ? 0 : t.getColsLeftWidth(), i = o ? 0 : t.getDisplayedColumnsRightWidth();
    s != this.leftWidth && (this.leftWidth = s, n.dispatchEvent({ type: "leftPinnedWidthChanged" })), i != this.rightWidth && (this.rightWidth = i, n.dispatchEvent({ type: "rightPinnedWidthChanged" }));
  }
  keepPinnedColumnsNarrowerThanViewport() {
    const e = this.gridBodyCtrl.eBodyViewport, t = mr(e);
    if (t <= 50)
      return;
    const n = this.getPinnedColumnsOverflowingViewport(t - 50), o = this.gos.getCallback("processUnpinnedColumns"), { columns: s, hasLockedPinned: i } = n;
    let r = s;
    !r.length && !i || (o && (r = o({
      columns: r,
      viewportWidth: t
    })), !(!r || !r.length) && (r = r.filter((a) => !bs(a)), this.setColsPinned(r, null, "viewportSizeFeature")));
  }
  createPinnedWidthFeature(e, ...t) {
    return new ZL(e, t);
  }
  setColsPinned(e, t, n) {
    const { colModel: o, colAnimation: s, visibleCols: i, gos: r } = this.beans;
    if (!o.cols || !(e != null && e.length))
      return;
    if (jt(r, "print")) {
      Z(37);
      return;
    }
    s == null || s.start();
    let a;
    t === !0 || t === "left" ? a = "left" : t === "right" ? a = "right" : a = null;
    const l = [];
    e.forEach((d) => {
      if (!d)
        return;
      const c = o.getCol(d);
      c && c.getPinned() !== a && (this.setColPinned(c, a), l.push(c));
    }), l.length && (i.refresh(n), jC(this.eventSvc, l, n)), s == null || s.finish();
  }
  initCol(e) {
    const { pinned: t, initialPinned: n } = e.colDef;
    t !== void 0 ? this.setColPinned(e, t) : this.setColPinned(e, n);
  }
  setColPinned(e, t) {
    t === !0 || t === "left" ? e.pinned = "left" : t === "right" ? e.pinned = "right" : e.pinned = null, e.dispatchStateUpdatedEvent("pinned");
  }
  setupHeaderPinnedWidth(e) {
    const { scrollVisibleSvc: t } = this.beans;
    if (e.pinned == null)
      return;
    const n = e.pinned === "left", o = e.pinned === "right";
    e.hidden = !0;
    const s = () => {
      const i = n ? this.leftWidth : this.rightWidth;
      if (i == null)
        return;
      const r = i == 0, a = e.hidden !== r, l = this.gos.get("enableRtl"), d = t.getScrollbarWidth(), u = t.verticalScrollShowing && (l && n || !l && o) ? i + d : i;
      e.comp.setPinnedContainerWidth(`${u}px`), e.comp.setDisplayed(!r), a && (e.hidden = r, e.refresh());
    };
    e.addManagedEventListeners({
      leftPinnedWidthChanged: s,
      rightPinnedWidthChanged: s,
      scrollVisibilityChanged: s,
      scrollbarWidthChanged: s
    });
  }
  getHeaderResizeDiff(e, t) {
    if (t.getPinned()) {
      const { leftWidth: o, rightWidth: s } = this, i = mr(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
      if (o + s + e > i)
        if (i > o + s)
          e = i - o - s;
        else
          return 0;
    }
    return e;
  }
  getPinnedColumnsOverflowingViewport(e) {
    const t = this.rightWidth ?? 0, n = this.leftWidth ?? 0, o = t + n;
    let s = !1;
    if (o < e)
      return { columns: [], hasLockedPinned: s };
    const { visibleCols: i } = this.beans, r = [...i.leftCols], a = [...i.rightCols];
    let l = 0, d = 0;
    const c = 0, u = [];
    let h = o - c - e;
    for (; (d < r.length || l < a.length) && h > 0; ) {
      if (l < a.length) {
        const g = a[l++];
        if (g.colDef.lockPinned) {
          s = !0;
          continue;
        }
        h -= g.getActualWidth(), u.push(g);
      }
      if (d < r.length && h > 0) {
        const g = r[d++];
        if (g.colDef.lockPinned) {
          s = !0;
          continue;
        }
        h -= g.getActualWidth(), u.push(g);
      }
    }
    return { columns: u, hasLockedPinned: s };
  }
}, jL = {
  moduleName: "PinnedColumn",
  version: Ee,
  beans: [qL],
  css: [KL]
}, YL = class extends U {
  constructor() {
    super(), this.beanName = "ariaAnnounce", this.descriptionContainer = null, this.pendingAnnouncements = /* @__PURE__ */ new Map(), this.lastAnnouncement = "", this.updateAnnouncement = Lt(this, this.updateAnnouncement.bind(this), 200);
  }
  postConstruct() {
    const e = this.beans, t = Bt(e), n = this.descriptionContainer = t.createElement("div");
    n.classList.add("ag-aria-description-container"), iC(n, "polite"), XA(n, "additions text"), JA(n, !0), e.eGridDiv.appendChild(n);
  }
  /**
   * @param key used for debouncing calls
   */
  announceValue(e, t) {
    this.pendingAnnouncements.set(t, e), this.updateAnnouncement();
  }
  updateAnnouncement() {
    if (!this.descriptionContainer)
      return;
    const e = Array.from(this.pendingAnnouncements.values()).join(". ");
    this.pendingAnnouncements.clear(), this.descriptionContainer.textContent = "", setTimeout(() => {
      this.handleAnnouncementUpdate(e);
    }, 50);
  }
  handleAnnouncementUpdate(e) {
    if (!this.isAlive() || !this.descriptionContainer)
      return;
    let t = e;
    if (t == null || t.replace(/[ .]/g, "") == "") {
      this.lastAnnouncement = "";
      return;
    }
    this.lastAnnouncement === t && (t = `${t}​`), this.lastAnnouncement = t, this.descriptionContainer.textContent = t;
  }
  destroy() {
    var t;
    super.destroy();
    const { descriptionContainer: e } = this;
    e && (ht(e), (t = e.parentElement) == null || t.removeChild(e)), this.descriptionContainer = null, this.pendingAnnouncements.clear();
  }
}, QL = {
  moduleName: "Aria",
  version: Ee,
  beans: [YL]
}, JL = (
  /*css*/
  ":where(.ag-delay-render){.ag-cell,.ag-header-cell,.ag-header-group-cell,.ag-row,.ag-spanned-cell-wrapper{visibility:hidden}}"
), o0 = "ag-delay-render", XL = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colDelayRenderSvc", this.hideRequested = !1, this.alreadyRevealed = !1, this.timesRetried = 0, this.requesters = /* @__PURE__ */ new Set();
  }
  hideColumns(e) {
    this.alreadyRevealed || this.requesters.has(e) || (this.requesters.add(e), this.hideRequested || (this.beans.ctrlsSvc.whenReady(this, (t) => {
      t.gridBodyCtrl.eGridBody.classList.add(o0);
    }), this.hideRequested = !0));
  }
  revealColumns(e) {
    if (this.alreadyRevealed || !this.isAlive() || (this.requesters.delete(e), this.requesters.size > 0))
      return;
    const { renderStatus: t, ctrlsSvc: n } = this.beans;
    if (t) {
      if (!t.areHeaderCellsRendered() && this.timesRetried < 5) {
        this.timesRetried++, setTimeout(() => this.revealColumns(e));
        return;
      }
      this.timesRetried = 0;
    }
    n.getGridBodyCtrl().eGridBody.classList.remove(o0), this.alreadyRevealed = !0;
  }
}, e5 = {
  moduleName: "ColumnDelayRender",
  version: Ee,
  beans: [XL],
  css: [JL]
};
function t5(e) {
  var t;
  (t = e.overlays) == null || t.showLoadingOverlay();
}
function n5(e) {
  var t;
  (t = e.overlays) == null || t.showNoRowsOverlay();
}
function o5(e) {
  var t;
  (t = e.overlays) == null || t.hideOverlay();
}
var s5 = (
  /*css*/
  ".ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}"
), i5 = {
  tag: "div",
  cls: "ag-overlay",
  role: "presentation",
  children: [
    {
      tag: "div",
      cls: "ag-overlay-panel",
      role: "presentation",
      children: [{ tag: "div", ref: "eOverlayWrapper", cls: "ag-overlay-wrapper", role: "presentation" }]
    }
  ]
}, ky = class extends Te {
  constructor() {
    super(i5), this.eOverlayWrapper = X, this.activePromise = null, this.activeOverlay = null, this.updateListenerDestroyFunc = null, this.activeCssClass = null, this.elToFocusAfter = null, this.registerCSS(s5);
  }
  handleKeyDown(e) {
    if (e.key !== O.TAB || e.defaultPrevented || Dn(e))
      return;
    const t = this.beans;
    if (sn(t, this.eOverlayWrapper, !1, e.shiftKey))
      return;
    let o = !1;
    e.shiftKey ? o = t.focusSvc.focusGridView({
      column: Je(t.visibleCols.allCols),
      backwards: !0,
      canFocusOverlay: !1
    }) : o = Do(t, !1), o && e.preventDefault();
  }
  updateLayoutClasses(e, t) {
    const n = this.eOverlayWrapper.classList, { AUTO_HEIGHT: o, NORMAL: s, PRINT: i } = Qn;
    n.toggle(o, t.autoHeight), n.toggle(s, t.normal), n.toggle(i, t.print);
  }
  postConstruct() {
    this.createManagedBean(new wp(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.beans.overlays.setOverlayWrapperComp(this), this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  setWrapperTypeClass(e) {
    const t = this.eOverlayWrapper.classList;
    this.activeCssClass && t.toggle(this.activeCssClass, !1), this.activeCssClass = e, t.toggle(e, !0);
  }
  showOverlay(e, t, n, o) {
    if (this.setWrapperTypeClass(t), this.destroyActiveOverlay(), this.elToFocusAfter = null, this.activePromise = e, !!e) {
      if (this.setDisplayed(!0, { skipAriaHidden: !0 }), n && this.isGridFocused()) {
        const s = je(this.beans);
        s && !fr(this.beans) && (this.elToFocusAfter = s);
      }
      e.then((s) => {
        if (this.activePromise !== e) {
          this.activeOverlay !== s && (this.destroyBean(s), s = null);
          return;
        }
        if (this.activePromise = null, !!s) {
          if (this.activeOverlay !== s && (this.eOverlayWrapper.appendChild(s.getGui()), this.activeOverlay = s, o)) {
            const i = s;
            this.updateListenerDestroyFunc = this.addManagedPropertyListener(o, ({ currentValue: r }) => {
              var a;
              (a = i.refresh) == null || a.call(i, ke(this.gos, { ...r ?? {} }));
            });
          }
          n && this.isGridFocused() && pn(this.eOverlayWrapper);
        }
      });
    }
  }
  updateOverlayWrapperPaddingTop(e) {
    this.eOverlayWrapper.style.setProperty("padding-top", `${e}px`);
  }
  destroyActiveOverlay() {
    var o;
    this.activePromise = null;
    const e = this.activeOverlay;
    if (!e)
      return;
    let t = this.elToFocusAfter;
    this.activeOverlay = null, this.elToFocusAfter = null, t && !this.isGridFocused() && (t = null);
    const n = this.updateListenerDestroyFunc;
    n && (n(), this.updateListenerDestroyFunc = null), this.destroyBean(e), ht(this.eOverlayWrapper), (o = t == null ? void 0 : t.focus) == null || o.call(t, { preventScroll: !0 });
  }
  hideOverlay() {
    this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
  }
  isGridFocused() {
    const e = je(this.beans);
    return !!e && this.beans.eGridDiv.contains(e);
  }
  destroy() {
    this.elToFocusAfter = null, this.destroyActiveOverlay(), this.beans.overlays.setOverlayWrapperComp(void 0), super.destroy();
  }
}, r5 = {
  selector: "AG-OVERLAY-WRAPPER",
  component: ky
}, a5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "overlays", this.state = 0, this.showInitialOverlay = !0, this.wrapperPadding = 0;
  }
  postConstruct() {
    this.isClientSide = Ct(this.gos), this.isServerSide = !this.isClientSide && gn(this.gos);
    const e = () => this.updateOverlayVisibility();
    this.addManagedEventListeners({
      newColumnsLoaded: e,
      rowDataUpdated: e,
      gridSizeChanged: this.refreshWrapperPadding.bind(this),
      rowCountReady: () => {
        this.showInitialOverlay = !1, this.updateOverlayVisibility();
      }
    }), this.addManagedPropertyListener("loading", e);
  }
  setOverlayWrapperComp(e) {
    this.eWrapper = e, this.updateOverlayVisibility();
  }
  /** Returns true if the overlay is visible. */
  isVisible() {
    return this.state !== 0 && !!this.eWrapper;
  }
  /** Returns true if the overlay is visible and is exclusive (popup over the grid) */
  isExclusive() {
    return this.state === 1 && !!this.eWrapper;
  }
  showLoadingOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos, t = e.get("loading");
    !t && (t !== void 0 || e.get("suppressLoadingOverlay")) || this.doShowLoadingOverlay();
  }
  showNoRowsOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos;
    e.get("loading") || e.get("suppressNoRowsOverlay") || this.doShowNoRowsOverlay();
  }
  hideOverlay() {
    if (this.showInitialOverlay = !1, this.gos.get("loading")) {
      Z(99);
      return;
    }
    this.doHideOverlay();
  }
  getOverlayWrapperSelector() {
    return r5;
  }
  getOverlayWrapperCompClass() {
    return ky;
  }
  updateOverlayVisibility() {
    if (!this.eWrapper) {
      this.state = 0;
      return;
    }
    const {
      state: e,
      isClientSide: t,
      isServerSide: n,
      beans: { gos: o, colModel: s, rowModel: i }
    } = this;
    let r = this.gos.get("loading");
    r !== void 0 && (this.showInitialOverlay = !1), this.showInitialOverlay && r === void 0 && !o.get("suppressLoadingOverlay") && (r = !o.get("columnDefs") || !s.ready || !o.get("rowData") && t), r ? e !== 1 && this.doShowLoadingOverlay() : (this.showInitialOverlay = !1, t && i.isEmpty() && !o.get("suppressNoRowsOverlay") ? e !== 2 && this.doShowNoRowsOverlay() : (e === 1 || !n && e !== 0) && this.doHideOverlay());
  }
  doShowLoadingOverlay() {
    this.eWrapper && (this.state = 1, this.showOverlay(
      $F(this.beans.userCompFactory, ke(this.gos, {})),
      "ag-overlay-loading-wrapper",
      "loadingOverlayComponentParams"
    ), this.updateExclusive());
  }
  doShowNoRowsOverlay() {
    this.eWrapper && (this.state = 2, this.showOverlay(
      zF(this.beans.userCompFactory, ke(this.gos, {})),
      "ag-overlay-no-rows-wrapper",
      "noRowsOverlayComponentParams"
    ), this.updateExclusive());
  }
  doHideOverlay() {
    this.eWrapper && (this.state = 0, this.eWrapper.hideOverlay(), this.updateExclusive());
  }
  showOverlay(e, t, n) {
    var s;
    const o = (e == null ? void 0 : e.newAgStackInstance()) ?? null;
    (s = this.eWrapper) == null || s.showOverlay(o, t, this.isExclusive(), n), this.refreshWrapperPadding();
  }
  updateExclusive() {
    const e = this.exclusive;
    this.exclusive = this.isExclusive(), this.exclusive !== e && this.eventSvc.dispatchEvent({
      type: "overlayExclusiveChanged"
    });
  }
  refreshWrapperPadding() {
    const e = this.eWrapper;
    if (!e)
      return;
    let t = 0;
    if (this.state === 2) {
      const n = this.beans.ctrlsSvc.get("gridHeaderCtrl");
      t = (n == null ? void 0 : n.headerHeight) || 0;
    } else this.wrapperPadding !== 0 && (t = 0);
    this.wrapperPadding !== t && (this.wrapperPadding = t, e.updateOverlayWrapperPaddingTop(t));
  }
}, l5 = {
  moduleName: "Overlay",
  version: Ee,
  userComponents: {
    agLoadingOverlay: RP,
    agNoRowsOverlay: AP
  },
  apiFunctions: {
    showLoadingOverlay: t5,
    showNoRowsOverlay: n5,
    hideOverlay: o5
  },
  beans: [a5]
}, d5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowContainerHeight", this.scrollY = 0, this.uiBodyHeight = 0;
  }
  postConstruct() {
    this.addManagedEventListeners({ bodyHeightChanged: this.updateOffset.bind(this) }), this.maxDivHeight = ZF(), Is(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
  }
  updateOffset() {
    if (!this.stretching)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top, t = this.getUiBodyHeight();
    (e !== this.scrollY || t !== this.uiBodyHeight) && (this.scrollY = e, this.uiBodyHeight = t, this.calculateOffset());
  }
  calculateOffset() {
    this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    const e = this.scrollY / this.maxScrollY, t = e * this.pixelsToShave;
    Is(
      this.gos,
      `RowContainerHeightService - Div Stretch Offset = ${t} (${this.pixelsToShave} * ${e})`
    ), this.setDivStretchOffset(t);
  }
  setUiContainerHeight(e) {
    e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventSvc.dispatchEvent({ type: "rowContainerHeightChanged" }));
  }
  clearOffset() {
    this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
  }
  setDivStretchOffset(e) {
    const t = typeof e == "number" ? Math.floor(e) : null;
    this.divStretchOffset !== t && (this.divStretchOffset = t, this.eventSvc.dispatchEvent({ type: "heightScaleChanged" }));
  }
  setModelHeight(e) {
    this.modelHeight = e, this.stretching = e != null && // null happens when in print layout
    this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
  }
  getRealPixelPosition(e) {
    return e - this.divStretchOffset;
  }
  getUiBodyHeight() {
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
    return e.bottom - e.top;
  }
  getScrollPositionForPixel(e) {
    if (this.pixelsToShave <= 0)
      return e;
    const t = this.modelHeight - this.getUiBodyHeight(), n = e / t;
    return this.maxScrollY * n;
  }
}, c5 = 400, u5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowRenderer", this.destroyFuncsForColumnListeners = [], this.rowCtrlsByRowIndex = {}, this.zombieRowCtrls = {}, this.allRowCtrls = [], this.topRowCtrls = [], this.bottomRowCtrls = [], this.refreshInProgress = !1, this.dataFirstRenderedFired = !1, this.setupRangeSelectionListeners = () => {
      const e = () => {
        this.getAllCellCtrls().forEach((i) => i.onCellSelectionChanged());
      }, t = () => {
        this.getAllCellCtrls().forEach((i) => i.updateRangeBordersIfRangeCount());
      }, n = () => {
        this.eventSvc.addListener("cellSelectionChanged", e), this.eventSvc.addListener("columnMoved", t), this.eventSvc.addListener("columnPinned", t), this.eventSvc.addListener("columnVisible", t);
      }, o = () => {
        this.eventSvc.removeListener("cellSelectionChanged", e), this.eventSvc.removeListener("columnMoved", t), this.eventSvc.removeListener("columnPinned", t), this.eventSvc.removeListener("columnVisible", t);
      };
      this.addDestroyFunc(() => o()), this.addManagedPropertyListeners(["enableRangeSelection", "cellSelection"], () => {
        Xo(this.gos) ? n() : o();
      }), Xo(this.gos) && n();
    };
  }
  wireBeans(e) {
    this.pageBounds = e.pageBounds, this.colModel = e.colModel, this.pinnedRowModel = e.pinnedRowModel, this.rowModel = e.rowModel, this.focusSvc = e.focusSvc, this.rowContainerHeight = e.rowContainerHeight, this.ctrlsSvc = e.ctrlsSvc, this.editSvc = e.editSvc;
  }
  postConstruct() {
    this.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.initialise();
    });
  }
  initialise() {
    this.addManagedEventListeners({
      paginationChanged: this.onPageLoaded.bind(this),
      pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
      pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      bodyScroll: this.onBodyScroll.bind(this),
      bodyHeightChanged: this.redraw.bind(this, {})
    }), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], () => this.onDomLayoutChanged()), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], () => this.redraw()), this.addManagedPropertyListener("suppressCellFocus", (o) => this.onSuppressCellFocusChanged(o.currentValue)), this.addManagedPropertyListeners(
      [
        "groupSuppressBlankHeader",
        "getBusinessKeyForNode",
        "fullWidthCellRenderer",
        "fullWidthCellRendererParams",
        "suppressStickyTotalRow",
        "groupRowRenderer",
        "groupRowRendererParams",
        // maybe only needs to refresh FW rows...
        "loadingCellRenderer",
        "loadingCellRendererParams",
        "detailCellRenderer",
        "detailCellRendererParams",
        "enableRangeSelection",
        "enableCellTextSelection"
      ],
      () => this.redrawRows()
    ), this.addManagedPropertyListener("cellSelection", ({ currentValue: o, previousValue: s }) => {
      (!s && o || s && !o) && this.redrawRows();
    });
    const { stickyRowSvc: e, gos: t, showRowGroupCols: n } = this.beans;
    if (n && this.addManagedPropertyListener("showOpenedGroup", () => {
      const o = n.getShowRowGroupCols();
      o.length && this.refreshCells({ columns: o, force: !0 });
    }), e)
      this.stickyRowFeature = e.createStickyRowFeature(
        this,
        this.createRowCon.bind(this),
        this.destroyRowCtrls.bind(this)
      );
    else {
      const o = this.gridBodyCtrl;
      o.setStickyTopHeight(0), o.setStickyBottomHeight(0);
    }
    this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = jt(t, "print"), this.embedFullWidthRows = this.printLayout || t.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
  }
  initialiseCache() {
    if (this.gos.get("keepDetailRows")) {
      const e = this.getKeepDetailRowsCount(), t = e ?? 3;
      this.cachedRowCtrls = new h5(t);
    }
  }
  getKeepDetailRowsCount() {
    return this.gos.get("keepDetailRowsCount");
  }
  getStickyTopRowCtrls() {
    var e;
    return ((e = this.stickyRowFeature) == null ? void 0 : e.stickyTopRowCtrls) ?? [];
  }
  getStickyBottomRowCtrls() {
    var e;
    return ((e = this.stickyRowFeature) == null ? void 0 : e.stickyBottomRowCtrls) ?? [];
  }
  updateAllRowCtrls() {
    var o;
    const e = Object.values(this.rowCtrlsByRowIndex), t = Object.values(this.zombieRowCtrls), n = ((o = this.cachedRowCtrls) == null ? void 0 : o.getEntries()) ?? [];
    t.length > 0 || n.length > 0 ? this.allRowCtrls = [...e, ...t, ...n] : this.allRowCtrls = e;
  }
  /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */
  isCellBeingRendered(e, t) {
    var s;
    const n = this.rowCtrlsByRowIndex[e];
    return !t || !n ? !!n : n.isFullWidth() ? !0 : !!((s = this.beans.spannedRowRenderer) == null ? void 0 : s.getCellByPosition({ rowIndex: e, column: t, rowPinned: null })) || !!n.getCellCtrl(t) || !n.isRowRendered();
  }
  /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */
  updateCellFocus(e) {
    this.getAllCellCtrls().forEach((t) => t.onCellFocused(e)), this.getFullWidthRowCtrls().forEach((t) => t.onFullWidthRowFocused(e));
  }
  /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */
  onCellFocusChanged(e) {
    if (e && e.rowIndex != null && !e.rowPinned) {
      const t = this.beans.colModel.getCol(e.column) ?? void 0;
      this.isCellBeingRendered(e.rowIndex, t) || this.redraw();
    }
    this.updateCellFocus(e);
  }
  onSuppressCellFocusChanged(e) {
    this.getAllCellCtrls().forEach((t) => t.onSuppressCellFocusChanged(e)), this.getFullWidthRowCtrls().forEach((t) => t.onSuppressCellFocusChanged(e));
  }
  // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
  // registering and de-registering for events is a performance bottleneck. so we register here once and inform
  // all active cells.
  registerCellEventListeners() {
    this.addManagedEventListeners({
      cellFocused: (e) => this.onCellFocusChanged(e),
      cellFocusCleared: () => this.updateCellFocus(),
      flashCells: (e) => {
        const { cellFlashSvc: t } = this.beans;
        t && this.getAllCellCtrls().forEach((n) => t.onFlashCells(n, e));
      },
      columnHoverChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onColumnHover());
      },
      displayedColumnsChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onDisplayedColumnsChanged());
      },
      displayedColumnsWidthChanged: () => {
        this.printLayout && this.getAllCellCtrls().forEach((e) => e.onLeftChanged());
      }
    }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedEventListeners({
      gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
    }), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  }
  // executes all functions in destroyFuncsForColumnListeners and then clears the list
  removeGridColumnListeners() {
    this.destroyFuncsForColumnListeners.forEach((e) => e()), this.destroyFuncsForColumnListeners.length = 0;
  }
  // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
  // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
  // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
  // once instead.
  refreshListenersToColumnsForCellComps() {
    this.removeGridColumnListeners(), this.colModel.getCols().forEach((t) => {
      const n = (l) => {
        this.getAllCellCtrls().forEach((d) => {
          d.column === t && l(d);
        });
      }, o = () => {
        n((l) => l.onLeftChanged());
      }, s = () => {
        n((l) => l.onWidthChanged());
      }, i = () => {
        n((l) => l.onFirstRightPinnedChanged());
      }, r = () => {
        n((l) => l.onLastLeftPinnedChanged());
      }, a = () => {
        n((l) => l.onColDefChanged());
      };
      t.__addEventListener("leftChanged", o), t.__addEventListener("widthChanged", s), t.__addEventListener("firstRightPinnedChanged", i), t.__addEventListener("lastLeftPinnedChanged", r), t.__addEventListener("colDefChanged", a), this.destroyFuncsForColumnListeners.push(() => {
        t.__removeEventListener("leftChanged", o), t.__removeEventListener("widthChanged", s), t.__removeEventListener("firstRightPinnedChanged", i), t.__removeEventListener("lastLeftPinnedChanged", r), t.__removeEventListener("colDefChanged", a);
      });
    });
  }
  onDomLayoutChanged() {
    const e = jt(this.gos, "print"), t = e || this.gos.get("embedFullWidthRows"), n = t !== this.embedFullWidthRows || this.printLayout !== e;
    this.printLayout = e, this.embedFullWidthRows = t, n && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
  }
  // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
  // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
  datasourceChanged() {
    this.firstRenderedRow = 0, this.lastRenderedRow = -1;
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e);
  }
  onPageLoaded(e) {
    const t = {
      recycleRows: e.keepRenderedRows,
      animate: e.animate,
      newData: e.newData,
      newPage: e.newPage,
      // because this is a model updated event (not pinned rows), we
      // can skip updating the pinned rows. this is needed so that if user
      // is doing transaction updates, the pinned rows are not getting constantly
      // trashed - or editing cells in pinned rows are not refreshed and put into read mode
      onlyBody: !0
    };
    this.redrawAfterModelUpdate(t);
  }
  /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */
  getAllCellsNotSpanningForColumn(e) {
    const t = [];
    return this.getAllRowCtrls().forEach((n) => {
      var s;
      const o = (s = n.getCellCtrl(e, !0)) == null ? void 0 : s.eGui;
      o && t.push(o);
    }), t;
  }
  refreshFloatingRowComps(e = !0) {
    this.refreshFloatingRows(this.topRowCtrls, "top", e), this.refreshFloatingRows(this.bottomRowCtrls, "bottom", e);
  }
  /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */
  refreshFloatingRows(e, t, n) {
    const { pinnedRowModel: o, beans: s, printLayout: i } = this, r = Object.fromEntries(e.map((l) => [l.rowNode.id, l]));
    o == null || o.forEachPinnedRow(t, (l, d) => {
      const c = e[d];
      c && o.getPinnedRowById(c.rowNode.id, t) === void 0 && (c.destroyFirstPass(), c.destroySecondPass()), l.id in r && n ? (e[d] = r[l.id], delete r[l.id]) : e[d] = new Gd(l, s, !1, !1, i);
    });
    const a = (t === "top" ? o == null ? void 0 : o.getPinnedTopRowCount() : o == null ? void 0 : o.getPinnedBottomRowCount()) ?? 0;
    e.length = a;
  }
  onPinnedRowDataChanged() {
    const e = {
      recycleRows: !0
    };
    this.redrawAfterModelUpdate(e);
  }
  onPinnedRowsChanged() {
    this.redrawAfterModelUpdate({ recycleRows: !0 });
  }
  redrawRow(e, t = !1) {
    var n, o;
    if (e.sticky)
      (n = this.stickyRowFeature) == null || n.refreshStickyNode(e);
    else if ((o = this.cachedRowCtrls) != null && o.has(e)) {
      this.cachedRowCtrls.removeRow(e);
      return;
    } else {
      const s = (i) => {
        const r = i[e.rowIndex];
        r && r.rowNode === e && (r.destroyFirstPass(), r.destroySecondPass(), i[e.rowIndex] = this.createRowCon(e, !1, !1));
      };
      switch (e.rowPinned) {
        case "top":
          s(this.topRowCtrls);
          break;
        case "bottom":
          s(this.bottomRowCtrls);
          break;
        default:
          s(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
      }
    }
    t || this.dispatchDisplayedRowsChanged(!1);
  }
  redrawRows(e) {
    const { editSvc: t } = this.beans;
    if (t != null && t.isEditing() && (t.isBatchEditing() ? t.cleanupEditors() : t.stopEditing(void 0, { source: "api" })), e != null) {
      e == null || e.forEach((o) => this.redrawRow(o, !0)), this.dispatchDisplayedRowsChanged(!1);
      return;
    }
    this.redrawAfterModelUpdate();
  }
  // gets called from:
  // +) initialisation (in registerGridComp) params = null
  // +) onDomLayoutChanged, params = null
  // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
  // +) onPinnedRowDataChanged, recycleRows = true
  // +) redrawRows (from Grid API), recycleRows = true/false
  redrawAfterModelUpdate(e = {}) {
    var a;
    this.getLockOnRefresh();
    const t = (a = this.beans.focusSvc) == null ? void 0 : a.getFocusCellToUseAfterRefresh();
    this.updateContainerHeights(), this.scrollToTopIfNewData(e);
    const n = !e.domLayoutChanged && !!e.recycleRows, o = e.animate && Xi(this.gos), s = n ? this.getRowsToRecycle() : null;
    n || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender();
    const { stickyRowFeature: i, gos: r } = this;
    if (i) {
      i.checkStickyRows();
      const l = i.extraTopHeight + i.extraBottomHeight;
      l && this.updateContainerHeights(l);
    }
    this.recycleRows(s, o), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(r.get("enableRowPinning") ? n : void 0), this.dispatchDisplayedRowsChanged(), t != null && this.restoreFocusedCell(t), this.releaseLockOnRefresh();
  }
  scrollToTopIfNewData(e) {
    var o;
    const t = e.newData || e.newPage, n = this.gos.get("suppressScrollOnNewData");
    t && !n && (this.gridBodyCtrl.scrollFeature.scrollToTop(), (o = this.stickyRowFeature) == null || o.resetOffsets());
  }
  updateContainerHeights(e = 0) {
    const { rowContainerHeight: t } = this;
    if (this.printLayout) {
      t.setModelHeight(null);
      return;
    }
    let n = this.pageBounds.getCurrentPageHeight();
    n === 0 && (n = 1), t.setModelHeight(n + e);
  }
  getLockOnRefresh() {
    var e, t;
    if (this.refreshInProgress)
      throw new Error(Eo(252));
    this.refreshInProgress = !0, (t = (e = this.beans.frameworkOverrides).getLockOnRefresh) == null || t.call(e);
  }
  releaseLockOnRefresh() {
    var e, t;
    this.refreshInProgress = !1, (t = (e = this.beans.frameworkOverrides).releaseLockOnRefresh) == null || t.call(e);
  }
  isRefreshInProgress() {
    return this.refreshInProgress;
  }
  // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
  // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
  // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
  // edited cell).
  restoreFocusedCell(e) {
    if (!e)
      return;
    const t = this.beans.focusSvc, n = this.findPositionToFocus(e);
    if (!n) {
      t.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: xo(this.beans) - 1,
          column: e.column
        }
      });
      return;
    }
    if (e.rowIndex !== n.rowIndex || e.rowPinned != n.rowPinned) {
      t.setFocusedCell({
        ...n,
        preventScrollOnBrowserFocus: !0,
        forceBrowserFocus: !0
      });
      return;
    }
    t.doesRowOrCellHaveBrowserFocus() || this.updateCellFocus(
      ke(this.gos, {
        ...n,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !0,
        type: "cellFocused"
      })
    );
  }
  findPositionToFocus(e) {
    const { pagination: t, pageBounds: n } = this.beans;
    let o = e;
    for (o.rowPinned == null && t && n && !t.isRowInPage(o.rowIndex) && (o = { rowPinned: null, rowIndex: n.getFirstRow() }); o; ) {
      if (o.rowPinned == null && n)
        if (o.rowIndex < n.getFirstRow()) {
          if (o = Ld(this.beans, { rowPinned: null, rowIndex: 0 }), !o)
            return null;
        } else o.rowIndex > n.getLastRow() && (o = { rowPinned: null, rowIndex: n.getLastRow() });
      const s = this.getRowByPosition(o);
      if (s != null && s.isAlive())
        return { ...s.getRowPosition(), column: e.column };
      o = Ld(this.beans, o);
    }
    return null;
  }
  getAllCellCtrls() {
    const e = [], t = this.getAllRowCtrls(), n = t.length;
    for (let o = 0; o < n; o++) {
      const s = t[o].getAllCellCtrls(), i = s.length;
      for (let r = 0; r < i; r++)
        e.push(s[r]);
    }
    return e;
  }
  getAllRowCtrls() {
    const { spannedRowRenderer: e } = this.beans, t = this.getStickyTopRowCtrls(), n = this.getStickyBottomRowCtrls();
    return [
      ...this.topRowCtrls,
      ...this.bottomRowCtrls,
      ...t,
      ...n,
      ...(e == null ? void 0 : e.getCtrls("top")) ?? [],
      ...(e == null ? void 0 : e.getCtrls("bottom")) ?? [],
      ...(e == null ? void 0 : e.getCtrls("center")) ?? [],
      ...Object.values(this.rowCtrlsByRowIndex)
    ];
  }
  addRenderedRowListener(e, t, n) {
    const o = this.rowCtrlsByRowIndex[t];
    o && o.addEventListener(e, n);
  }
  refreshCells({ rowNodes: e, columns: t, force: n, suppressFlash: o } = {}) {
    const s = {
      force: n,
      newData: !1,
      suppressFlash: o
    };
    for (const i of this.getCellCtrls(e, t))
      i.refreshOrDestroyCell(s);
    this.refreshFullWidth(e);
  }
  refreshRows(e = {}) {
    this.getRowCtrls(e.rowNodes).forEach((t) => t.refreshRow(e)), this.refreshFullWidth(e.rowNodes);
  }
  refreshFullWidth(e) {
    if (!e)
      return;
    let t = !1;
    for (const n of this.getRowCtrls(e)) {
      if (!n.isFullWidth())
        continue;
      n.refreshFullWidth() || (t = !0, this.redrawRow(n.rowNode, !0));
    }
    t && this.dispatchDisplayedRowsChanged(!1);
  }
  /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */
  getRowCtrls(e) {
    const t = Nh(e), n = this.getAllRowCtrls();
    return !e || !t ? n : n.filter((o) => {
      const s = o.rowNode;
      return $h(s, t);
    });
  }
  // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
  // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
  getCellCtrls(e, t) {
    let n;
    ue(t) && (n = {}, t.forEach((s) => {
      const i = this.colModel.getCol(s);
      ue(i) && (n[i.getId()] = !0);
    }));
    const o = [];
    return this.getRowCtrls(e).forEach((s) => {
      s.getAllCellCtrls().forEach((i) => {
        const r = i.column.getId();
        n && !n[r] || o.push(i);
      });
    }), o;
  }
  destroy() {
    this.removeAllRowComps(!0), super.destroy();
  }
  removeAllRowComps(e = !1) {
    var n;
    const t = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(t, e), (n = this.stickyRowFeature) == null || n.destroyStickyCtrls();
  }
  getRowsToRecycle() {
    const e = [];
    for (const n of Object.keys(this.rowCtrlsByRowIndex))
      this.rowCtrlsByRowIndex[n].rowNode.id == null && e.push(n);
    this.removeRowCtrls(e);
    const t = {};
    for (const n of Object.values(this.rowCtrlsByRowIndex)) {
      const o = n.rowNode;
      t[o.id] = n;
    }
    return this.rowCtrlsByRowIndex = {}, t;
  }
  // takes array of row indexes
  removeRowCtrls(e, t = !1) {
    e.forEach((n) => {
      const o = this.rowCtrlsByRowIndex[n];
      o && (o.destroyFirstPass(t), o.destroySecondPass()), delete this.rowCtrlsByRowIndex[n];
    });
  }
  onBodyScroll(e) {
    e.direction === "vertical" && this.redraw({ afterScroll: !0 });
  }
  // gets called when rows don't change, but viewport does, so after:
  // 1) height of grid body changes, ie number of displayed rows has changed
  // 2) grid scrolled to new position
  // 3) ensure index visible (which is a scroll)
  redraw(e = {}) {
    const { focusSvc: t, animationFrameSvc: n } = this.beans, { afterScroll: o } = e;
    let s;
    const i = this.stickyRowFeature;
    i && (s = (t == null ? void 0 : t.getFocusCellToUseAfterRefresh()) || void 0);
    const r = this.firstRenderedRow, a = this.lastRenderedRow;
    this.workOutFirstAndLastRowsToRender();
    let l = !1;
    if (i) {
      l = i.checkStickyRows();
      const c = i.extraTopHeight + i.extraBottomHeight;
      c && this.updateContainerHeights(c);
    }
    const d = this.firstRenderedRow !== r || this.lastRenderedRow !== a;
    if (!(o && !l && !d) && (this.getLockOnRefresh(), this.recycleRows(null, !1, o), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(o && !l), s != null)) {
      const c = t == null ? void 0 : t.getFocusCellToUseAfterRefresh();
      s != null && c == null && (n == null || n.flushAllFrames(), this.restoreFocusedCell(s));
    }
  }
  removeRowCompsNotToDraw(e, t) {
    const n = {};
    e.forEach((i) => n[i] = !0);
    const s = Object.keys(this.rowCtrlsByRowIndex).filter((i) => !n[i]);
    this.removeRowCtrls(s, t);
  }
  calculateIndexesToDraw(e) {
    var r, a;
    const t = [];
    for (let l = this.firstRenderedRow; l <= this.lastRenderedRow; l++)
      t.push(l);
    const n = this.beans.pagination, o = (a = (r = this.beans.focusSvc) == null ? void 0 : r.getFocusedCell()) == null ? void 0 : a.rowIndex;
    o != null && (o < this.firstRenderedRow || o > this.lastRenderedRow) && (!n || n.isRowInPage(o)) && o < this.rowModel.getRowCount() && t.push(o);
    const s = (l) => {
      const d = l.rowNode.rowIndex;
      d == null || d === o || (d < this.firstRenderedRow || d > this.lastRenderedRow) && this.doNotUnVirtualiseRow(l) && t.push(d);
    };
    for (const l of Object.values(this.rowCtrlsByRowIndex))
      s(l);
    if (e)
      for (const l of Object.values(e))
        s(l);
    t.sort((l, d) => l - d);
    const i = [];
    for (let l = 0; l < t.length; l++) {
      const d = t[l], c = this.rowModel.getRow(d);
      c && !c.sticky && i.push(d);
    }
    return i;
  }
  recycleRows(e, t = !1, n = !1) {
    const o = this.calculateIndexesToDraw(e);
    if ((this.printLayout || n) && (t = !1), this.removeRowCompsNotToDraw(o, !t), o.forEach((s) => {
      this.createOrUpdateRowCtrl(s, e, t, n);
    }), e) {
      const { animationFrameSvc: s } = this.beans;
      (s == null ? void 0 : s.active) && n && !this.printLayout ? s.addDestroyTask(() => {
        this.destroyRowCtrls(e, t), this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
      }) : this.destroyRowCtrls(e, t);
    }
    this.updateAllRowCtrls();
  }
  dispatchDisplayedRowsChanged(e = !1) {
    this.eventSvc.dispatchEvent({
      type: "displayedRowsChanged",
      afterScroll: e
    });
  }
  onDisplayedColumnsChanged() {
    const { visibleCols: e } = this.beans, t = e.isPinningLeft(), n = e.isPinningRight();
    (this.pinningLeft !== t || n !== this.pinningRight) && (this.pinningLeft = t, this.pinningRight = n, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
  }
  // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
  // then it should go into the pinned left area if pinning left, or the center area if not pinning.
  redrawFullWidthEmbeddedRows() {
    const e = [];
    this.getFullWidthRowCtrls().forEach((t) => {
      const n = t.rowNode.rowIndex;
      e.push(n.toString());
    }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
  }
  getFullWidthRowCtrls(e) {
    const t = Nh(e);
    return this.getAllRowCtrls().filter((n) => {
      if (!n.isFullWidth())
        return !1;
      const o = n.rowNode;
      return !(t != null && !$h(o, t));
    });
  }
  createOrUpdateRowCtrl(e, t, n, o) {
    let s, i = this.rowCtrlsByRowIndex[e];
    if (i || (s = this.rowModel.getRow(e), ue(s) && ue(t) && t[s.id] && s.alreadyRendered && (i = t[s.id], t[s.id] = null)), !i)
      if (s || (s = this.rowModel.getRow(e)), ue(s))
        i = this.createRowCon(s, n, o);
      else
        return;
    return s && (s.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = i, i;
  }
  destroyRowCtrls(e, t) {
    const n = [];
    if (e) {
      for (const o of Object.values(e))
        if (o) {
          if (this.cachedRowCtrls && o.isCacheable()) {
            this.cachedRowCtrls.addRow(o);
            continue;
          }
          if (o.destroyFirstPass(!t), t) {
            const s = o.instanceId;
            this.zombieRowCtrls[s] = o, n.push(() => {
              o.destroySecondPass(), delete this.zombieRowCtrls[s];
            });
          } else
            o.destroySecondPass();
        }
    }
    t && (n.push(() => {
      this.isAlive() && (this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged());
    }), window.setTimeout(() => n.forEach((o) => o()), c5));
  }
  getRowBuffer() {
    return this.gos.get("rowBuffer");
  }
  getRowBufferInPixels() {
    const e = this.getRowBuffer(), t = Kn(this.beans);
    return e * t;
  }
  workOutFirstAndLastRowsToRender() {
    const { rowContainerHeight: e, pageBounds: t, rowModel: n } = this;
    e.updateOffset();
    let o, s;
    if (!n.isRowsToRender())
      o = 0, s = -1;
    else if (this.printLayout)
      this.beans.environment.refreshRowHeightVariable(), o = t.getFirstRow(), s = t.getLastRow();
    else {
      const c = this.getRowBufferInPixels(), u = this.ctrlsSvc.getScrollFeature(), h = this.gos.get("suppressRowVirtualisation");
      let g = !1, p, f;
      do {
        const A = t.getPixelOffset(), { pageFirstPixel: S, pageLastPixel: F } = t.getCurrentPagePixelRange(), E = e.divStretchOffset, M = u.getVScrollPosition(), I = M.top, P = M.bottom;
        h ? (p = S + E, f = F + E) : (p = Math.max(I + A - c, S) + E, f = Math.min(P + A + c, F) + E), this.firstVisibleVPixel = Math.max(I + A, S) + E, this.lastVisibleVPixel = Math.min(P + A, F) + E, g = this.ensureAllRowsInRangeHaveHeightsCalculated(p, f);
      } while (g);
      let m = n.getRowIndexAtPixel(p), C = n.getRowIndexAtPixel(f);
      const w = t.getFirstRow(), b = t.getLastRow();
      m < w && (m = w), C > b && (C = b), o = m, s = C;
    }
    const i = jt(this.gos, "normal"), r = this.gos.get("suppressMaxRenderedRowRestriction"), a = Math.max(this.getRowBuffer(), 500);
    i && !r && s - o > a && (s = o + a);
    const l = o !== this.firstRenderedRow, d = s !== this.lastRenderedRow;
    (l || d) && (this.firstRenderedRow = o, this.lastRenderedRow = s, this.eventSvc.dispatchEvent({
      type: "viewportChanged",
      firstRow: o,
      lastRow: s
    }));
  }
  /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */
  dispatchFirstDataRenderedEvent() {
    this.dataFirstRenderedFired || (this.dataFirstRenderedFired = !0, kn(this.beans, () => {
      this.beans.eventSvc.dispatchEvent({
        type: "firstDataRendered",
        firstRow: this.firstRenderedRow,
        lastRow: this.lastRenderedRow
      });
    }));
  }
  ensureAllRowsInRangeHaveHeightsCalculated(e, t) {
    var a, l;
    const n = (a = this.pinnedRowModel) == null ? void 0 : a.ensureRowHeightsValid(), o = (l = this.stickyRowFeature) == null ? void 0 : l.ensureRowHeightsValid(), { pageBounds: s, rowModel: i } = this, r = i.ensureRowHeightsValid(
      e,
      t,
      s.getFirstRow(),
      s.getLastRow()
    );
    return (r || o) && this.eventSvc.dispatchEvent({
      type: "recalculateRowBounds"
    }), o || r || n ? (this.updateContainerHeights(), !0) : !1;
  }
  // check that none of the rows to remove are editing or focused as:
  // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
  //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
  //    the edit is reset - so we want to keep it rendered.
  // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
  //    otherwise the user can range select and drag (with focus cell going out of the viewport)
  //    and then ctrl+c, nothing will happen if cell is removed from dom.
  // c) if detail record of master detail, as users complained that the context of detail rows
  //    was getting lost when detail row out of view. eg user expands to show detail row,
  //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
  //    after detail panel is scrolled out of / into view.
  doNotUnVirtualiseRow(e) {
    var d;
    const o = e.rowNode, s = this.focusSvc.isRowFocused(o.rowIndex, o.rowPinned), i = (d = this.editSvc) == null ? void 0 : d.isEditing(e), r = o.detail;
    return s || i || r ? !!this.isRowPresent(o) : !1;
  }
  isRowPresent(e) {
    var t;
    return this.rowModel.isRowPresent(e) ? ((t = this.beans.pagination) == null ? void 0 : t.isRowInPage(e.rowIndex)) ?? !0 : !1;
  }
  createRowCon(e, t, n) {
    var r, a;
    const o = ((r = this.cachedRowCtrls) == null ? void 0 : r.getRow(e)) ?? null;
    if (o)
      return o;
    const s = n && !this.printLayout && !!((a = this.beans.animationFrameSvc) != null && a.active);
    return new Gd(e, this.beans, t, s, this.printLayout);
  }
  getRenderedNodes() {
    const e = Object.values(this.rowCtrlsByRowIndex).map((o) => o.rowNode), t = this.getStickyTopRowCtrls().map((o) => o.rowNode), n = this.getStickyBottomRowCtrls().map((o) => o.rowNode);
    return [...t, ...e, ...n];
  }
  getRowByPosition(e) {
    let t;
    const { rowIndex: n } = e;
    switch (e.rowPinned) {
      case "top":
        t = this.topRowCtrls[n];
        break;
      case "bottom":
        t = this.bottomRowCtrls[n];
        break;
      default:
        t = this.rowCtrlsByRowIndex[n], t || (t = this.getStickyTopRowCtrls().find((o) => o.rowNode.rowIndex === n) || null, t || (t = this.getStickyBottomRowCtrls().find((o) => o.rowNode.rowIndex === n) || null));
        break;
    }
    return t;
  }
  // returns true if any row between startIndex and endIndex is rendered. used by
  // SSRM or IRM, as they don't want to purge visible blocks from cache.
  isRangeInRenderedViewport(e, t) {
    if (e == null || t == null)
      return !1;
    const o = e > this.lastRenderedRow;
    return !(t < this.firstRenderedRow) && !o;
  }
}, h5 = class {
  constructor(e) {
    this.entriesMap = {}, this.entriesList = [], this.maxCount = e;
  }
  addRow(e) {
    if (this.entriesMap[e.rowNode.id] = e, this.entriesList.push(e), e.setCached(!0), this.entriesList.length > this.maxCount) {
      const t = this.entriesList[0];
      t.destroyFirstPass(), t.destroySecondPass(), this.removeFromCache(t);
    }
  }
  getRow(e) {
    if (e == null || e.id == null)
      return null;
    const t = this.entriesMap[e.id];
    return t ? (this.removeFromCache(t), t.setCached(!1), t.rowNode != e ? null : t) : null;
  }
  has(e) {
    return this.entriesMap[e.id] != null;
  }
  removeRow(e) {
    const t = e.id, n = this.entriesMap[t];
    delete this.entriesMap[t], $t(this.entriesList, n);
  }
  removeFromCache(e) {
    const t = e.rowNode.id;
    delete this.entriesMap[t], $t(this.entriesList, e);
  }
  getEntries() {
    return this.entriesList;
  }
};
function Nh(e) {
  if (!e)
    return;
  const t = {
    top: {},
    bottom: {},
    normal: {}
  };
  return e.forEach((n) => {
    const o = n.id;
    switch (n.rowPinned) {
      case "top":
        t.top[o] = n;
        break;
      case "bottom":
        t.bottom[o] = n;
        break;
      default:
        t.normal[o] = n;
        break;
    }
  }), t;
}
function $h(e, t) {
  const n = e.id;
  switch (e.rowPinned) {
    case "top":
      return t.top[n] != null;
    case "bottom":
      return t.bottom[n] != null;
    default:
      return t.normal[n] != null;
  }
}
var g5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowNodeSorter";
  }
  postConstruct() {
    const { gos: e } = this;
    this.isAccentedSort = e.get("accentedSort"), this.primaryColumnsSortGroups = Xn(e), this.addManagedPropertyListener(
      "accentedSort",
      (t) => this.isAccentedSort = t.currentValue
    ), this.addManagedPropertyListener(
      "autoGroupColumnDef",
      () => this.primaryColumnsSortGroups = Xn(e)
    );
  }
  doFullSort(e, t) {
    const n = e.map((o, s) => ({
      currentPos: s,
      rowNode: o
    }));
    return n.sort(this.compareRowNodes.bind(this, t)), n.map((o) => o.rowNode);
  }
  compareRowNodes(e, t, n) {
    const o = t.rowNode, s = n.rowNode;
    for (let i = 0, r = e.length; i < r; i++) {
      const a = e[i], l = a.sort === "desc", d = this.getValue(o, a.column), c = this.getValue(s, a.column);
      let u;
      const h = this.getComparator(a, o);
      if (h ? u = h(d, c, o, s, l) : u = vd(d, c, this.isAccentedSort), !isNaN(u) && u !== 0)
        return a.sort === "asc" ? u : u * -1;
    }
    return t.currentPos - n.currentPos;
  }
  getComparator(e, t) {
    const n = e.column, o = n.getColDef().comparator;
    if (o != null)
      return o;
    if (!n.getColDef().showRowGroup)
      return;
    const s = !t.group && n.getColDef().field;
    if (!s)
      return;
    const i = this.beans.colModel.getColDefCol(s);
    if (i)
      return i.getColDef().comparator;
  }
  getValue(e, t) {
    var a, l;
    const { valueSvc: n, colModel: o, showRowGroupCols: s, gos: i } = this.beans;
    if (!this.primaryColumnsSortGroups)
      return n.getValue(t, e, !1);
    if (e.rowGroupColumn === t) {
      if (Xg(i, o.isPivotActive())) {
        const u = (a = e.allLeafChildren) == null ? void 0 : a[0];
        return u ? n.getValue(t, u, !1) : void 0;
      }
      const c = s == null ? void 0 : s.getShowRowGroupCol(t.getId());
      return c ? (l = e.groupData) == null ? void 0 : l[c.getId()] : void 0;
    }
    if (!(e.group && t.getColDef().showRowGroup))
      return n.getValue(t, e, !1);
  }
};
function p5(e) {
  var t;
  (t = e.sortSvc) == null || t.onSortChanged("api");
}
var Bp = {
  moduleName: "Sort",
  version: Ee,
  beans: [Tk, g5],
  apiFunctions: {
    onSortChanged: p5
  },
  userComponents: {
    agSortIndicator: Dp
  },
  icons: {
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
    sortUnSort: "none"
  }
}, f5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "syncSvc", this.waitingForColumns = !1;
  }
  postConstruct() {
    this.addManagedPropertyListener("columnDefs", (e) => this.setColumnDefs(e));
  }
  start() {
    this.beans.ctrlsSvc.whenReady(this, () => {
      const e = this.gos.get("columnDefs");
      e ? this.setColumnsAndData(e) : this.waitingForColumns = !0, this.gridReady();
    });
  }
  setColumnsAndData(e) {
    const { colModel: t, rowModel: n } = this.beans;
    t.setColumnDefs(e ?? [], "gridInitializing"), n.start();
  }
  gridReady() {
    const { eventSvc: e, gos: t } = this;
    e.dispatchEvent({
      type: "gridReady"
    }), Is(t, `initialised successfully, enterprise = ${t.isModuleRegistered("EnterpriseCore")}`);
  }
  setColumnDefs(e) {
    const t = this.gos.get("columnDefs");
    if (t) {
      if (this.waitingForColumns) {
        this.waitingForColumns = !1, this.setColumnsAndData(t);
        return;
      }
      this.beans.colModel.setColumnDefs(t, di(e.source));
    }
  }
};
function m5(e) {
  var t;
  (t = e.valueCache) == null || t.expire();
}
function v5(e, t) {
  const { colKey: n, rowNode: o, useFormatter: s } = t, i = e.colModel.getColDefCol(n) ?? e.colModel.getCol(n);
  if (st(i))
    return null;
  const r = e.valueSvc.getValueForDisplay(i, o, s);
  return s ? r.valueFormatted ?? Ii(r.value) : r.value;
}
var C5 = "paste", w5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "changeDetectionSvc", this.clientSideRowModel = null;
  }
  postConstruct() {
    const { gos: e, rowModel: t } = this.beans;
    Ct(e) && (this.clientSideRowModel = t), this.addManagedEventListeners({ cellValueChanged: this.onCellValueChanged.bind(this) });
  }
  onCellValueChanged(e) {
    const { gos: t, rowRenderer: n } = this.beans;
    if (e.source === C5 || t.get("suppressChangeDetection"))
      return;
    const o = e.node, s = [o], i = this.clientSideRowModel, r = i == null ? void 0 : i.rootNode;
    if (r && !o.isRowPinned()) {
      const a = t.get("aggregateOnlyChangedColumns"), l = new Rr(a, r);
      l.addParentNode(o.parent, [e.column]), i.doAggregate(l), l.forEachChangedNodeDepthFirst((d) => {
        s.push(d), d.sibling && s.push(d.sibling);
      });
    }
    n.refreshCells({ rowNodes: s });
  }
}, y5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "expressionSvc", this.cache = {};
  }
  evaluate(e, t) {
    if (typeof e == "string")
      return this.evaluateExpression(e, t);
    $e(15, { expression: e });
  }
  evaluateExpression(e, t) {
    try {
      return this.createExpressionFunction(e)(
        t.value,
        t.context,
        t.oldValue,
        t.newValue,
        t.value,
        t.node,
        t.data,
        t.colDef,
        t.rowIndex,
        t.api,
        t.getValue,
        t.column,
        t.columnGroup
      );
    } catch (n) {
      return $e(16, { expression: e, params: t, e: n }), null;
    }
  }
  createExpressionFunction(e) {
    const t = this.cache;
    if (t[e])
      return t[e];
    const n = this.createFunctionBody(e), o = new Function(
      "x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup",
      n
    );
    return t[e] = o, o;
  }
  createFunctionBody(e) {
    return e.indexOf("return") >= 0 ? e : "return " + e + ";";
  }
}, b5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "valueCache", this.cacheVersion = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("valueCache"), this.neverExpires = e.get("valueCacheNeverExpires");
  }
  onDataChanged() {
    this.neverExpires || this.expire();
  }
  expire() {
    this.cacheVersion++;
  }
  setValue(e, t, n) {
    if (this.active) {
      const o = this.cacheVersion;
      e.__cacheVersion !== o && (e.__cacheVersion = o, e.__cacheData = {}), e.__cacheData[t] = n;
    }
  }
  getValue(e, t) {
    if (!(!this.active || e.__cacheVersion !== this.cacheVersion))
      return e.__cacheData[t];
  }
}, S5 = {
  moduleName: "ValueCache",
  version: Ee,
  beans: [b5],
  apiFunctions: {
    expireValueCache: m5
  }
}, x5 = {
  moduleName: "Expression",
  version: Ee,
  beans: [y5]
}, R5 = {
  moduleName: "ChangeDetection",
  version: Ee,
  beans: [w5]
}, E5 = {
  moduleName: "CellApi",
  version: Ee,
  apiFunctions: {
    getCellValue: v5
  }
}, A5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "valueSvc", this.hasEditSvc = !1, this.initialised = !1, this.isSsrm = !1;
  }
  wireBeans(e) {
    this.expressionSvc = e.expressionSvc, this.colModel = e.colModel, this.valueCache = e.valueCache, this.dataTypeSvc = e.dataTypeSvc, this.editSvc = e.editSvc, this.hasEditSvc = !!e.editSvc;
  }
  postConstruct() {
    this.initialised || this.init();
  }
  init() {
    this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this), this.isSsrm = gn(this.gos), this.cellExpressions = this.gos.get("enableCellExpressions"), this.isTreeData = this.gos.get("treeData"), this.initialised = !0;
    const e = (t) => this.callColumnCellValueChangedHandler(t);
    this.eventSvc.addListener("cellValueChanged", e, !0), this.addDestroyFunc(() => this.eventSvc.removeListener("cellValueChanged", e, !0)), this.addManagedPropertyListener("treeData", (t) => this.isTreeData = t.currentValue);
  }
  /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */
  getValueForDisplay(e, t, n = !1, o = !1, s = "ui") {
    const { showRowGroupColValueSvc: i } = this.beans, r = !e && t.group, a = e == null ? void 0 : e.colDef.showRowGroup, l = !this.isTreeData || t.footer;
    if (i && l && (r || a)) {
      const f = i.getGroupValue(t, e);
      if (f == null)
        return {
          value: null,
          valueFormatted: null
        };
      if (!n)
        return {
          value: f.value,
          valueFormatted: null
        };
      const m = i.formatAndPrefixGroupColValue(f, e, o);
      return {
        value: f.value,
        valueFormatted: m
      };
    }
    if (!e)
      return {
        value: t.key,
        valueFormatted: null
      };
    const d = t.leafGroup && this.colModel.isPivotMode(), c = t.group && t.expanded && !t.footer && !d, u = this.gos.get("groupSuppressBlankHeader") || !t.sibling, h = c && !u, g = this.getValue(e, t, h, s), p = n && !(o && e.colDef.useValueFormatterForExport === !1);
    return {
      value: g,
      valueFormatted: p ? this.formatValue(e, t, g) : null
    };
  }
  getValue(e, t, n = !1, o = "ui") {
    var f;
    if (this.initialised || this.init(), !t)
      return;
    const s = e.getColDef(), i = s.field, r = e.getColId(), a = t.data;
    if (this.hasEditSvc && o === "ui") {
      const m = this.editSvc;
      if (m.isEditing()) {
        const C = m.getCellDataValue({ rowNode: t, column: e }, !0);
        if (C !== void 0)
          return C;
      }
    }
    let l;
    const d = s.showRowGroup;
    if (typeof d == "string" && (((f = this.beans.rowGroupColsSvc) == null ? void 0 : f.getColumnIndex(d)) ?? -1) > t.level)
      return null;
    const c = typeof d != "string" || !t.group, u = t.groupData && r in t.groupData, h = !n && t.aggData && t.aggData[r] !== void 0, g = this.isSsrm && n && !!s.aggFunc, p = this.isSsrm && t.footer && t.field && (s.showRowGroup === !0 || s.showRowGroup === t.field);
    if (this.isTreeData && h)
      l = t.aggData[r];
    else if (this.isTreeData && s.valueGetter)
      l = this.executeValueGetter(s.valueGetter, a, e, t);
    else if (this.isTreeData && i && a)
      l = la(a, i, e.isFieldContainsDots());
    else if (u)
      l = t.groupData[r];
    else if (h)
      l = t.aggData[r];
    else if (s.valueGetter && !g) {
      if (!c)
        return l;
      l = this.executeValueGetter(s.valueGetter, a, e, t);
    } else if (p)
      l = la(a, t.field, e.isFieldContainsDots());
    else if (i && a && !g) {
      if (!c)
        return l;
      l = la(a, i, e.isFieldContainsDots());
    }
    if (this.cellExpressions && typeof l == "string" && l.indexOf("=") === 0) {
      const m = l.substring(1);
      l = this.executeValueGetter(m, a, e, t);
    }
    return l;
  }
  parseValue(e, t, n, o) {
    var r;
    const s = e.getColDef(), i = s.valueParser;
    if (ue(i)) {
      const a = ke(this.gos, {
        node: t,
        data: t == null ? void 0 : t.data,
        oldValue: o,
        newValue: n,
        colDef: s,
        column: e
      });
      return typeof i == "function" ? i(a) : (r = this.expressionSvc) == null ? void 0 : r.evaluate(i, a);
    }
    return n;
  }
  getDeleteValue(e, t) {
    return ue(e.getColDef().valueParser) ? this.parseValue(e, t, "", this.getValueForDisplay(e, t).value) ?? null : null;
  }
  formatValue(e, t, n, o, s = !0) {
    const { expressionSvc: i } = this.beans;
    let r = null, a;
    const l = e.getColDef();
    if (o ? a = o : s && (a = l.valueFormatter), a) {
      const d = t ? t.data : null, c = ke(this.gos, {
        value: n,
        node: t,
        data: d,
        colDef: l,
        column: e
      });
      typeof a == "function" ? r = a(c) : r = i ? i.evaluate(a, c) : null;
    } else if (l.refData)
      return l.refData[n] || "";
    return r == null && Array.isArray(n) && (r = n.join(", ")), r;
  }
  /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */
  setValue(e, t, n, o) {
    var c, u;
    const s = this.colModel.getColDefCol(t);
    if (!e || !s)
      return !1;
    st(e.data) && (e.data = {});
    const { field: i, valueSetter: r } = s.getColDef();
    if (st(i) && st(r))
      return Z(17), !1;
    if (this.dataTypeSvc && !this.dataTypeSvc.checkType(s, n))
      return Z(135), !1;
    const a = ke(this.gos, {
      node: e,
      data: e.data,
      oldValue: this.getValue(s, e, void 0, o),
      newValue: n,
      colDef: s.getColDef(),
      column: s
    });
    a.newValue = n;
    let l;
    if (ue(r) ? typeof r == "function" ? l = r(a) : l = (c = this.expressionSvc) == null ? void 0 : c.evaluate(r, a) : l = this.setValueUsingField(e.data, i, n, s.isFieldContainsDots()), l === void 0 && (l = !0), !l)
      return !1;
    e.resetQuickFilterAggregateText(), (u = this.valueCache) == null || u.onDataChanged();
    const d = this.getValue(s, e);
    return this.dispatchCellValueChangedEvent(e, a, d, o), e.pinnedSibling && this.dispatchCellValueChangedEvent(e.pinnedSibling, a, d, o), !0;
  }
  dispatchCellValueChangedEvent(e, t, n, o) {
    this.eventSvc.dispatchEvent({
      type: "cellValueChanged",
      event: null,
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: t.column,
      colDef: t.colDef,
      data: e.data,
      node: e,
      oldValue: t.oldValue,
      newValue: n,
      value: n,
      source: o
    });
  }
  callColumnCellValueChangedHandler(e) {
    const t = e.colDef.onCellValueChanged;
    typeof t == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => {
      t({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        context: e.context
      });
    });
  }
  setValueUsingField(e, t, n, o) {
    if (!t)
      return !1;
    let s = !1;
    if (!o)
      s = e[t] === n, s || (e[t] = n);
    else {
      const i = t.split(".");
      let r = e;
      for (; i.length > 0 && r; ) {
        const a = i.shift();
        i.length === 0 ? (s = r[a] === n, s || (r[a] = n)) : r = r[a];
      }
    }
    return !s;
  }
  executeValueGetterWithValueCache(e, t, n, o) {
    const s = n.getColId(), i = this.valueCache.getValue(o, s);
    if (i !== void 0)
      return i;
    const r = this.executeValueGetterWithoutValueCache(e, t, n, o);
    return this.valueCache.setValue(o, s, r), r;
  }
  executeValueGetterWithoutValueCache(e, t, n, o) {
    var r;
    const s = ke(this.gos, {
      data: t,
      node: o,
      column: n,
      colDef: n.getColDef(),
      getValue: this.getValueCallback.bind(this, o)
    });
    let i;
    return typeof e == "function" ? i = e(s) : i = (r = this.expressionSvc) == null ? void 0 : r.evaluate(e, s), i;
  }
  getValueCallback(e, t) {
    const n = this.colModel.getColDefCol(t);
    return n ? this.getValue(n, e) : null;
  }
  // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
  getKeyForNode(e, t) {
    const n = this.getValue(e, t), o = e.getColDef().keyCreator;
    let s = n;
    if (o) {
      const i = ke(this.gos, {
        value: n,
        colDef: e.getColDef(),
        column: e,
        node: t,
        data: t.data
      });
      s = o(i);
    }
    return typeof s == "string" || s == null || (s = String(s), s === "[object Object]" && Z(121)), s;
  }
}, F5 = {
  moduleName: "CommunityCore",
  version: Ee,
  beans: [
    Mk,
    pD,
    x4,
    uF,
    d5,
    OT,
    Sk,
    Qk,
    rF,
    UL,
    WL,
    u5,
    A5,
    Ak,
    bk,
    Fk,
    E4,
    f5,
    C4,
    w4,
    lL
  ],
  icons: {
    // icon on select dropdowns (select cell editor, charts tool panels)
    selectOpen: "small-down",
    /** @deprecated v33 */
    smallDown: "small-down",
    /** @deprecated v33 */
    colorPicker: "color-picker",
    /** @deprecated v33 */
    smallUp: "small-up",
    /** @deprecated v33 */
    checkboxChecked: "small-up",
    /** @deprecated v33 */
    checkboxIndeterminate: "checkbox-indeterminate",
    /** @deprecated v33 */
    checkboxUnchecked: "checkbox-unchecked",
    /** @deprecated v33 */
    radioButtonOn: "radio-button-on",
    /** @deprecated v33 */
    radioButtonOff: "radio-button-off",
    /** @deprecated v33 */
    smallLeft: "small-left",
    /** @deprecated v33 */
    smallRight: "small-right"
  },
  apiFunctions: {
    getGridId: fD,
    destroy: mD,
    isDestroyed: vD,
    getGridOption: CD,
    setGridOption: wD,
    updateGridOptions: oy,
    isModuleRegistered: yD
  },
  dependsOn: [
    f4,
    Ip,
    bT,
    Bp,
    sL,
    uy,
    iL,
    l5,
    R5,
    aL,
    zL,
    jL,
    QL,
    cL,
    S4,
    m4,
    x5,
    NT,
    e5
  ]
}, Ly = {
  AdvancedFilter: 1,
  AllEnterprise: 1,
  BatchEdit: 1,
  CellSelection: 1,
  Clipboard: 1,
  ColumnMenu: 1,
  ColumnsToolPanel: 1,
  ContextMenu: 1,
  ExcelExport: 1,
  FiltersToolPanel: 1,
  Find: 1,
  GridCharts: 1,
  IntegratedCharts: 1,
  GroupFilter: 1,
  MasterDetail: 1,
  Menu: 1,
  MultiFilter: 1,
  NewFiltersToolPanel: 1,
  Pivot: 1,
  RangeSelection: 1,
  RichSelect: 1,
  RowNumbers: 1,
  RowGrouping: 1,
  RowGroupingPanel: 1,
  ServerSideRowModelApi: 1,
  ServerSideRowModel: 1,
  SetFilter: 1,
  SideBar: 1,
  Sparklines: 1,
  StatusBar: 1,
  TreeData: 1,
  ViewportRowModel: 1
}, Du = [
  "TextFilter",
  "NumberFilter",
  "DateFilter",
  "SetFilter",
  "MultiFilter",
  "GroupFilter",
  "CustomFilter"
], M5 = {
  EditCore: [
    "TextEditor",
    "NumberEditor",
    "DateEditor",
    "CheckboxEditor",
    "LargeTextEditor",
    "SelectEditor",
    "RichSelect",
    "CustomEditor"
  ],
  CheckboxCellRenderer: ["AllCommunity"],
  ClientSideRowModelHierarchy: ["RowGrouping", "Pivot", "TreeData"],
  ColumnFilter: Du,
  ColumnGroupHeaderComp: ["AllCommunity"],
  ColumnGroup: ["AllCommunity"],
  ColumnHeaderComp: ["AllCommunity"],
  ColumnMove: ["AllCommunity"],
  ColumnResize: ["AllCommunity"],
  CommunityCore: ["AllCommunity"],
  CsrmSsrmSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  RowModelSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  EnterpriseCore: ["AllEnterprise"],
  FilterCore: [...Du, "QuickFilter", "ExternalFilter", "AdvancedFilter"],
  GroupCellRenderer: ["RowGrouping", "Pivot", "TreeData", "MasterDetail", "ServerSideRowModel"],
  KeyboardNavigation: ["AllCommunity"],
  LoadingCellRenderer: ["ServerSideRowModel"],
  MenuCore: ["ColumnMenu", "ContextMenu"],
  MenuItem: ["ColumnMenu", "ContextMenu", "MultiFilter", "IntegratedCharts", "ColumnsToolPanel"],
  Overlay: ["AllCommunity"],
  PinnedColumn: ["AllCommunity"],
  SharedAggregation: ["RowGrouping", "Pivot", "TreeData", "ServerSideRowModel"],
  SharedDragAndDrop: ["AllCommunity"],
  SharedMasterDetail: ["MasterDetail", "ServerSideRowModel"],
  SharedMenu: [...Du, "ColumnMenu", "ContextMenu"],
  SharedPivot: ["Pivot", "ServerSideRowModel"],
  SharedRowGrouping: ["RowGrouping", "ServerSideRowModel"],
  SharedRowSelection: ["RowSelection", "ServerSideRowModel"],
  SkeletonCellRenderer: ["ServerSideRowModel"],
  Sort: ["AllCommunity"],
  SsrmInfiniteSharedApi: ["InfiniteRowModel", "ServerSideRowModelApi"],
  SharedTreeData: ["TreeData", "ServerSideRowModel"]
}, I5 = {
  InfiniteRowModel: "infinite",
  ClientSideRowModelApi: "clientSide",
  ClientSideRowModel: "clientSide",
  ServerSideRowModelApi: "serverSide",
  ServerSideRowModel: "serverSide",
  ViewportRowModel: "viewport"
};
function P5(e, t) {
  const n = [];
  return (Array.isArray(e) ? e : [e]).forEach((o) => {
    const s = M5[o];
    s ? s.forEach((i) => {
      const r = I5[i];
      (!r || r === t) && n.push(i);
    }) : n.push(o);
  }), n;
}
var By = () => `No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `, D5 = (e) => {
  const t = e.map(
    (o) => `import { ${ca(o)} } from '${Ly[o] ? "ag-grid-enterprise" : "ag-grid-community"}';`
  );
  return e.some((o) => o === "IntegratedCharts" || o === "Sparklines") && t.push("import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';"), `import { ModuleRegistry } from 'ag-grid-community'; 
${t.join(` 
`)} 

ModuleRegistry.registerModules([ ${e.map((o) => ca(o, !0)).join(", ")} ]); 

For more info see: ${Ji}/modules/`;
};
function ca(e, t = !1) {
  return t && (e === "IntegratedCharts" || e === "Sparklines") ? `${e}Module.with(AgChartsEnterpriseModule)` : `${e}Module`;
}
function T5(e, t) {
  const n = t.filter((i) => i === "IntegratedCharts" || i === "Sparklines");
  let o = "";
  return !(globalThis == null ? void 0 : globalThis.agCharts) && n.length > 0 ? o = `Unable to use ${e} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
` : t.some((i) => Ly[i]) && (o = o + `Unable to use ${e} as that requires the ag-grid-enterprise script to be included.
`), o;
}
function Oy({
  moduleName: e,
  rowModelType: t
}) {
  return `To use the ${e}Module you must set the gridOption "rowModelType='${t}'"`;
}
var s0 = ({
  reasonOrId: e,
  moduleName: t,
  gridScoped: n,
  gridId: o,
  rowModelType: s,
  additionalText: i,
  isUmd: r
}) => {
  const a = P5(t, s), l = typeof e == "string" ? e : O5[e];
  if (r)
    return T5(l, a);
  const d = a.filter((h) => h === "IntegratedCharts" || h === "Sparklines"), c = d.length > 0 ? `${d.map((h) => ca(h)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
  return `${`Unable to use ${l} as ${a.length > 1 ? "one of " + a.map((h) => ca(h)).join(", ") : ca(a[0])} is not registered${n ? " for gridId: " + o : ""}. ${c} Check if you have registered the module:
`}
${D5(a)}` + (i ? ` 

${i}` : "");
}, i0 = (e) => `${e} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${e} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${e}.with(AgChartsEnterpriseModule)]);
    `, k5 = (e) => `AG Grid: Unable to use the Clipboard API (navigator.clipboard.${e}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`, L5 = {
  1: () => "`rowData` must be an array",
  2: ({ nodeId: e }) => `Duplicate node id '${e}' detected from getRowId callback, this could cause issues in your grid.`,
  3: () => "Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
  4: ({ id: e }) => `Could not find row id=${e}, data item was not found for this id`,
  5: ({ data: e }) => [
    "Could not find data item as object was not found.",
    e,
    " Consider using getRowId to help the Grid find matching row data"
  ],
  6: () => "'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'",
  7: () => "Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
  8: ({ key: e }) => `Unknown key for navigation ${e}`,
  9: ({ variable: e }) => `No value for ${e == null ? void 0 : e.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${e == null ? void 0 : e.defaultValue} will be used and updated when styles load.`,
  10: ({ eventType: e }) => `As of v33, the '${e}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
  11: () => "No gridOptions provided to createGrid",
  12: ({ colKey: e }) => ["column ", e, " not found"],
  13: () => "Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
  14: ({ groupPrefix: e }) => `Row IDs cannot start with ${e}, this is a reserved prefix for AG Grid's row grouping feature.`,
  15: ({ expression: e }) => ["value should be either a string or a function", e],
  16: ({ expression: e, params: t, e: n }) => [
    "Processing of the expression failed",
    "Expression = ",
    e,
    "Params = ",
    t,
    "Exception = ",
    n
  ],
  17: () => "you need either field or valueSetter set on colDef for editing to work",
  18: () => "alignedGrids contains an undefined option.",
  19: () => "alignedGrids - No api found on the linked grid.",
  20: () => `You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
  21: () => "pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
  22: ({ key: e }) => `${e} is an initial property and cannot be updated.`,
  23: () => "The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
  24: () => "row height must be a number if not using standard row model",
  25: ({ id: e }) => ["The getRowId callback must return a string. The ID ", e, " is being cast to a string."],
  26: ({ fnName: e, preDestroyLink: t }) => `Grid API function ${e}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${t}`,
  27: ({ fnName: e, module: t }) => `API function '${e}' not registered to module '${t}'`,
  28: () => "setRowCount cannot be used while using row grouping.",
  29: () => "tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
  30: ({ toIndex: e }) => [
    "tried to insert columns in invalid location, toIndex = ",
    e,
    "remember that you should not count the moving columns when calculating the new index"
  ],
  31: () => "infinite loop in resizeColumnSets",
  32: () => "applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
  33: () => "stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
  34: ({ key: e }) => `the column type '${e}' is a default column type and cannot be overridden.`,
  35: () => "Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.",
  36: ({ t: e }) => "colDef.type '" + e + "' does not correspond to defined gridOptions.columnTypes",
  37: () => "Changing the column pinning status is not allowed with domLayout='print'",
  38: ({ iconName: e }) => `provided icon '${e}' needs to be a string or a function`,
  39: () => "Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
  40: ({ e, method: t }) => `${e}
${k5(t)}`,
  41: () => "Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
  42: () => "Browser does not support document.execCommand('copy') for clipboard operations",
  43: ({ iconName: e }) => `As of v33, icon '${e}' is deprecated. Use the icon CSS name instead.`,
  44: () => 'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
  45: ({ parentCellDataType: e }) => `The data type definition ${e} does not exist.`,
  46: () => 'The "baseDataType" property of a data type definition must match that of its parent.',
  47: ({ cellDataType: e }) => `Missing data type definition - "${e}"`,
  48: ({ property: e }) => `Cell data type is "object" but no Value ${e} has been provided. Please either provide an object data type definition with a Value ${e}, or set "colDef.value${e}"`,
  49: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  50: ({ compName: e }) => `Could not find component ${e}, did you forget to configure this component?`,
  51: () => "Export cancelled. Export is not allowed as per your configuration.",
  52: () => "There is no `window` associated with the current `document`",
  53: () => "unknown value type during csv conversion",
  54: () => "Could not find document body, it is needed for drag and drop and context menu.",
  55: () => "addRowDropZone - A container target needs to be provided",
  56: () => "addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
  57: () => "unable to show popup filter, filter instantiation failed",
  58: () => "no values found for select cellEditor",
  59: () => "cannot select pinned rows",
  60: () => "cannot select node until it has finished loading",
  61: () => "since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
  62: ({ colId: e }) => `setFilterModel() - no column found for colId: ${e}`,
  63: ({ colId: e }) => `setFilterModel() - unable to fully apply model, filtering disabled for colId: ${e}`,
  64: ({ colId: e }) => `setFilterModel() - unable to fully apply model, unable to create filter for colId: ${e}`,
  65: () => "filter missing setModel method, which is needed for setFilterModel",
  66: () => "filter API missing getModel method, which is needed for getFilterModel",
  67: () => "Filter is missing isFilterActive() method",
  68: () => "Column Filter API methods have been disabled as Advanced Filters are enabled.",
  69: ({ guiFromFilter: e }) => `getGui method from filter returned ${e}; it should be a DOM element.`,
  70: ({ newFilter: e }) => `Grid option quickFilterText only supports string inputs, received: ${typeof e}`,
  71: () => "debounceMs is ignored when apply button is present",
  72: ({ keys: e }) => ["ignoring FilterOptionDef as it doesn't contain one of ", e],
  73: () => "invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'",
  74: () => "no filter options for filter",
  75: () => "Unknown button type specified",
  76: ({ filterModelType: e }) => [
    'Unexpected type of filter "',
    e,
    '", it looks like the filter was configured with incorrect Filter Options'
  ],
  77: () => "Filter model is missing 'conditions'",
  78: () => 'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
  79: () => '"filterParams.maxNumConditions" must be greater than or equal to zero.',
  80: () => '"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
  81: () => '"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
  82: ({ param: e }) => `DateFilter ${e} is not a number`,
  83: () => "DateFilter minValidYear should be <= maxValidYear",
  84: () => "DateFilter minValidDate should be <= maxValidDate",
  85: () => "DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
  86: () => "DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
  87: () => "DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
  88: ({ index: e }) => `Invalid row index for ensureIndexVisible: ${e}`,
  89: () => "A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)",
  90: () => "datasource is missing getRows method",
  91: () => "Filter is missing method doesFilterPass",
  92: () => "AnimationFrameService called but animation frames are off",
  93: () => "cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
  94: ({
    paginationPageSizeOption: e,
    pageSizeSet: t,
    pageSizesSet: n,
    pageSizeOptions: o
  }) => `'paginationPageSize=${e}'${t ? "" : " (default value)"}, but ${e} is not included in${n ? "" : " the default"} paginationPageSizeSelector=[${o == null ? void 0 : o.join(", ")}].`,
  95: ({
    paginationPageSizeOption: e,
    paginationPageSizeSelector: t
  }) => `Either set '${t}' to an array that includes ${e} or to 'false' to disable the page size selector.`,
  96: ({ id: e, data: t }) => [
    "Duplicate ID",
    e,
    "found for pinned row with data",
    t,
    "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
  ],
  97: ({ colId: e }) => `cellEditor for column ${e} is missing getGui() method`,
  98: () => "popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
  99: () => "Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
  // 100: ({ rowModelType }: { rowModelType: RowModelType }) =>
  //     `selectAll only available when rowModelType='clientSide', ie not ${rowModelType}` as const,
  101: ({
    propertyName: e,
    componentName: t,
    agGridDefaults: n,
    jsComps: o
  }) => {
    const s = [], i = [
      // Don't include the old names / internals in potential suggestions
      ...Object.keys(n ?? []).filter(
        (a) => !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(a)
      ),
      ...Object.keys(o ?? []).filter((a) => !!o[a])
    ], r = La({
      inputValue: t,
      allSuggestions: i,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return s.push(
      `Could not find '${t}' component. It was configured as "${e}: '${t}'" but it wasn't found in the list of registered components.
`
    ), r.length > 0 && s.push(`         Did you mean: [${r.slice(0, 3)}]?
`), s.push("If using a custom component check it has been registered correctly."), s;
  },
  102: () => "selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
  103: () => "Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
  104: ({ value: e, param: t }) => `Numeric value ${e} passed to ${t} param will be interpreted as ${e} seconds. If this is intentional use "${e}s" to silence this warning.`,
  105: ({ e }) => ["chart rendering failed", e],
  106: () => `Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${Ji}/theming-migration/`,
  107: ({ key: e, value: t }) => `Invalid value for theme param ${e} - ${t}`,
  108: ({ e }) => ["chart update failed", e],
  109: ({ inputValue: e, allSuggestions: t }) => {
    const n = La({
      inputValue: e,
      allSuggestions: t,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return [
      `Could not find '${e}' aggregate function. It was configured as "aggFunc: '${e}'" but it wasn't found in the list of registered aggregations.`,
      n.length > 0 ? `         Did you mean: [${n.slice(0, 3)}]?` : "",
      "If using a custom aggregation function check it has been registered correctly."
    ].join(`
`);
  },
  110: () => "groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
  111: () => "Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
  113: () => "Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
  114: ({ component: e }) => `Could not find component with name of ${e}. Is it in Vue.components?`,
  // 115: () => 'The provided selection state should be an object.' as const,
  116: () => "Invalid selection state. The state must conform to `IServerSideSelectionState`.",
  117: () => "selectAll must be of boolean type.",
  118: () => "Infinite scrolling must be enabled in order to set the row count.",
  119: () => "Unable to instantiate filter",
  120: () => "MultiFloatingFilterComp expects MultiFilter as its parent",
  121: () => "a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
  122: () => "could not find the document, document is empty",
  123: () => "Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
  124: () => "No active charts to update.",
  125: ({ chartId: e }) => `Unable to update chart. No active chart found with ID: ${e}.`,
  126: () => "unable to restore chart as no chart model is provided",
  127: ({ allRange: e }) => `unable to create chart as ${e ? "there are no columns in the grid" : "no range is selected"}.`,
  128: ({ feature: e }) => `${e} is only available if using 'multiRow' selection mode.`,
  129: ({ feature: e, rowModel: t }) => `${e} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${t}.`,
  130: () => 'cannot multi select unless selection mode is "multiRow"',
  // 131: () => 'cannot range select while selecting multiple rows' as const,
  132: () => "Row selection features are not available unless `rowSelection` is enabled.",
  133: ({ iconName: e }) => `icon '${e}' function should return back a string or a dom object`,
  134: ({ iconName: e }) => `Did not find icon '${e}'`,
  135: () => "Data type of the new value does not match the cell data type of the column",
  136: () => "Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.",
  137: ({ type: e, currentChartType: t }) => `Unable to update chart as a '${e}' update type is not permitted on a ${t}.`,
  138: ({ chartType: e }) => `invalid chart type supplied: ${e}`,
  139: ({ customThemeName: e }) => `a custom chart theme with the name ${e} has been supplied but not added to the 'chartThemes' list`,
  140: ({ name: e }) => `no stock theme exists with the name '${e}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
  141: () => "cross filtering with row grouping is not supported.",
  142: () => "cross filtering is only supported in the client side row model.",
  143: ({ panel: e }) => `'${e}' is not a valid Chart Tool Panel name`,
  144: ({ type: e }) => `Invalid charts data panel group name supplied: '${e}'`,
  145: ({ group: e }) => `As of v32, only one charts customize panel group can be expanded at a time. '${e}' will not be expanded.`,
  146: ({ comp: e }) => `Unable to instantiate component '${e}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
  147: ({ group: e }) => `Invalid charts customize panel group name supplied: '${e}'`,
  148: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  149: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  150: () => "'seriesChartTypes' are required when the 'customCombo' chart type is specified.",
  151: ({ chartType: e }) => `invalid chartType '${e}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
  152: ({ colId: e }) => `no 'seriesChartType' found for colId = '${e}', defaulting to 'line'.`,
  153: ({ chartDataType: e }) => `unexpected chartDataType value '${e}' supplied, instead use 'category', 'series' or 'excluded'`,
  154: ({ colId: e }) => `cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${e}`,
  155: ({ option: e }) => `'${e}' is not a valid Chart Toolbar Option`,
  156: ({ panel: e }) => `Invalid panel in chartToolPanelsDef.panels: '${e}'`,
  157: ({ unrecognisedGroupIds: e }) => ["unable to find group(s) for supplied groupIds:", e],
  158: () => "can not expand a column item that does not represent a column group header",
  159: () => "Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
  160: () => "Export cancelled. Export is not allowed as per your configuration.",
  161: () => "The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
  162: ({ id: e, dataType: t }) => `Unrecognized data type for excel export [${e}.dataType=${t}]`,
  163: ({ featureName: e }) => `Excel table export does not work with ${e}. The exported Excel file will not contain any Excel tables.
 Please turn off ${e} to enable Excel table exports.`,
  164: () => "Unable to add data table to Excel sheet: A table already exists.",
  165: () => "Unable to add data table to Excel sheet: Missing required parameters.",
  166: ({ unrecognisedGroupIds: e }) => ["unable to find groups for these supplied groupIds:", e],
  167: ({ unrecognisedColIds: e }) => ["unable to find columns for these supplied colIds:", e],
  168: () => "detailCellRendererParams.template should be function or string",
  169: () => 'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
  170: ({ providedStrategy: e }) => `invalid cellRendererParams.refreshStrategy = ${e} supplied, defaulting to refreshStrategy = 'rows'.`,
  171: () => "could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
  172: () => "could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
  173: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  174: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  175: ({ menuTabName: e, itemsToConsider: t }) => [
    `Trying to render an invalid menu item '${e}'. Check that your 'menuTabs' contains one of `,
    t
  ],
  176: ({ key: e }) => `unknown menu item type ${e}`,
  177: () => "valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.",
  178: ({ colId: e }) => `column ${e} is not visible`,
  179: () => "totalValueGetter should be either a function or a string (expression)",
  180: () => "agRichSelectCellEditor requires cellEditorParams.values to be set",
  181: () => "agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
  182: () => 'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
  183: () => "Group Column Filter only works on group columns. Please use a different filter.",
  184: ({ parentGroupData: e, childNodeData: t }) => ["duplicate group keys for row data, keys should be unique", [e, t]],
  185: ({ data: e }) => ["getDataPath() should not return an empty path", [e]],
  186: ({
    rowId: e,
    rowData: t,
    duplicateRowsData: n
  }) => [
    "duplicate group keys for row data, keys should be unique",
    e,
    t,
    ...n ?? []
  ],
  187: ({ rowId: e, firstData: t, secondData: n }) => [
    `Duplicate node id ${e}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
    "first instance",
    t,
    "second instance",
    n
  ],
  188: (e) => `getRowId callback must be provided for Server Side Row Model ${(e == null ? void 0 : e.feature) || "selection"} to work correctly.`,
  189: ({ startRow: e }) => `invalid value ${e} for startRow, the value should be >= 0`,
  190: ({ rowGroupId: e, data: t }) => [
    "null and undefined values are not allowed for server side row model keys",
    e ? `column = ${e}` : "",
    "data is ",
    t
  ],
  // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
  // 192: () => `cannot use range selection when multi selecting rows` as const,
  // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
  194: ({ method: e }) => `calling gridApi.${e}() is only possible when using rowModelType=\`clientSide\`.`,
  195: ({ justCurrentPage: e }) => `selecting just ${e ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
  196: ({ key: e }) => `Provided ids must be of string type. Invalid id provided: ${e}`,
  197: () => "`toggledNodes` must be an array of string ids.",
  // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
  199: () => "getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  200: s0,
  201: ({ rowModelType: e }) => `Could not find row model for rowModelType = ${e}`,
  202: () => "`getSelectedNodes` and `getSelectedRows` functions cannot be used with `groupSelectsChildren` and the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  203: () => "Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
  204: () => "Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
  205: ({ duplicateIdText: e }) => `Unable to display rows as duplicate row ids (${e}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
  206: () => "getRowId callback must be implemented for transactions to work. Transaction was ignored.",
  207: () => 'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
  208: () => "Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.",
  209: () => `Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${Ji}/filter-set-filter-list/#filter-value-types`,
  210: () => "Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
  211: () => "property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
  212: () => "please review all your toolPanel components, it seems like at least one of them doesn't have an id",
  213: () => "Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
  214: ({ key: e }) => `unable to lookup Tool Panel as invalid key supplied: ${e}`,
  215: ({ key: e, defaultByKey: t }) => `the key ${e} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(t ?? {}).join(",")}`,
  216: ({ name: e }) => `Missing component for '${e}'`,
  217: ({ invalidColIds: e }) => ["unable to find grid columns for the supplied colDef(s):", e],
  218: ({ property: e, defaultOffset: t }) => `${e} must be a number, the value you provided is not a valid number. Using the default of ${t}px.`,
  219: ({ property: e }) => `Property ${e} does not exist on the target object.`,
  220: ({ lineDash: e }) => `'${e}' is not a valid 'lineDash' option.`,
  221: () => "agAggregationComponent should only be used with the client and server side row model.",
  222: () => "agFilteredRowCountComponent should only be used with the client side row model.",
  223: () => "agSelectedRowCountComponent should only be used with the client and server side row model.",
  224: () => "agTotalAndFilteredRowCountComponent should only be used with the client side row model.",
  225: () => "agTotalRowCountComponent should only be used with the client side row model.",
  226: () => "viewport is missing init method.",
  227: () => "menu item icon must be DOM node or string",
  228: ({ menuItemOrString: e }) => `unrecognised menu item ${e}`,
  229: ({ index: e }) => ["invalid row index for ensureIndexVisible: ", e],
  230: () => "detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
  // @deprecated v32 mark for removal as part of v32 deprecated features
  231: () => "As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
  232: () => "Using both rowData and v-model. rowData will be ignored.",
  233: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  234: () => 'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
  235: () => 'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
  236: () => 'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
  237: () => "Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
  238: () => "setRowCount can only accept a positive row count.",
  239: () => 'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
  240: ({ theme: e }) => `theme grid option must be a Theming API theme object or the string "legacy", received: ${e}`,
  // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
  // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
  243: () => "Failed to deserialize state - each provided state object must be an object.",
  244: () => "Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
  245: () => "Failed to deserialize state - `toggledNodes` must be an array.",
  246: () => "Failed to deserialize state - Every `toggledNode` requires an associated string id.",
  247: () => `Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
  248: () => "SetFloatingFilter expects SetFilter as its parent",
  249: () => "Must supply a Value Formatter in Set Filter params when using a Key Creator",
  250: () => "Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
  251: ({ chartType: e }) => `AG Grid: Unable to create chart as an invalid chartType = '${e}' was supplied.`,
  252: () => `cannot get grid to draw rows when it is in the middle of drawing rows. 
Your code probably called a grid API method while the grid was in the render stage. 
To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). 
To see what part of your code that caused the refresh check this stacktrace.`,
  253: ({ version: e }) => ["Illegal version string: ", e],
  254: () => "Cannot create chart: no chart themes available.",
  255: ({ point: e }) => `Lone surrogate U+${e == null ? void 0 : e.toString(16).toUpperCase()} is not a scalar value`,
  256: () => "Unable to initialise. See validation error, or load ValidationModule if missing.",
  257: () => i0("IntegratedChartsModule"),
  258: () => i0("SparklinesModule"),
  259: ({ part: e }) => `the argument to theme.withPart must be a Theming API part object, received: ${e}`,
  260: ({
    propName: e,
    compName: t,
    gridScoped: n,
    gridId: o,
    rowModelType: s
  }) => s0({
    reasonOrId: `AG Grid '${e}' component: ${t}`,
    moduleName: or[t],
    gridId: o,
    gridScoped: n,
    rowModelType: s
  }),
  261: () => "As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
  262: () => 'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
  263: () => 'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
  264: () => 'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
  265: ({ colId: e }) => `Unable to infer chart data type for column '${e}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${Ji}/integrated-charts-range-chart#coldefchartdatatype .`,
  266: () => 'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
  267: () => "Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
  268: () => "Transactions aren't supported with tree data when using treeDataChildrenField",
  269: () => "When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
  270: ({ id: e, parentId: t }) => `Cycle detected for row with id='${e}' and parent id='${t}'. Resetting the parent for row with id='${e}' and showing it as a root-level node.`,
  271: ({ id: e, parentId: t }) => `Parent row not found for row with id='${e}' and parent id='${t}'. Showing row with id='${e}' as a root-level node.`,
  272: () => By(),
  273: ({ providedId: e, usedId: t }) => `Provided column id '${e}' was already in use, ensure all column and group ids are unique. Using '${t}' instead.`,
  274: ({ prop: e }) => {
    let t = `Since v33, ${e} has been deprecated.`;
    switch (e) {
      case "maxComponentCreationTimeMs":
        t += " This property is no longer required and so will be removed in a future version.";
        break;
      case "setGridApi":
        t += " This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api ";
        break;
      case "children":
        t += " For multiple versions AgGridReact does not support children.";
        break;
    }
    return t;
  },
  275: Oy,
  276: () => "Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled.",
  277: ({ colId: e }) => `'enableFilterHandlers' is set to true, but column '${e}' does not have 'filter.doesFilterPass' or 'filter.handler' set.`,
  278: ({ colId: e }) => `Unable to create filter handler for column '${e}'`,
  279: (e) => {
  },
  // `Unable to create dynamic bean '${name}' during module init lifecycle, dynamic beans must be initialised on first use.` as const,
  280: ({ colId: e }) => `'name' must be provided for custom filter components for column '${e}`,
  281: ({ colId: e }) => `Filter for column '${e}' does not have 'filterParams.buttons', but the new Filters Tool Panel has buttons configured. Either configure buttons for the filter, or disable buttons on the Filters Tool Panel.`,
  282: () => "New filter tool panel requires `enableFilterHandlers: true`.",
  283: () => "As of v34, use the same method on the filter handler (`api.getColumnFilterHandler(colKey)`) instead.",
  284: () => "As of v34, filters are active when they have a model. Use `api.getColumnFilterModel()` instead.",
  285: () => "As of v34, use (`api.getColumnFilterModel()`) instead.",
  286: () => "As of v34, use (`api.setColumnFilterModel()`) instead.",
  287: () => "`api.doFilterAction()` requires `enableFilterHandlers = true",
  288: () => "`api.getColumnFilterModel(key, true)` requires `enableFilterHandlers = true",
  289: ({ rowModelType: e }) => `Row Model '${e}' is not supported with Batch Editing`,
  290: ({ rowIndex: e, rowPinned: t }) => `Row with index '${e}' and pinned state '${t}' not found`
};
function B5(e, t) {
  const n = L5[e];
  if (!n)
    return [`Missing error text for error id ${e}!`];
  const o = n(t), i = `
See ${FC(e, t)}`;
  return Array.isArray(o) ? o.concat(i) : [o, i];
}
var O5 = {
  1: "Charting Aggregation",
  2: "pivotResultFields",
  3: "setTooltip"
}, r0 = /* @__PURE__ */ new WeakMap(), a0 = /* @__PURE__ */ new WeakMap();
function Gy(e, t, n) {
  if (!t)
    return $e(11), {};
  const o = n;
  let s;
  if (!(o != null && o.setThemeOnGridDiv)) {
    const r = Ue({ tag: "div" });
    r.style.height = "100%", e.appendChild(r), e = r, s = () => e.remove();
  }
  return new H5().create(
    e,
    t,
    (r) => {
      const a = new hD(e);
      r.createBean(a);
    },
    void 0,
    n,
    s
  );
}
var G5 = 1, H5 = class {
  create(e, t, n, o, s, i) {
    const r = E3.applyGlobalGridOptions(t), a = r.gridId ?? String(G5++), l = this.getRegisteredModules(s, a, r.rowModelType), d = this.createBeansList(r.rowModelType, l, a), c = this.createProvidedBeans(e, r, s);
    if (!d)
      return;
    const h = {
      providedBeanInstances: c,
      beanClasses: d,
      id: a,
      beanInitComparator: jP,
      beanDestroyComparator: YP,
      derivedBeans: [ZP],
      destroyCallback: () => {
        a0.delete(p), r0.delete(e), I4(a), i == null || i();
      }
    }, g = new UM(h);
    this.registerModuleFeatures(g, l), n(g), g.getBean("syncSvc").start(), o == null || o(g);
    const p = g.getBean("gridApi");
    return r0.set(e, p), a0.set(p, e), p;
  }
  getRegisteredModules(e, t, n) {
    var o;
    return Er(F5, void 0, !0), (o = e == null ? void 0 : e.modules) == null || o.forEach((s) => Er(s, t)), P4(t, l0(n));
  }
  registerModuleFeatures(e, t) {
    const n = e.getBean("registry"), o = e.getBean("apiFunctionSvc");
    t.forEach((s) => {
      n.registerModule(s);
      const i = s.apiFunctions;
      i && Object.keys(i).forEach((a) => {
        o == null || o.addFunction(a, i[a]);
      });
    });
  }
  createProvidedBeans(e, t, n) {
    let o = n ? n.frameworkOverrides : null;
    st(o) && (o = new ty());
    const s = {
      gridOptions: t,
      eGridDiv: e,
      eRootDiv: e,
      globalListener: n ? n.globalListener : null,
      globalSyncListener: n ? n.globalSyncListener : null,
      frameworkOverrides: o
    };
    return n && n.providedBeanInstances && Object.assign(s, n.providedBeanInstances), s;
  }
  createBeansList(e, t, n) {
    const o = {
      clientSide: "ClientSideRowModel",
      infinite: "InfiniteRowModel",
      serverSide: "ServerSideRowModel",
      viewport: "ViewportRowModel"
    }, s = l0(e), i = o[s];
    if (!i) {
      Qr(201, { rowModelType: s }, `Unknown rowModelType ${s}.`);
      return;
    }
    if (!k4()) {
      Qr(272, void 0, By());
      return;
    }
    if (!e) {
      const a = Object.entries(o).filter(
        ([l, d]) => Oh(d, n, l)
      );
      if (a.length == 1) {
        const [l, d] = a[0];
        if (l !== s) {
          const c = {
            moduleName: d,
            rowModelType: l
          };
          Qr(275, c, Oy(c));
          return;
        }
      }
    }
    if (!Oh(i, n, s)) {
      Qr(
        200,
        {
          reasonOrId: `rowModelType = '${s}'`,
          moduleName: i,
          gridScoped: Pp(),
          gridId: n,
          rowModelType: s
        },
        `Missing module ${i}Module for rowModelType ${s}.`
      );
      return;
    }
    const r = /* @__PURE__ */ new Set();
    return t.forEach((a) => {
      var l;
      return (l = a.beans) == null ? void 0 : l.forEach((d) => r.add(d));
    }), Array.from(r);
  }
};
function l0(e) {
  return e ?? "clientSide";
}
var V5 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "localeSvc";
  }
  getLocaleTextFunc() {
    const e = this.gos, t = e.getCallback("getLocaleText");
    return t ? C3(t) : w3(e.get("localeText"));
  }
};
function _5(e, t = !1) {
  const n = [], o = [], s = [], i = [], r = [], a = [], l = [], d = [], c = [];
  let u = 0;
  for (let h = 0; h < e.length; h++) {
    const {
      colId: g,
      sort: p,
      sortIndex: f,
      rowGroup: m,
      rowGroupIndex: C,
      aggFunc: w,
      pivot: b,
      pivotIndex: A,
      pinned: S,
      hide: F,
      width: E,
      flex: M
    } = e[h];
    c.push(g), p && (n[f ?? u++] = { colId: g, sort: p }), m && (o[C ?? 0] = g), typeof w == "string" && s.push({ colId: g, aggFunc: w }), b && (i[A ?? 0] = g), S && (S === "right" ? a : r).push(g), F && l.push(g), (M != null || E) && d.push({ colId: g, flex: M ?? void 0, width: E });
  }
  return {
    sort: n.length ? { sortModel: n } : void 0,
    rowGroup: o.length ? { groupColIds: o } : void 0,
    aggregation: s.length ? { aggregationModel: s } : void 0,
    pivot: i.length || t ? { pivotMode: t, pivotColIds: i } : void 0,
    columnPinning: r.length || a.length ? { leftColIds: r, rightColIds: a } : void 0,
    columnVisibility: l.length ? { hiddenColIds: l } : void 0,
    columnSizing: d.length ? { columnSizingModel: d } : void 0,
    columnOrder: c.length ? { orderedColIds: c } : void 0
  };
}
function N5(e) {
  const t = [];
  return e.forEach(({ groupId: n, open: o }) => {
    o && t.push(n);
  }), t.length ? { openColumnGroupIds: t } : void 0;
}
var $5 = class {
  wrap(e, t, n, o) {
    const s = this.createWrapper(e, o);
    return t == null || t.forEach((i) => {
      this.createMethod(s, i, !0);
    }), n == null || n.forEach((i) => {
      this.createMethod(s, i, !1);
    }), s;
  }
  createMethod(e, t, n) {
    e.addMethod(t, this.createMethodProxy(e, t, n));
  }
  createMethodProxy(e, t, n) {
    return function() {
      return e.hasMethod(t) ? e.callMethod(t, arguments) : (n && Z(49, { methodName: t }), null);
    };
  }
};
function ua(e) {
  return e.get("tooltipShowMode") === "whenTruncated";
}
function Op(e, t) {
  return ua(e) ? ai(t) : void 0;
}
function z5(e, t) {
  if (typeof e != "number")
    return "";
  const n = t(), o = n("thousandSeparator", ","), s = n("decimalSeparator", ".");
  return e.toString().replace(".", s).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${o}`);
}
var W5 = class extends U {
  getFileName(e) {
    const t = this.getDefaultFileExtension();
    return (e == null || !e.length) && (e = this.getDefaultFileName()), e.indexOf(".") === -1 ? `${e}.${t}` : e;
  }
  getData(e) {
    const t = this.createSerializingSession(e);
    return this.beans.gridSerializer.serialize(t, e);
  }
  getDefaultFileName() {
    return `export.${this.getDefaultFileExtension()}`;
  }
}, U5 = class {
  constructor(e) {
    const {
      colModel: t,
      rowGroupColsSvc: n,
      colNames: o,
      valueSvc: s,
      gos: i,
      processCellCallback: r,
      processHeaderCallback: a,
      processGroupHeaderCallback: l,
      processRowGroupCallback: d
    } = e;
    this.colModel = t, this.rowGroupColsSvc = n, this.colNames = o, this.valueSvc = s, this.gos = i, this.processCellCallback = r, this.processHeaderCallback = a, this.processGroupHeaderCallback = l, this.processRowGroupCallback = d;
  }
  prepare(e) {
  }
  extractHeaderValue(e) {
    return this.getHeaderName(this.processHeaderCallback, e) ?? "";
  }
  extractRowCellValue(e, t, n, o, s) {
    var h;
    const i = t === 0 && DC(this.gos, s, this.colModel.isPivotMode());
    if (this.processRowGroupCallback && (this.gos.get("treeData") || s.group) && (e.isRowGroupDisplayed(((h = s.rowGroupColumn) == null ? void 0 : h.getColId()) ?? "") || i))
      return { value: this.processRowGroupCallback(ke(this.gos, { column: e, node: s })) ?? "" };
    if (this.processCellCallback)
      return {
        value: this.processCellCallback(
          ke(this.gos, {
            accumulatedRowIndex: n,
            column: e,
            node: s,
            value: this.valueSvc.getValueForDisplay(e, s, void 0, void 0).value,
            type: o,
            parseValue: (g) => this.valueSvc.parseValue(
              e,
              s,
              g,
              this.valueSvc.getValue(e, s, void 0)
            ),
            formatValue: (g) => this.valueSvc.formatValue(e, s, g) ?? g
          })
        ) ?? ""
      };
    const r = this.gos.get("treeData"), a = this.valueSvc, l = s.level === -1 && s.footer, d = e.colDef.showRowGroup === !0 && (s.group || r);
    if (!l && (i || d)) {
      let g = "", p = s;
      for (; p && p.level !== -1; ) {
        const { value: f, valueFormatted: m } = a.getValueForDisplay(
          i ? void 0 : e,
          // full width group doesn't have a column
          p,
          !0,
          !0
        );
        g = ` -> ${m ?? f ?? ""}${g}`, p = p.parent;
      }
      return {
        value: g,
        // don't return the unformatted value; as if the grid detects number it'll not use the concatenated string
        valueFormatted: g
      };
    }
    const { value: c, valueFormatted: u } = a.getValueForDisplay(e, s, !0, !0);
    return {
      value: c ?? "",
      valueFormatted: u
    };
  }
  getHeaderName(e, t) {
    return e ? e(ke(this.gos, { column: t })) : this.colNames.getDisplayNameForColumn(t, "csv", !0);
  }
};
function K5(e, t) {
  const n = document.defaultView || window;
  if (!n) {
    Z(52);
    return;
  }
  const o = document.createElement("a"), s = n.URL.createObjectURL(t);
  o.setAttribute("href", s), o.setAttribute("download", e), o.style.display = "none", document.body.appendChild(o), o.dispatchEvent(
    new MouseEvent("click", {
      bubbles: !1,
      cancelable: !0,
      view: n
    })
  ), document.body.removeChild(o), n.setTimeout(() => {
    n.URL.revokeObjectURL(s);
  }, 0);
}
var Z5 = {
  enableBrowserTooltips: !0,
  tooltipTrigger: !0,
  tooltipMouseTrack: !0,
  tooltipShowMode: !0,
  tooltipInteraction: !0,
  defaultColGroupDef: !0,
  suppressAutoSize: !0,
  skipHeaderOnAutoSize: !0,
  autoSizeStrategy: !0,
  components: !0,
  stopEditingWhenCellsLoseFocus: !0,
  undoRedoCellEditing: !0,
  undoRedoCellEditingLimit: !0,
  excelStyles: !0,
  cacheQuickFilter: !0,
  customChartThemes: !0,
  chartThemeOverrides: !0,
  chartToolPanelsDef: !0,
  loadingCellRendererSelector: !0,
  localeText: !0,
  keepDetailRows: !0,
  keepDetailRowsCount: !0,
  detailRowHeight: !0,
  detailRowAutoHeight: !0,
  tabIndex: !0,
  valueCache: !0,
  valueCacheNeverExpires: !0,
  enableCellExpressions: !0,
  suppressTouch: !0,
  suppressBrowserResizeObserver: !0,
  suppressPropertyNamesCheck: !0,
  debug: !0,
  dragAndDropImageComponent: !0,
  loadingOverlayComponent: !0,
  suppressLoadingOverlay: !0,
  noRowsOverlayComponent: !0,
  paginationPageSizeSelector: !0,
  paginateChildRows: !0,
  pivotPanelShow: !0,
  pivotSuppressAutoColumn: !0,
  suppressExpandablePivotGroups: !0,
  aggFuncs: !0,
  allowShowChangeAfterFilter: !0,
  ensureDomOrder: !0,
  enableRtl: !0,
  suppressColumnVirtualisation: !0,
  suppressMaxRenderedRowRestriction: !0,
  suppressRowVirtualisation: !0,
  rowDragText: !0,
  groupLockGroupColumns: !0,
  suppressGroupRowsSticky: !0,
  rowModelType: !0,
  cacheOverflowSize: !0,
  infiniteInitialRowCount: !0,
  serverSideInitialRowCount: !0,
  maxBlocksInCache: !0,
  maxConcurrentDatasourceRequests: !0,
  blockLoadDebounceMillis: !0,
  serverSideOnlyRefreshFilteredGroups: !0,
  serverSidePivotResultFieldSeparator: !0,
  viewportRowModelPageSize: !0,
  viewportRowModelBufferSize: !0,
  debounceVerticalScrollbar: !0,
  suppressAnimationFrame: !0,
  suppressPreventDefaultOnMouseWheel: !0,
  scrollbarWidth: !0,
  icons: !0,
  suppressRowTransform: !0,
  gridId: !0,
  enableGroupEdit: !0,
  initialState: !0,
  processUnpinnedColumns: !0,
  createChartContainer: !0,
  getLocaleText: !0,
  getRowId: !0,
  reactiveCustomComponents: !0,
  renderingMode: !0,
  columnMenu: !0,
  suppressSetFilterByDefault: !0,
  getDataPath: !0,
  enableCellSpan: !0,
  enableFilterHandlers: !0,
  filterHandlers: !0
}, Cn = "clientSide", Xt = "serverSide", Gi = "infinite", q5 = {
  onGroupExpandedOrCollapsed: [Cn],
  refreshClientSideRowModel: [Cn],
  isRowDataEmpty: [Cn],
  forEachLeafNode: [Cn],
  forEachNodeAfterFilter: [Cn],
  forEachNodeAfterFilterAndSort: [Cn],
  resetRowHeights: [Cn, Xt],
  applyTransaction: [Cn],
  applyTransactionAsync: [Cn],
  flushAsyncTransactions: [Cn],
  getBestCostNodeSelection: [Cn],
  getServerSideSelectionState: [Xt],
  setServerSideSelectionState: [Xt],
  applyServerSideTransaction: [Xt],
  applyServerSideTransactionAsync: [Xt],
  applyServerSideRowData: [Xt],
  retryServerSideLoads: [Xt],
  flushServerSideAsyncTransactions: [Xt],
  refreshServerSide: [Xt],
  getServerSideGroupLevelState: [Xt],
  refreshInfiniteCache: [Gi],
  purgeInfiniteCache: [Gi],
  getInfiniteRowCount: [Gi],
  isLastRowIndexKnown: [Gi, Xt],
  expandAll: [Cn, Xt],
  collapseAll: [Cn, Xt],
  onRowHeightChanged: [Cn, Xt],
  setRowCount: [Gi, Xt],
  getCacheBlockState: [Gi, Xt]
}, j5 = {
  showLoadingOverlay: {
    version: "v32",
    message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
  },
  clearRangeSelection: {
    version: "v32.2",
    message: "Use `clearCellSelection` instead."
  },
  getInfiniteRowCount: {
    version: "v32.2",
    old: "getInfiniteRowCount()",
    new: "getDisplayedRowCount()"
  },
  selectAllFiltered: {
    version: "v33",
    old: "selectAllFiltered()",
    new: 'selectAll("filtered")'
  },
  deselectAllFiltered: {
    version: "v33",
    old: "deselectAllFiltered()",
    new: 'deselectAll("filtered")'
  },
  selectAllOnCurrentPage: {
    version: "v33",
    old: "selectAllOnCurrentPage()",
    new: 'selectAll("currentPage")'
  },
  deselectAllOnCurrentPage: {
    version: "v33",
    old: "deselectAllOnCurrentPage()",
    new: 'deselectAll("currentPage")'
  }
};
function Y5(e, t, n) {
  const o = j5[e];
  if (o) {
    const { version: i, new: r, old: a, message: l } = o, d = a ?? e;
    return (...c) => {
      const u = r ? `Please use ${r} instead. ` : "";
      return ra(`Since ${i} api.${d} is deprecated. ${u}${l ?? ""}`), t.apply(t, c);
    };
  }
  const s = q5[e];
  return s ? (...i) => {
    const r = n.rowModel.getType();
    if (!s.includes(r)) {
      Qi(
        `api.${e} can only be called when gridOptions.rowModelType is ${s.join(" or ")}`
      );
      return;
    }
    return t.apply(t, i);
  } : t;
}
var Q5 = {
  detailCellRendererCtrl: "SharedMasterDetail",
  dndSourceComp: "DragAndDrop",
  fillHandle: "CellSelection",
  groupCellRendererCtrl: "GroupCellRenderer",
  headerFilterCellCtrl: "ColumnFilter",
  headerGroupCellCtrl: "ColumnGroup",
  rangeHandle: "CellSelection",
  tooltipFeature: "Tooltip",
  highlightTooltipFeature: "Tooltip",
  tooltipStateManager: "Tooltip",
  groupStrategy: "RowGrouping",
  treeGroupStrategy: "TreeData",
  rowNumberRowResizer: "RowNumbers",
  singleCell: "EditCore",
  fullRow: "EditCore",
  agSetColumnFilterHandler: "SetFilter",
  agMultiColumnFilterHandler: "MultiFilter",
  agGroupColumnFilterHandler: "GroupFilter",
  agNumberColumnFilterHandler: "NumberFilter",
  agDateColumnFilterHandler: "DateFilter",
  agTextColumnFilterHandler: "TextFilter"
}, J5 = {
  expanded: 1,
  contracted: 1,
  "tree-closed": 1,
  "tree-open": 1,
  "tree-indeterminate": 1,
  pin: 1,
  "eye-slash": 1,
  arrows: 1,
  left: 1,
  right: 1,
  group: 1,
  aggregation: 1,
  pivot: 1,
  "not-allowed": 1,
  chart: 1,
  cross: 1,
  cancel: 1,
  tick: 1,
  first: 1,
  previous: 1,
  next: 1,
  last: 1,
  linked: 1,
  unlinked: 1,
  "color-picker": 1,
  loading: 1,
  menu: 1,
  "menu-alt": 1,
  filter: 1,
  "filter-add": 1,
  columns: 1,
  maximize: 1,
  minimize: 1,
  copy: 1,
  cut: 1,
  paste: 1,
  grip: 1,
  save: 1,
  csv: 1,
  excel: 1,
  "small-down": 1,
  "small-left": 1,
  "small-right": 1,
  "small-up": 1,
  asc: 1,
  desc: 1,
  none: 1,
  up: 1,
  down: 1,
  plus: 1,
  minus: 1,
  settings: 1,
  "checkbox-checked": 1,
  "checkbox-indeterminate": 1,
  "checkbox-unchecked": 1,
  "radio-button-on": 1,
  "radio-button-off": 1,
  eye: 1,
  "column-arrow": 1,
  "un-pin": 1,
  "pinned-top": 1,
  "pinned-bottom": 1,
  "chevron-up": 1,
  "chevron-down": 1,
  "chevron-left": 1,
  "chevron-right": 1,
  edit: 1
}, X5 = {
  chart: "MenuCore",
  cancel: "EnterpriseCore",
  first: "Pagination",
  previous: "Pagination",
  next: "Pagination",
  last: "Pagination",
  linked: "IntegratedCharts",
  loadingMenuItems: "MenuCore",
  unlinked: "IntegratedCharts",
  menu: "ColumnHeaderComp",
  legacyMenu: "ColumnMenu",
  filter: "ColumnFilter",
  filterActive: "ColumnFilter",
  filterAdd: "NewFiltersToolPanel",
  filterCardCollapse: "NewFiltersToolPanel",
  filterCardExpand: "NewFiltersToolPanel",
  filterCardEditing: "NewFiltersToolPanel",
  filterTab: "ColumnMenu",
  filtersToolPanel: "FiltersToolPanel",
  columns: ["MenuCore"],
  columnsToolPanel: ["ColumnsToolPanel"],
  maximize: "EnterpriseCore",
  minimize: "EnterpriseCore",
  save: "MenuCore",
  columnGroupOpened: "ColumnGroupHeaderComp",
  columnGroupClosed: "ColumnGroupHeaderComp",
  accordionOpen: "EnterpriseCore",
  accordionClosed: "EnterpriseCore",
  accordionIndeterminate: "EnterpriseCore",
  columnSelectClosed: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectOpen: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectIndeterminate: ["ColumnsToolPanel", "ColumnMenu"],
  columnMovePin: "SharedDragAndDrop",
  columnMoveHide: "SharedDragAndDrop",
  columnMoveMove: "SharedDragAndDrop",
  columnMoveLeft: "SharedDragAndDrop",
  columnMoveRight: "SharedDragAndDrop",
  columnMoveGroup: "SharedDragAndDrop",
  columnMoveValue: "SharedDragAndDrop",
  columnMovePivot: "SharedDragAndDrop",
  dropNotAllowed: "SharedDragAndDrop",
  ensureColumnVisible: ["ColumnsToolPanel", "ColumnMenu"],
  groupContracted: "GroupCellRenderer",
  groupExpanded: "GroupCellRenderer",
  setFilterGroupClosed: "SetFilter",
  setFilterGroupOpen: "SetFilter",
  setFilterGroupIndeterminate: "SetFilter",
  setFilterLoading: "SetFilter",
  close: "EnterpriseCore",
  check: "MenuItem",
  colorPicker: "CommunityCore",
  groupLoading: "LoadingCellRenderer",
  menuAlt: "ColumnHeaderComp",
  menuPin: "MenuCore",
  menuValue: "MenuCore",
  menuAddRowGroup: ["MenuCore", "ColumnsToolPanel"],
  menuRemoveRowGroup: ["MenuCore", "ColumnsToolPanel"],
  clipboardCopy: "MenuCore",
  clipboardCut: "MenuCore",
  clipboardPaste: "MenuCore",
  pivotPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  rowGroupPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  valuePanel: "ColumnsToolPanel",
  columnDrag: "EnterpriseCore",
  rowDrag: ["RowDrag", "DragAndDrop"],
  csvExport: "MenuCore",
  excelExport: "MenuCore",
  smallDown: "CommunityCore",
  selectOpen: "CommunityCore",
  richSelectOpen: "RichSelect",
  richSelectRemove: "RichSelect",
  smallLeft: "CommunityCore",
  smallRight: "CommunityCore",
  subMenuOpen: "MenuItem",
  subMenuOpenRtl: "MenuItem",
  panelDelimiter: "RowGroupingPanel",
  panelDelimiterRtl: "RowGroupingPanel",
  smallUp: "CommunityCore",
  sortAscending: ["MenuCore", "Sort"],
  sortDescending: ["MenuCore", "Sort"],
  sortUnSort: ["MenuCore", "Sort"],
  advancedFilterBuilder: "AdvancedFilter",
  advancedFilterBuilderDrag: "AdvancedFilter",
  advancedFilterBuilderInvalid: "AdvancedFilter",
  advancedFilterBuilderMoveUp: "AdvancedFilter",
  advancedFilterBuilderMoveDown: "AdvancedFilter",
  advancedFilterBuilderAdd: "AdvancedFilter",
  advancedFilterBuilderRemove: "AdvancedFilter",
  advancedFilterBuilderSelectOpen: "AdvancedFilter",
  chartsMenu: "IntegratedCharts",
  chartsMenuEdit: "IntegratedCharts",
  chartsMenuAdvancedSettings: "IntegratedCharts",
  chartsMenuAdd: "IntegratedCharts",
  chartsColorPicker: "IntegratedCharts",
  chartsThemePrevious: "IntegratedCharts",
  chartsThemeNext: "IntegratedCharts",
  chartsDownload: "IntegratedCharts",
  checkboxChecked: "CommunityCore",
  checkboxIndeterminate: "CommunityCore",
  checkboxUnchecked: "CommunityCore",
  radioButtonOn: "CommunityCore",
  radioButtonOff: "CommunityCore",
  rowPin: "PinnedRow",
  rowUnpin: "PinnedRow",
  rowPinBottom: "PinnedRow",
  rowPinTop: "PinnedRow"
}, eB = /* @__PURE__ */ new Set([
  "colorPicker",
  "smallUp",
  "checkboxChecked",
  "checkboxIndeterminate",
  "checkboxUnchecked",
  "radioButtonOn",
  "radioButtonOff",
  "smallDown",
  "smallLeft",
  "smallRight"
]), tB = class extends U {
  constructor() {
    super(...arguments), this.beanName = "validation";
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, F3(B5);
  }
  warnOnInitialPropertyUpdate(e, t) {
    e === "api" && Z5[t] && Z(22, { key: t });
  }
  processGridOptions(e) {
    this.processOptions(e, qk());
  }
  validateApiFunction(e, t) {
    return Y5(e, t, this.beans);
  }
  missingUserComponent(e, t, n, o) {
    const s = or[t];
    s ? this.gos.assertModuleRegistered(
      s,
      `AG Grid '${e}' component: ${t}`
    ) : Z(101, {
      propertyName: e,
      componentName: t,
      agGridDefaults: n,
      jsComps: o
    });
  }
  missingDynamicBean(e) {
    const t = Q5[e];
    return t ? Eo(200, {
      ...this.gos.getModuleErrorParams(),
      moduleName: t,
      reasonOrId: e
    }) : void 0;
  }
  checkRowEvents(e) {
    oB.has(e) && Z(10, { eventType: e });
  }
  validateIcon(e) {
    if (eB.has(e) && Z(43, { iconName: e }), J5[e])
      return;
    const t = X5[e];
    if (t) {
      $e(200, {
        reasonOrId: `icon '${e}'`,
        moduleName: t,
        gridScoped: Pp(),
        gridId: this.beans.context.getId(),
        rowModelType: this.gos.get("rowModelType"),
        additionalText: "Alternatively, use the CSS icon name directly."
      });
      return;
    }
    Z(134, { iconName: e });
  }
  isProvidedUserComp(e) {
    return !!or[e];
  }
  /** Should only be called via the GridOptionsService */
  validateColDef(e) {
    this.processOptions(e, Hk());
  }
  processOptions(e, t) {
    const { validations: n, deprecations: o, allProperties: s, propertyExceptions: i, objectName: r, docsUrl: a } = t;
    s && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(
      e,
      [...i ?? [], ...Object.keys(o)],
      s,
      r,
      a
    );
    const l = /* @__PURE__ */ new Set();
    Object.keys(e).forEach((c) => {
      const u = o[c];
      if (u) {
        const { message: w, version: b } = u;
        l.add(`As of v${b}, ${String(c)} is deprecated. ${w ?? ""}`);
      }
      const h = e[c];
      if (h == null || h === !1)
        return;
      const g = n[c];
      if (!g)
        return;
      const { dependencies: p, validate: f, supportedRowModels: m, expectedType: C } = g;
      if (C) {
        const w = typeof h;
        if (w !== C) {
          l.add(
            `${String(c)} should be of type '${C}' but received '${w}' (${h}).`
          );
          return;
        }
      }
      if (m) {
        const w = this.gridOptions.rowModelType ?? "clientSide";
        if (!m.includes(w)) {
          l.add(
            `${String(c)} is not supported with the '${w}' row model. It is only valid with: ${m.join(", ")}.`
          );
          return;
        }
      }
      if (p) {
        const w = this.checkForRequiredDependencies(c, p, e);
        if (w) {
          l.add(w);
          return;
        }
      }
      if (f) {
        const w = f(e, this.gridOptions, this.beans);
        if (w) {
          l.add(w);
          return;
        }
      }
    }), l.size > 0 && l.forEach((c) => {
      ra(c);
    });
  }
  checkForRequiredDependencies(e, t, n) {
    const s = Object.entries(t).filter(([i, r]) => {
      const a = n[i];
      return !r.required.includes(a);
    });
    return s.length === 0 ? null : s.map(
      ([i, r]) => `'${String(e)}' requires '${i}' to be one of [${r.required.map((a) => a === null ? "null" : a === void 0 ? "undefined" : a).join(", ")}]. ${r.reason ?? ""}`
    ).join(`
           `);
  }
  checkProperties(e, t, n, o, s) {
    const i = ["__ob__", "__v_skip", "__metadata__"], r = nB(
      Object.getOwnPropertyNames(e),
      [...i, ...t, ...n],
      n
    ), a = Object.keys(r);
    for (const l of a) {
      const d = r[l];
      let c = `invalid ${o} property '${l}' did you mean any of these: ${d.slice(0, 8).join(", ")}.`;
      n.includes("context") && (c += `
If you are trying to annotate ${o} with application data, use the '${o}.context' property instead.`), ra(c);
    }
    if (a.length > 0 && s) {
      const l = this.beans.frameworkOverrides.getDocLink(s);
      ra(`to see all the valid ${o} properties please check: ${l}`);
    }
  }
};
function nB(e, t, n) {
  const o = {}, s = e.filter(
    (i) => !t.some((r) => r === i)
  );
  return s.length > 0 && s.forEach(
    (i) => o[i] = La({ inputValue: i, allSuggestions: n }).values
  ), o;
}
var oB = /* @__PURE__ */ new Set([
  "firstChildChanged",
  "lastChildChanged",
  "childIndexChanged"
]), sB = {
  moduleName: "Validation",
  version: Ee,
  beans: [tB]
};
function Hy(e) {
  e.sibling && (e.sibling.childrenAfterFilter = e.childrenAfterFilter);
}
var iB = class extends U {
  constructor() {
    super(...arguments), this.beanName = "filterStage", this.refreshProps = /* @__PURE__ */ new Set(["excludeChildrenWhenTreeDataFiltering"]), this.step = "filter";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    const { changedPath: t } = e;
    this.filter(t);
  }
  filter(e) {
    var n;
    const t = !!((n = this.filterManager) != null && n.isChildFilterPresent());
    this.filterNodes(t, e);
  }
  filterNodes(e, t) {
    const n = (o, s) => {
      o.hasChildren() && e && !s ? o.childrenAfterFilter = o.childrenAfterGroup.filter((i) => {
        const r = i.childrenAfterFilter && i.childrenAfterFilter.length > 0, a = i.data && this.filterManager.doesRowPassFilter({ rowNode: i });
        return r || a;
      }) : o.childrenAfterFilter = o.childrenAfterGroup, Hy(o);
    };
    if (this.doingTreeDataFiltering()) {
      const o = (i, r) => {
        if (i.childrenAfterGroup)
          for (let a = 0; a < i.childrenAfterGroup.length; a++) {
            const l = i.childrenAfterGroup[a], d = r || this.filterManager.doesRowPassFilter({ rowNode: l });
            l.childrenAfterGroup ? o(i.childrenAfterGroup[a], d) : n(l, d);
          }
        n(i, r);
      }, s = (i) => o(i, !1);
      t.executeFromRootNode(s);
    } else {
      const o = (s) => n(s, !1);
      t.forEachChangedNodeDepthFirst(o, !0);
    }
  }
  doingTreeDataFiltering() {
    return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
  }
}, rB = class extends Fp {
  constructor() {
    super(...arguments), this.iconCreated = !1;
  }
  wireComp(e, t, n, o, s) {
    this.comp = e;
    const i = Ja(this, this.beans.context, s);
    this.eButtonShowMainFilter = n, this.eFloatingFilterBody = o, this.setGui(t, i), this.setupActive(), this.refreshHeaderStyles(), this.setupWidth(i), this.setupLeft(i), this.setupHover(i), this.setupFocus(i), this.setupAria(), this.setupFilterButton(), this.setupUserComp(), this.setupSyncWithFilter(i), this.setupUi(), i.addManagedElementListeners(this.eButtonShowMainFilter, { click: this.showParentFilter.bind(this) }), this.setupFilterChangedListener(i);
    const r = () => this.onColDefChanged(i);
    i.addManagedListeners(this.column, { colDefChanged: r }), i.addManagedEventListeners({
      filterSwitched: ({ column: a }) => {
        a === this.column && r();
      }
    }), i.addDestroyFunc(() => {
      this.eButtonShowMainFilter = null, this.eFloatingFilterBody = null, this.userCompDetails = null, this.clearComponent();
    });
  }
  // empty abstract method
  resizeHeader() {
  }
  moveHeader() {
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, n = e.colDef;
    return ke(t.gos, {
      colDef: n,
      column: e,
      floatingFilter: !0
    });
  }
  setupActive() {
    const e = this.column.getColDef(), t = !!e.filter, n = !!e.floatingFilter;
    this.active = t && n;
  }
  setupUi() {
    if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton), !this.active || this.iconCreated)
      return;
    const e = Le("filter", this.beans, this.column);
    e && (this.iconCreated = !0, this.eButtonShowMainFilter.appendChild(e));
  }
  setupFocus(e) {
    e.createManagedBean(
      new Hs(this.eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    );
  }
  setupAria() {
    const e = this.getLocaleTextFunc();
    yt(this.eButtonShowMainFilter, e("ariaFilterMenuOpen", "Open Filter Menu"));
  }
  onTabKeyDown(e) {
    var r;
    const { beans: t } = this;
    if (je(t) === this.eGui)
      return;
    const s = sn(t, this.eGui, null, e.shiftKey);
    if (s) {
      (r = t.headerNavigation) == null || r.scrollToColumn(this.column), e.preventDefault(), s.focus();
      return;
    }
    const i = this.findNextColumnWithFloatingFilter(e.shiftKey);
    i && t.focusSvc.focusHeaderPosition({
      headerPosition: {
        headerRowIndex: this.rowCtrl.rowIndex,
        column: i
      },
      event: e
    }) && e.preventDefault();
  }
  findNextColumnWithFloatingFilter(e) {
    const t = this.beans.visibleCols;
    let n = this.column;
    do
      if (n = e ? t.getColBefore(n) : t.getColAfter(n), !n)
        break;
    while (!n.getColDef().filter || !n.getColDef().floatingFilter);
    return n;
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case O.UP:
      case O.DOWN:
      case O.LEFT:
      case O.RIGHT:
        if (t)
          return;
        bt(e);
      case O.ENTER:
        t && pn(this.eGui) && e.preventDefault();
        break;
      case O.ESCAPE:
        t || this.eGui.focus();
    }
  }
  onFocusIn(e) {
    if (this.eGui.contains(e.relatedTarget))
      return;
    const n = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), o = !!e.relatedTarget && ri(e.relatedTarget, "ag-floating-filter");
    if (n && o && e.target === this.eGui) {
      const s = this.lastFocusEvent, i = !!(s && s.key === O.TAB);
      if (s && i) {
        const r = s.shiftKey;
        pn(this.eGui, r);
      }
    }
    this.focusThis();
  }
  setupHover(e) {
    var t;
    (t = this.beans.colHover) == null || t.addHeaderFilterColumnHoverListener(e, this.comp, this.column, this.eGui);
  }
  setupLeft(e) {
    const t = new Ap(this.column, this.eGui, this.beans);
    e.createManagedBean(t);
  }
  setupFilterButton() {
    var e;
    this.suppressFilterButton = !((e = this.beans.menuSvc) != null && e.isFloatingFilterButtonEnabled(this.column)), this.highlightFilterButtonWhenActive = !Nt(this.gos);
  }
  setupUserComp() {
    var t;
    if (!this.active)
      return;
    const e = (t = this.beans.colFilter) == null ? void 0 : t.getFloatingFilterCompDetails(
      this.column,
      () => this.showParentFilter()
    );
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setCompDetails(e);
  }
  showParentFilter() {
    var t;
    const e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
    (t = this.beans.menuSvc) == null || t.showFilterMenu({
      column: this.column,
      buttonElement: e,
      containerType: "floatingFilter",
      positionBy: "button"
    });
  }
  setupSyncWithFilter(e) {
    if (!this.active)
      return;
    const {
      beans: { colFilter: t },
      column: n,
      gos: o
    } = this, s = (i) => {
      if ((i == null ? void 0 : i.source) === "filterDestroyed" && (!this.isAlive() || !(t != null && t.isAlive())))
        return;
      const r = this.comp.getFloatingFilterComp();
      r && r.then((a) => {
        if (a) {
          if (o.get("enableFilterHandlers")) {
            const c = i;
            let u = "filter";
            c != null && c.afterFloatingFilter ? u = "ui" : c != null && c.afterDataChange ? u = "dataChanged" : (i == null ? void 0 : i.source) === "api" && (u = "api"), this.updateFloatingFilterParams(this.userCompDetails, u);
            return;
          }
          const l = t == null ? void 0 : t.getCurrentFloatingFilterParentModel(n), d = i ? {
            // event can have additional params like `afterDataChange` which need to be passed through
            ...i,
            columns: i.columns ?? [],
            source: i.source === "api" ? "api" : "columnFilter"
          } : null;
          a.onParentModelChanged(l, d);
        }
      });
    };
    [this.destroySyncListener] = e.addManagedListeners(n, { filterChanged: s }), t != null && t.isFilterActive(n) && s(null);
  }
  setupWidth(e) {
    const t = () => {
      const n = `${this.column.getActualWidth()}px`;
      this.comp.setWidth(n);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupFilterChangedListener(e) {
    this.active && ([this.destroyFilterChangedListener] = e.addManagedListeners(this.column, {
      filterChanged: this.updateFilterButton.bind(this)
    }), this.updateFilterButton());
  }
  updateFilterButton() {
    var e;
    if (!this.suppressFilterButton && this.comp) {
      const t = !!((e = this.beans.filterManager) != null && e.isFilterAllowed(this.column));
      this.comp.setButtonWrapperDisplayed(t), this.highlightFilterButtonWhenActive && t && this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
    }
  }
  onColDefChanged(e) {
    const t = this.active;
    this.setupActive();
    const n = !t && this.active;
    t && !this.active && (this.destroySyncListener(), this.destroyFilterChangedListener());
    const o = this.beans.colFilter, s = this.active ? o == null ? void 0 : o.getFloatingFilterCompDetails(this.column, () => this.showParentFilter()) : null, i = this.comp.getFloatingFilterComp();
    !i || !s ? this.updateCompDetails(e, s, n) : i.then((r) => {
      !r || o != null && o.areFilterCompsDifferent(this.userCompDetails ?? null, s) ? this.updateCompDetails(e, s, n) : this.updateFloatingFilterParams(s, "colDef");
    });
  }
  updateCompDetails(e, t, n) {
    this.isAlive() && (this.setCompDetails(t), this.setupFilterButton(), this.setupUi(), n && (this.setupSyncWithFilter(e), this.setupFilterChangedListener(e)));
  }
  updateFloatingFilterParams(e, t) {
    var o;
    if (!e)
      return;
    let n = e.params;
    (o = this.comp.getFloatingFilterComp()) == null || o.then((s) => {
      var i;
      typeof (s == null ? void 0 : s.refresh) == "function" && (this.gos.get("enableFilterHandlers") && (n = {
        ...n,
        model: _t(((i = this.beans.colFilter) == null ? void 0 : i.model) ?? {}, this.column.getColId()),
        source: t
      }), s.refresh(n));
    });
  }
  addResizeAndMoveKeyboardListeners() {
  }
  destroy() {
    super.destroy(), this.destroySyncListener = null, this.destroyFilterChangedListener = null;
  }
};
function aB(e, t) {
  var o;
  const n = e.colModel.getCol(t);
  if (!n) {
    $e(12, { colKey: t });
    return;
  }
  (o = e.menuSvc) == null || o.showColumnMenu({
    column: n,
    positionBy: "auto"
  });
}
function lB(e) {
  var t;
  (t = e.menuSvc) == null || t.hidePopupMenu();
}
var Vy = {
  moduleName: "SharedMenu",
  version: Ee,
  beans: [SP],
  apiFunctions: {
    showColumnMenu: aB,
    hidePopupMenu: lB
  }
}, dB = class extends tI {
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridCtrl = e.gridCtrl;
    }), this.addManagedEventListeners({ gridStylesChanged: this.handleThemeChange.bind(this) });
  }
  getDefaultPopupParent() {
    return this.gridCtrl.getGui();
  }
  positionPopupForMenu(e) {
    const { eventSource: t, ePopup: n, event: o } = e, s = t.getBoundingClientRect(), i = this.getParentRect();
    this.setAlignedTo(t, n);
    let r = !1;
    const a = () => {
      const l = this.keepXYWithinBounds(
        n,
        s.top - i.top,
        0
        /* Vertical */
      ), d = n.clientWidth > 0 ? n.clientWidth : 200;
      r || (n.style.minWidth = `${d}px`, r = !0);
      const u = i.right - i.left - d;
      let h;
      return this.gos.get("enableRtl") ? (h = p(), h < 0 && (h = g(), this.setAlignedStyles(n, "left")), h > u && (h = 0, this.setAlignedStyles(n, "right"))) : (h = g(), h > u && (h = p(), this.setAlignedStyles(n, "right")), h < 0 && (h = 0, this.setAlignedStyles(n, "left"))), { x: h, y: l };
      function g() {
        return s.right - i.left - 2;
      }
      function p() {
        return s.left - i.left - d;
      }
    };
    this.positionPopup({
      ePopup: n,
      keepWithinBounds: !0,
      updatePosition: a,
      postProcessCallback: () => this.callPostProcessPopup(
        e,
        "subMenu",
        n,
        t,
        o instanceof MouseEvent ? o : void 0
      )
    });
  }
  callPostProcessPopup(e, t, n, o, s) {
    const i = this.gos.getCallback("postProcessPopup");
    if (i) {
      const { column: r, rowNode: a } = e;
      i({
        column: r,
        rowNode: a,
        ePopup: n,
        type: t,
        eventSource: o,
        mouseEvent: s
      });
    }
  }
  getActivePopups() {
    return this.popupList.map((e) => e.element);
  }
  handleThemeChange(e) {
    if (e.themeChanged) {
      const t = this.beans.environment;
      for (const n of this.popupList)
        t.applyThemeClasses(n.wrapper);
    }
  }
  hasAnchoredPopup() {
    return this.popupList.some((e) => e.isAnchored);
  }
  isStopPropagation(e) {
    return Dn(e);
  }
}, Vs = {
  moduleName: "Popup",
  version: Ee,
  beans: [dB]
}, cB = (
  /*css*/
  ".ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}:where(.ag-floating-filter-full-body)>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]),:where(.ag-input-field-input[type=datetime-local]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-date-floating-filter-wrapper{display:flex}.ag-set-floating-filter-input :where(input)[disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{align-items:unset;background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:solid var(--ag-border-width) var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}"
);
function uB(e) {
  const t = e.filterManager;
  return !!(t != null && t.isColumnFilterPresent()) || !!(t != null && t.isAggregateFilterPresent());
}
function hB(e, t) {
  var n;
  return ((n = e.filterManager) == null ? void 0 : n.getColumnFilterInstance(t)) ?? Promise.resolve(void 0);
}
function gB(e, t) {
  var o;
  const n = e.colModel.getColDefCol(t);
  if (n)
    return (o = e.colFilter) == null ? void 0 : o.destroyFilter(n, "api");
}
function pB(e, t) {
  e.frameworkOverrides.wrapIncoming(() => {
    var n;
    return (n = e.filterManager) == null ? void 0 : n.setFilterModel(t);
  });
}
function fB(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getFilterModel()) ?? {};
}
function mB(e, t, n) {
  const { gos: o, colModel: s, colFilter: i } = e;
  n && !o.get("enableFilterHandlers") && (Z(288), n = !1);
  const r = s.getColDefCol(t);
  return r ? (i == null ? void 0 : i.getModelForColumn(r, n)) ?? null : null;
}
function vB(e, t, n) {
  var o;
  return ((o = e.filterManager) == null ? void 0 : o.setColumnFilterModel(t, n)) ?? Promise.resolve();
}
function CB(e, t) {
  var o;
  const n = e.colModel.getCol(t);
  if (!n) {
    $e(12, { colKey: t });
    return;
  }
  (o = e.menuSvc) == null || o.showFilterMenu({
    column: n,
    containerType: "columnFilter",
    positionBy: "auto"
  });
}
function wB(e) {
  var t;
  (t = e.menuSvc) == null || t.hideFilterMenu();
}
function yB(e, t) {
  var o;
  const n = e.colModel.getCol(t);
  if (!n) {
    $e(12, { colKey: t });
    return;
  }
  return (o = e.colFilter) == null ? void 0 : o.getHandler(n, !0);
}
function bB(e, t) {
  const { colModel: n, colFilter: o, gos: s } = e;
  if (!s.get("enableFilterHandlers")) {
    Z(287);
    return;
  }
  const { colId: i, action: r } = t;
  if (i) {
    const a = n.getColById(i);
    a && (o == null || o.updateModel(a, r));
  } else
    o == null || o.updateAllModels(r);
}
var SB = {
  filterHandler: () => ({
    doesFilterPass: () => !0
  })
}, xB = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colFilter", this.allColumnFilters = /* @__PURE__ */ new Map(), this.allColumnListeners = /* @__PURE__ */ new Map(), this.activeAggregateFilters = [], this.activeColumnFilters = [], this.processingFilterChange = !1, this.modelUpdates = [], this.columnModelUpdates = [], this.state = /* @__PURE__ */ new Map(), this.handlerMap = {
      ...Rw
    }, this.isGlobalButtons = !1, this.activeFilterComps = /* @__PURE__ */ new Set();
  }
  postConstruct() {
    var n, o;
    this.addManagedEventListeners({
      gridColumnsChanged: this.onColumnsChanged.bind(this),
      dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
    });
    const e = this.gos, t = {
      ...((o = (n = e.get("initialState")) == null ? void 0 : n.filter) == null ? void 0 : o.filterModel) ?? {}
    };
    this.initialModel = t, this.model = {
      ...t
    }, e.get("enableFilterHandlers") || delete this.handlerMap.agMultiColumnFilter;
  }
  refreshModel() {
    this.onNewRowsLoaded("rowDataUpdated");
  }
  setModel(e, t = "api", n) {
    const { colModel: o, dataTypeSvc: s, filterManager: i } = this.beans;
    if (s != null && s.isPendingInference) {
      this.modelUpdates.push({ model: e, source: t });
      return;
    }
    const r = [], a = this.getModel(!0);
    if (e) {
      const l = new Set(Object.keys(e));
      this.allColumnFilters.forEach((d, c) => {
        const u = e[c];
        r.push(this.setModelOnFilterWrapper(d, u)), l.delete(c);
      }), l.forEach((d) => {
        const c = o.getColDefCol(d) || o.getCol(d);
        if (!c) {
          Z(62, { colId: d });
          return;
        }
        if (!c.isFilterAllowed()) {
          Z(63, { colId: d });
          return;
        }
        const u = this.getOrCreateFilterWrapper(c, !0);
        if (!u) {
          Z(64, { colId: d });
          return;
        }
        r.push(this.setModelOnFilterWrapper(u, e[d], !0));
      });
    } else
      this.model = {}, this.allColumnFilters.forEach((l) => {
        r.push(this.setModelOnFilterWrapper(l, null));
      });
    tt.all(r).then(() => {
      const l = this.getModel(!0), d = [];
      this.allColumnFilters.forEach((c, u) => {
        const h = a ? a[u] : null, g = l ? l[u] : null;
        pr(h, g) || d.push(c.column);
      }), d.length > 0 ? i == null || i.onFilterChanged({ columns: d, source: t }) : n && this.updateActive("filterChanged");
    });
  }
  getModel(e) {
    var i;
    const t = {}, {
      allColumnFilters: n,
      initialModel: o,
      beans: { colModel: s }
    } = this;
    if (n.forEach((r, a) => {
      const l = this.getModelFromFilterWrapper(r);
      ue(l) && (t[a] = l);
    }), !e)
      for (const r of Object.keys(o)) {
        const a = o[r];
        ue(a) && !n.has(r) && ((i = s.getCol(r)) != null && i.isFilterAllowed()) && (t[r] = a);
      }
    return t;
  }
  setState(e, t, n = "api") {
    if (this.state.clear(), t)
      for (const o of Object.keys(t)) {
        const s = t[o];
        this.state.set(o, {
          model: _t(this.model, o),
          state: s
        });
      }
    this.setModel(e, n, !0);
  }
  getState() {
    const e = this.state;
    if (!e.size)
      return;
    const t = {};
    let n = !1;
    return e.forEach((o, s) => {
      const i = o.state;
      i != null && (n = !0, t[s] = i);
    }), n ? t : void 0;
  }
  getModelFromFilterWrapper(e) {
    const n = e.column.getColId();
    if (e.isHandler)
      return _t(this.model, n);
    const o = e.filter;
    return o ? typeof o.getModel != "function" ? (Z(66), null) : o.getModel() : _t(this.initialModel, n);
  }
  isFilterPresent() {
    return this.activeColumnFilters.length > 0;
  }
  isAggFilterPresent() {
    return !!this.activeAggregateFilters.length;
  }
  disableFilters() {
    this.initialModel = {};
    const { allColumnFilters: e } = this;
    return e.size ? (e.forEach(
      (t) => this.disposeFilterWrapper(t, "advancedFilterEnabled")
    ), !0) : !1;
  }
  updateActiveFilters() {
    const e = (d) => d ? d.isFilterActive ? d.isFilterActive() : (Z(67), !1) : !1, { colModel: t, gos: n } = this.beans, o = !!Da(n), s = (d) => {
      if (!d.isPrimary())
        return !0;
      const u = !t.isPivotActive();
      return !d.isValueActive() || !u ? !1 : t.isPivotMode() ? !0 : o;
    }, i = [], r = [], a = (d, c, u) => {
      c && (s(d) ? i.push(u) : r.push(u));
    }, l = [];
    return this.allColumnFilters.forEach((d) => {
      const c = d.column, u = c.getColId();
      if (d.isHandler)
        l.push(
          tt.resolve().then(() => {
            a(c, this.isHandlerActive(c), {
              colId: u,
              isHandler: !0,
              handler: d.handler,
              handlerParams: d.handlerParams
            });
          })
        );
      else {
        const h = as(d);
        h && l.push(
          h.then((g) => {
            a(c, e(g), {
              colId: u,
              isHandler: !1,
              comp: g
            });
          })
        );
      }
    }), tt.all(l).then(() => {
      this.activeAggregateFilters = i, this.activeColumnFilters = r;
    });
  }
  updateFilterFlagInColumns(e, t) {
    var o;
    const n = [];
    return this.allColumnFilters.forEach((s) => {
      const i = s.column;
      if (s.isHandler)
        n.push(
          tt.resolve().then(() => {
            this.setColFilterActive(
              i,
              this.isHandlerActive(i),
              e,
              t
            );
          })
        );
      else {
        const r = as(s);
        r && n.push(
          r.then((a) => {
            this.setColFilterActive(
              i,
              a.isFilterActive(),
              e,
              t
            );
          })
        );
      }
    }), (o = this.beans.groupFilter) == null || o.updateFilterFlags(e, t), tt.all(n);
  }
  doFiltersPass(e, t, n) {
    const { data: o, aggData: s } = e, i = n ? this.activeAggregateFilters : this.activeColumnFilters, r = n ? s : o, a = this.model;
    for (let l = 0; l < i.length; l++) {
      const d = i[l], { colId: c, isHandler: u } = d;
      if (c !== t)
        if (u) {
          const { handler: h, handlerParams: g } = d;
          if (!h.doesFilterPass({
            node: e,
            data: r,
            model: _t(a, c),
            handlerParams: g
          }))
            return !1;
        } else {
          const h = d.comp;
          if (typeof h.doesFilterPass != "function") {
            $e(91);
            continue;
          }
          if (!h.doesFilterPass({ node: e, data: r }))
            return !1;
        }
    }
    return !0;
  }
  getHandlerParams(e) {
    const t = this.allColumnFilters.get(e.getColId());
    return t != null && t.isHandler ? t.handlerParams : void 0;
  }
  // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
  // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
  // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
  // which results in React State getting applied in the main application, triggering a useEffect() to
  // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
  // getting it's useEffect() triggered in this way.
  callOnFilterChangedOutsideRenderCycle(e) {
    const { rowRenderer: t, filterManager: n } = this.beans, o = () => {
      this.isAlive() && (n == null || n.onFilterChanged(e));
    };
    t.isRefreshInProgress() ? setTimeout(o, 0) : o();
  }
  updateBeforeFilterChanged(e = {}) {
    const { column: t, additionalEventAttributes: n } = e, o = t == null ? void 0 : t.getColId();
    return this.updateActiveFilters().then(
      () => this.updateFilterFlagInColumns("filterChanged", n).then(() => {
        this.allColumnFilters.forEach((s) => {
          var a, l, d;
          const { column: i, isHandler: r } = s;
          o !== i.getColId() && (r && ((l = (a = s.handler).onAnyFilterChanged) == null || l.call(a)), (d = as(s, r)) == null || d.then((c) => {
            typeof (c == null ? void 0 : c.onAnyFilterChanged) == "function" && c.onAnyFilterChanged();
          }));
        }), this.processingFilterChange = !0;
      })
    );
  }
  updateAfterFilterChanged() {
    this.processingFilterChange = !1;
  }
  isSuppressFlashingCellsBecauseFiltering() {
    return !(this.gos.get("allowShowChangeAfterFilter") ?? !1) && this.processingFilterChange;
  }
  onNewRowsLoaded(e) {
    const t = [];
    this.allColumnFilters.forEach((n) => {
      var i, r;
      const o = n.isHandler;
      o && ((r = (i = n.handler).onNewRowsLoaded) == null || r.call(i));
      const s = as(n, o);
      s && t.push(
        s.then((a) => {
          var l;
          (l = a.onNewRowsLoaded) == null || l.call(a);
        })
      );
    }), tt.all(t).then(() => this.updateActive(e, { afterDataChange: !0 }));
  }
  updateActive(e, t) {
    this.updateFilterFlagInColumns(e, t).then(() => this.updateActiveFilters());
  }
  createGetValue(e, t) {
    const { filterValueSvc: n, colModel: o } = this.beans;
    return (s, i) => {
      const r = i ? o.getCol(i) : e;
      return r ? n.getValue(r, s, t) : void 0;
    };
  }
  isFilterActive(e) {
    const t = this.cachedFilter(e);
    if (t != null && t.isHandler)
      return this.isHandlerActive(e);
    const n = t == null ? void 0 : t.filter;
    return n ? n.isFilterActive() : _t(this.initialModel, e.getColId()) != null;
  }
  isHandlerActive(e) {
    const t = ue(_t(this.model, e.getColId()));
    if (t)
      return t;
    const n = this.beans.groupFilter;
    return n != null && n.isGroupFilter(e) ? n.isFilterActive(e) : !1;
  }
  getOrCreateFilterUi(e) {
    const t = this.getOrCreateFilterWrapper(e, !0);
    return t ? as(t) : null;
  }
  getFilterUiForDisplay(e) {
    const t = this.getOrCreateFilterWrapper(e, !0);
    if (!t)
      return null;
    const n = as(t);
    return n ? n.then((o) => ({
      comp: o,
      params: t.filterUi.filterParams,
      isHandler: t.isHandler
    })) : null;
  }
  getHandler(e, t) {
    const n = this.getOrCreateFilterWrapper(e, t);
    return n != null && n.isHandler ? n.handler : void 0;
  }
  getOrCreateFilterWrapper(e, t) {
    if (!e.isFilterAllowed())
      return;
    let n = this.cachedFilter(e);
    return !n && t && (n = this.createFilterWrapper(e), this.setColumnFilterWrapper(e, n)), n;
  }
  cachedFilter(e) {
    return this.allColumnFilters.get(e.getColId());
  }
  getDefaultFilter(e, t = !1) {
    return this.getDefaultFilterFromDataType(() => {
      var n;
      return (n = this.beans.dataTypeSvc) == null ? void 0 : n.getBaseDataType(e);
    }, t);
  }
  getDefaultFilterFromDataType(e, t = !1) {
    return _3(this.gos) ? t ? "agSetColumnFloatingFilter" : "agSetColumnFilter" : wI(e(), t);
  }
  getDefaultFloatingFilter(e) {
    return this.getDefaultFilter(e, !0);
  }
  createFilterComp(e, t, n, o, s, i) {
    const r = () => {
      const d = this.createFilterCompParams(e, s, i), c = o(d, s);
      return _F(this.beans.userCompFactory, t, c, n);
    }, a = r();
    return a ? {
      compDetails: a,
      createFilterUi: (d) => (d ? r() : a).newAgStackInstance()
    } : null;
  }
  createFilterInstance(e, t, n, o) {
    var u, h;
    const s = this.beans.selectableFilter;
    s != null && s.isSelectable(t) && (t = s.getFilterDef(e, t));
    const { handler: i, handlerParams: r, handlerGenerator: a } = this.createHandler(e, t, n) ?? {}, l = this.createFilterComp(
      e,
      t,
      n,
      o,
      !!i,
      "init"
    );
    if (!l)
      return {
        compDetails: null,
        createFilterUi: null,
        handler: i,
        handlerGenerator: a,
        handlerParams: r
      };
    const { compDetails: d, createFilterUi: c } = l;
    return this.isGlobalButtons && ((h = (u = d.params) == null ? void 0 : u.buttons) != null && h.length || Z(281, { colId: e.getColId() })), {
      compDetails: d,
      handler: i,
      handlerGenerator: a,
      handlerParams: r,
      createFilterUi: c
    };
  }
  createBaseFilterParams(e, t) {
    const { filterManager: n, rowModel: o } = this.beans;
    return ke(this.gos, {
      column: e,
      colDef: e.getColDef(),
      getValue: this.createGetValue(e),
      doesRowPassOtherFilter: t ? () => !0 : (s) => (n == null ? void 0 : n.doesRowPassOtherFilters(e.getColId(), s)) ?? !0,
      // to avoid breaking changes to `filterParams` defined as functions
      // we need to provide the below options even though they are not valid for handlers
      rowModel: o
    });
  }
  createFilterCompParams(e, t, n, o) {
    const s = this.filterChangedCallbackFactory(e), i = this.createBaseFilterParams(e, o);
    if (i.filterChangedCallback = s, i.filterModifiedCallback = o ? () => {
    } : (r) => this.filterModified(e, r), t) {
      const r = i, a = e.getColId(), l = _t(this.model, a);
      r.model = l, r.state = this.state.get(a) ?? {
        model: l
      }, r.onModelChange = (d, c) => {
        this.updateStoredModel(a, d), this.refreshHandlerAndUi(e, d, "ui").then(() => {
          s({ ...c, source: "columnFilter" });
        });
      }, r.onStateChange = (d) => {
        this.updateState(e, d), this.updateOrRefreshFilterUi(e);
      }, r.onAction = (d, c, u) => {
        this.updateModel(e, d, c), this.dispatchLocalEvent({
          type: "filterAction",
          column: e,
          action: d,
          event: u
        });
      }, r.getHandler = () => this.getHandler(e, !0), r.onUiChange = (d) => this.filterUiChanged(e, d), r.source = n;
    }
    return i;
  }
  createFilterUiForHandler(e, t) {
    return t ? {
      created: !1,
      create: t,
      filterParams: e.params,
      compDetails: e
    } : null;
  }
  createFilterUiLegacy(e, t, n) {
    const o = t(), s = {
      created: !0,
      create: t,
      filterParams: e.params,
      compDetails: e,
      promise: o
    };
    return o.then(n), s;
  }
  createFilterWrapper(e) {
    var a;
    const { compDetails: t, handler: n, handlerGenerator: o, handlerParams: s, createFilterUi: i } = this.createFilterInstance(
      e,
      e.getColDef(),
      this.getDefaultFilter(e),
      (l) => l
    ), r = e.getColId();
    if (n)
      return delete this.initialModel[r], (a = n.init) == null || a.call(n, {
        ...s,
        source: "init",
        model: _t(this.model, r)
      }), {
        column: e,
        isHandler: !0,
        handler: n,
        handlerGenerator: o,
        handlerParams: s,
        filterUi: this.createFilterUiForHandler(t, i)
      };
    if (i) {
      const l = {
        column: e,
        filterUi: null,
        isHandler: !1
      };
      return l.filterUi = this.createFilterUiLegacy(t, i, (d) => {
        l.filter = d ?? void 0;
      }), l;
    }
    return {
      column: e,
      filterUi: null,
      isHandler: !1
    };
  }
  createHandlerFunc(e, t, n) {
    var g;
    const { gos: o, frameworkOverrides: s, registry: i } = this.beans;
    let r;
    const a = (p) => {
      const f = p.filter;
      if (nw(f)) {
        const m = f.handler;
        return m || (r = f.doesFilterPass, r ? () => ({
          doesFilterPass: r
        }) : void 0);
      }
      return typeof f == "string" ? f : void 0;
    }, l = o.get("enableFilterHandlers"), d = l ? a(t) : void 0, c = (p) => () => this.createBean(i.createDynamicBean(p, !0));
    let u, h;
    if (typeof d == "string") {
      const p = (g = o.get("filterHandlers")) == null ? void 0 : g[d];
      p != null ? u = p : lI.has(d) && (u = c(d), h = d);
    } else
      u = d;
    if (!u) {
      let p;
      const { compName: f, jsComp: m, fwComp: C } = rw(s, t);
      f ? p = f : m == null && C == null && t.filter === !0 && (p = n), h = this.handlerMap[p], h && (u = c(h));
    }
    return u ? { filterHandler: u, handlerNameOrCallback: r ?? h } : l ? (Ct(o) && Z(277, { colId: e.getColId() }), SB) : void 0;
  }
  createHandler(e, t, n) {
    const o = this.createHandlerFunc(e, t, n);
    if (!o)
      return;
    const s = au(
      this.beans.userCompFactory,
      t,
      this.createFilterCompParams(e, !0, "init")
    ), { handlerNameOrCallback: i, filterHandler: r } = o, { handler: a, handlerParams: l } = this.createHandlerFromFunc(e, r, s);
    return {
      handler: a,
      handlerParams: l,
      handlerGenerator: i ?? r
    };
  }
  createHandlerFromFunc(e, t, n) {
    const o = e.getColDef(), s = t(ke(this.gos, { column: e, colDef: o })), i = this.createHandlerParams(e, n);
    return { handler: s, handlerParams: i };
  }
  createHandlerParams(e, t) {
    const n = e.getColDef(), o = e.getColId(), s = this.filterChangedCallbackFactory(e);
    return ke(this.gos, {
      colDef: n,
      column: e,
      getValue: this.createGetValue(e),
      doesRowPassOtherFilter: (i) => {
        var r;
        return ((r = this.beans.filterManager) == null ? void 0 : r.doesRowPassOtherFilters(o, i)) ?? !0;
      },
      onModelChange: (i, r) => {
        this.updateStoredModel(o, i), this.refreshHandlerAndUi(e, i, "handler").then(() => {
          s({ ...r, source: "columnFilter" });
        });
      },
      filterParams: t
    });
  }
  onColumnsChanged() {
    const e = [], { colModel: t, filterManager: n, groupFilter: o } = this.beans;
    this.allColumnFilters.forEach((i, r) => {
      let a;
      i.column.isPrimary() ? a = t.getColDefCol(r) : a = t.getCol(r), !(a && a === i.column) && (e.push(i.column), this.disposeFilterWrapper(i, "columnChanged"), this.disposeColumnListener(r));
    });
    const s = o && e.every((i) => o.isGroupFilter(i));
    e.length > 0 && !s && (n == null || n.onFilterChanged({ columns: e, source: "api" }));
  }
  isFilterAllowed(e) {
    if (!e.isFilterAllowed())
      return !1;
    const n = this.beans.groupFilter;
    return n != null && n.isGroupFilter(e) ? n.isFilterAllowed(e) : !0;
  }
  getFloatingFilterCompDetails(e, t) {
    const { userCompFactory: n, frameworkOverrides: o, selectableFilter: s } = this.beans, i = (h) => {
      const g = this.getOrCreateFilterUi(e);
      g != null && g.then((p) => {
        h(Sr(p));
      });
    }, r = e.getColDef(), a = s != null && s.isSelectable(r) ? s.getFilterDef(e, r) : r, l = bI(o, a, () => this.getDefaultFloatingFilter(e)) ?? "agReadOnlyFloatingFilter", d = this.gos.get("enableFilterHandlers"), c = au(
      n,
      a,
      this.createFilterCompParams(e, d, "init", !0)
    ), u = ke(this.gos, {
      column: e,
      filterParams: c,
      currentParentModel: () => this.getCurrentFloatingFilterParentModel(e),
      parentFilterInstance: i,
      showParentFilter: t
    });
    if (d) {
      const h = u, g = e.getColId(), p = this.filterChangedCallbackFactory(e);
      h.onUiChange = (f) => this.floatingFilterUiChanged(e, f), h.model = _t(this.model, g), h.onModelChange = (f, m) => {
        this.updateStoredModel(g, f), this.refreshHandlerAndUi(e, f, "floating", !0).then(() => {
          p({ ...m, source: "columnFilter" });
        });
      }, h.getHandler = () => this.getHandler(e, !0), h.source = "init";
    }
    return UF(n, r, u, l);
  }
  getCurrentFloatingFilterParentModel(e) {
    return this.getModelFromFilterWrapper(this.cachedFilter(e) ?? { column: e });
  }
  destroyFilterUi(e, t, n, o) {
    if (e.isHandler) {
      const s = t.getColId();
      delete this.initialModel[s], this.state.delete(s);
      const i = e.filterUi, r = this.createFilterUiForHandler(n, o);
      e.filterUi = r, i != null && i.created && i.promise.then((a) => {
        this.destroyBean(a), this.eventSvc.dispatchEvent({
          type: "filterDestroyed",
          source: "paramsUpdated",
          column: e.column
        });
      });
    } else
      this.destroyFilter(t, "paramsUpdated");
  }
  // destroys the filter, so it no longer takes part
  destroyFilter(e, t = "api") {
    const n = e.getColId(), o = this.allColumnFilters.get(n);
    this.disposeColumnListener(n), delete this.initialModel[n], o && this.disposeFilterWrapper(o, t).then((s) => {
      var i;
      s && this.isAlive() && ((i = this.beans.filterManager) == null || i.onFilterChanged({
        columns: [e],
        source: "api"
      }));
    });
  }
  disposeColumnListener(e) {
    const t = this.allColumnListeners.get(e);
    t && (this.allColumnListeners.delete(e), t());
  }
  disposeFilterWrapper(e, t) {
    let n = !1;
    const { column: o, isHandler: s, filterUi: i } = e, r = o.getColId();
    s && (n = this.isHandlerActive(o), this.destroyBean(e.handler), delete this.model[r], this.state.delete(r));
    const a = () => {
      this.setColFilterActive(o, !1, "filterDestroyed"), this.allColumnFilters.delete(r), this.eventSvc.dispatchEvent({
        type: "filterDestroyed",
        source: t,
        column: o
      });
    };
    if (i) {
      if (i.created)
        return i.promise.then((l) => (n = s ? n : !!(l != null && l.isFilterActive()), this.destroyBean(l), a(), n));
      a();
    }
    return tt.resolve(n);
  }
  filterChangedCallbackFactory(e) {
    return (t) => {
      this.callOnFilterChangedOutsideRenderCycle({
        additionalEventAttributes: t,
        columns: [e],
        column: e,
        source: (t == null ? void 0 : t.source) ?? "columnFilter"
      });
    };
  }
  filterParamsChanged(e, t = "api") {
    var m, C, w, b, A, S;
    const n = this.allColumnFilters.get(e);
    if (!n)
      return;
    const o = this.beans, s = n.column, i = s.getColDef(), r = s.isFilterAllowed(), a = this.getDefaultFilter(s), l = o.selectableFilter, d = l != null && l.isSelectable(i) ? l.getFilterDef(s, i) : i, c = r ? this.createHandlerFunc(s, d, this.getDefaultFilter(s)) : void 0, u = !!c, h = n.isHandler;
    if (h != u) {
      this.destroyFilter(s, "paramsUpdated");
      return;
    }
    const { compDetails: g, createFilterUi: p } = (r ? this.createFilterComp(s, d, a, (F) => F, u, "colDef") : null) ?? { compDetails: null, createFilterUi: null }, f = (g == null ? void 0 : g.params) ?? au(
      o.userCompFactory,
      d,
      this.createFilterCompParams(s, u, "colDef")
    );
    if (h) {
      const F = (c == null ? void 0 : c.handlerNameOrCallback) ?? (c == null ? void 0 : c.filterHandler), E = _t(this.model, e);
      if (n.handlerGenerator != F) {
        const M = n.handler, { handler: I, handlerParams: P } = this.createHandlerFromFunc(
          s,
          c.filterHandler,
          f
        );
        n.handler = I, n.handlerParams = P, n.handlerGenerator = F, delete this.model[e], (m = I.init) == null || m.call(I, { ...P, source: "init", model: null }), this.destroyBean(M), E != null && ((C = this.beans.filterManager) == null || C.onFilterChanged({
          columns: [s],
          source: t
        }));
      } else {
        const M = this.createHandlerParams(s, g == null ? void 0 : g.params);
        n.handlerParams = M, (b = (w = n.handler).refresh) == null || b.call(w, {
          ...M,
          source: "colDef",
          model: E
        });
      }
    }
    if (this.areFilterCompsDifferent(((A = n.filterUi) == null ? void 0 : A.compDetails) ?? null, g) || !n.filterUi || !g) {
      this.destroyFilterUi(n, s, g, p);
      return;
    }
    n.filterUi.filterParams = f, (S = as(n, h)) == null || S.then((F) => {
      (F != null && F.refresh ? F.refresh(f) : !0) === !1 ? this.destroyFilterUi(n, s, g, p) : this.dispatchLocalEvent({
        type: "filterParamsChanged",
        column: s,
        params: f
      });
    });
  }
  refreshHandlerAndUi(e, t, n, o) {
    const s = this.cachedFilter(e);
    if (!s)
      return o && this.getOrCreateFilterWrapper(e, !0), tt.resolve();
    if (!s.isHandler)
      return tt.resolve();
    const { filterUi: i, handler: r, handlerParams: a } = s;
    return dI(
      () => {
        if (i) {
          const { created: l, filterParams: d } = i;
          if (l)
            return i.promise.then((c) => c ? { filter: c, filterParams: d } : void 0);
          i.refreshed = !0;
        }
        return tt.resolve(void 0);
      },
      r,
      a,
      t,
      this.state.get(e.getColId()) ?? { model: t },
      n
    );
  }
  setColumnFilterWrapper(e, t) {
    const n = e.getColId();
    this.allColumnFilters.set(n, t), this.allColumnListeners.set(
      n,
      this.addManagedListeners(e, { colDefChanged: () => this.filterParamsChanged(n) })[0]
    );
  }
  areFilterCompsDifferent(e, t) {
    if (!t || !e)
      return !0;
    const { componentClass: n } = e, { componentClass: o } = t;
    return !(n === o || // react hooks returns new wrappers, so check nested render method
    (n == null ? void 0 : n.render) && (o == null ? void 0 : o.render) && n.render === o.render);
  }
  hasFloatingFilters() {
    return this.beans.colModel.getCols().some((t) => t.getColDef().floatingFilter);
  }
  getFilterInstance(e) {
    const t = this.beans.colModel.getColDefCol(e);
    if (!t)
      return Promise.resolve(void 0);
    const n = this.getOrCreateFilterUi(t);
    return n ? new Promise((o) => {
      n.then((s) => {
        o(Sr(s));
      });
    }) : Promise.resolve(null);
  }
  processFilterModelUpdateQueue() {
    this.modelUpdates.forEach(({ model: e, source: t }) => this.setModel(e, t)), this.modelUpdates = [], this.columnModelUpdates.forEach(({ key: e, model: t, resolve: n }) => {
      this.setModelForColumn(e, t).then(() => n());
    }), this.columnModelUpdates = [];
  }
  getModelForColumn(e, t) {
    if (t) {
      const { state: o, model: s } = this, i = e.getColId(), r = o.get(i);
      return r ? r.model ?? null : _t(s, i);
    }
    const n = this.cachedFilter(e);
    return n ? this.getModelFromFilterWrapper(n) : null;
  }
  setModelForColumn(e, t) {
    var n;
    if ((n = this.beans.dataTypeSvc) != null && n.isPendingInference) {
      let o = () => {
      };
      const s = new Promise((i) => {
        o = i;
      });
      return this.columnModelUpdates.push({ key: e, model: t, resolve: o }), s;
    }
    return new Promise((o) => {
      this.setModelForColumnLegacy(e, t).then((s) => o(s));
    });
  }
  getStateForColumn(e) {
    return this.state.get(e) ?? {
      model: _t(this.model, e)
    };
  }
  setModelForColumnLegacy(e, t) {
    const n = this.beans.colModel.getColDefCol(e), o = n ? this.getOrCreateFilterWrapper(n, !0) : null;
    return o ? this.setModelOnFilterWrapper(o, t) : tt.resolve();
  }
  setColDefPropsForDataType(e, t, n) {
    var c;
    const o = e.filter, s = o === !0 ? this.getDefaultFilterFromDataType(() => t.baseDataType) : o;
    if (typeof s != "string")
      return;
    let i, r;
    const a = this.beans, { filterParams: l, filterValueGetter: d } = e;
    s === "agMultiColumnFilter" ? { filterParams: i, filterValueGetter: r } = ((c = a.multiFilter) == null ? void 0 : c.getParamsForDataType(
      l,
      d,
      t,
      n
    )) ?? {} : { filterParams: i, filterValueGetter: r } = mI(
      s,
      l,
      d,
      t,
      n,
      a,
      this.getLocaleTextFunc()
    ), e.filterParams = i, r && (e.filterValueGetter = r);
  }
  // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
  setColFilterActive(e, t, n, o) {
    e.filterActive !== t && (e.filterActive = t, e.dispatchColEvent("filterActiveChanged", n)), e.dispatchColEvent("filterChanged", n, o);
  }
  setModelOnFilterWrapper(e, t, n) {
    return new tt((o) => {
      if (e.isHandler) {
        const i = e.column, r = i.getColId(), a = this.model[r];
        if (this.updateStoredModel(r, t), n && t === a) {
          o();
          return;
        }
        this.refreshHandlerAndUi(i, t, "api").then(() => o());
        return;
      }
      const s = as(e);
      if (s) {
        s.then((i) => {
          if (typeof (i == null ? void 0 : i.setModel) != "function") {
            Z(65), o();
            return;
          }
          (i.setModel(t) || tt.resolve()).then(() => o());
        });
        return;
      }
      o();
    });
  }
  /** for handlers only */
  updateStoredModel(e, t) {
    ue(t) ? this.model[e] = t : delete this.model[e];
    const n = this.state.get(e), o = {
      model: t,
      state: n == null ? void 0 : n.state
    };
    this.state.set(e, o);
  }
  filterModified(e, t) {
    var n;
    (n = this.getOrCreateFilterUi(e)) == null || n.then((o) => {
      this.eventSvc.dispatchEvent({
        type: "filterModified",
        column: e,
        filterInstance: o,
        ...t
      });
    });
  }
  filterUiChanged(e, t) {
    this.gos.get("enableFilterHandlers") && this.eventSvc.dispatchEvent({
      type: "filterUiChanged",
      column: e,
      ...t
    });
  }
  floatingFilterUiChanged(e, t) {
    this.gos.get("enableFilterHandlers") && this.eventSvc.dispatchEvent({
      type: "floatingFilterUiChanged",
      column: e,
      ...t
    });
  }
  updateModel(e, t, n) {
    var r;
    const o = e.getColId(), s = this.cachedFilter(e), i = () => s == null ? void 0 : s.filterUi;
    bm(
      t,
      i,
      () => _t(this.model, o),
      () => this.state.get(o),
      (a) => this.updateState(e, a),
      (a) => {
        var l, d;
        return (d = (l = i()) == null ? void 0 : l.filterParams) == null ? void 0 : d.onModelChange(a, n);
      },
      s != null && s.isHandler ? (r = s.handler.processModelToApply) == null ? void 0 : r.bind(s.handler) : void 0
    );
  }
  updateAllModels(e, t) {
    const n = [];
    this.allColumnFilters.forEach((o, s) => {
      var r;
      const i = this.beans.colModel.getColDefCol(s);
      i && bm(
        e,
        () => o.filterUi,
        () => _t(this.model, s),
        () => this.state.get(s),
        (a) => this.updateState(i, a),
        (a) => {
          this.updateStoredModel(s, a), this.dispatchLocalEvent({
            type: "filterAction",
            column: i,
            action: e
          }), n.push(this.refreshHandlerAndUi(i, a, "ui"));
        },
        o != null && o.isHandler ? (r = o.handler.processModelToApply) == null ? void 0 : r.bind(o.handler) : void 0
      );
    }), n.length && tt.all(n).then(() => {
      this.callOnFilterChangedOutsideRenderCycle({
        source: "columnFilter",
        additionalEventAttributes: t,
        columns: []
      });
    });
  }
  updateOrRefreshFilterUi(e) {
    const t = e.getColId();
    Aw(
      () => {
        var n;
        return (n = this.cachedFilter(e)) == null ? void 0 : n.filterUi;
      },
      () => _t(this.model, t),
      () => this.state.get(t)
    );
  }
  updateState(e, t) {
    this.state.set(e.getColId(), t), this.dispatchLocalEvent({
      type: "filterStateChanged",
      column: e,
      state: t
    });
  }
  // for tool panel only
  canApplyAll() {
    const { state: e, model: t, activeFilterComps: n } = this;
    for (const s of n)
      if (s.source === "COLUMN_MENU")
        return !1;
    let o = !1;
    for (const s of e.keys()) {
      const i = e.get(s);
      if (i.valid === !1)
        return !1;
      (i.model ?? null) !== _t(t, s) && (o = !0);
    }
    return o;
  }
  hasUnappliedModel(e) {
    var o;
    const { model: t, state: n } = this;
    return (((o = n.get(e)) == null ? void 0 : o.model) ?? null) !== _t(t, e);
  }
  setGlobalButtons(e) {
    this.isGlobalButtons = e, this.dispatchLocalEvent({
      type: "filterGlobalButtons",
      isGlobal: e
    });
  }
  shouldKeepStateOnDetach(e, t) {
    if (t === "newFiltersToolPanel")
      return !0;
    const n = this.beans.filterPanelSvc;
    return n != null && n.isActive ? !!n.getState(e.getColId()) : !1;
  }
  destroy() {
    super.destroy(), this.allColumnFilters.forEach((e) => this.disposeFilterWrapper(e, "gridDestroyed")), this.allColumnListeners.clear(), this.state.clear(), this.activeFilterComps.clear();
  }
};
function RB(e) {
  var t;
  return !!((t = e.filterManager) != null && t.isAnyFilterPresent());
}
function EB(e, t = "api") {
  var n;
  (n = e.filterManager) == null || n.onFilterChanged({ source: t });
}
var AB = class extends U {
  constructor() {
    super(...arguments), this.beanName = "filterManager", this.advFilterModelUpdateQueue = [];
  }
  wireBeans(e) {
    this.quickFilter = e.quickFilter, this.advancedFilter = e.advancedFilter, this.colFilter = e.colFilter;
  }
  postConstruct() {
    const e = this.refreshFiltersForAggregations.bind(this), t = this.updateAdvFilterColumns.bind(this);
    this.addManagedEventListeners({
      columnValueChanged: e,
      columnPivotChanged: e,
      columnPivotModeChanged: e,
      newColumnsLoaded: t,
      columnVisible: t,
      advancedFilterEnabledChanged: ({ enabled: o }) => this.onAdvFilterEnabledChanged(o),
      dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
    }), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], () => {
      this.onFilterChanged({ source: "api" });
    }), this.updateAggFiltering(), this.addManagedPropertyListener("groupAggFiltering", () => {
      this.updateAggFiltering(), this.onFilterChanged();
    }), this.quickFilter && this.addManagedListeners(this.quickFilter, {
      quickFilterChanged: () => this.onFilterChanged({ source: "quickFilter" })
    });
    const { gos: n } = this;
    this.alwaysPassFilter = n.get("alwaysPassFilter"), this.addManagedPropertyListener("alwaysPassFilter", () => {
      this.alwaysPassFilter = n.get("alwaysPassFilter"), this.onFilterChanged({ source: "api" });
    });
  }
  isExternalFilterPresentCallback() {
    const e = this.gos.getCallback("isExternalFilterPresent");
    return typeof e == "function" && e({});
  }
  doesExternalFilterPass(e) {
    const t = this.gos.get("doesExternalFilterPass");
    return typeof t == "function" && t(e);
  }
  setFilterState(e, t, n = "api") {
    var o;
    this.isAdvFilterEnabled() || (o = this.colFilter) == null || o.setState(e, t, n);
  }
  setFilterModel(e, t = "api", n) {
    var o;
    if (this.isAdvFilterEnabled()) {
      n || this.warnAdvFilters();
      return;
    }
    (o = this.colFilter) == null || o.setModel(e, t);
  }
  getFilterModel() {
    var e;
    return ((e = this.colFilter) == null ? void 0 : e.getModel()) ?? {};
  }
  getFilterState() {
    var e;
    return (e = this.colFilter) == null ? void 0 : e.getState();
  }
  isColumnFilterPresent() {
    var e;
    return !!((e = this.colFilter) != null && e.isFilterPresent());
  }
  isAggregateFilterPresent() {
    var e;
    return !!((e = this.colFilter) != null && e.isAggFilterPresent());
  }
  isChildFilterPresent() {
    return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
  }
  isAnyFilterPresent() {
    return this.isChildFilterPresent() || this.isAggregateFilterPresent();
  }
  isAdvFilterPresent() {
    return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
  }
  onAdvFilterEnabledChanged(e) {
    var t, n;
    e ? (t = this.colFilter) != null && t.disableFilters() && this.onFilterChanged({ source: "advancedFilter" }) : (n = this.advancedFilter) != null && n.isFilterPresent() && (this.advancedFilter.setModel(null), this.onFilterChanged({ source: "advancedFilter" }));
  }
  isAdvFilterEnabled() {
    var e;
    return !!((e = this.advancedFilter) != null && e.isEnabled());
  }
  isAdvFilterHeaderActive() {
    return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
  }
  refreshFiltersForAggregations() {
    Da(this.gos) && this.isAnyFilterPresent() && this.onFilterChanged();
  }
  onFilterChanged(e = {}) {
    const { source: t, additionalEventAttributes: n, columns: o = [] } = e;
    this.externalFilterPresent = this.isExternalFilterPresentCallback(), (this.colFilter ? this.colFilter.updateBeforeFilterChanged(e) : tt.resolve()).then(() => {
      var i;
      const s = {
        source: t,
        type: "filterChanged",
        columns: o
      };
      n && on(s, n), this.eventSvc.dispatchEvent(s), (i = this.colFilter) == null || i.updateAfterFilterChanged();
    });
  }
  isSuppressFlashingCellsBecauseFiltering() {
    var e;
    return !!((e = this.colFilter) != null && e.isSuppressFlashingCellsBecauseFiltering());
  }
  isQuickFilterPresent() {
    var e;
    return !!((e = this.quickFilter) != null && e.isFilterPresent());
  }
  updateAggFiltering() {
    this.aggFiltering = !!Da(this.gos);
  }
  isAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
  }
  isNonAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
  }
  shouldApplyQuickFilterAfterAgg() {
    return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
  }
  doesRowPassOtherFilters(e, t) {
    return this.doesRowPassFilter({ rowNode: t, colIdToSkip: e });
  }
  doesRowPassAggregateFilters(e) {
    var n;
    const { rowNode: t } = e;
    return (n = this.alwaysPassFilter) != null && n.call(this, t) ? !0 : !(this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(t) || this.isAggregateFilterPresent() && !this.colFilter.doFiltersPass(t, e.colIdToSkip, !0));
  }
  doesRowPassFilter(e) {
    var n;
    const { rowNode: t } = e;
    return (n = this.alwaysPassFilter) != null && n.call(this, t) ? !0 : !(this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(t) || this.externalFilterPresent && !this.doesExternalFilterPass(t) || this.isColumnFilterPresent() && !this.colFilter.doFiltersPass(t, e.colIdToSkip) || this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(t));
  }
  // for group filters, can change dynamically whether they are allowed or not
  isFilterAllowed(e) {
    var t;
    return this.isAdvFilterEnabled() ? !1 : !!((t = this.colFilter) != null && t.isFilterAllowed(e));
  }
  getAdvFilterModel() {
    return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
  }
  setAdvFilterModel(e, t = "api") {
    var n;
    if (this.isAdvFilterEnabled()) {
      if ((n = this.beans.dataTypeSvc) != null && n.isPendingInference) {
        this.advFilterModelUpdateQueue.push(e);
        return;
      }
      this.advancedFilter.setModel(e ?? null), this.onFilterChanged({ source: t });
    }
  }
  toggleAdvFilterBuilder(e, t) {
    this.isAdvFilterEnabled() && this.advancedFilter.getCtrl().toggleFilterBuilder({ source: t, force: e });
  }
  updateAdvFilterColumns() {
    this.isAdvFilterEnabled() && this.advancedFilter.updateValidity() && this.onFilterChanged({ source: "advancedFilter" });
  }
  hasFloatingFilters() {
    var e;
    return this.isAdvFilterEnabled() ? !1 : !!((e = this.colFilter) != null && e.hasFloatingFilters());
  }
  getColumnFilterInstance(e) {
    var t;
    return this.isAdvFilterEnabled() ? (this.warnAdvFilters(), Promise.resolve(void 0)) : ((t = this.colFilter) == null ? void 0 : t.getFilterInstance(e)) ?? Promise.resolve(void 0);
  }
  warnAdvFilters() {
    Z(68);
  }
  setupAdvFilterHeaderComp(e) {
    var t;
    (t = this.advancedFilter) == null || t.getCtrl().setupHeaderComp(e);
  }
  getHeaderRowCount() {
    return this.isAdvFilterHeaderActive() ? 1 : 0;
  }
  getHeaderHeight() {
    return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
  }
  processFilterModelUpdateQueue() {
    this.advFilterModelUpdateQueue.forEach((e) => this.setAdvFilterModel(e)), this.advFilterModelUpdateQueue = [];
  }
  setColumnFilterModel(e, t) {
    var n;
    return this.isAdvFilterEnabled() ? (this.warnAdvFilters(), Promise.resolve()) : ((n = this.colFilter) == null ? void 0 : n.setModelForColumn(e, t)) ?? Promise.resolve();
  }
}, FB = class extends U {
  constructor() {
    super(...arguments), this.beanName = "filterMenuFactory";
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  hideActiveMenu() {
    var e;
    (e = this.hidePopup) == null || e.call(this);
  }
  showMenuAfterMouseEvent(e, t, n, o) {
    e && !e.isColumn || this.showPopup(
      e,
      (s) => {
        var i;
        (i = this.popupSvc) == null || i.positionPopupUnderMouseEvent({
          column: e,
          type: n,
          mouseEvent: t,
          ePopup: s
        });
      },
      n,
      t.target,
      Nt(this.gos),
      o
    );
  }
  showMenuAfterButtonClick(e, t, n, o) {
    if (e && !e.isColumn)
      return;
    let s = -1, i = "left";
    const r = Nt(this.gos);
    !r && this.gos.get("enableRtl") && (s = 1, i = "right");
    const a = r ? void 0 : 4 * s, l = r ? void 0 : 4;
    this.showPopup(
      e,
      (d) => {
        var c;
        (c = this.popupSvc) == null || c.positionPopupByComponent({
          type: n,
          eventSource: t,
          ePopup: d,
          nudgeX: a,
          nudgeY: l,
          alignSide: i,
          keepWithinBounds: !0,
          position: "under",
          column: e
        });
      },
      n,
      t,
      r,
      o
    );
  }
  showPopup(e, t, n, o, s, i) {
    var f;
    const r = e ? this.createBean(new Fw(e, "COLUMN_MENU")) : void 0;
    if (this.activeMenu = r, !(r != null && r.hasFilter()) || !e) {
      $e(57);
      return;
    }
    const a = Ue({
      tag: "div",
      cls: `ag-menu${s ? "" : " ag-filter-menu"}`,
      role: "presentation"
    });
    [this.tabListener] = this.addManagedElementListeners(a, {
      keydown: (m) => this.trapFocusWithin(m, a)
    }), a.appendChild(r == null ? void 0 : r.getGui());
    let l;
    const d = () => r == null ? void 0 : r.afterGuiDetached(), c = OC(this.gos) ? o ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0, u = (m) => {
      kd(e, !1, "contextMenu");
      const C = m instanceof KeyboardEvent;
      if (this.tabListener && (this.tabListener = this.tabListener()), C && o && vn(o)) {
        const w = cp(o);
        w == null || w.focus({ preventScroll: !0 });
      }
      d(), this.destroyBean(this.activeMenu), this.dispatchVisibleChangedEvent(!1, n, e), i == null || i();
    }, h = this.getLocaleTextFunc(), g = s && n !== "columnFilter" ? h("ariaLabelColumnMenu", "Column Menu") : h("ariaLabelColumnFilter", "Column Filter"), p = (f = this.popupSvc) == null ? void 0 : f.addPopup({
      modal: !0,
      eChild: a,
      closeOnEsc: !0,
      closedCallback: u,
      positionCallback: () => t(a),
      anchorToElement: c,
      ariaLabel: g
    });
    p && (this.hidePopup = l = p.hideFunc), r.afterInit().then(() => {
      t(a), r.afterGuiAttached({ container: n, hidePopup: l });
    }), kd(e, !0, "contextMenu"), this.dispatchVisibleChangedEvent(!0, n, e);
  }
  trapFocusWithin(e, t) {
    e.key !== O.TAB || e.defaultPrevented || sn(this.beans, t, !1, e.shiftKey) || (e.preventDefault(), pn(t, e.shiftKey));
  }
  dispatchVisibleChangedEvent(e, t, n) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: !1,
      key: t,
      column: n ?? null,
      columnGroup: null
    });
  }
  isMenuEnabled(e) {
    return e.isFilterAllowed() && (e.getColDef().menuTabs ?? ["filterMenuTab"]).includes("filterMenuTab");
  }
  showMenuAfterContextMenuEvent() {
  }
  destroy() {
    this.destroyBean(this.activeMenu), super.destroy();
  }
}, MB = class extends U {
  constructor() {
    super(...arguments), this.beanName = "filterValueSvc";
  }
  getValue(e, t, n) {
    if (!t)
      return;
    const o = e.getColDef(), { selectableFilter: s, valueSvc: i } = this.beans, r = n ?? (s == null ? void 0 : s.getFilterValueGetter(e.getColId())) ?? o.filterValueGetter;
    return r ? this.executeFilterValueGetter(r, t.data, e, t, o) : i.getValue(e, t);
  }
  executeFilterValueGetter(e, t, n, o, s) {
    const { expressionSvc: i, valueSvc: r } = this.beans, a = ke(this.gos, {
      data: t,
      node: o,
      column: n,
      colDef: s,
      getValue: r.getValueCallback.bind(r, o)
    });
    return typeof e == "function" ? e(a) : i == null ? void 0 : i.evaluate(e, a);
  }
}, IB = {
  tag: "div",
  cls: "ag-floating-filter-input",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eFloatingFilterText"
    }
  ]
}, PB = class extends Te {
  constructor() {
    super(IB, [ao]), this.eFloatingFilterText = X;
  }
  init(e) {
    this.params = e;
    const t = this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0);
    if (this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel(`${t} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`), this.gos.get("enableFilterHandlers")) {
      const n = e, o = n.getHandler();
      if (o.getModelAsString) {
        const s = o.getModelAsString(n.model);
        this.eFloatingFilterText.setValue(s);
      }
    }
  }
  onParentModelChanged(e) {
    if (e == null) {
      this.eFloatingFilterText.setValue("");
      return;
    }
    this.params.parentFilterInstance((t) => {
      if (t.getModelAsString) {
        const n = t.getModelAsString(e);
        this.eFloatingFilterText.setValue(n);
      }
    });
  }
  refresh(e) {
    this.init(e);
  }
}, Gp = class {
  constructor() {
    this.customFilterOptions = {};
  }
  init(e, t) {
    this.filterOptions = e.filterOptions ?? t, this.mapCustomOptions(), this.defaultOption = this.getDefaultItem(e.defaultOption);
  }
  refresh(e, t) {
    const n = e.filterOptions ?? t;
    this.filterOptions !== n && (this.filterOptions = n, this.customFilterOptions = {}, this.mapCustomOptions()), this.defaultOption = this.getDefaultItem(e.defaultOption);
  }
  mapCustomOptions() {
    const { filterOptions: e } = this;
    e && e.forEach((t) => {
      if (typeof t == "string")
        return;
      const n = [["displayKey"], ["displayName"], ["predicate", "test"]], o = (s) => s.some((i) => t[i] != null) ? !0 : (Z(72, { keys: s }), !1);
      if (!n.every(o)) {
        this.filterOptions = e.filter((s) => s === t) || [];
        return;
      }
      this.customFilterOptions[t.displayKey] = t;
    });
  }
  getDefaultItem(e) {
    const { filterOptions: t } = this;
    if (e)
      return e;
    if (t.length >= 1) {
      const n = t[0];
      if (typeof n == "string")
        return n;
      if (n.displayKey)
        return n.displayKey;
      Z(73);
    } else
      Z(74);
  }
  getCustomOption(e) {
    return this.customFilterOptions[e];
  }
};
function ha(e, t, n) {
  return n == null ? e.splice(t) : e.splice(t, n);
}
function Hd(e) {
  return e == null || typeof e == "string" && e.trim().length === 0;
}
function DB(e) {
  return e === "AND" || e === "OR" ? e : "AND";
}
function TB(e, t, n) {
  if (e == null)
    return;
  const { predicate: o } = e;
  if (o != null && !t.some((s) => s == null))
    return o(t, n);
}
function kB(e, t) {
  let n = e.length;
  return n > t && (e.splice(t), Z(78), n = t), n;
}
function Ga(e, t) {
  const n = t.getCustomOption(e);
  if (n) {
    const { numberOfInputs: s } = n;
    return s ?? 1;
  }
  return e && ["empty", "notBlank", "blank"].indexOf(e) >= 0 ? 0 : e === "inRange" ? 2 : 1;
}
var Hp = class extends Dw {
  constructor(e, t, n) {
    super(e, "simple-filter"), this.mapValuesFromModel = t, this.defaultOptions = n, this.eTypes = [], this.eJoinPanels = [], this.eJoinAnds = [], this.eJoinOrs = [], this.eConditionBodies = [], this.listener = () => this.onUiChanged(), this.lastUiCompletePosition = null, this.joinOperatorId = 0;
  }
  setParams(e) {
    super.setParams(e);
    const t = new Gp();
    this.optionsFactory = t, t.init(e, this.defaultOptions), this.commonUpdateSimpleParams(e), this.createOption(), this.createMissingConditionsAndOperators();
  }
  updateParams(e, t) {
    this.optionsFactory.refresh(e, this.defaultOptions), super.updateParams(e, t), this.commonUpdateSimpleParams(e);
  }
  commonUpdateSimpleParams(e) {
    this.setNumConditions(e), this.defaultJoinOperator = DB(e.defaultJoinOperator), this.filterPlaceholder = e.filterPlaceholder, this.createFilterListOptions();
    const t = this.getGui();
    this.isReadOnly() ? t.setAttribute("tabindex", "-1") : t.removeAttribute("tabindex");
  }
  // floating filter calls this when user applies filter from floating filter
  onFloatingFilterChanged(e, t) {
    this.setTypeFromFloatingFilter(e), this.setValueFromFloatingFilter(t), this.onUiChanged("immediately", !0);
  }
  setTypeFromFloatingFilter(e) {
    this.eTypes.forEach((t, n) => {
      const o = n === 0 ? e : this.optionsFactory.defaultOption;
      t.setValue(o, !0);
    });
  }
  getModelFromUi() {
    const e = this.getUiCompleteConditions();
    return e.length === 0 ? null : this.maxNumConditions > 1 && e.length > 1 ? {
      filterType: this.filterType,
      operator: this.getJoinOperator(),
      conditions: e
    } : e[0];
  }
  getConditionTypes() {
    return this.eTypes.map((e) => e.getValue());
  }
  getConditionType(e) {
    return this.eTypes[e].getValue();
  }
  getJoinOperator() {
    const { eJoinOrs: e, defaultJoinOperator: t } = this;
    return e.length === 0 ? t : e[0].getValue() === !0 ? "OR" : "AND";
  }
  areNonNullModelsEqual(e, t) {
    const n = !e.operator, o = !t.operator;
    if (!n && o || n && !o)
      return !1;
    let i;
    if (n) {
      const r = e, a = t;
      i = this.areSimpleModelsEqual(r, a);
    } else {
      const r = e, a = t;
      i = r.operator === a.operator && Yn(
        r.conditions,
        a.conditions,
        (l, d) => this.areSimpleModelsEqual(l, d)
      );
    }
    return i;
  }
  setModelIntoUi(e, t) {
    if (e == null)
      return this.resetUiToDefaults(t), tt.resolve();
    if (e.operator) {
      const o = e;
      let s = o.conditions;
      s == null && (s = [], Z(77));
      const i = kB(s, this.maxNumConditions), r = this.getNumConditions();
      if (i < r)
        this.removeConditionsAndOperators(i);
      else if (i > r)
        for (let l = r; l < i; l++)
          this.createJoinOperatorPanel(), this.createOption();
      const a = o.operator === "OR";
      this.eJoinAnds.forEach((l) => l.setValue(!a, !0)), this.eJoinOrs.forEach((l) => l.setValue(a, !0)), s.forEach((l, d) => {
        this.eTypes[d].setValue(l.type, !0), this.setConditionIntoUi(l, d);
      });
    } else {
      const o = e;
      this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(o.type, !0), this.setConditionIntoUi(o, 0);
    }
    return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.updateUiVisibility(), t || this.params.onUiChange(this.getUiChangeEventParams()), tt.resolve();
  }
  setNumConditions(e) {
    let t = e.maxNumConditions ?? 2;
    t < 1 && (Z(79), t = 1), this.maxNumConditions = t;
    let n = e.numAlwaysVisibleConditions ?? 1;
    n < 1 && (Z(80), n = 1), n > t && (Z(81), n = t), this.numAlwaysVisibleConditions = n;
  }
  createOption() {
    const e = this.getGui(), t = this.createManagedBean(new up());
    this.eTypes.push(t), t.addCss("ag-filter-select"), e.appendChild(t.getGui());
    const n = this.createEValue();
    this.eConditionBodies.push(n), e.appendChild(n), this.putOptionsIntoDropdown(t), this.resetType(t);
    const o = this.getNumConditions() - 1;
    this.forEachPositionInput(o, (s) => this.resetInput(s)), this.addChangedListeners(t, o);
  }
  createJoinOperatorPanel() {
    const e = Ue({ tag: "div", cls: "ag-filter-condition" });
    this.eJoinPanels.push(e);
    const t = this.createJoinOperator(this.eJoinAnds, e, "and"), n = this.createJoinOperator(this.eJoinOrs, e, "or");
    this.getGui().appendChild(e);
    const o = this.eJoinPanels.length - 1, s = this.joinOperatorId++;
    this.resetJoinOperatorAnd(t, o, s), this.resetJoinOperatorOr(n, o, s), this.isReadOnly() || (t.onValueChange(this.listener), n.onValueChange(this.listener));
  }
  createJoinOperator(e, t, n) {
    const o = this.createManagedBean(new iM());
    e.push(o);
    const s = "ag-filter-condition-operator";
    return o.addCss(s), o.addCss(`${s}-${n}`), t.appendChild(o.getGui()), o;
  }
  createFilterListOptions() {
    this.filterListOptions = this.optionsFactory.filterOptions.map(
      (e) => typeof e == "string" ? this.createBoilerplateListOption(e) : this.createCustomListOption(e)
    );
  }
  putOptionsIntoDropdown(e) {
    const { filterListOptions: t } = this;
    t.forEach((n) => {
      e.addOption(n);
    }), e.setDisabled(t.length <= 1);
  }
  createBoilerplateListOption(e) {
    return { value: e, text: this.translate(e) };
  }
  createCustomListOption(e) {
    const { displayKey: t } = e, n = this.optionsFactory.getCustomOption(e.displayKey);
    return {
      value: t,
      text: n ? this.getLocaleTextFunc()(n.displayKey, n.displayName) : this.translate(t)
    };
  }
  createBodyTemplate() {
    return null;
  }
  getAgComponents() {
    return [];
  }
  updateUiVisibility() {
    const e = this.getJoinOperator();
    this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, e);
  }
  updateNumConditions() {
    let e = -1, t = !0;
    for (let n = 0; n < this.getNumConditions(); n++)
      this.isConditionUiComplete(n) ? e = n : t = !1;
    if (this.shouldAddNewConditionAtEnd(t))
      this.createJoinOperatorPanel(), this.createOption();
    else {
      const n = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
      if (e < n) {
        this.removeConditionsAndOperators(n + 1);
        const o = e + 1, s = n - o;
        s > 0 && this.removeConditionsAndOperators(o, s), this.createMissingConditionsAndOperators();
      }
    }
    this.lastUiCompletePosition = e;
  }
  updateConditionStatusesAndValues(e, t) {
    this.eTypes.forEach((o, s) => {
      const i = this.isConditionDisabled(s, e);
      o.setDisabled(i || this.filterListOptions.length <= 1), s === 1 && (vi(this.eJoinPanels[0], i), this.eJoinAnds[0].setDisabled(i), this.eJoinOrs[0].setDisabled(i));
    }), this.eConditionBodies.forEach((o, s) => {
      He(o, this.isConditionBodyVisible(s));
    });
    const n = (t ?? this.getJoinOperator()) === "OR";
    this.eJoinAnds.forEach((o) => {
      o.setValue(!n, !0);
    }), this.eJoinOrs.forEach((o) => {
      o.setValue(n, !0);
    }), this.forEachInput((o, s, i, r) => {
      this.setElementDisplayed(o, s < r), this.setElementDisabled(o, this.isConditionDisabled(i, e));
    }), this.resetPlaceholder();
  }
  shouldAddNewConditionAtEnd(e) {
    return e && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
  }
  removeConditionsAndOperators(e, t) {
    if (e >= this.getNumConditions())
      return;
    const {
      eTypes: n,
      eConditionBodies: o,
      eJoinPanels: s,
      eJoinAnds: i,
      eJoinOrs: r
    } = this;
    this.removeComponents(n, e, t), this.removeElements(o, e, t), this.removeEValues(e, t);
    const a = Math.max(e - 1, 0);
    this.removeElements(s, a, t), this.removeComponents(i, a, t), this.removeComponents(r, a, t);
  }
  removeElements(e, t, n) {
    ha(e, t, n).forEach((s) => nn(s));
  }
  removeComponents(e, t, n) {
    ha(e, t, n).forEach((s) => {
      nn(s.getGui()), this.destroyBean(s);
    });
  }
  afterGuiAttached(e) {
    var t;
    if (super.afterGuiAttached(e), this.resetPlaceholder(), !(e != null && e.suppressFocus)) {
      let n;
      if (!this.isReadOnly()) {
        const o = this.getInputs(0)[0];
        o instanceof ti && this.isConditionBodyVisible(0) ? n = o.getInputElement() : n = (t = this.eTypes[0]) == null ? void 0 : t.getFocusableElement();
      }
      (n ?? this.getGui()).focus({ preventScroll: !0 });
    }
  }
  afterGuiDetached() {
    var r;
    super.afterGuiDetached();
    const e = this.params;
    if ((r = this.beans.colFilter) != null && r.shouldKeepStateOnDetach(e.column))
      return;
    e.onStateChange({
      model: e.model
    });
    let t = -1, n = -1, o = !1;
    const s = this.getJoinOperator();
    for (let a = this.getNumConditions() - 1; a >= 0; a--)
      if (this.isConditionUiComplete(a))
        t === -1 && (t = a, n = a);
      else {
        const l = a >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(a - 1), d = a < t;
        (l || d) && (this.removeConditionsAndOperators(a, 1), o = !0, d && n--);
      }
    let i = !1;
    this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), i = !0), this.shouldAddNewConditionAtEnd(n === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), i = !0), i && this.updateConditionStatusesAndValues(n, s), o && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = n;
  }
  getModelAsString(e) {
    var t, n;
    return ((n = (t = this.params.getHandler()) == null ? void 0 : t.getModelAsString) == null ? void 0 : n.call(t, e)) ?? "";
  }
  getPlaceholderText(e, t) {
    let n = this.translate(e);
    if (typeof this.filterPlaceholder == "function") {
      const o = this.eTypes[t].getValue(), s = this.translate(o);
      n = this.filterPlaceholder({
        filterOptionKey: o,
        filterOption: s,
        placeholder: n
      });
    } else typeof this.filterPlaceholder == "string" && (n = this.filterPlaceholder);
    return n;
  }
  // allow sub-classes to reset HTML placeholders after UI update.
  resetPlaceholder() {
    const e = this.getLocaleTextFunc();
    this.forEachInput((t, n, o, s) => {
      if (!(t instanceof ti))
        return;
      const i = n === 0 && s > 1 ? "inRangeStart" : n === 0 ? "filterOoo" : "inRangeEnd", r = n === 0 && s > 1 ? e("ariaFilterFromValue", "Filter from value") : n === 0 ? e("ariaFilterValue", "Filter Value") : e("ariaFilterToValue", "Filter to Value");
      t.setInputPlaceholder(this.getPlaceholderText(i, o)), t.setInputAriaLabel(r);
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setElementValue(e, t, n) {
    e instanceof ti && e.setValue(t != null ? String(t) : null, !0);
  }
  setElementDisplayed(e, t) {
    gm(e) && He(e.getGui(), t);
  }
  setElementDisabled(e, t) {
    gm(e) && vi(e.getGui(), t);
  }
  attachElementOnChange(e, t) {
    e instanceof ti && e.onValueChange(t);
  }
  forEachInput(e) {
    this.getConditionTypes().forEach((t, n) => {
      this.forEachPositionTypeInput(n, t, e);
    });
  }
  forEachPositionInput(e, t) {
    const n = this.getConditionType(e);
    this.forEachPositionTypeInput(e, n, t);
  }
  forEachPositionTypeInput(e, t, n) {
    const o = Ga(t, this.optionsFactory), s = this.getInputs(e);
    for (let i = 0; i < s.length; i++) {
      const r = s[i];
      r != null && n(r, i, e, o);
    }
  }
  isConditionDisabled(e, t) {
    return this.isReadOnly() ? !0 : e === 0 ? !1 : e > t + 1;
  }
  isConditionBodyVisible(e) {
    const t = this.getConditionType(e);
    return Ga(t, this.optionsFactory) > 0;
  }
  // returns true if the UI represents a working filter, eg all parts are filled out.
  // eg if text filter and textfield blank then returns false.
  isConditionUiComplete(e) {
    return !(e >= this.getNumConditions() || this.getConditionType(e) === "empty" || this.getValues(e).some((n) => n == null));
  }
  getNumConditions() {
    return this.eTypes.length;
  }
  getUiCompleteConditions() {
    const e = [];
    for (let t = 0; t < this.getNumConditions(); t++)
      this.isConditionUiComplete(t) && e.push(this.createCondition(t));
    return e;
  }
  createMissingConditionsAndOperators() {
    if (!this.isReadOnly())
      for (let e = this.getNumConditions(); e < this.numAlwaysVisibleConditions; e++)
        this.createJoinOperatorPanel(), this.createOption();
  }
  resetUiToDefaults(e) {
    this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach((t) => this.resetType(t)), this.eJoinAnds.forEach(
      (t, n) => this.resetJoinOperatorAnd(t, n, this.joinOperatorId + n)
    ), this.eJoinOrs.forEach(
      (t, n) => this.resetJoinOperatorOr(t, n, this.joinOperatorId + n)
    ), this.joinOperatorId++, this.forEachInput((t) => this.resetInput(t)), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, this.updateUiVisibility(), e || this.params.onUiChange(this.getUiChangeEventParams());
  }
  resetType(e) {
    const n = this.getLocaleTextFunc()("ariaFilteringOperator", "Filtering operator");
    e.setValue(this.optionsFactory.defaultOption, !0).setAriaLabel(n).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
  }
  resetJoinOperatorAnd(e, t, n) {
    this.resetJoinOperator(
      e,
      t,
      this.defaultJoinOperator === "AND",
      this.translate("andCondition"),
      n
    );
  }
  resetJoinOperatorOr(e, t, n) {
    this.resetJoinOperator(
      e,
      t,
      this.defaultJoinOperator === "OR",
      this.translate("orCondition"),
      n
    );
  }
  resetJoinOperator(e, t, n, o, s) {
    this.updateJoinOperatorDisabled(
      e.setValue(n, !0).setName(`ag-simple-filter-and-or-${this.getCompId()}-${s}`).setLabel(o),
      t
    );
  }
  updateJoinOperatorsDisabled() {
    const e = (t, n) => this.updateJoinOperatorDisabled(t, n);
    this.eJoinAnds.forEach(e), this.eJoinOrs.forEach(e);
  }
  updateJoinOperatorDisabled(e, t) {
    e.setDisabled(this.isReadOnly() || t > 0);
  }
  resetInput(e) {
    this.setElementValue(e, null), this.setElementDisabled(e, this.isReadOnly());
  }
  // puts model values into the UI
  setConditionIntoUi(e, t) {
    const n = this.mapValuesFromModel(e, this.optionsFactory);
    this.forEachInput((o, s, i) => {
      i === t && this.setElementValue(o, n[s] != null ? n[s] : null);
    });
  }
  // after floating filter changes, this sets the 'value' section. this is implemented by the base class
  // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
  setValueFromFloatingFilter(e) {
    this.forEachInput((t, n, o) => {
      this.setElementValue(t, n === 0 && o === 0 ? e : null, !0);
    });
  }
  addChangedListeners(e, t) {
    this.isReadOnly() || (e.onValueChange(this.listener), this.forEachPositionInput(t, (n) => {
      this.attachElementOnChange(n, this.listener);
    }));
  }
  hasInvalidInputs() {
    return !1;
  }
  isReadOnly() {
    return !!this.params.readOnly;
  }
}, _y = class {
  constructor(e, t, n, o, s, i) {
    this.alive = !0, this.context = e, this.eParent = s;
    const r = NF(t, n, o);
    r && r.newAgStackInstance().then((a) => {
      var c, u;
      if (!this.alive) {
        e.destroyBean(a);
        return;
      }
      if (this.dateComp = a, !a)
        return;
      s.appendChild(a.getGui()), (c = a == null ? void 0 : a.afterGuiAttached) == null || c.call(a);
      const { tempValue: l, disabled: d } = this;
      l && a.setDate(l), d != null && ((u = a.setDisabled) == null || u.call(a, d)), i == null || i(this);
    });
  }
  destroy() {
    this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
  }
  getDate() {
    return this.dateComp ? this.dateComp.getDate() : this.tempValue;
  }
  setDate(e) {
    const t = this.dateComp;
    t ? t.setDate(e) : this.tempValue = e;
  }
  setDisabled(e) {
    var n;
    const t = this.dateComp;
    t ? (n = t.setDisabled) == null || n.call(t, e) : this.disabled = e;
  }
  setDisplayed(e) {
    He(this.eParent, e);
  }
  setInputPlaceholder(e) {
    var t, n;
    (n = (t = this.dateComp) == null ? void 0 : t.setInputPlaceholder) == null || n.call(t, e);
  }
  setInputAriaLabel(e) {
    var t, n;
    (n = (t = this.dateComp) == null ? void 0 : t.setInputAriaLabel) == null || n.call(t, e);
  }
  afterGuiAttached(e) {
    var t, n;
    (n = (t = this.dateComp) == null ? void 0 : t.afterGuiAttached) == null || n.call(t, e);
  }
  updateParams(e) {
    var t, n;
    (n = (t = this.dateComp) == null ? void 0 : t.refresh) == null || n.call(t, e);
  }
}, Vp = [
  "equals",
  "notEqual",
  "lessThan",
  "greaterThan",
  "inRange",
  "blank",
  "notBlank"
];
function Ny(e, t) {
  const { dateFrom: n, dateTo: o, type: s } = e || {};
  return [
    n && Qt(n, void 0, !0) || null,
    o && Qt(o, void 0, !0) || null
  ].slice(0, Ga(s, t));
}
var d0 = 1e3, c0 = 1 / 0, LB = class extends Hp {
  constructor() {
    super("dateFilter", Ny, Vp), this.eConditionPanelsFrom = [], this.eConditionPanelsTo = [], this.dateConditionFromComps = [], this.dateConditionToComps = [], this.minValidYear = d0, this.maxValidYear = c0, this.minValidDate = null, this.maxValidDate = null, this.filterType = "date";
  }
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.dateConditionFromComps[0].afterGuiAttached(e);
  }
  commonUpdateSimpleParams(e) {
    super.commonUpdateSimpleParams(e);
    const t = (l, d) => {
      const c = e[l];
      if (c != null)
        if (isNaN(c))
          Z(82, { param: l });
        else
          return c == null ? d : Number(c);
      return d;
    }, n = t("minValidYear", d0), o = t("maxValidYear", c0);
    this.minValidYear = n, this.maxValidYear = o, n > o && Z(83);
    const { minValidDate: s, maxValidDate: i } = e, r = s instanceof Date ? s : Qt(s);
    this.minValidDate = r;
    const a = i instanceof Date ? i : Qt(i);
    this.maxValidDate = a, r && a && r > a && Z(84);
  }
  createDateCompWrapper(e) {
    const {
      beans: { userCompFactory: t, context: n, gos: o },
      params: s
    } = this, i = new _y(
      n,
      t,
      s.colDef,
      ke(o, {
        onDateChanged: () => this.onUiChanged(),
        filterParams: s,
        location: "filter"
      }),
      e
    );
    return this.addDestroyFunc(() => i.destroy()), i;
  }
  setElementValue(e, t) {
    e.setDate(t);
  }
  setElementDisplayed(e, t) {
    e.setDisplayed(t);
  }
  setElementDisabled(e, t) {
    e.setDisabled(t);
  }
  createEValue() {
    const e = Ue({ tag: "div", cls: "ag-filter-body" });
    return this.createFromToElement(e, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(e, this.eConditionPanelsTo, this.dateConditionToComps, "to"), e;
  }
  createFromToElement(e, t, n, o) {
    const s = Ue({ tag: "div", cls: `ag-filter-${o} ag-filter-date-${o}` });
    t.push(s), e.appendChild(s), n.push(this.createDateCompWrapper(s));
  }
  removeEValues(e, t) {
    this.removeDateComps(this.dateConditionFromComps, e, t), this.removeDateComps(this.dateConditionToComps, e, t), ha(this.eConditionPanelsFrom, e, t), ha(this.eConditionPanelsTo, e, t);
  }
  removeDateComps(e, t, n) {
    ha(e, t, n).forEach((s) => s.destroy());
  }
  isValidDateValue(e) {
    if (e === null)
      return !1;
    const { minValidDate: t, maxValidDate: n, minValidYear: o, maxValidYear: s } = this;
    if (t) {
      if (e < t)
        return !1;
    } else if (e.getUTCFullYear() < o)
      return !1;
    if (n) {
      if (e > n)
        return !1;
    } else if (e.getUTCFullYear() > s)
      return !1;
    return !0;
  }
  isConditionUiComplete(e) {
    if (!super.isConditionUiComplete(e))
      return !1;
    let t = !0;
    return this.forEachInput((n, o, s, i) => {
      s !== e || !t || o >= i || (t = t && this.isValidDateValue(n.getDate()));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.dateFrom === t.dateFrom && e.dateTo === t.dateTo && e.type === t.type;
  }
  createCondition(e) {
    const t = this.getConditionType(e), n = {}, o = this.getValues(e), s = this.params.useIsoSeparator ? "T" : " ";
    return o.length > 0 && (n.dateFrom = un(o[0], !0, s)), o.length > 1 && (n.dateTo = un(o[1], !0, s)), {
      dateFrom: null,
      dateTo: null,
      filterType: this.filterType,
      type: t,
      ...n
    };
  }
  resetPlaceholder() {
    const e = this.getLocaleTextFunc(), t = this.translate("dateFormatOoo"), n = e("ariaFilterValue", "Filter Value");
    this.forEachInput((o) => {
      o.setInputPlaceholder(t), o.setInputAriaLabel(n);
    });
  }
  getInputs(e) {
    const { dateConditionFromComps: t, dateConditionToComps: n } = this;
    return e >= t.length ? [null, null] : [t[e], n[e]];
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (n, o, s, i) => {
      o < i && t.push(n.getDate());
    }), t;
  }
  translate(e) {
    return e === "lessThan" ? super.translate("before") : e === "greaterThan" ? super.translate("after") : super.translate(e);
  }
}, $y = class extends U {
  constructor(e, t) {
    super(), this.mapValuesFromModel = e, this.defaultOptions = t;
  }
  init(e) {
    const t = e.filterParams, n = new Gp();
    this.optionsFactory = n, n.init(t, this.defaultOptions), this.filterModelFormatter = this.createManagedBean(
      new this.FilterModelFormatterClass(n, t)
    ), this.updateParams(e), this.validateModel(e);
  }
  refresh(e) {
    if (e.source === "colDef") {
      const t = e.filterParams, n = this.optionsFactory;
      n.refresh(t, this.defaultOptions), this.filterModelFormatter.updateParams({ optionsFactory: n, filterParams: t }), this.updateParams(e);
    }
    this.validateModel(e);
  }
  updateParams(e) {
    this.params = e;
  }
  doesFilterPass(e) {
    const t = e.model;
    if (t == null)
      return !0;
    const { operator: n } = t, o = [];
    if (n) {
      const r = t;
      o.push(...r.conditions ?? []);
    } else
      o.push(t);
    const s = n && n === "OR" ? "some" : "every", i = this.params.getValue(e.node);
    return o[s]((r) => this.individualConditionPasses(e, r, i));
  }
  getModelAsString(e, t) {
    return this.filterModelFormatter.getModelAsString(e, t) ?? "";
  }
  validateModel(e) {
    const {
      model: t,
      filterParams: { filterOptions: n, maxNumConditions: o }
    } = e;
    if (t == null)
      return;
    let i = Tw(t) ? t.conditions : [t];
    const r = (n == null ? void 0 : n.map((c) => typeof c == "string" ? c : c.displayKey)) ?? this.defaultOptions;
    if (!(!i || i.every((c) => r.find((u) => u === c.type) !== void 0))) {
      this.params = {
        ...e,
        model: null
      }, e.onModelChange(null);
      return;
    }
    let l = !1;
    const d = this.filterType;
    if ((i && !i.every((c) => c.filterType === d) || t.filterType !== d) && (i = i.map((c) => ({ ...c, filterType: d })), l = !0), typeof o == "number" && i && i.length > o && (i = i.slice(0, o), l = !0), l) {
      const c = i.length > 1 ? {
        ...t,
        filterType: d,
        conditions: i
      } : {
        ...i[0],
        filterType: d
      };
      this.params = {
        ...e,
        model: c
      }, e.onModelChange(c);
      return;
    }
  }
  /** returns true if the row passes the said condition */
  individualConditionPasses(e, t, n) {
    const o = this.optionsFactory, s = this.mapValuesFromModel(t, o), i = o.getCustomOption(t.type), r = TB(i, s, n);
    return r ?? (n == null ? this.evaluateNullValue(t.type) : this.evaluateNonNullValue(s, n, t, e));
  }
}, zy = class extends $y {
  evaluateNullValue(e) {
    const {
      includeBlanksInEquals: t,
      includeBlanksInNotEqual: n,
      includeBlanksInGreaterThan: o,
      includeBlanksInLessThan: s,
      includeBlanksInRange: i
    } = this.params.filterParams;
    switch (e) {
      case "equals":
        if (t)
          return !0;
        break;
      case "notEqual":
        if (n)
          return !0;
        break;
      case "greaterThan":
      case "greaterThanOrEqual":
        if (o)
          return !0;
        break;
      case "lessThan":
      case "lessThanOrEqual":
        if (s)
          return !0;
        break;
      case "inRange":
        if (i)
          return !0;
        break;
      case "blank":
        return !0;
      case "notBlank":
        return !1;
    }
    return !1;
  }
  evaluateNonNullValue(e, t, n) {
    const o = n.type;
    if (!this.isValid(t))
      return o === "notEqual" || o === "notBlank";
    const s = this.comparator(), i = e[0] != null ? s(e[0], t) : 0;
    switch (o) {
      case "equals":
        return i === 0;
      case "notEqual":
        return i !== 0;
      case "greaterThan":
        return i > 0;
      case "greaterThanOrEqual":
        return i >= 0;
      case "lessThan":
        return i < 0;
      case "lessThanOrEqual":
        return i <= 0;
      case "inRange": {
        const r = s(e[1], t);
        return this.params.filterParams.inRangeInclusive ? i >= 0 && r <= 0 : i > 0 && r < 0;
      }
      case "blank":
        return Hd(t);
      case "notBlank":
        return !Hd(t);
      default:
        return Z(76, { filterModelType: o }), !0;
    }
  }
}, Wy = {
  equals: "Equals",
  notEqual: "NotEqual",
  greaterThan: "GreaterThan",
  greaterThanOrEqual: "GreaterThanOrEqual",
  lessThan: "LessThan",
  lessThanOrEqual: "LessThanOrEqual",
  inRange: "InRange"
}, BB = {
  contains: "Contains",
  notContains: "NotContains",
  equals: "TextEquals",
  notEqual: "TextNotEqual",
  startsWith: "StartsWith",
  endsWith: "EndsWith",
  inRange: "InRange"
}, _p = class extends U {
  constructor(e, t, n) {
    super(), this.optionsFactory = e, this.filterParams = t, this.valueFormatter = n;
  }
  // used by:
  // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
  // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
  getModelAsString(e, t) {
    const n = this.getLocaleTextFunc(), o = t === "filterToolPanel";
    if (!e)
      return o ? ws(this, "filterSummaryInactive") : null;
    if (e.operator != null) {
      const i = e, a = (i.conditions ?? []).map((d) => this.getModelAsString(d, t)), l = i.operator === "AND" ? "andCondition" : "orCondition";
      return a.join(` ${ws(this, l)} `);
    } else {
      if (e.type === "blank" || e.type === "notBlank")
        return o ? ws(this, e.type === "blank" ? "filterSummaryBlank" : "filterSummaryNotBlank") : n(e.type, e.type);
      {
        const i = e, r = this.optionsFactory.getCustomOption(i.type), { displayKey: a, displayName: l, numberOfInputs: d } = r || {};
        return a && l && d === 0 ? n(a, l) : this.conditionToString(
          i,
          o,
          i.type === "inRange" || d === 2,
          a,
          l
        );
      }
    }
  }
  updateParams(e) {
    const { optionsFactory: t, filterParams: n } = e;
    this.optionsFactory = t, this.filterParams = n;
  }
  conditionForToolPanel(e, t, n, o, s, i) {
    let r;
    const a = this.getTypeKey(e);
    return a && (r = ws(this, a)), s && i && (r = this.getLocaleTextFunc()(s, i)), r != null ? t ? `${r} ${ws(this, "filterSummaryInRangeValues", [n(), o()])}` : `${r} ${n()}` : null;
  }
  getTypeKey(e) {
    const t = this.filterTypeKeys[e];
    return t ? `filterSummary${t}` : null;
  }
  formatValue(e) {
    const t = this.valueFormatter;
    return t ? t(e ?? null) ?? "" : String(e);
  }
}, Uy = class extends _p {
  constructor(e, t) {
    super(e, t, (n) => {
      const { dataTypeSvc: o, valueSvc: s } = this.beans, i = t.column, r = o == null ? void 0 : o.getDateFormatterFunction(i), a = r == null ? void 0 : r(n ?? void 0);
      return s.formatValue(i, null, a);
    }), this.filterTypeKeys = Wy;
  }
  conditionToString(e, t, n, o, s) {
    const { type: i } = e, r = Qt(e.dateFrom), a = Qt(e.dateTo), l = this.filterParams.inRangeFloatingFilterDateFormat, d = t ? this.formatValue.bind(this) : (h) => Rh(h, l), c = () => r !== null ? d(r) : "null", u = () => a !== null ? d(a) : "null";
    if (t) {
      const h = this.conditionForToolPanel(
        i,
        n,
        c,
        u,
        o,
        s
      );
      if (h != null)
        return h;
    }
    return n ? `${c()}-${u()}` : r != null ? d(r) : `${i}`;
  }
};
function OB(e, t) {
  const n = t;
  return n < e ? -1 : n > e ? 1 : 0;
}
var GB = class extends zy {
  constructor() {
    super(Ny, Vp), this.filterType = "date", this.FilterModelFormatterClass = Uy;
  }
  comparator() {
    return this.params.filterParams.comparator ?? OB;
  }
  isValid(e) {
    const t = this.params.filterParams.isValidDate;
    return !t || t(e);
  }
}, Ky = class extends Te {
  constructor() {
    super(...arguments), this.defaultDebounceMs = 0;
  }
  setLastTypeFromModel(e) {
    if (!e) {
      this.lastType = this.optionsFactory.defaultOption;
      return;
    }
    const t = e.operator;
    let n;
    t ? n = e.conditions[0] : n = e, this.lastType = n.type;
  }
  canWeEditAfterModelFromParentFilter(e) {
    if (!e)
      return this.isTypeEditable(this.lastType);
    if (e.operator)
      return !1;
    const n = e;
    return this.isTypeEditable(n.type);
  }
  init(e) {
    this.params = e;
    const t = this.gos.get("enableFilterHandlers");
    if (this.reactive = t, this.setParams(e), t) {
      const n = e;
      this.onModelUpdated(n.model);
    }
  }
  setParams(e) {
    const t = new Gp();
    this.optionsFactory = t, t.init(e.filterParams, this.defaultOptions), this.filterModelFormatter = this.createManagedBean(
      new this.FilterModelFormatterClass(t, e.filterParams)
    ), this.setSimpleParams(e, !1);
  }
  setSimpleParams(e, t = !0) {
    const n = this.optionsFactory.defaultOption;
    t || (this.lastType = n), this.readOnly = !!e.filterParams.readOnly;
    const o = this.isTypeEditable(n);
    this.setEditable(o);
  }
  refresh(e) {
    this.params = e;
    const t = e, n = this.reactive;
    if ((!n || t.source === "colDef") && this.updateParams(e), n) {
      const { source: o, model: s } = t;
      if (o === "dataChanged" || o === "ui")
        return;
      this.onModelUpdated(s);
    }
  }
  updateParams(e) {
    const t = this.optionsFactory;
    t.refresh(e.filterParams, this.defaultOptions), this.setSimpleParams(e), this.filterModelFormatter.updateParams({
      optionsFactory: t,
      filterParams: e.filterParams
    });
  }
  onParentModelChanged(e, t) {
    t != null && t.afterFloatingFilter || t != null && t.afterDataChange || this.onModelUpdated(e);
  }
  hasSingleInput(e) {
    var n;
    const t = (n = this.optionsFactory.getCustomOption(e)) == null ? void 0 : n.numberOfInputs;
    return t == null || t == 1;
  }
  isTypeEditable(e) {
    const t = ["inRange", "empty", "blank", "notBlank"];
    return !!e && !this.readOnly && this.hasSingleInput(e) && t.indexOf(e) < 0;
  }
  getAriaLabel(e) {
    return `${this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0)} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
  }
}, HB = {
  tag: "div",
  cls: "ag-floating-filter-input",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eReadOnlyText"
    },
    { tag: "div", ref: "eDateWrapper", cls: "ag-date-floating-filter-wrapper" }
  ]
}, VB = class extends Ky {
  constructor() {
    super(HB, [ao]), this.eReadOnlyText = X, this.eDateWrapper = X, this.FilterModelFormatterClass = Uy, this.filterType = "date", this.defaultOptions = Vp;
  }
  setParams(e) {
    super.setParams(e), this.createDateComponent();
    const t = this.getLocaleTextFunc();
    this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(t("ariaDateFilterInput", "Date Filter Input"));
  }
  updateParams(e) {
    super.updateParams(e), this.dateComp.updateParams(this.getDateComponentParams()), this.updateCompOnModelChange(e.currentParentModel());
  }
  updateCompOnModelChange(e) {
    const t = !this.readOnly && this.canWeEditAfterModelFromParentFilter(e);
    if (this.setEditable(t), t) {
      const n = e ? Qt(e.dateFrom) : null;
      this.dateComp.setDate(n), this.eReadOnlyText.setValue("");
    } else
      this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
  }
  setEditable(e) {
    He(this.eDateWrapper, e), He(this.eReadOnlyText.getGui(), !e);
  }
  onModelUpdated(e) {
    super.setLastTypeFromModel(e), this.updateCompOnModelChange(e);
  }
  onDateChanged() {
    const e = this.dateComp.getDate();
    if (this.reactive) {
      const t = this.params;
      t.onUiChange();
      const n = t.model, o = un(e), s = o == null ? null : {
        ...n ?? {
          filterType: this.filterType,
          type: this.lastType ?? this.optionsFactory.defaultOption
        },
        dateFrom: o
      };
      t.onModelChange(s, { afterFloatingFilter: !0 });
    } else
      this.params.parentFilterInstance((t) => {
        t == null || t.onFloatingFilterChanged(this.lastType || null, e);
      });
  }
  getDateComponentParams() {
    const { filterParams: e } = this.params, t = Cp(e, this.defaultDebounceMs);
    return ke(this.gos, {
      onDateChanged: Lt(this, this.onDateChanged.bind(this), t),
      filterParams: e,
      location: "floatingFilter"
    });
  }
  createDateComponent() {
    const {
      beans: { context: e, userCompFactory: t },
      eDateWrapper: n,
      params: o
    } = this;
    this.dateComp = new _y(
      e,
      t,
      o.column.getColDef(),
      this.getDateComponentParams(),
      n,
      (s) => {
        s.setInputAriaLabel(this.getAriaLabel(o));
      }
    ), this.addDestroyFunc(() => this.dateComp.destroy());
  }
}, _B = {
  tag: "div",
  cls: "ag-filter-filter",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eDateInput",
      cls: "ag-date-filter"
    }
  ]
}, NB = class extends Te {
  constructor() {
    super(_B, [ao]), this.eDateInput = X, this.isApply = !1, this.applyOnFocusOut = !1;
  }
  init(e) {
    this.params = e, this.setParams(e);
    const t = this.eDateInput.getInputElement();
    this.addManagedListeners(t, {
      // ensures that the input element is focussed when a clear button is clicked,
      // unless using safari as there is no clear button and focus does not work properly
      mouseDown: () => {
        this.eDateInput.isDisabled() || this.usingSafariDatePicker || t.focus({ preventScroll: !0 });
      },
      input: this.handleInput.bind(this, !1),
      change: this.handleInput.bind(this, !0),
      focusout: this.handleFocusOut.bind(this)
    });
  }
  handleInput(e) {
    if (!this.eDateInput.isDisabled()) {
      if (this.isApply) {
        this.applyOnFocusOut = !e, e && this.params.onDateChanged();
        return;
      }
      e || this.params.onDateChanged();
    }
  }
  handleFocusOut() {
    this.applyOnFocusOut && (this.applyOnFocusOut = !1, this.params.onDateChanged());
  }
  setParams(e) {
    var h;
    const t = this.eDateInput.getInputElement(), n = this.shouldUseBrowserDatePicker(e);
    this.usingSafariDatePicker = n && os();
    const { minValidYear: o, maxValidYear: s, minValidDate: i, maxValidDate: r, buttons: a, includeTime: l, colDef: d } = e.filterParams || {}, c = this.beans.dataTypeSvc, u = l ?? ((h = c == null ? void 0 : c.getDateIncludesTimeFlag) == null ? void 0 : h.call(c, d.cellDataType)) ?? !1;
    if (n ? u ? (t.type = "datetime-local", t.step = "1") : t.type = "date" : t.type = "text", i && o && Z(85), r && s && Z(86), i && r) {
      const [g, p] = [i, r].map(
        (f) => f instanceof Date ? f : Qt(f)
      );
      g && p && g.getTime() > p.getTime() && Z(87);
    }
    i ? i instanceof Date ? t.min = Rh(i) : t.min = i : o && (t.min = `${o}-01-01`), r ? r instanceof Date ? t.max = Rh(r) : t.max = r : s && (t.max = `${s}-12-31`), this.isApply = e.location === "floatingFilter" && !!(a != null && a.includes("apply"));
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  getDate() {
    return Qt(this.eDateInput.getValue());
  }
  setDate(e) {
    var o;
    const t = this.params.filterParams.colDef.cellDataType, n = ((o = this.beans.dataTypeSvc) == null ? void 0 : o.getDateIncludesTimeFlag(t)) ?? !1;
    this.eDateInput.setValue(un(e, n));
  }
  setInputPlaceholder(e) {
    this.eDateInput.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.eDateInput.setAriaLabel(e);
  }
  setDisabled(e) {
    this.eDateInput.setDisabled(e);
  }
  afterGuiAttached(e) {
    (!e || !e.suppressFocus) && this.eDateInput.getInputElement().focus({ preventScroll: !0 });
  }
  shouldUseBrowserDatePicker(e) {
    var t;
    return ((t = e == null ? void 0 : e.filterParams) == null ? void 0 : t.browserDatePicker) ?? !0;
  }
}, Np = [
  "equals",
  "notEqual",
  "greaterThan",
  "greaterThanOrEqual",
  "lessThan",
  "lessThanOrEqual",
  "inRange",
  "blank",
  "notBlank"
];
function zh(e) {
  const { allowedCharPattern: t } = e ?? {};
  return t ?? null;
}
function Wh(e) {
  return e == null || isNaN(e) ? null : e;
}
function Zy(e, t) {
  const { filter: n, filterTo: o, type: s } = e || {};
  return [Wh(n), Wh(o)].slice(
    0,
    Ga(s, t)
  );
}
var $B = class extends Hp {
  constructor() {
    super("numberFilter", Zy, Np), this.eValuesFrom = [], this.eValuesTo = [], this.filterType = "number", this.defaultDebounceMs = 500;
  }
  setElementValue(e, t, n) {
    const { numberFormatter: o } = this.params, s = !n && o ? o(t ?? null) : t;
    super.setElementValue(e, s);
  }
  createEValue() {
    const e = zh(this.params), t = Ue({ tag: "div", cls: "ag-filter-body", role: "presentation" });
    return this.createFromToElement(t, this.eValuesFrom, "from", e), this.createFromToElement(t, this.eValuesTo, "to", e), t;
  }
  createFromToElement(e, t, n, o) {
    const s = this.createManagedBean(
      o ? new Fo({ allowedCharPattern: o }) : new Cc()
    );
    s.addCss(`ag-filter-${n}`), s.addCss("ag-filter-filter"), t.push(s), e.appendChild(s.getGui());
  }
  removeEValues(e, t) {
    const n = (o) => this.removeComponents(o, e, t);
    n(this.eValuesFrom), n(this.eValuesTo);
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (n, o, s, i) => {
      o < i && t.push(Wh(this.stringToFloat(n.getValue())));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  stringToFloat(e) {
    if (typeof e == "number")
      return e;
    let t = Gt(e);
    t != null && t.trim() === "" && (t = null);
    const n = this.params.numberParser;
    return n ? n(t) : t == null || t.trim() === "-" ? null : parseFloat(t);
  }
  createCondition(e) {
    const t = this.getConditionType(e), n = {
      filterType: this.filterType,
      type: t
    }, o = this.getValues(e);
    return o.length > 0 && (n.filter = o[0]), o.length > 1 && (n.filterTo = o[1]), n;
  }
  getInputs(e) {
    const { eValuesFrom: t, eValuesTo: n } = this;
    return e >= t.length ? [null, null] : [t[e], n[e]];
  }
  hasInvalidInputs() {
    let e = !1;
    return this.forEachInput((t) => {
      if (!t.getInputElement().validity.valid) {
        e = !0;
        return;
      }
    }), e;
  }
}, qy = class extends _p {
  constructor(e, t) {
    super(e, t, t.numberFormatter), this.filterTypeKeys = Wy;
  }
  conditionToString(e, t, n, o, s) {
    const { filter: i, filterTo: r, type: a } = e, l = this.formatValue.bind(this);
    if (t) {
      const d = this.conditionForToolPanel(
        a,
        n,
        () => l(i),
        () => l(r),
        o,
        s
      );
      if (d != null)
        return d;
    }
    return n ? `${l(i)}-${l(r)}` : i != null ? l(i) : `${a}`;
  }
}, zB = class extends zy {
  constructor() {
    super(Zy, Np), this.filterType = "number", this.FilterModelFormatterClass = qy;
  }
  comparator() {
    return (e, t) => e === t ? 0 : e < t ? 1 : -1;
  }
  isValid(e) {
    return !isNaN(e);
  }
}, jy = class extends U {
  constructor(e) {
    super(), this.params = e, this.eInput = X, this.onValueChanged = () => {
    };
  }
  setupGui(e) {
    var o;
    this.eInput = this.createManagedBean(new Fo((o = this.params) == null ? void 0 : o.config));
    const t = this.eInput.getGui();
    e.appendChild(t);
    const n = (s) => this.onValueChanged(s);
    this.addManagedListeners(t, {
      input: n,
      keydown: n
    });
  }
  setEditable(e) {
    this.eInput.setDisabled(!e);
  }
  getValue() {
    return this.eInput.getValue();
  }
  setValue(e, t) {
    this.eInput.setValue(e, t);
  }
  setValueChangedListener(e) {
    this.onValueChanged = e;
  }
  setParams({ ariaLabel: e, autoComplete: t }) {
    const { eInput: n } = this;
    n.setInputAriaLabel(e), t !== void 0 && n.setAutoComplete(t);
  }
};
function Uh(e) {
  const t = e == null ? void 0 : e.trim();
  return t === "" ? e : t;
}
function Yy(e, t) {
  const { filter: n, filterTo: o, type: s } = e || {};
  return [n || null, o || null].slice(0, Ga(s, t));
}
var WB = {
  tag: "div",
  ref: "eFloatingFilterInputContainer",
  cls: "ag-floating-filter-input",
  role: "presentation"
}, Qy = class extends Ky {
  constructor() {
    super(...arguments), this.eFloatingFilterInputContainer = X, this.defaultDebounceMs = 500;
  }
  postConstruct() {
    this.setTemplate(WB);
  }
  onModelUpdated(e) {
    this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(e));
  }
  setParams(e) {
    this.setupFloatingFilterInputService(e), super.setParams(e), this.setTextInputParams(e);
  }
  setupFloatingFilterInputService(e) {
    this.inputSvc = this.createFloatingFilterInputService(e), this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
  }
  setTextInputParams(e) {
    const t = e.browserAutoComplete ?? !1, { inputSvc: n, defaultDebounceMs: o, readOnly: s } = this;
    if (n.setParams({
      ariaLabel: this.getAriaLabel(e),
      autoComplete: t
    }), this.applyActive = bc(e.filterParams), !s) {
      const i = Cp(e.filterParams, o), r = Lt(
        this,
        this.syncUpWithParentFilter.bind(this),
        i
      );
      n.setValueChangedListener(r);
    }
  }
  updateParams(e) {
    super.updateParams(e), this.setTextInputParams(e);
  }
  recreateFloatingFilterInputService(e) {
    const { inputSvc: t } = this, n = t.getValue();
    ht(this.eFloatingFilterInputContainer), this.destroyBean(t), this.setupFloatingFilterInputService(e), t.setValue(n, !0);
  }
  syncUpWithParentFilter(e) {
    const t = e.key === O.ENTER, n = this.reactive;
    if (n && this.params.onUiChange(), this.applyActive && !t)
      return;
    const { inputSvc: o, params: s, lastType: i } = this;
    let r = o.getValue();
    if (s.filterParams.trimInput && (r = Uh(r), o.setValue(r, !0)), n) {
      const a = s, l = a.model, d = this.convertValue(r), c = d == null ? null : {
        ...l ?? {
          filterType: this.filterType,
          type: i ?? this.optionsFactory.defaultOption
        },
        filter: d
      };
      a.onModelChange(c, { afterFloatingFilter: !0 });
    } else
      s.parentFilterInstance((a) => {
        a == null || a.onFloatingFilterChanged(i || null, r || null);
      });
  }
  convertValue(e) {
    return e || null;
  }
  setEditable(e) {
    this.inputSvc.setEditable(e);
  }
}, UB = class extends U {
  constructor() {
    super(...arguments), this.onValueChanged = () => {
    }, this.numberInputActive = !0;
  }
  setupGui(e) {
    this.eNumberInput = this.createManagedBean(new Cc()), this.eTextInput = this.createManagedBean(new Fo()), this.eTextInput.setDisabled(!0);
    const t = this.eNumberInput.getGui(), n = this.eTextInput.getGui();
    e.appendChild(t), e.appendChild(n), this.setupListeners(t, (o) => this.onValueChanged(o)), this.setupListeners(n, (o) => this.onValueChanged(o));
  }
  setEditable(e) {
    this.numberInputActive = e, this.eNumberInput.setDisplayed(this.numberInputActive), this.eTextInput.setDisplayed(!this.numberInputActive);
  }
  setAutoComplete(e) {
    this.eNumberInput.setAutoComplete(e), this.eTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.getActiveInputElement().getValue();
  }
  setValue(e, t) {
    this.getActiveInputElement().setValue(e, t);
  }
  getActiveInputElement() {
    return this.numberInputActive ? this.eNumberInput : this.eTextInput;
  }
  setValueChangedListener(e) {
    this.onValueChanged = e;
  }
  setupListeners(e, t) {
    this.addManagedListeners(e, {
      input: t,
      keydown: t
    });
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eNumberInput.setInputAriaLabel(e), this.eTextInput.setInputAriaLabel(e);
  }
}, KB = class extends Qy {
  constructor() {
    super(...arguments), this.FilterModelFormatterClass = qy, this.filterType = "number", this.defaultOptions = Np;
  }
  updateParams(e) {
    zh(e.filterParams) !== this.allowedCharPattern && this.recreateFloatingFilterInputService(e), super.updateParams(e);
  }
  createFloatingFilterInputService(e) {
    return this.allowedCharPattern = zh(e.filterParams), this.allowedCharPattern ? this.createManagedBean(
      new jy({
        config: { allowedCharPattern: this.allowedCharPattern }
      })
    ) : this.createManagedBean(new UB());
  }
  convertValue(e) {
    return e ? Number(e) : null;
  }
}, $p = [
  "contains",
  "notContains",
  "equals",
  "notEqual",
  "startsWith",
  "endsWith",
  "blank",
  "notBlank"
], ZB = class extends Hp {
  constructor() {
    super("textFilter", Yy, $p), this.filterType = "text", this.eValuesFrom = [], this.eValuesTo = [], this.defaultDebounceMs = 500;
  }
  createCondition(e) {
    const t = this.getConditionType(e), n = {
      filterType: this.filterType,
      type: t
    }, o = this.getValues(e);
    return o.length > 0 && (n.filter = o[0]), o.length > 1 && (n.filterTo = o[1]), n;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  getInputs(e) {
    const { eValuesFrom: t, eValuesTo: n } = this;
    return e >= t.length ? [null, null] : [t[e], n[e]];
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (n, o, s, i) => {
      o < i && t.push(Gt(n.getValue()));
    }), t;
  }
  createEValue() {
    const e = Ue({ tag: "div", cls: "ag-filter-body", role: "presentation" }), { eValuesFrom: t, eValuesTo: n } = this;
    return this.createFromToElement(e, t, "from"), this.createFromToElement(e, n, "to"), e;
  }
  createFromToElement(e, t, n) {
    const o = this.createManagedBean(new Fo());
    o.addCss(`ag-filter-${n}`), o.addCss("ag-filter-filter"), t.push(o), e.appendChild(o.getGui());
  }
  removeEValues(e, t) {
    const n = (i) => this.removeComponents(i, e, t), { eValuesFrom: o, eValuesTo: s } = this;
    n(o), n(s);
  }
}, Jy = class extends _p {
  constructor() {
    super(...arguments), this.filterTypeKeys = BB;
  }
  conditionToString(e, t, n, o, s) {
    const { filter: i, filterTo: r, type: a } = e;
    if (t) {
      const l = (c) => () => ws(this, "filterSummaryTextQuote", [c]), d = this.conditionForToolPanel(
        a,
        n,
        l(i),
        l(r),
        o,
        s
      );
      if (d != null)
        return d;
    }
    return n ? `${i}-${r}` : i != null ? `${i}` : `${a}`;
  }
}, qB = ({ filterOption: e, value: t, filterText: n }) => {
  if (n == null)
    return !1;
  switch (e) {
    case "contains":
      return t.indexOf(n) >= 0;
    case "notContains":
      return t.indexOf(n) < 0;
    case "equals":
      return t === n;
    case "notEqual":
      return t != n;
    case "startsWith":
      return t.indexOf(n) === 0;
    case "endsWith": {
      const o = t.lastIndexOf(n);
      return o >= 0 && o === t.length - n.length;
    }
    default:
      return !1;
  }
}, jB = (e) => e, YB = (e) => e == null ? null : e.toString().toLowerCase(), QB = class extends $y {
  constructor() {
    super(Yy, $p), this.filterType = "text", this.FilterModelFormatterClass = Jy;
  }
  updateParams(e) {
    super.updateParams(e);
    const t = e.filterParams;
    this.matcher = t.textMatcher ?? qB, this.formatter = t.textFormatter ?? (t.caseSensitive ? jB : YB);
  }
  evaluateNullValue(e) {
    return e ? ["notEqual", "notContains", "blank"].indexOf(e) >= 0 : !1;
  }
  evaluateNonNullValue(e, t, n, o) {
    const s = e.map((h) => this.formatter(h)) || [], i = this.formatter(t), {
      api: r,
      colDef: a,
      column: l,
      context: d,
      filterParams: { textFormatter: c }
    } = this.params;
    if (n.type === "blank")
      return Hd(t);
    if (n.type === "notBlank")
      return !Hd(t);
    const u = {
      api: r,
      colDef: a,
      column: l,
      context: d,
      node: o.node,
      data: o.data,
      filterOption: n.type,
      value: i,
      textFormatter: c
    };
    return s.some((h) => this.matcher({ ...u, filterText: h }));
  }
  processModelToApply(e) {
    if (e && this.params.filterParams.trimInput) {
      const t = (n) => {
        const o = {
          ...n
        }, { filter: s, filterTo: i } = n;
        return s && (o.filter = Uh(s) ?? null), i && (o.filterTo = Uh(i) ?? null), o;
      };
      return Tw(e) ? {
        ...e,
        conditions: e.conditions.map(t)
      } : t(e);
    }
    return e;
  }
}, JB = class extends Qy {
  constructor() {
    super(...arguments), this.FilterModelFormatterClass = Jy, this.filterType = "text", this.defaultOptions = $p;
  }
  createFloatingFilterInputService() {
    return this.createManagedBean(new jy());
  }
};
function XB(e) {
  var t;
  return !!((t = e.quickFilter) != null && t.isFilterPresent());
}
function eO(e) {
  var t;
  return (t = e.quickFilter) == null ? void 0 : t.getText();
}
function tO(e) {
  var t;
  (t = e.quickFilter) == null || t.resetCache();
}
var nO = class extends U {
  constructor() {
    super(...arguments), this.beanName = "quickFilter", this.quickFilter = null, this.quickFilterParts = null;
  }
  postConstruct() {
    const e = this.resetCache.bind(this), t = this.gos;
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: e,
      columnRowGroupChanged: e,
      columnVisible: () => {
        t.get("includeHiddenColumnsInQuickFilter") || this.resetCache();
      }
    }), this.addManagedPropertyListener("quickFilterText", (n) => this.setFilter(n.currentValue)), this.addManagedPropertyListeners(
      ["includeHiddenColumnsInQuickFilter", "applyQuickFilterBeforePivotOrAgg"],
      () => this.onColumnConfigChanged()
    ), this.quickFilter = this.parseFilter(t.get("quickFilterText")), this.parser = t.get("quickFilterParser"), this.matcher = t.get("quickFilterMatcher"), this.setFilterParts(), this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], () => this.setParserAndMatcher());
  }
  // if we are using autoGroupCols, then they should be included for quick filter. this covers the
  // following scenarios:
  // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
  // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
  //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
  refreshCols() {
    var l;
    const { autoColSvc: e, colModel: t, gos: n, pivotResultCols: o } = this.beans, s = t.isPivotMode(), i = e == null ? void 0 : e.getColumns(), r = t.getColDefCols();
    let a = (s && !n.get("applyQuickFilterBeforePivotOrAgg") ? (l = o == null ? void 0 : o.getPivotResultCols()) == null ? void 0 : l.list : r) ?? [];
    i && (a = a.concat(i)), this.colsToUse = n.get("includeHiddenColumnsInQuickFilter") ? a : a.filter((d) => d.isVisible() || d.isRowGroupActive());
  }
  isFilterPresent() {
    return this.quickFilter !== null;
  }
  doesRowPass(e) {
    const t = this.gos.get("cacheQuickFilter");
    return this.matcher ? this.doesRowPassMatcher(t, e) : this.quickFilterParts.every(
      (n) => t ? this.doesRowPassCache(e, n) : this.doesRowPassNoCache(e, n)
    );
  }
  resetCache() {
    this.beans.rowModel.forEachNode((e) => e.quickFilterAggregateText = null);
  }
  getText() {
    return this.gos.get("quickFilterText");
  }
  setFilterParts() {
    const { quickFilter: e, parser: t } = this;
    e ? this.quickFilterParts = t ? t(e) : e.split(" ") : this.quickFilterParts = null;
  }
  parseFilter(e) {
    return ue(e) ? e.toUpperCase() : null;
  }
  setFilter(e) {
    if (e != null && typeof e != "string") {
      Z(70, { newFilter: e });
      return;
    }
    const t = this.parseFilter(e);
    this.quickFilter !== t && (this.quickFilter = t, this.setFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  setParserAndMatcher() {
    const e = this.gos.get("quickFilterParser"), t = this.gos.get("quickFilterMatcher"), n = e !== this.parser || t !== this.matcher;
    this.parser = e, this.matcher = t, n && (this.setFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  onColumnConfigChanged() {
    this.refreshCols(), this.resetCache(), this.isFilterPresent() && this.dispatchLocalEvent({ type: "quickFilterChanged" });
  }
  doesRowPassNoCache(e, t) {
    return this.colsToUse.some((n) => {
      const o = this.getTextForColumn(n, e);
      return ue(o) && o.indexOf(t) >= 0;
    });
  }
  doesRowPassCache(e, t) {
    return this.checkGenerateAggText(e), e.quickFilterAggregateText.indexOf(t) >= 0;
  }
  doesRowPassMatcher(e, t) {
    let n;
    e ? (this.checkGenerateAggText(t), n = t.quickFilterAggregateText) : n = this.getAggText(t);
    const { quickFilterParts: o, matcher: s } = this;
    return s(o, n);
  }
  checkGenerateAggText(e) {
    e.quickFilterAggregateText || (e.quickFilterAggregateText = this.getAggText(e));
  }
  getTextForColumn(e, t) {
    let n = this.beans.filterValueSvc.getValue(e, t);
    const o = e.getColDef();
    if (o.getQuickFilterText) {
      const s = ke(this.gos, {
        value: n,
        node: t,
        data: t.data,
        column: e,
        colDef: o
      });
      n = o.getQuickFilterText(s);
    }
    return ue(n) ? n.toString().toUpperCase() : null;
  }
  getAggText(e) {
    const t = [];
    return this.colsToUse.forEach((n) => {
      const o = this.getTextForColumn(n, e);
      ue(o) && t.push(o);
    }), t.join(`
`);
  }
}, oO = {
  moduleName: "ClientSideRowModelFilter",
  version: Ee,
  rowModels: ["clientSide"],
  beans: [iB]
}, Fc = {
  moduleName: "FilterCore",
  version: Ee,
  beans: [AB],
  apiFunctions: {
    isAnyFilterPresent: RB,
    onFilterChanged: EB
  },
  css: [cB],
  dependsOn: [oO]
}, zp = {
  moduleName: "FilterValue",
  version: Ee,
  beans: [MB]
}, il = {
  moduleName: "ColumnFilter",
  version: Ee,
  beans: [xB, FB],
  dynamicBeans: { headerFilterCellCtrl: rB },
  icons: {
    // open filter button - header, floating filter, menu
    filter: "filter",
    // filter is applied - header (legacy column menu), filter tool panel
    filterActive: "filter"
  },
  apiFunctions: {
    isColumnFilterPresent: uB,
    getColumnFilterInstance: hB,
    destroyFilter: gB,
    setFilterModel: pB,
    getFilterModel: fB,
    getColumnFilterModel: mB,
    setColumnFilterModel: vB,
    showColumnFilter: CB,
    hideColumnFilter: wB,
    getColumnFilterHandler: yB,
    doFilterAction: bB
  },
  dependsOn: [Fc, Vs, zp, Vy]
}, sO = {
  moduleName: "CustomFilter",
  version: Ee,
  userComponents: { agReadOnlyFloatingFilter: PB },
  dependsOn: [il]
}, iO = {
  moduleName: "TextFilter",
  version: Ee,
  dependsOn: [il],
  userComponents: {
    agTextColumnFilter: {
      classImp: ZB,
      params: {
        useForm: !0
      }
    },
    agTextColumnFloatingFilter: JB
  },
  dynamicBeans: {
    agTextColumnFilterHandler: QB
  }
}, rO = {
  moduleName: "NumberFilter",
  version: Ee,
  dependsOn: [il],
  userComponents: {
    agNumberColumnFilter: {
      classImp: $B,
      params: {
        useForm: !0
      }
    },
    agNumberColumnFloatingFilter: KB
  },
  dynamicBeans: {
    agNumberColumnFilterHandler: zB
  }
}, aO = {
  moduleName: "DateFilter",
  version: Ee,
  dependsOn: [il],
  userComponents: {
    agDateColumnFilter: {
      classImp: LB,
      params: {
        useForm: !0
      }
    },
    agDateInput: NB,
    agDateColumnFloatingFilter: VB
  },
  dynamicBeans: {
    agDateColumnFilterHandler: GB
  }
}, lO = {
  moduleName: "QuickFilterCore",
  version: Ee,
  rowModels: ["clientSide"],
  beans: [nO],
  dependsOn: [Fc, zp]
}, dO = {
  moduleName: "QuickFilter",
  version: Ee,
  apiFunctions: {
    isQuickFilterPresent: XB,
    getQuickFilter: eO,
    resetQuickFilter: tO
  },
  dependsOn: [lO]
}, cO = {
  moduleName: "ExternalFilter",
  version: Ee,
  dependsOn: [Fc]
}, uO = (
  /*css*/
  ".ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;white-space:normal;z-index:99999;&:where(.ag-cell-editor-tooltip){background-color:var(--ag-tooltip-error-background-color);border:var(--ag-tooltip-error-border);color:var(--ag-tooltip-error-text-color);font-weight:500}}.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}"
), Tu = (e, t, n) => {
  var a, l, d;
  const { editModelSvc: o } = e, s = (l = (a = o == null ? void 0 : o.getCellValidationModel()) == null ? void 0 : a.getCellValidation(t)) == null ? void 0 : l.errorMessages, i = (d = o == null ? void 0 : o.getRowValidationModel().getRowValidation(t)) == null ? void 0 : d.errorMessages, r = s || i;
  return r && r.length ? r.join(n("tooltipValidationErrorSeparator", ". ")) : void 0;
}, hO = class extends U {
  constructor() {
    super(...arguments), this.beanName = "tooltipSvc";
  }
  setupHeaderTooltip(e, t, n, o) {
    e && t.destroyBean(e);
    const s = ua(this.gos), { column: i, eGui: r } = t, a = i.getColDef();
    !o && s && !a.headerComponent && (o = ai(
      () => r.querySelector(".ag-header-cell-text")
    ));
    const l = {
      getGui: () => r,
      getLocation: () => "header",
      getTooltipValue: () => n ?? i.getColDef().headerTooltip,
      shouldDisplayTooltip: o,
      getAdditionalParams: () => ({
        column: i,
        colDef: i.getColDef()
      })
    };
    let d = this.createTooltipFeature(l);
    return d && (d = t.createBean(d), t.setRefreshFunction("tooltip", () => d.refreshTooltip())), d;
  }
  setupHeaderGroupTooltip(e, t, n, o) {
    e && t.destroyBean(e);
    const s = ua(this.gos), { column: i, eGui: r } = t, a = i.getColGroupDef();
    !o && s && !(a != null && a.headerGroupComponent) && (o = ai(
      () => r.querySelector(".ag-header-group-text")
    ));
    const l = {
      getGui: () => r,
      getLocation: () => "headerGroup",
      getTooltipValue: () => n ?? (a && a.headerTooltip),
      shouldDisplayTooltip: o,
      getAdditionalParams: () => {
        const c = {
          column: i
        };
        return a && (c.colDef = a), c;
      }
    }, d = this.createTooltipFeature(l);
    return d && t.createBean(d);
  }
  enableCellTooltipFeature(e, t, n) {
    const { beans: o } = this, { gos: s, editSvc: i } = o, { column: r, rowNode: a } = e;
    let l = "cell";
    const d = () => {
      const g = !!!(i != null && i.isEditing(e)) && Tu(o, e, this.getLocaleTextFunc());
      if (g)
        return l = "cellEditor", g;
      l = "cell";
      const p = r.getColDef(), f = a.data;
      if (p.tooltipField && ue(f))
        return la(f, p.tooltipField, r.isTooltipFieldContainsDots());
      const m = p.tooltipValueGetter;
      return m ? m(
        ke(s, {
          location: "cell",
          colDef: r.getColDef(),
          column: r,
          rowIndex: e.cellPosition.rowIndex,
          node: a,
          data: a.data,
          value: e.value,
          valueFormatted: e.valueFormatted
        })
      ) : null;
    }, c = ua(s);
    n || (c && !e.isCellRenderer() ? n = () => {
      const h = !!(i != null && i.isEditing(e));
      if (!h && Tu(o, e, this.getLocaleTextFunc()))
        return !0;
      if (!r.isTooltipEnabled())
        return !1;
      const f = ai(() => {
        const m = e.eGui;
        return m.children.length === 0 ? m : m.querySelector(".ag-cell-value");
      });
      return !h && f();
    } : n = () => !(i != null && i.isEditing(e)));
    const u = {
      getGui: () => e.eGui,
      getLocation: () => l,
      getTooltipValue: t != null ? () => t : d,
      shouldDisplayTooltip: n,
      getAdditionalParams: () => ({
        column: r,
        colDef: r.getColDef(),
        rowIndex: e.cellPosition.rowIndex,
        node: a,
        data: a.data,
        valueFormatted: e.valueFormatted
      })
    };
    return this.createTooltipFeature(u, o);
  }
  setupFullWidthRowTooltip(e, t, n, o) {
    const s = {
      getGui: () => t.getFullWidthElement(),
      getTooltipValue: () => n,
      getLocation: () => "fullWidthRow",
      shouldDisplayTooltip: o
    }, i = this.beans, r = i.context;
    e && t.destroyBean(e, r);
    const a = this.createTooltipFeature(s, i);
    if (a)
      return t.createBean(a, r);
  }
  setupCellEditorTooltip(e, t) {
    var a, l;
    const { beans: n } = this, { context: o } = n, s = ((a = t.getValidationElement) == null ? void 0 : a.call(t, !0)) || !((l = t.isPopup) != null && l.call(t)) && e.eGui;
    if (!s)
      return;
    const i = {
      getGui: () => s,
      getTooltipValue: () => Tu(n, e, this.getLocaleTextFunc()),
      getLocation: () => "cellEditor",
      shouldDisplayTooltip: () => {
        var p, f;
        const { editModelSvc: d } = n, c = (p = d == null ? void 0 : d.getRowValidationModel()) == null ? void 0 : p.getRowValidationMap(), u = (f = d == null ? void 0 : d.getCellValidationModel()) == null ? void 0 : f.getCellValidationMap(), h = !!c && c.size > 0, g = !!u && u.size > 0;
        return h || g;
      }
    }, r = this.createTooltipFeature(i, n);
    if (r)
      return e.createBean(r, o);
  }
  initCol(e) {
    const { colDef: t } = e;
    e.tooltipEnabled = ue(t.tooltipField) || ue(t.tooltipValueGetter) || ue(t.tooltipComponent);
  }
  createTooltipFeature(e, t) {
    return this.beans.registry.createDynamicBean("tooltipFeature", !1, e, t);
  }
}, gO = class extends JM {
  createTooltipComp(e, t) {
    const n = WF(this.beans.userCompFactory, e);
    n == null || n.newAgStackInstance().then(t);
  }
  setEventHandlers(e) {
    [this.onColumnMovedEventCallback] = this.addManagedEventListeners({
      columnMoved: e
    });
  }
  clearEventHandlers() {
    var e;
    (e = this.onColumnMovedEventCallback) == null || e.call(this), this.onColumnMovedEventCallback = void 0;
  }
}, Wp = {
  moduleName: "Tooltip",
  version: Ee,
  beans: [hO],
  dynamicBeans: {
    tooltipFeature: yw,
    highlightTooltipFeature: XM,
    tooltipStateManager: gO
  },
  userComponents: {
    agTooltipComponent: nI
  },
  dependsOn: [Vs],
  css: [uO]
}, Ni = class {
  constructor(e) {
    this.cellValueChanges = e;
  }
}, ku = class extends Ni {
  constructor(e, t, n, o) {
    super(e), this.initialRange = t, this.finalRange = n, this.ranges = o;
  }
}, pO = 10, u0 = class {
  constructor(e) {
    this.actionStack = [], this.maxStackSize = e || pO, this.actionStack = new Array(this.maxStackSize);
  }
  pop() {
    return this.actionStack.pop();
  }
  push(e) {
    e.cellValueChanges && e.cellValueChanges.length > 0 && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(e));
  }
  clear() {
    this.actionStack = [];
  }
  getCurrentStackSize() {
    return this.actionStack.length;
  }
}, fO = class extends U {
  constructor() {
    super(...arguments), this.beanName = "undoRedo", this.cellValueChanges = [], this.activeCellEdit = null, this.activeRowEdit = null, this.isPasting = !1, this.isRangeInAction = !1, this.batchEditing = !1, this.bulkEditing = !1, this.onCellValueChanged = (e) => {
      const t = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned }, n = this.activeCellEdit !== null && Mp(this.activeCellEdit, t), o = this.activeRowEdit !== null && sy(this.activeRowEdit, t);
      if (!(n || o || this.isPasting || this.isRangeInAction))
        return;
      const { rowPinned: i, rowIndex: r, column: a, oldValue: l, value: d } = e, c = {
        rowPinned: i,
        rowIndex: r,
        columnId: a.getColId(),
        newValue: d,
        oldValue: l
      };
      this.cellValueChanges.push(c);
    }, this.clearStacks = () => {
      this.undoStack.clear(), this.redoStack.clear();
    };
  }
  postConstruct() {
    const { gos: e, ctrlsSvc: t } = this.beans;
    if (!e.get("undoRedoCellEditing"))
      return;
    const n = e.get("undoRedoCellEditingLimit");
    if (n <= 0)
      return;
    this.undoStack = new u0(n), this.redoStack = new u0(n), this.addListeners();
    const o = this.clearStacks.bind(this);
    this.addManagedEventListeners({
      cellValueChanged: this.onCellValueChanged.bind(this),
      // undo / redo is restricted to actual editing so we clear the stacks when other operations are
      // performed that change the order of the row / cols.
      modelUpdated: (s) => {
        s.keepUndoRedoStack || this.clearStacks();
      },
      columnPivotModeChanged: o,
      newColumnsLoaded: o,
      columnGroupOpened: o,
      columnRowGroupChanged: o,
      columnMoved: o,
      columnPinned: o,
      columnVisible: o,
      rowDragEnd: o
    }), t.whenReady(this, (s) => {
      this.gridBodyCtrl = s.gridBodyCtrl;
    });
  }
  getCurrentUndoStackSize() {
    var e;
    return ((e = this.undoStack) == null ? void 0 : e.getCurrentStackSize()) ?? 0;
  }
  getCurrentRedoStackSize() {
    var e;
    return ((e = this.redoStack) == null ? void 0 : e.getCurrentStackSize()) ?? 0;
  }
  undo(e) {
    const { eventSvc: t, undoStack: n, redoStack: o } = this;
    t.dispatchEvent({
      type: "undoStarted",
      source: e
    });
    const s = this.undoRedo(n, o, "initialRange", "oldValue", "undo");
    t.dispatchEvent({
      type: "undoEnded",
      source: e,
      operationPerformed: s
    });
  }
  redo(e) {
    const { eventSvc: t, undoStack: n, redoStack: o } = this;
    t.dispatchEvent({
      type: "redoStarted",
      source: e
    });
    const s = this.undoRedo(o, n, "finalRange", "newValue", "redo");
    t.dispatchEvent({
      type: "redoEnded",
      source: e,
      operationPerformed: s
    });
  }
  undoRedo(e, t, n, o, s) {
    if (!e)
      return !1;
    const i = e.pop();
    return !i || !i.cellValueChanges ? !1 : (this.processAction(
      i,
      (r) => r[o],
      s
    ), i instanceof ku ? this.processRange(i.ranges || [i[n]]) : this.processCell(i.cellValueChanges), t.push(i), !0);
  }
  processAction(e, t, n) {
    e.cellValueChanges.forEach((o) => {
      const { rowIndex: s, rowPinned: i, columnId: r } = o, a = { rowIndex: s, rowPinned: i }, l = To(this.beans, a);
      l.displayed && l.setDataValue(r, t(o), n);
    });
  }
  processRange(e) {
    let t;
    const n = this.beans.rangeSvc;
    n.removeAllCellRanges(!0), e.forEach((o, s) => {
      if (!o)
        return;
      const i = o.startRow, r = o.endRow;
      s === e.length - 1 && (t = {
        rowPinned: i.rowPinned,
        rowIndex: i.rowIndex,
        columnId: o.startColumn.getColId()
      }, this.setLastFocusedCell(t));
      const a = {
        rowStartIndex: i.rowIndex,
        rowStartPinned: i.rowPinned,
        rowEndIndex: r.rowIndex,
        rowEndPinned: r.rowPinned,
        columnStart: o.startColumn,
        columns: o.columns
      };
      n.addCellRange(a);
    });
  }
  processCell(e) {
    const t = e[0], { rowIndex: n, rowPinned: o } = t, s = { rowIndex: n, rowPinned: o }, i = To(this.beans, s), r = {
      rowPinned: t.rowPinned,
      rowIndex: i.rowIndex,
      columnId: t.columnId
    };
    this.setLastFocusedCell(r);
  }
  setLastFocusedCell(e) {
    const { rowIndex: t, columnId: n, rowPinned: o } = e, { colModel: s, focusSvc: i, rangeSvc: r } = this.beans, a = s.getCol(n);
    if (!a)
      return;
    const { scrollFeature: l } = this.gridBodyCtrl;
    l.ensureIndexVisible(t), l.ensureColumnVisible(a);
    const d = { rowIndex: t, column: a, rowPinned: o };
    i.setFocusedCell({ ...d, forceBrowserFocus: !0 }), r == null || r.setRangeToCell(d);
  }
  addListeners() {
    this.addManagedEventListeners({
      rowEditingStarted: (e) => {
        this.activeRowEdit = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
      },
      rowEditingStopped: () => {
        const e = new Ni(this.cellValueChanges);
        this.pushActionsToUndoStack(e), this.activeRowEdit = null;
      },
      cellEditingStarted: (e) => {
        this.activeCellEdit = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned };
      },
      cellEditingStopped: (e) => {
        if (this.activeCellEdit = null, e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction) {
          const n = new Ni(this.cellValueChanges);
          this.pushActionsToUndoStack(n);
        }
      },
      pasteStart: () => {
        this.isPasting = !0;
      },
      pasteEnd: () => {
        const e = new Ni(this.cellValueChanges);
        this.pushActionsToUndoStack(e), this.isPasting = !1;
      },
      fillStart: () => {
        this.isRangeInAction = !0;
      },
      fillEnd: (e) => {
        const t = new ku(this.cellValueChanges, e.initialRange, e.finalRange);
        this.pushActionsToUndoStack(t), this.isRangeInAction = !1;
      },
      keyShortcutChangedCellStart: () => {
        this.isRangeInAction = !0;
      },
      keyShortcutChangedCellEnd: () => {
        let e;
        const { rangeSvc: t, gos: n } = this.beans;
        t && Xo(n) ? e = new ku(this.cellValueChanges, void 0, void 0, [
          ...t.getCellRanges()
        ]) : e = new Ni(this.cellValueChanges), this.pushActionsToUndoStack(e), this.isRangeInAction = !1;
      },
      batchEditingStarted: () => this.startBigChange("batchEditing"),
      batchEditingStopped: ({ changes: e }) => this.stopBigChange("batchEditing", e),
      bulkEditingStarted: () => this.startBigChange("bulkEditing"),
      bulkEditingStopped: ({ changes: e }) => this.stopBigChange("bulkEditing", e)
    });
  }
  startBigChange(e) {
    this[e] = !0;
  }
  stopBigChange(e, t) {
    if (!this[e] || (this[e] = !1, (t == null ? void 0 : t.length) === 0))
      return;
    const n = new Ni(t ?? []);
    this.pushActionsToUndoStack(n), this.cellValueChanges = [];
  }
  pushActionsToUndoStack(e) {
    this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
  }
}, mO = (
  /*css*/
  ".ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;min-height:100%;width:100%}&.ag-cell-editing-error{border-color:var(--ag-invalid-color)!important}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{display:block;height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-row.ag-row-editing-invalid .ag-cell-inline-editing){opacity:.8}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}"
), vO = {
  tag: "div",
  cls: "ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eEditor",
      role: "presentation"
    }
  ]
}, CO = class extends Rc {
  constructor() {
    super(vO, [Di]), this.eEditor = X;
  }
  initialiseEditor(e) {
    const t = e.value ?? void 0, n = this.eEditor;
    n.setValue(t), n.getInputElement().setAttribute("tabindex", "-1"), this.setAriaLabel(t), this.addManagedListeners(n, {
      fieldValueChanged: (s) => this.setAriaLabel(s.selected)
    });
  }
  getValue() {
    return this.eEditor.getValue();
  }
  focusIn() {
    this.eEditor.getFocusableElement().focus();
  }
  afterGuiAttached() {
    this.params.cellStartedEdit && this.focusIn();
  }
  isPopup() {
    return !1;
  }
  setAriaLabel(e) {
    const t = this.getLocaleTextFunc(), n = dc(t, e), o = t("ariaToggleCellValue", "Press SPACE to toggle cell value");
    this.eEditor.setInputAriaLabel(`${o} (${n})`);
  }
  getValidationElement(e) {
    return e ? this.params.eGridCell : this.eEditor.getInputElement();
  }
  getValidationErrors() {
    const { params: e } = this, { getValidationErrors: t } = e, n = this.getValue();
    return t ? t({
      value: n,
      internalErrors: null,
      cellEditorParams: e
    }) : null;
  }
}, Mc = class extends Rc {
  constructor(e) {
    super(), this.cellEditorInput = e, this.eEditor = X;
  }
  initialiseEditor(e) {
    const { cellEditorInput: t } = this;
    this.setTemplate(
      { tag: "div", cls: "ag-cell-edit-wrapper", children: [t.getTemplate()] },
      t.getAgComponents()
    );
    const { eEditor: n } = this, { cellStartedEdit: o, eventKey: s, suppressPreventDefault: i } = e;
    n.getInputElement().setAttribute("title", ""), t.init(n, e);
    let r, a = !0;
    o ? (this.focusAfterAttached = !0, s === O.BACKSPACE || s === O.DELETE ? r = "" : s && s.length === 1 ? i ? a = !1 : r = s : (r = t.getStartValue(), s !== O.F2 && (this.highlightAllOnFocus = !0))) : (this.focusAfterAttached = !1, r = t.getStartValue()), a && r != null && n.setStartValue(r), this.addGuiEventListener("keydown", (l) => {
      const { key: d } = l;
      (d === O.PAGE_UP || d === O.PAGE_DOWN) && l.preventDefault();
    });
  }
  afterGuiAttached() {
    var o, s;
    const e = this.getLocaleTextFunc(), t = this.eEditor;
    if (t.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), !this.focusAfterAttached)
      return;
    os() || t.getFocusableElement().focus();
    const n = t.getInputElement();
    this.highlightAllOnFocus ? n.select() : (s = (o = this.cellEditorInput).setCaret) == null || s.call(o);
  }
  // gets called when tabbing through cells and in full row edit mode
  focusIn() {
    const { eEditor: e } = this, t = e.getFocusableElement(), n = e.getInputElement();
    t.focus(), n.select();
  }
  getValue() {
    return this.cellEditorInput.getValue();
  }
  isPopup() {
    return !1;
  }
  getValidationElement() {
    return this.eEditor.getInputElement();
  }
  getValidationErrors() {
    return this.cellEditorInput.getValidationErrors();
  }
}, wO = {
  tag: "ag-input-date-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, yO = class {
  constructor(e, t) {
    this.getDataTypeService = e, this.getLocaleTextFunc = t;
  }
  getTemplate() {
    return wO;
  }
  getAgComponents() {
    return [uw];
  }
  init(e, t) {
    var r, a;
    this.eEditor = e, this.params = t;
    const { min: n, max: o, step: s, colDef: i } = t;
    n != null && e.setMin(n), o != null && e.setMax(o), s != null && e.setStep(s), this.includeTime = t.includeTime ?? ((a = (r = this.getDataTypeService()) == null ? void 0 : r.getDateIncludesTimeFlag) == null ? void 0 : a.call(r, i.cellDataType)), this.includeTime != null && e.setIncludeTime(this.includeTime);
  }
  getValidationErrors() {
    const t = this.eEditor.getInputElement().valueAsDate, { params: n } = this, { min: o, max: s, getValidationErrors: i } = n;
    let r = [];
    const a = this.getLocaleTextFunc();
    if (t instanceof Date && !isNaN(t.getTime())) {
      if (o) {
        const l = o instanceof Date ? o : new Date(o);
        if (t < l) {
          const d = l.toLocaleDateString();
          r.push(
            a("minDateValidation", `Date must be after ${d}`, [d])
          );
        }
      }
      if (s) {
        const l = s instanceof Date ? s : new Date(s);
        if (t > l) {
          const d = l.toLocaleDateString();
          r.push(
            a("maxDateValidation", `Date must be before ${d}`, [d])
          );
        }
      }
    }
    return r.length || (r = null), i ? i({ value: t, cellEditorParams: n, internalErrors: r }) : r;
  }
  getValue() {
    const { eEditor: e, params: t } = this, n = e.getDate();
    return !ue(n) && !ue(t.value) ? t.value : n ?? null;
  }
  getStartValue() {
    const { value: e } = this.params;
    if (e instanceof Date)
      return un(e, this.includeTime ?? !1);
  }
}, bO = class extends Mc {
  constructor() {
    super(
      new yO(
        () => this.beans.dataTypeSvc,
        () => this.getLocaleTextFunc()
      )
    );
  }
}, SO = {
  tag: "ag-input-date-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, xO = class {
  constructor(e, t) {
    this.getDataTypeService = e, this.getLocaleTextFunc = t;
  }
  getTemplate() {
    return SO;
  }
  getAgComponents() {
    return [uw];
  }
  init(e, t) {
    var r, a;
    this.eEditor = e, this.params = t;
    const { min: n, max: o, step: s, colDef: i } = t;
    n != null && e.setMin(n), o != null && e.setMax(o), s != null && e.setStep(s), this.includeTime = t.includeTime ?? ((a = (r = this.getDataTypeService()) == null ? void 0 : r.getDateIncludesTimeFlag) == null ? void 0 : a.call(r, i.cellDataType)), this.includeTime != null && e.setIncludeTime(this.includeTime);
  }
  getValidationErrors() {
    const { eEditor: e, params: t } = this, n = e.getInputElement().value, o = this.formatDate(this.parseDate(n ?? void 0)), { min: s, max: i, getValidationErrors: r } = t;
    let a = [];
    if (o) {
      const l = new Date(o), d = this.getLocaleTextFunc();
      if (s) {
        const c = new Date(s);
        if (l < c) {
          const u = c.toLocaleDateString();
          a.push(
            d("minDateValidation", `Date must be after ${u}`, [u])
          );
        }
      }
      if (i) {
        const c = new Date(i);
        if (l > c) {
          const u = c.toLocaleDateString();
          a.push(
            d("maxDateValidation", `Date must be before ${u}`, [u])
          );
        }
      }
    }
    return a.length || (a = null), r ? r({
      value: this.getValue(),
      cellEditorParams: t,
      internalErrors: a
    }) : a;
  }
  getValue() {
    const { params: e, eEditor: t } = this, n = this.formatDate(t.getDate());
    return !ue(n) && !ue(e.value) ? e.value : e.parseValue(n ?? "");
  }
  getStartValue() {
    return un(this.parseDate(this.params.value ?? void 0) ?? null, this.includeTime ?? !1);
  }
  parseDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateParserFunction(this.params.column)(e) : Qt(e) ?? void 0;
  }
  formatDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateFormatterFunction(this.params.column)(e) : un(e ?? null, this.includeTime ?? !1) ?? void 0;
  }
}, RO = class extends Mc {
  constructor() {
    super(
      new xO(
        () => this.beans.dataTypeSvc,
        () => this.getLocaleTextFunc()
      )
    );
  }
}, EO = {
  tag: "div",
  cls: "ag-large-text",
  children: [
    {
      tag: "ag-input-text-area",
      ref: "eEditor",
      cls: "ag-large-text-input"
    }
  ]
}, AO = class extends Rc {
  constructor() {
    super(EO, [cM]), this.eEditor = X;
  }
  initialiseEditor(e) {
    const { eEditor: t } = this, { cellStartedEdit: n, eventKey: o, maxLength: s, cols: i, rows: r } = e;
    this.focusAfterAttached = n, t.getInputElement().setAttribute("title", ""), t.setMaxLength(s || 200).setCols(i || 60).setRows(r || 10);
    let a;
    n ? (this.focusAfterAttached = !0, o === O.BACKSPACE || o === O.DELETE ? a = "" : o && o.length === 1 ? a = o : (a = this.getStartValue(e), o !== O.F2 && (this.highlightAllOnFocus = !0))) : (this.focusAfterAttached = !1, a = this.getStartValue(e)), a != null && t.setValue(a, !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.activateTabIndex();
  }
  getStartValue(e) {
    const { value: t } = e;
    return (t == null ? void 0 : t.toString()) ?? t;
  }
  onKeyDown(e) {
    const t = e.key;
    (t === O.LEFT || t === O.UP || t === O.RIGHT || t === O.DOWN || e.shiftKey && t === O.ENTER) && e.stopPropagation();
  }
  afterGuiAttached() {
    const { eEditor: e, focusAfterAttached: t, highlightAllOnFocus: n } = this, o = this.getLocaleTextFunc();
    e.setInputAriaLabel(o("ariaInputEditor", "Input Editor")), t && (e.getFocusableElement().focus(), n && e.getInputElement().select());
  }
  getValue() {
    const { eEditor: e, params: t } = this, { value: n } = t, o = e.getValue();
    return !ue(o) && !ue(n) ? n : t.parseValue(o);
  }
  getValidationElement() {
    return this.eEditor.getInputElement();
  }
  getValidationErrors() {
    const { params: e } = this, { maxLength: t, getValidationErrors: n } = e, o = this.getLocaleTextFunc(), s = this.getValue();
    let i = [];
    return typeof s == "string" && t != null && s.length > t && i.push(
      o("maxLengthValidation", `Must be ${t} characters or fewer.`, [String(t)])
    ), i.length || (i = null), n ? n({
      value: s,
      internalErrors: i,
      cellEditorParams: e
    }) : i;
  }
}, FO = {
  tag: "ag-input-number-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, MO = class {
  constructor(e) {
    this.getLocaleTextFunc = e;
  }
  getTemplate() {
    return FO;
  }
  getAgComponents() {
    return [uM];
  }
  init(e, t) {
    this.eEditor = e, this.params = t;
    const { max: n, min: o, precision: s, step: i } = t;
    n != null && e.setMax(n), o != null && e.setMin(o), s != null && e.setPrecision(s), i != null && e.setStep(i);
    const r = e.getInputElement();
    t.preventStepping ? e.addManagedElementListeners(r, { keydown: this.preventStepping }) : t.showStepperButtons && r.classList.add("ag-number-field-input-stepper");
  }
  getValidationErrors() {
    const { params: e } = this, { min: t, max: n, getValidationErrors: o } = e, i = this.eEditor.getInputElement().valueAsNumber, r = this.getLocaleTextFunc();
    let a = [];
    return typeof i == "number" && (t != null && i < t && a.push(
      r("minValueValidation", `Must be greater than or equal to ${t}.`, [String(t)])
    ), n != null && i > n && a.push(
      r("maxValueValidation", `Must be less than or equal to ${n}.`, [String(n)])
    )), a.length || (a = null), o ? o({
      value: i,
      cellEditorParams: e,
      internalErrors: a
    }) : a;
  }
  preventStepping(e) {
    (e.key === O.UP || e.key === O.DOWN) && e.preventDefault();
  }
  getValue() {
    const { eEditor: e, params: t } = this, n = e.getValue();
    if (!ue(n) && !ue(t.value))
      return t.value;
    let o = t.parseValue(n);
    if (o == null)
      return o;
    if (typeof o == "string") {
      if (o === "")
        return null;
      o = Number(o);
    }
    return isNaN(o) ? null : o;
  }
  getStartValue() {
    return this.params.value;
  }
  setCaret() {
    os() && this.eEditor.getInputElement().focus({ preventScroll: !0 });
  }
}, IO = class extends Mc {
  constructor() {
    super(new MO(() => this.getLocaleTextFunc()));
  }
}, PO = {
  tag: "div",
  cls: "ag-cell-edit-wrapper",
  children: [
    {
      tag: "ag-select",
      ref: "eEditor",
      cls: "ag-cell-editor"
    }
  ]
}, DO = class extends Rc {
  constructor() {
    super(PO, [yM]), this.eEditor = X, this.startedByEnter = !1;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc;
  }
  initialiseEditor(e) {
    this.focusAfterAttached = e.cellStartedEdit;
    const { eEditor: t, valueSvc: n, gos: o } = this, { values: s, value: i, eventKey: r } = e;
    if (st(s)) {
      Z(58);
      return;
    }
    this.startedByEnter = r != null ? r === O.ENTER : !1;
    let a = !1;
    s.forEach((u) => {
      const h = { value: u }, g = n.formatValue(e.column, null, u), p = g != null;
      h.text = p ? g : u, t.addOption(h), a = a || i === u;
    }), a ? t.setValue(e.value, !0) : e.values.length && t.setValue(e.values[0], !0);
    const { valueListGap: l, valueListMaxWidth: d, valueListMaxHeight: c } = e;
    l != null && t.setPickerGap(l), c != null && t.setPickerMaxHeight(c), d != null && t.setPickerMaxWidth(d), o.get("editType") !== "fullRow" && this.addManagedListeners(this.eEditor, { selectedItem: () => e.stopEditing() });
  }
  afterGuiAttached() {
    this.focusAfterAttached && this.eEditor.getFocusableElement().focus(), this.startedByEnter && setTimeout(() => {
      this.isAlive() && this.eEditor.showPicker();
    });
  }
  focusIn() {
    this.eEditor.getFocusableElement().focus();
  }
  getValue() {
    return this.eEditor.getValue();
  }
  isPopup() {
    return !1;
  }
  getValidationElement() {
    return this.eEditor.getAriaElement();
  }
  getValidationErrors() {
    const { params: e } = this, { values: t, getValidationErrors: n } = e, o = this.getValue();
    let s = [];
    if (t && !t.includes(o)) {
      const i = this.getLocaleTextFunc();
      s.push(i("invalidSelectionValidation", "Invalid selection."));
    } else
      s = null;
    return n ? n({
      value: o,
      internalErrors: s,
      cellEditorParams: e
    }) : s;
  }
}, TO = {
  tag: "ag-input-text-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, kO = class {
  constructor(e) {
    this.getLocaleTextFunc = e;
  }
  getTemplate() {
    return TO;
  }
  getAgComponents() {
    return [ao];
  }
  init(e, t) {
    this.eEditor = e, this.params = t;
    const n = t.maxLength;
    n != null && e.setMaxLength(n);
  }
  getValidationErrors() {
    const { params: e } = this, { maxLength: t, getValidationErrors: n } = e, o = this.getValue(), s = this.getLocaleTextFunc();
    let i = [];
    return t != null && typeof o == "string" && o.length > t && i.push(
      s("maxLengthValidation", `Must be ${t} characters or fewer.`, [String(t)])
    ), i.length || (i = null), n ? n({ value: o, cellEditorParams: e, internalErrors: i }) : i;
  }
  getValue() {
    const { eEditor: e, params: t } = this, n = e.getValue();
    return !ue(n) && !ue(t.value) ? t.value : t.parseValue(n);
  }
  getStartValue() {
    const e = this.params;
    return e.useFormatter || e.column.getColDef().refData ? e.formatValue(e.value) : e.value;
  }
  setCaret() {
    os() && this.eEditor.getInputElement().focus({ preventScroll: !0 });
    const e = this.eEditor, t = e.getValue(), n = ue(t) && t.length || 0;
    n && e.getInputElement().setSelectionRange(n, n);
  }
}, h0 = class extends Mc {
  constructor() {
    super(new kO(() => this.getLocaleTextFunc()));
  }
};
function LO(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function BO(e) {
  return e.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function Xy(e, t, n = "auto") {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureColumnVisible(t, n),
    "ensureVisible"
  );
}
function eb(e, t, n) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureIndexVisible(t, n),
    "ensureVisible"
  );
}
function OO(e, t, n = null) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureNodeVisible(t, n),
    "ensureVisible"
  );
}
function GO(e) {
  var t;
  (t = e.undoRedo) == null || t.undo("api");
}
function HO(e) {
  var t;
  (t = e.undoRedo) == null || t.redo("api");
}
function VO(e, t) {
  var n;
  return (n = e.editModelSvc) == null ? void 0 : n.getEditRowDataValue(t, { checkSiblings: !0 });
}
function _O(e) {
  var o;
  const t = (o = e.editModelSvc) == null ? void 0 : o.getEditMap(), n = [];
  return t == null || t.forEach((s, i) => {
    const { rowIndex: r, rowPinned: a } = i;
    s.forEach((l, d) => {
      const { editorValue: c, pendingValue: u, sourceValue: h, state: g } = l, p = zo(l);
      let f = c ?? u;
      f === jn && (f = void 0);
      const m = {
        newValue: f,
        oldValue: h,
        state: g,
        column: d,
        colId: d.getColId(),
        colKey: d.getColId(),
        rowIndex: r,
        rowPinned: a
      };
      (g === "editing" || g === "changed" && p) && n.push(m);
    });
  }), n;
}
function NO(e, t = !1) {
  var o;
  const { editSvc: n } = e;
  n != null && n.isBatchEditing() ? (t ? (o = e.editModelSvc) == null || o.getEditPositions().forEach((s) => {
    s.state === "editing" && n.revertSingleCellEdit(s);
  }) : ni(e, { persist: !0 }), sr(e, void 0, { cancel: t })) : n == null || n.stopEditing(void 0, { cancel: t, source: "edit", forceStop: !t, forceCancel: t });
}
function $O(e, t) {
  var o;
  const n = wt(e, t);
  return ((o = e.editSvc) == null ? void 0 : o.isEditing(n)) ?? !1;
}
function zO(e, t) {
  const { key: n, colKey: o, rowIndex: s, rowPinned: i } = t, { editSvc: r, colModel: a } = e, l = a.getCol(o);
  if (!l) {
    Z(12, { colKey: o });
    return;
  }
  const c = To(e, {
    rowIndex: s,
    rowPinned: i || null
  });
  if (!c) {
    Z(290, { rowIndex: s, rowPinned: i });
    return;
  }
  if (!l.isCellEditable(c))
    return;
  i == null && eb(e, s), Xy(e, o), r == null || r.startEditing(
    {
      rowNode: c,
      column: l
    },
    {
      event: n ? new KeyboardEvent("keydown", { key: n }) : void 0,
      source: "api"
    }
  );
}
function WO(e) {
  var t;
  return ((t = e.editSvc) == null ? void 0 : t.validateEdit()) || null;
}
function UO(e) {
  var t;
  return ((t = e.undoRedo) == null ? void 0 : t.getCurrentUndoStackSize()) ?? 0;
}
function KO(e) {
  var t;
  return ((t = e.undoRedo) == null ? void 0 : t.getCurrentRedoStackSize()) ?? 0;
}
var ZO = { tag: "div", cls: "ag-popup-editor", attrs: { tabindex: "-1" } }, qO = class extends fc {
  constructor(e) {
    super(ZO), this.params = e;
  }
  postConstruct() {
    Ci(this.gos, this.getGui(), "popupEditorWrapper", !0), this.addKeyDownListener();
  }
  addKeyDownListener() {
    const e = this.getGui(), t = this.params, n = (o) => {
      Ih(this.gos, o, t.node, t.column, !0) || t.onKeyDown(o);
    };
    this.addManagedElementListeners(e, { keydown: n });
  }
};
function jO(e, { column: t }, n, o, s = "ui") {
  var d;
  if (n instanceof KeyboardEvent && (n.key === O.TAB || n.key === O.ENTER || n.key === O.F2 || n.key === O.BACKSPACE && o))
    return !0;
  if ((n == null ? void 0 : n.shiftKey) && ((d = e.rangeSvc) == null ? void 0 : d.getCellRanges().length) != 0)
    return !1;
  const r = t == null ? void 0 : t.getColDef(), a = YO(e.gos, r), l = n == null ? void 0 : n.type;
  return l === "click" && (n == null ? void 0 : n.detail) === 1 && a === 1 || l === "dblclick" && (n == null ? void 0 : n.detail) === 2 && a === 2 ? !0 : s === "api" ? o ?? !1 : !1;
}
function YO(e, t) {
  return e.get("suppressClickEdit") === !0 ? 0 : e.get("singleClickEdit") === !0 || t != null && t.singleClickEdit ? 1 : 2;
}
function Kh(e, { rowNode: t, column: n }, o = "ui") {
  const s = n.getColDef().editable, i = e.editModelSvc;
  return n.isColumnFunc(t, s) || !!i && i.hasEdits({ rowNode: t, column: n }, { withOpenEditor: !0 });
}
function QO(e, t, n = "ui") {
  const o = Kh(e, t, n);
  return o === !0 || n === "ui" ? o : e.colModel.getCols().some((i) => Kh(e, { rowNode: t.rowNode, column: i }, n));
}
var Vd = (e, t = !1) => {
  if (e !== void 0)
    return zo(e) || t && e.state === "editing";
};
function tb(e, t, n = !1) {
  var o;
  return Vd((o = e.editModelSvc) == null ? void 0 : o.getEdit(t), n);
}
function nb(e, t) {
  const { editModelSvc: n } = e, { column: o, rowNode: s } = t;
  if (e.gos.get("groupTotalRow") && !(s != null && s.footer))
    return !1;
  for (const i of (s == null ? void 0 : s.allLeafChildren) ?? [])
    if (Vd(n == null ? void 0 : n.getEdit({ rowNode: i, column: o })) || Vd(n == null ? void 0 : n.getEdit({ rowNode: i.pinnedSibling, column: o })))
      return !0;
}
function ob(e, { rowNode: t, column: n }) {
  var o;
  if (t = t.pinnedSibling, !!t)
    return Vd(
      (o = e.editModelSvc) == null ? void 0 : o.getEdit({
        rowNode: t,
        column: n
      })
    );
}
var JO = class extends U {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.editSvc = t.editSvc, this.editModelSvc = t.editModelSvc;
  }
  setComp(e) {
    this.cellComp = e, this.applyCellStyles();
  }
  applyCellStyles() {
    var s;
    const { cellCtrl: e, editSvc: t, beans: n } = this;
    if (t != null && t.isBatchEditing() && t.isEditing()) {
      const i = tb(n, e) || nb(n, e) || ob(n, e);
      this.applyBatchingStyle(i);
    } else
      this.applyBatchingStyle(!1);
    const o = !!((s = this.editModelSvc) != null && s.getCellValidationModel().hasCellValidation(this.cellCtrl));
    this.cellComp.toggleCss("ag-cell-editing-error", o);
  }
  applyBatchingStyle(e) {
    var t;
    this.cellComp.toggleCss("ag-cell-editing", e ?? !1), this.cellComp.toggleCss("ag-cell-batch-edit", (e && ((t = this.editSvc) == null ? void 0 : t.isBatchEditing())) ?? !1);
  }
}, XO = class extends U {
  constructor(e, t) {
    super(), this.rowCtrl = e, this.beans = t, this.gos = t.gos, this.editSvc = t.editSvc, this.editModelSvc = t.editModelSvc;
  }
  applyRowStyles() {
    var r;
    const { rowCtrl: e, editModelSvc: t, beans: n } = this;
    let o = e.rowNode, s = t == null ? void 0 : t.getEditRow(o);
    const i = (r = this.editModelSvc) == null ? void 0 : r.getRowValidationModel().hasRowValidation({ rowNode: o });
    if (!s && o.pinnedSibling && (o = o.pinnedSibling, s = t == null ? void 0 : t.getEditRow(o)), s) {
      const a = Array.from(s.keys()).some((l) => {
        const d = { rowNode: o, column: l };
        return tb(n, d, !0) || nb(n, d) || ob(n, d);
      });
      this.applyStyle(i, a);
      return;
    }
    this.applyStyle(i);
  }
  applyStyle(e = !1, t = !1) {
    var s, i;
    const n = ((s = this.editSvc) == null ? void 0 : s.isBatchEditing()) ?? !1, o = this.gos.get("editType") === "fullRow";
    (i = this.rowCtrl) == null || i.forEachGui(void 0, ({ rowComp: r }) => {
      r.toggleCss("ag-row-editing", o && t), r.toggleCss("ag-row-batch-edit", o && t && n), r.toggleCss("ag-row-inline-editing", t), r.toggleCss("ag-row-not-inline-editing", !t), r.toggleCss("ag-row-editing-invalid", o && t && e);
    });
  }
}, eG = ({ rowModel: e, pinnedRowModel: t, editModelSvc: n }, o) => {
  const s = /* @__PURE__ */ new Set();
  return e.forEachNode((i) => o.has(i) && s.add(i)), t == null || t.forEachPinnedRow("top", (i) => o.has(i) && s.add(i)), t == null || t.forEachPinnedRow("bottom", (i) => o.has(i) && s.add(i)), o.forEach((i) => {
    s.has(i) || n.removeEdits({ rowNode: i });
  }), s;
}, tG = ({ editModelSvc: e }, t, n) => {
  t.forEach(
    (o) => {
      var s;
      return (s = e == null ? void 0 : e.getEditRow(o)) == null ? void 0 : s.forEach((i, r) => !n.has(r) && e.removeEdits({ rowNode: o, column: r }));
    }
  );
}, nG = (e) => () => {
  const t = new Set(e.colModel.getCols()), n = e.editModelSvc.getEditMap(!0), o = new Set(n.keys());
  tG(e, eG(e, o), t);
}, oG = /* @__PURE__ */ new Set(["undo", "redo", "paste", "bulk", "rangeSvc"]), sG = /* @__PURE__ */ new Set(["ui", "api"]), sb = {
  paste: "api",
  rangeSvc: "api",
  fillHandle: "api",
  cellClear: "api",
  bulk: "api"
}, iG = new Set(Object.keys(sb)), rG = /* @__PURE__ */ new Set([
  "paste",
  "rangeSvc",
  "renderer",
  "cellClear",
  "redo",
  "undo"
]), Fl = { cancel: !0, source: "api" }, aG = { cancel: !1, source: "api" }, Hi = { checkSiblings: !0 }, Ur = { force: !0, suppressFlash: !0 }, lG = class extends U {
  constructor() {
    super(...arguments), this.beanName = "editSvc", this.batch = !1, this.stopping = !1, this.committing = !1;
  }
  postConstruct() {
    const { beans: e } = this;
    this.model = e.editModelSvc, this.valueSvc = e.valueSvc, this.rangeSvc = e.rangeSvc, this.addManagedPropertyListener("editType", ({ currentValue: o }) => {
      this.stopEditing(void 0, Fl), this.createStrategy(o);
    });
    const t = nG(e), n = () => {
      const o = this.model.getCellValidationModel().getCellValidationMap().size > 0, s = this.model.getRowValidationModel().getRowValidationMap().size > 0;
      return o || s ? this.stopEditing(void 0, Fl) : this.isEditing() && (this.isBatchEditing() ? sr(e, this.model.getEditPositions()) : this.stopEditing(void 0, aG)), !1;
    };
    this.addManagedEventListeners({
      columnPinned: t,
      columnVisible: t,
      columnRowGroupChanged: t,
      rowExpansionStateChanged: t,
      pinnedRowsChanged: t,
      displayedRowsChanged: t,
      sortChanged: n,
      filterChanged: n,
      cellFocused: this.onCellFocused.bind(this)
    });
  }
  isBatchEditing() {
    return this.batch;
  }
  setBatchEditing(e) {
    e ? (this.batch = !0, this.stopEditing(void 0, Fl)) : (this.stopEditing(void 0, Fl), this.batch = !1);
  }
  createStrategy(e) {
    const { beans: t, gos: n, strategy: o } = this, s = g0(n, e);
    if (o) {
      if (o.beanName === s)
        return o;
      this.destroyStrategy();
    }
    return this.strategy = this.createOptionalManagedBean(
      t.registry.createDynamicBean(s, !0)
    );
  }
  destroyStrategy() {
    this.strategy && (this.strategy.destroy(), this.strategy = this.destroyBean(this.strategy));
  }
  shouldStartEditing(e, t, n, o = "ui") {
    const s = jO(this.beans, e, t, n, o);
    return s && (this.strategy ?? (this.strategy = this.createStrategy())), s;
  }
  shouldStopEditing(e, t, n = "ui") {
    var o;
    return ((o = this.strategy) == null ? void 0 : o.shouldStop(e, t, n)) ?? null;
  }
  shouldCancelEditing(e, t, n = "ui") {
    var o;
    return ((o = this.strategy) == null ? void 0 : o.shouldCancel(e, t, n)) ?? null;
  }
  validateEdit() {
    return EL(this.beans);
  }
  isEditing(e, t) {
    return this.model.hasEdits(e, t ?? Hi);
  }
  isRowEditing(e, t) {
    return (e && this.model.hasRowEdits(e, t)) ?? !1;
  }
  /** @returns whether to prevent default on event */
  startEditing(e, t) {
    const { startedEdit: n = !0, event: o = null, source: s = "ui", ignoreEventKey: i = !1, silent: r } = t;
    if (this.strategy ?? (this.strategy = this.createStrategy()), !this.isCellEditable(e, "api"))
      return;
    const a = wt(this.beans, e);
    if (a && !a.comp) {
      a.onCompAttachedFuncs.push(() => this.startEditing(e, t));
      return;
    }
    const l = this.shouldStartEditing(e, o, n, s);
    if (l === !1 && s !== "api") {
      this.isEditing(e) && this.stopEditing();
      return;
    }
    !this.batch && this.shouldStopEditing(e, void 0, s) && !t.continueEditing && this.stopEditing(void 0, { source: s }), l && this.isBatchEditing() && this.dispatchBatchEvent("batchEditingStarted", /* @__PURE__ */ new Map()), this.strategy.start({
      position: e,
      event: o,
      source: s,
      ignoreEventKey: i,
      startedEdit: n,
      silent: r
    });
  }
  stopEditing(e, t) {
    var C, w, b;
    const { event: n, cancel: o, source: s = "ui", suppressNavigateAfterEdit: i, forceCancel: r, forceStop: a } = t || {}, { beans: l, model: d } = this;
    if (iG.has(s) && this.isBatchEditing())
      return this.bulkRefresh(e), !1;
    const c = this.committing ? sb[s] : s;
    if (!(this.committing || this.isEditing(e) || this.isBatchEditing() && d.hasEdits(e, Hi)) || !this.strategy || this.stopping)
      return !1;
    this.stopping = !0;
    const h = wt(l, e);
    h && (h.onEditorAttachedFuncs = []);
    let g = d.getEditMap(!0), p = !1;
    const f = !o && (!!this.shouldStopEditing(e, n, c) || this.committing && !this.batch) || (a ?? !1), m = o && !!this.shouldCancelEditing(e, n, c) || (r ?? !1);
    if (f || m) {
      ni(l, { persist: !0, isCancelling: m || o, isStopping: f });
      const A = d.getEditMap(), S = this.processEdits(A, o, s);
      (C = this.strategy) == null || C.stop(o, n), S.forEach((F) => {
        d.clearEditValue(F);
      }), this.bulkRefresh(void 0, g), d.getEditPositions(A).forEach((F) => {
        const E = wt(l, F), M = zo(F);
        E == null || E.refreshCell({ force: !0, suppressFlash: !M });
      }), g = A, p || (p = f);
    } else if (n instanceof KeyboardEvent && this.batch && ((w = this.strategy) != null && w.midBatchInputsAllowed(e)) && this.isEditing(e, { withOpenEditor: !0 })) {
      const A = n.key, S = A === O.ENTER, F = A === O.ESCAPE, E = A === O.TAB;
      (S || E || F) && (S || E ? ni(l, { persist: !0 }) : F && this.revertSingleCellEdit(h), this.isBatchEditing() ? (b = this.strategy) == null || b.cleanupEditors() : sr(l, d.getEditPositions(), { event: n, cancel: F }), n.preventDefault(), this.bulkRefresh(e, g, { suppressFlash: !0 }), g = d.getEditMap());
    } else
      ni(l, { persist: !0 }), g = d.getEditMap();
    return p && e && this.model.removeEdits(e), !i && h && this.navigateAfterEdit(n instanceof KeyboardEvent && n.shiftKey, h.cellPosition), _h(l), this.model.hasEdits() || (this.model.getCellValidationModel().clearCellValidationMap(), this.model.getRowValidationModel().clearRowValidationMap()), this.bulkRefresh(), m && this.beans.rowRenderer.refreshRows({ rowNodes: Array.from(g.keys()) }), this.isBatchEditing() && (this.beans.rowRenderer.refreshRows({ suppressFlash: !0, force: !0 }), p && f && this.dispatchBatchEvent("batchEditingStopped", g)), this.stopping = !1, p;
  }
  navigateAfterEdit(e, t) {
    var o;
    if (this.gos.get("enterNavigatesVerticallyAfterEdit")) {
      const s = e ? O.UP : O.DOWN;
      (o = this.beans.navigation) == null || o.navigateToNextCell(null, s, t, !1);
    }
  }
  processEdits(e, t = !1, n) {
    const o = Array.from(e.keys()), s = this.model.getCellValidationModel().getCellValidationMap().size > 0 || this.model.getRowValidationModel().getRowValidationMap().size > 0, i = [];
    for (const r of o) {
      const a = e.get(r);
      for (const l of a.keys()) {
        const d = a.get(l), c = { rowNode: r, column: l }, u = zo(d);
        !t && u && !s && (this.setNodeDataValue(r, l, d.pendingValue, void 0, n) || i.push(c));
      }
    }
    return i;
  }
  setNodeDataValue(e, t, n, o, s = "edit") {
    const { beans: i } = this, r = wt(i, { rowNode: e, column: t }), a = sG.has(s) ? "edit" : s;
    r && (r.suppressRefreshCell = !0), this.commitNextEdit();
    const l = e.setDataValue(t, n, a);
    return r && (r.suppressRefreshCell = !1), o && (r == null || r.refreshCell(Ur)), l;
  }
  setEditMap(e, t) {
    var o;
    this.strategy ?? (this.strategy = this.createStrategy()), (o = this.strategy) == null || o.setEditMap(e, t), this.bulkRefresh();
    let n = Ur;
    t != null && t.forceRefreshOfEditCellsOnly && (n = {
      ...dG(e),
      ...Ur
    }), this.beans.rowRenderer.refreshCells(n);
  }
  dispatchEditValuesChanged({ rowNode: e, column: t }, n = {}) {
    if (!e || !t || !n)
      return;
    const { pendingValue: o, sourceValue: s } = n, { rowIndex: i, rowPinned: r, data: a } = e;
    this.beans.eventSvc.dispatchEvent({
      type: "cellEditValuesChanged",
      node: e,
      rowIndex: i,
      rowPinned: r,
      column: t,
      source: "api",
      data: a,
      newValue: o,
      oldValue: s,
      value: o,
      colDef: t.getColDef()
    });
  }
  bulkRefresh(e = {}, t, n = {}) {
    var a;
    const { beans: o, gos: s } = this, { editModelSvc: i, rowModel: r } = o;
    Ct(s) && (e.rowNode && e.column ? this.refCell(e, this.model.getEdit(e), n) : t && ((a = i == null ? void 0 : i.getEditMap(!1)) == null || a.forEach((l, d) => {
      for (const c of l.keys())
        this.refCell({ rowNode: d, column: c }, l.get(c), n);
    })));
  }
  refCell({ rowNode: e, column: t }, n, o = {}) {
    var u;
    const { beans: s, gos: i } = this, r = /* @__PURE__ */ new Set([e]), a = /* @__PURE__ */ new Set(), l = e.pinnedSibling;
    l && r.add(l);
    const d = e.sibling;
    d && a.add(d);
    let c = e.parent;
    for (; c; )
      (u = c.sibling) != null && u.footer && i.get("groupTotalRow") || !c.parent && c.sibling && i.get("grandTotalRow") ? a.add(c.sibling) : a.add(c), c = c.parent;
    r.forEach((h) => this.dispatchEditValuesChanged({ rowNode: h, column: t }, n)), r.forEach((h) => {
      var g;
      return (g = wt(s, { rowNode: h, column: t })) == null ? void 0 : g.refreshCell(o);
    }), a.forEach((h) => {
      var g;
      return (g = wt(s, { rowNode: h, column: t })) == null ? void 0 : g.refreshCell(o);
    });
  }
  stopAllEditing(e = !1, t = "ui") {
    this.isEditing() && this.stopEditing(void 0, { cancel: e, source: t });
  }
  isCellEditable(e, t = "ui") {
    const { rowNode: n } = e, { gos: o, beans: s } = this;
    if (n.group) {
      if (o.get("treeData")) {
        if (!n.data && !o.get("enableGroupEdit"))
          return !1;
      } else if (!o.get("enableGroupEdit"))
        return !1;
    }
    const i = g0(o) === "fullRow" ? QO(s, e, t) : Kh(s, e, t);
    return i && (this.strategy ?? (this.strategy = this.createStrategy())), i;
  }
  cellEditingInvalidCommitBlocks() {
    return this.gos.get("invalidEditValueMode") === "block";
  }
  checkNavWithValidation(e, t, n = !0) {
    var o, s, i, r;
    if (this.hasValidationErrors(e)) {
      const a = wt(this.beans, e);
      return this.cellEditingInvalidCommitBlocks() ? ((o = t == null ? void 0 : t.preventDefault) == null || o.call(t), n && (!(a != null && a.hasBrowserFocus()) && (a == null || a.focusCell()), (r = (i = (s = a == null ? void 0 : a.comp) == null ? void 0 : s.getCellEditor()) == null ? void 0 : i.focusIn) == null || r.call(i)), "block-stop") : (a && this.revertSingleCellEdit(a), "revert-continue");
    }
    return "continue";
  }
  revertSingleCellEdit(e, t = !1) {
    var o, s, i, r, a;
    const n = wt(this.beans, e);
    (o = n == null ? void 0 : n.comp) != null && o.getCellEditor() && (sr(this.beans, [e], { silent: !0 }), this.model.clearEditValue(e), Ar(this.beans, e, { silent: !0 }), bi(this.beans), n == null || n.refreshCell(Ur), (s = n.rowCtrl.rowEditStyleFeature) == null || s.applyRowStyles(), t && (n == null || n.focusCell(), (a = (r = (i = n == null ? void 0 : n.comp) == null ? void 0 : i.getCellEditor()) == null ? void 0 : r.focusIn) == null || a.call(r)));
  }
  hasValidationErrors(e) {
    var o;
    bi(this.beans);
    const t = wt(this.beans, e);
    t && (t.refreshCell(Ur), (o = t.rowCtrl.rowEditStyleFeature) == null || o.applyRowStyles());
    let n = !1;
    return e != null && e.rowNode ? (n || (n = this.model.getRowValidationModel().hasRowValidation({ rowNode: e.rowNode })), e.column && (n || (n = this.model.getCellValidationModel().hasCellValidation({ rowNode: e.rowNode, column: e.column })))) : (n || (n = this.model.getCellValidationModel().getCellValidationMap().size > 0), n || (n = this.model.getRowValidationModel().getRowValidationMap().size > 0)), n;
  }
  moveToNextCell(e, t, n, o = "ui") {
    var a;
    let s;
    const i = this.isEditing(), r = i && this.checkNavWithValidation(void 0, n) === "block-stop";
    return e instanceof ir && i && (s = (a = this.strategy) == null ? void 0 : a.moveToNextEditingCell(e, t, n, o, r)), s === null || (s = s || !!this.beans.focusSvc.focusedHeader, s === !1 && !r && this.stopEditing()), s;
  }
  getCellDataValue({ rowNode: e, column: t }, n = !0) {
    if (!e || !t)
      return;
    let o = this.model.getEdit({ rowNode: e, column: t });
    const s = e.pinnedSibling;
    if (s) {
      const r = this.model.getEdit({ rowNode: s, column: t });
      r && (o = r);
    }
    const i = n ? (o == null ? void 0 : o.editorValue) ?? (o == null ? void 0 : o.pendingValue) : o == null ? void 0 : o.pendingValue;
    return i === jn || !o ? (o == null ? void 0 : o.sourceValue) ?? this.valueSvc.getValue(t, e, !1, "api") : i;
  }
  addStopEditingWhenGridLosesFocus(e) {
    wL(this, this.beans, e);
  }
  createPopupEditorWrapper(e) {
    return new qO(e);
  }
  commitNextEdit() {
    this.committing = !0;
  }
  setDataValue(e, t, n) {
    var o;
    try {
      if ((!this.isEditing() || this.committing) && !rG.has(n))
        return;
      const { beans: s } = this;
      this.strategy ?? (this.strategy = this.createStrategy());
      const i = this.isBatchEditing() ? "ui" : this.committing ? n ?? "api" : "api";
      if (!n || oG.has(n))
        return nd(s, e, t, n, void 0, { persist: !0 }), this.setNodeDataValue(e.rowNode, e.column, t, !0, n);
      const r = this.model.getEdit(e);
      if (r) {
        if (r.pendingValue === t)
          return !1;
        if (r.sourceValue !== t)
          return nd(s, e, t, n, void 0, { persist: !0 }), this.stopEditing(e, { source: i, suppressNavigateAfterEdit: !0 }), !0;
        if (r.sourceValue === t)
          return (o = s.editModelSvc) == null || o.removeEdits(e), this.dispatchEditValuesChanged(e, {
            ...r,
            pendingValue: t
          }), !0;
      }
      return nd(s, e, t, n, void 0, { persist: !0 }), this.stopEditing(e, { source: i, suppressNavigateAfterEdit: !0 }), !0;
    } finally {
      this.committing = !1;
    }
  }
  handleColDefChanged(e) {
    SL(this.beans, e);
  }
  destroy() {
    this.model.clear(), this.destroyStrategy(), super.destroy();
  }
  prepDetailsDuringBatch(e, t) {
    if (!this.batch || !this.model.hasRowEdits(e.rowNode, Hi))
      return;
    const { rowNode: o, column: s } = e, { compDetails: i, valueToDisplay: r } = t;
    if (i) {
      const { params: l } = i;
      return l.data = this.model.getEditRowDataValue(o, Hi), { compDetails: i };
    }
    const a = this.model.getEditRow(e.rowNode, Hi);
    if (r !== void 0 && (a != null && a.has(s)))
      return { valueToDisplay: this.valueSvc.getValue(s, o) };
  }
  cleanupEditors() {
    var e;
    (e = this.strategy) == null || e.cleanupEditors();
  }
  dispatchCellEvent(e, t, n, o) {
    var s;
    (s = this.strategy) == null || s.dispatchCellEvent(e, t, n, o);
  }
  dispatchBatchEvent(e, t) {
    this.eventSvc.dispatchEvent(this.createBatchEditEvent(e, t));
  }
  createBatchEditEvent(e, t) {
    return ke(this.gos, {
      type: e,
      ...e === "batchEditingStopped" ? {
        changes: this.toEventChangeList(t)
      } : {}
    });
  }
  toEventChangeList(e) {
    return this.model.getEditPositions(e).map((t) => ({
      rowIndex: t.rowNode.rowIndex,
      rowPinned: t.rowNode.rowPinned,
      columnId: t.column.getColId(),
      newValue: t.pendingValue,
      oldValue: t.sourceValue
    }));
  }
  applyBulkEdit({ rowNode: e, column: t }, n) {
    var d, c;
    if (!n || n.length === 0)
      return;
    const { beans: o, rangeSvc: s, valueSvc: i } = this;
    ni(o, { persist: !0 });
    const r = this.model.getEditMap(!0), a = (c = (d = r.get(e)) == null ? void 0 : d.get(t)) == null ? void 0 : c.pendingValue;
    this.batch || this.eventSvc.dispatchEvent({ type: "bulkEditingStarted" }), n.forEach((u) => {
      if (s == null || s.forEachRowInRange(u, (h) => {
        const g = To(o, h);
        if (g === void 0)
          return;
        const p = r.get(g) ?? /* @__PURE__ */ new Map();
        for (const f of u.columns)
          if (f && this.isCellEditable({ rowNode: g, column: f }, "api")) {
            const m = i.getValue(f, g, !0, "api");
            let C = i.parseValue(
              f,
              g ?? null,
              a,
              m
            );
            Number.isNaN(C) && (C = null), p.set(f, {
              editorValue: void 0,
              pendingValue: C,
              sourceValue: m,
              state: "changed",
              editorState: {
                isCancelAfterEnd: void 0,
                isCancelBeforeStart: void 0
              }
            });
          }
        p.size > 0 && r.set(g, p);
      }), this.setEditMap(r), this.batch) {
        this.cleanupEditors(), _h(o), this.bulkRefresh();
        return;
      }
      this.commitNextEdit(), this.stopEditing(void 0, { source: "bulk" }), this.eventSvc.dispatchEvent({ type: "bulkEditingStopped", changes: this.toEventChangeList(r) });
    }), this.bulkRefresh();
    const l = wt(o, { rowNode: e, column: t });
    l && l.focusCell(!0);
  }
  createCellStyleFeature(e, t) {
    return new JO(e, t);
  }
  createRowStyleFeature(e, t) {
    return new XO(e, t);
  }
  setEditingCells(e, t) {
    const { beans: n } = this, { colModel: o, valueSvc: s } = n, i = /* @__PURE__ */ new Map();
    e.forEach(({ colId: r, column: a, colKey: l, rowIndex: d, rowPinned: c, newValue: u, state: h }) => {
      const g = r ? o.getCol(r) : l ? o.getCol(l) : a;
      if (!g)
        return;
      const p = To(n, { rowIndex: d, rowPinned: c });
      if (!p)
        return;
      const f = s.getValue(g, p, !0, "api");
      if (!(t != null && t.forceRefreshOfEditCellsOnly) && !zo({ pendingValue: u, sourceValue: f }) && h !== "editing")
        return;
      let m = i.get(p);
      m || (m = /* @__PURE__ */ new Map(), i.set(p, m)), u === void 0 && (u = jn), m.set(g, {
        editorValue: void 0,
        pendingValue: u,
        sourceValue: f,
        state: h ?? "changed",
        editorState: {
          isCancelAfterEnd: void 0,
          isCancelBeforeStart: void 0
        }
      });
    }), this.setEditMap(i, t);
  }
  onCellFocused(e) {
    var i;
    const t = wt(this.beans, e);
    if (!t || !this.isEditing(t, Hi))
      return;
    const n = this.model.getEdit(t);
    if (!n || !zo(n))
      return;
    const s = this.getLocaleTextFunc()("ariaPendingChange", "Pending Change");
    (i = this.beans.ariaAnnounce) == null || i.announceValue(s, "pendingChange");
  }
  allowedFocusTargetOnValidation(e) {
    return wt(this.beans, e);
  }
};
function dG(e) {
  return {
    rowNodes: e ? Array.from(e.keys()) : void 0,
    columns: e ? [...new Set(Array.from(e.values()).flatMap((t) => Array.from(t.keys())))] : void 0
  };
}
function g0(e, t) {
  return t ?? e.get("editType") ?? "singleCell";
}
var ib = class extends U {
  postConstruct() {
    var e, t;
    this.model = this.beans.editModelSvc, this.editSvc = this.beans.editSvc, this.addManagedEventListeners({
      cellFocused: (e = this.onCellFocusChanged) == null ? void 0 : e.bind(this),
      cellFocusCleared: (t = this.onCellFocusChanged) == null ? void 0 : t.bind(this)
    });
  }
  clearEdits(e) {
    this.model.clearEditValue(e);
  }
  onCellFocusChanged(e) {
    let t;
    const n = e.previousParams, { editSvc: o, beans: s } = this, i = e.type === "cellFocused" ? e.sourceEvent : null;
    n && (t = wt(s, n));
    const { gos: r, editModelSvc: a } = s, l = e.type === "cellFocusCleared";
    if (o.isEditing(void 0, { withOpenEditor: !0 })) {
      const { column: d, rowIndex: c, rowPinned: u } = e, h = {
        column: d,
        rowNode: To(s, { rowIndex: c, rowPinned: u })
      }, g = r.get("invalidEditValueMode") === "block";
      if (g)
        return;
      const p = !g, f = !!(a != null && a.getCellValidationModel().hasCellValidation(h)), m = p && f;
      (n || l ? o.stopEditing(void 0, {
        cancel: m,
        source: l && p ? "api" : void 0,
        event: i
      }) : !0) || (o.isBatchEditing() ? o.cleanupEditors() : o.stopEditing(void 0, { source: "api" }));
    }
    t == null || t.refreshCell({ suppressFlash: !0, force: !0 });
  }
  stop(e, t) {
    const n = this.model.getEditPositions(), o = { all: [], pass: [], fail: [] };
    if (n.forEach((i) => {
      var a;
      o.all.push(i);
      const r = this.model.getCellValidationModel().getCellValidation(i);
      if ((((a = r == null ? void 0 : r.errorMessages) == null ? void 0 : a.length) ?? 0) > 0) {
        o.fail.push(i);
        return;
      }
      o.pass.push(i);
    }), e)
      return n.forEach((i) => {
        Od(this.beans, i, { cancel: e }), this.model.stop(i);
      }), !0;
    const s = this.processValidationResults(o);
    return s.destroy.length > 0 && s.destroy.forEach((i) => {
      Od(this.beans, i, { event: t, cancel: e }), this.model.stop(i);
    }), s.keep.length > 0 && s.keep.forEach((i) => {
      var a;
      const r = wt(this.beans, i);
      (a = this.editSvc) != null && a.cellEditingInvalidCommitBlocks() || r && this.editSvc.revertSingleCellEdit(r);
    }), !0;
  }
  cleanupEditors({ rowNode: e } = {}, t) {
    ni(this.beans, { persist: !1 });
    const n = this.model.getEditPositions(), o = [];
    e ? n.forEach((s) => {
      !e || s.rowNode === e || o.push(s);
    }) : n.forEach((s) => {
      o.push(s);
    }), sr(this.beans, o), _h(this.beans, t);
  }
  setFocusOutOnEditor(e) {
    var t, n, o;
    (o = (n = (t = e.comp) == null ? void 0 : t.getCellEditor()) == null ? void 0 : n.focusOut) == null || o.call(n);
  }
  setFocusInOnEditor(e) {
    const t = e.comp, n = t == null ? void 0 : t.getCellEditor();
    if (n != null && n.focusIn)
      n.focusIn();
    else {
      const o = this.beans.gos.get("editType") === "fullRow";
      e.focusCell(o), e.onEditorAttachedFuncs.push(() => {
        var s, i;
        return (i = (s = t == null ? void 0 : t.getCellEditor()) == null ? void 0 : s.focusIn) == null ? void 0 : i.call(s);
      });
    }
  }
  setupEditors(e) {
    const { event: t, ignoreEventKey: n = !1, startedEdit: o, position: s, cells: i = this.model.getEditPositions() } = e, r = t instanceof KeyboardEvent && !n && t.key || void 0;
    bL(this.beans, i, s, r, t, o);
  }
  dispatchCellEvent(e, t, n, o) {
    const s = wt(this.beans, e);
    s && this.eventSvc.dispatchEvent({ ...s.createEvent(t ?? null, n), ...o });
  }
  dispatchRowEvent(e, t, n) {
    if (n)
      return;
    const o = Tp(this.beans, e);
    o && this.eventSvc.dispatchEvent(o.createRowEvent(t));
  }
  shouldStop(e, t, n = "ui") {
    const o = this.editSvc.isBatchEditing();
    return o && n === "api" ? !0 : o && (n === "ui" || n === "edit") ? !1 : n === "api" ? !0 : t instanceof KeyboardEvent && !o ? t.key === O.ENTER : null;
  }
  shouldCancel(e, t, n = "ui") {
    const o = this.editSvc.isBatchEditing();
    return !!(t instanceof KeyboardEvent && !o && t.key === O.ESCAPE || o && n === "api" || n === "api");
  }
  setEditMap(e, t) {
    var o;
    t != null && t.update || this.editSvc.stopEditing(void 0, { cancel: !0, source: "api" });
    const n = [];
    if (e.forEach((s, i) => {
      s.forEach((r, a) => {
        r.state === "editing" && n.push({ ...r, rowNode: i, column: a });
      });
    }), t != null && t.update && (e = new Map([...this.model.getEditMap(), ...e])), (o = this.model) == null || o.setEditMap(e), n.length > 0) {
      const s = n.at(-1), i = s.pendingValue === jn ? void 0 : s.pendingValue;
      this.start({ position: s, event: new KeyboardEvent("keydown", { key: i }), source: "api" });
      const r = wt(this.beans, s);
      r && this.setFocusInOnEditor(r);
    }
  }
  destroy() {
    this.cleanupEditors(), super.destroy();
  }
}, cG = class extends ib {
  constructor() {
    super(...arguments), this.beanName = "fullRow", this.startedRows = [];
  }
  shouldStop(e, t, n = "ui") {
    const { rowNode: o } = e || {};
    if (!Tp(this.beans, {
      rowNode: this.rowNode
    }))
      return !0;
    const i = super.shouldStop({ rowNode: this.rowNode }, t, n);
    return i !== null ? i : this.rowNode ? o !== this.rowNode : !1;
  }
  midBatchInputsAllowed({ rowNode: e }) {
    return e ? this.model.hasEdits({ rowNode: e }) : !1;
  }
  clearEdits(e) {
    this.model.clearEditValue(e);
  }
  start(e) {
    const { position: t, silent: n, startedEdit: o, event: s, ignoreEventKey: i } = e, { rowNode: r } = t;
    this.rowNode !== r && super.cleanupEditors(t), this.dispatchRowEvent({ rowNode: r }, "rowEditingStarted", n), this.startedRows.push(r);
    const a = this.beans.visibleCols.allCols, l = [];
    a.forEach((d) => {
      if (!d.isCellEditable(r))
        return;
      const c = {
        rowNode: r,
        column: d
      };
      l.push(c), this.model.hasEdits(c) || this.model.start(c);
    }), this.rowNode = r, this.setupEditors({ cells: l, position: t, startedEdit: o, event: s, ignoreEventKey: i });
  }
  processValidationResults(e) {
    return e.fail.length > 0 && this.editSvc.cellEditingInvalidCommitBlocks() ? {
      destroy: [],
      keep: e.all
    } : {
      destroy: e.all,
      keep: []
    };
  }
  stop(e, t) {
    var s;
    const { rowNode: n } = this;
    if (n && !this.model.hasRowEdits(n))
      return !1;
    const o = [];
    return e || this.model.getEditMap().forEach((i, r) => {
      if (!(!i || i.size === 0)) {
        for (const a of i.values())
          if (zo(a)) {
            o.push(r);
            break;
          }
      }
    }), bi(this.beans), !e && ((s = this.editSvc) == null ? void 0 : s.checkNavWithValidation({ rowNode: n })) === "block-stop" ? !1 : (super.stop(e, t), o.forEach((i) => this.dispatchRowEvent({ rowNode: i }, "rowValueChanged")), this.cleanupEditors({ rowNode: n }, !0), this.rowNode = void 0, !0);
  }
  onCellFocusChanged(e) {
    const { rowIndex: t } = e, n = e.previousParams;
    if ((n == null ? void 0 : n.rowIndex) === t || e.sourceEvent instanceof KeyboardEvent)
      return;
    const o = wt(this.beans, n);
    this.gos.get("invalidEditValueMode") === "block" && o && (this.model.getCellValidationModel().getCellValidation(o) || this.model.getRowValidationModel().getRowValidation(o)) || super.onCellFocusChanged(e);
  }
  cleanupEditors(e = {}, t) {
    super.cleanupEditors(e, t), this.startedRows.forEach((n) => this.dispatchRowEvent({ rowNode: n }, "rowEditingStopped")), this.startedRows.length = 0;
  }
  // returns null if no navigation should be performed
  moveToNextEditingCell(e, t, n, o = "ui", s = !1) {
    var h, g, p, f;
    const i = e.cellPosition;
    let r;
    this.model.suspend(!0);
    try {
      r = (h = this.beans.navigation) == null ? void 0 : h.findNextCellToFocusOn(i, {
        backwards: t,
        startEditing: !0,
        // Default behaviour for fullRow is skip to the next cell,
        // editable or not. FullRow editing might have some editable
        // and some not editable cells in the row.
        // More complex logic needed to skip to the
        // next FullRow editable cell,
        skipToNextEditableCell: !1
      });
    } finally {
      this.model.suspend(!1);
    }
    if (r === !1)
      return null;
    if (r == null)
      return !1;
    const a = r.cellPosition, l = e.isCellEditable(), d = r.isCellEditable(), c = a && i.rowIndex === a.rowIndex && i.rowPinned === a.rowPinned;
    l && this.setFocusOutOnEditor(e), this.restoreEditors();
    const u = this.gos.get("suppressStartEditOnTab");
    return d && !s ? u ? r.focusCell(!0, n) : ((g = r.comp) != null && g.getCellEditor() || Ar(this.beans, r, { event: n, cellStartedEdit: !0 }), this.setFocusInOnEditor(r), r.focusCell(!1, n)) : (d && s && this.setFocusInOnEditor(r), r.focusCell(!0, n)), !c && !s && ((p = this.editSvc) == null || p.stopEditing({ rowNode: e.rowNode }, { event: n }), this.cleanupEditors(r, !0), u ? r.focusCell(!0, n) : this.editSvc.startEditing(r, { startedEdit: !0, event: n, source: o, ignoreEventKey: !0 })), (f = e.rowCtrl) == null || f.refreshRow({ suppressFlash: !0, force: !0 }), !0;
  }
  restoreEditors() {
    this.model.getEditMap().forEach(
      (e, t) => e.forEach(({ state: n }, o) => {
        var i;
        if (n !== "editing")
          return;
        const s = wt(this.beans, {
          rowNode: t,
          column: o
        });
        s && !((i = s.comp) != null && i.getCellEditor()) && Ar(this.beans, s, { silent: !0 });
      })
    );
  }
  destroy() {
    super.destroy(), this.rowNode = void 0, this.startedRows.length = 0;
  }
}, uG = class extends ib {
  constructor() {
    super(...arguments), this.beanName = "singleCell";
  }
  shouldStop(e, t, n = "ui") {
    const o = super.shouldStop(e, t, n);
    if (o !== null)
      return o;
    const { rowNode: s, column: i } = e || {};
    return (!this.rowNode || !this.column) && s && i ? null : this.rowNode !== s || this.column !== i;
  }
  midBatchInputsAllowed(e) {
    return this.model.hasEdits(e);
  }
  start(e) {
    const { position: t, startedEdit: n, event: o, ignoreEventKey: s } = e;
    (this.rowNode !== t.rowNode || this.column !== t.column) && super.cleanupEditors(), this.rowNode = t.rowNode, this.column = t.column, this.model.start(t), this.setupEditors({ cells: [t], position: t, startedEdit: n, event: o, ignoreEventKey: s });
  }
  dispatchRowEvent(e, t, n) {
  }
  processValidationResults(e) {
    return e.fail.length > 0 && this.editSvc.cellEditingInvalidCommitBlocks() ? {
      destroy: [],
      keep: e.all
    } : {
      destroy: e.all,
      keep: []
    };
  }
  stop(e, t) {
    return super.stop(e, t), this.rowNode = void 0, this.column = void 0, !0;
  }
  onCellFocusChanged(e) {
    const { colModel: t, editSvc: n } = this.beans, { rowIndex: o, column: s, rowPinned: i } = e, r = To(this.beans, { rowIndex: o, rowPinned: i }), a = Vh(s), l = t.getCol(a), d = e.previousParams;
    if (d) {
      const c = Vh(d.column);
      if ((d == null ? void 0 : d.rowIndex) === o && c === a && (d == null ? void 0 : d.rowPinned) === i)
        return;
    }
    n != null && n.isEditing({ rowNode: r, column: l }, { withOpenEditor: !0 }) && e.type === "cellFocused" || super.onCellFocusChanged(e);
  }
  // returns null if no navigation should be performed
  moveToNextEditingCell(e, t, n, o = "ui", s = !1) {
    var p, f, m, C, w, b;
    const i = this.beans.focusSvc.getFocusedCell();
    i && (e = Ki(this.beans, i) ?? e);
    const r = e.cellPosition;
    let a;
    const l = this.beans.gos.get("editType") === "fullRow";
    l && this.model.suspend(!0), s || (e.eGui.focus(), (f = this.editSvc) == null || f.stopEditing(e, { source: (p = this.editSvc) != null && p.isBatchEditing() ? "ui" : "api", event: n }));
    try {
      a = (m = this.beans.navigation) == null ? void 0 : m.findNextCellToFocusOn(r, {
        backwards: t,
        startEditing: !0
        // Default behaviour for fullRow is skip to the next cell,
        // editable or not. FullRow editing might have some editable
        // and some not editable cells in the row.
        // More complex logic needed to skip to the
        // next FullRow editable cell,
        // skipToNextEditableCell: false,
      });
    } finally {
      l && this.model.suspend(!1);
    }
    if (a === !1)
      return null;
    if (a == null)
      return !1;
    const d = a.cellPosition, c = e.isCellEditable(), u = a.isCellEditable(), h = d && r.rowIndex === d.rowIndex && r.rowPinned === d.rowPinned;
    c && !s && this.setFocusOutOnEditor(e);
    const g = this.gos.get("suppressStartEditOnTab");
    if (!h && !s && (super.cleanupEditors(a, !0), g ? a.focusCell(!0, n) : this.editSvc.startEditing(a, { startedEdit: !0, event: n, source: o, ignoreEventKey: !0 })), u && !s) {
      if (a.focusCell(!1, n), g)
        a.focusCell(!0, n);
      else if (!((C = a.comp) != null && C.getCellEditor())) {
        const A = (w = this.editSvc) == null ? void 0 : w.isEditing(a, { withOpenEditor: !0 });
        Ar(this.beans, a, { event: n, cellStartedEdit: !0, silent: A }), this.setFocusInOnEditor(a), this.cleanupEditors(a);
      }
    } else
      u && s && this.setFocusInOnEditor(a), a.focusCell(!0, n);
    return (b = e.rowCtrl) == null || b.refreshRow({ suppressFlash: !0, force: !0 }), !0;
  }
  destroy() {
    super.destroy(), this.rowNode = void 0, this.column = void 0;
  }
}, _s = {
  moduleName: "EditCore",
  version: Ee,
  beans: [CL, lG],
  apiFunctions: {
    getEditingCells: _O,
    getEditRowValues: VO,
    getCellEditorInstances: yL,
    startEditingCell: zO,
    stopEditing: NO,
    isEditing: $O,
    validateEdit: WO
  },
  dynamicBeans: {
    singleCell: uG,
    fullRow: cG
  },
  dependsOn: [Vs, Wp],
  css: [mO]
}, hG = {
  moduleName: "UndoRedoEdit",
  version: Ee,
  beans: [fO],
  apiFunctions: {
    undoCellEditing: GO,
    redoCellEditing: HO,
    getCurrentUndoSize: UO,
    getCurrentRedoSize: KO
  },
  dependsOn: [_s]
}, gG = {
  moduleName: "TextEditor",
  version: Ee,
  userComponents: { agCellEditor: h0, agTextCellEditor: h0 },
  dependsOn: [_s]
}, pG = {
  moduleName: "NumberEditor",
  version: Ee,
  userComponents: {
    agNumberCellEditor: {
      classImp: IO
    }
  },
  dependsOn: [_s]
}, fG = {
  moduleName: "DateEditor",
  version: Ee,
  userComponents: {
    agDateCellEditor: bO,
    agDateStringCellEditor: RO
  },
  dependsOn: [_s]
}, mG = {
  moduleName: "CheckboxEditor",
  version: Ee,
  userComponents: {
    agCheckboxCellEditor: CO
  },
  dependsOn: [_s]
}, vG = {
  moduleName: "SelectEditor",
  version: Ee,
  userComponents: { agSelectCellEditor: DO },
  dependsOn: [_s]
}, CG = {
  moduleName: "LargeTextEditor",
  version: Ee,
  userComponents: { agLargeTextCellEditor: AO },
  dependsOn: [_s]
}, wG = {
  moduleName: "CustomEditor",
  version: Ee,
  dependsOn: [_s]
}, yG = class extends U {
  constructor() {
    super(...arguments), this.beanName = "selectionColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener("rowSelection", (e) => {
      this.onSelectionOptionsChanged(
        e.currentValue,
        e.previousValue,
        di(e.source)
      );
    }), this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
  }
  addColumns(e) {
    const t = this.columns;
    t != null && (e.list = t.list.concat(e.list), e.tree = t.tree.concat(e.tree), sp(e));
  }
  createColumns(e, t) {
    var h, g;
    const n = () => {
      var p;
      ts(this.beans, (p = this.columns) == null ? void 0 : p.tree), this.columns = null;
    }, o = e.treeDepth, i = (((h = this.columns) == null ? void 0 : h.treeDepth) ?? -1) == o, r = this.generateSelectionCols();
    if (op(r, ((g = this.columns) == null ? void 0 : g.list) ?? []) && i)
      return;
    n();
    const { colGroupSvc: l } = this.beans, d = (l == null ? void 0 : l.findDepth(e.tree)) ?? 0, c = (l == null ? void 0 : l.balanceTreeForAutoCols(r, d)) ?? [];
    this.columns = {
      list: r,
      tree: c,
      treeDepth: d,
      map: {}
    }, t((p) => {
      if (!p)
        return null;
      const f = p.filter((m) => !Gs(m));
      return [...r, ...f];
    });
  }
  updateColumns(e) {
    var n;
    const t = di(e.source);
    (n = this.columns) == null || n.list.forEach((o) => {
      const s = this.createSelectionColDef(e.currentValue);
      o.setColDef(s, null, t), cn(this.beans, { state: [{ ...s, colId: o.getColId() }] }, t);
    });
  }
  getColumn(e) {
    var t;
    return ((t = this.columns) == null ? void 0 : t.list.find((n) => ka(n, e))) ?? null;
  }
  getColumns() {
    var e;
    return ((e = this.columns) == null ? void 0 : e.list) ?? null;
  }
  isSelectionColumnEnabled() {
    var r, a;
    const { gos: e, beans: t } = this, n = e.get("rowSelection");
    if (typeof n != "object" || !In(e))
      return !1;
    const o = (((a = (r = t.autoColSvc) == null ? void 0 : r.getColumns()) == null ? void 0 : a.length) ?? 0) > 0;
    if (n.checkboxLocation === "autoGroupColumn" && o)
      return !1;
    const s = !!li(n), i = jl(n);
    return s || i;
  }
  createSelectionColDef(e) {
    const { gos: t } = this, n = e ?? t.get("selectionColumnDef"), o = t.get("enableRtl"), { rowSpan: s, spanRows: i, ...r } = n ?? {};
    return {
      // overridable properties
      width: 50,
      resizable: !1,
      suppressHeaderMenuButton: !0,
      sortable: !1,
      suppressMovable: !0,
      lockPosition: o ? "right" : "left",
      comparator(a, l, d, c) {
        const u = d.isSelected(), h = c.isSelected();
        return u === h ? 0 : u ? 1 : -1;
      },
      editable: !1,
      suppressFillHandle: !0,
      pinned: null,
      // overrides
      ...r,
      // non-overridable properties
      colId: HC,
      chartDataType: "excluded"
    };
  }
  generateSelectionCols() {
    if (!this.isSelectionColumnEnabled())
      return [];
    const e = this.createSelectionColDef(), t = e.colId;
    this.gos.validateColDef(e, t, !0);
    const n = new Go(e, null, t, !1);
    return this.createBean(n), [n];
  }
  onSelectionOptionsChanged(e, t, n) {
    const o = t && typeof t != "string" ? li(t) : void 0, s = e && typeof e != "string" ? li(e) : void 0, i = o !== s, r = t && typeof t != "string" ? jl(t) : void 0, a = e && typeof e != "string" ? jl(e) : void 0, l = r !== a, d = Ta(e), c = Ta(t);
    (i || l || d !== c) && this.beans.colModel.refreshAll(n);
  }
  destroy() {
    var e;
    ts(this.beans, (e = this.columns) == null ? void 0 : e.tree), super.destroy();
  }
  /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */
  refreshVisibility(e, t, n) {
    var l, d;
    if (!((l = this.columns) != null && l.list.length))
      return;
    const o = e.length + t.length + n.length;
    if (o === 0)
      return;
    const s = this.columns.list[0];
    if (!s.isVisible())
      return;
    const i = () => {
      let c;
      switch (s.pinned) {
        case "left":
        case !0:
          c = e;
          break;
        case "right":
          c = n;
          break;
        default:
          c = t;
      }
      c && $t(c, s);
    };
    (((d = this.beans.rowNumbersSvc) == null ? void 0 : d.getColumn(VC)) ? 2 : 1) === o && i();
  }
};
function bG(e, t) {
  var r;
  if (!t.nodes.every((a) => a.rowPinned && !nl(a) ? (Z(59), !1) : a.id === void 0 ? (Z(60), !1) : !0))
    return;
  const { nodes: o, source: s, newValue: i } = t;
  (r = e.selectionSvc) == null || r.setNodesSelected({ nodes: o, source: s ?? "api", newValue: i });
}
function SG(e, t, n = "apiSelectAll") {
  var o;
  (o = e.selectionSvc) == null || o.selectAllRowNodes({ source: n, selectAll: t });
}
function xG(e, t, n = "apiSelectAll") {
  var o;
  (o = e.selectionSvc) == null || o.deselectAllRowNodes({ source: n, selectAll: t });
}
function RG(e, t = "apiSelectAllFiltered") {
  var n;
  (n = e.selectionSvc) == null || n.selectAllRowNodes({ source: t, selectAll: "filtered" });
}
function EG(e, t = "apiSelectAllFiltered") {
  var n;
  (n = e.selectionSvc) == null || n.deselectAllRowNodes({ source: t, selectAll: "filtered" });
}
function AG(e, t = "apiSelectAllCurrentPage") {
  var n;
  (n = e.selectionSvc) == null || n.selectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function FG(e, t = "apiSelectAllCurrentPage") {
  var n;
  (n = e.selectionSvc) == null || n.deselectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function MG(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectedNodes()) ?? [];
}
function IG(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectedRows()) ?? [];
}
var PG = class extends Jw {
  constructor() {
    super(...arguments), this.beanName = "selectionSvc", this.selectedNodes = /* @__PURE__ */ new Map(), this.detailSelection = /* @__PURE__ */ new Map(), this.masterSelectsDetail = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { gos: e } = this;
    this.mode = Cr(e), this.groupSelectsDescendants = wi(e), this.groupSelectsFiltered = xd(e) === "filteredDescendants", this.masterSelectsDetail = dm(e) === "detail", this.addManagedPropertyListeners(["groupSelectsChildren", "groupSelectsFiltered", "rowSelection"], () => {
      const t = wi(e), n = Cr(e), o = xd(e) === "filteredDescendants";
      this.masterSelectsDetail = dm(e) === "detail", (t !== this.groupSelectsDescendants || o !== this.groupSelectsFiltered || n !== this.mode) && (this.deselectAllRowNodes({ source: "api" }), this.groupSelectsDescendants = t, this.groupSelectsFiltered = o, this.mode = n);
    }), this.addManagedEventListeners({ rowSelected: this.onRowSelected.bind(this) });
  }
  destroy() {
    super.destroy(), this.resetNodes();
  }
  handleSelectionEvent(e, t, n) {
    if (this.isRowSelectionBlocked(t))
      return 0;
    const o = this.inferNodeSelections(t, e.shiftKey, e.metaKey || e.ctrlKey, n);
    if (o == null)
      return 0;
    if (this.selectionCtx.selectAll = !1, "select" in o)
      return o.reset ? this.resetNodes() : this.selectRange(o.deselect, !1, n), this.selectRange(o.select, !0, n);
    {
      const s = o.checkFilteredNodes ? ab(o.node) : o.newValue;
      return this.setNodesSelected({
        nodes: [o.node],
        newValue: s,
        clearSelection: o.clearSelection,
        keepDescendants: o.keepDescendants,
        event: e,
        source: n
      });
    }
  }
  setNodesSelected({
    newValue: e,
    clearSelection: t,
    suppressFinishActions: n,
    nodes: o,
    event: s,
    source: i,
    keepDescendants: r = !1
  }) {
    var d;
    const { gos: a } = this;
    if (!In(a) && e)
      return Z(132), 0;
    if (o.length === 0)
      return 0;
    if (o.length > 1 && !this.isMultiSelect())
      return Z(130), 0;
    let l = 0;
    for (let c = 0; c < o.length; c++) {
      const u = o[c], h = Vi(u);
      if (h.rowPinned && !nl(h)) {
        Z(59);
        continue;
      }
      if (h.id === void 0) {
        Z(60);
        continue;
      }
      this.groupSelectsFiltered && h.group && !a.get("treeData") || this.selectRowNode(h, e, s, i) && (this.detailSelection.delete(h.id), l++), this.groupSelectsDescendants && ((d = h.childrenAfterGroup) != null && d.length) && (l += this.selectChildren(h, e, i));
    }
    return n || (o.length === 1 && i === "api" && this.selectionCtx.setRoot(Vi(o[0])), e && (t || !this.isMultiSelect()) && (l += this.clearOtherNodes(Vi(o[0]), r, i)), l > 0 && (this.updateGroupsFromChildrenSelections(i), this.dispatchSelectionChanged(i))), l;
  }
  // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
  // holding down 'shift'.
  selectRange(e, t, n) {
    let o = 0;
    return e.forEach((s) => {
      const i = Vi(s);
      if (i.group && this.groupSelectsDescendants)
        return;
      this.selectRowNode(i, t, void 0, n) && o++;
    }), o > 0 && (this.updateGroupsFromChildrenSelections(n), this.dispatchSelectionChanged(n)), o;
  }
  selectChildren(e, t, n) {
    const o = this.groupSelectsFiltered ? e.childrenAfterAggFilter : e.childrenAfterGroup;
    return o ? this.setNodesSelected({
      newValue: t,
      clearSelection: !1,
      suppressFinishActions: !0,
      source: n,
      nodes: o
    }) : 0;
  }
  getSelectedNodes() {
    return Array.from(this.selectedNodes.values());
  }
  getSelectedRows() {
    const e = [];
    return this.selectedNodes.forEach((t) => t.data && e.push(t.data)), e;
  }
  getSelectionCount() {
    return this.selectedNodes.size;
  }
  /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */
  filterFromSelection(e) {
    const t = /* @__PURE__ */ new Map();
    this.selectedNodes.forEach((n, o) => {
      e(n) && t.set(o, n);
    }), this.selectedNodes = t;
  }
  updateGroupsFromChildrenSelections(e, t) {
    if (!this.groupSelectsDescendants)
      return !1;
    const { gos: n, rowModel: o } = this.beans;
    if (!Ct(n))
      return !1;
    const s = o.rootNode;
    if (!s)
      return !1;
    t || (t = new Rr(!0, s), t.active = !1);
    let i = !1;
    return t.forEachChangedNodeDepthFirst((r) => {
      if (r !== s) {
        const a = this.calculateSelectedFromChildren(r);
        i = this.selectRowNode(r, a === null ? !1 : a, void 0, e) || i;
      }
    }), i;
  }
  clearOtherNodes(e, t, n) {
    const o = /* @__PURE__ */ new Map();
    let s = 0;
    return this.selectedNodes.forEach((i) => {
      const r = i.id == e.id;
      if ((t ? !TG(e, i) : !0) && !r) {
        const l = this.selectedNodes.get(i.id);
        s += this.setNodesSelected({
          nodes: [l],
          newValue: !1,
          clearSelection: !1,
          suppressFinishActions: !0,
          source: n
        }), this.groupSelectsDescendants && i.parent && o.set(i.parent.id, i.parent);
      }
    }), o.forEach((i) => {
      const r = this.calculateSelectedFromChildren(i);
      this.selectRowNode(i, r === null ? !1 : r, void 0, n);
    }), s;
  }
  onRowSelected(e) {
    const t = e.node;
    this.groupSelectsDescendants && t.group || (t.isSelected() ? this.selectedNodes.set(t.id, t) : this.selectedNodes.delete(t.id));
  }
  syncInRowNode(e, t) {
    this.syncInOldRowNode(e, t), this.syncInNewRowNode(e);
  }
  createDaemonNode(e) {
    if (!e.id)
      return;
    const t = new Ln(this.beans);
    return t.id = e.id, t.data = e.data, t.__daemon = !0, t.__selected = e.__selected, t.level = e.level, t;
  }
  // if the id has changed for the node, then this means the rowNode
  // is getting used for a different data item, which breaks
  // our selectedNodes, as the node now is mapped by the old id
  // which is inconsistent. so to keep the old node as selected,
  // we swap in the clone (with the old id and old data). this means
  // the oldNode is effectively a daemon we keep a reference to,
  // so if client calls api.getSelectedNodes(), it gets the daemon
  // in the result. when the client un-selects, the reference to the
  // daemon is removed. the daemon, because it's an oldNode, is not
  // used by the grid for rendering, it's a copy of what the node used
  // to be like before the id was changed.
  syncInOldRowNode(e, t) {
    t && e.id !== t.id && this.selectedNodes.get(t.id) == e && this.selectedNodes.set(t.id, t);
  }
  syncInNewRowNode(e) {
    this.selectedNodes.has(e.id) ? (e.__selected = !0, this.selectedNodes.set(e.id, e)) : e.__selected = !1;
  }
  reset(e) {
    const t = this.getSelectionCount();
    this.resetNodes(), t && this.dispatchSelectionChanged(e);
  }
  resetNodes() {
    this.selectedNodes.forEach((e) => {
      this.selectRowNode(e, !1);
    }), this.selectedNodes.clear();
  }
  // returns a list of all nodes at 'best cost' - a feature to be used
  // with groups / trees. if a group has all it's children selected,
  // then the group appears in the result, but not the children.
  // Designed for use with 'children' as the group selection type,
  // where groups don't actually appear in the selection normally.
  getBestCostNodeSelection() {
    const { gos: e, rowModel: t } = this.beans;
    if (!Ct(e))
      return;
    const n = t.getTopLevelNodes();
    if (n === null)
      return;
    const o = [];
    function s(i) {
      for (let r = 0, a = i.length; r < a; r++) {
        const l = i[r];
        l.isSelected() ? o.push(l) : l.group && l.childrenAfterGroup && s(l.childrenAfterGroup);
      }
    }
    return s(n), o;
  }
  isEmpty() {
    return this.getSelectionCount() === 0;
  }
  deselectAllRowNodes({ source: e, selectAll: t }) {
    const n = Ct(this.gos);
    let o = !1;
    const s = (i) => {
      const r = this.selectRowNode(Vi(i), !1, void 0, e);
      o || (o = r);
    };
    if (t === "currentPage" || t === "filtered") {
      if (!n) {
        $e(102);
        return;
      }
      this.getNodesToSelect(t).forEach(s);
    } else
      this.selectedNodes.forEach(s), this.reset(e);
    if (this.selectionCtx.selectAll = !1, n && this.groupSelectsDescendants) {
      const i = this.updateGroupsFromChildrenSelections(e);
      o || (o = i);
    }
    o && this.dispatchSelectionChanged(e);
  }
  getSelectedCounts(e) {
    let t = 0, n = 0;
    return this.getNodesToSelect(e).forEach((o) => {
      this.groupSelectsDescendants && o.group || (o.isSelected() ? t++ : o.selectable && n++);
    }), { selectedCount: t, notSelectedCount: n };
  }
  getSelectAllState(e) {
    const { selectedCount: t, notSelectedCount: n } = this.getSelectedCounts(e);
    return rb(t, n) ?? null;
  }
  hasNodesToSelect(e) {
    return this.getNodesToSelect(e).filter((t) => t.selectable).length > 0;
  }
  /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */
  getNodesToSelect(e) {
    if (!this.canSelectAll())
      return [];
    const t = [], n = (s) => t.push(s);
    if (e === "currentPage")
      return this.forEachNodeOnPage((s) => {
        if (!s.group) {
          n(s);
          return;
        }
        if (!s.expanded && !s.footer) {
          const i = (r) => {
            var a;
            n(r), (a = r.childrenAfterFilter) == null || a.forEach(i);
          };
          i(s);
          return;
        }
        this.groupSelectsDescendants || n(s);
      }), t;
    const o = this.beans.rowModel;
    return e === "filtered" ? (o.forEachNodeAfterFilter(n), t) : (o.forEachNode(n), t);
  }
  forEachNodeOnPage(e) {
    const { pageBounds: t, rowModel: n } = this.beans, o = t.getFirstRow(), s = t.getLastRow();
    for (let i = o; i <= s; i++) {
      const r = n.getRow(i);
      r && e(r);
    }
  }
  selectAllRowNodes(e) {
    const { gos: t, selectionCtx: n } = this;
    if (!In(t)) {
      Z(132);
      return;
    }
    if (ep(t) && !es(t)) {
      Z(130);
      return;
    }
    if (!this.canSelectAll())
      return;
    const { source: o, selectAll: s } = e;
    let i = !1;
    if (this.getNodesToSelect(s).forEach((r) => {
      const a = this.selectRowNode(Vi(r), !0, void 0, o);
      i || (i = a);
    }), n.selectAll = !0, Ct(t) && this.groupSelectsDescendants) {
      const r = this.updateGroupsFromChildrenSelections(o);
      i || (i = r);
    }
    i && this.dispatchSelectionChanged(o);
  }
  getSelectionState() {
    return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
  }
  setSelectionState(e, t, n) {
    if (e || (e = []), !Array.isArray(e)) {
      $e(103);
      return;
    }
    const o = new Set(e), s = [];
    this.beans.rowModel.forEachNode((i) => {
      o.has(i.id) && s.push(i);
    }), n && this.resetNodes(), this.setNodesSelected({
      newValue: !0,
      nodes: s,
      source: t
    });
  }
  canSelectAll() {
    const { gos: e } = this.beans;
    return !!Ct(e);
  }
  /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */
  updateSelectable(e) {
    var l;
    const { gos: t, rowModel: n } = this.beans;
    if (!In(t))
      return;
    const o = "selectableChanged", s = e !== void 0, i = Ct(t) && this.groupSelectsDescendants, r = [], a = (d) => {
      var u;
      if (s && !d.group)
        return;
      if (i && d.group) {
        const h = ((u = d.childrenAfterGroup) == null ? void 0 : u.some((g) => g.selectable)) ?? !1;
        this.setRowSelectable(d, h, !0);
        return;
      }
      !this.updateRowSelectable(d, !0) && d.isSelected() && r.push(d);
    };
    if (i) {
      if (e === void 0) {
        const d = n.rootNode;
        e = d ? new Rr(!1, d) : void 0;
      }
      e == null || e.forEachChangedNodeDepthFirst(a, !s, !s);
    } else
      n.forEachNode(a);
    r.length && this.setNodesSelected({
      nodes: r,
      newValue: !1,
      source: o
    }), !s && i && ((l = this.updateGroupsFromChildrenSelections) == null || l.call(this, o));
  }
  // only called by CSRM
  updateSelectableAfterGrouping(e) {
    var t;
    this.updateSelectable(e), this.groupSelectsDescendants && ((t = this.updateGroupsFromChildrenSelections) != null && t.call(this, "rowGroupChanged", e)) && this.dispatchSelectionChanged("rowGroupChanged");
  }
  refreshMasterNodeState(e, t) {
    var i, r;
    if (!this.masterSelectsDetail)
      return;
    const n = (r = (i = e.detailNode) == null ? void 0 : i.detailGridInfo) == null ? void 0 : r.api;
    if (!n)
      return;
    const o = DG(n);
    if (e.isSelected() !== o && this.selectRowNode(e, o, t, "masterDetail") && this.dispatchSelectionChanged("masterDetail"), !o) {
      const a = this.detailSelection.get(e.id) ?? /* @__PURE__ */ new Set();
      for (const l of n.getSelectedNodes())
        a.add(l.id);
      this.detailSelection.set(e.id, a);
    }
  }
  setDetailSelectionState(e, t, n) {
    if (this.masterSelectsDetail) {
      if (!es(t)) {
        Z(269);
        return;
      }
      switch (e.isSelected()) {
        case !0: {
          n.selectAll();
          break;
        }
        case !1: {
          n.deselectAll();
          break;
        }
        case void 0: {
          const o = this.detailSelection.get(e.id);
          if (o) {
            const s = [];
            for (const i of o) {
              const r = n.getRowNode(i);
              r && s.push(r);
            }
            n.setNodesSelected({ nodes: s, newValue: !0, source: "masterDetail" });
          }
          break;
        }
      }
    }
  }
  dispatchSelectionChanged(e) {
    this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: e,
      selectedNodes: this.getSelectedNodes(),
      serverSideState: null
    });
  }
};
function Vi(e) {
  return nl(e) ? e.pinnedSibling : e.footer ? e.sibling : e;
}
function DG(e) {
  let t = 0, n = 0;
  return e.forEachNode((o) => {
    o.isSelected() ? t++ : o.selectable && n++;
  }), rb(t, n);
}
function rb(e, t) {
  if (e === 0 && t === 0)
    return !1;
  if (!(e > 0 && t > 0))
    return e > 0;
}
function TG(e, t) {
  let n = t.parent;
  for (; n; ) {
    if (n === e)
      return !0;
    n = n.parent;
  }
  return !1;
}
function ab(e) {
  var o;
  const t = e.isSelected() === !1, n = ((o = e.childrenAfterFilter) == null ? void 0 : o.some(ab)) ?? !1;
  return t || n;
}
var lb = {
  moduleName: "SharedRowSelection",
  version: Ee,
  beans: [yG],
  apiFunctions: {
    setNodesSelected: bG,
    selectAll: SG,
    deselectAll: xG,
    selectAllFiltered: RG,
    deselectAllFiltered: EG,
    selectAllOnCurrentPage: AG,
    deselectAllOnCurrentPage: FG,
    getSelectedNodes: MG,
    getSelectedRows: IG
  }
}, kG = {
  moduleName: "RowSelection",
  version: Ee,
  rowModels: ["clientSide", "infinite", "viewport"],
  beans: [PG],
  dependsOn: [lb]
};
function LG(e) {
  var t;
  (t = e.expansionSvc) == null || t.expandAll(!0);
}
function BG(e) {
  var t;
  (t = e.expansionSvc) == null || t.expandAll(!1);
}
function Up(e) {
  var t;
  (t = e.rowModel) == null || t.onRowHeightChanged();
}
function Kp(e) {
  var t, n;
  if ((t = e.rowAutoHeight) != null && t.active) {
    Z(3);
    return;
  }
  (n = e.rowModel) == null || n.resetRowHeights();
}
function OG(e, t, n) {
  var i;
  const o = ol(e);
  if (o) {
    if (((i = e.rowGroupColsSvc) == null ? void 0 : i.columns.length) === 0) {
      if (t < 0) {
        $e(238);
        return;
      }
      o.setRowCount(t, n);
      return;
    }
    $e(28);
    return;
  }
  const s = Ec(e);
  if (s) {
    s.setRowCount(t, n);
    return;
  }
}
function GG(e) {
  var t;
  return gn(e.gos) ? e.rowModel.getBlockStates() : ((t = e.rowNodeBlockLoader) == null ? void 0 : t.getBlockState()) ?? {};
}
function HG(e) {
  return e.rowModel.isLastRowIndexKnown();
}
var db = {
  moduleName: "CsrmSsrmSharedApi",
  version: Ee,
  apiFunctions: { expandAll: LG, collapseAll: BG }
}, cb = {
  moduleName: "RowModelSharedApi",
  version: Ee,
  apiFunctions: { onRowHeightChanged: Up, resetRowHeights: Kp }
}, ub = {
  moduleName: "SsrmInfiniteSharedApi",
  version: Ee,
  apiFunctions: {
    setRowCount: OG,
    getCacheBlockState: GG,
    isLastRowIndexKnown: HG
  }
}, VG = class extends U {
  constructor() {
    super(...arguments), this.beanName = "alignedGridsSvc", this.consuming = !1;
  }
  getAlignedGridApis() {
    let e = this.gos.get("alignedGrids") ?? [];
    const t = typeof e == "function";
    return typeof e == "function" && (e = e()), e.map((o) => {
      var i;
      if (!o) {
        $e(18), t || $e(20);
        return;
      }
      if (this.isGridApi(o))
        return o;
      const s = o;
      return "current" in s ? (i = s.current) == null ? void 0 : i.api : (s.api || $e(19), s.api);
    }).filter((o) => !!o && !o.isDestroyed());
  }
  isGridApi(e) {
    return !!e && !!e.dispatchEvent;
  }
  postConstruct() {
    const e = this.fireColumnEvent.bind(this);
    this.addManagedEventListeners({
      columnMoved: e,
      columnVisible: e,
      columnPinned: e,
      columnGroupOpened: e,
      columnResized: e,
      bodyScroll: this.fireScrollEvent.bind(this),
      alignedGridColumn: ({ event: t }) => this.onColumnEvent(t),
      alignedGridScroll: ({ event: t }) => this.onScrollEvent(t)
    });
  }
  // common logic across all the fire methods
  fireEvent(e) {
    this.consuming || this.getAlignedGridApis().forEach((t) => {
      t.isDestroyed() || t.dispatchEvent(e);
    });
  }
  // common logic across all consume methods. very little common logic, however extracting
  // guarantees consistency across the methods.
  onEvent(e) {
    this.consuming = !0, e(), this.consuming = !1;
  }
  fireColumnEvent(e) {
    this.fireEvent({
      type: "alignedGridColumn",
      event: e
    });
  }
  fireScrollEvent(e) {
    e.direction === "horizontal" && this.fireEvent({
      type: "alignedGridScroll",
      event: e
    });
  }
  onScrollEvent(e) {
    this.onEvent(() => {
      this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(e.left, !0);
    });
  }
  extractDataFromEvent(e, t) {
    const n = [];
    return e.columns ? e.columns.forEach((o) => {
      n.push(t(o));
    }) : e.column && n.push(t(e.column)), n;
  }
  getMasterColumns(e) {
    return this.extractDataFromEvent(e, (t) => t);
  }
  getColumnIds(e) {
    return this.extractDataFromEvent(e, (t) => t.getColId());
  }
  onColumnEvent(e) {
    this.onEvent(() => {
      switch (e.type) {
        case "columnMoved":
        case "columnVisible":
        case "columnPinned":
        case "columnResized": {
          this.processColumnEvent(e);
          break;
        }
        case "columnGroupOpened": {
          this.processGroupOpenedEvent(e);
          break;
        }
        case "columnPivotChanged":
          Z(21);
          break;
      }
    });
  }
  processGroupOpenedEvent(e) {
    const { colGroupSvc: t } = this.beans;
    t && e.columnGroups.forEach((n) => {
      let o = null;
      n && (o = t.getProvidedColGroup(n.getGroupId())), !(n && !o) && t.setColumnGroupOpened(o, n.isExpanded(), "alignedGridChanged");
    });
  }
  processColumnEvent(e) {
    var c;
    const t = e.column;
    let n = null;
    const o = this.beans, { colResize: s, ctrlsSvc: i, colModel: r } = o;
    if (t && (n = r.getColDefCol(t.getColId())), t && !n)
      return;
    const a = this.getMasterColumns(e);
    switch (e.type) {
      case "columnMoved":
        {
          const h = e.api.getColumnState().map((g) => ({ colId: g.colId }));
          cn(o, { state: h, applyOrder: !0 }, "alignedGridChanged");
        }
        break;
      case "columnVisible":
        {
          const h = e.api.getColumnState().map((g) => ({ colId: g.colId, hide: g.hide }));
          cn(o, { state: h }, "alignedGridChanged");
        }
        break;
      case "columnPinned":
        {
          const h = e.api.getColumnState().map((g) => ({ colId: g.colId, pinned: g.pinned }));
          cn(o, { state: h }, "alignedGridChanged");
        }
        break;
      case "columnResized": {
        const u = e, h = {};
        a.forEach((g) => {
          h[g.getId()] = { key: g.getColId(), newWidth: g.getActualWidth() };
        }), (c = u.flexColumns) == null || c.forEach((g) => {
          h[g.getId()] && delete h[g.getId()];
        }), s == null || s.setColumnWidths(
          Object.values(h),
          !1,
          u.finished,
          "alignedGridChanged"
        );
        break;
      }
    }
    const d = i.getGridBodyCtrl().isVerticalScrollShowing();
    this.getAlignedGridApis().forEach((u) => {
      u.setGridOption("alwaysShowVerticalScroll", d);
    });
  }
}, _G = {
  moduleName: "AlignedGrids",
  version: Ee,
  beans: [VG],
  dependsOn: [hy]
}, NG = class extends Yw {
  constructor() {
    super(...arguments), this.beanName = "csrmNodeSvc";
  }
}, Lu = class {
  constructor() {
    this.removals = /* @__PURE__ */ new Set(), this.updates = /* @__PURE__ */ new Set(), this.adds = /* @__PURE__ */ new Set();
  }
  /** Marks a row as removed. Order of operations is: remove, update, add */
  remove(e) {
    this.adds.delete(e) || (this.updates.delete(e), this.removals.add(e));
  }
  /** Marks a row as updated. Order of operations is: remove, update, add */
  update(e) {
    this.adds.has(e) || this.updates.add(e);
  }
  /** Marks a row as added. Order of operation is: remove, update, add */
  add(e) {
    this.adds.add(e);
  }
}, hb = (e) => {
  const t = e.childrenAfterSort, n = e.sibling;
  if (n && (n.childrenAfterSort = t), !!t)
    for (let o = 0, s = t.length - 1; o <= s; o++) {
      const i = t[o], r = o === 0, a = o === s;
      i.firstChild !== r && (i.firstChild = r, i.dispatchRowEvent("firstChildChanged")), i.lastChild !== a && (i.lastChild = a, i.dispatchRowEvent("lastChildChanged")), i.childIndex !== o && (i.childIndex = o, i.dispatchRowEvent("childIndexChanged"));
    }
}, $G = class extends U {
  constructor() {
    super(...arguments), this.beanName = "sortStage", this.refreshProps = /* @__PURE__ */ new Set(["postSortRows", "groupDisplayType", "accentedSort"]), this.step = "sort";
  }
  execute(e) {
    const t = this.beans.sortSvc.getSortOptions(), n = t.length > 0 && !!e.changedRowNodes && // in time we can remove this check, so that delta sort is always
    // on if transactions are present. it's off for now so that we can
    // selectively turn it on and test it with some select users before
    // rolling out to everyone.
    this.gos.get("deltaSort");
    this.sort(t, n, e.changedRowNodes, e.changedPath);
  }
  sort(e, t, n, o) {
    const { gos: s, colModel: i, rowGroupColsSvc: r, rowNodeSorter: a, rowRenderer: l, showRowGroupCols: d } = this.beans, c = s.get("groupMaintainOrder"), u = i.getCols().some((w) => w.isRowGroupActive()), h = r == null ? void 0 : r.columns, g = i.isPivotMode(), p = s.getCallback("postSortRows");
    let f = !1, m;
    const C = (w) => {
      var F, E;
      const b = g && w.leafGroup;
      let A = c && u && !w.leafGroup;
      A && (m ?? (m = this.shouldSortContainsGroupCols(e)), A && (A = !m));
      let S = null;
      if (A) {
        let M = !1;
        if (h) {
          const I = w.level + 1;
          I < h.length && (M = h[I].getSort() === null);
        }
        M || (S = UG(w));
      } else !e.length || b ? S = null : t && n ? S = zG(a, w, n, o, e) : S = a.doFullSort(w.childrenAfterAggFilter, e);
      if (S || (S = ((F = w.childrenAfterAggFilter) == null ? void 0 : F.slice(0)) ?? []), f || (f = ((E = w.childrenAfterSort) == null ? void 0 : E[0]) !== S[0]), w.childrenAfterSort = S, hb(w), p) {
        const M = { nodes: w.childrenAfterSort };
        p(M);
      }
    };
    if (o == null || o.forEachChangedNodeDepthFirst(C), f && s.get("groupHideOpenParents")) {
      const w = d == null ? void 0 : d.getShowRowGroupCols();
      w != null && w.length && l.refreshCells({ columns: w, force: !0 });
    }
  }
  shouldSortContainsGroupCols(e) {
    const t = e.length;
    if (!t)
      return !1;
    if (Xn(this.gos)) {
      for (let n = 0; n < t; ++n) {
        const o = e[n].column;
        if (o.isPrimary() && o.isRowGroupActive())
          return !0;
      }
      return !1;
    }
    for (let n = 0; n < t; ++n)
      if (e[n].column.getColDef().showRowGroup)
        return !0;
    return !1;
  }
}, zG = (e, t, n, o, s) => {
  const i = t.childrenAfterAggFilter, r = t.childrenAfterSort;
  if (!r)
    return e.doFullSort(i, s);
  const a = /* @__PURE__ */ new Set(), l = [], { updates: d, adds: c } = n;
  for (let h = 0, g = i.length; h < g; ++h) {
    const p = i[h];
    d.has(p) || c.has(p) || o && !o.canSkip(p) ? l.push({
      currentPos: l.length,
      rowNode: p
    }) : a.add(p);
  }
  const u = r.filter((h) => a.has(h)).map((h, g) => ({ currentPos: g, rowNode: h }));
  return l.sort((h, g) => e.compareRowNodes(s, h, g)), WG(e, s, l, u);
}, WG = (e, t, n, o) => {
  let s = 0, i = 0;
  const r = n.length, a = o.length, l = new Array(r + a);
  let d = 0;
  for (; s < r && i < a; ) {
    const c = n[s], u = o[i];
    e.compareRowNodes(t, c, u) < 0 ? (l[d++] = c.rowNode, ++s) : (l[d++] = u.rowNode, ++i);
  }
  for (; s < r; )
    l[d++] = n[s++].rowNode;
  for (; i < a; )
    l[d++] = o[i++].rowNode;
  return l;
}, UG = (e) => {
  const t = e.childrenAfterSort, n = e.childrenAfterAggFilter, o = t == null ? void 0 : t.length, s = n == null ? void 0 : n.length;
  if (!o || !s)
    return null;
  const i = new Array(s), r = /* @__PURE__ */ new Set();
  for (let l = 0; l < s; ++l)
    r.add(n[l]);
  let a = 0;
  for (let l = 0; l < o; ++l) {
    const d = t[l];
    r.delete(d) && (i[a++] = d);
  }
  if (r.size === 0 && a === o)
    return t;
  for (const l of r)
    i[a++] = l;
  return i.length = a, i;
}, KG = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.rootNode = null, this.rowsToDisplay = [], this.rowDataUpdatedPending = !1, this.started = !1, this.isRefreshingModel = !1, this.rowNodesCountReady = !1, this.rowCountReady = !1, this.onRowHeightChanged_debounced = Lt(this, this.onRowHeightChanged.bind(this), 100);
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.valueCache = e.valueCache, this.filterStage = e.filterStage, this.sortStage = e.sortStage, this.flattenStage = e.flattenStage, this.groupStage = e.groupStage, this.aggStage = e.aggStage, this.pivotStage = e.pivotStage, this.filterAggStage = e.filterAggStage;
  }
  postConstruct() {
    this.orderedStages = [
      this.groupStage,
      this.filterStage,
      this.pivotStage,
      this.aggStage,
      this.sortStage,
      this.filterAggStage,
      this.flattenStage
    ].filter((o) => !!o);
    const e = this.refreshModel.bind(this, { step: "group" }), t = this.refreshModel.bind(this, {
      step: "group",
      // after cols change, row grouping (the first stage) could of changed
      afterColumnsChanged: !0,
      keepRenderedRows: !0,
      // we want animations cos sorting or filtering could be applied
      animate: !this.gos.get("suppressAnimationFrame")
    });
    this.addManagedEventListeners({
      newColumnsLoaded: t,
      columnRowGroupChanged: e,
      columnValueChanged: this.onValueChanged.bind(this),
      columnPivotChanged: this.refreshModel.bind(this, { step: "pivot" }),
      filterChanged: this.onFilterChanged.bind(this),
      sortChanged: this.onSortChanged.bind(this),
      columnPivotModeChanged: e,
      gridStylesChanged: this.onGridStylesChanges.bind(this),
      gridReady: this.onGridReady.bind(this),
      rowExpansionStateChanged: this.onRowGroupOpened.bind(this)
    }), this.addPropertyListeners(), this.rootNode = new Ln(this.beans);
    const n = this.getNewNodeManager();
    this.nodeManager = n, n.activate(this.rootNode);
  }
  getNewNodeManager() {
    const { gos: e, beans: t } = this;
    return tp(e) === "treeNested" && t.csrmChildrenTreeNodeSvc || t.csrmNodeSvc;
  }
  addPropertyListeners() {
    const e = [
      "treeData",
      "treeDataChildrenField",
      ...this.orderedStages.flatMap(({ refreshProps: t }) => [...t])
    ];
    this.addManagedPropertyListeners(e, (t) => {
      var o;
      const n = (o = t.changeSet) == null ? void 0 : o.properties;
      n && this.onPropChange(n);
    }), this.addManagedPropertyListener("rowData", () => this.onPropChange(["rowData"])), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights());
  }
  start() {
    this.started = !0, this.rowNodesCountReady ? this.refreshModel({ step: "group", rowDataUpdated: !0, newData: !0 }) : this.setInitialData();
  }
  setInitialData() {
    this.gos.get("rowData") && this.onPropChange(["rowData"]);
  }
  ensureRowHeightsValid(e, t, n, o) {
    let s, i = !1;
    do {
      s = !1;
      const r = this.getRowIndexAtPixel(e), a = this.getRowIndexAtPixel(t), l = Math.max(r, n), d = Math.min(a, o);
      for (let c = l; c <= d; c++) {
        const u = this.getRow(c);
        if (u.rowHeightEstimated) {
          const h = qt(this.beans, u);
          u.setRowHeight(h.height), s = !0, i = !0;
        }
      }
      s && this.setRowTopAndRowIndex();
    } while (s);
    return i;
  }
  onPropChange(e) {
    if (!this.rootNode)
      return;
    const t = this.gos, n = new Set(e), o = {
      step: "nothing",
      changedProps: n
    }, s = n.has("rowData"), i = this.nodeManager, r = this.getNewNodeManager(), a = i !== r || s && n.has("treeData") && t.get("treeData") || n.has("treeDataChildrenField") && t.get("treeData");
    let l;
    if ((a || s) && (l = t.get("rowData"), l != null && !Array.isArray(l) && (l = null, Z(1))), a && (s || (l = (i == null ? void 0 : i.extractRowData()) ?? l), i !== r && (i == null || i.deactivate(), this.nodeManager = r), r.activate(this.rootNode)), l)
      if (!a && !this.isEmpty() && l.length > 0 && t.exists("getRowId") && // this property is a backwards compatibility property, for those who want
      // the old behaviour of Row IDs but NOT Immutable Data.
      !t.get("resetRowDataOnUpdate"))
        o.keepRenderedRows = !0, o.animate = !this.gos.get("suppressAnimationFrame"), o.changedRowNodes = new Lu(), r.setImmutableRowData(o, l);
      else {
        o.rowDataUpdated = !0, o.newData = !0;
        const { selectionSvc: c, pinnedRowModel: u } = this.beans;
        c == null || c.reset("rowDataChanged"), u != null && u.isManual() && u.reset(), this.rowNodesCountReady = !0, r.setNewRowData(l);
      }
    if (o.rowDataUpdated)
      o.step = "group";
    else if (o.step === "nothing") {
      for (const { refreshProps: d, step: c } of this.orderedStages)
        if (e.some((u) => d.has(u))) {
          o.step = c;
          break;
        }
    }
    o.step !== "nothing" && this.refreshModel(o);
  }
  setRowTopAndRowIndex() {
    const { beans: e, rowsToDisplay: t } = this, n = e.environment.getDefaultRowHeight();
    let o = 0;
    const s = /* @__PURE__ */ new Set(), i = jt(this.gos, "normal");
    for (let r = 0, a = t.length; r < a; ++r) {
      const l = t[r];
      if (l.id != null && s.add(l.id), l.rowHeight == null) {
        const d = qt(e, l, i, n);
        l.setRowHeight(d.height, d.estimated);
      }
      l.setRowTop(o), l.setRowIndex(r), o += l.rowHeight;
    }
    return s;
  }
  clearRowTopAndRowIndex(e, t) {
    const n = e.active, o = (i) => {
      i && i.id != null && !t.has(i.id) && i.clearRowTopAndRowIndex();
    }, s = (i) => {
      if (i !== null && (o(i), o(i.detailNode), o(i.sibling), i.hasChildren() && i.childrenAfterGroup)) {
        const r = i.level == -1;
        n && !r && !i.expanded || i.childrenAfterGroup.forEach(s);
      }
    };
    s(this.rootNode);
  }
  isLastRowIndexKnown() {
    return !0;
  }
  getRowCount() {
    return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
  }
  /**
   * Returns the number of rows with level === 1
   */
  getTopLevelRowCount() {
    const e = this.rootNode;
    if (!e || this.rowsToDisplay.length === 0)
      return 0;
    if (this.rowsToDisplay && this.rowsToDisplay[0] === e)
      return 1;
    const n = e.childrenAfterSort, o = e.sibling && e.sibling.displayed ? 1 : 0;
    return (n ? n.length : 0) + o;
  }
  /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */
  getTopLevelRowDisplayedIndex(e) {
    const { rootNode: t, rowsToDisplay: n } = this;
    if (!t || !n.length || n[0] === t)
      return e;
    const { childrenAfterSort: s } = t, i = (a) => {
      let l = s[a];
      if (this.gos.get("groupHideOpenParents"))
        for (; l.expanded && l.childrenAfterSort && l.childrenAfterSort.length > 0; )
          l = l.childrenAfterSort[0];
      return l.rowIndex;
    }, { footerSvc: r } = this.beans;
    return r ? r.getTopDisplayIndex(n, e, s, i) : i(e);
  }
  /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */
  getTopLevelIndexFromDisplayedIndex(e) {
    var r;
    const { rootNode: t, rowsToDisplay: n } = this;
    if (!t || !n.length || n[0] === t)
      return e;
    let s = this.getRow(e);
    for (s.footer && (s = s.sibling); s.parent && s.parent !== t; )
      s = s.parent;
    const i = (r = t.childrenAfterSort) == null ? void 0 : r.findIndex((a) => a === s);
    return i === -1 ? e : i ?? e;
  }
  getRowBounds(e) {
    const t = this.rowsToDisplay[e];
    return t ? {
      rowTop: t.rowTop,
      rowHeight: t.rowHeight
    } : null;
  }
  onRowGroupOpened() {
    const e = Xi(this.gos);
    this.refreshModel({ step: "map", keepRenderedRows: !0, animate: e });
  }
  onFilterChanged(e) {
    if (e.afterDataChange)
      return;
    const t = Xi(this.gos), o = e.columns.length === 0 || e.columns.some((s) => s.isPrimary()) ? "filter" : "filter_aggregates";
    this.refreshModel({ step: o, keepRenderedRows: !0, animate: t });
  }
  onSortChanged() {
    const e = Xi(this.gos);
    this.refreshModel({
      step: "sort",
      keepRenderedRows: !0,
      animate: e
    });
  }
  getType() {
    return "clientSide";
  }
  onValueChanged() {
    this.refreshModel({ step: this.colModel.isPivotActive() ? "pivot" : "aggregate" });
  }
  createChangePath(e) {
    const t = new Rr(!1, this.rootNode);
    return e || (t.active = !1), t;
  }
  isSuppressModelUpdateAfterUpdateTransaction(e) {
    if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction"))
      return !1;
    const { changedRowNodes: t, newData: n, rowDataUpdated: o } = e;
    return !(!t || n || !o || t.removals.size || t.adds.size);
  }
  refreshModel(e) {
    var i, r, a;
    if (!this.rootNode)
      return;
    const t = this.beans;
    let n = !!e.rowDataUpdated;
    const o = e.changedPath ?? (e.changedPath = this.createChangePath(!e.newData && n));
    if (this.started && n && this.eventSvc.dispatchEvent({ type: "rowDataUpdated" }), !this.started || this.isRefreshingModel || this.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(e)) {
      this.rowDataUpdatedPending || (this.rowDataUpdatedPending = n);
      return;
    }
    switch (this.rowDataUpdatedPending && (this.rowDataUpdatedPending = !1, e.rowDataUpdated = n = !0, e.step = "group"), this.isRefreshingModel = !0, (i = t.masterDetailSvc) == null || i.refreshModel(e), n && e.step !== "group" && ((r = t.colFilter) == null || r.refreshModel()), e.step) {
      case "group":
        (this.doRowGrouping(e) || n) && ((a = t.colFilter) == null || a.refreshModel()), !this.rowCountReady && this.rowNodesCountReady && (this.rowCountReady = !0, this.eventSvc.dispatchEventOnce({ type: "rowCountReady" }));
      case "filter":
        this.doFilter(o);
      case "pivot":
        this.doPivot(o);
      case "aggregate":
        this.doAggregate(o);
      case "filter_aggregates":
        this.doFilterAggregates(o);
      case "sort":
        this.doSort(e.changedRowNodes, o);
      case "map":
        this.doRowsToDisplay();
    }
    const s = this.setRowTopAndRowIndex();
    this.clearRowTopAndRowIndex(o, s), this.isRefreshingModel = !1, this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      animate: e.animate,
      keepRenderedRows: e.keepRenderedRows,
      newData: e.newData,
      newPage: !1,
      keepUndoRedoStack: e.keepUndoRedoStack
    });
  }
  isEmpty() {
    var e, t, n;
    return !((t = (e = this.rootNode) == null ? void 0 : e.allLeafChildren) != null && t.length) || !((n = this.colModel) != null && n.ready);
  }
  isRowsToRender() {
    return this.rowsToDisplay.length > 0;
  }
  getNodesInRangeForSelection(e, t) {
    let n = !1, o = !1;
    const s = [], i = wi(this.gos);
    return this.forEachNodeAfterFilterAndSort((r) => {
      if (o)
        return;
      if (n && (r === t || r === e) && (o = !0, r.group && i)) {
        s.push(...r.allLeafChildren);
        return;
      }
      if (!n) {
        if (r !== t && r !== e)
          return;
        n = !0, t === e && (o = !0);
      }
      if (!r.group || !i) {
        s.push(r);
        return;
      }
    }), s;
  }
  getTopLevelNodes() {
    var e;
    return ((e = this.rootNode) == null ? void 0 : e.childrenAfterGroup) ?? null;
  }
  getRow(e) {
    return this.rowsToDisplay[e];
  }
  isRowPresent(e) {
    return this.rowsToDisplay.indexOf(e) >= 0;
  }
  getRowIndexAtPixel(e) {
    const t = this.rowsToDisplay;
    if (this.isEmpty() || t.length === 0)
      return -1;
    let n = 0, o = t.length - 1;
    if (e <= 0)
      return 0;
    if (Je(t).rowTop <= e)
      return t.length - 1;
    let i = -1, r = -1;
    for (; ; ) {
      const a = Math.floor((n + o) / 2), l = t[a];
      if (this.isRowInPixel(l, e) || (l.rowTop < e ? n = a + 1 : l.rowTop > e && (o = a - 1), i === n && r === o))
        return a;
      i = n, r = o;
    }
  }
  isRowInPixel(e, t) {
    const n = e.rowTop, o = e.rowTop + e.rowHeight;
    return n <= t && o > t;
  }
  forEachLeafNode(e) {
    var t, n;
    (n = (t = this.rootNode) == null ? void 0 : t.allLeafChildren) == null || n.forEach((o, s) => e(o, s));
  }
  forEachNode(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t);
  }
  forEachDisplayedNode(e) {
    this.rowsToDisplay.forEach(e);
  }
  forEachNodeAfterFilter(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t, (n) => n.childrenAfterAggFilter);
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t, (n) => n.childrenAfterSort);
  }
  forEachPivotNode(e, t = !1, n = !1) {
    const { colModel: o, rowGroupColsSvc: s } = this.beans;
    if (!o.isPivotMode())
      return;
    if (!(s != null && s.columns.length)) {
      e(this.rootNode, 0);
      return;
    }
    const i = n ? "childrenAfterSort" : "childrenAfterGroup";
    this.depthFirstSearchRowNodes(
      e,
      t,
      (r) => r.leafGroup ? null : r[i]
    );
  }
  /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */
  depthFirstSearchRowNodes(e, t = !1, n = (i) => i.childrenAfterGroup, o = this.rootNode, s = 0) {
    let i = s;
    if (!o)
      return i;
    const r = o === this.rootNode;
    r || e(o, i++);
    const { footerSvc: a } = this.beans;
    if (o.hasChildren() && !o.footer) {
      const l = n(o);
      if (l) {
        i = (a == null ? void 0 : a.addTotalRows(i, o, e, t, r, "top")) ?? i;
        for (const d of l)
          i = this.depthFirstSearchRowNodes(e, t, n, d, i);
        return (a == null ? void 0 : a.addTotalRows(i, o, e, t, r, "bottom")) ?? i;
      }
    }
    return i;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  doAggregate(e) {
    var n;
    const t = this.rootNode;
    t && ((n = this.aggStage) == null || n.execute({ rowNode: t, changedPath: e }));
  }
  doFilterAggregates(e) {
    const t = this.rootNode;
    this.filterAggStage ? this.filterAggStage.execute({ rowNode: t, changedPath: e }) : t.childrenAfterAggFilter = t.childrenAfterFilter;
  }
  doSort(e, t) {
    this.sortStage ? this.sortStage.execute({
      rowNode: this.rootNode,
      changedRowNodes: e,
      changedPath: t
    }) : t.forEachChangedNodeDepthFirst((n) => {
      n.childrenAfterSort = n.childrenAfterAggFilter.slice(0), hb(n);
    });
  }
  doRowGrouping(e) {
    var s;
    const t = this.rootNode, n = (s = this.groupStage) == null ? void 0 : s.execute({
      rowNode: t,
      changedRowNodes: e.changedRowNodes,
      changedPath: e.changedPath,
      rowNodesOrderChanged: !!e.rowNodesOrderChanged,
      afterColumnsChanged: !!e.afterColumnsChanged
    });
    if (n !== void 0)
      return n;
    const o = t.sibling;
    return t.childrenAfterGroup = t.allLeafChildren, o && (o.childrenAfterGroup = t.childrenAfterGroup), t.updateHasChildren(), !1;
  }
  doFilter(e) {
    this.filterStage ? this.filterStage.execute({ rowNode: this.rootNode, changedPath: e }) : e.forEachChangedNodeDepthFirst((t) => {
      t.childrenAfterFilter = t.childrenAfterGroup, Hy(t);
    }, !0);
  }
  doPivot(e) {
    var t;
    (t = this.pivotStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  getRowNode(e) {
    var o;
    const t = this.nodeManager.getRowNode(e);
    return typeof t == "object" ? t : typeof e == "string" && e.indexOf(Pd) === 0 ? (o = this.groupStage) == null ? void 0 : o.getNode(e) : void 0;
  }
  batchUpdateRowData(e, t) {
    if (this.applyAsyncTransactionsTimeout == null) {
      this.rowDataTransactionBatch = [];
      const n = this.gos.get("asyncTransactionWaitMillis");
      this.applyAsyncTransactionsTimeout = window.setTimeout(() => {
        this.isAlive() && this.executeBatchUpdateRowData();
      }, n);
    }
    this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: t });
  }
  flushAsyncTransactions() {
    this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
  }
  executeBatchUpdateRowData() {
    var s, i;
    (s = this.valueCache) == null || s.onDataChanged();
    const e = [], t = [], n = new Lu();
    let o = !1;
    (i = this.rowDataTransactionBatch) == null || i.forEach((r) => {
      this.rowNodesCountReady = !0;
      const { rowNodeTransaction: a, rowsInserted: l } = this.nodeManager.updateRowData(
        r.rowDataTransaction,
        n
      );
      l && (o = !0), t.push(a), r.callback && e.push(r.callback.bind(null, a));
    }), this.commitTransactions(o, n), e.length > 0 && window.setTimeout(() => {
      e.forEach((r) => r());
    }, 0), t.length > 0 && this.eventSvc.dispatchEvent({
      type: "asyncTransactionsFlushed",
      results: t
    }), this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
  }
  /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */
  updateRowData(e) {
    var s;
    (s = this.valueCache) == null || s.onDataChanged(), this.rowNodesCountReady = !0;
    const t = new Lu(), { rowNodeTransaction: n, rowsInserted: o } = this.nodeManager.updateRowData(e, t);
    return this.commitTransactions(o, t), n;
  }
  /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */
  commitTransactions(e, t) {
    this.refreshModel({
      step: "group",
      rowDataUpdated: !0,
      rowNodesOrderChanged: e,
      keepRenderedRows: !0,
      animate: !this.gos.get("suppressAnimationFrame"),
      changedRowNodes: t,
      changedPath: this.createChangePath(!0)
    });
  }
  doRowsToDisplay() {
    const { flattenStage: e, rootNode: t } = this;
    let n;
    if (e)
      n = e.execute({ rowNode: t });
    else {
      n = (t == null ? void 0 : t.childrenAfterSort) ?? [];
      for (const o of n)
        o.setUiLevel(0);
    }
    this.rowsToDisplay = n;
  }
  onRowHeightChanged() {
    this.refreshModel({
      step: "map",
      keepRenderedRows: !0,
      keepUndoRedoStack: !0
    });
  }
  resetRowHeights() {
    const e = this.rootNode;
    if (!e)
      return;
    const t = this.resetRowHeightsForAllRowNodes();
    e.setRowHeight(e.rowHeight, !0), e.sibling && e.sibling.setRowHeight(e.sibling.rowHeight, !0), t && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      t.setRowHeight(t.rowHeight, !0);
      const n = t.detailNode;
      n && n.setRowHeight(n.rowHeight, !0), t.sibling && t.sibling.setRowHeight(t.sibling.rowHeight, !0), e = !0;
    }), e;
  }
  onGridStylesChanges(e) {
    var t;
    if (e.rowHeightChanged) {
      if ((t = this.beans.rowAutoHeight) != null && t.active)
        return;
      this.resetRowHeights();
    }
  }
  onGridReady() {
    this.started || this.setInitialData();
  }
  isRowDataLoaded() {
    return this.rowCountReady;
  }
  destroy() {
    super.destroy(), this.started = !1, this.rootNode = null, this.nodeManager = null, this.rowDataTransactionBatch = null, this.orderedStages = Vo, this.rowsToDisplay = Vo;
  }
  /**
   * @deprecated v33.1
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
};
function ZG(e) {
  var t;
  (t = e.expansionSvc) == null || t.onGroupExpandedOrCollapsed();
}
function qG(e, t) {
  const n = Ho(e);
  n && ((!t || t === "everything") && (t = "group"), n.refreshModel({
    step: t,
    keepRenderedRows: !0,
    animate: !e.gos.get("suppressAnimationFrame")
  }));
}
function jG(e) {
  var t;
  return ((t = Ho(e)) == null ? void 0 : t.isEmpty()) ?? !0;
}
function YG(e, t) {
  var n;
  (n = Ho(e)) == null || n.forEachLeafNode(t);
}
function QG(e, t) {
  var n;
  (n = Ho(e)) == null || n.forEachNodeAfterFilter(t);
}
function JG(e, t) {
  var n;
  (n = Ho(e)) == null || n.forEachNodeAfterFilterAndSort(t);
}
function XG(e, t) {
  return e.frameworkOverrides.wrapIncoming(
    () => {
      var n;
      return (n = Ho(e)) == null ? void 0 : n.updateRowData(t);
    }
  );
}
function eH(e, t, n) {
  e.frameworkOverrides.wrapIncoming(
    () => {
      var o;
      return (o = Ho(e)) == null ? void 0 : o.batchUpdateRowData(t, n);
    }
  );
}
function tH(e) {
  e.frameworkOverrides.wrapIncoming(() => {
    var t;
    return (t = Ho(e)) == null ? void 0 : t.flushAsyncTransactions();
  });
}
function nH(e) {
  var t;
  return (t = e.selectionSvc) == null ? void 0 : t.getBestCostNodeSelection();
}
var oH = {
  moduleName: "ClientSideRowModel",
  version: Ee,
  rowModels: ["clientSide"],
  beans: [NG, KG, $G],
  dependsOn: [Bp]
}, sH = {
  moduleName: "ClientSideRowModelApi",
  version: Ee,
  apiFunctions: {
    onGroupExpandedOrCollapsed: ZG,
    refreshClientSideRowModel: qG,
    isRowDataEmpty: jG,
    forEachLeafNode: YG,
    forEachNodeAfterFilter: QG,
    forEachNodeAfterFilterAndSort: JG,
    applyTransaction: XG,
    applyTransactionAsync: eH,
    flushAsyncTransactions: tH,
    getBestCostNodeSelection: nH,
    resetRowHeights: Kp,
    onRowHeightChanged: Up
  },
  dependsOn: [db, cb]
}, iH = class extends U {
  constructor() {
    super(...arguments), this.beanName = "gridSerializer";
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel, this.rowModel = e.rowModel, this.pinnedRowModel = e.pinnedRowModel;
  }
  serialize(e, t = {}) {
    const { allColumns: n, columnKeys: o, skipRowGroups: s, exportRowNumbers: i } = t, r = this.getColumnsToExport({
      allColumns: n,
      skipRowGroups: s,
      columnKeys: o,
      exportRowNumbers: i
    });
    return [
      // first pass, put in the header names of the cols
      this.prepareSession(r),
      this.prependContent(t),
      this.exportColumnGroups(t, r),
      this.exportHeaders(t, r),
      this.processPinnedTopRows(t, r),
      this.processRows(t, r),
      this.processPinnedBottomRows(t, r),
      this.appendContent(t)
    ].reduce((a, l) => l(a), e).parse();
  }
  processRow(e, t, n, o) {
    var p;
    const s = t.shouldRowBeSkipped || (() => !1), r = t.rowPositions != null || !!t.onlySelected, a = this.gos.get("groupHideOpenParents") && !r, l = this.colModel.isPivotMode() ? o.leafGroup : !o.group, d = !!o.footer, c = o.allChildrenCount === 1 && ((p = o.childrenAfterGroup) == null ? void 0 : p.length) === 1 && O3(this.gos, o);
    if (!l && !d && (t.skipRowGroups || c || a) || t.onlySelected && !o.isSelected() || t.skipPinnedTop && o.rowPinned === "top" || t.skipPinnedBottom && o.rowPinned === "bottom" || o.stub || o.level === -1 && !l && !d || s(ke(this.gos, { node: o })))
      return;
    const g = e.onNewBodyRow(o);
    if (n.forEach((f, m) => {
      g.onColumn(f, m, o);
    }), t.getCustomContentBelowRow) {
      const f = t.getCustomContentBelowRow(ke(this.gos, { node: o }));
      f && e.addCustomContent(f);
    }
  }
  appendContent(e) {
    return (t) => {
      const n = e.appendContent;
      return n && t.addCustomContent(n), t;
    };
  }
  prependContent(e) {
    return (t) => {
      const n = e.prependContent;
      return n && t.addCustomContent(n), t;
    };
  }
  prepareSession(e) {
    return (t) => (t.prepare(e), t);
  }
  exportColumnGroups(e, t) {
    return (n) => {
      if (!e.skipColumnGroupHeaders) {
        const o = new ew(), { colGroupSvc: s } = this.beans, i = s ? s.createColumnGroups({
          columns: t,
          idCreator: o,
          pinned: null,
          isStandaloneStructure: !0
        }) : t;
        this.recursivelyAddHeaderGroups(
          i,
          n,
          e.processGroupHeaderCallback
        );
      }
      return n;
    };
  }
  exportHeaders(e, t) {
    return (n) => {
      if (!e.skipColumnHeaders) {
        const o = n.onNewHeaderRow();
        t.forEach((s, i) => {
          o.onColumn(s, i, void 0);
        });
      }
      return n;
    };
  }
  processPinnedTopRows(e, t) {
    return (n) => {
      var s, i;
      const o = this.processRow.bind(this, n, e, t);
      return e.rowPositions ? e.rowPositions.filter((r) => r.rowPinned === "top").sort((r, a) => r.rowIndex - a.rowIndex).map((r) => {
        var a;
        return (a = this.pinnedRowModel) == null ? void 0 : a.getPinnedTopRow(r.rowIndex);
      }).forEach(o) : (s = this.pinnedRowModel) != null && s.isManual() || (i = this.pinnedRowModel) == null || i.forEachPinnedRow("top", o), n;
    };
  }
  processRows(e, t) {
    return (n) => {
      var d;
      const o = this.rowModel, s = Ct(this.gos), i = gn(this.gos), r = !s && e.onlySelected, a = this.processRow.bind(this, n, e, t), { exportedRows: l = "filteredAndSorted" } = e;
      if (e.rowPositions)
        return e.rowPositions.filter((c) => c.rowPinned == null).sort((c, u) => c.rowIndex - u.rowIndex).map((c) => o.getRow(c.rowIndex)).forEach(a), n;
      if (this.colModel.isPivotMode())
        return s ? o.forEachPivotNode(a, !0, l === "filteredAndSorted") : i ? o.forEachNodeAfterFilterAndSort(a, !0) : o.forEachNode(a), n;
      if (e.onlySelectedAllPages || r) {
        const c = ((d = this.beans.selectionSvc) == null ? void 0 : d.getSelectedNodes()) ?? [];
        this.replicateSortedOrder(c), c.forEach(a);
      } else
        l === "all" ? o.forEachNode(a) : s || i ? o.forEachNodeAfterFilterAndSort(a, !0) : o.forEachNode(a);
      return n;
    };
  }
  replicateSortedOrder(e) {
    const { sortSvc: t, rowNodeSorter: n } = this.beans;
    if (!t || !n)
      return;
    const o = t.getSortOptions(), s = (i, r) => {
      var a, l;
      return i.rowIndex != null && r.rowIndex != null ? i.rowIndex - r.rowIndex : i.level === r.level ? ((a = i.parent) == null ? void 0 : a.id) === ((l = r.parent) == null ? void 0 : l.id) ? n.compareRowNodes(
        o,
        {
          rowNode: i,
          currentPos: i.rowIndex ?? -1
        },
        {
          rowNode: r,
          currentPos: r.rowIndex ?? -1
        }
      ) : s(i.parent, r.parent) : i.level > r.level ? s(i.parent, r) : s(i, r.parent);
    };
    e.sort(s);
  }
  processPinnedBottomRows(e, t) {
    return (n) => {
      var s, i;
      const o = this.processRow.bind(this, n, e, t);
      return e.rowPositions ? e.rowPositions.filter((r) => r.rowPinned === "bottom").sort((r, a) => r.rowIndex - a.rowIndex).map((r) => {
        var a;
        return (a = this.pinnedRowModel) == null ? void 0 : a.getPinnedBottomRow(r.rowIndex);
      }).forEach(o) : (s = this.pinnedRowModel) != null && s.isManual() || (i = this.pinnedRowModel) == null || i.forEachPinnedRow("bottom", o), n;
    };
  }
  getColumnsToExport(e) {
    const { allColumns: t = !1, skipRowGroups: n = !1, exportRowNumbers: o = !1, columnKeys: s } = e, { colModel: i, gos: r, visibleCols: a } = this, l = i.isPivotMode(), d = (h) => Gs(h) ? !1 : !bs(h) || o;
    if (s && s.length)
      return i.getColsForKeys(s).filter(d);
    const c = r.get("treeData");
    let u = [];
    return t && !l ? u = i.getCols() : u = a.allCols, u = u.filter(
      (h) => d(h) && (n && !c ? !pc(h) : !0)
    ), u;
  }
  recursivelyAddHeaderGroups(e, t, n) {
    const o = [];
    e.forEach((s) => {
      const i = s;
      i.getChildren && i.getChildren().forEach((r) => o.push(r));
    }), e.length > 0 && Dt(e[0]) && this.doAddHeaderHeader(t, e, n), o && o.length > 0 && this.recursivelyAddHeaderGroups(
      o,
      t,
      n
    );
  }
  doAddHeaderHeader(e, t, n) {
    const o = e.onNewHeaderGroupingRow();
    let s = 0;
    t.forEach((i) => {
      const r = i;
      let a;
      n ? a = n(
        ke(this.gos, {
          columnGroup: r
        })
      ) : a = this.beans.colNames.getDisplayNameForColumnGroup(r, "header");
      const d = (r.isExpandable() ? r.getLeafColumns() : []).reduce(
        (c, u, h, g) => {
          let p = Je(c);
          return u.getColumnGroupShow() === "open" ? (!p || p[1] != null) && (p = [h], c.push(p)) : p && p[1] == null && (p[1] = h - 1), h === g.length - 1 && p && p[1] == null && (p[1] = h), c;
        },
        []
      );
      o.onColumn(
        r,
        a || "",
        s++,
        r.getLeafColumns().length - 1,
        d
      );
    });
  }
}, rH = {
  moduleName: "SharedExport",
  version: Ee,
  beans: [iH]
}, p0 = `\r
`, aH = class extends U5 {
  constructor(e) {
    super(e), this.config = e, this.isFirstLine = !0, this.result = "";
    const { suppressQuotes: t, columnSeparator: n } = e;
    this.suppressQuotes = t, this.columnSeparator = n;
  }
  addCustomContent(e) {
    e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, p0), this.result += e) : e.forEach((t) => {
      this.beginNewLine(), t.forEach((n, o) => {
        o !== 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(n.data.value || ""), n.mergeAcross && this.appendEmptyCells(n.mergeAcross);
      });
    }));
  }
  onNewHeaderGroupingRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
    };
  }
  onNewHeaderGroupingRowColumn(e, t, n, o) {
    n != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(t), this.appendEmptyCells(o);
  }
  appendEmptyCells(e) {
    for (let t = 1; t <= e; t++)
      this.result += this.columnSeparator + this.putInQuotes("");
  }
  onNewHeaderRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderRowColumn.bind(this)
    };
  }
  onNewHeaderRowColumn(e, t) {
    t != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
  }
  onNewBodyRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewBodyRowColumn.bind(this)
    };
  }
  onNewBodyRowColumn(e, t, n) {
    t != 0 && (this.result += this.columnSeparator);
    const o = this.extractRowCellValue(e, t, t, "csv", n);
    this.result += this.putInQuotes(o.valueFormatted ?? o.value);
  }
  putInQuotes(e) {
    if (this.suppressQuotes)
      return e;
    if (e == null)
      return '""';
    let t;
    return typeof e == "string" ? t = e : typeof e.toString == "function" ? t = e.toString() : (Z(53), t = ""), '"' + t.replace(/"/g, '""') + '"';
  }
  parse() {
    return this.result;
  }
  beginNewLine() {
    this.isFirstLine || (this.result += p0), this.isFirstLine = !1;
  }
}, lH = class extends W5 {
  constructor() {
    super(...arguments), this.beanName = "csvCreator";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.colNames = e.colNames, this.rowGroupColsSvc = e.rowGroupColsSvc, this.valueSvc = e.valueSvc;
  }
  getMergedParams(e) {
    const t = this.gos.get("defaultCsvExportParams");
    return Object.assign({}, t, e);
  }
  export(e) {
    if (this.isExportSuppressed()) {
      Z(51);
      return;
    }
    const t = this.getMergedParams(e), n = this.getData(t), o = new Blob(["\uFEFF", n], { type: "text/plain" }), s = typeof t.fileName == "function" ? t.fileName(ke(this.gos, {})) : t.fileName;
    K5(this.getFileName(s), o);
  }
  exportDataAsCsv(e) {
    this.export(e);
  }
  getDataAsCsv(e, t = !1) {
    const n = t ? Object.assign({}, e) : this.getMergedParams(e);
    return this.getData(n);
  }
  getDefaultFileExtension() {
    return "csv";
  }
  createSerializingSession(e) {
    const { colModel: t, colNames: n, rowGroupColsSvc: o, valueSvc: s, gos: i } = this, {
      processCellCallback: r,
      processHeaderCallback: a,
      processGroupHeaderCallback: l,
      processRowGroupCallback: d,
      suppressQuotes: c,
      columnSeparator: u
    } = e;
    return new aH({
      colModel: t,
      colNames: n,
      valueSvc: s,
      gos: i,
      processCellCallback: r || void 0,
      processHeaderCallback: a || void 0,
      processGroupHeaderCallback: l || void 0,
      processRowGroupCallback: d || void 0,
      suppressQuotes: c || !1,
      columnSeparator: u || ",",
      rowGroupColsSvc: o
    });
  }
  isExportSuppressed() {
    return this.gos.get("suppressCsvExport");
  }
};
function dH(e, t) {
  var n;
  return (n = e.csvCreator) == null ? void 0 : n.getDataAsCsv(t);
}
function cH(e, t) {
  var n;
  (n = e.csvCreator) == null || n.exportDataAsCsv(t);
}
var uH = {
  moduleName: "CsvExport",
  version: Ee,
  beans: [lH],
  apiFunctions: {
    getDataAsCsv: dH,
    exportDataAsCsv: cH
  },
  dependsOn: [rH]
}, hH = class extends U {
  constructor(e, t, n) {
    super(), this.id = e, this.parentCache = t, this.params = n, this.state = "needsLoading", this.version = 0, this.startRow = e * n.blockSize, this.endRow = this.startRow + n.blockSize;
  }
  load() {
    this.state = "loading", this.loadFromDatasource();
  }
  setStateWaitingToLoad() {
    this.version++, this.state = "needsLoading";
  }
  pageLoadFailed(e) {
    this.isRequestMostRecentAndLive(e) && (this.state = "failed"), this.dispatchLocalEvent({ type: "loadComplete" });
  }
  pageLoaded(e, t, n) {
    this.successCommon(e, { rowData: t, rowCount: n });
  }
  isRequestMostRecentAndLive(e) {
    const t = e === this.version, n = this.isAlive();
    return t && n;
  }
  successCommon(e, t) {
    this.dispatchLocalEvent({ type: "loadComplete" }), this.isRequestMostRecentAndLive(e) && (this.state = "loaded", this.processServerResult(t));
  }
  postConstruct() {
    this.rowNodes = [];
    const {
      params: { blockSize: e, rowHeight: t },
      startRow: n,
      beans: o,
      rowNodes: s
    } = this;
    for (let i = 0; i < e; i++) {
      const r = n + i, a = new Ln(o);
      a.setRowHeight(t), a.uiLevel = 0, a.setRowIndex(r), a.setRowTop(t * r), s.push(a);
    }
  }
  getBlockStateJson() {
    const { id: e, startRow: t, endRow: n, state: o } = this;
    return {
      id: "" + e,
      state: {
        blockNumber: e,
        startRow: t,
        endRow: n,
        pageStatus: o
      }
    };
  }
  setDataAndId(e, t, n) {
    ue(t) ? e.setDataAndId(t, n.toString()) : e.setDataAndId(void 0, void 0);
  }
  loadFromDatasource() {
    const e = this.createLoadParams();
    if (st(this.params.datasource.getRows)) {
      Z(90);
      return;
    }
    window.setTimeout(() => {
      this.params.datasource.getRows(e);
    }, 0);
  }
  createLoadParams() {
    const {
      startRow: e,
      endRow: t,
      version: n,
      params: { sortModel: o, filterModel: s },
      gos: i
    } = this;
    return {
      startRow: e,
      endRow: t,
      successCallback: this.pageLoaded.bind(this, n),
      failCallback: this.pageLoadFailed.bind(this, n),
      sortModel: o,
      filterModel: s,
      context: ke(i, {}).context
    };
  }
  forEachNode(e, t, n) {
    this.rowNodes.forEach((o, s) => {
      this.startRow + s < n && e(o, t.value++);
    });
  }
  getRow(e, t = !1) {
    t || (this.lastAccessed = this.params.lastAccessedSequence.value++);
    const n = e - this.startRow;
    return this.rowNodes[n];
  }
  processServerResult(e) {
    const { rowNodes: t, beans: n } = this;
    t.forEach((s, i) => {
      const r = e.rowData ? e.rowData[i] : void 0;
      !s.id && s.alreadyRendered && r && (t[i] = new Ln(n), t[i].setRowIndex(s.rowIndex), t[i].setRowTop(s.rowTop), t[i].setRowHeight(s.rowHeight), s.clearRowTopAndRowIndex()), this.setDataAndId(t[i], r, this.startRow + i);
    });
    const o = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
    this.parentCache.pageLoaded(this, o);
  }
  destroy() {
    this.rowNodes.forEach((e) => {
      e.clearRowTopAndRowIndex();
    }), super.destroy();
  }
}, gH = 2, pH = class extends U {
  constructor(e) {
    super(), this.params = e, this.lastRowIndexKnown = !1, this.blocks = {}, this.blockCount = 0, this.rowCount = e.initialRowCount;
  }
  // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
  // it will want new pages in the cache as it asks for rows. only when we are inserting /
  // removing rows via the api is dontCreatePage set, where we move rows between the pages.
  getRow(e, t = !1) {
    const n = Math.floor(e / this.params.blockSize);
    let o = this.blocks[n];
    if (!o) {
      if (t)
        return;
      o = this.createBlock(n);
    }
    return o.getRow(e);
  }
  createBlock(e) {
    const t = this.params, n = this.createBean(new hH(e, this, t));
    return this.blocks[n.id] = n, this.blockCount++, this.purgeBlocksIfNeeded(n), t.rowNodeBlockLoader.addBlock(n), n;
  }
  // we have this on infinite row model only, not server side row model,
  // because for server side, it would leave the children in inconsistent
  // state - eg if a node had children, but after the refresh it had data
  // for a different row, then the children would be with the wrong row node.
  refreshCache() {
    if (this.blockCount == 0) {
      this.purgeCache();
      return;
    }
    this.getBlocksInOrder().forEach((t) => t.setStateWaitingToLoad()), this.params.rowNodeBlockLoader.checkBlockToLoad();
  }
  destroy() {
    this.getBlocksInOrder().forEach((e) => this.destroyBlock(e)), super.destroy();
  }
  getRowCount() {
    return this.rowCount;
  }
  isLastRowIndexKnown() {
    return this.lastRowIndexKnown;
  }
  // block calls this, when page loaded
  pageLoaded(e, t) {
    this.isAlive() && (Is(this.gos, `InfiniteCache - onPageLoaded: page = ${e.id}, lastRow = ${t}`), this.checkRowCount(e, t), this.onCacheUpdated());
  }
  purgeBlocksIfNeeded(e) {
    const t = this.getBlocksInOrder().filter((r) => r != e), n = (r, a) => a.lastAccessed - r.lastAccessed;
    t.sort(n);
    const o = this.params.maxBlocksInCache > 0, s = o ? this.params.maxBlocksInCache - 1 : null, i = gH - 1;
    t.forEach((r, a) => {
      const l = r.state === "needsLoading" && a >= i, d = o ? a >= s : !1;
      if (l || d) {
        if (this.isBlockCurrentlyDisplayed(r) || this.isBlockFocused(r))
          return;
        this.removeBlockFromCache(r);
      }
    });
  }
  isBlockFocused(e) {
    const t = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
    if (!t || t.rowPinned != null)
      return !1;
    const { startRow: n, endRow: o } = e;
    return t.rowIndex >= n && t.rowIndex < o;
  }
  isBlockCurrentlyDisplayed(e) {
    const { startRow: t, endRow: n } = e;
    return this.beans.rowRenderer.isRangeInRenderedViewport(t, n - 1);
  }
  removeBlockFromCache(e) {
    e && this.destroyBlock(e);
  }
  checkRowCount(e, t) {
    if (typeof t == "number" && t >= 0)
      this.rowCount = t, this.lastRowIndexKnown = !0;
    else if (!this.lastRowIndexKnown) {
      const { blockSize: n, overflowSize: o } = this.params, i = (e.id + 1) * n + o;
      this.rowCount < i && (this.rowCount = i);
    }
  }
  setRowCount(e, t) {
    this.rowCount = e, ue(t) && (this.lastRowIndexKnown = t), this.lastRowIndexKnown || this.rowCount % this.params.blockSize === 0 && this.rowCount++, this.onCacheUpdated();
  }
  forEachNodeDeep(e) {
    const t = { value: 0 };
    this.getBlocksInOrder().forEach((n) => n.forEachNode(e, t, this.rowCount));
  }
  getBlocksInOrder() {
    const e = (n, o) => n.id - o.id;
    return Object.values(this.blocks).sort(e);
  }
  destroyBlock(e) {
    delete this.blocks[e.id], this.destroyBean(e), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(e);
  }
  // gets called 1) row count changed 2) cache purged 3) items inserted
  onCacheUpdated() {
    this.isAlive() && (this.destroyAllBlocksPastVirtualRowCount(), this.eventSvc.dispatchEvent({
      type: "storeUpdated"
    }));
  }
  destroyAllBlocksPastVirtualRowCount() {
    const e = [];
    this.getBlocksInOrder().forEach((t) => {
      t.id * this.params.blockSize >= this.rowCount && e.push(t);
    }), e.length > 0 && e.forEach((t) => this.destroyBlock(t));
  }
  purgeCache() {
    this.getBlocksInOrder().forEach((e) => this.removeBlockFromCache(e)), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
  }
  getRowNodesInRange(e, t) {
    const n = [];
    let o = -1, s = !1;
    const i = { value: 0 };
    let r = !1;
    return this.getBlocksInOrder().forEach((l) => {
      if (!r) {
        if (s && o + 1 !== l.id) {
          r = !0;
          return;
        }
        o = l.id, l.forEachNode(
          (d) => {
            const c = d === e || d === t;
            (s || c) && n.push(d), c && (s = !s);
          },
          i,
          this.rowCount
        );
      }
    }), r || s ? [] : n;
  }
}, fH = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowModel";
  }
  getRowBounds(e) {
    return {
      rowHeight: this.rowHeight,
      rowTop: this.rowHeight * e
    };
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid() {
    return !1;
  }
  postConstruct() {
    this.gos.get("rowModelType") === "infinite" && (this.rowHeight = Kn(this.beans), this.addEventListeners(), this.addDestroyFunc(() => this.destroyCache()));
  }
  start() {
    this.setDatasource(this.gos.get("datasource"));
  }
  destroy() {
    this.destroyDatasource(), super.destroy();
  }
  destroyDatasource() {
    this.datasource && (this.destroyBean(this.datasource), this.beans.rowRenderer.datasourceChanged(), this.datasource = null);
  }
  addEventListeners() {
    this.addManagedEventListeners({
      filterChanged: this.reset.bind(this),
      sortChanged: this.reset.bind(this),
      newColumnsLoaded: this.onColumnEverything.bind(this),
      storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
    }), this.addManagedPropertyListener("datasource", () => this.setDatasource(this.gos.get("datasource"))), this.addManagedPropertyListener("cacheBlockSize", () => this.resetCache()), this.addManagedPropertyListener("rowHeight", () => {
      this.rowHeight = Kn(this.beans), this.cacheParams.rowHeight = this.rowHeight, this.updateRowHeights();
    });
  }
  onColumnEverything() {
    var t;
    let e;
    this.cacheParams ? e = !pr(this.cacheParams.sortModel, ((t = this.beans.sortSvc) == null ? void 0 : t.getSortModel()) ?? []) : e = !0, e && this.reset();
  }
  getType() {
    return "infinite";
  }
  setDatasource(e) {
    this.destroyDatasource(), this.datasource = e, e && this.reset();
  }
  isEmpty() {
    return !this.infiniteCache;
  }
  isRowsToRender() {
    return !!this.infiniteCache;
  }
  getNodesInRangeForSelection(e, t) {
    var n;
    return ((n = this.infiniteCache) == null ? void 0 : n.getRowNodesInRange(e, t)) ?? [];
  }
  reset() {
    var n;
    if (!this.datasource)
      return;
    Jo(this.gos) != null || (n = this.beans.selectionSvc) == null || n.reset("rowDataChanged"), this.resetCache();
  }
  dispatchModelUpdatedEvent() {
    this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      // not sure if these should all be false - noticed if after implementing,
      // maybe they should be true?
      newPage: !1,
      newPageSize: !1,
      newData: !1,
      keepRenderedRows: !0,
      animate: !1
    });
  }
  resetCache() {
    this.destroyCache();
    const e = this.beans, { filterManager: t, sortSvc: n, rowNodeBlockLoader: o, eventSvc: s, gos: i } = e;
    this.cacheParams = {
      // the user provided datasource
      datasource: this.datasource,
      // sort and filter model
      filterModel: (t == null ? void 0 : t.getFilterModel()) ?? {},
      sortModel: (n == null ? void 0 : n.getSortModel()) ?? [],
      rowNodeBlockLoader: o,
      // properties - this way we take a snapshot of them, so if user changes any, they will be
      // used next time we create a new cache, which is generally after a filter or sort change,
      // or a new datasource is set
      initialRowCount: i.get("infiniteInitialRowCount"),
      maxBlocksInCache: i.get("maxBlocksInCache"),
      rowHeight: Kn(e),
      // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
      // the current page and request first row of next page
      overflowSize: i.get("cacheOverflowSize"),
      // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
      // server for one page at a time. so the default if not specified is 100.
      blockSize: i.get("cacheBlockSize"),
      // the cache could create this, however it is also used by the pages, so handy to create it
      // here as the settings are also passed to the pages
      lastAccessedSequence: { value: 0 }
    }, this.infiniteCache = this.createBean(new pH(this.cacheParams)), s.dispatchEventOnce({
      type: "rowCountReady"
    }), this.dispatchModelUpdatedEvent();
  }
  updateRowHeights() {
    this.forEachNode((e) => {
      e.setRowHeight(this.rowHeight), e.setRowTop(this.rowHeight * e.rowIndex);
    }), this.dispatchModelUpdatedEvent();
  }
  destroyCache() {
    this.infiniteCache = this.destroyBean(this.infiniteCache);
  }
  getRow(e) {
    const t = this.infiniteCache;
    if (t && !(e >= t.getRowCount()))
      return t.getRow(e);
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((n) => {
      n.id === e && (t = n);
    }), t;
  }
  forEachNode(e) {
    var t;
    (t = this.infiniteCache) == null || t.forEachNodeDeep(e);
  }
  getTopLevelRowCount() {
    return this.getRowCount();
  }
  getTopLevelRowDisplayedIndex(e) {
    return e;
  }
  getRowIndexAtPixel(e) {
    if (this.rowHeight !== 0) {
      const t = Math.floor(e / this.rowHeight), n = this.getRowCount() - 1;
      return t > n ? n : t;
    }
    return 0;
  }
  getRowCount() {
    return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  refreshCache() {
    var e;
    (e = this.infiniteCache) == null || e.refreshCache();
  }
  purgeCache() {
    var e;
    (e = this.infiniteCache) == null || e.purgeCache();
  }
  // for iRowModel
  isLastRowIndexKnown() {
    var e;
    return ((e = this.infiniteCache) == null ? void 0 : e.isLastRowIndexKnown()) ?? !1;
  }
  setRowCount(e, t) {
    var n;
    (n = this.infiniteCache) == null || n.setRowCount(e, t);
  }
  resetRowHeights() {
  }
  onRowHeightChanged() {
  }
};
function mH(e) {
  var t;
  (t = Ec(e)) == null || t.refreshCache();
}
function vH(e) {
  var t;
  (t = Ec(e)) == null || t.purgeCache();
}
function CH(e) {
  var t;
  return (t = Ec(e)) == null ? void 0 : t.getRowCount();
}
var wH = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowNodeBlockLoader", this.activeBlockLoadsCount = 0, this.blocks = [], this.active = !0;
  }
  postConstruct() {
    this.maxConcurrentRequests = TC(this.gos);
    const e = this.gos.get("blockLoadDebounceMillis");
    e && e > 0 && (this.checkBlockToLoadDebounce = Lt(
      this,
      this.performCheckBlocksToLoad.bind(this),
      e
    ));
  }
  addBlock(e) {
    this.blocks.push(e), e.addEventListener("loadComplete", this.loadComplete.bind(this)), this.checkBlockToLoad();
  }
  removeBlock(e) {
    $t(this.blocks, e);
  }
  destroy() {
    super.destroy(), this.active = !1;
  }
  loadComplete() {
    this.activeBlockLoadsCount--, this.checkBlockToLoad();
  }
  checkBlockToLoad() {
    this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
  }
  performCheckBlocksToLoad() {
    if (!this.active)
      return;
    if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
      Is(this.gos, "RowNodeBlockLoader - checkBlockToLoad: max loads exceeded");
      return;
    }
    const e = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1, t = this.blocks.filter((n) => n.state === "needsLoading").slice(0, e);
    this.activeBlockLoadsCount += t.length, t.forEach((n) => n.load()), this.printCacheStatus();
  }
  getBlockState() {
    const e = {};
    return this.blocks.forEach((t) => {
      const { id: n, state: o } = t.getBlockStateJson();
      e[n] = o;
    }), e;
  }
  printCacheStatus() {
    Is(
      this.gos,
      `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`
    );
  }
}, yH = {
  moduleName: "InfiniteRowModelCore",
  version: Ee,
  rowModels: ["infinite"],
  beans: [fH, wH]
}, bH = {
  moduleName: "InfiniteRowModel",
  version: Ee,
  apiFunctions: {
    refreshInfiniteCache: mH,
    purgeInfiniteCache: vH,
    getInfiniteRowCount: CH
  },
  dependsOn: [yH, ub]
}, SH = "↑", xH = "↓", RH = {
  tag: "span",
  children: [
    { tag: "span", ref: "eDelta", cls: "ag-value-change-delta" },
    { tag: "span", ref: "eValue", cls: "ag-value-change-value" }
  ]
}, EH = class extends Te {
  constructor() {
    super(RH), this.eValue = X, this.eDelta = X, this.refreshCount = 0;
  }
  init(e) {
    this.refresh(e, !0);
  }
  showDelta(e, t) {
    const n = Math.abs(t), o = e.formatValue(n), s = ue(o) ? o : n, i = t >= 0, r = this.eDelta;
    i ? r.textContent = SH + s : r.textContent = xH + s, r.classList.toggle("ag-value-change-delta-up", i), r.classList.toggle("ag-value-change-delta-down", !i);
  }
  setTimerToRemoveDelta() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.hideDeltaValue();
      }, 2e3);
    });
  }
  hideDeltaValue() {
    this.eValue.classList.remove("ag-value-change-value-highlight"), ht(this.eDelta);
  }
  refresh(e, t = !1) {
    var d;
    const { value: n, valueFormatted: o } = e, { eValue: s, lastValue: i, beans: r } = this;
    if (n === i || (ue(o) ? s.textContent = o : ue(n) ? s.textContent = n : ht(s), (d = r.filterManager) != null && d.isSuppressFlashingCellsBecauseFiltering()))
      return !1;
    const a = n && typeof n == "object" && "toNumber" in n ? n.toNumber() : n, l = i && typeof i == "object" && "toNumber" in i ? i.toNumber() : i;
    if (a === l)
      return !1;
    if (typeof a == "number" && typeof l == "number") {
      const c = a - l;
      this.showDelta(e, c);
    }
    return i && s.classList.add("ag-value-change-value-highlight"), t || this.setTimerToRemoveDelta(), this.lastValue = n, !0;
  }
}, AH = (
  /*css*/
  ".ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}"
), FH = {
  tag: "span",
  children: [{ tag: "span", ref: "eCurrent", cls: "ag-value-slide-current" }]
}, MH = class extends Te {
  constructor() {
    super(FH), this.eCurrent = X, this.refreshCount = 0, this.registerCSS(AH);
  }
  init(e) {
    this.refresh(e, !0);
  }
  addSlideAnimation() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.ePrevious && this.getGui().removeChild(this.ePrevious);
    const { beans: t, eCurrent: n } = this, o = Ue({ tag: "span", cls: "ag-value-slide-previous ag-value-slide-out" });
    this.ePrevious = o, o.textContent = n.textContent, this.getGui().insertBefore(o, n), t.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(() => {
        e === this.refreshCount && (this.getGui().removeChild(this.ePrevious), this.ePrevious = null);
      }, 3e3);
    });
  }
  refresh(e, t = !1) {
    var s;
    let n = e.value;
    if (st(n) && (n = ""), n === this.lastValue || (s = this.beans.filterManager) != null && s.isSuppressFlashingCellsBecauseFiltering())
      return !1;
    t || this.addSlideAnimation(), this.lastValue = n;
    const o = this.eCurrent;
    return ue(e.valueFormatted) ? o.textContent = e.valueFormatted : ue(e.value) ? o.textContent = n : ht(o), !0;
  }
}, IH = class extends U {
  constructor() {
    super(...arguments), this.beanName = "cellFlashSvc", this.nextAnimationTime = null, this.nextAnimationCycle = null, this.animations = {
      highlight: /* @__PURE__ */ new Map(),
      "data-changed": /* @__PURE__ */ new Map()
    };
  }
  animateCell(e, t, n = this.beans.gos.get("cellFlashDuration"), o = this.beans.gos.get("cellFadeDuration")) {
    const s = this.animations[t];
    s.delete(e);
    const i = Date.now(), r = i + n, a = i + n + o, l = {
      phase: "flash",
      flashEndTime: r,
      fadeEndTime: a
    };
    s.set(e, l);
    const d = `ag-cell-${t}`, c = `${d}-animation`, {
      comp: u,
      eGui: { style: h }
    } = e;
    u.toggleCss(d, !0), u.toggleCss(c, !1), h.removeProperty("transition"), h.removeProperty("transition-delay"), this.nextAnimationTime && r + 15 < this.nextAnimationTime && (clearTimeout(this.nextAnimationCycle), this.nextAnimationCycle = null, this.nextAnimationTime = null), this.nextAnimationCycle || (this.beans.frameworkOverrides.wrapIncoming(() => {
      this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), n);
    }), this.nextAnimationTime = r);
  }
  advanceAnimations() {
    const e = Date.now();
    let t = null;
    for (const n of Object.keys(this.animations)) {
      const o = this.animations[n], s = `ag-cell-${n}`, i = `${s}-animation`;
      for (const [r, a] of o) {
        if (!r.isAlive() || !r.comp) {
          o.delete(r);
          continue;
        }
        const { phase: l, flashEndTime: d, fadeEndTime: c } = a, u = l === "flash" ? d : c;
        if (!(e + 15 >= u)) {
          t = Math.min(u, t ?? 1 / 0);
          continue;
        }
        const {
          comp: g,
          eGui: { style: p }
        } = r;
        switch (l) {
          case "flash":
            g.toggleCss(s, !1), g.toggleCss(i, !0), p.transition = `background-color ${c - d}ms`, p.transitionDelay = `${d - e}ms`, t = Math.min(c, t ?? 1 / 0), a.phase = "fade";
            break;
          case "fade":
            g.toggleCss(s, !1), g.toggleCss(i, !1), p.removeProperty("transition"), p.removeProperty("transition-delay"), o.delete(r);
            break;
        }
      }
    }
    t == null ? (this.nextAnimationTime = null, this.nextAnimationCycle = null) : t && (this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), t - e), this.nextAnimationTime = t);
  }
  onFlashCells(e, t) {
    if (!e.comp)
      return;
    const n = TD(e.cellPosition);
    t.cells[n] && this.animateCell(e, "highlight");
  }
  flashCell(e, t) {
    this.animateCell(e, "data-changed", t == null ? void 0 : t.flashDuration, t == null ? void 0 : t.fadeDuration);
  }
  destroy() {
    for (const e of Object.keys(this.animations))
      this.animations[e].clear();
  }
};
function PH(e, t = {}) {
  const { cellFlashSvc: n } = e;
  n && e.frameworkOverrides.wrapIncoming(() => {
    e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((o) => n.flashCell(o, t));
  });
}
var DH = {
  moduleName: "HighlightChanges",
  version: Ee,
  beans: [IH],
  userComponents: {
    agAnimateShowChangeCellRenderer: EH,
    agAnimateSlideCellRenderer: MH
  },
  apiFunctions: {
    flashCells: PH
  }
};
function TH(e) {
  var t;
  return ((t = e.stateSvc) == null ? void 0 : t.getState()) ?? {};
}
function kH(e, t, n) {
  var o;
  return (o = e.stateSvc) == null ? void 0 : o.setState(t, n);
}
function f0(e) {
  switch (e = { ...e }, e.version || (e.version = "32.1.0"), e.version) {
    case "32.1.0":
      e = LH(e);
  }
  return e.version = Ee, e;
}
function LH(e) {
  return e.cellSelection = BH(e, "rangeSelection"), e;
}
function BH(e, t) {
  if (e && typeof e == "object")
    return e[t];
}
var OH = class extends U {
  constructor() {
    super(...arguments), this.beanName = "stateSvc", this.updateRowGroupExpansionStateTimer = 0, this.suppressEvents = !0, this.queuedUpdateSources = /* @__PURE__ */ new Set(), this.dispatchStateUpdateEventDebounced = Lt(this, () => this.dispatchQueuedStateUpdateEvents(), 0), this.onRowGroupOpenedDebounced = Lt(
      this,
      () => {
        this.beans.gos.get("ssrmExpandAllAffectsAllRows") ? (this.updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("rowGroupExpansion", void 0)) : (this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("ssrmRowGroupExpansion", void 0));
      },
      0
    ), this.onRowSelectedDebounced = Lt(
      this,
      () => {
        this.staleStateKeys.delete("rowSelection"), this.updateCachedState("rowSelection", this.getRowSelectionState());
      },
      0
    ), this.staleStateKeys = /* @__PURE__ */ new Set();
  }
  postConstruct() {
    const { gos: e, ctrlsSvc: t, colDelayRenderSvc: n } = this.beans;
    this.isClientSideRowModel = Ct(e);
    const o = f0(e.get("initialState") ?? {}), s = o.partialColumnState;
    delete o.partialColumnState, this.cachedState = o;
    const i = this.suppressEventsAndDispatchInitEvent.bind(this);
    t.whenReady(
      this,
      () => i(() => this.setupStateOnGridReady(o))
    ), (o.columnOrder || o.columnVisibility || o.columnSizing || o.columnPinning || o.columnGroup) && (n == null || n.hideColumns("columnState"));
    const [r, a, l] = this.addManagedEventListeners({
      newColumnsLoaded: ({ source: d }) => {
        d === "gridInitializing" && (r(), i(() => {
          this.setupStateOnColumnsInitialised(o, !!s), n == null || n.revealColumns("columnState");
        }));
      },
      rowCountReady: () => {
        a == null || a(), i(() => this.setupStateOnRowCountReady(o));
      },
      firstDataRendered: () => {
        l == null || l(), i(() => this.setupStateOnFirstDataRendered(o));
      }
    });
  }
  destroy() {
    super.destroy(), clearTimeout(this.updateRowGroupExpansionStateTimer), this.queuedUpdateSources.clear();
  }
  getState() {
    return this.staleStateKeys.size && this.refreshStaleState(), this.cachedState;
  }
  setState(e, t) {
    const n = f0(e);
    delete n.partialColumnState, this.cachedState = n, this.startSuppressEvents();
    const o = "api", s = t ? new Set(t) : void 0;
    this.setGridReadyState(n, o, s), this.setColumnsInitialisedState(n, o, !1, s), this.setRowCountState(n, o, s), setTimeout(() => {
      this.isAlive() && this.setFirstDataRenderedState(n, o, s), this.stopSuppressEvents(o);
    });
  }
  setGridReadyState(e, t, n) {
    var o, s;
    t === "api" && !(n != null && n.has("sideBar")) && ((s = (o = this.beans.sideBar) == null ? void 0 : o.comp) == null || s.setState(e.sideBar)), this.updateCachedState("sideBar", this.getSideBarState());
  }
  setupStateOnGridReady(e) {
    this.setGridReadyState(e, "gridInitializing");
    const t = () => this.updateCachedState("sideBar", this.getSideBarState());
    this.addManagedEventListeners({
      toolPanelVisibleChanged: t,
      sideBarUpdated: t
    });
  }
  updateColumnAndGroupState() {
    this.updateColumnState([
      "aggregation",
      "columnOrder",
      "columnPinning",
      "columnSizing",
      "columnVisibility",
      "pivot",
      "rowGroup",
      "sort"
    ]), this.updateCachedState("columnGroup", this.getColumnGroupState());
  }
  setColumnsInitialisedState(e, t, n, o) {
    this.setColumnState(e, t, n, o), this.setColumnGroupState(e, t, o), this.updateColumnAndGroupState();
  }
  setupStateOnColumnsInitialised(e, t) {
    this.setColumnsInitialisedState(e, "gridInitializing", t);
    const n = (o) => () => this.updateColumnState([o]);
    this.addManagedEventListeners({
      columnValueChanged: n("aggregation"),
      columnMoved: n("columnOrder"),
      columnPinned: n("columnPinning"),
      columnResized: n("columnSizing"),
      columnVisible: n("columnVisibility"),
      columnPivotChanged: n("pivot"),
      columnPivotModeChanged: n("pivot"),
      columnRowGroupChanged: n("rowGroup"),
      sortChanged: n("sort"),
      newColumnsLoaded: this.updateColumnAndGroupState.bind(this),
      columnGroupOpened: () => this.updateCachedState("columnGroup", this.getColumnGroupState())
    });
  }
  setRowCountState(e, t, n) {
    const {
      filter: o,
      rowGroupExpansion: s,
      ssrmRowGroupExpansion: i,
      rowSelection: r,
      pagination: a
    } = e, l = (c, u) => !(n != null && n.has(c)) && (u || t === "api");
    l("filter", o) && this.setFilterState(o), l("rowGroupExpansion", s) && this.setRowGroupExpansionState(i, s, t), l("rowSelection", r) && this.setRowSelectionState(r, t), l("pagination", a) && this.setPaginationState(a, t);
    const d = this.updateCachedState.bind(this);
    d("filter", this.getFilterState()), this.beans.gos.get("ssrmExpandAllAffectsAllRows") ? (d("ssrmRowGroupExpansion", this.getRowGroupExpansionState()), d("rowGroupExpansion", void 0)) : (d("rowGroupExpansion", this.getRowGroupExpansionState()), d("ssrmRowGroupExpansion", void 0)), d("rowSelection", this.getRowSelectionState()), d("pagination", this.getPaginationState());
  }
  setupStateOnRowCountReady(e) {
    this.setRowCountState(e, "gridInitializing");
    const t = this.updateCachedState.bind(this), n = () => {
      this.updateRowGroupExpansionStateTimer = 0, this.beans.gos.get("ssrmExpandAllAffectsAllRows") ? (t("ssrmRowGroupExpansion", this.getRowGroupExpansionState()), t("rowGroupExpansion", void 0)) : (t("rowGroupExpansion", this.getRowGroupExpansionState()), t("ssrmRowGroupExpansion", void 0));
    }, o = () => t("filter", this.getFilterState()), { gos: s, colFilter: i } = this.beans;
    this.addManagedEventListeners({
      filterChanged: o,
      rowExpansionStateChanged: this.onRowGroupOpenedDebounced,
      expandOrCollapseAll: n,
      // `groupDefaultExpanded`/`isGroupOpenByDefault` updates expansion state without an expansion event
      columnRowGroupChanged: n,
      rowDataUpdated: () => {
        (s.get("groupDefaultExpanded") !== 0 || s.get("isGroupOpenByDefault")) && (this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(n)));
      },
      selectionChanged: () => {
        this.staleStateKeys.add("rowSelection"), this.onRowSelectedDebounced();
      },
      paginationChanged: (r) => {
        (r.newPage || r.newPageSize) && t("pagination", this.getPaginationState());
      }
    }), i && this.addManagedListeners(i, {
      filterStateChanged: o
    });
  }
  setFirstDataRenderedState(e, t, n) {
    const {
      scroll: o,
      cellSelection: s,
      focusedCell: i,
      columnOrder: r,
      rowPinning: a
    } = e, l = (u, h) => !(n != null && n.has(u)) && (h || t === "api");
    l("focusedCell", i) && this.setFocusedCellState(i), l("cellSelection", s) && this.setCellSelectionState(s), l("scroll", o) && this.setScrollState(o), l("rowPinning", a) && this.setRowPinningState(a), this.setColumnPivotState(!!(r != null && r.orderedColIds), t);
    const d = this.updateCachedState.bind(this);
    d("sideBar", this.getSideBarState()), d("focusedCell", this.getFocusedCellState());
    const c = this.getRangeSelectionState();
    d("rangeSelection", c), d("cellSelection", c), d("scroll", this.getScrollState());
  }
  setupStateOnFirstDataRendered(e) {
    this.setFirstDataRenderedState(e, "gridInitializing");
    const t = this.updateCachedState.bind(this), n = () => t("focusedCell", this.getFocusedCellState());
    this.addManagedEventListeners({
      cellFocused: n,
      cellFocusCleared: n,
      cellSelectionChanged: (o) => {
        if (o.finished) {
          const s = this.getRangeSelectionState();
          t("rangeSelection", s), t("cellSelection", s);
        }
      },
      bodyScrollEnd: () => t("scroll", this.getScrollState()),
      pinnedRowsChanged: () => t("rowPinning", this.getRowPinningState())
    });
  }
  getColumnState() {
    const e = this.beans;
    return _5(Ed(e), e.colModel.isPivotMode());
  }
  setColumnState(e, t, n, o) {
    const {
      sort: s,
      rowGroup: i,
      aggregation: r,
      pivot: a,
      columnPinning: l,
      columnVisibility: d,
      columnSizing: c,
      columnOrder: u
    } = e;
    let h = !1;
    const g = (k, B) => {
      const j = !(o != null && o.has(k)) && !!(B || t === "api");
      return h || (h = j), j;
    }, p = {}, f = (k) => {
      let B = p[k];
      return B || (B = { colId: k }, p[k] = B, B);
    }, m = {}, C = g("sort", s);
    C && (s == null || s.sortModel.forEach(({ colId: k, sort: B }, j) => {
      const N = f(k);
      N.sort = B, N.sortIndex = j;
    })), (C || !n) && (m.sort = null, m.sortIndex = null);
    const w = g("rowGroup", i);
    w && (i == null || i.groupColIds.forEach((k, B) => {
      const j = f(k);
      j.rowGroup = !0, j.rowGroupIndex = B;
    })), (w || !n) && (m.rowGroup = null, m.rowGroupIndex = null);
    const b = g("aggregation", r);
    b && (r == null || r.aggregationModel.forEach(({ colId: k, aggFunc: B }) => {
      f(k).aggFunc = B;
    })), (b || !n) && (m.aggFunc = null);
    const A = g("pivot", a);
    A && (a == null || a.pivotColIds.forEach((k, B) => {
      const j = f(k);
      j.pivot = !0, j.pivotIndex = B;
    }), this.gos.updateGridOptions({
      options: { pivotMode: !!(a != null && a.pivotMode) },
      source: t
    })), (A || !n) && (m.pivot = null, m.pivotIndex = null);
    const S = g("columnPinning", l);
    S && (l == null || l.leftColIds.forEach((k) => {
      f(k).pinned = "left";
    }), l == null || l.rightColIds.forEach((k) => {
      f(k).pinned = "right";
    })), (S || !n) && (m.pinned = null);
    const F = g("columnVisibility", d);
    F && (d == null || d.hiddenColIds.forEach((k) => {
      f(k).hide = !0;
    })), (F || !n) && (m.hide = null);
    const E = g("columnSizing", c);
    E && (c == null || c.columnSizingModel.forEach(({ colId: k, flex: B, width: j }) => {
      const N = f(k);
      N.flex = B ?? null, N.width = j;
    })), (E || !n) && (m.flex = null);
    const M = u == null ? void 0 : u.orderedColIds, I = !!(M != null && M.length) && !(o != null && o.has("columnOrder")), P = I ? M.map((k) => f(k)) : Object.values(p);
    (P.length || h) && (this.columnStates = P, cn(
      this.beans,
      {
        state: P,
        applyOrder: I,
        defaultState: m
      },
      t
    ));
  }
  setColumnPivotState(e, t) {
    const n = this.columnStates;
    this.columnStates = void 0;
    const o = this.columnGroupStates;
    this.columnGroupStates = void 0;
    const s = this.beans, { pivotResultCols: i, colGroupSvc: r } = s;
    if (i != null && i.isPivotResultColsPresent()) {
      if (n) {
        const a = [];
        for (const l of n)
          i.getPivotResultCol(l.colId) && a.push(l);
        cn(
          s,
          {
            state: a,
            applyOrder: e
          },
          t
        );
      }
      o && (r == null || r.setColumnGroupState(o, t));
    }
  }
  getColumnGroupState() {
    const e = this.beans.colGroupSvc;
    if (!e)
      return;
    const t = e.getColumnGroupState();
    return N5(t);
  }
  setColumnGroupState(e, t, n) {
    var a;
    const o = this.beans.colGroupSvc;
    if (!o || n != null && n.has("columnGroup") || t !== "api" && !Object.prototype.hasOwnProperty.call(e, "columnGroup"))
      return;
    const s = new Set((a = e.columnGroup) == null ? void 0 : a.openColumnGroupIds), r = o.getColumnGroupState().map(({ groupId: l }) => {
      const d = s.has(l);
      return d && s.delete(l), {
        groupId: l,
        open: d
      };
    });
    s.forEach((l) => {
      r.push({
        groupId: l,
        open: !0
      });
    }), r.length && (this.columnGroupStates = r), o.setColumnGroupState(r, t);
  }
  getFilterState() {
    const e = this.beans.filterManager;
    let t = e == null ? void 0 : e.getFilterModel();
    t && Object.keys(t).length === 0 && (t = void 0);
    const n = e == null ? void 0 : e.getFilterState(), o = (e == null ? void 0 : e.getAdvFilterModel()) ?? void 0;
    return t || o || n ? { filterModel: t, columnFilterState: n, advancedFilterModel: o } : void 0;
  }
  setFilterState(e) {
    const t = this.beans.filterManager, { filterModel: n, columnFilterState: o, advancedFilterModel: s } = e ?? {
      filterModel: null,
      columnFilterState: null,
      advancedFilterModel: null
    };
    (n !== void 0 || o !== void 0) && (t == null || t.setFilterState(n ?? null, o ?? null, "columnFilter")), s !== void 0 && (t == null || t.setAdvFilterModel(s ?? null, "advancedFilter"));
  }
  getRangeSelectionState() {
    var t;
    const e = (t = this.beans.rangeSvc) == null ? void 0 : t.getCellRanges().map((n) => {
      const { id: o, type: s, startRow: i, endRow: r, columns: a, startColumn: l } = n;
      return {
        id: o,
        type: s,
        startRow: i,
        endRow: r,
        colIds: a.map((d) => d.getColId()),
        startColId: l.getColId()
      };
    });
    return e != null && e.length ? { cellRanges: e } : void 0;
  }
  setCellSelectionState(e) {
    const { gos: t, rangeSvc: n, colModel: o, visibleCols: s } = this.beans;
    if (!Xo(t) || !n)
      return;
    const i = [];
    e == null || e.cellRanges.forEach((r) => {
      const a = [];
      if (r.colIds.forEach((d) => {
        const c = o.getCol(d);
        c && a.push(c);
      }), !a.length)
        return;
      let l = o.getCol(r.startColId);
      if (!l) {
        const d = s.allCols, c = new Set(a);
        l = d.find((u) => c.has(u));
      }
      i.push({
        ...r,
        columns: a,
        startColumn: l
      });
    }), n.setCellRanges(i);
  }
  getScrollState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature(), { left: t } = (e == null ? void 0 : e.getHScrollPosition()) ?? { left: 0 }, { top: n } = (e == null ? void 0 : e.getVScrollPosition()) ?? { top: 0 };
    return n || t ? {
      top: n,
      left: t
    } : void 0;
  }
  setScrollState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { top: t, left: n } = e ?? { top: 0, left: 0 }, { frameworkOverrides: o, rowRenderer: s, animationFrameSvc: i, ctrlsSvc: r } = this.beans;
    o.wrapIncoming(() => {
      var a;
      r.get("center").setCenterViewportScrollLeft(n), (a = r.getScrollFeature()) == null || a.setVerticalScrollPosition(t), s.redraw({ afterScroll: !0 }), i == null || i.flushAllFrames();
    });
  }
  getSideBarState() {
    var e, t;
    return (t = (e = this.beans.sideBar) == null ? void 0 : e.comp) == null ? void 0 : t.getState();
  }
  getFocusedCellState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.beans.focusSvc.getFocusedCell();
    if (e) {
      const { column: t, rowIndex: n, rowPinned: o } = e;
      return {
        colId: t.getColId(),
        rowIndex: n,
        rowPinned: o
      };
    }
  }
  setFocusedCellState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { focusSvc: t, colModel: n } = this.beans;
    if (!e) {
      t.clearFocusedCell();
      return;
    }
    const { colId: o, rowIndex: s, rowPinned: i } = e;
    t.setFocusedCell({
      column: n.getCol(o),
      rowIndex: s,
      rowPinned: i,
      forceBrowserFocus: !0,
      preventScrollOnBrowserFocus: !0
    });
  }
  getPaginationState() {
    const { pagination: e, gos: t } = this.beans;
    if (!e)
      return;
    const n = e.getCurrentPage(), o = t.get("paginationAutoPageSize") ? void 0 : e.getPageSize();
    if (!(!n && !o))
      return { page: n, pageSize: o };
  }
  setPaginationState(e, t) {
    const { pagination: n, gos: o } = this.beans;
    if (!n)
      return;
    const { pageSize: s, page: i } = e ?? { page: 0, pageSize: o.get("paginationPageSize") }, r = t === "gridInitializing";
    s && !o.get("paginationAutoPageSize") && n.setPageSize(s, r ? "initialState" : "pageSizeSelector"), typeof i == "number" && (r ? n.setPage(i) : n.goToPage(i));
  }
  getRowSelectionState() {
    var o;
    const e = this.beans.selectionSvc;
    if (!e)
      return;
    const t = e.getSelectionState();
    return !t || !Array.isArray(t) && (t.selectAll === !1 || t.selectAllChildren === !1) && !((o = t == null ? void 0 : t.toggledNodes) != null && o.length) ? void 0 : t;
  }
  setRowSelectionState(e, t) {
    var n;
    (n = this.beans.selectionSvc) == null || n.setSelectionState(e, t, t === "api");
  }
  getRowGroupExpansionState() {
    const { expansionSvc: e } = this.beans;
    if (e)
      return e.getExpansionState();
  }
  getRowPinningState() {
    var e;
    return (e = this.beans.pinnedRowModel) == null ? void 0 : e.getPinnedState();
  }
  setRowPinningState(e) {
    const t = this.beans.pinnedRowModel;
    e ? t == null || t.setPinnedState(e) : t == null || t.reset();
  }
  setRowGroupExpansionState(e, t, n) {
    const o = this.beans.expansionSvc;
    if (!o)
      return;
    const s = t ?? { expandedRowGroupIds: [], collapsedRowGroupIds: [] };
    o.setExpansionState(s, n);
  }
  updateColumnState(e) {
    const t = this.getColumnState();
    let n = !1;
    const o = this.cachedState;
    for (const s of Object.keys(t)) {
      const i = t[s];
      pr(i, o[s]) || (n = !0);
    }
    this.cachedState = {
      ...o,
      ...t
    }, n && this.dispatchStateUpdateEvent(e);
  }
  updateCachedState(e, t) {
    const n = this.cachedState[e];
    this.setCachedStateValue(e, t), pr(t, n) || this.dispatchStateUpdateEvent([e]);
  }
  setCachedStateValue(e, t) {
    this.cachedState = {
      ...this.cachedState,
      [e]: t
    };
  }
  refreshStaleState() {
    const e = this.staleStateKeys;
    e.forEach((t) => {
      switch (t) {
        case "rowSelection":
          this.setCachedStateValue(t, this.getRowSelectionState());
          break;
      }
    }), e.clear();
  }
  dispatchStateUpdateEvent(e) {
    this.suppressEvents || (e.forEach((t) => this.queuedUpdateSources.add(t)), this.dispatchStateUpdateEventDebounced());
  }
  dispatchQueuedStateUpdateEvents() {
    const e = this.queuedUpdateSources, t = Array.from(e);
    e.clear(), this.eventSvc.dispatchEvent({
      type: "stateUpdated",
      sources: t,
      state: this.cachedState
    });
  }
  startSuppressEvents() {
    var e;
    this.suppressEvents = !0, (e = this.beans.colAnimation) == null || e.setSuppressAnimation(!0);
  }
  stopSuppressEvents(e) {
    setTimeout(() => {
      var t;
      this.suppressEvents = !1, this.queuedUpdateSources.clear(), this.isAlive() && ((t = this.beans.colAnimation) == null || t.setSuppressAnimation(!1), this.dispatchStateUpdateEvent([e]));
    });
  }
  suppressEventsAndDispatchInitEvent(e) {
    this.startSuppressEvents(), e(), this.stopSuppressEvents("gridInitializing");
  }
}, GH = {
  moduleName: "GridState",
  version: Ee,
  beans: [OH],
  apiFunctions: {
    getState: TH,
    setState: kH
  }
};
function HH(e) {
  return e.rowModel.isLastRowIndexKnown();
}
function VH(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getPageSize()) ?? 100;
}
function _H(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getCurrentPage()) ?? 0;
}
function NH(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getTotalPages()) ?? 1;
}
function $H(e) {
  return e.pagination ? e.pagination.getMasterRowCount() : e.rowModel.getRowCount();
}
function zH(e) {
  var t;
  (t = e.pagination) == null || t.goToNextPage();
}
function WH(e) {
  var t;
  (t = e.pagination) == null || t.goToPreviousPage();
}
function UH(e) {
  var t;
  (t = e.pagination) == null || t.goToFirstPage();
}
function KH(e) {
  var t;
  (t = e.pagination) == null || t.goToLastPage();
}
function ZH(e, t) {
  var n;
  (n = e.pagination) == null || n.goToPage(t);
}
var qH = class extends U {
  constructor() {
    super(...arguments), this.beanName = "paginationAutoPageSizeSvc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowsCtrl = e.center;
      const t = this.checkPageSize.bind(this);
      this.addManagedEventListeners({
        bodyHeightChanged: t,
        scrollVisibilityChanged: t
      }), this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this)), this.checkPageSize();
    });
  }
  notActive() {
    return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
  }
  onPaginationAutoSizeChanged() {
    this.notActive() ? this.beans.pagination.unsetAutoCalculatedPageSize() : this.checkPageSize();
  }
  checkPageSize() {
    if (this.notActive())
      return;
    const e = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
    if (e > 0) {
      const t = this.beans, n = () => {
        const o = Math.max(Kn(t), 1), s = Math.floor(e / o);
        t.pagination.setPageSize(s, "autoCalculated");
      };
      this.isBodyRendered ? Lt(this, n, 50)() : (n(), this.isBodyRendered = !0);
    } else
      this.isBodyRendered = !1;
  }
}, Kr = "paginationPageSizeSelector", jH = { tag: "span", cls: "ag-paging-page-size" }, YH = class extends Te {
  constructor() {
    super(jH), this.hasEmptyOption = !1, this.handlePageSizeItemSelected = () => {
      if (!this.selectPageSizeComp)
        return;
      const e = this.selectPageSizeComp.getValue();
      if (!e)
        return;
      const t = Number(e);
      isNaN(t) || t < 1 || t === this.pagination.getPageSize() || (this.pagination.setPageSize(t, "pageSizeSelector"), this.hasEmptyOption && this.toggleSelectDisplay(!0), this.selectPageSizeComp.getFocusableElement().focus());
    };
  }
  wireBeans(e) {
    this.pagination = e.pagination;
  }
  postConstruct() {
    this.addManagedPropertyListener(Kr, () => {
      this.onPageSizeSelectorValuesChange();
    }), this.addManagedEventListeners({ paginationChanged: (e) => this.handlePaginationChanged(e) });
  }
  handlePaginationChanged(e) {
    if (!this.selectPageSizeComp || !(e != null && e.newPageSize))
      return;
    const t = this.pagination.getPageSize();
    this.getPageSizeSelectorValues().includes(t) ? this.selectPageSizeComp.setValue(t.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
  }
  toggleSelectDisplay(e) {
    this.selectPageSizeComp && !e && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp);
  }
  reset() {
    ht(this.getGui()), this.selectPageSizeComp && (this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp));
  }
  onPageSizeSelectorValuesChange() {
    this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
  }
  shouldShowPageSizeSelector() {
    return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get(Kr) !== !1;
  }
  reloadPageSizesSelector() {
    const e = this.getPageSizeSelectorValues(), t = this.pagination.getPageSize(), n = !t || !e.includes(t);
    if (n) {
      const s = this.gos.exists("paginationPageSize"), i = this.gos.get(Kr) !== !0;
      Z(94, { pageSizeSet: s, pageSizesSet: i, pageSizeOptions: e, paginationPageSizeOption: t }), i || Z(95, { paginationPageSizeOption: t, paginationPageSizeSelector: Kr }), e.unshift("");
    }
    const o = String(n ? "" : t);
    this.selectPageSizeComp ? (Yn(this.pageSizeOptions, e) || (this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(e)), this.pageSizeOptions = e), this.selectPageSizeComp.setValue(o, !0)) : this.createPageSizeSelectorComp(e, o), this.hasEmptyOption = n;
  }
  createPageSizeSelectOptions(e) {
    return e.map((t) => ({
      value: String(t)
    }));
  }
  createPageSizeSelectorComp(e, t) {
    const n = this.getLocaleTextFunc(), o = n("pageSizeSelectorLabel", "Page Size:"), s = n("ariaPageSizeSelectorLabel", "Page Size");
    this.selectPageSizeComp = this.createManagedBean(new up()).addOptions(this.createPageSizeSelectOptions(e)).setValue(t).setAriaLabel(s).setLabel(o).onValueChange(() => this.handlePageSizeItemSelected()), this.appendChild(this.selectPageSizeComp);
  }
  getPageSizeSelectorValues() {
    const e = [20, 50, 100], t = this.gos.get(Kr);
    return !Array.isArray(t) || !(t != null && t.length) ? e : [...t].sort((n, o) => n - o);
  }
  destroy() {
    this.toggleSelectDisplay(!1), super.destroy();
  }
}, QH = {
  selector: "AG-PAGE-SIZE-SELECTOR",
  component: YH
}, JH = (
  /*css*/
  ".ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:var(--ag-pagination-panel-height);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}"
), XH = class extends Ti {
  constructor() {
    super(), this.btFirst = X, this.btPrevious = X, this.btNext = X, this.btLast = X, this.lbRecordCount = X, this.lbFirstRowOnPage = X, this.lbLastRowOnPage = X, this.lbCurrent = X, this.lbTotal = X, this.pageSizeComp = X, this.previousAndFirstButtonsDisabled = !1, this.nextButtonDisabled = !1, this.lastButtonDisabled = !1, this.areListenersSetup = !1, this.allowFocusInnerElement = !1, this.registerCSS(JH);
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pagination = e.pagination, this.ariaAnnounce = e.ariaAnnounce;
  }
  postConstruct() {
    const e = this.gos.get("enableRtl");
    this.setTemplate(this.getTemplate(), [QH]);
    const { btFirst: t, btPrevious: n, btNext: o, btLast: s } = this;
    this.activateTabIndex([t, n, o, s]), t.insertAdjacentElement("afterbegin", Le(e ? "last" : "first", this.beans)), n.insertAdjacentElement("afterbegin", Le(e ? "next" : "previous", this.beans)), o.insertAdjacentElement("afterbegin", Le(e ? "previous" : "next", this.beans)), s.insertAdjacentElement("afterbegin", Le(e ? "first" : "last", this.beans)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(
      ["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"],
      () => this.onPageSizeRelatedOptionsChange()
    ), this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector()), this.initialiseTabGuard({
      // prevent tab guard default logic
      onTabKeyDown: () => {
      },
      focusInnerElement: (i) => this.allowFocusInnerElement ? this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(i) : rP(this.beans, i),
      forceFocusOutWhenTabGuardsAreEmpty: !0
    }), this.onPaginationChanged();
  }
  setAllowFocus(e) {
    this.allowFocusInnerElement = e;
  }
  onPaginationChanged() {
    const t = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.setDisplayed(t), t && (this.setupListeners(), this.enableOrDisableButtons(), this.updateLabels(), this.onPageSizeRelatedOptionsChange());
  }
  onPageSizeRelatedOptionsChange() {
    this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
  }
  setupListeners() {
    this.areListenersSetup || (this.addManagedEventListeners({ paginationChanged: this.onPaginationChanged.bind(this) }), [
      { el: this.btFirst, fn: this.onBtFirst.bind(this) },
      { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
      { el: this.btNext, fn: this.onBtNext.bind(this) },
      { el: this.btLast, fn: this.onBtLast.bind(this) }
    ].forEach((e) => {
      const { el: t, fn: n } = e;
      this.addManagedListeners(t, {
        click: n,
        keydown: (o) => {
          (o.key === O.ENTER || o.key === O.SPACE) && (o.preventDefault(), n());
        }
      });
    }), Uw(this.beans, this, this.getGui()), this.areListenersSetup = !0);
  }
  onBtFirst() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToFirstPage();
  }
  formatNumber(e) {
    const t = this.gos.getCallback("paginationNumberFormatter");
    return t ? t({ value: e }) : z5(e, this.getLocaleTextFunc.bind(this));
  }
  getTemplate() {
    const e = this.getLocaleTextFunc(), t = `ag-${this.getCompId()}`;
    return {
      tag: "div",
      cls: "ag-paging-panel ag-unselectable",
      attrs: { id: `${t}` },
      children: [
        {
          tag: "ag-page-size-selector",
          ref: "pageSizeComp"
        },
        {
          tag: "span",
          cls: "ag-paging-row-summary-panel",
          children: [
            {
              tag: "span",
              ref: "lbFirstRowOnPage",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-first-row` }
            },
            { tag: "span", attrs: { id: `${t}-to` }, children: e("to", "to") },
            {
              tag: "span",
              ref: "lbLastRowOnPage",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-last-row` }
            },
            { tag: "span", attrs: { id: `${t}-of` }, children: e("of", "of") },
            {
              tag: "span",
              ref: "lbRecordCount",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-row-count` }
            }
          ]
        },
        {
          tag: "span",
          cls: "ag-paging-page-summary-panel",
          role: "presentation",
          children: [
            {
              tag: "div",
              ref: "btFirst",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("firstPage", "First Page") }
            },
            {
              tag: "div",
              ref: "btPrevious",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("previousPage", "Previous Page") }
            },
            {
              tag: "span",
              cls: "ag-paging-description",
              children: [
                {
                  tag: "span",
                  attrs: {
                    id: `${t}-start-page`
                  },
                  children: e("page", "Page")
                },
                {
                  tag: "span",
                  ref: "lbCurrent",
                  cls: "ag-paging-number",
                  attrs: { id: `${t}-start-page-number` }
                },
                {
                  tag: "span",
                  attrs: {
                    id: `${t}-of-page`
                  },
                  children: e("of", "of")
                },
                {
                  tag: "span",
                  ref: "lbTotal",
                  cls: "ag-paging-number",
                  attrs: { id: `${t}-of-page-number` }
                }
              ]
            },
            {
              tag: "div",
              ref: "btNext",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("nextPage", "Next Page") }
            },
            {
              tag: "div",
              ref: "btLast",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("lastPage", "Last Page") }
            }
          ]
        }
      ]
    };
  }
  onBtNext() {
    this.nextButtonDisabled || this.pagination.goToNextPage();
  }
  onBtPrevious() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToPreviousPage();
  }
  onBtLast() {
    this.lastButtonDisabled || this.pagination.goToLastPage();
  }
  enableOrDisableButtons() {
    const e = this.pagination.getCurrentPage(), t = this.rowModel.isLastRowIndexKnown(), n = this.pagination.getTotalPages();
    this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    const o = this.isZeroPagesToDisplay(), s = e === n - 1;
    this.nextButtonDisabled = s || o, this.lastButtonDisabled = !t || o || e === n - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
  }
  toggleButtonDisabled(e, t) {
    Cd(e, t), e.classList.toggle("ag-disabled", t);
  }
  isZeroPagesToDisplay() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages();
    return e && t === 0;
  }
  updateLabels() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages(), n = this.pagination.getMasterRowCount(), o = e ? n : null, s = this.pagination.getCurrentPage(), i = this.pagination.getPageSize();
    let r, a;
    this.isZeroPagesToDisplay() ? r = a = 0 : (r = i * s + 1, a = r + i - 1, e && a > o && (a = o));
    const l = r + i - 1, d = !e && n < l, c = this.formatNumber(r);
    this.lbFirstRowOnPage.textContent = c;
    let u;
    const h = this.getLocaleTextFunc();
    d ? u = h("pageLastRowUnknown", "?") : u = this.formatNumber(a), this.lbLastRowOnPage.textContent = u;
    const p = t > 0 ? s + 1 : 0, f = this.formatNumber(p);
    this.lbCurrent.textContent = f;
    let m, C;
    if (e)
      m = this.formatNumber(t), C = this.formatNumber(o);
    else {
      const w = h("more", "more");
      m = w, C = w;
    }
    this.lbTotal.textContent = m, this.lbRecordCount.textContent = C, this.announceAriaStatus(c, u, C, f, m);
  }
  announceAriaStatus(e, t, n, o, s) {
    var u, h;
    const i = this.getLocaleTextFunc(), r = i("page", "Page"), a = i("to", "to"), l = i("of", "of"), d = `${e} ${a} ${t} ${l} ${n}`, c = `${r} ${o} ${l} ${s}`;
    d !== this.ariaRowStatus && (this.ariaRowStatus = d, (u = this.ariaAnnounce) == null || u.announceValue(d, "paginationRow")), c !== this.ariaPageStatus && (this.ariaPageStatus = c, (h = this.ariaAnnounce) == null || h.announceValue(c, "paginationPage"));
  }
}, eV = {
  selector: "AG-PAGINATION",
  component: XH
}, tV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pagination", this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = 0, this.masterRowCount = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("pagination"), this.pageSizeFromGridOptions = e.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
  }
  getPaginationSelector() {
    return eV;
  }
  isPaginateChildRows() {
    const e = this.gos;
    return e.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
    e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") ? !0 : e.get("paginateChildRows");
  }
  onPaginationGridOptionChanged() {
    this.active = this.gos.get("pagination"), this.calculatePages(), this.dispatchPaginationChangedEvent({ keepRenderedRows: !0 });
  }
  onPageSizeGridOptionChanged() {
    this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
  }
  goToPage(e) {
    const t = this.currentPage;
    if (!this.active || t === e || typeof t != "number")
      return;
    const { editSvc: n } = this.beans;
    n != null && n.isEditing() && (n.isBatchEditing() ? n.cleanupEditors() : n.stopEditing(void 0, { source: "api" })), this.currentPage = e, this.calculatePages(), this.dispatchPaginationChangedEvent({ newPage: !0 });
  }
  goToPageWithIndex(e) {
    var n, o;
    if (!this.active)
      return;
    let t = e;
    this.paginateChildRows || (t = ((o = (n = this.beans.rowModel).getTopLevelIndexFromDisplayedIndex) == null ? void 0 : o.call(n, e)) ?? e), this.goToPage(Math.floor(t / this.pageSize));
  }
  isRowInPage(e) {
    return this.active ? e >= this.topDisplayedRowIndex && e <= this.bottomDisplayedRowIndex : !0;
  }
  getCurrentPage() {
    return this.currentPage;
  }
  goToNextPage() {
    this.goToPage(this.currentPage + 1);
  }
  goToPreviousPage() {
    this.goToPage(this.currentPage - 1);
  }
  goToFirstPage() {
    this.goToPage(0);
  }
  goToLastPage() {
    const e = this.beans.rowModel.getRowCount(), t = Math.floor(e / this.pageSize);
    this.goToPage(t);
  }
  getPageSize() {
    return this.pageSize;
  }
  getTotalPages() {
    return this.totalPages;
  }
  /** This is only for state setting before data has been loaded */
  setPage(e) {
    this.currentPage = e;
  }
  get pageSize() {
    return ue(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize") ? this.pageSizeAutoCalculated : ue(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : ue(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : ue(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
  }
  calculatePages() {
    this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
  }
  unsetAutoCalculatedPageSize() {
    if (this.pageSizeAutoCalculated === void 0)
      return;
    const e = this.pageSizeAutoCalculated;
    this.pageSizeAutoCalculated = void 0, this.pageSize !== e && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0 }));
  }
  setPageSize(e, t) {
    const n = this.pageSize;
    switch (t) {
      case "autoCalculated":
        this.pageSizeAutoCalculated = e;
        break;
      case "pageSizeSelector":
        this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
        break;
      case "initialState":
        this.pageSizeFromInitialState = e;
        break;
      case "gridOptions":
        this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
        break;
    }
    n !== this.pageSize && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0, keepRenderedRows: !0 }));
  }
  setZeroRows() {
    this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
  }
  adjustCurrentPageIfInvalid() {
    const e = this.totalPages;
    this.currentPage >= e && (this.currentPage = e - 1);
    const t = this.currentPage;
    (!isFinite(t) || isNaN(t) || t < 0) && (this.currentPage = 0);
  }
  calculatePagesMasterRowsOnly() {
    const e = this.beans.rowModel, t = e.getTopLevelRowCount();
    if (this.masterRowCount = t, t <= 0) {
      this.setZeroRows();
      return;
    }
    const n = this.pageSize, o = t - 1;
    this.totalPages = Math.floor(o / n) + 1, this.adjustCurrentPageIfInvalid();
    const s = this.currentPage, i = n * s;
    let r = n * (s + 1) - 1;
    if (r > o && (r = o), this.topDisplayedRowIndex = e.getTopLevelRowDisplayedIndex(i), r === o)
      this.bottomDisplayedRowIndex = e.getRowCount() - 1;
    else {
      const a = e.getTopLevelRowDisplayedIndex(r + 1);
      this.bottomDisplayedRowIndex = a - 1;
    }
  }
  getMasterRowCount() {
    return this.masterRowCount;
  }
  calculatePagesAllRows() {
    const e = this.beans.rowModel.getRowCount();
    if (this.masterRowCount = e, e === 0) {
      this.setZeroRows();
      return;
    }
    const { pageSize: t, currentPage: n } = this, o = e - 1;
    this.totalPages = Math.floor(o / t) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = t * n, this.bottomDisplayedRowIndex = t * (n + 1) - 1, this.bottomDisplayedRowIndex > o && (this.bottomDisplayedRowIndex = o);
  }
  calculatedPagesNotActive() {
    this.setPageSize(void 0, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
  }
  dispatchPaginationChangedEvent(e) {
    const { keepRenderedRows: t = !1, newPage: n = !1, newPageSize: o = !1 } = e;
    this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: !1,
      newData: !1,
      newPage: n,
      newPageSize: o,
      keepRenderedRows: t
    });
  }
}, nV = {
  moduleName: "Pagination",
  version: Ee,
  beans: [tV, qH],
  icons: {
    // "go to first" button in pagination controls
    first: "first",
    // "go to previous" button in pagination controls
    previous: "previous",
    // "go to next" button in pagination controls
    next: "next",
    // "go to last" button in pagination controls
    last: "last"
  },
  apiFunctions: {
    paginationIsLastPageFound: HH,
    paginationGetPageSize: VH,
    paginationGetCurrentPage: _H,
    paginationGetTotalPages: NH,
    paginationGetRowCount: $H,
    paginationGoToNextPage: zH,
    paginationGoToPreviousPage: WH,
    paginationGoToFirstPage: UH,
    paginationGoToLastPage: KH,
    paginationGoToPage: ZH
  },
  dependsOn: [Vs]
};
function oV(e, t = {}) {
  const n = t ? t.rowNodes : void 0;
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.redrawRows(n));
}
function gb(e, t, n, o, s) {
  t && (o && t.parent && t.parent.level !== -1 && gb(e, t.parent, n, o, s), t.setExpanded(n, void 0, s));
}
function sV(e, t) {
  return e.rowModel.getRowNode(t);
}
function iV(e, t, n, o) {
  e.rowRenderer.addRenderedRowListener(t, n, o);
}
function rV(e) {
  return e.rowRenderer.getRenderedNodes();
}
function aV(e, t, n) {
  e.rowModel.forEachNode(t, n);
}
function lV(e) {
  return e.rowRenderer.firstRenderedRow;
}
function dV(e) {
  return e.rowRenderer.lastRenderedRow;
}
function cV(e, t) {
  return e.rowModel.getRow(t);
}
function uV(e) {
  return e.rowModel.getRowCount();
}
var pb = {
  moduleName: "RowApi",
  version: Ee,
  apiFunctions: {
    redrawRows: oV,
    setRowNodeExpanded: gb,
    getRowNode: sV,
    addRenderedRowListener: iV,
    getRenderedNodes: rV,
    forEachNode: aV,
    getFirstDisplayedRowIndex: lV,
    getLastDisplayedRowIndex: dV,
    getDisplayedRowAtIndex: cV,
    getDisplayedRowCount: uV
  }
}, hV = {
  moduleName: "ScrollApi",
  version: Ee,
  apiFunctions: {
    getVerticalPixelRange: LO,
    getHorizontalPixelRange: BO,
    ensureColumnVisible: Xy,
    ensureIndexVisible: eb,
    ensureNodeVisible: OO
  }
};
function gV(e, t, n) {
  if (!t)
    return;
  const o = e.ctrlsSvc.getGridBodyCtrl().eGridBody, s = `aria-${t}`;
  n === null ? o.removeAttribute(s) : o.setAttribute(s, n);
}
function pV(e, t = {}) {
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.refreshCells(t));
}
function fV(e) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getHeaderRowContainerCtrls().forEach((t) => t.refresh())
  );
}
function mV(e) {
  var t;
  return ((t = e.animationFrameSvc) == null ? void 0 : t.isQueueEmpty()) ?? !0;
}
function vV(e) {
  var t;
  (t = e.animationFrameSvc) == null || t.flushAllFrames();
}
function CV(e) {
  return {
    rowHeight: Kn(e),
    headerHeight: tl(e)
  };
}
function wV(e, t = {}) {
  var i;
  const n = [];
  if (e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((r) => {
    const a = r.getCellRenderer();
    a != null && n.push(Sr(a));
  }), (i = t.columns) != null && i.length)
    return n;
  const o = [], s = Nh(t.rowNodes);
  return e.rowRenderer.getAllRowCtrls().forEach((r) => {
    if (s && !$h(r.rowNode, s) || !r.isFullWidth())
      return;
    const a = r.getFullWidthCellRenderers();
    for (let l = 0; l < a.length; l++) {
      const d = a[l];
      d != null && o.push(Sr(d));
    }
  }), [...o, ...n];
}
var yV = {
  moduleName: "RenderApi",
  version: Ee,
  apiFunctions: {
    setGridAriaProperty: gV,
    refreshCells: pV,
    refreshHeader: fV,
    isAnimationFrameQueueEmpty: mV,
    flushAllAnimationFrames: vV,
    getSizesForCurrentTheme: CV,
    getCellRendererInstances: wV
  }
};
function bV(e, t) {
  var n, o;
  typeof t == "number" ? (n = e.colAutosize) == null || n.sizeColumnsToFit(t, "api") : (o = e.colAutosize) == null || o.sizeColumnsToFitGridBody(t);
}
function fb({ colAutosize: e, visibleCols: t }, n, o) {
  Array.isArray(n) ? e == null || e.autoSizeCols({ colKeys: n, skipHeader: o, source: "api" }) : e == null || e.autoSizeCols({
    colKeys: n.colIds ?? t.allCols,
    skipHeader: n.skipHeader,
    defaultMaxWidth: n.defaultMaxWidth,
    defaultMinWidth: n.defaultMinWidth,
    columnLimits: n.columnLimits,
    source: "api"
  });
}
function SV(e, t) {
  var n;
  t && typeof t == "object" ? fb(e, t) : (n = e.colAutosize) == null || n.autoSizeAllColumns({ source: "api", skipHeader: t });
}
var xV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colAutosize", this.timesDelayed = 0, this.shouldQueueResizeOperations = !1, this.resizeOperationQueue = [];
  }
  postConstruct() {
    var t;
    const e = this.gos.get("autoSizeStrategy");
    if (e) {
      let n = !1;
      const o = e.type;
      o === "fitGridWidth" || o === "fitProvidedWidth" ? n = !0 : o === "fitCellContents" && this.addManagedEventListeners({ firstDataRendered: () => this.onFirstDataRendered(e) }), n && ((t = this.beans.colDelayRenderSvc) == null || t.hideColumns(o));
    }
  }
  autoSizeCols(e) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeCols(e));
      return;
    }
    const {
      colKeys: t,
      skipHeader: n,
      skipHeaderGroups: o,
      stopAtGroup: s,
      defaultMaxWidth: i,
      defaultMinWidth: r,
      columnLimits: a = [],
      source: l = "api"
    } = e, { animationFrameSvc: d, renderStatus: c, colModel: u, autoWidthCalc: h, visibleCols: g } = this.beans;
    if (d == null || d.flushAllFrames(), this.timesDelayed < 5 && c && (!c.areHeaderCellsRendered() || !c.areCellsRendered())) {
      this.timesDelayed++, setTimeout(() => {
        this.isAlive() && this.autoSizeCols(e);
      });
      return;
    }
    this.timesDelayed = 0;
    const p = [];
    let f = -1;
    const m = Object.fromEntries(
      a.map(({ colId: b, maxWidth: A, minWidth: S }) => [b, { maxWidth: A, minWidth: S }])
    ), C = n ?? this.gos.get("skipHeaderOnAutoSize"), w = o ?? C;
    for (; f !== 0; ) {
      f = 0;
      const b = [];
      t.forEach((A) => {
        if (!A || j3(A))
          return;
        const S = u.getCol(A);
        if (!S || p.indexOf(S) >= 0)
          return;
        const F = h.getPreferredWidthForColumn(S, C);
        if (F > 0) {
          const E = m[S.colId] ?? {};
          E.minWidth ?? (E.minWidth = r), E.maxWidth ?? (E.maxWidth = i);
          const M = RV(S, F, E);
          S.setActualWidth(M, l), p.push(S), f++;
        }
        b.push(S);
      }), b.length && g.refresh(l);
    }
    w || this.autoSizeColumnGroupsByColumns(t, l, s), yr(this.eventSvc, p, !0, "autosizeColumns");
  }
  autoSizeColumn(e, t, n) {
    e && this.autoSizeCols({ colKeys: [e], skipHeader: n, skipHeaderGroups: !0, source: t });
  }
  autoSizeColumnGroupsByColumns(e, t, n) {
    const { colModel: o, ctrlsSvc: s } = this.beans, i = /* @__PURE__ */ new Set();
    o.getColsForKeys(e).forEach((d) => {
      let c = d.getParent();
      for (; c && c != n; )
        c.isPadding() || i.add(c), c = c.getParent();
    });
    let a;
    const l = [];
    for (const d of i) {
      for (const c of s.getHeaderRowContainerCtrls())
        if (a = c.getHeaderCtrlForColumn(d), a)
          break;
      a && a.resizeLeafColumnsToFit(t);
    }
    return l;
  }
  autoSizeAllColumns(e) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeAllColumns(e));
      return;
    }
    const t = this.beans.visibleCols.allCols;
    this.autoSizeCols({ colKeys: t, ...e });
  }
  addColumnAutosize(e, t) {
    const n = this.gos.get("skipHeaderOnAutoSize"), o = () => {
      this.autoSizeColumn(t, "uiColumnResized", n);
    };
    e.addEventListener("dblclick", o);
    const s = new No(e);
    return s.addEventListener("doubleTap", o), () => {
      e.removeEventListener("dblclick", o), s.removeEventListener("doubleTap", o), s.destroy();
    };
  }
  addColumnGroupResize(e, t, n) {
    const o = this.gos.get("skipHeaderOnAutoSize"), s = () => {
      const i = [];
      t.getDisplayedLeafColumns().forEach((a) => {
        a.getColDef().suppressAutoSize || i.push(a.getColId());
      }), i.length > 0 && this.autoSizeCols({
        colKeys: i,
        skipHeader: o,
        stopAtGroup: t,
        source: "uiColumnResized"
      }), n();
    };
    return e.addEventListener("dblclick", s), () => e.removeEventListener("dblclick", s);
  }
  // method will call itself if no available width. this covers if the grid
  // isn't visible, but is just about to be visible.
  sizeColumnsToFitGridBody(e, t) {
    if (!this.isAlive())
      return;
    const { ctrlsSvc: n, scrollVisibleSvc: o } = this.beans, s = n.getGridBodyCtrl(), r = s.isVerticalScrollShowing() ? o.getScrollbarWidth() : 0, l = mr(s.eGridBody) - r;
    if (l > 0) {
      this.sizeColumnsToFit(l, "sizeColumnsToFit", !1, e);
      return;
    }
    t === void 0 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 100);
    }, 0) : t === 100 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 500);
    }, 100) : t === 500 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, -1);
    }, 500) : Z(29);
  }
  // called from api
  sizeColumnsToFit(e, t = "sizeColumnsToFit", n, o) {
    var g;
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.sizeColumnsToFit(e, t, n, o));
      return;
    }
    const s = {};
    o && ((g = o == null ? void 0 : o.columnLimits) == null || g.forEach(({ key: p, ...f }) => {
      s[typeof p == "string" ? p : p.getColId()] = f;
    }));
    const i = this.beans.visibleCols.allCols;
    if (e <= 0 || !i.length || e === _o(i) && i.every((f) => {
      if (f.colDef.suppressSizeToFit)
        return !0;
      const m = s == null ? void 0 : s[f.getId()], C = (m == null ? void 0 : m.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth), w = (m == null ? void 0 : m.maxWidth) ?? (o == null ? void 0 : o.defaultMaxWidth), b = f.getActualWidth();
      return (C == null || b >= C) && (w == null || b <= w);
    }))
      return;
    const a = [], l = [];
    i.forEach((p) => {
      p.getColDef().suppressSizeToFit === !0 ? l.push(p) : a.push(p);
    });
    const d = a.slice(0);
    let c = !1;
    const u = (p) => {
      $t(a, p), l.push(p);
    };
    for (a.forEach((p) => {
      p.resetActualWidth(t);
      const f = s == null ? void 0 : s[p.getId()], m = (f == null ? void 0 : f.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth), C = (f == null ? void 0 : f.maxWidth) ?? (o == null ? void 0 : o.defaultMaxWidth), w = p.getActualWidth();
      typeof m == "number" && w < m ? p.setActualWidth(m, t, !0) : typeof C == "number" && w > C && p.setActualWidth(C, t, !0);
    }); !c; ) {
      c = !0;
      const p = e - _o(l);
      if (p <= 0)
        a.forEach((f) => {
          var C;
          const m = ((C = s == null ? void 0 : s[f.getId()]) == null ? void 0 : C.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth);
          if (typeof m == "number") {
            f.setActualWidth(m, t, !0);
            return;
          }
          f.setActualWidth(f.minWidth, t);
        });
      else {
        const f = p / _o(a);
        let m = p;
        for (let C = a.length - 1; C >= 0; C--) {
          const w = a[C], b = s == null ? void 0 : s[w.getId()], A = (b == null ? void 0 : b.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth), S = (b == null ? void 0 : b.maxWidth) ?? (o == null ? void 0 : o.defaultMaxWidth), F = w.getMinWidth(), E = w.getMaxWidth(), M = typeof A == "number" && A > F ? A : F, I = typeof S == "number" && S < E ? S : E;
          let P = Math.round(w.getActualWidth() * f);
          P < M ? (P = M, u(w), c = !1) : P > I ? (P = I, u(w), c = !1) : C === 0 && (P = m), w.setActualWidth(P, t, !0), m -= P;
        }
      }
    }
    d.forEach((p) => {
      p.fireColumnWidthChangedEvent(t);
    });
    const h = this.beans.visibleCols;
    h.setLeftValues(t), h.updateBodyWidths(), !n && yr(this.eventSvc, d, !0, t);
  }
  applyAutosizeStrategy() {
    const { gos: e, colDelayRenderSvc: t } = this.beans, n = e.get("autoSizeStrategy");
    !n || n.type === "fitCellContents" || setTimeout(() => {
      if (!this.isAlive())
        return;
      const o = n.type;
      if (o === "fitGridWidth") {
        const { columnLimits: s, defaultMinWidth: i, defaultMaxWidth: r } = n, a = s == null ? void 0 : s.map(({ colId: l, minWidth: d, maxWidth: c }) => ({
          key: l,
          minWidth: d,
          maxWidth: c
        }));
        this.sizeColumnsToFitGridBody({
          defaultMinWidth: i,
          defaultMaxWidth: r,
          columnLimits: a
        });
      } else o === "fitProvidedWidth" && this.sizeColumnsToFit(n.width, "sizeColumnsToFit");
      t == null || t.revealColumns(o);
    });
  }
  onFirstDataRendered(e) {
    const { colIds: t, skipHeader: n, defaultMaxWidth: o, defaultMinWidth: s, columnLimits: i } = e;
    setTimeout(() => {
      if (!this.isAlive())
        return;
      const r = {
        skipHeader: n,
        source: "autosizeColumns",
        defaultMaxWidth: o,
        defaultMinWidth: s,
        columnLimits: i
      };
      t ? this.autoSizeCols({ colKeys: t, ...r }) : this.autoSizeAllColumns(r);
    });
  }
  processResizeOperations() {
    this.shouldQueueResizeOperations = !1, this.resizeOperationQueue.forEach((e) => e()), this.resizeOperationQueue = [];
  }
  pushResizeOperation(e) {
    this.resizeOperationQueue.push(e);
  }
  destroy() {
    this.resizeOperationQueue.length = 0, super.destroy();
  }
};
function RV(e, t, n = {}) {
  const o = n.minWidth ?? e.getMinWidth();
  t < o && (t = o);
  const s = n.maxWidth ?? e.getMaxWidth();
  return t > s && (t = s), t;
}
var EV = {
  moduleName: "ColumnAutoSize",
  version: Ee,
  beans: [xV],
  apiFunctions: {
    sizeColumnsToFit: bV,
    autoSizeColumns: fb,
    autoSizeAllColumns: SV
  },
  dependsOn: [cy]
}, AV = (
  /*css*/
  ".ag-row-pinned-source{background-color:var(--ag-pinned-source-row-background-color);color:var(--ag-pinned-source-row-text-color);font-weight:var(--ag-pinned-source-row-font-weight)}.ag-row-pinned-manual{background-color:var(--ag-pinned-row-background-color);color:var(--ag-pinned-row-text-color);font-weight:var(--ag-pinned-row-font-weight)}"
);
function FV(e) {
  var t;
  return ((t = e.pinnedRowModel) == null ? void 0 : t.getPinnedTopRowCount()) ?? 0;
}
function MV(e) {
  var t;
  return ((t = e.pinnedRowModel) == null ? void 0 : t.getPinnedBottomRowCount()) ?? 0;
}
function IV(e, t) {
  var n;
  return (n = e.pinnedRowModel) == null ? void 0 : n.getPinnedTopRow(t);
}
function PV(e, t) {
  var n;
  return (n = e.pinnedRowModel) == null ? void 0 : n.getPinnedBottomRow(t);
}
function DV(e, t, n) {
  var o;
  return (o = e.pinnedRowModel) == null ? void 0 : o.forEachPinnedRow(t, n);
}
var TV = {
  moduleName: "PinnedRow",
  version: Ee,
  beans: [_P],
  css: [AV],
  apiFunctions: {
    getPinnedTopRowCount: FV,
    getPinnedBottomRowCount: MV,
    getPinnedTopRow: IV,
    getPinnedBottomRow: PV,
    forEachPinnedRow: DV
  },
  icons: {
    rowPin: "pin",
    rowPinTop: "pinned-top",
    rowPinBottom: "pinned-bottom",
    rowUnpin: "un-pin"
  }
}, kV = class extends ir {
  constructor(e, t, n) {
    super(e.col, e.firstNode, n, t), this.cellSpan = e, this.SPANNED_CELL_CSS_CLASS = "ag-spanned-cell";
  }
  setComp(e, t, n, o, s, i, r) {
    this.eWrapper = n, super.setComp(e, t, n, o, s, i, r), this.setAriaRowSpan(), this.refreshAriaRowIndex();
  }
  isCellSpanning() {
    return !0;
  }
  getCellSpan() {
    return this.cellSpan;
  }
  /**
   * When cell is spanning, ensure row index is also available on the cell
   */
  refreshAriaRowIndex() {
    this.rowNode.rowIndex != null && Ma(this.eGui, this.rowNode.rowIndex);
  }
  /**
   * When cell is spanning, ensure row index is also available on the cell
   */
  setAriaRowSpan() {
    o3(this.eGui, this.cellSpan.spannedNodes.size);
  }
  // not ideal, for tabbing need to force the focused position
  setFocusedCellPosition(e) {
    this.focusedCellPosition = e;
  }
  getFocusedCellPosition() {
    return this.focusedCellPosition ?? this.cellPosition;
  }
  checkCellFocused() {
    const e = this.beans.focusSvc.getFocusedCell();
    return !!e && this.cellSpan.doesSpanContain(e);
  }
  applyStaticCssClasses() {
    super.applyStaticCssClasses(), this.comp.toggleCss(this.SPANNED_CELL_CSS_CLASS, !0);
  }
  onCellFocused(e) {
    const { beans: t } = this;
    if (xc(t)) {
      this.focusedCellPosition = void 0;
      return;
    }
    const n = this.isCellFocused();
    n || (this.focusedCellPosition = void 0), e && n && (this.focusedCellPosition = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column
      // fix
    }), super.onCellFocused(e);
  }
  getRootElement() {
    return this.eWrapper;
  }
}, LV = class extends Gd {
  onRowIndexChanged() {
    super.onRowIndexChanged(), this.getAllCellCtrls().forEach((e) => e.refreshAriaRowIndex());
  }
  getInitialRowClasses(e) {
    return ["ag-spanned-row"];
  }
  getNewCellCtrl(e) {
    var o;
    const t = (o = this.beans.rowSpanSvc) == null ? void 0 : o.getCellSpan(e, this.rowNode);
    if (!(!t || t.firstNode !== this.rowNode))
      return new kV(t, this, this.beans);
  }
  isCorrectCtrlForSpan(e) {
    var o;
    const t = (o = this.beans.rowSpanSvc) == null ? void 0 : o.getCellSpan(e.column, this.rowNode);
    return !t || t.firstNode !== this.rowNode ? !1 : e.getCellSpan() === t;
  }
  /**
   * Below overrides are explicitly disabling styling and other unwanted behaviours for spannedRowCtrl
   */
  // row height should be 0 in spanned row - they're only included for purpose of aria
  onRowHeightChanged() {
  }
  // no styling spanned rows
  refreshFirstAndLastRowStyles() {
  }
  // no hover functionality for spanned rows
  addHoverFunctionality() {
  }
  resetHoveredStatus() {
  }
}, BV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "spannedRowRenderer", this.topCtrls = /* @__PURE__ */ new Map(), this.bottomCtrls = /* @__PURE__ */ new Map(), this.centerCtrls = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    this.addManagedEventListeners({
      displayedRowsChanged: this.createAllCtrls.bind(this)
    });
  }
  createAllCtrls() {
    this.createCtrls("top"), this.createCtrls("bottom"), this.createCtrls("center");
  }
  /**
   * When displayed rows or cols change, the spanned cell ctrls need to update
   */
  createCtrls(e) {
    const { rowSpanSvc: t } = this.beans, n = `${e}Ctrls`, o = this[n], s = o.size, i = this.getAllRelevantRowControls(e), r = /* @__PURE__ */ new Map();
    let a = !1;
    for (const d of i)
      d.isAlive() && (t == null || t.forEachSpannedColumn(d.rowNode, (c, u) => {
        if (r.has(u.firstNode))
          return;
        const h = o.get(u.firstNode);
        if (h) {
          r.set(u.firstNode, h), o.delete(u.firstNode);
          return;
        }
        a = !0;
        const g = new LV(u.firstNode, this.beans, !1, !1, !1);
        r.set(u.firstNode, g);
      }));
    this[n] = r;
    const l = r.size === s;
    if (!(!a && l)) {
      for (const d of o.values())
        d.destroyFirstPass(!0), d.destroySecondPass();
      this.dispatchLocalEvent({
        type: "spannedRowsUpdated",
        ctrlsKey: e
      });
    }
  }
  // cannot use getAllRowCtrls as it returns this services row ctrls.
  getAllRelevantRowControls(e) {
    const { rowRenderer: t } = this.beans;
    switch (e) {
      case "top":
        return t.topRowCtrls;
      case "bottom":
        return t.bottomRowCtrls;
      case "center":
        return t.allRowCtrls;
    }
  }
  getCellByPosition(e) {
    const { rowSpanSvc: t } = this.beans, n = t == null ? void 0 : t.getCellSpanByPosition(e);
    if (!n)
      return;
    const o = `${mb(e.rowPinned)}Ctrls`, s = this[o].get(n.firstNode);
    if (s)
      return s.getAllCellCtrls().find((i) => i.column === e.column);
  }
  getCtrls(e) {
    const t = `${e}Ctrls`;
    return [...this[t].values()];
  }
  destroyRowCtrls(e) {
    const t = `${e}Ctrls`;
    for (const n of this[t].values())
      n.destroyFirstPass(!0), n.destroySecondPass();
    this[t] = /* @__PURE__ */ new Map();
  }
  destroy() {
    super.destroy(), this.destroyRowCtrls("top"), this.destroyRowCtrls("bottom"), this.destroyRowCtrls("center");
  }
}, mb = (e) => e ?? "center", OV = class {
  constructor(e, t) {
    this.col = e, this.firstNode = t, this.cellSpan = !0, this.spannedNodes = /* @__PURE__ */ new Set(), this.addSpannedNode(t);
  }
  /**
   * Reset the span leaving only the head.
   * Head is used as a comparison as this is the row used to render this cell
   * Even if the row data changes, the cell will properly reflect the correct value.
   */
  reset() {
    this.spannedNodes.clear(), this.addSpannedNode(this.firstNode);
  }
  addSpannedNode(e) {
    this.spannedNodes.add(e), this.lastNode = e;
  }
  getLastNode() {
    return this.lastNode;
  }
  getCellHeight() {
    return this.lastNode.rowTop + this.lastNode.rowHeight - this.firstNode.rowTop - 1;
  }
  doesSpanContain(e) {
    return e.column !== this.col || e.rowPinned != this.firstNode.rowPinned ? !1 : this.firstNode.rowIndex <= e.rowIndex && e.rowIndex <= this.lastNode.rowIndex;
  }
  /**
   * Gets the auto height value for last node in the spanned cell.
   * The first node is used to store the auto height for the cell, but the additional height for this cell
   * needs applied to the last row in the span.
   */
  getLastNodeAutoHeight() {
    var n;
    const e = (n = this.firstNode.__autoHeights) == null ? void 0 : n[this.col.getColId()];
    if (e == null)
      return;
    let t = 0;
    return this.spannedNodes.forEach((o) => {
      o !== this.lastNode && (t += o.rowHeight);
    }), e - t;
  }
}, GV = class extends U {
  constructor(e) {
    super(), this.column = e;
  }
  buildCache(e) {
    var b;
    const {
      column: t,
      beans: { gos: n, pinnedRowModel: o, rowModel: s, valueSvc: i, pagination: r }
    } = this, { colDef: a } = t, l = this[`${e}ValueNodeMap`], d = /* @__PURE__ */ new Map(), c = n.getCallback("isFullWidthRow"), u = a.equals, h = a.spanRows, g = typeof h == "function";
    let p = null, f = null, m;
    const C = (A, S) => {
      p = A, f = null, m = S;
    }, w = (A) => {
      const S = !A.isExpandable() && !A.group && !A.detail && (c ? !c({ rowNode: A }) : !0);
      if (A.rowIndex == null || !S) {
        C(null, null);
        return;
      }
      if (p == null || A.level !== p.level || // no span across groups
      A.footer || f && A.rowIndex - 1 !== (f == null ? void 0 : f.getLastNode().rowIndex)) {
        C(A, i.getValue(t, A));
        return;
      }
      const F = i.getValue(t, A);
      if (g) {
        const E = ke(n, {
          valueA: m,
          nodeA: p,
          valueB: F,
          nodeB: A,
          column: t,
          colDef: a
        });
        if (!h(E)) {
          C(A, F);
          return;
        }
      } else if (u ? !u(m, F) : m !== F) {
        C(A, F);
        return;
      }
      if (!f) {
        const E = l == null ? void 0 : l.get(p);
        (E == null ? void 0 : E.firstNode) === p ? (E.reset(), f = E) : f = new OV(t, p), d.set(p, f);
      }
      f.addSpannedNode(A), d.set(A, f);
    };
    switch (e) {
      case "center":
        (b = s.forEachDisplayedNode) == null || b.call(s, (A) => {
          (!r || r.isRowInPage(A.rowIndex)) && w(A);
        });
        break;
      case "top":
        o == null || o.forEachPinnedRow("top", w);
        break;
      case "bottom":
        o == null || o.forEachPinnedRow("bottom", w);
        break;
    }
    this[`${e}ValueNodeMap`] = d;
  }
  isCellSpanning(e) {
    return !!this.getCellSpan(e);
  }
  getCellSpan(e) {
    return this[`${mb(e.rowPinned)}ValueNodeMap`].get(e);
  }
}, HV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowSpanSvc", this.spanningColumns = /* @__PURE__ */ new Map(), this.debouncePinnedEvent = Lt(this, this.dispatchCellsUpdatedEvent.bind(this, !0), 0), this.debounceModelEvent = Lt(this, this.dispatchCellsUpdatedEvent.bind(this, !1), 0), this.pinnedTimeout = null, this.modelTimeout = null;
  }
  postConstruct() {
    const e = this.onRowDataUpdated.bind(this), t = this.buildPinnedCaches.bind(this);
    this.addManagedEventListeners({
      paginationChanged: this.buildModelCaches.bind(this),
      pinnedRowDataChanged: t,
      pinnedRowsChanged: t,
      rowNodeDataChanged: e,
      cellValueChanged: e
    });
  }
  /**
   * When a new column is created with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */
  register(e) {
    const { gos: t } = this.beans;
    if (!t.get("enableCellSpan") || this.spanningColumns.has(e))
      return;
    const n = this.createManagedBean(new GV(e));
    this.spanningColumns.set(e, n), n.buildCache("top"), n.buildCache("bottom"), n.buildCache("center"), this.debouncePinnedEvent(), this.debounceModelEvent();
  }
  dispatchCellsUpdatedEvent(e) {
    this.dispatchLocalEvent({ type: "spannedCellsUpdated", pinned: e });
  }
  /**
   * When a new column is destroyed with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */
  deregister(e) {
    this.spanningColumns.delete(e);
  }
  // called when data changes, as this could be a hot path it's debounced
  // it uses timeouts instead of debounce so that it can be cancelled by `modelUpdated`
  // which is expected to run immediately (to exec before the rowRenderer)
  onRowDataUpdated({ node: e }) {
    const { spannedRowRenderer: t } = this.beans;
    if (e.rowPinned) {
      if (this.pinnedTimeout != null)
        return;
      this.pinnedTimeout = window.setTimeout(() => {
        this.pinnedTimeout = null, this.buildPinnedCaches(), t == null || t.createCtrls("top"), t == null || t.createCtrls("bottom");
      }, 0);
      return;
    }
    this.modelTimeout == null && (this.modelTimeout = window.setTimeout(() => {
      this.modelTimeout = null, this.buildModelCaches(), t == null || t.createCtrls("center");
    }, 0));
  }
  buildModelCaches() {
    this.modelTimeout != null && clearTimeout(this.modelTimeout), this.spanningColumns.forEach((e) => e.buildCache("center")), this.debounceModelEvent();
  }
  buildPinnedCaches() {
    this.pinnedTimeout != null && clearTimeout(this.pinnedTimeout), this.spanningColumns.forEach((e) => {
      e.buildCache("top"), e.buildCache("bottom");
    }), this.debouncePinnedEvent();
  }
  isCellSpanning(e, t) {
    const n = this.spanningColumns.get(e);
    return n ? n.isCellSpanning(t) : !1;
  }
  getCellSpanByPosition(e) {
    const { pinnedRowModel: t, rowModel: n } = this.beans, o = e.column, s = e.rowIndex, i = this.spanningColumns.get(o);
    if (!i)
      return;
    let r;
    switch (e.rowPinned) {
      case "top":
        r = t == null ? void 0 : t.getPinnedTopRow(s);
        break;
      case "bottom":
        r = t == null ? void 0 : t.getPinnedBottomRow(s);
        break;
      default:
        r = n.getRow(s);
    }
    if (r)
      return i.getCellSpan(r);
  }
  getCellStart(e) {
    const t = this.getCellSpanByPosition(e);
    return t ? { ...e, rowIndex: t.firstNode.rowIndex } : e;
  }
  getCellEnd(e) {
    const t = this.getCellSpanByPosition(e);
    return t ? { ...e, rowIndex: t.getLastNode().rowIndex } : e;
  }
  /**
   * Look-up a spanned cell given a col and node as position indicators
   *
   * @param col a column to lookup a span at this position
   * @param rowNode a node that may be spanned at this position
   * @returns the CellSpan object if one exists
   */
  getCellSpan(e, t) {
    const n = this.spanningColumns.get(e);
    if (n)
      return n.getCellSpan(t);
  }
  forEachSpannedColumn(e, t) {
    for (const [n, o] of this.spanningColumns)
      if (o.isCellSpanning(e)) {
        const s = o.getCellSpan(e);
        t(n, s);
      }
  }
  destroy() {
    super.destroy(), this.spanningColumns.clear();
  }
}, VV = {
  moduleName: "CellSpan",
  version: Ee,
  beans: [HV, BV]
}, _V = class extends U {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.staticClasses = [], this.beans = t, this.column = e.column;
  }
  setComp(e) {
    this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
  }
  applyCellClassRules() {
    const { column: e, cellComp: t } = this, n = e.colDef, o = n.cellClassRules, s = this.getCellClassParams(e, n);
    Lp(
      this.beans.expressionSvc,
      // if current was previous, skip
      o === this.cellClassRules ? void 0 : this.cellClassRules,
      o,
      s,
      (i) => t.toggleCss(i, !0),
      (i) => t.toggleCss(i, !1)
    ), this.cellClassRules = o;
  }
  applyUserStyles() {
    const e = this.column, t = e.colDef, n = t.cellStyle;
    if (!n)
      return;
    let o;
    if (typeof n == "function") {
      const s = this.getCellClassParams(e, t);
      o = n(s);
    } else
      o = n;
    o && this.cellComp.setUserStyles(o);
  }
  applyClassesFromColDef() {
    const { column: e, cellComp: t } = this, n = e.colDef, o = this.getCellClassParams(e, n);
    this.staticClasses.forEach((i) => t.toggleCss(i, !1));
    const s = this.beans.cellStyles.getStaticCellClasses(n, o);
    this.staticClasses = s, s.forEach((i) => t.toggleCss(i, !0));
  }
  getCellClassParams(e, t) {
    const { value: n, rowNode: o } = this.cellCtrl;
    return ke(this.beans.gos, {
      value: n,
      data: o.data,
      node: o,
      colDef: t,
      column: e,
      rowIndex: o.rowIndex
    });
  }
}, NV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "cellStyles";
  }
  processAllCellClasses(e, t, n, o) {
    Lp(
      this.beans.expressionSvc,
      void 0,
      e.cellClassRules,
      t,
      n,
      o
    ), this.processStaticCellClasses(e, t, n);
  }
  getStaticCellClasses(e, t) {
    const { cellClass: n } = e;
    if (!n)
      return [];
    let o;
    return typeof n == "function" ? o = n(t) : o = n, typeof o == "string" && (o = [o]), o || [];
  }
  createCellCustomStyleFeature(e, t) {
    return new _V(e, t);
  }
  processStaticCellClasses(e, t, n) {
    this.getStaticCellClasses(e, t).forEach((s) => {
      n(s);
    });
  }
}, $V = {
  moduleName: "CellStyle",
  version: Ee,
  beans: [NV]
}, zV = {
  moduleName: "RowStyle",
  version: Ee,
  beans: [_L]
};
function WV(e, t) {
  var n;
  return !!((n = e.colHover) != null && n.isHovered(t));
}
var UV = class extends U {
  constructor(e, t) {
    super(), this.columns = e, this.element = t, this.destroyManagedListeners = [], this.enableFeature = (n) => {
      const { beans: o, gos: s, element: i, columns: r } = this, a = o.colHover;
      n ?? !!s.get("columnHoverHighlight") ? this.destroyManagedListeners = this.addManagedElementListeners(i, {
        mouseover: a.setMouseOver.bind(a, r),
        mouseout: a.clearMouseOver.bind(a)
      }) : (this.destroyManagedListeners.forEach((d) => d()), this.destroyManagedListeners = []);
    };
  }
  postConstruct() {
    this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: e }) => {
      this.enableFeature(e);
    }), this.enableFeature();
  }
  destroy() {
    super.destroy(), this.destroyManagedListeners = null;
  }
}, KV = "ag-column-hover", ZV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colHover";
  }
  postConstruct() {
    this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: e }) => {
      e || this.clearMouseOver();
    });
  }
  setMouseOver(e) {
    this.updateState(e);
  }
  clearMouseOver() {
    this.updateState(null);
  }
  isHovered(e) {
    if (!this.gos.get("columnHoverHighlight"))
      return !1;
    const t = this.selectedColumns;
    return !!t && t.indexOf(e) >= 0;
  }
  addHeaderColumnHoverListener(e, t, n) {
    const o = () => {
      const s = this.isHovered(n);
      t.toggleCss("ag-column-hover", s);
    };
    e.addManagedEventListeners({ columnHoverChanged: o }), o();
  }
  onCellColumnHover(e, t) {
    if (!t)
      return;
    const n = this.isHovered(e);
    t.toggleCss(KV, n);
  }
  addHeaderFilterColumnHoverListener(e, t, n, o) {
    this.createHoverFeature(e, [n], o);
    const s = () => {
      const i = this.isHovered(n);
      t.toggleCss("ag-column-hover", i);
    };
    e.addManagedEventListeners({ columnHoverChanged: s }), s();
  }
  createHoverFeature(e, t, n) {
    e.createManagedBean(new UV(t, n));
  }
  updateState(e) {
    this.selectedColumns = e, this.eventSvc.dispatchEvent({
      type: "columnHoverChanged"
    });
  }
}, qV = {
  moduleName: "ColumnHover",
  version: Ee,
  beans: [ZV],
  apiFunctions: {
    isColumnHovered: WV
  }
}, jV = class extends U {
  constructor() {
    super(...arguments), this.beanName = "apiEventSvc", this.syncListeners = /* @__PURE__ */ new Map(), this.asyncListeners = /* @__PURE__ */ new Map(), this.syncGlobalListeners = /* @__PURE__ */ new Set(), this.globalListenerPairs = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    var e, t;
    this.wrapSvc = (t = (e = this.beans.frameworkOverrides).createGlobalEventListenerWrapper) == null ? void 0 : t.call(e);
  }
  addListener(e, t) {
    var i;
    const n = ((i = this.wrapSvc) == null ? void 0 : i.wrap(e, t)) ?? t, o = !da.has(e), s = o ? this.asyncListeners : this.syncListeners;
    s.has(e) || s.set(e, /* @__PURE__ */ new Set()), s.get(e).add(n), this.eventSvc.addListener(e, n, o);
  }
  removeListener(e, t) {
    var i, r;
    const n = ((i = this.wrapSvc) == null ? void 0 : i.unwrap(e, t)) ?? t, o = this.asyncListeners.get(e), s = !!(o != null && o.delete(n));
    s || (r = this.syncListeners.get(e)) == null || r.delete(n), this.eventSvc.removeListener(e, n, s);
  }
  addGlobalListener(e) {
    var i;
    const t = ((i = this.wrapSvc) == null ? void 0 : i.wrapGlobal(e)) ?? e, n = (r, a) => {
      da.has(r) && t(r, a);
    }, o = (r, a) => {
      da.has(r) || t(r, a);
    };
    this.globalListenerPairs.set(e, { syncListener: n, asyncListener: o });
    const s = this.eventSvc;
    s.addGlobalListener(n, !1), s.addGlobalListener(o, !0);
  }
  removeGlobalListener(e) {
    const { eventSvc: t, wrapSvc: n, globalListenerPairs: o } = this, s = (n == null ? void 0 : n.unwrapGlobal(e)) ?? e;
    if (o.has(s)) {
      const { syncListener: r, asyncListener: a } = o.get(s);
      t.removeGlobalListener(r, !1), t.removeGlobalListener(a, !0), o.delete(e);
    } else
      this.syncGlobalListeners.delete(s), t.removeGlobalListener(s, !1);
  }
  destroyEventListeners(e, t) {
    e.forEach((n, o) => {
      n.forEach((s) => this.eventSvc.removeListener(o, s, t)), n.clear();
    }), e.clear();
  }
  destroyGlobalListeners(e, t) {
    e.forEach((n) => this.eventSvc.removeGlobalListener(n, t)), e.clear();
  }
  destroy() {
    super.destroy(), this.destroyEventListeners(this.syncListeners, !1), this.destroyEventListeners(this.asyncListeners, !0), this.destroyGlobalListeners(this.syncGlobalListeners, !1);
    const { globalListenerPairs: e, eventSvc: t } = this;
    e.forEach(({ syncListener: n, asyncListener: o }) => {
      t.removeGlobalListener(n, !1), t.removeGlobalListener(o, !0);
    }), e.clear();
  }
};
function YV(e, t, n) {
  var o;
  (o = e.apiEventSvc) == null || o.addListener(t, n);
}
function QV(e, t, n) {
  var o;
  (o = e.apiEventSvc) == null || o.removeListener(t, n);
}
function JV(e, t) {
  var n;
  (n = e.apiEventSvc) == null || n.addGlobalListener(t);
}
function XV(e, t) {
  var n;
  (n = e.apiEventSvc) == null || n.removeGlobalListener(t);
}
var vb = {
  moduleName: "EventApi",
  version: Ee,
  apiFunctions: {
    addEventListener: YV,
    addGlobalListener: JV,
    removeEventListener: QV,
    removeGlobalListener: XV
  },
  beans: [jV]
}, e7 = {
  moduleName: "Locale",
  version: Ee,
  beans: [V5]
}, t7 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowAutoHeight", this.wasEverActive = !1, this._debouncedCalculateRowHeights = Lt(this, this.calculateRowHeights.bind(this), 1);
  }
  /**
   * If row height has been active, request a refresh of the row heights.
   */
  requestCheckAutoHeight() {
    this.wasEverActive && this._debouncedCalculateRowHeights();
  }
  calculateRowHeights() {
    var a, l, d, c;
    const { visibleCols: e, rowModel: t, rowSpanSvc: n, pinnedRowModel: o } = this.beans, s = e.autoHeightCols;
    let i = !1;
    const r = (u) => {
      var p;
      const h = u.__autoHeights;
      let g = qt(this.beans, u).height;
      for (const f of s) {
        let m = h == null ? void 0 : h[f.getColId()];
        const C = n == null ? void 0 : n.getCellSpan(f, u);
        if (C) {
          if (C.getLastNode() !== u)
            continue;
          if (m = (p = n == null ? void 0 : n.getCellSpan(f, u)) == null ? void 0 : p.getLastNodeAutoHeight(), !m)
            return;
        }
        if (m == null) {
          if (this.colSpanSkipCell(f, u))
            continue;
          return;
        }
        g = Math.max(m, g);
      }
      g !== u.rowHeight && (u.setRowHeight(g), i = !0);
    };
    (a = o == null ? void 0 : o.forEachPinnedRow) == null || a.call(o, "top", r), (l = o == null ? void 0 : o.forEachPinnedRow) == null || l.call(o, "bottom", r), (d = t.forEachDisplayedNode) == null || d.call(t, r), i && ((c = t.onRowHeightChanged) == null || c.call(t));
  }
  /**
   * Set the cell height into the row node, and request a refresh of the row heights if there's been a change.
   * @param rowNode the node to set the auto height on
   * @param cellHeight the height to set, undefined if the cell has just been destroyed
   * @param column the column of the cell
   */
  setRowAutoHeight(e, t, n) {
    if (e.__autoHeights ?? (e.__autoHeights = {}), t == null) {
      delete e.__autoHeights[n.getId()];
      return;
    }
    const o = e.__autoHeights[n.getId()];
    e.__autoHeights[n.getId()] = t, o !== t && this.requestCheckAutoHeight();
  }
  /**
   * If using col span, then cells which have been spanned over do not need an auto height value
   * @param col the column of the cell
   * @param node the node of the cell
   * @returns whether the row needs auto height value for that column
   */
  colSpanSkipCell(e, t) {
    const { colModel: n, colViewport: o, visibleCols: s } = this.beans;
    if (!n.colSpanActive)
      return !1;
    let i = [];
    switch (e.getPinned()) {
      case "left":
        i = s.getLeftColsForRow(t);
        break;
      case "right":
        i = s.getRightColsForRow(t);
        break;
      case null:
        i = o.getColsWithinViewport(t);
        break;
    }
    return !i.includes(e);
  }
  /**
   * If required, sets up observers to continuously measure changes in the cell height.
   * @param cellCtrl the cellCtrl of the cell
   * @param eCellWrapper the HTMLElement to track the height of
   * @param compBean the component bean to add the destroy/cleanup function to
   * @returns whether or not auto height has been set up on this cell
   */
  setupCellAutoHeight(e, t, n) {
    if (!e.column.isAutoHeight() || !t)
      return !1;
    this.wasEverActive = !0;
    const o = t.parentElement, { rowNode: s, column: i } = e, r = this.beans, a = (c) => {
      var w;
      if ((w = this.beans.editSvc) != null && w.isEditing(e) || !e.isAlive() || !n.isAlive())
        return;
      const { paddingTop: u, paddingBottom: h, borderBottomWidth: g, borderTopWidth: p } = Pi(o), f = u + h + g + p, C = t.offsetHeight + f;
      if (c < 5) {
        const b = Bt(r), A = !b || !b.contains(t), S = C == 0;
        if (A || S) {
          window.setTimeout(() => a(c + 1), 0);
          return;
        }
      }
      this.setRowAutoHeight(s, C, i);
    }, l = () => a(0);
    l();
    const d = Bo(r, t, l);
    return n.addDestroyFunc(() => {
      d(), this.setRowAutoHeight(s, void 0, i);
    }), !0;
  }
  setAutoHeightActive(e) {
    this.active = e.list.some((t) => t.isVisible() && t.isAutoHeight());
  }
  /**
   * Determines if the row auto height service has cells to grow.
   * @returns true if all of the rendered rows are at least as tall as their rendered cells.
   */
  areRowsMeasured() {
    if (!this.active)
      return !0;
    const e = this.beans.rowRenderer.getAllRowCtrls();
    let t = null;
    for (const { rowNode: n } of e)
      if ((!t || this.beans.colModel.colSpanActive) && (t = this.beans.colViewport.getColsWithinViewport(n).filter((s) => s.isAutoHeight())), t.length !== 0) {
        if (!n.__autoHeights)
          return !1;
        for (const o of t) {
          const s = n.__autoHeights[o.getColId()];
          if (!s || n.rowHeight < s)
            return !1;
        }
      }
    return !0;
  }
}, n7 = {
  moduleName: "RowAutoHeight",
  version: Ee,
  beans: [t7]
}, o7 = {
  moduleName: "AllCommunity",
  version: Ee,
  dependsOn: [
    oH,
    uH,
    bH,
    sB,
    gG,
    pG,
    fG,
    mG,
    vG,
    CG,
    wG,
    hG,
    iO,
    rO,
    aO,
    sO,
    dO,
    cO,
    GH,
    _G,
    nV,
    hy,
    pb,
    hV,
    yV,
    EV,
    ZD,
    TV,
    kG,
    S5,
    $V,
    qV,
    zV,
    vb,
    E5,
    DH,
    Wp,
    e7,
    n7,
    KD,
    sH,
    VV
  ]
}, s7 = class {
  constructor() {
    this.ieCompatibility = !1;
  }
  init() {
    this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
  }
  md5cycle(e, t) {
    let n = e[0], o = e[1], s = e[2], i = e[3];
    n = this.ff(n, o, s, i, t[0], 7, -680876936), i = this.ff(i, n, o, s, t[1], 12, -389564586), s = this.ff(s, i, n, o, t[2], 17, 606105819), o = this.ff(o, s, i, n, t[3], 22, -1044525330), n = this.ff(n, o, s, i, t[4], 7, -176418897), i = this.ff(i, n, o, s, t[5], 12, 1200080426), s = this.ff(s, i, n, o, t[6], 17, -1473231341), o = this.ff(o, s, i, n, t[7], 22, -45705983), n = this.ff(n, o, s, i, t[8], 7, 1770035416), i = this.ff(i, n, o, s, t[9], 12, -1958414417), s = this.ff(s, i, n, o, t[10], 17, -42063), o = this.ff(o, s, i, n, t[11], 22, -1990404162), n = this.ff(n, o, s, i, t[12], 7, 1804603682), i = this.ff(i, n, o, s, t[13], 12, -40341101), s = this.ff(s, i, n, o, t[14], 17, -1502002290), o = this.ff(o, s, i, n, t[15], 22, 1236535329), n = this.gg(n, o, s, i, t[1], 5, -165796510), i = this.gg(i, n, o, s, t[6], 9, -1069501632), s = this.gg(s, i, n, o, t[11], 14, 643717713), o = this.gg(o, s, i, n, t[0], 20, -373897302), n = this.gg(n, o, s, i, t[5], 5, -701558691), i = this.gg(i, n, o, s, t[10], 9, 38016083), s = this.gg(s, i, n, o, t[15], 14, -660478335), o = this.gg(o, s, i, n, t[4], 20, -405537848), n = this.gg(n, o, s, i, t[9], 5, 568446438), i = this.gg(i, n, o, s, t[14], 9, -1019803690), s = this.gg(s, i, n, o, t[3], 14, -187363961), o = this.gg(o, s, i, n, t[8], 20, 1163531501), n = this.gg(n, o, s, i, t[13], 5, -1444681467), i = this.gg(i, n, o, s, t[2], 9, -51403784), s = this.gg(s, i, n, o, t[7], 14, 1735328473), o = this.gg(o, s, i, n, t[12], 20, -1926607734), n = this.hh(n, o, s, i, t[5], 4, -378558), i = this.hh(i, n, o, s, t[8], 11, -2022574463), s = this.hh(s, i, n, o, t[11], 16, 1839030562), o = this.hh(o, s, i, n, t[14], 23, -35309556), n = this.hh(n, o, s, i, t[1], 4, -1530992060), i = this.hh(i, n, o, s, t[4], 11, 1272893353), s = this.hh(s, i, n, o, t[7], 16, -155497632), o = this.hh(o, s, i, n, t[10], 23, -1094730640), n = this.hh(n, o, s, i, t[13], 4, 681279174), i = this.hh(i, n, o, s, t[0], 11, -358537222), s = this.hh(s, i, n, o, t[3], 16, -722521979), o = this.hh(o, s, i, n, t[6], 23, 76029189), n = this.hh(n, o, s, i, t[9], 4, -640364487), i = this.hh(i, n, o, s, t[12], 11, -421815835), s = this.hh(s, i, n, o, t[15], 16, 530742520), o = this.hh(o, s, i, n, t[2], 23, -995338651), n = this.ii(n, o, s, i, t[0], 6, -198630844), i = this.ii(i, n, o, s, t[7], 10, 1126891415), s = this.ii(s, i, n, o, t[14], 15, -1416354905), o = this.ii(o, s, i, n, t[5], 21, -57434055), n = this.ii(n, o, s, i, t[12], 6, 1700485571), i = this.ii(i, n, o, s, t[3], 10, -1894986606), s = this.ii(s, i, n, o, t[10], 15, -1051523), o = this.ii(o, s, i, n, t[1], 21, -2054922799), n = this.ii(n, o, s, i, t[8], 6, 1873313359), i = this.ii(i, n, o, s, t[15], 10, -30611744), s = this.ii(s, i, n, o, t[6], 15, -1560198380), o = this.ii(o, s, i, n, t[13], 21, 1309151649), n = this.ii(n, o, s, i, t[4], 6, -145523070), i = this.ii(i, n, o, s, t[11], 10, -1120210379), s = this.ii(s, i, n, o, t[2], 15, 718787259), o = this.ii(o, s, i, n, t[9], 21, -343485551), e[0] = this.add32(n, e[0]), e[1] = this.add32(o, e[1]), e[2] = this.add32(s, e[2]), e[3] = this.add32(i, e[3]);
  }
  cmn(e, t, n, o, s, i) {
    return t = this.add32(this.add32(t, e), this.add32(o, i)), this.add32(t << s | t >>> 32 - s, n);
  }
  ff(e, t, n, o, s, i, r) {
    return this.cmn(t & n | ~t & o, e, t, s, i, r);
  }
  gg(e, t, n, o, s, i, r) {
    return this.cmn(t & o | n & ~o, e, t, s, i, r);
  }
  hh(e, t, n, o, s, i, r) {
    return this.cmn(t ^ n ^ o, e, t, s, i, r);
  }
  ii(e, t, n, o, s, i, r) {
    return this.cmn(n ^ (t | ~o), e, t, s, i, r);
  }
  md51(e) {
    const t = e.length, n = [1732584193, -271733879, -1732584194, 271733878];
    let o;
    for (o = 64; o <= e.length; o += 64)
      this.md5cycle(n, this.md5blk(e.substring(o - 64, o)));
    e = e.substring(o - 64);
    const s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (o = 0; o < e.length; o++)
      s[o >> 2] |= e.charCodeAt(o) << (o % 4 << 3);
    if (s[o >> 2] |= 128 << (o % 4 << 3), o > 55)
      for (this.md5cycle(n, s), o = 0; o < 16; o++)
        s[o] = 0;
    return s[14] = t * 8, this.md5cycle(n, s), n;
  }
  /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */
  md5blk(e) {
    const t = [];
    for (let n = 0; n < 64; n += 4)
      t[n >> 2] = e.charCodeAt(n) + (e.charCodeAt(n + 1) << 8) + (e.charCodeAt(n + 2) << 16) + (e.charCodeAt(n + 3) << 24);
    return t;
  }
  rhex(e) {
    const t = "0123456789abcdef".split("");
    let n = "", o = 0;
    for (; o < 4; o++)
      n += t[e >> o * 8 + 4 & 15] + t[e >> o * 8 & 15];
    return n;
  }
  hex(e) {
    for (let t = 0; t < e.length; t++)
      e[t] = this.rhex(e[t]);
    return e.join("");
  }
  md5(e) {
    return this.hex(this.md51(e));
  }
  add32(e, t) {
    return this.ieCompatibility ? this.add32Compat(e, t) : this.add32Std(e, t);
  }
  /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */
  add32Std(e, t) {
    return e + t & 4294967295;
  }
  add32Compat(e, t) {
    const n = (e & 65535) + (t & 65535);
    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | n & 65535;
  }
}, Ml = {
  "01": "GRID",
  "02": "CHARTS",
  "0102": "BOTH"
}, m0 = "https://www.ag-grid.com/licensing/", Cb = class yn {
  constructor(t) {
    this.watermarkMessage = void 0, this.totalMessageLength = 124, this.document = t, this.md5 = new s7(), this.md5.init();
  }
  validateLicense() {
    const t = this.getLicenseDetails(yn.licenseKey), n = `AG Grid ${t.currentLicenseType === "BOTH" ? "and AG Charts " : ""}Enterprise`, o = t.suppliedLicenseType === void 0 ? "" : `AG ${t.suppliedLicenseType === "BOTH" ? "Grid and AG Charts" : t.suppliedLicenseType === "GRID" ? "Grid" : "Charts"} Enterprise`;
    if (t.missing)
      (!this.isWebsiteUrl() || this.isForceWatermark()) && this.outputMissingLicenseKey(n);
    else if (t.expired) {
      const s = yn.getGridReleaseDate(), i = yn.formatDate(s);
      this.outputExpiredKey(t.expiry, i, n, o);
    } else t.valid ? t.isTrial && t.trialExpired && this.outputExpiredTrialKey(t.expiry, n, o) : this.outputInvalidLicenseKey(
      !!t.incorrectLicenseType,
      n,
      o
    );
  }
  static extractExpiry(t) {
    const n = t.substring(t.lastIndexOf("_") + 1, t.length);
    return new Date(parseInt(yn.decode(n), 10));
  }
  static extractLicenseComponents(t) {
    let n = t.replace(/[\u200B-\u200D\uFEFF]/g, "");
    if (n = n.replace(/\r?\n|\r/g, ""), t.length <= 32)
      return { md5: null, license: t, version: null, isTrial: null };
    const o = n.length - 32, s = n.substring(o), i = n.substring(0, o), [r, a, l] = yn.extractBracketedInformation(n);
    return { md5: s, license: i, version: r, isTrial: a, type: l };
  }
  getLicenseDetails(t) {
    const n = yn.chartsLicenseManager ? "BOTH" : "GRID";
    if (!(t != null && t.length))
      return {
        licenseKey: t,
        valid: !1,
        missing: !0,
        currentLicenseType: n
      };
    const o = yn.getGridReleaseDate(), { md5: s, license: i, version: r, isTrial: a, type: l } = yn.extractLicenseComponents(t);
    let d = s === this.md5.md5(i) && t.indexOf("For_Trialing_ag-Grid_Only") === -1, c, u, h = null, g = !1, p;
    function f() {
      c = h < /* @__PURE__ */ new Date(), u = void 0;
    }
    if (d && (h = yn.extractExpiry(i), d = !isNaN(h.getTime()), d))
      switch (u = o > h, r) {
        case "legacy":
        case "2": {
          a && f();
          break;
        }
        case "3":
          l != null && l.length ? (p = l, l !== Ml["01"] && l !== Ml["0102"] || n === "BOTH" && p !== "BOTH" ? (d = !1, g = !0) : a && f()) : d = !1;
      }
    return d ? {
      licenseKey: t,
      valid: d,
      expiry: yn.formatDate(h),
      expired: u,
      version: r,
      isTrial: a,
      trialExpired: c,
      incorrectLicenseType: g,
      currentLicenseType: n,
      suppliedLicenseType: p
    } : {
      licenseKey: t,
      valid: d,
      incorrectLicenseType: g,
      currentLicenseType: n,
      suppliedLicenseType: p
    };
  }
  isDisplayWatermark() {
    var t;
    return this.isForceWatermark() || !this.isLocalhost() && !this.isWebsiteUrl() && !!((t = this.watermarkMessage) != null && t.length);
  }
  getWatermarkMessage() {
    return this.watermarkMessage || "";
  }
  getHostname() {
    const n = (this.document.defaultView || window).location, { hostname: o = "" } = n;
    return o;
  }
  isForceWatermark() {
    const n = (this.document.defaultView || window).location, { pathname: o } = n;
    return o ? o.indexOf("forceWatermark") !== -1 : !1;
  }
  isWebsiteUrl() {
    return this.getHostname().match(/^((?:[\w-]+\.)?ag-grid\.com)$/) !== null;
  }
  isLocalhost() {
    return this.getHostname().match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
  }
  static formatDate(t) {
    const n = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ], o = t.getDate(), s = t.getMonth(), i = t.getFullYear();
    return o + " " + n[s] + " " + i;
  }
  static getGridReleaseDate() {
    return new Date(parseInt(yn.decode(yn.RELEASE_INFORMATION), 10));
  }
  static decode(t) {
    const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let o = "", s, i, r, a, l, d, c, u = 0;
    const h = t.replace(/[^A-Za-z0-9+/=]/g, "");
    for (; u < h.length; )
      a = n.indexOf(h.charAt(u++)), l = n.indexOf(h.charAt(u++)), d = n.indexOf(h.charAt(u++)), c = n.indexOf(h.charAt(u++)), s = a << 2 | l >> 4, i = (l & 15) << 4 | d >> 2, r = (d & 3) << 6 | c, o = o + String.fromCharCode(s), d != 64 && (o = o + String.fromCharCode(i)), c != 64 && (o = o + String.fromCharCode(r));
    return o = yn.utf8_decode(o), o;
  }
  static utf8_decode(t) {
    t = t.replace(/rn/g, "n");
    let n = "";
    for (let o = 0; o < t.length; o++) {
      const s = t.charCodeAt(o);
      s < 128 ? n += String.fromCharCode(s) : s > 127 && s < 2048 ? (n += String.fromCharCode(s >> 6 | 192), n += String.fromCharCode(s & 63 | 128)) : (n += String.fromCharCode(s >> 12 | 224), n += String.fromCharCode(s >> 6 & 63 | 128), n += String.fromCharCode(s & 63 | 128));
    }
    return n;
  }
  static setChartsLicenseManager(t) {
    var n;
    this.chartsLicenseManager = t, (n = this.chartsLicenseManager) == null || n.setLicenseKey(this.licenseKey, !0);
  }
  static setLicenseKey(t) {
    var n;
    this.licenseKey = t, (n = this.chartsLicenseManager) == null || n.setLicenseKey(t, !0);
  }
  static extractBracketedInformation(t) {
    if (!t.includes("["))
      return ["legacy", !1, void 0];
    const n = t.match(/\[(.*?)\]/g).map((a) => a.replace("[", "").replace("]", ""));
    if (!n || n.length === 0)
      return ["legacy", !1, void 0];
    const o = n.filter((a) => a === "TRIAL").length === 1, s = n.filter((a) => a.indexOf("v") === 0)[0], i = s ? s.replace("v", "") : "legacy", r = Ml[n.filter((a) => Ml[a])[0]];
    return [i, o, r];
  }
  centerPadAndOutput(t) {
    const n = this.totalMessageLength - t.length;
    console.error(t.padStart(n / 2 + t.length, "*").padEnd(this.totalMessageLength, "*"));
  }
  padAndOutput(t, n = "*", o = "") {
    console.error(
      t.padEnd(this.totalMessageLength - o.length, n) + o
    );
  }
  outputInvalidLicenseKey(t, n, o) {
    t ? (this.centerPadAndOutput(""), this.centerPadAndOutput(` ${n} License `), this.centerPadAndOutput(" Incompatible License Key "), this.padAndOutput(
      `* Your license key is for ${o} only and does not cover you for ${n}.`,
      " ",
      "*"
    ), this.padAndOutput(`* To troubleshoot your license key visit ${m0}.`, " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput("")) : (this.centerPadAndOutput(""), this.centerPadAndOutput(` ${n} License `), this.centerPadAndOutput(" Invalid License Key "), this.padAndOutput("* Your license key is not valid.", " ", "*"), this.padAndOutput(`* To troubleshoot your license key visit ${m0}.`, " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput("")), this.watermarkMessage = "Invalid License";
  }
  outputExpiredTrialKey(t, n, o) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${n} License `), this.centerPadAndOutput(" Trial Period Expired. "), this.padAndOutput(
      `* Your trial only license for ${o} expired on ${t}.`,
      " ",
      "*"
    ), this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "Trial Period Expired";
  }
  outputMissingLicenseKey(t) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${t} License `), this.centerPadAndOutput(" License Key Not Found "), this.padAndOutput(`* All ${t} features are unlocked for trial.`, " ", "*"), this.padAndOutput(
      "* If you want to hide the watermark please email info@ag-grid.com for a trial license key.",
      " ",
      "*"
    ), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "For Trial Use Only";
  }
  outputExpiredKey(t, n, o, s) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${o} License `), this.centerPadAndOutput(" Incompatible Software Version "), this.padAndOutput(
      `* Your license key works with versions${s == "" ? "" : ` of ${s}`} released before ${t}.`,
      " ",
      "*"
    ), this.padAndOutput(`* The version you are trying to use was released on ${n}.`, " ", "*"), this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "License Expired";
  }
};
Cb.RELEASE_INFORMATION = "MTc1NzA4ODUwMDMzNw==";
var Il = Cb, i7 = (
  /*css*/
  '.ag-watermark{bottom:20px;color:#9b9b9b;opacity:.7;position:absolute;transition:opacity 1s ease-out 3s;&:before{background-image:url("data:image/svg+xml;base64,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");background-repeat:no-repeat;background-size:170px 40px;content:"";display:block;height:40px;width:170px}}:where(.ag-ltr) .ag-watermark{right:25px}:where(.ag-rtl) .ag-watermark{left:25px}.ag-watermark-text{font-family:Impact,sans-serif;font-size:19px;font-weight:700;opacity:.5}:where(.ag-ltr) .ag-watermark-text{padding-left:.7rem}:where(.ag-rtl) .ag-watermark-text{padding-right:.7rem}'
), r7 = {
  tag: "div",
  cls: "ag-watermark",
  children: [{ tag: "div", ref: "eLicenseTextRef", cls: "ag-watermark-text" }]
}, a7 = class extends Te {
  constructor() {
    super(r7), this.eLicenseTextRef = X, this.registerCSS(i7);
  }
  wireBeans(e) {
    this.licenseManager = e.licenseManager;
  }
  postConstruct() {
    const e = this.shouldDisplayWatermark();
    this.setDisplayed(e), e && (this.eLicenseTextRef.textContent = this.licenseManager.getWatermarkMessage(), window.setTimeout(() => this.addCss("ag-opacity-zero"), 0), window.setTimeout(() => this.setDisplayed(!1), 5e3));
  }
  shouldDisplayWatermark() {
    return this.licenseManager.isDisplayWatermark();
  }
}, l7 = {
  selector: "AG-WATERMARK",
  component: a7
}, wb = class extends U {
  constructor() {
    super(...arguments), this.beanName = "licenseManager";
  }
  postConstruct() {
    this.validateLicense();
  }
  validateLicense() {
    this.licenseManager = new Il(Bt(this.beans)), this.licenseManager.validateLicense();
  }
  static getLicenseDetails(e) {
    return new Il(null).getLicenseDetails(e);
  }
  getWatermarkSelector() {
    return l7;
  }
  isDisplayWatermark() {
    return this.licenseManager.isDisplayWatermark();
  }
  getWatermarkMessage() {
    return this.licenseManager.getWatermarkMessage();
  }
  static setLicenseKey(e) {
    Il.setLicenseKey(e);
  }
  static setChartsLicenseManager(e) {
    Il.setChartsLicenseManager(e);
  }
}, gt = "34.2.0", an = {
  moduleName: "EnterpriseCore",
  version: gt,
  beans: [wb],
  icons: {
    // accordion open (filter tool panel group, charts group)
    accordionOpen: "tree-open",
    // accordion closed (filter tool panel group, charts group)
    accordionClosed: "tree-closed",
    // accordion indeterminate - shown when some children are expanded and
    //     others are collapsed (filter tool panel group, charts group)
    accordionIndeterminate: "tree-indeterminate",
    // dialog title bar
    close: "cross",
    // X (remove) on column 'pill' after adding it to a drop zone list
    cancel: "cancel",
    // button in chart regular size window title bar (click to maximise)
    maximize: "maximize",
    // button in chart maximised window title bar (click to make regular size)
    minimize: "minimize",
    // drag handle used to pick up draggable columns
    columnDrag: "grip"
  },
  dependsOn: []
}, d7 = (
  /*css*/
  '.ag-advanced-filter-header{align-items:center;background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);display:flex;position:relative}.ag-advanced-filter{align-items:center;display:flex;width:100%}.ag-advanced-filter-buttons{display:contents}.ag-advanced-filter-header-cell{height:100%;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{align-items:center;background-color:unset;border:0;display:flex;font-size:var(--ag-font-size);font-weight:600;line-height:normal;padding:var(--ag-spacing);white-space:nowrap;&:where(:not(:disabled)){cursor:pointer;&:hover{background-color:var(--ag-row-hover-color)}}}:where(.ag-ltr) .ag-advanced-filter-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-advanced-filter-builder-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-advanced-filter-builder-button-label{margin-right:var(--ag-spacing)}.ag-advanced-filter-builder{display:flex;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-button-panel{border-top:var(--ag-advanced-filter-builder-button-bar-border);display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-advanced-filter-builder-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-builder-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-cancel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-advanced-filter-builder-item-wrapper{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;overflow:hidden}:where(.ag-ltr) .ag-advanced-filter-builder-item-wrapper{padding-left:calc(var(--ag-icon-size)/2);padding-right:var(--ag-icon-size)}:where(.ag-rtl) .ag-advanced-filter-builder-item-wrapper{padding-left:var(--ag-icon-size);padding-right:calc(var(--ag-icon-size)/2)}:where(.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper) .ag-tab-guard{position:absolute}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size);&:before{height:50%;top:50%}}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-bottom,.ag-advanced-filter-builder-item-tree-line-vertical-top{align-items:center;display:flex;height:100%;position:relative;&:after,&:before{content:"";height:100%;position:absolute}}.ag-advanced-filter-builder-item-tree-line-horizontal:after{border-bottom:var(--ag-border-width) solid var(--ag-border-color);height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size))}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-horizontal:after{left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-horizontal:after{right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical:before{top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc(50% - var(--ag-icon-size)*1.5/2);top:calc(50% + var(--ag-icon-size)*1.5/2);width:calc(var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-condition{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-item-tree-lines,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-pill-wrapper{align-items:center;display:flex;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0 var(--ag-spacing)}.ag-advanced-filter-builder-pill{border-radius:var(--ag-border-radius);min-height:calc(100% - var(--ag-spacing)*3);min-width:calc(var(--ag-spacing)*2);padding:var(--ag-spacing) calc(var(--ag-spacing)*2);position:relative}:where(.ag-advanced-filter-builder-pill){.ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-value-empty{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-left:var(--ag-spacing)}}.ag-advanced-filter-builder-pill-display{font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-advanced-filter-builder-join-pill{background-color:var(--ag-advanced-filter-builder-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{background-color:var(--ag-advanced-filter-builder-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{background-color:var(--ag-advanced-filter-builder-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{background-color:var(--ag-advanced-filter-builder-value-pill-color);cursor:text;max-width:140px;:where(.ag-advanced-filter-builder-pill-display){display:block}}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-spacing)*.5)}.ag-advanced-filter-builder-item-button{color:var(--ag-subtle-text-color);cursor:pointer;position:relative}.ag-advanced-filter-builder-item-button,.ag-advanced-filter-builder-pill{&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-advanced-filter-builder-item-button-disabled{cursor:default;opacity:.5}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-spacing)}.ag-advanced-filter-builder-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:hover{background-color:var(--ag-row-hover-color);:where(.ag-advanced-filter-builder-item-button){opacity:1}}}.ag-advanced-filter-builder-invalid{color:var(--ag-subtle-text-color);cursor:default;margin:0 var(--ag-spacing)}:where(.ag-advanced-filter-builder-validation) .ag-advanced-filter-builder-invalid{color:var(--ag-invalid-color)}:where(.ag-advanced-filter-builder-virtual-list-item-highlight) .ag-advanced-filter-builder-item-button:focus-visible{opacity:1}'
);
function c7(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getAdvFilterModel()) ?? null;
}
function u7(e, t) {
  var n;
  (n = e.filterManager) == null || n.setAdvFilterModel(t);
}
function h7(e) {
  var t;
  (t = e.filterManager) == null || t.toggleAdvFilterBuilder(!0, "api");
}
function g7(e) {
  var t;
  (t = e.filterManager) == null || t.toggleAdvFilterBuilder(!1, "api");
}
var p7 = {
  ariaAdvancedFilterBuilderItem: (e) => `${e[0]}. Level ${e[1]}. Press ENTER to edit`,
  ariaAdvancedFilterBuilderItemValidation: (e) => `${e[0]}. Level ${e[1]}. ${e[2]} Press ENTER to edit`,
  ariaAdvancedFilterBuilderList: "Advanced Filter Builder List",
  ariaAdvancedFilterBuilderFilterItem: "Filter Condition",
  ariaAdvancedFilterBuilderGroupItem: "Filter Group",
  ariaAdvancedFilterBuilderColumn: "Column",
  ariaAdvancedFilterBuilderOption: "Option",
  ariaAdvancedFilterBuilderValue: "Value",
  ariaAdvancedFilterBuilderJoinOperator: "Join Operator",
  ariaAdvancedFilterInput: "Advanced Filter Input",
  ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
  advancedFilterContains: "contains",
  advancedFilterNotContains: "does not contain",
  advancedFilterTextEquals: "equals",
  advancedFilterTextNotEqual: "does not equal",
  advancedFilterStartsWith: "begins with",
  advancedFilterEndsWith: "ends with",
  advancedFilterBlank: "is blank",
  advancedFilterNotBlank: "is not blank",
  advancedFilterEquals: "=",
  advancedFilterNotEqual: "!=",
  advancedFilterGreaterThan: ">",
  advancedFilterGreaterThanOrEqual: ">=",
  advancedFilterLessThan: "<",
  advancedFilterLessThanOrEqual: "<=",
  advancedFilterTrue: "is true",
  advancedFilterFalse: "is false",
  advancedFilterAnd: "AND",
  advancedFilterOr: "OR",
  advancedFilterApply: "Apply",
  advancedFilterReset: "Reset",
  advancedFilterCancel: "Cancel",
  advancedFilterClear: "Clear",
  advancedFilterBuilder: "Builder",
  advancedFilterValidationMissingColumn: "Column is missing",
  advancedFilterValidationMissingOption: "Option is missing",
  advancedFilterValidationMissingValue: "Value is missing",
  advancedFilterValidationInvalidColumn: "Column not found",
  advancedFilterValidationInvalidOption: "Option not found",
  advancedFilterValidationMissingQuote: "Value is missing an end quote",
  advancedFilterValidationNotANumber: "Value is not a number",
  advancedFilterValidationInvalidDate: "Value is not a valid date",
  advancedFilterValidationMissingCondition: "Condition is missing",
  advancedFilterValidationJoinOperatorMismatch: "Join operators within a condition must be the same",
  advancedFilterValidationInvalidJoinOperator: "Join operator not found",
  advancedFilterValidationMissingEndBracket: "Missing end bracket",
  advancedFilterValidationExtraEndBracket: "Too many end brackets",
  advancedFilterValidationMessage: (e) => `Expression has an error. ${e[0]} - ${e[1]}.`,
  advancedFilterValidationMessageAtEnd: (e) => `Expression has an error. ${e[0]} at end of expression.`,
  advancedFilterBuilderTitle: "Advanced Filter",
  advancedFilterBuilderApply: "Apply",
  advancedFilterBuilderCancel: "Cancel",
  advancedFilterBuilderClear: "Clear",
  advancedFilterBuilderReset: "Reset",
  advancedFilterBuilderAddButtonTooltip: "Add Filter or Group",
  advancedFilterBuilderRemoveButtonTooltip: "Remove",
  advancedFilterBuilderMoveUpButtonTooltip: "Move Up",
  advancedFilterBuilderMoveDownButtonTooltip: "Move Down",
  advancedFilterBuilderAddJoin: "Add Group",
  advancedFilterBuilderAddCondition: "Add Filter",
  advancedFilterBuilderSelectColumn: "Select a column",
  advancedFilterBuilderSelectOption: "Select an option",
  advancedFilterBuilderEnterValue: "Enter a value...",
  advancedFilterBuilderValidationAlreadyApplied: "Current filter already applied.",
  advancedFilterBuilderValidationIncomplete: "Not all conditions are complete.",
  advancedFilterBuilderValidationSelectColumn: "Must select a column.",
  advancedFilterBuilderValidationSelectOption: "Must select an option.",
  advancedFilterBuilderValidationEnterValue: "Must enter a value."
};
function Zh(e, t, n) {
  if (!e)
    return "";
  const o = n - t;
  return o ? e.slice(0, e.length - o) : e;
}
function xs(e, t, n, o, s, i, r) {
  const a = n + (!e.length || r ? 0 : 1);
  let l = 0;
  return s && (e[a] === " " ? l = 1 : (o += " ", i && (o += '"'))), { updatedValue: e.slice(0, t) + o + e.slice(a), updatedPosition: t + o.length + l };
}
function f7(e, t, n) {
  let o = t;
  for (; o < n && e[o] === " "; )
    o++;
  return o;
}
function qh(e, t, n, o) {
  let s = t, i = !1;
  for (; s < e.length; ) {
    const r = e[s];
    if (r === "(") {
      o && e[s - 1] === " " ? i = !0 : s = s - 1;
      break;
    } else if (r === " " || n && r === ")") {
      s = s - 1;
      break;
    }
    s++;
  }
  return { endPosition: s, isEmpty: i };
}
function Zp(e, t, n, o) {
  n !== t && (e.expression = xs(
    e.expression,
    o - t.length + 1,
    o,
    n
  ).updatedValue);
}
var m7 = class {
  constructor(e, t) {
    this.params = e, this.startPosition = t, this.type = "column", this.valid = !0, this.hasStartChar = !1, this.hasEndChar = !1, this.colName = "";
  }
  parse(e, t) {
    if (e === jh && !this.colName)
      this.hasStartChar = !0;
    else if (e === Yh && this.hasStartChar) {
      if (this.parseColumn(!1, t))
        return this.hasEndChar = !0, !1;
      this.colName += e;
    } else
      this.colName += e;
  }
  getDisplayValue() {
    return (this.hasStartChar ? jh : "") + this.colName + (this.hasEndChar ? Yh : "");
  }
  getColId() {
    return this.colId;
  }
  complete(e) {
    this.parseColumn(!0, e);
  }
  getValidationError() {
    return this.valid ? null : {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidColumn"),
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    };
  }
  parseColumn(e, t) {
    var o;
    this.endPosition = t;
    const n = this.params.advFilterExpSvc.getColId(this.colName);
    return n && this.hasStartChar && (this.colId = n.colId, Zp(this.params, this.colName, n.columnName, t - 1), this.colName = n.columnName, this.column = this.params.colModel.getColDefCol(this.colId), this.column) ? (this.baseCellDataType = ((o = this.params.dataTypeSvc) == null ? void 0 : o.getBaseDataType(this.column)) ?? "text", !0) : (e && (this.valid = !1), this.baseCellDataType = "text", !1);
  }
}, v7 = class {
  constructor(e, t, n) {
    this.params = e, this.startPosition = t, this.baseCellDataType = n, this.type = "operator", this.valid = !0, this.expectedNumOperands = 0, this.operator = "";
  }
  parse(e, t) {
    if (e === " " || e === ")") {
      if (this.parseOperator(!1, t - 1))
        return !0;
      this.operator += e;
    } else
      this.operator += e;
  }
  complete(e) {
    this.parseOperator(!0, e);
  }
  getValidationError() {
    return this.valid ? null : {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidOption"),
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    };
  }
  getDisplayValue() {
    return this.operator;
  }
  getOperatorKey() {
    return this.parsedOperator;
  }
  parseOperator(e, t) {
    const n = this.params.advFilterExpSvc.getDataTypeExpressionOperator(this.baseCellDataType), o = n.findOperator(this.operator);
    if (this.endPosition = t, o) {
      this.parsedOperator = o;
      const i = n.operators[o];
      this.expectedNumOperands = i.numOperands;
      const r = i.displayValue;
      return Zp(this.params, this.operator, r, t), this.operator = r, !0;
    }
    return (e || !(o === null)) && (this.valid = !1), !1;
  }
}, C7 = class {
  constructor(e, t, n, o) {
    this.params = e, this.startPosition = t, this.baseCellDataType = n, this.column = o, this.type = "operand", this.valid = !0, this.operand = "", this.validationMessage = null, this.filterValidationSetters = {
      number: () => {
        (this.quotes || isNaN(this.modelValue)) && (this.valid = !1, this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationNotANumber"));
      },
      date: (s) => {
        s == null && (this.valid = !1, this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidDate"));
      },
      dateString: (...s) => this.filterValidationSetters.date(...s),
      dateTime: (...s) => this.filterValidationSetters.date(...s),
      dateTimeString: (...s) => this.filterValidationSetters.date(...s),
      boolean() {
      },
      object() {
      },
      text() {
      }
    };
  }
  parse(e, t) {
    if (e === " ")
      if (this.quotes)
        this.operand += e;
      else
        return this.parseOperand(!1, t), !0;
    else if (e === ")") {
      if (this.baseCellDataType === "number" || !this.quotes)
        return this.parseOperand(!1, t - 1), !0;
      this.operand += e;
    } else if (!this.operand && !this.quotes && (e === "'" || e === '"'))
      this.quotes = e;
    else {
      if (this.quotes && e === this.quotes)
        return this.parseOperand(!1, t), !1;
      this.operand += e;
    }
  }
  complete(e) {
    this.parseOperand(!0, e);
  }
  getValidationError() {
    return this.validationMessage ? {
      message: this.validationMessage,
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    } : null;
  }
  getRawValue() {
    return this.operand;
  }
  getModelValue() {
    return this.modelValue;
  }
  parseOperand(e, t) {
    const { advFilterExpSvc: n } = this.params;
    if (this.endPosition = t, this.modelValue = this.operand, e && this.quotes)
      this.valid = !1, this.validationMessage = n.translate("advancedFilterValidationMissingQuote");
    else if (this.modelValue === "")
      this.valid = !1, this.validationMessage = n.translate("advancedFilterValidationMissingValue");
    else {
      const o = n.getOperandModelValue(this.operand, this.baseCellDataType, this.column);
      o != null && (this.modelValue = o), this.filterValidationSetters[this.baseCellDataType](o);
    }
  }
}, jh = "[", Yh = "]", w7 = class {
  constructor(e, t) {
    this.params = e, this.startPosition = t, this.isAwaiting = !0, this.operandValueGetters = {
      number: Number,
      date: (n) => this.params.valueSvc.parseValue(this.columnParser.column, null, n, void 0),
      dateString: (...n) => this.operandValueGetters.date(...n),
      dateTime: (...n) => this.operandValueGetters.date(...n),
      dateTimeString: (...n) => this.operandValueGetters.date(...n),
      boolean: (n) => n,
      object: (n) => n,
      text: (n) => n
    };
  }
  parseExpression() {
    var n, o;
    let e = this.startPosition;
    const { expression: t } = this.params;
    for (; e < t.length; ) {
      const s = t[e];
      if (!(s === " " && this.isAwaiting)) {
        if (this.isAwaiting = !1, !this.parser) {
          let r;
          this.columnParser ? this.operatorParser ? (this.operandParser = new C7(
            this.params,
            e,
            this.columnParser.baseCellDataType,
            this.columnParser.column
          ), r = this.operandParser) : (this.operatorParser = new v7(this.params, e, this.columnParser.baseCellDataType), r = this.operatorParser) : (this.columnParser = new m7(this.params, e), r = this.columnParser), this.parser = r;
        }
        const i = this.parser.parse(s, e);
        if (i != null) {
          if (this.isComplete())
            return this.returnEndPosition(i ? e - 1 : e, !0);
          this.parser = void 0, this.isAwaiting = !0;
        }
      }
      e++;
    }
    return (o = (n = this.parser) == null ? void 0 : n.complete) == null || o.call(n, e - 1), this.returnEndPosition(e);
  }
  isValid() {
    return this.isComplete() && this.columnParser.valid && this.operatorParser.valid && (!this.operandParser || this.operandParser.valid);
  }
  getValidationError() {
    var o, s, i;
    const e = ((o = this.columnParser) == null ? void 0 : o.getValidationError()) ?? ((s = this.operatorParser) == null ? void 0 : s.getValidationError()) ?? ((i = this.operandParser) == null ? void 0 : i.getValidationError());
    if (e)
      return e;
    const t = this.params.expression.length;
    let n;
    return this.columnParser ? this.operatorParser ? this.operatorParser.expectedNumOperands && !this.operandParser && (n = "advancedFilterValidationMissingValue") : n = "advancedFilterValidationMissingOption" : n = "advancedFilterValidationMissingColumn", n ? {
      message: this.params.advFilterExpSvc.translate(n),
      startPosition: t,
      endPosition: t
    } : null;
  }
  getFunction(e) {
    return this.getFunctionCommon(e, (t, n, o, s) => (i, r, a) => a.operators[n].evaluator(
      i.getValue(o, r),
      r,
      a.evaluatorParams[s],
      t == null ? void 0 : a.operands[t]
    ));
  }
  getAutocompleteListParams(e) {
    if (this.isColumnPosition(e))
      return this.getColumnAutocompleteListParams(e);
    if (this.isOperatorPosition(e))
      return this.getOperatorAutocompleteListParams(e);
    if (!this.isBeyondEndPosition(e))
      return { enabled: !1 };
  }
  updateExpression(e, t, n) {
    var s, i, r;
    const { expression: o } = this.params;
    if (this.isColumnPosition(e))
      return xs(
        this.params.expression,
        this.startPosition,
        (s = this.columnParser) != null && s.getColId() ? this.columnParser.endPosition : qh(o, e).endPosition,
        this.params.advFilterExpSvc.getColumnValue(t),
        !0
      );
    if (this.isOperatorPosition(e)) {
      const a = this.getBaseCellDataTypeFromOperatorAutocompleteType(n), l = this.hasOperand(a, t.key), d = l && this.doesOperandNeedQuotes(a);
      let c;
      if (((i = this.operatorParser) == null ? void 0 : i.startPosition) != null && e < this.operatorParser.startPosition)
        c = xs(
          o,
          e,
          e,
          t.displayValue ?? t.key,
          l,
          d
        );
      else {
        let u, h = !1;
        if ((r = this.operatorParser) != null && r.getOperatorKey())
          u = this.operatorParser.endPosition;
        else {
          const { endPosition: g, isEmpty: p } = qh(
            o,
            e,
            !0,
            !0
          );
          u = g, h = p;
        }
        c = xs(
          o,
          f7(o, this.columnParser.endPosition + 1, u),
          u,
          t.displayValue ?? t.key,
          l,
          d,
          h
        );
      }
      return { ...c, hideAutocomplete: !l };
    }
    return null;
  }
  getModel() {
    const e = this.columnParser.getColId(), t = {
      filterType: this.columnParser.baseCellDataType,
      colId: e,
      type: this.operatorParser.getOperatorKey()
    };
    return this.operatorParser.expectedNumOperands && (t.filter = this.operandParser.getModelValue()), t;
  }
  getFunctionCommon(e, t) {
    var h, g;
    const n = this.columnParser.getColId(), o = (h = this.operatorParser) == null ? void 0 : h.getOperatorKey(), { operators: s, evaluatorParams: i, operands: r } = e, a = this.params.advFilterExpSvc.getExpressionOperator(
      this.columnParser.baseCellDataType,
      o
    ), l = this.addToListAndGetIndex(s, a), d = this.params.advFilterExpSvc.getExpressionEvaluatorParams(n), c = this.addToListAndGetIndex(i, d), u = ((g = this.operatorParser) == null ? void 0 : g.expectedNumOperands) === 0 ? void 0 : this.addToListAndGetIndex(r, this.getOperandValue());
    return t(u, l, n, c);
  }
  getOperandValue() {
    var o;
    const { baseCellDataType: e, column: t } = this.columnParser, n = this.operandValueGetters[e](this.operandParser.getRawValue());
    return e === "dateString" || e === "dateTimeString" ? ((o = this.params.dataTypeSvc) == null ? void 0 : o.getDateParserFunction(t)(n)) ?? n : n;
  }
  isComplete() {
    return !!(this.operatorParser && (!this.operatorParser.expectedNumOperands || this.operatorParser.expectedNumOperands && this.operandParser));
  }
  isColumnPosition(e) {
    return !this.columnParser || this.columnParser.endPosition == null || e <= this.columnParser.endPosition + 1;
  }
  isOperatorPosition(e) {
    return !this.operatorParser || this.operatorParser.endPosition == null || e <= this.operatorParser.endPosition + 1;
  }
  isBeyondEndPosition(e) {
    return this.isComplete() && this.endPosition != null && e > this.endPosition + 1 && this.endPosition + 1 < this.params.expression.length;
  }
  returnEndPosition(e, t) {
    return this.endPosition = t ? e : e - 1, e;
  }
  getColumnAutocompleteListParams(e) {
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getColumnAutocompleteEntries(),
      "column",
      this.getColumnSearchString(e)
    );
  }
  getColumnSearchString(e) {
    var i, r, a, l;
    const t = ((i = this.columnParser) == null ? void 0 : i.getDisplayValue()) ?? "", n = Zh(
      t,
      e,
      ((r = this.columnParser) == null ? void 0 : r.endPosition) == null ? this.params.expression.length : this.columnParser.endPosition + 1
    ), o = ((a = this.columnParser) == null ? void 0 : a.hasStartChar) && n.length > 0, s = ((l = this.columnParser) == null ? void 0 : l.hasEndChar) && n.length === t.length + 2;
    return o ? n.slice(1, s ? -1 : void 0) : n;
  }
  getOperatorAutocompleteListParams(e) {
    var s, i, r, a;
    const t = (s = this.columnParser) == null ? void 0 : s.column;
    if (!t)
      return { enabled: !1 };
    const n = this.columnParser.baseCellDataType, o = ((i = this.operatorParser) == null ? void 0 : i.startPosition) != null && e < this.operatorParser.startPosition ? "" : Zh(
      ((r = this.operatorParser) == null ? void 0 : r.getDisplayValue()) ?? "",
      e,
      ((a = this.operatorParser) == null ? void 0 : a.endPosition) == null ? this.params.expression.length : this.operatorParser.endPosition + 1
    );
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getOperatorAutocompleteEntries(t, n),
      `operator-${n}`,
      o
    );
  }
  getBaseCellDataTypeFromOperatorAutocompleteType(e) {
    return e == null ? void 0 : e.replace("operator-", "");
  }
  hasOperand(e, t) {
    var n;
    return !e || !t || (((n = this.params.advFilterExpSvc.getExpressionOperator(e, t)) == null ? void 0 : n.numOperands) ?? 0) > 0;
  }
  doesOperandNeedQuotes(e) {
    return e !== "number";
  }
  addToListAndGetIndex(e, t) {
    const n = e.length;
    return e.push(t), n;
  }
};
function Ic(e, t, n) {
  let o = !1;
  const s = e.toLocaleLowerCase(), i = s + " ", r = Object.keys(t).find((a) => {
    const l = t[a], d = n(l).toLocaleLowerCase();
    return d.startsWith(i) && (o = !0), d === s;
  });
  return r || (o ? null : void 0);
}
function qp(e, t) {
  return (t ?? Object.keys(e)).map((o) => ({
    key: o,
    displayValue: e[o].displayValue
  }));
}
var v0 = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return qp(this.operators, e);
  }
  findOperator(e) {
    return Ic(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e } = this.params;
    this.operators = {
      contains: {
        displayValue: e("advancedFilterContains"),
        evaluator: (t, n, o, s) => this.evaluateExpression(t, n, o, s, !1, (i, r) => i.includes(r)),
        numOperands: 1
      },
      notContains: {
        displayValue: e("advancedFilterNotContains"),
        evaluator: (t, n, o, s) => this.evaluateExpression(t, n, o, s, !0, (i, r) => !i.includes(r)),
        numOperands: 1
      },
      equals: {
        displayValue: e("advancedFilterTextEquals"),
        evaluator: (t, n, o, s) => this.evaluateExpression(t, n, o, s, !1, (i, r) => i === r),
        numOperands: 1
      },
      notEqual: {
        displayValue: e("advancedFilterTextNotEqual"),
        evaluator: (t, n, o, s) => this.evaluateExpression(t, n, o, s, !0, (i, r) => i != r),
        numOperands: 1
      },
      startsWith: {
        displayValue: e("advancedFilterStartsWith"),
        evaluator: (t, n, o, s) => this.evaluateExpression(t, n, o, s, !1, (i, r) => i.startsWith(r)),
        numOperands: 1
      },
      endsWith: {
        displayValue: e("advancedFilterEndsWith"),
        evaluator: (t, n, o, s) => this.evaluateExpression(t, n, o, s, !1, (i, r) => i.endsWith(r)),
        numOperands: 1
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (t) => t == null || typeof t == "string" && t.trim().length === 0,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (t) => t != null && (typeof t != "string" || t.trim().length > 0),
        numOperands: 0
      }
    };
  }
  evaluateExpression(e, t, n, o, s, i) {
    return e == null ? s : n.caseSensitive ? i(n.valueConverter(e, t), o) : i(n.valueConverter(e, t).toLocaleLowerCase(), o.toLocaleLowerCase());
  }
}, Zr = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return qp(this.operators, e);
  }
  findOperator(e) {
    return Ic(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e, equals: t } = this.params;
    this.operators = {
      equals: {
        displayValue: e("advancedFilterEquals"),
        evaluator: (n, o, s, i) => this.evaluateSingleOperandExpression(
          n,
          o,
          s,
          i,
          !!s.includeBlanksInEquals,
          t
        ),
        numOperands: 1
      },
      notEqual: {
        displayValue: e("advancedFilterNotEqual"),
        evaluator: (n, o, s, i) => this.evaluateSingleOperandExpression(
          n,
          o,
          s,
          i,
          !!s.includeBlanksInEquals,
          (r, a) => !t(r, a)
        ),
        numOperands: 1
      },
      greaterThan: {
        displayValue: e("advancedFilterGreaterThan"),
        evaluator: (n, o, s, i) => this.evaluateSingleOperandExpression(
          n,
          o,
          s,
          i,
          !!s.includeBlanksInGreaterThan,
          (r, a) => r > a
        ),
        numOperands: 1
      },
      greaterThanOrEqual: {
        displayValue: e("advancedFilterGreaterThanOrEqual"),
        evaluator: (n, o, s, i) => this.evaluateSingleOperandExpression(
          n,
          o,
          s,
          i,
          !!s.includeBlanksInGreaterThan,
          (r, a) => r >= a
        ),
        numOperands: 1
      },
      lessThan: {
        displayValue: e("advancedFilterLessThan"),
        evaluator: (n, o, s, i) => this.evaluateSingleOperandExpression(
          n,
          o,
          s,
          i,
          !!s.includeBlanksInLessThan,
          (r, a) => r < a
        ),
        numOperands: 1
      },
      lessThanOrEqual: {
        displayValue: e("advancedFilterLessThanOrEqual"),
        evaluator: (n, o, s, i) => this.evaluateSingleOperandExpression(
          n,
          o,
          s,
          i,
          !!s.includeBlanksInLessThan,
          (r, a) => r <= a
        ),
        numOperands: 1
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (n) => n == null,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (n) => n != null,
        numOperands: 0
      }
    };
  }
  evaluateSingleOperandExpression(e, t, n, o, s, i) {
    return e == null ? s : i(n.valueConverter(e, t), o);
  }
}, y7 = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return qp(this.operators, e);
  }
  findOperator(e) {
    return Ic(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e } = this.params;
    this.operators = {
      true: {
        displayValue: e("advancedFilterTrue"),
        evaluator: (t) => !!t,
        numOperands: 0
      },
      false: {
        displayValue: e("advancedFilterFalse"),
        evaluator: (t) => t === !1,
        numOperands: 0
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (t) => t == null,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (t) => t != null,
        numOperands: 0
      }
    };
  }
}, b7 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "advFilterExpSvc", this.filterOperandGetters = {
      number: (e) => Pn(e.filter) ?? "",
      date: (e) => {
        const t = this.colModel.getColDefCol(e.colId);
        return t ? this.valueSvc.formatValue(t, null, Qt(e.filter)) : null;
      },
      dateTime: (e) => this.filterOperandGetters.date(e),
      dateString: (e) => {
        var i;
        const t = this.colModel.getColDefCol(e.colId);
        if (!t)
          return null;
        const { filter: n } = e, o = (i = this.dataTypeSvc) == null ? void 0 : i.getDateFormatterFunction(t), s = (o == null ? void 0 : o(Qt(n) ?? void 0)) ?? n;
        return this.valueSvc.formatValue(t, null, s);
      },
      dateTimeString: (e) => this.filterOperandGetters.dateString(e),
      boolean: () => null,
      object: () => null,
      text: () => null
    }, this.operandModelValueGetters = {
      number: (e) => ue(e) ? Number(e) : null,
      date: (e, t, n) => {
        var o;
        return un(
          this.valueSvc.parseValue(t, null, e, void 0),
          !!((o = this.dataTypeSvc) != null && o.getDateIncludesTimeFlag(n))
        );
      },
      dateTime: (...e) => this.operandModelValueGetters.date(...e),
      dateString: (e, t, n) => {
        const o = this.valueSvc.parseValue(t, null, e, void 0);
        return this.dataTypeSvc ? un(
          this.dataTypeSvc.getDateParserFunction(t)(o) ?? null,
          this.dataTypeSvc.getDateIncludesTimeFlag(n)
        ) : o;
      },
      dateTimeString: (...e) => this.operandModelValueGetters.dateString(...e),
      boolean: (e) => e,
      object: (e) => e,
      text: (e) => e
    }, this.columnNameToIdMap = {}, this.columnAutocompleteEntries = null, this.expressionEvaluatorParams = {};
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.colNames = e.colNames, this.dataTypeSvc = e.dataTypeSvc;
  }
  postConstruct() {
    this.expressionJoinOperators = this.generateExpressionJoinOperators(), this.expressionOperators = this.generateExpressionOperators();
  }
  parseJoinOperator(e) {
    const { type: t } = e;
    return this.expressionJoinOperators[t] ?? t;
  }
  getColumnDisplayValue(e) {
    const { colId: t } = e, o = this.getColumnAutocompleteEntries().find(({ key: i }) => i === t);
    let s;
    return o ? (s = o.displayValue, this.columnNameToIdMap[s.toLocaleUpperCase()] = { colId: t, columnName: s }) : s = t, s;
  }
  getOperatorDisplayValue(e) {
    var t;
    return ((t = this.getExpressionOperator(e.filterType, e.type)) == null ? void 0 : t.displayValue) ?? e.type;
  }
  getOperandModelValue(e, t, n) {
    return this.operandModelValueGetters[t](e, n, t);
  }
  getOperandDisplayValue(e, t) {
    const { filter: n } = e;
    if (n == null)
      return "";
    let o = this.filterOperandGetters[e.filterType](e);
    return e.filterType !== "number" && (o ?? (o = Pn(n) ?? ""), t || (o = `"${o}"`)), t ? o : ` ${o}`;
  }
  parseColumnFilterModel(e) {
    const t = this.getColumnDisplayValue(e) ?? "", n = this.getOperatorDisplayValue(e) ?? "", o = this.getOperandDisplayValue(e);
    return `[${t}] ${n}${o}`;
  }
  updateAutocompleteCache(e, t) {
    if (t === "column") {
      const { key: n, displayValue: o } = e;
      this.columnNameToIdMap[e.displayValue.toLocaleUpperCase()] = {
        colId: n,
        columnName: o
      };
    }
  }
  translate(e, t) {
    let n = p7[e];
    return typeof n == "function" && (n = n(t)), this.getLocaleTextFunc()(e, n, t);
  }
  generateAutocompleteListParams(e, t, n) {
    return {
      enabled: !0,
      type: t,
      searchString: n,
      entries: e
    };
  }
  getColumnAutocompleteEntries() {
    if (this.columnAutocompleteEntries)
      return this.columnAutocompleteEntries;
    const e = this.colModel.getColDefCols() ?? [], t = [], n = this.gos.get("includeHiddenColumnsInAdvancedFilter");
    return e.forEach((o) => {
      o.getColDef().filter && (n || o.isVisible() || o.isRowGroupActive()) && t.push({
        key: o.getColId(),
        displayValue: this.colNames.getDisplayNameForColumn(o, "advancedFilter")
      });
    }), t.sort((o, s) => {
      const i = o.displayValue ?? "", r = s.displayValue ?? "";
      return i < r ? -1 : r > i ? 1 : 0;
    }), t;
  }
  getOperatorAutocompleteEntries(e, t) {
    const n = this.getActiveOperators(e);
    return this.getDataTypeExpressionOperator(t).getEntries(n);
  }
  getJoinOperatorAutocompleteEntries() {
    return Object.entries(this.expressionJoinOperators).map(([e, t]) => ({ key: e, displayValue: t }));
  }
  getDefaultAutocompleteListParams(e) {
    return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), "column", e);
  }
  getDataTypeExpressionOperator(e) {
    return this.expressionOperators[e];
  }
  getExpressionOperator(e, t) {
    var n, o;
    return (o = (n = this.getDataTypeExpressionOperator(e)) == null ? void 0 : n.operators) == null ? void 0 : o[t];
  }
  getExpressionJoinOperators() {
    return this.expressionJoinOperators;
  }
  getColId(e) {
    const t = e.toLocaleUpperCase(), n = this.columnNameToIdMap[t];
    if (n)
      return n;
    const s = this.getColumnAutocompleteEntries().find(
      ({ displayValue: i }) => i.toLocaleUpperCase() === t
    );
    if (s) {
      const { key: i, displayValue: r } = s, a = { colId: i, columnName: r };
      return this.columnNameToIdMap[t] = a, a;
    }
    return null;
  }
  getExpressionEvaluatorParams(e) {
    var i, r;
    let t = this.expressionEvaluatorParams[e];
    if (t)
      return t;
    const n = this.colModel.getColDefCol(e);
    if (!n)
      return { valueConverter: (a) => a };
    switch ((i = this.dataTypeSvc) == null ? void 0 : i.getBaseDataType(n)) {
      case "dateTimeString":
      case "dateString":
        t = {
          valueConverter: ((r = this.dataTypeSvc) == null ? void 0 : r.getDateParserFunction(n)) ?? ((a) => a)
        };
        break;
      case "object":
        n.getColDef().filterValueGetter ? t = { valueConverter: (a) => a } : t = {
          valueConverter: (a, l) => this.valueSvc.formatValue(n, l, a) ?? (typeof a.toString == "function" ? a.toString() : "")
        };
        break;
      case "text":
      case void 0:
        t = { valueConverter: (a) => Pn(a) };
        break;
      default:
        t = { valueConverter: (a) => a };
        break;
    }
    const { filterParams: s } = n.getColDef();
    return s && ["caseSensitive", "includeBlanksInEquals", "includeBlanksInLessThan", "includeBlanksInGreaterThan"].forEach(
      (a) => {
        const l = s[a];
        l && (t[a] = l);
      }
    ), this.expressionEvaluatorParams[e] = t, t;
  }
  getColumnDetails(e) {
    var o;
    const t = this.colModel.getColDefCol(e) ?? void 0, n = (t ? (o = this.dataTypeSvc) == null ? void 0 : o.getBaseDataType(t) : void 0) ?? "text";
    return { column: t, baseCellDataType: n };
  }
  generateExpressionOperators() {
    const e = (n, o) => this.translate(n, o), t = {
      translate: e,
      equals: (n, o) => n.getTime() === o.getTime()
    };
    return {
      text: new v0({ translate: e }),
      boolean: new y7({ translate: e }),
      object: new v0({ translate: e }),
      number: new Zr({ translate: e, equals: (n, o) => n === o }),
      date: new Zr(t),
      dateString: new Zr(t),
      dateTime: new Zr(t),
      dateTimeString: new Zr(t)
    };
  }
  getColumnValue({ displayValue: e }) {
    return `${jh}${e}${Yh}`;
  }
  generateExpressionJoinOperators() {
    return {
      AND: this.translate("advancedFilterAnd"),
      OR: this.translate("advancedFilterOr")
    };
  }
  getActiveOperators(e) {
    var o;
    const t = (o = e.getColDef().filterParams) == null ? void 0 : o.filterOptions;
    return t && t.every((s) => typeof s == "string") ? t : void 0;
  }
  resetColumnCaches() {
    this.columnAutocompleteEntries = null, this.columnNameToIdMap = {}, this.expressionEvaluatorParams = {};
  }
}, S7 = (
  /*css*/
  ".ag-panel{background-color:var(--ag-panel-background-color);display:flex;flex-direction:column;overflow:hidden;position:relative}.ag-dialog{border:var(--ag-dialog-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dialog-shadow);position:absolute}.ag-panel-title-bar{align-items:center;background-color:var(--ag-panel-title-bar-background-color);border-bottom:var(--ag-panel-title-bar-border);color:var(--ag-panel-title-bar-text-color);cursor:default;display:flex;flex:none;font-weight:var(--ag-panel-title-bar-font-weight);height:var(--ag-header-height);padding:var(--ag-spacing) var(--ag-cell-horizontal-padding)}.ag-panel-title-bar-button{cursor:pointer;:where(.ag-icon){color:var(--ag-panel-title-bar-icon-color)}}:where(.ag-ltr) .ag-panel-title-bar-button{margin-left:calc(var(--ag-spacing)*2);margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-panel-title-bar-button{margin-left:var(--ag-spacing);margin-right:calc(var(--ag-spacing)*2)}.ag-panel-title-bar-title{flex:1 1 auto}.ag-panel-title-bar-buttons{display:flex}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;overflow:hidden;position:relative}:where(.ag-dragging-fill-handle) .ag-dialog,:where(.ag-dragging-range-handle) .ag-dialog{opacity:.7;pointer-events:none}"
);
function x7(e) {
  const t = e.cssIdentifier || "default";
  return {
    tag: "div",
    cls: `ag-panel ag-${t}-panel`,
    attrs: { tabindex: "-1" },
    children: [
      {
        tag: "div",
        ref: "eTitleBar",
        cls: `ag-panel-title-bar ag-${t}-panel-title-bar ag-unselectable`,
        children: [
          {
            tag: "span",
            ref: "eTitle",
            cls: `ag-panel-title-bar-title ag-${t}-panel-title-bar-title`
          },
          {
            tag: "div",
            ref: "eTitleBarButtons",
            cls: `ag-panel-title-bar-buttons ag-${t}-panel-title-bar-buttons`
          }
        ]
      },
      {
        tag: "div",
        ref: "eContentWrapper",
        cls: `ag-panel-content-wrapper ag-${t}-panel-content-wrapper`
      }
    ]
  };
}
var R7 = class extends Te {
  constructor(e) {
    super(x7(e)), this.config = e, this.closable = !0, this.eContentWrapper = X, this.eTitleBar = X, this.eTitleBarButtons = X, this.eTitle = X, this.registerCSS(S7);
  }
  postConstruct() {
    const {
      component: e,
      closable: t,
      hideTitleBar: n,
      title: o,
      minWidth: s = 250,
      width: i,
      minHeight: r = 250,
      height: a,
      centered: l,
      popup: d,
      x: c,
      y: u,
      postProcessPopupParams: h
    } = this.config, g = this.beans, p = this.createManagedBean(
      new Sc(this.getGui(), {
        minWidth: s,
        width: i,
        minHeight: r,
        height: a,
        centered: l,
        x: c,
        y: u,
        popup: d,
        calculateTopBuffer: () => this.positionableFeature.getHeight() - this.getBodyHeight()
      })
    );
    this.positionableFeature = p;
    const f = this.getGui();
    if (e && this.setBodyComponent(e), n ? He(this.eTitleBar, !1) : (o && this.setTitle(o), this.setClosable(t ?? this.closable)), this.addManagedElementListeners(this.eTitleBar, {
      mousedown: (C) => {
        if (f.contains(C.relatedTarget) || f.contains(je(g)) || this.eTitleBarButtons.contains(C.target)) {
          C.preventDefault();
          return;
        }
        const w = this.eContentWrapper.querySelector(
          "button, [href], input, select, textarea, [tabindex]"
        );
        w && w.focus();
      }
    }), d && p.isPositioned())
      return;
    this.renderComponent && this.renderComponent();
    let m;
    if (h) {
      const { type: C, eventSource: w, mouseEvent: b } = h;
      m = () => {
        var A;
        return (A = g.popupSvc) == null ? void 0 : A.callPostProcessPopup(h, C, f, w, b);
      };
    }
    p.initialisePosition(m), this.eContentWrapper.style.height = "0";
  }
  renderComponent() {
    const e = this.getGui();
    e.focus(), this.close = () => {
      e.parentElement.removeChild(e), this.destroy();
    };
  }
  getHeight() {
    return this.positionableFeature.getHeight();
  }
  setHeight(e) {
    this.positionableFeature.setHeight(e);
  }
  getWidth() {
    return this.positionableFeature.getWidth();
  }
  setWidth(e) {
    this.positionableFeature.setWidth(e);
  }
  setClosable(e) {
    if (e !== this.closable && (this.closable = e), e) {
      const t = this.closeButtonComp = new Te({ tag: "div", cls: "ag-button" });
      this.createBean(t);
      const n = t.getGui(), o = Le("close", this.beans);
      o.classList.add("ag-panel-title-bar-button-icon"), n.appendChild(o), this.addTitleBarButton(t), t.addManagedElementListeners(n, { click: this.onBtClose.bind(this) });
    } else if (this.closeButtonComp) {
      const t = this.closeButtonComp.getGui();
      t.parentElement.removeChild(t), this.closeButtonComp = this.destroyBean(this.closeButtonComp);
    }
  }
  setBodyComponent(e) {
    e.setParentComponent(this), this.eContentWrapper.appendChild(e.getGui());
  }
  addTitleBarButton(e, t) {
    const n = this.eTitleBarButtons, o = n.children, s = o.length;
    t == null && (t = s), t = Math.max(0, Math.min(t, s)), e.addCss("ag-panel-title-bar-button");
    const i = e.getGui();
    t === 0 ? n.insertAdjacentElement("afterbegin", i) : t === s ? n.insertAdjacentElement("beforeend", i) : o[t - 1].insertAdjacentElement("afterend", i), e.setParentComponent(this);
  }
  getBodyHeight() {
    return cc(this.eContentWrapper);
  }
  getBodyWidth() {
    return mr(this.eContentWrapper);
  }
  setTitle(e) {
    this.eTitle.innerText = e;
  }
  // called when user hits the 'x' in the top right
  onBtClose() {
    this.close();
  }
  destroy() {
    this.closeButtonComp && (this.closeButtonComp = this.destroyBean(this.closeButtonComp));
    const e = this.getGui();
    e && vn(e) && this.close(), super.destroy();
  }
}, yb = class extends R7 {
  constructor(e) {
    super({ ...e, popup: !0 }), this.isMaximizable = !1, this.isMaximized = !1, this.maximizeListeners = [], this.resizeListenerDestroy = null, this.lastPosition = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    const e = this.getGui(), { movable: t, resizable: n, maximizable: o, modal: s } = this.config;
    if (this.addCss("ag-dialog"), super.postConstruct(), this.tabGuardFeature = this.createManagedBean(new Xw(this)), this.tabGuardFeature.initialiseTabGuard({
      isFocusableContainer: !0,
      onFocusIn: () => {
        var i;
        (i = this.popupSvc) == null || i.bringPopupToFront(e);
      },
      onTabKeyDown: (i) => {
        if (s)
          return;
        const r = i.shiftKey, a = sn(this.beans, e, !1, r);
        (!a || this.tabGuardFeature.getTabGuardCtrl().isTabGuard(a)) && Do(this.beans, r) && i.preventDefault();
      }
    }), t && this.setMovable(t), o && this.setMaximizable(o), n && this.setResizable(n), !this.config.modal) {
      const i = this.beans.ctrlsSvc.get("gridCtrl");
      i.addFocusableContainer(this), this.addDestroyFunc(() => i.removeFocusableContainer(this));
    }
  }
  setAllowFocus(e) {
    this.tabGuardFeature.getTabGuardCtrl().setAllowFocus(e);
  }
  renderComponent() {
    var a;
    const e = this.getGui(), { alwaysOnTop: t, modal: n, title: o, afterGuiAttached: s } = this.config, i = this.getLocaleTextFunc(), r = (a = this.popupSvc) == null ? void 0 : a.addPopup({
      modal: n,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: this.onClosed.bind(this),
      alwaysOnTop: t,
      ariaLabel: o || i("ariaLabelDialog", "Dialog"),
      afterGuiAttached: s
    });
    r && (this.close = r.hideFunc);
  }
  onClosed(e) {
    var t, n;
    this.destroy(), (n = (t = this.config).closedCallback) == null || n.call(t, e);
  }
  setMaximized(e) {
    this.isMaximizable && e !== this.isMaximized && this.toggleMaximize();
  }
  toggleMaximize() {
    const e = this.positionableFeature.getPosition();
    if (this.isMaximized) {
      const { x: t, y: n, width: o, height: s } = this.lastPosition;
      this.setWidth(o), this.setHeight(s), this.positionableFeature.offsetElement(t, n);
    } else
      this.lastPosition.width = this.getWidth(), this.lastPosition.height = this.getHeight(), this.lastPosition.x = e.x, this.lastPosition.y = e.y, this.positionableFeature.offsetElement(0, 0), this.setHeight("100%"), this.setWidth("100%");
    this.isMaximized = !this.isMaximized, this.refreshMaximizeIcon();
  }
  refreshMaximizeIcon() {
    He(this.maximizeIcon, !this.isMaximized), He(this.minimizeIcon, this.isMaximized);
  }
  clearMaximizebleListeners() {
    this.maximizeListeners.length && (this.maximizeListeners.forEach((e) => e()), this.maximizeListeners.length = 0), this.resizeListenerDestroy && (this.resizeListenerDestroy(), this.resizeListenerDestroy = null);
  }
  destroy() {
    this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp), this.clearMaximizebleListeners(), super.destroy();
  }
  setResizable(e) {
    this.positionableFeature.setResizable(e);
  }
  setMovable(e) {
    this.positionableFeature.setMovable(e, this.eTitleBar);
  }
  setMaximizable(e) {
    if (!e) {
      this.clearMaximizebleListeners(), this.maximizeButtonComp && (this.destroyBean(this.maximizeButtonComp), this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0);
      return;
    }
    const t = this.eTitleBar;
    if (!t || e === this.isMaximizable)
      return;
    this.isMaximizable = e;
    const n = this.buildMaximizeAndMinimizeElements();
    this.refreshMaximizeIcon(), n.addManagedElementListeners(n.getGui(), {
      click: this.toggleMaximize.bind(this)
    }), this.addTitleBarButton(n, 0), this.maximizeListeners.push(
      ...this.addManagedElementListeners(t, {
        dblclick: this.toggleMaximize.bind(this)
      })
    ), [this.resizeListenerDestroy] = this.addManagedListeners(this.positionableFeature, {
      resize: () => {
        this.isMaximized = !1, this.refreshMaximizeIcon();
      }
    });
  }
  buildMaximizeAndMinimizeElements() {
    const e = this.maximizeButtonComp = this.createBean(
      new Te({ tag: "div", cls: "ag-dialog-button" })
    ), t = e.getGui();
    return this.maximizeIcon = Le("maximize", this.beans), t.appendChild(this.maximizeIcon), this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon"), this.minimizeIcon = Le("minimize", this.beans), t.appendChild(this.minimizeIcon), this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon"), e;
  }
}, E7 = (
  /*css*/
  ".ag-autocomplete{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}}.ag-autocomplete-list-popup{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-autocomplete-list{height:calc(var(--ag-row-height)*6.5);min-width:200px;position:relative;width:100%}.ag-autocomplete-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:focus-visible:after{content:none}&:hover{background-color:var(--ag-row-hover-color)}}.ag-autocomplete-row{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}.ag-autocomplete-row-label{margin:0 var(--ag-widget-container-horizontal-padding);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}"
);
function A7(e) {
  return {
    tag: "div",
    cls: `ag-virtual-list-viewport ag-${e}-virtual-list-viewport`,
    role: "presentation",
    children: [
      {
        tag: "div",
        ref: "eContainer",
        cls: `ag-virtual-list-container ag-${e}-virtual-list-container`
      }
    ]
  };
}
var Lr = class extends Ti {
  constructor(e) {
    super(A7((e == null ? void 0 : e.cssIdentifier) || "default")), this.renderedRows = /* @__PURE__ */ new Map(), this.rowHeight = 20, this.pageSize = -1, this.isScrolling = !1, this.isHeightFromTheme = !0, this.eContainer = X, this.awaitStableCallbacks = [];
    const { cssIdentifier: t = "default", ariaRole: n = "listbox", listName: o, moveItemCallback: s } = e || {};
    this.cssIdentifier = t, this.ariaRole = n, this.listName = o, this.moveItemCallback = s;
  }
  wireBeans(e) {
    this.environment = e.environment;
  }
  postConstruct() {
    this.addScrollListener(), this.rowHeight = this.getItemHeight(), this.addResizeObserver(), this.initialiseTabGuard({
      onFocusIn: (e) => this.onFocusIn(e),
      onFocusOut: (e) => this.onFocusOut(e),
      focusInnerElement: (e) => this.focusInnerElement(e),
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    }), this.refreshAriaProperties(), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanged.bind(this) });
  }
  onGridStylesChanged(e) {
    e.listItemHeightChanged && (this.rowHeight = this.getItemHeight(), this.refresh());
  }
  refreshAriaProperties() {
    var o;
    const t = this.getLocaleTextFunc()("ariaDefaultListName", this.listName || "List"), n = this.eContainer;
    hn(n, ((o = this.model) == null ? void 0 : o.getRowCount()) > 0 ? this.ariaRole : "presentation"), yt(n, t);
  }
  addResizeObserver() {
    const e = () => kn(this.beans, () => this.drawVirtualRows()), t = Bo(this.beans, this.getGui(), e);
    this.addDestroyFunc(t);
  }
  focusInnerElement(e) {
    return this.focusRow(e ? this.model.getRowCount() - 1 : 0), !0;
  }
  onFocusIn(e) {
    const t = e.target;
    t.classList.contains("ag-virtual-list-item") && (this.lastFocusedRowIndex = YA(t) - 1);
  }
  onFocusOut(e) {
    this.getFocusableElement().contains(e.relatedTarget) || (this.lastFocusedRowIndex = null);
  }
  handleKeyDown(e) {
    const { key: t, shiftKey: n } = e;
    switch (t) {
      case O.UP:
      case O.DOWN:
        {
          const o = t === O.UP;
          e.preventDefault(), n ? this.moveItem(o) : this.navigate(o);
        }
        break;
      case O.PAGE_HOME:
      case O.PAGE_END:
      case O.PAGE_UP:
      case O.PAGE_DOWN:
        this.navigateToPage(t) !== null && e.preventDefault();
        break;
    }
  }
  onTabKeyDown(e) {
    bt(e), this.forceFocusOutOfContainer(e.shiftKey);
  }
  getNextRow(e) {
    if (this.lastFocusedRowIndex == null)
      return;
    const t = this.lastFocusedRowIndex + (e ? -1 : 1);
    if (!(t < 0 || t >= this.model.getRowCount()))
      return t;
  }
  moveItem(e) {
    if (!this.moveItemCallback)
      return;
    const t = this.getComponentAt(this.lastFocusedRowIndex);
    t && this.moveItemCallback(t, e);
  }
  navigate(e) {
    const t = this.getNextRow(e);
    t !== void 0 && this.focusRow(t);
  }
  navigateToPage(e, t = "focused") {
    let n = !1;
    t === "focused" && (t = this.getLastFocusedRow(), n = !0);
    const o = this.model.getRowCount() - 1;
    let s = -1;
    return e === O.PAGE_HOME ? s = 0 : e === O.PAGE_END ? s = o : e === O.PAGE_DOWN ? s = Math.min(t + this.pageSize, o) : e === O.PAGE_UP && (s = Math.max(t - this.pageSize, 0)), s === -1 ? null : (n ? this.focusRow(s) : this.ensureIndexVisible(s), s);
  }
  getLastFocusedRow() {
    return this.lastFocusedRowIndex;
  }
  focusRow(e) {
    this.isScrolling || (this.isScrolling = !0, this.ensureIndexVisible(e), kn(this.beans, () => {
      if (this.isScrolling = !1, !this.isAlive())
        return;
      const t = this.renderedRows.get(e);
      t && t.eDiv.focus();
    }));
  }
  getComponentAt(e) {
    const t = this.renderedRows.get(e);
    return t && t.rowComponent;
  }
  forEachRenderedRow(e) {
    this.renderedRows.forEach((t, n) => e(t.rowComponent, n));
  }
  getItemHeight() {
    return this.isHeightFromTheme ? this.environment.getDefaultListItemHeight() : this.rowHeight;
  }
  /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */
  ensureIndexVisible(e, t = !0) {
    const n = this.model.getRowCount();
    if (typeof e != "number" || e < 0 || e >= n)
      return Z(229, { index: e }), !1;
    const o = e * this.rowHeight, s = o + this.rowHeight, i = this.getGui(), r = i.scrollTop, a = i.offsetHeight, l = r + a, d = t ? 0 : this.rowHeight, c = r > o + d, u = l < s - d;
    if (c)
      return i.scrollTop = o, !0;
    if (u) {
      const h = s - a;
      return i.scrollTop = h, !0;
    }
    return !1;
  }
  setComponentCreator(e) {
    this.componentCreator = e;
  }
  setComponentUpdater(e) {
    this.componentUpdater = e;
  }
  getRowHeight() {
    return this.rowHeight;
  }
  getScrollTop() {
    return this.getGui().scrollTop;
  }
  setRowHeight(e) {
    this.isHeightFromTheme = !1, this.rowHeight = e, this.refresh();
  }
  refresh(e) {
    if (this.model == null || !this.isAlive())
      return;
    const t = this.model.getRowCount();
    this.eContainer.style.height = `${t * this.rowHeight}px`, this.refreshAriaProperties(), this.awaitStable(() => {
      this.isAlive() && (this.canSoftRefresh(e) ? this.drawVirtualRows(!0) : (this.clearVirtualRows(), this.drawVirtualRows()));
    });
  }
  awaitStable(e) {
    if (this.awaitStableCallbacks.push(e), this.awaitStableCallbacks.length > 1)
      return;
    const t = this.model.getRowCount();
    SC(
      this,
      () => this.eContainer.clientHeight >= t * this.rowHeight,
      () => {
        if (!this.isAlive())
          return;
        const n = this.awaitStableCallbacks;
        this.awaitStableCallbacks = [], n.forEach((o) => o());
      }
    );
  }
  canSoftRefresh(e) {
    return !!(e && this.renderedRows.size && typeof this.model.areRowsEqual == "function" && this.componentUpdater);
  }
  clearVirtualRows() {
    this.renderedRows.forEach((e, t) => this.removeRow(t));
  }
  drawVirtualRows(e) {
    if (!this.isAlive() || !this.model)
      return;
    const t = this.getGui(), n = t.scrollTop, o = n + t.offsetHeight;
    if (n === o)
      this.clearVirtualRows();
    else {
      const s = Math.floor(n / this.rowHeight), i = Math.floor(o / this.rowHeight);
      this.pageSize = Math.floor((o - n) / this.rowHeight), this.ensureRowsRendered(s, i, e);
    }
  }
  ensureRowsRendered(e, t, n) {
    this.renderedRows.forEach((o, s) => {
      (s < e || s > t) && s !== this.lastFocusedRowIndex && this.removeRow(s);
    }), n && this.refreshRows();
    for (let o = e; o <= t; o++)
      this.renderedRows.has(o) || o < this.model.getRowCount() && this.insertRow(o);
  }
  insertRow(e) {
    const t = this.model.getRow(e), n = this.ariaRole === "tree" ? "treeitem" : "option", o = Ue({
      tag: "div",
      cls: `ag-virtual-list-item ag-${this.cssIdentifier}-virtual-list-item`,
      role: n,
      attrs: { tabindex: "-1" }
    });
    ac(o, this.model.getRowCount()), lc(o, e + 1), o.style.height = `${this.rowHeight}px`, o.style.top = `${this.rowHeight * e}px`;
    const s = this.componentCreator(t, o);
    s.addGuiEventListener("focusin", () => this.lastFocusedRowIndex = e), o.appendChild(s.getGui()), this.renderedRows.has(e - 1) ? this.renderedRows.get(e - 1).eDiv.insertAdjacentElement("afterend", o) : this.renderedRows.has(e + 1) ? this.renderedRows.get(e + 1).eDiv.insertAdjacentElement("beforebegin", o) : this.eContainer.appendChild(o), this.renderedRows.set(e, { rowComponent: s, eDiv: o, value: t });
  }
  removeRow(e) {
    const t = this.renderedRows.get(e);
    this.eContainer.removeChild(t.eDiv), this.destroyBean(t.rowComponent), this.renderedRows.delete(e);
  }
  refreshRows() {
    const e = this.model.getRowCount();
    this.renderedRows.forEach((t, n) => {
      var o, s;
      if (n >= e)
        this.removeRow(n);
      else {
        const i = this.model.getRow(n);
        (s = (o = this.model).areRowsEqual) != null && s.call(o, t.value, i) ? this.componentUpdater(i, t.rowComponent) : this.removeRow(n);
      }
    });
  }
  addScrollListener() {
    this.addGuiEventListener("scroll", () => this.drawVirtualRows(), { passive: !0 });
  }
  setModel(e) {
    this.model = e;
  }
  getAriaElement() {
    return this.eContainer;
  }
  destroy() {
    this.isAlive() && (this.clearVirtualRows(), this.awaitStableCallbacks.length = 0, super.destroy());
  }
}, F7 = {
  tag: "div",
  cls: "ag-autocomplete-row",
  role: "presentation",
  children: [{ tag: "div", cls: "ag-autocomplete-row-label" }]
}, M7 = class extends Te {
  constructor() {
    super(F7), this.hasHighlighting = !1;
  }
  setState(e, t) {
    this.value = e, this.render(), this.updateSelected(t);
  }
  updateSelected(e) {
    this.toggleCss("ag-autocomplete-row-selected", e);
  }
  setSearchString(e) {
    let t = !1;
    const { value: n } = this;
    if (n && ue(e)) {
      const o = n.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (o >= 0) {
        t = !0, this.hasHighlighting = !0;
        const s = o + e.length, i = this.getGui().lastElementChild;
        ht(i), i.append(
          // Start part
          n.slice(0, o),
          // Highlighted part wrapped in bold tag
          Ue({ tag: "b", children: n.slice(o, s) }),
          // End part
          n.slice(s)
        );
      }
    }
    !t && this.hasHighlighting && (this.hasHighlighting = !1, this.render());
  }
  render() {
    this.getGui().lastElementChild.textContent = this.value ?? " ";
  }
}, I7 = {
  tag: "div",
  cls: "ag-autocomplete-list-popup",
  children: [
    {
      tag: "div",
      ref: "eList",
      cls: "ag-autocomplete-list"
    }
  ]
}, P7 = class extends fc {
  constructor(e) {
    super(I7), this.params = e, this.eList = X, this.searchString = "";
  }
  postConstruct() {
    this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList = this.createManagedBean(new Lr({ cssIdentifier: "autocomplete" })), this.virtualList.setComponentCreator(this.createRowComponent.bind(this)), this.eList.appendChild(this.virtualList.getGui()), this.virtualList.setModel({
      getRowCount: () => this.autocompleteEntries.length,
      getRow: (t) => this.autocompleteEntries[t]
    });
    const e = this.virtualList.getGui();
    this.addManagedListeners(e, {
      click: () => this.params.onConfirmed(),
      mousemove: this.onMouseMove.bind(this),
      mousedown: (t) => t.preventDefault()
    }), this.setSelectedValue(0);
  }
  onNavigationKeyDown(e, t) {
    e.preventDefault();
    const n = this.autocompleteEntries.indexOf(this.selectedValue), o = t === O.UP ? n - 1 : n + 1;
    this.checkSetSelectedValue(o);
  }
  setSearch(e) {
    this.searchString = e, ue(e) ? this.runSearch() : (this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList.refresh(), this.checkSetSelectedValue(0)), this.updateSearchInList();
  }
  runContainsSearch(e, t) {
    let n, o = !1;
    const s = e.toLocaleLowerCase(), i = t.filter((r) => {
      const l = r.toLocaleLowerCase().indexOf(s), d = l === 0, c = l >= 0;
      return c && (!n || !o && d || o === d && r.length < n.length) && (n = r, o = d), c;
    });
    return !n && i.length && (n = i[0]), { topMatch: n, allMatches: i };
  }
  runSearch() {
    const { autocompleteEntries: e, useFuzzySearch: t, forceLastSelection: n } = this.params, o = e.map((l) => l.displayValue ?? l.key);
    let s, i;
    if (t)
      s = La({
        inputValue: this.searchString,
        allSuggestions: o,
        hideIrrelevant: !0
      }).values, i = s.length ? s[0] : void 0;
    else {
      const l = this.runContainsSearch(this.searchString, o);
      s = l.allMatches, i = l.topMatch;
    }
    let r = e.filter(
      ({ key: l, displayValue: d }) => s.includes(d ?? l)
    );
    if (!r.length && this.selectedValue && (n != null && n(this.selectedValue, this.searchString)) && (r = [this.selectedValue]), this.autocompleteEntries = r, this.virtualList.refresh(), !i)
      return;
    const a = s.indexOf(i);
    this.checkSetSelectedValue(a);
  }
  updateSearchInList() {
    this.virtualList.forEachRenderedRow((e) => e.setSearchString(this.searchString));
  }
  checkSetSelectedValue(e) {
    e >= 0 && e < this.autocompleteEntries.length && this.setSelectedValue(e);
  }
  setSelectedValue(e) {
    const t = this.autocompleteEntries[e];
    this.selectedValue !== t && (this.selectedValue = t, this.virtualList.ensureIndexVisible(e), this.virtualList.forEachRenderedRow((n, o) => {
      n.updateSelected(e === o);
    }));
  }
  createRowComponent(e) {
    const t = new M7();
    return this.createBean(t), t.setState(e.displayValue ?? e.key, e === this.selectedValue), t;
  }
  onMouseMove(e) {
    const t = this.virtualList, n = t.getGui().getBoundingClientRect(), o = t.getScrollTop(), s = e.clientY - n.top + o, i = Math.floor(s / t.getRowHeight());
    this.checkSetSelectedValue(i);
  }
  afterGuiAttached() {
    this.virtualList.refresh();
  }
  getSelectedValue() {
    return this.autocompleteEntries.length ? this.selectedValue ?? null : null;
  }
}, D7 = {
  tag: "div",
  cls: "ag-autocomplete",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eAutocompleteInput"
    }
  ]
}, T7 = class extends Te {
  constructor() {
    super(D7, [ao]), this.eAutocompleteInput = X, this.isListOpen = !1, this.lastPosition = 0, this.valid = !0, this.registerCSS(E7);
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    this.eAutocompleteInput.onValueChange((e) => this.onValueChanged(e)), this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off"), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.addGuiEventListener("click", this.updatePositionAndList.bind(this)), this.addDestroyFunc(() => {
      this.destroyBean(this.autocompleteList);
    }), this.addGuiEventListener("focusout", () => this.onFocusOut());
  }
  onValueChanged(e) {
    const t = Gt(e);
    this.updateValue(t), this.updateAutocompleteList(t);
  }
  updateValue(e) {
    this.updateLastPosition(), this.dispatchLocalEvent({
      type: "eventValueChanged",
      value: e
    }), this.validate(e);
  }
  updateAutocompleteList(e) {
    var o, s;
    const t = ((o = this.listGenerator) == null ? void 0 : o.call(this, e, this.lastPosition)) ?? { enabled: !1 };
    (!t.type || t.type !== ((s = this.autocompleteListParams) == null ? void 0 : s.type)) && this.isListOpen && this.closeList();
    const n = this.isListOpen;
    if (this.autocompleteListParams = t, t != null && t.enabled) {
      n || this.openList();
      const { searchString: i } = t;
      this.autocompleteList.setSearch(i ?? "");
    } else
      n && this.closeList();
  }
  onKeyDown(e) {
    const t = e.key;
    switch (this.updateLastPosition(), t) {
      case O.ENTER:
        this.onEnterKeyDown(e);
        break;
      case O.TAB:
        this.onTabKeyDown(e);
        break;
      case O.DOWN:
      case O.UP:
        this.onUpDownKeyDown(e, t);
        break;
      case O.LEFT:
      case O.RIGHT:
      case O.PAGE_HOME:
      case O.PAGE_END:
        setTimeout(() => {
          this.updatePositionAndList();
        });
        break;
      case O.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case O.SPACE:
        e.ctrlKey && !this.isListOpen && (e.preventDefault(), this.forceOpenList());
        break;
    }
  }
  confirmSelection() {
    var t;
    const e = (t = this.autocompleteList) == null ? void 0 : t.getSelectedValue();
    e && (this.closeList(), this.dispatchLocalEvent({
      type: "eventOptionSelected",
      value: this.getValue(),
      position: this.lastPosition,
      updateEntry: e,
      autocompleteType: this.autocompleteListParams.type
    }));
  }
  onTabKeyDown(e) {
    this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.confirmSelection());
  }
  onEnterKeyDown(e) {
    e.preventDefault(), this.isListOpen ? this.confirmSelection() : this.onCompleted();
  }
  onUpDownKeyDown(e, t) {
    var n;
    e.preventDefault(), this.isListOpen ? (n = this.autocompleteList) == null || n.onNavigationKeyDown(e, t) : this.forceOpenList();
  }
  onEscapeKeyDown(e) {
    this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.closeList(), this.setCaret(this.lastPosition, !0));
  }
  onFocusOut() {
    this.isListOpen && this.closeList();
  }
  updatePositionAndList() {
    this.updateLastPosition(), this.updateAutocompleteList(this.eAutocompleteInput.getValue() ?? null);
  }
  setCaret(e, t) {
    (t || fr(this.beans)) && this.eAutocompleteInput.getFocusableElement().focus();
    const n = this.eAutocompleteInput.getInputElement();
    n.setSelectionRange(e, e), e === n.value.length && (n.scrollLeft = n.scrollWidth);
  }
  forceOpenList() {
    this.onValueChanged(this.eAutocompleteInput.getValue());
  }
  updateLastPosition() {
    this.lastPosition = this.eAutocompleteInput.getInputElement().selectionStart ?? 0;
  }
  validate(e) {
    if (!this.validator)
      return;
    const t = this.validationMessage = this.validator(e);
    this.eAutocompleteInput.getInputElement().setCustomValidity(t ?? ""), this.valid = !t, this.dispatchLocalEvent({
      type: "eventValidChanged",
      isValid: this.valid,
      validationMessage: t
    });
  }
  openList() {
    this.isListOpen = !0, this.autocompleteList = this.createBean(
      new P7({
        autocompleteEntries: this.autocompleteListParams.entries,
        onConfirmed: () => this.confirmSelection(),
        forceLastSelection: this.forceLastSelection
      })
    );
    const e = this.autocompleteList.getGui(), t = {
      ePopup: e,
      type: "autocomplete",
      eventSource: this.getGui(),
      position: "under",
      alignSide: this.gos.get("enableRtl") ? "right" : "left",
      keepWithinBounds: !0
    }, n = this.popupSvc.addPopup({
      eChild: e,
      anchorToElement: this.getGui(),
      positionCallback: () => this.popupSvc.positionPopupByComponent(t),
      ariaLabel: this.listAriaLabel
    });
    this.hidePopup = n.hideFunc, this.autocompleteList.afterGuiAttached();
  }
  closeList() {
    this.isListOpen = !1, this.hidePopup(), this.destroyBean(this.autocompleteList), this.autocompleteList = null;
  }
  onCompleted() {
    this.isListOpen && this.closeList(), this.dispatchLocalEvent({
      type: "eventValueConfirmed",
      value: this.getValue(),
      isValid: this.isValid()
    });
  }
  getValue() {
    return Gt(this.eAutocompleteInput.getValue());
  }
  setInputPlaceholder(e) {
    return this.eAutocompleteInput.setInputPlaceholder(e), this;
  }
  setInputAriaLabel(e) {
    return this.eAutocompleteInput.setInputAriaLabel(e), this;
  }
  setListAriaLabel(e) {
    return this.listAriaLabel = e, this;
  }
  setListGenerator(e) {
    return this.listGenerator = e, this;
  }
  setValidator(e) {
    return this.validator = e, this;
  }
  isValid() {
    return this.valid;
  }
  setValue(e) {
    const { value: t, position: n, silent: o, updateListOnlyIfOpen: s, restoreFocus: i } = e;
    this.eAutocompleteInput.setValue(t, !0), this.setCaret(n ?? this.lastPosition, i), o || this.updateValue(t), (!s || this.isListOpen) && this.updateAutocompleteList(t);
  }
  setForceLastSelection(e) {
    return this.forceLastSelection = e, this;
  }
  setInputDisabled(e) {
    return this.eAutocompleteInput.setDisabled(e), this;
  }
}, k7 = {
  selector: "AG-AUTOCOMPLETE",
  component: T7
}, Bu = {
  buttons: ["apply"],
  suppressBuilderButton: !1
}, C0 = {
  apply: "advancedFilterApply",
  clear: "advancedFilterClear",
  cancel: "advancedFilterCancel",
  reset: "advancedFilterReset"
}, L7 = {
  tag: "div",
  cls: "ag-advanced-filter",
  role: "presentation",
  attrs: { tabindex: "-1" },
  children: [
    { tag: "ag-autocomplete", ref: "eAutocomplete" },
    {
      tag: "ag-filter-button",
      ref: "eButtons",
      cls: "ag-advanced-filter-buttons"
    },
    {
      tag: "button",
      ref: "eBuilderFilterButton",
      cls: "ag-button ag-advanced-filter-builder-button",
      children: [
        { tag: "span", ref: "eBuilderFilterButtonIcon", attrs: { "aria-hidden": "true" } },
        { tag: "span", ref: "eBuilderFilterButtonLabel", cls: "ag-advanced-filter-builder-button-label" }
      ]
    }
  ]
}, bb = class extends Te {
  constructor() {
    super(L7, [k7, uI]), this.eAutocomplete = X, this.eButtons = X, this.eBuilderFilterButton = X, this.eBuilderFilterButtonIcon = X, this.eBuilderFilterButtonLabel = X, this.expressionParser = null, this.isApplyDisabled = !0, this.builderOpen = !1;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc, this.advancedFilter = e.advancedFilter, this.filterManager = e.filterManager, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getTooltipShowDelayOverride: () => 1e3,
        getLocation: () => "advancedFilter"
      })
    ), this.eAutocomplete.setListGenerator((n, o) => this.generateAutocompleteListParams(o)).setValidator(() => this.validateValue()).setForceLastSelection(
      (n, o) => this.forceLastSelection(n, o)
    ).setInputAriaLabel(this.advFilterExpSvc.translate("ariaAdvancedFilterInput")).setListAriaLabel(this.advFilterExpSvc.translate("ariaLabelAdvancedFilterAutocomplete")), this.refresh(), this.addManagedListeners(this.eAutocomplete, {
      eventValueChanged: ({ value: n }) => this.onValueChanged(n),
      eventValueConfirmed: ({ isValid: n }) => this.onValueConfirmed(n),
      eventOptionSelected: ({ position: n, updateEntry: o, autocompleteType: s }) => this.onOptionSelected(n, o, s),
      eventValidChanged: ({ isValid: n, validationMessage: o }) => this.onValidChanged(n, o)
    });
    const { buttons: e, suppressBuilderButton: t } = {
      ...Bu,
      ...this.gos.get("advancedFilterParams")
    };
    this.setupButtons(e), this.setupBuilderButton(t), this.beans.gos.addManagedPropertyListener("advancedFilterParams", (n) => {
      const o = { ...Bu, ...n.currentValue }, s = { ...Bu, ...n.previousValue };
      if (o.buttons !== s.buttons) {
        const i = o.buttons.map((r) => ({
          type: r,
          label: this.advFilterExpSvc.translate(C0[r])
        }));
        this.eButtons.updateButtons(i);
      }
      o.suppressBuilderButton !== s.suppressBuilderButton && He(this.eBuilderFilterButton, !o.suppressBuilderButton);
    });
  }
  refresh() {
    const e = this.advancedFilter.getExpressionDisplayValue();
    this.eAutocomplete.setValue({
      value: e ?? "",
      position: e == null ? void 0 : e.length,
      updateListOnlyIfOpen: !0
    });
  }
  setInputDisabled(e) {
    this.eAutocomplete.setInputDisabled(e), this.eButtons.updateValidity(
      !e && !this.isApplyDisabled && !this.advancedFilter.isCurrentExpressionApplied()
    );
  }
  setupButtons(e) {
    const t = e.map((o) => ({
      type: o,
      label: this.advFilterExpSvc.translate(C0[o])
    })), n = (o) => () => {
      this.updateModel(o);
    };
    this.eButtons.addManagedListeners(this.eButtons, {
      apply: n("apply"),
      clear: n("clear"),
      reset: n("reset"),
      cancel: n("cancel")
    }), this.eButtons.updateButtons(t);
  }
  updateModel(e) {
    var t, n;
    switch (e) {
      case "apply":
        this.onValueConfirmed(this.eAutocomplete.isValid());
        break;
      case "reset":
        this.advancedFilter.setModel(null), (t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" });
        break;
      case "cancel":
        this.advancedFilter.setModel(this.advancedFilter.getModel()), (n = this.filterManager) == null || n.onFilterChanged({ source: "advancedFilter" });
        break;
      case "clear":
        this.eAutocomplete.setValue({
          value: "",
          restoreFocus: !0
        });
        break;
    }
  }
  setupBuilderButton(e) {
    this.eBuilderFilterButtonIcon.appendChild(Le("advancedFilterBuilder", this.beans)), this.eBuilderFilterButtonLabel.textContent = this.advFilterExpSvc.translate("advancedFilterBuilder"), this.activateTabIndex([this.eBuilderFilterButton]), this.addManagedElementListeners(this.eBuilderFilterButton, { click: () => this.openBuilder() }), this.addManagedListeners(this.advancedFilter.getCtrl(), {
      advancedFilterBuilderClosed: () => this.closeBuilder()
    }), He(this.eBuilderFilterButton, !e);
  }
  onValueChanged(e) {
    var n;
    e = Gt(e), this.advancedFilter.setExpressionDisplayValue(e), this.expressionParser = this.advancedFilter.createExpressionParser(e);
    const t = (n = this.expressionParser) == null ? void 0 : n.parseExpression();
    t && t !== e && this.eAutocomplete.setValue({ value: t, silent: !0, restoreFocus: !0 });
  }
  onValueConfirmed(e) {
    var t, n;
    !e || this.isApplyDisabled || ((t = this.eButtons) == null || t.updateValidity(!1), this.advancedFilter.applyExpression(), (n = this.filterManager) == null || n.onFilterChanged({ source: "advancedFilter" }));
  }
  onOptionSelected(e, t, n) {
    const { updatedValue: o, updatedPosition: s, hideAutocomplete: i } = this.updateExpression(e, t, n);
    this.eAutocomplete.setValue({
      value: o,
      position: s,
      updateListOnlyIfOpen: i,
      restoreFocus: !0
    });
  }
  validateValue() {
    var e, t;
    return (e = this.expressionParser) != null && e.isValid() ? null : ((t = this.expressionParser) == null ? void 0 : t.getValidationMessage()) ?? null;
  }
  onValidChanged(e, t) {
    var n;
    this.isApplyDisabled = !e || this.advancedFilter.isCurrentExpressionApplied(), this.eButtons.updateValidity(!this.isApplyDisabled), (n = this.tooltipFeature) == null || n.setTooltipAndRefresh(t);
  }
  generateAutocompleteListParams(e) {
    return this.expressionParser ? this.expressionParser.getAutocompleteListParams(e) : this.advFilterExpSvc.getDefaultAutocompleteListParams("");
  }
  updateExpression(e, t, n) {
    var o;
    return this.advFilterExpSvc.updateAutocompleteCache(t, n), ((o = this.expressionParser) == null ? void 0 : o.updateExpression(e, t, n)) ?? this.advancedFilter.getDefaultExpression(t);
  }
  forceLastSelection({ key: e, displayValue: t }, n) {
    return !!n.toLocaleLowerCase().match(`^${(t ?? e).toLocaleLowerCase()}\\s*$`);
  }
  openBuilder() {
    this.builderOpen || (this.builderOpen = !0, vi(this.eBuilderFilterButton, !0), this.advancedFilter.getCtrl().toggleFilterBuilder({ source: "ui", eventSource: this.eBuilderFilterButton }));
  }
  closeBuilder() {
    this.builderOpen && (this.builderOpen = !1, vi(this.eBuilderFilterButton, !1), this.eBuilderFilterButton.focus());
  }
}, B7 = {
  tag: "div",
  cls: "ag-advanced-filter-header",
  role: "row"
}, O7 = class extends Te {
  constructor(e) {
    super(B7), this.enabled = e;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.focusSvc = e.focusSvc, this.ctrlsSvc = e.ctrlsSvc;
  }
  postConstruct() {
    this.setupAdvancedFilter(this.enabled), this.addDestroyFunc(() => this.destroyBean(this.eAdvancedFilter));
    const e = () => {
      this.enabled && this.setEnabledHeight();
    };
    this.addManagedEventListeners({
      gridColumnsChanged: () => this.onGridColumnsChanged(),
      columnHeaderHeightChanged: e,
      gridStylesChanged: e
    }), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addGuiEventListener("keydown", (t) => this.onKeyDown(t)), this.addGuiEventListener("focusout", (t) => {
      this.getFocusableElement().contains(t.relatedTarget) || this.focusSvc.clearAdvancedFilterColumn();
    });
  }
  getFocusableElement() {
    var e;
    return ((e = this.eAdvancedFilter) == null ? void 0 : e.getGui()) ?? this.getGui();
  }
  setEnabled(e) {
    e !== this.enabled && this.setupAdvancedFilter(e);
  }
  refresh() {
    var e;
    (e = this.eAdvancedFilter) == null || e.refresh();
  }
  getHeight() {
    return this.height;
  }
  setInputDisabled(e) {
    var t;
    (t = this.eAdvancedFilter) == null || t.setInputDisabled(e);
  }
  setupAdvancedFilter(e) {
    const t = this.getGui();
    if (e) {
      this.eAdvancedFilter = this.createBean(new bb());
      const n = this.eAdvancedFilter.getGui();
      this.eAdvancedFilter.addCss("ag-advanced-filter-header-cell"), this.setEnabledHeight(), this.setAriaRowIndex(), hn(n, "gridcell"), $g(n, 1), this.setAriaColumnCount(n), t.appendChild(n);
    } else
      ht(t), this.destroyBean(this.eAdvancedFilter), this.height = 0;
    He(t, e), this.enabled = e;
  }
  setEnabledHeight() {
    const e = this.getGui();
    this.height = Rp(this.beans);
    const t = `${this.height}px`;
    e.style.height = t, e.style.minHeight = t;
  }
  setAriaColumnCount(e) {
    lC(e, this.colModel.getCols().length);
  }
  setAriaRowIndex() {
    var e;
    Ma(this.getGui(), ((e = this.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : e.getRowCount()) ?? 0);
  }
  onGridColumnsChanged() {
    this.eAdvancedFilter && (this.setAriaColumnCount(this.eAdvancedFilter.getGui()), this.setAriaRowIndex());
  }
  onKeyDown(e) {
    switch (e.key) {
      case O.ENTER: {
        this.hasFocus() && pn(this.getFocusableElement()) && e.preventDefault();
        break;
      }
      case O.ESCAPE:
        this.hasFocus() || this.getFocusableElement().focus();
        break;
      case O.UP:
        this.navigateUpDown(!0, e);
        break;
      case O.DOWN:
        this.navigateUpDown(!1, e);
        break;
      case O.TAB:
        if (this.hasFocus())
          this.navigateLeftRight(e);
        else {
          const t = sn(
            this.beans,
            this.getFocusableElement(),
            null,
            e.shiftKey
          );
          t ? (e.preventDefault(), t.focus()) : this.navigateLeftRight(e);
        }
        break;
    }
  }
  navigateUpDown(e, t) {
    this.hasFocus() && this.focusSvc.focusNextFromAdvancedFilter(e) && t.preventDefault();
  }
  navigateLeftRight(e) {
    (e.shiftKey ? this.focusSvc.focusLastHeader() : this.focusSvc.focusNextFromAdvancedFilter(!1, !0)) && e.preventDefault();
  }
  hasFocus() {
    return je(this.beans) === this.getFocusableElement();
  }
}, Ou = "ag-list-item-hovered", Sb = class extends U {
  constructor(e, t, n) {
    super(), this.comp = e, this.virtualList = t, this.params = n, this.currentDragValue = null, this.lastHoveredListItem = null;
  }
  wireBeans(e) {
    this.dragAndDrop = e.dragAndDrop;
  }
  postConstruct() {
    this.addManagedListeners(this.params.eventSource, {
      [this.params.listItemDragStartEvent]: this.listItemDragStart.bind(this),
      [this.params.listItemDragEndEvent]: this.listItemDragEnd.bind(this)
    }), this.createDropTarget(), this.createAutoScrollService();
  }
  listItemDragStart(e) {
    this.currentDragValue = this.params.getCurrentDragValue(e), this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
  }
  listItemDragEnd() {
    window.setTimeout(() => {
      this.currentDragValue = null, this.moveBlocked = !1;
    }, 10);
  }
  createDropTarget() {
    var t;
    const e = {
      isInterestedIn: (n) => n === this.params.dragSourceType,
      getIconName: () => this.moveBlocked ? "pinned" : "move",
      getContainer: () => this.comp.getGui(),
      onDragging: (n) => this.onDragging(n),
      onDragStop: () => this.onDragStop(),
      onDragLeave: () => this.onDragLeave(),
      onDragCancel: () => this.onDragCancel()
    };
    (t = this.dragAndDrop) == null || t.addDropTarget(e);
  }
  createAutoScrollService() {
    const e = this.virtualList.getGui();
    this.autoScrollService = new ey({
      scrollContainer: e,
      scrollAxis: "y",
      getVerticalPosition: () => e.scrollTop,
      setVerticalPosition: (t) => e.scrollTop = t
    });
  }
  onDragging(e) {
    if (!this.currentDragValue || this.moveBlocked)
      return;
    const t = this.getListDragItem(e), n = this.virtualList.getComponentAt(t.rowIndex);
    if (!n)
      return;
    const o = n.getGui().parentElement;
    this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === t.rowIndex && this.lastHoveredListItem.position === t.position || (this.autoScrollService.check(e.event), this.clearHoveredItems(), this.lastHoveredListItem = t, nm(o, Ou), nm(o, `ag-item-highlight-${t.position}`));
  }
  getListDragItem(e) {
    const t = this.virtualList.getGui(), n = parseFloat(window.getComputedStyle(t).paddingTop), o = this.virtualList.getRowHeight(), s = this.virtualList.getScrollTop(), i = Math.max(0, (e.y - n + s) / o), r = this.params.getNumRows(this.comp) - 1, a = Math.min(r, i) | 0;
    return {
      rowIndex: a,
      position: Math.round(i) > i || i > r ? "bottom" : "top",
      component: this.virtualList.getComponentAt(a)
    };
  }
  onDragStop() {
    this.moveBlocked || (this.params.moveItem(this.currentDragValue, this.lastHoveredListItem), this.clearDragProperties());
  }
  onDragCancel() {
    this.clearDragProperties();
  }
  onDragLeave() {
    this.clearDragProperties();
  }
  clearDragProperties() {
    this.clearHoveredItems(), this.autoScrollService.ensureCleared();
  }
  clearHoveredItems() {
    this.virtualList.getGui().querySelectorAll(`.${Ou}`).forEach((t) => {
      [Ou, "ag-item-highlight-top", "ag-item-highlight-bottom"].forEach((n) => {
        t.classList.remove(n);
      });
    }), this.lastHoveredListItem = null;
  }
}, G7 = class extends U {
  constructor(e, t) {
    super(), this.comp = e, this.virtualList = t;
  }
  postConstruct() {
    this.createManagedBean(
      new Sb(this.comp, this.virtualList, {
        dragSourceType: ns.AdvancedFilterBuilder,
        listItemDragStartEvent: "advancedFilterBuilderDragStarted",
        listItemDragEndEvent: "advancedFilterBuilderDragEnded",
        eventSource: this,
        getCurrentDragValue: (e) => this.getCurrentDragValue(e),
        isMoveBlocked: () => !1,
        getNumRows: (e) => e.getNumItems(),
        moveItem: (e, t) => this.moveItem(e, t)
      })
    );
  }
  getCurrentDragValue(e) {
    return e.item;
  }
  moveItem(e, t) {
    this.comp.moveItem(e, t);
  }
}, H7 = {
  tag: "div",
  cls: "ag-pill",
  role: "option",
  children: [
    {
      tag: "span",
      ref: "eText",
      cls: "ag-pill-text"
    },
    {
      tag: "span",
      ref: "eButton",
      cls: "ag-button ag-pill-button",
      role: "presentation"
    }
  ]
}, V7 = class extends Te {
  constructor(e) {
    super(H7), this.config = e, this.eText = X, this.eButton = X;
  }
  postConstruct() {
    const { config: e, eButton: t } = this, { onKeyDown: n, onButtonClick: o } = e;
    this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex"))), this.addGuiEventListener("focus", () => {
      this.eButton.focus();
    }), n && this.addGuiEventListener("keydown", n), o && this.addManagedElementListeners(t, {
      click: o
    });
  }
  toggleCloseButtonClass(e, t) {
    this.eButton.classList.toggle(e, t);
  }
  setText(e) {
    this.eText.textContent = e;
  }
  getText() {
    return this.eText.textContent;
  }
}, _7 = {
  tag: "div",
  cls: "ag-pill-container"
}, N7 = class extends Te {
  constructor() {
    super(_7), this.pills = [];
  }
  init(e) {
    this.params = e, this.refresh();
  }
  refresh() {
    this.clearPills();
    const { params: e, onPillKeyDown: t } = this;
    let n = e.getValue();
    if (!Array.isArray(n)) {
      if (n == null)
        return;
      n = [n];
    }
    const o = e.valueFormatter ?? ((i) => String(i)), s = n.length;
    hn(this.getGui(), s === 0 ? "presentation" : "listbox");
    for (let i = 0; i < s; i++) {
      const r = n[i], a = this.createBean(
        new V7({
          onButtonClick: () => this.onPillButtonClick(a),
          onKeyDown: t.bind(this)
        })
      ), l = a.getGui();
      lc(l, i + 1), ac(l, s), e.onPillMouseDown && a.addGuiEventListener("mousedown", e.onPillMouseDown), e.announceItemFocus && a.addGuiEventListener("focus", e.announceItemFocus), a.setText(o(r) ?? ""), a.toggleCloseButtonClass("ag-icon-cancel", !0), this.appendChild(l), this.pills.push(a);
    }
  }
  onNavigationKeyDown(e) {
    const { key: t } = e;
    if (!this.pills.length || t !== O.LEFT && t !== O.RIGHT)
      return;
    e.preventDefault();
    const { params: n, beans: o } = this, s = je(o), i = this.getGui();
    if (i.contains(s)) {
      const r = sn(o, i, !1, t === O.LEFT);
      r ? r.focus() : n.eWrapper && n.eWrapper.focus();
    } else {
      const r = Ko(i);
      r.length > 0 && r[t === O.RIGHT ? 0 : r.length - 1].focus();
    }
  }
  clearPills() {
    const e = this.getGui();
    e.contains(je(this.beans)) && this.params.eWrapper && this.params.eWrapper.focus(), ht(e), this.destroyBeans(this.pills), this.pills = [];
  }
  onPillButtonClick(e) {
    this.deletePill(e);
  }
  onPillKeyDown(e) {
    const t = e.key;
    if (t !== O.DELETE && t !== O.BACKSPACE)
      return;
    e.preventDefault();
    const n = Bt(this.beans), o = this.pills.findIndex((i) => i.getGui().contains(n.activeElement));
    if (o === -1)
      return;
    const s = this.pills[o];
    s && this.deletePill(s, o);
  }
  deletePill(e, t) {
    const n = e.getText(), o = (this.params.getValue() || []).filter((s) => s !== n);
    if (this.params.setValue(o), !o.length && this.params.eWrapper)
      this.params.eWrapper.focus();
    else if (t != null) {
      const s = this.pills[Math.min(t, this.pills.length - 1)];
      s && s.getFocusableElement().focus();
    }
  }
  destroy() {
    this.clearPills(), super.destroy();
  }
}, $7 = (
  /*css*/
  ".ag-rich-select{cursor:default;height:100%}.ag-rich-select-value{align-items:center;background-color:var(--ag-picker-button-background-color);display:flex;height:100%;padding:var(--ag-spacing);:where(.ag-picker-field-display){overflow:hidden;text-overflow:ellipsis;&:where(.ag-display-as-placeholder){opacity:.5}}}.ag-rich-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-input-border-radius);box-shadow:var(--ag-dropdown-shadow);height:auto;position:relative;width:100%;:where(.ag-loading-text){padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}}.ag-rich-select-row{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;padding:0 var(--ag-spacing);white-space:nowrap}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row-highlighted,.ag-rich-select-row:hover{background-image:linear-gradient(var(--ag-row-hover-color),var(--ag-row-hover-color))}.ag-rich-select-row-text-highlight{font-weight:700}.ag-rich-select-field-input{flex:1 1 auto;:where(.ag-input-field-input){border:none!important;box-shadow:none!important;padding:0!important;text-overflow:ellipsis;&::-moz-placeholder{opacity:.8}&::placeholder{opacity:.8}}}:where(.ag-ltr) .ag-rich-select-field-input{left:var(--ag-spacing)}:where(.ag-rtl) .ag-rich-select-field-input{right:var(--ag-spacing)}:where(.ag-popup-editor) .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-pill-container{display:flex;flex-wrap:nowrap;gap:.25rem}.ag-pill{align-items:center;background:var(--ag-select-cell-background-color);border:var(--ag-select-cell-border);border-radius:var(--ag-border-radius);display:flex;padding:0 .25rem;white-space:nowrap}.ag-pill-button{border:none;padding:0;&:hover{color:var(--ag-accent-color);cursor:pointer}}:where(.ag-ltr) .ag-pill-button{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-pill-button{margin-right:var(--ag-spacing)}"
), z7 = { tag: "div", cls: "ag-rich-select-row", role: "presentation" }, W7 = class extends Te {
  constructor(e) {
    super(z7), this.params = e;
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean(
        "highlightTooltipFeature",
        !1,
        {
          getGui: () => this.getGui(),
          shouldDisplayTooltip: () => {
            var e;
            return ((e = this.shouldDisplayTooltip) == null ? void 0 : e.call(this)) ?? !0;
          }
        },
        this
      )
    );
  }
  setState(e) {
    var s;
    const { params: t } = this, n = ((s = t.valueFormatter) == null ? void 0 : s.call(t, e)) ?? "";
    this.populateWithRenderer(e, n) || this.populateWithoutRenderer(e, n), this.value = e;
  }
  highlightString(e) {
    const { parsedValue: t, params: n } = this;
    if (n.cellRenderer || !ue(t))
      return;
    let o = ue(e);
    if (o) {
      const s = t == null ? void 0 : t.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (s >= 0) {
        const i = s + e.length, r = this.getGui().querySelector("span");
        r && (ht(r), r.append(
          // Start part
          t.slice(0, s),
          // Highlighted part wrapped in bold tag
          Ue({
            tag: "span",
            cls: "ag-rich-select-row-text-highlight",
            children: t.slice(s, i)
          }),
          // End part
          t.slice(i)
        ));
      } else
        o = !1;
    }
    o || this.renderValueWithoutRenderer(t);
  }
  updateSelected(e) {
    const t = this.getGui();
    zg(t.parentElement, e), this.toggleCss("ag-rich-select-row-selected", e);
  }
  getValue() {
    return this.value;
  }
  toggleHighlighted(e) {
    this.toggleCss("ag-rich-select-row-highlighted", e), this.dispatchLocalEvent({
      type: "itemHighlighted",
      highlighted: e
    });
  }
  populateWithoutRenderer(e, t) {
    var i;
    const n = this.getGui(), o = Ue({ tag: "span" });
    o.style.overflow = "hidden", o.style.textOverflow = "ellipsis";
    const s = Ii(ue(t) ? t : e);
    this.parsedValue = ue(s) ? s : null, n.appendChild(o), this.renderValueWithoutRenderer(s), this.shouldDisplayTooltip = ai(() => o), (i = this.tooltipFeature) == null || i.setTooltipAndRefresh(this.parsedValue);
  }
  renderValueWithoutRenderer(e) {
    const t = this.getGui().querySelector("span");
    t && (t.textContent = ue(e) ? e : " ");
  }
  populateWithRenderer(e, t) {
    var s;
    let n, o;
    if (this.params.cellRenderer) {
      const i = (s = this.getParentComponent()) == null ? void 0 : s.getParentComponent();
      o = sw(
        this.userCompFactory,
        this.params,
        ke(this.gos, {
          value: e,
          valueFormatted: t,
          getValue: () => i == null ? void 0 : i.getValue(),
          setValue: (r) => {
            i == null || i.setValue(r, !0);
          },
          setTooltip: (r, a) => {
            var l;
            this.gos.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = a, (l = this.tooltipFeature) == null || l.setTooltipAndRefresh(r);
          }
        })
      );
    }
    return o && (n = o.newAgStackInstance()), n && Rb(n, this.getGui()), n ? (n.then((i) => {
      this.addDestroyFunc(() => {
        this.destroyBean(i);
      });
    }), !0) : !1;
  }
}, w0 = "ag-rich-select-list", y0 = "ag-rich-select-row", U7 = class extends Lr {
  constructor(e, t, n) {
    super({ cssIdentifier: "rich-select" }), this.params = e, this.richSelectWrapper = t, this.getSearchString = n, this.lastRowHovered = -1, this.selectedItems = /* @__PURE__ */ new Set(), this.params = e, this.setComponentCreator(this.createRowComponent.bind(this)), this.setComponentUpdater(() => {
    });
  }
  postConstruct() {
    super.postConstruct(), this.eLoading = Ue({
      tag: "div",
      cls: "ag-loading-text",
      children: this.getLocaleTextFunc()("loadingOoo", "Loading...")
    });
    const { cellRowHeight: e, pickerAriaLabelKey: t, pickerAriaLabelValue: n } = this.params;
    e && this.setRowHeight(e);
    const o = this.getGui(), s = this.getAriaElement();
    this.addManagedListeners(o, {
      mousemove: this.onMouseMove.bind(this),
      mouseout: this.onMouseOut.bind(this),
      mousedown: this.onMouseDown.bind(this),
      click: this.onClick.bind(this)
    }), o.classList.add(w0);
    const i = `${w0}-${this.getCompId()}`;
    s.setAttribute("id", i);
    const a = this.getLocaleTextFunc()(t, n);
    yt(s, a), Wg(this.richSelectWrapper, s);
  }
  navigateToPage(e) {
    const t = super.navigateToPage(e, this.lastRowHovered);
    return t != null && kn(this.beans, () => {
      if (!this.isAlive())
        return null;
      this.highlightIndex(t);
    }), t;
  }
  drawVirtualRows(e) {
    super.drawVirtualRows(e), this.refreshSelectedItems();
  }
  highlightFilterMatch(e) {
    this.forEachRenderedRow((t) => {
      t.highlightString(e);
    });
  }
  onNavigationKeyDown(e, t) {
    kn(this.beans, () => {
      if (!this.currentList || !this.isAlive())
        return;
      const n = this.currentList.length, o = this.lastRowHovered, s = e === O.DOWN ? 1 : -1, i = Math.min(Math.max(o === -1 ? 0 : o + s, 0), n - 1);
      this.highlightIndex(i), t();
    });
  }
  selectValue(e) {
    var o, s;
    if (!this.currentList)
      return this.eLoading && this.appendChild(this.eLoading), !1;
    if ((o = this.eLoading) != null && o.offsetParent && ((s = this.eLoading.parentElement) == null || s.removeChild(this.eLoading)), e == null)
      return !1;
    const t = this.getIndicesForValues(e), n = t.length > 0;
    return n && (this.refresh(), this.ensureIndexVisible(t[0]), this.refresh(!0)), this.selectListItems(Array.isArray(e) ? e : [e]), n;
  }
  selectListItems(e, t = !1) {
    t || this.selectedItems.clear();
    for (let n = 0; n < e.length; n++) {
      const o = e[n];
      this.findItemInSelected(o) === void 0 && this.selectedItems.add(o);
    }
    this.refreshSelectedItems();
  }
  getCurrentList() {
    return this.currentList;
  }
  setCurrentList(e) {
    this.currentList = e, this.setModel({
      getRowCount: () => e.length,
      getRow: (t) => e[t],
      areRowsEqual: (t, n) => t === n
    });
  }
  getSelectedItems() {
    return this.selectedItems;
  }
  getLastItemHovered() {
    return this.currentList[this.lastRowHovered];
  }
  highlightIndex(e, t) {
    this.currentList && (e < 0 || e >= this.currentList.length ? this.lastRowHovered = -1 : (this.lastRowHovered = e, this.ensureIndexVisible(e, !t) && !t && this.refresh(!0)), this.forEachRenderedRow((n, o) => {
      const s = e === o;
      if (n.toggleHighlighted(s), s) {
        const i = `${y0}-${n.getCompId()}`;
        rC(this.richSelectWrapper, i), this.richSelectWrapper.setAttribute("data-active-option", i);
      }
    }));
  }
  getIndicesForValues(e) {
    const { currentList: t } = this;
    if (!t || t.length === 0 || e == null)
      return [];
    if (Array.isArray(e) || (e = [e]), e.length === 0)
      return [];
    const { valueFormatter: n } = this.params, o = [], s = typeof e[0] == "object", i = t.map(n);
    for (const r of e) {
      let a = -1;
      s ? a = i.indexOf(n(r)) : a = t.indexOf(r), a >= 0 && o.push(a);
    }
    return o;
  }
  toggleListItemSelection(e) {
    const t = this.findItemInSelected(e);
    t !== void 0 ? this.selectedItems.delete(t) : this.selectedItems.add(e), this.refreshSelectedItems(), this.dispatchValueSelected();
  }
  refreshSelectedItems() {
    this.forEachRenderedRow((e) => {
      const t = this.findItemInSelected(e.getValue()) !== void 0;
      e.updateSelected(t);
    });
  }
  findItemInSelected(e) {
    if (typeof e == "object") {
      const t = this.params.valueFormatter, n = t(e);
      for (const o of this.selectedItems)
        if (t(o) === n)
          return o;
    } else
      return this.selectedItems.has(e) ? e : void 0;
  }
  createRowComponent(e, t) {
    const n = new W7(this.params);
    t.setAttribute("id", `${y0}-${n.getCompId()}`), n.setParentComponent(this), this.createBean(n), n.setState(e);
    const { highlightMatch: o, searchType: s = "fuzzy" } = this.params;
    return o && s !== "fuzzy" && n.highlightString(this.getSearchString()), n;
  }
  getRowForMouseEvent(e) {
    if (!this.model)
      return -1;
    const n = this.getGui().getBoundingClientRect(), o = this.getScrollTop(), s = e.clientY - n.top + o;
    return Math.min(Math.floor(s / this.getRowHeight()), this.model.getRowCount() - 1);
  }
  onMouseMove(e) {
    const t = this.getRowForMouseEvent(e);
    t !== -1 && t != this.lastRowHovered && (this.lastRowHovered = t, this.highlightIndex(t, !0));
  }
  onMouseDown(e) {
    e.preventDefault();
  }
  onMouseOut(e) {
    this.getGui().contains(e.relatedTarget) || this.highlightIndex(-1);
  }
  onClick(e) {
    const { multiSelect: t } = this.params;
    if (!this.currentList)
      return;
    const n = this.getRowForMouseEvent(e), o = this.currentList[n];
    t ? this.toggleListItemSelection(o) : (this.selectListItems([o]), this.dispatchValueSelected());
  }
  dispatchValueSelected() {
    this.dispatchLocalEvent({
      type: "richSelectListRowSelected",
      fromEnterKey: !1,
      value: this.selectedItems
    });
  }
  destroy() {
    super.destroy(), this.eLoading = void 0;
  }
}, K7 = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed",
      children: [
        { tag: "span", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "ag-input-text-field", ref: "eInput", cls: "ag-rich-select-field-input" },
        {
          tag: "span",
          ref: "eDeselect",
          cls: "ag-rich-select-deselect-button ag-picker-field-icon",
          role: "presentation"
        },
        { tag: "span", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, xb = class extends hw {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelRichSelectField",
      pickerAriaLabelValue: "Rich Select Field",
      pickerType: "ag-list",
      className: "ag-rich-select",
      pickerIcon: "richSelectOpen",
      ariaRole: "combobox",
      template: (e == null ? void 0 : e.template) ?? K7,
      agComponents: [ao],
      modalPicker: !1,
      ...e,
      // maxPickerHeight needs to be set after expanding `config`
      maxPickerHeight: (e == null ? void 0 : e.maxPickerHeight) ?? "calc(var(--ag-row-height) * 6.5)"
    }), this.searchString = "", this.searchStringCreator = null, this.eInput = X, this.eDeselect = X, this.skipWrapperAnnouncement = !1;
    const { value: t, valueList: n, searchStringCreator: o } = e || {};
    t !== void 0 && (this.value = t), o && (this.searchStringCreator = o), n != null && this.setValues(n), this.registerCSS($7);
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.ariaAnnounce = e.ariaAnnounce, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        shouldDisplayTooltip: () => {
          var s;
          return ((s = this.shouldDisplayTooltip) == null ? void 0 : s.call(this)) ?? !0;
        }
      })
    ), super.postConstruct(), this.createListComponent(), this.eDeselect.appendChild(Le("richSelectRemove", this.beans));
    const { allowTyping: e, placeholder: t, suppressDeselectAll: n } = this.config;
    this.eDeselect.classList.add("ag-hidden"), e ? (this.eInput.setAutoComplete(!1).setInputPlaceholder(t), this.eDisplayField.classList.add("ag-hidden")) : this.eInput.setDisplayed(!1), this.setupAriaProperties();
    const { searchDebounceDelay: o = 300 } = this.config;
    this.clearSearchString = Lt(this, this.clearSearchString.bind(this), o), this.renderSelectedValue(), e && this.eInput.onValueChange((s) => this.searchTextFromString(s)), this.addManagedElementListeners(this.eWrapper, { focus: this.onWrapperFocus.bind(this) }), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) }), n || this.addManagedElementListeners(this.eDeselect, {
      mousedown: this.onDeselectAllMouseDown.bind(this),
      click: this.onDeselectAllClick.bind(this)
    });
  }
  setupAriaProperties() {
    const { eWrapper: e, gos: t } = this;
    e.tabIndex = t.get("tabIndex");
    const n = this.getLocaleTextFunc();
    this.ariaDeleteSelection = n("ariaLabelRichSelectDeleteSelection", "Press DELETE to deselect item"), this.ariaDeselectAllItems = n(
      "ariaLabelRichSelectDeselectAllItems",
      "Press DELETE to deselect all items"
    ), this.ariaToggleSelection = n("ariaLabelRichSelectToggleSelection", "Press SPACE to toggle selection");
  }
  createListComponent() {
    this.listComponent = this.createBean(
      new U7(this.config, this.getFocusableElement(), () => this.searchString)
    ), this.listComponent.setParentComponent(this), this.addManagedListeners(this.listComponent, {
      richSelectListRowSelected: (e) => {
        this.onListValueSelected(e.value, e.fromEnterKey);
      }
    });
  }
  renderSelectedValue() {
    var p;
    const { value: e, eDisplayField: t, config: n, gos: o } = this, {
      allowTyping: s,
      cellRenderer: i,
      initialInputValue: r,
      multiSelect: a,
      suppressDeselectAll: l,
      suppressMultiSelectPillRenderer: d,
      valueFormatter: c
    } = n, u = b0(e, c);
    if (s) {
      this.eInput.setValue(r ?? u);
      return;
    }
    if (a && !l) {
      const f = e == null || Array.isArray(e) && e.length === 0;
      this.eDeselect.classList.toggle("ag-hidden", f);
    }
    let h;
    if (a && !d) {
      this.createOrUpdatePillContainer(t);
      return;
    }
    i && (h = sw(
      this.userCompFactory,
      n,
      ke(this.gos, {
        value: e,
        valueFormatted: u,
        getValue: () => this.getValue(),
        setValue: (f) => {
          this.setValue(f, !0);
        },
        setTooltip: (f, m) => {
          var C;
          o.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = m, (C = this.tooltipFeature) == null || C.setTooltipAndRefresh(f);
        }
      })
    ));
    let g;
    if (h && (g = h.newAgStackInstance()), g)
      ht(t), Rb(g, t), g.then((f) => {
        this.addDestroyFunc(() => this.destroyBean(f));
      });
    else {
      if (ue(this.value))
        t.innerText = u, t.classList.remove("ag-display-as-placeholder");
      else {
        const { placeholder: f } = n;
        ue(f) ? (t.textContent = f, t.classList.add("ag-display-as-placeholder")) : ht(t);
      }
      this.shouldDisplayTooltip = ai(() => this.eDisplayField), (p = this.tooltipFeature) == null || p.setTooltipAndRefresh(u ?? null);
    }
  }
  createPickerComponent() {
    const { values: e } = this;
    return e && this.setValueList({ valueList: e }), this.listComponent;
  }
  setSearchStringCreator(e) {
    this.searchStringCreator = e;
  }
  setValueList(e) {
    const { valueList: t, refresh: n } = e;
    !this.listComponent || this.listComponent.getCurrentList() === t || (this.listComponent.setCurrentList(t), n && (this.values ? this.listComponent.refresh(!0) : (this.setValues(t), this.isPickerDisplayed && (this.listComponent.selectValue(this.value) || this.listComponent.refresh())), this.alignPickerToComponent()));
  }
  /**
   * This method updates the list of values
   */
  setValues(e) {
    this.values = e, this.searchStrings = this.getSearchStringsFromValues(e);
  }
  showPicker() {
    var o;
    super.showPicker();
    const { listComponent: e, value: t } = this;
    if (!e)
      return;
    let n = null;
    e.selectValue(this.value), this.value != null && (n = e.getIndicesForValues(Array.isArray(t) ? t : [t])[0]), n != null ? ((o = this.tooltipFeature) == null || o.attemptToHideTooltip(), e.highlightIndex(n)) : e.refresh(), this.displayOrHidePicker();
  }
  createOrUpdatePillContainer(e) {
    if (!this.pillContainer) {
      const t = this.pillContainer = this.createBean(new N7());
      this.addDestroyFunc(() => {
        this.destroyBean(this.pillContainer), this.pillContainer = null;
      }), ht(e), e.appendChild(t.getGui());
      const { config: n, eWrapper: o, ariaDeleteSelection: s } = this, { valueFormatter: i } = n;
      t.init({
        eWrapper: o,
        valueFormatter: i,
        onPillMouseDown: (r) => {
          r.stopImmediatePropagation();
        },
        announceItemFocus: () => {
          this.announceAriaValue(s);
        },
        getValue: () => this.getValue(),
        setValue: (r) => this.setValue(r, !0)
      });
    }
    this.doWhileBlockingAnnouncement(() => {
      var t;
      return (t = this.pillContainer) == null ? void 0 : t.refresh();
    });
  }
  doWhileBlockingAnnouncement(e) {
    this.skipWrapperAnnouncement = !0, e(), this.skipWrapperAnnouncement = !1;
  }
  onWrapperFocus() {
    const { eInput: e, config: t } = this, { allowTyping: n, multiSelect: o, suppressDeselectAll: s } = t;
    if (n) {
      const i = e.getFocusableElement();
      i.focus(), i.select();
    } else o && !s && !this.skipWrapperAnnouncement && this.announceAriaValue(this.ariaDeselectAllItems);
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  onDeselectAllMouseDown(e) {
    e.stopImmediatePropagation();
  }
  onDeselectAllClick() {
    this.setValue([], !0);
  }
  buildSearchStringFromKeyboardEvent(e) {
    let { key: t } = e;
    if (t === O.BACKSPACE)
      this.searchString = this.searchString.slice(0, -1), t = "";
    else if (!dp(e))
      return;
    e.preventDefault(), this.searchTextFromCharacter(t);
  }
  searchTextFromCharacter(e) {
    this.searchString += e, this.runSearch(), this.clearSearchString();
  }
  searchTextFromString(e) {
    e == null && (e = ""), this.searchString = e, this.runSearch();
  }
  getSearchStringsFromValues(e) {
    const {
      config: { valueFormatter: t }
    } = this;
    return typeof e[0] == "object" && this.searchStringCreator ? this.searchStringCreator(e) : e.map((n) => b0(n, t));
  }
  filterListModel(e) {
    const { filterList: t } = this.config;
    t && this.setValueList({ valueList: e, refresh: !0 });
  }
  runSearch() {
    var l;
    if (!this.listComponent)
      return;
    const { values: e } = this, t = this.searchStrings;
    if (!t) {
      this.listComponent.highlightIndex(-1);
      return;
    }
    const { suggestions: n, filteredValues: o } = this.getSuggestionsAndFilteredValues(this.searchString, t), { filterList: s, highlightMatch: i, searchType: r = "fuzzy" } = this.config, a = !!(s && this.searchString !== "");
    this.filterListModel(a ? o : e), this.highlightEmptyValue() || this.highlightListValue(n, o, a), i && r !== "fuzzy" && ((l = this.listComponent) == null || l.highlightFilterMatch(this.searchString)), this.displayOrHidePicker();
  }
  highlightEmptyValue() {
    var e, t;
    if (this.searchString === "") {
      const n = (e = this.searchStrings) == null ? void 0 : e.indexOf("");
      if (n !== void 0 && n !== -1)
        return (t = this.listComponent) == null || t.highlightIndex(n), !0;
    }
    return !1;
  }
  highlightListValue(e, t, n) {
    var o, s, i, r, a;
    if (e.length) {
      const l = n ? 0 : (o = this.searchStrings) == null ? void 0 : o.indexOf(e[0]);
      l !== void 0 && ((s = this.listComponent) == null || s.highlightIndex(l));
    } else if ((i = this.listComponent) == null || i.highlightIndex(-1), !n || t.length)
      (r = this.listComponent) == null || r.ensureIndexVisible(0);
    else if (n) {
      this.getAriaElement().removeAttribute("data-active-option");
      const l = (a = this.listComponent) == null ? void 0 : a.getAriaElement();
      l && rC(l, null);
    }
  }
  getSuggestionsAndFilteredValues(e, t) {
    let n = [];
    const o = [];
    if (!e.length)
      return { suggestions: n, filteredValues: o };
    const { searchType: s = "fuzzy", filterList: i } = this.config;
    if (s === "fuzzy") {
      const r = La({
        inputValue: e,
        allSuggestions: t,
        hideIrrelevant: !0
      });
      n = r.values;
      const a = r.indices;
      if (i && a.length)
        for (let l = 0; l < a.length; l++)
          o.push(this.values[a[l]]);
    } else
      n = t.filter((r, a) => {
        const l = r.toLocaleLowerCase(), d = this.searchString.toLocaleLowerCase(), c = s === "match" ? l.startsWith(d) : l.indexOf(d) !== -1;
        return i && c && o.push(this.values[a]), c;
      });
    return { suggestions: n, filteredValues: o };
  }
  displayOrHidePicker() {
    if (!this.listComponent)
      return;
    const e = this.listComponent.getGui(), t = this.listComponent.getCurrentList(), n = t ? t.length === 0 : !1;
    e.classList.toggle("ag-hidden", n);
  }
  clearSearchString() {
    this.searchString = "";
  }
  setValue(e, t, n, o) {
    var i, r;
    if (this.value === e)
      return this;
    const s = Array.isArray(e);
    if (e != null) {
      if (!s) {
        const a = (i = this.listComponent) == null ? void 0 : i.getCurrentList();
        if ((a ? a.indexOf(e) : -1) === -1)
          return this;
      }
      n || (r = this.listComponent) == null || r.selectValue(e);
    }
    return super.setValue(e, t), o || this.renderSelectedValue(), this;
  }
  onNavigationKeyDown(e, t, n) {
    var s;
    e.preventDefault();
    const o = t === O.DOWN;
    if (!this.isPickerDisplayed && o) {
      this.showPicker();
      return;
    }
    (s = this.listComponent) == null || s.onNavigationKeyDown(t, n);
  }
  onEnterKeyDown(e) {
    var t;
    if (this.isPickerDisplayed && (e.preventDefault(), (t = this.listComponent) != null && t.getCurrentList())) {
      const n = this.listComponent.getLastItemHovered();
      this.config.multiSelect || n == null ? this.dispatchPickerEventAndHidePicker(this.value, !0) : this.onListValueSelected(/* @__PURE__ */ new Set([n]), !0);
    }
  }
  onDeleteKeyDown(e) {
    const { eWrapper: t, beans: n } = this;
    je(n) === t && (e.preventDefault(), this.setValue([], !0));
  }
  onTabKeyDown() {
    const { config: e, isPickerDisplayed: t, listComponent: n } = this, { multiSelect: o } = e;
    if (!(!t || !n)) {
      if (o) {
        const s = this.getValueFromSet(n.getSelectedItems());
        s && this.setValue(s, !1, !0, !0);
      } else {
        const s = n.getLastItemHovered();
        s && this.setValue(s, !1, !0);
      }
      this.hidePicker();
    }
  }
  getValueFromSet(e) {
    const { multiSelect: t } = this.config;
    let n = null;
    for (const o of e) {
      if (e.size === 1 && !t) {
        n = o;
        break;
      }
      n || (n = []), n.push(o);
    }
    return Array.isArray(n) && n.sort(), n;
  }
  onListValueSelected(e, t) {
    const n = this.getValueFromSet(e);
    this.setValue(n, !1, !0), this.config.multiSelect || this.dispatchPickerEventAndHidePicker(n, t);
  }
  dispatchPickerEventAndHidePicker(e, t) {
    const n = {
      type: "fieldPickerValueSelected",
      fromEnterKey: t,
      value: e
    };
    this.dispatchLocalEvent(n), this.hidePicker();
  }
  getFocusableElement() {
    const { allowTyping: e } = this.config;
    return e ? this.eInput.getFocusableElement() : super.getFocusableElement();
  }
  onKeyDown(e) {
    var d;
    const { key: t, isComposing: n } = e, {
      isPickerDisplayed: o,
      config: { allowTyping: s, multiSelect: i, suppressDeselectAll: r },
      listComponent: a,
      pickerComponent: l
    } = this;
    switch (t) {
      case O.LEFT:
      case O.RIGHT:
        (!s || this.pillContainer) && (e.preventDefault(), this.pillContainer && ((d = this.listComponent) == null || d.highlightIndex(-1), this.pillContainer.onNavigationKeyDown(e)));
        break;
      case O.PAGE_HOME:
      case O.PAGE_END:
        if (s) {
          e.preventDefault();
          const c = this.eInput.getInputElement(), u = t === O.PAGE_HOME ? 0 : c.value.length;
          c.setSelectionRange(u, u);
          break;
        }
      case O.PAGE_UP:
      case O.PAGE_DOWN:
        e.preventDefault(), l && (a == null || a.navigateToPage(t));
        break;
      case O.DOWN:
      case O.UP:
        n || this.onNavigationKeyDown(e, t, () => {
          i && (this.doWhileBlockingAnnouncement(() => this.eWrapper.focus()), this.announceAriaValue(this.ariaToggleSelection));
        });
        break;
      case O.ESCAPE:
        o && (vn(this.listComponent.getGui()) && (e.preventDefault(), bt(e)), this.hidePicker());
        break;
      case O.ENTER:
        n ? e.preventDefault() : this.onEnterKeyDown(e);
        break;
      case O.SPACE:
        if ((!s || n) && e.preventDefault(), !n && o && i && a) {
          const c = a.getLastItemHovered();
          c && a.toggleListItemSelection(c);
        }
        break;
      case O.TAB:
        this.onTabKeyDown();
        break;
      case O.DELETE:
        i && !r && this.onDeleteKeyDown(e);
        break;
      default:
        s || this.buildSearchStringFromKeyboardEvent(e);
    }
  }
  announceAriaValue(e) {
    var t;
    (t = this.ariaAnnounce) == null || t.announceValue(e, "richSelect");
  }
  destroy() {
    this.listComponent && (this.listComponent = this.destroyBean(this.listComponent)), this.searchStrings = void 0, super.destroy();
  }
}, b0 = (e, t) => (t == null ? void 0 : t(e)) ?? String(e ?? "");
function Rb(e, t) {
  e.then((n) => {
    const o = n.getGui();
    o != null && t.appendChild(o);
  });
}
var Z7 = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-collapsed",
      children: [
        { tag: "div", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "ag-input-text-field", ref: "eInput", cls: "ag-rich-select-field-input" },
        {
          tag: "span",
          ref: "eDeselect",
          cls: "ag-rich-select-deselect-button ag-picker-field-icon",
          role: "presentation"
        },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, Eb = class extends xb {
  constructor(e) {
    super({
      ...e,
      template: Z7,
      agComponents: [ao]
    }), this.params = e;
  }
  showPicker() {
    setTimeout(() => super.showPicker());
  }
  hidePicker() {
    setTimeout(() => super.hidePicker());
  }
  postConstruct() {
    super.postConstruct();
    const { wrapperClassName: e, ariaLabel: t } = this.params;
    He(this.eDisplayField, !1), e && this.eWrapper.classList.add(e), Ms(this.eWrapper, ""), yt(this.eWrapper, t);
  }
  onEnterKeyDown(e) {
    bt(e), this.isPickerDisplayed ? super.onEnterKeyDown(e) : (e.preventDefault(), this.showPicker());
  }
}, Ab = class extends U {
  constructor(e, t, n) {
    super(), this.eGui = e, this.focusWrapper = t, this.eFocusableComp = n;
  }
  postConstruct() {
    this.addManagedElementListeners(this.eGui, {
      keydown: (t) => {
        switch (t.key) {
          case O.TAB:
            t.defaultPrevented || bt(t);
            break;
          case O.UP:
          case O.DOWN:
            bt(t);
            break;
          case O.ESCAPE:
            if (Dn(t))
              return;
            this.eGui.contains(je(this.beans)) && (t.preventDefault(), bt(t), this.focusWrapper.focus());
            break;
        }
      }
    });
    const e = "ag-advanced-filter-builder-virtual-list-item-highlight";
    this.addManagedListeners(this.focusWrapper, {
      keydown: (t) => {
        switch (t.key) {
          case O.ENTER:
            if (Dn(t))
              return;
            je(this.beans) === this.focusWrapper && (t.preventDefault(), bt(t), this.eFocusableComp.getFocusableElement().focus());
            break;
        }
      },
      focusin: () => {
        this.focusWrapper.classList.add(e);
      },
      focusout: (t) => {
        this.focusWrapper.contains(t.relatedTarget) || this.focusWrapper.classList.remove(e);
      }
    });
  }
};
function Fb(e, t) {
  return {
    pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderAddField",
    pickerAriaLabelValue: "Advanced Filter Builder Add Field",
    pickerType: "ag-list",
    valueList: [
      {
        key: "condition",
        displayValue: e("advancedFilterBuilderAddCondition")
      },
      {
        key: "join",
        displayValue: e("advancedFilterBuilderAddJoin")
      }
    ],
    valueFormatter: (n) => n == null ? "" : n.displayValue ?? n.key,
    pickerIcon: "advancedFilterBuilderAdd",
    maxPickerWidth: `${t ?? 120}px`,
    wrapperClassName: "ag-advanced-filter-builder-item-button",
    ariaLabel: e("advancedFilterBuilderAddButtonTooltip")
  };
}
var q7 = {
  tag: "div",
  cls: "ag-advanced-filter-builder-item-wrapper",
  role: "presentation",
  children: [
    {
      tag: "div",
      ref: "eItem",
      cls: "ag-advanced-filter-builder-item",
      role: "presentation",
      children: [
        {
          tag: "div",
          cls: "ag-advanced-filter-builder-item-tree-lines",
          attrs: { "aria-hidden": "true" },
          children: [
            {
              tag: "div",
              cls: "ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"
            }
          ]
        }
      ]
    }
  ]
}, j7 = class extends Te {
  constructor(e, t) {
    super(q7), this.item = e, this.focusWrapper = t, this.eItem = X;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    var n;
    rc(this.focusWrapper, 2);
    const e = Fb(
      (o) => this.advFilterExpSvc.translate(o),
      (n = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : n.addSelectWidth
    ), t = this.createManagedBean(new Eb(e));
    this.addManagedListeners(t, {
      fieldPickerValueSelected: ({ value: o }) => {
        this.dispatchLocalEvent({
          type: "advancedFilterBuilderAdded",
          item: this.item,
          isJoin: o.key === "join"
        });
      }
    }), this.eItem.appendChild(t.getGui()), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => t.getGui(),
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
      })
    ), this.createManagedBean(
      new Ab(this.getGui(), this.focusWrapper, t)
    ), yt(
      this.focusWrapper,
      this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
        this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip"),
        `${this.item.level + 1}`
      ])
    );
  }
  afterAdd() {
  }
}, Y7 = class extends Te {
  constructor() {
    super({ tag: "div", cls: "ag-advanced-filter-builder-item-condition", role: "presentation" }), this.validationMessage = null;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  init(e) {
    const { item: t, createPill: n } = e;
    this.item = t, this.createPill = n, this.filterModel = t.filterModel, this.setupColumnCondition(this.filterModel), this.validate(), this.addDestroyFunc(() => this.destroyBeans([this.eColumnPill, this.eOperatorPill, this.eOperandPill]));
  }
  getDragName() {
    return this.filterModel.colId ? this.advFilterExpSvc.parseColumnFilterModel(this.filterModel) : this.getDefaultColumnDisplayValue();
  }
  getAriaLabel() {
    return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderFilterItem")} ${this.getDragName()}`;
  }
  getValidationMessage() {
    return this.validationMessage;
  }
  getFocusableElement() {
    return this.eColumnPill.getFocusableElement();
  }
  setupColumnCondition(e) {
    const t = this.advFilterExpSvc.getColumnDetails(e.colId);
    this.baseCellDataType = t.baseCellDataType, this.column = t.column, this.numOperands = this.getNumOperands(this.getOperatorKey()), this.eColumnPill = this.createPill({
      key: this.getColumnKey(),
      displayValue: this.getColumnDisplayValue() ?? this.getDefaultColumnDisplayValue(),
      cssClass: "ag-advanced-filter-builder-column-pill",
      isSelect: !0,
      getEditorParams: () => ({ values: this.advFilterExpSvc.getColumnAutocompleteEntries() }),
      update: (n) => this.setColumnKey(n),
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderColumnSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Column Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderColumn")
    }), this.getGui().appendChild(this.eColumnPill.getGui()), ue(this.getColumnKey()) && (this.createOperatorPill(), this.hasOperand() && this.createOperandPill());
  }
  createOperatorPill() {
    this.eOperatorPill = this.createPill({
      key: this.getOperatorKey(),
      displayValue: this.getOperatorDisplayValue() ?? this.getDefaultOptionSelectValue(),
      cssClass: "ag-advanced-filter-builder-option-pill",
      isSelect: !0,
      getEditorParams: () => ({ values: this.getOperatorAutocompleteEntries() }),
      update: (e) => this.setOperatorKey(e),
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderOptionSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Option Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderOption")
    }), this.eColumnPill.getGui().insertAdjacentElement("afterend", this.eOperatorPill.getGui());
  }
  createOperandPill() {
    const { filter: e } = this.filterModel, t = (typeof e == "number" ? Pn(e) : e) ?? "";
    this.eOperandPill = this.createPill({
      key: t,
      // Convert from the input format to display format.
      // Input format matches model format except for numbers, but these get stringified anyway
      valueFormatter: (n) => this.advFilterExpSvc.getOperandDisplayValue({ ...this.filterModel, filter: n }, !0),
      baseCellDataType: this.baseCellDataType,
      cssClass: "ag-advanced-filter-builder-value-pill",
      isSelect: !1,
      update: (n) => this.setOperand(n),
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderValue")
    }), this.getGui().appendChild(this.eOperandPill.getGui());
  }
  getColumnKey() {
    return this.filterModel.colId;
  }
  getColumnDisplayValue() {
    return this.advFilterExpSvc.getColumnDisplayValue(this.filterModel);
  }
  getOperatorKey() {
    return this.filterModel.type;
  }
  getOperatorDisplayValue() {
    return this.advFilterExpSvc.getOperatorDisplayValue(this.filterModel);
  }
  getOperandDisplayValue() {
    return this.advFilterExpSvc.getOperandDisplayValue(this.filterModel, !0);
  }
  hasOperand() {
    return this.numOperands > 0;
  }
  getOperatorAutocompleteEntries() {
    return this.column ? this.advFilterExpSvc.getOperatorAutocompleteEntries(this.column, this.baseCellDataType) : [];
  }
  setColumnKey(e) {
    this.eOperatorPill || this.createOperatorPill();
    const t = this.advFilterExpSvc.getColumnDetails(e);
    this.column = t.column;
    const n = t.baseCellDataType;
    this.baseCellDataType !== n && (this.baseCellDataType = n, this.setOperatorKey(void 0), this.eOperatorPill && (nn(this.eOperatorPill.getGui()), this.destroyBean(this.eOperatorPill), this.createOperatorPill()), this.validate()), this.filterModel.colId = e, this.filterModel.filterType = this.baseCellDataType;
  }
  setOperatorKey(e) {
    const t = this.getNumOperands(e);
    t !== this.numOperands && (this.numOperands = t, t === 0 ? this.destroyOperandPill() : (this.createOperandPill(), this.baseCellDataType !== "number" && this.setOperand(""))), this.filterModel.type = e, this.validate();
  }
  setOperand(e) {
    let t = e;
    this.baseCellDataType === "number" && (t = ue(e) ? Number(e) : ""), this.filterModel.filter = t, this.validate();
  }
  getNumOperands(e) {
    var t;
    return ((t = this.advFilterExpSvc.getExpressionOperator(this.baseCellDataType, e)) == null ? void 0 : t.numOperands) ?? 0;
  }
  destroyOperandPill() {
    delete this.filterModel.filter, this.getGui().removeChild(this.eOperandPill.getGui()), this.destroyBean(this.eOperandPill), this.eOperandPill = void 0;
  }
  validate() {
    let e = null;
    ue(this.getColumnKey()) ? ue(this.getOperatorKey()) ? this.numOperands > 0 && !ue(this.getOperandDisplayValue()) && (e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationEnterValue")) : e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectOption") : e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectColumn"), this.item.valid = !e, e !== this.validationMessage && (this.validationMessage = e, this.dispatchLocalEvent({
      type: "advancedFilterBuilderValidChanged"
    }));
  }
  getDefaultColumnDisplayValue() {
    return this.advFilterExpSvc.translate("advancedFilterBuilderSelectColumn");
  }
  getDefaultOptionSelectValue() {
    return this.advFilterExpSvc.translate("advancedFilterBuilderSelectOption");
  }
}, Q7 = {
  number: [Cc],
  boolean: [Fo],
  object: [Fo],
  text: [Fo],
  date: [Xr],
  dateString: [Xr],
  dateTime: [Xr, (e) => e.setIncludeTime(!0)],
  dateTimeString: [Xr, (e) => e.setIncludeTime(!0)]
}, J7 = {
  tag: "div",
  cls: "ag-advanced-filter-builder-pill-wrapper",
  role: "presentation",
  children: [
    {
      tag: "div",
      ref: "ePill",
      cls: "ag-advanced-filter-builder-pill",
      role: "button",
      children: [
        {
          tag: "span",
          ref: "eLabel",
          cls: "ag-advanced-filter-builder-pill-display"
        }
      ]
    }
  ]
}, X7 = class extends Te {
  constructor(e) {
    super(J7), this.params = e, this.ePill = X, this.eLabel = X;
    const { value: t, valueFormatter: n } = e;
    this.value = t, this.displayValue = n(t);
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  postConstruct() {
    const { cssClass: e, ariaLabel: t } = this.params;
    this.ePill.classList.add(e), this.activateTabIndex([this.ePill]), this.eLabel.id = `${this.getCompId()}`, ic(this.ePill, this.eLabel.id), yt(this.ePill, t), this.renderValue(), this.addManagedListeners(this.ePill, {
      click: (n) => {
        n.preventDefault(), this.showEditor();
      },
      keydown: (n) => {
        switch (n.key) {
          case O.ENTER:
            n.preventDefault(), bt(n), this.showEditor();
            break;
        }
      }
    }), this.addDestroyFunc(() => this.destroyBean(this.eEditor));
  }
  getFocusableElement() {
    return this.ePill;
  }
  showEditor() {
    if (this.eEditor)
      return;
    He(this.ePill, !1), this.eEditor = this.createEditorComp(this.params.type), this.eEditor.setValue(this.value);
    const e = this.eEditor.getGui();
    this.eEditor.addManagedElementListeners(e, {
      keydown: (t) => {
        switch (t.key) {
          case O.ENTER:
            t.preventDefault(), bt(t), this.updateValue(!0);
            break;
          case O.ESCAPE:
            t.preventDefault(), bt(t), this.hideEditor(!0);
            break;
        }
      },
      focusout: () => this.updateValue(!1)
    }), this.getGui().appendChild(e), this.eEditor.getFocusableElement().focus();
  }
  /**
   * Responsible for instantiating an InputField and calling some of the setup methods
   */
  createEditorComp(e) {
    const [t, n] = Q7[e], o = this.createBean(new t());
    return n && n(o), o;
  }
  hideEditor(e) {
    const { eEditor: t } = this;
    t && (this.eEditor = void 0, this.getGui().removeChild(t.getGui()), this.destroyBean(t), He(this.ePill, !0), e && this.ePill.focus());
  }
  renderValue() {
    let e;
    const { displayValue: t, eLabel: n } = this, { classList: o } = n;
    o.remove(
      "ag-advanced-filter-builder-value-empty",
      "ag-advanced-filter-builder-value-number",
      "ag-advanced-filter-builder-value-text"
    ), ue(t) ? this.params.type === "number" ? (e = t, o.add("ag-advanced-filter-builder-value-number")) : (e = `"${t}"`, o.add("ag-advanced-filter-builder-value-text")) : (e = this.advFilterExpSvc.translate("advancedFilterBuilderEnterValue"), o.add("ag-advanced-filter-builder-value-empty")), n.textContent = e;
  }
  updateValue(e) {
    if (!this.eEditor)
      return;
    const t = this.eEditor.getValue() ?? "";
    this.dispatchLocalEvent({
      type: "fieldValueChanged",
      value: t
    }), this.value = t, this.displayValue = this.params.valueFormatter(t), this.renderValue(), this.hideEditor(e);
  }
}, e_ = class extends Te {
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  constructor() {
    super({
      tag: "div",
      cls: "ag-advanced-filter-builder-item-condition",
      role: "presentation"
    });
  }
  init(e) {
    const { item: t, createPill: n } = e, o = t.filterModel;
    this.filterModel = o, this.ePill = n({
      key: o.type,
      displayValue: this.advFilterExpSvc.parseJoinOperator(o),
      cssClass: "ag-advanced-filter-builder-join-pill",
      isSelect: !0,
      getEditorParams: () => ({
        values: this.advFilterExpSvc.getJoinOperatorAutocompleteEntries()
      }),
      update: (s) => o.type = s,
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderJoinSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Join Operator Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderJoinOperator")
    }), this.getGui().appendChild(this.ePill.getGui()), this.addDestroyFunc(() => this.destroyBean(this.ePill));
  }
  getDragName() {
    return this.advFilterExpSvc.parseJoinOperator(this.filterModel);
  }
  getAriaLabel() {
    return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderGroupItem")} ${this.getDragName()}`;
  }
  getValidationMessage() {
    return null;
  }
  getFocusableElement() {
    return this.ePill.getFocusableElement();
  }
}, t_ = {
  tag: "div",
  cls: "ag-picker-field ag-advanced-filter-builder-pill-wrapper",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed",
      children: [
        {
          tag: "div",
          ref: "eDisplayField",
          cls: "ag-picker-field-display ag-advanced-filter-builder-pill-display"
        },
        { tag: "ag-input-text-field", ref: "eInput", cls: "ag-rich-select-field-input" },
        {
          tag: "span",
          ref: "eDeselect",
          cls: "ag-rich-select-deselect-button ag-picker-field-icon",
          role: "presentation"
        },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, n_ = class extends xb {
  constructor(e) {
    super({
      ...e,
      template: t_,
      agComponents: [ao]
    }), this.params = e;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  showPicker() {
    setTimeout(() => super.showPicker());
  }
  hidePicker() {
    setTimeout(() => super.hidePicker());
  }
  postConstruct() {
    super.postConstruct();
    const { wrapperClassName: e, ariaLabel: t } = this.params;
    this.eWrapper.classList.add(e), Ms(this.eWrapper, ""), yt(this.eWrapper, t);
  }
  createPickerComponent() {
    if (!this.values) {
      const { values: e } = this.params.getEditorParams();
      this.values = e;
      const t = this.value.key, n = e.find((o) => o.key === t) ?? {
        key: t,
        displayValue: this.value.displayValue
      };
      this.value = n;
    }
    return super.createPickerComponent();
  }
  onEnterKeyDown(e) {
    bt(e), this.isPickerDisplayed ? super.onEnterKeyDown(e) : (e.preventDefault(), this.showPicker());
  }
}, o_ = {
  tag: "div",
  cls: "ag-advanced-filter-builder-item-wrapper",
  role: "presentation",
  children: [
    {
      tag: "div",
      cls: "ag-advanced-filter-builder-item",
      role: "presentation",
      children: [
        {
          tag: "div",
          ref: "eTreeLines",
          cls: "ag-advanced-filter-builder-item-tree-lines",
          attrs: { "aria-hidden": "true" }
        },
        {
          tag: "span",
          ref: "eDragHandle",
          cls: "ag-drag-handle",
          attrs: { "aria-hidden": "true" }
        },
        {
          tag: "span",
          ref: "eValidation",
          cls: "ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid",
          attrs: { "aria-hidden": "true" }
        }
      ]
    },
    {
      tag: "div",
      ref: "eButtons",
      cls: "ag-advanced-filter-builder-item-buttons",
      children: [
        { tag: "span", ref: "eMoveUpButton", cls: "ag-advanced-filter-builder-item-button", role: "button" },
        { tag: "span", ref: "eMoveDownButton", cls: "ag-advanced-filter-builder-item-button", role: "button" },
        { tag: "div", ref: "eAddButton", role: "presentation" },
        { tag: "span", ref: "eRemoveButton", cls: "ag-advanced-filter-builder-item-button", role: "button" }
      ]
    }
  ]
}, Gu = class extends Ti {
  constructor(e, t, n) {
    super(o_), this.item = e, this.dragFeature = t, this.focusWrapper = n, this.eTreeLines = X, this.eDragHandle = X, this.eButtons = X, this.eValidation = X, this.eMoveUpButton = X, this.eMoveDownButton = X, this.eAddButton = X, this.eRemoveButton = X, this.moveUpDisabled = !1, this.moveDownDisabled = !1;
  }
  wireBeans(e) {
    this.dragAndDrop = e.dragAndDrop, this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    const { filterModel: e, level: t, showMove: n } = this.item, o = e.filterType === "join";
    if (this.ePillWrapper = this.createManagedBean(o ? new e_() : new Y7()), this.ePillWrapper.init({ item: this.item, createPill: (s) => this.createPill(s) }), this.eDragHandle.insertAdjacentElement("afterend", this.ePillWrapper.getGui()), t === 0) {
      const s = Ue({
        tag: "div",
        cls: "ag-advanced-filter-builder-item-tree-line-vertical-bottom ag-advanced-filter-builder-item-tree-line-root"
      });
      this.eTreeLines.appendChild(s), He(this.eDragHandle, !1), He(this.eButtons, !1), Zn(this.focusWrapper, !0);
    } else
      this.setupTreeLines(t), this.eDragHandle.appendChild(Le("advancedFilterBuilderDrag", this.beans)), this.setupValidation(), this.setupMoveButtons(n), this.setupAddButton(), this.setupRemoveButton(), this.setupDragging(), this.updateAriaExpanded();
    rc(this.focusWrapper, t + 1), this.initialiseTabGuard({}), this.createManagedBean(
      new Ab(this.getGui(), this.focusWrapper, this.ePillWrapper)
    ), this.updateAriaLabel(), this.addManagedListeners(this.ePillWrapper, {
      advancedFilterBuilderValueChanged: () => this.dispatchLocalEvent({
        type: "advancedFilterBuilderValueChanged"
      }),
      advancedFilterBuilderValidChanged: () => this.updateValidity()
    });
  }
  setState(e) {
    var a, l;
    const { level: t } = this.item;
    if (t === 0)
      return;
    const { showMove: n } = this.item, { disableMoveUp: o, disableMoveDown: s, treeLines: i, showStartTreeLine: r } = e;
    this.updateTreeLines(i, r), this.updateAriaExpanded(), n && (this.moveUpDisabled = !!o, this.moveDownDisabled = !!s, this.eMoveUpButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", o), this.eMoveDownButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", s), Cd(this.eMoveUpButton, !!o), Cd(this.eMoveDownButton, !!s), (a = this.moveUpTooltipFeature) == null || a.refreshTooltip(), (l = this.moveDownTooltipFeature) == null || l.refreshTooltip());
  }
  focusMoveButton(e) {
    (e ? this.eMoveUpButton : this.eMoveDownButton).focus();
  }
  afterAdd() {
    this.ePillWrapper.getFocusableElement().focus();
  }
  setupTreeLines(e) {
    for (let t = 0; t < e; t++)
      this.eTreeLines.appendChild(Ue({ tag: "div" }));
  }
  updateTreeLines(e, t) {
    const n = e.length - 1, { children: o } = this.eTreeLines;
    for (let i = 0; i < n; i++) {
      const r = o.item(i);
      r && r.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !e[i]);
    }
    const s = o.item(n);
    if (s) {
      s.classList.add("ag-advanced-filter-builder-item-tree-line-horizontal");
      const i = e[n];
      s.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-top", i), s.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !i);
    }
    this.eDragHandle.classList.toggle(
      "ag-advanced-filter-builder-item-tree-line-vertical-bottom",
      t
    );
  }
  setupValidation() {
    this.eValidation.appendChild(Le("advancedFilterBuilderInvalid", this.beans)), this.validationTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eValidation,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.ePillWrapper.getValidationMessage(),
        getTooltipShowDelayOverride: () => 1e3
      })
    ), this.updateValidity();
  }
  setupAddButton() {
    var n;
    const e = Fb(
      (o) => this.advFilterExpSvc.translate(o),
      (n = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : n.addSelectWidth
    ), t = this.createManagedBean(new Eb(e));
    this.addManagedListeners(t, {
      fieldPickerValueSelected: ({ value: o }) => this.dispatchLocalEvent({
        type: "advancedFilterBuilderAdded",
        item: this.item,
        isJoin: o.key === "join"
      })
    }), this.eAddButton.appendChild(t.getGui()), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eAddButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
      })
    );
  }
  setupRemoveButton() {
    this.eRemoveButton.appendChild(Le("advancedFilterBuilderRemove", this.beans)), this.addManagedListeners(this.eRemoveButton, {
      click: () => this.removeItem(),
      keydown: (e) => {
        switch (e.key) {
          case O.ENTER:
            e.preventDefault(), bt(e), this.removeItem();
            break;
        }
      }
    }), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eRemoveButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")
      })
    ), yt(this.eRemoveButton, this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")), this.activateTabIndex([this.eRemoveButton]);
  }
  setupMoveButtons(e) {
    e ? (this.eMoveUpButton.appendChild(Le("advancedFilterBuilderMoveUp", this.beans)), this.addManagedListeners(this.eMoveUpButton, {
      click: () => this.moveItem(!0),
      keydown: (t) => {
        switch (t.key) {
          case O.ENTER:
            t.preventDefault(), bt(t), this.moveItem(!0);
            break;
        }
      }
    }), this.moveUpTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eMoveUpButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.moveUpDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
      })
    ), yt(
      this.eMoveUpButton,
      this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
    ), this.eMoveDownButton.appendChild(Le("advancedFilterBuilderMoveDown", this.beans)), this.addManagedListeners(this.eMoveDownButton, {
      click: () => this.moveItem(!1),
      keydown: (t) => {
        switch (t.key) {
          case O.ENTER:
            t.preventDefault(), bt(t), this.moveItem(!1);
            break;
        }
      }
    }), this.moveDownTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eMoveDownButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.moveDownDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
      })
    ), yt(
      this.eMoveDownButton,
      this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
    ), this.activateTabIndex([this.eMoveUpButton, this.eMoveDownButton])) : (He(this.eMoveUpButton, !1), He(this.eMoveDownButton, !1));
  }
  updateValidity() {
    var e;
    uC(this.eValidation, !this.item.valid), (e = this.validationTooltipFeature) == null || e.refreshTooltip(), this.updateAriaLabel();
  }
  createPill(e) {
    const { key: t, cssClass: n, update: o, ariaLabel: s } = e, i = (r) => {
      r != null && (o(r), this.dispatchLocalEvent({
        type: "advancedFilterBuilderValueChanged"
      }));
    };
    if (e.isSelect) {
      const { getEditorParams: r, pickerAriaLabelKey: a, pickerAriaLabelValue: l, displayValue: d } = e, c = this.gos.get("advancedFilterBuilderParams"), u = `${(c == null ? void 0 : c.pillSelectMinWidth) ?? 140}px`, h = `${(c == null ? void 0 : c.pillSelectMaxWidth) ?? 200}px`, g = this.createBean(
        new n_({
          pickerAriaLabelKey: a,
          pickerAriaLabelValue: l,
          pickerType: "ag-list",
          value: {
            key: t,
            displayValue: d
          },
          valueFormatter: (p) => p == null ? "" : p.displayValue ?? p.key,
          variableWidth: !0,
          minPickerWidth: u,
          maxPickerWidth: h,
          getEditorParams: r,
          wrapperClassName: n,
          ariaLabel: s,
          pickerIcon: "advancedFilterBuilderSelectOpen"
        })
      );
      return this.addManagedListeners(g, {
        fieldPickerValueSelected: ({ value: p }) => i(p == null ? void 0 : p.key)
      }), g;
    } else {
      const { baseCellDataType: r, valueFormatter: a } = e, l = this.createBean(
        new X7({
          value: t,
          valueFormatter: a,
          cssClass: n,
          type: r,
          ariaLabel: s
        })
      );
      return this.addManagedListeners(l, { fieldValueChanged: ({ value: d }) => i(d) }), l;
    }
  }
  setupDragging() {
    const e = {
      type: ns.AdvancedFilterBuilder,
      eElement: this.eDragHandle,
      dragItemName: () => this.ePillWrapper.getDragName(),
      getDefaultIconName: () => "notAllowed",
      getDragItem: () => ({}),
      onDragStarted: () => this.dragFeature.dispatchLocalEvent({
        type: "advancedFilterBuilderDragStarted",
        item: this.item
      }),
      onDragStopped: () => this.dragFeature.dispatchLocalEvent({
        type: "advancedFilterBuilderDragEnded"
      })
    };
    this.dragAndDrop.addDragSource(e, !0), this.addDestroyFunc(() => this.dragAndDrop.removeDragSource(e));
  }
  updateAriaLabel() {
    const e = this.ePillWrapper.getAriaLabel(), t = `${this.item.level + 1}`, n = this.ePillWrapper.getValidationMessage();
    let o;
    n ? o = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItemValidation", [
      e,
      t,
      n
    ]) : o = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [e, t]), yt(this.focusWrapper, o);
  }
  updateAriaExpanded() {
    aC(this.focusWrapper);
    const { filterModel: e } = this.item;
    (e == null ? void 0 : e.filterType) === "join" && e.conditions.length && Zn(this.focusWrapper, !0);
  }
  removeItem() {
    this.dispatchLocalEvent({
      type: "advancedFilterBuilderRemoved",
      item: this.item
    });
  }
  moveItem(e) {
    this.dispatchLocalEvent({
      type: "advancedFilterBuilderMoved",
      item: this.item,
      backwards: e
    });
  }
}, s_ = {
  apply: "advancedFilterBuilderApply",
  clear: "advancedFilterBuilderClear",
  cancel: "advancedFilterBuilderCancel",
  reset: "advancedFilterBuilderReset"
}, i_ = {
  tag: "div",
  cls: "ag-advanced-filter-builder",
  role: "presentation",
  attrs: { tabindex: "-1" },
  children: [
    {
      tag: "div",
      ref: "eList",
      cls: "ag-advanced-filter-builder-list",
      role: "presentation"
    }
  ]
}, r_ = class extends Te {
  constructor() {
    super(i_), this.eList = X;
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.advancedFilter = e.advancedFilter, this.advFilterExpSvc = e.advFilterExpSvc;
  }
  postConstruct() {
    const e = this.gos.get("advancedFilterBuilderParams");
    this.params = { buttons: ["apply", "cancel"], ...e }, this.addManagedPropertyListener("advancedFilterBuilderParams", ({ currentValue: t }) => {
      this.params.showMoveButtons = !!(t != null && t.showMoveButtons), this.params.buttons = (t == null ? void 0 : t.buttons) ?? ["apply", "cancel"], this.refreshList(!1);
    }), this.filterModel = this.setupFilterModel(), this.setupVirtualList(), this.dragFeature = this.createManagedBean(new G7(this, this.virtualList)), this.resetButtonsPanel(this.params.buttons);
  }
  refresh() {
    const e = this.virtualList;
    let t = e.getLastFocusedRow();
    this.setupFilterModel(), this.validateItems(), this.refreshList(!1), t != null && (e.getComponentAt(t) || (t = 0), e.focusRow(t));
  }
  getNumItems() {
    return this.items.length;
  }
  moveItem(e, t) {
    !t || !e || this.moveItemToIndex(e, t.rowIndex, t.position);
  }
  afterGuiAttached() {
    this.virtualList.awaitStable(() => this.virtualList.focusRow(0));
  }
  setupVirtualList() {
    const e = this.virtualList = this.createManagedBean(
      new Lr({
        cssIdentifier: "advanced-filter-builder",
        ariaRole: "tree",
        listName: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderList"),
        moveItemCallback: this.virtualListMoveItemCallback.bind(this)
      })
    );
    e.setComponentCreator(this.createItemComponent.bind(this)), e.setComponentUpdater(this.updateItemComponent.bind(this)), e.setRowHeight(40), this.eList.appendChild(e.getGui()), e.setModel({
      getRowCount: () => {
        var t;
        return ((t = this.items) == null ? void 0 : t.length) || 0;
      },
      getRow: (t) => this.items[t],
      areRowsEqual: (t, n) => t === n
    }), this.buildList(), e.refresh();
  }
  resetButtonsPanel(e) {
    const t = e && e.length > 0;
    let n = this.eButtons;
    if (t) {
      const o = e.map((i) => ({
        type: i,
        label: this.advFilterExpSvc.translate(s_[i])
      }));
      if (!n) {
        n = this.createBean(new vp()), this.appendChild(n.getGui());
        const i = (r) => ({ event: a }) => {
          this.updateModel(r), this.afterAction(r, a);
        };
        n.addManagedListeners(n, {
          apply: i("apply"),
          clear: i("clear"),
          reset: i("reset"),
          cancel: i("cancel")
        }), this.eButtons = n;
      }
      n.updateButtons(o);
      const s = n.getApplyButton();
      if (s) {
        const i = (r) => this.toggleCss("ag-advanced-filter-builder-validation", r);
        this.addManagedElementListeners(s, {
          mouseenter: () => i(!0),
          mouseleave: () => i(!1)
        });
      }
    } else
      n && (nn(n.getGui()), this.eButtons = this.destroyBean(n));
  }
  updateModel(e) {
    var t, n;
    switch (e) {
      case "apply":
        this.advancedFilter.setModel(this.filterModel), (t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" });
        break;
      case "reset":
        this.advancedFilter.setModel(null), (n = this.filterManager) == null || n.onFilterChanged({ source: "advancedFilter" });
        break;
      case "cancel":
        break;
      case "clear":
        this.filterModel = this.formatFilterModel(null), this.refreshList(!1);
        break;
    }
  }
  afterAction(e, t) {
    switch (e) {
      case "apply": {
        t == null || t.preventDefault(), this.close();
        break;
      }
      case "reset": {
        this.close();
        break;
      }
      case "cancel": {
        this.close();
        break;
      }
    }
  }
  removeItemFromParent(e) {
    const t = e.parent.conditions.indexOf(e.filterModel);
    return e.parent.conditions.splice(t, 1), t;
  }
  moveItemToIndex(e, t, n) {
    var a;
    const o = this.items[t], s = ((a = o.filterModel) == null ? void 0 : a.filterType) === "join" && n === "bottom", i = s ? o.filterModel : o.parent;
    if (!i || this.isChildOrSelf(i, e.filterModel) || o === e)
      return;
    this.removeItemFromParent(e);
    let r;
    s ? r = 0 : (r = i.conditions.indexOf(o.filterModel), r === -1 ? r = i.conditions.length : n === "bottom" && (r += 1)), i.conditions.splice(r, 0, e.filterModel), this.refreshList(!1);
  }
  isChildOrSelf(e, t) {
    return e === t || t.filterType === "join" && t.conditions.some((n) => this.isChildOrSelf(e, n));
  }
  setupFilterModel() {
    const e = this.formatFilterModel(this.advancedFilter.getModel());
    return this.stringifiedModel = JSON.stringify(e), e;
  }
  formatFilterModel(e) {
    return e = e ?? {
      filterType: "join",
      type: "AND",
      conditions: []
    }, e.filterType !== "join" && (e = {
      filterType: "join",
      type: "AND",
      conditions: [e]
    }), e;
  }
  buildList() {
    const e = (t, n, o, s) => {
      n.push({ filterModel: t, level: o, parent: s, valid: !0, showMove: this.params.showMoveButtons }), t.filterType === "join" && (t.conditions.forEach(
        (i) => e(i, n, o + 1, t)
      ), o === 0 && n.push({ filterModel: null, level: o + 1, parent: t, valid: !0 }));
    };
    this.items = [], e(this.filterModel, this.items, 0);
  }
  refreshList(e) {
    if (!e) {
      const t = [];
      this.items.forEach((n) => {
        n.valid || t.push(n.filterModel);
      }), this.buildList(), t.length && this.items.forEach((n) => {
        n.filterModel && t.includes(n.filterModel) && (n.valid = !1);
      });
    }
    this.virtualList.refresh(e), this.validate();
  }
  updateItemComponent(e, t) {
    const n = this.items.indexOf(e), o = (a, l) => {
      const d = this.items.find((u) => u.filterModel === a), c = d == null ? void 0 : d.parent;
      if (c) {
        const { conditions: u } = c;
        o(c, l), l.push(u[u.length - 1] === a);
      }
    }, s = [], { filterModel: i } = e;
    i && (o(i, s), s[0] = !1);
    const r = (i == null ? void 0 : i.filterType) === "join" && !!i.conditions.length;
    t.setState({
      disableMoveUp: n === 1,
      disableMoveDown: !this.canMoveDown(e, n),
      treeLines: s,
      showStartTreeLine: r
    });
  }
  createItemComponent(e, t) {
    const n = this.createBean(
      e.filterModel ? new Gu(e, this.dragFeature, t) : new j7(e, t)
    );
    return n.addManagedListeners(n, {
      advancedFilterBuilderRemoved: ({ item: o }) => this.removeItem(o),
      advancedFilterBuilderValueChanged: () => this.validate(),
      advancedFilterBuilderAdded: ({ item: o, isJoin: s }) => this.addItem(o, s),
      advancedFilterBuilderMoved: ({ item: o, backwards: s }) => this.moveItemUpDown(o, s)
    }), n instanceof Gu && this.updateItemComponent(e, n), n;
  }
  addItem(e, t) {
    var u;
    const { parent: n, level: o, filterModel: s } = e, i = (s == null ? void 0 : s.filterType) === "join", r = t ? {
      filterType: "join",
      type: "AND",
      conditions: []
    } : {}, a = i ? s : n;
    let l = i ? 0 : a.conditions.indexOf(s);
    l >= 0 ? (i || (l += 1), a.conditions.splice(l, 0, r)) : a.conditions.push(r);
    let d = this.items.indexOf(e);
    const c = d >= 0;
    if (c) {
      e.filterModel && d++;
      const h = [
        {
          filterModel: r,
          level: i ? o + 1 : o,
          parent: a,
          valid: t,
          showMove: this.params.showMoveButtons
        }
      ];
      this.items.splice(d, 0, ...h);
    }
    this.refreshList(c), c && ((u = this.virtualList.getComponentAt(d)) == null || u.afterAdd());
  }
  removeItem(e) {
    var a;
    const t = e.parent, { filterModel: n } = e, o = t.conditions.indexOf(n);
    t.conditions.splice(o, 1);
    const s = ((a = e.filterModel) == null ? void 0 : a.filterType) === "join", i = this.items.indexOf(e), r = !s && i >= 0;
    r && this.items.splice(i, 1), this.refreshList(r), i >= 0 && this.virtualList.focusRow(i);
  }
  moveItemUpDown(e, t, n) {
    const o = this.items.indexOf(e), s = t ? o - 1 : o + 1;
    if (s === 0 || !t && !this.canMoveDown(e, o))
      return;
    const i = this.items[s], r = this.removeItemFromParent(e), { level: a, filterModel: l, parent: d } = e, {
      level: c,
      filterModel: u,
      parent: h
    } = i;
    if (t)
      if (c === a && u.filterType === "join")
        u.conditions.push(l);
      else if (c <= a) {
        const f = h.conditions.indexOf(u);
        h.conditions.splice(f, 0, l);
      } else
        d.conditions[r - 1].conditions.push(l);
    else if (c === a)
      if (u.filterType === "join")
        u.conditions.splice(0, 0, l);
      else {
        const f = h.conditions.indexOf(u);
        h.conditions.splice(f + 1, 0, l);
      }
    else if (r < d.conditions.length)
      d.conditions.splice(r + 1, 0, l);
    else {
      const f = this.items.find((C) => C.filterModel === d), m = f.parent.conditions.indexOf(f.filterModel) + 1;
      f.parent.conditions.splice(m, 0, l);
    }
    this.refreshList(!1);
    const g = this.items.findIndex(
      ({ filterModel: f }) => f === l
    );
    if (g < 0)
      return;
    const p = this.virtualList.getComponentAt(g);
    p instanceof Gu && (n || p.focusMoveButton(t));
  }
  virtualListMoveItemCallback(e, t) {
    const n = e.item, o = this.items.indexOf(n);
    o <= 0 || o === this.items.length - 1 || t && o === 1 || !t && !this.canMoveDown(n, o) || (this.moveItemUpDown(n, t, !0), this.virtualList.focusRow(o + (t ? -1 : 1)));
  }
  canMoveDown(e, t) {
    return !(e.level === 1 && t === this.items.length - 2 || e.level === 1 && e.parent.conditions[e.parent.conditions.length - 1] === e.filterModel);
  }
  close() {
    this.advancedFilter.getCtrl().toggleFilterBuilder({ source: "ui" });
  }
  validate() {
    var n;
    let e = this.items.every(({ valid: o }) => o), t = null;
    e ? (e = JSON.stringify(this.filterModel) !== this.stringifiedModel, e ? t = null : t = this.advFilterExpSvc.translate("advancedFilterBuilderValidationAlreadyApplied")) : t = this.advFilterExpSvc.translate("advancedFilterBuilderValidationIncomplete"), (n = this.eButtons) == null || n.updateValidity(e, t);
  }
  validateItems() {
    const e = (n) => {
      n.type = void 0;
    }, t = (n) => {
      delete n.filter;
    };
    this.items.forEach((n) => {
      if (!n.valid || !n.filterModel || n.filterModel.filterType === "join")
        return;
      const { filterModel: o } = n, { colId: s } = o, i = this.advFilterExpSvc.getColumnAutocompleteEntries().find(({ key: d }) => d === s), r = this.advFilterExpSvc.getColumnDetails(o.colId);
      if (!i || !r.column) {
        n.valid = !1, o.colId = void 0, e(o), t(o);
        return;
      }
      const l = this.advFilterExpSvc.getDataTypeExpressionOperator(r.baseCellDataType).operators[o.type];
      if (!l) {
        n.valid = !1, e(o), t(o);
        return;
      }
      if (l.numOperands > 0 && !ue(o.filter)) {
        n.valid = !1;
        return;
      }
    });
  }
}, a_ = class extends U {
  constructor(e) {
    super(), this.enabled = e;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.popupSvc = e.popupSvc, this.advFilterExpSvc = e.advFilterExpSvc, this.environment = e.environment;
  }
  postConstruct() {
    this.hasAdvancedFilterParent = !!this.gos.get("advancedFilterParent"), this.ctrlsSvc.whenReady(this, () => this.setAdvancedFilterComp()), this.addManagedEventListeners({
      advancedFilterEnabledChanged: ({ enabled: e }) => this.onEnabledChanged(e)
    }), this.addManagedPropertyListener("advancedFilterParent", () => this.updateComps()), this.addManagedPropertyListener("advancedFilterBuilderParams", (e) => {
      var t, n, o, s;
      ((t = e.currentValue) == null ? void 0 : t.suppressFullScreenButton) !== ((n = e.previousValue) == null ? void 0 : n.suppressFullScreenButton) && ((s = this.eBuilderDialog) == null || s.setMaximizable(((o = e.currentValue) == null ? void 0 : o.suppressFullScreenButton) ?? !0));
    }), this.addDestroyFunc(() => {
      this.destroyAdvancedFilterComp(), this.destroyBean(this.eBuilderComp), this.eBuilderDialog && this.eBuilderDialog.isAlive() && this.destroyBean(this.eBuilderDialog);
    });
  }
  setupHeaderComp(e) {
    var t;
    this.eHeaderComp && ((t = this.eHeaderComp) == null || t.getGui().remove(), this.destroyBean(this.eHeaderComp)), this.eHeaderComp = this.createManagedBean(
      new O7(this.enabled && !this.hasAdvancedFilterParent)
    ), e.insertAdjacentElement("beforebegin", this.eHeaderComp.getGui());
  }
  focusHeaderComp() {
    return this.eHeaderComp ? (this.eHeaderComp.getFocusableElement().focus(), !0) : !1;
  }
  refreshComp() {
    var e, t;
    (e = this.eFilterComp) == null || e.refresh(), (t = this.eHeaderComp) == null || t.refresh();
  }
  refreshBuilderComp() {
    var e;
    (e = this.eBuilderComp) == null || e.refresh();
  }
  getHeaderHeight() {
    var e;
    return ((e = this.eHeaderComp) == null ? void 0 : e.getHeight()) ?? 0;
  }
  setInputDisabled(e) {
    var t, n;
    (t = this.eFilterComp) == null || t.setInputDisabled(e), (n = this.eHeaderComp) == null || n.setInputDisabled(e);
  }
  toggleFilterBuilder(e) {
    const { source: t, force: n, eventSource: o } = e;
    if (n && this.eBuilderDialog || n === !1 && !this.eBuilderDialog)
      return;
    if (this.eBuilderDialog) {
      this.builderDestroySource = t, this.destroyBean(this.eBuilderDialog);
      return;
    }
    this.setInputDisabled(!0);
    const { width: s, height: i, minWidth: r } = this.getBuilderDialogSize(), { suppressFullScreenButton: a } = {
      suppressFullScreenButton: !1,
      ...this.gos.get("advancedFilterBuilderParams")
    };
    this.eBuilderComp = this.createBean(new r_()), this.eBuilderDialog = this.createBean(
      new yb({
        title: this.advFilterExpSvc.translate("advancedFilterBuilderTitle"),
        component: this.eBuilderComp,
        width: s,
        height: i,
        resizable: !0,
        movable: !0,
        maximizable: !a,
        centered: !0,
        closable: !0,
        minWidth: r,
        afterGuiAttached: () => {
          var l;
          return (l = this.eBuilderComp) == null ? void 0 : l.afterGuiAttached();
        },
        postProcessPopupParams: {
          type: "advancedFilterBuilder",
          eventSource: o
        }
      })
    ), this.dispatchFilterBuilderVisibleChangedEvent(t, !0), this.eBuilderDialog.addEventListener("destroyed", () => {
      this.destroyBean(this.eBuilderComp), this.eBuilderComp = void 0, this.eBuilderDialog = void 0, this.setInputDisabled(!1), this.dispatchLocalEvent({
        type: "advancedFilterBuilderClosed"
      }), this.dispatchFilterBuilderVisibleChangedEvent(this.builderDestroySource ?? "ui", !1), this.builderDestroySource = void 0;
    });
  }
  dispatchFilterBuilderVisibleChangedEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: "advancedFilterBuilderVisibleChanged",
      source: e,
      visible: t
    });
  }
  getBuilderDialogSize() {
    var r;
    const e = ((r = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : r.minWidth) ?? 500, t = this.popupSvc.getPopupParent(), n = Math.round(Ia(t)) - 2, o = Math.round(Kg(t) * 0.75) - 2, s = Math.min(Math.max(700, e), n), i = Math.min(600, o);
    return { width: s, height: i, minWidth: e };
  }
  onEnabledChanged(e) {
    this.enabled = e, this.updateComps();
  }
  updateComps() {
    this.setAdvancedFilterComp(), this.setHeaderCompEnabled(), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  setAdvancedFilterComp() {
    if (this.destroyAdvancedFilterComp(), !this.enabled)
      return;
    const e = this.gos.get("advancedFilterParent");
    if (this.hasAdvancedFilterParent = !!e, e) {
      const t = this.createBean(new bb()), n = t.getGui();
      this.environment.applyThemeClasses(n), n.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr"), e.appendChild(n), this.eFilterComp = t;
    }
  }
  setHeaderCompEnabled() {
    var e;
    (e = this.eHeaderComp) == null || e.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
  }
  destroyAdvancedFilterComp() {
    this.eFilterComp && (nn(this.eFilterComp.getGui()), this.destroyBean(this.eFilterComp));
  }
}, l_ = class {
  constructor(e) {
    this.params = e, this.operators = [], this.operatorStartPositions = [], this.operatorEndPositions = [], this.activeOperator = 0, this.validationError = null;
  }
  parseExpression(e) {
    this.operators.push(""), this.operatorStartPositions.push(e), this.operatorEndPositions.push(void 0);
    const { expression: t } = this.params;
    for (; e < t.length; ) {
      const n = t[e];
      if (n === " ") {
        if (this.parseOperator(e - 1))
          return this.activeOperator++, e - 1;
        this.operators[this.activeOperator] += n;
      } else
        this.operators[this.activeOperator] += n;
      e++;
    }
    return this.parseOperator(e - 1), e;
  }
  isValid() {
    return !this.validationError && (!this.operators.length || !!this.parsedOperator);
  }
  getValidationError() {
    return this.validationError;
  }
  getFunction() {
    return this.parsedOperator === "OR" ? "||" : "&&";
  }
  getModel() {
    return this.parsedOperator === "OR" ? "OR" : "AND";
  }
  getAutocompleteListParams(e, t) {
    let n;
    if (t == null)
      n = "";
    else {
      const s = this.operators[t], i = this.operatorEndPositions[t];
      n = Zh(
        s,
        e,
        i == null ? this.params.expression.length : i + 1
      );
    }
    let o = this.params.advFilterExpSvc.getJoinOperatorAutocompleteEntries();
    return (t || t == null && this.activeOperator) && (o = o.filter(({ key: s }) => s === this.parsedOperator)), this.params.advFilterExpSvc.generateAutocompleteListParams(o, "join", n);
  }
  updateExpression(e, t, n) {
    let { expression: o } = this.params;
    const s = t.displayValue ?? t.key;
    if (n === 0)
      for (let a = this.operatorEndPositions.length - 1; a > 0; a--) {
        const l = this.operatorEndPositions[a];
        l != null && (o = xs(
          o,
          this.operatorStartPositions[a],
          l,
          s
        ).updatedValue);
      }
    const i = this.operatorStartPositions.length > n ? this.operatorStartPositions[n] : e, r = (this.operatorEndPositions.length > n ? this.operatorEndPositions[n] : void 0) ?? qh(o, e, !0).endPosition;
    return xs(o, i, r, s, !0);
  }
  getNumOperators() {
    return this.operators.length;
  }
  getLastOperatorEndPosition() {
    return this.operatorEndPositions[this.operatorEndPositions.length - 1];
  }
  parseOperator(e) {
    const t = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : "", n = this.params.advFilterExpSvc.getExpressionJoinOperators(), o = Ic(t, n, (s) => s);
    if (o) {
      this.operatorEndPositions[this.activeOperator] = e;
      const s = n[o];
      if (this.activeOperator) {
        if (o !== this.parsedOperator)
          return this.validationError || (this.validationError = {
            message: this.params.advFilterExpSvc.translate(
              "advancedFilterValidationJoinOperatorMismatch"
            ),
            startPosition: e - t.length + 1,
            endPosition: e
          }), !1;
      } else
        this.parsedOperator = o;
      return t !== s && (Zp(this.params, t, s, e), this.operators[this.activeOperator] = s), !0;
    } else return o === null ? !1 : (this.validationError || (this.validationError = {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidJoinOperator"),
      startPosition: e - t.length + 1,
      endPosition: e
    }), !0);
  }
}, d_ = class Mb {
  constructor(t, n) {
    this.params = t, this.startPosition = n, this.expectingExpression = !0, this.expectingOperator = !1, this.expressionParsers = [], this.operatorParser = new l_(this.params), this.missingEndBracket = !1, this.extraEndBracket = !1;
  }
  parseExpression() {
    let t = this.startPosition;
    const { expression: n } = this.params;
    for (; t < n.length; ) {
      const o = n[t];
      if (o === "(" && !this.expectingOperator) {
        const s = new Mb(this.params, t + 1);
        t = s.parseExpression(), this.expressionParsers.push(s), this.expectingExpression = !1, this.expectingOperator = !0;
      } else {
        if (o === ")")
          return this.endPosition = t - 1, this.startPosition === 0 && (this.extraEndBracket = !0), t;
        if (o !== " ") if (this.expectingExpression) {
          const s = new w7(this.params, t);
          t = s.parseExpression(), this.expressionParsers.push(s), this.expectingExpression = !1, this.expectingOperator = !0;
        } else this.expectingOperator && (t = this.operatorParser.parseExpression(t), this.expectingOperator = !1, this.expectingExpression = !0);
      }
      t++;
    }
    return this.startPosition > 0 && (this.missingEndBracket = !0), t;
  }
  isValid() {
    return !this.missingEndBracket && !this.extraEndBracket && this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 && this.operatorParser.isValid() && this.expressionParsers.every((t) => t.isValid());
  }
  getValidationError() {
    const t = this.operatorParser.getValidationError();
    for (let o = 0; o < this.expressionParsers.length; o++) {
      const s = this.expressionParsers[o].getValidationError();
      if (s)
        return t && t.startPosition < s.startPosition ? t : s;
    }
    if (t)
      return t;
    if (this.extraEndBracket)
      return {
        message: this.params.advFilterExpSvc.translate("advancedFilterValidationExtraEndBracket"),
        startPosition: this.endPosition + 1,
        endPosition: this.endPosition + 1
      };
    let n;
    return this.expressionParsers.length === this.operatorParser.getNumOperators() ? n = "advancedFilterValidationMissingCondition" : this.missingEndBracket && (n = "advancedFilterValidationMissingEndBracket"), n ? {
      message: this.params.advFilterExpSvc.translate(n),
      startPosition: this.params.expression.length,
      endPosition: this.params.expression.length
    } : null;
  }
  getFunction(t) {
    const n = this.operatorParser.getFunction(), o = this.expressionParsers.map((i) => i.getFunction(t)), s = n === "&&" ? "every" : "some";
    return (i, r, a) => o[s]((l) => l(i, r, a));
  }
  getAutocompleteListParams(t) {
    if (this.endPosition != null && t > this.endPosition + 1)
      return;
    if (!this.expressionParsers.length)
      return this.getColumnAutocompleteListParams();
    const n = this.getExpressionParserIndex(t);
    if (n == null)
      return this.params.expression[t] === "(" ? { enabled: !1 } : this.getColumnAutocompleteListParams();
    const s = this.expressionParsers[n].getAutocompleteListParams(t);
    if (!s) {
      if (n < this.expressionParsers.length - 1)
        return this.operatorParser.getAutocompleteListParams(t, n);
      if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
        const i = this.operatorParser.getLastOperatorEndPosition();
        return i == null || t <= i + 1 ? this.operatorParser.getAutocompleteListParams(t, this.operatorParser.getNumOperators() - 1) : this.getColumnAutocompleteListParams();
      }
      return this.params.expression[t - 1] === ")" ? { enabled: !1 } : this.operatorParser.getAutocompleteListParams(t);
    }
    return s;
  }
  updateExpression(t, n, o) {
    const s = this.params.expression, i = this.getExpressionParserIndex(t);
    if (i == null) {
      const l = o === "column" ? this.params.advFilterExpSvc.getColumnValue(n) : n.displayValue ?? n.key;
      return xs(s, this.startPosition, this.startPosition, l, !0);
    }
    const a = this.expressionParsers[i].updateExpression(t, n, o);
    return a ?? (o === "column" ? xs(
      s,
      t,
      s.length - 1,
      this.params.advFilterExpSvc.getColumnValue(n),
      !0
    ) : this.endPosition != null && t > this.endPosition + 1 ? null : this.operatorParser.updateExpression(t, n, i));
  }
  getModel() {
    return this.expressionParsers.length > 1 ? {
      filterType: "join",
      type: this.operatorParser.getModel(),
      conditions: this.expressionParsers.map((t) => t.getModel())
    } : this.expressionParsers[0].getModel();
  }
  getColumnAutocompleteListParams() {
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getColumnAutocompleteEntries(),
      "column",
      ""
    );
  }
  getExpressionParserIndex(t) {
    let n;
    for (let o = 0; o < this.expressionParsers.length && !(this.expressionParsers[o].startPosition > t); o++)
      n = o;
    return n;
  }
}, c_ = class {
  constructor(e) {
    this.params = e, this.valid = !1;
  }
  parseExpression() {
    this.joinExpressionParser = new d_(this.params, 0);
    const e = this.joinExpressionParser.parseExpression();
    return this.valid = e >= this.params.expression.length - 1 && this.joinExpressionParser.isValid(), this.params.expression;
  }
  isValid() {
    return this.valid;
  }
  getValidationMessage() {
    const e = this.joinExpressionParser.getValidationError();
    if (!e)
      return null;
    const { message: t, startPosition: n, endPosition: o } = e;
    return n < this.params.expression.length ? this.params.advFilterExpSvc.translate("advancedFilterValidationMessage", [
      t,
      this.params.expression.slice(n, o + 1).trim()
    ]) : this.params.advFilterExpSvc.translate("advancedFilterValidationMessageAtEnd", [t]);
  }
  getFunction() {
    const e = this.createFunctionParams();
    return {
      expressionFunction: this.joinExpressionParser.getFunction(e),
      params: e
    };
  }
  getAutocompleteListParams(e) {
    return this.joinExpressionParser.getAutocompleteListParams(e) ?? { enabled: !1 };
  }
  updateExpression(e, t, n) {
    return this.joinExpressionParser.updateExpression(e, t, n);
  }
  getModel() {
    return this.isValid() ? this.joinExpressionParser.getModel() : null;
  }
  createFunctionParams() {
    return {
      operands: [],
      operators: [],
      evaluatorParams: []
    };
  }
}, u_ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "advancedFilter", this.appliedExpression = null, this.expression = null, this.isValid = !0;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.dataTypeSvc = e.dataTypeSvc, this.advFilterExpSvc = e.advFilterExpSvc, this.filterValueSvc = e.filterValueSvc, this.filterManager = e.filterManager;
  }
  postConstruct() {
    this.setEnabled(this.gos.get("enableAdvancedFilter"), !0), this.ctrl = this.createManagedBean(new a_(this.enabled)), this.expressionProxy = {
      getValue: (e, t) => {
        const n = this.colModel.getColDefCol(e);
        return n ? this.filterValueSvc.getValue(n, t) : void 0;
      }
    }, this.addManagedPropertyListener("enableAdvancedFilter", (e) => this.setEnabled(!!e.currentValue)), this.addManagedEventListeners({
      newColumnsLoaded: (e) => this.onNewColumnsLoaded(e)
    }), this.addManagedPropertyListener("includeHiddenColumnsInAdvancedFilter", () => {
      var t;
      this.updateValidity() && ((t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" }));
    });
  }
  isEnabled() {
    return this.enabled;
  }
  isFilterPresent() {
    return !!this.expressionFunction;
  }
  doesFilterPass(e) {
    return this.expressionFunction(this.expressionProxy, e, this.expressionParams);
  }
  getModel() {
    const e = this.createExpressionParser(this.appliedExpression);
    return e == null || e.parseExpression(), (e == null ? void 0 : e.getModel()) ?? null;
  }
  setModel(e) {
    const t = (o, s) => {
      if (o.filterType === "join") {
        const i = this.advFilterExpSvc.parseJoinOperator(o), r = o.conditions.map((a) => t(a)).filter((a) => ue(a)).join(` ${i} `);
        return s || o.conditions.length <= 1 ? r : `(${r})`;
      } else
        return this.advFilterExpSvc.parseColumnFilterModel(o);
    }, n = e ? t(e, !0) : null;
    this.setExpressionDisplayValue(n), this.applyExpression(), this.ctrl.refreshComp(), this.ctrl.refreshBuilderComp();
  }
  getExpressionDisplayValue() {
    return this.expression;
  }
  setExpressionDisplayValue(e) {
    this.expression = e;
  }
  isCurrentExpressionApplied() {
    return this.appliedExpression === this.expression;
  }
  createExpressionParser(e) {
    return e ? new c_({
      expression: e,
      colModel: this.colModel,
      dataTypeSvc: this.dataTypeSvc,
      valueSvc: this.valueSvc,
      advFilterExpSvc: this.advFilterExpSvc
    }) : null;
  }
  getDefaultExpression(e) {
    const t = this.advFilterExpSvc.getColumnValue(e) + " ";
    return {
      updatedValue: t,
      updatedPosition: t.length
    };
  }
  isHeaderActive() {
    return !this.gos.get("advancedFilterParent");
  }
  getCtrl() {
    return this.ctrl;
  }
  setEnabled(e, t) {
    const n = this.enabled, o = Ct(this.gos) || gn(this.gos);
    e && !o && Z(123), this.enabled = e && o, !t && this.enabled !== n && this.eventSvc.dispatchEvent({
      type: "advancedFilterEnabledChanged",
      enabled: this.enabled
    });
  }
  applyExpression() {
    const e = this.createExpressionParser(this.expression);
    e == null || e.parseExpression(), this.applyExpressionFromParser(e);
  }
  getAppliedExpressionDisplayValue() {
    return this.appliedExpression;
  }
  applyExpressionFromParser(e) {
    if (this.isValid = !e || e.isValid(), !e || !this.isValid) {
      this.expressionFunction = null, this.expressionParams = null, this.appliedExpression = null;
      return;
    }
    const { expressionFunction: t, params: n } = e.getFunction();
    this.expressionFunction = t, this.expressionParams = n, this.appliedExpression = this.expression;
  }
  updateValidity() {
    this.advFilterExpSvc.resetColumnCaches();
    const e = this.createExpressionParser(this.expression);
    e == null || e.parseExpression();
    const n = (!e || e.isValid()) !== this.isValid;
    return this.applyExpressionFromParser(e), this.ctrl.refreshComp(), this.ctrl.refreshBuilderComp(), n;
  }
  onNewColumnsLoaded(e) {
    var n;
    if (e.source !== "gridInitializing" || !((n = this.dataTypeSvc) != null && n.isPendingInference))
      return;
    this.ctrl.setInputDisabled(!0);
    const [t] = this.addManagedEventListeners({
      dataTypesInferred: () => {
        t == null || t(), this.ctrl.setInputDisabled(!1);
      }
    });
  }
}, h_ = {
  moduleName: "AdvancedFilter",
  version: gt,
  beans: [u_, b7],
  icons: {
    // Builder button in Advanced Filter
    advancedFilterBuilder: "group",
    // drag handle used to pick up Advanced Filter Builder rows
    advancedFilterBuilderDrag: "grip",
    // Advanced Filter Builder row validation error
    advancedFilterBuilderInvalid: "not-allowed",
    // shown on Advanced Filter Builder rows to move them up
    advancedFilterBuilderMoveUp: "up",
    // shown on Advanced Filter Builder rows to move them down
    advancedFilterBuilderMoveDown: "down",
    // shown on Advanced Filter Builder rows to add new rows
    advancedFilterBuilderAdd: "plus",
    // shown on Advanced Filter Builder rows to remove row
    advancedFilterBuilderRemove: "minus",
    // shown on Advanced Filter Builder selection pills
    advancedFilterBuilderSelectOpen: "small-down",
    // remove for rich select editor pills
    richSelectRemove: "cancel"
  },
  apiFunctions: {
    getAdvancedFilterModel: c7,
    setAdvancedFilterModel: u7,
    showAdvancedFilterBuilder: h7,
    hideAdvancedFilterBuilder: g7
  },
  dependsOn: [
    an,
    Fc,
    sl,
    Vs,
    zp,
    Wp
  ],
  css: [d7]
};
function g_(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.isDisplayed()) ?? !1;
}
function p_(e, t) {
  var n;
  (n = e.sideBar) == null || n.comp.setDisplayed(t);
}
function f_(e, t) {
  var n;
  (n = e.sideBar) == null || n.comp.setSideBarPosition(t);
}
function m_(e, t, n) {
  var o;
  (o = e.sideBar) == null || o.comp.openToolPanel(t, "api", n);
}
function v_(e) {
  var t;
  (t = e.sideBar) == null || t.comp.close("api");
}
function C_(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.openedItem()) ?? null;
}
function w_(e) {
  var t;
  (t = e.sideBar) == null || t.comp.refresh();
}
function y_(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.isToolPanelShowing()) ?? !1;
}
function b_(e, t) {
  var o;
  const n = (o = e.sideBar) == null ? void 0 : o.comp.getToolPanelInstance(t);
  return Sr(n);
}
function S_(e) {
  var t;
  return (t = e.sideBar) == null ? void 0 : t.comp.getDef();
}
function Qh(e, t) {
  if (!t)
    return null;
  const n = Ko(e), o = n.indexOf(t);
  if (o === -1)
    return null;
  let s = -1;
  for (let i = o - 1; i >= 0; i--)
    if (n[i].classList.contains(Xl.TAB_GUARD_TOP)) {
      s = i;
      break;
    }
  return s <= 0 ? null : n[s - 1];
}
function Ib(e, t) {
  if (!t)
    return !1;
  const n = e.querySelectorAll(`.${Pw}`);
  if (!n.length)
    return !1;
  for (let o = 0; o < n.length; o++)
    if (n[o].contains(t))
      return !0;
  return !1;
}
var x_ = (
  /*css*/
  '.ag-tool-panel-wrapper{display:flex;overflow:hidden auto;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-side-bar-panel-width)}.ag-tool-panel-external{display:flex;flex-direction:row}:where(.ag-tool-panel-external) .ag-tool-panel-wrapper{flex-grow:1}.ag-select-agg-func-item{align-items:center;display:flex;flex:1 1 auto;flex-flow:row nowrap;height:100%;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap;>*{flex:none}}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-side-bar{background-color:var(--ag-side-bar-background-color);display:flex;flex-direction:row-reverse;position:relative}:where(.ag-ltr) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{right:-3px}:where(.ag-rtl) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-ltr) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-rtl) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{right:-3px}.ag-side-bar-left{flex-direction:row;order:-1}.ag-side-buttons{background-color:var(--ag-side-button-bar-background-color);padding-top:var(--ag-side-button-bar-top-padding);position:relative}.ag-side-button{background-color:var(--ag-side-button-background-color);border-bottom:var(--ag-side-button-border);border-top:var(--ag-side-button-border);color:var(--ag-side-button-text-color);margin-top:-1px;position:relative;&:before{background-color:transparent;bottom:0;content:"";display:block;position:absolute;top:0;transition:background-color var(--ag-side-button-selected-underline-transition-duration);width:var(--ag-side-button-selected-underline-width)}&:hover{background-color:var(--ag-side-button-hover-background-color);color:var(--ag-side-button-hover-text-color)}&.ag-selected{background-color:var(--ag-side-button-selected-background-color);border-bottom:var(--ag-side-button-selected-border);border-top:var(--ag-side-button-selected-border);color:var(--ag-side-button-selected-text-color);&:before{background-color:var(--ag-side-button-selected-underline-color)}}}:where(.ag-ltr) .ag-side-button{&:before{left:0}}:where(.ag-rtl) .ag-side-button{&:before{right:0}}.ag-side-button-button{align-items:center;display:flex;flex-direction:column;gap:var(--ag-spacing);position:relative;white-space:nowrap;width:100%;&:focus{box-shadow:none}}:where(.ag-ltr) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding)}:where(.ag-rtl) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding)}.ag-side-button-button:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-side-button-label{writing-mode:vertical-lr}@media (resolution <= 1.5x){.ag-side-button-label{font-family:"Segoe UI",var(--ag-font-family)}:where(.ag-ltr) .ag-side-button-label{transform:rotate(.05deg)}:where(.ag-rtl) .ag-side-button-label{transform:rotate(-.05deg)}}:where(.ag-ltr) .ag-side-bar-left,:where(.ag-rtl) .ag-side-bar-right{border-right:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-left:var(--ag-side-panel-border)}}:where(.ag-ltr) .ag-side-bar-right,:where(.ag-rtl) .ag-side-bar-left{border-left:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-right:var(--ag-side-panel-border)}}'
), R_ = {
  tag: "div",
  cls: "ag-side-button",
  role: "presentation",
  children: [
    {
      tag: "button",
      ref: "eToggleButton",
      cls: "ag-button ag-side-button-button",
      role: "tab",
      attrs: { type: "button", tabindex: "-1", "aria-expanded": "false" },
      children: [
        {
          tag: "div",
          ref: "eIconWrapper",
          cls: "ag-side-button-icon-wrapper",
          attrs: { "aria-hidden": "true" }
        },
        { tag: "span", ref: "eLabel", cls: "ag-side-button-label" }
      ]
    }
  ]
}, E_ = class extends Te {
  constructor(e) {
    super(), this.toolPanelDef = e, this.eToggleButton = X, this.eIconWrapper = X, this.eLabel = X;
  }
  getToolPanelId() {
    return this.toolPanelDef.id;
  }
  postConstruct() {
    this.setTemplate(R_, []), this.setLabel(), this.setIcon(), this.addManagedElementListeners(this.eToggleButton, { click: this.onButtonPressed.bind(this) }), this.eToggleButton.setAttribute("id", `ag-${this.getCompId()}-button`);
  }
  setLabel() {
    const e = this.toolPanelDef, t = this.getLocaleTextFunc()(e.labelKey, e.labelDefault);
    this.eLabel.textContent = t;
  }
  setIcon() {
    this.eIconWrapper.insertAdjacentElement(
      "afterbegin",
      Le(this.toolPanelDef.iconKey, this.beans)
    );
  }
  onButtonPressed() {
    this.dispatchLocalEvent({ type: "toggleButtonClicked" });
  }
  setSelected(e) {
    this.toggleCss("ag-selected", e), Zn(this.eToggleButton, e);
  }
}, A_ = { tag: "div", cls: "ag-side-buttons", role: "tablist" }, F_ = class extends Te {
  constructor() {
    super(A_), this.buttonComps = [];
  }
  postConstruct() {
    this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  handleKeyDown(e) {
    if (!(e.key !== O.TAB || !e.shiftKey)) {
      if (Do(this.beans, !0)) {
        e.preventDefault();
        return;
      }
      bt(e);
    }
  }
  setActiveButton(e) {
    this.buttonComps.forEach((t) => {
      t.setSelected(e === t.getToolPanelId());
    });
  }
  addButtonComp(e) {
    const t = this.createBean(new E_(e));
    return this.buttonComps.push(t), this.appendChild(t), t.addEventListener("toggleButtonClicked", () => {
      this.dispatchLocalEvent({
        type: "sideBarButtonClicked",
        toolPanelId: e.id
      });
    }), t;
  }
  clearButtons() {
    this.buttonComps = this.destroyBeans(this.buttonComps), ht(this.getGui());
  }
  destroy() {
    this.clearButtons(), super.destroy();
  }
}, M_ = {
  selector: "AG-SIDE-BAR-BUTTONS",
  component: F_
}, Pb = {
  id: "columns",
  labelDefault: "Columns",
  labelKey: "columns",
  iconKey: "columnsToolPanel",
  toolPanel: "agColumnsToolPanel"
}, Db = {
  id: "filters",
  labelDefault: "Filters",
  labelKey: "filters",
  iconKey: "filtersToolPanel",
  toolPanel: "agFiltersToolPanel"
}, I_ = {
  id: "filters-new",
  labelDefault: "Filters",
  labelKey: "filters",
  iconKey: "filtersToolPanel",
  toolPanel: "agNewFiltersToolPanel"
}, ga = {
  columns: Pb,
  filters: Db,
  "filters-new": I_
};
function Jh(e) {
  if (e) {
    if (e === !0)
      return {
        toolPanels: [Pb, Db],
        defaultToolPanel: "columns"
      };
    if (typeof e == "string")
      return Jh([e]);
    if (Array.isArray(e)) {
      const t = [];
      return e.forEach((n) => {
        const o = ga[n];
        if (!o) {
          Z(215, { key: n, defaultByKey: ga });
          return;
        }
        t.push(o);
      }), t.length === 0 ? void 0 : {
        toolPanels: t,
        defaultToolPanel: t[0].id
      };
    }
    return {
      toolPanels: P_(e.toolPanels),
      defaultToolPanel: e.defaultToolPanel,
      hiddenByDefault: e.hiddenByDefault,
      position: e.position,
      hideButtons: e.hideButtons
    };
  }
}
function P_(e) {
  const t = [];
  return e && e.forEach((n) => {
    const o = Tb(n);
    o && t.push(o);
  }), t;
}
function Tb(e) {
  return typeof e != "string" ? e : ga[e] ? ga[e] : (Z(215, { key: e, defaultByKey: ga }), null);
}
var D_ = class extends Te {
  constructor() {
    super({ tag: "div", cls: "ag-tool-panel-horizontal-resize" }), this.minWidth = 100, this.maxWidth = null;
  }
  postConstruct() {
    const e = this.beans.horizontalResizeSvc.addResizeBar({
      eResizeBar: this.getGui(),
      dragStartPixels: 1,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this),
      onResizeEnd: this.onResizeEnd.bind(this)
    });
    this.addDestroyFunc(e), this.inverted = this.gos.get("enableRtl");
  }
  dispatchResizeEvent(e, t, n) {
    this.eventSvc.dispatchEvent({
      type: "toolPanelSizeChanged",
      width: n,
      started: e,
      ended: t
    });
  }
  onResizeStart() {
    this.startingWidth = this.elementToResize.offsetWidth, this.dispatchResizeEvent(!0, !1, this.startingWidth);
  }
  onResizeEnd(e) {
    return this.onResizing(e, !0);
  }
  onResizing(e, t = !1) {
    const n = this.inverted ? -1 : 1;
    let o = Math.max(this.minWidth, Math.floor(this.startingWidth - e * n));
    this.maxWidth != null && (o = Math.min(this.maxWidth, o)), this.elementToResize.style.width = `${o}px`, this.dispatchResizeEvent(!1, t, o);
  }
};
function T_(e, t, n) {
  return e.getCompDetails(t, k_, void 0, n, !0);
}
var k_ = {
  name: "toolPanel",
  optionalMethods: ["refresh", "getState"]
}, L_ = {
  tag: "div",
  cls: "ag-tool-panel-wrapper",
  role: "tabpanel"
}, B_ = class extends Te {
  constructor() {
    super(L_);
  }
  postConstruct() {
    const e = this.getGui(), t = this.resizeBar = this.createManagedBean(new D_());
    e.setAttribute("id", `ag-${this.getCompId()}`), t.elementToResize = e, this.appendChild(t);
  }
  getToolPanelId() {
    return this.toolPanelId;
  }
  setToolPanelDef(e, t) {
    const { id: n, minWidth: o, maxWidth: s, width: i } = e;
    this.toolPanelId = n, this.width = i;
    const r = T_(this.beans.userCompFactory, e, t);
    if (r == null)
      return !1;
    const a = r.newAgStackInstance();
    this.params = r.params, a.then(this.setToolPanelComponent.bind(this));
    const l = this.resizeBar;
    return o != null && (l.minWidth = o), s != null && (l.maxWidth = s), !0;
  }
  setToolPanelComponent(e) {
    this.toolPanelCompInstance = e, this.appendChild(e.getGui()), this.addDestroyFunc(() => {
      this.destroyBean(e);
    });
    const t = this.width;
    t && (this.getGui().style.width = `${t}px`);
  }
  getToolPanelInstance() {
    return this.toolPanelCompInstance;
  }
  setResizerSizerSide(e) {
    const t = this.gos.get("enableRtl"), n = e === "left", o = t ? n : !n;
    this.resizeBar.inverted = o;
  }
  refresh() {
    var e;
    (e = this.toolPanelCompInstance) == null || e.refresh(this.params);
  }
}, O_ = {
  tag: "div",
  cls: "ag-side-bar ag-unselectable",
  children: [
    {
      tag: "ag-side-bar-buttons",
      ref: "sideBarButtons"
    }
  ]
}, G_ = class extends Te {
  constructor() {
    super(O_, [M_]), this.sideBarButtons = X, this.toolPanelWrappers = [], this.registerCSS(x_);
  }
  postConstruct() {
    this.sideBarButtons.addEventListener("sideBarButtonClicked", this.onToolPanelButtonClicked.bind(this));
    const { beans: e, gos: t } = this, { sideBar: n } = t.get("initialState") ?? {};
    this.setSideBarDef({
      sideBarDef: Jh(t.get("sideBar")),
      sideBarState: n
    }), this.addManagedPropertyListener("sideBar", () => this.setState()), e.sideBar.comp = this;
    const o = this.getFocusableElement();
    this.createManagedBean(
      new Hs(o, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this)
      })
    ), Uw(e, this, o);
  }
  onTabKeyDown(e) {
    if (e.defaultPrevented)
      return;
    const { beans: t, sideBarButtons: n } = this, o = this.getGui(), s = n.getGui(), i = je(t), r = o.querySelector(".ag-tool-panel-wrapper:not(.ag-hidden)"), a = e.target, l = e.shiftKey;
    if (!r)
      return Do(t, l) ? (e.preventDefault(), !0) : Do(t, l, !0);
    if (s.contains(i)) {
      pn(r, l) && e.preventDefault();
      return;
    }
    if (!l)
      return;
    let d = null;
    r.contains(i) ? d = sn(t, r, void 0, !0) : Ib(r, a) && (d = Qh(r, a)), d || (d = s.querySelector(".ag-selected button"), d = vn(d) ? d : null), d && d !== e.target && (e.preventDefault(), d.focus());
  }
  handleKeyDown(e) {
    const t = je(this.beans), n = this.sideBarButtons;
    if (!n.getGui().contains(t))
      return;
    const o = n.getGui(), s = Array.prototype.slice.call(o.querySelectorAll(".ag-side-button")), i = s.findIndex((l) => l.contains(t));
    let r = null;
    switch (e.key) {
      case O.LEFT:
      case O.UP:
        r = Math.max(0, i - 1);
        break;
      case O.RIGHT:
      case O.DOWN:
        r = Math.min(i + 1, s.length - 1);
        break;
    }
    if (r === null)
      return;
    const a = s[r].querySelector("button");
    a && (a.focus(), e.preventDefault());
  }
  onToolPanelButtonClicked(e) {
    const t = e.toolPanelId;
    this.openedItem() === t ? this.openToolPanel(void 0, "sideBarButtonClicked") : this.openToolPanel(t, "sideBarButtonClicked");
  }
  clearDownUi() {
    this.sideBarButtons.clearButtons(), this.destroyToolPanelWrappers();
  }
  setSideBarDef({
    sideBarDef: e,
    sideBarState: t,
    existingToolPanelWrappers: n
  }) {
    if (this.setDisplayed(!1), this.sideBar = e, e && this.sideBarButtons.setDisplayed(!e.hideButtons), e != null && e.toolPanels) {
      const o = e.toolPanels;
      if (this.createToolPanelsAndSideButtons(o, t, n), !this.toolPanelWrappers.length)
        return;
      const s = t ? t.visible : !e.hiddenByDefault;
      if (this.setDisplayed(s), this.setSideBarPosition(t ? t.position : e.position), s)
        if (t) {
          const { openToolPanel: i } = t;
          i && this.openToolPanel(i, "sideBarInitializing");
        } else
          this.openToolPanel(e.defaultToolPanel, "sideBarInitializing");
    }
  }
  getDef() {
    return this.sideBar;
  }
  setSideBarPosition(e) {
    e || (e = "right"), this.position = e;
    const t = e === "left", n = t ? "right" : "left";
    return this.toggleCss("ag-side-bar-left", t), this.toggleCss("ag-side-bar-right", !t), this.toolPanelWrappers.forEach((o) => {
      o.setResizerSizerSide(n);
    }), this.dispatchSideBarUpdated(), this;
  }
  setDisplayed(e, t) {
    super.setDisplayed(e, t), this.dispatchSideBarUpdated();
  }
  getState() {
    const e = {};
    return this.toolPanelWrappers.forEach((t) => {
      var n, o;
      e[t.getToolPanelId()] = (o = (n = t.getToolPanelInstance()) == null ? void 0 : n.getState) == null ? void 0 : o.call(n);
    }), {
      visible: this.isDisplayed(),
      position: this.position,
      openToolPanel: this.openedItem(),
      toolPanels: e
    };
  }
  createToolPanelsAndSideButtons(e, t, n) {
    var o;
    for (const s of e)
      this.createToolPanelAndSideButton(
        s,
        (o = t == null ? void 0 : t.toolPanels) == null ? void 0 : o[s.id],
        n == null ? void 0 : n[s.id]
      );
  }
  validateDef(e) {
    var o;
    const { id: t, toolPanel: n } = e;
    return t == null ? (Z(212), !1) : (n === "agFiltersToolPanel" || n === "agNewFiltersToolPanel") && (o = this.beans.filterManager) != null && o.isAdvFilterEnabled() ? (Z(213), !1) : !0;
  }
  createToolPanelAndSideButton(e, t, n) {
    if (!this.validateDef(e))
      return;
    let o;
    if (n)
      o = n;
    else if (o = this.createBean(new B_()), !o.setToolPanelDef(
      e,
      ke(this.gos, {
        initialState: t,
        onStateUpdated: () => this.dispatchSideBarUpdated()
      })
    ))
      return;
    o.setDisplayed(!1);
    const s = o.getGui(), i = e.parent instanceof HTMLElement ? e.parent : this;
    i === e.parent && (this.beans.environment.applyThemeClasses(i, ["ag-external", "ag-tool-panel-external"]), s.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr")), i.appendChild(s), this.toolPanelWrappers.push(o);
    const r = this.sideBarButtons.addButtonComp(e);
    Wg(r.eToggleButton, s);
  }
  refresh() {
    this.toolPanelWrappers.forEach((e) => e.refresh());
  }
  renderToolPanelUnderParent(e, t) {
    var o, s, i, r;
    const n = (s = (o = this.sideBar) == null ? void 0 : o.toolPanels) == null ? void 0 : s.find((a) => (typeof a == "string" ? a : a.id) === e);
    if (n) {
      const a = Tb(n);
      if (a) {
        const l = (r = (i = (this.gos.get("initialState") ?? {}).sideBar) == null ? void 0 : i.toolPanels) == null ? void 0 : r[a.id];
        a.parent = t;
        const d = this.toolPanelWrappers.find((c) => c.getToolPanelId() === e);
        this.createToolPanelAndSideButton(a, l, d);
      }
    }
  }
  openToolPanel(e, t = "api", n) {
    n && e && this.renderToolPanelUnderParent(e, n);
    const o = this.openedItem();
    if (o === e)
      return;
    this.toolPanelWrappers.forEach((r) => {
      const a = e === r.getToolPanelId();
      r.setDisplayed(a);
    });
    const s = this.openedItem();
    o !== s && (this.sideBarButtons.setActiveButton(e), this.raiseToolPanelVisibleEvent(e, o ?? void 0, t));
  }
  getToolPanelInstance(e) {
    const t = this.toolPanelWrappers.filter((n) => n.getToolPanelId() === e)[0];
    if (!t) {
      Z(214, { key: e });
      return;
    }
    return t.getToolPanelInstance();
  }
  raiseToolPanelVisibleEvent(e, t, n) {
    const o = !!e && !!t, s = this.eventSvc;
    t && s.dispatchEvent({
      type: "toolPanelVisibleChanged",
      source: n,
      key: t,
      visible: !1,
      switchingToolPanel: o
    }), e && s.dispatchEvent({
      type: "toolPanelVisibleChanged",
      source: n,
      key: e,
      visible: !0,
      switchingToolPanel: o
    });
  }
  close(e = "api") {
    this.openToolPanel(void 0, e);
  }
  isToolPanelShowing() {
    return !!this.openedItem();
  }
  openedItem() {
    let e = null;
    return this.toolPanelWrappers.forEach((t) => {
      t.isDisplayed() && (e = t.getToolPanelId());
    }), e;
  }
  setState(e) {
    var o;
    const t = Jh(this.gos.get("sideBar")), n = {};
    t && this.sideBar && ((o = t.toolPanels) == null || o.forEach((s) => {
      var c, u;
      const { id: i } = s;
      if (!i)
        return;
      const r = (c = this.sideBar.toolPanels) == null ? void 0 : c.find(
        (h) => h.id === i
      );
      if (!r || s.toolPanel !== r.toolPanel)
        return;
      const a = this.toolPanelWrappers.find((h) => h.getToolPanelId() === i);
      if (!a)
        return;
      const l = ke(this.gos, {
        ...s.toolPanelParams ?? {},
        onStateUpdated: () => this.dispatchSideBarUpdated()
      });
      ((u = a.getToolPanelInstance()) == null ? void 0 : u.refresh(l)) === !0 && (this.toolPanelWrappers = this.toolPanelWrappers.filter((h) => h !== a), nn(a.getGui()), n[i] = a);
    })), this.clearDownUi(), this.setSideBarDef({ sideBarDef: t, sideBarState: e, existingToolPanelWrappers: n });
  }
  dispatchSideBarUpdated() {
    this.eventSvc.dispatchEvent({ type: "sideBarUpdated" });
  }
  destroyToolPanelWrappers() {
    this.toolPanelWrappers.forEach((e) => {
      nn(e.getGui()), this.destroyBean(e);
    }), this.toolPanelWrappers.length = 0;
  }
  destroy() {
    this.destroyToolPanelWrappers(), super.destroy();
  }
}, H_ = {
  selector: "AG-SIDE-BAR",
  component: G_
}, V_ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "sideBar";
  }
  getSelector() {
    return H_;
  }
}, __ = {
  moduleName: "SideBar",
  version: gt,
  beans: [V_],
  apiFunctions: {
    isSideBarVisible: g_,
    setSideBarVisible: p_,
    setSideBarPosition: f_,
    openToolPanel: m_,
    closeToolPanel: v_,
    getOpenedToolPanel: C_,
    refreshToolPanel: w_,
    isToolPanelShowing: y_,
    getToolPanelInstance: b_,
    getSideBar: S_
  },
  dependsOn: [an, ay]
}, N_ = { tag: "div" }, $_ = class extends Te {
  constructor() {
    super(N_);
  }
  init(e) {
    this.params = e, this.cssClassPrefix = this.params.cssClassPrefix ?? "ag-menu-option", this.addAriaAttributes(), this.addIcon(), this.addName(), this.addShortcut(), this.addSubMenu();
  }
  configureDefaults() {
    return !0;
  }
  addAriaAttributes() {
    const { checked: e, subMenu: t } = this.params, n = this.getGui();
    e && dC(n, e), t && Zn(n, !1);
  }
  addIcon() {
    if (this.params.isCompact)
      return;
    const e = Ue({
      tag: "span",
      ref: "eIcon",
      cls: `${this.getClassName("part")} ${this.getClassName("icon")}`,
      role: "presentation"
    }), { checked: t, icon: n } = this.params;
    t ? e.appendChild(Le("check", this.beans)) : n && (uc(n) ? e.appendChild(n) : typeof n == "string" ? e.innerHTML = n : Z(227)), this.getGui().appendChild(e);
  }
  addName() {
    const e = Ue({
      tag: "span",
      ref: "eName",
      cls: `${this.getClassName("part")} ${this.getClassName("text")}`,
      children: this.params.name || ""
    });
    this.getGui().appendChild(e);
  }
  addShortcut() {
    if (this.params.isCompact)
      return;
    const e = Ue({
      tag: "span",
      ref: "eShortcut",
      cls: `${this.getClassName("part")} ${this.getClassName("shortcut")}`,
      children: this.params.shortcut || ""
    });
    this.getGui().appendChild(e);
  }
  addSubMenu() {
    const e = Ue({
      tag: "span",
      ref: "ePopupPointer",
      cls: `${this.getClassName("part")} ${this.getClassName("popup-pointer")}`
    }), t = this.getGui();
    if (this.params.subMenu) {
      const n = this.gos.get("enableRtl") ? "subMenuOpenRtl" : "subMenuOpen";
      e.appendChild(Le(n, this.beans));
    }
    t.appendChild(e);
  }
  getClassName(e) {
    return `${this.cssClassPrefix}-${e}`;
  }
}, z_ = (
  /*css*/
  '.ag-menu-list{cursor:default;display:table;padding:var(--ag-spacing) 0;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option{cursor:pointer;font-weight:500}:where(.ag-ltr) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:right}:where(.ag-rtl) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:left}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{display:flex;flex-wrap:nowrap;width:100%}.ag-compact-menu-option-text{flex:1 1 auto;white-space:nowrap}.ag-menu-separator{height:calc(var(--ag-spacing)*2 + 1px)}.ag-menu-separator-part:after{border-top:solid var(--ag-border-width) var(--ag-menu-separator-color);content:"";display:block}.ag-compact-menu-option-active,.ag-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-compact-menu-option-part,.ag-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-spacing) + 2px) 0}.ag-compact-menu-option-disabled,.ag-menu-option-disabled{cursor:not-allowed;opacity:.5}.ag-compact-menu-option-icon,.ag-menu-option-icon{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-compact-menu-option-icon,:where(.ag-ltr) .ag-menu-option-icon{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-compact-menu-option-icon,:where(.ag-rtl) .ag-menu-option-icon{padding-right:calc(var(--ag-spacing)*2)}.ag-compact-menu-option-text,.ag-menu-option-text{padding-left:calc(var(--ag-spacing)*2);padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-compact-menu-option-shortcut,:where(.ag-ltr) .ag-menu-option-shortcut{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-shortcut,:where(.ag-rtl) .ag-menu-option-shortcut{padding-left:var(--ag-spacing)}:where(.ag-ltr) .ag-compact-menu-option-popup-pointer,:where(.ag-ltr) .ag-menu-option-popup-pointer{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-popup-pointer,:where(.ag-rtl) .ag-menu-option-popup-pointer{padding-left:var(--ag-spacing)}.ag-menu-column-select-wrapper{height:265px;overflow:auto;:where(.ag-column-select){height:100%}}.ag-menu:where(.ag-tabs){min-width:290px}.ag-context-menu-loading-icon{pointer-events:none;position:absolute}'
), kb = {
  moduleName: "MenuItem",
  version: gt,
  userComponents: {
    agMenuItem: $_
  },
  icons: {
    // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
    check: "tick",
    // icon for sub menu item
    subMenuOpen: "small-right",
    // version of subMenuOpen used in RTL mode
    subMenuOpenRtl: "small-left"
  },
  css: [z_]
}, W_ = (
  /*css*/
  ".ag-column-select{display:flex;flex:3 1 0px;flex-direction:column;overflow:hidden;position:relative}.ag-column-select-header{align-items:center;display:flex;flex:none;gap:var(--ag-widget-horizontal-spacing);height:var(--ag-header-height);padding-left:var(--ag-widget-container-horizontal-padding);padding-right:var(--ag-widget-container-horizontal-padding);position:relative}.ag-column-select-column,.ag-column-select-column-group{align-items:center;display:flex;gap:var(--ag-widget-horizontal-spacing);height:100%;position:relative;&:where(:not(:last-child)){margin-bottom:var(--ag-widget-vertical-spacing)}}:where(.ag-ltr) .ag-column-select-column,:where(.ag-ltr) .ag-column-select-column-group{padding-left:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}:where(.ag-rtl) .ag-column-select-column,:where(.ag-rtl) .ag-column-select-column-group{padding-right:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}.ag-column-select-header-icon{border-radius:var(--ag-border-radius);cursor:pointer;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}:where(.ag-ltr) .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}:where(.ag-rtl) .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly{opacity:.5;pointer-events:none;.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-column-select-column-readonly{&.ag-icon-grip,.ag-icon-grip{opacity:.35}}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding)*.5) 0}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}"
), U_ = 300, K_ = {
  tag: "div",
  cls: "ag-column-select-header",
  role: "presentation",
  children: [
    { tag: "div", ref: "eExpand", cls: "ag-column-select-header-icon" },
    { tag: "ag-checkbox", ref: "eSelect", cls: "ag-column-select-header-checkbox" },
    { tag: "ag-input-text-field", ref: "eFilterTextField", cls: "ag-column-select-header-filter-wrapper" }
  ]
}, Z_ = class extends Te {
  constructor() {
    super(K_, [Di, ao]), this.eExpand = X, this.eSelect = X, this.eFilterTextField = X;
  }
  postConstruct() {
    this.createExpandIcons(), this.addManagedListeners(this.eExpand, {
      click: this.onExpandClicked.bind(this),
      keydown: (t) => {
        t.key === O.SPACE && (t.preventDefault(), this.onExpandClicked());
      }
    }), this.addManagedElementListeners(this.eSelect.getInputElement(), { click: this.onSelectClicked.bind(this) }), this.addManagedPropertyListener("functionsReadOnly", () => this.onFunctionsReadOnlyPropChanged()), this.eFilterTextField.setAutoComplete(!1).onValueChange(() => this.onFilterTextChanged()), this.addManagedEventListeners({ newColumnsLoaded: this.showOrHideOptions.bind(this) });
    const e = this.getLocaleTextFunc();
    this.eSelect.setInputAriaLabel(e("ariaColumnSelectAll", "Toggle All Columns Visibility")), this.eFilterTextField.setInputAriaLabel(e("ariaFilterColumnsInput", "Filter Columns Input")), this.activateTabIndex([this.eExpand]);
  }
  onFunctionsReadOnlyPropChanged() {
    const e = this.gos.get("functionsReadOnly");
    this.eSelect.setReadOnly(e), this.eSelect.toggleCss("ag-column-select-column-readonly", e);
  }
  init(e) {
    this.params = e;
    const t = this.gos.get("functionsReadOnly");
    this.eSelect.setReadOnly(t), this.eSelect.toggleCss("ag-column-select-column-readonly", t), this.beans.colModel.ready && this.showOrHideOptions();
  }
  createExpandIcons() {
    const e = this.beans;
    this.eExpand.appendChild(this.eExpandChecked = Le("columnSelectOpen", e)), this.eExpand.appendChild(this.eExpandUnchecked = Le("columnSelectClosed", e)), this.eExpand.appendChild(this.eExpandIndeterminate = Le("columnSelectIndeterminate", e)), this.setExpandState(
      0
      /* EXPANDED */
    );
  }
  // we only show expand / collapse if we are showing columns
  showOrHideOptions() {
    var r;
    const e = this.params, t = !e.suppressColumnFilter, n = !e.suppressColumnSelectAll, o = !e.suppressColumnExpandAll, s = !!((r = this.beans.colModel.colDefCols) != null && r.treeDepth), i = this.getLocaleTextFunc();
    this.eFilterTextField.setInputPlaceholder(i("searchOoo", "Search...")), He(this.eFilterTextField.getGui(), t), He(this.eSelect.getGui(), n), He(this.eExpand, o && s);
  }
  onFilterTextChanged() {
    this.onFilterTextChangedDebounced || (this.onFilterTextChangedDebounced = Lt(
      this,
      () => {
        const e = this.eFilterTextField.getValue();
        this.dispatchLocalEvent({ type: "filterChanged", filterText: e });
      },
      U_
    )), this.onFilterTextChangedDebounced();
  }
  onSelectClicked() {
    this.dispatchLocalEvent({ type: this.selectState ? "unselectAll" : "selectAll" });
  }
  onExpandClicked() {
    this.dispatchLocalEvent({ type: this.expandState === 0 ? "collapseAll" : "expandAll" });
  }
  setExpandState(e) {
    this.expandState = e, He(
      this.eExpandChecked,
      e === 0
      /* EXPANDED */
    ), He(
      this.eExpandUnchecked,
      e === 1
      /* COLLAPSED */
    ), He(
      this.eExpandIndeterminate,
      e === 2
      /* INDETERMINATE */
    );
  }
  setSelectionState(e) {
    this.selectState = e, this.eSelect.setValue(this.selectState);
  }
}, q_ = {
  selector: "AG-PRIMARY-COLS-HEADER",
  component: Z_
};
function rr(e) {
  return !!e && typeof e.children < "u";
}
function ms(e) {
  return rr(e) ? e.groupId : e.colId;
}
function Lb(e, t, n) {
  const o = (r, a) => {
    const d = r.children.map(ms).includes(ms(a)), c = Je(r.children), u = c && ms(c) !== ms(a);
    return d && u;
  };
  if (!rr(e))
    return !0;
  const s = e, i = n;
  if (o(s, i) || s.groupId === t && !s.children.map(ms).includes(ms(i)))
    return s.children.push(i), !0;
  for (let r = s.children.length - 1; r >= 0 && !Lb(s.children[r], t, n); r--)
    ;
  return !1;
}
function j_(e) {
  const t = (s, i) => rr(s) && rr(i) && ms(s) === ms(i), n = (s, i) => {
    if (!rr(i))
      return s;
    const r = s, a = i;
    return a.children && a.groupId && Lb(r, a.groupId, a.children[0]) || a.children.forEach((l) => n(r, l)), r;
  }, o = [];
  for (let s = 1; s <= e.length; s++) {
    const i = e[s - 1], r = e[s];
    t(i, r) ? e[s] = n(i, r) : o.push(i);
  }
  return o;
}
function Y_(e, t) {
  const n = [], o = (i, r) => {
    if (rr(i)) {
      const a = i, l = typeof a.groupId < "u" ? a.groupId : a.headerName, d = new er(a, l, !1, r), c = [];
      return a.children.forEach((u) => {
        const h = o(u, r + 1);
        h && c.push(h);
      }), d.setChildren(c), d;
    } else {
      const a = i, l = a.colId ? a.colId : a.field, d = e.getColDefCol(l);
      return d || n.push(a), d;
    }
  }, s = [];
  return t.forEach((i) => {
    const r = o(i, 0);
    r && s.push(r);
  }), n.length > 0 && Z(217, { invalidColIds: n }), s;
}
function Q_(e, t) {
  const n = J_(e), o = j_(n);
  t(o);
}
function J_(e) {
  const t = (s, i) => {
    let r;
    if (Pt(s))
      if (s.isPadding())
        r = i;
      else {
        const l = Object.assign({}, s.getColGroupDef());
        l.groupId = s.getGroupId(), l.children = [i], r = l;
      }
    else {
      const l = Object.assign({}, s.getColDef());
      l.colId = s.getColId(), r = l;
    }
    const a = s.getOriginalParent();
    return a ? t(a, r) : r;
  };
  return e.getCols().filter((s) => {
    const i = s.getColDef();
    return s.isPrimary() && !i.showRowGroup;
  }).map((s) => t(s, s.getColDef()));
}
var S0 = class {
  constructor(e, t, n, o = !1, s) {
    this.displayName = e, this.depth = n, this.group = o, this.localEventService = new Fs(), o ? (this.columnGroup = t, this._expanded = s, this.children = []) : this.column = t;
  }
  get expanded() {
    return !!this._expanded;
  }
  set expanded(e) {
    e !== this._expanded && (this._expanded = e, this.localEventService.dispatchEvent({ type: "expandedChanged" }));
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
};
function Bb(e, t, n, o) {
  const s = X_(t);
  Ob(e, s, n, o);
}
function Ob(e, t, n, o) {
  e.colModel.isPivotMode() ? tN(e, t, n, o) : eN(e, t, n, o);
}
function X_(e) {
  const t = [], n = (o) => {
    o.forEach((s) => {
      s.passesFilter && (s.group ? n(s.children) : t.push(s.column));
    });
  };
  return n(e), t;
}
function eN(e, t, n, o) {
  const s = [];
  t.forEach((i) => {
    i.getColDef().lockVisible || i.isVisible() != n && s.push({
      colId: i.getId(),
      hide: !n
    });
  }), s.length > 0 && cn(e, { state: s }, o);
}
function tN(e, t, n, o) {
  nN(e, t, n, o);
}
function nN(e, t, n, o) {
  const s = [], a = n ? (l) => {
    var d;
    if (!l.isAnyFunctionActive())
      if (l.isAllowValue()) {
        const c = typeof l.getAggFunc() == "string" ? l.getAggFunc() : (d = e.aggFuncSvc) == null ? void 0 : d.getDefaultAggFunc(l);
        s.push({
          colId: l.getId(),
          aggFunc: c
        });
      } else l.isAllowRowGroup() ? s.push({
        colId: l.getId(),
        rowGroup: !0
      }) : l.isAllowPivot() && s.push({
        colId: l.getId(),
        pivot: !0
      });
  } : (l) => {
    (l.isPivotActive() || l.isRowGroupActive() || l.isValueActive()) && s.push({
      colId: l.getId(),
      pivot: !1,
      rowGroup: !1,
      aggFunc: null
    });
  };
  t.forEach(a), s.length > 0 && cn(e, { state: s }, o);
}
function Gb(e, t) {
  const { columns: n, visibleState: o, pivotState: s, eventType: i } = t, r = n.map((a) => {
    const l = a.getColId();
    if (e.colModel.isPivotMode()) {
      const d = s == null ? void 0 : s[l];
      return {
        colId: l,
        pivot: d == null ? void 0 : d.pivot,
        rowGroup: d == null ? void 0 : d.rowGroup,
        aggFunc: d == null ? void 0 : d.aggFunc
      };
    } else
      return {
        colId: l,
        hide: !(o != null && o[l])
      };
  });
  cn(e, { state: r }, i);
}
function Hb(e) {
  return {
    pivot: e.isPivotActive(),
    rowGroup: e.isRowGroupActive(),
    aggFunc: e.isValueActive() ? e.getAggFunc() : void 0
  };
}
function x0(e, t, n, o) {
  const s = t.getCol(n);
  e.groupData || (e.groupData = {});
  const i = s.getColId(), r = e.groupData[i];
  r !== o && (e.groupData[i] = o, e.dispatchCellChangedEvent(s, o, r));
}
function Vb(e, t, n) {
  var o;
  e.group !== n && (e.group && !n && (e.expanded = !1), e.group = n, e.updateHasChildren(), (o = t.selectionSvc) == null || o.updateRowSelectable(e), e.dispatchRowEvent("groupChanged"));
}
function Ha(e, t) {
  const { gos: n, rowGroupColsSvc: o } = t;
  if (!o || !e)
    return !1;
  const s = n.get("groupLockGroupColumns");
  if (!e.isRowGroupActive() || s === 0)
    return !1;
  if (s === -1)
    return !0;
  const i = o.columns.findIndex((r) => r.getColId() === e.getColId());
  return s > i;
}
function oN(e) {
  const t = mi(e), n = "getSelection" in t ? t.getSelection() : null, o = [];
  for (let s = 0; s < ((n == null ? void 0 : n.rangeCount) ?? 0); s++) {
    const i = n == null ? void 0 : n.getRangeAt(s);
    i && o.push(i);
  }
  return { selection: n, ranges: o };
}
function Pc(e, t) {
  if (!e.gos.get("enableCellTextSelection") || !ap() && !os())
    return t();
  const { selection: o, ranges: s } = oN(e);
  t(), o == null || o.removeAllRanges();
  for (const i of s)
    o == null || o.addRange(i);
}
var sN = class extends Ti {
  constructor(e) {
    super(), this.setTemplateFromElement(e.getGui(), void 0, void 0, !0);
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    });
  }
  handleKeyDown(e) {
    e.key === O.ESCAPE && this.closePanel();
  }
  onTabKeyDown(e) {
    e.defaultPrevented || (this.closePanel(), e.preventDefault());
  }
  closePanel() {
    const e = this.parentComponent;
    e.closeSubMenu(), setTimeout(() => e.getGui().focus(), 0);
  }
};
function iN(e, t, n) {
  return e.getCompDetails(t, rN, "agMenuItem", n, !0);
}
var rN = {
  name: "menuItem",
  optionalMethods: ["setActive", "select", "setExpanded", "configureDefaults"]
}, aN = { tag: "div", cls: "ag-menu", role: "presentation" }, R0 = class extends U {
  constructor() {
    super(...arguments), this.ACTIVATION_DELAY = 80, this.isActive = !1, this.subMenuIsOpen = !1, this.subMenuIsOpening = !1, this.suppressRootStyles = !0, this.suppressAria = !0, this.suppressFocus = !0;
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.userCompFactory = e.userCompFactory, this.registry = e.registry;
  }
  init(e) {
    var a;
    const { menuItemDef: t, isAnotherSubMenuOpen: n, level: o, childComponent: s, contextParams: i } = e;
    this.params = e.menuItemDef, this.level = o, this.isAnotherSubMenuOpen = n, this.childComponent = s, this.contextParams = i, this.cssClassPrefix = ((a = this.params.menuItemParams) == null ? void 0 : a.cssClassPrefix) ?? "ag-menu-option";
    const r = iN(
      this.userCompFactory,
      this.params,
      ke(this.gos, {
        ...t,
        level: o,
        isAnotherSubMenuOpen: n,
        openSubMenu: (l) => this.openSubMenu(l),
        closeSubMenu: () => this.closeSubMenu(),
        closeMenu: (l) => this.closeMenu(l),
        updateTooltip: (l, d) => this.refreshTooltip(l, d),
        onItemActivated: () => this.onItemActivated()
      })
    );
    return (r == null ? void 0 : r.newAgStackInstance().then((l) => {
      var c;
      this.menuItemComp = l;
      const d = (c = l.configureDefaults) == null ? void 0 : c.call(l);
      d && this.configureDefaults(d === !0 ? void 0 : d);
    })) ?? tt.resolve();
  }
  addListeners(e, t) {
    t != null && t.suppressClick || this.addManagedElementListeners(e, { click: (n) => this.onItemSelected(n) }), t != null && t.suppressKeyboardSelect || this.addManagedElementListeners(e, {
      keydown: (n) => {
        (n.key === O.ENTER || n.key === O.SPACE) && (n.preventDefault(), this.onItemSelected(n));
      }
    }), t != null && t.suppressMouseDown || this.addManagedElementListeners(e, {
      mousedown: (n) => {
        n.stopPropagation(), n.preventDefault();
      }
    }), t != null && t.suppressMouseOver || this.addManagedElementListeners(e, {
      mouseenter: () => this.onMouseEnter(),
      mouseleave: () => this.onMouseLeave()
    });
  }
  isDisabled() {
    return !!this.params.disabled;
  }
  openSubMenu(e = !1, t) {
    var d, c;
    if (this.closeSubMenu(), !this.params.subMenu)
      return;
    this.subMenuIsOpening = !0;
    const n = Ue(aN);
    this.eSubMenuGui = n;
    let o, s = () => {
      this.subMenuIsOpening = !1;
    };
    if (this.childComponent) {
      const u = this.createBean(new sN(this.childComponent));
      u.setParentComponent(this);
      const h = u.getGui(), g = "mouseenter", p = () => this.cancelDeactivate();
      h.addEventListener(g, p), o = () => {
        h.removeEventListener(g, p), this.destroyBean(u);
      }, n.appendChild(h), this.childComponent.afterGuiAttached && (s = () => {
        this.childComponent.afterGuiAttached(), this.subMenuIsOpening = !1;
      });
    } else if (this.params.subMenu) {
      const u = this.createBean(new Dc(this.level + 1, this.contextParams));
      u.setParentComponent(this), u.addMenuItems(this.params.subMenu), n.appendChild(u.getGui()), this.addManagedListeners(u, { closeMenu: (h) => this.dispatchLocalEvent(h) }), u.addGuiEventListener("mouseenter", () => this.cancelDeactivate()), o = () => this.destroyBean(u), e && (s = () => {
        u.activateFirstItem(), this.subMenuIsOpening = !1;
      });
    }
    const { popupSvc: i } = this, r = () => {
      const u = this.eGui, { column: h, node: g } = this.contextParams;
      i == null || i.positionPopupForMenu({
        eventSource: u,
        ePopup: n,
        event: t instanceof MouseEvent ? t : void 0,
        column: h,
        rowNode: g
      });
    }, a = this.getLocaleTextFunc(), l = i == null ? void 0 : i.addPopup({
      modal: !0,
      eChild: n,
      positionCallback: r,
      anchorToElement: this.eGui,
      ariaLabel: a("ariaLabelSubMenu", "SubMenu"),
      afterGuiAttached: s
    });
    this.subMenuIsOpen = !0, this.setAriaExpanded(!0), this.hideSubMenu = () => {
      var u, h;
      l && l.hideFunc(), this.subMenuIsOpen = !1, this.setAriaExpanded(!1), o(), (h = (u = this.menuItemComp).setExpanded) == null || h.call(u, !1), this.eSubMenuGui = void 0;
    }, (c = (d = this.menuItemComp).setExpanded) == null || c.call(d, !0);
  }
  setAriaExpanded(e) {
    this.suppressAria || Zn(this.eGui, e);
  }
  closeSubMenu() {
    this.hideSubMenu && (this.hideSubMenu(), this.hideSubMenu = null, this.setAriaExpanded(!1));
  }
  isSubMenuOpen() {
    return this.subMenuIsOpen;
  }
  isSubMenuOpening() {
    return this.subMenuIsOpening;
  }
  activate(e, t) {
    var n, o;
    this.cancelActivate(), !(this.params.disabled && !t) && (this.isActive = !0, this.suppressRootStyles || this.eGui.classList.add(`${this.cssClassPrefix}-active`), (o = (n = this.menuItemComp).setActive) == null || o.call(n, !0), this.suppressFocus || Pc(this.beans, () => this.eGui.focus({ preventScroll: !t })), e && this.params.subMenu && window.setTimeout(() => {
      this.isAlive() && this.isActive && this.openSubMenu();
    }, 300), this.onItemActivated());
  }
  deactivate() {
    var e, t;
    this.cancelDeactivate(), this.suppressRootStyles || this.eGui.classList.remove(`${this.cssClassPrefix}-active`), (t = (e = this.menuItemComp).setActive) == null || t.call(e, !1), this.isActive = !1, this.subMenuIsOpen && this.closeSubMenu();
  }
  getGui() {
    return this.menuItemComp.getGui();
  }
  getParentComponent() {
    return this.parentComponent;
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getSubMenuGui() {
    return this.eSubMenuGui;
  }
  onItemSelected(e) {
    var t, n;
    (n = (t = this.menuItemComp).select) == null || n.call(t), this.params.action ? this.beans.frameworkOverrides.wrapOutgoing(
      () => this.params.action(
        ke(this.gos, {
          ...this.contextParams
        })
      )
    ) : this.openSubMenu(e && e.type === "keydown", e), !(this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) && this.closeMenu(e);
  }
  closeMenu(e) {
    const t = {
      type: "closeMenu"
    };
    e && (e instanceof MouseEvent ? t.mouseEvent = e : t.keyboardEvent = e), this.dispatchLocalEvent(t);
  }
  onItemActivated() {
    const e = {
      type: "menuItemActivated",
      menuItem: this
    };
    this.dispatchLocalEvent(e);
  }
  cancelActivate() {
    this.activateTimeoutId && (window.clearTimeout(this.activateTimeoutId), this.activateTimeoutId = 0);
  }
  cancelDeactivate() {
    this.deactivateTimeoutId && (window.clearTimeout(this.deactivateTimeoutId), this.deactivateTimeoutId = 0);
  }
  onMouseEnter() {
    this.cancelDeactivate(), this.isAnotherSubMenuOpen() ? this.activateTimeoutId = window.setTimeout(() => this.activate(!0), this.ACTIVATION_DELAY) : this.activate(!0);
  }
  onMouseLeave() {
    this.cancelActivate(), this.isSubMenuOpen() ? this.deactivateTimeoutId = window.setTimeout(() => this.deactivate(), this.ACTIVATION_DELAY) : this.deactivate();
  }
  refreshRootElementGui(e) {
    var r, a;
    let t = this.menuItemComp.getGui();
    const {
      cssClassPrefix: n,
      params: { cssClasses: o, disabled: s }
    } = this, i = (a = (r = this.menuItemComp).getRootElement) == null ? void 0 : a.call(r);
    return i && (e || t.classList.add("ag-menu-option-custom"), t = i), this.suppressRootStyles = !!e, this.suppressRootStyles || (t.classList.add(n), o == null || o.forEach((l) => t.classList.add(l)), s && t.classList.add(`${n}-disabled`)), t;
  }
  applyAriaProperties(e) {
    const {
      params: { checked: t, subMenu: n, subMenuRole: o, disabled: s }
    } = this, i = t != null;
    hn(e, i ? "menuitemcheckbox" : "menuitem"), n && l3(e, o ?? "menu"), s && Cd(e, !0);
  }
  configureDefaults(e) {
    if (!this.menuItemComp) {
      setTimeout(() => this.configureDefaults(e));
      return;
    }
    const { suppressRootStyles: t, suppressTooltip: n, suppressAria: o, suppressTabIndex: s, suppressFocus: i } = e || {}, {
      params: { tooltip: r, disabled: a }
    } = this, l = this.eGui = this.refreshRootElementGui(!!t);
    this.suppressAria = !!o, o || this.applyAriaProperties(l), s || l.setAttribute("tabindex", "-1"), n || this.refreshTooltip(r), a || this.addListeners(l, e), this.suppressFocus = !!i;
  }
  refreshTooltip(e, t) {
    if (this.tooltip = e, this.tooltipFeature = this.destroyBean(this.tooltipFeature), !e || !this.menuItemComp)
      return;
    const n = this.registry.createDynamicBean("tooltipFeature", !1, {
      getGui: () => this.getGui(),
      getTooltipValue: () => this.tooltip,
      getLocation: () => "menu",
      shouldDisplayTooltip: t
    });
    n && (this.tooltipFeature = this.createBean(n));
  }
  destroy() {
    var e, t;
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), (t = (e = this.menuItemComp) == null ? void 0 : e.destroy) == null || t.call(e), super.destroy();
  }
}, Dc = class extends Ti {
  constructor(e = 0, t) {
    super({ tag: "div", cls: "ag-menu-list", role: "menu" }), this.level = e, this.menuItems = [], this.params = t ?? {
      column: null,
      node: null,
      value: null
    };
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => Pc(this.beans, () => this.handleKeyDown(e)),
      onFocusIn: (e) => this.handleFocusIn(e),
      onFocusOut: (e) => this.handleFocusOut(e)
    });
  }
  onTabKeyDown(e) {
    var o;
    const t = this.getParentComponent();
    ((o = t == null ? void 0 : t.getGui()) == null ? void 0 : o.classList.contains("ag-focus-managed")) || e.preventDefault(), e.shiftKey && this.closeIfIsChild(e);
  }
  handleKeyDown(e) {
    switch (e.key) {
      case O.UP:
      case O.RIGHT:
      case O.DOWN:
      case O.LEFT:
        e.preventDefault(), this.handleNavKey(e.key);
        break;
      case O.ESCAPE:
        this.closeIfIsChild() && bt(e);
        break;
    }
  }
  handleFocusIn(e) {
    var n, o;
    const t = e.relatedTarget;
    !this.tabGuardFeature.getTabGuardCtrl().isTabGuard(t) && (this.getGui().contains(t) || (o = (n = this.activeMenuItem) == null ? void 0 : n.getSubMenuGui()) != null && o.contains(t)) || (this.activeMenuItem ? this.activeMenuItem.activate() : this.activateFirstItem());
  }
  handleFocusOut(e) {
    var n;
    const t = e.relatedTarget;
    !this.activeMenuItem || this.getGui().contains(t) || (n = this.activeMenuItem.getSubMenuGui()) != null && n.contains(t) || this.activeMenuItem.isSubMenuOpening() || this.activeMenuItem.deactivate();
  }
  clearActiveItem() {
    this.activeMenuItem && (this.activeMenuItem.deactivate(), this.activeMenuItem = null);
  }
  addMenuItems(e) {
    e != null && tt.all(
      e.map((t) => t === "separator" ? tt.resolve({ eGui: this.createSeparator() }) : typeof t == "string" ? (Z(228, { menuItemOrString: t }), tt.resolve({ eGui: null })) : this.addItem(t))
    ).then((t) => {
      (t ?? []).forEach((n) => {
        n != null && n.eGui && (this.appendChild(n.eGui), n.comp && this.menuItems.push(n.comp));
      });
    });
  }
  addItem(e) {
    const t = this.createManagedBean(new R0());
    return t.init({
      menuItemDef: e,
      isAnotherSubMenuOpen: () => this.menuItems.some((n) => n.isSubMenuOpen()),
      level: this.level,
      contextParams: this.params
    }).then(() => (t.setParentComponent(this), this.addManagedListeners(t, {
      closeMenu: (n) => {
        this.dispatchLocalEvent(n);
      },
      menuItemActivated: (n) => {
        this.activeMenuItem && this.activeMenuItem !== n.menuItem && this.activeMenuItem.deactivate(), this.activeMenuItem = n.menuItem;
      }
    }), {
      comp: t,
      eGui: t.getGui()
    }));
  }
  activateFirstItem() {
    const e = this.menuItems.filter((t) => !t.isDisabled())[0];
    e && e.activate();
  }
  createSeparator() {
    const e = { tag: "div", cls: "ag-menu-separator-part" };
    return Ue({
      tag: "div",
      cls: "ag-menu-separator",
      attrs: {
        "aria-hidden": "true"
      },
      children: [e, e, e, e]
    });
  }
  handleNavKey(e) {
    switch (e) {
      case O.UP:
      case O.DOWN: {
        const n = this.findNextItem(e === O.UP);
        n && n !== this.activeMenuItem && n.activate(!1, !0);
        return;
      }
    }
    const t = this.gos.get("enableRtl") ? O.RIGHT : O.LEFT;
    e === t ? this.closeIfIsChild() : this.openChild();
  }
  closeIfIsChild(e) {
    const t = this.getParentComponent();
    return t && t instanceof R0 ? (e && e.preventDefault(), t.closeSubMenu(), t.getGui().focus(), !0) : !1;
  }
  openChild() {
    this.activeMenuItem && this.activeMenuItem.openSubMenu(!0);
  }
  findNextItem(e) {
    const t = [...this.menuItems];
    if (!t.length)
      return;
    if (!this.activeMenuItem)
      return e ? Je(t) : t[0];
    e && t.reverse();
    let n, o = !1;
    for (const s of t) {
      if (!o) {
        s === this.activeMenuItem && (o = !0);
        continue;
      }
      n = s;
      break;
    }
    return o && !n ? t[0] : n || this.activeMenuItem;
  }
  destroy() {
    this.clearActiveItem(), super.destroy();
  }
}, _b = class extends Te {
  constructor(e, t, n) {
    super({ tag: "div", cls: "ag-menu" }), this.column = e, this.mouseEvent = t, this.parentEl = n, this.displayName = null;
  }
  postConstruct() {
    const {
      column: e,
      beans: { colNames: t }
    } = this;
    this.initializeProperties(e);
    let n;
    if (Io(e) ? n = t.getDisplayNameForColumn(e, "columnToolPanel") : n = t.getDisplayNameForProvidedColumnGroup(null, e, "columnToolPanel"), this.displayName = n, this.buildMenuItemMap(), this.isActive()) {
      this.mouseEvent.preventDefault();
      const o = this.getMappedMenuItems();
      if (o.length === 0)
        return;
      this.displayContextMenu(o);
    }
  }
  initializeProperties(e) {
    let t;
    Pt(e) ? t = e.getLeafColumns() : t = [e], this.columns = t;
    const n = this.beans.colModel.isPivotMode();
    this.allowScrollIntoView = !n && t.some(this.isColumnValidForScrollIntoView), this.allowGrouping = t.some((o) => o.isPrimary() && o.isAllowRowGroup()), this.allowValues = t.some((o) => o.isPrimary() && o.isAllowValue()), this.allowPivoting = n && t.some((o) => o.isPrimary() && o.isAllowPivot());
  }
  buildMenuItemMap() {
    const e = this.getLocaleTextFunc(), { beans: t, displayName: n } = this, { rowGroupColsSvc: o, valueColsSvc: s, pivotColsSvc: i, colModel: r } = t, a = /* @__PURE__ */ new Map();
    this.menuItemMap = a;
    const l = r.isPivotMode();
    a.set("scrollIntoView", {
      allowedFunction: (d) => !d.isPinned() && !l && this.isColumnValidForScrollIntoView(d),
      activeFunction: () => !1,
      activateLabel: () => e("scrollColumnIntoView", `Scroll ${n} into View`, [n]),
      activateFunction: () => {
        const d = this.columns.find(this.isColumnValidForScrollIntoView);
        d && this.beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(d);
      },
      deActivateFunction: () => {
      },
      addIcon: "ensureColumnVisible"
    }), a.set("rowGroup", {
      allowedFunction: (d) => d.isPrimary() && d.isAllowRowGroup() && !Ha(d, t),
      activeFunction: (d) => d.isRowGroupActive(),
      activateLabel: () => `${e("groupBy", "Group by")} ${n}`,
      deactivateLabel: () => `${e("ungroupBy", "Un-Group by")} ${n}`,
      activateFunction: () => o == null ? void 0 : o.setColumns(this.addColumnsToList(o.columns), "toolPanelUi"),
      deActivateFunction: () => o == null ? void 0 : o.setColumns(this.removeColumnsFromList(o.columns), "toolPanelUi"),
      addIcon: "menuAddRowGroup",
      removeIcon: "menuRemoveRowGroup"
    }), a.set("value", {
      allowedFunction: (d) => d.isPrimary() && d.isAllowValue(),
      activeFunction: (d) => d.isValueActive(),
      activateLabel: () => e("addToValues", `Add ${n} to values`, [n]),
      deactivateLabel: () => e("removeFromValues", `Remove ${n} from values`, [n]),
      activateFunction: () => s == null ? void 0 : s.setColumns(this.addColumnsToList(s.columns), "toolPanelUi"),
      deActivateFunction: () => s == null ? void 0 : s.setColumns(this.removeColumnsFromList(s.columns), "toolPanelUi"),
      addIcon: "valuePanel",
      removeIcon: "valuePanel"
    }), a.set("pivot", {
      allowedFunction: (d) => l && d.isPrimary() && d.isAllowPivot(),
      activeFunction: (d) => d.isPivotActive(),
      activateLabel: () => e("addToLabels", `Add ${n} to labels`, [n]),
      deactivateLabel: () => e("removeFromLabels", `Remove ${n} from labels`, [n]),
      activateFunction: () => i == null ? void 0 : i.setColumns(this.addColumnsToList(i.columns), "toolPanelUi"),
      deActivateFunction: () => i == null ? void 0 : i.setColumns(this.removeColumnsFromList(i.columns), "toolPanelUi"),
      addIcon: "pivotPanel",
      removeIcon: "pivotPanel"
    });
  }
  isColumnValidForScrollIntoView(e) {
    var o;
    if (!e.isVisible())
      return !1;
    const n = e.getParent();
    return n ? ((o = n.getDisplayedChildren()) == null ? void 0 : o.indexOf(e)) !== -1 : !0;
  }
  addColumnsToList(e) {
    return [...e].concat(this.columns.filter((t) => e.indexOf(t) === -1));
  }
  removeColumnsFromList(e) {
    return e.filter((t) => this.columns.indexOf(t) === -1);
  }
  displayContextMenu(e) {
    const t = this.getGui(), n = this.createBean(new Dc()), o = this.getLocaleTextFunc();
    let s = () => {
    };
    t.appendChild(n.getGui()), n.addMenuItems(e), n.addManagedListeners(n, {
      closeMenu: () => {
        this.parentEl.focus(), s();
      }
    });
    const i = this.beans.popupSvc, r = i.addPopup({
      modal: !0,
      eChild: t,
      closeOnEsc: !0,
      afterGuiAttached: () => pn(n.getGui()),
      ariaLabel: o("ariaLabelContextMenu", "Context Menu"),
      closedCallback: (a) => {
        a instanceof KeyboardEvent && this.parentEl.focus(), this.destroyBean(n);
      }
    });
    r && (s = r.hideFunc), i.positionPopupUnderMouseEvent({
      type: "columnContextMenu",
      mouseEvent: this.mouseEvent,
      ePopup: t
    });
  }
  isActive() {
    return this.allowScrollIntoView || this.allowGrouping || this.allowValues || this.allowPivoting;
  }
  getMappedMenuItems() {
    const e = [], { menuItemMap: t, columns: n, displayName: o, beans: s } = this;
    for (const i of t.values()) {
      const r = n.some((l) => i.allowedFunction(l) && !i.activeFunction(l)), a = n.some((l) => i.allowedFunction(l) && i.activeFunction(l));
      r && e.push({
        name: i.activateLabel(o),
        icon: Le(i.addIcon, s, null),
        action: () => i.activateFunction()
      }), a && i.removeIcon && i.deactivateLabel && e.push({
        name: i.deactivateLabel(o),
        icon: Le(i.removeIcon, s, null),
        action: () => {
          var l;
          return (l = i.deActivateFunction) == null ? void 0 : l.call(i);
        }
      });
    }
    return e;
  }
}, lN = {
  tag: "div",
  cls: "ag-column-select-column-group",
  children: [
    {
      tag: "span",
      ref: "eColumnGroupIcons",
      cls: "ag-column-group-icons",
      children: [
        { tag: "span", ref: "eGroupClosedIcon", cls: "ag-column-group-closed-icon" },
        { tag: "span", ref: "eGroupOpenedIcon", cls: "ag-column-group-opened-icon" }
      ]
    },
    { tag: "ag-checkbox", ref: "cbSelect", cls: "ag-column-select-checkbox" },
    { tag: "span", ref: "eLabel", cls: "ag-column-select-column-label" }
  ]
}, Nb = class extends Te {
  constructor(e, t, n, o) {
    super(), this.modelItem = e, this.allowDragging = t, this.eventType = n, this.focusWrapper = o, this.cbSelect = X, this.eLabel = X, this.eGroupOpenedIcon = X, this.eGroupClosedIcon = X, this.eColumnGroupIcons = X, this.processingColumnStateChange = !1;
    const { columnGroup: s, depth: i, displayName: r } = e;
    this.columnGroup = s, this.columnDepth = i, this.displayName = r;
  }
  postConstruct() {
    this.setTemplate(lN, [Di]);
    const { beans: e, cbSelect: t, eLabel: n, displayName: o, columnDepth: s, modelItem: i, focusWrapper: r, columnGroup: a } = this, { registry: l, gos: d } = e, c = Le("columnDrag", e);
    this.eDragHandle = c, c.classList.add("ag-drag-handle", "ag-column-select-column-group-drag-handle");
    const u = t.getGui(), h = t.getInputElement();
    u.insertAdjacentElement("afterend", c), h.setAttribute("tabindex", "-1"), n.textContent = o ?? "", this.setupExpandContract(), this.addCss("ag-column-select-indent-" + s), this.getGui().style.setProperty("--ag-indentation-level", String(s)), this.tooltipFeature = this.createOptionalManagedBean(
      l.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.focusWrapper,
        getLocation: () => "columnToolPanelColumnGroup",
        shouldDisplayTooltip: Op(d, () => n)
      })
    ), this.addManagedEventListeners({ columnPivotModeChanged: this.onColumnStateChanged.bind(this) }), this.addManagedElementListeners(n, { click: this.onLabelClicked.bind(this) }), this.addManagedListeners(t, { fieldValueChanged: this.onCheckboxChanged.bind(this) }), this.addManagedListeners(i, { expandedChanged: this.onExpandChanged.bind(this) }), this.addManagedListeners(r, {
      keydown: this.handleKeyDown.bind(this),
      contextmenu: this.onContextMenu.bind(this)
    }), this.setOpenClosedIcons(), this.setupDragging(), this.onColumnStateChanged(), this.addVisibilityListenersToAllChildren(), this.refreshAriaExpanded(), this.refreshAriaLabel(), this.setupTooltip(), $w(a.getColGroupDef(), d, null, a).forEach((p) => this.toggleCss(p, !0));
  }
  getColumns() {
    return this.columnGroup.getLeafColumns();
  }
  setupTooltip() {
    const e = this.columnGroup.getColGroupDef();
    if (!e)
      return;
    const t = () => {
      var n;
      return (n = this.tooltipFeature) == null ? void 0 : n.setTooltipAndRefresh(e.headerTooltip);
    };
    t(), this.addManagedEventListeners({ newColumnsLoaded: t });
  }
  handleKeyDown(e) {
    switch (e.key) {
      case O.LEFT:
        e.preventDefault(), this.modelItem.expanded = !1;
        break;
      case O.RIGHT:
        e.preventDefault(), this.modelItem.expanded = !0;
        break;
      case O.SPACE:
        e.preventDefault(), this.isSelectable() && this.onSelectAllChanged(!this.isSelected());
        break;
    }
  }
  onContextMenu(e) {
    const { columnGroup: t, gos: n } = this;
    if (n.get("functionsReadOnly"))
      return;
    const o = this.createBean(new _b(t, e, this.focusWrapper));
    this.addDestroyFunc(() => {
      o.isAlive() && this.destroyBean(o);
    });
  }
  addVisibilityListenersToAllChildren() {
    const e = this.onColumnStateChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      this.addManagedListeners(t, {
        visibleChanged: e,
        columnValueChanged: e,
        columnPivotChanged: e,
        columnRowGroupChanged: e
      });
    });
  }
  setupDragging() {
    if (!this.allowDragging) {
      He(this.eDragHandle, !1);
      return;
    }
    const e = this.beans, { gos: t, eventSvc: n, dragAndDrop: o } = e;
    let s = !t.get("suppressDragLeaveHidesColumns");
    const i = {
      type: ns.ToolPanel,
      eElement: this.eDragHandle,
      dragItemName: this.displayName,
      getDefaultIconName: () => s ? "hide" : "notAllowed",
      getDragItem: () => this.createDragItem(),
      onDragStarted: () => {
        s = !t.get("suppressDragLeaveHidesColumns"), n.dispatchEvent({
          type: "columnPanelItemDragStart",
          column: this.columnGroup
        });
      },
      onDragStopped: () => {
        n.dispatchEvent({
          type: "columnPanelItemDragEnd"
        });
      },
      onGridEnter: (r) => {
        s && Gb(e, {
          columns: this.columnGroup.getLeafColumns(),
          visibleState: r == null ? void 0 : r.visibleState,
          pivotState: r == null ? void 0 : r.pivotState,
          eventType: this.eventType
        });
      },
      onGridExit: () => {
        s && this.onChangeCommon(!1);
      }
    };
    o.addDragSource(i, !0), this.addDestroyFunc(() => o.removeDragSource(i));
  }
  createDragItem() {
    const e = this.columnGroup.getLeafColumns(), t = {}, n = {};
    return e.forEach((o) => {
      const s = o.getId();
      t[s] = o.isVisible(), n[s] = Hb(o);
    }), {
      columns: e,
      visibleState: t,
      pivotState: n
    };
  }
  setupExpandContract() {
    const { beans: e, eGroupClosedIcon: t, eGroupOpenedIcon: n, eColumnGroupIcons: o } = this;
    t.appendChild(nr("columnSelectClosed", e, null)), n.appendChild(nr("columnSelectOpen", e, null));
    const s = this.onExpandOrContractClicked.bind(this);
    this.addManagedElementListeners(t, { click: s }), this.addManagedElementListeners(n, { click: s });
    const i = new No(o, !0);
    this.addManagedListeners(i, { tap: s }), this.addDestroyFunc(i.destroy.bind(i));
  }
  onLabelClicked() {
    const e = !this.cbSelect.getValue();
    this.onChangeCommon(e);
  }
  onCheckboxChanged(e) {
    this.onChangeCommon(e.selected);
  }
  getVisibleLeafColumns() {
    const e = [], t = (n) => {
      n.forEach((o) => {
        o.passesFilter && (o.group ? t(o.children) : e.push(o.column));
      });
    };
    return t(this.modelItem.children), e;
  }
  onChangeCommon(e) {
    this.refreshAriaLabel(), !this.processingColumnStateChange && Bb(this.beans, this.modelItem.children, e, this.eventType);
  }
  refreshAriaLabel() {
    const { cbSelect: e, focusWrapper: t, displayName: n } = this, o = this.getLocaleTextFunc(), s = o("ariaColumnGroup", "Column Group"), i = e.getValue(), r = i === void 0 ? o("ariaIndeterminate", "indeterminate") : i ? o("ariaVisible", "visible") : o("ariaHidden", "hidden"), a = o("ariaToggleVisibility", "Press SPACE to toggle visibility");
    yt(t, `${n} ${s}`), e.setInputAriaLabel(`${a} (${r})`), ic(t, e.getInputElement().id);
  }
  onColumnStateChanged() {
    const e = this.workOutSelectedValue(), t = this.workOutReadOnlyValue();
    this.processingColumnStateChange = !0;
    const n = this.cbSelect;
    n.setValue(e), n.setReadOnly(t), this.toggleCss("ag-column-select-column-group-readonly", t), this.processingColumnStateChange = !1;
  }
  workOutSelectedValue() {
    const e = this.beans.colModel.isPivotMode(), t = this.getVisibleLeafColumns();
    let n = 0, o = 0;
    if (t.forEach((s) => {
      !e && s.getColDef().lockVisible || (this.isColumnChecked(s, e) ? n++ : o++);
    }), !(n > 0 && o > 0))
      return n > 0;
  }
  workOutReadOnlyValue() {
    const e = this.beans.colModel.isPivotMode();
    let t = 0;
    return this.columnGroup.getLeafColumns().forEach((n) => {
      e ? n.isAnyFunctionAllowed() && t++ : n.getColDef().lockVisible || t++;
    }), t === 0;
  }
  isColumnChecked(e, t) {
    if (t) {
      const n = e.isPivotActive(), o = e.isRowGroupActive(), s = e.isValueActive();
      return n || o || s;
    }
    return e.isVisible();
  }
  onExpandOrContractClicked() {
    const e = this.modelItem, t = e.expanded;
    e.expanded = !t;
  }
  onExpandChanged() {
    this.setOpenClosedIcons(), this.refreshAriaExpanded();
  }
  setOpenClosedIcons() {
    const e = this.modelItem.expanded;
    He(this.eGroupClosedIcon, !e), He(this.eGroupOpenedIcon, e);
  }
  refreshAriaExpanded() {
    Zn(this.focusWrapper, this.modelItem.expanded);
  }
  getDisplayName() {
    return this.displayName;
  }
  onSelectAllChanged(e) {
    const t = this.cbSelect, n = t.getValue();
    !t.isReadOnly() && (e && !n || !e && n) && t.toggle();
  }
  isSelected() {
    return this.cbSelect.getValue();
  }
  isSelectable() {
    return !this.cbSelect.isReadOnly();
  }
  setSelected(e) {
    this.cbSelect.setValue(e, !0);
  }
}, Hu = (e) => Pt(e) ? e.getLeafColumns() : e ? [e] : [], dN = (e, t, n, o) => {
  if (!n || !t)
    return null;
  const s = e.colModel.getCols(), i = s.indexOf(n), r = o ? i : i + 1, a = cN(s, t, r);
  return r - a;
}, cN = (e, t, n) => {
  if (!t)
    return 0;
  const o = t[0], s = t.length;
  return e.indexOf(o) < n ? s : 0;
}, E0 = (e, t, n) => e.get("suppressMovableColumns") || t.colModel.isPivotMode() ? !0 : !!n.find(({ colDef: i }) => !!i.suppressMovable || !!i.lockPosition), A0 = (e, t, n) => {
  var a;
  if (!n)
    return;
  const { component: o } = n;
  let s = null, i = n.position === "top";
  if (o instanceof Nb ? (s = o.getColumns()[0], i = !0) : o && (s = o.column), !s)
    return;
  const r = dN(e, t, s, i);
  r != null && ((a = e.colMoves) == null || a.moveColumns(t, r, "toolPanelUi"));
}, uN = (e) => e.column, hN = {
  tag: "div",
  cls: "ag-column-select-column",
  children: [
    { tag: "ag-checkbox", ref: "cbSelect", cls: "ag-column-select-checkbox" },
    { tag: "span", ref: "eLabel", cls: "ag-column-select-column-label" }
  ]
}, gN = class extends Te {
  constructor(e, t, n, o) {
    super(), this.modelItem = e, this.allowDragging = t, this.groupsExist = n, this.focusWrapper = o, this.eLabel = X, this.cbSelect = X, this.processingColumnStateChange = !1;
    const { column: s, depth: i, displayName: r } = e;
    this.column = s, this.columnDepth = i, this.displayName = r;
  }
  postConstruct() {
    this.setTemplate(hN, [Di]);
    const {
      beans: e,
      cbSelect: t,
      displayName: n,
      eLabel: o,
      columnDepth: s,
      groupsExist: i,
      column: r,
      gos: a,
      focusWrapper: l
    } = this, d = Le("columnDrag", e);
    this.eDragHandle = d, d.classList.add("ag-drag-handle", "ag-column-select-column-drag-handle");
    const c = t.getGui(), u = t.getInputElement();
    c.insertAdjacentElement("afterend", d), u.setAttribute("tabindex", "-1"), o.textContent = n, i && this.addCss("ag-column-select-add-group-indent"), this.addCss(`ag-column-select-indent-${s}`), this.getGui().style.setProperty("--ag-indentation-level", String(s)), this.tooltipFeature = this.createOptionalManagedBean(
      e.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.focusWrapper,
        getLocation: () => "columnToolPanelColumn",
        shouldDisplayTooltip: Op(a, () => o),
        getAdditionalParams: () => ({
          colDef: r.getColDef()
        })
      })
    ), this.setupDragging();
    const h = this.onColumnStateChanged.bind(this);
    this.addManagedEventListeners({ columnPivotModeChanged: h }), this.addManagedListeners(r, {
      columnValueChanged: h,
      columnPivotChanged: h,
      columnRowGroupChanged: h,
      visibleChanged: h
    }), this.addManagedListeners(l, {
      keydown: this.handleKeyDown.bind(this),
      contextmenu: this.onContextMenu.bind(this)
    }), this.addManagedPropertyListener("functionsReadOnly", this.onColumnStateChanged.bind(this)), this.addManagedListeners(t, { fieldValueChanged: this.onCheckboxChanged.bind(this) }), this.addManagedElementListeners(o, { click: this.onLabelClicked.bind(this) }), this.onColumnStateChanged(), this.refreshAriaLabel(), this.setupTooltip(), $w(r.getColDef(), a, r, null).forEach((p) => this.toggleCss(p, !0));
  }
  getColumn() {
    return this.column;
  }
  setupTooltip() {
    const e = () => {
      var t;
      return (t = this.tooltipFeature) == null ? void 0 : t.setTooltipAndRefresh(this.column.getColDef().headerTooltip);
    };
    e(), this.addManagedEventListeners({ newColumnsLoaded: e });
  }
  onContextMenu(e) {
    const { column: t, gos: n } = this;
    if (n.get("functionsReadOnly"))
      return;
    const o = this.createBean(new _b(t, e, this.focusWrapper));
    this.addDestroyFunc(() => {
      o.isAlive() && this.destroyBean(o);
    });
  }
  handleKeyDown(e) {
    e.key === O.SPACE && (e.preventDefault(), this.isSelectable() && this.onSelectAllChanged(!this.isSelected()));
  }
  onLabelClicked() {
    if (this.gos.get("functionsReadOnly"))
      return;
    const e = !this.cbSelect.getValue();
    this.onChangeCommon(e);
  }
  onCheckboxChanged(e) {
    this.onChangeCommon(e.selected);
  }
  onChangeCommon(e) {
    this.cbSelect.isReadOnly() || (this.refreshAriaLabel(), !this.processingColumnStateChange && Ob(this.beans, [this.column], e, "toolPanelUi"));
  }
  refreshAriaLabel() {
    const { cbSelect: e, focusWrapper: t, displayName: n } = this, o = this.getLocaleTextFunc(), s = o("ariaColumn", "Column"), i = e.getValue() ? o("ariaVisible", "visible") : o("ariaHidden", "hidden"), r = o("ariaToggleVisibility", "Press SPACE to toggle visibility");
    yt(t, `${n} ${s}`), this.cbSelect.setInputAriaLabel(`${r} (${i})`), ic(t, e.getInputElement().id);
  }
  setupDragging() {
    const e = this.eDragHandle;
    if (!this.allowDragging) {
      He(e, !1);
      return;
    }
    const t = this.beans, { gos: n, eventSvc: o, dragAndDrop: s } = t;
    let i = !n.get("suppressDragLeaveHidesColumns");
    const r = {
      type: ns.ToolPanel,
      eElement: e,
      dragItemName: this.displayName,
      getDefaultIconName: () => i ? "hide" : "notAllowed",
      getDragItem: () => this.createDragItem(),
      onDragStarted: () => {
        i = !n.get("suppressDragLeaveHidesColumns"), o.dispatchEvent({
          type: "columnPanelItemDragStart",
          column: this.column
        });
      },
      onDragStopped: () => {
        o.dispatchEvent({
          type: "columnPanelItemDragEnd"
        });
      },
      onGridEnter: (a) => {
        i && Gb(t, {
          columns: [this.column],
          visibleState: a == null ? void 0 : a.visibleState,
          pivotState: a == null ? void 0 : a.pivotState,
          eventType: "toolPanelUi"
        });
      },
      onGridExit: () => {
        i && this.onChangeCommon(!1);
      }
    };
    s.addDragSource(r, !0), this.addDestroyFunc(() => s.removeDragSource(r));
  }
  createDragItem() {
    const e = this.column.getColId(), t = { [e]: this.column.isVisible() }, n = { [e]: Hb(this.column) };
    return {
      columns: [this.column],
      visibleState: t,
      pivotState: n
    };
  }
  onColumnStateChanged() {
    this.processingColumnStateChange = !0;
    const e = this.beans.colModel.isPivotMode();
    if (e) {
      const o = this.column.isAnyFunctionActive();
      this.cbSelect.setValue(o);
    } else
      this.cbSelect.setValue(this.column.isVisible());
    let t = !0, n = !0;
    if (e) {
      const o = this.gos.get("functionsReadOnly"), s = !this.column.isAnyFunctionAllowed();
      t = !o && !s, n = t;
    } else {
      const { enableRowGroup: o, enableValue: s, lockPosition: i, suppressMovable: r, lockVisible: a } = this.column.getColDef(), l = !!o || !!s, d = !!i || !!r;
      t = !a, n = l || !d;
    }
    this.cbSelect.setReadOnly(!t), this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !n), this.toggleCss("ag-column-select-column-readonly", !n && !t), this.cbSelect.setPassive(!1), this.processingColumnStateChange = !1;
  }
  getDisplayName() {
    return this.displayName;
  }
  onSelectAllChanged(e) {
    const t = this.cbSelect;
    e !== t.getValue() && (t.isReadOnly() || t.toggle());
  }
  isSelected() {
    return this.cbSelect.getValue();
  }
  isSelectable() {
    return !this.cbSelect.isReadOnly();
  }
  isExpandable() {
    return !1;
  }
  setExpanded(e) {
    Z(158);
  }
}, pN = class {
  constructor(e) {
    this.items = e;
  }
  getRowCount() {
    return this.items.length;
  }
  getRow(e) {
    return this.items[e];
  }
}, fN = "ag-column-select-list", mN = class extends Te {
  constructor() {
    super({ tag: "div", cls: fN, role: "presentation" }), this.destroyColumnItemFuncs = [], this.hasLoadedInitialState = !1, this.isInitialState = !1, this.skipRefocus = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  destroy() {
    this.destroyColumnTree(), super.destroy();
  }
  destroyColumnTree() {
    this.allColsTree = [], this.destroyColumnItemFuncs.forEach((e) => e()), this.destroyColumnItemFuncs = [];
  }
  init(e, t, n) {
    this.params = e;
    const { suppressSyncLayoutWithGrid: o, contractColumnSelection: s, suppressColumnMove: i } = e;
    this.allowDragging = t, this.eventType = n, o || this.addManagedEventListeners({ columnMoved: this.onColumnsChanged.bind(this) }), this.addManagedEventListeners({
      newColumnsLoaded: this.onColumnsChanged.bind(this)
    });
    const r = this.fireSelectionChangedEvent.bind(this);
    this.addManagedEventListeners({
      columnPivotChanged: r,
      columnPivotModeChanged: r,
      columnRowGroupChanged: r,
      columnValueChanged: r,
      columnVisible: r,
      newColumnsLoaded: r
    }), this.expandGroupsByDefault = !s;
    const a = i || o, l = this.createManagedBean(
      new Lr({
        cssIdentifier: "column-select",
        ariaRole: "tree",
        moveItemCallback: (d, c) => {
          a || this.moveItems(d, c);
        }
      })
    );
    this.virtualList = l, this.appendChild(l.getGui()), l.setComponentCreator((d, c) => (rc(c, d.depth + 1), this.createComponentFromItem(d, c))), this.colModel.ready && this.onColumnsChanged(), !a && this.createItemDragFeature();
  }
  createItemDragFeature() {
    const { gos: e, beans: t, eventSvc: n, virtualList: o } = this;
    this.createManagedBean(
      new Sb(this, o, {
        dragSourceType: ns.ToolPanel,
        listItemDragStartEvent: "columnPanelItemDragStart",
        listItemDragEndEvent: "columnPanelItemDragEnd",
        eventSource: n,
        getCurrentDragValue: (s) => uN(s),
        isMoveBlocked: (s) => E0(e, t, Hu(s)),
        getNumRows: (s) => s.getDisplayedColsList().length,
        moveItem: (s, i) => A0(t, Hu(s), i)
      })
    );
  }
  moveItems(e, t) {
    var p;
    const { gos: n, beans: o } = this, { modelItem: s } = e, { group: i, columnGroup: r, column: a, expanded: l } = s, d = Hu(i ? r : a);
    if (E0(n, o, d))
      return;
    const c = this.displayedColsList.indexOf(s), u = t ? -1 : 1;
    let h = 0;
    if (t) {
      const f = e.columnDepth > 0 && ((p = a.getParent()) == null ? void 0 : p.getChildren());
      f && f.length && a === f[0] && (h = -1);
    } else i && (h = l ? s.children.length : 0);
    const g = Math.min(Math.max(c + h + u, 0), this.displayedColsList.length - 1);
    this.skipRefocus = !0, A0(o, d, {
      position: t ? "top" : "bottom",
      component: this.virtualList.getComponentAt(g)
    }), this.focusRowIfAlive(g - h).then(() => {
      this.skipRefocus = !1;
    });
  }
  createComponentFromItem(e, t) {
    const n = this.allowDragging;
    if (e.group) {
      const s = new Nb(e, n, this.eventType, t);
      return this.createBean(s), s;
    }
    const o = new gN(e, n, this.groupsExist, t);
    return this.createBean(o), o;
  }
  onColumnsChanged() {
    const e = this.params;
    this.hasLoadedInitialState || (this.hasLoadedInitialState = !0, this.isInitialState = !!e.initialState);
    const t = this.getExpandedStates(), n = this.colModel.isPivotMode();
    !e.suppressSyncLayoutWithGrid && !n ? this.buildTreeFromWhatGridIsDisplaying() : this.buildTreeFromProvidedColumnDefs(), this.setExpandedStates(t), this.markFilteredColumns(), this.flattenAndFilterModel(), this.isInitialState = !1;
  }
  getDisplayedColsList() {
    return this.displayedColsList;
  }
  getExpandedStates() {
    const e = {};
    if (this.isInitialState) {
      const { expandedGroupIds: t } = this.params.initialState;
      return t.forEach((n) => {
        e[n] = !0;
      }), e;
    }
    return this.allColsTree ? (this.forEachItem((t) => {
      if (!t.group)
        return;
      const n = t.columnGroup;
      n && (e[n.getId()] = t.expanded);
    }), e) : {};
  }
  setExpandedStates(e) {
    if (!this.allColsTree)
      return;
    const { isInitialState: t } = this;
    this.forEachItem((n) => {
      if (!n.group)
        return;
      const o = n.columnGroup;
      if (o) {
        const s = e[o.getId()];
        (s != null || t) && (n.expanded = !!s);
      }
    });
  }
  buildTreeFromWhatGridIsDisplaying() {
    Q_(this.colModel, this.setColumnLayout.bind(this));
  }
  setColumnLayout(e) {
    const t = Y_(this.colModel, e);
    this.buildListModel(t), this.groupsExist = e.some((n) => n && typeof n.children < "u"), this.markFilteredColumns(), this.flattenAndFilterModel();
  }
  buildTreeFromProvidedColumnDefs() {
    var t;
    const e = this.colModel;
    this.buildListModel(e.getColDefColTree()), this.groupsExist = !!((t = e.colDefCols) != null && t.treeDepth);
  }
  buildListModel(e) {
    const t = this.onColumnExpanded.bind(this), n = (a) => {
      a.addEventListener("expandedChanged", t);
      const l = a.removeEventListener.bind(a, "expandedChanged", t);
      this.destroyColumnItemFuncs.push(l);
    }, o = this.beans.colNames, s = (a, l, d) => {
      a.forEach((c) => {
        Pt(c) ? i(c, l, d) : r(c, l, d);
      });
    }, i = (a, l, d) => {
      const c = a.getColGroupDef();
      if (c && c.suppressColumnsToolPanel)
        return;
      if (a.isPadding()) {
        s(a.getChildren(), l, d);
        return;
      }
      const h = o.getDisplayNameForProvidedColumnGroup(null, a, "columnToolPanel"), g = new S0(
        h,
        a,
        l,
        !0,
        this.expandGroupsByDefault
      );
      d.push(g), n(g), s(a.getChildren(), l + 1, g.children);
    }, r = (a, l, d) => {
      if (a.getColDef() && a.getColDef().suppressColumnsToolPanel)
        return;
      const u = o.getDisplayNameForColumn(a, "columnToolPanel");
      d.push(new S0(u, a, l));
    };
    this.destroyColumnTree(), s(e, 0, this.allColsTree);
  }
  onColumnExpanded() {
    this.flattenAndFilterModel();
  }
  flattenAndFilterModel() {
    this.displayedColsList = [];
    const e = (o) => {
      o.passesFilter && (this.displayedColsList.push(o), o.group && o.expanded && o.children.forEach(e));
    }, t = this.virtualList;
    this.allColsTree.forEach(e), t.setModel(new pN(this.displayedColsList));
    let n = null;
    this.skipRefocus || (n = t.getLastFocusedRow()), t.refresh(), n != null && this.focusRowIfAlive(n), this.notifyListeners(), this.refreshAriaLabel();
  }
  refreshAriaLabel() {
    const e = this.getLocaleTextFunc(), t = e("ariaColumnPanelList", "Column List"), n = e("columns", "Columns"), o = this.displayedColsList.length;
    yt(this.virtualList.getAriaElement(), `${t} ${o} ${n}`);
  }
  focusRowIfAlive(e) {
    return e === -1 ? Promise.resolve() : new Promise((t) => {
      window.setTimeout(() => {
        this.isAlive() && this.virtualList.focusRow(e), t();
      }, 0);
    });
  }
  forEachItem(e) {
    const t = (o) => {
      o.forEach((s) => {
        e(s), s.group && t(s.children);
      });
    }, n = this.allColsTree;
    n && t(n);
  }
  doSetExpandedAll(e) {
    this.forEachItem((t) => {
      t.group && (t.expanded = e);
    });
  }
  setGroupsExpanded(e, t) {
    if (!t) {
      this.doSetExpandedAll(e);
      return;
    }
    const n = [];
    this.forEachItem((s) => {
      if (!s.group)
        return;
      const i = s.columnGroup.getId();
      t.indexOf(i) >= 0 && (s.expanded = e, n.push(i));
    });
    const o = t.filter((s) => !n.includes(s));
    o.length > 0 && Z(157, { unrecognisedGroupIds: o });
  }
  getExpandState() {
    let e = 0, t = 0;
    return this.forEachItem((n) => {
      n.group && (n.expanded ? e++ : t++);
    }), e > 0 && t > 0 ? 2 : t > 0 ? 1 : 0;
  }
  doSetSelectedAll(e) {
    Bb(this.beans, this.allColsTree, e, this.eventType);
  }
  getSelectionState() {
    let e = 0, t = 0;
    const n = this.colModel.isPivotMode();
    if (this.forEachItem((o) => {
      if (o.group || !o.passesFilter)
        return;
      const s = o.column, i = s.getColDef();
      let r;
      if (n) {
        if (!s.isAllowPivot() && !s.isAllowRowGroup() && !s.isAllowValue())
          return;
        r = s.isValueActive() || s.isPivotActive() || s.isRowGroupActive();
      } else {
        if (i.lockVisible)
          return;
        r = s.isVisible();
      }
      r ? e++ : t++;
    }), !(e > 0 && t > 0))
      return !(e === 0 || t > 0);
  }
  setFilterText(e) {
    this.filterText = ue(e) ? e.toLowerCase() : null, this.markFilteredColumns(), this.flattenAndFilterModel();
  }
  markFilteredColumns() {
    const e = (n) => {
      if (!ue(this.filterText))
        return !0;
      const o = n.displayName;
      return o == null || o.toLowerCase().indexOf(this.filterText) !== -1;
    }, t = (n, o) => {
      let s = !1;
      if (n.group) {
        const r = e(n);
        n.children.forEach((a) => {
          const l = t(a, r || o);
          l && (s = l);
        });
      }
      const i = o || s ? !0 : e(n);
      return n.passesFilter = i, i;
    };
    this.allColsTree.forEach((n) => t(n, !1));
  }
  notifyListeners() {
    this.fireGroupExpandedEvent(), this.fireSelectionChangedEvent();
  }
  fireGroupExpandedEvent() {
    const e = this.getExpandState();
    this.dispatchLocalEvent({ type: "groupExpanded", state: e });
  }
  fireSelectionChangedEvent() {
    if (!this.allColsTree)
      return;
    const e = this.getSelectionState();
    this.dispatchLocalEvent({ type: "selectionChanged", state: e });
  }
  getExpandedGroups() {
    const e = [];
    return this.allColsTree && this.forEachItem((t) => {
      t.group && t.expanded && e.push(t.columnGroup.getId());
    }), e;
  }
}, vN = {
  selector: "AG-PRIMARY-COLS-LIST",
  component: mN
}, CN = {
  tag: "div",
  cls: "ag-column-select",
  children: [
    { tag: "ag-primary-cols-header", ref: "primaryColsHeaderPanel" },
    { tag: "ag-primary-cols-list", ref: "primaryColsListPanel" }
  ]
}, $b = class extends Te {
  constructor() {
    super(CN, [q_, vN]), this.primaryColsHeaderPanel = X, this.primaryColsListPanel = X, this.registerCSS(W_);
  }
  // we allow dragging in the toolPanel, but not when this component appears in the column menu
  init(e, t, n) {
    const { primaryColsHeaderPanel: o, primaryColsListPanel: s } = this;
    o.init(t);
    const i = t.suppressColumnFilter, r = t.suppressColumnSelectAll;
    t.suppressColumnExpandAll && i && r && o.setDisplayed(!1), this.addManagedListeners(s, {
      groupExpanded: (l) => {
        o.setExpandState(l.state), t.onStateUpdated();
      },
      selectionChanged: (l) => o.setSelectionState(l.state)
    }), s.init(t, e, n), this.addManagedListeners(o, {
      expandAll: s.doSetExpandedAll.bind(s, !0),
      collapseAll: s.doSetExpandedAll.bind(s, !1),
      selectAll: s.doSetSelectedAll.bind(s, !0),
      unselectAll: s.doSetSelectedAll.bind(s, !1),
      filterChanged: (l) => s.setFilterText(l.filterText)
    }), this.positionableFeature = this.createManagedBean(new Sc(this.getGui(), { minHeight: 100 }));
  }
  toggleResizable(e) {
    this.positionableFeature.setResizable(e ? { bottom: !0 } : !1);
  }
  expandGroups(e) {
    this.primaryColsListPanel.setGroupsExpanded(!0, e);
  }
  collapseGroups(e) {
    this.primaryColsListPanel.setGroupsExpanded(!1, e);
  }
  setColumnLayout(e) {
    this.primaryColsListPanel.setColumnLayout(e);
  }
  syncLayoutWithGrid() {
    this.primaryColsListPanel.onColumnsChanged();
  }
  getExpandedGroups() {
    return this.primaryColsListPanel.getExpandedGroups();
  }
}, wN = (
  /*css*/
  ".ag-column-panel{display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden}.ag-pivot-mode-panel{display:flex;height:var(--ag-header-height)}.ag-pivot-mode-select{align-items:center;display:flex}:where(.ag-ltr) .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-panel-column-select{border-bottom:var(--ag-tool-panel-separator-border)}.ag-column-panel-column-select:where(:nth-child(n+2 of :not(.ag-hidden))){border-top:var(--ag-tool-panel-separator-border)}:where(.ag-column-panel) .ag-column-drop-vertical{flex:1 1 0px;min-height:50px;&:where(:not(.ag-last-column-drop)){border-bottom:var(--ag-tool-panel-separator-border)}}"
), yN = class extends Te {
  constructor() {
    super({ tag: "div", cls: "ag-column-panel" }), this.initialised = !1, this.childDestroyFuncs = [], this.registerCSS(wN);
  }
  wireBeans(e) {
    this.colToolPanelFactory = e.colToolPanelFactory;
  }
  // lazy initialise the panel
  setVisible(e) {
    super.setDisplayed(e), e && !this.initialised && this.init(this.params);
  }
  init(e) {
    const n = {
      ...ke(this.gos, {
        suppressColumnMove: !1,
        suppressColumnSelectAll: !1,
        suppressColumnFilter: !1,
        suppressColumnExpandAll: !1,
        contractColumnSelection: !1,
        suppressPivotMode: !1,
        suppressRowGroups: !1,
        suppressValues: !1,
        suppressPivots: !1,
        suppressSyncLayoutWithGrid: !1
      }),
      ...e
    };
    this.params = n;
    const { childDestroyFuncs: o, colToolPanelFactory: s, gos: i } = this, r = i.isModuleRegistered("SharedPivot"), a = r || i.isModuleRegistered("SharedRowGrouping");
    !n.suppressPivotMode && s && r && (this.pivotModePanel = s.createPivotModePanel(this, o));
    const l = this.createBean(new $b());
    if (this.primaryColsPanel = l, o.push(() => this.destroyBean(this.primaryColsPanel)), l.init(!0, n, "toolPanelUi"), l.addCss("ag-column-panel-column-select"), this.appendChild(l), s) {
      !n.suppressRowGroups && a && (this.rowGroupDropZonePanel = s.createRowGroupPanel(this, o)), !n.suppressValues && a && (this.valuesDropZonePanel = s.createValuesPanel(this, o)), !n.suppressPivots && r && (this.pivotDropZonePanel = s.createPivotPanel(this, o)), this.setLastVisible();
      const [d] = this.addManagedEventListeners({
        columnPivotModeChanged: () => {
          this.resetChildrenHeight(), this.setLastVisible();
        }
      });
      o.push(() => d());
    }
    this.initialised = !0;
  }
  setPivotModeSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.pivotModePanel = t.setPanelVisible(
      this.pivotModePanel,
      e,
      t.createPivotModePanel.bind(t, this, this.childDestroyFuncs, !0)
    ), this.setLastVisible());
  }
  setRowGroupsSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.rowGroupDropZonePanel = t.setPanelVisible(
      this.rowGroupDropZonePanel,
      e,
      t.createRowGroupPanel.bind(t, this, this.childDestroyFuncs)
    ), this.setLastVisible());
  }
  setValuesSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.valuesDropZonePanel = t.setPanelVisible(
      this.valuesDropZonePanel,
      e,
      t.createValuesPanel.bind(t, this, this.childDestroyFuncs)
    ), this.setLastVisible());
  }
  setPivotSectionVisible(e) {
    var n;
    const t = this.colToolPanelFactory;
    t && (this.pivotDropZonePanel = t.setPanelVisible(
      this.pivotDropZonePanel,
      e,
      t.createPivotPanel.bind(t, this, this.childDestroyFuncs)
    ), (n = this.pivotDropZonePanel) == null || n.setDisplayed(e), this.setLastVisible());
  }
  setResizers() {
    [this.primaryColsPanel, this.rowGroupDropZonePanel, this.valuesDropZonePanel, this.pivotDropZonePanel].forEach(
      (e) => {
        if (!e)
          return;
        const t = e.getGui();
        e.toggleResizable(
          !t.classList.contains("ag-last-column-drop") && !t.classList.contains("ag-hidden")
        );
      }
    );
  }
  setLastVisible() {
    const e = this.getGui();
    Array.prototype.slice.call(e.querySelectorAll(".ag-column-drop")).forEach((s) => s.classList.remove("ag-last-column-drop"));
    const n = e.querySelectorAll(".ag-column-drop:not(.ag-hidden)"), o = Je(n);
    o && o.classList.add("ag-last-column-drop"), this.setResizers();
  }
  resetChildrenHeight() {
    const t = this.getGui().children;
    for (let n = 0; n < t.length; n++) {
      const { style: o } = t[n];
      o.removeProperty("height"), o.removeProperty("flex");
    }
  }
  expandColumnGroups(e) {
    this.primaryColsPanel.expandGroups(e);
  }
  collapseColumnGroups(e) {
    this.primaryColsPanel.collapseGroups(e);
  }
  setColumnLayout(e) {
    this.primaryColsPanel.setColumnLayout(e);
  }
  syncLayoutWithGrid() {
    this.primaryColsPanel.syncLayoutWithGrid();
  }
  destroyChildren() {
    const e = this.childDestroyFuncs;
    e.forEach((t) => t()), e.length = 0, ht(this.getGui());
  }
  refresh(e) {
    return this.destroyChildren(), this.init(e), !0;
  }
  getState() {
    return {
      expandedGroupIds: this.primaryColsPanel.getExpandedGroups()
    };
  }
  destroy() {
    this.destroyChildren(), super.destroy();
  }
}, bN = (
  /*css*/
  ".ag-column-drop{align-items:center;display:inline-flex;overflow:auto;position:relative;width:100%}.ag-column-drop-list{align-items:center;display:flex}.ag-column-drop-cell{align-items:center;background-color:var(--ag-column-drop-cell-background-color);border:var(--ag-column-drop-cell-border);border-radius:500px;color:var(--ag-column-drop-cell-text-color);display:flex;padding:calc(var(--ag-spacing)*.25);position:relative;&:focus-visible{box-shadow:var(--ag-focus-shadow)}:where(.ag-drag-handle){color:var(--ag-column-drop-cell-drag-handle-color)}}:where(.ag-ltr) .ag-column-drop-cell{padding-left:calc(var(--ag-spacing)*.75)}:where(.ag-rtl) .ag-column-drop-cell{padding-right:calc(var(--ag-spacing)*.75)}.ag-column-drop-cell-text{flex:1 1 auto;margin:0 var(--ag-spacing);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{align-items:stretch;display:flex;flex-direction:column;min-height:75px;overflow:hidden}.ag-column-drop-vertical-title-bar{align-items:center;display:flex;flex:none;padding:var(--ag-widget-container-vertical-padding) calc(var(--ag-spacing)*2) 0}.ag-column-drop-vertical-list{align-items:stretch;flex-direction:column;flex-grow:1;overflow-x:auto;padding-bottom:var(--ag-spacing);padding-left:var(--ag-spacing);padding-right:var(--ag-spacing);position:relative;>*{flex:none}}:where(.ag-column-drop-empty) .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-cell-button{cursor:pointer;min-width:0;opacity:.75;&:hover{opacity:1}}:where(.ag-ltr) .ag-column-drop-cell-button{margin-right:calc(var(--ag-spacing)/4)}:where(.ag-rtl) .ag-column-drop-cell-button{margin-left:calc(var(--ag-spacing)/4)}:where(.ag-ltr) .ag-column-drop-cell-drag-handle{margin-left:calc(var(--ag-spacing)/4)}:where(.ag-rtl) .ag-column-drop-cell-drag-handle{margin-right:calc(var(--ag-spacing)/4)}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{width:50%!important}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;white-space:nowrap}:where(.ag-ltr) .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-column-drop-horizontal-list{gap:var(--ag-cell-widget-spacing)}.ag-column-drop-vertical-cell{margin-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-icon{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-icon{margin-left:var(--ag-widget-horizontal-spacing)}.ag-select-agg-func-popup{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);height:calc(var(--ag-spacing)*5*3.5);padding:0;position:absolute}.ag-select-agg-func-virtual-list-item{cursor:default;&:hover{background-color:var(--ag-selected-row-background-color)}}:where(.ag-ltr) .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-left:solid var(--ag-border-width) var(--ag-border-color)}"
);
function F0(e, t, n) {
  e == null || t == null || e.splice(n, 0, ...t);
}
var SN = { tag: "div", cls: "ag-unselectable", role: "presentation" }, xN = class extends Te {
  constructor(e) {
    super(SN), this.horizontal = e, this.state = "notDragging", this.guiDestroyFunctions = [], this.childPillComponents = [], this.resizeEnabled = !1, this.addElementClasses(this.getGui()), this.ePillDropList = Ue({ tag: "div" }), this.addElementClasses(this.ePillDropList, "list"), this.registerCSS(bN);
  }
  toggleResizable(e) {
    this.positionableFeature.setResizable(e ? { bottom: !0 } : !1), this.resizeEnabled = e;
  }
  isSourceEventFromTarget(e) {
    const { dropZoneTarget: t, dragSource: n } = e;
    return t.contains(n.eElement);
  }
  destroy() {
    this.destroyGui(), super.destroy();
  }
  destroyGui() {
    this.guiDestroyFunctions.forEach((e) => e()), this.guiDestroyFunctions.length = 0, this.childPillComponents.length = 0, ht(this.getGui()), ht(this.ePillDropList);
  }
  init(e) {
    this.params = e ?? {}, this.createManagedBean(
      new Hs(this.getFocusableElement(), {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.onKeyDown.bind(this)
      })
    ), this.setupDropTarget(), this.positionableFeature = new Sc(this.getGui()), this.createManagedBean(this.positionableFeature), this.refreshGui(), yt(this.ePillDropList, this.getAriaLabel());
  }
  onTabKeyDown(e) {
    const t = Ko(this.getFocusableElement(), null, !0), n = t.length;
    if (n === 0)
      return;
    const { shiftKey: o } = e, s = je(this.beans), i = s === t[0], r = s === Je(t);
    n === 1 || i && o || r && !o || t[o ? 0 : n - 1].focus();
  }
  onKeyDown(e) {
    const { key: t } = e, n = !this.horizontal;
    let o = t === O.DOWN, s = t === O.UP;
    if (!n) {
      const i = this.gos.get("enableRtl");
      o = !i && t === O.RIGHT || i && t === O.LEFT, s = !i && t === O.LEFT || i && t === O.RIGHT;
    }
    if (!(!o && !s))
      if (e.preventDefault(), e.shiftKey)
        this.moveFocusedItem(s);
      else {
        const i = sn(this.beans, this.getFocusableElement(), !1, s);
        i && i.focus();
      }
  }
  moveFocusedItem(e) {
    const t = this.getFocusedItem();
    if (t === -1)
      return;
    const n = e ? -1 : 1;
    if (!this.normalizeAndUpdateInsertIndex(t, t + n))
      return;
    const s = this.childPillComponents[t];
    if (!s.isMovable())
      return;
    const i = s.getItem();
    this.focusItemAtIndex(this.insertIndex), this.rearrangeItems([i], !0);
  }
  addElementClasses(e, t) {
    t = t ? `-${t}` : "";
    const n = this.horizontal ? "horizontal" : "vertical";
    e.classList.add(`ag-column-drop${t}`, `ag-column-drop-${n}${t}`);
  }
  setupDropTarget() {
    var e;
    this.dropTarget = {
      getContainer: this.getGui.bind(this),
      getIconName: this.getIconName.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragEnter: this.onDragEnter.bind(this),
      onDragLeave: this.onDragLeave.bind(this),
      onDragStop: this.onDragStop.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      isInterestedIn: this.isInterestedIn.bind(this)
    }, (e = this.beans.dragAndDrop) == null || e.addDropTarget(this.dropTarget);
  }
  minimumAllowedNewInsertIndex() {
    return 0;
  }
  checkInsertIndex(e) {
    const t = this.getNewInsertIndex(e);
    return t < 0 ? !1 : this.normalizeAndUpdateInsertIndex(this.insertIndex, t);
  }
  normalizeAndUpdateInsertIndex(e, t) {
    const n = this.minimumAllowedNewInsertIndex(), o = Math.max(n, t), s = o !== e;
    return s && (this.insertIndex = o), s;
  }
  getNewInsertIndex(e) {
    const t = e.event, n = this.horizontal ? t.clientX : t.clientY, o = this.childPillComponents.map((i) => i.getGui().getBoundingClientRect()), s = o.findIndex(
      (i) => this.horizontal ? i.right > n && i.left < n : i.top < n && i.bottom > n
    );
    if (s === -1) {
      const i = this.gos.get("enableRtl");
      return o.every((l) => n > (this.horizontal ? l.right : l.bottom)) ? i && this.horizontal ? 0 : this.childPillComponents.length : o.every((l) => n < (this.horizontal ? l.left : l.top)) ? i && this.horizontal ? this.childPillComponents.length : 0 : this.insertIndex;
    }
    return this.insertIndex <= s ? s + 1 : s;
  }
  checkDragStartedBySelf(e) {
    this.state === "notDragging" && (this.state = "rearrangeItems", this.potentialDndItems = this.getItems(e.dragSource.getDragItem()), this.refreshGui(), this.checkInsertIndex(e), this.refreshGui());
  }
  onDragging(e) {
    this.checkDragStartedBySelf(e), this.checkInsertIndex(e) && this.refreshGui();
  }
  handleDragEnterEnd(e) {
  }
  onDragEnter(e) {
    const t = this.getItems(e.dragSource.getDragItem());
    this.state = "newItemsIn";
    const n = t.filter((s) => this.isItemDroppable(s, e)), o = n.every(
      (s) => this.childPillComponents.map((i) => i.getItem()).indexOf(s) !== -1
    );
    if (n.length !== 0) {
      if (this.potentialDndItems = n, o) {
        this.state = "notDragging";
        return;
      }
      this.handleDragEnterEnd(e), this.checkInsertIndex(e), this.refreshGui();
    }
  }
  isPotentialDndItems() {
    var e;
    return !!((e = this.potentialDndItems) != null && e.length);
  }
  handleDragLeaveEnd(e) {
  }
  onDragLeave(e) {
    if (this.state === "rearrangeItems") {
      const t = this.getItems(e.dragSource.getDragItem());
      this.removeItems(t);
    }
    this.isPotentialDndItems() && (this.handleDragLeaveEnd(e), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  onDragCancel(e) {
    this.isPotentialDndItems() && (this.state === "newItemsIn" && this.handleDragLeaveEnd(e), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  onDragStop() {
    this.isPotentialDndItems() && (this.state === "newItemsIn" ? this.addItems(this.potentialDndItems) : this.rearrangeItems(this.potentialDndItems), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  removeItems(e) {
    const t = this.getExistingItems().filter((n) => !e.includes(n));
    this.updateItems(t);
  }
  addItems(e) {
    if (!e)
      return;
    const t = this.getExistingItems().slice(), n = e.filter((o) => t.indexOf(o) < 0);
    F0(t, n, this.insertIndex), this.updateItems(t);
  }
  addItem(e) {
    this.insertIndex = this.getExistingItems().length, this.addItems([e]), this.refreshGui();
  }
  rearrangeItems(e, t) {
    let n;
    return t ? n = this.getExistingItems().filter((o) => e.indexOf(o) === -1) : n = this.getNonGhostItems().slice(), F0(n, e, this.insertIndex), Yn(n, this.getExistingItems()) ? !1 : (this.updateItems(n), !0);
  }
  refreshGui() {
    let e = 0;
    this.horizontal || (e = this.ePillDropList.scrollTop);
    const t = this.resizeEnabled, n = this.getFocusedItem(), { eGridDiv: o } = this.beans, s = mc();
    let i = null;
    s && (i = sn(this.beans, o) ?? sn(this.beans, o, !1, !0)), this.toggleResizable(!1), this.destroyGui(), this.addIconAndTitleToGui(), this.addEmptyMessageToGui(), this.addItemsToGui(), e !== 0 && (this.ePillDropList.scrollTop = e), t && this.toggleResizable(t), s && this.restoreFocus(n, i);
  }
  getFocusedItem() {
    const e = this.getGui(), t = je(this.beans);
    return e.contains(t) ? Array.from(e.querySelectorAll(".ag-column-drop-cell")).indexOf(t) : -1;
  }
  focusItemAtIndex(e) {
    const t = this.getGui(), o = Array.from(t.querySelectorAll(".ag-column-drop-cell"))[e];
    o && o.focus({ preventScroll: !0 });
  }
  restoreFocus(e, t) {
    const n = this.getGui(), o = Array.from(n.querySelectorAll(".ag-column-drop-cell"));
    if (e === -1)
      return;
    o.length === 0 && t.focus();
    const s = Math.min(o.length - 1, e), i = o[s];
    i && i.focus();
  }
  focusList(e) {
    const t = e ? this.childPillComponents.length - 1 : 0;
    this.restoreFocus(t, this.getFocusableElement());
  }
  getNonGhostItems() {
    const e = this.getExistingItems();
    return this.isPotentialDndItems() ? e.filter((t) => !this.potentialDndItems.includes(t)) : e;
  }
  addItemsToGui() {
    const t = this.getNonGhostItems().map((n) => this.createItemComponent(n, !1));
    if (this.isPotentialDndItems()) {
      const n = this.potentialDndItems.map((o) => this.createItemComponent(o, !0));
      this.insertIndex >= t.length ? t.push(...n) : t.splice(this.insertIndex, 0, ...n);
    }
    this.appendChild(this.ePillDropList), t.forEach((n, o) => {
      o > 0 && this.addArrow(this.ePillDropList), this.ePillDropList.appendChild(n.getGui());
    }), this.addAriaLabelsToComponents();
  }
  addAriaLabelsToComponents() {
    const { childPillComponents: e, ePillDropList: t } = this, n = e.length;
    hn(t, n === 0 ? "presentation" : "listbox");
    for (let o = 0; o < n; o++) {
      const i = e[o].getGui();
      lc(i, o + 1), ac(i, n);
    }
  }
  createItemComponent(e, t) {
    const n = this.createPillComponent(e, this.dropTarget, t, this.horizontal);
    return n.addEventListener("columnRemove", this.removeItems.bind(this, [e])), this.createBean(n), this.guiDestroyFunctions.push(() => this.destroyBean(n)), t || this.childPillComponents.push(n), n;
  }
  addIconAndTitleToGui() {
    const { title: e, icon: t } = this.params;
    if (!e || !t)
      return;
    const n = Ue({ tag: "div" });
    if (Ng(n, !0), this.addElementClasses(n, "title-bar"), this.addElementClasses(t, "icon"), this.toggleCss("ag-column-drop-empty", this.isExistingItemsEmpty()), n.appendChild(t), !this.horizontal) {
      const o = Ue({ tag: "span" });
      this.addElementClasses(o, "title"), o.textContent = e, n.appendChild(o);
    }
    this.appendChild(n);
  }
  isExistingItemsEmpty() {
    return this.getExistingItems().length === 0;
  }
  addEmptyMessageToGui() {
    const { emptyMessage: e } = this.params;
    if (!e || !this.isExistingItemsEmpty() || this.isPotentialDndItems())
      return;
    const t = Ue({ tag: "span" });
    t.textContent = e, this.addElementClasses(t, "empty-message"), this.ePillDropList.appendChild(t);
  }
  addArrow(e) {
    if (this.horizontal) {
      const t = this.gos.get("enableRtl"), n = Le(t ? "panelDelimiterRtl" : "panelDelimiter", this.beans);
      this.addElementClasses(n, "cell-separator"), e.appendChild(n);
    }
  }
}, RN = {
  tag: "span",
  role: "option",
  children: [
    {
      tag: "span",
      ref: "eDragHandle",
      cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
      role: "presentation"
    },
    { tag: "span", ref: "eText", cls: "ag-column-drop-cell-text", attrs: { "aria-hidden": "true" } },
    { tag: "span", ref: "eButton", cls: "ag-column-drop-cell-button", role: "presentation" }
  ]
}, EN = class extends Te {
  constructor(e, t, n, o, s) {
    super(), this.dragSourceDropTarget = e, this.ghost = t, this.horizontal = n, this.template = o, this.agComponents = s, this.eText = X, this.eDragHandle = X, this.eButton = X;
  }
  postConstruct() {
    this.setTemplate(this.template ?? RN, this.agComponents);
    const e = this.getGui(), { beans: t, eDragHandle: n, eText: o, eButton: s } = this;
    this.addElementClasses(e), this.addElementClasses(n, "drag-handle"), this.addElementClasses(o, "text"), this.addElementClasses(s, "button"), n.appendChild(Le("columnDrag", t)), s.appendChild(Le("cancel", t)), this.tooltipFeature = this.createOptionalManagedBean(
      t.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui()
      })
    ), this.setupComponents(), !this.ghost && this.isDraggable() && this.addDragSource(), this.setupAria(), this.setupTooltip(), this.activateTabIndex(), this.refreshDraggable();
  }
  isDraggable() {
    return !0;
  }
  refreshDraggable() {
    this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
  }
  setupAria() {
    const e = this.getLocaleTextFunc(), t = [this.getAriaDisplayName()];
    this.addAdditionalAriaInstructions(t, e), yt(this.getGui(), t.join(". "));
  }
  addAdditionalAriaInstructions(e, t) {
    if (this.isRemovable()) {
      const n = t("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
      e.push(n);
    }
  }
  setupTooltip() {
    const e = () => {
      var t;
      return (t = this.tooltipFeature) == null ? void 0 : t.setTooltipAndRefresh(this.getTooltip());
    };
    e(), this.addManagedEventListeners({ newColumnsLoaded: e });
  }
  getDragSourceId() {
  }
  getDefaultIconName() {
    return "notAllowed";
  }
  addDragSource() {
    const {
      beans: { dragAndDrop: e },
      eDragHandle: t
    } = this, n = this.createGetDragItem(), o = this.getDefaultIconName(), s = {
      type: this.getDragSourceType(),
      sourceId: this.getDragSourceId(),
      eElement: t,
      getDefaultIconName: () => o,
      getDragItem: n,
      dragItemName: this.getDisplayName()
    };
    e == null || e.addDragSource(s, !0), this.addDestroyFunc(() => e == null ? void 0 : e.removeDragSource(s));
  }
  setupComponents() {
    this.eText.textContent = this.getDisplayValue(), this.setupRemove(), this.ghost && this.addCss("ag-column-drop-cell-ghost");
  }
  isRemovable() {
    return !0;
  }
  refreshRemove() {
    He(this.eButton, this.isRemovable());
  }
  setupRemove() {
    this.refreshRemove();
    const e = { type: "columnRemove" };
    this.addGuiEventListener("keydown", (n) => this.onKeyDown(n)), this.addManagedElementListeners(this.eButton, {
      click: (n) => {
        this.dispatchLocalEvent(e), n.stopPropagation();
      }
    });
    const t = new No(this.eButton);
    this.addManagedListeners(t, {
      tap: () => this.dispatchLocalEvent(e)
    }), this.addDestroyFunc(t.destroy.bind(t));
  }
  onKeyDown(e) {
    e.key === O.DELETE && this.isRemovable() && (e.preventDefault(), this.dispatchLocalEvent({ type: "columnRemove" }));
  }
  getDisplayValue() {
    return this.getDisplayName();
  }
  addElementClasses(e, t) {
    t = t ? `-${t}` : "";
    const n = this.horizontal ? "horizontal" : "vertical";
    e.classList.add(`ag-column-drop-cell${t}`, `ag-column-drop-${n}-cell${t}`);
  }
  destroy() {
    super.destroy(), this.dragSourceDropTarget = null;
  }
}, AN = class extends EN {
  constructor(e, t, n, o, s) {
    super(t, n, s), this.column = e, this.dropZonePurpose = o, this.eSortIndicator = X, this.popupShowing = !1;
  }
  postConstruct() {
    const { sortSvc: e, colNames: t } = this.beans;
    this.template = {
      tag: "span",
      role: "option",
      children: [
        {
          tag: "span",
          ref: "eDragHandle",
          cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
          role: "presentation"
        },
        { tag: "span", ref: "eText", cls: "ag-column-drop-cell-text", attrs: { "aria-hidden": "true" } },
        e ? { tag: "ag-sort-indicator", ref: "eSortIndicator" } : void 0,
        { tag: "span", ref: "eButton", cls: "ag-column-drop-cell-button", role: "presentation" }
      ]
    }, e && (this.agComponents = [e.getSortIndicatorSelector()]), this.displayName = t.getDisplayNameForColumn(this.column, "columnDrop"), super.postConstruct(), e && (this.setupSort(), this.addManagedEventListeners({
      sortChanged: () => {
        this.setupAria();
      }
    })), this.isGroupingZone() && this.addManagedPropertyListener("groupLockGroupColumns", () => {
      this.refreshRemove(), this.refreshDraggable(), this.setupAria();
    });
  }
  getItem() {
    return this.column;
  }
  getDisplayName() {
    return this.displayName;
  }
  getTooltip() {
    return this.column.getColDef().headerTooltip;
  }
  addAdditionalAriaInstructions(e, t) {
    const n = this.gos.get("rowGroupPanelSuppressSort"), o = this.gos.get("functionsReadOnly");
    if (this.isAggregationZone() && !o) {
      const s = t(
        "ariaDropZoneColumnValueItemDescription",
        "Press ENTER to change the aggregation type"
      );
      e.push(s);
    }
    if (this.isGroupingZone() && this.column.isSortable() && !n) {
      const s = t("ariaDropZoneColumnGroupItemDescription", "Press ENTER to sort");
      e.push(s);
    }
    super.addAdditionalAriaInstructions(e, t);
  }
  isMovable() {
    return this.isDraggable();
  }
  isDraggable() {
    return this.isReadOnly();
  }
  isRemovable() {
    return this.isReadOnly();
  }
  isReadOnly() {
    return !this.isGroupingAndLocked() && !this.gos.get("functionsReadOnly");
  }
  getAriaDisplayName() {
    const e = this.getLocaleTextFunc(), { name: t, aggFuncName: n } = this.getColumnAndAggFuncName(), o = e("ariaDropZoneColumnComponentAggFuncSeparator", " of "), s = {
      asc: e("ariaDropZoneColumnComponentSortAscending", "ascending"),
      desc: e("ariaDropZoneColumnComponentSortDescending", "descending")
    }, i = this.column.getSort(), r = this.gos.get("rowGroupPanelSuppressSort");
    return [
      n && `${n}${o}`,
      t,
      this.isGroupingZone() && !r && i && `, ${s[i]}`
    ].filter((a) => !!a).join("");
  }
  getColumnAndAggFuncName() {
    const e = this.displayName;
    let t = "";
    if (this.isAggregationZone()) {
      const n = this.column.getAggFunc(), o = typeof n == "string" ? n : "agg";
      t = this.getLocaleTextFunc()(o, o);
    }
    return { name: e, aggFuncName: t };
  }
  setupSort() {
    if (!(!this.column.isSortable() || !this.isGroupingZone()) && !this.gos.get("rowGroupPanelSuppressSort")) {
      this.eSortIndicator.setupSort(this.column, !0);
      const e = (t) => {
        t.preventDefault(), this.beans.sortSvc.progressSortFromEvent(this.column, t);
      };
      this.addGuiEventListener("click", e), this.addGuiEventListener("keydown", (t) => {
        t.key === O.ENTER && this.isGroupingZone() && e(t);
      });
    }
  }
  getDefaultIconName() {
    return "hide";
  }
  createGetDragItem() {
    const { column: e } = this;
    return () => {
      const t = {};
      return t[e.getId()] = e.isVisible(), {
        columns: [e],
        visibleState: t
      };
    };
  }
  setupComponents() {
    super.setupComponents(), this.isAggregationZone() && !this.gos.get("functionsReadOnly") && this.addGuiEventListener("click", this.onShowAggFuncSelection.bind(this));
  }
  onKeyDown(e) {
    super.onKeyDown(e), e.key === O.ENTER && this.isAggregationZone() && !this.gos.get("functionsReadOnly") && (e.preventDefault(), this.onShowAggFuncSelection());
  }
  getDisplayValue() {
    const { name: e, aggFuncName: t } = this.getColumnAndAggFuncName();
    return this.isAggregationZone() ? `${t}(${e})` : e;
  }
  onShowAggFuncSelection() {
    if (this.popupShowing)
      return;
    this.popupShowing = !0;
    const { aggFuncSvc: e, popupSvc: t } = this.beans, n = new Lr({ cssIdentifier: "select-agg-func" }), o = e.getFuncNames(this.column), s = this.getGui(), i = n.getGui();
    n.setModel({
      getRow: function(h) {
        return o[h];
      },
      getRowCount: function() {
        return o.length;
      }
    }), this.createBean(n);
    const r = Ue({ tag: "div", cls: "ag-select-agg-func-popup" });
    r.style.top = "0px", r.style.left = "0px", r.appendChild(i), r.style.width = `${s.clientWidth}px`;
    const [a] = this.addManagedElementListeners(r, {
      focusout: (h) => {
        !r.contains(h.relatedTarget) && c && c.hideFunc();
      }
    }), l = (h) => {
      this.destroyBean(n), this.popupShowing = !1, (h == null ? void 0 : h.key) === "Escape" && s.focus(), a && a();
    }, d = this.getLocaleTextFunc(), c = t.addPopup({
      modal: !0,
      eChild: r,
      closeOnEsc: !0,
      closedCallback: l,
      ariaLabel: d("ariaLabelAggregationFunction", "Aggregation Function")
    });
    c && n.setComponentCreator(this.createAggSelect.bind(this, c.hideFunc)), n.addGuiEventListener("keydown", (h) => {
      if (h.key === O.ENTER || h.key === O.SPACE) {
        const g = n.getLastFocusedRow();
        if (g == null)
          return;
        const p = n.getComponentAt(g);
        p && p.selectItem();
      }
    }), t.positionPopupByComponent({
      type: "aggFuncSelect",
      eventSource: s,
      ePopup: r,
      keepWithinBounds: !0,
      column: this.column,
      position: "under"
    }), n.refresh();
    let u = o.findIndex((h) => h === this.column.getAggFunc());
    u === -1 && (u = 0), n.focusRow(u);
  }
  createAggSelect(e, t) {
    const n = () => {
      var a, l;
      e(), this.getGui().focus(), (l = (a = this.beans.valueColsSvc) == null ? void 0 : a.setColumnAggFunc) == null || l.call(a, this.column, t, "toolPanelDragAndDrop");
    }, o = this.getLocaleTextFunc(), s = t.toString(), i = o(s, s);
    return new FN(n, i);
  }
  isGroupingAndLocked() {
    return this.isGroupingZone() && Ha(this.column, this.beans);
  }
  isAggregationZone() {
    return this.dropZonePurpose === "aggregation";
  }
  isGroupingZone() {
    return this.dropZonePurpose === "rowGroup";
  }
  getDragSourceType() {
    return ns.ToolPanel;
  }
  destroy() {
    super.destroy(), this.column = null;
  }
}, FN = class extends Te {
  constructor(e, t) {
    super({ tag: "div", cls: "ag-select-agg-func-item", children: t }), this.selectItem = e, this.addGuiEventListener("click", this.selectItem);
  }
}, jp = class extends xN {
  constructor(e, t) {
    super(e), this.dropZonePurpose = t, this.addElementClasses(this.getGui(), this.dropZonePurpose.toLowerCase());
  }
  init(e) {
    super.init(e), this.addManagedEventListeners({ newColumnsLoaded: this.refreshGui.bind(this) }), this.addManagedPropertyListeners(
      ["functionsReadOnly", "rowGroupPanelSuppressSort", "groupLockGroupColumns"],
      this.refreshGui.bind(this)
    );
  }
  getItems(e) {
    return e.columns ?? [];
  }
  isInterestedIn(e) {
    return e === ns.HeaderCell || e === ns.ToolPanel;
  }
  minimumAllowedNewInsertIndex() {
    const { gos: e, rowGroupColsSvc: t } = this.beans, n = e.get("groupLockGroupColumns"), o = (t == null ? void 0 : t.columns.length) ?? 0;
    return n === -1 ? o : Math.min(n, o);
  }
  showOrHideColumnOnExit(e) {
    return this.isRowGroupPanel() && kC(this.gos, !0) && !e.fromNudge;
  }
  handleDragEnterEnd(e) {
    if (this.showOrHideColumnOnExit(e)) {
      const o = e.dragSource.getDragItem().columns;
      this.setColumnsVisible(o, !1, "uiColumnDragged");
    }
  }
  handleDragLeaveEnd(e) {
    if (this.showOrHideColumnOnExit(e)) {
      const n = e.dragSource.getDragItem();
      this.setColumnsVisible(n.columns, !0, "uiColumnDragged");
    }
  }
  setColumnsVisible(e, t, n) {
    if (e) {
      const o = e.filter((s) => !s.getColDef().lockVisible);
      this.beans.colModel.setColsVisible(o, t, n);
    }
  }
  isRowGroupPanel() {
    return this.dropZonePurpose === "rowGroup";
  }
  createPillComponent(e, t, n, o) {
    return new AN(e, t, n, this.dropZonePurpose, o);
  }
}, zb = class extends jp {
  constructor(e) {
    super(e, "pivot");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("pivotColumnsEmptyMessage", "Drag here to set column labels"), n = e("pivots", "Column Labels");
    super.init({
      icon: Le("pivotPanel", this.beans, null),
      emptyMessage: t,
      title: n
    }), this.addManagedEventListeners({
      newColumnsLoaded: this.refresh.bind(this),
      columnPivotChanged: this.refresh.bind(this),
      columnPivotModeChanged: this.checkVisibility.bind(this)
    }), this.refresh();
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaPivotDropZonePanelLabel", "Column Labels");
  }
  refresh() {
    this.checkVisibility(), this.refreshGui();
  }
  checkVisibility() {
    const e = this.beans.colModel, t = e.isPivotMode();
    if (this.horizontal)
      switch (this.gos.get("pivotPanelShow")) {
        case "always":
          this.setDisplayed(t);
          break;
        case "onlyWhenPivoting": {
          const n = e.isPivotActive();
          this.setDisplayed(t && n);
          break;
        }
        default:
          this.setDisplayed(!1);
          break;
      }
    else
      this.setDisplayed(t);
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowPivot() && (!e.isPivotActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.pivotColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "pivot" : "notAllowed";
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.pivotColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, Wb = class extends jp {
  constructor(e) {
    super(e, "rowGroup");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("rowGroupColumnsEmptyMessage", "Drag here to set row groups"), n = e("groups", "Row Groups");
    super.init({
      icon: Le("rowGroupPanel", this.beans, null),
      emptyMessage: t,
      title: n
    }), this.addManagedEventListeners({ columnRowGroupChanged: this.refreshGui.bind(this) });
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaRowGroupDropZonePanelLabel", "Row Groups");
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() || e.colDef.showRowGroup ? !1 : e.isAllowRowGroup() && (!e.isRowGroupActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.rowGroupColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "group" : "notAllowed";
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.rowGroupColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, MN = class extends jp {
  constructor(e) {
    super(e, "aggregation");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("valueColumnsEmptyMessage", "Drag here to aggregate"), n = e("values", "Values");
    super.init({
      icon: Le("valuePanel", this.beans, null),
      emptyMessage: t,
      title: n
    }), this.addManagedEventListeners({ columnValueChanged: this.refreshGui.bind(this) });
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaValuesDropZonePanelLabel", "Values");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "aggregate" : "notAllowed";
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowValue() && (!e.isValueActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.valueColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.valueColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, IN = {
  tag: "div",
  cls: "ag-pivot-mode-panel",
  children: [
    {
      tag: "ag-toggle-button",
      ref: "cbPivotMode",
      cls: "ag-pivot-mode-select"
    }
  ]
}, PN = class extends Te {
  constructor() {
    super(...arguments), this.cbPivotMode = X;
  }
  postConstruct() {
    this.setTemplate(IN, [lM]);
    const e = this.cbPivotMode, { colModel: t, ctrlsSvc: n, gos: o } = this.beans;
    e.setValue(t.isPivotMode());
    const s = this.getLocaleTextFunc();
    e.setLabel(s("pivotMode", "Pivot Mode"));
    const i = () => {
      const a = !!e.getValue();
      a !== t.isPivotMode() && (o.updateGridOptions({ options: { pivotMode: a }, source: "toolPanelUi" }), n.getHeaderRowContainerCtrls().forEach((l) => l.refresh()));
    }, r = () => {
      const a = t.isPivotMode();
      e.setValue(a);
    };
    this.addManagedListeners(e, { fieldValueChanged: i }), this.addManagedEventListeners({
      newColumnsLoaded: r,
      columnPivotModeChanged: r
    });
  }
}, DN = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colToolPanelFactory";
  }
  setPanelVisible(e, t, n) {
    return e ? e.setDisplayed(t) : t && (e = n()), e;
  }
  createRowGroupPanel(e, t) {
    return this.createPanel(e, t, new Wb(!1));
  }
  createValuesPanel(e, t) {
    return this.createPanel(e, t, new MN(!1));
  }
  createPivotPanel(e, t) {
    return this.createPanel(e, t, new zb(!1));
  }
  createPivotModePanel(e, t, n) {
    return this.createPanel(e, t, new PN(), n);
  }
  createPanel(e, t, n, o) {
    return n = e.createBean(n), t.push(() => e.destroyBean(n)), o ? e.prependChild(n) : e.appendChild(n), n;
  }
}, TN = {
  moduleName: "ColumnsToolPanel",
  version: gt,
  beans: [DN],
  userComponents: { agColumnsToolPanel: yN },
  icons: {
    ensureColumnVisible: "column-arrow",
    // column tool panel tab
    columnsToolPanel: "columns",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // columns tool panel Values drop zone
    valuePanel: "aggregation",
    // column tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // column tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate"
  },
  dependsOn: [
    an,
    __,
    Ip,
    sl,
    Vs,
    kb
  ]
}, kN = class extends U {
  constructor() {
    super(...arguments), this.beanName = "chartMenuItemMapper";
  }
  getChartItems(e) {
    var d, c;
    const t = this.beans, n = t.chartSvc, o = e === "pivotChart";
    if (!n)
      return null;
    const s = this.getLocaleTextFunc.bind(this), i = o ? new LN(t, n, s) : new BN(t, n, s), r = n.isEnterprise();
    let a = i.getMenuItem();
    if (a && a.subMenu && !r) {
      const u = (h) => {
        var g;
        return {
          ...h,
          subMenu: (g = h.subMenu) == null ? void 0 : g.filter((p) => !p._enterprise).map((p) => u(p))
        };
      };
      a = u(a);
    }
    const l = (c = (d = this.gos.get("chartToolPanelsDef")) == null ? void 0 : d.settingsPanel) == null ? void 0 : c.chartGroupsDef;
    return l && (a = this.filterAndOrderChartMenu(
      a,
      l,
      i.getConfigLookup()
    )), this.cleanInternals(a);
  }
  // Remove our internal _key and _enterprise properties so this does not leak out of the class on the menu items.
  cleanInternals(e) {
    if (!e)
      return e;
    const t = (n) => {
      var o;
      return n == null || delete n._key, n == null || delete n._enterprise, (o = n == null ? void 0 : n.subMenu) == null || o.forEach((s) => t(s)), n;
    };
    return t(e);
  }
  buildLookup(e) {
    const t = {}, n = (o) => {
      t[o._key] = o, o.subMenu && o.subMenu.forEach((s) => n(s));
    };
    return n(e), t;
  }
  /**
   * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
   */
  filterAndOrderChartMenu(e, t, n) {
    var i, r, a;
    const o = this.buildLookup(e), s = { ...e, subMenu: [] };
    for (const l of Object.keys(t)) {
      const d = t[l], c = n[l];
      if (c === null)
        continue;
      if (c == null) {
        Z(173, { group: l });
        continue;
      }
      const u = o[c._key];
      if (u)
        if (u.subMenu) {
          const h = d.map((g) => {
            const p = c[g];
            if (p == null) {
              Z(174, { group: l, chartType: g });
              return;
            }
            return o[p];
          }).filter((g) => g !== void 0);
          h.length > 0 && (u.subMenu = h, (i = s.subMenu) == null || i.push(u));
        } else
          (r = s.subMenu) == null || r.push(u);
    }
    return ((a = s.subMenu) == null ? void 0 : a.length) == 0 ? null : s;
  }
}, LN = class {
  constructor(e, t, n) {
    this.beans = e, this.chartSvc = t, this.getLocaleTextFunc = n;
  }
  getMenuItem() {
    const e = this.getLocaleTextFunc(), t = (n, o, s, i, r = !1) => ({
      // will have a LRM character appended to ensure correct display in RTL languages
      name: e(n, o + "‎"),
      action: () => this.chartSvc.createPivotChart({ chartType: s }),
      _key: i,
      _enterprise: r
    });
    return {
      name: e("pivotChart", "Pivot Chart"),
      _key: "pivotChart",
      subMenu: [
        {
          _key: "pivotColumnChart",
          name: e("columnChart", "Column"),
          subMenu: [
            t("groupedColumn", "Grouped", "groupedColumn", "pivotGroupedColumn"),
            t("stackedColumn", "Stacked", "stackedColumn", "pivotStackedColumn"),
            t("normalizedColumn", "100% Stacked", "normalizedColumn", "pivotNormalizedColumn")
          ]
        },
        {
          _key: "pivotBarChart",
          name: e("barChart", "Bar"),
          subMenu: [
            t("groupedBar", "Grouped", "groupedBar", "pivotGroupedBar"),
            t("stackedBar", "Stacked", "stackedBar", "pivotStackedBar"),
            t("normalizedBar", "100% Stacked", "normalizedBar", "pivotNormalizedBar")
          ]
        },
        {
          _key: "pivotPieChart",
          name: e("pieChart", "Pie"),
          subMenu: [
            t("pie", "Pie", "pie", "pivotPie"),
            t("donut", "Donut", "donut", "pivotDonut")
          ]
        },
        {
          _key: "pivotLineChart",
          name: e("lineChart", "Line"),
          subMenu: [
            t("lineChart", "Line", "line", "pivotLineChart"),
            t("stackedLine", "Stacked", "stackedLine", "pivotStackedLine"),
            t("normalizedLine", "100% Stacked", "normalizedLine", "pivotNormalizedLine")
          ]
        },
        {
          _key: "pivotAreaChart",
          name: e("areaChart", "Area"),
          subMenu: [
            t("areaChart", "Area", "area", "pivotArea"),
            t("stackedArea", "Stacked", "stackedArea", "pivotStackedArea"),
            t("normalizedArea", "100% Stacked", "normalizedArea", "pivotNormalizedArea")
          ]
        },
        {
          _key: "pivotXYChart",
          name: e("xyChart", "X Y (Scatter)"),
          subMenu: [
            t("scatter", "Scatter", "scatter", "pivotScatter"),
            t("bubble", "Bubble", "bubble", "pivotBubble")
          ]
        },
        {
          _key: "pivotStatisticalChart",
          _enterprise: !1,
          // histogram chart is available in both community and enterprise distributions
          name: e("statisticalChart", "Statistical"),
          subMenu: [t("histogramChart", "Histogram", "histogram", "pivotHistogram", !1)]
        },
        {
          _key: "pivotHierarchicalChart",
          _enterprise: !0,
          name: e("hierarchicalChart", "Hierarchical"),
          subMenu: [
            t("treemapChart", "Treemap", "treemap", "pivotTreemap", !0),
            t("sunburstChart", "Sunburst", "sunburst", "pivotSunburst", !0)
          ]
        },
        {
          _key: "pivotFunnel",
          name: e("funnel", "Funnel"),
          subMenu: [
            t("funnel", "Funnel", "funnel", "pivotFunnel"),
            t("coneFunnel", "Cone Funnel", "coneFunnel", "pivotConeFunnel"),
            t("pyramid", "Pyramid", "pyramid", "pivotPyramid")
          ]
        },
        {
          _key: "pivotCombinationChart",
          name: e("combinationChart", "Combination"),
          subMenu: [
            t("columnLineCombo", "Column & Line", "columnLineCombo", "pivotColumnLineCombo"),
            t("AreaColumnCombo", "Area & Column", "areaColumnCombo", "pivotAreaColumnCombo")
          ]
        }
      ],
      icon: Le("chart", this.beans, void 0)
    };
  }
  getConfigLookup() {
    return {
      columnGroup: {
        _key: "pivotColumnChart",
        column: "pivotGroupedColumn",
        stackedColumn: "pivotStackedColumn",
        normalizedColumn: "pivotNormalizedColumn"
      },
      barGroup: {
        _key: "pivotBarChart",
        bar: "pivotGroupedBar",
        stackedBar: "pivotStackedBar",
        normalizedBar: "pivotNormalizedBar"
      },
      pieGroup: {
        _key: "pivotPieChart",
        pie: "pivotPie",
        donut: "pivotDonut",
        doughnut: "pivotDonut"
      },
      lineGroup: {
        _key: "pivotLineChart",
        line: "pivotLineChart",
        stackedLine: "pivotStackedLine",
        normalizedLine: "pivotNormalizedLine"
      },
      areaGroup: {
        _key: "pivotAreaChart",
        area: "pivotArea",
        stackedArea: "pivotStackedArea",
        normalizedArea: "pivotNormalizedArea"
      },
      scatterGroup: {
        _key: "pivotXYChart",
        bubble: "pivotBubble",
        scatter: "pivotScatter"
      },
      combinationGroup: {
        _key: "pivotCombinationChart",
        columnLineCombo: "pivotColumnLineCombo",
        areaColumnCombo: "pivotAreaColumnCombo",
        customCombo: null
        // Not currently supported
      },
      hierarchicalGroup: {
        _key: "pivotHierarchicalChart",
        treemap: "pivotTreemap",
        sunburst: "pivotSunburst"
      },
      statisticalGroup: {
        _key: "pivotStatisticalChart",
        histogram: "pivotHistogram",
        // Some statistical charts do not currently support pivot mode
        rangeBar: null,
        rangeArea: null,
        boxPlot: null
      },
      funnelGroup: {
        _key: "pivotFunnel",
        funnel: "pivotFunnel",
        coneFunnel: "pivotConeFunnel",
        pyramid: "pivotPyramid"
      },
      // Polar charts do not support pivot mode
      polarGroup: null,
      // Specialized charts do not currently support pivot mode
      specializedGroup: null
    };
  }
}, BN = class {
  constructor(e, t, n) {
    this.beans = e, this.chartSvc = t, this.getLocaleTextFunc = n;
  }
  getMenuItem() {
    const e = this.getLocaleTextFunc(), t = (n, o, s, i, r = !1) => ({
      name: e(n, o),
      action: () => this.chartSvc.createChartFromCurrentRange(s),
      _key: i,
      _enterprise: r
    });
    return {
      name: e("chartRange", "Chart Range"),
      _key: "chartRange",
      subMenu: [
        {
          name: e("columnChart", "Column"),
          subMenu: [
            t("groupedColumn", "Grouped", "groupedColumn", "rangeGroupedColumn"),
            t("stackedColumn", "Stacked", "stackedColumn", "rangeStackedColumn"),
            t("normalizedColumn", "100% Stacked", "normalizedColumn", "rangeNormalizedColumn")
          ],
          _key: "rangeColumnChart"
        },
        {
          name: e("barChart", "Bar"),
          subMenu: [
            t("groupedBar", "Grouped", "groupedBar", "rangeGroupedBar"),
            t("stackedBar", "Stacked", "stackedBar", "rangeStackedBar"),
            t("normalizedBar", "100% Stacked", "normalizedBar", "rangeNormalizedBar")
          ],
          _key: "rangeBarChart"
        },
        {
          name: e("pieChart", "Pie"),
          subMenu: [
            t("pie", "Pie", "pie", "rangePie"),
            t("donut", "Donut", "donut", "rangeDonut")
          ],
          _key: "rangePieChart"
        },
        {
          name: e("lineChart", "Line"),
          subMenu: [
            t("lineChart", "Line", "line", "rangeLineChart"),
            t("stackedLine", "Stacked", "stackedLine", "rangeStackedLine"),
            t("normalizedLine", "100% Stacked", "normalizedLine", "rangeNormalizedLine")
          ],
          _key: "rangeLineChart"
        },
        {
          name: e("areaChart", "Area"),
          subMenu: [
            t("areaChart", "Area", "area", "rangeArea"),
            t("stackedArea", "Stacked", "stackedArea", "rangeStackedArea"),
            t("normalizedArea", "100% Stacked", "normalizedArea", "rangeNormalizedArea")
          ],
          _key: "rangeAreaChart"
        },
        {
          name: e("xyChart", "X Y (Scatter)"),
          subMenu: [
            t("scatter", "Scatter", "scatter", "rangeScatter"),
            t("bubble", "Bubble", "bubble", "rangeBubble")
          ],
          _key: "rangeXYChart"
        },
        {
          name: e("polarChart", "Polar"),
          subMenu: [
            t("radarLine", "Radar Line", "radarLine", "rangeRadarLine"),
            t("radarArea", "Radar Area", "radarArea", "rangeRadarArea"),
            t("nightingale", "Nightingale", "nightingale", "rangeNightingale"),
            t("radialColumn", "Radial Column", "radialColumn", "rangeRadialColumn"),
            t("radialBar", "Radial Bar", "radialBar", "rangeRadialBar")
          ],
          _key: "rangePolarChart",
          _enterprise: !0
        },
        {
          name: e("statisticalChart", "Statistical"),
          subMenu: [
            t("boxPlot", "Box Plot", "boxPlot", "rangeBoxPlot", !0),
            t("histogramChart", "Histogram", "histogram", "rangeHistogram", !1),
            t("rangeBar", "Range Bar", "rangeBar", "rangeRangeBar", !0),
            t("rangeArea", "Range Area", "rangeArea", "rangeRangeArea", !0)
          ],
          _key: "rangeStatisticalChart",
          _enterprise: !1
          // histogram chart is available in both community and enterprise distributions
        },
        {
          name: e("hierarchicalChart", "Hierarchical"),
          subMenu: [
            t("treemap", "Treemap", "treemap", "rangeTreemap"),
            t("sunburst", "Sunburst", "sunburst", "rangeSunburst")
          ],
          _key: "rangeHierarchicalChart",
          _enterprise: !0
        },
        {
          name: e("specializedChart", "Specialized"),
          subMenu: [
            t("heatmap", "Heatmap", "heatmap", "rangeHeatmap"),
            t("waterfall", "Waterfall", "waterfall", "rangeWaterfall")
          ],
          _key: "rangeSpecializedChart",
          _enterprise: !0
        },
        {
          name: e("funnel", "Funnel"),
          subMenu: [
            t("funnel", "Funnel", "funnel", "rangeFunnel"),
            t("coneFunnel", "Cone Funnel", "coneFunnel", "rangeConeFunnel"),
            t("pyramid", "Pyramid", "pyramid", "rangePyramid")
          ],
          _key: "rangeFunnel",
          _enterprise: !0
        },
        {
          name: e("combinationChart", "Combination"),
          subMenu: [
            t("columnLineCombo", "Column & Line", "columnLineCombo", "rangeColumnLineCombo"),
            t("AreaColumnCombo", "Area & Column", "areaColumnCombo", "rangeAreaColumnCombo")
          ],
          _key: "rangeCombinationChart"
        }
      ],
      icon: Le("chart", this.beans, void 0)
    };
  }
  getConfigLookup() {
    return {
      columnGroup: {
        _key: "rangeColumnChart",
        column: "rangeGroupedColumn",
        stackedColumn: "rangeStackedColumn",
        normalizedColumn: "rangeNormalizedColumn"
      },
      barGroup: {
        _key: "rangeBarChart",
        bar: "rangeGroupedBar",
        stackedBar: "rangeStackedBar",
        normalizedBar: "rangeNormalizedBar"
      },
      pieGroup: {
        _key: "rangePieChart",
        pie: "rangePie",
        donut: "rangeDonut",
        doughnut: "rangeDonut"
      },
      lineGroup: {
        _key: "rangeLineChart",
        line: "rangeLineChart",
        stackedLine: "rangeStackedLine",
        normalizedLine: "rangeNormalizedLine"
      },
      areaGroup: {
        _key: "rangeAreaChart",
        area: "rangeArea",
        stackedArea: "rangeStackedArea",
        normalizedArea: "rangeNormalizedArea"
      },
      scatterGroup: {
        _key: "rangeXYChart",
        bubble: "rangeBubble",
        scatter: "rangeScatter"
      },
      polarGroup: {
        _key: "rangePolarChart",
        radarLine: "rangeRadarLine",
        radarArea: "rangeRadarArea",
        nightingale: "rangeNightingale",
        radialColumn: "rangeRadialColumn",
        radialBar: "rangeRadialBar"
      },
      statisticalGroup: {
        _key: "rangeStatisticalChart",
        boxPlot: "rangeBoxPlot",
        histogram: "rangeHistogram",
        rangeBar: "rangeRangeBar",
        rangeArea: "rangeRangeArea"
      },
      hierarchicalGroup: {
        _key: "rangeHierarchicalChart",
        treemap: "rangeTreemap",
        sunburst: "rangeSunburst"
      },
      specializedGroup: {
        _key: "rangeSpecializedChart",
        heatmap: "rangeHeatmap",
        waterfall: "rangeWaterfall"
      },
      funnelGroup: {
        _key: "rangeFunnel",
        funnel: "rangeFunnel",
        coneFunnel: "rangeConeFunnel",
        pyramid: "rangePyramid"
      },
      combinationGroup: {
        _key: "rangeCombinationChart",
        columnLineCombo: "rangeColumnLineCombo",
        areaColumnCombo: "rangeAreaColumnCombo",
        customCombo: null
        // Not currently supported
      }
    };
  }
}, ON = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colChooserFactory";
  }
  createColumnSelectPanel(e, t, n, o) {
    const s = e.createManagedBean(new $b()), i = o ?? (t == null ? void 0 : t.getColDef().columnChooserParams) ?? {}, {
      contractColumnSelection: r,
      suppressColumnExpandAll: a,
      suppressColumnFilter: l,
      suppressColumnSelectAll: d,
      suppressSyncLayoutWithGrid: c,
      columnLayout: u
    } = i;
    return s.init(
      !!n,
      ke(this.gos, {
        suppressColumnMove: !1,
        suppressValues: !1,
        suppressPivots: !1,
        suppressRowGroups: !1,
        suppressPivotMode: !1,
        contractColumnSelection: !!r,
        suppressColumnExpandAll: !!a,
        suppressColumnFilter: !!l,
        suppressColumnSelectAll: !!d,
        suppressSyncLayoutWithGrid: !!u || !!c,
        onStateUpdated: () => {
        }
      }),
      "columnMenu"
    ), u && s.setColumnLayout(u), s;
  }
  showColumnChooser({
    column: e,
    chooserParams: t,
    eventSource: n,
    headerPosition: o
  }) {
    this.hideActiveColumnChooser();
    const s = this.createColumnSelectPanel(this, e, !0, t), i = this.getLocaleTextFunc(), r = this.beans, { visibleCols: a, focusSvc: l, menuUtils: d } = r, c = a.allCols.indexOf(e), u = e ? l.focusedHeader ?? o ?? null : null;
    this.activeColumnChooserDialog = this.createBean(
      new yb({
        title: i("chooseColumns", "Choose Columns"),
        component: s,
        width: 300,
        height: 300,
        resizable: !0,
        movable: !0,
        centered: !0,
        closable: !0,
        afterGuiAttached: () => {
          var h;
          (h = sn(r, s.getGui())) == null || h.focus({
            preventScroll: !0
          }), this.dispatchVisibleChangedEvent(!0, e);
        },
        closedCallback: (h) => {
          const g = this.activeColumnChooser.getGui();
          this.destroyBean(this.activeColumnChooser), this.activeColumnChooser = void 0, this.activeColumnChooserDialog = void 0, this.dispatchVisibleChangedEvent(!1, e), e && d.restoreFocusOnClose(
            { column: e, headerPosition: u, columnIndex: c, eventSource: n },
            g,
            h,
            !0
          );
        },
        postProcessPopupParams: {
          type: "columnChooser",
          column: e,
          eventSource: n
        }
      })
    ), this.activeColumnChooser = s;
  }
  hideActiveColumnChooser() {
    this.destroyBean(this.activeColumnChooserDialog);
  }
  dispatchVisibleChangedEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: !1,
      key: "columnChooser",
      column: t ?? null
    });
  }
}, GN = {
  pinSubMenu: "PinnedColumn",
  pinLeft: "PinnedColumn",
  pinRight: "PinnedColumn",
  clearPinned: "PinnedColumn",
  pinRowSubMenu: "PinnedRow",
  pinBottom: "PinnedRow",
  pinTop: "PinnedRow",
  unpinRow: "PinnedRow",
  valueAggSubMenu: "SharedAggregation",
  autoSizeThis: "ColumnAutoSize",
  autoSizeAll: "ColumnAutoSize",
  rowGroup: "SharedRowGrouping",
  rowUnGroup: "SharedRowGrouping",
  resetColumns: "CommunityCore",
  expandAll: ["ClientSideRowModelHierarchy", "ServerSideRowModel"],
  contractAll: ["ClientSideRowModelHierarchy", "ServerSideRowModel"],
  copy: "Clipboard",
  copyWithHeaders: "Clipboard",
  copyWithGroupHeaders: "Clipboard",
  cut: "Clipboard",
  paste: "Clipboard",
  export: ["CsvExport", "ExcelExport"],
  csvExport: "CsvExport",
  excelExport: "ExcelExport",
  separator: "CommunityCore",
  pivotChart: "IntegratedCharts",
  chartRange: "IntegratedCharts",
  columnFilter: "ColumnFilter",
  columnChooser: "ColumnMenu",
  sortAscending: "Sort",
  sortDescending: "Sort",
  sortUnSort: "Sort"
};
function HN(e, t) {
  const n = GN[t];
  n && e.assertModuleRegistered(n, `menu item '${t}'`);
}
var Ys = "separator";
function Ub(e, t) {
  if (e)
    for (let n = e.length - 2; n >= 0; n--) {
      const o = e[n] === t, s = e[n + 1] === t;
      o && s && e.splice(n + 1, 1);
    }
}
var VN = class extends U {
  constructor() {
    super(...arguments), this.beanName = "menuItemMapper";
  }
  mapWithStockItems(e, t, n, o, s) {
    if (!e)
      return [];
    const i = [], r = this.getLocaleTextFunc(), { beans: a, gos: l } = this, {
      pinnedCols: d,
      colAutosize: c,
      aggFuncSvc: u,
      rowGroupColsSvc: h,
      colNames: g,
      colModel: p,
      clipboardSvc: f,
      expansionSvc: m,
      focusSvc: C,
      csvCreator: w,
      excelCreator: b,
      menuSvc: A,
      colChooserFactory: S,
      sortSvc: F,
      chartMenuItemMapper: E,
      valueColsSvc: M,
      pinnedRowModel: I
    } = a, P = (k, B, j, N) => {
      var re;
      switch (HN(l, k), k) {
        case "pinSubMenu":
          return d && B ? {
            name: r("pinColumn", "Pin Column"),
            icon: Le("menuPin", a, null),
            subMenu: ["clearPinned", "pinLeft", "pinRight"]
          } : null;
        case "pinLeft":
          return d && B ? {
            name: r("pinLeft", "Pin Left"),
            action: () => d.setColsPinned([B], "left", N),
            checked: !!B && B.isPinnedLeft()
          } : null;
        case "pinRight":
          return d && B ? {
            name: r("pinRight", "Pin Right"),
            action: () => d.setColsPinned([B], "right", N),
            checked: !!B && B.isPinnedRight()
          } : null;
        case "clearPinned":
          return d && B ? {
            name: r("noPin", "No Pin"),
            action: () => d.setColsPinned([B], null, N),
            checked: !!B && !B.isPinned()
          } : null;
        case "pinRowSubMenu": {
          const H = l.get("enableRowPinning"), _ = [], ne = (n == null ? void 0 : n.rowPinned) ?? ((re = n == null ? void 0 : n.pinnedSibling) == null ? void 0 : re.rowPinned);
          return ne && _.push("unpinRow"), H && H !== "bottom" && ne != "top" && _.push("pinTop"), H && H !== "top" && ne != "bottom" && _.push("pinBottom"), I != null && I.isManual() ? {
            name: r("pinRow", "Pin Row"),
            icon: Le("rowPin", a, B),
            subMenu: _
          } : null;
        }
        case "pinTop":
          return I != null && I.isManual() ? {
            name: r("pinTop", "Pin to Top"),
            icon: Le("rowPinTop", a, B),
            action: ({ node: H, column: _ }) => H && I.pinRow(H, "top", _)
          } : null;
        case "pinBottom":
          return I != null && I.isManual() ? {
            name: r("pinBottom", "Pin to Bottom"),
            icon: Le("rowPinBottom", a, B),
            action: ({ node: H, column: _ }) => H && I.pinRow(H, "bottom", _)
          } : null;
        case "unpinRow":
          return I != null && I.isManual() ? {
            name: r("unpinRow", "Unpin Row"),
            icon: Le("rowUnpin", a, B),
            action: ({ node: H, column: _ }) => H && I.pinRow(H, null, _)
          } : null;
        case "valueAggSubMenu":
          return u && M && (B != null && B.isPrimary() || B != null && B.getColDef().pivotValueColumn) ? {
            name: r("valueAggregation", "Value Aggregation"),
            icon: Le("menuValue", a, null),
            subMenu: _N(B, u, M, r),
            disabled: l.get("functionsReadOnly")
          } : null;
        case "autoSizeThis":
          return c ? {
            name: r("autosizeThisColumn", "Autosize This Column"),
            action: () => c.autoSizeColumn(B, N, l.get("skipHeaderOnAutoSize"))
          } : null;
        case "autoSizeAll":
          return c ? {
            name: r("autosizeAllColumns", "Autosize All Columns"),
            action: () => c.autoSizeAllColumns({
              source: N,
              skipHeader: l.get("skipHeaderOnAutoSize")
            })
          } : null;
        case "rowGroup":
          return h ? {
            name: r("groupBy", "Group by") + " " + g.getDisplayNameForColumn(B, "header"),
            disabled: l.get("functionsReadOnly") || (B == null ? void 0 : B.isRowGroupActive()) || !(B != null && B.getColDef().enableRowGroup),
            action: () => h.addColumns([B], N),
            icon: Le("menuAddRowGroup", a, null)
          } : null;
        case "rowUnGroup":
          if (h && l.isModuleRegistered("SharedRowGrouping")) {
            const H = B == null ? void 0 : B.getColDef().showRowGroup, _ = l.get("groupLockGroupColumns");
            let ne, ce, me;
            if (H === !0)
              ne = r("ungroupAll", "Un-Group All"), ce = l.get("functionsReadOnly") || _ === -1 || _ >= (h.columns.length ?? 0), me = () => h.setColumns(h.columns.slice(0, _), N);
            else if (typeof H == "string") {
              const Ie = p.getColDefCol(H), L = Ie != null ? g.getDisplayNameForColumn(Ie, "header") : H;
              ne = r("ungroupBy", "Un-Group by") + " " + L, ce = l.get("functionsReadOnly") || Ha(Ie, a), me = () => {
                h.removeColumns([H], N);
              };
            } else
              ne = r("ungroupBy", "Un-Group by") + " " + g.getDisplayNameForColumn(B, "header"), ce = l.get("functionsReadOnly") || !(B != null && B.isRowGroupActive()) || !(B != null && B.getColDef().enableRowGroup) || Ha(B, a), me = () => h.removeColumns([B], N);
            return {
              name: ne,
              disabled: ce,
              action: me,
              icon: Le("menuRemoveRowGroup", a, null)
            };
          } else
            return null;
        case "resetColumns":
          return {
            name: r("resetColumns", "Reset Columns"),
            action: () => QC(a, N)
          };
        case "expandAll":
          return m ? {
            name: r("expandAll", "Expand All Row Groups"),
            action: () => m.expandAll(!0)
          } : null;
        case "contractAll":
          return m ? {
            name: r("collapseAll", "Collapse All Row Groups"),
            action: () => m.expandAll(!1)
          } : null;
        case "copy":
          return f ? {
            name: r("copy", "Copy"),
            shortcut: r("ctrlC", "Ctrl+C"),
            icon: Le("clipboardCopy", a, null),
            action: () => f.copyToClipboard()
          } : null;
        case "copyWithHeaders":
          return f ? {
            name: r("copyWithHeaders", "Copy with Headers"),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: Le("clipboardCopy", a, null),
            action: () => f.copyToClipboard({ includeHeaders: !0 })
          } : null;
        case "copyWithGroupHeaders":
          return f ? {
            name: r("copyWithGroupHeaders", "Copy with Group Headers"),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: Le("clipboardCopy", a, null),
            action: () => f.copyToClipboard({ includeHeaders: !0, includeGroupHeaders: !0 })
          } : null;
        case "cut":
          if (f) {
            const H = C.getFocusedCell(), _ = H ? To(a, H) : null, ne = _ ? H == null ? void 0 : H.column.isCellEditable(_) : !1;
            return {
              name: r("cut", "Cut"),
              shortcut: r("ctrlX", "Ctrl+X"),
              icon: Le("clipboardCut", a, null),
              disabled: !ne || l.get("suppressCutToClipboard"),
              action: () => f.cutToClipboard(void 0, "contextMenu")
            };
          } else
            return null;
        case "paste":
          if (f) {
            const H = l.get("suppressClipboardApi") || l.get("suppressClipboardPaste") || !B || !n || !B.isCellEditable(n) || B.isSuppressPaste(n);
            return {
              name: r("paste", "Paste"),
              shortcut: r("ctrlV", "Ctrl+V"),
              icon: Le("clipboardPaste", a, null),
              disabled: H,
              action: () => f.pasteFromClipboard()
            };
          } else
            return null;
        case "export": {
          const H = [];
          return !l.get("suppressCsvExport") && w && H.push("csvExport"), !l.get("suppressExcelExport") && b && H.push("excelExport"), H.length ? {
            name: r("export", "Export"),
            subMenu: H,
            icon: Le("save", a, null)
          } : null;
        }
        case "csvExport":
          return w ? {
            name: r("csvExport", "CSV Export"),
            icon: Le("csvExport", a, null),
            action: () => w.exportDataAsCsv()
          } : null;
        case "excelExport":
          return b ? {
            name: r("excelExport", "Excel Export"),
            icon: Le("excelExport", a, null),
            action: () => b.exportDataAsExcel()
          } : null;
        case "separator":
          return k;
        case "pivotChart":
        case "chartRange":
          return E.getChartItems(k);
        case "columnFilter":
          return A && B ? {
            name: r("columnFilter", "Column Filter"),
            icon: Le("filter", a, null),
            action: () => A.showFilterMenu({
              column: B,
              buttonElement: j(),
              containerType: "columnFilter",
              positionBy: "button"
            })
          } : null;
        case "columnChooser": {
          const H = C.focusedHeader;
          return S ? {
            name: r("columnChooser", "Choose Columns"),
            icon: Le("columns", a, null),
            action: () => S.showColumnChooser({
              column: B,
              eventSource: j(),
              headerPosition: H
            })
          } : null;
        }
        case "sortAscending":
          return F ? {
            name: r("sortAscending", "Sort Ascending"),
            icon: Le("sortAscending", a, null),
            action: () => F.setSortForColumn(B, "asc", !1, N)
          } : null;
        case "sortDescending":
          return F ? {
            name: r("sortDescending", "Sort Descending"),
            icon: Le("sortDescending", a, null),
            action: () => F.setSortForColumn(B, "desc", !1, N)
          } : null;
        case "sortUnSort":
          return F ? {
            name: r("sortUnSort", "Clear Sort"),
            icon: Le("sortUnSort", a, null),
            action: () => F.setSortForColumn(B, null, !1, N)
          } : null;
        default:
          return Z(176, { key: k }), null;
      }
    };
    return e.forEach((k) => {
      let B;
      if (typeof k == "string" ? B = P(k, t, o, s) : B = { ...k }, !B)
        return;
      const j = B, { subMenu: N } = j;
      N && N instanceof Array && (j.subMenu = this.mapWithStockItems(
        N,
        t,
        n,
        o,
        s
      )), B != null && i.push(B);
    }), Ub(i, Ys), i;
  }
};
function _N(e, t, n, o) {
  let s;
  if (e.isPrimary())
    s = e;
  else {
    const r = e.getColDef().pivotValueColumn;
    s = ue(r) ? r : void 0;
  }
  const i = [];
  if (s) {
    const r = s.isValueActive(), a = t.getFuncNames(s);
    i.push({
      name: o("noAggregation", "None"),
      action: () => {
        n.removeColumns([s], "contextMenu"), n.setColumnAggFunc(s, void 0, "contextMenu");
      },
      checked: !r
    }), a.forEach((l) => {
      i.push({
        name: o(l, t.getDefaultFuncLabel(l)),
        action: () => {
          n.setColumnAggFunc(s, l, "contextMenu"), n.addColumns([s], "contextMenu");
        },
        checked: r && s.getAggFunc() === l
      });
    });
  }
  return i;
}
var NN = class extends U {
  constructor() {
    super(...arguments), this.beanName = "colMenuFactory";
  }
  createMenu(e, t, n, o) {
    const s = e.createManagedBean(
      new Dc(0, {
        column: n ?? null,
        node: null,
        value: null
      })
    ), i = this.beans.menuItemMapper.mapWithStockItems(
      t,
      n ?? null,
      null,
      o,
      "columnMenu"
    );
    return s.addMenuItems(i), s;
  }
  getMenuItems(e = null, t = null) {
    var i;
    const n = this.getDefaultMenuOptions(e);
    let o;
    const s = (i = (e == null ? void 0 : e.getColDef()) ?? (t == null ? void 0 : t.getColGroupDef())) == null ? void 0 : i.mainMenuItems;
    if (Array.isArray(s))
      o = s;
    else if (typeof s == "function")
      o = s(
        ke(this.gos, {
          column: e,
          columnGroup: t,
          defaultItems: n
        })
      );
    else {
      const r = this.gos.getCallback("getMainMenuItems");
      r ? o = r({
        column: e,
        columnGroup: t,
        defaultItems: n
      }) : o = n;
    }
    return Ub(o, Ys), o;
  }
  getDefaultMenuOptions(e) {
    const t = [], { beans: n, gos: o } = this, {
      colChooserFactory: s,
      rowGroupColsSvc: i,
      colModel: r,
      expansionSvc: a,
      sortSvc: l,
      menuSvc: d,
      pinnedCols: c,
      aggFuncSvc: u,
      colAutosize: h
    } = n, g = Nt(o), p = () => {
      !g && s && t.push("columnChooser"), t.push("resetColumns");
    };
    if (!e)
      return p(), t;
    const { colDef: f } = e, m = c && !f.lockPinned, C = (i == null ? void 0 : i.columns.length) ?? 0, w = C > 0, b = e.isPrimary(), A = u && // if primary, then only allow aggValue if grouping and it's a value columns
    b && w && e.isAllowValue() || // secondary columns can always have aggValue, as it means it's a pivot value column
    !b;
    if (l && !g && e.isSortable()) {
      const S = e.getSort();
      S !== "asc" && t.push("sortAscending"), S !== "desc" && t.push("sortDescending"), S && t.push("sortUnSort"), t.push(Ys);
    }
    if (d != null && d.isFilterMenuItemEnabled(e) && (t.push("columnFilter"), t.push(Ys)), m && t.push("pinSubMenu"), A && t.push("valueAggSubMenu"), (m || A) && t.push(Ys), h && (t.push("autoSizeThis"), t.push("autoSizeAll"), t.push(Ys)), i && o.isModuleRegistered("SharedRowGrouping")) {
      const S = t.length;
      f.showRowGroup ? t.push("rowUnGroup") : e.isAllowRowGroup() && b && (e.isRowGroupActive() ? Ha(e, n) || t.push("rowUnGroup") : t.push("rowGroup")), t.length > S && t.push(Ys);
    }
    return p(), a && (Ct(o) || o.get("ssrmExpandAllAffectsAllRows")) && (o.get("treeData") || C > (r.isPivotMode() ? 1 : 0)) && (t.push("expandAll"), t.push("contractAll")), t;
  }
}, $N = "ag-menu", M0 = "ag-context-menu-open", zN = "ag-context-menu-loading-icon", WN = class extends U {
  constructor() {
    super(...arguments), this.beanName = "contextMenuSvc", this.destroyLoadingSpinner = null, this.lastPromise = 0;
  }
  hideActiveMenu() {
    this.destroyBean(this.activeMenu);
  }
  getMenuItems(e, t, n, o) {
    const s = [], { clipboardSvc: i, chartSvc: r, csvCreator: a, excelCreator: l, colModel: d, rangeSvc: c, gos: u } = this.beans;
    if (ue(e) && i && t && (u.get("suppressCutToClipboard") || s.push("cut"), s.push("copy", "copyWithHeaders", "copyWithGroupHeaders", "paste", "separator")), u.get("enableCharts") && r && (d.isPivotMode() && s.push("pivotChart"), c && !c.isEmpty() && s.push("chartRange")), ue(e)) {
      const f = u.get("enableRowPinning"), m = u.get("isRowPinnable");
      if (f) {
        const S = e.level > -1 && e.footer, F = e.level === -1 && e.footer, E = kr(u);
        (F && !(E === "pinnedBottom" || E === "pinnedTop") || !F && !S) && ((m == null ? void 0 : m(e)) ?? !0) && s.push("pinRowSubMenu");
      }
      const C = u.get("suppressExcelExport") || !l, w = u.get("suppressCsvExport") || !a;
      !Ss() && (!C || !w) && s.push("export");
    }
    const h = s.length ? s : void 0, g = t == null ? void 0 : t.getColDef().contextMenuItems;
    if (Array.isArray(g))
      return g;
    if (typeof g == "function")
      return g(
        ke(u, {
          column: t,
          node: e,
          value: n,
          defaultItems: h,
          event: o
        })
      );
    const p = u.getCallback("getContextMenuItems");
    return (p == null ? void 0 : p({ column: t, node: e, value: n, defaultItems: h, event: o })) ?? s;
  }
  getContextMenuPosition(e, t) {
    const n = this.getRowCtrl(e), o = this.getCellGui(n, t);
    if (!o)
      return { x: 0, y: (n == null ? void 0 : n.getRowYPosition()) ?? 0 };
    const s = o.getBoundingClientRect();
    return {
      x: s.x + s.width / 2,
      y: s.y + s.height / 2
    };
  }
  showContextMenu(e) {
    const t = e.rowNode ?? null, n = e.column ?? null;
    let { anchorToElement: o, value: s, source: i } = e;
    t && n && s == null && (s = this.beans.valueSvc.getValueForDisplay(n, t).value), o == null && (o = this.getContextMenuAnchorElement(t, n)), this.beans.menuUtils.onContextMenu({
      mouseEvent: e.mouseEvent ?? null,
      touchEvent: e.touchEvent ?? null,
      showMenuCallback: (r) => this.showMenu(t, n, s, r, o),
      source: i
    });
  }
  handleContextMenuMouseEvent(e, t, n, o) {
    var u;
    const s = (o == null ? void 0 : o.rowNode) ?? (n == null ? void 0 : n.rowNode) ?? null, i = (o == null ? void 0 : o.column) ?? ((u = n == null ? void 0 : n.findFullWidthInfoForEvent(e || t)) == null ? void 0 : u.column) ?? null, { valueSvc: r, ctrlsSvc: a } = this.beans, l = i ? r.getValue(i, s) : null, d = a.getGridBodyCtrl(), c = o ? o.eGui : d.eGridBody;
    this.showContextMenu({
      mouseEvent: e,
      touchEvent: t,
      rowNode: s,
      column: i,
      value: l,
      anchorToElement: c,
      source: "ui"
    });
  }
  showMenu(e, t, n, o, s) {
    const i = this.getMenuItems(e, t, n, o);
    if (lF(i)) {
      const r = this.lastPromise + 1;
      return this.lastPromise = r, this.destroyLoadingSpinner || this.createLoadingIcon(o), i.then((a) => {
        var u, h;
        if (this.lastPromise !== r)
          return;
        const { target: l } = o, d = !l;
        // check if there are actual menu items to be displayed
        a && a.length && // check if the element that triggered the context menu was removed from the DOM
        (d || vn(l)) && // overlay was displayed
        !((u = this.beans.overlays) != null && u.isExclusive()) && this.createContextMenu({ menuItems: a, node: e, column: t, value: n, mouseEvent: o, anchorToElement: s }), (h = this.destroyLoadingSpinner) == null || h.call(this);
      }), !0;
    }
    return i === void 0 || !(i != null && i.length) ? !1 : (this.createContextMenu({ menuItems: i, node: e, column: t, value: n, mouseEvent: o, anchorToElement: s }), !0);
  }
  createLoadingIcon(e) {
    var l;
    const { beans: t } = this, n = this.getLocaleTextFunc(), o = Le("loadingMenuItems", t), s = Ue({ tag: "div", cls: zN });
    s.appendChild(o);
    const i = mi(t), r = sc(t);
    if (!r) {
      Z(54);
      return;
    }
    r.appendChild(s), (l = t.ariaAnnounce) == null || l.announceValue(
      n("ariaLabelLoadingContextMenu", "Loading Context Menu"),
      "contextmenu"
    ), t.environment.applyThemeClasses(s), fh(s, e, t);
    const a = (d) => {
      fh(s, d, t);
    };
    i.addEventListener("mousemove", a), this.destroyLoadingSpinner = () => {
      i.removeEventListener("mousemove", a), r.removeChild(s), this.destroyLoadingSpinner = null;
    };
  }
  createContextMenu(e) {
    const { menuItems: t, node: n, column: o, value: s, mouseEvent: i, anchorToElement: r } = e, { ctrlsSvc: a, focusSvc: l, popupSvc: d } = this.beans, c = a.getGridBodyCtrl().eGridBody, u = new UN(t, o, n, s);
    this.createBean(u);
    const h = u.getGui();
    o || l.clearFocusedCell();
    const g = {
      column: o,
      rowNode: n,
      type: "contextMenu",
      mouseEvent: i,
      ePopup: h,
      // move one pixel away so that accidentally double clicking
      // won't show the browser's contextmenu
      nudgeY: 1
    }, p = this.getLocaleTextFunc(), f = d == null ? void 0 : d.addPopup({
      modal: !0,
      eChild: h,
      closeOnEsc: !0,
      closedCallback: (C) => {
        Pc(this.beans, () => {
          c.classList.remove(M0), this.destroyBean(u), this.dispatchVisibleChangedEvent(!1, C === void 0 ? "api" : "ui");
        });
      },
      click: i,
      positionCallback: () => {
        const C = this.gos.get("enableRtl");
        d == null || d.positionPopupUnderMouseEvent({
          ...g,
          nudgeX: C ? (h.offsetWidth + 1) * -1 : 1
        });
      },
      // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
      anchorToElement: r,
      ariaLabel: p("ariaLabelContextMenu", "Context Menu")
    });
    f && (c.classList.add(M0), u.afterGuiAttached({ container: "contextMenu", hidePopup: f.hideFunc })), this.activeMenu && this.hideActiveMenu(), this.activeMenu = u, u.addEventListener("destroyed", () => {
      this.activeMenu === u && (this.activeMenu = null);
    }), f && u.addEventListener(
      "closeMenu",
      (C) => f.hideFunc({
        mouseEvent: C.mouseEvent ?? void 0,
        keyboardEvent: C.keyboardEvent ?? void 0,
        forceHide: !0
      })
    );
    const m = i && i instanceof MouseEvent && i.type === "mousedown";
    this.dispatchVisibleChangedEvent(!0, m ? "api" : "ui");
  }
  dispatchVisibleChangedEvent(e, t = "ui") {
    this.eventSvc.dispatchEvent({
      type: "contextMenuVisibleChanged",
      visible: e,
      source: t
    });
  }
  getRowCtrl(e) {
    const { rowIndex: t, rowPinned: n } = e || {};
    if (t != null)
      return this.beans.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: n }) || void 0;
  }
  getCellGui(e, t) {
    if (!e || !t)
      return;
    const n = e.getCellCtrl(t);
    return (n == null ? void 0 : n.eGui) || void 0;
  }
  getContextMenuAnchorElement(e, t) {
    const n = this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody, o = this.getRowCtrl(e);
    if (!o)
      return n;
    const s = this.getCellGui(o, t);
    return s || (o.isFullWidth() ? o.getFullWidthElement() : n);
  }
  destroy() {
    var e;
    (e = this.destroyLoadingSpinner) == null || e.call(this), super.destroy();
  }
}, UN = class extends Te {
  constructor(e, t, n, o) {
    super({ tag: "div", cls: $N, role: "presentation" }), this.menuItems = e, this.column = t, this.node = n, this.value = o, this.menuList = null, this.focusedCell = null;
  }
  postConstruct() {
    const e = this.createManagedBean(
      new Dc(0, {
        column: this.column,
        node: this.node,
        value: this.value
      })
    ), t = this.beans.menuItemMapper.mapWithStockItems(
      this.menuItems,
      this.column,
      this.node,
      () => this.getGui(),
      "contextMenu"
    );
    e.addMenuItems(t), this.appendChild(e), this.menuList = e, e.addEventListener("closeMenu", (n) => this.dispatchLocalEvent(n));
  }
  afterGuiAttached({ hidePopup: e }) {
    e && this.addDestroyFunc(e), this.focusedCell = this.beans.focusSvc.getFocusedCell();
    const t = this.menuList;
    t && Pc(this.beans, () => pn(t.getGui()));
  }
  restoreFocusedCell() {
    const { beans: e, focusedCell: t } = this, n = e.focusSvc, o = n.getFocusedCell();
    if (o && t && Mp(o, t)) {
      const { rowIndex: s, rowPinned: i, column: r } = t;
      fr(e) && n.setFocusedCell({
        rowIndex: s,
        column: r,
        rowPinned: i,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !mc()
      });
    }
  }
  destroy() {
    super.destroy(), this.restoreFocusedCell();
  }
};
function KN(e) {
  return {
    tag: "div",
    cls: `ag-tabs ${e}`,
    children: [
      { tag: "div", ref: "eHeader" },
      {
        tag: "div",
        ref: "eBody",
        role: "presentation",
        cls: `ag-tabs-body ${e ? `${e}-body` : ""}`
      }
    ]
  };
}
var ZN = class extends Ti {
  constructor(e) {
    super(KN(e.cssClass)), this.eHeader = X, this.eBody = X, this.items = [], this.tabbedItemScrollMap = /* @__PURE__ */ new Map(), this.params = e;
  }
  postConstruct() {
    this.setupHeader(), this.params.items && this.params.items.forEach((e) => this.addItem(e)), this.initialiseTabGuard({
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this),
      focusInnerElement: this.focusInnerElement.bind(this),
      focusTrapActive: !0
    }), this.addDestroyFunc(() => {
      var e, t, n;
      return (n = (t = (e = this.activeItem) == null ? void 0 : e.tabbedItem) == null ? void 0 : t.afterDetachedCallback) == null ? void 0 : n.call(t);
    });
  }
  setupHeader() {
    const { enableCloseButton: e, cssClass: t } = this.params, n = (o, s) => {
      o.classList.add(`ag-tabs-${s}`), t && o.classList.add(`${t}-${s}`);
    };
    e ? (this.setupCloseButton(n), this.eTabHeader = Ue({ tag: "div", role: "presentation" }), n(this.eHeader, "header-wrapper"), this.eHeader.appendChild(this.eTabHeader)) : this.eTabHeader = this.eHeader, hn(this.eTabHeader, "tablist"), n(this.eTabHeader, "header");
  }
  setupCloseButton(e) {
    const t = Ue({ tag: "button" });
    e(t, "close-button");
    const n = Le("close", this.beans);
    yt(t, this.params.closeButtonAriaLabel), t.appendChild(n), this.addManagedElementListeners(t, { click: () => {
      var s, i;
      return (i = (s = this.params).onCloseClicked) == null ? void 0 : i.call(s);
    } });
    const o = Ue({ tag: "div", role: "presentation" });
    e(o, "close-button-wrapper"), o.appendChild(t), this.eHeader.appendChild(o), this.eCloseButton = t;
  }
  handleKeyDown(e) {
    switch (e.key) {
      case O.RIGHT:
      case O.LEFT: {
        if (!this.eTabHeader.contains(je(this.beans)))
          return;
        const t = e.key === O.RIGHT, n = this.gos.get("enableRtl"), o = this.items.indexOf(this.activeItem), s = t !== n ? Math.min(o + 1, this.items.length - 1) : Math.max(o - 1, 0);
        if (o === s)
          return;
        e.preventDefault();
        const i = this.items[s];
        this.showItemWrapper(i), i.eHeaderButton.focus();
        break;
      }
      case O.UP:
      case O.DOWN:
        e.stopPropagation();
        break;
    }
  }
  onTabKeyDown(e) {
    var h, g, p, f;
    if (e.defaultPrevented)
      return;
    const { beans: t, eHeader: n, eBody: o, activeItem: s, params: i } = this, { suppressTrapFocus: r, enableCloseButton: a } = i, l = je(t), d = e.target, c = e.shiftKey;
    if (n.contains(l)) {
      e.preventDefault(), a && c && !((h = this.eCloseButton) != null && h.contains(l)) ? (g = this.eCloseButton) == null || g.focus() : r && c ? (p = Qh(Bt(t).body, d)) == null || p.focus() : this.focusBody(e.shiftKey);
      return;
    }
    let u = null;
    if (Ib(o, d) && (c && (u = Qh(o, d)), !u && !r && (u = s.eHeaderButton)), !u && o.contains(l) && (u = sn(t, o, !1, c), !u)) {
      r && !c ? this.forceFocusOutOfContainer(c) : a && !c ? (e.preventDefault(), (f = this.eCloseButton) == null || f.focus()) : (e.preventDefault(), this.focusHeader());
      return;
    }
    u && (e.preventDefault(), u.focus());
  }
  focusInnerElement(e) {
    return e ? this.focusBody(!0) : (this.focusHeader(), !0);
  }
  focusHeader(e) {
    this.activeItem.eHeaderButton.focus({ preventScroll: e });
  }
  focusBody(e) {
    return pn(this.eBody, e);
  }
  setAfterAttachedParams(e) {
    this.afterAttachedParams = e;
  }
  showFirstItem() {
    this.items.length > 0 && this.showItemWrapper(this.items[0]);
  }
  addItem(e) {
    const t = Ue({
      tag: "span",
      cls: "ag-tab",
      role: "tab",
      attrs: { tabindex: "-1" }
    });
    t.appendChild(e.title), this.eTabHeader.appendChild(t), yt(t, e.titleLabel);
    const n = {
      tabbedItem: e,
      eHeaderButton: t
    };
    this.items.push(n), t.addEventListener("click", this.showItemWrapper.bind(this, n));
  }
  showItem(e) {
    const t = this.items.find((n) => n.tabbedItem === e);
    t && this.showItemWrapper(t);
  }
  showItemWrapper(e) {
    var o, s, i, r, a, l;
    const { tabbedItem: t, eHeaderButton: n } = e;
    if ((s = (o = this.params).onItemClicked) == null || s.call(o, { item: t }), this.activeItem === e) {
      (r = (i = this.params).onActiveItemClicked) == null || r.call(i);
      return;
    }
    this.lastScrollListener && (this.lastScrollListener = this.lastScrollListener()), ht(this.eBody), t.bodyPromise.then((d) => {
      this.eBody.appendChild(d);
      const c = !mc();
      if (this.params.suppressFocusBodyOnOpen || pn(this.eBody, !1, c), t.afterAttachedCallback && t.afterAttachedCallback(this.afterAttachedParams), this.params.keepScrollPosition) {
        const u = t.getScrollableContainer && t.getScrollableContainer() || d;
        [this.lastScrollListener] = this.addManagedElementListeners(u, {
          scroll: () => {
            this.tabbedItemScrollMap.set(t.name, u.scrollTop);
          }
        });
        const h = this.tabbedItemScrollMap.get(t.name);
        h !== void 0 && setTimeout(() => {
          u.scrollTop = h;
        }, 0);
      }
    }), this.activeItem && (this.activeItem.eHeaderButton.classList.remove("ag-tab-selected"), (l = (a = this.activeItem.tabbedItem).afterDetachedCallback) == null || l.call(a)), n.classList.add("ag-tab-selected"), this.activeItem = e;
  }
}, vs = "filterMenuTab", Cs = "generalMenuTab", Qs = "columnsMenuTab", od = [Cs, vs, Qs], qN = class extends U {
  constructor() {
    super(...arguments), this.beanName = "enterpriseMenuFactory";
  }
  hideActiveMenu() {
    this.destroyBean(this.activeMenu);
  }
  showMenuAfterMouseEvent(e, t, n, o, s) {
    const { column: i, columnGroup: r } = this.splitColumnOrGroup(e), a = s ? "filterMenuTab" : void 0;
    this.showMenu(
      i,
      r,
      (l) => {
        var c;
        const d = l.getGui();
        this.beans.popupSvc.positionPopupUnderMouseEvent({
          type: n,
          column: i,
          mouseEvent: t,
          ePopup: d
        }), a && ((c = l.showTab) == null || c.call(l, a)), this.dispatchVisibleChangedEvent(!0, !1, i, r, a);
      },
      n,
      a,
      void 0,
      t.target,
      o
    );
  }
  splitColumnOrGroup(e) {
    const t = e && Io(e);
    return { column: t ? e : void 0, columnGroup: t ? void 0 : e };
  }
  showMenuAfterButtonClick(e, t, n, o, s) {
    let i = -1, r = "left";
    this.gos.get("enableRtl") && (i = 1, r = "right");
    const a = s ? "filterMenuTab" : void 0, l = a ? [a] : void 0, d = Nt(this.gos), c = (d ? 9 : 4) * i, u = d ? -23 : 4, { column: h, columnGroup: g } = this.splitColumnOrGroup(e);
    this.showMenu(
      h,
      g,
      (p) => {
        var m;
        const f = p.getGui();
        this.beans.popupSvc.positionPopupByComponent({
          type: n,
          column: h,
          eventSource: t,
          ePopup: f,
          alignSide: r,
          nudgeX: c,
          nudgeY: u,
          position: "under",
          keepWithinBounds: !0
        }), a && ((m = p.showTab) == null || m.call(p, a)), this.dispatchVisibleChangedEvent(!0, !1, h, g, a);
      },
      n,
      a,
      l,
      t,
      o
    );
  }
  showMenu(e, t, n, o, s, i, r, a) {
    var C;
    const l = this.getMenuParams(e, t, i, r);
    if (!l)
      return;
    const { menu: d, eMenuGui: c, anchorToElement: u, restoreFocusParams: h } = l, g = [], { menuUtils: p, popupSvc: f } = this.beans;
    g.push((w) => {
      const b = d.getGui();
      this.destroyBean(d), e && (kd(e, !1, "contextMenu"), p.restoreFocusOnClose(h, b, w)), a == null || a();
    });
    const m = this.getLocaleTextFunc();
    if (f.addPopup({
      modal: !0,
      eChild: c,
      closeOnEsc: !0,
      closedCallback: (w) => {
        g.forEach((b) => b(w)), this.dispatchVisibleChangedEvent(!1, !1, e, t, s);
      },
      afterGuiAttached: (w) => d.afterGuiAttached(Object.assign({}, { container: o }, w)),
      // if defaultTab is not present, positionCallback will be called
      // after `showTabBasedOnPreviousSelection` is called.
      positionCallback: s ? () => n(d) : void 0,
      ariaLabel: m("ariaLabelColumnMenu", "Column Menu")
    }), s || ((C = d.showTabBasedOnPreviousSelection) == null || C.call(d), n(d)), OC(this.gos)) {
      const w = f.setPopupPositionRelatedToElement(c, u);
      w && e && this.addStopAnchoring(w, e, g);
    }
    d.addEventListener("tabSelected", (w) => {
      this.dispatchVisibleChangedEvent(!1, !0, e), this.lastSelectedTab = w.key, this.dispatchVisibleChangedEvent(!0, !0, e);
    }), e && kd(e, !0, "contextMenu"), this.activeMenu = d, d.addEventListener("destroyed", () => {
      this.activeMenu === d && (this.activeMenu = null);
    });
  }
  addStopAnchoring(e, t, n) {
    e.then((o) => {
      t.__addEventListener("leftChanged", o), t.__addEventListener("visibleChanged", o), n.push(() => {
        t.__removeEventListener("leftChanged", o), t.__removeEventListener("visibleChanged", o);
      });
    });
  }
  getMenuParams(e, t, n, o) {
    const { focusSvc: s, visibleCols: i, ctrlsSvc: r } = this.beans, a = {
      column: e,
      headerPosition: s.focusedHeader,
      columnIndex: i.allCols.indexOf(e),
      eventSource: o
    }, l = this.createMenu(e, t, a, n, o);
    return l ? {
      menu: l,
      eMenuGui: l.getGui(),
      anchorToElement: o || r.getGridBodyCtrl().eGridBody,
      restoreFocusParams: a
    } : void 0;
  }
  createMenu(e, t, n, o, s) {
    if (Nt(this.gos))
      return this.createBean(
        new jN(e, n, this.lastSelectedTab, o, s)
      );
    {
      const i = this.beans.colMenuFactory.getMenuItems(e, t);
      return i.length ? this.createBean(new YN(i, e, n, s)) : void 0;
    }
  }
  dispatchVisibleChangedEvent(e, t, n, o, s) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: t,
      key: this.lastSelectedTab ?? s ?? (Nt(this.gos) ? Cs : "columnMenu"),
      column: n ?? null,
      columnGroup: o ?? null
    });
  }
  isMenuEnabled(e) {
    var s;
    if (!Nt(this.gos))
      return !0;
    const t = !((s = this.beans.filterManager) != null && s.isFilterAllowed(e)), n = e.getColDef().menuTabs ?? od;
    return (t && n.includes(vs) ? n.length - 1 : n.length) > 0;
  }
  showMenuAfterContextMenuEvent(e, t, n) {
    this.beans.menuUtils.onContextMenu({
      mouseEvent: t,
      touchEvent: n,
      source: "ui",
      showMenuCallback: (o) => (this.showMenuAfterMouseEvent(e, o, "columnMenu"), !0)
    });
  }
}, jN = class extends U {
  constructor(e, t, n, o, s) {
    super(), this.column = e, this.restoreFocusParams = t, this.initialSelection = n, this.restrictTo = o, this.sourceElement = s, this.tabFactories = {}, this.includeChecks = {};
    const { tabFactories: i, includeChecks: r } = this;
    i[Cs] = this.createMainPanel.bind(this), i[vs] = this.createFilterPanel.bind(this), i[Qs] = this.createColumnsPanel.bind(this), r[Cs] = () => !0, r[vs] = () => {
      var a;
      return e ? !!((a = this.beans.filterManager) != null && a.isFilterAllowed(e)) : !1;
    }, r[Qs] = () => !0;
  }
  postConstruct() {
    var n;
    const e = this.getTabsToCreate().map((o) => this.createTab(o)), t = new ZN({
      items: e,
      cssClass: "ag-menu",
      onActiveItemClicked: this.onHidePopup.bind(this),
      onItemClicked: this.onTabItemClicked.bind(this)
    });
    this.tabbedLayout = this.createBean(t), (n = this.mainMenuList) == null || n.setParentComponent(t), this.addDestroyFunc(() => this.destroyBean(t));
  }
  getTabsToCreate() {
    var e;
    return this.restrictTo ? this.restrictTo : (((e = this.column) == null ? void 0 : e.getColDef().menuTabs) ?? od).filter(
      (t) => this.isValidMenuTabItem(t) && this.isNotSuppressed(t)
    );
  }
  isValidMenuTabItem(e) {
    let t = !0, n = od;
    return this.restrictTo != null && (t = this.restrictTo.indexOf(e) > -1, n = this.restrictTo), t = t && od.indexOf(e) > -1, t || Z(175, { menuTabName: e, itemsToConsider: n }), t;
  }
  isNotSuppressed(e) {
    return this.includeChecks[e]();
  }
  createTab(e) {
    return this.tabFactories[e]();
  }
  showTabBasedOnPreviousSelection() {
    this.showTab(this.initialSelection);
  }
  showTab(e) {
    const { tabItemColumns: t, tabbedLayout: n, tabItemFilter: o, tabItemGeneral: s } = this;
    t && e === Qs ? n.showItem(t) : o && e === vs ? n.showItem(o) : s && e === Cs ? n.showItem(s) : n.showFirstItem();
  }
  onTabItemClicked(e) {
    let t = null;
    switch (e.item) {
      case this.tabItemColumns:
        t = Qs;
        break;
      case this.tabItemFilter:
        t = vs;
        break;
      case this.tabItemGeneral:
        t = Cs;
        break;
    }
    t && this.activateTab(t);
  }
  activateTab(e) {
    const t = {
      type: "tabSelected",
      key: e
    };
    this.dispatchLocalEvent(t);
  }
  createMainPanel() {
    const { beans: e, column: t } = this, n = e.colMenuFactory, o = n.createMenu(
      this,
      n.getMenuItems(t),
      this.column,
      () => this.sourceElement ?? this.getGui()
    );
    this.mainMenuList = o, o.addEventListener("closeMenu", this.onHidePopup.bind(this));
    const s = {
      title: Le("legacyMenu", e, t),
      titleLabel: Cs.replace("MenuTab", ""),
      bodyPromise: tt.resolve(o.getGui()),
      name: Cs
    };
    return this.tabItemGeneral = s, s;
  }
  onHidePopup(e) {
    this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(
      this.hidePopupFunc,
      this.restoreFocusParams,
      e
    );
  }
  createFilterPanel() {
    const e = this.column ? this.createBean(new Fw(this.column, "COLUMN_MENU")) : null;
    this.filterComp = e, e != null && e.hasFilter() || $e(119);
    const t = (o) => e == null ? void 0 : e.afterGuiAttached(o), n = () => e == null ? void 0 : e.afterGuiDetached();
    return this.tabItemFilter = {
      title: Le("filterTab", this.beans, this.column),
      titleLabel: vs.replace("MenuTab", ""),
      bodyPromise: tt.resolve(e == null ? void 0 : e.getGui()),
      afterAttachedCallback: t,
      afterDetachedCallback: n,
      name: vs
    }, this.tabItemFilter;
  }
  createColumnsPanel() {
    const e = Ue({ tag: "div", cls: "ag-menu-column-select-wrapper" }), { beans: t, column: n } = this, s = t.colChooserFactory.createColumnSelectPanel(
      this,
      n
    ).getGui();
    s.classList.add("ag-menu-column-select"), e.appendChild(s);
    const i = {
      title: Le("columns", t, n),
      //createColumnsIcon(),
      titleLabel: Qs.replace("MenuTab", ""),
      bodyPromise: tt.resolve(e),
      name: Qs
    };
    return this.tabItemColumns = i, i;
  }
  afterGuiAttached(e) {
    const { container: t, hidePopup: n } = e;
    this.tabbedLayout.setAfterAttachedParams({ container: t, hidePopup: n }), n && (this.hidePopupFunc = n, this.addDestroyFunc(n));
  }
  getGui() {
    return this.tabbedLayout.getGui();
  }
  destroy() {
    super.destroy(), this.destroyBean(this.filterComp);
  }
}, YN = class extends Te {
  constructor(e, t, n, o) {
    super({ tag: "div", ref: "eColumnMenu", cls: "ag-menu ag-column-menu", role: "presentation" }), this.menuItems = e, this.column = t, this.restoreFocusParams = n, this.sourceElement = o, this.eColumnMenu = X;
  }
  postConstruct() {
    const e = this.beans.colMenuFactory.createMenu(
      this,
      this.menuItems,
      this.column,
      () => this.sourceElement ?? this.getGui()
    );
    this.mainMenuList = e, e.addEventListener("closeMenu", this.onHidePopup.bind(this)), this.eColumnMenu.appendChild(e.getGui());
  }
  onHidePopup(e) {
    this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(
      this.hidePopupFunc,
      this.restoreFocusParams,
      e
    );
  }
  afterGuiAttached({ hidePopup: e }) {
    e && (this.hidePopupFunc = e, this.addDestroyFunc(e)), pn(this.mainMenuList.getGui());
  }
};
function QN(e, t) {
  const { contextMenuSvc: n } = e;
  if (!n)
    return;
  const { rowNode: o, column: s, value: i, x: r, y: a } = t || {};
  let { x: l, y: d } = n.getContextMenuPosition(o, s);
  r != null && (l = r), a != null && (d = a), n.showContextMenu({
    mouseEvent: new MouseEvent("mousedown", { clientX: l, clientY: d }),
    rowNode: o,
    column: s,
    value: i,
    source: "api"
  });
}
function JN(e, t) {
  var n;
  (n = e.colChooserFactory) == null || n.showColumnChooser({ chooserParams: t });
}
function XN(e) {
  var t;
  (t = e.colChooserFactory) == null || t.hideActiveColumnChooser();
}
var e$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "menuUtils";
  }
  restoreFocusOnClose(e, t, n, o) {
    const { eventSource: s } = e, i = n instanceof KeyboardEvent;
    if (!o && !i || !s)
      return;
    const r = je(this.beans);
    // focus is outside of comp
    !t.contains(r) && // something else has focus
    !fr(this.beans) || this.focusHeaderCell(e);
  }
  closePopupAndRestoreFocusOnSelect(e, t, n) {
    let o;
    n && n.keyboardEvent && (o = n.keyboardEvent), e(o && { keyboardEvent: o });
    const s = this.beans, i = s.focusSvc, r = i.getFocusedCell();
    if (fr(s))
      if (r) {
        const { rowIndex: a, rowPinned: l, column: d } = r;
        i.setFocusedCell({
          rowIndex: a,
          column: d,
          rowPinned: l,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0
        });
      } else
        this.focusHeaderCell(t);
  }
  onContextMenu(e) {
    const { mouseEvent: t, touchEvent: n, showMenuCallback: o, source: s } = e;
    if (!this.gos.get("allowContextMenuWithControlKey") && t && (t.ctrlKey || t.metaKey) || (t && this.blockMiddleClickScrollsIfNeeded(t), s === "ui" && this.gos.get("suppressContextMenu")))
      return;
    const i = t ?? n.touches[0];
    if (o(i)) {
      const r = t ?? n;
      r && r.cancelable && r.preventDefault();
    }
  }
  // make this async for react
  async focusHeaderCell(e) {
    const { column: t, columnIndex: n, headerPosition: o, eventSource: s } = e, { visibleCols: i, headerNavigation: r, focusSvc: a } = this.beans, l = await i.allCols.some((d) => d === t);
    if (this.isAlive()) {
      if (t != null && t.isAlive() && l && s && vn(s)) {
        const d = cp(s);
        d && (r == null || r.scrollToColumn(t), d.focus());
      } else if (o && n !== -1) {
        const d = i.allCols, c = d[n] || Je(d);
        c && a.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: o.headerRowIndex,
            column: c
          }
        });
      }
    }
  }
  blockMiddleClickScrollsIfNeeded(e) {
    this.gos.get("suppressMiddleClickScrolls") && e.which === 2 && e.preventDefault();
  }
}, Kb = {
  moduleName: "MenuCore",
  version: gt,
  beans: [VN, kN, e$],
  icons: {
    // context menu chart item
    chart: "chart",
    // columns in menu (column chooser / columns tab)
    columns: "columns",
    // loading async menu items
    loadingMenuItems: "loading",
    // "Pin column" item in column header menu
    menuPin: "pin",
    // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
    menuValue: "aggregation",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // context menu copy item
    clipboardCopy: "copy",
    // context menu cut item
    clipboardCut: "cut",
    // context menu paste item
    clipboardPaste: "paste",
    // context menu export item
    save: "save",
    // csv export
    csvExport: "csv",
    // excel export,
    excelExport: "excel",
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with colDef.unSortIcon=true
    sortUnSort: "none"
  },
  dependsOn: [an, Vs, Vy, kb]
}, t$ = {
  moduleName: "ColumnMenu",
  version: gt,
  beans: [qN, NN, ON],
  icons: {
    ensureColumnVisible: "column-arrow",
    // menu tab icon in legacy tabbed enterprise column menu
    legacyMenu: "menu",
    // filter tab icon in legacy tabbed enterprise column menu
    filterTab: "filter",
    // column tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // column tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate"
  },
  apiFunctions: {
    showColumnChooser: JN,
    hideColumnChooser: XN
  },
  dependsOn: [Kb, sl, Ip]
}, n$ = {
  moduleName: "ContextMenu",
  version: gt,
  beans: [WN],
  apiFunctions: {
    showContextMenu: QN
  },
  dependsOn: [Kb]
}, oi = "__AG_SELECT_ALL__", si = "__AG_ADD_SELECTION_TO_FILTER__", o$ = class {
  constructor(e, t, n, o) {
    this.valueSvc = e, this.getValueFormatter = t, this.formatter = n, this.column = o, this.displayedKeys = [];
  }
  updateDisplayedValuesToAllAvailable(e, t, n) {
    this.displayedKeys = Array.from(n);
  }
  updateDisplayedValuesToMatchMiniFilter(e, t, n, o, s) {
    this.displayedKeys = [];
    const i = this.getValueFormatter();
    for (const r of n)
      if (r == null)
        s && this.displayedKeys.push(r);
      else {
        const a = e(r), l = this.valueSvc.formatValue(this.column, null, a, i, !1), d = this.formatter(l);
        o(d) && this.displayedKeys.push(r);
      }
  }
  getDisplayedValueCount() {
    return this.displayedKeys.length;
  }
  getDisplayedItem(e) {
    return this.displayedKeys[e];
  }
  getSelectAllItem() {
    return oi;
  }
  getAddSelectionToFilterItem() {
    return si;
  }
  getDisplayedKeys() {
    return this.displayedKeys;
  }
  forEachDisplayedKey(e) {
    this.displayedKeys.forEach(e);
  }
  someDisplayedKey(e) {
    return this.displayedKeys.some(e);
  }
  hasGroups() {
    return !1;
  }
  refresh() {
  }
}, s$ = {
  tag: "div",
  cls: "ag-set-filter-item",
  attrs: { "aria-hidden": "true" },
  children: [
    {
      tag: "span",
      cls: "ag-set-filter-group-icons",
      children: [
        { tag: "span", ref: "eGroupClosedIcon", cls: "ag-set-filter-group-closed-icon" },
        { tag: "span", ref: "eGroupOpenedIcon", cls: "ag-set-filter-group-opened-icon" },
        { tag: "span", ref: "eGroupIndeterminateIcon", cls: "ag-set-filter-group-indeterminate-icon" }
      ]
    },
    { tag: "ag-checkbox", ref: "eCheckbox", cls: "ag-set-filter-item-checkbox" }
  ]
}, i$ = {
  tag: "div",
  cls: "ag-set-filter-item",
  children: [{ tag: "ag-checkbox", ref: "eCheckbox", cls: "ag-set-filter-item-checkbox" }]
}, r$ = class extends Te {
  constructor(e) {
    super(e.isGroup ? s$ : i$, [Di]), this.eCheckbox = X, this.eGroupOpenedIcon = X, this.eGroupClosedIcon = X, this.eGroupIndeterminateIcon = X, this.formattedValue = null, this.focusWrapper = e.focusWrapper, this.value = e.value, this.params = e.params, this.translate = e.translate, this.valueFormatter = e.valueFormatter, this.item = e.item, this.isSelected = e.isSelected, this.isTree = e.isTree, this.depth = e.depth ?? 0, this.isGroup = e.isGroup, this.groupsExist = e.groupsExist, this.isExpanded = e.isExpanded, this.hasIndeterminateExpandState = e.hasIndeterminateExpandState;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.focusWrapper,
        getLocation: () => "setFilterValue",
        shouldDisplayTooltip: () => {
          var e;
          return ((e = this.shouldDisplayTooltip) == null ? void 0 : e.call(this)) ?? !0;
        },
        getAdditionalParams: () => {
          const { colDef: e, column: t } = this.params, n = {
            colDef: e,
            column: t,
            valueFormatted: this.formattedValue ?? void 0
          };
          return this.isTree && (n.level = this.depth), n;
        }
      })
    ), this.addDestroyFunc(() => {
      var e;
      return (e = this.destroyCellRendererComponent) == null ? void 0 : e.call(this);
    }), this.render(), this.eCheckbox.setLabelEllipsis(!0).setValue(this.isSelected, !0).setDisabled(!!this.params.readOnly).getInputElement().setAttribute("tabindex", "-1"), this.refreshVariableAriaLabels(), this.isTree && (this.depth > 0 && (this.addCss("ag-set-filter-indent-" + this.depth), this.getGui().style.setProperty("--ag-indentation-level", String(this.depth))), this.isGroup ? this.setupExpansion() : this.groupsExist && this.addCss("ag-set-filter-add-group-indent"), rc(this.getAriaElement(), this.depth + 1)), this.refreshAriaChecked(), !this.params.readOnly && this.eCheckbox.onValueChange((e) => this.onCheckboxChanged(!!e));
  }
  getFocusableElement() {
    return this.focusWrapper;
  }
  setupExpansion() {
    const { eGroupClosedIcon: e, eGroupOpenedIcon: t, eGroupIndeterminateIcon: n, hasIndeterminateExpandState: o, beans: s } = this;
    e.appendChild(nr("setFilterGroupClosed", s, null)), t.appendChild(nr("setFilterGroupOpen", s, null));
    const i = this.onExpandOrContractClicked.bind(this);
    this.addManagedElementListeners(e, { click: i }), this.addManagedElementListeners(t, { click: i }), o && (n.appendChild(nr("setFilterGroupIndeterminate", s, null)), this.addManagedElementListeners(n, {
      click: i
    })), this.setExpandedIcons(), this.refreshAriaExpanded();
  }
  onExpandOrContractClicked() {
    this.setExpanded(!this.isExpanded);
  }
  setExpanded(e, t) {
    if (this.isGroup && e !== this.isExpanded) {
      this.isExpanded = e;
      const n = {
        type: "expandedChanged",
        isExpanded: !!e,
        item: this.item
      };
      t || this.dispatchLocalEvent(n), this.setExpandedIcons(), this.refreshAriaExpanded();
    }
  }
  setExpandedIcons() {
    const { isExpanded: e, hasIndeterminateExpandState: t, eGroupClosedIcon: n, eGroupOpenedIcon: o, eGroupIndeterminateIcon: s } = this;
    He(n, t ? e === !1 : !e), He(o, e === !0), t && He(s, e === void 0);
  }
  onCheckboxChanged(e) {
    this.isSelected = e;
    const t = {
      type: "selectionChanged",
      isSelected: e,
      item: this.item
    };
    this.dispatchLocalEvent(t), this.refreshVariableAriaLabels(), this.refreshAriaChecked();
  }
  toggleSelected() {
    this.params.readOnly || this.setSelected(!this.isSelected);
  }
  setSelected(e, t) {
    this.isSelected = e, this.eCheckbox.setValue(e, t), this.refreshAriaChecked();
  }
  refreshVariableAriaLabels() {
    if (!this.isTree)
      return;
    const e = this.getLocaleTextFunc(), t = this.eCheckbox.getValue(), n = t === void 0 ? e("ariaIndeterminate", "indeterminate") : t ? e("ariaVisible", "visible") : e("ariaHidden", "hidden"), o = e("ariaToggleVisibility", "Press SPACE to toggle visibility");
    Ms(this.eCheckbox.getInputElement(), void 0), this.eCheckbox.setInputAriaLabel(`${o} (${n})`);
  }
  setupFixedAriaLabels(e) {
    if (!this.isTree)
      return;
    const n = this.getLocaleTextFunc()("ariaFilterValue", "Filter Value"), o = this.getAriaElement();
    yt(o, `${e} ${n}`), ic(o, this.eCheckbox.getInputElement().id);
  }
  refreshAriaChecked() {
    const e = this.getAriaElement();
    dC(e, this.eCheckbox.getValue());
  }
  refreshAriaExpanded() {
    Zn(this.getAriaElement(), !!this.isExpanded);
  }
  refresh(e, t, n) {
    var a;
    this.item = e, t !== this.isSelected && this.setSelected(t, !0), this.setExpanded(n, !0);
    const { cellRendererComponent: o, cellRendererParams: s, beans: i, params: r } = this;
    if (this.valueFunction) {
      const l = this.valueFunction();
      this.setTooltipAndCellRendererParams(l, l), o || this.renderCellWithoutCellRenderer();
    }
    if (o) {
      const l = br(i.userCompFactory, r, s);
      if (!((a = o.refresh) == null ? void 0 : a.call(o, (l == null ? void 0 : l.params) ?? s))) {
        const c = o;
        this.renderCell(), this.destroyBean(c);
      }
    }
  }
  render() {
    const {
      params: { column: e }
    } = this;
    let { value: t } = this, n = null;
    typeof t == "function" ? (this.valueFunction = t, n = this.valueFunction(), t = n) : this.isTree ? n = Pn(t) : n = this.getFormattedValue(e, t), this.formattedValue = n, this.setTooltipAndCellRendererParams(t, n), this.renderCell();
  }
  setTooltipAndCellRendererParams(e, t) {
    var o;
    const n = this.gos;
    if (this.params.showTooltips && (!ua(n) || !this.params.cellRenderer)) {
      const s = t ?? Pn(e);
      this.shouldDisplayTooltip = Op(
        n,
        () => this.eCheckbox.getGui().querySelector(".ag-label")
      ), (o = this.tooltipFeature) == null || o.setTooltipAndRefresh(s);
    }
    this.cellRendererParams = ke(n, {
      value: e,
      valueFormatted: t,
      colDef: this.params.colDef,
      column: this.params.column,
      setTooltip: (s, i) => {
        var r;
        n.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = i, (r = this.tooltipFeature) == null || r.setTooltipAndRefresh(s);
      }
    });
  }
  getFormattedValue(e, t) {
    return this.beans.valueSvc.formatValue(e, null, t, this.valueFormatter, !1);
  }
  renderCell() {
    const e = br(this.beans.userCompFactory, this.params, this.cellRendererParams), t = e == null ? void 0 : e.newAgStackInstance();
    if (t == null) {
      this.renderCellWithoutCellRenderer();
      return;
    }
    t.then((n) => {
      n && (this.cellRendererComponent = n, this.eCheckbox.setLabel(n.getGui()), this.destroyCellRendererComponent = () => this.destroyBean(n));
    });
  }
  renderCellWithoutCellRenderer() {
    const { valueFormatted: e, value: t } = this.cellRendererParams;
    let n = e ?? t ?? this.translate("blanks");
    typeof n != "string" && (Z(208), n = ""), this.eCheckbox.setLabel(n), this.setupFixedAriaLabels(n);
  }
  getComponentHolder() {
    return this.params.column.getColDef();
  }
}, a$ = {
  loadingOoo: "Loading...",
  blanks: "(Blanks)",
  searchOoo: "Search...",
  selectAll: "(Select All)",
  selectAllSearchResults: "(Select All Search Results)",
  addCurrentSelectionToFilter: "Add current selection to filter",
  noMatches: "No matches.",
  ariaSearchFilterValues: "Search filter values",
  ariaFilterList: "Filter List",
  filterSummaryListInactive: "is (All)",
  filterSummaryListSeparator: ", ",
  filterSummaryListShort: (e) => `is (${e[0]})`,
  filterSummaryListLong: (e) => `is (${e[0]}) and ${e[1]} more`
};
function Xh(e, t, n) {
  let o = e;
  return o ? (o = o.map((s) => Pn(Gt(s))), !t && n && o.some((s) => s == null) ? Je(o) == null ? null : o.filter((s) => s != null) : o) : null;
}
function Sn(e, t, n) {
  return bC(e, a$, t, n);
}
function l$(e) {
  e.excelMode === "windows" ? (e.buttons || (e.buttons = ["apply", "cancel"]), e.closeOnApply == null && (e.closeOnApply = !0)) : e.excelMode === "mac" && (e.buttons || (e.buttons = ["reset"]), e.applyMiniFilterWhileTyping == null && (e.applyMiniFilterWhileTyping = !0), e.debounceMs == null && (e.debounceMs = 500)), e.excelMode && e.defaultToNothingSelected && (e.defaultToNothingSelected = !1, Z(207));
}
function d$() {
  return ([e, t], [n, o]) => {
    if (t == null)
      return o == null ? 0 : -1;
    if (o == null)
      return 1;
    for (let s = 0; s < t.length; s++) {
      if (s >= o.length)
        return 1;
      const i = vd(t[s], o[s]);
      if (i !== 0)
        return i;
    }
    return 0;
  };
}
var I0 = class {
  constructor(e, t, n, o) {
    this.formatter = e, this.treeListPathGetter = t, this.treeListFormatter = n, this.treeDataOrGrouping = o, this.allDisplayedItemsTree = /* @__PURE__ */ new Map(), this.activeDisplayedItemsFlat = [], this.selectAllItem = {
      depth: 0,
      filterPasses: !0,
      available: !0,
      treeKey: oi,
      children: this.allDisplayedItemsTree,
      expanded: !0,
      key: oi,
      parentTreeKeys: []
    }, this.addSelectionToFilterItem = {
      depth: 0,
      filterPasses: !0,
      available: !0,
      treeKey: si,
      expanded: !0,
      key: si,
      parentTreeKeys: []
    };
  }
  updateParams(e, t) {
    this.treeListPathGetter = e, this.treeListFormatter = t;
  }
  updateDisplayedValuesToAllAvailable(e, t, n, o) {
    o === "reload" ? this.generateItemTree(e, t, n) : o === "otherFilter" ? (this.updateAvailable(n), this.updateExpandAll()) : o === "miniFilter" && (this.resetFilter(), this.updateExpandAll()), this.flattenItems();
  }
  updateDisplayedValuesToMatchMiniFilter(e, t, n, o, s, i) {
    i === "reload" ? this.generateItemTree(e, t, n) : i === "otherFilter" && this.updateAvailable(n), this.updateFilter(o, s), this.updateExpandAll(), this.flattenItems();
  }
  generateItemTree(e, t, n) {
    const o = /* @__PURE__ */ new Map();
    this.allDisplayedItemsTree = o;
    let s = !1;
    const i = this.getTreeListPathGetter(e, n);
    for (const r of t) {
      const a = e(r), l = i(a) ?? [null], d = l.length;
      d > 1 && (s = !0);
      const c = n.has(r);
      let u = o, h, g = [];
      for (let p = 0; p < d; p++) {
        const f = l[p];
        u || (u = /* @__PURE__ */ new Map(), h.children = u);
        const m = (f == null ? void 0 : f.toUpperCase()) ?? null;
        h = u.get(m), h || (h = {
          treeKey: f,
          depth: p,
          filterPasses: !0,
          expanded: !1,
          available: c,
          parentTreeKeys: g
        }, p === l.length - 1 && (h.key = r), u.set(m, h)), u = h.children, g = [...g, f];
      }
    }
    this.groupsExist = s, this.updateAvailable(n), this.selectAllItem.children = o, this.selectAllItem.expanded = !1;
  }
  getTreeListPathGetter(e, t) {
    if (this.treeListPathGetter)
      return this.treeListPathGetter;
    if (this.treeDataOrGrouping)
      return (o) => o;
    let n = !1;
    for (const o of t) {
      const s = e(o);
      if (s instanceof Date) {
        n = !0;
        break;
      } else if (s != null)
        break;
    }
    return n ? (o) => zi(o, !1) : (Z(211), (o) => [String(o)]);
  }
  flattenItems() {
    this.activeDisplayedItemsFlat = [];
    const e = (t) => {
      for (const n of t.values())
        !n.filterPasses || !n.available || (this.activeDisplayedItemsFlat.push(n), n.children && n.expanded && e(n.children));
    };
    e(this.allDisplayedItemsTree);
  }
  resetFilter() {
    const e = (t) => {
      const n = t.children;
      if (n)
        for (const o of n.values())
          e(o);
      t.filterPasses = !0;
    };
    for (const t of this.allDisplayedItemsTree.values())
      e(t);
  }
  updateFilter(e, t) {
    const n = (o) => o.available ? o.treeKey == null ? t : e(
      this.formatter(
        this.treeListFormatter ? this.treeListFormatter(o.treeKey, o.depth, o.parentTreeKeys) : o.treeKey
      )
    ) : !1;
    for (const o of this.allDisplayedItemsTree.values())
      this.recursiveItemCheck(o, !1, n, "filterPasses");
  }
  getDisplayedValueCount() {
    return this.activeDisplayedItemsFlat.length;
  }
  getDisplayedItem(e) {
    return this.activeDisplayedItemsFlat[e];
  }
  getSelectAllItem() {
    return this.selectAllItem;
  }
  getAddSelectionToFilterItem() {
    return this.addSelectionToFilterItem;
  }
  getDisplayedKeys() {
    const e = [];
    return this.forEachDisplayedKey((t) => e.push(t)), e;
  }
  forEachDisplayedKey(e) {
    const t = (n, o) => {
      const s = n.children;
      if (s) {
        if (!n.expanded || !o)
          for (const i of s.values())
            i.filterPasses && t(i, !1);
      } else
        e(n.key);
    };
    this.activeDisplayedItemsFlat.forEach((n) => t(n, !0));
  }
  someDisplayedKey(e) {
    const t = (n, o) => {
      const s = n.children;
      if (s) {
        if (!n.expanded || !o) {
          for (const i of s.values())
            if (i.filterPasses && t(i, !1))
              return !0;
          return !1;
        }
      } else
        return e(n.key);
      return !1;
    };
    return this.activeDisplayedItemsFlat.some((n) => t(n, !0));
  }
  hasGroups() {
    return this.groupsExist;
  }
  refresh() {
    this.updateExpandAll(), this.flattenItems();
  }
  updateExpandAll() {
    const e = (n, o, s) => {
      for (const i of n.values()) {
        if (!i.filterPasses || !i.available || !i.children)
          continue;
        if (o = o || !!i.expanded, s = s || !i.expanded, o && s)
          return;
        const r = e(i.children, o, s);
        if (r === void 0)
          return;
        r ? o = !0 : s = !0;
      }
      return o && s ? void 0 : o;
    }, t = this.getSelectAllItem();
    t.expanded = e(t.children, !1, !1);
  }
  recursiveItemCheck(e, t, n, o) {
    let s = !1;
    const i = e.children;
    if (i)
      for (const a of i.values()) {
        const l = this.recursiveItemCheck(
          a,
          t || n(e),
          n,
          o
        );
        s = s || l;
      }
    const r = t || s || n(e);
    return e[o] = r, r;
  }
  updateAvailable(e) {
    const t = (n) => e.has(n.key);
    for (const n of this.allDisplayedItemsTree.values())
      this.recursiveItemCheck(n, !1, t, "available");
  }
}, Zb = class extends Dw {
  constructor() {
    super("setFilter", "set-filter"), this.filterType = "set", this.eMiniFilter = X, this.eFilterLoading = X, this.eFilterLoadingIcon = X, this.eSetFilterList = X, this.eFilterNoMatches = X, this.hardRefreshVirtualList = !1, this.miniFilterText = null, this.addCurrentSelectionToFilter = !1, this.selectedKeys = /* @__PURE__ */ new Set();
  }
  setParams(e) {
    super.setParams(e);
    const t = this.updateHandler(e.getHandler()), { column: n, textFormatter: o, treeList: s, treeListPathGetter: i, treeListFormatter: r } = e;
    this.formatter = o ?? ((a) => a ?? null), this.displayValueModel = s ? new I0(
      this.formatter,
      i,
      r,
      t.isTreeDataOrGrouping()
    ) : new o$(
      this.beans.valueSvc,
      () => this.handler.valueFormatter,
      this.formatter,
      n
    ), t.valueModel.allKeys.then((a) => {
      this.updateDisplayedValues("reload", a ?? []), this.resetSelectionState(a ?? []);
    }), t.valueModel.isLoading() && this.setIsLoading(!0), this.initialiseFilterBodyUi();
  }
  refresh(e) {
    return this.params.treeList !== e.treeList ? !1 : (this.updateHandler(
      e.getHandler()
    ), super.refresh(e));
  }
  updateParams(e, t) {
    super.updateParams(e, t), this.updateMiniFilter(), e.suppressSelectAll !== t.suppressSelectAll && this.createVirtualListModel(e);
    const { textFormatter: n, treeListPathGetter: o, treeListFormatter: s } = e;
    this.formatter = n ?? ((i) => i ?? null), this.displayValueModel instanceof I0 && this.displayValueModel.updateParams(o, s), this.handler.refreshFilterValues(!0);
  }
  updateHandler(e) {
    var n;
    return this.handler !== e && ((n = this.handlerDestroyFuncs) == null || n.forEach((o) => o()), this.handlerDestroyFuncs = [
      ...this.addManagedListeners(e, {
        anyFilterChanged: (o) => {
          e.valueModel.allKeys.then((s) => {
            this.isAlive() && (this.updateDisplayedValues("otherFilter", s ?? []), o.updated && (this.checkAndRefreshVirtualList(), this.showOrHideResults()));
          });
        },
        dataChanged: ({ hardRefresh: o }) => {
          e.valueModel.allKeys.then((s) => {
            var i;
            this.isAlive() && (this.updateDisplayedValues("reload", s ?? []), this.setSelectedModel(((i = this.state.model) == null ? void 0 : i.values) ?? null), o && (this.hardRefreshVirtualList = !0), this.checkAndRefreshVirtualList());
          });
        }
      }),
      ...this.addManagedListeners(e.valueModel, {
        loadingStart: () => this.setIsLoading(!0),
        loadingEnd: () => this.setIsLoading(!1)
      })
    ], this.handler = e), e;
  }
  // unlike the simple filters, nothing in the set filter UI shows/hides.
  // maybe this method belongs in abstractSimpleFilter???
  updateUiVisibility() {
  }
  createBodyTemplate() {
    return {
      tag: "div",
      cls: "ag-set-filter",
      children: [
        {
          tag: "div",
          ref: "eFilterLoading",
          cls: "ag-filter-loading ag-loading ag-hidden",
          children: [
            { tag: "span", ref: "eFilterLoadingIcon", cls: "ag-loading-icon" },
            { tag: "span", cls: "ag-loading-text", children: Sn(this, "loadingOoo") }
          ]
        },
        { tag: "ag-input-text-field", ref: "eMiniFilter", cls: "ag-mini-filter" },
        {
          tag: "div",
          ref: "eFilterNoMatches",
          cls: "ag-filter-no-matches ag-hidden",
          children: Sn(this, "noMatches")
        },
        { tag: "div", ref: "eSetFilterList", cls: "ag-set-filter-list", role: "presentation" }
      ]
    };
  }
  getAgComponents() {
    return [ao];
  }
  handleKeyDown(e) {
    var n, o, s;
    if (super.handleKeyDown(e), e.defaultPrevented)
      return;
    const t = () => {
      if (!this.eSetFilterList.contains(je(this.beans)))
        return;
      const i = this.virtualList.getLastFocusedRow();
      if (i == null)
        return;
      const r = this.virtualList.getComponentAt(i);
      if (r == null)
        return;
      e.preventDefault();
      const { readOnly: a } = this.params;
      if (!a)
        return r;
    };
    switch (e.key) {
      case O.SPACE:
        (n = t()) == null || n.toggleSelected();
        break;
      case O.ENTER:
        this.handleKeyEnter(e);
        break;
      case O.LEFT:
        (o = t()) == null || o.setExpanded(!1);
        break;
      case O.RIGHT:
        (s = t()) == null || s.setExpanded(!0);
        break;
    }
  }
  handleKeyEnter(e) {
    e.preventDefault();
    const { excelMode: t, readOnly: n } = this.params;
    !t || n || (this.params.onAction("apply", void 0, e), this.params.excelMode === "mac" && this.eMiniFilter.getInputElement().select());
  }
  setModelAndRefresh(e) {
    return this.setSelectedModel(e).then(() => {
      this.isAlive() && this.checkAndRefreshVirtualList();
    });
  }
  setModelIntoUi(e) {
    var n;
    this.setMiniFilter(((n = this.params.state.state) == null ? void 0 : n.miniFilterValue) ?? null, !0);
    const t = e == null ? null : e.values;
    return this.setModelAndRefresh(t);
  }
  getModelFromUi() {
    const e = this.getSelectedModel();
    return e ? { values: e, filterType: this.filterType } : null;
  }
  areNonNullModelsEqual(e, t) {
    return Yn(e.values, t.values);
  }
  setIsLoading(e) {
    He(this.eFilterLoading, e), e || (this.hardRefreshVirtualList = !0);
  }
  initialiseFilterBodyUi() {
    this.initVirtualList(), this.initMiniFilter(), this.initLoading();
  }
  initLoading() {
    const e = Le("setFilterLoading", this.beans, this.params.column);
    e && this.eFilterLoadingIcon.appendChild(e);
  }
  initVirtualList() {
    const e = Sn(this, "ariaFilterList"), t = !!this.params.treeList, n = this.virtualList = this.createBean(
      new Lr({
        cssIdentifier: "filter",
        ariaRole: t ? "tree" : "listbox",
        listName: e
      })
    ), o = this.eSetFilterList;
    t && o.classList.add("ag-set-filter-tree-list"), o.appendChild(n.getGui());
    const { cellHeight: s } = this.params;
    s != null && n.setRowHeight(s);
    const i = (a, l) => this.createSetListItem(a, t, l);
    n.setComponentCreator(i);
    const r = (a, l) => this.updateSetListItem(a, l);
    n.setComponentUpdater(r), this.createVirtualListModel(this.params);
  }
  createVirtualListModel(e) {
    let t;
    e.suppressSelectAll ? t = new c$(this.displayValueModel) : t = new u$(
      this.displayValueModel,
      this.showAddCurrentSelectionToFilter.bind(this)
    ), e.treeList && (t = new h$(t)), this.virtualList.setModel(t);
  }
  getSelectAllLabel() {
    const e = this.miniFilterText == null || !this.params.excelMode ? "selectAll" : "selectAllSearchResults";
    return Sn(this, e);
  }
  getAddSelectionToFilterLabel() {
    return Sn(this, "addCurrentSelectionToFilter");
  }
  createSetListItem(e, t, n) {
    const o = this.displayValueModel.hasGroups(), { isSelected: s, isExpanded: i } = this.isSelectedExpanded(e), { value: r, depth: a, isGroup: l, hasIndeterminateExpandState: d, selectedListener: c, expandedListener: u } = this.newSetListItemAttributes(e), h = {
      focusWrapper: n,
      value: r,
      params: this.params,
      translate: (p) => Sn(this, p),
      valueFormatter: this.handler.valueFormatter,
      item: e,
      isSelected: s,
      isTree: t,
      depth: a,
      groupsExist: o,
      isGroup: l,
      isExpanded: i,
      hasIndeterminateExpandState: d
    }, g = this.createBean(new r$(h));
    return g.addEventListener("selectionChanged", c), u && g.addEventListener("expandedChanged", u), g;
  }
  newSetTreeItemAttributes(e) {
    var n, o, s, i;
    const t = this.displayValueModel.hasGroups();
    return e.key === oi ? {
      value: () => this.getSelectAllLabel(),
      isGroup: t,
      depth: e.depth,
      hasIndeterminateExpandState: !0,
      selectedListener: (r) => this.onSelectAll(r.isSelected),
      expandedListener: (r) => this.onExpandAll(r.item, r.isExpanded)
    } : e.key === si ? {
      value: () => this.getAddSelectionToFilterLabel(),
      depth: e.depth,
      isGroup: !1,
      hasIndeterminateExpandState: !1,
      selectedListener: (r) => {
        this.addCurrentSelectionToFilter = r.isSelected, this.refreshAfterSelection();
      }
    } : e.children ? {
      value: ((o = (n = this.params).treeListFormatter) == null ? void 0 : o.call(n, e.treeKey, e.depth, e.parentTreeKeys)) ?? e.treeKey,
      depth: e.depth,
      isGroup: !0,
      selectedListener: (r) => this.onGroupItemSelected(r.item, r.isSelected),
      expandedListener: (r) => this.onExpandedChanged(r.item, r.isExpanded)
    } : {
      value: ((i = (s = this.params).treeListFormatter) == null ? void 0 : i.call(s, e.treeKey, e.depth, e.parentTreeKeys)) ?? e.treeKey,
      depth: e.depth,
      selectedListener: (r) => this.onItemSelected(r.item.key, r.isSelected)
    };
  }
  newSetListItemAttributes(e) {
    return this.isSetFilterModelTreeItem(e) ? this.newSetTreeItemAttributes(e) : e === oi ? {
      value: () => this.getSelectAllLabel(),
      selectedListener: (t) => this.onSelectAll(t.isSelected)
    } : e === si ? {
      value: () => this.getAddSelectionToFilterLabel(),
      selectedListener: (t) => {
        this.addCurrentSelectionToFilter = t.isSelected, this.refreshAfterSelection();
      }
    } : {
      value: this.handler.valueModel.allValues.get(e) ?? null,
      selectedListener: (t) => this.onItemSelected(t.item, t.isSelected)
    };
  }
  updateSetListItem(e, t) {
    const { isSelected: n, isExpanded: o } = this.isSelectedExpanded(e);
    t.refresh(e, n, o);
  }
  isSelectedExpanded(e) {
    let t, n;
    return this.isSetFilterModelTreeItem(e) ? (n = e.expanded, e.key === oi ? t = this.isSelectAllSelected() : e.key === si ? t = this.isAddCurrentSelectionToFilterChecked() : e.children ? t = this.areAllChildrenSelected(e) : t = this.selectedKeys.has(e.key)) : e === oi ? t = this.isSelectAllSelected() : e === si ? t = this.isAddCurrentSelectionToFilterChecked() : t = this.selectedKeys.has(e), { isSelected: t, isExpanded: n };
  }
  isSetFilterModelTreeItem(e) {
    return (e == null ? void 0 : e.treeKey) !== void 0;
  }
  initMiniFilter() {
    const { eMiniFilter: e } = this;
    this.updateMiniFilter(), e.onValueChange(() => this.onMiniFilterInput()), e.setInputAriaLabel(Sn(this, "ariaSearchFilterValues")), this.addManagedElementListeners(e.getInputElement(), {
      keydown: (t) => this.onMiniFilterKeyDown(t)
    });
  }
  updateMiniFilter() {
    const { eMiniFilter: e, miniFilterText: t, params: n } = this;
    e.setDisplayed(!n.suppressMiniFilter), e.setValue(t);
  }
  // we need to have the GUI attached before we can draw the virtual rows, as the
  // virtual row logic needs info about the GUI state
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.resetExpansion(), this.refreshVirtualList();
    const { eMiniFilter: t } = this;
    t.setInputPlaceholder(Sn(this, "searchOoo")), (!e || !e.suppressFocus) && (t.isDisplayed() ? t.getFocusableElement().focus() : this.virtualList.awaitStable(() => this.virtualList.focusRow(0)));
  }
  afterGuiDetached() {
    var s;
    super.afterGuiDetached();
    const { column: e, excelMode: t, model: n, onStateChange: o } = this.params;
    (s = this.beans.colFilter) != null && s.shouldKeepStateOnDetach(e) || (t && this.resetMiniFilter(), (t || n !== this.state.model) && (o({
      model: n,
      state: this.getState()
    }), this.showOrHideResults()));
  }
  canApply(e) {
    return this.params.excelMode ? e == null || e.values.length > 0 : !0;
  }
  /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */
  onNewRowsLoaded() {
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  setFilterValues(e) {
    Z(283), this.handler.setFilterValues(e);
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  resetFilterValues() {
    Z(283), this.handler.resetFilterValues();
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  refreshFilterValues() {
    Z(283), this.doRefreshFilterValues();
  }
  doRefreshFilterValues() {
    this.handler.refreshFilterValues();
  }
  /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */
  onAnyFilterChanged() {
  }
  onMiniFilterInput(e) {
    if (!this.doSetMiniFilter(this.eMiniFilter.getValue()))
      return;
    if (e) {
      this.showOrHideResults();
      return;
    }
    const { applyMiniFilterWhileTyping: t, readOnly: n, excelMode: o } = this.params, s = !n && (t || !!o), i = t && !n ? "debounce" : void 0;
    this.updateUiAfterMiniFilterChange(s, i);
  }
  updateUiAfterMiniFilterChange(e, t) {
    if (e) {
      const { excelMode: n, readOnly: o, model: s } = this.params;
      n && !o && this.miniFilterText == null ? this.setModelAndRefresh((s == null ? void 0 : s.values) ?? null) : this.selectAllMatchingMiniFilter(!0);
    }
    this.checkAndRefreshVirtualList(), this.onUiChanged(e ? t : "prevent"), this.showOrHideResults();
  }
  showOrHideResults() {
    const e = this.miniFilterText != null && this.displayValueModel.getDisplayedValueCount() < 1;
    He(this.eFilterNoMatches, e), He(this.eSetFilterList, !e);
  }
  resetMiniFilter() {
    this.eMiniFilter.setValue(null, !0), this.doSetMiniFilter(null);
  }
  onMiniFilterKeyDown(e) {
    const { excelMode: t, readOnly: n } = this.params;
    e.key === O.ENTER && !t && !n && this.updateUiAfterMiniFilterChange(!0, "immediately");
  }
  focusRowIfAlive(e) {
    return e == null ? Promise.resolve() : new Promise((t) => {
      window.setTimeout(() => {
        this.isAlive() && this.virtualList.focusRow(e), t();
      }, 0);
    });
  }
  onSelectAll(e) {
    e ? this.selectAllMatchingMiniFilter() : this.deselectAllMatchingMiniFilter(), this.refreshAfterSelection();
  }
  onGroupItemSelected(e, t) {
    const n = (o) => {
      if (!o.filterPasses)
        return;
      const s = o.children;
      if (s)
        for (const i of s.values())
          n(i);
      else
        this.setKeySelected(o.key, t);
    };
    n(e), this.refreshAfterSelection();
  }
  onItemSelected(e, t) {
    this.setKeySelected(e, t), this.refreshAfterSelection();
  }
  onExpandAll(e, t) {
    const n = (o) => {
      if (o.filterPasses && o.available && o.children) {
        for (const s of o.children.values())
          n(s);
        o.expanded = t;
      }
    };
    n(e), this.refreshAfterExpansion();
  }
  onExpandedChanged(e, t) {
    e.expanded = t, this.refreshAfterExpansion();
  }
  refreshAfterExpansion() {
    const e = this.virtualList.getLastFocusedRow();
    this.updateDisplayedValues("expansion"), this.checkAndRefreshVirtualList(), this.focusRowIfAlive(e);
  }
  refreshAfterSelection() {
    const e = this.virtualList.getLastFocusedRow();
    this.checkAndRefreshVirtualList(), this.onUiChanged(), this.focusRowIfAlive(e);
  }
  setMiniFilter(e, t) {
    this.eMiniFilter.setValue(e, t), this.onMiniFilterInput(t);
  }
  /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */
  doSetMiniFilter(e) {
    return e = Gt(e), this.miniFilterText === e ? !1 : (e === null && (this.addCurrentSelectionToFilter = !1), this.miniFilterText = e, this.updateDisplayedValues("miniFilter"), !0);
  }
  getMiniFilter() {
    return this.miniFilterText;
  }
  getUiChangeEventParams() {
    return {
      miniFilterValue: this.miniFilterText
    };
  }
  getState() {
    const e = this.miniFilterText;
    return e ? { miniFilterValue: e } : void 0;
  }
  checkAndRefreshVirtualList() {
    this.virtualList.refresh(!this.hardRefreshVirtualList), this.hardRefreshVirtualList && (this.hardRefreshVirtualList = !1);
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  getFilterKeys() {
    return Z(283), this.handler.getFilterKeys();
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  getFilterValues() {
    return Z(283), this.handler.getFilterValues();
  }
  refreshVirtualList() {
    this.params.refreshValuesOnOpen ? this.doRefreshFilterValues() : this.checkAndRefreshVirtualList();
  }
  isSelectAllSelected() {
    if (this.params.defaultToNothingSelected) {
      if (this.hasSelections() && this.isEverythingVisibleSelected())
        return !0;
      if (this.isNothingVisibleSelected())
        return !1;
    } else {
      if (this.hasSelections() && this.isNothingVisibleSelected())
        return !1;
      if (this.isEverythingVisibleSelected())
        return !0;
    }
  }
  areAllChildrenSelected(e) {
    const t = (n) => {
      if (n.children) {
        let o = !1, s = !1;
        for (const i of n.children.values()) {
          if (!i.filterPasses || !i.available)
            continue;
          const r = t(i);
          if (r === void 0 || (r ? o = !0 : s = !0, o && s))
            return;
        }
        return o;
      } else
        return this.selectedKeys.has(n.key);
    };
    return this.params.defaultToNothingSelected ? this.hasSelections() && t(e) : t(e);
  }
  resetExpansion() {
    if (!this.params.treeList)
      return;
    const e = this.displayValueModel.getSelectAllItem();
    if (this.isSetFilterModelTreeItem(e)) {
      const t = (n) => {
        const o = n.children;
        if (o) {
          for (const s of o.values())
            t(s);
          n.expanded = !1;
        }
      };
      t(e), this.updateDisplayedValues("expansion");
    }
  }
  getModelAsString(e) {
    return this.handler.getModelAsString(e);
  }
  getPositionableElement() {
    return this.eSetFilterList;
  }
  updateDisplayedValues(e, t) {
    if (e === "expansion") {
      this.displayValueModel.refresh();
      return;
    }
    const n = this.handler, o = n.valueModel;
    if (this.miniFilterText == null) {
      this.displayValueModel.updateDisplayedValuesToAllAvailable(
        (a) => o.allValues.get(a) ?? null,
        t,
        o.availableKeys,
        e
      );
      return;
    }
    const s = n.caseFormat(this.formatter(this.miniFilterText) || ""), i = (a) => a != null && n.caseFormat(a).indexOf(s) >= 0, r = !!this.params.excelMode && i(Sn(this, "blanks"));
    this.displayValueModel.updateDisplayedValuesToMatchMiniFilter(
      (a) => o.allValues.get(a) ?? null,
      t,
      o.availableKeys,
      i,
      r,
      e
    );
  }
  hasSelections() {
    return this.params.defaultToNothingSelected ? this.selectedKeys.size > 0 : this.handler.valueModel.allValues.size !== this.selectedKeys.size;
  }
  isInWindowsExcelMode() {
    return this.params.excelMode === "windows";
  }
  isAddCurrentSelectionToFilterChecked() {
    return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
  }
  showAddCurrentSelectionToFilter() {
    return this.isInWindowsExcelMode() && ue(this.miniFilterText) && this.miniFilterText.length > 0;
  }
  selectAllMatchingMiniFilter(e = !1) {
    this.miniFilterText == null ? this.selectedKeys = new Set(this.handler.valueModel.allValues.keys()) : (e && this.selectedKeys.clear(), this.displayValueModel.forEachDisplayedKey((t) => this.selectedKeys.add(t)));
  }
  deselectAllMatchingMiniFilter() {
    this.miniFilterText == null ? this.selectedKeys.clear() : this.displayValueModel.forEachDisplayedKey((e) => this.selectedKeys.delete(e));
  }
  setKeySelected(e, t) {
    t ? this.selectedKeys.add(e) : (this.params.excelMode && this.isEverythingVisibleSelected() && this.resetSelectionState(this.displayValueModel.getDisplayedKeys()), this.selectedKeys.delete(e));
  }
  isEverythingVisibleSelected() {
    return !this.displayValueModel.someDisplayedKey((e) => !this.selectedKeys.has(e));
  }
  isNothingVisibleSelected() {
    return !this.displayValueModel.someDisplayedKey((e) => this.selectedKeys.has(e));
  }
  getSelectedModel() {
    var t;
    if (!this.hasSelections())
      return null;
    const e = this.isAddCurrentSelectionToFilterChecked() ? (t = this.params.model) == null ? void 0 : t.values : void 0;
    if (e != null && e.length) {
      if (this.selectedKeys) {
        const n = /* @__PURE__ */ new Set([...e, ...this.selectedKeys]);
        return Array.from(n);
      }
      return Array.from(e);
    }
    return Array.from(this.selectedKeys);
  }
  setSelectedModel(e) {
    const t = this.handler, n = t.valueModel;
    return n.allKeys.then((o) => {
      if (e == null)
        this.resetSelectionState(o ?? []);
      else {
        this.selectedKeys.clear();
        const s = /* @__PURE__ */ new Map();
        n.allValues.forEach((i, r) => {
          s.set(t.caseFormat(r), r);
        }), e.forEach((i) => {
          const r = t.caseFormat(Gt(i)), a = s.get(r);
          a !== void 0 && this.selectedKeys.add(a);
        });
      }
    });
  }
  resetSelectionState(e) {
    this.params.defaultToNothingSelected ? this.selectedKeys.clear() : this.selectedKeys = new Set(e);
  }
  getFilterHandler() {
    return this.handler;
  }
  destroy() {
    var e;
    this.virtualList = this.destroyBean(this.virtualList), (e = this.handlerDestroyFuncs) == null || e.forEach((t) => t()), this.handler = void 0, this.displayValueModel = void 0, this.selectedKeys.clear(), super.destroy();
  }
}, c$ = class {
  constructor(e) {
    this.model = e;
  }
  getRowCount() {
    return this.model.getDisplayedValueCount();
  }
  getRow(e) {
    return this.model.getDisplayedItem(e);
  }
  areRowsEqual(e, t) {
    return e === t;
  }
}, u$ = class {
  constructor(e, t) {
    this.model = e, this.showAddCurrentSelectionToFilter = t;
  }
  getRowCount() {
    const t = this.showAddCurrentSelectionToFilter() ? 2 : 1;
    return this.model.getDisplayedValueCount() + t;
  }
  getRow(e) {
    if (e === 0)
      return this.model.getSelectAllItem();
    const t = this.showAddCurrentSelectionToFilter(), n = t ? 2 : 1;
    return e === 1 && t ? this.model.getAddSelectionToFilterItem() : this.model.getDisplayedItem(e - n);
  }
  areRowsEqual(e, t) {
    return e === t;
  }
}, h$ = class {
  constructor(e) {
    this.model = e;
  }
  getRowCount() {
    return this.model.getRowCount();
  }
  getRow(e) {
    return this.model.getRow(e);
  }
  areRowsEqual(e, t) {
    return e == null && t == null ? !0 : e != null && t != null && e.treeKey === t.treeKey && e.depth === t.depth;
  }
}, g$ = class extends U {
  constructor(e, t, n, o, s) {
    super(), this.createKey = e, this.caseFormat = t, this.getValue = n, this.isTreeDataOrGrouping = o, this.isTreeData = s;
  }
  extractUniqueValuesAsync(e, t) {
    return new tt((n) => {
      if (this.beans.rowModel.isRowDataLoaded())
        n(this.extractUniqueValues(e, t));
      else {
        const [o] = this.addManagedEventListeners({
          rowCountReady: () => {
            o == null || o(), n(this.extractUniqueValues(e, t));
          }
        });
      }
    });
  }
  extractUniqueValues(e, t) {
    var c;
    const n = /* @__PURE__ */ new Map(), o = this.extractExistingFormattedKeys(t), s = /* @__PURE__ */ new Set(), i = this.isTreeData(), r = this.isTreeDataOrGrouping(), a = (c = this.beans.rowGroupColsSvc) == null ? void 0 : c.columns, l = this.gos.get("groupAllowUnbalanced"), d = (u, h) => {
      const g = this.caseFormat(u);
      if (!s.has(g)) {
        s.add(g);
        let p = u, f = Gt(h);
        const m = o == null ? void 0 : o.get(g);
        m != null && (p = m, f = t.get(m)), n.set(p, f);
      }
    };
    return this.beans.rowModel.forEachLeafNode((u) => {
      if (!u.data || !e(u))
        return;
      if (r) {
        this.addValueForTreeDataOrGrouping(u, i, a, d, l);
        return;
      }
      const h = this.getValue(u);
      h != null && Array.isArray(h) ? (h.forEach((g) => {
        d(this.createKey(g, u), g);
      }), h.length === 0 && d(null, null)) : d(this.createKey(h, u), h);
    }), n;
  }
  addValueForTreeDataOrGrouping(e, t, n = [], o, s) {
    var a;
    let i;
    if (t) {
      if ((a = e.childrenAfterGroup) != null && a.length)
        return;
      i = e.getRoute() ?? [e.key ?? e.id];
    } else
      i = n.map((l) => this.beans.valueSvc.getKeyForNode(l, e)), i.push(this.getValue(e));
    const r = Xh(i, t, s);
    o(this.createKey(r), r);
  }
  extractExistingFormattedKeys(e) {
    if (!e)
      return null;
    const t = /* @__PURE__ */ new Map();
    return e.forEach((n, o) => {
      t.set(this.caseFormat(o), o);
    }), t;
  }
}, p$ = class {
  constructor(e) {
    this.caseFormat = e, this.keys = null;
  }
  /** No model applied */
  isNull() {
    return this.keys == null;
  }
  /** Nothing selected */
  isEmpty() {
    var e;
    return !((e = this.keys) != null && e.size);
  }
  update(e) {
    const t = /* @__PURE__ */ new Set();
    this.keys = t;
    const n = e == null ? void 0 : e.values;
    if (n) {
      const o = this.caseFormat;
      for (let s = 0, i = n.length; s < i; s++)
        t.add(o(n[s]));
    }
  }
  has(e) {
    var t;
    return !!((t = this.keys) != null && t.has(this.caseFormat(e)));
  }
  destroy() {
    this.keys = null;
  }
}, qb = /* @__PURE__ */ ((e) => (e[e.PROVIDED_LIST = 0] = "PROVIDED_LIST", e[e.PROVIDED_CALLBACK = 1] = "PROVIDED_CALLBACK", e[e.TAKEN_FROM_GRID_VALUES = 2] = "TAKEN_FROM_GRID_VALUES", e))(qb || {}), Vu = qb, f$ = class extends U {
  constructor(e, t, n, o, s) {
    super(), this.clientSideValuesExtractor = e, this.caseFormat = t, this.createKey = n, this.isTreeDataOrGrouping = o, this.params = s, this.allValues = /* @__PURE__ */ new Map(), this.availableKeys = /* @__PURE__ */ new Set(), this.providedValues = null, this.initialised = !1;
  }
  postConstruct() {
    const e = this.params, t = e.handlerParams.filterParams.values;
    this.updateParams(e), t == null ? this.valuesType = 2 : (this.valuesType = Array.isArray(t) ? 0 : 1, this.providedValues = t), this.updateAllValues();
  }
  refresh(e) {
    const t = e.handlerParams;
    if (t.source !== "colDef")
      return;
    const { values: n, suppressSorting: o } = t.filterParams, s = this.providedValues, i = this.params.handlerParams.filterParams.suppressSorting;
    this.params = e, this.updateParams(e), this.providedValues = n ?? null, (this.providedValues !== s || o !== i) && (!n || n.length === 0 ? (this.valuesType = 2, this.providedValues = null) : this.valuesType = Array.isArray(n) ? 0 : 1, this.updateAllValues());
  }
  updateParams(e) {
    const {
      handlerParams: {
        colDef: t,
        filterParams: { comparator: n, treeList: o, treeListPathGetter: s }
      },
      usingComplexObjects: i
    } = e, r = n ?? t.comparator, a = this.isTreeDataOrGrouping();
    let l;
    a && !r ? l = d$() : o && !s && !r ? l = ([d, c], [u, h]) => vd(c, h) : l = ([d, c], [u, h]) => r(c, h), this.entryComparator = l, this.keyComparator = r ?? vd, this.compareByValue = !!(i && r || a || o && !s);
  }
  updateAllValues() {
    return this.allKeys = new tt((e) => {
      switch (this.valuesType) {
        case 2:
          this.getValuesFromRowsAsync().then((t) => e(this.processAllValues(t)));
          break;
        case 0: {
          e(
            this.processAllValues(
              this.uniqueValues(this.validateProvidedValues(this.providedValues))
            )
          );
          break;
        }
        case 1: {
          this.dispatchLocalEvent({ type: "loadingStart" });
          const t = this.providedValues, { column: n, colDef: o } = this.params.handlerParams, s = ke(this.gos, {
            success: (i) => {
              this.dispatchLocalEvent({ type: "loadingEnd" }), e(this.processAllValues(this.uniqueValues(this.validateProvidedValues(i))));
            },
            colDef: o,
            column: n
          });
          window.setTimeout(() => t(s), 0);
          break;
        }
      }
    }), this.allKeys.then((e) => {
      this.updateAvailableKeys(e ?? []), this.initialised = !0;
    }), this.allKeys;
  }
  getAvailableValues(e) {
    return this.sortKeys(this.getValuesFromRows(e));
  }
  overrideValues(e) {
    return this.allKeys.then(() => {
      this.valuesType = 0, this.providedValues = e;
    });
  }
  refreshAvailable() {
    return new tt((e) => {
      if (this.showAvailableOnly()) {
        this.allKeys.then((t) => {
          const n = t ?? [];
          this.updateAvailableKeys(n), e(!0);
        });
        return;
      }
      e(!1);
    });
  }
  refreshAll() {
    return new tt((e) => {
      this.allKeys.then(() => {
        this.updateAllValues().then(() => {
          e();
        });
      });
    });
  }
  isLoading() {
    return !this.initialised && this.valuesType === 1;
  }
  isInitialised() {
    return this.initialised;
  }
  getValueForFormatter(e) {
    return this.initialised ? this.allValues.get(e) : e;
  }
  getAvailableKeys(e) {
    return this.initialised ? e.filter((t) => this.availableKeys.has(t)) : e;
  }
  getParamsForValuesFromRows(e) {
    if (!this.clientSideValuesExtractor) {
      $e(113);
      return;
    }
    return e && !this.params.handlerParams.filterParams.caseSensitive ? this.allValues : void 0;
  }
  getValuesFromRows(e) {
    var n;
    const t = this.getParamsForValuesFromRows(!0);
    return ((n = this.clientSideValuesExtractor) == null ? void 0 : n.extractUniqueValues(e, t)) ?? null;
  }
  getValuesFromRowsAsync() {
    var t;
    const e = this.getParamsForValuesFromRows(!1);
    return ((t = this.clientSideValuesExtractor) == null ? void 0 : t.extractUniqueValuesAsync(() => !0, e)) ?? tt.resolve(null);
  }
  processAllValues(e) {
    const t = this.sortKeys(e);
    return this.allValues = e ?? /* @__PURE__ */ new Map(), t;
  }
  uniqueValues(e) {
    const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), { caseFormat: o, createKey: s } = this;
    return (e ?? []).forEach((i) => {
      const r = Gt(i), a = s(r), l = o(a);
      n.has(l) || (n.add(l), t.set(a, r));
    }), t;
  }
  validateProvidedValues(e) {
    if (this.params.usingComplexObjects && (e != null && e.length)) {
      const t = e[0];
      t && typeof t != "object" && typeof t != "function" && (this.createKey(t) == null ? Z(209) : Z(210));
    }
    return e;
  }
  sortKeys(e) {
    const t = e ?? /* @__PURE__ */ new Map(), n = this.params.handlerParams.filterParams;
    if (n.suppressSorting)
      return Array.from(t.keys());
    let o;
    return this.compareByValue ? o = Array.from(t.entries()).sort(this.entryComparator).map(([s]) => s) : o = Array.from(t.keys()).sort(this.keyComparator), n.excelMode && t.has(null) && (o = o.filter((s) => s != null), o.push(null)), o;
  }
  showAvailableOnly() {
    return this.valuesType === 2;
  }
  updateAvailableKeys(e) {
    const t = this.showAvailableOnly() ? this.getAvailableValues((n) => this.params.handlerParams.doesRowPassOtherFilter(n)) : e;
    this.availableKeys = new Set(t), this.dispatchLocalEvent({ type: "availableValuesChanged" });
  }
}, m$ = class extends U {
  constructor() {
    super(...arguments), this.filterType = "set", this.treeDataTreeList = !1, this.groupingTreeList = !1, this.caseSensitive = !1, this.noValueFormatterSupplied = !1;
  }
  init(e) {
    this.updateParams(e);
    const t = this.isTreeDataOrGrouping.bind(this), n = () => this.treeDataTreeList, o = this.createKey, s = this.caseFormat.bind(this), { gos: i, beans: r } = this, a = Ct(i, r.rowModel) ? this.createManagedBean(
      new g$(
        o,
        s,
        e.getValue,
        t,
        n
      )
    ) : void 0;
    this.valueModel = this.createManagedBean(
      new f$(a, s, o, t, {
        handlerParams: e,
        usingComplexObjects: !!(e.filterParams.keyCreator ?? e.colDef.keyCreator)
      })
    ), this.appliedModel = new p$(this.caseFormat.bind(this)), this.appliedModel.update(e.model), this.validateModel(e), this.addEventListenersForDataChanges();
  }
  refresh(e) {
    this.updateParams(e), this.valueModel.refresh({
      handlerParams: e,
      usingComplexObjects: !!(e.filterParams.keyCreator ?? e.colDef.keyCreator)
    }), this.appliedModel.update(e.model), this.validateModel(e);
  }
  updateParams(e) {
    var l;
    this.params = e;
    const {
      colDef: t,
      filterParams: { caseSensitive: n, treeList: o, keyCreator: s, valueFormatter: i }
    } = e;
    this.caseSensitive = !!n;
    const r = !!t.showRowGroup;
    this.treeDataTreeList = this.gos.get("treeData") && !!o && r, this.groupingTreeList = !!((l = this.beans.rowGroupColsSvc) != null && l.columns.length) && !!o && r;
    const a = s ?? t.keyCreator;
    this.createKey = this.generateCreateKey(a, this.isTreeDataOrGrouping()), this.setValueFormatter(i, a, !!o, !!t.refData);
  }
  doesFilterPass(e) {
    const { appliedModel: t, treeDataTreeList: n, groupingTreeList: o } = this;
    if (t.isNull())
      return !0;
    if (t.isEmpty())
      return !1;
    const { node: s } = e;
    if (n)
      return this.doesFilterPassForTreeData(s);
    if (o)
      return this.doesFilterPassForGrouping(s);
    const i = this.params.getValue(s);
    return i != null && Array.isArray(i) ? i.length === 0 ? t.has(null) : i.some((r) => t.has(this.createKey(r, s))) : t.has(this.createKey(i, s));
  }
  getFormattedValue(e) {
    let t = this.valueModel.getValueForFormatter(e);
    this.noValueFormatterSupplied && this.isTreeDataOrGrouping() && Array.isArray(t) && (t = Je(t));
    const n = this.beans.valueSvc.formatValue(
      this.params.column,
      null,
      t,
      this.valueFormatter,
      !1
    );
    return n ?? Pn(t) ?? Sn(this, "blanks");
  }
  getModelAsString(e, t) {
    const { values: n } = e ?? {}, o = t === "filterToolPanel";
    if (n == null)
      return o ? Sn(this, "filterSummaryListInactive") : "";
    const s = this.valueModel.getAvailableKeys(n), i = s.length, r = o ? 3 : 10, a = s.slice(0, r).map((l) => this.getFormattedValue(l));
    if (o) {
      const l = a.join(Sn(this, "filterSummaryListSeparator"));
      return i > 3 ? Sn(this, "filterSummaryListLong", [l, String(i - 3)]) : Sn(this, "filterSummaryListShort", [l]);
    }
    return `(${i}) ${a.join(",")}${i > 10 ? ",..." : ""}`;
  }
  onAnyFilterChanged() {
    window.setTimeout(() => {
      this.isAlive() && this.valueModel.refreshAvailable().then((e) => {
        this.dispatchLocalEvent({ type: "anyFilterChanged", updated: !!e });
      });
    });
  }
  onNewRowsLoaded() {
    this.syncAfterDataChange();
  }
  setFilterValues(e) {
    this.valueModel.overrideValues(e).then(() => {
      this.refreshFilterValues();
    });
  }
  resetFilterValues() {
    this.valueModel.valuesType = Vu.TAKEN_FROM_GRID_VALUES, this.syncAfterDataChange();
  }
  /**
   * @param suppressAvailableValuesCheck when refreshing values via the API, the model will be reset if all available values are selected.
   * When refreshing due to internal changes, set this to `true` to do the reset check based on all values instead.
   */
  refreshFilterValues(e) {
    this.valueModel.isInitialised() && this.valueModel.refreshAll().then(() => {
      this.dispatchLocalEvent({ type: "dataChanged", hardRefresh: !0 }), this.validateModel(this.params, void 0, !e);
    });
  }
  getFilterKeys() {
    return Array.from(this.valueModel.allValues.keys());
  }
  getFilterValues() {
    return Array.from(this.valueModel.allValues.values());
  }
  isTreeDataOrGrouping() {
    return this.treeDataTreeList || this.groupingTreeList;
  }
  caseFormat(e) {
    return e == null || typeof e != "string" || this.caseSensitive ? e : e.toUpperCase();
  }
  addEventListenersForDataChanges() {
    this.addManagedPropertyListeners(["groupAllowUnbalanced"], () => this.syncAfterDataChange());
    const e = Lt(this, this.syncAfterDataChange.bind(this), 0);
    this.addManagedEventListeners({
      cellValueChanged: (t) => {
        t.column === this.params.column && e();
      }
    });
  }
  syncAfterDataChange() {
    this.isValuesTakenFromGrid() && this.valueModel.refreshAll().then(() => {
      this.dispatchLocalEvent({ type: "dataChanged" }), this.validateModel(this.params, { afterDataChange: !0 });
    });
  }
  validateModel(e, t, n) {
    const o = this.valueModel;
    o.allKeys.then(() => {
      const s = e.model;
      if (s == null)
        return;
      const i = /* @__PURE__ */ new Map(), r = (h) => i.set(this.caseFormat(h), h);
      if (n)
        for (const h of o.availableKeys)
          r(h);
      else
        o.allValues.forEach((h, g) => r(g));
      const a = [];
      let l = !1;
      for (const h of s.values) {
        const g = this.caseFormat(Gt(h)), p = i.get(g);
        p !== void 0 ? (a.push(p), p !== h && (l = !0)) : l = !0;
      }
      const d = a.length;
      if (d === 0 && e.filterParams.excelMode) {
        e.onModelChange(null, t);
        return;
      }
      const u = (this.valueModel.valuesType === Vu.TAKEN_FROM_GRID_VALUES || !e.filterParams.suppressClearModelOnRefreshValues) && d === i.size;
      if (l || !s.filterType || u) {
        const h = u ? null : { filterType: this.filterType, values: a };
        e.onModelChange(h, t);
        return;
      }
    });
  }
  isValuesTakenFromGrid() {
    return this.valueModel.valuesType === Vu.TAKEN_FROM_GRID_VALUES;
  }
  doesFilterPassForTreeData(e) {
    var o;
    if ((o = e.childrenAfterGroup) != null && o.length)
      return !1;
    const { gos: t, appliedModel: n } = this;
    return n.has(
      this.createKey(
        Xh(
          e.getRoute() ?? [e.key ?? e.id],
          !0,
          t.get("groupAllowUnbalanced")
        )
      )
    );
  }
  doesFilterPassForGrouping(e) {
    const {
      appliedModel: t,
      params: n,
      gos: o,
      beans: { rowGroupColsSvc: s, valueSvc: i }
    } = this, r = ((s == null ? void 0 : s.columns) ?? []).map((a) => i.getKeyForNode(a, e));
    return r.push(n.getValue(e)), t.has(
      this.createKey(Xh(r, !1, o.get("groupAllowUnbalanced")))
    );
  }
  generateCreateKey(e, t) {
    return t && !e ? ($e(250), () => null) : e ? (n, o = null) => {
      const s = this.getKeyCreatorParams(n, o);
      return Gt(e(s));
    } : (n) => Gt(Pn(n));
  }
  getKeyCreatorParams(e, t = null) {
    const { colDef: n, column: o } = this.params;
    return ke(this.gos, {
      value: e,
      colDef: n,
      column: o,
      node: t,
      data: t == null ? void 0 : t.data
    });
  }
  setValueFormatter(e, t, n, o) {
    let s = e;
    if (!s) {
      if (t && !n) {
        $e(249);
        return;
      }
      this.noValueFormatterSupplied = !0, o || (s = (i) => Pn(i.value));
    }
    this.valueFormatter = s;
  }
  getCrossFilterModel(e) {
    var s;
    const { createKey: t, valueModel: n, params: o } = this;
    return e(t, n.availableKeys, (s = o.model) == null ? void 0 : s.values);
  }
  destroy() {
    this.appliedModel.destroy(), super.destroy(), this.valueModel = void 0;
  }
}, v$ = {
  tag: "div",
  cls: "ag-floating-filter-input ag-set-floating-filter-input",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eFloatingFilterText"
    }
  ]
}, C$ = class extends Te {
  constructor() {
    super(v$, [ao]), this.eFloatingFilterText = X, this.listenerAdded = !1;
  }
  init(e) {
    this.params = e, this.eFloatingFilterText.setDisabled(!0).addGuiEventListener("click", () => this.params.showParentFilter()), this.setParams(e);
  }
  setParams(e) {
    const t = this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0), n = this.getLocaleTextFunc();
    if (this.eFloatingFilterText.setInputAriaLabel(`${t} ${n("ariaFilterInput", "Filter Input")}`), this.gos.get("enableFilterHandlers")) {
      const o = e;
      this.updateFloatingFilterText(o.model);
    }
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  onParentModelChanged(e) {
    this.updateFloatingFilterText(e);
  }
  parentSetFilterInstance(e) {
    this.params.parentFilterInstance((t) => {
      if (!(t instanceof Zb)) {
        $e(248);
        return;
      }
      e(t);
    });
  }
  addAvailableValuesListener() {
    const e = (t) => {
      if (t == null || !t.isAlive())
        return;
      const n = t.valueModel;
      this.destroyListeners = n.addManagedListeners(n, {
        availableValuesChanged: () => this.updateFloatingFilterText(t.params.model),
        destroyed: () => {
          this.listenerAdded = !1, this.destroyListeners = void 0;
        }
      });
    };
    this.gos.get("enableFilterHandlers") ? e(this.params.getHandler()) : this.parentSetFilterInstance((t) => {
      e(t.handler);
    }), this.listenerAdded = !0;
  }
  updateFloatingFilterText(e) {
    var t, n;
    e == null ? this.eFloatingFilterText.setValue("") : (this.listenerAdded || this.addAvailableValuesListener(), this.gos.get("enableFilterHandlers") ? this.eFloatingFilterText.setValue(
      ((n = (t = this.params.getHandler()).getModelAsString) == null ? void 0 : n.call(t, e)) ?? ""
    ) : this.parentSetFilterInstance((o) => {
      this.eFloatingFilterText.setValue(o.getModelAsString(e));
    }));
  }
  destroy() {
    const e = this.destroyListeners;
    e && (e.forEach((t) => t()), e.length = 0), super.destroy();
  }
}, w$ = {
  moduleName: "SetFilter",
  version: gt,
  userComponents: {
    agSetColumnFilter: {
      classImp: Zb,
      params: {
        useForm: !0
      },
      processParams: (e) => (l$(e), e)
    },
    agSetColumnFloatingFilter: C$
  },
  dynamicBeans: {
    agSetColumnFilterHandler: m$
  },
  icons: {
    // set filter tree list group contracted (click to expand)
    setFilterGroupClosed: "tree-closed",
    // set filter tree list group expanded (click to contract)
    setFilterGroupOpen: "tree-open",
    // set filter tree list expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    setFilterGroupIndeterminate: "tree-indeterminate",
    // set filter async values loading
    setFilterLoading: "loading"
  },
  dependsOn: [an, il]
}, y$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "aggColNameSvc";
  }
  getHeaderName(e, t) {
    if (this.gos.get("suppressAggFuncInHeader"))
      return t;
    const { valueColsSvc: n, colModel: o, rowGroupColsSvc: s } = this.beans, i = e.getColDef().pivotValueColumn, r = ue(i);
    let a = null, l;
    if (r) {
      const d = (n == null ? void 0 : n.columns) ?? [], c = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && d.length === 1, u = e.getColDef().pivotTotalColumnIds !== void 0;
      if (c && !u)
        return t;
      a = i ? i.getAggFunc() : null, l = !0;
    } else {
      const d = e.isValueActive(), c = o.isPivotMode() || (s == null ? void 0 : s.columns.length) !== 0;
      d && c ? (a = e.getAggFunc(), l = !0) : l = !1;
    }
    if (l) {
      const d = typeof a == "string" ? a : "func";
      return `${this.getLocaleTextFunc()(d, d)}(${t})`;
    }
    return t;
  }
}, b$ = {
  sum: "Sum",
  first: "First",
  last: "Last",
  min: "Min",
  max: "Max",
  count: "Count",
  avg: "Average"
}, S$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "aggFuncSvc", this.aggFuncsMap = {}, this.initialised = !1;
  }
  postConstruct() {
    this.init();
  }
  init() {
    this.initialised || (this.initialiseWithDefaultAggregations(), this.addAggFuncs(this.gos.get("aggFuncs")));
  }
  initialiseWithDefaultAggregations() {
    const e = this.aggFuncsMap;
    e.sum = x$, e.first = R$, e.last = E$, e.min = A$, e.max = F$, e.count = I$, e.avg = D$, this.initialised = !0;
  }
  isAggFuncPossible(e, t) {
    const o = this.getFuncNames(e).includes(t), s = ue(this.aggFuncsMap[t]);
    return o && s;
  }
  getDefaultFuncLabel(e) {
    return b$[e] ?? e;
  }
  getDefaultAggFunc(e) {
    const t = e.getColDef().defaultAggFunc;
    if (ue(t) && this.isAggFuncPossible(e, t))
      return t;
    if (this.isAggFuncPossible(e, "sum"))
      return "sum";
    const n = this.getFuncNames(e);
    return n != null && n.length ? n[0] : null;
  }
  addAggFuncs(e) {
    if (this.init(), !!e)
      for (const t of Object.keys(e))
        e[t] && (this.aggFuncsMap[t] = e[t]);
  }
  getAggFunc(e) {
    return this.init(), this.aggFuncsMap[e];
  }
  getFuncNames(e) {
    const t = e.getColDef().allowedAggFuncs;
    return t ?? Object.keys(this.aggFuncsMap).sort();
  }
  clear() {
    this.aggFuncsMap = {};
  }
};
function x$(e) {
  const { values: t } = e;
  let n = null;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    typeof s == "number" ? n === null ? n = s : n += typeof n == "number" ? s : BigInt(s) : typeof s == "bigint" && (n === null ? n = s : n = (typeof n == "bigint" ? n : BigInt(n)) + s);
  }
  return n;
}
function R$(e) {
  return e.values.length > 0 ? e.values[0] : null;
}
function E$(e) {
  return e.values.length > 0 ? Je(e.values) : null;
}
function A$(e) {
  const { values: t } = e;
  let n = null;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    (typeof s == "number" || typeof s == "bigint") && (n === null || n > s) && (n = s);
  }
  return n;
}
function F$(e) {
  const { values: t } = e;
  let n = null;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    (typeof s == "number" || typeof s == "bigint") && (n === null || n < s) && (n = s);
  }
  return n;
}
var M$ = Object.freeze({
  // the grid by default uses toString to render values for an object, so this
  // is a trick to get the default cellRenderer to display the avg value
  toString: function() {
    return this.value.toString();
  },
  // used for sorting
  toNumber: function() {
    return this.value;
  }
});
function I$(e) {
  var i, r;
  const { values: t } = e;
  let n = 0;
  for (let a = 0; a < t.length; a++) {
    const l = t[a];
    n += l != null && typeof l.value == "number" ? l.value : 1;
  }
  const o = (r = (i = e.rowNode) == null ? void 0 : i.aggData) == null ? void 0 : r[e.column.getColId()];
  if (o && o.value === n)
    return o;
  const s = Object.create(M$);
  return s.value = n, s;
}
var P$ = Object.freeze({
  // the grid by default uses toString to render values for an object, so this
  // is a trick to get the default cellRenderer to display the avg value
  toString: function() {
    return typeof this.value == "number" || typeof this.value == "bigint" ? this.value.toString() : "";
  },
  // used for sorting
  toNumber: function() {
    return this.value;
  }
});
function D$(e) {
  var a, l, d;
  const { values: t } = e;
  let n = 0, o = 0;
  for (let c = 0; c < t.length; c++) {
    const u = t[c];
    let h = null;
    typeof u == "number" || typeof u == "bigint" ? (h = u, o++) : u != null && (typeof u.value == "number" || typeof u.value == "bigint") && typeof u.count == "number" && (h = u.value * (typeof u.value == "number" ? u.count : BigInt(u.count)), o += u.count), typeof h == "number" ? n += typeof n == "number" ? h : BigInt(h) : typeof h == "bigint" && (n = (typeof n == "bigint" ? n : BigInt(n)) + h);
  }
  let s = null;
  o > 0 && (s = n / (typeof n == "number" ? o : BigInt(o)));
  const i = (d = (a = e.rowNode) == null ? void 0 : a.aggData) == null ? void 0 : d[(l = e.column) == null ? void 0 : l.getColId()];
  if (i && i.count === o && i.value === s)
    return i;
  const r = Object.create(P$);
  return r.count = o, r.value = s, r;
}
function T$(e, t) {
  e.aggFuncSvc && e.aggFuncSvc.addAggFuncs(t);
}
function k$(e) {
  e.aggFuncSvc && e.aggFuncSvc.clear();
}
function L$(e, t, n) {
  var o, s;
  (s = (o = e.valueColsSvc) == null ? void 0 : o.setColumnAggFunc) == null || s.call(o, t, n, "api");
}
function _u(e, t, n, o, s, i) {
  const r = typeof n == "string" ? e.aggFuncSvc.getAggFunc(n) : n;
  if (typeof r != "function")
    return Z(109, { inputValue: n.toString(), allSuggestions: e.aggFuncSvc.getFuncNames(o) }), null;
  const a = ke(e.gos, {
    values: t,
    column: o,
    colDef: o.colDef,
    pivotResultColumn: i,
    rowNode: s,
    // this is typed incorrectly. Within CSRM, this will always be defined. When called from integrated charts, this will never be defined.
    data: s == null ? void 0 : s.data
  });
  return r(a);
}
var B$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "aggStage", this.refreshProps = /* @__PURE__ */ new Set([
      "getGroupRowAgg",
      "alwaysAggregateAtRootLevel",
      "suppressAggFilteredOnly",
      "grandTotalRow"
    ]), this.step = "aggregate";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.pivotResultCols = e.pivotResultCols, this.valueSvc = e.valueSvc;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  execute(e) {
    var s, i, r;
    const t = !((i = (s = this.valueColsSvc) == null ? void 0 : s.columns) != null && i.length), n = !this.gos.getCallback("getGroupRowAgg");
    if (t && n && ((r = e.changedPath) != null && r.active))
      return;
    const o = this.createAggDetails(e);
    this.recursivelyCreateAggData(o);
  }
  createAggDetails(e) {
    var i;
    const t = this.colModel.isPivotActive(), n = (i = this.valueColsSvc) == null ? void 0 : i.columns, o = t && this.pivotColsSvc ? this.pivotColsSvc.columns : [];
    return {
      alwaysAggregateAtRootLevel: this.gos.get("alwaysAggregateAtRootLevel"),
      groupIncludeTotalFooter: !!kr(this.gos),
      changedPath: e.changedPath,
      valueColumns: n ?? [],
      pivotColumns: o,
      filteredOnly: !this.isSuppressAggFilteredOnly(),
      userAggFunc: this.gos.getCallback("getGroupRowAgg")
    };
  }
  isSuppressAggFilteredOnly() {
    return Da(this.gos) !== void 0 || this.gos.get("suppressAggFilteredOnly");
  }
  recursivelyCreateAggData(e) {
    const t = (n) => {
      if (!n.hasChildren()) {
        n.aggData && this.setAggData(n, null);
        return;
      }
      if (n.level === -1 && !e.groupIncludeTotalFooter) {
        const i = !this.colModel.isPivotMode();
        if (!e.alwaysAggregateAtRootLevel && i) {
          this.setAggData(n, null);
          return;
        }
      }
      this.aggregateRowNode(n, e);
    };
    e.changedPath.forEachChangedNodeDepthFirst(t, !0);
  }
  aggregateRowNode(e, t) {
    const n = t.valueColumns.length === 0, o = t.pivotColumns.length === 0;
    let s;
    t.userAggFunc ? s = t.userAggFunc({ nodes: e.childrenAfterFilter }) : n ? s = null : o ? s = this.aggregateRowNodeUsingValuesOnly(e, t) : s = this.aggregateRowNodeUsingValuesAndPivot(e), this.setAggData(e, s), e.sibling && (this.setAggData(e.sibling, s), e.sibling.pinnedSibling && this.setAggData(e.sibling.pinnedSibling, s));
  }
  aggregateRowNodeUsingValuesAndPivot(e) {
    var i, r;
    const t = {}, n = ((r = (i = this.pivotResultCols) == null ? void 0 : i.getPivotResultCols()) == null ? void 0 : r.list) ?? [];
    let o = !0;
    const s = this.beans;
    for (let a = 0; a < n.length; a++) {
      const l = n[a], d = l.getColDef();
      if (d.pivotTotalColumnIds != null) {
        o = !1;
        continue;
      }
      const c = d.pivotKeys ?? [];
      let u;
      e.leafGroup ? u = this.getValuesFromMappedSet(e.childrenMapped, c, d.pivotValueColumn) : u = this.getValuesPivotNonLeaf(e, d.colId), t[d.colId] = _u(
        s,
        u,
        d.pivotValueColumn.getAggFunc(),
        d.pivotValueColumn,
        e,
        l
      );
    }
    if (!o)
      for (let a = 0; a < n.length; a++) {
        const l = n[a], d = l.getColDef();
        if (d.pivotTotalColumnIds == null || !d.pivotTotalColumnIds.length)
          continue;
        const c = d.pivotTotalColumnIds.map(
          (u) => t[u]
        );
        t[d.colId] = _u(
          s,
          c,
          d.pivotValueColumn.getAggFunc(),
          d.pivotValueColumn,
          e,
          l
        );
      }
    return t;
  }
  aggregateRowNodeUsingValuesOnly(e, t) {
    const n = {}, { changedPath: o, valueColumns: s, filteredOnly: i } = t, r = o.active ? o.getValueColumnsForNode(e, s) : s, a = o.active ? o.getNotValueColumnsForNode(e, s) : null, l = this.getValuesNormal(e, r, i), d = e.aggData, c = this.beans;
    return r.forEach((u, h) => {
      n[u.getId()] = _u(
        c,
        l[h],
        u.getAggFunc(),
        u,
        e
      );
    }), a && d && a.forEach((u) => {
      n[u.getId()] = d[u.getId()];
    }), n;
  }
  getValuesPivotNonLeaf(e, t) {
    return e.childrenAfterFilter.map((n) => n.aggData[t]);
  }
  getValuesFromMappedSet(e, t, n) {
    let o = e;
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      o = o ? o[i] : null;
    }
    return o ? o.map((s) => this.valueSvc.getValue(n, s)) : [];
  }
  getValuesNormal(e, t, n) {
    const o = [];
    t.forEach(() => o.push([]));
    const s = t.length, i = n ? e.childrenAfterFilter : e.childrenAfterGroup, r = i.length;
    for (let a = 0; a < r; a++) {
      const l = i[a];
      for (let d = 0; d < s; d++) {
        const c = t[d], u = this.valueSvc.getValue(c, l);
        o[d].push(u);
      }
    }
    return o;
  }
  setAggData(e, t) {
    const n = e.aggData;
    if (e.aggData = t, e.__localEventService) {
      const o = (s) => {
        const i = e.aggData ? e.aggData[s] : void 0, r = n ? n[s] : void 0;
        if (i === r)
          return;
        const a = this.colModel.getColById(s);
        a && e.dispatchCellChangedEvent(a, i, r);
      };
      if (n)
        for (const s of Object.keys(n))
          o(s);
      if (t)
        for (const s of Object.keys(t))
          (!n || !(s in n)) && o(s);
    }
  }
}, O$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "filterAggStage", this.refreshProps = /* @__PURE__ */ new Set([]), this.step = "filter_aggregates";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    var d, c;
    const t = this.beans.colModel.isPivotMode(), n = ((d = this.filterManager) == null ? void 0 : d.isAggregateFilterPresent()) || ((c = this.filterManager) == null ? void 0 : c.isAggregateQuickFilterPresent()), o = (u) => !u.node.group, s = (u) => u.node.leafGroup, i = Da(this.gos) || (t ? s : o), { changedPath: r } = e, a = (u, h = !1) => {
      u.childrenAfterFilter && (u.childrenAfterAggFilter = u.childrenAfterFilter, h && u.childrenAfterAggFilter.forEach((g) => a(g, h)), this.setAllChildrenCount(u)), u.sibling && (u.sibling.childrenAfterAggFilter = u.childrenAfterAggFilter);
    }, l = (u) => {
      var h;
      u.childrenAfterAggFilter = ((h = u.childrenAfterFilter) == null ? void 0 : h.filter((g) => {
        var m;
        return i({ node: g }) && this.filterManager.doesRowPassAggregateFilters({ rowNode: g }) ? (a(g, !0), !0) : (m = g.childrenAfterAggFilter) == null ? void 0 : m.length;
      })) || null, this.setAllChildrenCount(u), u.sibling && (u.sibling.childrenAfterAggFilter = u.childrenAfterAggFilter);
    };
    r.forEachChangedNodeDepthFirst(n ? l : a, !0);
  }
  /** for tree data, we include all children, groups and leafs */
  setAllChildrenCountTreeData(e) {
    const t = e.childrenAfterAggFilter;
    let n = 0;
    if (t) {
      const o = t.length;
      n = o;
      for (let s = 0; s < o; ++s)
        n += t[s].allChildrenCount ?? 0;
    }
    e.setAllChildrenCount(
      // Maintain the historical behaviour:
      // - allChildrenCount is 0 in the root if there are no children
      // - allChildrenCount is null in any non-root row if there are no children
      n === 0 && e.level >= 0 ? null : n
    );
  }
  /* for grid data, we only count the leafs */
  setAllChildrenCountGridGrouping(e) {
    let t = 0;
    e.childrenAfterAggFilter.forEach((n) => {
      n.group ? t += n.allChildrenCount : t++;
    }), e.setAllChildrenCount(t);
  }
  setAllChildrenCount(e) {
    if (!e.hasChildren()) {
      e.setAllChildrenCount(null);
      return;
    }
    this.gos.get("treeData") ? this.setAllChildrenCountTreeData(e) : this.setAllChildrenCountGridGrouping(e);
  }
};
function Zo(e, t) {
  if (e.sibling)
    return;
  const n = xw(e, t);
  n.footer = !0, n.setRowTop(null), n.setRowIndex(null), n.oldRowTop = null, n.id = "rowGroupFooter_" + e.id, n.sibling = e, e.sibling = n;
}
function Yp(e) {
  e.sibling && (e.sibling.setRowTop(null), e.sibling.setRowIndex(null), e.sibling = void 0);
}
var G$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "footerSvc";
  }
  addTotalRows(e, t, n, o, s, i) {
    let r = e;
    if (s) {
      const d = o && kr(this.gos);
      return H$(i, d) && (Zo(t, this.beans), n(t.sibling, r++)), r;
    }
    const a = vr(this.gos);
    return (o && a({ node: t })) === i && (Zo(t, this.beans), n(t.sibling, r++)), r;
  }
  getTopDisplayIndex(e, t, n, o) {
    let s = t;
    if (e[0].footer) {
      if (t === 0)
        return 0;
      s -= 1;
    }
    const i = e[e.length - 1], r = s >= n.length;
    return i.footer && r ? i.rowIndex : o(s);
  }
  doesCellShowTotalPrefix(e, t) {
    var n;
    return !e.footer || !(t != null && t.getColDef().showRowGroup) ? !1 : this.gos.get("treeData") ? !0 : e.level === -1 ? ((n = this.beans.showRowGroupCols) == null ? void 0 : n.getShowRowGroupCols()[0]) === t : !!e.rowGroupColumn && t && t.isRowGroupDisplayed(e.rowGroupColumn.getId());
  }
  applyTotalPrefix(e, t, n, o) {
    var i, r;
    const s = (i = o.getColDef().cellRendererParams) == null ? void 0 : i.totalValueGetter;
    if (s) {
      const a = ke(this.gos, { column: o, node: n, value: e, formattedValue: t });
      if (typeof s === "function")
        return s(a);
      if (typeof s == "string")
        return (r = this.beans.expressionSvc) == null ? void 0 : r.evaluate(s, a);
      Z(179);
    }
    return n.level === -1 ? this.getLocaleTextFunc()("footerTotal", "Total") + " " : this.getTotalValue(t ?? e) ?? "";
  }
  getTotalValue(e) {
    return this.getLocaleTextFunc()("footerTotal", "Total") + " " + (e ?? "");
  }
};
function H$(e, t) {
  switch (t) {
    case "top":
    case "pinnedTop":
      return e === "top";
    case "bottom":
    case "pinnedBottom":
      return e === "bottom";
    default:
      return !1;
  }
}
var jb = class extends ip {
  constructor() {
    super(...arguments), this.beanName = "valueColsSvc", this.eventName = "columnValueChanged", this.columnProcessors = {
      set: (e, t, n) => this.setValueActive(t, e, n),
      add: (e, t, n) => this.setValueActive(!0, e, n),
      remove: (e, t, n) => this.setValueActive(!1, e, n)
    }, this.columnExtractors = {
      setFlagFunc: (e, t, n) => this.setColValueActive(e, t, n),
      getIndexFunc: () => {
      },
      getInitialIndexFunc: () => {
      },
      getValueFunc: (e) => {
        const t = e.aggFunc;
        if (t === null || t === "")
          return null;
        if (t !== void 0)
          return !!t;
      },
      getInitialValueFunc: (e) => e.initialAggFunc != null && e.initialAggFunc != ""
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => $t(this.columns, e)
    };
  }
  extractCols(e, t) {
    return this.columns = super.extractCols(e, t), this.columns.forEach((n) => {
      const o = n.getColDef();
      o.aggFunc != null && o.aggFunc != "" ? this.setColAggFunc(n, o.aggFunc) : n.getAggFunc() || this.setColAggFunc(n, o.initialAggFunc);
    }), this.columns;
  }
  setColumnAggFunc(e, t, n) {
    if (!e)
      return;
    const o = this.colModel.getColDefCol(e);
    o && (this.setColAggFunc(o, t), this.dispatchColumnChangedEvent(this.eventSvc, this.eventName, [o], n));
  }
  syncColumnWithState(e, t, n) {
    const o = n("aggFunc").value1;
    o !== void 0 && (typeof o == "string" ? (this.setColAggFunc(e, o), e.isValueActive() || (this.setColValueActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e))) : (ue(o) && Z(33), e.isValueActive() && (this.setColValueActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e))));
  }
  setValueActive(e, t, n) {
    if (e !== t.isValueActive() && (this.setColValueActive(t, e, n), e && !t.getAggFunc() && this.aggFuncSvc)) {
      const o = this.aggFuncSvc.getDefaultAggFunc(t);
      this.setColAggFunc(t, o);
    }
  }
  setColAggFunc(e, t) {
    e.aggFunc = t, e.dispatchStateUpdatedEvent("aggFunc");
  }
  setColValueActive(e, t, n) {
    e.aggregationActive !== t && (e.aggregationActive = t, e.dispatchColEvent("columnValueChanged", n));
  }
}, Qp = {
  moduleName: "SharedAggregation",
  version: gt,
  beans: [S$, y$, G$, jb],
  apiFunctions: {
    addAggFuncs: T$,
    clearAggFuncs: k$,
    setColumnAggFunc: L$
  },
  dependsOn: [an]
}, Yb = {
  moduleName: "Aggregation",
  version: gt,
  beans: [B$, O$],
  rowModels: ["clientSide"],
  dependsOn: [Qp]
}, V$ = ({ valueSvc: e }, t, n) => {
  const o = e.getValue(t, n);
  let s = null;
  return o instanceof Date ? s = o : typeof o == "string" && (s = Qt(o)), s;
}, cs = (e, t, n, o) => (s) => {
  const i = V$(e, t, s.node), r = zi(i);
  return r ? (o == null ? void 0 : o(r[n])) ?? r[n] : null;
}, us = ({ colNames: e }, t, n) => (o) => {
  const s = e.getDisplayNameForColumn(t, o.location);
  return s ? `${s} (${n})` : "";
}, _$ = Object.fromEntries(Ad.map((e) => [e, e.toLowerCase()])), N$ = (e) => {
  const t = Ad[parseInt(e, 10) - 1] ?? e, n = _$[t] ?? e;
  return { month: t, localeKey: n };
}, $$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "groupHierarchyColSvc", this.columns = null, this.sourceColumnMap = /* @__PURE__ */ new WeakMap(), this.inverseColumnMap = /* @__PURE__ */ new WeakMap();
  }
  addColumns(e) {
    const t = this.columns;
    t != null && (e.list = t.list.filter((n) => !e.list.some((o) => o.getColId() === n.getColId())).concat(e.list), e.tree = t.tree.filter((n) => !e.tree.some((o) => o.getId() === n.getId())).concat(e.tree), sp(e));
  }
  createColumns(e) {
    var r, a;
    this.sourceColumnMap = /* @__PURE__ */ new WeakMap(), this.inverseColumnMap = /* @__PURE__ */ new WeakMap();
    const t = this.createGroupHierarchyColumns(e);
    if (op(t, ((r = this.columns) == null ? void 0 : r.list) ?? []))
      return;
    ts(this.beans, (a = this.columns) == null ? void 0 : a.tree), this.columns = null;
    const { colGroupSvc: o } = this.beans, s = (o == null ? void 0 : o.findDepth(e.tree)) ?? 0, i = (o == null ? void 0 : o.balanceTreeForAutoCols(t, s)) ?? [];
    this.columns = {
      list: t,
      tree: i,
      treeDepth: s,
      map: {}
    };
  }
  updateColumns(e) {
  }
  getColumn(e) {
    var t;
    return ((t = this.columns) == null ? void 0 : t.list.find((n) => ka(n, e))) ?? null;
  }
  getColumns() {
    var e;
    return ((e = this.columns) == null ? void 0 : e.list) ?? null;
  }
  expandColumnInto(e, t) {
    const n = this.getVirtualColumnsForColumn(t).concat(t);
    for (const o of n)
      e.some((s) => ka(s, o) || s.getColId() === o.getColId()) || e.push(o);
  }
  compareVirtualColumns(e, t) {
    var s, i;
    const n = this.inverseColumnMap.get(e), o = this.inverseColumnMap.get(t);
    if (n && n === o) {
      const r = this.sourceColumnMap.get(n) ?? [];
      return (r == null ? void 0 : r.indexOf(e)) - (r == null ? void 0 : r.indexOf(t));
    }
    return (s = this.sourceColumnMap.get(e)) != null && s.includes(t) ? 1 : (i = this.sourceColumnMap.get(t)) != null && i.includes(e) ? -1 : null;
  }
  insertVirtualColumnsForCol(e, t) {
    const n = this.getVirtualColumnsForColumn(t) ?? [];
    for (const o of n)
      e.includes(o) || e.push(o);
  }
  getVirtualColumnsForColumn(e) {
    return this.isGroupHierarchyColsEnabledForCol(e) ? this.sourceColumnMap.get(e) ?? [] : [];
  }
  isGroupHierarchyColsEnabled(e) {
    return e.list.some((t) => this.isGroupHierarchyColsEnabledForCol(t));
  }
  isGroupHierarchyColsEnabledForCol(e) {
    const t = e.getColDef();
    return !!(t.rowGroupingHierarchy && (t.rowGroup || t.enableRowGroup));
  }
  createGroupHierarchyColDefs(e) {
    const t = [], n = e.getColDef();
    if (!n.rowGroupingHierarchy || !this.isGroupHierarchyColsEnabledForCol(e))
      return t;
    for (const o of n.rowGroupingHierarchy) {
      let s = null;
      typeof o == "string" ? s = this.createColDefForPart(o, e, n) : s = o, s && t.push(s);
    }
    return t;
  }
  createGroupHierarchyColumns(e) {
    if (!this.isGroupHierarchyColsEnabled(e))
      return [];
    const t = [];
    for (const n of e.list)
      this.createGroupHierarchyColDefs(n).forEach((o) => {
        const s = o.colId;
        this.gos.validateColDef(o, s, !0);
        const i = new Go(o, null, s, !0);
        this.createBean(i), t.push(i), z$(this.sourceColumnMap, n, i), this.inverseColumnMap.set(i, n);
      });
    return t;
  }
  createColDefForPart(e, t, n) {
    var c;
    const { beans: o, gos: s } = this, i = `${q3}-${t.getColId()}-${e}`, r = {
      enableRowGroup: !0,
      rowGroup: n.rowGroup,
      enablePivot: n.enablePivot,
      hide: !0,
      editable: !1
    }, a = s.get("groupHierarchyConfig") ?? {};
    if (e in a) {
      const u = a[e];
      return u.colId ?? (u.colId = i), yi(this.beans, { ...r, ...u }, u.colId, !0);
    }
    const l = yi(o, { colId: i, ...r }, i, !0), d = (c = o.localeSvc) == null ? void 0 : c.getLocaleTextFunc();
    switch (e) {
      case "year":
        return {
          ...l,
          headerValueGetter: us(o, t, "Year"),
          valueGetter: cs(o, t, 0)
        };
      case "quarter":
        return {
          ...l,
          headerValueGetter: us(o, t, "Quarter"),
          valueGetter: cs(
            o,
            t,
            1,
            (u) => (Math.floor(Number(u) / 4) + 1).toString()
          )
        };
      case "month":
        return {
          ...l,
          headerValueGetter: us(o, t, "Month"),
          valueGetter: cs(o, t, 1)
        };
      case "formattedMonth":
        return {
          ...l,
          headerValueGetter: us(o, t, "Month"),
          valueGetter: cs(o, t, 1, (u) => {
            const h = N$(u);
            return (d == null ? void 0 : d(h.localeKey, h.month)) ?? h.month;
          })
        };
      case "day":
        return {
          ...l,
          headerValueGetter: us(o, t, "Day"),
          valueGetter: cs(o, t, 2)
        };
      case "hour":
        return {
          ...l,
          headerValueGetter: us(o, t, "Hour"),
          valueGetter: cs(o, t, 3)
        };
      case "minute":
        return {
          ...l,
          headerValueGetter: us(o, t, "Minute"),
          valueGetter: cs(o, t, 4)
        };
      case "second":
        return {
          ...l,
          headerValueGetter: us(o, t, "Second"),
          valueGetter: cs(o, t, 5)
        };
      default:
        return null;
    }
  }
};
function z$(e, t, n) {
  const o = e.get(t);
  e.set(t, (o ?? []).concat(n));
}
var W$ = {
  moduleName: "GroupHierarchy",
  version: gt,
  beans: [$$]
}, Qb = class extends ip {
  constructor() {
    super(...arguments), this.beanName = "pivotColsSvc", this.eventName = "columnPivotChanged", this.columnProcessors = {
      set: (e, t, n) => this.setColPivotActive(e, t, n),
      add: (e, t, n) => this.setColPivotActive(e, !0, n),
      remove: (e, t, n) => this.setColPivotActive(e, !1, n)
    }, this.columnOrdering = {
      enableProp: "pivot",
      initialEnableProp: "initialPivot",
      indexProp: "pivotIndex",
      initialIndexProp: "initialPivotIndex"
    }, this.columnExtractors = {
      setFlagFunc: (e, t, n) => this.setColPivotActive(e, t, n),
      getIndexFunc: (e) => e.pivotIndex,
      getInitialIndexFunc: (e) => e.initialPivotIndex,
      getValueFunc: (e) => e.pivot,
      getInitialValueFunc: (e) => e.initialPivot
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => $t(this.columns, e)
    };
  }
  syncColumnWithState(e, t, n, o) {
    const { value1: s, value2: i } = n("pivot", "pivotIndex");
    (s !== void 0 || i !== void 0) && (typeof i == "number" || s ? (e.isPivotActive() || (this.setColPivotActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e)), o && typeof i == "number" && (o[e.getId()] = i)) : e.isPivotActive() && (this.setColPivotActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e)));
  }
  setColPivotActive(e, t, n) {
    e.pivotActive !== t && (e.pivotActive = t, e.dispatchColEvent("columnPivotChanged", n)), e.dispatchStateUpdatedEvent("pivot");
  }
}, U$ = class extends ip {
  constructor() {
    super(...arguments), this.beanName = "rowGroupColsSvc", this.eventName = "columnRowGroupChanged", this.columnProcessors = {
      set: (e, t, n) => this.setActive(t, e, n),
      add: (e, t, n) => this.setActive(!0, e, n),
      remove: (e, t, n) => this.setActive(!1, e, n)
    }, this.columnOrdering = {
      enableProp: "rowGroup",
      initialEnableProp: "initialRowGroup",
      indexProp: "rowGroupIndex",
      initialIndexProp: "initialRowGroupIndex"
    }, this.columnExtractors = {
      setFlagFunc: (e, t, n) => this.setColRowGroupActive(e, t, n),
      getIndexFunc: (e) => e.rowGroupIndex,
      getInitialIndexFunc: (e) => e.initialRowGroupIndex,
      getValueFunc: (e) => e.rowGroup,
      getInitialValueFunc: (e) => e.initialRowGroup
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => {
        var t;
        (t = this.beans.groupHierarchyColSvc) == null || t.insertVirtualColumnsForCol(this.columns, e), this.columns.includes(e) || this.columns.push(e);
      },
      removeCol: (e) => $t(this.columns, e)
    };
  }
  moveColumn(e, t, n) {
    if (this.columns.length === 0)
      return;
    const o = this.columns[e], s = this.columns.slice(e, t);
    this.columns.splice(e, 1), this.columns.splice(t, 0, o), this.updateIndexMap(), this.eventSvc.dispatchEvent({
      type: this.eventName,
      columns: s,
      column: s.length === 1 ? s[0] : null,
      source: n
    });
  }
  syncColumnWithState(e, t, n, o) {
    const { value1: s, value2: i } = n("rowGroup", "rowGroupIndex");
    (s !== void 0 || i !== void 0) && (typeof i == "number" || s ? (e.isRowGroupActive() || (this.setColRowGroupActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e)), o && typeof i == "number" && (o[e.getId()] = i)) : e.isRowGroupActive() && (this.setColRowGroupActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e)));
  }
  setActive(e, t, n) {
    var s;
    if (e === t.isRowGroupActive())
      return;
    this.setColRowGroupActive(t, e, n);
    const o = (s = this.beans.groupHierarchyColSvc) == null ? void 0 : s.getColumn(t);
    kC(this.gos, e) && !o && this.colModel.setColsVisible([t], !e, n);
  }
  setColRowGroupActive(e, t, n) {
    var o;
    e.rowGroupActive !== t && (e.rowGroupActive = t, t && ((o = this.beans.groupHierarchyColSvc) == null || o.insertVirtualColumnsForCol(this.columns, e)), e.dispatchColEvent("columnRowGroupChanged", n)), e.dispatchStateUpdatedEvent("rowGroup");
  }
}, K$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "autoColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener("autoGroupColumnDef", this.updateColumns.bind(this));
  }
  addColumns(e) {
    this.columns != null && (e.list = this.columns.list.concat(e.list), e.tree = this.columns.tree.concat(e.tree), sp(e));
  }
  createColumns(e, t) {
    var F;
    const n = this.beans, { colModel: o, gos: s, rowGroupColsSvc: i, colGroupSvc: r } = n, a = o.isPivotMode(), l = Xg(s, a), d = a ? s.get("pivotSuppressAutoColumn") : this.isSuppressAutoCol(), c = i == null ? void 0 : i.columns, h = !(c && c.length > 0 || s.get("treeData")) || d || l, g = () => {
      this.columns && (ts(n, this.columns.tree), this.columns = null);
    };
    if (h) {
      g();
      return;
    }
    const p = this.generateAutoCols(c), f = op(p, ((F = this.columns) == null ? void 0 : F.list) || null), m = e.treeDepth, w = (this.columns ? this.columns.treeDepth : -1) == m;
    if (f && w)
      return;
    g();
    const b = (r == null ? void 0 : r.findDepth(e.tree)) ?? 0, A = (r == null ? void 0 : r.balanceTreeForAutoCols(p, b)) ?? [];
    this.columns = {
      list: p,
      tree: A,
      treeDepth: b,
      map: {}
    }, t((E) => {
      if (!E)
        return null;
      const M = E.filter((I) => !pc(I));
      return [...p, ...M];
    });
  }
  updateColumns(e) {
    var n;
    const t = di(e.source);
    (n = this.columns) == null || n.list.forEach((o, s) => this.updateOneAutoCol(o, s, t));
  }
  getColumn(e) {
    var t;
    return ((t = this.columns) == null ? void 0 : t.list.find((n) => ka(n, e))) ?? null;
  }
  getColumns() {
    var e;
    return ((e = this.columns) == null ? void 0 : e.list) ?? null;
  }
  generateAutoCols(e = []) {
    const t = [], n = this.gos.get("treeData");
    let o = PC(this.gos);
    return n && o && (Z(182), o = !1), o ? e.forEach((s, i) => {
      t.push(this.createOneAutoCol(s, i));
    }) : t.push(this.createOneAutoCol()), t;
  }
  isSuppressAutoCol() {
    const e = this.gos;
    return e.get("groupDisplayType") === "custom" ? !0 : e.get("treeDataDisplayType") === "custom";
  }
  // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
  createOneAutoCol(e, t) {
    let n;
    e ? n = `${wr}-${e.getId()}` : n = wr;
    const o = this.createAutoColDef(n, e, t);
    o.colId = n;
    const s = new Go(o, null, n, !0);
    return this.createBean(s), s;
  }
  /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */
  updateOneAutoCol(e, t, n) {
    const o = e.getColDef(), s = typeof o.showRowGroup == "string" ? o.showRowGroup : void 0, i = this.beans, r = s != null ? i.colModel.getColDefCol(s) : void 0, a = e.getId(), l = this.createAutoColDef(a, r ?? void 0, t);
    e.setColDef(l, null, n), cn(i, { state: [{ colId: a, ...l }] }, n);
  }
  createAutoColDef(e, t, n) {
    let o = this.createBaseColDef(t);
    const s = this.gos.get("autoGroupColumnDef");
    on(o, s), o = yi(this.beans, o, e, !0), this.gos.get("treeData") || st(o.field) && st(o.valueGetter) && st(o.filterValueGetter) && o.filter !== "agGroupColumnFilter" && (o.filter = !1), n && n > 0 && (o.headerCheckboxSelection = !1);
    const i = Xn(this.gos), r = o.valueGetter || o.field != null;
    return i && !r && (o.sortIndex = void 0, o.initialSort = void 0), o;
  }
  createBaseColDef(e) {
    const t = this.gos.get("autoGroupColumnDef"), o = {
      headerName: this.getLocaleTextFunc()("group", "Group"),
      showRowGroup: (e == null ? void 0 : e.getColId()) ?? !0
    };
    return t && (t.cellRenderer || t.cellRendererSelector) || (o.cellRenderer = "agGroupCellRenderer"), e && (o.headerName = this.beans.colNames.getDisplayNameForColumn(e, "header") ?? void 0, o.headerValueGetter = e.colDef.headerValueGetter), o;
  }
  destroy() {
    var e;
    ts(this.beans, (e = this.columns) == null ? void 0 : e.tree), super.destroy();
  }
}, Jb = class extends U {
  addExpandedCss(e, t) {
    t.isExpandable() && (e.push("ag-row-group"), e.push(t.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted"));
  }
  getRowExpandedListeners(e) {
    const { rowNode: t } = e, n = this.updateExpandedCss.bind(this, e, t);
    return {
      expandedChanged: n,
      hasChildrenChanged: n
    };
  }
  setExpanded(e, t, n, o) {
    if (e.expanded === t)
      return;
    e.expanded = t, e.dispatchRowEvent("expandedChanged");
    const s = { ...Sw(e, this.gos, "rowGroupOpened"), expanded: t, event: n || null };
    this.dispatchExpandedEvent(s, o);
  }
  isExpandable(e) {
    return e.footer ? !1 : this.beans.colModel.isPivotMode() ? e.hasChildren() && !e.leafGroup : e.hasChildren() || e.master;
  }
  updateExpandedCss(e, t) {
    const n = t.isExpandable(), o = t.expanded == !0;
    e.forEachGui(void 0, (s) => {
      const i = s.rowComp;
      i.toggleCss("ag-row-group", n), i.toggleCss("ag-row-group-expanded", n && o), i.toggleCss("ag-row-group-contracted", n && !o), Zn(s.element, n && o);
    });
  }
  dispatchStateUpdatedEvent() {
    this.eventSvc.dispatchEvent({ type: "rowExpansionStateChanged" });
  }
}, Z$ = class extends Jb {
  constructor() {
    super(...arguments), this.beanName = "expansionSvc", this.events = [];
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  setExpansionState(e) {
    const t = new Set(e.expandedRowGroupIds);
    this.rowModel.forEachNode((n) => {
      const o = n.id;
      o && (n.expanded = t.has(o));
    }), this.onGroupExpandedOrCollapsed();
  }
  getExpansionState() {
    const e = [];
    return this.rowModel.forEachNode((t) => {
      const n = t.id;
      n && t.expanded && e.push(n);
    }), { expandedRowGroupIds: e };
  }
  expandAll(e) {
    const { gos: t, colModel: n, eventSvc: o } = this.beans, s = this.rowModel, i = t.get("treeData"), r = n.isPivotActive(), a = (d) => {
      d && d.forEach((c) => {
        const u = () => {
          c.expanded = e, a(c.childrenAfterGroup);
        };
        if (i) {
          ue(c.childrenAfterGroup) && u();
          return;
        }
        if (r) {
          !c.leafGroup && u();
          return;
        }
        c.group && u();
      });
    }, l = s.rootNode;
    l && a(l.childrenAfterGroup), this.onGroupExpandedOrCollapsed(), o.dispatchEvent({
      type: "expandOrCollapseAll",
      source: e ? "expandAll" : "collapseAll"
    });
  }
  onGroupExpandedOrCollapsed() {
    this.dispatchStateUpdatedEvent(), this.rowModel.refreshModel({ step: "map" });
  }
  // because the user can call rowNode.setExpanded() many times in one VM turn,
  // we throttle the calls to ClientSideRowModel using animationFrameSvc. this means for 100
  // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
  // CSRM has updated.
  //
  // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
  // to re-render 100+ times, which would be a performance lag.
  //
  // we use animationFrameService
  // rather than debounce() so this will get done if anyone flushes the animationFrameService
  // (eg user calls api.ensureRowVisible(), which in turn flushes ).
  dispatchExpandedEvent(e, t) {
    this.events.push(e);
    const n = () => {
      this.events.forEach((s) => this.eventSvc.dispatchEvent(s));
      const o = this.events.map((s) => s.node);
      this.beans.rowRenderer.refreshCells({ rowNodes: o }), this.events = [], this.dispatchStateUpdatedEvent();
    };
    t ? n() : (this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.debounce(n)), this.dispatchExpandedDebounced());
  }
  // the advantage over normal debounce is the client can call flushAllFrames()
  // to make sure all rendering is complete. we don't wait any milliseconds,
  // as this is intended to batch calls in one VM turn.
  debounce(e) {
    const t = this.beans.animationFrameSvc;
    if (!t)
      return () => window.setTimeout(e, 0);
    let n = !1;
    return () => {
      if (!t.active) {
        window.setTimeout(e, 0);
        return;
      }
      n || (n = !0, t.addDestroyTask(() => {
        n = !1, e();
      }));
    };
  }
};
function q$(e) {
  let t = e.get("groupHideParentOfSingleChild");
  return t || (t = e.get("groupRemoveSingleChildren"), !t && e.get("groupRemoveLowestSingleChildren") && (t = "leafGroupsOnly")), {
    groupHideParentOfSingleChild: t,
    isGroupMultiAutoColumn: PC(e),
    hideOpenParents: e.get("groupHideOpenParents"),
    grandTotalRow: kr(e),
    groupTotalRow: vr(e)
  };
}
function j$(e, t, n) {
  return e.groupHideParentOfSingleChild === !0 && n && t.childrenAfterGroup.length === 1;
}
function Y$(e, t, n) {
  return e.groupHideParentOfSingleChild === "leafGroupsOnly" && n && t.leafGroup && t.childrenAfterGroup.length === 1;
}
function Q$(e, t, n, o, s, i) {
  const r = o && !n, a = o && t.leafGroup, l = e.hideOpenParents && t.expanded && !t.master && !a;
  return !r && !l && !s && !i;
}
var J$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "flattenStage", this.refreshProps = /* @__PURE__ */ new Set([
      "groupHideParentOfSingleChild",
      "groupRemoveSingleChildren",
      "groupRemoveLowestSingleChildren",
      "groupTotalRow",
      "masterDetail"
    ]), this.step = "map";
  }
  execute(e) {
    var c;
    const t = e.rowNode, n = [], o = this.beans.colModel.isPivotMode(), s = o && t.leafGroup && t.aggData, i = s ? [t] : t.childrenAfterSort, r = q$(this.gos);
    this.recursivelyAddToRowsToDisplay(r, i, n, o, 0);
    const a = n.length > 0, l = r.grandTotalRow;
    if (!s && // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
    a && l)
      if (Zo(t, this.beans), l === "pinnedBottom" || l === "pinnedTop")
        (c = this.beans.pinnedRowModel) == null || c.setGrandTotalPinned(l === "pinnedBottom" ? "bottom" : "top");
      else {
        const u = l === "top";
        this.addRowNodeToRowsToDisplay(r, t.sibling, n, 0, u);
      }
    return n;
  }
  recursivelyAddToRowsToDisplay(e, t, n, o, s) {
    if (!(t != null && t.length))
      return;
    const i = this.beans.masterDetailSvc;
    for (let r = 0; r < t.length; r++) {
      const a = t[r], l = a.hasChildren(), d = j$(e, a, l), c = Y$(e, a, l);
      if (Q$(
        e,
        a,
        l,
        o,
        d,
        c
      ) && this.addRowNodeToRowsToDisplay(e, a, n, s), !(o && a.leafGroup))
        if (l) {
          const h = d || c;
          if (a.expanded || h) {
            const g = e.groupTotalRow({ node: a });
            g || Yp(a);
            const p = h ? s : s + 1;
            g === "top" && (Zo(a, this.beans), this.addRowNodeToRowsToDisplay(e, a.sibling, n, p));
            const f = i == null ? void 0 : i.getDetail(a);
            f && this.addRowNodeToRowsToDisplay(e, f, n, s), this.recursivelyAddToRowsToDisplay(
              e,
              a.childrenAfterSort,
              n,
              o,
              p
            ), g === "bottom" && (Zo(a, this.beans), this.addRowNodeToRowsToDisplay(e, a.sibling, n, p));
          }
        } else {
          const h = i == null ? void 0 : i.getDetail(a);
          h && this.addRowNodeToRowsToDisplay(e, h, n, s);
        }
    }
  }
  // duplicated method, it's also in floatingRowModel
  addRowNodeToRowsToDisplay(e, t, n, o, s) {
    s ? n.unshift(t) : n.push(t), t.setUiLevel(e.isGroupMultiAutoColumn ? 0 : o);
  }
}, X$ = class extends U {
  constructor() {
    super(...arguments), this.beanName = "groupStage", this.refreshProps = /* @__PURE__ */ new Set([
      "groupDefaultExpanded",
      "groupAllowUnbalanced",
      "initialGroupOrderComparator",
      "groupHideOpenParents",
      "groupDisplayType",
      "treeData",
      "treeDataChildrenField",
      "treeDataParentIdField"
    ]), this.step = "group", this.approach = null, this.strategyBeanName = null, this.strategy = void 0;
  }
  /** Gets a filler row by id */
  getNode(e) {
    var t;
    return (t = this.strategy) == null ? void 0 : t.getNode(e);
  }
  destroy() {
    super.destroy(), this.strategy = void 0;
  }
  execute(e) {
    const t = tp(this.gos), n = this.approach !== t, o = n ? this.changeApproach(e, t) : this.strategy;
    if (o)
      return o.execute(e, t) || n;
  }
  getStrategyBeanName(e) {
    switch (e) {
      case "group":
        return "groupStrategy";
      case "treePath":
      case "treeNested":
      case "treeSelfRef":
        return "treeGroupStrategy";
      default:
        return null;
    }
  }
  changeApproach({ rowNode: e }, t) {
    var i;
    this.approach = t;
    const n = this.getStrategyBeanName(t), o = this.strategy;
    let s = o;
    return this.strategyBeanName !== n ? (this.destroyBean(s), s = void 0, n && (s = this.beans.registry.createDynamicBean(n, !1), this.createOptionalManagedBean(s)), this.strategy = s, this.strategyBeanName = n) : (i = s == null ? void 0 : s.reset) == null || i.call(s), o && e9(e, t !== "treeNested"), s;
  }
}, e9 = (e, t) => {
  const n = e.allLeafChildren, o = e.sibling;
  e.treeNodeFlags = 0, e.childrenAfterGroup = n, e.childrenMapped = null, e.groupData = null, o && (o.childrenAfterGroup = e.childrenAfterGroup, o.childrenAfterAggFilter = e.childrenAfterAggFilter, o.childrenAfterFilter = e.childrenAfterFilter, o.childrenAfterSort = e.childrenAfterSort, o.childrenMapped = null);
  for (const s of n) {
    const i = s.sibling;
    P0(s), i && P0(i), s.parent = e, t && (s.treeParent = null), (s.group || s.hasChildren()) && (s.group = !1, s.updateHasChildren());
  }
  e.updateHasChildren();
}, P0 = (e) => {
  e.key = null, e.treeNodeFlags = 0, e.allChildrenCount = null, e.allLeafChildren = null, e.childrenAfterGroup = null, e.childrenAfterAggFilter = null, e.childrenAfterFilter = null, e.childrenAfterSort = null, e.childrenMapped = null, e.level = 0, e.groupData && (e.groupData = null);
};
function D0(e, t, n) {
  var r;
  let o = e;
  const s = o.level - t.level;
  if (s <= 0 || !n.get("groupHideOpenParents"))
    return !1;
  for (let a = 0; a < s; a++) {
    if (!(((r = o.parent) == null ? void 0 : r.getFirstChild()) === o))
      return !1;
    o = o.parent;
  }
  return o === t;
}
var Jp = (e, t, n, o = t.group) => {
  const s = e.gos, i = o && s.get("isGroupOpenByDefault");
  if (!i) {
    const a = s.get("groupDefaultExpanded");
    return a === -1 || n < a;
  }
  const r = {
    api: e.gridApi,
    context: e.gridOptions.context,
    rowNode: t,
    field: t.field,
    key: t.key,
    level: n,
    rowGroupColumn: t.rowGroupColumn
  };
  return i(r) == !0;
}, Xb = class extends U {
  constructor() {
    super(...arguments), this.indentClass = null;
  }
  init(e, t, n, o, s, i, r) {
    var c;
    this.params = r, this.eGui = t, this.eCheckbox = n, this.eExpanded = o, this.eContracted = s, this.comp = e, this.compClass = i;
    const { node: a, column: l } = r;
    if (this.node = a, this.displayedNode = a, !this.isEmbeddedRowMismatch()) {
      if (a.footer) {
        this.initFooterCell();
        return;
      }
      if (!l) {
        this.initFullWidthCell();
        return;
      }
      this.displayedNode = ((c = this.beans.showRowGroupColValueSvc) == null ? void 0 : c.getDisplayedNode(a, l)) ?? this.node, this.setupExpand(), this.setupCheckbox(), this.addGroupValue(), this.setupIndent();
    }
  }
  initFooterCell() {
    const { node: e } = this.params;
    this.addGroupValue(), this.setupIndent(), e.level === -1 || this.comp.toggleCss("ag-row-group-leaf-indent", !0);
  }
  initFullWidthCell() {
    const e = () => {
      const { rowDragSvc: t } = this.beans;
      if (!this.params.rowDrag || !t)
        return;
      const n = t.createRowDragComp(() => this.params.value, this.params.node);
      this.createManagedBean(n), this.eGui.insertAdjacentElement("afterbegin", n.getGui());
    };
    this.setupExpand(), e(), this.setupCheckbox(), this.addGroupValue(), this.setupIndent();
  }
  /**
   * Returns an aria "role" to place on full width group cells, or the parent wrapper.
   * @returns the aria role to place on the parent wrapper
   */
  getCellAriaRole() {
    var n, o;
    const e = (n = this.params.colDef) == null ? void 0 : n.cellAriaRole, t = (o = this.params.column) == null ? void 0 : o.getColDef().cellAriaRole;
    return e || t || "gridcell";
  }
  /**
   * Determines if this cell should be rendered, as when using embeddedFullWidthRows
   * only one group cell should be rendered.
   *
   * if [enableRTL] all but pinned right cells should be skipped if available
   * otherwise prioritise pinned left cell if available
   * otherwise center viewport.
   *
   * @returns whether the cell should be skipped due to embedded full width rows
   */
  isEmbeddedRowMismatch() {
    if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows"))
      return !1;
    const { visibleCols: e } = this.beans, t = this.params.pinned === "left", n = this.params.pinned === "right", o = !t && !n;
    return this.gos.get("enableRtl") ? e.isPinningLeft() ? !n : !o : e.isPinningLeft() ? !t : !o;
  }
  /**
   * Displays the group value for the displayed node
   */
  addGroupValue() {
    const {
      params: { value: e, valueFormatted: t }
    } = this, n = this.getInnerCompDetails();
    this.comp.setInnerRenderer(n, t ?? e ?? null);
  }
  /**
   * Sets up expand/collapse:
   * Chevron
   * Aria-expanded
   * Child count
   */
  setupExpand() {
    const { colModel: e } = this.beans, { eGridCell: t, column: n, suppressDoubleClickExpand: o } = this.params, s = (d, c) => {
      const u = Le(d, this.beans, null);
      u && (c.appendChild(u), this.addDestroyFunc(() => c.removeChild(u)));
    };
    s("groupExpanded", this.eExpanded), s("groupContracted", this.eContracted);
    const i = this.comp, r = () => {
      if (!this.isExpandable())
        return;
      const c = this.displayedNode.expanded;
      i.setExpandedDisplayed(c), i.setContractedDisplayed(!c), Zn(t, !!this.displayedNode.expanded);
    }, a = () => {
      const d = this.isExpandable();
      i.toggleCss("ag-cell-expandable", d), i.toggleCss("ag-row-group", d);
      const c = !d && e.isPivotMode();
      i.toggleCss("ag-pivot-leaf-group", c);
      const u = !e.isPivotMode() && (!this.displayedNode.footer || this.displayedNode.level !== -1);
      i.toggleCss("ag-row-group-leaf-indent", !d && u);
      const h = this.getChildCount(), g = h > 0 ? `(${h})` : "";
      i.setChildCount(g), d ? r() : (i.setExpandedDisplayed(!1), i.setContractedDisplayed(!1), aC(t));
    };
    (() => {
      !((n == null ? void 0 : n.isCellEditable(this.displayedNode)) && this.gos.get("enableGroupEdit")) && !o && this.addManagedListeners(t, { dblclick: this.onCellDblClicked.bind(this) }), this.addManagedListeners(this.eExpanded, { click: this.onExpandClicked.bind(this) }), this.addManagedListeners(this.eContracted, { click: this.onExpandClicked.bind(this) }), this.addManagedListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedListeners(this.displayedNode, {
        // Expandable state has changed
        allChildrenCountChanged: a,
        masterChanged: a,
        groupChanged: a,
        hasChildrenChanged: a,
        // Node expanded changed
        expandedChanged: r
      });
    })(), a();
  }
  /**
   * Return the inner renderer details for the cell
   *
   * Prioritises:
   * 1. Group row renderer for group rows
   * 2. agFindCellRenderer for find results in group rows
   * 3. Provided innerRenderer (i.e, cellRendererParams.innerRenderer)
   * 4. Cell renderer of the grouped column
   * 5. Inner renderer of the grouped column
   * 6. agFindCellRenderer for find results
   */
  getInnerCompDetails() {
    var l, d;
    const { userCompFactory: e, findSvc: t } = this.beans, n = this.params;
    if (n.fullWidth) {
      const c = this.gos.get("groupRowRendererParams"), u = Cl(
        e,
        c,
        n
      );
      return u || (t != null && t.isMatch(n.node, null) ? Cl(
        e,
        { ...c, innerRenderer: "agFindCellRenderer" },
        n
      ) : void 0);
    }
    const o = (c) => c && c.componentClass == this.compClass, s = Cl(e, n, n);
    if (s && !o(s))
      return s;
    const {
      displayedNode: { rowGroupColumn: i }
    } = this, r = i == null ? void 0 : i.colDef, a = i && ((l = n.column) == null ? void 0 : l.isRowGroupDisplayed(i.getId()));
    if (r && a) {
      const c = br(e, r, n);
      if (c)
        if (o(c)) {
          if ((d = r == null ? void 0 : r.cellRendererParams) != null && d.innerRenderer)
            return Cl(
              e,
              r.cellRendererParams,
              n
            );
        } else
          return c;
    }
    if (t != null && t.isMatch(n.node, n.column))
      return br(
        e,
        { ...r ?? n.colDef, cellRenderer: "agFindCellRenderer" },
        n
      );
  }
  /**
   * Get the allChildCount of a given node
   * @param node the node to return the count for
   * @returns 0 if the count should not be displayed, otherwise the count
   */
  getChildCount() {
    const { column: e, suppressCount: t } = this.params;
    if (t)
      return 0;
    const { allChildrenCount: n, rowGroupColumn: o } = this.displayedNode;
    return !((n ?? 0) > 0 && (!o || !e || (e == null ? void 0 : e.isRowGroupDisplayed(o.getId())))) || this.gos.get("showOpenedGroup") && this.displayedNode !== this.node && !D0(this.node, this.displayedNode, this.gos) ? 0 : n ?? 0;
  }
  /**
   * Checks whether the current cell is expandable, either due to [groupHideOpenParent] control or otherwise.
   * @returns whether this cell is expandable
   */
  isExpandable() {
    const { node: e, column: t, colDef: n } = this.params;
    if (!this.displayedNode.isExpandable() || e.rowPinned)
      return !1;
    if (!t)
      return !0;
    if (e.hasChildren() && n) {
      const { showRowGroup: i } = n;
      if (!i)
        return !1;
      if (i === !0)
        return !0;
    }
    return e === this.displayedNode ? e.rowGroupColumn && (t == null ? void 0 : t.isRowGroupDisplayed(e.rowGroupColumn.getId())) ? !0 : e.master ? (n == null ? void 0 : n.showRowGroup) === !0 || (n == null ? void 0 : n.showRowGroup) == null : !1 : D0(this.node, this.displayedNode, this.gos);
  }
  /**
   * For full width group cells & single group column, indents child groups based on uiLevel
   */
  setupIndent() {
    const { suppressPadding: e, node: t, colDef: n } = this.params;
    if (e)
      return;
    const o = () => {
      let s = 0;
      n && n.showRowGroup !== !0 ? s = 0 : s = t.uiLevel;
      const i = "ag-row-group-indent-" + s;
      i !== this.indentClass && (this.indentClass && this.comp.toggleCss(this.indentClass, !1), this.indentClass = i, this.comp.toggleCss(i, !0), this.eGui.style.setProperty("--ag-indentation-level", String(s)));
    };
    this.addManagedListeners(t, { uiLevelChanged: o.bind(this) }), o();
  }
  /**
   * Selection checkboxes
   */
  setupCheckbox() {
    const { node: e } = this.params;
    !e.footer && !e.rowPinned && !e.detail && (this.addManagedPropertyListener("rowSelection", ({ currentValue: n, previousValue: o }) => {
      const s = typeof n == "object" ? n : void 0, i = typeof o == "object" ? o : void 0;
      (s == null ? void 0 : s.checkboxLocation) !== (i == null ? void 0 : i.checkboxLocation) && (this.destroyCheckbox(), this.addCheckbox());
    }), this.addCheckbox());
  }
  addCheckbox() {
    const { selectionSvc: e } = this.beans;
    if (!e || !In(this.gos))
      return;
    const { node: t, column: n } = this.params, o = this.gos.get("rowSelection"), s = Ta(o);
    if (s === "selectionColumn")
      return;
    if (s === "autoGroupColumn") {
      const d = (n == null ? void 0 : n.getColDef().showRowGroup) != null, c = !n && t.group;
      if (!(d || c))
        return;
    }
    const i = typeof o == "object" ? li(o) : this.params.checkbox;
    if (!(typeof i == "function" || i === !0))
      return;
    if (typeof (n == null ? void 0 : n.getColDef().showRowGroup) == "string" && !this.isExpandable()) {
      this.comp.setCheckboxSpacing(!0);
      return;
    }
    const l = e.createCheckboxSelectionComponent();
    this.cbComp = l, this.createBean(l), l.init({
      rowNode: t,
      // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
      column: n,
      overrides: {
        isVisible: i,
        callbackParams: this.params,
        removeHidden: !0
      }
    }), this.eCheckbox.appendChild(l.getGui()), this.comp.setCheckboxVisible(!0);
  }
  destroyCheckbox() {
    this.comp.setCheckboxSpacing(!1), this.comp.setCheckboxVisible(!1), this.cbComp && this.eCheckbox.removeChild(this.cbComp.getGui()), this.cbComp = this.destroyBean(this.cbComp);
  }
  /**
   * Called when the expand / contract icon is clicked.
   */
  onExpandClicked(e) {
    Dn(e) || (bt(e), this.onExpandOrContract(e));
  }
  /**
   * Called on cell key press - only handles 'Enter' key for expand/collapse
   */
  onKeyDown(e) {
    !(e.key === O.ENTER) || this.params.suppressEnterExpand || this.params.column && this.params.column.isCellEditable(this.params.node) || this.onExpandOrContract(e);
  }
  /**
   * Called on cell double click - only expands/collapses if the event is not on the expand / contract icon
   */
  onCellDblClicked(e) {
    if (Dn(e))
      return;
    ph(this.eExpanded, e) || ph(this.eContracted, e) || this.onExpandOrContract(e);
  }
  /**
   * Called when expand or contract is attempted, to scroll the row and update the node state
   * @param e originating event
   */
  onExpandOrContract(e) {
    if (!this.isExpandable())
      return;
    const t = this.displayedNode, n = !t.expanded;
    !n && t.sticky && this.beans.ctrlsSvc.getScrollFeature().setVerticalScrollPosition(t.rowTop - t.stickyRowTop), t.setExpanded(n, e);
  }
  destroy() {
    super.destroy(), this.destroyCheckbox();
  }
}, t9 = {
  tag: "span",
  cls: "ag-cell-wrapper",
  children: [
    { tag: "span", ref: "eExpanded", cls: "ag-group-expanded ag-hidden" },
    { tag: "span", ref: "eContracted", cls: "ag-group-contracted ag-hidden" },
    { tag: "span", ref: "eCheckbox", cls: "ag-group-checkbox ag-invisible" },
    { tag: "span", ref: "eValue", cls: "ag-group-value" },
    { tag: "span", ref: "eChildCount", cls: "ag-group-child-count" }
  ]
}, T0 = class extends Te {
  constructor() {
    super(t9), this.eExpanded = X, this.eContracted = X, this.eCheckbox = X, this.eValue = X, this.eChildCount = X;
  }
  init(e) {
    const t = {
      setInnerRenderer: (i, r) => this.setRenderDetails(i, r),
      setChildCount: (i) => this.eChildCount.textContent = i,
      toggleCss: (i, r) => this.toggleCss(i, r),
      setContractedDisplayed: (i) => He(this.eContracted, i),
      setExpandedDisplayed: (i) => He(this.eExpanded, i),
      setCheckboxVisible: (i) => this.eCheckbox.classList.toggle("ag-invisible", !i),
      setCheckboxSpacing: (i) => this.eCheckbox.classList.toggle("ag-group-checkbox-spacing", i)
    }, n = this.createManagedBean(new Xb()), o = !e.colDef, s = this.getGui();
    n.init(t, s, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, e), o && hn(s, n.getCellAriaRole());
  }
  setRenderDetails(e, t) {
    e ? e.newAgStackInstance().then((n) => {
      if (!n)
        return;
      const o = () => this.destroyBean(n);
      this.isAlive() ? (this.eValue.appendChild(n.getGui()), this.addDestroyFunc(o)) : o();
    }) : this.eValue.innerText = t;
  }
  destroy() {
    this.destroyBean(this.innerCellRenderer), super.destroy();
  }
  refresh() {
    return !1;
  }
}, n9 = (
  /*css*/
  ".ag-group-checkbox-spacing{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-group-checkbox-spacing{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-checkbox-spacing{margin-left:var(--ag-cell-widget-spacing)}"
), o9 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "showRowGroupColValueSvc";
  }
  /**
   * Get the value for format in the group column, also returns the displayedNode from which the value was
   * taken in cases of groupHideOpenParents and showOpenedGroup.
   */
  getGroupValue(e, t) {
    var i;
    if (!t)
      return e.group ? { displayedNode: e, value: e.groupValue } : null;
    const n = this.beans.valueSvc, o = t.colDef.showRowGroup;
    if (!o)
      return null;
    if (e.level === -1 && e.footer)
      return { displayedNode: e, value: null };
    if (typeof o == "string") {
      if ((((i = this.beans.rowGroupColsSvc) == null ? void 0 : i.getColumnIndex(o)) ?? -1) > e.level)
        return null;
      const a = this.getDisplayedNode(e, t, !0);
      if (a)
        return {
          displayedNode: a,
          value: n.getValue(t, a)
        };
    }
    const s = n.getValue(t, e);
    if (s == null) {
      const r = this.getDisplayedNode(e, t);
      if (r)
        return {
          displayedNode: r,
          value: n.getValue(t, r)
        };
    }
    return {
      displayedNode: e,
      value: s
    };
  }
  /**
   * Formats a group col value, and prefixes it with the "Total" prefix if applicable
   */
  formatAndPrefixGroupColValue(e, t, n = !1) {
    const o = this.formatGroupColValue(e, t, n), { value: s, displayedNode: i } = e, r = this.beans.footerSvc;
    return r != null && r.doesCellShowTotalPrefix(i, t) ? r.applyTotalPrefix(s, o, i, t) : i.footer && i.level === -1 ? null : o;
  }
  /**
   * Formats the group col value using the underlying column's value formatter
   */
  formatGroupColValue(e, t, n = !1) {
    const o = this.beans.valueSvc, { displayedNode: s, value: i } = e, r = s.rowGroupColumn, a = s.group && !t;
    if (r && (a || (t == null ? void 0 : t.isRowGroupDisplayed(r.colId)))) {
      if (n && r.colDef.useValueFormatterForExport === !1)
        return null;
      const d = o.formatValue(r, s, i);
      return d == null && s.key === "" ? this.getLocaleTextFunc()("blanks", "(Blanks)") : d;
    }
    return !t || s.group || n && t.colDef.useValueFormatterForExport === !1 ? null : o.formatValue(t, s, i);
  }
  /**
   * Checks if the node has a value to inherit from the parent node for display in the given column
   *
   * This is used when [groupHideOpenParents] or [showOpenedGroup] are enabled
   *
   * @param node node to check for preferential nodes to display
   * @param column column to get the displayed node for
   * @returns a parent node of node to display the value from, or undefined if no value will be inherited
   */
  getDisplayedNode(e, t, n = !1) {
    var l, d;
    const o = this.gos, s = o.get("groupHideOpenParents"), i = o.get("showOpenedGroup") && !n;
    if (!s && !i)
      return;
    const r = t.colDef.showRowGroup;
    if (r === !0)
      return e.group ? void 0 : e.parent ?? void 0;
    let a = e;
    for (; a && ((l = a.rowGroupColumn) == null ? void 0 : l.getId()) != r; ) {
      const c = a === ((d = a.parent) == null ? void 0 : d.getFirstChild());
      if (!i && !c)
        return;
      a = a.parent;
    }
    if (a !== e)
      return a ?? void 0;
  }
}, s9 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "showRowGroupCols";
  }
  refresh() {
    this.showRowGroupCols = [], this.showRowGroupColsMap = {};
    const { colModel: e, rowGroupColsSvc: t } = this.beans;
    e.getCols().forEach((n) => {
      const s = n.getColDef().showRowGroup, i = typeof s == "string";
      !i && !(s === !0) || (this.showRowGroupCols.push(n), i ? this.showRowGroupColsMap[s] = n : t && t.columns.forEach((a) => {
        this.showRowGroupColsMap[a.getId()] = n;
      }));
    });
  }
  getShowRowGroupCols() {
    return this.showRowGroupCols;
  }
  getShowRowGroupCol(e) {
    return this.showRowGroupColsMap[e];
  }
  getSourceColumnsForGroupColumn(e) {
    const t = e.getColDef().showRowGroup;
    if (!t)
      return null;
    const { rowGroupColsSvc: n, colModel: o } = this.beans;
    if (t === !0 && n)
      return n.columns.slice(0);
    const s = o.getColDefCol(t);
    return s ? [s] : null;
  }
  isRowGroupDisplayed(e, t) {
    const { colDef: n } = e;
    if ((n == null ? void 0 : n.showRowGroup) == null)
      return !1;
    const o = n.showRowGroup === !0, s = n.showRowGroup === t;
    return o || s;
  }
}, i9 = class extends U {
  constructor(e, t) {
    super(), this.createRowCon = e, this.destroyRowCtrls = t, this.stickyTopRowCtrls = [], this.stickyBottomRowCtrls = [], this.extraTopHeight = 0, this.extraBottomHeight = 0;
  }
  postConstruct() {
    this.isClientSide = Ct(this.gos), this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl;
    }), this.resetStickyContainers();
  }
  setOffsetTop(e) {
    this.extraTopHeight !== e && (this.extraTopHeight = e, this.eventSvc.dispatchEvent({
      type: "stickyTopOffsetChanged",
      offset: e
    }));
  }
  setOffsetBottom(e) {
    this.extraBottomHeight !== e && (this.extraBottomHeight = e);
  }
  resetOffsets() {
    this.setOffsetBottom(0), this.setOffsetTop(0);
  }
  /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */
  getLastPixelOfGroup(e) {
    return this.isClientSide ? a9(e) : r9(e);
  }
  /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */
  getFirstPixelOfGroup(e) {
    return e.footer ? e.sibling.rowTop + e.sibling.rowHeight - 1 : e.hasChildren() ? e.rowTop - 1 : 0;
  }
  updateStickyRows(e) {
    const t = e === "top";
    let n = 0;
    if (!this.canRowsBeSticky())
      return this.refreshNodesAndContainerHeight(e, /* @__PURE__ */ new Set(), n);
    const { rowModel: o, rowRenderer: s, pinnedRowModel: i } = this.beans, r = t ? s.firstVisibleVPixel - this.extraTopHeight : s.lastVisibleVPixel - this.extraTopHeight, a = /* @__PURE__ */ new Set(), l = (h) => {
      if (a.add(h), t) {
        const g = this.getLastPixelOfGroup(h), p = r + n + h.rowHeight;
        g < p ? h.stickyRowTop = n + (g - p) : h.stickyRowTop = n;
      } else {
        const g = this.getFirstPixelOfGroup(h), p = r - (n + h.rowHeight);
        g > p ? h.stickyRowTop = n - (g - p) : h.stickyRowTop = n;
      }
      n = 0, a.forEach((g) => {
        const p = g.stickyRowTop + g.rowHeight;
        n < p && (n = p);
      });
    }, d = this.areFooterRowsStickySuppressed(), c = this.gos.get("suppressGroupRowsSticky"), u = (h) => {
      if (!h.displayed)
        return !1;
      if (h.footer) {
        if (d === !0 || d === "grand" && h.level === -1 || d === "group" && h.level > -1)
          return !1;
        const g = h.sibling.rowIndex ? h.sibling.rowIndex + 1 === h.rowIndex : !1;
        return e === "bottom" && g || h.level === -1 && (i != null && i.getGrandTotalPinned()) ? !1 : !a.has(h);
      }
      return h.isExpandable() ? c === !0 || e === "bottom" ? !1 : !a.has(h) && h.expanded : !1;
    };
    for (let h = 0; h < 100; h++) {
      let g = r + n;
      t || (g = r - n);
      const p = o.getRowIndexAtPixel(g), f = o.getRow(p);
      if (f == null)
        break;
      const C = this.getStickyAncestors(f).find(
        (b) => (t ? b.rowIndex < p : b.rowIndex > p) && u(b)
      );
      if (C) {
        l(C);
        continue;
      }
      if ((t ? f.rowTop < g : f.rowTop + f.rowHeight > g) && u(f)) {
        l(f);
        continue;
      }
      break;
    }
    return t || a.forEach((h) => {
      h.stickyRowTop = n - (h.stickyRowTop + h.rowHeight);
    }), this.refreshNodesAndContainerHeight(e, a, n);
  }
  areFooterRowsStickySuppressed() {
    const e = this.gos.get("suppressStickyTotalRow");
    if (e === !0)
      return !0;
    const t = e === "group", n = e === "grand";
    return t && n ? !0 : n ? "grand" : t ? "group" : !1;
  }
  canRowsBeSticky() {
    const e = gc(this.gos), t = this.areFooterRowsStickySuppressed(), n = this.gos.get("suppressGroupRowsSticky");
    return e && (!t || !n);
  }
  getStickyAncestors(e) {
    const t = [];
    let n = e.footer ? e.sibling : e.parent;
    for (; n; )
      n.sibling && t.push(n.sibling), t.push(n), n = n.parent;
    return t.reverse();
  }
  checkStickyRows() {
    const e = this.updateStickyRows("top"), t = this.updateStickyRows("bottom");
    return e || t;
  }
  destroyStickyCtrls() {
    this.resetStickyContainers();
  }
  resetStickyContainers() {
    this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0), this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
  }
  refreshStickyNode(e) {
    const t = /* @__PURE__ */ new Set();
    if (this.stickyTopRowCtrls.some((n) => n.rowNode === e)) {
      for (let n = 0; n < this.stickyTopRowCtrls.length; n++) {
        const o = this.stickyTopRowCtrls[n].rowNode;
        o !== e && t.add(o);
      }
      this.refreshNodesAndContainerHeight("top", t, this.topContainerHeight) && this.checkStickyRows();
      return;
    }
    for (let n = 0; n < this.stickyBottomRowCtrls.length; n++) {
      const o = this.stickyBottomRowCtrls[n].rowNode;
      o !== e && t.add(o);
    }
    this.refreshNodesAndContainerHeight("bottom", t, this.bottomContainerHeight) && this.checkStickyRows();
  }
  /**
   * Destroy old ctrls and create new ctrls where necessary.
   */
  refreshNodesAndContainerHeight(e, t, n) {
    const o = e === "top", s = o ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls, i = {}, r = [];
    for (let g = 0; g < s.length; g++) {
      const p = s[g].rowNode;
      if (!t.has(p)) {
        i[p.id] = s[g], p.sticky = !1;
        continue;
      }
      r.push(s[g]);
    }
    const a = /* @__PURE__ */ new Set();
    for (let g = 0; g < r.length; g++)
      a.add(r[g].rowNode);
    const l = [];
    t.forEach((g) => {
      a.has(g) || (g.sticky = !0, l.push(this.createRowCon(g, !1, !1)));
    });
    let d = !!l.length || r.length !== s.length;
    o ? this.topContainerHeight !== n && (this.topContainerHeight = n, this.gridBodyCtrl.setStickyTopHeight(n), d = !0) : this.bottomContainerHeight !== n && (this.bottomContainerHeight = n, this.gridBodyCtrl.setStickyBottomHeight(n), d = !0), this.destroyRowCtrls(i, !1);
    const c = [...r, ...l];
    c.sort((g, p) => p.rowNode.rowIndex - g.rowNode.rowIndex), o || c.reverse(), c.forEach((g) => g.setRowTop(g.rowNode.stickyRowTop));
    const u = this.beans.pageBounds;
    let h = 0;
    return o ? (t.forEach((g) => {
      g.rowIndex < u.getFirstRow() && (h += g.rowHeight);
    }), h > this.topContainerHeight && (h = this.topContainerHeight), this.setOffsetTop(h)) : (t.forEach((g) => {
      g.rowIndex > u.getLastRow() && (h += g.rowHeight);
    }), h > this.bottomContainerHeight && (h = this.bottomContainerHeight), this.setOffsetBottom(h)), d ? (o ? this.stickyTopRowCtrls = c : this.stickyBottomRowCtrls = c, !0) : !1;
  }
  ensureRowHeightsValid() {
    let e = !1;
    const t = (n) => {
      const o = n.rowNode;
      if (o.rowHeightEstimated) {
        const s = qt(this.beans, o);
        o.setRowHeight(s.height), e = !0;
      }
    };
    return this.stickyTopRowCtrls.forEach(t), this.stickyBottomRowCtrls.forEach(t), e;
  }
};
function r9(e) {
  var t, n;
  if (e.isExpandable() || e.footer) {
    if (e.master && e.detailNode)
      return e.detailNode.rowTop + e.detailNode.rowHeight;
    if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
      let s = (t = e.childStore) == null ? void 0 : t.getStoreBounds();
      return e.footer && (s = (n = e.sibling.childStore) == null ? void 0 : n.getStoreBounds()), ((s == null ? void 0 : s.heightPx) ?? 0) + ((s == null ? void 0 : s.topPx) ?? 0);
    }
    return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
  }
  return Number.MAX_SAFE_INTEGER;
}
function a9(e) {
  if (e.isExpandable() || e.footer) {
    if (e.footer && e.rowIndex === 0)
      return Number.MAX_SAFE_INTEGER;
    if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
      let o = e.footer ? e.sibling : e;
      for (; o.isExpandable() && o.expanded; )
        if (o.master && o.detailNode)
          o = o.detailNode;
        else if (o.childrenAfterSort) {
          if (o.childrenAfterSort.length === 0)
            break;
          o = Je(o.childrenAfterSort);
        }
      return o.rowTop + o.rowHeight;
    }
    return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
  }
  return Number.MAX_SAFE_INTEGER;
}
var l9 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "stickyRowSvc";
  }
  createStickyRowFeature(e, t, n) {
    const o = this.gos;
    if (gc(o) && Ct(o) || gn(o))
      return e.createManagedBean(new i9(t, n));
  }
}, eS = {
  moduleName: "GroupCellRenderer",
  version: gt,
  userComponents: {
    agGroupRowRenderer: T0,
    agGroupCellRenderer: T0
  },
  dynamicBeans: { groupCellRendererCtrl: Xb },
  icons: {
    // shown on row group when contracted (click to expand)
    groupContracted: "tree-closed",
    // shown on row group when expanded (click to contract)
    groupExpanded: "tree-open"
  },
  css: [n9],
  dependsOn: [an]
}, tS = {
  moduleName: "GroupColumn",
  version: gt,
  beans: [
    K$,
    s9,
    o9,
    U$,
    Qb,
    jb
  ],
  dependsOn: [an, eS]
}, Xp = {
  moduleName: "ClientSideRowModelHierarchy",
  version: gt,
  rowModels: ["clientSide"],
  beans: [X$, J$, Z$],
  dependsOn: [an]
}, ef = {
  moduleName: "StickyRow",
  version: gt,
  beans: [l9]
}, d9 = class extends Te {
  constructor() {
    super();
  }
  postConstruct() {
    this.setGui(this.createNorthPanel());
    const e = this.onRowGroupChanged.bind(this);
    this.addManagedEventListeners({
      columnRowGroupChanged: e,
      newColumnsLoaded: e
    }), this.addManagedPropertyListener("rowGroupPanelShow", e), this.addManagedPropertyListener("pivotPanelShow", () => this.onPivotPanelShow()), this.onRowGroupChanged();
  }
  createNorthPanel() {
    const e = Ue({ tag: "div", cls: "ag-column-drop-wrapper", role: "presentation" }), t = new Wb(!0);
    this.rowGroupComp = this.createManagedBean(t);
    const n = new zb(!0);
    this.pivotComp = this.createManagedBean(n), e.appendChild(t.getGui()), e.appendChild(n.getGui());
    const o = this.onDropPanelVisible.bind(this);
    return this.addManagedListeners(t, {
      displayChanged: o
    }), this.addManagedListeners(n, {
      displayChanged: o
    }), this.onDropPanelVisible(), e;
  }
  onDropPanelVisible() {
    const { rowGroupComp: e, pivotComp: t } = this, n = e.isDisplayed() && t.isDisplayed(), o = "ag-column-drop-horizontal-half-width";
    e.toggleCss(o, n), t.toggleCss(o, n);
  }
  onRowGroupChanged() {
    var n, o;
    const e = this.rowGroupComp;
    if (!e)
      return;
    const t = this.gos.get("rowGroupPanelShow");
    if (t === "always")
      e.setDisplayed(!0);
    else if (t === "onlyWhenGrouping") {
      const s = ((o = (n = this.beans.rowGroupColsSvc) == null ? void 0 : n.columns) == null ? void 0 : o.length) !== 0;
      e.setDisplayed(s);
    } else
      e.setDisplayed(!1);
  }
  onPivotPanelShow() {
    const e = this.pivotComp;
    if (!e)
      return;
    const t = this.gos.get("pivotPanelShow");
    if (t === "always")
      e.setDisplayed(!0);
    else if (t === "onlyWhenPivoting") {
      const n = this.beans.colModel.isPivotActive();
      e.setDisplayed(n);
    } else
      e.setDisplayed(!1);
  }
}, c9 = {
  selector: "AG-GRID-HEADER-DROP-ZONES",
  component: d9
}, Nu = class {
  constructor() {
    this.allSets = /* @__PURE__ */ new Map();
  }
  removeFromChildrenAfterGroup(e, t) {
    const n = this.getSet(e);
    (n.fromChildrenAfterGroup ?? (n.fromChildrenAfterGroup = /* @__PURE__ */ new Set())).add(t);
  }
  isRemoveFromAllLeafChildren(e, t) {
    var n, o;
    return !!((o = (n = this.allSets.get(e)) == null ? void 0 : n.fromAllLeafChildren) != null && o.has(t));
  }
  preventRemoveFromAllLeafChildren(e, t) {
    var n, o;
    (o = (n = this.allSets.get(e)) == null ? void 0 : n.fromAllLeafChildren) == null || o.delete(t);
  }
  removeFromAllLeafChildren(e, t) {
    const n = this.getSet(e);
    (n.fromAllLeafChildren ?? (n.fromAllLeafChildren = /* @__PURE__ */ new Set())).add(t);
  }
  getSet(e) {
    let t = this.allSets.get(e);
    return t || (t = {
      fromChildrenAfterGroup: null,
      fromAllLeafChildren: null
    }, this.allSets.set(e, t)), t;
  }
  getAllParents() {
    return Array.from(this.allSets.keys());
  }
  flush() {
    const e = this.allSets;
    for (const t of e.keys()) {
      const n = e.get(t);
      if (n) {
        const { fromChildrenAfterGroup: o, fromAllLeafChildren: s } = n, { childrenAfterGroup: i, allLeafChildren: r } = t;
        i && o && (k0(i, o), t.updateHasChildren()), r && s && k0(r, s);
      }
    }
    e.clear();
  }
};
function k0(e, t) {
  let n = 0;
  for (let o = 0, s = e.length; o < s; ++o) {
    const i = e[o];
    t.has(i) || (e[n++] = i);
  }
  e.length = n;
}
var L0 = (e) => {
  if (!e)
    return [];
  const t = e.length, n = new Array(t);
  for (let o = 0; o < t; o++) {
    const s = e[o], i = s.getColDef();
    n[o] = {
      col: s,
      field: i.field,
      type: i.type,
      keyCreator: i.keyCreator,
      valueGetter: i.valueGetter
    };
  }
  return n;
}, B0 = (e, t) => {
  const n = e.length;
  if (n !== (t == null ? void 0 : t.length))
    return !0;
  for (let o = 0; o < n; o++) {
    const s = e[o], i = t[o];
    if (s.col !== i)
      return !0;
    const r = i.getColDef();
    if (s.field !== r.field || s.type !== r.type || s.valueGetter !== r.valueGetter || s.keyCreator !== r.keyCreator)
      return !0;
  }
  return !1;
};
function u9(e) {
  if (!e)
    return !1;
  const t = e.length;
  if (t < 2)
    return !1;
  let n = !1;
  for (let o = 1; o < t; o++)
    if (O0(e[o - 1], e[o]) > 0) {
      n = !0;
      break;
    }
  return n ? (e.sort(O0), !0) : !1;
}
function O0(e, t) {
  const n = e.sourceRowIndex, o = t.sourceRowIndex, s = n >= 0, i = o >= 0, r = s && i, a = !s && !i;
  return r ? n - o : a ? e.__objectId - t.__objectId : s ? 1 : -1;
}
var h9 = class extends U {
  constructor() {
    super(...arguments), this.prevGroupCols = null, this.prevShowGroupCols = null;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.valueSvc = e.valueSvc, this.selectionSvc = e.selectionSvc, this.showRowGroupCols = e.showRowGroupCols;
  }
  getNode(e) {
    let t;
    return this.beans.rowModel.forEachNode((n) => {
      n.id === e && (t = n);
    }), t;
  }
  execute(e) {
    var s;
    const t = this.createGroupingDetails(e), n = e.changedRowNodes;
    n ? this.handleDeltaUpdate(t, n) : this.shotgunResetEverything(t, !!e.afterColumnsChanged);
    const o = e.changedPath;
    this.positionLeafsAndGroups(o), this.orderGroups(t), (s = this.selectionSvc) == null || s.updateSelectableAfterGrouping(o);
  }
  positionLeafsAndGroups(e) {
    e.forEachChangedNodeDepthFirst((t) => {
      if (t.childrenAfterGroup) {
        const n = [], o = [];
        let s;
        t.childrenAfterGroup.forEach((r) => {
          var a;
          (a = r.childrenAfterGroup) != null && a.length ? r.key === "" && !s ? s = r : o.push(r) : n.push(r);
        }), s && o.push(s), t.childrenAfterGroup = [...n, ...o];
        const i = t.sibling;
        i && (i.childrenAfterGroup = t.childrenAfterGroup);
      }
    }, !1);
  }
  createGroupingDetails(e) {
    var l;
    const { rowNode: t, changedPath: n, rowNodesOrderChanged: o } = e;
    let s = !1;
    const i = (l = this.beans.rowGroupColsSvc) == null ? void 0 : l.columns;
    let r = this.prevGroupCols;
    return (!r || B0(r, i)) && (s = !!r, this.prevGroupCols = r = L0(i)), {
      groupCols: r,
      rootNode: t,
      pivotMode: this.colModel.isPivotMode(),
      rowNodesOrderChanged: !!o,
      groupColsChanged: s,
      // if no transaction and not immutable row data set, then it's shotgun, changed path would be 'not active' at this point anyway
      changedPath: n,
      groupAllowUnbalanced: this.gos.get("groupAllowUnbalanced"),
      isGroupOpenByDefault: this.gos.getCallback("isGroupOpenByDefault"),
      initialGroupOrderComparator: this.gos.getCallback("initialGroupOrderComparator")
    };
  }
  handleDeltaUpdate(e, { removals: t, updates: n, adds: o }) {
    const s = new Nu();
    t.size && this.removeNodes(t, e, s);
    for (const a of n)
      this.moveNodeInWrongPath(a, e, s);
    const i = e.changedPath;
    for (const a of o)
      this.insertOneNode(a, e), i.active && i.addParentNode(a.parent);
    const r = s.getAllParents();
    s.flush(), this.removeEmptyGroups(r, e), e.rowNodesOrderChanged && this.sortChildren(e);
  }
  // this is used when doing delta updates, eg Redux, keeps nodes in right order
  sortChildren(e) {
    e.changedPath.forEachChangedNodeDepthFirst(
      (t) => {
        u9(t.childrenAfterGroup) && e.changedPath.addParentNode(t);
      },
      !1,
      !0
    );
  }
  orderGroups(e) {
    const t = e.initialGroupOrderComparator;
    ue(t) && n(e.rootNode);
    function n(o) {
      ue(o.childrenAfterGroup) && // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
      !o.leafGroup && (o.childrenAfterGroup.sort((i, r) => t({ nodeA: i, nodeB: r })), o.childrenAfterGroup.forEach((i) => n(i)));
    }
  }
  getExistingPathForNode(e, t) {
    const n = [];
    let o = e.parent;
    for (; o && o !== t.rootNode; )
      n.push({
        key: o.key,
        rowGroupColumn: o.rowGroupColumn,
        field: o.field
      }), o = o.parent;
    return n.reverse(), n;
  }
  moveNodeInWrongPath(e, t, n) {
    t.changedPath.active && t.changedPath.addParentNode(e.parent);
    const o = (a) => a.key, s = this.getExistingPathForNode(e, t).map(o), i = this.getGroupInfo(e, t).map(o);
    Yn(s, i) || this.moveNode(e, t, n);
  }
  moveNode(e, t, n) {
    if (this.removeNodesFromParents([e], t, n), this.insertOneNode(e, t, n), e.setData(e.data), t.changedPath.active) {
      const o = e.parent;
      t.changedPath.addParentNode(o);
    }
  }
  removeNodes(e, t, n) {
    if (this.removeNodesFromParents(e, t, n), t.changedPath.active)
      for (const o of e)
        t.changedPath.addParentNode(o.parent);
  }
  forEachParentGroup(e, t, n) {
    let o = t;
    for (; o && o !== e.rootNode; )
      n(o), o = o.parent;
  }
  removeNodesFromParents(e, t, n) {
    const o = n == null, s = n || new Nu();
    for (const i of e)
      this.removeFromParent(i, s), this.forEachParentGroup(t, i.parent, (r) => {
        s.removeFromAllLeafChildren(r, i);
      });
    o && s.flush();
  }
  removeEmptyGroups(e, t) {
    let n = !0;
    const o = (s) => {
      var l, d;
      const i = this.getChildrenMappedKey(s.key, s.rowGroupColumn), r = (l = s.parent) == null ? void 0 : l.childrenMapped;
      return (r ? !r[i] : !0) ? !1 : !!s.group && (((d = s.childrenAfterGroup) == null ? void 0 : d.length) ?? 0) === 0;
    };
    for (; n; ) {
      n = !1;
      const s = new Nu();
      e.forEach((i) => {
        this.forEachParentGroup(t, i, (r) => {
          var a;
          o(r) && (n = !0, this.removeFromParent(r, s), (a = this.selectionSvc) == null || a.setNodesSelected({
            nodes: [r],
            newValue: !1,
            source: "rowGroupChanged"
          }));
        });
      }), s.flush();
    }
  }
  // removes the node from the parent by:
  // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
  // b) removing from childrenMapped (immediately)
  // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
  // d) setRowIndex(null) - as the rowNode will no longer be displayed.
  removeFromParent(e, t) {
    var s;
    e.parent && (t ? t.removeFromChildrenAfterGroup(e.parent, e) : ($t(e.parent.childrenAfterGroup, e), e.parent.updateHasChildren()));
    const n = this.getChildrenMappedKey(e.key, e.rowGroupColumn), o = (s = e.parent) == null ? void 0 : s.childrenMapped;
    o && delete o[n], e.setRowTop(null), e.setRowIndex(null);
  }
  /**
   * This is idempotent, but relies on the `key` field being the same throughout a RowNode's lifetime
   */
  addToParent(e, t) {
    const n = t.childrenMapped ?? (t.childrenMapped = {}), o = this.getChildrenMappedKey(e.key, e.rowGroupColumn);
    if (n[o] !== e) {
      n[o] = e;
      let s = t.childrenAfterGroup;
      if (!s) {
        t.childrenAfterGroup = s = [];
        const i = t.sibling;
        i && (i.childrenAfterGroup = t.childrenAfterGroup);
      }
      s.push(e), Vb(t, this.beans, !0);
    }
  }
  checkAllGroupDataAfterColsChanged(e) {
    const t = (n) => {
      n && n.forEach((o) => {
        var r;
        if (!o.group)
          return;
        const i = {
          field: o.field,
          key: o.key,
          rowGroupColumn: o.rowGroupColumn,
          leafNode: (r = o.allLeafChildren) == null ? void 0 : r[0]
        };
        this.setGroupData(o, i), t(o.childrenAfterGroup);
      });
    };
    t(e.rootNode.childrenAfterGroup);
  }
  shotgunResetEverything(e, t) {
    var s, i;
    if (this.noChangeInGroupingColumns(e, t))
      return;
    (i = (s = this.selectionSvc) == null ? void 0 : s.filterFromSelection) == null || i.call(s, (r) => !r.group);
    const n = e.rootNode;
    n.leafGroup = e.groupCols.length === 0, n.childrenAfterGroup = [], n.childrenMapped = {}, n.updateHasChildren();
    const o = n.sibling;
    o && (o.childrenAfterGroup = n.childrenAfterGroup, o.childrenMapped = n.childrenMapped), this.insertNodes(n.allLeafChildren, e);
  }
  noChangeInGroupingColumns(e, t) {
    let n = !1;
    const o = this.prevShowGroupCols, s = this.showRowGroupCols.getShowRowGroupCols();
    return (!o || B0(o, s)) && (n = !!o, this.prevShowGroupCols = L0(s)), !t || e.groupColsChanged ? !1 : (n && this.checkAllGroupDataAfterColsChanged(e), !0);
  }
  insertNodes(e, t) {
    e.forEach((n) => {
      this.insertOneNode(n, t), t.changedPath.active && t.changedPath.addParentNode(n.parent);
    });
  }
  insertOneNode(e, t, n) {
    const o = this.getGroupInfo(e, t), s = this.findParentForNode(e, o, t, n);
    s.group || Z(184, { parentGroupData: s.data, childNodeData: e.data }), e.parent = s, e.level = o.length, s.childrenAfterGroup.push(e), s.updateHasChildren();
  }
  findParentForNode(e, t, n, o) {
    let s = n.rootNode;
    return t.forEach((i, r) => {
      s = this.getOrCreateNextNode(s, i, r, n), o != null && o.isRemoveFromAllLeafChildren(s, e) ? o == null || o.preventRemoveFromAllLeafChildren(s, e) : s.allLeafChildren.push(e);
    }), s;
  }
  getOrCreateNextNode(e, t, n, o) {
    const s = this.getChildrenMappedKey(t.key, t.rowGroupColumn), i = e == null ? void 0 : e.childrenMapped;
    let r = i == null ? void 0 : i[s];
    return r || (r = this.createGroup(t, e, n, o), this.addToParent(r, e)), r;
  }
  createGroup(e, t, n, o) {
    const s = new Ln(this.beans);
    return s.group = !0, s.field = e.field, s.rowGroupColumn = e.rowGroupColumn, this.setGroupData(s, e), s.key = e.key, s.id = this.createGroupId(s, t, n), s.level = n, s.leafGroup = n === o.groupCols.length - 1, s.allLeafChildren = [], s.setAllChildrenCount(0), s.rowGroupIndex = n, s.childrenAfterGroup = [], s.childrenMapped = {}, s.updateHasChildren(), s.parent = t, this.setExpandedInitialValue(o, s), s;
  }
  createGroupId(e, t, n) {
    const o = (s, i) => {
      if (!s.rowGroupColumn)
        return null;
      const r = i ? o(i, i.parent) : null;
      return `${r == null ? "" : r + "-"}${s.rowGroupColumn.getColId()}-${s.key}`;
    };
    return Pd + o(e, t);
  }
  setGroupData(e, t) {
    const n = t.rowGroupColumn;
    n && t.leafNode && (e.groupValue = this.valueSvc.getValue(n, t.leafNode)), e.groupData = {}, this.showRowGroupCols.getShowRowGroupCols().forEach((s) => {
      const i = e.rowGroupColumn;
      i !== null && s.isRowGroupDisplayed(i.getId()) && (e.groupData[s.getColId()] = this.valueSvc.getValue(i, t.leafNode));
    });
  }
  getChildrenMappedKey(e, t) {
    return t ? t.getId() + "-" + e : e;
  }
  setExpandedInitialValue(e, t) {
    if (e.pivotMode && t.leafGroup) {
      t.expanded = !1;
      return;
    }
    t.expanded = Jp(this.beans, t, t.level);
  }
  getGroupInfo(e, t) {
    const n = [];
    for (const { col: o, field: s } of t.groupCols) {
      let i = this.valueSvc.getKeyForNode(o, e), r = i != null && i !== "";
      if ((t.pivotMode || !t.groupAllowUnbalanced) && !r && (i = "", r = !0), r) {
        const l = {
          key: i,
          field: s,
          rowGroupColumn: o,
          leafNode: e
        };
        n.push(l);
      }
    }
    return n;
  }
};
function g9(e, t) {
  var n;
  (n = e.rowGroupColsSvc) == null || n.setColumns(t, "api");
}
function p9(e, t) {
  var n;
  (n = e.rowGroupColsSvc) == null || n.removeColumns(t, "api");
}
function f9(e, t) {
  var n;
  (n = e.rowGroupColsSvc) == null || n.addColumns(t, "api");
}
function m9(e, t, n) {
  var o, s;
  (s = (o = e.rowGroupColsSvc) == null ? void 0 : o.moveColumn) == null || s.call(o, t, n, "api");
}
function v9(e) {
  var t;
  return ((t = e.rowGroupColsSvc) == null ? void 0 : t.columns) ?? [];
}
var nS = {
  moduleName: "SharedRowGrouping",
  version: gt,
  apiFunctions: {
    setRowGroupColumns: g9,
    removeRowGroupColumns: p9,
    addRowGroupColumns: f9,
    getRowGroupColumns: v9,
    moveRowGroupColumn: m9
  },
  dependsOn: [
    an,
    Qp,
    tS,
    ef,
    W$
  ]
}, C9 = {
  moduleName: "RowGrouping",
  version: gt,
  dynamicBeans: { groupStrategy: h9 },
  rowModels: ["clientSide"],
  dependsOn: [nS, Yb, Xp]
}, w9 = {
  moduleName: "RowGroupingPanel",
  version: gt,
  selectors: [c9],
  icons: {
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // separator between column 'pills' when you add multiple columns to the header drop zone
    panelDelimiter: "small-right",
    // version of panelDelimiter used in RTL mode
    panelDelimiterRtl: "small-left"
  },
  dependsOn: [an, Vs]
}, oS = class extends U {
  constructor() {
    super(...arguments), this.loadRowDataVersion = 0;
  }
  wireBeans(e) {
    this.environment = e.environment;
  }
  init(e, t) {
    this.params = t, this.comp = e, t.pinned == null && (this.setAutoHeightClasses(), this.setupRefreshStrategy(), this.createDetailGrid(), this.loadRowData(), this.addManagedEventListeners({ fullWidthRowFocused: this.onFullWidthRowFocused.bind(this) }));
  }
  onFullWidthRowFocused(e) {
    const t = this.params, n = { rowIndex: t.node.rowIndex, rowPinned: t.node.rowPinned }, o = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    sy(n, o) && pn(this.comp.getGui(), e.fromBelow);
  }
  setAutoHeightClasses() {
    const e = this.gos.get("detailRowAutoHeight"), t = e ? "ag-details-row-auto-height" : "ag-details-row-fixed-height", n = e ? "ag-details-grid-auto-height" : "ag-details-grid-fixed-height", o = this.comp;
    o.toggleCss(t, !0), o.toggleDetailGridCss(n, !0);
  }
  setupRefreshStrategy() {
    const e = this.params.refreshStrategy;
    if (e == "everything" || e == "nothing" || e == "rows") {
      this.refreshStrategy = e;
      return;
    }
    e != null && Z(170, { providedStrategy: e }), this.refreshStrategy = "rows";
  }
  createDetailGrid() {
    const { params: e, gos: t } = this;
    if (st(e.detailGridOptions)) {
      Z(171);
      return;
    }
    const n = t.get("theme"), o = e.detailGridOptions.theme;
    o && o !== n && Z(267);
    const s = {
      themeStyleContainer: this.environment.eStyleContainer,
      ...e.detailGridOptions,
      theme: n
    };
    t.get("detailRowAutoHeight") && (s.domLayout = "autoHeight"), this.comp.setDetailGrid(s);
  }
  registerDetailWithMaster(e) {
    const {
      params: t,
      beans: { selectionSvc: n, findSvc: o }
    } = this, s = t.node.id, i = t.api, r = {
      id: s,
      api: e
    }, a = t.node;
    if (i.isDestroyed())
      return;
    i.addDetailGridInfo(s, r), a.detailGridInfo = r;
    const l = a.parent;
    o == null || o.registerDetailGrid(a, e);
    function d() {
      l && (n == null || n.refreshMasterNodeState(l));
    }
    function c({ node: u, source: h }) {
      u !== l || h === "masterDetail" || e.isDestroyed() || n == null || n.setDetailSelectionState(l, t.detailGridOptions, e);
    }
    e.addEventListener("firstDataRendered", () => {
      e.isDestroyed() || i.isDestroyed() || (n == null || n.setDetailSelectionState(l, t.detailGridOptions, e), e.addEventListener("selectionChanged", d), i.addEventListener("rowSelected", c));
    }), this.addDestroyFunc(() => {
      a.detailGridInfo === r && (i.isDestroyed() || i.removeDetailGridInfo(s), a.detailGridInfo = null);
    });
  }
  loadRowData() {
    var i, r, a;
    this.loadRowDataVersion++;
    const e = this.loadRowDataVersion, t = this.params;
    if (((i = t.detailGridOptions) == null ? void 0 : i.rowModelType) === "serverSide") {
      (a = (r = t.node.detailGridInfo) == null ? void 0 : r.api) == null || a.refreshServerSide({ purge: !0 });
      return;
    }
    const n = t.getDetailRowData;
    if (!n) {
      Z(172);
      return;
    }
    const o = (l) => {
      this.loadRowDataVersion === e && this.comp.setRowData(l);
    }, s = {
      node: t.node,
      // we take data from node, rather than params.data
      // as the data could have been updated with new instance
      data: t.node.data,
      successCallback: o,
      context: ke(this.gos, {}).context
    };
    n(s);
  }
  refresh() {
    switch (this.refreshStrategy) {
      case "nothing":
        return !0;
      case "everything":
        return !1;
    }
    return this.loadRowData(), !0;
  }
}, y9 = class {
  constructor(e) {
    this.parentWrapper = e;
  }
  wrap(e, t, n, o) {
    return this.parentWrapper.wrap(e, t, n, o);
  }
}, b9 = { tag: "div", cls: "ag-details-row" }, S9 = {
  tag: "div",
  cls: "ag-details-row",
  role: "gridcell",
  children: [{ tag: "div", ref: "eDetailGrid", cls: "ag-details-grid", role: "presentation" }]
}, x9 = class extends Te {
  constructor() {
    super(...arguments), this.eDetailGrid = X;
  }
  wireBeans(e) {
    this.context = e.context;
  }
  init(e) {
    this.params = e, this.selectAndSetTemplate();
    const t = {
      toggleCss: (n, o) => this.toggleCss(n, o),
      toggleDetailGridCss: (n, o) => this.eDetailGrid.classList.toggle(n, o),
      setDetailGrid: (n) => this.setDetailGrid(n),
      setRowData: (n) => this.setRowData(n),
      getGui: () => this.eDetailGrid
    };
    this.ctrl = this.createManagedBean(new oS()), this.ctrl.init(t, e);
  }
  refresh() {
    var e;
    return ((e = this.ctrl) == null ? void 0 : e.refresh()) ?? !1;
  }
  selectAndSetTemplate() {
    const e = this.params;
    if (e.pinned) {
      this.setTemplate(b9);
      return;
    }
    const t = () => {
      this.setTemplate(S9);
    };
    if (st(e.template))
      t();
    else if (typeof e.template == "string")
      this.setTemplate(e.template, []);
    else if (typeof e.template == "function") {
      const n = e.template, o = n(e);
      this.setTemplate(o, []);
    } else
      Z(168), t();
    this.eDetailGrid == null && Z(169);
  }
  setDetailGrid(e) {
    var i;
    if (!this.eDetailGrid)
      return;
    const t = this.context.getBean("frameworkCompWrapper"), n = new y9(t), { frameworkOverrides: o } = this.beans, s = Gy(this.eDetailGrid, e, {
      frameworkOverrides: o,
      providedBeanInstances: { frameworkCompWrapper: n },
      modules: T4(this.params.api.getGridId(), e.rowModelType ?? "clientSide")
    });
    this.detailApi = s, (i = this.ctrl) == null || i.registerDetailWithMaster(s), this.addDestroyFunc(() => {
      s.destroy();
    });
  }
  setRowData(e) {
    var t;
    (t = this.detailApi) == null || t.setGridOption("rowData", e);
  }
};
function Tc(e, t) {
  var o;
  const n = (o = e.masterDetailSvc) == null ? void 0 : o.store;
  return n ? t(n) : void 0;
}
function R9(e, t, n) {
  Tc(e, (o) => {
    o[t] = n;
  });
}
function E9(e, t) {
  Tc(e, (n) => {
    delete n[t];
  });
}
function A9(e, t) {
  return Tc(e, (n) => n[t]);
}
function F9(e, t) {
  Tc(e, (n) => {
    let o = 0;
    Object.values(n).forEach((s) => {
      s && t(s, o++);
    });
  });
}
var M9 = (
  /*css*/
  ".ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}"
), I9 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "masterDetailSvc", this.store = {};
  }
  isEnabled() {
    return !!this.gos.get("masterDetail");
  }
  postConstruct() {
    Ct(this.gos) && (this.enabled = this.isEnabled());
  }
  refreshModel(e) {
    if (e.changedProps) {
      const t = this.isEnabled();
      if (this.enabled !== t) {
        this.setMasters(null);
        return;
      }
    }
    e.rowDataUpdated && this.setMasters(e.changedRowNodes);
  }
  setMasters(e) {
    var r, a;
    const t = this.isEnabled();
    this.enabled = t;
    const n = this.gos, o = n.get("isRowMaster"), s = n.get("treeData"), i = (l, d, c) => {
      var g;
      const u = l.master;
      let h = t;
      if (t)
        if (d || c) {
          if (o) {
            const p = l.data;
            h = !!p && !!o(p);
          }
        } else
          h = u;
      if (!s)
        if (h && d) {
          const p = ((g = this.beans.rowGroupColsSvc) == null ? void 0 : g.columns.length) ?? 0;
          l.expanded = Jp(this.beans, l, p, !1);
        } else !h && u && (l.expanded = !1);
      h !== u && (l.master = h, l.dispatchRowEvent("masterChanged"));
    };
    if (e) {
      for (const l of e.updates)
        i(l, !1, !0);
      for (const l of e.adds)
        i(l, !0, !1);
    } else {
      const l = (a = (r = Ho(this.beans)) == null ? void 0 : r.rootNode) == null ? void 0 : a.allLeafChildren;
      if (l)
        for (let d = 0, c = l.length; d < c; ++d)
          i(l[d], !0, !1);
    }
  }
  /** Used by flatten stage to get or create a detail node from a master node */
  getDetail(e) {
    if (!e.master || !e.expanded)
      return null;
    let t = e.detailNode;
    return t || (t = new Ln(this.beans), t.detail = !0, t.selectable = !1, t.parent = e, ue(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1, e.detailNode = t, t);
  }
  setupDetailRowAutoHeight(e, t) {
    const { gos: n, beans: o } = this;
    if (!n.get("detailRowAutoHeight"))
      return;
    const s = () => {
      const r = t.clientHeight;
      if (r != null && r > 0) {
        const a = () => {
          const { rowModel: l } = this.beans, { rowNode: d } = e;
          d.setRowHeight(r), (Ct(n) || gn(n)) && l.onRowHeightChanged();
        };
        window.setTimeout(a, 0);
      }
    }, i = Bo(o, t, s);
    e.addDestroyFunc(i), s();
  }
  destroy() {
    this.store = {}, super.destroy();
  }
}, P9 = {
  moduleName: "SharedMasterDetail",
  version: gt,
  beans: [I9],
  userComponents: { agDetailCellRenderer: x9 },
  dynamicBeans: { detailCellRendererCtrl: oS },
  apiFunctions: {
    addDetailGridInfo: R9,
    removeDetailGridInfo: E9,
    getDetailGridInfo: A9,
    forEachDetailGridInfo: F9
  },
  dependsOn: [an, eS, ef],
  css: [M9]
}, D9 = {
  moduleName: "MasterDetail",
  version: gt,
  dependsOn: [P9, Xp, vb]
}, T9 = {
  tag: "div",
  cls: "ag-loading",
  children: [
    { tag: "span", ref: "eLoadingIcon", cls: "ag-loading-icon" },
    { tag: "span", ref: "eLoadingText", cls: "ag-loading-text" }
  ]
}, k9 = class extends Te {
  constructor() {
    super(T9), this.eLoadingIcon = X, this.eLoadingText = X;
  }
  init(e) {
    e.node.failedLoad ? this.setupFailed() : this.setupLoading();
  }
  setupFailed() {
    this.eLoadingText.textContent = this.getLocaleTextFunc()("loadingError", "ERR");
  }
  setupLoading() {
    const e = Le("groupLoading", this.beans, null);
    e && this.eLoadingIcon.appendChild(e), this.eLoadingText.textContent = this.getLocaleTextFunc()("loadingOoo", "Loading");
  }
  refresh(e) {
    return !1;
  }
}, L9 = {
  moduleName: "LoadingCellRenderer",
  version: gt,
  userComponents: {
    agLoadingCellRenderer: k9
  },
  icons: {
    // rotating spinner shown by the loading cell renderer
    groupLoading: "loading"
  },
  dependsOn: [an]
};
function B9(e) {
  return e.colModel.isPivotMode();
}
function O9(e, t, n) {
  var o;
  return ((o = e.pivotResultCols) == null ? void 0 : o.lookupPivotResultCol(t, n)) ?? null;
}
function G9(e, t) {
  var n;
  (n = e.valueColsSvc) == null || n.setColumns(t, "api");
}
function H9(e) {
  var t;
  return ((t = e.valueColsSvc) == null ? void 0 : t.columns) ?? [];
}
function V9(e, t) {
  var n;
  (n = e.valueColsSvc) == null || n.removeColumns(t, "api");
}
function _9(e, t) {
  var n;
  (n = e.valueColsSvc) == null || n.addColumns(t, "api");
}
function N9(e, t) {
  var n;
  (n = e.pivotColsSvc) == null || n.setColumns(t, "api");
}
function $9(e, t) {
  var n;
  (n = e.pivotColsSvc) == null || n.removeColumns(t, "api");
}
function z9(e, t) {
  var n;
  (n = e.pivotColsSvc) == null || n.addColumns(t, "api");
}
function W9(e) {
  var t;
  return ((t = e.pivotColsSvc) == null ? void 0 : t.columns) ?? [];
}
function U9(e, t) {
  var n;
  (n = e.pivotResultCols) == null || n.setPivotResultCols(t, "api");
}
function K9(e) {
  var n;
  const t = (n = e.pivotResultCols) == null ? void 0 : n.getPivotResultCols();
  return t ? t.list : null;
}
var G0 = "PivotRowTotal_", Z9 = ({ headerName: e }, { headerName: t }) => e && !t ? 1 : !e && t ? -1 : !e && !t ? 0 : e < t ? -1 : e > t ? 1 : 0, q9 = (e) => (t, n) => e(t.headerName, n.headerName), j9 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pivotColDefSvc";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.colNames = e.colNames;
  }
  postConstruct() {
    const e = () => this.gos.get("serverSidePivotResultFieldSeparator") ?? "_";
    this.fieldSeparator = e(), this.addManagedPropertyListener("serverSidePivotResultFieldSeparator", () => {
      this.fieldSeparator = e();
    });
    const t = () => this.gos.get("pivotDefaultExpanded");
    this.pivotDefaultExpanded = t(), this.addManagedPropertyListener("pivotDefaultExpanded", () => {
      this.pivotDefaultExpanded = t();
    });
  }
  createPivotColumnDefs(e) {
    const t = this.createPivotColumnsFromUniqueValues(e);
    function n(s, i = []) {
      return s.forEach((r) => {
        r.children !== void 0 ? n(r.children, i) : i.push(r);
      }), i;
    }
    const o = n(t);
    return this.addRowGroupTotals(t, o), this.addExpandablePivotGroups(t, o), this.addPivotTotalsToGroups(t, o), t;
  }
  createPivotColumnsFromUniqueValues(e) {
    var s;
    const t = ((s = this.pivotColsSvc) == null ? void 0 : s.columns) ?? [], n = t.length;
    return this.recursivelyBuildGroup(
      0,
      e,
      [],
      n,
      t
    );
  }
  recursivelyBuildGroup(e, t, n, o, s) {
    var d;
    if (e >= o)
      return this.buildMeasureCols(n);
    const { pivotComparator: i } = s[e].getColDef(), r = i ? q9(i) : Z9, a = (d = this.valueColsSvc) == null ? void 0 : d.columns;
    if ((a == null ? void 0 : a.length) === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && e === o - 1) {
      const c = [];
      for (const u of t.keys()) {
        const h = [...n, u], g = this.createColDef(a[0], u, h);
        g.columnGroupShow = "open", c.push(g);
      }
      return c.sort(r), c;
    }
    const l = [];
    for (const c of t.keys()) {
      const u = this.pivotDefaultExpanded === -1 || e < this.pivotDefaultExpanded, h = [...n, c];
      l.push({
        children: this.recursivelyBuildGroup(
          e + 1,
          t.get(c),
          h,
          o,
          s
        ),
        headerName: c,
        pivotKeys: h,
        columnGroupShow: "open",
        openByDefault: u,
        groupId: this.generateColumnGroupId(h)
      });
    }
    return l.sort(r), l;
  }
  buildMeasureCols(e) {
    var n;
    const t = ((n = this.valueColsSvc) == null ? void 0 : n.columns) ?? [];
    return t.length === 0 ? [this.createColDef(null, "-", e)] : t.map((o) => {
      const s = this.colNames.getDisplayNameForColumn(o, "header"), i = this.createColDef(o, s, e);
      return i.columnGroupShow = "open", i;
    });
  }
  addExpandablePivotGroups(e, t) {
    const n = this.gos.get("suppressExpandablePivotGroups");
    if (n || this.gos.get("pivotColumnGroupTotals"))
      return;
    const o = (s, i, r) => {
      if ("children" in s) {
        const { valueColsSvc: d } = this, { columns: c = [] } = d ?? {}, u = /* @__PURE__ */ new Map();
        s.children.forEach((p) => {
          o(p, i, u);
        });
        const h = !s.children.some((p) => p.children), g = h && c.length === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
        c.forEach((p) => {
          const f = this.colNames.getDisplayNameForColumn(p, "header"), m = this.createColDef(p, f, s.pivotKeys);
          m.pivotTotalColumnIds = u.get(p.getColId()), m.columnGroupShow = n ? "open" : "closed", m.aggFunc = p.getAggFunc(), (!h || g) && (s.children.push(m), i.push(m));
        }), this.merge(r, u);
        return;
      }
      if (!s.pivotValueColumn)
        return;
      const a = s.pivotValueColumn.getColId();
      r.has(a) ? r.get(a).push(s.colId) : r.set(a, [s.colId]);
    };
    e.forEach((s) => {
      o(s, t, /* @__PURE__ */ new Map());
    });
  }
  addPivotTotalsToGroups(e, t) {
    var i;
    if (!this.gos.get("pivotColumnGroupTotals"))
      return;
    const n = this.gos.get("pivotColumnGroupTotals") === "after", o = (i = this.valueColsSvc) == null ? void 0 : i.columns, s = o == null ? void 0 : o.map((r) => r.getAggFunc());
    if (!(!s || s.length < 1 || !this.sameAggFuncs(s)) && o) {
      const r = o[0];
      e.forEach((a) => {
        this.recursivelyAddPivotTotal(a, t, r, n);
      });
    }
  }
  recursivelyAddPivotTotal(e, t, n, o) {
    const s = e;
    if (!s.children) {
      const r = e;
      return r.colId ? [r.colId] : null;
    }
    let i = [];
    if (s.children.forEach((r) => {
      const a = this.recursivelyAddPivotTotal(r, t, n, o);
      a && (i = i.concat(a));
    }), s.children.length > 1) {
      const a = this.getLocaleTextFunc()("pivotColumnGroupTotals", "Total"), l = this.createColDef(n, a, e.pivotKeys, !0);
      l.pivotTotalColumnIds = i, l.aggFunc = n.getAggFunc(), l.columnGroupShow = this.gos.get("suppressExpandablePivotGroups") ? "open" : void 0;
      const d = e.children;
      o ? d.push(l) : d.unshift(l), t.push(l);
    }
    return i;
  }
  addRowGroupTotals(e, t) {
    var r;
    if (!this.gos.get("pivotRowTotals"))
      return;
    const n = this.gos.get("pivotRowTotals") === "after", s = (((r = this.valueColsSvc) == null ? void 0 : r.columns) ?? []).slice();
    n || s.reverse();
    const i = s.length > 1 || !this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
    for (let a = 0; a < s.length; a++) {
      const l = s[a], d = this.colNames.getDisplayNameForColumn(l, "header"), c = this.createColDef(l, d, []), u = [];
      for (let g = 0; g < t.length; g++) {
        const p = t[g];
        p.pivotValueColumn === l && u.push(p.colId);
      }
      c.pivotTotalColumnIds = u, c.colId = G0 + c.colId;
      const h = i ? {
        children: [c],
        pivotKeys: [],
        groupId: `${G0}_pivotGroup_${l.getColId()}`
      } : c;
      t.push(c), n ? e.push(h) : e.unshift(h);
    }
  }
  /**
   * Recreate a pivot colDef to update from a changed valueColumn colDef
   */
  recreateColDef(e) {
    var c;
    const {
      pivotValueColumn: t,
      headerName: n,
      pivotKeys: o,
      pivotTotalColumnIds: s,
      columnGroupShow: i,
      colId: r,
      valueGetter: a,
      aggFunc: l
    } = e;
    if (!t)
      return e;
    const d = this.createColDef(t, n, o, !!s);
    return d.columnGroupShow = i, d.colId = r, d.valueGetter = a, d.aggFunc = l, d.pivotTotalColumnIds = s, (c = this.gos.get("processPivotResultColDef")) == null || c(d), d;
  }
  createColDef(e, t, n, o = !1) {
    const s = {};
    if (e) {
      const i = e.getColDef();
      Object.assign(s, i), s.hide = !1;
    }
    return s.headerName = t, s.colId = this.generateColumnId(
      n || [],
      e && !o ? e.getColId() : ""
    ), s.field = s.colId, s.valueGetter = (i) => {
      var r;
      return (r = i.data) == null ? void 0 : r[i.colDef.field];
    }, s.pivotKeys = n, s.pivotValueColumn = e, s.filter === !0 && (s.filter = "agNumberColumnFilter"), s;
  }
  sameAggFuncs(e) {
    if (e.length == 1)
      return !0;
    for (let t = 1; t < e.length; t++)
      if (e[t] !== e[0])
        return !1;
    return !0;
  }
  merge(e, t) {
    t.forEach((n, o) => {
      const i = [...e.has(o) ? e.get(o) : [], ...n];
      e.set(o, i);
    });
  }
  generateColumnGroupId(e) {
    var n;
    return `pivotGroup_${(((n = this.pivotColsSvc) == null ? void 0 : n.columns) ?? []).map((o) => o.getColId()).join("-")}_${e.join("-")}`;
  }
  generateColumnId(e, t) {
    var o;
    return `pivot_${(((o = this.pivotColsSvc) == null ? void 0 : o.columns) ?? []).map((s) => s.getColId()).join("-")}_${e.join("-")}_${t}`;
  }
  /**
   * Used by the SSRM to create secondary columns from provided fields
   * @param fields
   */
  createColDefsFromFields(e) {
    const t = /* @__PURE__ */ new Map();
    for (let s = 0; s < e.length; s++) {
      const r = e[s].split(this.fieldSeparator);
      let a = t;
      for (let l = 0; l < r.length; l++) {
        const d = r[l];
        let c = a.get(d);
        c || (c = /* @__PURE__ */ new Map(), a.set(d, c)), a = c;
      }
    }
    const n = (s, i, r, a) => {
      const l = [];
      for (const [u, h] of r) {
        const g = n(`${s}${this.fieldSeparator}${u}`, u, h, a + 1);
        l.push(g);
      }
      if (l.length === 0) {
        const u = this.colModel.getColDefCol(i);
        if (u) {
          const g = this.colNames.getDisplayNameForColumn(u, "header") ?? i, p = this.createColDef(u, g, void 0, !1);
          return p.colId = s, p.aggFunc = u.getAggFunc(), p.valueGetter = (f) => {
            var m;
            return (m = f.data) == null ? void 0 : m[s];
          }, p;
        }
        return {
          colId: s,
          headerName: i,
          // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
          // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
          valueGetter: (g) => {
            var p;
            return (p = g.data) == null ? void 0 : p[s];
          }
        };
      }
      return this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && l.length === 1 && "colId" in l[0] ? (l[0].headerName = i, l[0]) : {
        openByDefault: this.pivotDefaultExpanded === -1 || a < this.pivotDefaultExpanded,
        groupId: s,
        headerName: i,
        children: l
      };
    }, o = [];
    for (const [s, i] of t) {
      const r = n(s, s, i, 0);
      o.push(r);
    }
    return o;
  }
}, Y9 = class extends U {
  constructor() {
    super(...arguments), this.beanName = "pivotResultCols";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.visibleCols = e.visibleCols;
  }
  destroy() {
    var e;
    ts(this.beans, (e = this.pivotResultCols) == null ? void 0 : e.tree), super.destroy();
  }
  isPivotResultColsPresent() {
    return this.pivotResultCols != null;
  }
  lookupPivotResultCol(e, t) {
    if (this.pivotResultCols == null)
      return null;
    const n = this.colModel.getColDefCol(t);
    let o = null;
    return this.pivotResultCols.list.forEach((s) => {
      const i = s.getColDef().pivotKeys, r = s.getColDef().pivotValueColumn;
      Yn(i, e) && r === n && (o = s);
    }), o;
  }
  getPivotResultCols() {
    return this.pivotResultCols;
  }
  getPivotResultCol(e) {
    return this.pivotResultCols ? this.colModel.getColFromCollection(e, this.pivotResultCols) : null;
  }
  setPivotResultCols(e, t) {
    var n, o;
    if (this.colModel.ready && !(e == null && this.pivotResultCols == null)) {
      if (e) {
        this.processPivotResultColDef(e);
        const i = (t === "api" ? _C : Q3)(
          this.beans,
          e,
          !1,
          ((n = this.pivotResultCols) == null ? void 0 : n.tree) || this.previousPivotResultCols || void 0,
          t
        );
        ts(this.beans, (o = this.pivotResultCols) == null ? void 0 : o.tree, i.columnTree);
        const r = i.columnTree, a = i.treeDepth, l = np(r), d = {};
        this.pivotResultCols = { tree: r, treeDepth: a, list: l, map: d }, this.pivotResultCols.list.forEach((u) => this.pivotResultCols.map[u.getId()] = u);
        const c = !!this.previousPivotResultCols;
        this.previousPivotResultCols = null, this.colModel.refreshCols(!c);
      } else
        this.previousPivotResultCols = this.pivotResultCols ? this.pivotResultCols.tree : null, this.pivotResultCols = null, this.colModel.refreshCols(!1);
      this.visibleCols.refresh(t);
    }
  }
  processPivotResultColDef(e) {
    const t = this.gos.get("processPivotResultColDef"), n = this.gos.get("processPivotResultColGroupDef");
    if (!t && !n)
      return;
    const o = (s) => {
      s.forEach((i) => {
        if (ue(i.children)) {
          const a = i;
          n && n(a), o(a.children);
        } else
          t && t(i);
      });
    };
    e && o(e);
  }
}, Q9 = {
  moduleName: "SharedPivot",
  version: gt,
  beans: [Y9, j9, Qb],
  apiFunctions: {
    isPivotMode: B9,
    getPivotResultColumn: O9,
    setValueColumns: G9,
    getValueColumns: H9,
    removeValueColumns: V9,
    addValueColumns: _9,
    setPivotColumns: N9,
    removePivotColumns: $9,
    addPivotColumns: z9,
    getPivotColumns: W9,
    setPivotResultColumns: U9,
    getPivotResultColumns: K9
  },
  dependsOn: [nS, uy]
}, J9 = (e) => {
  if (typeof e != "string" || !e.length)
    return [];
  const t = e.split(".");
  return t.includes("__proto__") ? [] : t;
}, sS = (e) => {
  const t = J9(e);
  let n = null;
  const o = t.length - 1;
  return o === 0 ? n = (s) => s == null ? void 0 : s[e] : o > 0 ? n = (s) => {
    let i = s;
    for (let r = 0; r <= o && i !== null && i !== void 0; ++r)
      if (i = i[t[r]], r < o && typeof i != "object" && i !== void 0)
        return null;
    return i;
  } : n = () => {
  }, n.path = e, n;
}, X9 = class extends Yw {
  constructor() {
    super(...arguments), this.beanName = "csrmChildrenTreeNodeSvc", this.childrenGetter = null;
  }
  destroy() {
    super.destroy(), this.childrenGetter = null;
  }
  extractRowData() {
    var e, t;
    return (t = (e = this.rootNode) == null ? void 0 : e.childrenAfterGroup) == null ? void 0 : t.map(({ data: n }) => n);
  }
  activate(e) {
    const t = this.childrenGetter, n = this.gos.get("treeDataChildrenField") ?? null;
    (!t || t.path !== n) && (this.childrenGetter = sS(n)), super.activate(e);
  }
  deactivate() {
    this.childrenGetter = null, super.deactivate();
  }
  updateRowData(e, t) {
    return Z(268), {
      changedRowNodes: t,
      rowNodeTransaction: { add: [], remove: [], update: [] },
      rowsInserted: !1
    };
  }
  loadNewRowData(e) {
    const t = this.rootNode, n = this.childrenGetter, o = /* @__PURE__ */ new Map(), s = [];
    t.allLeafChildren = s;
    const i = (r, a) => {
      let l = o.get(a);
      if (l !== void 0) {
        $e(2, { nodeId: l.id });
        return;
      }
      l = this.createRowNode(a, s.length), l.treeParent = r, o.set(a, l), s.push(l);
      const d = n == null ? void 0 : n(a);
      if (d)
        for (let c = 0, u = d.length; c < u; ++c)
          i(l, d[c]);
    };
    for (let r = 0, a = e.length; r < a; ++r)
      i(t, e[r]);
  }
  setImmutableRowData(e, t) {
    this.dispatchRowDataUpdateStartedEvent(t);
    const n = this.gos, o = this.rootNode, s = this.childrenGetter, i = Jo(n), r = !n.get("suppressMaintainUnsortedOrder"), a = /* @__PURE__ */ new Map(), l = new Rr(!1, o);
    e.changedPath = l;
    const d = e.changedRowNodes, c = o.allLeafChildren, u = [], h = [];
    let g = !1, p = !1;
    const f = (w, b, A) => {
      const S = b == null ? void 0 : b.length;
      let F = !0, E = -1;
      for (let M = 0; M < S; ++M) {
        const I = m(w, b[M], A);
        r && I >= 0 && (I < E && (F = !1), E = I);
      }
      F || (g = !0);
    }, m = (w, b, A) => {
      let S = a.get(b);
      if (S !== void 0)
        return Z(2, { nodeId: S.id }), -1;
      const F = i({ data: b, level: A });
      if (S = this.getRowNode(F), S) {
        let I = !1;
        S.data !== b && (I = !0, S.updateData(b), !S.selectable && S.isSelected() && h.push(S)), S.treeParent !== w && (S.treeParent = w, I = !0), I && (p = !0, d.update(S));
      } else
        S = this.createRowNode(b, -1), S.treeParent = w, p = !0, d.add(S);
      a.set(b, S);
      let E;
      r ? (E = S.sourceRowIndex, S.sourceRowIndex = u.push(S) - 1) : E = -1;
      const M = s == null ? void 0 : s(b);
      return M && f(S, M, A + 1), E;
    };
    if (f(o, t, 0), c) {
      const w = this.beans.pinnedRowModel;
      for (let b = 0, A = c.length; b < A; ++b) {
        const S = c[b];
        if (!a.has(S.data)) {
          S.treeParent = null, S.treeNodeFlags = 0;
          const F = S.pinnedSibling;
          F && (w == null || w.pinRow(F, null)), S.clearRowTopAndRowIndex(), this.rowNodeDeleted(S), S.isSelected() && h.push(S), d.remove(S);
        }
      }
    }
    if (!r) {
      if (c) {
        const w = d.removals;
        for (let b = 0, A = c.length; b < A; ++b) {
          const S = c[b];
          w.has(S) || (S.sourceRowIndex = u.push(S) - 1);
        }
      }
      for (const w of d.adds)
        w.sourceRowIndex = u.push(w) - 1;
    }
    o.allLeafChildren = u, h.length && this.deselectNodes(h);
    const C = o.sibling;
    C && (C.allLeafChildren = u), (p || g) && (e.rowDataUpdated = !0, e.rowNodesOrderChanged || (e.rowNodesOrderChanged = g));
  }
}, dn = 2147483648, wn = 1073741824, Pl = 536870912, hs = 268435456, qr = 268435455, Dl = String.fromCharCode(31, 4096 + Math.random() * 61440, 4096 + Math.random() * 61440, 8291), $u = 4, ez = class extends U {
  constructor() {
    super(...arguments), this.groupColsIds = "", this.groupColsChanged = !0, this.parentIdGetter = null, this.fillerNodesById = null, this.nodesToUnselect = null;
  }
  destroy() {
    super.destroy(), this.groupColsIds = "", this.parentIdGetter = null, this.fillerNodesById = null, this.nodesToUnselect = null;
  }
  reset() {
    this.destroyFillerRows(), this.deselectHiddenNodes(!1), this.groupColsIds = "", this.groupColsChanged = !0, this.parentIdGetter = null;
  }
  getNode(e) {
    var t;
    return (t = this.fillerNodesById) == null ? void 0 : t.get(e);
  }
  execute(e, t) {
    const { changedRowNodes: n, changedPath: o, afterColumnsChanged: s } = e;
    this.checkGroupColsUpdated(s);
    const i = e.rowNode, r = o != null && o.active ? o : void 0, a = !n && !r, l = !!n && this.flagUpdatedNodes(n);
    (a || l) && (t === "treeNested" ? this.loadNested(e, a) : t === "treeSelfRef" ? this.loadSelfRef(e, a) : this.loadDataPath(e, a));
    const d = this.initRowsParents(i);
    this.destroyFillerRows(), this.initRowsChildrenSize(i);
    let c = this.preprocessRows(i);
    const u = d || (c & dn) !== 0;
    c &= ~dn;
    const h = this.traverseRoot(i, r);
    return c > 0 && c !== h && (this.handleCycles(i), this.traverseRoot(i, r)), i.treeNodeFlags = 0, this.deselectHiddenNodes(d || a), u;
  }
  flagUpdatedNodes(e) {
    const { adds: t, updates: n, removals: o } = e;
    let s = o.size > 0;
    if (t.size > 0) {
      s = !0;
      for (const i of t)
        i.treeNodeFlags |= wn;
    }
    if (n.size > 0) {
      s = !0;
      for (const i of n)
        i.treeNodeFlags |= wn;
    }
    return s;
  }
  initRowsParents(e) {
    const t = e.allLeafChildren, n = t.length;
    let o = !1;
    for (let s = 0; s < n; ++s) {
      let i = t[s];
      for (; ; ) {
        const r = i.parent, a = i.treeParent;
        if (a === null) {
          r && (o = !0, this.hideRow(i));
          break;
        }
        let l = a.treeNodeFlags + 1;
        if (r !== a && (o = !0, l |= wn, i.parent = a, r)) {
          const d = r.treeNodeFlags;
          (d & hs) !== 0 && (l & hs) === 0 && a.treeParent !== null && !a.data && (a.expanded = r.expanded, l |= hs), r.treeNodeFlags = d | wn;
        }
        if (a.data || (a.treeNodeFlags & Pl) !== 0 || a.treeParent === null) {
          a.treeNodeFlags = l;
          break;
        }
        a.treeNodeFlags = l | Pl | i.treeNodeFlags & wn, i = a;
      }
    }
    return o;
  }
  destroyFillerRows() {
    const e = this.fillerNodesById;
    if (e) {
      for (const t of e.values())
        (t.treeParent === null || (t.treeNodeFlags & qr) === 0) && (e.delete(t.id), this.hideRow(t));
      e.size === 0 && (this.fillerNodesById = null);
    }
  }
  initRowsChildrenSize(e) {
    this.initRowChildrenSize(e);
    const t = e.allLeafChildren, n = t.length;
    for (let s = 0; s < n; ++s)
      this.initRowChildrenSize(t[s]);
    const o = this.fillerNodesById;
    if (o !== null)
      for (const s of o.values())
        this.initRowChildrenSize(s);
  }
  initRowChildrenSize(e) {
    let { childrenAfterGroup: t, allLeafChildren: n, treeNodeFlags: o } = e;
    const s = t == null ? void 0 : t.length, i = o & qr;
    if (e.treeNodeFlags = o & ~qr | ((s || 0) !== i ? dn : 0), i === 0 && e.level >= 0) {
      if (t !== Vo) {
        e.childrenAfterGroup = Vo;
        const r = e.sibling;
        r && (r.childrenAfterGroup = Vo);
      }
    } else if (s !== i || t === n)
      if (!t || t === Vo || t === n) {
        e.childrenAfterGroup = t = new Array(i);
        const r = e.sibling;
        r && (r.childrenAfterGroup = t);
      } else
        t.length = i;
  }
  preprocessRows(e) {
    const t = e.allLeafChildren, n = t.length, o = this.groupColsChanged;
    let s = 0, i = !1;
    for (let r = 0; r < n; ++r) {
      let a = t[r];
      for (; ; ) {
        const l = a.treeParent;
        if (l === null)
          break;
        ++s;
        let d = l.treeNodeFlags;
        const c = l.childrenAfterGroup, u = d & qr;
        if (d = d & ~qr | u + 1, (d & dn || c[u] !== a) && (d |= dn, c[u] = a, i = !0), l.treeNodeFlags = d, (!a.groupData || o) && (a.treeNodeFlags |= wn, this.setGroupData(a, a.key)), l.data || (l.treeNodeFlags & Pl) === 0 || l.treeParent === null)
          break;
        l.treeNodeFlags = d & ~Pl | a.treeNodeFlags & wn, a = l;
      }
    }
    return s | (i ? dn : 0);
  }
  traverseRoot(e, t) {
    let n = 0;
    const o = e.childrenAfterGroup;
    for (let s = 0, i = o.length; s < i; ++s)
      n += this.traverse(o[s], 0, !1, t);
    return n & ~dn;
  }
  /**
   * After all the rows are initialized and treeParent is set and childrenAfterGroup is filled,
   * we traverse the tree to finalize it
   * @returns the number of leaf nodes processed, which is used to detect cycles in the tree, and a flag set if leaf children were changed.
   */
  traverse(e, t, n, o) {
    var d;
    const s = e.childrenAfterGroup, i = s.length;
    let r = e.treeNodeFlags;
    e.treeNodeFlags = r & hs, e.level = t, e.group !== !!i ? (Vb(e, this.beans, !!i), r |= wn) : e.hasChildren() !== !!i && (e.updateHasChildren(), r |= wn), (r & (wn | dn)) !== 0 && (o == null || o.addParentNode(e)), i !== 0 || e.master ? (r & hs) === 0 && (e.treeNodeFlags |= hs, e.expanded = Jp(this.beans, e, t)) : (e.expanded && (e.expanded = !1), (r & hs) !== 0 && (e.treeNodeFlags &= ~hs)), n && e.rowIndex !== null && e.clearRowTopAndRowIndex(), n || (n = e.expanded === !1), ++t, r &= dn;
    let l = 0;
    for (let c = 0; c < i; ++c) {
      const u = s[c], h = this.traverse(u, t, n, o);
      r = r + (h & ~dn) | h & dn, l += (((d = u.allLeafChildren) == null ? void 0 : d.length) || 0) + (u.data ? 1 : 0);
    }
    return this.updateAllLeafChildren(e, l, (r & dn) !== 0) ? (r | dn) + 1 : (r & ~dn) + 1;
  }
  updateAllLeafChildren(e, t, n) {
    let o = e.allLeafChildren, s = ((o == null ? void 0 : o.length) || 0) !== t;
    if (t === 0) {
      if (o !== null) {
        e.allLeafChildren = null;
        const i = e.sibling;
        i && (i.allLeafChildren = null);
      }
    } else if (s || n) {
      if (o)
        s && (o.length = t);
      else {
        e.allLeafChildren = o = new Array(t);
        const r = e.sibling;
        r && (r.allLeafChildren = o);
      }
      const i = e.childrenAfterGroup;
      for (let r = 0, a = 0, l = i.length; r < l; ++r) {
        const d = i[r];
        d.data && ((s || (s = o[a] !== d)) && (o[a] = d), ++a);
        const c = d.allLeafChildren;
        if (c)
          for (let u = 0, h = c.length; u < h; ++u, ++a) {
            const g = c[u];
            (s || (s = o[a] !== g)) && (o[a] = g);
          }
      }
    }
    return s;
  }
  /** Handle cycles in a tree. Is not optimal for performance but this is an edge case that shouldn't happen as is a warning. */
  handleCycles(e) {
    const t = /* @__PURE__ */ new Set(), n = (s) => t.has(s) ? !1 : (t.add(s), s.childrenAfterGroup.forEach(n), !0);
    n(e);
    const o = e.childrenAfterGroup;
    o.length = 0;
    for (const s of e.allLeafChildren) {
      const i = s.treeParent;
      i && n(s) ? (i.treeNodeFlags |= dn | wn, s.parent = e, $t(i.childrenAfterGroup, s), o.push(s), Z(270, { id: s.id, parentId: (i == null ? void 0 : i.id) ?? "" })) : i === e && o.push(s);
    }
  }
  setGroupData(e, t) {
    var s;
    const n = {}, o = (s = this.beans.showRowGroupCols) == null ? void 0 : s.getShowRowGroupCols();
    if (e.groupData = n, o)
      for (const i of o)
        n[i.getColId()] = t;
  }
  /** Load the tree structure for nested groups, aka children property */
  loadNested({ rowNode: e, changedRowNodes: t }, n) {
    if (!n && t) {
      for (const s of t.adds)
        s.key = s.id;
      return;
    }
    const o = e.allLeafChildren;
    for (let s = 0, i = o.length; s < i; ++s) {
      const r = o[s], a = r.id;
      r.key !== a && (r.key = a, r.groupData = null);
    }
  }
  /** Load the tree structure for self-referencing data, aka parentId field */
  loadSelfRef({ rowNode: e, changedRowNodes: t }, n) {
    const o = e.allLeafChildren, s = this.gos;
    if (!s.get("getRowId")) {
      for (let d = 0, c = o.length; d < c; ++d)
        o[d].treeParent = null;
      return;
    }
    const i = this.beans.rowModel, r = t == null ? void 0 : t.removals;
    let a = this.parentIdGetter;
    const l = s.get("treeDataParentIdField") || null;
    (a == null ? void 0 : a.path) !== l && (this.parentIdGetter = a = sS(l), n = !0);
    for (let d = 0, c = o.length; d < c; ++d) {
      const u = o[d];
      if (n || u.treeNodeFlags & wn || r != null && r.has(u.treeParent)) {
        let h;
        const g = a(u.data);
        g != null && (h = i.getRowNode(g), h || Z(271, { id: u.id, parentId: g })), u.treeParent = h ?? e;
        const p = u.id;
        u.key !== p && (u.key = p, u.groupData = null);
      } else
        u.treeParent ?? (u.treeParent = e);
    }
  }
  loadFlattened(e) {
    const t = e.allLeafChildren;
    for (let n = 0, o = t.length; n < o; ++n) {
      const s = t[n];
      s.treeParent = e;
      const i = s.id;
      s.key !== i && (s.key = i, s.groupData = null);
    }
  }
  /** Load the tree structure for data paths, aka getDataPath callback */
  loadDataPath({ rowNode: e }, t) {
    const n = this.gos.get("getDataPath");
    if (!n) {
      this.loadFlattened(e);
      return;
    }
    const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
    let i;
    t || (i = this.loadExistingDataPath(e, o, s));
    const r = e.allLeafChildren;
    for (let a = 0, l = r.length; a < l; ++a) {
      const d = r[a];
      if (!t && d.treeParent !== null && (d.treeNodeFlags & wn) === 0)
        continue;
      const c = n(d.data), u = c == null ? void 0 : c.length;
      if (!u) {
        Z(185, { data: d.data });
        continue;
      }
      const h = c[u - 1];
      d.key !== h && (d.key = h, d.groupData = null);
      const g = c.join(Dl);
      s.set(d, g);
      const p = o.get(g);
      p === void 0 ? o.set(g, d) : p !== d && (i = this.duplicatedPath(o, i, p, d, g));
    }
    i && this.processDuplicatePaths(i, s), this.buildFromPaths(e, o, s);
  }
  loadExistingDataPath(e, t, n) {
    let o;
    const s = e.allLeafChildren;
    for (let i = 0, r = s.length; i < r; ++i) {
      const a = s[i], l = a.treeParent;
      if (l === null || (a.treeNodeFlags & wn) !== 0)
        continue;
      let d = a.key, c = l;
      for (; c && c !== e && c !== a; ) {
        d = Dl + d;
        const u = n.get(c);
        if (u !== void 0) {
          d = u + d;
          break;
        }
        d = c.key + d, c = c.treeParent;
      }
      if (c !== a) {
        n.set(a, d);
        const u = t.get(d);
        u === void 0 ? t.set(d, a) : u !== a && (o = this.duplicatedPath(t, o, u, a, d));
      }
    }
    return o;
  }
  duplicatedPath(e, t, n, o, s) {
    o.sourceRowIndex < n.sourceRowIndex && e.set(s, o);
    const i = (t ?? (t = /* @__PURE__ */ new Map())).get(s);
    return i === void 0 ? t.set(s, [n, o]) : i.push(o), t;
  }
  buildFromPaths(e, t, n) {
    const o = new Array(48), s = e.allLeafChildren;
    for (let i = 0, r = s.length; i < r; ++i) {
      const a = s[i], l = n.get(a);
      if (l === void 0)
        continue;
      const d = this.splitPathKey(o, l);
      let c = 0, u = e;
      for (let h = d - 1; h >= 0; --h) {
        const g = t.get(l.slice(0, o[h]));
        if (g) {
          u = g, c = h + 1;
          break;
        }
      }
      c < d && (u = this.buildMissingFillers(
        t,
        l,
        o,
        d,
        c,
        u
      )), a.treeParent = u;
    }
  }
  /** Collect separators positions, fast string split without allocations */
  splitPathKey(e, t) {
    let n = 0, o = 0;
    const s = t.length;
    for (; o < s; ) {
      const i = t.indexOf(Dl, o);
      if (i === -1)
        break;
      e[n++] = i, o = i + $u;
    }
    return n;
  }
  /** Walk forward from startLevel to segmentsLen creating missing filler nodes and return the final parent. */
  buildMissingFillers(e, t, n, o, s, i) {
    let r = 0, a = "row-group";
    i.sourceRowIndex < 0 && i.treeParent && (r = s, a = i.id);
    do {
      const l = s === 0 ? 0 : n[s - 1] + $u, d = n[s], c = t.slice(0, d);
      let u = e.get(c);
      if (u !== void 0)
        u.sourceRowIndex < 0 && (a = u.id, r = s + 1);
      else {
        const h = l === 0 ? c : t.slice(l, d);
        a = this.makeFillerIdBase(t, n, s, a, r) + h, u = this.getOrCreateFiller(h, a), e.set(c, u), r = s + 1;
      }
      u.treeParent = i, i = u, ++s;
    } while (s < o);
    return i;
  }
  processDuplicatePaths(e, t) {
    for (const n of e.values()) {
      n.sort(tz);
      const o = n.length, s = new Array(o - 1);
      for (let r = 1; r < o; ++r) {
        const a = n[r];
        t.delete(a), a.treeParent = null, s[r - 1] = a.data;
      }
      const i = n[0];
      Z(186, { rowId: i.id, rowData: i.data, duplicateRowsData: s });
    }
  }
  getOrCreateFiller(e, t) {
    const n = this.fillerNodesById ?? (this.fillerNodesById = /* @__PURE__ */ new Map());
    let o = n.get(t);
    return o === void 0 && (o = new Ln(this.beans), o.id = t, o.key = e, o.group = !0, o.leafGroup = !1, o.rowGroupIndex = null, n.set(t, o)), o;
  }
  /**
   * Build the base filler ID up to the given 'level' and include the final level separator prefix.
   * Caller should append only the 'fillerKey' after this base.
   * Result format:
   * - With no prefix and level === 0: _ROW_ID_PREFIX_ROW_GROUP + '0-'
   * - With no prefix and level > 0: _ROW_ID_PREFIX_ROW_GROUP + '0-key0-1-key1-...-(level-1)-key(level-1)-level-'
   * - With prefix present: prefixId + '-level-'
   */
  makeFillerIdBase(e, t, n, o, s) {
    for (; s < n; ) {
      const i = s > 0 ? t[s - 1] + $u : 0, r = t[s];
      o += "-" + s + "-" + e.slice(i, r), ++s;
    }
    return o + "-" + n + "-";
  }
  deselectHiddenNodes(e) {
    var s;
    const t = this.beans.selectionSvc, n = this.nodesToUnselect, o = "rowDataChanged";
    if (n && (this.nodesToUnselect = null, t == null || t.setNodesSelected({ newValue: !1, nodes: n, suppressFinishActions: !0, source: o })), (n || e) && ((s = t == null ? void 0 : t.updateGroupsFromChildrenSelections) == null || s.call(t, o)), n) {
      const i = (t == null ? void 0 : t.getSelectedNodes()) ?? null;
      this.eventSvc.dispatchEvent({ type: "selectionChanged", source: o, selectedNodes: i, serverSideState: null });
    }
  }
  hideRow(e) {
    e.isSelected() && (this.nodesToUnselect ?? (this.nodesToUnselect = [])).push(e), e.parent = null, e.group = !1, e.groupData = null, e.treeParent = null, e.treeNodeFlags = 0, e.allLeafChildren = null, e.childrenAfterGroup = Vo;
    const t = e.sibling;
    t && (t.allLeafChildren = null, t.childrenAfterGroup = Vo), e.updateHasChildren(), e.rowIndex !== null && e.clearRowTopAndRowIndex();
  }
  checkGroupColsUpdated(e) {
    var t;
    if (this.groupColsChanged = !1, e || !this.groupColsIds) {
      const n = ((t = this.beans.showRowGroupCols) == null ? void 0 : t.getShowRowGroupCols()) ?? Vo;
      let o = "";
      for (let s = 0, i = n.length; s < i; ++s)
        o += n[s].getId() + Dl;
      this.groupColsIds !== o && (this.groupColsIds = o, this.groupColsChanged = !0);
    }
  }
}, tz = (e, t) => e.sourceRowIndex - t.sourceRowIndex, iS = {
  moduleName: "SharedTreeData",
  version: gt,
  dependsOn: [an, Qp, tS, ef]
}, nz = {
  moduleName: "TreeData",
  version: gt,
  beans: [X9],
  dynamicBeans: { treeGroupStrategy: ez },
  rowModels: ["clientSide"],
  dependsOn: [iS, Yb, Xp]
}, oz = "ag-Grid-MissingKey", sz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmBlockUtils";
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.showRowGroupCols = e.showRowGroupCols, this.nodeManager = e.ssrmNodeManager, this.expansionSvc = e.expansionSvc, this.serverSideRowModel = e.rowModel, this.storeFactory = e.ssrmStoreFactory;
  }
  createRowNode(e) {
    const t = new Ln(this.beans), n = e.rowHeight != null ? e.rowHeight : Kn(this.beans);
    return t.setRowHeight(n), t.group = e.group, t.leafGroup = e.leafGroup, t.level = e.level, t.uiLevel = e.level, t.parent = e.parent, t.stub = !0, t.__needsRefreshWhenVisible = !1, t.group && (t.expanded = !1, t.field = e.field, t.rowGroupColumn = e.rowGroupColumn, t.rowGroupIndex = e.level), t;
  }
  destroyRowNode(e, t = !1) {
    e.childStore && !t && (this.destroyBean(e.childStore), e.childStore = null), e.sibling && !e.footer && this.destroyRowNode(e.sibling, !1), e.clearRowTopAndRowIndex(), e.id != null && this.nodeManager.removeNode(e);
  }
  setTreeGroupInfo(e) {
    e.updateHasChildren();
    const t = this.gos.get("getServerSideGroupKey"), n = e.hasChildren();
    n && t != null && (e.key = t(e.data)), !n && e.childStore != null && (this.destroyBean(e.childStore), e.childStore = null, e.master || (e.expanded = !1));
  }
  setRowGroupInfo(e) {
    if (e.key = this.valueSvc.getValue(e.rowGroupColumn, e), (e.key === null || e.key === void 0) && hc(() => {
      var s;
      Z(190, { rowGroupId: (s = e.rowGroupColumn) == null ? void 0 : s.getId(), data: e.data });
    }, "SSBlock-BadKey"), this.gos.get("groupAllowUnbalanced") && e.key === "") {
      const s = this.serverSideRowModel.getParams();
      e.childStore = this.createBean(this.storeFactory.createStore(s, e));
    }
    vr(this.beans.gos)({ node: e }) && (Zo(e, this.beans), e.sibling && (e.sibling.uiLevel = e.uiLevel + 1));
  }
  setMasterDetailInfo(e) {
    const t = this.gos.get("isRowMaster");
    t != null ? e.master = t(e.data) : e.master = !0;
  }
  updateDataIntoRowNode(e, t) {
    e.updateData(t), this.gos.get("treeData") ? (this.setTreeGroupInfo(e), this.setChildCountIntoRowNode(e), this.updateRowFooter(e)) : e.group ? (this.setChildCountIntoRowNode(e), this.updateRowFooter(e)) : this.gos.get("masterDetail");
  }
  updateRowFooter(e) {
    if (!e.footer) {
      if (e.group && vr(this.beans.gos)({ node: e }) && !e.sibling) {
        Zo(e, this.beans);
        return;
      }
      e.sibling && Yp(e);
    }
  }
  setDataIntoRowNode(e, t, n, o) {
    var r;
    e.stub = !1;
    const s = this.gos.get("treeData");
    e.setDataAndId(t, n);
    const i = e.group;
    (s || !i) && this.gos.get("masterDetail") && this.setMasterDetailInfo(e), s ? this.setTreeGroupInfo(e) : i && this.setRowGroupInfo(e), (s || i) && (this.setGroupDataIntoRowNode(e), this.setChildCountIntoRowNode(e)), ue(t) && (e.setRowHeight(qt(this.beans, e, !1, o).height), (r = e.sibling) == null || r.setRowHeight(
      qt(this.beans, e.sibling, !1, o).height
    ));
  }
  setChildCountIntoRowNode(e) {
    const t = this.gos.get("getChildCount");
    t && e.setAllChildrenCount(t(e.data));
  }
  setGroupDataIntoRowNode(e) {
    var o;
    e.groupValue = e.key;
    const t = ((o = this.showRowGroupCols) == null ? void 0 : o.getShowRowGroupCols()) ?? [], n = this.gos.get("treeData");
    t.forEach((s) => {
      if (e.groupData == null && (e.groupData = {}), n)
        e.groupData[s.getColId()] = e.key;
      else if (s.isRowGroupDisplayed(e.rowGroupColumn.getId())) {
        const i = this.valueSvc.getValue(e.rowGroupColumn, e);
        e.groupData[s.getColId()] = i;
      }
    });
  }
  clearDisplayIndex(e) {
    var o, s;
    e.clearRowTopAndRowIndex(), e.hasChildren() && !!e.childStore && ((o = e.childStore) == null || o.clearDisplayIndexes()), e.master && e.detailNode && ((s = e.detailNode) == null || s.clearRowTopAndRowIndex());
  }
  setDisplayIndex(e, t, n, o) {
    const s = this.gos.get("groupAllowUnbalanced") && e.group && e.key === "";
    if (this.gos.get("groupHideOpenParents") && e.group && e.expanded || s ? (e.setRowIndex(null), e.setRowTop(null)) : (e.setRowIndex(t.value++), e.setRowTop(n.value), n.value += e.rowHeight), e.setUiLevel(o), e.footer)
      return;
    if (e.master && (e.expanded && e.detailNode ? (e.detailNode.setRowIndex(t.value++), e.detailNode.setRowTop(n.value), n.value += e.detailNode.rowHeight) : e.detailNode && e.detailNode.clearRowTopAndRowIndex()), e.hasChildren() && !!e.childStore) {
      const l = e.childStore;
      e.expanded || s ? l.setDisplayIndexes(t, n, s ? o : o + 1) : l.clearDisplayIndexes();
    }
  }
  extractRowBounds(e, t) {
    const n = (o) => ({
      rowHeight: o.rowHeight,
      rowTop: o.rowTop
    });
    if (e.rowIndex === t)
      return n(e);
    if (e.hasChildren() && e.expanded && e.childStore) {
      const o = e.childStore;
      if (o.isDisplayIndexInStore(t))
        return o.getRowBounds(t);
    } else if (e.master && e.expanded && e.detailNode && e.detailNode.rowIndex === t)
      return n(e.detailNode);
  }
  isPixelInNodeRange(e, t) {
    return !ue(e.rowTop) || !ue(e.rowHeight) ? !1 : t >= e.rowTop && t < e.rowTop + e.rowHeight;
  }
  getIndexAtPixel(e, t) {
    if (this.isPixelInNodeRange(e, t))
      return e.rowIndex;
    const n = e.master && e.expanded, o = e.detailNode;
    if (n && o && this.isPixelInNodeRange(o, t))
      return o.rowIndex;
    if (e.hasChildren() && e.expanded && e.childStore) {
      const s = e.childStore;
      if (s.isPixelInRange(t))
        return s.getRowIndexAtPixel(t);
    }
    return null;
  }
  createNodeIdPrefix(e) {
    const t = [];
    let n = e;
    for (; n && n.level >= 0; )
      n.key === "" ? t.push(oz) : t.push(n.key), n = n.parent;
    if (t.length > 0)
      return t.reverse().join("-");
  }
  checkOpenByDefault(e) {
    var o;
    const t = !!((o = this.expansionSvc) != null && o.isNodeExpanded(e)), n = e.expanded;
    !!n !== t ? e.setExpanded(t) : n === void 0 && (e.expanded = t);
  }
}, iz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmExpandListener";
  }
  postConstruct() {
    gn(this.gos) && this.addManagedEventListeners({ rowExpansionStateChanged: this.onRowExpandStateChanged.bind(this) });
  }
  onRowExpandStateChanged() {
    const e = this.beans, t = e.expansionSvc;
    e.rowModel.forEachNode((n) => {
      t.updateExpandedState(n);
    }), this.eventSvc.dispatchEvent({ type: "storeUpdated" });
  }
}, rz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmFilterListener";
  }
  wireBeans(e) {
    this.serverSideRowModel = e.rowModel, this.filterManager = e.filterManager, this.listenerUtils = e.ssrmListenerUtils;
  }
  postConstruct() {
    gn(this.gos) && this.addManagedEventListeners({
      advancedFilterEnabledChanged: () => this.onFilterChanged(!0),
      filterChanged: () => this.onFilterChanged()
    });
  }
  onFilterChanged(e) {
    var l, d;
    const t = this.serverSideRowModel.getParams();
    if (!t)
      return;
    const n = t.filterModel;
    let o, s;
    if ((l = this.filterManager) != null && l.isAdvFilterEnabled()) {
      o = this.filterManager.getAdvFilterModel();
      const c = e ? Object.keys(n ?? {}) : this.getAdvancedFilterColumns(n), u = this.getAdvancedFilterColumns(o);
      c.forEach((h) => u.add(h)), s = Array.from(u);
    } else if (o = ((d = this.filterManager) == null ? void 0 : d.getFilterModel()) ?? {}, e) {
      const c = this.getAdvancedFilterColumns(n);
      Object.keys(o).forEach((u) => c.add(u)), s = Array.from(c);
    } else
      s = this.findChangedColumns(n, o);
    const i = this.listenerUtils.isSortingWithValueColumn(s), r = this.listenerUtils.isSortingWithSecondaryColumn(s), a = {
      valueColChanged: i,
      secondaryColChanged: r,
      changedColumns: s
    };
    this.serverSideRowModel.refreshAfterFilter(o, a);
  }
  findChangedColumns(e, t) {
    const n = {};
    Object.keys(e).forEach((s) => n[s] = !0), Object.keys(t).forEach((s) => n[s] = !0);
    const o = [];
    return Object.keys(n).forEach((s) => {
      const i = JSON.stringify(e[s]), r = JSON.stringify(t[s]);
      i != r && o.push(s);
    }), o;
  }
  getAdvancedFilterColumns(e) {
    const t = /* @__PURE__ */ new Set();
    if (!e)
      return t;
    const n = (o) => {
      o.filterType === "join" ? o.conditions.forEach((s) => n(s)) : t.add(o.colId);
    };
    return n(e), t;
  }
}, az = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmListenerUtils";
  }
  wireBeans(e) {
    this.pivotResultCols = e.pivotResultCols, this.valueColsSvc = e.valueColsSvc;
  }
  isSortingWithValueColumn(e) {
    var n;
    const t = (((n = this.valueColsSvc) == null ? void 0 : n.columns) ?? []).map((o) => o.getColId());
    for (let o = 0; o < e.length; o++)
      if (t.indexOf(e[o]) > -1)
        return !0;
    return !1;
  }
  isSortingWithSecondaryColumn(e) {
    var o;
    const t = (o = this.pivotResultCols) == null ? void 0 : o.getPivotResultCols();
    if (!t)
      return !1;
    const n = t.list.map((s) => s.getColId());
    for (let s = 0; s < e.length; s++)
      if (n.indexOf(e[s]) > -1)
        return !0;
    return !1;
  }
}, lz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmSortSvc";
  }
  wireBeans(e) {
    this.sortSvc = e.sortSvc, this.serverSideRowModel = e.rowModel, this.listenerUtils = e.ssrmListenerUtils;
  }
  postConstruct() {
    gn(this.gos) && this.addManagedEventListeners({ sortChanged: this.onSortChanged.bind(this) });
  }
  onSortChanged() {
    const e = this.serverSideRowModel.getParams();
    if (!e)
      return;
    const t = this.sortSvc.getSortModel(), n = e.sortModel, o = this.findChangedColumnsInSort(t, n), s = this.listenerUtils.isSortingWithValueColumn(o), i = this.listenerUtils.isSortingWithSecondaryColumn(o), r = {
      valueColChanged: s,
      secondaryColChanged: i,
      changedColumns: o
    };
    this.serverSideRowModel.refreshAfterSort(t, r);
  }
  // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
  // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
  // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
  // was previously sorted by A and then the A sort now needs to be cleared.
  findChangedColumnsInSort(e, t) {
    let n = [];
    [e, t].forEach((i) => {
      if (i) {
        const r = i.map((a) => a.colId);
        n = n.concat(r);
      }
    });
    const o = (i, r) => {
      const a = i ? i.sort : null, l = r ? r.sort : null;
      return a !== l;
    }, s = (i, r) => {
      const a = i ? t.indexOf(i) : -1, l = r ? e.indexOf(r) : -1;
      return a !== l;
    };
    return n.filter((i) => {
      const r = t.find((l) => l.colId === i), a = e.find((l) => l.colId === i);
      return o(r, a) || s(r, a);
    });
  }
}, dz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmNodeManager", this.rowNodes = /* @__PURE__ */ new Map();
  }
  addRowNode(e) {
    const t = e.id;
    this.rowNodes.has(t) && Z(187, {
      rowId: t,
      firstData: this.rowNodes.get(t).data,
      secondData: e.data
    }), this.rowNodes.set(t, e);
  }
  removeNode(e) {
    const t = e.id;
    this.rowNodes.delete(t);
  }
  destroy() {
    this.clear(), super.destroy();
  }
  clear() {
    this.rowNodes.clear(), super.destroy();
  }
}, cz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.started = !1, this.managingPivotResultColumns = !1, this.onRowHeightChanged_debounced = Lt(this, this.onRowHeightChanged.bind(this), 100);
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.colNames = e.colNames, this.pivotResultCols = e.pivotResultCols, this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.filterManager = e.filterManager, this.sortSvc = e.sortSvc, this.rowRenderer = e.rowRenderer, this.nodeManager = e.ssrmNodeManager, this.storeFactory = e.ssrmStoreFactory, this.pivotColDefSvc = e.pivotColDefSvc;
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid() {
    return !1;
  }
  start() {
    this.started = !0, this.updateDatasource();
  }
  destroyDatasource() {
    this.datasource && (this.datasource.destroy && this.datasource.destroy(), this.rowRenderer.datasourceChanged(), this.datasource = void 0);
  }
  postConstruct() {
    const e = this.resetRootStore.bind(this);
    this.addManagedEventListeners({
      newColumnsLoaded: this.onColumnEverything.bind(this),
      storeUpdated: this.onStoreUpdated.bind(this),
      columnValueChanged: e,
      columnPivotChanged: e,
      columnRowGroupChanged: e,
      columnPivotModeChanged: e
    }), this.addManagedPropertyListeners(
      [
        /**
         * Following properties omitted as they are likely to come with undesired  side effects.
         * 'getRowId', 'isRowMaster', 'getRowHeight', 'isServerSideGroup', 'getServerSideGroupKey',
         * */
        "masterDetail",
        "treeData",
        "removePivotHeaderRowWhenSingleValueColumn",
        "cacheBlockSize"
      ],
      e
    ), this.addManagedPropertyListeners(["groupAllowUnbalanced", "groupTotalRow"], () => this.onStoreUpdated()), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights()), this.verifyProps(), this.addManagedPropertyListener("serverSideDatasource", () => this.updateDatasource());
  }
  updateDatasource() {
    const e = this.gos.get("serverSideDatasource");
    e && this.setDatasource(e);
  }
  verifyProps() {
    In(this.gos) && !this.gos.exists("getRowId") && Z(188, { feature: "selection" });
  }
  setDatasource(e) {
    this.started && (this.destroyDatasource(), this.datasource = e, this.resetRootStore());
  }
  applyRowData(e, t, n) {
    const o = this.getRootStore();
    if (!o)
      return;
    const s = o.getChildStore(n);
    s && s.applyRowData(e, t, e.rowData.length);
  }
  isLastRowIndexKnown() {
    const e = this.getRootStore();
    return e ? e.isLastRowIndexKnown() : !1;
  }
  onColumnEverything() {
    var d, c, u, h;
    if (!this.storeParams) {
      this.resetRootStore();
      return;
    }
    const e = this.columnsToValueObjects((d = this.rowGroupColsSvc) == null ? void 0 : d.columns), t = this.columnsToValueObjects((c = this.valueColsSvc) == null ? void 0 : c.columns), n = this.columnsToValueObjects((u = this.pivotColsSvc) == null ? void 0 : u.columns), o = (g) => {
      const p = {};
      g.oldCols.forEach((C) => p[C.id] = C);
      const f = g.newCols.every((C) => {
        const w = p[C.id];
        return w && delete p[C.id], w && w.field === C.field && w.aggFunc === C.aggFunc;
      }), m = !g.allowRemovedColumns && !!Object.values(p).length;
      return f && !m;
    }, s = !pr(this.storeParams.sortModel, ((h = this.sortSvc) == null ? void 0 : h.getSortModel()) ?? []), i = !o({
      oldCols: this.storeParams.rowGroupCols,
      newCols: e
    }), r = !o({
      oldCols: this.storeParams.pivotCols,
      newCols: n
    }), a = !!(e != null && e.length) && !o({
      oldCols: this.storeParams.valueCols,
      newCols: t,
      allowRemovedColumns: !0
    });
    if (s || i || r || a)
      this.resetRootStore();
    else {
      const g = this.createStoreParams();
      this.storeParams.rowGroupCols = g.rowGroupCols, this.storeParams.pivotCols = g.pivotCols, this.storeParams.valueCols = g.valueCols;
    }
  }
  destroyRootStore() {
    !this.rootNode || !this.rootNode.childStore || (this.rootNode.childStore = this.destroyBean(this.rootNode.childStore), this.nodeManager.clear());
  }
  refreshAfterSort(e, t) {
    this.storeParams && (this.storeParams.sortModel = e);
    const n = this.getRootStore();
    n && (n.refreshAfterSort(t), this.onStoreUpdated());
  }
  generateSecondaryColumns(e) {
    var n;
    if (!this.pivotColDefSvc) {
      this.gos.assertModuleRegistered("SharedPivot", 2);
      return;
    }
    const t = this.pivotColDefSvc.createColDefsFromFields(e);
    this.managingPivotResultColumns = !0, (n = this.pivotResultCols) == null || n.setPivotResultCols(t, "rowModelUpdated");
  }
  resetRowHeights() {
    const e = this.resetRowHeightsForAllRowNodes(), t = qt(this.beans, this.rootNode);
    if (this.rootNode.setRowHeight(t.height, t.estimated), this.rootNode.sibling) {
      const n = qt(this.beans, this.rootNode.sibling);
      this.rootNode.sibling.setRowHeight(n.height, n.estimated);
    }
    e && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      const n = qt(this.beans, t);
      t.setRowHeight(n.height, n.estimated);
      const o = t.detailNode;
      if (o) {
        const s = qt(this.beans, o);
        o.setRowHeight(s.height, s.estimated);
      }
      if (t.sibling) {
        const s = qt(this.beans, t.sibling);
        o == null || o.setRowHeight(s.height, s.estimated);
      }
      e = !0;
    }), e;
  }
  resetRootStore() {
    var e;
    this.destroyRootStore(), this.rootNode = new Ln(this.beans), this.rootNode.group = !0, this.rootNode.level = -1, this.datasource && (this.storeParams = this.createStoreParams(), this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode)), this.updateRowIndexesAndBounds()), this.managingPivotResultColumns && ((e = this.pivotResultCols) == null || e.setPivotResultCols(null, "api"), this.managingPivotResultColumns = !1), this.dispatchModelUpdated(!0);
  }
  columnsToValueObjects(e = []) {
    return e.map(
      (t) => ({
        id: t.getId(),
        aggFunc: t.getAggFunc(),
        displayName: this.colNames.getDisplayNameForColumn(t, "model"),
        field: t.getColDef().field
      })
    );
  }
  createStoreParams() {
    var i, r, a, l, d, c, u;
    const e = this.columnsToValueObjects((i = this.rowGroupColsSvc) == null ? void 0 : i.columns), t = this.columnsToValueObjects((r = this.valueColsSvc) == null ? void 0 : r.columns), n = this.columnsToValueObjects((a = this.pivotColsSvc) == null ? void 0 : a.columns), o = Jg(this.gos);
    return {
      // the columns the user has grouped and aggregated by
      valueCols: t,
      rowGroupCols: e,
      pivotCols: n,
      pivotMode: this.colModel.isPivotMode(),
      // sort and filter model
      filterModel: (l = this.filterManager) != null && l.isAdvFilterEnabled() ? (d = this.filterManager) == null ? void 0 : d.getAdvFilterModel() : ((c = this.filterManager) == null ? void 0 : c.getFilterModel()) ?? {},
      sortModel: ((u = this.sortSvc) == null ? void 0 : u.getSortModel()) ?? [],
      datasource: this.datasource,
      lastAccessedSequence: { value: 0 },
      // blockSize: blockSize == null ? 100 : blockSize,
      dynamicRowHeight: o
    };
  }
  getParams() {
    return this.storeParams;
  }
  dispatchModelUpdated(e = !1) {
    this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      animate: !e,
      keepRenderedRows: !e,
      newPage: !1,
      newData: !1
    });
  }
  onStoreUpdated() {
    this.updateRowIndexesAndBounds(), this.dispatchModelUpdated();
  }
  onRowHeightChanged() {
    this.updateRowIndexesAndBounds(), this.dispatchModelUpdated();
  }
  updateRowIndexesAndBounds() {
    const e = this.getRootStore();
    e && e.setDisplayIndexes({ value: 0 }, { value: 0 }, 0);
  }
  retryLoads() {
    const e = this.getRootStore();
    e && (e.retryLoads(), this.onStoreUpdated());
  }
  getRow(e) {
    const t = this.getRootStore();
    if (t)
      return t.getRowUsingDisplayIndex(e);
  }
  refreshAfterFilter(e, t) {
    this.storeParams && (this.storeParams.filterModel = e);
    const n = this.getRootStore();
    n && (n.refreshAfterFilter(t), this.onStoreUpdated());
  }
  getRootStore() {
    var e;
    return (e = this.rootNode) == null ? void 0 : e.childStore;
  }
  getRowCount() {
    const e = this.getRootStore();
    return e ? e.getDisplayIndexEnd() : 0;
  }
  getTopLevelRowCount() {
    const e = this.getRootStore();
    return e ? e.getRowCount() : 1;
  }
  getTopLevelRowDisplayedIndex(e) {
    const t = this.getRootStore();
    return t ? t.getTopLevelRowDisplayedIndex(e) : e;
  }
  getRowBounds(e) {
    const t = this.getRootStore();
    return t ? t.getRowBounds(e) : {
      rowTop: 0,
      rowHeight: Kn(this.beans)
    };
  }
  getBlockStates() {
    const e = this.getRootStore();
    if (!e)
      return;
    const t = {};
    return e.forEachStoreDeep((n) => {
      const o = n.getBlockStates();
      for (const s of Object.keys(o))
        t[s] = o[s];
    }), t;
  }
  getRowIndexAtPixel(e) {
    const t = this.getRootStore();
    return e <= 0 || !t ? 0 : t.getRowIndexAtPixel(e);
  }
  isEmpty() {
    return !1;
  }
  isRowsToRender() {
    return this.getRootStore() != null && this.getRowCount() > 0;
  }
  getType() {
    return "serverSide";
  }
  forEachNode(e) {
    const t = this.getRootStore();
    t && t.forEachNodeDeep(e);
  }
  forEachDisplayedNode(e) {
    const t = (n, o) => {
      n.stub || !n.displayed || e(n, o);
    };
    this.forEachNode(t);
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    const n = this.getRootStore();
    n && n.forEachNodeDeepAfterFilterAndSort(e, void 0, t);
  }
  /** @returns false if store hasn't started */
  executeOnStore(e, t) {
    if (!this.started)
      return !1;
    const n = this.getRootStore();
    if (!n)
      return !0;
    const o = n.getChildStore(e);
    return o && t(o), !0;
  }
  refreshStore(e = {}) {
    const t = e.route ? e.route : [];
    this.executeOnStore(t, (n) => n.refreshStore(e.purge == !0));
  }
  getStoreState() {
    const e = [], t = this.getRootStore();
    return t && t.addStoreStates(e), e;
  }
  getNodesInRangeForSelection(e, t) {
    const n = e.rowIndex, o = t.rowIndex;
    if (n === null && o === null)
      return [];
    if (o === null)
      return e ? [e] : [];
    if (n === null)
      return [t];
    const s = [], [i, r] = [n, o].sort((a, l) => a - l);
    return this.forEachNode((a) => {
      const l = a.rowIndex;
      l == null || a.stub || l >= i && l <= r && s.push(a);
    }), s.length !== r - i + 1 ? null : s;
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((n) => {
      n.id === e && (t = n), n.detailNode && n.detailNode.id === e && (t = n.detailNode);
    }), t;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  setRowCount(e, t) {
    const n = this.getRootStore();
    n && n.setRowCount(e, t);
  }
  destroy() {
    this.destroyDatasource(), this.destroyRootStore(), super.destroy();
  }
  /**
   * @deprecated v33.1
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
};
function uz(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectionState()) ?? null;
}
function hz(e, t) {
  var n;
  (n = e.selectionSvc) == null || n.setSelectionState(t, "api");
}
function gz(e, t) {
  var n;
  return (n = e.ssrmTxnManager) == null ? void 0 : n.applyTransaction(t);
}
function pz(e, t) {
  var s;
  const n = t.startRow ?? 0, o = t.route ?? [];
  if (n < 0) {
    Z(189, { startRow: n });
    return;
  }
  (s = ol(e)) == null || s.applyRowData(t.successParams, n, o);
}
function fz(e, t, n) {
  var o;
  return (o = e.ssrmTxnManager) == null ? void 0 : o.applyTransactionAsync(t, n);
}
function mz(e) {
  var t;
  (t = ol(e)) == null || t.retryLoads();
}
function vz(e) {
  var t;
  return (t = e.ssrmTxnManager) == null ? void 0 : t.flushAsyncTransactions();
}
function Cz(e, t) {
  var n;
  (n = ol(e)) == null || n.refreshStore(t);
}
function wz(e) {
  var t;
  return ((t = ol(e)) == null ? void 0 : t.getStoreState()) ?? [];
}
var zu = class extends U {
  constructor() {
    super(...arguments), this.name = "expand", this.expanded = /* @__PURE__ */ new Set(), this.collapsed = /* @__PURE__ */ new Set(), this.initialState = /* @__PURE__ */ new Map();
  }
  /**
   * Set the expanded and collapsed rows.
   * @param expandedRows the rows to expand
   * @param touchedRows the rows that have been touched
   */
  setExpandedState({ expandedRowGroupIds: e, collapsedRowGroupIds: t }) {
    this.expanded = new Set(e), this.collapsed = new Set(t);
    for (const n of this.expanded)
      this.initialState.set(n, !1);
    for (const n of this.collapsed)
      this.initialState.set(n, !0);
  }
  /**
   * Get the serializable expanded state
   * @returns an object containing the expanded and collapsed rows
   */
  getExpandedState() {
    return {
      expandedRowGroupIds: Array.from(this.expanded),
      collapsedRowGroupIds: Array.from(this.collapsed)
    };
  }
  /**
   * Set the expanded state for a row.
   * @param row the row to expand/collapse
   * @param expanded true to expand the row, false to collapse it
   */
  setRowExpanded(e, t) {
    const n = e.id, o = this.initialState.get(n) === t;
    if (t) {
      this.collapsed.delete(n), o || this.expanded.add(n);
      return;
    }
    this.expanded.delete(n), o || this.collapsed.add(n);
  }
  /**
   * Check if a row is expanded.
   * @param rowId the row id to check
   * @returns true if the row is expanded
   */
  isRowExpanded(e) {
    const t = e.id;
    if (this.expanded.has(t))
      return !0;
    if (this.collapsed.has(t))
      return !1;
    const n = this.initialState.get(t);
    if (n != null)
      return n;
    const o = this.getInitialRowState(e);
    return this.initialState.set(t, o), o;
  }
  /**
   * This is different from just checking expandedState.isExpanded(rowNode.id),
   * as this correctly prioritizes user interaction over the user-defined initial state.
   * Plus sanity checks that the rowNode is actually expandable.
   */
  getInitialRowState(e) {
    if (!e.isExpandable())
      return !1;
    const t = this.gos.getCallback("isServerSideGroupOpenByDefault");
    if (!t)
      return !1;
    const n = {
      data: e.data,
      rowNode: e
    };
    return t(n);
  }
  /**
   * if the row is expanded or has been collapsed intentionally, do not apply initial state.
   * @param rowId the row id to check
   * @returns true if the row has been toggled
   */
  isRowInitialised(e) {
    return this.initialState.has(e);
  }
  /**
   * Expand or collapse all loaded rows.
   * @param expanded true to expand all rows, false to collapse all rows
   */
  expandAll(e) {
    this.beans.rowModel.forEachNode((t) => {
      this.setRowExpanded(t, e);
    });
  }
}, H0 = class extends U {
  constructor() {
    super(...arguments), this.name = "expandAll", this.allExpanded = !1, this.flipped = /* @__PURE__ */ new Set();
  }
  setExpandedState(e) {
    this.allExpanded = e.expandAll, this.flipped = new Set(e.invertedRowGroupIds);
  }
  getExpandedState() {
    return {
      expandAll: this.allExpanded,
      invertedRowGroupIds: Array.from(this.flipped)
    };
  }
  setRowExpanded(e, t) {
    const n = e.id;
    if (t === this.allExpanded) {
      this.flipped.delete(n);
      return;
    }
    this.flipped.add(n);
  }
  isRowExpanded(e) {
    const t = e.id;
    return this.allExpanded !== this.flipped.has(t);
  }
  isRowInitialised() {
    return !0;
  }
  expandAll(e) {
    this.allExpanded = e, this.flipped.clear();
  }
}, yz = class extends Jb {
  constructor() {
    super(...arguments), this.beanName = "expansionSvc";
  }
  wireBeans(e) {
    this.serverSideRowModel = e.rowModel, this.storeFactory = e.ssrmStoreFactory;
  }
  postConstruct() {
    const e = () => {
      this.strategy = this.createManagedBean(new zu());
    };
    this.addManagedEventListeners({
      // when row grouping changes, the old expand all state is no longer valid as rows changed
      columnRowGroupChanged: e
    }), this.addManagedPropertyListener("ssrmExpandAllAffectsAllRows", (t) => {
      t.currentValue || (this.strategy = this.createManagedBean(new zu()), this.updateAllNodes(), this.dispatchStateUpdatedEvent());
    }), e();
  }
  setExpansionState(e) {
    const t = "expandAll" in e, n = this.isExpandAllStrategy(this.strategy);
    t !== n && (this.strategy = t ? this.createManagedBean(new H0()) : this.createManagedBean(new zu())), this.strategy.setExpandedState(e), this.dispatchStateUpdatedEvent(), this.updateAllNodes();
  }
  getExpansionState() {
    return this.strategy.getExpandedState();
  }
  /**
   * Updates all nodes to the correct expanded/collapsed state.
   */
  updateAllNodes() {
    this.serverSideRowModel.forEachNode((e) => {
      super.setExpanded(e, this.isNodeExpanded(e));
    });
  }
  isNodeExpanded(e) {
    return this.strategy.isRowExpanded(e);
  }
  setExpanded(e, t, n, o) {
    this.strategy.setRowExpanded(e, t), super.setExpanded(e, t, n), this.dispatchStateUpdatedEvent(), this.updateExpandedState(e);
  }
  expandAll(e) {
    const t = this.beans.gos.get("ssrmExpandAllAffectsAllRows"), n = this.isExpandAllStrategy(this.strategy) || !t ? this.strategy : new H0();
    this.strategy = n, n.expandAll(e), this.updateAllNodes(), this.dispatchStateUpdatedEvent(), this.beans.eventSvc.dispatchEvent({
      type: "expandOrCollapseAll",
      source: e ? "expandAll" : "collapseAll"
    });
  }
  isExpandAllStrategy(e) {
    return e.name === "expandAll";
  }
  onGroupExpandedOrCollapsed() {
  }
  dispatchExpandedEvent(e) {
    this.eventSvc.dispatchEvent(e), this.beans.rowRenderer.refreshCells({ rowNodes: [e.node] });
  }
  updateExpandedState(e) {
    const t = e.childStore;
    if (e.expanded) {
      if (e.master && !e.detailNode && (e.detailNode = this.createDetailNode(e)), !t && e.hasChildren()) {
        const n = this.serverSideRowModel.getParams();
        e.childStore = this.createBean(this.storeFactory.createStore(n, e));
      }
    } else t && this.gos.get("purgeClosedRowNodes") && (e.childStore = this.destroyBean(t));
  }
  createDetailNode(e) {
    const t = new Ln(this.beans);
    t.detail = !0, t.selectable = !1, t.parent = e, ue(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1;
    const n = 200, o = qt(this.beans, t).height;
    return t.rowHeight = o || n, t;
  }
}, Wu = class extends U {
  constructor(e) {
    super(), this.selectionCtx = e, this.selectedState = { selectAll: !1, toggledNodes: /* @__PURE__ */ new Set() }, this.selectAllUsed = !1, this.selectedNodes = {};
  }
  getSelectedState() {
    return {
      selectAll: this.selectedState.selectAll,
      toggledNodes: [...this.selectedState.toggledNodes]
    };
  }
  setSelectedState(e) {
    if (typeof e != "object") {
      $e(116);
      return;
    }
    if (!("selectAll" in e)) {
      $e(116);
      return;
    }
    if (typeof e.selectAll != "boolean") {
      $e(117);
      return;
    }
    if (!("toggledNodes" in e) || !Array.isArray(e.toggledNodes))
      return Z(197);
    const t = {
      selectAll: e.selectAll,
      toggledNodes: /* @__PURE__ */ new Set()
    };
    e.toggledNodes.forEach((o) => {
      typeof o == "string" ? t.toggledNodes.add(o) : Z(196, { key: o });
    });
    const n = t.selectAll || t.toggledNodes.size > 1;
    if (ep(this.gos) && !es(this.gos) && n) {
      Z(130);
      return;
    }
    this.selectedState = t;
  }
  deleteSelectionStateFromParent(e, t) {
    if (this.selectedState.toggledNodes.size === 0)
      return !1;
    let n = !1;
    return t.forEach((o) => {
      this.selectedState.toggledNodes.delete(o) && (n = !0);
    }), n;
  }
  setNodesSelected(e) {
    const { nodes: t, clearSelection: n, newValue: o, source: s } = e;
    if (t.length === 0)
      return 0;
    const i = n && o;
    if (!es(this.gos) || i) {
      if (t.length > 1)
        return $e(130), 0;
      const a = t[0], l = a.footer ? a.sibling : a;
      return o && l.selectable ? (this.selectedNodes = { [l.id]: l }, this.selectedState = {
        selectAll: !1,
        toggledNodes: /* @__PURE__ */ new Set([l.id])
      }) : (this.selectedNodes = {}, this.selectedState = {
        selectAll: !1,
        toggledNodes: /* @__PURE__ */ new Set()
      }), 1;
    }
    const r = (a, l = o) => {
      const d = a.footer ? a.sibling : a;
      l && d.selectable ? this.selectedNodes[d.id] = d : delete this.selectedNodes[d.id], l === this.selectedState.selectAll || !d.selectable ? this.selectedState.toggledNodes.delete(d.id) : this.selectedState.toggledNodes.add(d.id);
    };
    return t.forEach((a) => r(a)), t.length === 1 && s === "api" && this.selectionCtx.setRoot(t[0].footer ? t[0].sibling : t[0]), 1;
  }
  processNewRow(e) {
    this.selectedNodes[e.id] && (this.selectedNodes[e.id] = e);
  }
  isNodeSelected(e) {
    const t = this.selectedState.toggledNodes.has(e.id);
    return this.selectedState.selectAll ? !t : t;
  }
  getSelectedNodes(e = !1, t = !0) {
    const {
      selectedState: { selectAll: n },
      selectedNodes: o,
      selectAllUsed: s
    } = this;
    return t && s && Z(199), e && n ? null : Object.values(o);
  }
  getSelectedRows() {
    return (this.getSelectedNodes() ?? []).map((e) => e.data);
  }
  getSelectionCount() {
    return this.selectedState.selectAll ? -1 : this.selectedState.toggledNodes.size;
  }
  isEmpty() {
    var e;
    return !this.selectedState.selectAll && !((e = this.selectedState.toggledNodes) != null && e.size);
  }
  selectAllRowNodes() {
    this.reset(!0);
  }
  deselectAllRowNodes() {
    this.reset(!1);
  }
  reset(e) {
    this.selectedState = { selectAll: e, toggledNodes: /* @__PURE__ */ new Set() }, this.selectedNodes = {}, this.selectAllUsed || (this.selectAllUsed = e);
  }
  getSelectAllState() {
    return this.selectedState.selectAll ? this.selectedState.toggledNodes.size > 0 ? null : !0 : this.selectedState.toggledNodes.size > 0 ? null : !1;
  }
}, Tl = class extends U {
  constructor(e) {
    super(), this.selectionCtx = e, this.selectedState = { selectAllChildren: !1, toggledNodes: /* @__PURE__ */ new Map() };
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.rowGroupColsSvc = e.rowGroupColsSvc, this.filterManager = e.filterManager, this.selectionSvc = e.selectionSvc;
  }
  postConstruct() {
    this.addManagedEventListeners({
      // if model has updated, a store may now be fully loaded to clean up indeterminate states
      modelUpdated: () => this.removeRedundantState(),
      // when the grouping changes, the state no longer makes sense, so reset the state.
      columnRowGroupChanged: () => this.selectionSvc.reset("rowGroupChanged")
    });
  }
  getSelectedState() {
    const { gos: e, rowGroupColsSvc: t, selectedState: n } = this, o = e.get("treeData"), s = (i, r, a) => {
      const l = {
        nodeId: a
      };
      if ((o || t && r <= t.columns.length) && (l.selectAllChildren = i.selectAllChildren), i.toggledNodes.size) {
        const d = [];
        i.toggledNodes.forEach((c, u) => {
          const h = s(c, r + 1, u);
          d.push(h);
        }), l.toggledNodes = d;
      }
      return l;
    };
    return s(n, 0);
  }
  setSelectedState(e) {
    if ("selectAll" in e) {
      $e(111);
      return;
    }
    const t = (n, o) => {
      var a;
      if (typeof n != "object")
        throw $e(243), new Error();
      if ("selectAllChildren" in n && typeof n.selectAllChildren != "boolean")
        throw $e(244), new Error();
      if ("toggledNodes" in n) {
        if (!Array.isArray(n.toggledNodes))
          throw $e(245), new Error();
        if (!n.toggledNodes.every(
          (d) => typeof d == "object" && "nodeId" in d && typeof d.nodeId == "string"
        ))
          throw $e(246), new Error();
      }
      const s = n.selectAllChildren ?? !o, i = (a = n.toggledNodes) == null ? void 0 : a.map((l) => [
        l.nodeId,
        t(l, s)
      ]);
      if (i == null ? void 0 : i.some(
        ([, l]) => s === l.selectAllChildren && l.toggledNodes.size === 0
      ))
        throw $e(247), new Error();
      return {
        selectAllChildren: s,
        toggledNodes: new Map(i)
      };
    };
    try {
      this.selectedState = t(e, !!e.selectAllChildren);
    } catch {
    }
  }
  deleteSelectionStateFromParent(e, t) {
    let n = this.selectedState;
    const o = [...e];
    for (; n && o.length; )
      n = n.toggledNodes.get(o.pop());
    if (!n)
      return !1;
    let s = !1;
    return t.forEach((i) => {
      n != null && n.toggledNodes.delete(i) && (s = !0);
    }), s && this.removeRedundantState(), s;
  }
  setNodesSelected({ nodes: e, newValue: t, clearSelection: n, source: o }) {
    if (e.length === 0)
      return 0;
    const s = n && t;
    if (!es(this.gos) || s) {
      if (e.length > 1)
        return $e(130), 0;
      this.deselectAllRowNodes();
    }
    return e.forEach((i) => {
      const r = i.footer ? i.sibling : i, a = this.getRouteToNode(r);
      this.recursivelySelectNode(a, this.selectedState, t);
    }), this.removeRedundantState(), e.length === 1 && o === "api" && this.selectionCtx.setRoot(e[0].footer ? e[0].sibling : e[0]), 1;
  }
  isNodeSelected(e) {
    const t = this.getRouteToNode(e);
    return this.isNodePathSelected(t, this.selectedState);
  }
  isNodePathSelected([e, ...t], n) {
    if (t.length === 0) {
      const o = n.toggledNodes.has(e.id);
      if (e.hasChildren()) {
        const s = n.toggledNodes.get(e.id);
        if (s && s.toggledNodes.size)
          return;
      }
      return n.selectAllChildren ? !o : o;
    }
    if (n.toggledNodes.has(e.id)) {
      const o = n.toggledNodes.get(e.id);
      if (o)
        return this.isNodePathSelected(t, o);
    }
    return n.selectAllChildren;
  }
  getRouteToNode(e) {
    const t = [];
    let n = e;
    for (; n.parent; )
      t.push(n), n = n.parent;
    return t.reverse();
  }
  removeRedundantState() {
    var t;
    if ((t = this.filterManager) != null && t.isAnyFilterPresent())
      return;
    const e = (n = this.selectedState, o, s) => {
      if (n.toggledNodes.forEach((a, l) => {
        e(a, l, n);
      }), o) {
        const a = this.rowModel.getRowNode(o), l = a == null ? void 0 : a.childStore;
        if ((l == null ? void 0 : l.isLastRowIndexKnown()) && n.toggledNodes.size >= l.getRowCount()) {
          for (const u of n.toggledNodes.entries()) {
            const [h, g] = u;
            if (g.toggledNodes.size > 0 || !this.rowModel.getRowNode(h))
              return;
          }
          n.selectAllChildren = !n.selectAllChildren, n.toggledNodes.clear();
        }
      }
      const i = n.toggledNodes.size === 0, r = (s == null ? void 0 : s.selectAllChildren) === n.selectAllChildren;
      i && r && (s == null || s.toggledNodes.delete(o));
    };
    e();
  }
  recursivelySelectNode([e, ...t], n, o) {
    if (!e)
      return;
    if (!t.length) {
      const a = e.selectable;
      if (n.selectAllChildren === o || !a) {
        n.toggledNodes.delete(e.id);
        return;
      }
      const d = {
        selectAllChildren: o,
        toggledNodes: /* @__PURE__ */ new Map()
      };
      n.toggledNodes.set(e.id, d);
      return;
    }
    const i = n.toggledNodes.has(e.id), r = n.toggledNodes.get(e.id) ?? {
      selectAllChildren: n.selectAllChildren,
      toggledNodes: /* @__PURE__ */ new Map()
    };
    i || n.toggledNodes.set(e.id, r), this.recursivelySelectNode(t, r, o), n.selectAllChildren === r.selectAllChildren && r.toggledNodes.size === 0 && n.toggledNodes.delete(e.id);
  }
  getSelectedNodes(e = !1) {
    if (Z(202), this.selectedState.selectAllChildren && e)
      return null;
    const t = [];
    return this.rowModel.forEachNode((n) => {
      n.isSelected() && t.push(n);
    }), t;
  }
  processNewRow() {
  }
  getSelectedRows() {
    var e;
    return ((e = this.getSelectedNodes()) == null ? void 0 : e.map((t) => t.data)) ?? [];
  }
  getSelectionCount() {
    return -1;
  }
  isEmpty() {
    var e;
    return !this.selectedState.selectAllChildren && !((e = this.selectedState.toggledNodes) != null && e.size);
  }
  selectAllRowNodes() {
    this.reset(!0);
  }
  deselectAllRowNodes() {
    this.reset(!1);
  }
  reset(e) {
    this.selectedState = { selectAllChildren: e, toggledNodes: /* @__PURE__ */ new Map() };
  }
  getSelectAllState() {
    return this.selectedState.selectAllChildren ? this.selectedState.toggledNodes.size > 0 ? null : !0 : this.selectedState.toggledNodes.size > 0 ? null : !1;
  }
}, bz = class extends Jw {
  constructor() {
    super(...arguments), this.beanName = "selectionSvc";
  }
  postConstruct() {
    super.postConstruct(), this.addManagedPropertyListeners(["groupSelectsChildren", "rowSelection"], () => {
      const n = wi(this.gos), o = n && this.selectionStrategy instanceof Wu ? Tl : !n && this.selectionStrategy instanceof Tl ? Wu : void 0;
      o && (this.destroyBean(this.selectionStrategy), this.selectionStrategy = this.createManagedBean(new o(this.selectionCtx)), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged("api"));
    }), this.addManagedPropertyListeners(["rowSelection"], () => {
      const n = Cr(this.gos);
      n !== this.selectionMode && (this.selectionMode = n, this.deselectAllRowNodes({ source: "api" }));
    }), this.selectionMode = Cr(this.gos);
    const t = wi(this.gos) ? Tl : Wu;
    this.selectionStrategy = this.createManagedBean(new t(this.selectionCtx));
  }
  handleSelectionEvent(e, t, n) {
    if (this.isRowSelectionBlocked(t))
      return 0;
    let o = 0;
    const s = this.inferNodeSelections(t, e.shiftKey, e.metaKey || e.ctrlKey, n);
    return s == null ? 0 : (this.selectionCtx.selectAll = !1, "select" in s ? (s.reset ? this.selectionStrategy.deselectAllRowNodes({ source: "api" }) : this.selectionStrategy.setNodesSelected({ nodes: s.deselect, newValue: !1, source: n }), o = this.selectionStrategy.setNodesSelected({ nodes: s.select, newValue: !0, source: n })) : o = this.selectionStrategy.setNodesSelected({
      nodes: [s.node],
      newValue: s.newValue,
      clearSelection: s.clearSelection,
      event: e,
      source: n
    }), this.shotgunResetNodeSelectionState(n), this.dispatchSelectionChanged(n), o);
  }
  getSelectionState() {
    return this.selectionStrategy.getSelectedState();
  }
  setSelectionState(e, t) {
    if (!In(this.gos)) {
      e && Z(132);
      return;
    }
    Array.isArray(e) || (e ? (this.selectionStrategy.setSelectedState(e), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged(t)) : this.deselectAllRowNodes({ source: t }));
  }
  setNodesSelected(e) {
    if (!In(this.gos) && e.newValue)
      return Z(132), 0;
    const { nodes: t, ...n } = e;
    if (t.length > 1 && this.selectionMode !== "multiRow")
      return Z(130), 0;
    const o = {
      nodes: t.filter((i) => i.selectable),
      ...n
    };
    if (!o.nodes.length)
      return 0;
    const s = this.selectionStrategy.setNodesSelected(o);
    return this.shotgunResetNodeSelectionState(o.source), this.dispatchSelectionChanged(o.source), s;
  }
  /**
   * Deletes the selection state for a set of nodes, for use after deleting nodes via
   * transaction. As this is designed for transactions, all nodes should belong to the same group.
   */
  deleteSelectionStateFromParent(e, t) {
    this.selectionStrategy.deleteSelectionStateFromParent(e, t) && (this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged("api"));
  }
  shotgunResetNodeSelectionState(e) {
    this.beans.rowModel.forEachNode((t) => {
      if (t.stub)
        return;
      const n = this.selectionStrategy.isNodeSelected(t);
      n !== t.isSelected() && this.selectRowNode(t, n, void 0, e);
    });
  }
  getSelectedNodes() {
    return this.selectionStrategy.getSelectedNodes() ?? [];
  }
  getSelectedRows() {
    return this.selectionStrategy.getSelectedRows();
  }
  getSelectionCount() {
    return this.selectionStrategy.getSelectionCount();
  }
  syncInRowNode(e) {
    this.selectionStrategy.processNewRow(e);
    const t = this.selectionStrategy.isNodeSelected(e);
    if (t != !1 && !e.selectable) {
      this.selectionStrategy.setNodesSelected({
        nodes: [e],
        newValue: !1,
        source: "api"
      }), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged("api");
      return;
    }
    e.__selected = t;
  }
  reset() {
    this.selectionStrategy.deselectAllRowNodes({ source: "api" }), this.selectionCtx.reset();
  }
  isEmpty() {
    return this.selectionStrategy.isEmpty();
  }
  hasNodesToSelect() {
    return !0;
  }
  selectAllRowNodes(e) {
    if (!In(this.gos)) {
      Z(132);
      return;
    }
    if (V0(e), ep(this.gos) && !es(this.gos))
      return Z(130);
    this.selectionStrategy.selectAllRowNodes(e), this.selectionCtx.selectAll = !0, this.beans.rowModel.forEachNode((t) => {
      t.stub || this.selectRowNode(t, !0, void 0, e.source);
    }), this.dispatchSelectionChanged(e.source);
  }
  deselectAllRowNodes(e) {
    V0(e), this.selectionStrategy.deselectAllRowNodes(e), this.selectionCtx.selectAll = !1, this.beans.rowModel.forEachNode((t) => {
      t.stub || this.selectRowNode(t, !1, void 0, e.source);
    }), this.dispatchSelectionChanged(e.source);
  }
  getSelectAllState(e) {
    return this.selectionStrategy.getSelectAllState(e);
  }
  // used by CSRM
  getBestCostNodeSelection() {
    return Z(194, { method: "getBestCostNodeSelection" });
  }
  /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData
   */
  updateSelectable() {
    if (!In(this.gos))
      return;
    const e = [];
    this.beans.rowModel.forEachNode((t) => {
      !this.updateRowSelectable(t, !0) && t.isSelected() && e.push(t);
    }), e.length && this.setNodesSelected({
      nodes: e,
      newValue: !1,
      source: "selectableChanged"
    });
  }
  dispatchSelectionChanged(e) {
    this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: e,
      selectedNodes: this.selectionStrategy instanceof Tl ? null : this.selectionStrategy.getSelectedNodes(!0, !1),
      serverSideState: this.getSelectionState()
    });
  }
  updateSelectableAfterGrouping() {
    return $e(194, { method: "updateSelectableAfterGrouping" });
  }
  refreshMasterNodeState() {
  }
  setDetailSelectionState() {
  }
};
function V0({ selectAll: e }) {
  (e === "filtered" || e === "currentPage") && Z(195, { justCurrentPage: e === "currentPage" });
}
var Sz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "rowChildrenSvc";
  }
  getHasChildrenValue(e) {
    const t = this.gos.get("treeData"), n = this.gos.get("isServerSideGroup");
    return !e.stub && !e.footer && (t ? !!n && n(e.data) : !!e.group);
  }
}, xz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "lazyBlockLoadingSvc", this.outboundRequests = 0, this.cacheLoadingNodesMap = /* @__PURE__ */ new Map(), this.isCheckQueued = !1, this.nextBlockToLoad = void 0;
  }
  wireBeans(e) {
    this.rowRenderer = e.rowRenderer, this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.maxOutboundRequests = TC(this.gos);
  }
  subscribe(e) {
    this.cacheLoadingNodesMap.set(e, /* @__PURE__ */ new Set());
  }
  unsubscribe(e) {
    this.cacheLoadingNodesMap.delete(e);
  }
  /**
   * Queues a microtask to check if any blocks need to be loaded.
   */
  queueLoadCheck() {
    this.isCheckQueued || (this.isCheckQueued = !0, setTimeout(() => {
      this.queueLoadAction(), this.isCheckQueued = !1;
    }));
  }
  onLoadComplete() {
    this.outboundRequests -= 1, this.queueLoadCheck();
  }
  hasAvailableLoadBandwidth() {
    return this.maxOutboundRequests === void 0 ? !0 : this.outboundRequests < this.maxOutboundRequests;
  }
  queueLoadAction() {
    const e = this.getBlockToLoad();
    if (!e)
      return;
    const t = this.nextBlockToLoad && this.nextBlockToLoad.cache === e.cache && this.nextBlockToLoad.index === e.index;
    if (!t && (!this.nextBlockToLoad || !t)) {
      this.nextBlockToLoad = e, window.clearTimeout(this.loaderTimeout);
      const n = Number(this.nextBlockToLoad.index), o = this.nextBlockToLoad.cache, s = e.index + e.cache.getBlockSize();
      this.loaderTimeout = window.setTimeout(() => {
        o.isAlive() && (this.loaderTimeout = void 0, this.attemptLoad(o, n, s), this.nextBlockToLoad = void 0);
      }, this.gos.get("blockLoadDebounceMillis"));
    }
  }
  attemptLoad(e, t, n) {
    this.hasAvailableLoadBandwidth() && (this.executeLoad(e, t, n), this.queueLoadCheck());
  }
  executeLoad(e, t, n) {
    var u;
    const o = e.getSsrmParams(), s = {
      startRow: t,
      endRow: n,
      rowGroupCols: o.rowGroupCols,
      valueCols: o.valueCols,
      pivotCols: o.pivotCols,
      pivotMode: o.pivotMode,
      groupKeys: e.store.getParentNode().getRoute() ?? [],
      filterModel: o.filterModel,
      sortModel: o.sortModel
    }, i = this.cacheLoadingNodesMap.get(e), r = () => {
      for (let h = 0; h < n - t; h++)
        i.delete(t + h);
    }, a = () => {
      for (let h = 0; h < n - t; h++)
        i.add(t + h);
    }, l = (h) => {
      this.onLoadComplete(), e.onLoadSuccess(t, n - t, h), r();
    }, d = () => {
      this.onLoadComplete(), e.onLoadFailed(t, n - t), r();
    }, c = ke(this.gos, {
      request: s,
      success: l,
      fail: d,
      parentNode: e.store.getParentNode()
    });
    a(), this.outboundRequests += 1, (u = e.getSsrmParams().datasource) == null || u.getRows(c);
  }
  getBlockToLoad() {
    var a, l;
    const e = this.rowRenderer.firstRenderedRow, t = this.rowRenderer.lastRenderedRow;
    for (let d = e; d <= t; d++) {
      const c = this.rowModel.getRow(d);
      if (!c)
        continue;
      const u = (a = c.parent) == null ? void 0 : a.childStore;
      if (!u)
        continue;
      const h = u.getCache(), g = h.getNodes().getBy("node", c);
      if (!g)
        continue;
      const p = this.cacheLoadingNodesMap.get(h);
      if (!(p != null && p.has(g.index)) && (c.__needsRefreshWhenVisible || c.stub && !c.failedLoad))
        return {
          cache: h,
          index: h.getBlockStartIndex(g.index)
        };
    }
    let n = null, o = null, s = Number.MAX_SAFE_INTEGER;
    for (const d of this.cacheLoadingNodesMap.keys())
      d.getNodesToRefresh().forEach((u) => {
        if (u.rowIndex == null) {
          o = u, n = d;
          return;
        }
        const h = d.getNodes().getBy("node", u);
        if (!h)
          return;
        const g = this.cacheLoadingNodesMap.get(d);
        if (g != null && g.has(h.index))
          return;
        const p = Math.abs(e - u.rowIndex), f = Math.abs(u.rowIndex - t);
        p < s && (o = u, s = p, n = d), f < s && (o = u, s = f, n = d);
      });
    if (!n)
      return;
    const i = n, r = (l = i.getNodes().getBy("node", o)) == null ? void 0 : l.index;
    return r == null ? void 0 : {
      cache: i,
      index: i.getBlockStartIndex(r)
    };
  }
  isRowLoading(e, t) {
    var n;
    return ((n = this.cacheLoadingNodesMap.get(e)) == null ? void 0 : n.has(t)) ?? !1;
  }
}, Rz = class {
  constructor(...e) {
    this.indexes = e, this.maps = new Map(this.indexes.map((t) => [t, /* @__PURE__ */ new Map()]));
  }
  getSize() {
    return this.maps.get(this.indexes[0]).size;
  }
  getBy(e, t) {
    return this.maps.get(e).get(t);
  }
  set(e) {
    this.indexes.forEach((t) => {
      this.maps.get(t).set(e[t], e);
    });
  }
  delete(e) {
    this.indexes.forEach((t) => {
      this.maps.get(t).delete(e[t]);
    });
  }
  clear() {
    this.maps.forEach((e) => e.clear());
  }
  getIterator(e) {
    return this.maps.get(e).values();
  }
  forEach(e) {
    const t = this.getIterator(this.indexes[0]);
    let n;
    for (; (n = t.next()) && !n.done; )
      e(n.value);
  }
  find(e) {
    const t = this.getIterator(this.indexes[0]);
    let n;
    for (; (n = t.next()) && !n.done; )
      if (e(n.value))
        return n.value;
  }
  filter(e) {
    const t = this.getIterator(this.indexes[0]);
    let n;
    const o = [];
    for (; (n = t.next()) && !n.done; )
      e(n.value) && o.push(n.value);
    return o;
  }
}, Ez = 100, Uu = class extends U {
  constructor(e, t, n, o) {
    super(), this.live = !0, this.removedNodeCache = /* @__PURE__ */ new Map(), this.store = e, this.numberOfRows = t, this.isLastRowKnown = n, this.storeParams = o;
  }
  wireBeans(e) {
    this.rowRenderer = e.rowRenderer, this.blockUtils = e.ssrmBlockUtils, this.focusSvc = e.focusSvc, this.nodeManager = e.ssrmNodeManager, this.serverSideRowModel = e.rowModel, this.rowNodeSorter = e.rowNodeSorter, this.sortSvc = e.sortSvc, this.lazyBlockLoadingSvc = e.lazyBlockLoadingSvc, this.colModel = e.colModel;
  }
  postConstruct() {
    this.lazyBlockLoadingSvc.subscribe(this), this.nodeMap = new Rz("index", "id", "node"), this.nodeDisplayIndexMap = /* @__PURE__ */ new Map(), this.nodesToRefresh = /* @__PURE__ */ new Set(), this.defaultNodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode()), this.getRowIdFunc = Jo(this.gos), this.isMasterDetail = this.gos.get("masterDetail");
  }
  destroy() {
    this.lazyBlockLoadingSvc.unsubscribe(this), this.numberOfRows = 0, this.nodeMap.forEach((e) => this.blockUtils.destroyRowNode(e.node)), this.nodeMap.clear(), this.nodeDisplayIndexMap.clear(), this.nodesToRefresh.clear(), this.live = !1, super.destroy();
  }
  /**
   * Get the row node for a specific display index from this store
   * @param displayIndex the display index of the node to find
   * @returns undefined if the node is not in the store bounds, otherwise will always return a node
   */
  getRowByDisplayIndex(e) {
    var l, d, c, u, h;
    if (!this.store.isDisplayIndexInStore(e))
      return;
    const t = this.nodeDisplayIndexMap.get(e);
    if (t)
      return (t.stub || t.__needsRefreshWhenVisible) && this.lazyBlockLoadingSvc.queueLoadCheck(), t;
    if (this.gos.get("groupHideOpenParents") || this.gos.get("groupAllowUnbalanced")) {
      const g = this.nodeMap.find(
        (p) => {
          var f;
          return !!((f = p.node.childStore) != null && f.isDisplayIndexInStore(e));
        }
      );
      if (g)
        return (l = g.node.childStore) == null ? void 0 : l.getRowUsingDisplayIndex(e);
    }
    if (e === this.store.getDisplayIndexStart())
      return this.createStubNode(0, e);
    const o = this.nodeDisplayIndexMap.get(e - 1);
    if (o) {
      if (this.isMasterDetail && o.master && o.expanded)
        return o.detailNode;
      if (o.expanded && ((d = o.childStore) != null && d.isDisplayIndexInStore(e)))
        return (c = o.childStore) == null ? void 0 : c.getRowUsingDisplayIndex(
          e
        );
      const g = this.nodeMap.getBy("node", o);
      return this.createStubNode(g.index + 1, e);
    }
    const s = this.getSurroundingNodesByDisplayIndex(e);
    if (s == null) {
      const g = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - e);
      return this.createStubNode(g, e);
    }
    const { previousNode: i, nextNode: r } = s;
    if (i && i.node.expanded && ((u = i.node.childStore) != null && u.isDisplayIndexInStore(e)))
      return (h = i.node.childStore) == null ? void 0 : h.getRowUsingDisplayIndex(e);
    if (r) {
      const g = r.node.rowIndex - e, p = r.index - g;
      return this.createStubNode(p, e);
    }
    const a = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - e);
    return this.createStubNode(a, e);
  }
  /**
   * Used for creating and positioning a stub node without firing a store updated event
   */
  createStubNode(e, t) {
    const n = this.store.getRowBounds(t), o = this.createRowAtIndex(e, null, (s) => {
      s.setRowIndex(t), s.setRowTop(n.rowTop), this.nodeDisplayIndexMap.set(t, s);
    });
    if (e === 0 && this.gos.get("groupHideOpenParents")) {
      const s = this.store.getParentNode().groupData;
      if (s)
        for (const i of Object.keys(s))
          x0(o, this.colModel, i, s[i]);
    }
    return this.lazyBlockLoadingSvc.queueLoadCheck(), o;
  }
  /**
   * @param index The row index relative to this store
   * @returns A rowNode at the given store index
   */
  getRowByStoreIndex(e) {
    var t;
    return (t = this.nodeMap.getBy("index", e)) == null ? void 0 : t.node;
  }
  /**
   * Given a number of rows, skips through the given sequence & row top reference (using default row height)
   * @param numberOfRowsToSkip number of rows to skip over in the given sequence
   * @param displayIndexSeq the sequence in which to skip
   * @param nextRowTop the row top reference in which to skip
   */
  skipDisplayIndexes(e, t, n) {
    if (e === 0)
      return;
    const o = Kn(this.beans);
    t.value += e, n.value += e * o;
  }
  /**
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */
  setDisplayIndexes(e, t, n) {
    this.nodeDisplayIndexMap.clear();
    const o = {};
    this.nodeMap.forEach((r) => {
      o[r.index] = r.node;
    });
    let s = -1;
    for (const r of Object.keys(o)) {
      const a = o[r], l = Number(r), d = l - 1 - s;
      this.skipDisplayIndexes(d, e, t);
      const c = l === 0;
      if (a.firstChild !== c && (a.firstChild = c, a.dispatchRowEvent("firstChildChanged")), c && this.gos.get("groupHideOpenParents")) {
        const u = this.store.getParentNode().groupData;
        if (u)
          for (const h of Object.keys(u))
            x0(a, this.colModel, h, c ? u[h] : void 0);
      }
      this.blockUtils.setDisplayIndex(a, e, t, n), a.rowIndex != null && this.nodeDisplayIndexMap.set(a.rowIndex, a), s = l;
    }
    const i = this.numberOfRows - 1 - s;
    this.skipDisplayIndexes(i, e, t), this.purgeExcessRows();
  }
  getRowCount() {
    return this.numberOfRows;
  }
  setRowCount(e, t) {
    this.numberOfRows = e, t != null && (this.isLastRowKnown = t, t === !1 && (this.numberOfRows += 1)), this.fireStoreUpdatedEvent();
  }
  getNodes() {
    return this.nodeMap;
  }
  getNodeCachedByDisplayIndex(e) {
    return this.nodeDisplayIndexMap.get(e) ?? null;
  }
  getNodesToRefresh() {
    return this.nodesToRefresh;
  }
  /**
   * @returns the previous and next loaded row nodes surrounding the given display index
   */
  getSurroundingNodesByDisplayIndex(e) {
    let t, n;
    return this.nodeMap.forEach((o) => {
      if (e > o.node.rowIndex) {
        (n == null || n.node.rowIndex < o.node.rowIndex) && (n = o);
        return;
      }
      if (t == null || t.node.rowIndex > o.node.rowIndex) {
        t = o;
        return;
      }
    }), !n && !t ? null : { previousNode: n, nextNode: t };
  }
  /**
   * Get or calculate the display index for a given store index
   * @param storeIndex the rows index within this store
   * @returns the rows visible display index relative to the grid
   */
  getDisplayIndexFromStoreIndex(e) {
    var r;
    const t = this.nodeMap.getBy("index", e);
    if (t)
      return t.node.rowIndex;
    let n, o;
    if (this.nodeMap.forEach((a) => {
      if (e > a.index) {
        (o == null || o.index < a.index) && (o = a);
        return;
      }
      if (n == null || n.index > a.index) {
        n = a;
        return;
      }
    }), !n)
      return this.store.getDisplayIndexEnd() - (this.numberOfRows - e);
    if (!o)
      return this.store.getDisplayIndexStart() + e;
    const s = e - o.index;
    return (((r = o.node.childStore) == null ? void 0 : r.getDisplayIndexEnd()) ?? o.node.rowIndex) + s;
  }
  /**
   * Creates a new row and inserts it at the given index
   * @param atStoreIndex the node index relative to this store
   * @param data the data object to populate the node with
   * @returns the new row node
   */
  createRowAtIndex(e, t, n) {
    var i, r;
    const o = this.nodeMap.getBy("index", e);
    if (o) {
      const { node: a } = o;
      if (a.__needsRefreshWhenVisible = !1, this.doesNodeMatch(t, a))
        return this.blockUtils.updateDataIntoRowNode(a, t), this.nodesToRefresh.delete(a), a;
      if (this.getRowIdFunc == null && a.hasChildren() && a.expanded)
        return this.nodesToRefresh.delete(a), a;
      this.destroyRowAtIndex(e);
    }
    if (t && this.getRowIdFunc != null) {
      const a = this.getRowId(t), l = a && ((i = this.removedNodeCache) == null ? void 0 : i.get(a));
      if (l)
        return (r = this.removedNodeCache) == null || r.delete(a), this.blockUtils.updateDataIntoRowNode(l, t), this.nodeMap.set({
          id: l.id,
          node: l,
          index: e
        }), this.nodesToRefresh.delete(l), l.__needsRefreshWhenVisible = !1, l;
      const d = this.nodeMap.getBy("id", a);
      if (d) {
        this.nodeMap.delete(d);
        const { node: c, index: u } = d;
        return this.blockUtils.updateDataIntoRowNode(c, t), this.nodeMap.set({
          id: c.id,
          node: c,
          index: e
        }), this.nodesToRefresh.delete(c), c.__needsRefreshWhenVisible = !1, this.getBlockStartIndex(u) === this.getBlockStartIndex(e) || this.markBlockForVerify(u), c;
      }
    }
    const s = this.blockUtils.createRowNode(this.store.getRowDetails());
    if (t != null) {
      const a = this.getPrefixedId(this.store.getIdSequence().value++);
      this.blockUtils.setDataIntoRowNode(s, t, a, void 0), this.blockUtils.checkOpenByDefault(s), this.nodeManager.addRowNode(s);
    }
    return this.nodeMap.set({
      id: s.id,
      node: s,
      index: e
    }), n && n(s), s;
  }
  getBlockStates() {
    const e = {}, t = {};
    this.nodeMap.forEach(({ node: i, index: r }) => {
      const a = this.getBlockStartIndex(r);
      !i.stub && !i.failedLoad && (e[a] = (e[a] ?? 0) + 1);
      let l = "loaded";
      i.failedLoad ? l = "failed" : this.lazyBlockLoadingSvc.isRowLoading(this, a) ? l = "loading" : (this.nodesToRefresh.has(i) || i.stub) && (l = "needsLoading"), t[a] || (t[a] = /* @__PURE__ */ new Set()), t[a].add(l);
    });
    const n = {
      loading: 4,
      failed: 3,
      needsLoading: 2,
      loaded: 1
    }, o = this.blockUtils.createNodeIdPrefix(this.store.getParentNode()), s = {};
    for (const i of Object.keys(t)) {
      const a = [...t[i]].sort(
        (c, u) => (n[c] ?? 0) - (n[u] ?? 0)
      )[0], l = Number(i) / this.getBlockSize(), d = o ? `${o}-${l}` : String(l);
      s[d] = {
        blockNumber: l,
        startRow: Number(i),
        endRow: Number(i) + this.getBlockSize(),
        pageStatus: a,
        loadedRowCount: e[i] ?? 0
      };
    }
    return s;
  }
  destroyRowAtIndex(e) {
    const t = this.nodeMap.getBy("index", e);
    t && (this.nodeMap.delete(t), this.nodeDisplayIndexMap.delete(t.node.rowIndex), this.nodesToRefresh.size > 0 ? this.removedNodeCache.set(t.node.id, t.node) : this.blockUtils.destroyRowNode(t.node), this.nodesToRefresh.delete(t.node));
  }
  getSsrmParams() {
    return this.store.getSsrmParams();
  }
  /**
   * @param id the base id to be prefixed
   * @returns a node id with prefix if required
   */
  getPrefixedId(e) {
    return this.defaultNodeIdPrefix ? this.defaultNodeIdPrefix + "-" + e : e.toString();
  }
  markBlockForVerify(e) {
    const [t, n] = this.getBlockBounds(e);
    this.nodeMap.filter((s) => s.index >= t && s.index < n).forEach(({ node: s }) => {
      s.__needsRefreshWhenVisible = !0;
    });
  }
  doesNodeMatch(e, t) {
    if (t.stub)
      return !1;
    const n = this.getRowId(e);
    return n === null ? t.data === e : t.id === n;
  }
  /**
   * Deletes any stub nodes not within the given range
   */
  purgeStubsOutsideOfViewport() {
    const { firstRenderedRow: e, lastRenderedRow: t } = this.rowRenderer, n = this.getBlockStartIndex(e), [, o] = this.getBlockBounds(t);
    this.nodeMap.forEach((s) => {
      this.lazyBlockLoadingSvc.isRowLoading(this, s.index) || s.node.failedLoad || s.node.stub && (s.index < n || s.index > o) && this.destroyRowAtIndex(s.index);
    });
  }
  getBlocksDistanceFromRow(e, t) {
    const n = {};
    return e.forEach(({ node: o, index: s }) => {
      const [i, r] = this.getBlockBounds(s);
      if (i in n)
        return;
      const a = Math.abs(o.rowIndex - t);
      let l;
      const d = this.nodeMap.getBy("index", [r - 1]);
      d && (l = Math.abs(d.node.rowIndex - t));
      const c = l == null || a < l ? a : l;
      n[i] = c;
    }), Object.entries(n);
  }
  purgeExcessRows() {
    if (this.purgeStubsOutsideOfViewport(), this.store.getDisplayIndexEnd() == null || this.storeParams.maxBlocksInCache == null)
      return;
    const { firstRenderedRow: e, lastRenderedRow: t } = this.rowRenderer, n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
    this.nodeMap.forEach(({ index: g, node: p }) => {
      const f = this.getBlockStartIndex(g);
      n.add(f), p.rowIndex >= e && p.rowIndex <= t && o.add(f);
    });
    const s = Math.max(o.size, this.storeParams.maxBlocksInCache ?? 0), r = n.size - s;
    if (r <= 0)
      return;
    let a = Number.MAX_SAFE_INTEGER, l = Number.MIN_SAFE_INTEGER;
    o.forEach((g) => {
      a > g && (a = g), l < g && (l = g);
    });
    const d = this.nodeMap.filter(({ node: g, index: p }) => {
      const f = this.getBlockStartIndex(p);
      return !(f >= a && f <= l) && !this.isNodeCached(g);
    });
    if (d.length === 0)
      return;
    const c = e + (t - e) / 2, u = this.getBlocksDistanceFromRow(d, c), h = this.getBlockSize();
    u.sort((g, p) => Math.sign(p[1] - g[1]));
    for (let g = 0; g < Math.min(r, u.length); g++) {
      const p = Number(u[g][0]);
      for (let f = p; f < p + h; f++) {
        const m = this.nodeMap.getBy("index", f);
        !m || this.isNodeCached(m.node) || this.destroyRowAtIndex(f);
      }
    }
  }
  isNodeFocused(e) {
    const t = this.focusSvc.getFocusCellToUseAfterRefresh();
    return !t || t.rowPinned != null ? !1 : t.rowIndex === e.rowIndex;
  }
  isNodeCached(e) {
    const t = this.gos.get("groupAllowUnbalanced") && e.key === "";
    return e.isExpandable() && e.expanded || this.isNodeFocused(e) || t;
  }
  extractDuplicateIds(e) {
    if (this.getRowIdFunc == null)
      return [];
    const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
    return e.forEach((o) => {
      const s = this.getRowId(o);
      if (t.has(s)) {
        n.add(s);
        return;
      }
      t.add(s);
    }), [...n];
  }
  onLoadSuccess(e, t, n) {
    if (!this.live)
      return;
    const o = n.groupLevelInfo;
    if (this.store.setStoreInfo(o), this.getRowIdFunc != null) {
      const r = this.extractDuplicateIds(n.rowData);
      if (r.length > 0) {
        const a = r.join(", ");
        Z(205, { duplicateIdText: a }), this.onLoadFailed(e, t);
        return;
      }
    }
    n.pivotResultFields && this.serverSideRowModel.generateSecondaryColumns(n.pivotResultFields);
    const s = this.nodesToRefresh.size > 0;
    if (n.rowData.forEach((r, a) => {
      var c;
      const l = e + a, d = this.nodeMap.getBy("index", l);
      if ((c = d == null ? void 0 : d.node) != null && c.stub) {
        this.createRowAtIndex(l, r);
        return;
      }
      if (d && this.doesNodeMatch(r, d.node)) {
        this.blockUtils.updateDataIntoRowNode(d.node, r), this.nodesToRefresh.delete(d.node), d.node.__needsRefreshWhenVisible = !1;
        return;
      }
      this.createRowAtIndex(l, r);
    }), n.rowCount != null && n.rowCount !== -1)
      this.numberOfRows = n.rowCount, this.isLastRowKnown = !0;
    else if (t > n.rowData.length)
      this.numberOfRows = e + n.rowData.length, this.isLastRowKnown = !0;
    else if (!this.isLastRowKnown) {
      const r = e + n.rowData.length + 1;
      r > this.numberOfRows && (this.numberOfRows = r);
    }
    this.isLastRowKnown && this.nodeMap.filter((a) => a.index >= this.numberOfRows).forEach((a) => this.destroyRowAtIndex(a.index)), this.fireStoreUpdatedEvent();
    const i = this.nodesToRefresh.size === 0;
    s && i && this.fireRefreshFinishedEvent();
  }
  fireRefreshFinishedEvent() {
    this.nodesToRefresh.size === 0 && (this.removedNodeCache.forEach((t) => {
      this.blockUtils.destroyRowNode(t);
    }), this.removedNodeCache = /* @__PURE__ */ new Map(), this.store.fireRefreshFinishedEvent());
  }
  /**
   * @returns true if all rows are loaded
   */
  isStoreFullyLoaded() {
    const e = this.isLastRowKnown, t = this.nodeMap.getSize() === this.numberOfRows;
    if (!e || !t || this.nodesToRefresh.size > 0)
      return;
    let n = -1;
    return this.nodeMap.find((s) => (n += 1, !!(s.index !== n || s.node.__needsRefreshWhenVisible || s.node.stub))) == null;
  }
  isLastRowIndexKnown() {
    return this.isLastRowKnown;
  }
  onLoadFailed(e, t) {
    if (!this.live)
      return;
    const n = this.nodesToRefresh.size > 0;
    for (let s = e; s < e + t && s < this.getRowCount(); s++) {
      let { node: i } = this.nodeMap.getBy("index", s) ?? {};
      i && this.nodesToRefresh.delete(i), (!i || !i.stub) && (i && !i.stub && this.destroyRowAtIndex(s), i = this.createRowAtIndex(s)), i.__needsRefreshWhenVisible = !1, i.failedLoad = !0;
    }
    const o = this.nodesToRefresh.size === 0;
    n && o && this.fireRefreshFinishedEvent(), this.fireStoreUpdatedEvent();
  }
  markNodesForRefresh() {
    this.nodeMap.forEach((e) => {
      e.node.stub && !e.node.failedLoad || this.nodesToRefresh.add(e.node);
    }), this.lazyBlockLoadingSvc.queueLoadCheck(), this.isLastRowKnown && this.numberOfRows === 0 && (this.numberOfRows = 1, this.isLastRowKnown = !1, this.fireStoreUpdatedEvent());
  }
  isNodeInCache(e) {
    return !!this.nodeMap.getBy("id", e);
  }
  // gets called 1) row count changed 2) cache purged 3) items inserted
  fireStoreUpdatedEvent() {
    this.live && this.store.fireStoreUpdatedEvent();
  }
  getRowId(e) {
    if (this.getRowIdFunc == null)
      return null;
    const { level: t } = this.store.getRowDetails(), n = this.store.getParentNode().getRoute() ?? [];
    return this.getRowIdFunc({
      data: e,
      parentKeys: n.length > 0 ? n : void 0,
      level: t
    });
  }
  getOrderedNodeMap() {
    const e = {};
    return this.nodeMap.forEach((t) => e[t.index] = t), e;
  }
  clearDisplayIndexes() {
    this.nodeDisplayIndexMap.clear();
  }
  /**
   * Client side sorting
   */
  clientSideSortRows() {
    var s;
    const e = ((s = this.sortSvc) == null ? void 0 : s.getSortOptions()) ?? [];
    if (!e.some((i) => i.sort != null) || !this.rowNodeSorter)
      return;
    const n = new Array(this.nodeMap.getSize());
    this.nodeMap.forEach((i) => n[i.index] = i.node), this.nodeMap.clear(), this.rowNodeSorter.doFullSort(n, e).forEach((i, r) => {
      this.nodeMap.set({
        id: i.id,
        node: i,
        index: r
      });
    });
  }
  /**
   * Transaction Support here
   */
  updateRowNodes(e) {
    const t = [];
    return e.forEach((n) => {
      const o = this.getRowId(n), s = this.nodeMap.getBy("id", o);
      s && (this.blockUtils.updateDataIntoRowNode(s.node, n), t.push(s.node));
    }), t;
  }
  insertRowNodes(e, t) {
    const n = this.store.getRowCount() - (this.store.getParentNode().sibling ? 1 : 0), o = t == null && this.isLastRowKnown ? n : t;
    if (o == null || n < o)
      return [];
    const s = {};
    e.forEach((l) => {
      const d = this.getRowId(l);
      d && this.isNodeInCache(d) || (s[d] = l);
    });
    const i = Object.values(s), r = i.length;
    if (r === 0)
      return [];
    const a = this.nodeMap.filter((l) => l.index >= o);
    return a.forEach((l) => this.nodeMap.delete(l)), a.forEach((l) => {
      this.nodeMap.set({
        node: l.node,
        index: l.index + r,
        id: l.id
      });
    }), this.numberOfRows += r, i.map(
      (l, d) => this.createRowAtIndex(o + d, l)
    );
  }
  removeRowNodes(e) {
    const t = [], n = [];
    let o = 0;
    const s = [...e], i = this.getOrderedNodeMap();
    let r = -1;
    for (const a of Object.keys(i)) {
      r += 1;
      const l = i[a], d = s.findIndex((u) => u === l.id);
      if (d !== -1) {
        s.splice(d, 1), this.destroyRowAtIndex(Number(a)), t.push(l.node), o += 1;
        continue;
      }
      if (o === 0)
        continue;
      const c = Number(a);
      r !== c && n.push(l.node), this.nodeMap.delete(l), this.nodeMap.set({
        id: l.id,
        node: l.node,
        index: c - o
      });
    }
    return this.numberOfRows -= this.isLastRowIndexKnown() ? e.length : o, s.length > 0 && n.length > 0 && (n.forEach((a) => a.__needsRefreshWhenVisible = !0), this.lazyBlockLoadingSvc.queueLoadCheck()), t;
  }
  /**
   * Return the block size configured for this cache
   */
  getBlockSize() {
    return this.storeParams.cacheBlockSize || Ez;
  }
  /**
   * Get the start index of the loading block for a given index
   */
  getBlockStartIndex(e) {
    const t = this.getBlockSize();
    return e - e % t;
  }
  /**
   * Get the start and end index of a block, given a row store index
   */
  getBlockBounds(e) {
    const t = this.getBlockStartIndex(e), n = this.getBlockSize();
    return [t, t + n];
  }
}, Az = class extends U {
  constructor(e, t, n) {
    super(), this.idSequence = { value: 0 }, this.ssrmParams = e, this.parentRowNode = n, this.storeParams = t, this.level = n.level + 1, this.group = e.rowGroupCols ? this.level < e.rowGroupCols.length : !1, this.leafGroup = e.rowGroupCols ? this.level === e.rowGroupCols.length - 1 : !1, this.info = {};
  }
  wireBeans(e) {
    this.blockUtils = e.ssrmBlockUtils, this.storeUtils = e.ssrmStoreUtils, this.selectionSvc = e.selectionSvc, this.rowGroupColsSvc = e.rowGroupColsSvc;
  }
  postConstruct() {
    let e = 1;
    if (this.level === 0 && (e = this.storeUtils.getServerSideInitialRowCount() ?? 1, this.eventSvc.dispatchEventOnce({
      type: "rowCountReady"
    })), this.cache = this.createManagedBean(new Uu(this, e, !1, this.storeParams)), !this.gos.get("treeData") && this.group && this.rowGroupColsSvc) {
      const n = this.ssrmParams.rowGroupCols[this.level];
      this.groupField = n.field, this.rowGroupColumn = this.rowGroupColsSvc.columns[this.level];
    }
  }
  destroy() {
    this.displayIndexStart = void 0, this.displayIndexEnd = void 0, this.destroyBean(this.cache), super.destroy();
  }
  /**
   * Given a server response, ingest the rows outside of the data source lifecycle.
   *
   * @param rowDataParams the server response containing the rows to ingest
   * @param startRow the index to start ingesting rows
   * @param expectedRows the expected number of rows in the response (used to determine if the last row index is known)
   */
  applyRowData(e, t, n) {
    this.cache.onLoadSuccess(t, n, e);
  }
  /**
   * Applies a given transaction to the data set within this store
   *
   * @param transaction an object containing delta instructions determining the changes to apply to this store
   * @returns an object determining the status of this transaction and effected nodes
   */
  applyTransaction(e) {
    var c, u, h;
    const t = Jo(this.gos);
    if (!t)
      return Z(206), {
        status: mo.Cancelled
      };
    const n = this.gos.getCallback("isApplyServerSideTransaction");
    if (n) {
      const g = {
        transaction: e,
        parentNode: this.parentRowNode,
        groupLevelInfo: this.info
      };
      if (!n(g))
        return { status: mo.Cancelled };
    }
    const o = this.cache.isStoreFullyLoaded();
    let s;
    (c = e.update) != null && c.length && (s = this.cache.updateRowNodes(e.update));
    let i;
    if ((u = e.add) != null && u.length) {
      let g = e.addIndex;
      g != null && g < 0 && (g = void 0), i = this.cache.insertRowNodes(e.add, g);
    }
    let r;
    if ((h = e.remove) != null && h.length) {
      const g = e.remove.map(
        (f) => t({ level: this.level, parentKeys: this.parentRowNode.getRoute() ?? [], data: f })
      ), p = [...new Set(g)];
      r = this.cache.removeRowNodes(p);
    }
    const a = this.gos.get("serverSideEnableClientSideSort"), l = (s == null ? void 0 : s.length) || (i == null ? void 0 : i.length);
    return o && a && l && this.cache.clientSideSortRows(), this.updateSelectionAfterTransaction(s, r), {
      status: mo.Applied,
      update: s,
      add: i,
      remove: r
    };
  }
  updateSelectionAfterTransaction(e, t) {
    if (!this.selectionSvc)
      return;
    const n = [];
    e == null || e.forEach((o) => {
      o.isSelected() && !o.selectable && n.push(o);
    }), t == null || t.forEach((o) => {
      o.isSelected() && n.push(o);
    }), n.length && this.selectionSvc.setNodesSelected({
      newValue: !1,
      clearSelection: !1,
      nodes: n,
      source: "rowDataChanged"
    });
  }
  /**
   * Clear the display indexes, used for fading rows out when stores are not being destroyed
   */
  clearDisplayIndexes() {
    this.displayIndexStart = void 0, this.displayIndexEnd = void 0, this.cache.getNodes().forEach((e) => this.blockUtils.clearDisplayIndex(e.node)), this.parentRowNode.sibling && this.blockUtils.clearDisplayIndex(this.parentRowNode.sibling), this.cache.clearDisplayIndexes();
  }
  /**
   * @returns an index representing the last sequentially displayed row in the grid for this store
   */
  getDisplayIndexStart() {
    return this.displayIndexStart;
  }
  /**
   * @returns the index representing one after the last sequentially displayed row in the grid for this store
   */
  getDisplayIndexEnd() {
    return this.displayIndexEnd;
  }
  /**
   * @returns the virtual size of this store
   */
  getRowCount() {
    return this.parentRowNode.sibling ? this.cache.getRowCount() + 1 : this.cache.getRowCount();
  }
  /**
   * Sets the current row count of the store, and whether the last row index is known
   */
  setRowCount(e, t) {
    this.cache.setRowCount(e, t);
  }
  /**
   * Given a display index, returns whether that row is within this store or a child store of this store
   *
   * @param displayIndex the visible index of a row
   * @returns whether or not the row exists within this store
   */
  isDisplayIndexInStore(e) {
    return this.cache.getRowCount() === 0 ? !1 : this.displayIndexStart <= e && e < this.getDisplayIndexEnd();
  }
  /**
   * Recursively sets up the display indexes and top position of every node belonging to this store.
   *
   * Called after a row height changes, or a store updated event.
   *
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */
  setDisplayIndexes(e, t, n) {
    this.displayIndexStart = e.value, this.topPx = t.value;
    const o = this.parentRowNode.level > -1 && vr(this.gos)({ node: this.parentRowNode });
    o || Yp(this.parentRowNode), o === "top" && (Zo(this.parentRowNode, this.beans), this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, e, t, n)), this.cache.setDisplayIndexes(e, t, n), o === "bottom" && (Zo(this.parentRowNode, this.beans), this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, e, t, n)), this.displayIndexEnd = e.value, this.heightPx = t.value - this.topPx;
  }
  /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */
  forEachStoreDeep(e, t = { value: 0 }) {
    e(this, t.value++), this.cache.getNodes().forEach((n) => {
      const o = n.node.childStore;
      o && o.forEachStoreDeep(e, t);
    });
  }
  /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */
  forEachNodeDeep(e, t = { value: 0 }) {
    this.cache.getNodes().forEach((n) => {
      e(n.node, t.value++);
      const o = n.node.childStore;
      o && o.forEachNodeDeep(e, t);
    });
  }
  /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeep
   */
  forEachNodeDeepAfterFilterAndSort(e, t = { value: 0 }, n = !1) {
    const o = this.parentRowNode.level > -1 && vr(this.gos)({ node: this.parentRowNode });
    o === "top" && e(this.parentRowNode.sibling, t.value++);
    const s = this.cache.getOrderedNodeMap();
    for (const i of Object.values(s)) {
      e(i.node, t.value++);
      const r = i.node.childStore;
      r && r.forEachNodeDeepAfterFilterAndSort(e, t, n);
    }
    o === "bottom" && e(this.parentRowNode.sibling, t.value++);
  }
  /**
   * Removes the failed status from all nodes, and marks them as stub to encourage reloading
   */
  retryLoads() {
    this.cache.getNodes().forEach(({ node: e }) => {
      e.failedLoad && (e.failedLoad = !1, e.__needsRefreshWhenVisible = !0, e.stub = !0);
    }), this.forEachChildStoreShallow((e) => e.retryLoads()), this.fireStoreUpdatedEvent();
  }
  /**
   * Given a display index, returns the row at that location.
   *
   * @param displayRowIndex the displayed index within the grid to search for
   * @returns the row node if the display index falls within the store, if it didn't exist this will create a new stub to return
   */
  getRowUsingDisplayIndex(e) {
    return this.parentRowNode.sibling && e === this.parentRowNode.sibling.rowIndex ? this.parentRowNode.sibling : this.cache.getRowByDisplayIndex(e);
  }
  /**
   * Given a display index, returns the row top and height for the row at that index.
   *
   * @param displayIndex the display index of the node
   * @returns an object containing the rowTop and rowHeight of the node at the given displayIndex
   */
  getRowBounds(e) {
    if (!this.isDisplayIndexInStore(e))
      return null;
    const t = this.cache.getNodeCachedByDisplayIndex(e);
    if (t) {
      const a = this.blockUtils.extractRowBounds(t, e);
      if (a)
        return a;
    }
    const { previousNode: n, nextNode: o } = this.cache.getSurroundingNodesByDisplayIndex(e) ?? {};
    if (n) {
      const a = this.blockUtils.extractRowBounds(n.node, e);
      if (a != null)
        return a;
    }
    const s = Kn(this.beans);
    if (o) {
      const a = (o.node.rowIndex - e) * s;
      return {
        rowTop: o.node.rowTop - a,
        rowHeight: s
      };
    }
    const i = this.topPx + this.heightPx, r = (this.getDisplayIndexEnd() - e) * s;
    return {
      rowTop: i - r,
      rowHeight: s
    };
  }
  /**
   * Given a vertical pixel, determines whether this store contains a row at that pixel
   *
   * @param pixel a vertical pixel position from the grid
   * @returns whether that pixel points to a virtual space belonging to this store
   */
  isPixelInRange(e) {
    return e >= this.topPx && e < this.topPx + this.heightPx;
  }
  /**
   * Given a vertical pixel, returns the row existing at that pixel location
   *
   * @param pixel a vertical pixel position from the grid
   * @returns the display index at the given pixel location
   */
  getRowIndexAtPixel(e) {
    if (e < this.topPx)
      return this.getDisplayIndexStart();
    if (e >= this.topPx + this.heightPx)
      return this.getDisplayIndexEnd() - 1;
    if (this.parentRowNode.sibling && e > this.parentRowNode.sibling.rowTop && e < this.parentRowNode.sibling.rowTop + this.parentRowNode.sibling.rowHeight)
      return this.parentRowNode.sibling.rowIndex;
    let t = Number.MAX_SAFE_INTEGER, n = null, o = Number.MAX_SAFE_INTEGER, s = null;
    if (this.cache.getNodes().forEach(({ node: l }) => {
      const d = Math.abs(e - l.rowTop);
      if (l.rowTop < e) {
        d < t && (t = d, n = l);
        return;
      }
      d < o && (o = d, s = l);
    }), n = n, s = s, n) {
      const l = this.blockUtils.getIndexAtPixel(n, e);
      if (l != null)
        return l;
    }
    const i = Kn(this.beans);
    if (s) {
      const l = s.rowTop, d = Math.ceil((l - e) / i);
      return s.rowIndex - d;
    }
    const r = this.topPx + this.heightPx, a = Math.floor((r - e) / i);
    return this.getDisplayIndexEnd() - a;
  }
  /**
   * Given a path of group keys, returns the child store for that group.
   *
   * @param keys the grouping path to the desired store
   * @returns the child store for the given keys, or null if not found
   */
  getChildStore(e) {
    return this.storeUtils.getChildStore(e, this, (t) => {
      const n = this.cache.getNodes().find((o) => o.node.key == t);
      return n ? n.node : null;
    });
  }
  /**
   * Executes a provided callback on each child store belonging to this store
   *
   * @param cb the callback to execute
   */
  forEachChildStoreShallow(e) {
    this.cache.getNodes().forEach(({ node: t }) => {
      t.childStore && e(t.childStore);
    });
  }
  /**
   * Executes after a change to sorting, determines recursively whether this store or a child requires refreshed.
   *
   * If a purge refresh occurs, the row count is preserved.
   *
   * @param params a set of properties pertaining to the sort changes
   */
  refreshAfterSort(e) {
    if (this.storeUtils.isServerSideSortAllLevels() || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, e)) {
      const n = this.cache.isStoreFullyLoaded(), o = this.gos.get("serverSideEnableClientSideSort");
      if (!(n && o)) {
        const i = this.cache.getRowCount(), r = this.cache.isLastRowIndexKnown();
        this.destroyBean(this.cache), this.cache = this.createManagedBean(new Uu(this, i, r, this.storeParams));
        return;
      }
      this.cache.clientSideSortRows();
    }
    this.forEachChildStoreShallow((n) => n.refreshAfterSort(e));
  }
  /**
   * Executes after a change to filtering, determines recursively whether this store or a child requires refreshed.
   *
   * If a refresh occurs, the row count is reset.
   *
   * @param params a set of properties pertaining to the filter changes
   */
  refreshAfterFilter(e) {
    if (!this.storeUtils.isServerSideOnlyRefreshFilteredGroups() || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, e)) {
      this.refreshStore(!0);
      return;
    }
    this.forEachChildStoreShallow((n) => n.refreshAfterFilter(e));
  }
  /**
   * Marks all existing nodes as requiring reloaded, and triggers a load check
   *
   * @param purge whether to remove all nodes and data in favour of stub nodes
   */
  refreshStore(e) {
    if (e) {
      this.destroyBean(this.cache), this.cache = this.createManagedBean(new Uu(this, 1, !1, this.storeParams)), this.fireStoreUpdatedEvent();
      return;
    }
    this.cache.markNodesForRefresh();
  }
  /**
   * Used for pagination, given a local/store index, returns the display index of that row
   *
   * @param topLevelIndex the store index of a row
   * @returns the display index for the given store index
   */
  getTopLevelRowDisplayedIndex(e) {
    return this.cache.getDisplayIndexFromStoreIndex(e) ?? e;
  }
  /**
   * Used for pagination to determine if the last page is known, and for aria to determine if the last grid row is known
   *
   * @returns whether the last index of this store is known, or if lazy loading still required
   */
  isLastRowIndexKnown() {
    return this.cache.isLastRowIndexKnown();
  }
  /**
   * Used by the selection service to select a range of nodes
   *
   * @param firstInRange the first node in the range to find
   * @param lastInRange the last node in the range to find
   * @returns a range of nodes between firstInRange and lastInRange inclusive
   */
  getRowNodesInRange(e, t) {
    return this.cache.getNodes().filter(({ node: n }) => n.rowIndex >= e.rowIndex && n.rowIndex <= t.rowIndex).map(({ node: n }) => n);
  }
  /**
   * Mutates a given array to add this stores state, and recursively add all the children store states.
   *
   * @param result a mutable results array
   */
  addStoreStates(e) {
    e.push({
      route: this.parentRowNode.getRoute() ?? [],
      rowCount: this.getRowCount(),
      lastRowIndexKnown: this.isLastRowIndexKnown(),
      info: this.info,
      maxBlocksInCache: this.storeParams.maxBlocksInCache,
      cacheBlockSize: this.storeParams.cacheBlockSize
    }), this.forEachChildStoreShallow((t) => t.addStoreStates(e));
  }
  getIdSequence() {
    return this.idSequence;
  }
  getParentNode() {
    return this.parentRowNode;
  }
  getRowDetails() {
    return {
      field: this.groupField,
      group: this.group,
      leafGroup: this.leafGroup,
      level: this.level,
      parent: this.parentRowNode,
      rowGroupColumn: this.rowGroupColumn
    };
  }
  getSsrmParams() {
    return this.ssrmParams;
  }
  setStoreInfo(e) {
    e && Object.assign(this.info, e);
  }
  // gets called 1) row count changed 2) cache purged
  fireStoreUpdatedEvent() {
    this.eventSvc.dispatchEvent({
      type: "storeUpdated"
    });
  }
  // gets called when row data updated, and no more refreshing needed
  fireRefreshFinishedEvent() {
    this.eventSvc.dispatchEvent({
      type: "storeRefreshed",
      route: this.parentRowNode.getRoute()
    });
  }
  getBlockStates() {
    return this.cache.getBlockStates();
  }
  getStoreBounds() {
    return {
      topPx: this.topPx,
      heightPx: this.heightPx
    };
  }
  getCache() {
    return this.cache;
  }
  getFirstNode() {
    const e = this.cache.getNodes().getBy("index", 0);
    return (e == null ? void 0 : e.node) ?? null;
  }
}, Fz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmStoreFactory";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc, this.rowAutoHeight = e.rowAutoHeight;
  }
  createStore(e, t) {
    const n = this.getStoreParams(e, t);
    return new Az(e, n, t);
  }
  getStoreParams(e, t) {
    const n = this.getLevelSpecificParams(t), o = this.getBlockSize(n), s = this.getMaxBlocksInCache(e, n);
    return {
      cacheBlockSize: o,
      maxBlocksInCache: s
    };
  }
  getMaxBlocksInCache(e, t) {
    var s;
    const n = t && t.maxBlocksInCache != null ? t.maxBlocksInCache : this.gos.get("maxBlocksInCache");
    if (n != null && n >= 0) {
      if (e.dynamicRowHeight) {
        Z(203);
        return;
      }
      if ((s = this.rowAutoHeight) != null && s.active) {
        Z(204);
        return;
      }
      return n;
    }
  }
  getBlockSize(e) {
    const t = e && e.cacheBlockSize != null ? e.cacheBlockSize : this.gos.get("cacheBlockSize");
    return t != null && t > 0 ? t : 100;
  }
  getLevelSpecificParams(e) {
    var s, i;
    const t = this.gos.getCallback("getServerSideGroupLevelParams");
    if (!t)
      return;
    const n = {
      level: e.level + 1,
      parentRowNode: e.level >= 0 ? e : void 0,
      rowGroupColumns: ((s = this.rowGroupColsSvc) == null ? void 0 : s.columns) ?? [],
      pivotColumns: ((i = this.pivotColsSvc) == null ? void 0 : i.columns) ?? [],
      pivotMode: this.colModel.isPivotMode()
    };
    return t(n);
  }
}, Mz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmStoreUtils";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.serverSideRowModel = e.rowModel, this.storeFactory = e.ssrmStoreFactory;
  }
  getChildStore(e, t, n) {
    if (!(e != null && e.length))
      return t;
    const o = e[0], s = n(o);
    if (s) {
      if (e.length === 1 && !s.childStore) {
        const a = this.serverSideRowModel.getParams();
        s.childStore = this.createBean(this.storeFactory.createStore(a, s));
      }
      const i = e.slice(1, e.length), r = s.childStore;
      return r ? r.getChildStore(i) : null;
    }
    return null;
  }
  isServerRefreshNeeded(e, t, n) {
    if (n.valueColChanged || n.secondaryColChanged)
      return !0;
    const o = e.level + 1;
    if (!(o < t.length))
      return !0;
    const r = t[o].id;
    return n.changedColumns.indexOf(r) > -1 ? !0 : this.colModel.getCols().filter((c) => c.getColDef().showRowGroup && n.changedColumns.includes(c.getId())).map((c) => c.getColDef().showRowGroup).some((c) => c === !0 || c === r);
  }
  getServerSideInitialRowCount() {
    return this.gos.get("serverSideInitialRowCount");
  }
  isServerSideSortAllLevels() {
    return this.gos.get("serverSideSortAllLevels") && gn(this.gos);
  }
  isServerSideOnlyRefreshFilteredGroups() {
    return this.gos.get("serverSideOnlyRefreshFilteredGroups") && gn(this.gos);
  }
}, Iz = class extends U {
  constructor() {
    super(...arguments), this.beanName = "ssrmTxnManager", this.asyncTransactions = [];
  }
  wireBeans(e) {
    this.valueCache = e.valueCache, this.serverSideRowModel = e.rowModel, this.selectionSvc = e.selectionSvc;
  }
  postConstruct() {
    gn(this.gos);
  }
  applyTransactionAsync(e, t) {
    this.asyncTransactionsTimeout == null && this.scheduleExecuteAsync(), this.asyncTransactions.push({ transaction: e, callback: t });
  }
  scheduleExecuteAsync() {
    const e = this.gos.get("asyncTransactionWaitMillis");
    this.asyncTransactionsTimeout = window.setTimeout(() => {
      this.executeAsyncTransactions();
    }, e);
  }
  executeAsyncTransactions() {
    var s;
    if (!this.asyncTransactions)
      return;
    const e = [], t = [], n = [];
    let o = !1;
    this.asyncTransactions.forEach((i) => {
      let r;
      if (this.serverSideRowModel.executeOnStore(i.transaction.route, (d) => {
        r = d.applyTransaction(i.transaction);
      }) ? r == null && (r = { status: mo.StoreNotFound }) : r = { status: mo.StoreNotStarted }, t.push(r), r.status == mo.StoreLoading) {
        n.push(i);
        return;
      }
      i.callback && e.push(() => i.callback(r)), r.status === mo.Applied && (o = !0);
    }), e.length > 0 && window.setTimeout(() => {
      e.forEach((i) => i());
    }, 0), this.asyncTransactionsTimeout = void 0, this.asyncTransactions = n, o && ((s = this.valueCache) == null || s.onDataChanged(), this.eventSvc.dispatchEvent({ type: "storeUpdated" })), t.length > 0 && this.eventSvc.dispatchEvent({
      type: "asyncTransactionsFlushed",
      results: t
    });
  }
  flushAsyncTransactions() {
    this.asyncTransactionsTimeout != null && clearTimeout(this.asyncTransactionsTimeout), this.executeAsyncTransactions();
  }
  applyTransaction(e) {
    var o;
    let t;
    if (this.serverSideRowModel.executeOnStore(e.route, (s) => {
      t = s.applyTransaction(e);
    }))
      if (t) {
        if ((o = this.valueCache) == null || o.onDataChanged(), t.remove && this.selectionSvc) {
          const s = t.remove.map((i) => i.id);
          this.selectionSvc.deleteSelectionStateFromParent(e.route || [], s);
        }
        return this.eventSvc.dispatchEvent({ type: "storeUpdated" }), t;
      } else
        return { status: mo.StoreNotFound };
    else return { status: mo.StoreNotStarted };
  }
}, Pz = {
  moduleName: "ServerSideRowModel",
  version: gt,
  rowModels: ["serverSide"],
  beans: [
    cz,
    iz,
    Mz,
    sz,
    dz,
    Iz,
    rz,
    Fz,
    az,
    bz,
    xz,
    Sz,
    yz,
    lz
  ],
  dependsOn: [
    an,
    Bp,
    lb,
    Q9,
    iS,
    L9
  ]
}, Dz = {
  moduleName: "ServerSideRowModelApi",
  version: gt,
  apiFunctions: {
    getServerSideSelectionState: uz,
    setServerSideSelectionState: hz,
    applyServerSideTransaction: gz,
    applyServerSideTransactionAsync: fz,
    applyServerSideRowData: pz,
    retryServerSideLoads: mz,
    flushServerSideAsyncTransactions: vz,
    refreshServerSide: Cz,
    getServerSideGroupLevelState: wz,
    resetRowHeights: Kp,
    onRowHeightChanged: Up
  },
  dependsOn: [an, cb, db, ub]
}, Tz = ["number", "category", "grouped-category", "log", "time"];
Tz.reduce(
  (e, t) => ({ ...e, [t]: { title: { _enabledFromTheme: !0 } } }),
  {}
);
function rS(e) {
  return e.map(
    (t, n, o) => t.map((s, i) => o.slice(0, n + 1).reduce((r, a) => r + a[i], 0))
  );
}
function aS(e) {
  const t = e.map((n, o) => e.reduce((s, i) => Math.max(s, i[o]), 0));
  return e.map((n) => n.map((o, s) => o / t[s] * 19));
}
var lS = [
  [1, 3, 5],
  [2, 6, 4],
  [5, 3, 1]
], kz = rS(lS);
aS(kz);
var Lz = lS, Bz = rS(Lz);
aS(Bz);
var Oz = Object.defineProperty, Gz = (e, t, n) => t in e ? Oz(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ar = (e, t, n) => Gz(e, typeof t != "symbol" ? t + "" : t, n);
class Va {
  static getComponentDefinition(t, n) {
    let o;
    return typeof t == "string" ? o = this.searchForComponentInstance(n, t) : o = { extends: de({ ...t }) }, o || $e(114, { component: t }), o.extends ? (o.extends.setup && (o.setup = o.extends.setup), o.extends.props = this.addParamsToProps(o.extends.props)) : o.props = this.addParamsToProps(o.props), o;
  }
  static addParamsToProps(t) {
    return !t || Array.isArray(t) && t.indexOf("params") === -1 ? t = ["params", ...t || []] : typeof t == "object" && !t.params && (t.params = {
      type: Object
    }), t;
  }
  static createAndMountComponent(t, n, o, s) {
    const i = Va.getComponentDefinition(t, o);
    if (!i)
      return;
    const { vNode: r, destroy: a, el: l } = this.mount(
      i,
      { params: Object.freeze(n) },
      o,
      s || {}
    );
    return {
      componentInstance: r.component.proxy,
      element: l,
      destroy: a
    };
  }
  static mount(t, n, o, s) {
    let i = te(t, n);
    i.appContext = { ...o.appContext, provides: s };
    let r = document.createDocumentFragment();
    return dr(i, r), { vNode: i, destroy: () => {
      r && dr(null, r), r = null, i = null;
    }, el: r };
  }
  static searchForComponentInstance(t, n, o = 10, s = !1) {
    let i = null, r = 0, a = t.parent;
    for (; !i && a && a.components && ++r < o; )
      a.components && a.components[n] && (i = a.components[n]), a = a.parent;
    for (r = 0, a = t.parent; !i && a && a.$options && ++r < o; ) {
      const l = a;
      l.$options && l.$options.components && l.$options.components[n] ? i = l.$options.components[n] : l[n] && (i = l[n]), a = a.parent;
    }
    for (r = 0, a = t.parent; !i && a && ++r < o; ) {
      if (a.exposed) {
        const l = a;
        l.exposed && l.exposed[n] ? i = l.exposed[n] : l[n] && (i = l[n]);
      }
      a = a.parent;
    }
    if (!i) {
      const l = t.appContext.components;
      l && l[n] && (i = l[n]);
    }
    return !i && !s ? ($e(114, { component: n }), null) : i;
  }
}
class Hz extends $5 {
  constructor(t, n) {
    super(), ar(this, "parent"), ar(this, "provides"), this.parent = t, this.provides = n;
  }
  createWrapper(t) {
    const n = this;
    class o extends Vz {
      init(r) {
        super.init(r);
      }
      hasMethod(r) {
        var a, l;
        const d = s.getFrameworkComponentInstance();
        return d[r] ? !0 : ((a = d.$.exposed) == null ? void 0 : a[r]) != null || ((l = d.exposed) == null ? void 0 : l[r]) != null || d.$.setupState[r] != null;
      }
      callMethod(r, a) {
        var l, d;
        const c = this.getFrameworkComponentInstance(), u = s.getFrameworkComponentInstance();
        if (u[r])
          return u[r].apply(c, a);
        {
          const h = ((l = c.$.exposed) == null ? void 0 : l[r]) || ((d = c.exposed) == null ? void 0 : d[r]) || c.$.setupState[r];
          return h == null ? void 0 : h.apply(c, a);
        }
      }
      addMethod(r, a) {
        s[r] = a;
      }
      processMethod(r, a) {
        return r === "refresh" && (this.getFrameworkComponentInstance().params = a[0]), this.hasMethod(r) ? this.callMethod(r, a) : r === "refresh";
      }
      createComponent(r) {
        return n.createComponent(t, r);
      }
    }
    const s = new o();
    return s;
  }
  createComponent(t, n) {
    return Va.createAndMountComponent(t, n, this.parent, this.provides);
  }
  createMethodProxy(t, n, o) {
    return function() {
      return t.hasMethod(n) ? t.callMethod(n, arguments) : (o && Z(233, { methodName: n }), null);
    };
  }
  destroy() {
    this.parent = null;
  }
}
class Vz {
  constructor() {
    ar(this, "componentInstance"), ar(this, "element"), ar(this, "unmount");
  }
  getGui() {
    return this.element;
  }
  destroy() {
    this.getFrameworkComponentInstance() && typeof this.getFrameworkComponentInstance().destroy == "function" && this.getFrameworkComponentInstance().destroy(), this.unmount();
  }
  getFrameworkComponentInstance() {
    return this.componentInstance;
  }
  init(t) {
    const { componentInstance: n, element: o, destroy: s } = this.createComponent(t);
    this.componentInstance = n, this.unmount = s, this.element = o.firstElementChild ?? o;
  }
}
class _z extends ty {
  constructor(t) {
    super("vue"), ar(this, "parent"), this.parent = t;
  }
  /*
   * vue components are specified in the "components" part of the vue component - as such we need a way to determine
   * if a given component is within that context - this method provides this
   * Note: This is only really used/necessary with cellRendererSelectors
   */
  frameworkComponent(t, n) {
    let o = Va.searchForComponentInstance(this.parent, t, 10, !0) ? t : null;
    if (!o && n && n[t]) {
      const s = n[t];
      o = Va.searchForComponentInstance(this.parent, s, 10, !0) ? s : null;
    }
    return o;
  }
  isFrameworkComponent(t) {
    return typeof t == "object";
  }
}
function Nz() {
  return {
    gridOptions: {},
    modules: [],
    // @START_DEFAULTS@
    statusBar: void 0,
    sideBar: void 0,
    suppressContextMenu: void 0,
    preventDefaultOnContextMenu: void 0,
    allowContextMenuWithControlKey: void 0,
    columnMenu: void 0,
    suppressMenuHide: void 0,
    enableBrowserTooltips: void 0,
    tooltipTrigger: void 0,
    tooltipShowDelay: void 0,
    tooltipHideDelay: void 0,
    tooltipMouseTrack: void 0,
    tooltipShowMode: void 0,
    tooltipInteraction: void 0,
    popupParent: void 0,
    copyHeadersToClipboard: void 0,
    copyGroupHeadersToClipboard: void 0,
    clipboardDelimiter: void 0,
    suppressCopyRowsToClipboard: void 0,
    suppressCopySingleCellRanges: void 0,
    suppressLastEmptyLineOnPaste: void 0,
    suppressClipboardPaste: void 0,
    suppressClipboardApi: void 0,
    suppressCutToClipboard: void 0,
    columnDefs: void 0,
    defaultColDef: void 0,
    defaultColGroupDef: void 0,
    columnTypes: void 0,
    dataTypeDefinitions: void 0,
    maintainColumnOrder: void 0,
    enableStrictPivotColumnOrder: void 0,
    suppressFieldDotNotation: void 0,
    headerHeight: void 0,
    groupHeaderHeight: void 0,
    floatingFiltersHeight: void 0,
    pivotHeaderHeight: void 0,
    pivotGroupHeaderHeight: void 0,
    hidePaddedHeaderRows: void 0,
    allowDragFromColumnsToolPanel: void 0,
    suppressMovableColumns: void 0,
    suppressColumnMoveAnimation: void 0,
    suppressMoveWhenColumnDragging: void 0,
    suppressDragLeaveHidesColumns: void 0,
    suppressGroupChangesColumnVisibility: void 0,
    suppressMakeColumnVisibleAfterUnGroup: void 0,
    suppressRowGroupHidesColumns: void 0,
    colResizeDefault: void 0,
    suppressAutoSize: void 0,
    autoSizePadding: void 0,
    skipHeaderOnAutoSize: void 0,
    autoSizeStrategy: void 0,
    components: void 0,
    editType: void 0,
    suppressStartEditOnTab: void 0,
    getFullRowEditValidationErrors: void 0,
    invalidEditValueMode: void 0,
    singleClickEdit: void 0,
    suppressClickEdit: void 0,
    readOnlyEdit: void 0,
    stopEditingWhenCellsLoseFocus: void 0,
    enterNavigatesVertically: void 0,
    enterNavigatesVerticallyAfterEdit: void 0,
    enableCellEditingOnBackspace: void 0,
    undoRedoCellEditing: void 0,
    undoRedoCellEditingLimit: void 0,
    defaultCsvExportParams: void 0,
    suppressCsvExport: void 0,
    defaultExcelExportParams: void 0,
    suppressExcelExport: void 0,
    excelStyles: void 0,
    findSearchValue: void 0,
    findOptions: void 0,
    quickFilterText: void 0,
    cacheQuickFilter: void 0,
    includeHiddenColumnsInQuickFilter: void 0,
    quickFilterParser: void 0,
    quickFilterMatcher: void 0,
    applyQuickFilterBeforePivotOrAgg: void 0,
    excludeChildrenWhenTreeDataFiltering: void 0,
    enableAdvancedFilter: void 0,
    alwaysPassFilter: void 0,
    includeHiddenColumnsInAdvancedFilter: void 0,
    advancedFilterParent: void 0,
    advancedFilterBuilderParams: void 0,
    advancedFilterParams: void 0,
    suppressAdvancedFilterEval: void 0,
    suppressSetFilterByDefault: void 0,
    enableFilterHandlers: void 0,
    filterHandlers: void 0,
    enableCharts: void 0,
    chartThemes: void 0,
    customChartThemes: void 0,
    chartThemeOverrides: void 0,
    chartToolPanelsDef: void 0,
    chartMenuItems: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    localeText: void 0,
    masterDetail: void 0,
    keepDetailRows: void 0,
    keepDetailRowsCount: void 0,
    detailCellRenderer: void 0,
    detailCellRendererParams: void 0,
    detailRowHeight: void 0,
    detailRowAutoHeight: void 0,
    context: void 0,
    alignedGrids: void 0,
    tabIndex: void 0,
    rowBuffer: void 0,
    valueCache: void 0,
    valueCacheNeverExpires: void 0,
    enableCellExpressions: void 0,
    suppressTouch: void 0,
    suppressFocusAfterRefresh: void 0,
    suppressBrowserResizeObserver: void 0,
    suppressPropertyNamesCheck: void 0,
    suppressChangeDetection: void 0,
    debug: void 0,
    loading: void 0,
    overlayLoadingTemplate: void 0,
    loadingOverlayComponent: void 0,
    loadingOverlayComponentParams: void 0,
    suppressLoadingOverlay: void 0,
    overlayNoRowsTemplate: void 0,
    noRowsOverlayComponent: void 0,
    noRowsOverlayComponentParams: void 0,
    suppressNoRowsOverlay: void 0,
    pagination: void 0,
    paginationPageSize: void 0,
    paginationPageSizeSelector: void 0,
    paginationAutoPageSize: void 0,
    paginateChildRows: void 0,
    suppressPaginationPanel: void 0,
    pivotMode: void 0,
    pivotPanelShow: void 0,
    pivotMaxGeneratedColumns: void 0,
    pivotDefaultExpanded: void 0,
    pivotColumnGroupTotals: void 0,
    pivotRowTotals: void 0,
    pivotSuppressAutoColumn: void 0,
    suppressExpandablePivotGroups: void 0,
    functionsReadOnly: void 0,
    aggFuncs: void 0,
    suppressAggFuncInHeader: void 0,
    alwaysAggregateAtRootLevel: void 0,
    aggregateOnlyChangedColumns: void 0,
    suppressAggFilteredOnly: void 0,
    removePivotHeaderRowWhenSingleValueColumn: void 0,
    animateRows: void 0,
    cellFlashDuration: void 0,
    cellFadeDuration: void 0,
    allowShowChangeAfterFilter: void 0,
    domLayout: void 0,
    ensureDomOrder: void 0,
    enableCellSpan: void 0,
    enableRtl: void 0,
    suppressColumnVirtualisation: void 0,
    suppressMaxRenderedRowRestriction: void 0,
    suppressRowVirtualisation: void 0,
    rowDragManaged: void 0,
    rowDragInsertDelay: void 0,
    suppressRowDrag: void 0,
    suppressMoveWhenRowDragging: void 0,
    rowDragEntireRow: void 0,
    rowDragMultiRow: void 0,
    rowDragText: void 0,
    dragAndDropImageComponent: void 0,
    dragAndDropImageComponentParams: void 0,
    fullWidthCellRenderer: void 0,
    fullWidthCellRendererParams: void 0,
    embedFullWidthRows: void 0,
    groupDisplayType: void 0,
    groupDefaultExpanded: void 0,
    autoGroupColumnDef: void 0,
    groupMaintainOrder: void 0,
    groupSelectsChildren: void 0,
    groupLockGroupColumns: void 0,
    groupAggFiltering: void 0,
    groupTotalRow: void 0,
    grandTotalRow: void 0,
    suppressStickyTotalRow: void 0,
    groupSuppressBlankHeader: void 0,
    groupSelectsFiltered: void 0,
    showOpenedGroup: void 0,
    groupHideParentOfSingleChild: void 0,
    groupRemoveSingleChildren: void 0,
    groupRemoveLowestSingleChildren: void 0,
    groupHideOpenParents: void 0,
    groupAllowUnbalanced: void 0,
    rowGroupPanelShow: void 0,
    groupRowRenderer: void 0,
    groupRowRendererParams: void 0,
    treeData: void 0,
    treeDataChildrenField: void 0,
    treeDataParentIdField: void 0,
    rowGroupPanelSuppressSort: void 0,
    suppressGroupRowsSticky: void 0,
    groupHierarchyConfig: void 0,
    pinnedTopRowData: void 0,
    pinnedBottomRowData: void 0,
    enableRowPinning: void 0,
    isRowPinnable: void 0,
    isRowPinned: void 0,
    rowModelType: void 0,
    rowData: void 0,
    asyncTransactionWaitMillis: void 0,
    suppressModelUpdateAfterUpdateTransaction: void 0,
    datasource: void 0,
    cacheOverflowSize: void 0,
    infiniteInitialRowCount: void 0,
    serverSideInitialRowCount: void 0,
    suppressServerSideFullWidthLoadingRow: void 0,
    cacheBlockSize: void 0,
    maxBlocksInCache: void 0,
    maxConcurrentDatasourceRequests: void 0,
    blockLoadDebounceMillis: void 0,
    purgeClosedRowNodes: void 0,
    serverSideDatasource: void 0,
    serverSideSortAllLevels: void 0,
    serverSideEnableClientSideSort: void 0,
    serverSideOnlyRefreshFilteredGroups: void 0,
    serverSidePivotResultFieldSeparator: void 0,
    viewportDatasource: void 0,
    viewportRowModelPageSize: void 0,
    viewportRowModelBufferSize: void 0,
    alwaysShowHorizontalScroll: void 0,
    alwaysShowVerticalScroll: void 0,
    debounceVerticalScrollbar: void 0,
    suppressHorizontalScroll: void 0,
    suppressScrollOnNewData: void 0,
    suppressScrollWhenPopupsAreOpen: void 0,
    suppressAnimationFrame: void 0,
    suppressMiddleClickScrolls: void 0,
    suppressPreventDefaultOnMouseWheel: void 0,
    scrollbarWidth: void 0,
    rowSelection: void 0,
    cellSelection: void 0,
    rowMultiSelectWithClick: void 0,
    suppressRowDeselection: void 0,
    suppressRowClickSelection: void 0,
    suppressCellFocus: void 0,
    suppressHeaderFocus: void 0,
    selectionColumnDef: void 0,
    rowNumbers: void 0,
    suppressMultiRangeSelection: void 0,
    enableCellTextSelection: void 0,
    enableRangeSelection: void 0,
    enableRangeHandle: void 0,
    enableFillHandle: void 0,
    fillHandleDirection: void 0,
    suppressClearOnFillReduction: void 0,
    sortingOrder: void 0,
    accentedSort: void 0,
    unSortIcon: void 0,
    suppressMultiSort: void 0,
    alwaysMultiSort: void 0,
    multiSortKey: void 0,
    suppressMaintainUnsortedOrder: void 0,
    icons: void 0,
    rowHeight: void 0,
    rowStyle: void 0,
    rowClass: void 0,
    rowClassRules: void 0,
    suppressRowHoverHighlight: void 0,
    suppressRowTransform: void 0,
    columnHoverHighlight: void 0,
    gridId: void 0,
    deltaSort: void 0,
    treeDataDisplayType: void 0,
    enableGroupEdit: void 0,
    initialState: void 0,
    theme: void 0,
    loadThemeGoogleFonts: void 0,
    themeCssLayer: void 0,
    styleNonce: void 0,
    themeStyleContainer: void 0,
    getContextMenuItems: void 0,
    getMainMenuItems: void 0,
    postProcessPopup: void 0,
    processUnpinnedColumns: void 0,
    processCellForClipboard: void 0,
    processHeaderForClipboard: void 0,
    processGroupHeaderForClipboard: void 0,
    processCellFromClipboard: void 0,
    sendToClipboard: void 0,
    processDataFromClipboard: void 0,
    isExternalFilterPresent: void 0,
    doesExternalFilterPass: void 0,
    getChartToolbarItems: void 0,
    createChartContainer: void 0,
    focusGridInnerElement: void 0,
    navigateToNextHeader: void 0,
    tabToNextHeader: void 0,
    navigateToNextCell: void 0,
    tabToNextCell: void 0,
    getLocaleText: void 0,
    getDocument: void 0,
    paginationNumberFormatter: void 0,
    getGroupRowAgg: void 0,
    isGroupOpenByDefault: void 0,
    ssrmExpandAllAffectsAllRows: void 0,
    initialGroupOrderComparator: void 0,
    processPivotResultColDef: void 0,
    processPivotResultColGroupDef: void 0,
    getDataPath: void 0,
    getChildCount: void 0,
    getServerSideGroupLevelParams: void 0,
    isServerSideGroupOpenByDefault: void 0,
    isApplyServerSideTransaction: void 0,
    isServerSideGroup: void 0,
    getServerSideGroupKey: void 0,
    getBusinessKeyForNode: void 0,
    getRowId: void 0,
    resetRowDataOnUpdate: void 0,
    processRowPostCreate: void 0,
    isRowSelectable: void 0,
    isRowMaster: void 0,
    fillOperation: void 0,
    postSortRows: void 0,
    getRowStyle: void 0,
    getRowClass: void 0,
    getRowHeight: void 0,
    isFullWidthRow: void 0,
    isRowValidDropPosition: void 0,
    // @END_DEFAULTS@
    // @START_EVENT_PROPS@
    "onColumn-everything-changed": void 0,
    "onNew-columns-loaded": void 0,
    "onColumn-pivot-mode-changed": void 0,
    "onPivot-max-columns-exceeded": void 0,
    "onColumn-row-group-changed": void 0,
    "onExpand-or-collapse-all": void 0,
    "onColumn-pivot-changed": void 0,
    "onGrid-columns-changed": void 0,
    "onColumn-value-changed": void 0,
    "onColumn-moved": void 0,
    "onColumn-visible": void 0,
    "onColumn-pinned": void 0,
    "onColumn-group-opened": void 0,
    "onColumn-resized": void 0,
    "onDisplayed-columns-changed": void 0,
    "onVirtual-columns-changed": void 0,
    "onColumn-header-mouse-over": void 0,
    "onColumn-header-mouse-leave": void 0,
    "onColumn-header-clicked": void 0,
    "onColumn-header-context-menu": void 0,
    "onAsync-transactions-flushed": void 0,
    "onRow-group-opened": void 0,
    "onRow-data-updated": void 0,
    "onPinned-row-data-changed": void 0,
    "onPinned-rows-changed": void 0,
    "onRange-selection-changed": void 0,
    "onCell-selection-changed": void 0,
    "onChart-created": void 0,
    "onChart-range-selection-changed": void 0,
    "onChart-options-changed": void 0,
    "onChart-destroyed": void 0,
    "onTool-panel-visible-changed": void 0,
    "onTool-panel-size-changed": void 0,
    "onModel-updated": void 0,
    "onCut-start": void 0,
    "onCut-end": void 0,
    "onPaste-start": void 0,
    "onPaste-end": void 0,
    "onFill-start": void 0,
    "onFill-end": void 0,
    "onCell-selection-delete-start": void 0,
    "onCell-selection-delete-end": void 0,
    "onRange-delete-start": void 0,
    "onRange-delete-end": void 0,
    "onUndo-started": void 0,
    "onUndo-ended": void 0,
    "onRedo-started": void 0,
    "onRedo-ended": void 0,
    "onCell-clicked": void 0,
    "onCell-double-clicked": void 0,
    "onCell-mouse-down": void 0,
    "onCell-context-menu": void 0,
    "onCell-value-changed": void 0,
    "onCell-edit-request": void 0,
    "onRow-value-changed": void 0,
    "onHeader-focused": void 0,
    "onCell-focused": void 0,
    "onRow-selected": void 0,
    "onSelection-changed": void 0,
    "onTooltip-show": void 0,
    "onTooltip-hide": void 0,
    "onCell-key-down": void 0,
    "onCell-mouse-over": void 0,
    "onCell-mouse-out": void 0,
    "onFilter-changed": void 0,
    "onFilter-modified": void 0,
    "onFilter-ui-changed": void 0,
    "onFilter-opened": void 0,
    "onFloating-filter-ui-changed": void 0,
    "onAdvanced-filter-builder-visible-changed": void 0,
    "onSort-changed": void 0,
    "onVirtual-row-removed": void 0,
    "onRow-clicked": void 0,
    "onRow-double-clicked": void 0,
    "onGrid-ready": void 0,
    "onGrid-pre-destroyed": void 0,
    "onGrid-size-changed": void 0,
    "onViewport-changed": void 0,
    "onFirst-data-rendered": void 0,
    "onDrag-started": void 0,
    "onDrag-stopped": void 0,
    "onDrag-cancelled": void 0,
    "onRow-editing-started": void 0,
    "onRow-editing-stopped": void 0,
    "onCell-editing-started": void 0,
    "onCell-editing-stopped": void 0,
    "onBody-scroll": void 0,
    "onBody-scroll-end": void 0,
    "onPagination-changed": void 0,
    "onComponent-state-changed": void 0,
    "onStore-refreshed": void 0,
    "onState-updated": void 0,
    "onColumn-menu-visible-changed": void 0,
    "onContext-menu-visible-changed": void 0,
    "onRow-drag-enter": void 0,
    "onRow-drag-move": void 0,
    "onRow-drag-leave": void 0,
    "onRow-drag-end": void 0,
    "onRow-drag-cancel": void 0,
    "onFind-changed": void 0,
    "onRow-resize-started": void 0,
    "onRow-resize-ended": void 0,
    "onColumns-reset": void 0,
    "onBulk-editing-started": void 0,
    "onBulk-editing-stopped": void 0,
    "onBatch-editing-started": void 0,
    "onBatch-editing-stopped": void 0
    // @END_EVENT_PROPS@
  };
}
const $z = (e, t) => {
  let n;
  return () => {
    const o = function() {
      e();
    };
    window.clearTimeout(n), n = window.setTimeout(o, t);
  };
};
function zz(e) {
  return e && e.constructor && e.constructor.toString().substring(0, 5) === "class";
}
function jr(e) {
  const t = (n) => zz(n) ? Ff(n) : Array.isArray(n) ? n.map((o) => t(o)) : Yo(n) || U2(n) || K2(n) ? t(Ff(n)) : n;
  return t(e);
}
const Wz = { ref: "root" }, Uz = /* @__PURE__ */ de({
  __name: "AgGridVue",
  props: /* @__PURE__ */ dt(/* @__PURE__ */ W2({
    gridOptions: {},
    modules: {},
    statusBar: {},
    sideBar: { type: [Object, String, Array, Boolean, null] },
    suppressContextMenu: { type: Boolean },
    preventDefaultOnContextMenu: { type: Boolean },
    allowContextMenuWithControlKey: { type: Boolean },
    columnMenu: {},
    suppressMenuHide: { type: Boolean },
    enableBrowserTooltips: { type: Boolean },
    tooltipTrigger: {},
    tooltipShowDelay: {},
    tooltipHideDelay: {},
    tooltipMouseTrack: { type: Boolean },
    tooltipShowMode: {},
    tooltipInteraction: { type: Boolean },
    popupParent: {},
    copyHeadersToClipboard: { type: Boolean },
    copyGroupHeadersToClipboard: { type: Boolean },
    clipboardDelimiter: {},
    suppressCopyRowsToClipboard: { type: Boolean },
    suppressCopySingleCellRanges: { type: Boolean },
    suppressLastEmptyLineOnPaste: { type: Boolean },
    suppressClipboardPaste: { type: Boolean },
    suppressClipboardApi: { type: Boolean },
    suppressCutToClipboard: { type: Boolean },
    columnDefs: {},
    defaultColDef: {},
    defaultColGroupDef: {},
    columnTypes: {},
    dataTypeDefinitions: {},
    maintainColumnOrder: { type: Boolean },
    enableStrictPivotColumnOrder: { type: Boolean },
    suppressFieldDotNotation: { type: Boolean },
    headerHeight: {},
    groupHeaderHeight: {},
    floatingFiltersHeight: {},
    pivotHeaderHeight: {},
    pivotGroupHeaderHeight: {},
    hidePaddedHeaderRows: { type: Boolean },
    allowDragFromColumnsToolPanel: { type: Boolean },
    suppressMovableColumns: { type: Boolean },
    suppressColumnMoveAnimation: { type: Boolean },
    suppressMoveWhenColumnDragging: { type: Boolean },
    suppressDragLeaveHidesColumns: { type: Boolean },
    suppressGroupChangesColumnVisibility: { type: [Boolean, String] },
    suppressMakeColumnVisibleAfterUnGroup: { type: Boolean },
    suppressRowGroupHidesColumns: { type: Boolean },
    colResizeDefault: {},
    suppressAutoSize: { type: Boolean },
    autoSizePadding: {},
    skipHeaderOnAutoSize: { type: Boolean },
    autoSizeStrategy: {},
    components: {},
    editType: {},
    suppressStartEditOnTab: { type: Boolean },
    getFullRowEditValidationErrors: { type: Function },
    invalidEditValueMode: {},
    singleClickEdit: { type: Boolean },
    suppressClickEdit: { type: Boolean },
    readOnlyEdit: { type: Boolean },
    stopEditingWhenCellsLoseFocus: { type: Boolean },
    enterNavigatesVertically: { type: Boolean },
    enterNavigatesVerticallyAfterEdit: { type: Boolean },
    enableCellEditingOnBackspace: { type: Boolean },
    undoRedoCellEditing: { type: Boolean },
    undoRedoCellEditingLimit: {},
    defaultCsvExportParams: {},
    suppressCsvExport: { type: Boolean },
    defaultExcelExportParams: {},
    suppressExcelExport: { type: Boolean },
    excelStyles: {},
    findSearchValue: {},
    findOptions: {},
    quickFilterText: {},
    cacheQuickFilter: { type: Boolean },
    includeHiddenColumnsInQuickFilter: { type: Boolean },
    quickFilterParser: { type: Function },
    quickFilterMatcher: { type: Function },
    applyQuickFilterBeforePivotOrAgg: { type: Boolean },
    excludeChildrenWhenTreeDataFiltering: { type: Boolean },
    enableAdvancedFilter: { type: Boolean },
    alwaysPassFilter: { type: Function },
    includeHiddenColumnsInAdvancedFilter: { type: Boolean },
    advancedFilterParent: {},
    advancedFilterBuilderParams: {},
    advancedFilterParams: {},
    suppressAdvancedFilterEval: { type: Boolean },
    suppressSetFilterByDefault: { type: Boolean },
    enableFilterHandlers: { type: Boolean },
    filterHandlers: {},
    enableCharts: { type: Boolean },
    chartThemes: {},
    customChartThemes: {},
    chartThemeOverrides: {},
    chartToolPanelsDef: {},
    chartMenuItems: { type: [Array, Function] },
    loadingCellRenderer: {},
    loadingCellRendererParams: {},
    loadingCellRendererSelector: { type: Function },
    localeText: {},
    masterDetail: { type: Boolean },
    keepDetailRows: { type: Boolean },
    keepDetailRowsCount: {},
    detailCellRenderer: {},
    detailCellRendererParams: {},
    detailRowHeight: {},
    detailRowAutoHeight: { type: Boolean },
    context: {},
    alignedGrids: { type: [Array, Function] },
    tabIndex: {},
    rowBuffer: {},
    valueCache: { type: Boolean },
    valueCacheNeverExpires: { type: Boolean },
    enableCellExpressions: { type: Boolean },
    suppressTouch: { type: Boolean },
    suppressFocusAfterRefresh: { type: Boolean },
    suppressBrowserResizeObserver: { type: Boolean },
    suppressPropertyNamesCheck: { type: Boolean },
    suppressChangeDetection: { type: Boolean },
    debug: { type: Boolean },
    loading: { type: Boolean },
    overlayLoadingTemplate: {},
    loadingOverlayComponent: {},
    loadingOverlayComponentParams: {},
    suppressLoadingOverlay: { type: Boolean },
    overlayNoRowsTemplate: {},
    noRowsOverlayComponent: {},
    noRowsOverlayComponentParams: {},
    suppressNoRowsOverlay: { type: Boolean },
    pagination: { type: Boolean },
    paginationPageSize: {},
    paginationPageSizeSelector: { type: [Array, Boolean] },
    paginationAutoPageSize: { type: Boolean },
    paginateChildRows: { type: Boolean },
    suppressPaginationPanel: { type: Boolean },
    pivotMode: { type: Boolean },
    pivotPanelShow: {},
    pivotMaxGeneratedColumns: {},
    pivotDefaultExpanded: {},
    pivotColumnGroupTotals: {},
    pivotRowTotals: {},
    pivotSuppressAutoColumn: { type: Boolean },
    suppressExpandablePivotGroups: { type: Boolean },
    functionsReadOnly: { type: Boolean },
    aggFuncs: {},
    suppressAggFuncInHeader: { type: Boolean },
    alwaysAggregateAtRootLevel: { type: Boolean },
    aggregateOnlyChangedColumns: { type: Boolean },
    suppressAggFilteredOnly: { type: Boolean },
    removePivotHeaderRowWhenSingleValueColumn: { type: Boolean },
    animateRows: { type: Boolean },
    cellFlashDuration: {},
    cellFadeDuration: {},
    allowShowChangeAfterFilter: { type: Boolean },
    domLayout: {},
    ensureDomOrder: { type: Boolean },
    enableCellSpan: { type: Boolean },
    enableRtl: { type: Boolean },
    suppressColumnVirtualisation: { type: Boolean },
    suppressMaxRenderedRowRestriction: { type: Boolean },
    suppressRowVirtualisation: { type: Boolean },
    rowDragManaged: { type: Boolean },
    rowDragInsertDelay: {},
    suppressRowDrag: { type: Boolean },
    suppressMoveWhenRowDragging: { type: Boolean },
    rowDragEntireRow: { type: Boolean },
    rowDragMultiRow: { type: Boolean },
    rowDragText: { type: Function },
    dragAndDropImageComponent: {},
    dragAndDropImageComponentParams: {},
    fullWidthCellRenderer: {},
    fullWidthCellRendererParams: {},
    embedFullWidthRows: { type: Boolean },
    groupDisplayType: {},
    groupDefaultExpanded: {},
    autoGroupColumnDef: {},
    groupMaintainOrder: { type: Boolean },
    groupSelectsChildren: { type: Boolean },
    groupLockGroupColumns: {},
    groupAggFiltering: { type: [Boolean, Function] },
    groupTotalRow: { type: [String, Function] },
    grandTotalRow: {},
    suppressStickyTotalRow: { type: [Boolean, String] },
    groupSuppressBlankHeader: { type: Boolean },
    groupSelectsFiltered: { type: Boolean },
    showOpenedGroup: { type: Boolean },
    groupHideParentOfSingleChild: { type: [Boolean, String] },
    groupRemoveSingleChildren: { type: Boolean },
    groupRemoveLowestSingleChildren: { type: Boolean },
    groupHideOpenParents: { type: Boolean },
    groupAllowUnbalanced: { type: Boolean },
    rowGroupPanelShow: {},
    groupRowRenderer: {},
    groupRowRendererParams: {},
    treeData: { type: Boolean },
    treeDataChildrenField: {},
    treeDataParentIdField: {},
    rowGroupPanelSuppressSort: { type: Boolean },
    suppressGroupRowsSticky: { type: Boolean },
    groupHierarchyConfig: {},
    pinnedTopRowData: {},
    pinnedBottomRowData: {},
    enableRowPinning: { type: [Boolean, String] },
    isRowPinnable: { type: Function },
    isRowPinned: { type: Function },
    rowModelType: {},
    rowData: {},
    asyncTransactionWaitMillis: {},
    suppressModelUpdateAfterUpdateTransaction: { type: Boolean },
    datasource: {},
    cacheOverflowSize: {},
    infiniteInitialRowCount: {},
    serverSideInitialRowCount: {},
    suppressServerSideFullWidthLoadingRow: { type: Boolean },
    cacheBlockSize: {},
    maxBlocksInCache: {},
    maxConcurrentDatasourceRequests: {},
    blockLoadDebounceMillis: {},
    purgeClosedRowNodes: { type: Boolean },
    serverSideDatasource: {},
    serverSideSortAllLevels: { type: Boolean },
    serverSideEnableClientSideSort: { type: Boolean },
    serverSideOnlyRefreshFilteredGroups: { type: Boolean },
    serverSidePivotResultFieldSeparator: {},
    viewportDatasource: {},
    viewportRowModelPageSize: {},
    viewportRowModelBufferSize: {},
    alwaysShowHorizontalScroll: { type: Boolean },
    alwaysShowVerticalScroll: { type: Boolean },
    debounceVerticalScrollbar: { type: Boolean },
    suppressHorizontalScroll: { type: Boolean },
    suppressScrollOnNewData: { type: Boolean },
    suppressScrollWhenPopupsAreOpen: { type: Boolean },
    suppressAnimationFrame: { type: Boolean },
    suppressMiddleClickScrolls: { type: Boolean },
    suppressPreventDefaultOnMouseWheel: { type: Boolean },
    scrollbarWidth: {},
    rowSelection: {},
    cellSelection: { type: [Boolean, Object] },
    rowMultiSelectWithClick: { type: Boolean },
    suppressRowDeselection: { type: Boolean },
    suppressRowClickSelection: { type: Boolean },
    suppressCellFocus: { type: Boolean },
    suppressHeaderFocus: { type: Boolean },
    selectionColumnDef: {},
    rowNumbers: { type: [Boolean, Object] },
    suppressMultiRangeSelection: { type: Boolean },
    enableCellTextSelection: { type: Boolean },
    enableRangeSelection: { type: Boolean },
    enableRangeHandle: { type: Boolean },
    enableFillHandle: { type: Boolean },
    fillHandleDirection: {},
    suppressClearOnFillReduction: { type: Boolean },
    sortingOrder: {},
    accentedSort: { type: Boolean },
    unSortIcon: { type: Boolean },
    suppressMultiSort: { type: Boolean },
    alwaysMultiSort: { type: Boolean },
    multiSortKey: {},
    suppressMaintainUnsortedOrder: { type: Boolean },
    icons: {},
    rowHeight: {},
    rowStyle: {},
    rowClass: {},
    rowClassRules: {},
    suppressRowHoverHighlight: { type: Boolean },
    suppressRowTransform: { type: Boolean },
    columnHoverHighlight: { type: Boolean },
    gridId: {},
    deltaSort: { type: Boolean },
    treeDataDisplayType: {},
    enableGroupEdit: { type: Boolean },
    initialState: {},
    theme: {},
    loadThemeGoogleFonts: { type: Boolean },
    themeCssLayer: {},
    styleNonce: {},
    themeStyleContainer: {},
    getContextMenuItems: { type: Function },
    getMainMenuItems: { type: Function },
    postProcessPopup: { type: Function },
    processUnpinnedColumns: { type: Function },
    processCellForClipboard: { type: Function },
    processHeaderForClipboard: { type: Function },
    processGroupHeaderForClipboard: { type: Function },
    processCellFromClipboard: { type: Function },
    sendToClipboard: { type: Function },
    processDataFromClipboard: { type: Function },
    isExternalFilterPresent: { type: Function },
    doesExternalFilterPass: { type: Function },
    getChartToolbarItems: { type: Function },
    createChartContainer: { type: Function },
    focusGridInnerElement: { type: Function },
    navigateToNextHeader: { type: Function },
    tabToNextHeader: { type: Function },
    navigateToNextCell: { type: Function },
    tabToNextCell: { type: Function },
    getLocaleText: { type: Function },
    getDocument: { type: Function },
    paginationNumberFormatter: { type: Function },
    getGroupRowAgg: { type: Function },
    isGroupOpenByDefault: { type: Function },
    ssrmExpandAllAffectsAllRows: { type: Boolean },
    initialGroupOrderComparator: { type: Function },
    processPivotResultColDef: { type: Function },
    processPivotResultColGroupDef: { type: Function },
    getDataPath: { type: Function },
    getChildCount: { type: Function },
    getServerSideGroupLevelParams: { type: Function },
    isServerSideGroupOpenByDefault: { type: Function },
    isApplyServerSideTransaction: { type: Function },
    isServerSideGroup: { type: Function },
    getServerSideGroupKey: { type: Function },
    getBusinessKeyForNode: { type: Function },
    getRowId: { type: Function },
    resetRowDataOnUpdate: { type: Boolean },
    processRowPostCreate: { type: Function },
    isRowSelectable: { type: Function },
    isRowMaster: { type: Function },
    fillOperation: { type: Function },
    postSortRows: { type: Function },
    getRowStyle: { type: Function },
    getRowClass: { type: Function },
    getRowHeight: { type: Function },
    isFullWidthRow: { type: Function },
    isRowValidDropPosition: { type: Function },
    "onTool-panel-visible-changed": {},
    "onTool-panel-size-changed": {},
    "onColumn-menu-visible-changed": {},
    "onContext-menu-visible-changed": {},
    "onCut-start": {},
    "onCut-end": {},
    "onPaste-start": {},
    "onPaste-end": {},
    "onColumn-visible": {},
    "onColumn-pinned": {},
    "onColumn-resized": {},
    "onColumn-moved": {},
    "onColumn-value-changed": {},
    "onColumn-pivot-mode-changed": {},
    "onColumn-pivot-changed": {},
    "onColumn-group-opened": {},
    "onNew-columns-loaded": {},
    "onGrid-columns-changed": {},
    "onDisplayed-columns-changed": {},
    "onVirtual-columns-changed": {},
    "onColumn-everything-changed": {},
    "onColumns-reset": {},
    "onColumn-header-mouse-over": {},
    "onColumn-header-mouse-leave": {},
    "onColumn-header-clicked": {},
    "onColumn-header-context-menu": {},
    "onComponent-state-changed": {},
    "onCell-value-changed": {},
    "onCell-edit-request": {},
    "onRow-value-changed": {},
    "onCell-editing-started": {},
    "onCell-editing-stopped": {},
    "onRow-editing-started": {},
    "onRow-editing-stopped": {},
    "onBulk-editing-started": {},
    "onBulk-editing-stopped": {},
    "onBatch-editing-started": {},
    "onBatch-editing-stopped": {},
    "onUndo-started": {},
    "onUndo-ended": {},
    "onRedo-started": {},
    "onRedo-ended": {},
    "onCell-selection-delete-start": {},
    "onCell-selection-delete-end": {},
    "onRange-delete-start": {},
    "onRange-delete-end": {},
    "onFill-start": {},
    "onFill-end": {},
    "onFilter-opened": {},
    "onFilter-changed": {},
    "onFilter-modified": {},
    "onFilter-ui-changed": {},
    "onFloating-filter-ui-changed": {},
    "onAdvanced-filter-builder-visible-changed": {},
    "onFind-changed": {},
    "onChart-created": {},
    "onChart-range-selection-changed": {},
    "onChart-options-changed": {},
    "onChart-destroyed": {},
    "onCell-key-down": {},
    "onGrid-ready": {},
    "onGrid-pre-destroyed": {},
    "onFirst-data-rendered": {},
    "onGrid-size-changed": {},
    "onModel-updated": {},
    "onVirtual-row-removed": {},
    "onViewport-changed": {},
    "onBody-scroll": {},
    "onBody-scroll-end": {},
    "onDrag-started": {},
    "onDrag-stopped": {},
    "onDrag-cancelled": {},
    "onState-updated": {},
    "onPagination-changed": {},
    "onRow-drag-enter": {},
    "onRow-drag-move": {},
    "onRow-drag-leave": {},
    "onRow-drag-end": {},
    "onRow-drag-cancel": {},
    "onRow-resize-started": {},
    "onRow-resize-ended": {},
    "onColumn-row-group-changed": {},
    "onRow-group-opened": {},
    "onExpand-or-collapse-all": {},
    "onPivot-max-columns-exceeded": {},
    "onPinned-row-data-changed": {},
    "onPinned-rows-changed": {},
    "onRow-data-updated": {},
    "onAsync-transactions-flushed": {},
    "onStore-refreshed": {},
    "onHeader-focused": {},
    "onCell-clicked": {},
    "onCell-double-clicked": {},
    "onCell-focused": {},
    "onCell-mouse-over": {},
    "onCell-mouse-out": {},
    "onCell-mouse-down": {},
    "onRow-clicked": {},
    "onRow-double-clicked": {},
    "onRow-selected": {},
    "onSelection-changed": {},
    "onCell-context-menu": {},
    "onRange-selection-changed": {},
    "onCell-selection-changed": {},
    "onTooltip-show": {},
    "onTooltip-hide": {},
    "onSort-changed": {}
  }, Nz()), {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["update:modelValue"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const o = e, s = tn("root"), i = W(void 0), r = W(!1), a = W(!1), l = W(!1), d = W({}), c = W(null), u = Kv(o);
    Hh().filter((I) => I != "gridOptions").forEach((I) => {
      Re(
        () => u[I],
        (P, k) => {
          (I === "rowData" && !f.value || I !== "rowData") && E(I, P), f.value = !1;
        },
        { deep: !0 }
      );
    });
    const h = /* @__PURE__ */ new Set(["rowDataUpdated", "cellValueChanged", "rowValueChanged"]), g = lt(e, "modelValue"), p = W(!1), f = W(!1), m = n;
    Re(
      g,
      (I, P) => {
        r.value && (f.value || (p.value = !0, E("rowData", jr(I), jr(P))), f.value = !1);
      },
      { deep: !0 }
    );
    const C = $z(() => {
      f.value = !0, m("update:modelValue", S());
    }, 10), w = $n(), b = (I) => {
      var P, k;
      l.value && h.has(I) && (k = (P = w == null ? void 0 : w.vnode) == null ? void 0 : P.props) != null && k["onUpdate:modelValue"] && C();
    }, A = () => g.value || o.rowData || o.gridOptions.rowData, S = () => {
      const I = [];
      return i == null || i.value.forEachLeafNode((P) => {
        I.push(P.data);
      }), I;
    }, F = (I) => (P) => {
      if (a.value)
        return;
      P === "gridReady" && (l.value = !0);
      const k = da.has(P);
      k && !I || !k && I || h.has(P) && (p.value || b(P), p.value = !1);
    }, E = (I, P, k) => {
      if (r.value) {
        let B = P.value || P;
        I === "rowData" && B != null && (B = jr(B)), d.value[I] = B, c.value == null && (c.value = window.setTimeout(() => {
          c.value = null, z3(d.value, i.value), d.value = {};
        }, 0));
      }
    }, M = () => Object.create($n().provides);
    return Et(() => {
      Er(pb, void 0, !0);
      const I = new Hz($n(), M()), P = {
        globalListener: F(),
        globalSyncListener: F(!0),
        frameworkOverrides: new _z($n()),
        providedBeanInstances: {
          frameworkCompWrapper: I
        },
        modules: o.modules
      }, k = z2(
        $3(jr(o.gridOptions), o, [
          ...Hh(),
          // we could have replaced it with GRID_OPTIONS_VALIDATORS().allProperties,
          // but that prevents tree shaking of validation code in Vue
          ...Object.values(Ac)
        ])
      ), B = A();
      B !== void 0 && (k.rowData = jr(B)), i.value = Gy(s.value, k, P), r.value = !0;
    }), ks(() => {
      var I;
      r.value && ((I = i == null ? void 0 : i.value) == null || I.destroy(), a.value = !0);
    }), t({
      api: i
    }), (I, P) => (v(), y("div", Wz, null, 512));
  }
}), Kz = "sca-menu-option-wide";
function _0(e) {
  return e.map((t) => ({ ...t, cssClasses: [...t.cssClasses ?? [], Kz] }));
}
function Zz(e) {
  return e.filter((t) => t.length > 0).flatMap((t, n) => n === 0 ? t : ["separator", ...t]);
}
const qz = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm16,64V64A16,16,0,0,1,80,48h96a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H80A16,16,0,0,1,64,104Zm16,0h96V64H80Zm152,48v40a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16H216A16,16,0,0,1,232,152Zm-16,40V152H80v40H216Z"/></svg>', jz = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M232,200a8,8,0,0,1-16,0,88.1,88.1,0,0,0-88-88H51.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,61.66L51.31,96H128A104.11,104.11,0,0,1,232,200Z"/></svg>', Yz = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,109.66l-48,48a8,8,0,0,1-11.32-11.32L204.69,112H128a88.1,88.1,0,0,0-88,88,8,8,0,0,1-16,0A104.11,104.11,0,0,1,128,96h76.69L170.34,61.66a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,229.66,109.66Z"/></svg>', Qz = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"/></svg>', Jz = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z"/></svg>', Xz = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V76.69L62.63,62.06A95.43,95.43,0,0,1,130,33.94h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.56,79.56,0,0,0,73.94,73.37L59.31,88H88a8,8,0,0,1,0,16Zm128,48H168a8,8,0,0,0,0,16h28.69l-14.63,14.63a79.56,79.56,0,0,1-56.13,23.43h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.43,95.43,0,0,0,67.36-28.12L208,179.31V208a8,8,0,0,0,16,0V160A8,8,0,0,0,216,152Z"/></svg>', eW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M117.66,170.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L72,188.69V48a8,8,0,0,1,16,0V188.69l18.34-18.35A8,8,0,0,1,117.66,170.34Zm96-96-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L168,67.31V208a8,8,0,0,0,16,0V67.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z"/></svg>', tW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM122.34,101.66a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32L136,76.69V16a8,8,0,0,0-16,0V76.69L101.66,58.34A8,8,0,0,0,90.34,69.66Zm11.32,52.68a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L120,179.31V240a8,8,0,0,0,16,0V179.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z"/></svg>', nW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"/></svg>', oW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M235.5,216.81c-22.56-11-35.5-34.58-35.5-64.8V134.73a15.94,15.94,0,0,0-10.09-14.87L165,110a8,8,0,0,1-4.48-10.34l21.32-53a28,28,0,0,0-16.1-37,28.14,28.14,0,0,0-35.82,16,.61.61,0,0,0,0,.12L108.9,79a8,8,0,0,1-10.37,4.49L73.11,73.14A15.89,15.89,0,0,0,55.74,76.8C34.68,98.45,24,123.75,24,152a111.45,111.45,0,0,0,31.18,77.53A8,8,0,0,0,61,232H232a8,8,0,0,0,3.5-15.19ZM67.14,88l25.41,10.3a24,24,0,0,0,31.23-13.45l21-53c2.56-6.11,9.47-9.27,15.43-7a12,12,0,0,1,6.88,15.92L145.69,93.76a24,24,0,0,0,13.43,31.14L184,134.73V152c0,.33,0,.66,0,1L55.77,101.71A108.84,108.84,0,0,1,67.14,88Zm48,128a87.53,87.53,0,0,1-24.34-42,8,8,0,0,0-15.49,4,105.16,105.16,0,0,0,18.36,38H64.44A95.54,95.54,0,0,1,40,152a85.9,85.9,0,0,1,7.73-36.29l137.8,55.12c3,18,10.56,33.48,21.89,45.16Z"/></svg>', sW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg>', iW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>', rW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/></svg>', aW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M69.12,94.15,28.5,128l40.62,33.85a8,8,0,1,1-10.24,12.29l-48-40a8,8,0,0,1,0-12.29l48-40a8,8,0,0,1,10.24,12.3Zm176,27.7-48-40a8,8,0,1,0-10.24,12.3L227.5,128l-40.62,33.85a8,8,0,1,0,10.24,12.29l48-40a8,8,0,0,0,0-12.29ZM162.73,32.48a8,8,0,0,0-10.25,4.79l-64,176a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,96,224a8,8,0,0,0,7.52-5.27l64-176A8,8,0,0,0,162.73,32.48Z"/></svg>', lW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M72,92A12,12,0,1,1,60,80,12,12,0,0,1,72,92Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104ZM60,152a12,12,0,1,0,12,12A12,12,0,0,0,60,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152Z"/></svg>', dW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z"/></svg>', cW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"/></svg>', uW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M240,88.23a54.43,54.43,0,0,1-16,37L189.25,160a54.27,54.27,0,0,1-38.63,16h-.05A54.63,54.63,0,0,1,96,119.84a8,8,0,0,1,16,.45A38.62,38.62,0,0,0,150.58,160h0a38.39,38.39,0,0,0,27.31-11.31l34.75-34.75a38.63,38.63,0,0,0-54.63-54.63l-11,11A8,8,0,0,1,135.7,59l11-11A54.65,54.65,0,0,1,224,48,54.86,54.86,0,0,1,240,88.23ZM109,185.66l-11,11A38.41,38.41,0,0,1,70.6,208h0a38.63,38.63,0,0,1-27.29-65.94L78,107.31A38.63,38.63,0,0,1,144,135.71a8,8,0,0,0,16,.45A54.86,54.86,0,0,0,144,96a54.65,54.65,0,0,0-77.27,0L32,130.75A54.62,54.62,0,0,0,70.56,224h0a54.28,54.28,0,0,0,38.64-16l11-11A8,8,0,0,0,109,185.66Z"/></svg>', hW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z"/></svg>', gW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z"/></svg>', pW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"/></svg>', fW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z"/></svg>', mW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>', vW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M184,72V56H80.65l53.6,67a8,8,0,0,1,0,10l-53.6,67H184V184a8,8,0,0,1,16,0v24a8,8,0,0,1-8,8H64a8,8,0,0,1-6.25-13l60-75-60-75A8,8,0,0,1,64,40H192a8,8,0,0,1,8,8V72a8,8,0,0,1-16,0Z"/></svg>', CW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M112,48V208a8,8,0,0,1-16,0V136H43.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L43.31,120H96V48a8,8,0,0,1,16,0Zm125.66,74.34-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160V48a8,8,0,0,0-16,0V208a8,8,0,0,0,16,0V136h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34Z"/></svg>', wW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"/></svg>', yW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>', bW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,48H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm176,24H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-48,40H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z"/></svg>', SW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>', xW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z"/></svg>', RW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M120,64a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16h72A8,8,0,0,1,120,64Zm-8,32H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM144,72h72a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm72,24H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Z"/></svg>', EW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM34.34,141.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0,0-11.32l-40-40A8,8,0,0,0,34.34,61.66L68.69,96,34.34,130.34A8,8,0,0,0,34.34,141.66Z"/></svg>', AW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z"/></svg>', FW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z"/></svg>', MW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>', IW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path fill="none" d="M0 0h256v256H0z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" d="M32 64h72m-72 64h136M32 192h136"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" d="M224 192V64h-72"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" d="m176 40-24 24 24 24"/></svg>', PW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M18.427 18.073a.25.25 0 0 1 .054.273.25.25 0 0 1-.408.08L16 16.354l-2.073 2.074a.25.25 0 0 1-.354-.354L15.647 16l-2.074-2.073a.25.25 0 0 1 .354-.354L16 15.646l2.073-2.073a.25.25 0 1 1 .354.354L16.354 16zM15.625 4.375A.625.625 0 0 1 15 5h-2.674L8.992 15h2.258a.624.624 0 1 1 0 1.25H5A.625.625 0 1 1 5 15h2.674l3.334-10H8.75a.625.625 0 0 1 0-1.25H15a.625.625 0 0 1 .625.625"/></svg>', DW = {
  "generic/row-groups": IW,
  "generic/text-italic-x": PW,
  "phosphor/align-left": qz,
  "phosphor/arrow-bend-up-left": jz,
  "phosphor/arrow-bend-up-right": Yz,
  "phosphor/arrow-down": Qz,
  "phosphor/arrow-up": Jz,
  "phosphor/arrows-counter-clockwise": Xz,
  "phosphor/arrows-down-up": eW,
  "phosphor/arrows-in-line-vertical": tW,
  "phosphor/arrows-out-line-vertical": nW,
  "phosphor/broom": oW,
  "phosphor/caret-down": sW,
  "phosphor/caret-right": iW,
  "phosphor/check": rW,
  "phosphor/code": aW,
  "phosphor/dots-six": lW,
  "phosphor/dots-three-vertical": dW,
  "phosphor/eye": cW,
  "phosphor/link": uW,
  "phosphor/list-numbers": hW,
  "phosphor/list-plus": gW,
  "phosphor/pencil-simple-line": pW,
  "phosphor/push-pin": fW,
  "phosphor/question": mW,
  "phosphor/sigma": vW,
  "phosphor/split-horizontal": CW,
  "phosphor/text-align-center": wW,
  "phosphor/text-align-justify": yW,
  "phosphor/text-align-left": bW,
  "phosphor/text-align-right": SW,
  "phosphor/text-b": xW,
  "phosphor/text-columns": RW,
  "phosphor/text-indent": EW,
  "phosphor/text-italic": AW,
  "phosphor/text-outdent": FW,
  "phosphor/x": MW
}, Zi = (e, t = 16) => DW[e].replace(
  /<svg\b([^>]*)>/,
  (n, o) => `<svg${o.replace(/\s(?:width|height|fill)="[^"]*"/g, "")} width="${t}" height="${t}" fill="currentColor">`
), Kt = (e, t = 16) => `data:image/svg+xml;utf8,${encodeURIComponent(Zi(e, t))}`, TW = wy({
  type: "image",
  mask: !0,
  icons: { tick: { url: Kt("phosphor/check") } }
}), kW = Sy.withoutPart("checkboxStyle");
function LW(e) {
  return kW.withPart(nk).withPart(
    wy({
      type: "image",
      icons: {
        menuAlt: { url: Kt("phosphor/dots-three-vertical") },
        sortAscending: { url: Kt("phosphor/arrow-up") },
        sortDescending: { url: Kt("phosphor/arrow-down") },
        none: { url: Kt("phosphor/broom") },
        pin: { url: Kt("phosphor/push-pin") },
        autosize: { url: Kt("phosphor/split-horizontal") },
        autosizeall: { url: Kt("phosphor/text-columns") },
        reset: { url: Kt("phosphor/arrows-counter-clockwise") },
        hidecolumn: { url: Kt("phosphor/eye") },
        expandall: { url: Kt("phosphor/arrows-out-line-vertical") },
        collapseall: { url: Kt("phosphor/arrows-in-line-vertical") },
        "small-right": { url: Kt("phosphor/caret-right") },
        sigma: { url: Kt("phosphor/sigma") },
        alignLeft: { url: Kt("phosphor/align-left") },
        sortBy: { url: Kt("phosphor/arrows-down-up") }
      }
    })
  ).withPart(TW).withParams({
    borderColor: "#EAEDF0",
    accentColor: e,
    browserColorScheme: "light",
    fontFamily: { googleFont: "Inter" },
    fontSize: 12,
    headerBackgroundColor: "#F1F1F1",
    headerFontSize: 12,
    headerHeight: 28,
    iconSize: 16,
    rowHeight: 40
  });
}
const Ps = Math.min, qo = Math.max, _d = Math.round, kl = Math.floor, jo = (e) => ({
  x: e,
  y: e
}), BW = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function dS(e, t, n) {
  return qo(e, Ps(t, n));
}
function Br(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Si(e) {
  return e.split("-")[0];
}
function Or(e) {
  return e.split("-")[1];
}
function cS(e) {
  return e === "x" ? "y" : "x";
}
function tf(e) {
  return e === "y" ? "height" : "width";
}
function Wo(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function nf(e) {
  return cS(Wo(e));
}
function OW(e, t, n) {
  n === void 0 && (n = !1);
  const o = Or(e), s = nf(e), i = tf(s);
  let r = s === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (r = Nd(r)), [r, Nd(r)];
}
function GW(e) {
  const t = Nd(e);
  return [eg(e), t, eg(t)];
}
function eg(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const N0 = ["left", "right"], $0 = ["right", "left"], HW = ["top", "bottom"], VW = ["bottom", "top"];
function _W(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? $0 : N0 : t ? N0 : $0;
    case "left":
    case "right":
      return t ? HW : VW;
    default:
      return [];
  }
}
function NW(e, t, n, o) {
  const s = Or(e);
  let i = _W(Si(e), n === "start", o);
  return s && (i = i.map((r) => r + "-" + s), t && (i = i.concat(i.map(eg)))), i;
}
function Nd(e) {
  const t = Si(e);
  return BW[t] + e.slice(t.length);
}
function $W(e) {
  var t, n, o, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (o = e.bottom) != null ? o : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function uS(e) {
  return typeof e != "number" ? $W(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function $d(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: s
  } = e;
  return {
    width: o,
    height: s,
    top: n,
    left: t,
    right: t + o,
    bottom: n + s,
    x: t,
    y: n
  };
}
function z0(e, t, n) {
  let {
    reference: o,
    floating: s
  } = e;
  const i = Wo(t), r = nf(t), a = tf(r), l = Si(t), d = i === "y", c = o.x + o.width / 2 - s.width / 2, u = o.y + o.height / 2 - s.height / 2, h = o[a] / 2 - s[a] / 2;
  let g;
  switch (l) {
    case "top":
      g = {
        x: c,
        y: o.y - s.height
      };
      break;
    case "bottom":
      g = {
        x: c,
        y: o.y + o.height
      };
      break;
    case "right":
      g = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      g = {
        x: o.x - s.width,
        y: u
      };
      break;
    default:
      g = {
        x: o.x,
        y: o.y
      };
  }
  const p = Or(t);
  return p && (g[r] += h * (p === "end" ? 1 : -1) * (n && d ? -1 : 1)), g;
}
async function zW(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: s,
    platform: i,
    rects: r,
    elements: a,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: g = 0
  } = Br(t, e), p = uS(g), m = a[h ? u === "floating" ? "reference" : "floating" : u], C = $d(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(m))) == null || n ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), w = u === "floating" ? {
    x: o,
    y: s,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), A = await (i.isElement == null ? void 0 : i.isElement(b)) && await (i.getScale == null ? void 0 : i.getScale(b)) || {
    x: 1,
    y: 1
  }, S = $d(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: b,
    strategy: l
  }) : w);
  return {
    top: (C.top - S.top + p.top) / A.y,
    bottom: (S.bottom - C.bottom + p.bottom) / A.y,
    left: (C.left - S.left + p.left) / A.x,
    right: (S.right - C.right + p.right) / A.x
  };
}
const WW = 50, UW = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: r
  } = n, a = r.detectOverflow ? r : {
    ...r,
    detectOverflow: zW
  }, l = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let d = await r.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: c,
    y: u
  } = z0(d, o, l), h = o, g = 0;
  const p = {};
  for (let f = 0; f < i.length; f++) {
    const m = i[f];
    if (!m)
      continue;
    const {
      name: C,
      fn: w
    } = m, {
      x: b,
      y: A,
      data: S,
      reset: F
    } = await w({
      x: c,
      y: u,
      initialPlacement: o,
      placement: h,
      strategy: s,
      middlewareData: p,
      rects: d,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = b ?? c, u = A ?? u, p[C] = {
      ...p[C],
      ...S
    }, F && g < WW && (g++, typeof F == "object" && (F.placement && (h = F.placement), F.rects && (d = F.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : F.rects), {
      x: c,
      y: u
    } = z0(d, h, l)), f = -1);
  }
  return {
    x: c,
    y: u,
    placement: h,
    strategy: s,
    middlewareData: p
  };
}, KW = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: s,
      rects: i,
      platform: r,
      elements: a,
      middlewareData: l
    } = t, {
      element: d,
      padding: c = 0
    } = Br(e, t) || {};
    if (d == null)
      return {};
    const u = uS(c), h = {
      x: n,
      y: o
    }, g = nf(s), p = tf(g), f = await r.getDimensions(d), m = g === "y", C = m ? "top" : "left", w = m ? "bottom" : "right", b = m ? "clientHeight" : "clientWidth", A = i.reference[p] + i.reference[g] - h[g] - i.floating[p], S = h[g] - i.reference[g], F = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(d));
    let E = F ? F[b] : 0;
    (!E || !await (r.isElement == null ? void 0 : r.isElement(F))) && (E = a.floating[b] || i.floating[p]);
    const M = A / 2 - S / 2, I = E / 2 - f[p] / 2 - 1, P = Ps(u[C], I), k = Ps(u[w], I), B = E - f[p] - k, j = E / 2 - f[p] / 2 + M, N = dS(P, j, B), re = !l.arrow && Or(s) != null && j !== N && i.reference[p] / 2 - (j < P ? P : k) - f[p] / 2 < 0, H = re ? j < P ? j - P : j - B : 0;
    return {
      [g]: h[g] + H,
      data: {
        [g]: N,
        centerOffset: j - N - H,
        ...re && {
          alignmentOffset: H
        }
      },
      reset: re
    };
  }
}), ZW = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: s,
        middlewareData: i,
        rects: r,
        initialPlacement: a,
        platform: l,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: f = !0,
        ...m
      } = Br(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const C = Si(s), w = Wo(a), b = Si(a) === a, A = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), S = h || (b || !f ? [Nd(a)] : GW(a)), F = p !== "none";
      !h && F && S.push(...NW(a, f, p, A));
      const E = [a, ...S], M = await l.detectOverflow(t, m), I = [];
      let P = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (c && I.push(M[C]), u) {
        const N = OW(s, r, A);
        I.push(M[N[0]], M[N[1]]);
      }
      if (P = [...P, {
        placement: s,
        overflows: I
      }], !I.every((N) => N <= 0)) {
        var k, B;
        const N = (((k = i.flip) == null ? void 0 : k.index) || 0) + 1, re = E[N];
        if (re && (!(u === "alignment" ? w !== Wo(re) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((ne) => Wo(ne.placement) === w ? ne.overflows[0] > 0 : !0)))
          return {
            data: {
              index: N,
              overflows: P
            },
            reset: {
              placement: re
            }
          };
        let H = (B = P.filter((_) => _.overflows[0] <= 0).sort((_, ne) => _.overflows[1] - ne.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!H)
          switch (g) {
            case "bestFit": {
              var j;
              const _ = (j = P.filter((ne) => {
                if (F) {
                  const ce = Wo(ne.placement);
                  return ce === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ce === "y";
                }
                return !0;
              }).map((ne) => [ne.placement, ne.overflows.filter((ce) => ce > 0).reduce((ce, me) => ce + me, 0)]).sort((ne, ce) => ne[1] - ce[1])[0]) == null ? void 0 : j[0];
              _ && (H = _);
              break;
            }
            case "initialPlacement":
              H = a;
              break;
          }
        if (s !== H)
          return {
            reset: {
              placement: H
            }
          };
      }
      return {};
    }
  };
}, qW = /* @__PURE__ */ new Set(["left", "top"]);
async function jW(e, t) {
  const {
    placement: n,
    platform: o,
    elements: s
  } = e, i = await (o.isRTL == null ? void 0 : o.isRTL(s.floating)), r = Si(n), a = Or(n), l = Wo(n) === "y", d = qW.has(r) ? -1 : 1, c = i && l ? -1 : 1, u = Br(t, e);
  let {
    mainAxis: h,
    crossAxis: g,
    alignmentAxis: p
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return a && typeof p == "number" && (g = a === "end" ? p * -1 : p), l ? {
    x: g * c,
    y: h * d
  } : {
    x: h * d,
    y: g * c
  };
}
const YW = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: s,
        y: i,
        placement: r,
        middlewareData: a
      } = t, l = await jW(t, e);
      return r === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: s + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: r
        }
      };
    }
  };
}, QW = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: s,
        platform: i
      } = t, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (w) => {
            let {
              x: b,
              y: A
            } = w;
            return {
              x: b,
              y: A
            };
          }
        },
        ...d
      } = Br(e, t), c = {
        x: n,
        y: o
      }, u = await i.detectOverflow(t, d), h = Wo(s), g = cS(h);
      let p = c[g], f = c[h];
      const m = (w, b) => dS(b + u[w === "y" ? "top" : "left"], b, b - u[w === "y" ? "bottom" : "right"]);
      r && (p = m(g, p)), a && (f = m(h, f));
      const C = l.fn({
        ...t,
        [g]: p,
        [h]: f
      });
      return {
        ...C,
        data: {
          x: C.x - n,
          y: C.y - o,
          enabled: {
            [g]: r,
            [h]: a
          }
        }
      };
    }
  };
}, JW = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: o,
        platform: s,
        elements: i
      } = t, {
        apply: r = () => {
        },
        ...a
      } = Br(e, t), l = await s.detectOverflow(t, a), d = Si(n), c = Or(n), u = Wo(n) === "y", {
        width: h,
        height: g
      } = o.floating;
      let p, f;
      d === "top" || d === "bottom" ? (p = d, f = c === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = d, p = c === "end" ? "top" : "bottom");
      const m = g - l.top - l.bottom, C = h - l.left - l.right, w = Ps(g - l[p], m), b = Ps(h - l[f], C), A = t.middlewareData.shift, S = !A;
      let F = w, E = b;
      A != null && A.enabled.x && (E = C), A != null && A.enabled.y && (F = m), S && !c && (u ? E = h - 2 * qo(l.left, l.right) : F = g - 2 * qo(l.top, l.bottom)), await r({
        ...t,
        availableWidth: E,
        availableHeight: F
      });
      const M = await s.getDimensions(i.floating);
      return h !== M.width || g !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function kc() {
  return typeof window < "u";
}
function ki(e) {
  return of(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Fn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ss(e) {
  var t;
  return (t = (of(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function of(e) {
  return kc() ? e instanceof Node || e instanceof Fn(e).Node : !1;
}
function ko(e) {
  return kc() ? e instanceof Element || e instanceof Fn(e).Element : !1;
}
function Ns(e) {
  return kc() ? e instanceof HTMLElement || e instanceof Fn(e).HTMLElement : !1;
}
function W0(e) {
  return !kc() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Fn(e).ShadowRoot;
}
function Lc(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: s
  } = Lo(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && s !== "inline" && s !== "contents";
}
function XW(e) {
  return /^(table|td|th)$/.test(ki(e));
}
function Bc(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const eU = /transform|translate|scale|rotate|perspective|filter/, tU = /paint|layout|strict|content/, Us = (e) => !!e && e !== "none";
let Ku;
function sf(e) {
  const t = ko(e) ? Lo(e) : e;
  return Us(t.transform) || Us(t.translate) || Us(t.scale) || Us(t.rotate) || Us(t.perspective) || !rf() && (Us(t.backdropFilter) || Us(t.filter)) || eU.test(t.willChange || "") || tU.test(t.contain || "");
}
function nU(e) {
  let t = xi(e);
  for (; Ns(t) && !_a(t); ) {
    if (sf(t))
      return t;
    if (Bc(t))
      return null;
    t = xi(t);
  }
  return null;
}
function rf() {
  return Ku == null && (Ku = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ku;
}
function _a(e) {
  return /^(html|body|#document)$/.test(ki(e));
}
function Lo(e) {
  return Fn(e).getComputedStyle(e);
}
function Oc(e) {
  return ko(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function xi(e) {
  if (ki(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    W0(e) && e.host || // Fallback.
    ss(e)
  );
  return W0(t) ? t.host : t;
}
function hS(e) {
  const t = xi(e);
  return _a(t) ? (e.ownerDocument || e).body : Ns(t) && Lc(t) ? t : hS(t);
}
function Na(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = hS(e), i = s === ((o = e.ownerDocument) == null ? void 0 : o.body), r = Fn(s);
  if (i) {
    const a = tg(r);
    return t.concat(r, r.visualViewport || [], Lc(s) ? s : [], a && n ? Na(a) : []);
  } else
    return t.concat(s, Na(s, [], n));
}
function tg(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function gS(e) {
  const t = Lo(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const s = Ns(e), i = s ? e.offsetWidth : n, r = s ? e.offsetHeight : o, a = _d(n) !== i || _d(o) !== r;
  return a && (n = i, o = r), {
    width: n,
    height: o,
    $: a
  };
}
function af(e) {
  return ko(e) ? e : e.contextElement;
}
function lr(e) {
  const t = af(e);
  if (!Ns(t))
    return jo(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: s,
    $: i
  } = gS(t);
  let r = (i ? _d(n.width) : n.width) / o, a = (i ? _d(n.height) : n.height) / s;
  return (!r || !Number.isFinite(r)) && (r = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: r,
    y: a
  };
}
const oU = /* @__PURE__ */ jo(0);
function pS(e) {
  const t = Fn(e);
  return !rf() || !t.visualViewport ? oU : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sU(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Fn(e);
}
function Ri(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = af(e);
  let r = jo(1);
  t && (o ? ko(o) && (r = lr(o)) : r = lr(e));
  const a = sU(i, n, o) ? pS(i) : jo(0);
  let l = (s.left + a.x) / r.x, d = (s.top + a.y) / r.y, c = s.width / r.x, u = s.height / r.y;
  if (i && o) {
    const h = Fn(i), g = ko(o) ? Fn(o) : o;
    let p = h, f = tg(p);
    for (; f && g !== p; ) {
      const m = lr(f), C = f.getBoundingClientRect(), w = Lo(f), b = C.left + (f.clientLeft + parseFloat(w.paddingLeft)) * m.x, A = C.top + (f.clientTop + parseFloat(w.paddingTop)) * m.y;
      l *= m.x, d *= m.y, c *= m.x, u *= m.y, l += b, d += A, p = Fn(f), f = tg(p);
    }
  }
  return $d({
    width: c,
    height: u,
    x: l,
    y: d
  });
}
function Gc(e, t) {
  const n = Oc(e).scrollLeft;
  return t ? t.left + n : Ri(ss(e)).left + n;
}
function fS(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - Gc(e, n), s = n.top + t.scrollTop;
  return {
    x: o,
    y: s
  };
}
function iU(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: s
  } = e;
  const i = s === "fixed", r = ss(o), a = t ? Bc(t.floating) : !1;
  if (o === r || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = jo(1);
  const c = jo(0), u = Ns(o);
  if ((u || !i) && ((ki(o) !== "body" || Lc(r)) && (l = Oc(o)), u)) {
    const g = Ri(o);
    d = lr(o), c.x = g.x + o.clientLeft, c.y = g.y + o.clientTop;
  }
  const h = r && !u && !i ? fS(r, l) : jo(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - l.scrollLeft * d.x + c.x + h.x,
    y: n.y * d.y - l.scrollTop * d.y + c.y + h.y
  };
}
function rU(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function aU(e) {
  const t = Oc(e), n = e.ownerDocument.body, o = qo(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = qo(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + Gc(e);
  const r = -t.scrollTop;
  return Lo(n).direction === "rtl" && (i += qo(e.clientWidth, n.clientWidth) - o), {
    width: o,
    height: s,
    x: i,
    y: r
  };
}
const lU = 25;
function dU(e, t, n) {
  n === void 0 && (n = "viewport");
  const o = n === "layoutViewport", s = Fn(e), i = ss(e), r = s.visualViewport;
  let a = i.clientWidth, l = i.clientHeight, d = 0, c = 0;
  if (r) {
    const h = !rf() || t === "fixed";
    o ? h || (d = -r.offsetLeft, c = -r.offsetTop) : (a = r.width, l = r.height, h && (d = r.offsetLeft, c = r.offsetTop));
  }
  if (Gc(i) <= 0) {
    const h = i.ownerDocument, g = h.body, p = getComputedStyle(g), f = h.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, m = Math.abs(i.clientWidth - g.clientWidth - f), C = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? m / 2 : m;
    C <= lU && (a -= C);
  }
  return {
    width: a,
    height: l,
    x: d,
    y: c
  };
}
function cU(e, t) {
  const n = Ri(e, !0, t === "fixed"), o = n.top + e.clientTop, s = n.left + e.clientLeft, i = lr(e), r = e.clientWidth * i.x, a = e.clientHeight * i.y, l = s * i.x, d = o * i.y;
  return {
    width: r,
    height: a,
    x: l,
    y: d
  };
}
function U0(e, t, n) {
  let o;
  if (t === "viewport" || t === "layoutViewport")
    o = dU(e, n, t);
  else if (t === "document")
    o = aU(ss(e));
  else if (ko(t))
    o = cU(t, n);
  else {
    const s = pS(e);
    o = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return $d(o);
}
function uU(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Na(e, [], !1).filter((a) => ko(a) && ki(a) !== "body"), s = null;
  const i = Lo(e).position === "fixed";
  let r = i ? xi(e) : e;
  for (; ko(r) && !_a(r); ) {
    const a = Lo(r), l = sf(r), d = s ? s.position : i ? "fixed" : "";
    !l && (d === "fixed" || d === "absolute" && a.position === "static") ? o = o.filter((u) => u !== r) : s = a, r = xi(r);
  }
  return t.set(e, o), o;
}
function hU(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: s
  } = e;
  const r = [...n === "clippingAncestors" ? Bc(t) ? [] : uU(t, this._c) : [].concat(n), o], a = U0(t, r[0], s);
  let l = a.top, d = a.right, c = a.bottom, u = a.left;
  for (let h = 1; h < r.length; h++) {
    const g = U0(t, r[h], s);
    l = qo(g.top, l), d = Ps(g.right, d), c = Ps(g.bottom, c), u = qo(g.left, u);
  }
  return {
    width: d - u,
    height: c - l,
    x: u,
    y: l
  };
}
function gU(e) {
  const {
    width: t,
    height: n
  } = gS(e);
  return {
    width: t,
    height: n
  };
}
function pU(e, t, n) {
  const o = Ns(t), s = ss(t), i = n === "fixed", r = Ri(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = jo(0);
  if ((o || !i) && ((ki(t) !== "body" || Lc(s)) && (a = Oc(t)), o)) {
    const h = Ri(t, !0, i, t);
    l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
  }
  !o && s && (l.x = Gc(s));
  const d = s && !o && !i ? fS(s, a) : jo(0), c = r.left + a.scrollLeft - l.x - d.x, u = r.top + a.scrollTop - l.y - d.y;
  return {
    x: c,
    y: u,
    width: r.width,
    height: r.height
  };
}
function Zu(e) {
  return Lo(e).position === "static";
}
function K0(e, t) {
  if (!Ns(e) || Lo(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ss(e) === n && (n = n.ownerDocument.body), n;
}
function mS(e, t) {
  const n = Fn(e);
  if (Bc(e))
    return n;
  if (!Ns(e)) {
    let s = xi(e);
    for (; s && !_a(s); ) {
      if (ko(s) && !Zu(s))
        return s;
      s = xi(s);
    }
    return n;
  }
  let o = K0(e, t);
  for (; o && XW(o) && Zu(o); )
    o = K0(o, t);
  return o && _a(o) && Zu(o) && !sf(o) ? n : o || nU(e) || n;
}
const fU = async function(e) {
  const t = this.getOffsetParent || mS, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: pU(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function mU(e) {
  return Lo(e).direction === "rtl";
}
const vU = {
  convertOffsetParentRelativeRectToViewportRelativeRect: iU,
  getDocumentElement: ss,
  getClippingRect: hU,
  getOffsetParent: mS,
  getElementRects: fU,
  getClientRects: rU,
  getDimensions: gU,
  getScale: lr,
  isElement: ko,
  isRTL: mU
};
function vS(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function CU(e, t, n) {
  let o = null, s;
  const i = ss(e);
  function r() {
    var c;
    clearTimeout(s), (c = o) == null || c.disconnect(), o = null;
  }
  function a(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), r();
    const h = e.getBoundingClientRect(), {
      left: g,
      top: p,
      width: f,
      height: m
    } = h;
    if (c || t(), !f || !m)
      return;
    const C = kl(p), w = kl(i.clientWidth - (g + f)), b = kl(i.clientHeight - (p + m)), A = kl(g), F = {
      rootMargin: -C + "px " + -w + "px " + -b + "px " + -A + "px",
      threshold: qo(0, Ps(1, u)) || 1
    };
    let E = !0;
    function M(I) {
      const P = I[0].intersectionRatio;
      if (!vS(h, e.getBoundingClientRect()))
        return a();
      if (P !== u) {
        if (!E)
          return a();
        P ? a(!1, P) : s = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      E = !1;
    }
    try {
      o = new IntersectionObserver(M, {
        ...F,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(M, F);
    }
    o.observe(e);
  }
  const l = Fn(e), d = () => a(n);
  return l.addEventListener("resize", d), a(!0), () => {
    l.removeEventListener("resize", d), r();
  };
}
function ng(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, d = af(e), c = s || i ? [...d ? Na(d) : [], ...t ? Na(t) : []] : [];
  c.forEach((C) => {
    s && C.addEventListener("scroll", n), i && C.addEventListener("resize", n);
  });
  const u = d && a ? CU(d, n, i) : null;
  let h = -1, g = null;
  r && (g = new ResizeObserver((C) => {
    let [w] = C;
    w && w.target === d && g && t && (g.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var b;
      (b = g) == null || b.observe(t);
    })), n();
  }), d && !l && g.observe(d), t && g.observe(t));
  let p, f = l ? Ri(e) : null;
  l && m();
  function m() {
    const C = Ri(e);
    f && !vS(f, C) && n(), f = C, p = requestAnimationFrame(m);
  }
  return n(), () => {
    var C;
    c.forEach((w) => {
      s && w.removeEventListener("scroll", n), i && w.removeEventListener("resize", n);
    }), u == null || u(), (C = g) == null || C.disconnect(), g = null, l && cancelAnimationFrame(p);
  };
}
const CS = YW, wS = QW, yS = ZW, wU = JW, yU = KW, bS = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), s = n ?? {}, i = {
    ...vU,
    ...s.platform,
    _c: o
  };
  return UW(e, t, {
    ...s,
    platform: i
  });
};
function bU(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function og(e) {
  if (bU(e)) {
    const t = e.$el;
    return of(t) && ki(t) === "#comment" ? null : t;
  }
  return e;
}
function $i(e) {
  return typeof e == "function" ? e() : T(e);
}
function SU(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = og($i(e.element));
      return n == null ? {} : yU({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function SS(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Z0(e, t) {
  const n = SS(e);
  return Math.round(t * n) / n;
}
function xU(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, s = D(() => {
    var E;
    return (E = $i(n.open)) != null ? E : !0;
  }), i = D(() => $i(n.middleware)), r = D(() => {
    var E;
    return (E = $i(n.placement)) != null ? E : "bottom";
  }), a = D(() => {
    var E;
    return (E = $i(n.strategy)) != null ? E : "absolute";
  }), l = D(() => {
    var E;
    return (E = $i(n.transform)) != null ? E : !0;
  }), d = D(() => og(e.value)), c = D(() => og(t.value)), u = W(0), h = W(0), g = W(a.value), p = W(r.value), f = Qe({}), m = W(!1), C = D(() => {
    const E = {
      position: g.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return E;
    const M = Z0(c.value, u.value), I = Z0(c.value, h.value);
    return l.value ? {
      ...E,
      transform: "translate(" + M + "px, " + I + "px)",
      ...SS(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: g.value,
      left: M + "px",
      top: I + "px"
    };
  });
  let w;
  function b() {
    if (d.value == null || c.value == null)
      return;
    const E = s.value;
    bS(d.value, c.value, {
      middleware: i.value,
      placement: r.value,
      strategy: a.value
    }).then((M) => {
      u.value = M.x, h.value = M.y, g.value = M.strategy, p.value = M.placement, f.value = M.middlewareData, m.value = E !== !1;
    });
  }
  function A() {
    typeof w == "function" && (w(), w = void 0);
  }
  function S() {
    if (A(), o === void 0) {
      b();
      return;
    }
    if (d.value != null && c.value != null) {
      w = o(d.value, c.value, b);
      return;
    }
  }
  function F() {
    s.value || (m.value = !1);
  }
  return Re([i, r, a, s], b, {
    flush: "sync"
  }), Re([d, c], S, {
    flush: "sync"
  }), Re(s, F, {
    flush: "sync"
  }), Yd() && ro(A), {
    x: Zs(u),
    y: Zs(h),
    strategy: Zs(g),
    placement: Zs(p),
    middlewareData: Zs(f),
    isPositioned: Zs(m),
    floatingStyles: C,
    update: b
  };
}
function lf(e) {
  return Yd() ? (ro(e), !0) : !1;
}
const qu = /* @__PURE__ */ new WeakMap(), RU = (...e) => {
  var t;
  const n = e[0], o = (t = $n()) == null ? void 0 : t.proxy;
  if (o == null && !qd())
    throw new Error("injectLocal must be called in setup");
  return o && qu.has(o) && n in qu.get(o) ? qu.get(o)[n] : Mi(...e);
}, df = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const EU = (e) => typeof e < "u", AU = (e) => e != null, FU = Object.prototype.toString, MU = (e) => FU.call(e) === "[object Object]", _n = () => {
}, IU = /* @__PURE__ */ PU();
function PU() {
  var e, t;
  return df && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function xS(...e) {
  if (e.length !== 1)
    return Z2(...e);
  const t = e[0];
  return typeof t == "function" ? Qo(q2(() => ({ get: t, set: _n }))) : W(t);
}
function RS(e, t) {
  function n(...o) {
    return new Promise((s, i) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(s).catch(i);
    });
  }
  return n;
}
const ES = (e) => e();
function DU(e, t = {}) {
  let n, o, s = _n;
  const i = (l) => {
    clearTimeout(l), s(), s = _n;
  };
  let r;
  return (l) => {
    const d = xe(e), c = xe(t.maxWait);
    return n && i(n), d <= 0 || c !== void 0 && c <= 0 ? (o && (i(o), o = null), Promise.resolve(l())) : new Promise((u, h) => {
      s = t.rejectOnCancel ? h : u, r = l, c && !o && (o = setTimeout(() => {
        n && i(n), o = null, u(r());
      }, c)), n = setTimeout(() => {
        o && i(o), o = null, u(l());
      }, d);
    });
  };
}
function TU(e = ES, t = {}) {
  const {
    initialState: n = "active"
  } = t, o = xS(n === "active");
  function s() {
    o.value = !1;
  }
  function i() {
    o.value = !0;
  }
  const r = (...a) => {
    o.value && e(...a);
  };
  return { isActive: Qo(o), pause: s, resume: i, eventFilter: r };
}
function q0(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function pa(e) {
  return Array.isArray(e) ? e : [e];
}
function kU(e) {
  return $n();
}
function AS(e, t = 200, n = {}) {
  return RS(
    DU(t, n),
    e
  );
}
function LU(e, t = 200, n = {}) {
  const o = W(xe(e)), s = AS(() => {
    o.value = e.value;
  }, t, n);
  return Re(e, () => s()), Zs(o);
}
function BU(e, t, n = {}) {
  const {
    eventFilter: o = ES,
    ...s
  } = n;
  return Re(
    e,
    RS(
      o,
      t
    ),
    s
  );
}
function OU(e, t, n = {}) {
  const {
    eventFilter: o,
    initialState: s = "active",
    ...i
  } = n, { eventFilter: r, pause: a, resume: l, isActive: d } = TU(o, { initialState: s });
  return { stop: BU(
    e,
    t,
    {
      ...i,
      eventFilter: r
    }
  ), pause: a, resume: l, isActive: d };
}
function cf(e, t = !0, n) {
  kU() ? Et(e, n) : t ? e() : Xe(e);
}
function GU(e, t, n) {
  return Re(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function HU(e, t, n) {
  return Re(
    e,
    t,
    {
      ...n,
      once: !0
    }
  );
}
const so = df ? window : void 0;
function En(e) {
  var t;
  const n = xe(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function An(...e) {
  const t = [], n = () => {
    t.forEach((a) => a()), t.length = 0;
  }, o = (a, l, d, c) => (a.addEventListener(l, d, c), () => a.removeEventListener(l, d, c)), s = D(() => {
    const a = pa(xe(e[0])).filter((l) => l != null);
    return a.every((l) => typeof l != "string") ? a : void 0;
  }), i = GU(
    () => {
      var a, l;
      return [
        (l = (a = s.value) == null ? void 0 : a.map((d) => En(d))) != null ? l : [so].filter((d) => d != null),
        pa(xe(s.value ? e[1] : e[0])),
        pa(T(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        xe(s.value ? e[3] : e[2])
      ];
    },
    ([a, l, d, c]) => {
      if (n(), !(a != null && a.length) || !(l != null && l.length) || !(d != null && d.length))
        return;
      const u = MU(c) ? { ...c } : c;
      t.push(
        ...a.flatMap(
          (h) => l.flatMap(
            (g) => d.map((p) => o(h, g, p, u))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    i(), n();
  };
  return lf(n), r;
}
let j0 = !1;
function VU(e, t, n = {}) {
  const { window: o = so, ignore: s = [], capture: i = !0, detectIframe: r = !1, controls: a = !1 } = n;
  if (!o)
    return a ? { stop: _n, cancel: _n, trigger: _n } : _n;
  if (IU && !j0) {
    j0 = !0;
    const m = { passive: !0 };
    Array.from(o.document.body.children).forEach((C) => C.addEventListener("click", _n, m)), o.document.documentElement.addEventListener("click", _n, m);
  }
  let l = !0;
  const d = (m) => xe(s).some((C) => {
    if (typeof C == "string")
      return Array.from(o.document.querySelectorAll(C)).some((w) => w === m.target || m.composedPath().includes(w));
    {
      const w = En(C);
      return w && (m.target === w || m.composedPath().includes(w));
    }
  });
  function c(m) {
    const C = xe(m);
    return C && C.$.subTree.shapeFlag === 16;
  }
  function u(m, C) {
    const w = xe(m), b = w.$.subTree && w.$.subTree.children;
    return b == null || !Array.isArray(b) ? !1 : b.some((A) => A.el === C.target || C.composedPath().includes(A.el));
  }
  const h = (m) => {
    const C = En(e);
    if (m.target != null && !(!(C instanceof Element) && c(e) && u(e, m)) && !(!C || C === m.target || m.composedPath().includes(C))) {
      if ("detail" in m && m.detail === 0 && (l = !d(m)), !l) {
        l = !0;
        return;
      }
      t(m);
    }
  };
  let g = !1;
  const p = [
    An(o, "click", (m) => {
      g || (g = !0, setTimeout(() => {
        g = !1;
      }, 0), h(m));
    }, { passive: !0, capture: i }),
    An(o, "pointerdown", (m) => {
      const C = En(e);
      l = !d(m) && !!(C && !m.composedPath().includes(C));
    }, { passive: !0 }),
    r && An(o, "blur", (m) => {
      setTimeout(() => {
        var C;
        const w = En(e);
        ((C = o.document.activeElement) == null ? void 0 : C.tagName) === "IFRAME" && !(w != null && w.contains(o.document.activeElement)) && t(m);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), f = () => p.forEach((m) => m());
  return a ? {
    stop: f,
    cancel: () => {
      l = !1;
    },
    trigger: (m) => {
      l = !0, h(m), l = !1;
    }
  } : f;
}
function _U() {
  const e = Qe(!1), t = $n();
  return t && Et(() => {
    e.value = !0;
  }, t), e;
}
function uf(e) {
  const t = _U();
  return D(() => (t.value, !!e()));
}
const NU = Symbol("vueuse-ssr-width");
function $U() {
  const e = qd() ? RU(NU, null) : null;
  return typeof e == "number" ? e : void 0;
}
function FS(e, t = {}) {
  const { window: n = so, ssrWidth: o = $U() } = t, s = uf(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), i = Qe(typeof o == "number"), r = Qe(), a = Qe(!1), l = (d) => {
    a.value = d.matches;
  };
  return jd(() => {
    if (i.value) {
      i.value = !s.value;
      const d = xe(e).split(",");
      a.value = d.some((c) => {
        const u = c.includes("not all"), h = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), g = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let p = !!(h || g);
        return h && p && (p = o >= q0(h[1])), g && p && (p = o <= q0(g[1])), u ? !p : p;
      });
      return;
    }
    s.value && (r.value = n.matchMedia(xe(e)), a.value = r.value.matches);
  }), An(r, "change", l, { passive: !0 }), D(() => a.value);
}
function zU(e) {
  return JSON.parse(JSON.stringify(e));
}
const Ll = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Bl = "__vueuse_ssr_handlers__", WU = /* @__PURE__ */ UU();
function UU() {
  return Bl in Ll || (Ll[Bl] = Ll[Bl] || {}), Ll[Bl];
}
function KU(e, t) {
  return WU[e] || t;
}
function ZU(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const qU = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, Y0 = "vueuse-storage";
function jU(e, t, n, o = {}) {
  var s;
  const {
    flush: i = "pre",
    deep: r = !0,
    listenToStorageChanges: a = !0,
    writeDefaults: l = !0,
    mergeDefaults: d = !1,
    shallow: c,
    window: u = so,
    eventFilter: h,
    onError: g = (N) => {
      console.error(N);
    },
    initOnMounted: p
  } = o, f = (c ? Qe : W)(typeof t == "function" ? t() : t), m = D(() => xe(e));
  if (!n)
    try {
      n = KU("getDefaultStorage", () => {
        var N;
        return (N = so) == null ? void 0 : N.localStorage;
      })();
    } catch (N) {
      g(N);
    }
  if (!n)
    return f;
  const C = xe(t), w = ZU(C), b = (s = o.serializer) != null ? s : qU[w], { pause: A, resume: S } = OU(
    f,
    () => P(f.value),
    { flush: i, deep: r, eventFilter: h }
  );
  Re(m, () => B(), { flush: i });
  let F = !1;
  const E = (N) => {
    p && !F || B(N);
  }, M = (N) => {
    p && !F || j(N);
  };
  u && a && (n instanceof Storage ? An(u, "storage", E, { passive: !0 }) : An(u, Y0, M)), p ? cf(() => {
    F = !0, B();
  }) : B();
  function I(N, re) {
    if (u) {
      const H = {
        key: m.value,
        oldValue: N,
        newValue: re,
        storageArea: n
      };
      u.dispatchEvent(n instanceof Storage ? new StorageEvent("storage", H) : new CustomEvent(Y0, {
        detail: H
      }));
    }
  }
  function P(N) {
    try {
      const re = n.getItem(m.value);
      if (N == null)
        I(re, null), n.removeItem(m.value);
      else {
        const H = b.write(N);
        re !== H && (n.setItem(m.value, H), I(re, H));
      }
    } catch (re) {
      g(re);
    }
  }
  function k(N) {
    const re = N ? N.newValue : n.getItem(m.value);
    if (re == null)
      return l && C != null && n.setItem(m.value, b.write(C)), C;
    if (!N && d) {
      const H = b.read(re);
      return typeof d == "function" ? d(H, C) : w === "object" && !Array.isArray(H) ? { ...C, ...H } : H;
    } else return typeof re != "string" ? re : b.read(re);
  }
  function B(N) {
    if (!(N && N.storageArea !== n)) {
      if (N && N.key == null) {
        f.value = C;
        return;
      }
      if (!(N && N.key !== m.value)) {
        A();
        try {
          (N == null ? void 0 : N.newValue) !== b.write(f.value) && (f.value = k(N));
        } catch (re) {
          g(re);
        } finally {
          N ? Xe(S) : S();
        }
      }
    }
  }
  function j(N) {
    B(N.detail);
  }
  return f;
}
function YU(e, t = {}) {
  var n, o;
  const s = Qe(!1), i = Qe(null);
  let r = 0, a = !0;
  if (df) {
    const l = typeof t == "function" ? { onDrop: t } : t, d = (n = l.multiple) != null ? n : !0, c = (o = l.preventDefaultForUnhandled) != null ? o : !1, u = (m) => {
      var C, w;
      const b = Array.from((w = (C = m.dataTransfer) == null ? void 0 : C.files) != null ? w : []);
      return b.length === 0 ? null : d ? b : [b[0]];
    }, h = (m) => {
      const C = T(l.dataTypes);
      return typeof C == "function" ? C(m) : C != null && C.length ? m.length === 0 ? !1 : m.every(
        (w) => C.some((b) => w.includes(b))
      ) : !0;
    }, g = (m) => {
      const C = Array.from(m ?? []).map((A) => A.type), w = h(C), b = d || m.length <= 1;
      return w && b;
    }, p = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), f = (m, C) => {
      var w, b, A, S, F, E;
      const M = (w = m.dataTransfer) == null ? void 0 : w.items;
      if (a = (b = M && g(M)) != null ? b : !1, c && m.preventDefault(), !p() && !a) {
        m.dataTransfer && (m.dataTransfer.dropEffect = "none");
        return;
      }
      m.preventDefault(), m.dataTransfer && (m.dataTransfer.dropEffect = "copy");
      const I = u(m);
      switch (C) {
        case "enter":
          r += 1, s.value = !0, (A = l.onEnter) == null || A.call(l, null, m);
          break;
        case "over":
          (S = l.onOver) == null || S.call(l, null, m);
          break;
        case "leave":
          r -= 1, r === 0 && (s.value = !1), (F = l.onLeave) == null || F.call(l, null, m);
          break;
        case "drop":
          r = 0, s.value = !1, a && (i.value = I, (E = l.onDrop) == null || E.call(l, I, m));
          break;
      }
    };
    An(e, "dragenter", (m) => f(m, "enter")), An(e, "dragover", (m) => f(m, "over")), An(e, "dragleave", (m) => f(m, "leave")), An(e, "drop", (m) => f(m, "drop"));
  }
  return {
    files: i,
    isOverDropZone: s
  };
}
function Hc(e, t, n = {}) {
  const { window: o = so, ...s } = n;
  let i;
  const r = uf(() => o && "ResizeObserver" in o), a = () => {
    i && (i.disconnect(), i = void 0);
  }, l = D(() => {
    const u = xe(e);
    return Array.isArray(u) ? u.map((h) => En(h)) : [En(u)];
  }), d = Re(
    l,
    (u) => {
      if (a(), r.value && o) {
        i = new ResizeObserver(t);
        for (const h of u)
          h && i.observe(h, s);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    a(), d();
  };
  return lf(c), {
    isSupported: r,
    stop: c
  };
}
function QU(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: o = so, box: s = "content-box" } = n, i = D(() => {
    var u, h;
    return (h = (u = En(e)) == null ? void 0 : u.namespaceURI) == null ? void 0 : h.includes("svg");
  }), r = Qe(t.width), a = Qe(t.height), { stop: l } = Hc(
    e,
    ([u]) => {
      const h = s === "border-box" ? u.borderBoxSize : s === "content-box" ? u.contentBoxSize : u.devicePixelContentBoxSize;
      if (o && i.value) {
        const g = En(e);
        if (g) {
          const p = g.getBoundingClientRect();
          r.value = p.width, a.value = p.height;
        }
      } else if (h) {
        const g = pa(h);
        r.value = g.reduce((p, { inlineSize: f }) => p + f, 0), a.value = g.reduce((p, { blockSize: f }) => p + f, 0);
      } else
        r.value = u.contentRect.width, a.value = u.contentRect.height;
    },
    n
  );
  cf(() => {
    const u = En(e);
    u && (r.value = "offsetWidth" in u ? u.offsetWidth : t.width, a.value = "offsetHeight" in u ? u.offsetHeight : t.height);
  });
  const d = Re(
    () => En(e),
    (u) => {
      r.value = u ? t.width : 0, a.value = u ? t.height : 0;
    }
  );
  function c() {
    l(), d();
  }
  return {
    width: r,
    height: a,
    stop: c
  };
}
function JU(e, t, n = {}) {
  const {
    root: o,
    rootMargin: s = "0px",
    threshold: i = 0,
    window: r = so,
    immediate: a = !0
  } = n, l = uf(() => r && "IntersectionObserver" in r), d = D(() => {
    const p = xe(e);
    return pa(p).map(En).filter(AU);
  });
  let c = _n;
  const u = Qe(a), h = l.value ? Re(
    () => [d.value, En(o), u.value],
    ([p, f]) => {
      if (c(), !u.value || !p.length)
        return;
      const m = new IntersectionObserver(
        t,
        {
          root: En(f),
          rootMargin: s,
          threshold: i
        }
      );
      p.forEach((C) => C && m.observe(C)), c = () => {
        m.disconnect(), c = _n;
      };
    },
    { immediate: a, flush: "post" }
  ) : _n, g = () => {
    c(), h(), u.value = !1;
  };
  return lf(g), {
    isSupported: l,
    isActive: u,
    pause() {
      c(), u.value = !1;
    },
    resume() {
      u.value = !0;
    },
    stop: g
  };
}
function Q0(e, t = {}) {
  const {
    window: n = so,
    scrollTarget: o,
    threshold: s = 0,
    rootMargin: i,
    once: r = !1
  } = t, a = Qe(!1), { stop: l } = JU(
    e,
    (d) => {
      let c = a.value, u = 0;
      for (const h of d)
        h.time >= u && (u = h.time, c = h.isIntersecting);
      a.value = c, r && HU(a, () => {
        l();
      });
    },
    {
      root: o,
      window: n,
      threshold: s,
      rootMargin: xe(i)
    }
  );
  return a;
}
function IMe(e, t, n = {}) {
  const { window: o = so } = n;
  return jU(e, t, o == null ? void 0 : o.localStorage, n);
}
function Bn(e, t, n, o = {}) {
  var s, i, r;
  const {
    clone: a = !1,
    passive: l = !1,
    eventName: d,
    deep: c = !1,
    defaultValue: u,
    shouldEmit: h
  } = o, g = $n(), p = n || (g == null ? void 0 : g.emit) || ((s = g == null ? void 0 : g.$emit) == null ? void 0 : s.bind(g)) || ((r = (i = g == null ? void 0 : g.proxy) == null ? void 0 : i.$emit) == null ? void 0 : r.bind(g == null ? void 0 : g.proxy));
  let f = d;
  t || (t = "modelValue"), f = f || `update:${t.toString()}`;
  const m = (b) => a ? typeof a == "function" ? a(b) : zU(b) : b, C = () => EU(e[t]) ? m(e[t]) : u, w = (b) => {
    h ? h(b) && p(f, b) : p(f, b);
  };
  if (l) {
    const b = C(), A = W(b);
    let S = !1;
    return Re(
      () => e[t],
      (F) => {
        S || (S = !0, A.value = m(F), Xe(() => S = !1));
      }
    ), Re(
      A,
      (F) => {
        !S && (F !== e[t] || c) && w(F);
      },
      { deep: c }
    ), A;
  } else
    return D({
      get() {
        return C();
      },
      set(b) {
        w(b);
      }
    });
}
function XU(e = {}) {
  const {
    window: t = so,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: i = !0,
    type: r = "inner"
  } = e, a = Qe(n), l = Qe(o), d = () => {
    if (t)
      if (r === "outer")
        a.value = t.outerWidth, l.value = t.outerHeight;
      else if (r === "visual" && t.visualViewport) {
        const { width: u, height: h, scale: g } = t.visualViewport;
        a.value = Math.round(u * g), l.value = Math.round(h * g);
      } else i ? (a.value = t.innerWidth, l.value = t.innerHeight) : (a.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight);
  };
  d(), cf(d);
  const c = { passive: !0 };
  if (An("resize", d, c), t && r === "visual" && t.visualViewport && An(t.visualViewport, "resize", d, c), s) {
    const u = FS("(orientation: portrait)");
    Re(u, () => d());
  }
  return { width: a, height: l };
}
const Ut = [];
for (let e = 0; e < 256; ++e)
  Ut.push((e + 256).toString(16).slice(1));
function eK(e, t = 0) {
  return (Ut[e[t + 0]] + Ut[e[t + 1]] + Ut[e[t + 2]] + Ut[e[t + 3]] + "-" + Ut[e[t + 4]] + Ut[e[t + 5]] + "-" + Ut[e[t + 6]] + Ut[e[t + 7]] + "-" + Ut[e[t + 8]] + Ut[e[t + 9]] + "-" + Ut[e[t + 10]] + Ut[e[t + 11]] + Ut[e[t + 12]] + Ut[e[t + 13]] + Ut[e[t + 14]] + Ut[e[t + 15]]).toLowerCase();
}
let ju;
const tK = new Uint8Array(16);
function nK() {
  if (!ju) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    ju = crypto.getRandomValues.bind(crypto);
  }
  return ju(tK);
}
const oK = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), J0 = { randomUUID: oK };
function sK(e, t, n) {
  var s;
  if (J0.randomUUID && !e)
    return J0.randomUUID();
  e = e || {};
  const o = e.random ?? ((s = e.rng) == null ? void 0 : s.call(e)) ?? nK();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, eK(o);
}
const iK = /* @__PURE__ */ de({
  __name: "SCALoader",
  props: {
    type: { default: "spinner" },
    appearance: { default: "primary" },
    size: { default: "medium" },
    indeterminate: { type: Boolean, default: !1 },
    inverted: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x(t.$style.loader)
    }, [
      e.type === "spinner" ? (v(), y("div", {
        key: 0,
        class: x([
          t.$style.spinner,
          {
            [t.$style.appearanceWhite]: e.appearance === "white",
            [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
            [t.$style.sizeSmall]: e.size === "small",
            [t.$style.sizeLarge]: e.size === "large",
            [t.$style.indeterminate]: e.indeterminate,
            [t.$style.inverted]: e.inverted
          }
        ])
      }, null, 2)) : e.type === "dots" ? (v(), y("div", {
        key: 1,
        class: x([
          t.$style.dots,
          {
            [t.$style.sizeSmall]: e.size === "small",
            [t.$style.sizeLarge]: e.size === "large"
          }
        ])
      }, [
        R("span", {
          class: x([
            t.$style.dot,
            {
              [t.$style.appearanceWhite]: e.appearance === "white",
              [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
              [t.$style.inverted]: e.inverted,
              [t.$style.sizeSmall]: e.size === "small",
              [t.$style.sizeLarge]: e.size === "large"
            }
          ])
        }, null, 2),
        R("span", {
          class: x([
            t.$style.dot,
            {
              [t.$style.appearanceWhite]: e.appearance === "white",
              [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
              [t.$style.inverted]: e.inverted,
              [t.$style.sizeSmall]: e.size === "small",
              [t.$style.sizeLarge]: e.size === "large"
            }
          ])
        }, null, 2),
        R("span", {
          class: x([
            t.$style.dot,
            {
              [t.$style.appearanceWhite]: e.appearance === "white",
              [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
              [t.$style.inverted]: e.inverted,
              [t.$style.sizeSmall]: e.size === "small",
              [t.$style.sizeLarge]: e.size === "large"
            }
          ])
        }, null, 2)
      ], 2)) : V("", !0)
    ], 2));
  }
}), rK = "_loader_6oipg_755", aK = "_spinner_6oipg_761", lK = "_spin_6oipg_761", dK = "_appearanceWhite_6oipg_784", cK = "_appearanceGreyscale_6oipg_791", uK = "_sizeSmall_6oipg_798", hK = "_sizeLarge_6oipg_801", gK = "_indeterminate_6oipg_804", pK = "_inverted_6oipg_808", fK = "_dots_6oipg_812", mK = "_dot_6oipg_812", vK = {
  loader: rK,
  spinner: aK,
  spin: lK,
  appearanceWhite: dK,
  appearanceGreyscale: cK,
  sizeSmall: uK,
  sizeLarge: hK,
  indeterminate: gK,
  inverted: pK,
  dots: fK,
  dot: mK,
  "dot-bounce": "_dot-bounce_6oipg_1"
}, we = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, CK = {
  $style: vK
}, rl = /* @__PURE__ */ we(iK, [["__cssModules", CK]]), wK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function yK(e, t) {
  return v(), y("svg", wK, [...t[0] || (t[0] = [
    R("path", { d: "M8 8.183v1.3H4.751v-1.3zm.7-.7v-3.25a.7.7 0 0 0-.7-.7H4.751a.7.7 0 0 0-.7.7v3.25a.7.7 0 0 0 .7.7v1.3l-.204-.011a2 2 0 0 1-1.785-1.785l-.011-.205V4.233a2 2 0 0 1 2-2H8l.204.011A2 2 0 0 1 10 4.234v3.248l-.01.205a2 2 0 0 1-1.786 1.785L8 9.482v-1.3a.7.7 0 0 0 .7-.7" }, null, -1),
    R("path", { d: "M7.198 8.964v4.7H10v1.3H6.548a.65.65 0 0 1-.65-.65v-5.35zm8.255 1.564q.095.01.188.029.048.01.094.023.048.01.094.024.05.015.097.033l.079.029q.059.024.115.053l.048.023q.059.03.114.066l.05.03q.042.027.082.057.043.03.084.062.03.023.057.048a2 2 0 0 1 .216.219l.036.043q.038.047.073.097l.046.067a2 2 0 0 1 .098.168q.019.037.036.075l.039.086.04.11q.012.032.023.068.018.059.031.119l.016.068q.039.19.04.393v3.249l-.01.204a2 2 0 0 1-.03.188l-.015.06q-.012.06-.029.118l-.023.07-.04.11-.028.062-.049.103q-.016.033-.035.066l-.057.094-.04.062-.057.076-.058.074q-.113.135-.249.247l-.05.04q-.044.035-.092.068-.036.025-.073.047-.037.025-.078.048a2 2 0 0 1-.338.152q-.04.016-.083.028-.054.016-.11.028l-.064.015a2 2 0 0 1-.188.029l-.204.01H12a2 2 0 0 1-.39-.038l-.077-.019-.1-.025-.083-.028a2 2 0 0 1-.338-.152q-.04-.023-.078-.048-.038-.022-.073-.047l-.091-.068-.05-.04a2 2 0 0 1-.255-.253l-.035-.045a2 2 0 0 1-.078-.105l-.033-.05-.061-.1-.035-.066-.05-.103-.027-.061-.04-.11-.023-.071-.03-.117-.014-.06a2 2 0 0 1-.028-.19L10 15.768v-3.25a2 2 0 0 1 2-2h3.249zm-1.829 1.115a.626.626 0 0 0-.625.625v1.25h-1.25a.626.626 0 1 0 0 1.25h1.25v1.25a.626.626 0 0 0 1.25 0v-1.25h1.25a.627.627 0 0 0 .442-1.068.63.63 0 0 0-.442-.182h-1.25v-1.25a.626.626 0 0 0-.625-.625" }, null, -1)
  ])]);
}
const bK = { render: yK }, SK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  fill: "currentColor"
};
function xK(e, t) {
  return v(), y("svg", SK, [...t[0] || (t[0] = [
    R("path", { d: "M9.375 39.375v-21h30V26.4a1.2 1.2 0 0 0 1.2 1.2h.6a1.2 1.2 0 0 0 1.2-1.2V9.375a3 3 0 0 0-3-3h-4.5v-1.5a1.5 1.5 0 1 0-3 0v1.5h-15v-1.5a1.5 1.5 0 1 0-3 0v1.5h-4.5a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3H22.8a1.2 1.2 0 0 0 1.2-1.2v-.6a1.2 1.2 0 0 0-1.2-1.2zm4.5-30v1.5a1.5 1.5 0 1 0 3 0v-1.5h15v1.5a1.5 1.5 0 1 0 3 0v-1.5h4.5v6h-30v-6z" }, null, -1),
    R("path", { d: "M40.8 36a7.2 7.2 0 1 0-7.2 7.2v2.4a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2v-2.4a7.2 7.2 0 0 0 7.2-7.2" }, null, -1),
    R("path", { d: "M32.4 31.2a1.2 1.2 0 0 1 2.4 0v3.6h3.6a1.2 1.2 0 0 1 0 2.4h-4.32a1.68 1.68 0 0 1-1.645-1.34l-.035-.34z" }, null, -1)
  ])]);
}
const RK = { render: xK }, EK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function AK(e, t) {
  return v(), y("svg", EK, [...t[0] || (t[0] = [
    R("path", { d: "M80 32H56a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m0 176H56V48h24Zm72-176h-24a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m0 176h-24V48h24Zm96-80a8 8 0 0 1-8 8h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 8 8" }, null, -1)
  ])]);
}
const FK = { render: AK }, MK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function IK(e, t) {
  return v(), y("svg", MK, [...t[0] || (t[0] = [
    R("path", { d: "M13.675 6.872v1.3h-3.249v-1.3zm.7-.7v-3.25a.7.7 0 0 0-.7-.7h-3.249a.7.7 0 0 0-.7.7v3.25a.7.7 0 0 0 .7.7v1.3l-.204-.011a2 2 0 0 1-1.785-1.786l-.01-.204V2.922a2 2 0 0 1 2-2h3.248l.204.011a2 2 0 0 1 1.796 1.99V6.17l-.01.204a2 2 0 0 1-1.786 1.786l-.204.01v-1.3a.7.7 0 0 0 .7-.7m-.495 5.67q.095.009.187.028.006 0 .011.002l.168.042.009.003q.043.013.085.029.048.016.095.035l.09.041.076.036.078.044.096.06.048.033q.053.037.103.076l.051.044a2 2 0 0 1 .218.219q.023.026.043.053.036.045.07.092l.038.055q.033.051.063.104l.035.062q.031.06.059.122l.018.04q.067.16.105.333l.01.041q.039.192.04.395v3.249l-.011.204a2 2 0 0 1-.028.185l-.016.063a2 2 0 0 1-.032.126l-.016.046a2 2 0 0 1-.224.466l-.025.038-.07.094-.049.064q-.114.134-.249.248l-.045.035a2 2 0 0 1-.104.078l-.05.032-.1.062-.067.035a2 2 0 0 1-.256.11l-.09.03-.116.029-.06.015a2 2 0 0 1-.188.029l-.204.01h-3.25l-.204-.01q-.012-.001-.022-.004a2 2 0 0 1-.164-.024l-.08-.02q-.048-.01-.094-.023-.048-.015-.095-.033l-.081-.029a2 2 0 0 1-.256-.124l-.054-.033-.095-.06-.058-.045a2 2 0 0 1-.408-.412l-.025-.034a2 2 0 0 1-.183-.32 2 2 0 0 1-.1-.264l-.018-.075a2 2 0 0 1-.063-.49V13.83c0-.622.284-1.177.728-1.543.346-.286.79-.457 1.273-.457h3.249zm-1.83 1.114a.626.626 0 0 0-.624.625v1.25h-1.25a.626.626 0 1 0 0 1.25h1.25v1.25a.624.624 0 1 0 1.25 0v-1.25h1.25a.625.625 0 0 0 0-1.25h-1.25v-1.25a.627.627 0 0 0-.625-.625" }, null, -1),
    R("path", { d: "M9.265 5.39H5.624v9.96h3.64v1.3h-4.29a.65.65 0 0 1-.65-.65V4.74a.65.65 0 0 1 .65-.65h4.29z" }, null, -1)
  ])]);
}
const PK = { render: IK }, DK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function TK(e, t) {
  return v(), y("svg", DK, [...t[0] || (t[0] = [
    R("path", { d: "M11.576 16.664V3.83a1.283 1.283 0 0 1 1.283-1.284h3.85a1.283 1.283 0 0 1 1.283 1.284v12.833a1.283 1.283 0 0 1-1.283 1.283h-3.85a1.283 1.283 0 0 1-1.283-1.283m5.133 0V3.83h-3.85v12.833zm-1.925-1.284a.962.962 0 1 0 0-1.924.962.962 0 0 0 0 1.924m-12.618.158L5.035 3.029a1.283 1.283 0 0 1 1.538-.964l3.752.86a1.283 1.283 0 0 1 .964 1.538L8.42 16.971a1.283 1.283 0 0 1-1.537.964l-3.753-.86a1.283 1.283 0 0 1-.964-1.538m5.004 1.147 2.868-12.508-3.752-.86-2.869 12.508zm-1.59-1.68a.963.963 0 1 0 .43-1.878.963.963 0 0 0-.43 1.877" }, null, -1)
  ])]);
}
const kK = { render: TK }, LK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
};
function BK(e, t) {
  return v(), y("svg", LK, [...t[0] || (t[0] = [
    R("path", { d: "m13.174 2.453-8.14-1.437a1 1 0 0 0-1.159.81L2.015 12.39a1 1 0 0 0 .813 1.159l8.14 1.437a1 1 0 0 0 1.16-.812L13.987 3.61a1 1 0 0 0-.813-1.157M11.14 14 3 12.563 4.86 2 13 3.438zM5.584 3.651a.5.5 0 0 1 .58-.405l5.187.916a.5.5 0 1 1-.175.985L5.99 4.23a.5.5 0 0 1-.405-.58m-.347 1.97a.5.5 0 0 1 .58-.405l5.187.916a.5.5 0 1 1-.175.985L5.64 6.2a.5.5 0 0 1-.404-.58M4.89 7.59a.5.5 0 0 1 .579-.404l2.592.456a.5.5 0 1 1-.173.985L5.295 8.17a.5.5 0 0 1-.404-.58" }, null, -1)
  ])]);
}
const OK = { render: BK }, GK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
};
function HK(e, t) {
  return v(), y("svg", GK, [...t[0] || (t[0] = [
    R("circle", {
      cx: "8",
      cy: "8",
      r: "4"
    }, null, -1)
  ])]);
}
const VK = { render: HK }, _K = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function NK(e, t) {
  return v(), y("svg", _K, [...t[0] || (t[0] = [
    R("path", { d: "M7 10.5H5.5v-3H7a1.5 1.5 0 1 1 0 3" }, null, -1),
    R("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm7.5 8.375c0-.483.392-.875.875-.875h.875c.723 0 1.036.202 1.158.31a.5.5 0 0 1 .124.157.75.75 0 0 0 1.446-.399l-.728.182c.728-.182.727-.183.727-.183v-.004l-.002-.005-.003-.012a1.5 1.5 0 0 0-.129-.31 2 2 0 0 0-.438-.547C14.964 6.298 14.277 6 13.25 6h-.875A2.375 2.375 0 0 0 10 8.375c0 .81.55 1.415 1.082 1.771.55.37 1.256.604 1.918.604.338 0 .756.13 1.082.348.343.232.418.44.418.527a.875.875 0 0 1-.875.875h-.875c-.723 0-1.036-.202-1.158-.31a.5.5 0 0 1-.122-.152l-.002-.005a.75.75 0 0 0-1.446.399l.728-.182c-.728.182-.727.183-.727.183v.004l.002.005.003.012.008.028q.01.032.026.074.031.087.095.208c.087.16.225.357.438.547.441.391 1.128.689 2.155.689h.875A2.375 2.375 0 0 0 16 11.625c0-.81-.55-1.415-1.082-1.772-.55-.37-1.256-.603-1.918-.603-.338 0-.756-.13-1.082-.348-.343-.232-.418-.44-.418-.527M4.75 6a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0V12H7a3 3 0 1 0 0-6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const $K = { render: NK }, zK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
};
function WK(e, t) {
  return v(), y("svg", zK, [...t[0] || (t[0] = [
    R("path", { d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M5.466 4.728V12h1.317V9.337h1.341L9.553 12h1.47L9.449 9.12q.072-.028.139-.06a1.97 1.97 0 0 0 .87-.792q.299-.516.299-1.214 0-.696-.295-1.219a2 2 0 0 0-.863-.816q-.57-.292-1.407-.291zm2.524 1.1q.494 0 .806.146a.97.97 0 0 1 .466.419q.152.274.152.66 0 .389-.152.654a.96.96 0 0 1-.462.401q-.313.135-.803.135H6.783V5.828z" }, null, -1)
  ])]);
}
const UK = { render: WK }, KK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  fill: "currentColor"
};
function ZK(e, t) {
  return v(), y("svg", KK, [...t[0] || (t[0] = [
    R("path", { d: "M82.37 50.191a4.167 4.167 0 0 1 5.89.036l7.357 7.447a4.167 4.167 0 0 1-.036 5.892l-24.04 23.746a2.9 2.9 0 0 1-1.696.819l-9.018 1.11c-2.727.335-5.025-2.017-4.63-4.736l1.233-8.496a4.17 4.17 0 0 1 1.196-2.364zm-.078-29.358a3.125 3.125 0 0 1 3.125 3.125v16.667a3.125 3.125 0 0 1-6.25 0v-9.562L46.903 60.637a3.13 3.13 0 0 1-2.111.826 3.13 3.13 0 0 1-2.112-.826L10.417 31.063v46.02h31.25a3.126 3.126 0 0 1 0 6.25h-31.25a6.25 6.25 0 0 1-6.25-6.25V23.958a3.125 3.125 0 0 1 3.125-3.125zM63.127 77.405l-.843 5.781 5.867-.72 16.391-16.198-5.009-5.07zm20.557-20.308 5.012 5.078 1.604-1.587-5.018-5.074zm-38.892-3.003 29.463-27.011H15.328z" }, null, -1)
  ])]);
}
const qK = { render: ZK }, jK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  fill: "currentColor"
};
function YK(e, t) {
  return v(), y("svg", jK, [...t[0] || (t[0] = [
    R("path", { d: "M82.292 20.833a3.126 3.126 0 0 1 3.125 3.125v16.667a3.125 3.125 0 0 1-6.25 0v-9.562L46.903 60.637a3.12 3.12 0 0 1-2.111.825 3.13 3.13 0 0 1-2.112-.825L10.417 31.063v46.02h68.75v-3.125a3.126 3.126 0 0 1 6.25 0v3.125a6.25 6.25 0 0 1-6.25 6.25h-68.75a6.25 6.25 0 0 1-6.25-6.25V23.958a3.125 3.125 0 0 1 3.125-3.125zm-16.5 30.074a2.787 2.787 0 1 1 4.004 3.874l-2.812 2.742c10.624-2.467 22.129 1.523 27.482 8.656.941 1.254.328 2.979-1.103 3.62-1.312.589-2.842.04-3.78-1.049-1.67-1.94-4.16-3.687-7.527-5.037-4.772-1.911-8.46-1.33-15.17-.75l2.515 2.491a2.89 2.89 0 1 1-4.098 4.077l-5.781-5.916a4.17 4.17 0 0 1-.098-5.721zm-21 3.187 29.463-27.011H15.328z" }, null, -1)
  ])]);
}
const QK = { render: YK }, JK = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  fill: "currentColor"
};
function XK(e, t) {
  return v(), y("svg", JK, [...t[0] || (t[0] = [
    R("path", { d: "M82.292 20.833a3.125 3.125 0 0 1 3.125 3.125v16.667a3.125 3.125 0 0 1-6.25 0v-9.562L46.904 60.636c-.577.53-1.33.826-2.112.826a3.13 3.13 0 0 1-2.112-.826L10.417 31.063v46.02h68.75v-3.125a3.125 3.125 0 0 1 6.25 0v3.125a6.25 6.25 0 0 1-6.25 6.25h-68.75a6.25 6.25 0 0 1-6.25-6.25V23.958a3.124 3.124 0 0 1 3.125-3.125zm1.131 27.137a2.786 2.786 0 0 1 3.613.43l6.368 6.987a4.17 4.17 0 0 1-.097 5.721l-5.782 5.917a2.89 2.89 0 0 1-4 .126 2.89 2.89 0 0 1-.098-4.203l2.515-2.49c-6.71-.582-12.831.314-17.603 2.225-3.368 1.35-5.857 3.097-7.527 5.038-.938 1.09-2.469 1.637-3.78 1.05-1.432-.643-2.045-2.368-1.103-3.622 5.353-7.133 16.859-11.123 29.915-10.132l-2.811-2.742a2.785 2.785 0 0 1 .39-4.305M15.328 27.083l29.464 27.01 29.464-27.01z" }, null, -1)
  ])]);
}
const eZ = { render: XK }, tZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nZ(e, t) {
  return v(), y("svg", tZ, [...t[0] || (t[0] = [
    R("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }, null, -1),
    R("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      d: "M32 64h72m-72 64h136M32 192h136"
    }, null, -1),
    R("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      d: "M224 192V64h-72"
    }, null, -1),
    R("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      d: "m176 40-24 24 24 24"
    }, null, -1)
  ])]);
}
const oZ = { render: nZ }, sZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iZ(e, t) {
  return v(), y("svg", sZ, [...t[0] || (t[0] = [
    R("path", { d: "M208 112H48a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16m0 40H48v-24h160zm0-112H48a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16m0 40H48V56h160zm-48 136a8 8 0 0 1-8 8h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 8 8" }, null, -1)
  ])]);
}
const rZ = { render: iZ }, aZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 95 24",
  fill: "currentColor"
};
function lZ(e, t) {
  return v(), y("svg", aZ, [...t[0] || (t[0] = [
    R("path", {
      "fill-rule": "evenodd",
      d: "m47.957 18.224-.289-2.6c-.923.116-2.278.145-4.095.116q-1.167 0-1.557-.78c-.26-.49-.403-1.501-.403-2.974s.144-2.456.403-2.975q.39-.78 1.557-.78c1.27 0 2.567.029 3.836.058l.26-2.628c-1.154-.318-2.51-.491-4.096-.491-2.076 0-3.518.52-4.383 1.53-.836 1.011-1.269 2.773-1.269 5.286s.404 4.274 1.27 5.285c.835 1.01 2.306 1.53 4.382 1.53 1.788 0 3.26-.173 4.384-.577m-17.85-5.343 2.595 1.04c.348.124.59.249.723.318l.055.028c.116.144.202.347.202.664 0 .347-.115.549-.317.665s-.605.173-1.24.173c-.461 0-1.961-.029-4.527-.087l-.202 2.542a20 20 0 0 0 4.758.578c1.932 0 3.258-.29 3.98-.838.72-.549 1.095-1.56 1.095-3.061 0-.982-.201-1.791-.634-2.398-.433-.606-1.154-1.097-2.192-1.53l-2.393-.924c-.49-.174-.808-.318-.98-.491-.174-.145-.26-.376-.26-.665 0-.346.115-.548.317-.664.202-.086.606-.144 1.21-.144q.589.002 1.991.024l2.336.034.23-2.34c-1.182-.375-2.681-.577-4.498-.577-1.904 0-3.201.26-3.951.78-.72.49-1.096 1.501-1.096 2.974 0 .982.202 1.762.635 2.368.432.607 1.153 1.098 2.162 1.531m26.068 0L55.34 9.5c-.144-.663-.23-1.126-.23-1.386h-.52q-.13.737-.26 1.387l-.836 3.379zm.664 2.6h-3.98l-.779 3.118h-3.604l3.547-12.216c.057-.29.201-.491.432-.664s.462-.26.75-.26h3.259c.288 0 .547.086.75.26.23.173.374.404.432.664l3.547 12.216h-3.605zm10.093 3.118v-4.216L71.2 5.459h-3.634l-1.874 4.447c-.116.289-.26.867-.433 1.762h-.23c-.116-.78-.26-1.386-.433-1.762L62.72 5.46h-3.633l4.297 8.953V18.6zM75.64 5.43v9.473c0 .55.288.81.894.81h4.383l.173 2.685c-1.24.144-3.201.231-5.97.231q-1.426 0-2.249-.78c-.519-.52-.778-1.242-.778-2.108V5.43zm13.005 4.073.836 3.379H86.8l.836-3.38q.13-.649.26-1.386h.518c0 .26.087.723.231 1.387m-2.509 5.978h3.98l.778 3.12H94.5L90.953 6.382a1.13 1.13 0 0 0-.432-.664 1.13 1.13 0 0 0-.75-.26h-3.259c-.288 0-.519.086-.75.26-.23.173-.374.375-.432.664l-3.576 12.216h3.605z",
      "clip-rule": "evenodd"
    }, null, -1),
    R("path", { d: "M4.874 17.502a9.5 9.5 0 0 0 3.114 1.068c.087 0 .144.03.23.03.405.057.78.086 1.183.115q.995.086 1.99.086c2.047 0 3.46-.288 4.268-.837.778-.549 1.182-1.589 1.182-3.062 0-.981-.23-1.79-.692-2.396-.462-.607-1.24-1.127-2.365-1.531l-2.566-.925c-.52-.173-.865-.317-1.038-.49-.202-.145-.289-.376-.289-.665 0-.346.116-.577.346-.664.231-.116.664-.145 1.298-.145h.721c.548 0 1.096.03 1.673.087.057 0 .432.058.49.058a6.28 6.28 0 0 1 3.547 1.675 6.6 6.6 0 0 1 2.047 4.794 6.607 6.607 0 0 1-6.603 6.614 6.48 6.48 0 0 1-3.894-1.27H5.768A9.27 9.27 0 0 0 13.38 24c5.161 0 9.343-4.188 9.343-9.357a9.37 9.37 0 0 0-4.787-8.174 9.1 9.1 0 0 0-3.23-1.068h-.029c-.144-.03-.317-.03-.49-.058a25 25 0 0 0-2.653-.144q-3.027 0-4.24.78c-.778.52-1.181 1.501-1.181 2.974 0 .982.23 1.762.692 2.368.461.607 1.24 1.127 2.307 1.531l2.768 1.04q.649.216.865.433c.144.144.23.375.23.664 0 .318-.114.549-.345.665a2.6 2.6 0 0 1-.75.173c-1.845.173-3.316.058-4.47-.26-.201-.058-.375-.087-.548-.145-.26-.086-.605-.26-.894-.404-1.759-.895-2.508-2.426-2.912-3.668a6.6 6.6 0 0 1-.317-1.993 6.61 6.61 0 0 1 6.603-6.613 6.48 6.48 0 0 1 3.893 1.27h3.75C15.283 1.589 12.485 0 9.342 0 4.181 0 0 4.188 0 9.357a9.62 9.62 0 0 0 4.874 8.145" }, null, -1)
  ])]);
}
const dZ = { render: lZ }, cZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 209",
  fill: "currentColor"
};
function uZ(e, t) {
  return v(), y("svg", cZ, [...t[0] || (t[0] = [
    R("path", { d: "M42.1 150.96c7.973 4.483 17.438 7.723 26.904 9.216.749 0 1.244.25 1.992.25 3.49.499 6.726.748 10.215.997q8.592.745 17.188.745c17.688 0 29.891-2.491 36.869-7.224 6.725-4.732 10.211-13.699 10.211-26.405 0-8.468-1.993-15.442-5.977-20.674-3.988-5.232-10.713-9.715-20.428-13.204l-22.171-7.972c-4.484-1.494-7.47-2.738-8.967-4.234-1.743-1.244-2.491-3.237-2.491-5.731 0-2.987.997-4.98 2.99-5.728 1.992-.997 5.73-1.247 11.208-1.247h6.23c4.733 0 9.466.25 14.448.749.499 0 3.735.498 4.234.498 11.957 1.494 22.42 6.726 30.639 14.449 10.962 10.463 17.687 25.161 17.687 41.352 0 31.636-25.656 57.044-57.044 57.044-12.705 0-24.163-3.985-33.632-10.96H49.823c14.448 20.675 38.612 34.128 65.765 34.128 44.588 0 80.708-36.12 80.708-80.711 0-30.144-16.689-56.798-41.352-70.498-8.468-4.733-18.183-7.972-27.898-9.216h-.249c-1.244-.25-2.741-.25-4.234-.5a215 215 0 0 0-22.92-1.243c-17.438 0-29.641 2.242-36.619 6.725-6.725 4.483-10.21 12.955-10.21 25.657 0 8.471 1.992 15.196 5.976 20.428 3.988 5.232 10.713 9.715 19.93 13.204l23.913 8.967c3.739 1.244 6.227 2.491 7.474 3.735 1.244 1.247 1.992 3.24 1.992 5.731 0 2.74-.994 4.733-2.99 5.73-1.244.496-3.486 1.244-6.476 1.494-15.941 1.493-28.646.499-38.611-2.242-1.743-.499-3.24-.748-4.733-1.247-2.242-.745-5.232-2.242-7.723-3.486C36.37 121.814 29.894 108.61 26.405 97.9c-1.743-5.48-2.737-11.211-2.737-17.188 0-31.637 25.656-57.048 57.044-57.048 12.705 0 24.163 3.988 33.629 10.963h32.385C132.028 13.7 107.865 0 80.712 0 36.12 0 0 36.12 0 80.712c.748 30.143 17.438 56.299 42.1 70.248" }, null, -1)
  ])]);
}
const hZ = { render: uZ }, gZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
};
function pZ(e, t) {
  return v(), y("svg", gZ, [...t[0] || (t[0] = [
    R("path", { d: "M13 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m0 11H3V3h10z" }, null, -1),
    R("path", { d: "M6 10.667v-6h1.166v5.089H10v.91z" }, null, -1)
  ])]);
}
const fZ = { render: pZ }, mZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
};
function vZ(e, t) {
  return v(), y("svg", mZ, [...t[0] || (t[0] = [
    R("path", { d: "M13 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m0 11H3V3h10z" }, null, -1),
    R("path", { d: "M4.667 4.667h1.409l1.887 4.347h.074l1.887-4.347h1.41v6h-1.106V6.545h-.059l-1.756 4.104h-.826L5.831 6.536h-.06v4.13H4.668z" }, null, -1)
  ])]);
}
const CZ = { render: vZ }, wZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
};
function yZ(e, t) {
  return v(), y("svg", wZ, [...t[0] || (t[0] = [
    R("path", { d: "M13 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m0 11H3V3h10z" }, null, -1),
    R("path", { d: "M9.07 6.448a.78.78 0 0 0-.336-.58q-.293-.207-.761-.207-.33 0-.566.1a.84.84 0 0 0-.36.27.66.66 0 0 0-.046.704.75.75 0 0 0 .23.227q.146.09.321.154.177.061.355.105l.546.136q.33.077.633.207.307.131.549.33.244.2.386.48.142.281.142.66 0 .51-.261.9-.261.386-.756.605-.491.216-1.19.216-.68 0-1.18-.21a1.76 1.76 0 0 1-.778-.614q-.278-.404-.3-.983h1.036a.9.9 0 0 0 .188.506q.165.201.429.3.267.1.596.1.344 0 .603-.102a1 1 0 0 0 .409-.29.7.7 0 0 0 .15-.437.56.56 0 0 0-.133-.375 1 1 0 0 0-.367-.25 3.5 3.5 0 0 0-.545-.182l-.662-.17q-.72-.185-1.137-.56-.414-.378-.414-1.003a1.5 1.5 0 0 1 .278-.9 1.84 1.84 0 0 1 .764-.6 2.65 2.65 0 0 1 1.094-.216q.62 0 1.085.216.47.213.736.594.267.377.276.869z" }, null, -1)
  ])]);
}
const bZ = { render: yZ }, SZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function xZ(e, t) {
  return v(), y("svg", SZ, [...t[0] || (t[0] = [
    R("path", { d: "M18.427 18.073a.25.25 0 0 1 .054.273.25.25 0 0 1-.408.08L16 16.354l-2.073 2.074a.25.25 0 0 1-.354-.354L15.647 16l-2.074-2.073a.25.25 0 0 1 .354-.354L16 15.646l2.073-2.073a.25.25 0 1 1 .354.354L16.354 16zM15.625 4.375A.625.625 0 0 1 15 5h-2.674L8.992 15h2.258a.624.624 0 1 1 0 1.25H5A.625.625 0 1 1 5 15h2.674l3.334-10H8.75a.625.625 0 0 1 0-1.25H15a.625.625 0 0 1 .625.625" }, null, -1)
  ])]);
}
const RZ = { render: xZ }, EZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function AZ(e, t) {
  return v(), y("svg", EZ, [...t[0] || (t[0] = [
    R("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }, null, -1)
  ])]);
}
const FZ = { render: AZ }, MZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function IZ(e, t) {
  return v(), y("svg", MZ, [...t[0] || (t[0] = [
    R("path", {
      d: "M104,104V208H40a8,8,0,0,1-8-8V104Z",
      opacity: "0.2"
    }, null, -1),
    R("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z" }, null, -1)
  ])]);
}
const PZ = { render: IZ }, DZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function TZ(e, t) {
  return v(), y("svg", DZ, [...t[0] || (t[0] = [
    R("path", {
      d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
      opacity: "0.2"
    }, null, -1),
    R("path", { d: "M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const kZ = { render: TZ }, LZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function BZ(e, t) {
  return v(), y("svg", LZ, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }, null, -1)
  ])]);
}
const OZ = { render: BZ }, GZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function HZ(e, t) {
  return v(), y("svg", GZ, [...t[0] || (t[0] = [
    R("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }, null, -1)
  ])]);
}
const VZ = { render: HZ }, _Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function NZ(e, t) {
  return v(), y("svg", _Z, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const $Z = { render: NZ }, zZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function WZ(e, t) {
  return v(), y("svg", zZ, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }, null, -1)
  ])]);
}
const UZ = { render: WZ }, KZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ZZ(e, t) {
  return v(), y("svg", KZ, [...t[0] || (t[0] = [
    R("path", { d: "M234.29,114.85l-45,38.83L203,211.75a16.4,16.4,0,0,1-24.5,17.82L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,59,4.76a16.46,16.46,0,0,1,9.37,28.86Z" }, null, -1)
  ])]);
}
const qZ = { render: ZZ }, jZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function YZ(e, t) {
  return v(), y("svg", jZ, [...t[0] || (t[0] = [
    R("path", { d: "M235.33,116.72,139.28,20.66a16,16,0,0,0-22.56,0l-96,96.06a16,16,0,0,0,0,22.56l96.05,96.06h0a16,16,0,0,0,22.56,0l96.05-96.06a16,16,0,0,0,0-22.56ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, null, -1)
  ])]);
}
const QZ = { render: YZ }, JZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function XZ(e, t) {
  return v(), y("svg", JZ, [...t[0] || (t[0] = [
    R("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }, null, -1)
  ])]);
}
const eq = { render: XZ }, tq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nq(e, t) {
  return v(), y("svg", tq, [...t[0] || (t[0] = [
    R("path", { d: "M83.19,174.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,163,141.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,81.6,163.2,8,8,0,0,0,83.19,174.4ZM112,112a24,24,0,1,1,24,24A24,24,0,0,1,112,112Zm96-88H64A16,16,0,0,0,48,40V64H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V40A16,16,0,0,0,208,24Zm0,192H64V40H208Z" }, null, -1)
  ])]);
}
const oq = { render: nq }, sq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iq(e, t) {
  return v(), y("svg", sq, [...t[0] || (t[0] = [
    R("path", { d: "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM240,96v64a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V96A16,16,0,0,1,72,80H224A16,16,0,0,1,240,96Zm-16,64V96H72v64H224Z" }, null, -1)
  ])]);
}
const rq = { render: iq }, aq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lq(e, t) {
  return v(), y("svg", aq, [...t[0] || (t[0] = [
    R("path", { d: "M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm16,64V64A16,16,0,0,1,80,48h96a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H80A16,16,0,0,1,64,104Zm16,0h96V64H80Zm152,48v40a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16H216A16,16,0,0,1,232,152Zm-16,40V152H80v40H216Z" }, null, -1)
  ])]);
}
const dq = { render: lq }, cq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uq(e, t) {
  return v(), y("svg", cq, [...t[0] || (t[0] = [
    R("path", { d: "M85.66,146.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,61.66L43.31,104ZM128,96H99.31l34.35-34.34a8,8,0,0,0-11.32-11.32l-48,48a8,8,0,0,0,0,11.32l48,48a8,8,0,0,0,11.32-11.32L99.31,112H128a88.1,88.1,0,0,1,88,88,8,8,0,0,0,16,0A104.11,104.11,0,0,0,128,96Z" }, null, -1)
  ])]);
}
const hq = { render: uq }, gq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pq(e, t) {
  return v(), y("svg", gq, [...t[0] || (t[0] = [
    R("path", { d: "M208,32a8,8,0,0,1-8,8,88.1,88.1,0,0,0-88,88v76.69l34.34-34.35a8,8,0,0,1,11.32,11.32l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L96,204.69V128A104.11,104.11,0,0,1,200,24,8,8,0,0,1,208,32Z" }, null, -1)
  ])]);
}
const fq = { render: pq }, mq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vq(e, t) {
  return v(), y("svg", mq, [...t[0] || (t[0] = [
    R("path", { d: "M205.66,181.66l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L144,204.69V128A88.1,88.1,0,0,0,56,40a8,8,0,0,1,0-16A104.11,104.11,0,0,1,160,128v76.69l34.34-34.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const Cq = { render: vq }, wq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yq(e, t) {
  return v(), y("svg", wq, [...t[0] || (t[0] = [
    R("path", { d: "M232,200a8,8,0,0,1-16,0,88.1,88.1,0,0,0-88-88H51.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,61.66L51.31,96H128A104.11,104.11,0,0,1,232,200Z" }, null, -1)
  ])]);
}
const bq = { render: yq }, Sq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xq(e, t) {
  return v(), y("svg", Sq, [...t[0] || (t[0] = [
    R("path", { d: "M229.66,109.66l-48,48a8,8,0,0,1-11.32-11.32L204.69,112H128a88.1,88.1,0,0,0-88,88,8,8,0,0,1-16,0A104.11,104.11,0,0,1,128,96h76.69L170.34,61.66a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,229.66,109.66Z" }, null, -1)
  ])]);
}
const Rq = { render: xq }, Eq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Aq(e, t) {
  return v(), y("svg", Eq, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a96,96,0,0,1-94.71,96H128A95.38,95.38,0,0,1,62.1,197.8a8,8,0,0,1,11-11.63A80,80,0,1,0,71.43,71.39a3.07,3.07,0,0,1-.26.25L44.59,96H72a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V56a8,8,0,0,1,16,0V85.8L60.25,60A96,96,0,0,1,224,128Z" }, null, -1)
  ])]);
}
const Fq = { render: Aq }, Mq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Iq(e, t) {
  return v(), y("svg", Mq, [...t[0] || (t[0] = [
    R("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const Pq = { render: Iq }, Dq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Tq(e, t) {
  return v(), y("svg", Dq, [...t[0] || (t[0] = [
    R("path", { d: "M200,32V176a8,8,0,0,1-8,8H67.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48a8,8,0,0,1,11.32,11.32L67.31,168H184V32a8,8,0,0,1,16,0Z" }, null, -1)
  ])]);
}
const kq = { render: Tq }, Lq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Bq(e, t) {
  return v(), y("svg", Lq, [...t[0] || (t[0] = [
    R("path", { d: "M229.66,114.34l-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v80a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16V128h40a8,8,0,0,0,5.66-13.66ZM176,112a8,8,0,0,0-8,8v88H88V120a8,8,0,0,0-8-8H51.31L128,35.31,204.69,112Z" }, null, -1)
  ])]);
}
const Oq = { render: Bq }, Gq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hq(e, t) {
  return v(), y("svg", Gq, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z" }, null, -1)
  ])]);
}
const Vq = { render: Hq }, _q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Nq(e, t) {
  return v(), y("svg", _q, [...t[0] || (t[0] = [
    R("path", { d: "M50.34,117.66a8,8,0,0,1,11.32-11.32L120,164.69V32a8,8,0,0,1,16,0V164.69l58.34-58.35a8,8,0,0,1,11.32,11.32l-72,72a8,8,0,0,1-11.32,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const $q = { render: Nq }, zq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Wq(e, t) {
  return v(), y("svg", zq, [...t[0] || (t[0] = [
    R("path", { d: "M232,128a8,8,0,0,1-8,8H91.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L91.31,120H224A8,8,0,0,1,232,128ZM40,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,40,32Z" }, null, -1)
  ])]);
}
const Uq = { render: Wq }, Kq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zq(e, t) {
  return v(), y("svg", Kq, [...t[0] || (t[0] = [
    R("path", { d: "M189.66,122.34a8,8,0,0,1,0,11.32l-72,72a8,8,0,0,1-11.32-11.32L164.69,136H32a8,8,0,0,1,0-16H164.69L106.34,61.66a8,8,0,0,1,11.32-11.32ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z" }, null, -1)
  ])]);
}
const qq = { render: Zq }, jq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yq(e, t) {
  return v(), y("svg", jq, [...t[0] || (t[0] = [
    R("path", { d: "M205.66,138.34a8,8,0,0,1-11.32,11.32L136,91.31V224a8,8,0,0,1-16,0V91.31L61.66,149.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const Qq = { render: Yq }, Jq = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xq(e, t) {
  return v(), y("svg", Jq, [...t[0] || (t[0] = [
    R("path", { d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z" }, null, -1)
  ])]);
}
const ej = { render: Xq }, tj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nj(e, t) {
  return v(), y("svg", tj, [...t[0] || (t[0] = [
    R("path", { d: "M232,144a64.07,64.07,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H51.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,45.66L51.31,80H168A64.07,64.07,0,0,1,232,144Z" }, null, -1)
  ])]);
}
const oj = { render: nj }, sj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ij(e, t) {
  return v(), y("svg", sj, [...t[0] || (t[0] = [
    R("path", { d: "M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z" }, null, -1)
  ])]);
}
const rj = { render: ij }, aj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lj(e, t) {
  return v(), y("svg", aj, [...t[0] || (t[0] = [
    R("path", { d: "M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V76.69L62.63,62.06A95.43,95.43,0,0,1,130,33.94h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.56,79.56,0,0,0,73.94,73.37L59.31,88H88a8,8,0,0,1,0,16Zm128,48H168a8,8,0,0,0,0,16h28.69l-14.63,14.63a79.56,79.56,0,0,1-56.13,23.43h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.43,95.43,0,0,0,67.36-28.12L208,179.31V208a8,8,0,0,0,16,0V160A8,8,0,0,0,216,152Z" }, null, -1)
  ])]);
}
const dj = { render: lj }, cj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uj(e, t) {
  return v(), y("svg", cj, [...t[0] || (t[0] = [
    R("path", { d: "M117.66,170.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L72,188.69V48a8,8,0,0,1,16,0V188.69l18.34-18.35A8,8,0,0,1,117.66,170.34Zm96-96-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L168,67.31V208a8,8,0,0,0,16,0V67.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z" }, null, -1)
  ])]);
}
const hj = { render: uj }, gj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pj(e, t) {
  return v(), y("svg", gj, [...t[0] || (t[0] = [
    R("path", { d: "M237.66,133.66l-32,32a8,8,0,0,1-11.32-11.32L212.69,136H43.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L43.31,120H212.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,133.66Z" }, null, -1)
  ])]);
}
const fj = { render: pj }, mj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vj(e, t) {
  return v(), y("svg", mj, [...t[0] || (t[0] = [
    R("path", { d: "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM69.66,90.34a8,8,0,0,0-11.32,11.32L76.69,120H16a8,8,0,0,0,0,16H76.69L58.34,154.34a8,8,0,0,0,11.32,11.32l32-32a8,8,0,0,0,0-11.32ZM240,120H179.31l18.35-18.34a8,8,0,0,0-11.32-11.32l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32L179.31,136H240a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const Cj = { render: vj }, wj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yj(e, t) {
  return v(), y("svg", wj, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM122.34,101.66a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32L136,76.69V16a8,8,0,0,0-16,0V76.69L101.66,58.34A8,8,0,0,0,90.34,69.66Zm11.32,52.68a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L120,179.31V240a8,8,0,0,0,16,0V179.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z" }, null, -1)
  ])]);
}
const bj = { render: yj }, Sj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xj(e, t) {
  return v(), y("svg", Sj, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z" }, null, -1)
  ])]);
}
const Rj = { render: xj }, Ej = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Aj(e, t) {
  return v(), y("svg", Ej, [...t[0] || (t[0] = [
    R("path", { d: "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM96,120H35.31l18.35-18.34A8,8,0,0,0,42.34,90.34l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32L35.31,136H96a8,8,0,0,0,0-16Zm149.66,2.34-32-32a8,8,0,0,0-11.32,11.32L220.69,120H160a8,8,0,0,0,0,16h60.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,245.66,122.34Z" }, null, -1)
  ])]);
}
const Fj = { render: Aj }, Mj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ij(e, t) {
  return v(), y("svg", Mj, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z" }, null, -1)
  ])]);
}
const Pj = { render: Ij }, Dj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Tj(e, t) {
  return v(), y("svg", Dj, [...t[0] || (t[0] = [
    R("path", { d: "M216,48V96a8,8,0,0,1-16,0V67.31l-42.34,42.35a8,8,0,0,1-11.32-11.32L188.69,56H160a8,8,0,0,1,0-16h48A8,8,0,0,1,216,48ZM98.34,146.34,56,188.69V160a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8H96a8,8,0,0,0,0-16H67.31l42.35-42.34a8,8,0,0,0-11.32-11.32ZM208,152a8,8,0,0,0-8,8v28.69l-42.34-42.35a8,8,0,0,0-11.32,11.32L188.69,200H160a8,8,0,0,0,0,16h48a8,8,0,0,0,8-8V160A8,8,0,0,0,208,152ZM67.31,56H96a8,8,0,0,0,0-16H48a8,8,0,0,0-8,8V96a8,8,0,0,0,16,0V67.31l42.34,42.35a8,8,0,0,0,11.32-11.32Z" }, null, -1)
  ])]);
}
const kj = { render: Tj }, Lj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Bj(e, t) {
  return v(), y("svg", Lj, [...t[0] || (t[0] = [
    R("path", { d: "M128,96H232a8,8,0,0,1,0,16H128a8,8,0,0,1,0-16Zm104,32H128a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm0,32H80a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm0,32H80a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM96,144a8,8,0,0,0,0-16H88V64h32v8a8,8,0,0,0,16,0V56a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V72a8,8,0,0,0,16,0V64H72v64H64a8,8,0,0,0,0,16Z" }, null, -1)
  ])]);
}
const Oj = { render: Bj }, Gj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hj(e, t) {
  return v(), y("svg", Gj, [...t[0] || (t[0] = [
    R("path", { d: "M128,24a104,104,0,0,0,0,208c21.51,0,44.1-6.48,60.43-17.33a8,8,0,0,0-8.86-13.33C166,210.38,146.21,216,128,216a88,88,0,1,1,88-88c0,26.45-10.88,32-20,32s-20-5.55-20-32V88a8,8,0,0,0-16,0v4.26a48,48,0,1,0,5.93,65.1c6,12,16.35,18.64,30.07,18.64,22.54,0,36-17.94,36-48A104.11,104.11,0,0,0,128,24Zm0,136a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }, null, -1)
  ])]);
}
const Vj = { render: Hj }, _j = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Nj(e, t) {
  return v(), y("svg", _j, [...t[0] || (t[0] = [
    R("path", { d: "M24,104H48v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16H208V104h24a8,8,0,0,0,4.19-14.81l-104-64a8,8,0,0,0-8.38,0l-104,64A8,8,0,0,0,24,104Zm40,0H96v64H64Zm80,0v64H112V104Zm48,64H160V104h32ZM128,41.39,203.74,88H52.26ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208Z" }, null, -1)
  ])]);
}
const $j = { render: Nj }, zj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Wj(e, t) {
  return v(), y("svg", zj, [...t[0] || (t[0] = [
    R("path", { d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM80,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,80,80Zm104,88V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0ZM144,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,144,80Zm-32,0a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,112,80Z" }, null, -1)
  ])]);
}
const Uj = { render: Wj }, Kj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zj(e, t) {
  return v(), y("svg", Kj, [...t[0] || (t[0] = [
    R("path", { d: "M200,56H32A24,24,0,0,0,8,80v96a24,24,0,0,0,24,24H200a24,24,0,0,0,24-24V80A24,24,0,0,0,200,56Zm8,120a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Zm48-80v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0ZM138.81,123.79a8,8,0,0,1,.35,7.79l-16,32a8,8,0,0,1-14.32-7.16L119.06,136H100a8,8,0,0,1-7.16-11.58l16-32a8,8,0,1,1,14.32,7.16L112.94,120H132A8,8,0,0,1,138.81,123.79Z" }, null, -1)
  ])]);
}
const qj = { render: Zj }, jj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yj(e, t) {
  return v(), y("svg", jj, [...t[0] || (t[0] = [
    R("path", { d: "M48,48V208H80a8,8,0,0,1,0,16H40a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Z" }, null, -1)
  ])]);
}
const Qj = { render: Yj }, Jj = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xj(e, t) {
  return v(), y("svg", Jj, [...t[0] || (t[0] = [
    R("path", { d: "M235.5,216.81c-22.56-11-35.5-34.58-35.5-64.8V134.73a15.94,15.94,0,0,0-10.09-14.87L165,110a8,8,0,0,1-4.48-10.34l21.32-53a28,28,0,0,0-16.1-37,28.14,28.14,0,0,0-35.82,16,.61.61,0,0,0,0,.12L108.9,79a8,8,0,0,1-10.37,4.49L73.11,73.14A15.89,15.89,0,0,0,55.74,76.8C34.68,98.45,24,123.75,24,152a111.45,111.45,0,0,0,31.18,77.53A8,8,0,0,0,61,232H232a8,8,0,0,0,3.5-15.19ZM67.14,88l25.41,10.3a24,24,0,0,0,31.23-13.45l21-53c2.56-6.11,9.47-9.27,15.43-7a12,12,0,0,1,6.88,15.92L145.69,93.76a24,24,0,0,0,13.43,31.14L184,134.73V152c0,.33,0,.66,0,1L55.77,101.71A108.84,108.84,0,0,1,67.14,88Zm48,128a87.53,87.53,0,0,1-24.34-42,8,8,0,0,0-15.49,4,105.16,105.16,0,0,0,18.36,38H64.44A95.54,95.54,0,0,1,40,152a85.9,85.9,0,0,1,7.73-36.29l137.8,55.12c3,18,10.56,33.48,21.89,45.16Z" }, null, -1)
  ])]);
}
const eY = { render: Xj }, tY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nY(e, t) {
  return v(), y("svg", tY, [...t[0] || (t[0] = [
    R("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V88H40V56Zm0,144H40V104H216v96Z" }, null, -1)
  ])]);
}
const oY = { render: nY }, sY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iY(e, t) {
  return v(), y("svg", sY, [...t[0] || (t[0] = [
    R("path", { d: "M240,208h-8V72a8,8,0,0,0-8-8H184V40a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V96H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM40,112H80a8,8,0,0,0,8-8V48h80V72a8,8,0,0,0,8,8h40V208H152V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40H40Zm96,96H120V176h16ZM112,72a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,72Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,104Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,104ZM88,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,136Zm0,32a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,168Zm24-32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,136Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,168Z" }, null, -1)
  ])]);
}
const rY = { render: iY }, aY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lY(e, t) {
  return v(), y("svg", aY, [...t[0] || (t[0] = [
    R("path", { d: "M232,224H208V32h8a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16h8V224H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,32H192V224H160V184a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v40H64Zm80,192H112V192h32ZM88,64a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,64ZM88,104a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,104Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,104ZM88,144a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,144Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,144Z" }, null, -1)
  ])]);
}
const dY = { render: lY }, cY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uY(e, t) {
  return v(), y("svg", cY, [...t[0] || (t[0] = [
    R("path", { d: "M80,120h96a8,8,0,0,0,8-8V64a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v48A8,8,0,0,0,80,120Zm8-48h80v32H88ZM200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM100,148a12,12,0,1,1-12-12A12,12,0,0,1,100,148Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,140,148Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,180,148Zm-80,40a12,12,0,1,1-12-12A12,12,0,0,1,100,188Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,140,188Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,180,188Z" }, null, -1)
  ])]);
}
const hY = { render: uY }, gY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pY(e, t) {
  return v(), y("svg", gY, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z" }, null, -1)
  ])]);
}
const fY = { render: pY }, mY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vY(e, t) {
  return v(), y("svg", mY, [...t[0] || (t[0] = [
    R("path", { d: "M208,88H48a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,112H48V104H208v96ZM48,64a8,8,0,0,1,8-8H200a8,8,0,0,1,0,16H56A8,8,0,0,1,48,64ZM64,32a8,8,0,0,1,8-8H184a8,8,0,0,1,0,16H72A8,8,0,0,1,64,32Z" }, null, -1)
  ])]);
}
const CY = { render: vY }, wY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yY(e, t) {
  return v(), y("svg", wY, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,130.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,204.69l74.34-74.35A8,8,0,0,1,213.66,130.34Zm-91.32,11.32a8,8,0,0,0,11.32,0l80-80a8,8,0,0,0-11.32-11.32L128,124.69,53.66,50.34A8,8,0,0,0,42.34,61.66Z" }, null, -1)
  ])]);
}
const bY = { render: yY }, SY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xY(e, t) {
  return v(), y("svg", SY, [...t[0] || (t[0] = [
    R("path", { d: "M141.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L124.69,128,50.34,53.66A8,8,0,0,1,61.66,42.34l80,80A8,8,0,0,1,141.66,133.66Zm80-11.32-80-80a8,8,0,0,0-11.32,11.32L204.69,128l-74.35,74.34a8,8,0,0,0,11.32,11.32l80-80A8,8,0,0,0,221.66,122.34Z" }, null, -1)
  ])]);
}
const RY = { render: xY }, EY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function AY(e, t) {
  return v(), y("svg", EY, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,194.34a8,8,0,0,1-11.32,11.32L128,131.31,53.66,205.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0Zm-160-68.68L128,51.31l74.34,74.35a8,8,0,0,0,11.32-11.32l-80-80a8,8,0,0,0-11.32,0l-80,80a8,8,0,0,0,11.32,11.32Z" }, null, -1)
  ])]);
}
const FY = { render: AY }, MY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function IY(e, t) {
  return v(), y("svg", MY, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const PY = { render: IY }, DY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function TY(e, t) {
  return v(), y("svg", DY, [...t[0] || (t[0] = [
    R("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }, null, -1)
  ])]);
}
const kY = { render: TY }, LY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function BY(e, t) {
  return v(), y("svg", LY, [...t[0] || (t[0] = [
    R("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }, null, -1)
  ])]);
}
const OY = { render: BY }, GY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function HY(e, t) {
  return v(), y("svg", GY, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }, null, -1)
  ])]);
}
const VY = { render: HY }, _Y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function NY(e, t) {
  return v(), y("svg", _Y, [...t[0] || (t[0] = [
    R("path", { d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0v94.37L90.73,98a8,8,0,0,1,10.07-.38l58.81,44.11L218.73,90a8,8,0,1,1,10.54,12l-64,56a8,8,0,0,1-10.07.38L96.39,114.29,40,163.63V200H224A8,8,0,0,1,232,208Z" }, null, -1)
  ])]);
}
const $Y = { render: NY }, zY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function WY(e, t) {
  return v(), y("svg", zY, [...t[0] || (t[0] = [
    R("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const UY = { render: WY }, KY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ZY(e, t) {
  return v(), y("svg", KY, [...t[0] || (t[0] = [
    R("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const qY = { render: ZY }, jY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function YY(e, t) {
  return v(), y("svg", jY, [...t[0] || (t[0] = [
    R("path", { d: "M96.26,37.05A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88.09,88.09,0,0,0-44,0A8,8,0,0,1,96.26,37.05ZM53.79,55.14a104.05,104.05,0,0,0-26,45,8,8,0,0,0,15.42,4.27,88,88,0,0,1,22-38.09A8,8,0,0,0,53.79,55.14ZM43.21,151.55a8,8,0,1,0-15.42,4.28,104.12,104.12,0,0,0,26,45,8,8,0,0,0,11.41-11.22A88.14,88.14,0,0,1,43.21,151.55ZM150,213.22a88,88,0,0,1-44,0,8,8,0,1,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49ZM222.65,146a8,8,0,0,0-9.85,5.58,87.91,87.91,0,0,1-22,38.08,8,8,0,1,0,11.42,11.21,104,104,0,0,0,26-45A8,8,0,0,0,222.65,146Zm-9.86-41.54a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.22A88,88,0,0,1,212.79,104.45Z" }, null, -1)
  ])]);
}
const QY = { render: YY }, JY = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function XY(e, t) {
  return v(), y("svg", JY, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }, null, -1)
  ])]);
}
const eQ = { render: XY }, tQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nQ(e, t) {
  return v(), y("svg", tQ, [...t[0] || (t[0] = [
    R("path", { d: "M240,208h-8V88a8,8,0,0,0-8-8H160a8,8,0,0,0-8,8v40H104V40a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM168,96h48V208H168Zm-16,48v64H104V144ZM40,48H88V208H40ZM72,72V88a8,8,0,0,1-16,0V72a8,8,0,0,1,16,0Zm0,48v16a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm0,48v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm48,16V168a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm64,0V168a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm0-48V120a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Z" }, null, -1)
  ])]);
}
const oQ = { render: nQ }, sQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iQ(e, t) {
  return v(), y("svg", sQ, [...t[0] || (t[0] = [
    R("path", { d: "M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z" }, null, -1)
  ])]);
}
const rQ = { render: iQ }, aQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lQ(e, t) {
  return v(), y("svg", aQ, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z" }, null, -1)
  ])]);
}
const dQ = { render: lQ }, cQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uQ(e, t) {
  return v(), y("svg", cQ, [...t[0] || (t[0] = [
    R("path", { d: "M93.31,70,28,128l65.27,58a8,8,0,1,1-10.62,12l-72-64a8,8,0,0,1,0-12l72-64A8,8,0,1,1,93.31,70Zm152,52-72-64a8,8,0,0,0-10.62,12L228,128l-65.27,58a8,8,0,1,0,10.62,12l72-64a8,8,0,0,0,0-12Z" }, null, -1)
  ])]);
}
const hQ = { render: uQ }, gQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pQ(e, t) {
  return v(), y("svg", gQ, [...t[0] || (t[0] = [
    R("path", { d: "M69.12,94.15,28.5,128l40.62,33.85a8,8,0,1,1-10.24,12.29l-48-40a8,8,0,0,1,0-12.29l48-40a8,8,0,0,1,10.24,12.3Zm176,27.7-48-40a8,8,0,1,0-10.24,12.3L227.5,128l-40.62,33.85a8,8,0,1,0,10.24,12.29l48-40a8,8,0,0,0,0-12.29ZM162.73,32.48a8,8,0,0,0-10.25,4.79l-64,176a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,96,224a8,8,0,0,0,7.52-5.27l64-176A8,8,0,0,0,162.73,32.48Z" }, null, -1)
  ])]);
}
const fQ = { render: pQ }, mQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vQ(e, t) {
  return v(), y("svg", mQ, [...t[0] || (t[0] = [
    R("path", { d: "M128,32H104A16,16,0,0,0,88,48V208a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V48A16,16,0,0,0,128,32Zm0,176H104V48h24ZM200,32H176a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,176H176V48h24ZM72,128a8,8,0,0,1-8,8H48v16a8,8,0,0,1-16,0V136H16a8,8,0,0,1,0-16H32V104a8,8,0,0,1,16,0v16H64A8,8,0,0,1,72,128Z" }, null, -1)
  ])]);
}
const CQ = { render: vQ }, wQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yQ(e, t) {
  return v(), y("svg", wQ, [...t[0] || (t[0] = [
    R("path", { d: "M80,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V48A16,16,0,0,0,80,32Zm0,176H56V48H80ZM152,32H128a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V48A16,16,0,0,0,152,32Zm0,176H128V48h24Zm96-80a8,8,0,0,1-8,8H224v16a8,8,0,0,1-16,0V136H192a8,8,0,0,1,0-16h16V104a8,8,0,0,1,16,0v16h16A8,8,0,0,1,248,128Z" }, null, -1)
  ])]);
}
const bQ = { render: yQ }, SQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xQ(e, t) {
  return v(), y("svg", SQ, [...t[0] || (t[0] = [
    R("path", { d: "M104,32H64A16,16,0,0,0,48,48V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32Zm0,176H64V48h40ZM192,32H152a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Zm0,176H152V48h40Z" }, null, -1)
  ])]);
}
const RQ = { render: xQ }, EQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function AQ(e, t) {
  return v(), y("svg", EQ, [...t[0] || (t[0] = [
    R("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" }, null, -1)
  ])]);
}
const FQ = { render: AQ }, MQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function IQ(e, t) {
  return v(), y("svg", MQ, [...t[0] || (t[0] = [
    R("path", { d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z" }, null, -1)
  ])]);
}
const PQ = { render: IQ }, DQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function TQ(e, t) {
  return v(), y("svg", DQ, [...t[0] || (t[0] = [
    R("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }, null, -1)
  ])]);
}
const kQ = { render: TQ }, LQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function BQ(e, t) {
  return v(), y("svg", LQ, [...t[0] || (t[0] = [
    R("path", { d: "M72,92A12,12,0,1,1,60,80,12,12,0,0,1,72,92Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104ZM60,152a12,12,0,1,0,12,12A12,12,0,0,0,60,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152Z" }, null, -1)
  ])]);
}
const OQ = { render: BQ }, GQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function HQ(e, t) {
  return v(), y("svg", GQ, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z" }, null, -1)
  ])]);
}
const VQ = { render: HQ }, _Q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function NQ(e, t) {
  return v(), y("svg", _Q, [...t[0] || (t[0] = [
    R("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z" }, null, -1)
  ])]);
}
const $Q = { render: NQ }, zQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function WQ(e, t) {
  return v(), y("svg", zQ, [...t[0] || (t[0] = [
    R("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }, null, -1)
  ])]);
}
const UQ = { render: WQ }, KQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ZQ(e, t) {
  return v(), y("svg", KQ, [...t[0] || (t[0] = [
    R("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z" }, null, -1)
  ])]);
}
const qQ = { render: ZQ }, jQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function YQ(e, t) {
  return v(), y("svg", jQ, [...t[0] || (t[0] = [
    R("path", { d: "M174,47.75a254.19,254.19,0,0,0-41.45-38.3,8,8,0,0,0-9.18,0A254.19,254.19,0,0,0,82,47.75C54.51,79.32,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.49,79.32,174,47.75ZM128,216a72.08,72.08,0,0,1-72-72c0-57.23,55.47-105,72-118,16.53,13,72,60.75,72,118A72.08,72.08,0,0,1,128,216Zm55.89-62.66a57.6,57.6,0,0,1-46.56,46.55A8.75,8.75,0,0,1,136,200a8,8,0,0,1-1.32-15.89c16.57-2.79,30.63-16.85,33.44-33.45a8,8,0,0,1,15.78,2.68Z" }, null, -1)
  ])]);
}
const QQ = { render: YQ }, JQ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function XQ(e, t) {
  return v(), y("svg", JQ, [...t[0] || (t[0] = [
    R("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z" }, null, -1)
  ])]);
}
const eJ = { render: XQ }, tJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nJ(e, t) {
  return v(), y("svg", tJ, [...t[0] || (t[0] = [
    R("path", { d: "M224,160a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,160ZM40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1)
  ])]);
}
const oJ = { render: nJ }, sJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iJ(e, t) {
  return v(), y("svg", sJ, [...t[0] || (t[0] = [
    R("path", { d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z" }, null, -1)
  ])]);
}
const rJ = { render: iJ }, aJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lJ(e, t) {
  return v(), y("svg", aJ, [...t[0] || (t[0] = [
    R("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }, null, -1)
  ])]);
}
const dJ = { render: lJ }, cJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uJ(e, t) {
  return v(), y("svg", cJ, [...t[0] || (t[0] = [
    R("path", { d: "M192,96a40,40,0,0,0-24-72H96A40,40,0,0,0,72,96a40,40,0,0,0,1.37,65A44,44,0,1,0,144,196V160a40,40,0,1,0,48-64Zm0-32a24,24,0,0,1-24,24H144V40h24A24,24,0,0,1,192,64ZM72,64A24,24,0,0,1,96,40h32V88H96A24,24,0,0,1,72,64Zm24,88a24,24,0,0,1,0-48h32v48H96Zm32,44a28,28,0,1,1-28-28h28Zm40-44a24,24,0,1,1,24-24A24,24,0,0,1,168,152Z" }, null, -1)
  ])]);
}
const hJ = { render: uJ }, gJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pJ(e, t) {
  return v(), y("svg", gJ, [...t[0] || (t[0] = [
    R("path", { d: "M48,180c0,11,7.18,20,16,20a14.24,14.24,0,0,0,10.22-4.66A8,8,0,0,1,85.78,206.4,30.06,30.06,0,0,1,64,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a30.06,30.06,0,0,1,21.78,9.6,8,8,0,0,1-11.56,11.06A14.24,14.24,0,0,0,64,160C55.18,160,48,169,48,180Zm79.6-8.69c-4-1.16-8.14-2.35-10.45-3.84-1.25-.81-1.23-1-1.12-1.9a4.57,4.57,0,0,1,2-3.67c4.6-3.12,15.34-1.73,19.82-.56A8,8,0,0,0,142,145.86c-2.12-.55-21-5.22-32.84,2.76a20.58,20.58,0,0,0-9,14.95c-2,15.88,13.65,20.41,23,23.11,12.06,3.49,13.12,4.92,12.78,7.59-.31,2.41-1.26,3.34-2.14,3.93-4.6,3.06-15.17,1.56-19.55.36A8,8,0,0,0,109.94,214a61.34,61.34,0,0,0,15.19,2c5.82,0,12.3-1,17.49-4.46a20.82,20.82,0,0,0,9.19-15.23C154,179,137.49,174.17,127.6,171.31Zm83.09-26.84a8,8,0,0,0-10.23,4.84L188,184.21l-12.47-34.9a8,8,0,0,0-15.07,5.38l20,56a8,8,0,0,0,15.07,0l20-56A8,8,0,0,0,210.69,144.47ZM216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88Zm-27.31-8L160,51.31V80Z" }, null, -1)
  ])]);
}
const fJ = { render: pJ }, mJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vJ(e, t) {
  return v(), y("svg", mJ, [...t[0] || (t[0] = [
    R("path", { d: "M120,176h-8v-4a28,28,0,0,0-56,0v4H48a8,8,0,0,0-8,8v40a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V184A8,8,0,0,0,120,176Zm-48-4a12,12,0,0,1,24,0v4H72Zm40,44H56V192h56ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H160a8,8,0,0,0,0,16h40a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z" }, null, -1)
  ])]);
}
const CJ = { render: vJ }, wJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yJ(e, t) {
  return v(), y("svg", wJ, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-45.54-48.85a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM104,148a20,20,0,1,1,20,20A20,20,0,0,1,104,148Z" }, null, -1)
  ])]);
}
const bJ = { render: yJ }, SJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xJ(e, t) {
  return v(), y("svg", SJ, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h48A8,8,0,0,1,160,152Z" }, null, -1)
  ])]);
}
const RJ = { render: xJ }, EJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function AJ(e, t) {
  return v(), y("svg", EJ, [...t[0] || (t[0] = [
    R("path", { d: "M224,152a8,8,0,0,1-8,8H192v16h16a8,8,0,0,1,0,16H192v16a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8h32A8,8,0,0,1,224,152ZM92,172a28,28,0,0,1-28,28H56v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8H64A28,28,0,0,1,92,172Zm-16,0a12,12,0,0,0-12-12H56v24h8A12,12,0,0,0,76,172Zm88,8a36,36,0,0,1-36,36H112a8,8,0,0,1-8-8V152a8,8,0,0,1,8-8h16A36,36,0,0,1,164,180Zm-16,0a20,20,0,0,0-20-20h-8v40h8A20,20,0,0,0,148,180ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.69L160,51.31Z" }, null, -1)
  ])]);
}
const FJ = { render: AJ }, MJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function IJ(e, t) {
  return v(), y("svg", MJ, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z" }, null, -1)
  ])]);
}
const PJ = { render: IJ }, DJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function TJ(e, t) {
  return v(), y("svg", DJ, [...t[0] || (t[0] = [
    R("path", { d: "M224,152a8,8,0,0,1-8,8H204v48a8,8,0,0,1-16,0V160H176a8,8,0,0,1,0-16h40A8,8,0,0,1,224,152ZM92,172a28,28,0,0,1-28,28H56v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8H64A28,28,0,0,1,92,172Zm-16,0a12,12,0,0,0-12-12H56v24h8A12,12,0,0,0,76,172Zm84,0a28,28,0,0,1-28,28h-8v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8h16A28,28,0,0,1,160,172Zm-16,0a12,12,0,0,0-12-12h-8v24h8A12,12,0,0,0,144,172ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.69L160,51.31Z" }, null, -1)
  ])]);
}
const kJ = { render: TJ }, LJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function BJ(e, t) {
  return v(), y("svg", LJ, [...t[0] || (t[0] = [
    R("path", { d: "M48,120a8,8,0,0,0,8-8V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88a8,8,0,0,0-2.34-5.66l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72A8,8,0,0,0,48,120ZM160,51.31,188.69,80H160Zm-5.49,105.34L137.83,180l16.68,23.35a8,8,0,0,1-13,9.3L128,193.76l-13.49,18.89a8,8,0,1,1-13-9.3L118.17,180l-16.68-23.35a8,8,0,1,1,13-9.3L128,166.24l13.49-18.89a8,8,0,0,1,13,9.3ZM92,152a8,8,0,0,1-8,8H72v48a8,8,0,0,1-16,0V160H44a8,8,0,0,1,0-16H84A8,8,0,0,1,92,152Zm128,0a8,8,0,0,1-8,8H200v48a8,8,0,0,1-16,0V160H172a8,8,0,0,1,0-16h40A8,8,0,0,1,220,152Z" }, null, -1)
  ])]);
}
const OJ = { render: BJ }, GJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function HJ(e, t) {
  return v(), y("svg", GJ, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM155.88,145a8,8,0,0,0-8.12.22l-19.95,12.46A16,16,0,0,0,112,144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h64a16,16,0,0,0,15.81-13.68l19.95,12.46A8,8,0,0,0,160,216V152A8,8,0,0,0,155.88,145ZM112,208H48V160h64v48Zm32-6.43-16-10V176.43l16-10Z" }, null, -1)
  ])]);
}
const VJ = { render: HJ }, _J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function NJ(e, t) {
  return v(), y("svg", _J, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-42.34-82.34L139.31,152l18.35,18.34a8,8,0,0,1-11.32,11.32L128,163.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L116.69,152,98.34,133.66a8,8,0,0,1,11.32-11.32L128,140.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const $J = { render: NJ }, zJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function WJ(e, t) {
  return v(), y("svg", zJ, [...t[0] || (t[0] = [
    R("path", { d: "M184,144H168a8,8,0,0,0-8,8v56a8,8,0,0,0,16,0v-8h8a28,28,0,0,0,0-56Zm0,40h-8V160h8a12,12,0,0,1,0,24Zm-48-32v56a8,8,0,0,1-16,0V152a8,8,0,0,1,16,0ZM96,208a8,8,0,0,1-8,8H56a8,8,0,0,1-7-12l25.16-44H56a8,8,0,0,1,0-16H88a8,8,0,0,1,7,12L69.79,200H88A8,8,0,0,1,96,208ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,80V51.31L188.69,80Z" }, null, -1)
  ])]);
}
const UJ = { render: WJ }, KJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ZJ(e, t) {
  return v(), y("svg", KJ, [...t[0] || (t[0] = [
    R("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }, null, -1)
  ])]);
}
const qJ = { render: ZJ }, jJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function YJ(e, t) {
  return v(), y("svg", jJ, [...t[0] || (t[0] = [
    R("path", { d: "M107.18,24.33a15.86,15.86,0,0,0-17.92,9.45l-.06.14-64,159.93A16,16,0,0,0,40,216h64a16,16,0,0,0,16-16V40A15.85,15.85,0,0,0,107.18,24.33ZM104,200H40l.06-.15L104,40Zm126.77-6.15-64-159.93-.06-.14A16,16,0,0,0,136,40V200a16,16,0,0,0,16,16h64a16,16,0,0,0,14.78-22.15ZM152,200V40l63.93,159.84.06.15Z" }, null, -1)
  ])]);
}
const QJ = { render: YJ }, JJ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function XJ(e, t) {
  return v(), y("svg", JJ, [...t[0] || (t[0] = [
    R("path", { d: "M56,120H216a16,16,0,0,0,6.23-30.74l-.14-.06-159.93-64A16,16,0,0,0,40,40v64A16,16,0,0,0,56,120Zm0-80,.15.06L216,104H56l0-64Zm160,96H56a16,16,0,0,0-16,16v64a16,16,0,0,0,22.15,14.78l159.93-64,.14-.06A16,16,0,0,0,216,136ZM56.15,215.93,56,216V152H216Z" }, null, -1)
  ])]);
}
const eX = { render: XJ }, tX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nX(e, t) {
  return v(), y("svg", tX, [...t[0] || (t[0] = [
    R("path", { d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z" }, null, -1)
  ])]);
}
const oX = { render: nX }, sX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iX(e, t) {
  return v(), y("svg", sX, [...t[0] || (t[0] = [
    R("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216ZM104,136h48a8,8,0,0,1,0,16H104a8,8,0,0,1,0-16Z" }, null, -1)
  ])]);
}
const rX = { render: iX }, aX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lX(e, t) {
  return v(), y("svg", aX, [...t[0] || (t[0] = [
    R("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }, null, -1)
  ])]);
}
const dX = { render: lX }, cX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uX(e, t) {
  return v(), y("svg", cX, [...t[0] || (t[0] = [
    R("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }, null, -1)
  ])]);
}
const hX = { render: uX }, gX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pX(e, t) {
  return v(), y("svg", gX, [...t[0] || (t[0] = [
    R("path", { d: "M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const fX = { render: pX }, mX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vX(e, t) {
  return v(), y("svg", mX, [...t[0] || (t[0] = [
    R("path", { d: "M230.6,49.53A15.81,15.81,0,0,0,216,40H40A16,16,0,0,0,28.19,66.76l.08.09L96,139.17V216a16,16,0,0,0,24.87,13.32l32-21.34A16,16,0,0,0,160,194.66V139.17l67.74-72.32.08-.09A15.8,15.8,0,0,0,230.6,49.53ZM40,56h0Zm106.18,74.58A8,8,0,0,0,144,136v58.66L112,216V136a8,8,0,0,0-2.16-5.47L40,56H216Z" }, null, -1)
  ])]);
}
const CX = { render: vX }, wX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yX(e, t) {
  return v(), y("svg", wX, [...t[0] || (t[0] = [
    R("path", { d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.21,107.21,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.71,107.71,0,0,0-26.25-10.87,8,8,0,0,0-7.06,1.49L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.21,107.21,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8,8,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8,8,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z" }, null, -1)
  ])]);
}
const bX = { render: yX }, SX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xX(e, t) {
  return v(), y("svg", SX, [...t[0] || (t[0] = [
    R("path", { d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z" }, null, -1)
  ])]);
}
const RX = { render: xX }, EX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function AX(e, t) {
  return v(), y("svg", EX, [...t[0] || (t[0] = [
    R("path", { d: "M53.24,152.49,184.86,104,53.24,55.51a8,8,0,1,1,5.53-15l152,56a8,8,0,0,1,0,15l-152,56A8.13,8.13,0,0,1,56,168a8,8,0,0,1-2.76-15.51ZM208,192H56a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const FX = { render: AX }, MX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function IX(e, t) {
  return v(), y("svg", MX, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-4.58,7.23l-152,72a8,8,0,1,1-6.85-14.46L197.31,128,60.58,63.23a8,8,0,1,1,6.85-14.46l152,72A8,8,0,0,1,224,128Z" }, null, -1)
  ])]);
}
const PX = { render: IX }, DX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function TX(e, t) {
  return v(), y("svg", DX, [...t[0] || (t[0] = [
    R("path", { d: "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM104,144V112h48v32Zm48,16v32H104V160ZM40,112H88v32H40Zm64-16V64h48V96Zm64,16h48v32H168Zm48-16H168V64h48ZM88,64V96H40V64ZM40,160H88v32H40Zm176,32H168V160h48v32Z" }, null, -1)
  ])]);
}
const kX = { render: TX }, LX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function BX(e, t) {
  return v(), y("svg", LX, [...t[0] || (t[0] = [
    R("path", { d: "M128,35.31V128a8,8,0,0,1-16,0V35.31L93.66,53.66A8,8,0,0,1,82.34,42.34l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32Zm64,88.31V96a16,16,0,0,0-16-16H160a8,8,0,0,0,0,16h16v80.4A28,28,0,0,0,131.75,210l.24.38,22.26,34a8,8,0,0,0,13.39-8.76l-22.13-33.79A12,12,0,0,1,166.4,190c.07.13.15.26.23.38l10.68,16.31A8,8,0,0,0,192,202.31V144a74.84,74.84,0,0,1,24,54.69V240a8,8,0,0,0,16,0V198.65A90.89,90.89,0,0,0,192,123.62ZM80,80H64A16,16,0,0,0,48,96V200a8,8,0,0,0,16,0V96H80a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const OX = { render: BX }, GX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function HX(e, t) {
  return v(), y("svg", GX, [...t[0] || (t[0] = [
    R("path", { d: "M208,136H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm0,64H48V152H208v48Zm0-160H48A16,16,0,0,0,32,56v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,64H48V56H208v48ZM192,80a12,12,0,1,1-12-12A12,12,0,0,1,192,80Zm0,96a12,12,0,1,1-12-12A12,12,0,0,1,192,176Z" }, null, -1)
  ])]);
}
const VX = { render: HX }, _X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function NX(e, t) {
  return v(), y("svg", _X, [...t[0] || (t[0] = [
    R("path", { d: "M224,88H175.4l8.47-46.57a8,8,0,0,0-15.74-2.86l-9,49.43H111.4l8.47-46.57a8,8,0,0,0-15.74-2.86L95.14,88H48a8,8,0,0,0,0,16H92.23L83.5,152H32a8,8,0,0,0,0,16H80.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,80,224a8,8,0,0,0,7.86-6.57l9-49.43H144.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,144,224a8,8,0,0,0,7.86-6.57l9-49.43H208a8,8,0,0,0,0-16H163.77l8.73-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.77l8.73-48h47.73Z" }, null, -1)
  ])]);
}
const $X = { render: NX }, zX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function WX(e, t) {
  return v(), y("svg", zX, [...t[0] || (t[0] = [
    R("path", { d: "M253.66,106.34a8,8,0,0,0-11.32,0L192,156.69,107.31,72l50.35-50.34a8,8,0,1,0-11.32-11.32L96,60.69A16,16,0,0,0,93.18,79.5L72,100.69a16,16,0,0,0,0,22.62L76.69,128,18.34,186.34a8,8,0,0,0,3.13,13.25l72,24A7.88,7.88,0,0,0,96,224a8,8,0,0,0,5.66-2.34L136,187.31l4.69,4.69a16,16,0,0,0,22.62,0l21.19-21.18A16,16,0,0,0,203.31,168l50.35-50.34A8,8,0,0,0,253.66,106.34ZM93.84,206.85l-55-18.35L88,139.31,124.69,176ZM152,180.69,83.31,112,104,91.31,172.69,160Z" }, null, -1)
  ])]);
}
const UX = { render: WX }, KX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ZX(e, t) {
  return v(), y("svg", KX, [...t[0] || (t[0] = [
    R("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1)
  ])]);
}
const qX = { render: ZX }, jX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function YX(e, t) {
  return v(), y("svg", jX, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM48,48H208v77.38l-24.69-24.7a16,16,0,0,0-22.62,0L53.37,208H48ZM208,208H76l96-96,36,36v60ZM96,120A24,24,0,1,0,72,96,24,24,0,0,0,96,120Zm0-32a8,8,0,1,1-8,8A8,8,0,0,1,96,88Z" }, null, -1)
  ])]);
}
const QX = { render: YX }, JX = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function XX(e, t) {
  return v(), y("svg", JX, [...t[0] || (t[0] = [
    R("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V158.75l-26.07-26.06a16,16,0,0,0-22.63,0l-20,20-44-44a16,16,0,0,0-22.62,0L40,149.37V56ZM40,172l52-52,80,80H40Zm176,28H194.63l-36-36,20-20L216,181.38V200ZM144,100a12,12,0,1,1,12,12A12,12,0,0,1,144,100Z" }, null, -1)
  ])]);
}
const eee = { render: XX }, tee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nee(e, t) {
  return v(), y("svg", tee, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }, null, -1)
  ])]);
}
const oee = { render: nee }, see = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iee(e, t) {
  return v(), y("svg", see, [...t[0] || (t[0] = [
    R("path", { d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z" }, null, -1)
  ])]);
}
const ree = { render: iee }, aee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lee(e, t) {
  return v(), y("svg", aee, [...t[0] || (t[0] = [
    R("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z" }, null, -1)
  ])]);
}
const dee = { render: lee }, cee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uee(e, t) {
  return v(), y("svg", cee, [...t[0] || (t[0] = [
    R("path", { d: "M40,104a8,8,0,0,1,5.23-7.5l152-56a8,8,0,0,1,5.53,15L71.14,104l131.62,48.49A8,8,0,0,1,200,168a8.13,8.13,0,0,1-2.77-.49l-152-56A8,8,0,0,1,40,104Zm160,88H48a8,8,0,0,0,0,16H200a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const hee = { render: uee }, gee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pee(e, t) {
  return v(), y("svg", gee, [...t[0] || (t[0] = [
    R("path", { d: "M207.23,203.42a8,8,0,0,1-10.66,3.81l-152-72a8,8,0,0,1,0-14.46l152-72a8,8,0,1,1,6.85,14.46L66.69,128l136.73,64.77A8,8,0,0,1,207.23,203.42Z" }, null, -1)
  ])]);
}
const fee = { render: pee }, mee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vee(e, t) {
  return v(), y("svg", mee, [...t[0] || (t[0] = [
    R("path", { d: "M240,88.23a54.43,54.43,0,0,1-16,37L189.25,160a54.27,54.27,0,0,1-38.63,16h-.05A54.63,54.63,0,0,1,96,119.84a8,8,0,0,1,16,.45A38.62,38.62,0,0,0,150.58,160h0a38.39,38.39,0,0,0,27.31-11.31l34.75-34.75a38.63,38.63,0,0,0-54.63-54.63l-11,11A8,8,0,0,1,135.7,59l11-11A54.65,54.65,0,0,1,224,48,54.86,54.86,0,0,1,240,88.23ZM109,185.66l-11,11A38.41,38.41,0,0,1,70.6,208h0a38.63,38.63,0,0,1-27.29-65.94L78,107.31A38.63,38.63,0,0,1,144,135.71a8,8,0,0,0,16,.45A54.86,54.86,0,0,0,144,96a54.65,54.65,0,0,0-77.27,0L32,130.75A54.62,54.62,0,0,0,70.56,224h0a54.28,54.28,0,0,0,38.64-16l11-11A8,8,0,0,0,109,185.66Z" }, null, -1)
  ])]);
}
const Cee = { render: vee }, wee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yee(e, t) {
  return v(), y("svg", wee, [...t[0] || (t[0] = [
    R("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }, null, -1)
  ])]);
}
const bee = { render: yee }, See = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xee(e, t) {
  return v(), y("svg", See, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z" }, null, -1)
  ])]);
}
const Ree = { render: xee }, Eee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Aee(e, t) {
  return v(), y("svg", Eee, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z" }, null, -1)
  ])]);
}
const Fee = { render: Aee }, Mee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Iee(e, t) {
  return v(), y("svg", Mee, [...t[0] || (t[0] = [
    R("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const Pee = { render: Iee }, Dee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Tee(e, t) {
  return v(), y("svg", Dee, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const kee = { render: Tee }, Lee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Bee(e, t) {
  return v(), y("svg", Lee, [...t[0] || (t[0] = [
    R("path", { d: "M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,128H48V96H208V208Z" }, null, -1)
  ])]);
}
const Oee = { render: Bee }, Gee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hee(e, t) {
  return v(), y("svg", Gee, [...t[0] || (t[0] = [
    R("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }, null, -1)
  ])]);
}
const Vee = { render: Hee }, _ee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Nee(e, t) {
  return v(), y("svg", _ee, [...t[0] || (t[0] = [
    R("path", { d: "M152,112a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h64A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }, null, -1)
  ])]);
}
const $ee = { render: Nee }, zee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Wee(e, t) {
  return v(), y("svg", zee, [...t[0] || (t[0] = [
    R("path", { d: "M152,112a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }, null, -1)
  ])]);
}
const Uee = { render: Wee }, Kee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zee(e, t) {
  return v(), y("svg", Kee, [...t[0] || (t[0] = [
    R("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }, null, -1)
  ])]);
}
const qee = { render: Zee }, jee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yee(e, t) {
  return v(), y("svg", jee, [...t[0] || (t[0] = [
    R("path", { d: "M120,103.2V176a8,8,0,0,0,16,0V103.2a40,40,0,1,0-16,0ZM128,40a24,24,0,1,1-24,24A24,24,0,0,1,128,40ZM240,176c0,31.18-57.71,48-112,48S16,207.18,16,176c0-7.74,3.81-19.13,22-29.41,12.26-6.94,29.12-12.27,48.77-15.42A8,8,0,1,1,89.27,147c-17.54,2.82-33,7.63-43.42,13.55C37.05,165.5,32,171.14,32,176c0,13.36,36.52,32,96,32s96-18.64,96-32c0-4.86-5.05-10.5-13.85-15.49-10.46-5.92-25.88-10.73-43.42-13.55a8,8,0,1,1,2.54-15.79c19.65,3.15,36.51,8.48,48.77,15.42C236.19,156.87,240,168.26,240,176Z" }, null, -1)
  ])]);
}
const Qee = { render: Yee }, Jee = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xee(e, t) {
  return v(), y("svg", Jee, [...t[0] || (t[0] = [
    R("path", { d: "M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm-40,80h40v48H160Zm40-16H160V80a16,16,0,0,0-16-16V40h56ZM72,40h56V64H72ZM40,80H144v79.83c0,.06,0,.11,0,.17s0,.11,0,.17V176H40ZM72,192h56v24H72Zm72,24V192a16,16,0,0,0,16-16v-8h40v48ZM65.85,146.88,81.59,128,65.85,109.12a8,8,0,0,1,12.3-10.24L92,115.5l13.85-16.62a8,8,0,1,1,12.3,10.24L102.41,128l15.74,18.88a8,8,0,0,1-12.3,10.24L92,140.5,78.15,157.12a8,8,0,0,1-12.3-10.24Z" }, null, -1)
  ])]);
}
const ete = { render: Xee }, tte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nte(e, t) {
  return v(), y("svg", tte, [...t[0] || (t[0] = [
    R("path", { d: "M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm-40,80h40v48H160ZM72,40H200V88H160V80a16,16,0,0,0-16-16H72ZM40,80H144v79.83c0,.06,0,.11,0,.17s0,.11,0,.17V176H40ZM72,216V192h72a16,16,0,0,0,16-16v-8h40v48Zm-3.76-62.06-12-48a8,8,0,1,1,15.52-3.88l6.76,27,6.32-12.66a8,8,0,0,1,14.32,0l6.32,12.66,6.76-27a8,8,0,0,1,15.52,3.88l-12,48a8,8,0,0,1-6.89,6,8.46,8.46,0,0,1-.87.05,8,8,0,0,1-7.16-4.42L92,137.89l-8.84,17.69a8,8,0,0,1-14.92-1.64Z" }, null, -1)
  ])]);
}
const ote = { render: nte }, ste = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ite(e, t) {
  return v(), y("svg", ste, [...t[0] || (t[0] = [
    R("path", { d: "M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const rte = { render: ite }, ate = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lte(e, t) {
  return v(), y("svg", ate, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z" }, null, -1)
  ])]);
}
const dte = { render: lte }, cte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ute(e, t) {
  return v(), y("svg", cte, [...t[0] || (t[0] = [
    R("path", { d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z" }, null, -1)
  ])]);
}
const hte = { render: ute }, gte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pte(e, t) {
  return v(), y("svg", gte, [...t[0] || (t[0] = [
    R("path", { d: "M224,160a8,8,0,0,1-8,8H102.45L53.92,221.38a8,8,0,0,1-11.84-10.76L80.82,168H40a8,8,0,0,1,0-16H95.37L139,104H40a8,8,0,0,1,0-16H153.55l48.53-53.38a8,8,0,0,1,11.84,10.76L175.18,88H216a8,8,0,0,1,0,16H160.63L117,152h99A8,8,0,0,1,224,160Z" }, null, -1)
  ])]);
}
const fte = { render: pte }, mte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vte(e, t) {
  return v(), y("svg", mte, [...t[0] || (t[0] = [
    R("path", { d: "M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z" }, null, -1)
  ])]);
}
const Cte = { render: vte }, wte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yte(e, t) {
  return v(), y("svg", wte, [...t[0] || (t[0] = [
    R("path", { d: "M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z" }, null, -1)
  ])]);
}
const bte = { render: yte }, Ste = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xte(e, t) {
  return v(), y("svg", Ste, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-64h-8V80a8,8,0,0,0-14.31-4.91l-56,72A8,8,0,0,0,88,160h48v16a8,8,0,0,0,16,0V160h8a8,8,0,0,0,0-16Zm-24,0H104.36L136,103.32Z" }, null, -1)
  ])]);
}
const Rte = { render: xte }, Ete = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ate(e, t) {
  return v(), y("svg", Ete, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM140,80v96a8,8,0,0,1-16,0V95l-11.56,7.71a8,8,0,1,1-8.88-13.32l24-16A8,8,0,0,1,140,80Z" }, null, -1)
  ])]);
}
const Fte = { render: Ate }, Mte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ite(e, t) {
  return v(), y("svg", Mte, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-60a36,36,0,0,1-61.71,25.19A8,8,0,1,1,109.71,162,20,20,0,1,0,124,128a8,8,0,0,1-6.55-12.59L136.63,88H104a8,8,0,0,1,0-16h48a8,8,0,0,1,6.55,12.59l-21,30A36.07,36.07,0,0,1,160,148Z" }, null, -1)
  ])]);
}
const Pte = { render: Ite }, Dte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Tte(e, t) {
  return v(), y("svg", Dte, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-32a8,8,0,0,1-8,8H104a8,8,0,0,1-6.4-12.8l43.17-57.56a16,16,0,1,0-27.86-15,8,8,0,0,1-15.09-5.34,32.43,32.43,0,0,1,4.62-8.59,32,32,0,1,1,51.11,38.52L120,168h32A8,8,0,0,1,160,176Z" }, null, -1)
  ])]);
}
const kte = { render: Tte }, Lte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Bte(e, t) {
  return v(), y("svg", Lte, [...t[0] || (t[0] = [
    R("path", { d: "M234.53,139.07a8,8,0,0,0,3.13-13.24L122.17,10.34a8,8,0,0,0-11.31,0L70.25,51,45.65,26.34A8,8,0,0,0,34.34,37.66l24.6,24.6L15,106.17a24,24,0,0,0,0,33.94L99.89,225a24,24,0,0,0,33.94,0l78.49-78.49Zm-32.19-5.24-79.83,79.83a8,8,0,0,1-11.31,0L26.34,128.8a8,8,0,0,1,0-11.31L70.25,73.57l29.12,29.12a28,28,0,1,0,11.31-11.32L81.57,62.26l35-34.95L217.19,128l-11.72,3.9A8.09,8.09,0,0,0,202.34,133.83Zm-86.83-26.31,0,0a13.26,13.26,0,1,1-.05.06S115.51,107.53,115.51,107.52Zm123.15,56a8,8,0,0,0-13.32,0C223.57,166.23,208,190.09,208,208a24,24,0,0,0,48,0C256,190.09,240.43,166.23,238.66,163.56ZM232,216a8,8,0,0,1-8-8c0-6.8,4-16.32,8-24.08,4,7.76,8,17.34,8,24.08A8,8,0,0,1,232,216Z" }, null, -1)
  ])]);
}
const Ote = { render: Bte }, Gte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hte(e, t) {
  return v(), y("svg", Gte, [...t[0] || (t[0] = [
    R("path", { d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89Zm13,93.71A15.89,15.89,0,0,1,198.21,160H152a32,32,0,0,0-32,32,16,16,0,0,1-21.31,15.07C62.49,194.3,40,164,40,128a88,88,0,0,1,87.09-88h.9a88.35,88.35,0,0,1,88,87.25A88.86,88.86,0,0,1,213.81,147.6ZM140,76a12,12,0,1,1-12-12A12,12,0,0,1,140,76ZM96,100A12,12,0,1,1,84,88,12,12,0,0,1,96,100Zm0,56a12,12,0,1,1-12-12A12,12,0,0,1,96,156Zm88-56a12,12,0,1,1-12-12A12,12,0,0,1,184,100Z" }, null, -1)
  ])]);
}
const Vte = { render: Hte }, _te = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Nte(e, t) {
  return v(), y("svg", _te, [...t[0] || (t[0] = [
    R("path", { d: "M231.87,114l-168-95.89A16,16,0,0,0,40.92,37.34L71.55,128,40.92,218.67A16,16,0,0,0,56,240a16.15,16.15,0,0,0,7.93-2.1l167.92-96.05a16,16,0,0,0,.05-27.89ZM56,224a.56.56,0,0,0,0-.12L85.74,136H144a8,8,0,0,0,0-16H85.74L56.06,32.16A.46.46,0,0,0,56,32l168,95.83Z" }, null, -1)
  ])]);
}
const $te = { render: Nte }, zte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Wte(e, t) {
  return v(), y("svg", zte, [...t[0] || (t[0] = [
    R("path", { d: "M209.66,122.34a8,8,0,0,1,0,11.32l-82.05,82a56,56,0,0,1-79.2-79.21L147.67,35.73a40,40,0,1,1,56.61,56.55L105,193A24,24,0,1,1,71,159L154.3,74.38A8,8,0,1,1,165.7,85.6L82.39,170.31a8,8,0,1,0,11.27,11.36L192.93,81A24,24,0,1,0,159,47L59.76,147.68a40,40,0,1,0,56.53,56.62l82.06-82A8,8,0,0,1,209.66,122.34Z" }, null, -1)
  ])]);
}
const Ute = { render: Wte }, Kte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zte(e, t) {
  return v(), y("svg", Kte, [...t[0] || (t[0] = [
    R("path", { d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM136,75.31,152.69,92,68,176.69,51.31,160ZM48,208V179.31L76.69,208Zm48-3.31L79.32,188,164,103.31,180.69,120Zm96-96L147.32,64l24-24L216,84.69Z" }, null, -1)
  ])]);
}
const qte = { render: Zte }, jte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yte(e, t) {
  return v(), y("svg", jte, [...t[0] || (t[0] = [
    R("path", { d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z" }, null, -1)
  ])]);
}
const Qte = { render: Yte }, Jte = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xte(e, t) {
  return v(), y("svg", Jte, [...t[0] || (t[0] = [
    R("path", { d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z" }, null, -1)
  ])]);
}
const ene = { render: Xte }, tne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nne(e, t) {
  return v(), y("svg", tne, [...t[0] || (t[0] = [
    R("path", { d: "M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z" }, null, -1)
  ])]);
}
const one = { render: nne }, sne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ine(e, t) {
  return v(), y("svg", sne, [...t[0] || (t[0] = [
    R("path", { d: "M237.66,66.34a8,8,0,0,0-11.32,0L192,100.69,155.31,64l34.35-34.34a8,8,0,1,0-11.32-11.32L144,52.69,117.66,26.34a8,8,0,0,0-11.32,11.32L112.69,44l-53,53a40,40,0,0,0,0,56.57l15.71,15.71L26.34,218.34a8,8,0,0,0,11.32,11.32l49.09-49.09,15.71,15.71a40,40,0,0,0,56.57,0l53-53,6.34,6.35a8,8,0,0,0,11.32-11.32L203.31,112l34.35-34.34A8,8,0,0,0,237.66,66.34ZM147.72,185a24,24,0,0,1-33.95,0L71,142.23a24,24,0,0,1,0-33.95l53-53L200.69,132Z" }, null, -1)
  ])]);
}
const rne = { render: ine }, ane = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lne(e, t) {
  return v(), y("svg", ane, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z" }, null, -1)
  ])]);
}
const dne = { render: lne }, cne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function une(e, t) {
  return v(), y("svg", cne, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z" }, null, -1)
  ])]);
}
const hne = { render: une }, gne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pne(e, t) {
  return v(), y("svg", gne, [...t[0] || (t[0] = [
    R("path", { d: "M214.67,72H200V40a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8V72H41.33C27.36,72,16,82.77,16,96v80a8,8,0,0,0,8,8H56v32a8,8,0,0,0,8,8H192a8,8,0,0,0,8-8V184h32a8,8,0,0,0,8-8V96C240,82.77,228.64,72,214.67,72ZM72,48H184V72H72ZM184,208H72V160H184Zm40-40H200V152a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v16H32V96c0-4.41,4.19-8,9.33-8H214.67c5.14,0,9.33,3.59,9.33,8Zm-24-52a12,12,0,1,1-12-12A12,12,0,0,1,200,116Z" }, null, -1)
  ])]);
}
const fne = { render: pne }, mne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vne(e, t) {
  return v(), y("svg", mne, [...t[0] || (t[0] = [
    R("path", { d: "M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z" }, null, -1)
  ])]);
}
const Cne = { render: vne }, wne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yne(e, t) {
  return v(), y("svg", wne, [...t[0] || (t[0] = [
    R("path", { d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const bne = { render: yne }, Sne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xne(e, t) {
  return v(), y("svg", Sne, [...t[0] || (t[0] = [
    R("path", { d: "M208,112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V128A16,16,0,0,0,208,112Zm0,40H48V128H208v24Zm0-112H48A16,16,0,0,0,32,56V80A16,16,0,0,0,48,96H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,40H48V56H208V80ZM160,216a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V224H104a8,8,0,0,1,0-16h16V192a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,216Z" }, null, -1)
  ])]);
}
const Rne = { render: xne }, Ene = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ane(e, t) {
  return v(), y("svg", Ene, [...t[0] || (t[0] = [
    R("path", { d: "M208,160H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V176A16,16,0,0,0,208,160Zm0,40H48V176H208v24Zm0-112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,40H48V104H208v24ZM96,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H136V64a8,8,0,0,1-16,0V48H104A8,8,0,0,1,96,40Z" }, null, -1)
  ])]);
}
const Fne = { render: Ane }, Mne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ine(e, t) {
  return v(), y("svg", Mne, [...t[0] || (t[0] = [
    R("path", { d: "M208,136H48a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm0,56H48V152H208v40Zm0-144H48A16,16,0,0,0,32,64v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Zm0,56H48V64H208v40Z" }, null, -1)
  ])]);
}
const Pne = { render: Ine }, Dne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Tne(e, t) {
  return v(), y("svg", Dne, [...t[0] || (t[0] = [
    R("path", { d: "M157.73,113.13A8,8,0,0,1,159.82,102L227.48,55.7a8,8,0,0,1,9,13.21l-67.67,46.3a7.92,7.92,0,0,1-4.51,1.4A8,8,0,0,1,157.73,113.13Zm80.87,85.09a8,8,0,0,1-11.12,2.08L136,137.7,93.49,166.78a36,36,0,1,1-9-13.19L121.83,128,84.44,102.41a35.86,35.86,0,1,1,9-13.19l143,97.87A8,8,0,0,1,238.6,198.22ZM80,180a20,20,0,1,0-5.86,14.14A19.85,19.85,0,0,0,80,180ZM74.14,90.13a20,20,0,1,0-28.28,0A19.85,19.85,0,0,0,74.14,90.13Z" }, null, -1)
  ])]);
}
const kne = { render: Tne }, Lne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Bne(e, t) {
  return v(), y("svg", Lne, [...t[0] || (t[0] = [
    R("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }, null, -1)
  ])]);
}
const One = { render: Bne }, Gne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hne(e, t) {
  return v(), y("svg", Gne, [...t[0] || (t[0] = [
    R("path", { d: "M184,72V56H80.65l53.6,67a8,8,0,0,1,0,10l-53.6,67H184V184a8,8,0,0,1,16,0v24a8,8,0,0,1-8,8H64a8,8,0,0,1-6.25-13l60-75-60-75A8,8,0,0,1,64,40H192a8,8,0,0,1,8,8V72a8,8,0,0,1-16,0Z" }, null, -1)
  ])]);
}
const Vne = { render: Hne }, _ne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Nne(e, t) {
  return v(), y("svg", _ne, [...t[0] || (t[0] = [
    R("path", { d: "M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM200,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h64a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32Z" }, null, -1)
  ])]);
}
const $ne = { render: Nne }, zne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Wne(e, t) {
  return v(), y("svg", zne, [...t[0] || (t[0] = [
    R("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1)
  ])]);
}
const Une = { render: Wne }, Kne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zne(e, t) {
  return v(), y("svg", Kne, [...t[0] || (t[0] = [
    R("path", { d: "M246,98.73l-56-64A8,8,0,0,0,184,32H72a8,8,0,0,0-6,2.73l-56,64a8,8,0,0,0,.17,10.73l112,120a8,8,0,0,0,11.7,0l112-120A8,8,0,0,0,246,98.73ZM222.37,96H180L144,48h36.37ZM74.58,112l30.13,75.33L34.41,112Zm89.6,0L128,202.46,91.82,112ZM96,96l32-42.67L160,96Zm85.42,16h40.17l-70.3,75.33ZM75.63,48H112L76,96H33.63Z" }, null, -1)
  ])]);
}
const qne = { render: Zne }, jne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yne(e, t) {
  return v(), y("svg", jne, [...t[0] || (t[0] = [
    R("path", { d: "M40,88H73a32,32,0,0,0,62,0h81a8,8,0,0,0,0-16H135a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16Zm64-24A16,16,0,1,1,88,80,16,16,0,0,1,104,64ZM216,168H199a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16h97a32,32,0,0,0,62,0h17a8,8,0,0,0,0-16Zm-48,24a16,16,0,1,1,16-16A16,16,0,0,1,168,192Z" }, null, -1)
  ])]);
}
const Qne = { render: Yne }, Jne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xne(e, t) {
  return v(), y("svg", Jne, [...t[0] || (t[0] = [
    R("path", { d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z" }, null, -1)
  ])]);
}
const eoe = { render: Xne }, toe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function noe(e, t) {
  return v(), y("svg", toe, [...t[0] || (t[0] = [
    R("path", { d: "M112,48V208a8,8,0,0,1-16,0V136H43.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L43.31,120H96V48a8,8,0,0,1,16,0Zm125.66,74.34-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160V48a8,8,0,0,0-16,0V208a8,8,0,0,0,16,0V136h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34Z" }, null, -1)
  ])]);
}
const ooe = { render: noe }, soe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ioe(e, t) {
  return v(), y("svg", soe, [...t[0] || (t[0] = [
    R("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Z" }, null, -1)
  ])]);
}
const roe = { render: ioe }, aoe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function loe(e, t) {
  return v(), y("svg", aoe, [...t[0] || (t[0] = [
    R("path", { d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z" }, null, -1)
  ])]);
}
const doe = { render: loe }, coe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uoe(e, t) {
  return v(), y("svg", coe, [...t[0] || (t[0] = [
    R("path", { d: "M216,152.09V216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152.09a8,8,0,0,1,16,0V208H200V152.09a8,8,0,0,1,16,0Zm-128,32h80a8,8,0,1,0,0-16H88a8,8,0,1,0,0,16Zm4.88-53,77.27,20.68a7.89,7.89,0,0,0,2.08.28,8,8,0,0,0,2.07-15.71L97,115.61A8,8,0,1,0,92.88,131Zm18.45-49.93,69.28,40a8,8,0,0,0,10.93-2.93,8,8,0,0,0-2.93-10.91L119.33,67.27a8,8,0,1,0-8,13.84Zm87.33,13A8,8,0,1,0,210,82.84l-56.57-56.5a8,8,0,0,0-11.32,11.3Z" }, null, -1)
  ])]);
}
const hoe = { render: uoe }, goe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function poe(e, t) {
  return v(), y("svg", goe, [...t[0] || (t[0] = [
    R("path", { d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z" }, null, -1)
  ])]);
}
const foe = { render: poe }, moe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function voe(e, t) {
  return v(), y("svg", moe, [...t[0] || (t[0] = [
    R("path", { d: "M230.91,172A8,8,0,0,1,228,182.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,169.09l92,53.65,92-53.65A8,8,0,0,1,230.91,172ZM220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26Z" }, null, -1)
  ])]);
}
const Coe = { render: voe }, woe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yoe(e, t) {
  return v(), y("svg", woe, [...t[0] || (t[0] = [
    R("path", { d: "M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z" }, null, -1)
  ])]);
}
const boe = { render: yoe }, Soe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xoe(e, t) {
  return v(), y("svg", Soe, [...t[0] || (t[0] = [
    R("path", { d: "M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM96,48a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,72v72H40V72Zm0,128H40V160H216v40Z" }, null, -1)
  ])]);
}
const Roe = { render: xoe }, Eoe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Aoe(e, t) {
  return v(), y("svg", Eoe, [...t[0] || (t[0] = [
    R("path", { d: "M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z" }, null, -1)
  ])]);
}
const Foe = { render: Aoe }, Moe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ioe(e, t) {
  return v(), y("svg", Moe, [...t[0] || (t[0] = [
    R("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z" }, null, -1)
  ])]);
}
const Poe = { render: Ioe }, Doe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Toe(e, t) {
  return v(), y("svg", Doe, [...t[0] || (t[0] = [
    R("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const koe = { render: Toe }, Loe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Boe(e, t) {
  return v(), y("svg", Loe, [...t[0] || (t[0] = [
    R("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const Ooe = { render: Boe }, Goe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hoe(e, t) {
  return v(), y("svg", Goe, [...t[0] || (t[0] = [
    R("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,48H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm176,24H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-48,40H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const Voe = { render: Hoe }, _oe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Noe(e, t) {
  return v(), y("svg", _oe, [...t[0] || (t[0] = [
    R("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const $oe = { render: Noe }, zoe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Woe(e, t) {
  return v(), y("svg", zoe, [...t[0] || (t[0] = [
    R("path", { d: "M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z" }, null, -1)
  ])]);
}
const Uoe = { render: Woe }, Koe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zoe(e, t) {
  return v(), y("svg", Koe, [...t[0] || (t[0] = [
    R("path", { d: "M120,64a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16h72A8,8,0,0,1,120,64Zm-8,32H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM144,72h72a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm72,24H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const qoe = { render: Zoe }, joe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yoe(e, t) {
  return v(), y("svg", joe, [...t[0] || (t[0] = [
    R("path", { d: "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z" }, null, -1)
  ])]);
}
const Qoe = { render: Yoe }, Joe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xoe(e, t) {
  return v(), y("svg", Joe, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM34.34,141.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0,0-11.32l-40-40A8,8,0,0,0,34.34,61.66L68.69,96,34.34,130.34A8,8,0,0,0,34.34,141.66Z" }, null, -1)
  ])]);
}
const ese = { render: Xoe }, tse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nse(e, t) {
  return v(), y("svg", tse, [...t[0] || (t[0] = [
    R("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }, null, -1)
  ])]);
}
const ose = { render: nse }, sse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function ise(e, t) {
  return v(), y("svg", sse, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z" }, null, -1)
  ])]);
}
const rse = { render: ise }, ase = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lse(e, t) {
  return v(), y("svg", ase, [...t[0] || (t[0] = [
    R("path", { d: "M224,128a8,8,0,0,1-8,8H175.93c9.19,7.11,16.07,17.2,16.07,32,0,13.34-7,25.7-19.75,34.79C160.33,211.31,144.61,216,128,216s-32.33-4.69-44.25-13.21C71,193.7,64,181.34,64,168a8,8,0,0,1,16,0c0,17.35,22,32,48,32s48-14.65,48-32c0-14.85-10.54-23.58-38.77-32H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM76.33,104a8,8,0,0,0,7.61-10.49A17.3,17.3,0,0,1,83.11,88c0-18.24,19.3-32,44.89-32,18.84,0,34.16,7.42,41,19.85a8,8,0,0,0,14-7.7C173.33,50.52,152.77,40,128,40,93.29,40,67.11,60.63,67.11,88a33.73,33.73,0,0,0,1.62,10.49A8,8,0,0,0,76.33,104Z" }, null, -1)
  ])]);
}
const dse = { render: lse }, cse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function use(e, t) {
  return v(), y("svg", cse, [...t[0] || (t[0] = [
    R("path", { d: "M248,208a8,8,0,0,1-8,8H192a8,8,0,0,1-6.4-12.8l43.17-57.56a16,16,0,1,0-27.86-15,8,8,0,0,1-15.09-5.34,32.18,32.18,0,0,1,4.63-8.59,32,32,0,0,1,51.11,38.52L208,200h32A8,8,0,0,1,248,208ZM149.24,50a8,8,0,0,0-11.29.81L92,103.78l-45.95-53A8,8,0,0,0,34,61.24L81.41,116,34,170.76a8,8,0,0,0,12.1,10.48l46-53,45.95,53a8,8,0,1,0,12.1-10.48L102.59,116l47.46-54.76A8,8,0,0,0,149.24,50Z" }, null, -1)
  ])]);
}
const hse = { render: use }, gse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pse(e, t) {
  return v(), y("svg", gse, [...t[0] || (t[0] = [
    R("path", { d: "M248,144a8,8,0,0,1-8,8H192a8,8,0,0,1-6.4-12.8l43.17-57.55a16,16,0,1,0-27.86-15,8,8,0,0,1-15.09-5.33,32,32,0,1,1,55.74,29.92L208,136h32A8,8,0,0,1,248,144ZM149.24,74a8,8,0,0,0-11.29.8L92,127.79l-45.95-53A8,8,0,0,0,34,85.24L81.41,140,34,194.76a8,8,0,0,0,12.1,10.48l46-53,45.95,53a8,8,0,1,0,12.1-10.48L102.59,140l47.46-54.76A8,8,0,0,0,149.24,74Z" }, null, -1)
  ])]);
}
const fse = { render: pse }, mse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vse(e, t) {
  return v(), y("svg", mse, [...t[0] || (t[0] = [
    R("path", { d: "M213.38,221.92a8,8,0,0,1-11.3-.54L136,148.69V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V131.09L64,69.49V88a8,8,0,0,1-16,0V56a8,8,0,0,1,.72-3.31l-6.64-7.31A8,8,0,1,1,53.92,34.62l160,176A8,8,0,0,1,213.38,221.92ZM105.79,64H120V80.43a8,8,0,0,0,16,0V64h56V88a8,8,0,0,0,16,0V56a8,8,0,0,0-8-8H105.79a8,8,0,0,0,0,16Z" }, null, -1)
  ])]);
}
const Cse = { render: vse }, wse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yse(e, t) {
  return v(), y("svg", wse, [...t[0] || (t[0] = [
    R("path", { d: "M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z" }, null, -1)
  ])]);
}
const bse = { render: yse }, Sse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function xse(e, t) {
  return v(), y("svg", Sse, [...t[0] || (t[0] = [
    R("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }, null, -1)
  ])]);
}
const Rse = { render: xse }, Ese = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ase(e, t) {
  return v(), y("svg", Ese, [...t[0] || (t[0] = [
    R("path", { d: "M112,40a8,8,0,0,0-8,8V64H24A16,16,0,0,0,8,80v96a16,16,0,0,0,16,16h80v16a8,8,0,0,0,16,0V48A8,8,0,0,0,112,40ZM24,176V80h80v96ZM248,80v96a16,16,0,0,1-16,16H144a8,8,0,0,1,0-16h88V80H144a8,8,0,0,1,0-16h88A16,16,0,0,1,248,80ZM88,112a8,8,0,0,1-8,8H72v24a8,8,0,0,1-16,0V120H48a8,8,0,0,1,0-16H80A8,8,0,0,1,88,112Z" }, null, -1)
  ])]);
}
const Fse = { render: Ase }, Mse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Ise(e, t) {
  return v(), y("svg", Mse, [...t[0] || (t[0] = [
    R("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }, null, -1)
  ])]);
}
const Pse = { render: Ise }, Dse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Tse(e, t) {
  return v(), y("svg", Dse, [...t[0] || (t[0] = [
    R("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }, null, -1)
  ])]);
}
const kse = { render: Tse }, Lse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Bse(e, t) {
  return v(), y("svg", Lse, [...t[0] || (t[0] = [
    R("path", { d: "M160,112h48a16,16,0,0,0,16-16V48a16,16,0,0,0-16-16H160a16,16,0,0,0-16,16V64H128a24,24,0,0,0-24,24v32H72v-8A16,16,0,0,0,56,96H24A16,16,0,0,0,8,112v32a16,16,0,0,0,16,16H56a16,16,0,0,0,16-16v-8h32v32a24,24,0,0,0,24,24h16v16a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V160a16,16,0,0,0-16-16H160a16,16,0,0,0-16,16v16H128a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h16V96A16,16,0,0,0,160,112ZM56,144H24V112H56v32Zm104,16h48v48H160Zm0-112h48V96H160Z" }, null, -1)
  ])]);
}
const Ose = { render: Bse }, Gse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Hse(e, t) {
  return v(), y("svg", Gse, [...t[0] || (t[0] = [
    R("path", { d: "M176,152h32a16,16,0,0,0,16-16V104a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H88V80h8a16,16,0,0,0,16-16V32A16,16,0,0,0,96,16H64A16,16,0,0,0,48,32V64A16,16,0,0,0,64,80h8V192a24,24,0,0,0,24,24h64v8a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V192a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H96a8,8,0,0,1-8-8V128h72v8A16,16,0,0,0,176,152ZM64,32H96V64H64ZM176,192h32v32H176Zm0-88h32v32H176Z" }, null, -1)
  ])]);
}
const Vse = { render: Hse }, _se = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Nse(e, t) {
  return v(), y("svg", _se, [...t[0] || (t[0] = [
    R("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }, null, -1)
  ])]);
}
const $se = { render: Nse }, zse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Wse(e, t) {
  return v(), y("svg", zse, [...t[0] || (t[0] = [
    R("path", { d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.8,55.14a103.92,103.92,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-12.48,2.32,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z" }, null, -1)
  ])]);
}
const Use = { render: Wse }, Kse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Zse(e, t) {
  return v(), y("svg", Kse, [...t[0] || (t[0] = [
    R("path", { d: "M144,157.68a68,68,0,1,0-71.9,0c-20.65,6.76-39.23,19.39-54.17,37.17a8,8,0,1,0,12.24,10.3C50.25,181.19,77.91,168,108,168s57.75,13.19,77.87,37.15a8,8,0,0,0,12.26-10.3C183.18,177.07,164.6,164.44,144,157.68ZM56,100a52,52,0,1,1,52,52A52.06,52.06,0,0,1,56,100Zm196.25,43.07-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,1,0-8-13.86l-4.67,2.7a23.92,23.92,0,0,0-7.58-4.39V108a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,8,13.86l4.67-2.7a23.92,23.92,0,0,0,7.58,4.39V164a8,8,0,0,0,16,0v-5.38a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM216,136a8,8,0,1,1,8,8A8,8,0,0,1,216,136Z" }, null, -1)
  ])]);
}
const qse = { render: Zse }, jse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Yse(e, t) {
  return v(), y("svg", jse, [...t[0] || (t[0] = [
    R("path", { d: "M256,136a8,8,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A8,8,0,0,1,256,136Zm-57.87,58.85a8,8,0,0,1-12.26,10.3C165.75,181.19,138.09,168,108,168s-57.75,13.19-77.87,37.15a8,8,0,0,1-12.25-10.3c14.94-17.78,33.52-30.41,54.17-37.17a68,68,0,1,1,71.9,0C164.6,164.44,183.18,177.07,198.13,194.85ZM108,152a52,52,0,1,0-52-52A52.06,52.06,0,0,0,108,152Z" }, null, -1)
  ])]);
}
const Qse = { render: Yse }, Jse = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function Xse(e, t) {
  return v(), y("svg", Jse, [...t[0] || (t[0] = [
    R("path", { d: "M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z" }, null, -1)
  ])]);
}
const eie = { render: Xse }, tie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function nie(e, t) {
  return v(), y("svg", tie, [...t[0] || (t[0] = [
    R("path", { d: "M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z" }, null, -1)
  ])]);
}
const oie = { render: nie }, sie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function iie(e, t) {
  return v(), y("svg", sie, [...t[0] || (t[0] = [
    R("path", { d: "M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z" }, null, -1)
  ])]);
}
const rie = { render: iie }, aie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function lie(e, t) {
  return v(), y("svg", aie, [...t[0] || (t[0] = [
    R("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }, null, -1)
  ])]);
}
const die = { render: lie }, cie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function uie(e, t) {
  return v(), y("svg", cie, [...t[0] || (t[0] = [
    R("path", { d: "M128,72a8,8,0,0,1,8,8v56a8,8,0,0,1-16,0V80A8,8,0,0,1,128,72ZM116,172a12,12,0,1,0,12-12A12,12,0,0,0,116,172Zm124-44a15.85,15.85,0,0,1-4.67,11.28l-96.05,96.06a16,16,0,0,1-22.56,0h0l-96-96.06a16,16,0,0,1,0-22.56l96.05-96.06a16,16,0,0,1,22.56,0l96.05,96.06A15.85,15.85,0,0,1,240,128Zm-16,0L128,32,32,128,128,224h0Z" }, null, -1)
  ])]);
}
const hie = { render: uie }, gie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function pie(e, t) {
  return v(), y("svg", gie, [...t[0] || (t[0] = [
    R("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }, null, -1)
  ])]);
}
const fie = { render: pie }, mie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function vie(e, t) {
  return v(), y("svg", mie, [...t[0] || (t[0] = [
    R("path", { d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const Cie = { render: vie }, wie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function yie(e, t) {
  return v(), y("svg", wie, [...t[0] || (t[0] = [
    R("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }, null, -1)
  ])]);
}
const bie = { render: yie }, Sie = {
  "phosphor/address-book": oq,
  "phosphor/align-left": dq,
  "phosphor/align-left-simple": rq,
  "phosphor/arrow-bend-double-up-left": hq,
  "phosphor/arrow-bend-left-down": fq,
  "phosphor/arrow-bend-right-down": Cq,
  "phosphor/arrow-bend-up-left": bq,
  "phosphor/arrow-bend-up-right": Rq,
  "phosphor/arrow-counter-clockwise": Fq,
  "phosphor/arrow-down": Pq,
  "phosphor/arrow-elbow-down-left": kq,
  "phosphor/arrow-fat-up": Oq,
  "phosphor/arrow-left": Vq,
  "phosphor/arrow-line-down": $q,
  "phosphor/arrow-line-left": Uq,
  "phosphor/arrow-line-right": qq,
  "phosphor/arrow-line-up": Qq,
  "phosphor/arrow-square-out": ej,
  "phosphor/arrow-u-up-left": oj,
  "phosphor/arrow-up": rj,
  "phosphor/arrows-counter-clockwise": dj,
  "phosphor/arrows-down-up": hj,
  "phosphor/arrows-horizontal": fj,
  "phosphor/arrows-in-line-horizontal": Cj,
  "phosphor/arrows-in-line-vertical": bj,
  "phosphor/arrows-left-right": Rj,
  "phosphor/arrows-out": kj,
  "phosphor/arrows-out-line-horizontal": Fj,
  "phosphor/arrows-out-line-vertical": Pj,
  "phosphor/article-ny-times": Oj,
  "phosphor/at": Vj,
  "phosphor/bank": $j,
  "phosphor/barcode": Uj,
  "phosphor/battery-charging": qj,
  "phosphor/brackets-square": Qj,
  "phosphor/broom": eY,
  "phosphor/browser": oY,
  "phosphor/building": dY,
  "phosphor/building-apartment": rY,
  "phosphor/calculator": hY,
  "phosphor/calendar-blank": fY,
  "phosphor/cards-three": CY,
  "phosphor/caret-double-down": bY,
  "phosphor/caret-double-right": RY,
  "phosphor/caret-double-up": FY,
  "phosphor/caret-down": PY,
  "phosphor/caret-down-fill": OZ,
  "phosphor/caret-left": kY,
  "phosphor/caret-right": OY,
  "phosphor/caret-right-bold": FZ,
  "phosphor/caret-right-fill": VZ,
  "phosphor/caret-up": VY,
  "phosphor/chart-line": $Y,
  "phosphor/check": qY,
  "phosphor/check-circle": UY,
  "phosphor/check-circle-fill": $Z,
  "phosphor/circle": eQ,
  "phosphor/circle-dashed": QY,
  "phosphor/city": oQ,
  "phosphor/clipboard-text": rQ,
  "phosphor/clock": dQ,
  "phosphor/code": fQ,
  "phosphor/code-simple": hQ,
  "phosphor/columns": RQ,
  "phosphor/columns-plus-left": CQ,
  "phosphor/columns-plus-right": bQ,
  "phosphor/copy": FQ,
  "phosphor/cursor-text": PQ,
  "phosphor/dots-six": OQ,
  "phosphor/dots-six-vertical": kQ,
  "phosphor/dots-three": UQ,
  "phosphor/dots-three-circle": VQ,
  "phosphor/dots-three-vertical": $Q,
  "phosphor/download-simple": qQ,
  "phosphor/drop": QQ,
  "phosphor/envelope": eJ,
  "phosphor/equals": oJ,
  "phosphor/eye": dJ,
  "phosphor/eye-slash": rJ,
  "phosphor/figma-logo": hJ,
  "phosphor/file": qJ,
  "phosphor/file-csv": fJ,
  "phosphor/file-lock": CJ,
  "phosphor/file-magnifying-glass": bJ,
  "phosphor/file-minus": RJ,
  "phosphor/file-pdf": FJ,
  "phosphor/file-plus": PJ,
  "phosphor/file-ppt": kJ,
  "phosphor/file-txt": OJ,
  "phosphor/file-video": VJ,
  "phosphor/file-x": $J,
  "phosphor/file-zip": UJ,
  "phosphor/flip-horizontal": QJ,
  "phosphor/flip-vertical": eX,
  "phosphor/floppy-disk": oX,
  "phosphor/folder": hX,
  "phosphor/folder-minus": rX,
  "phosphor/folder-plus": dX,
  "phosphor/funnel": CX,
  "phosphor/funnel-simple": fX,
  "phosphor/gear": bX,
  "phosphor/globe": RX,
  "phosphor/greater-than": PX,
  "phosphor/greater-than-or-equal": FX,
  "phosphor/grid-nine": kX,
  "phosphor/hand-deposit": OX,
  "phosphor/hard-drives": VX,
  "phosphor/hash": $X,
  "phosphor/highlighter": UX,
  "phosphor/house": qX,
  "phosphor/image": eee,
  "phosphor/image-square": QX,
  "phosphor/info": oee,
  "phosphor/info-fill": UZ,
  "phosphor/key": ree,
  "phosphor/layout": dee,
  "phosphor/layout-duotone": PZ,
  "phosphor/less-than": fee,
  "phosphor/less-than-or-equal": hee,
  "phosphor/link": Cee,
  "phosphor/list": kee,
  "phosphor/list-bullets": bee,
  "phosphor/list-checks": Ree,
  "phosphor/list-numbers": Fee,
  "phosphor/list-plus": Pee,
  "phosphor/lock-simple": Vee,
  "phosphor/lock-simple-open": Oee,
  "phosphor/magnifying-glass": qee,
  "phosphor/magnifying-glass-minus": $ee,
  "phosphor/magnifying-glass-plus": Uee,
  "phosphor/map-pin-simple-area": Qee,
  "phosphor/microsoft-excel-logo": ete,
  "phosphor/microsoft-word-logo": ote,
  "phosphor/minus": dte,
  "phosphor/minus-circle": rte,
  "phosphor/minus-circle-duotone": kZ,
  "phosphor/network": hte,
  "phosphor/not-equals": fte,
  "phosphor/note-pencil": Cte,
  "phosphor/notebook": bte,
  "phosphor/number-square-four": Rte,
  "phosphor/number-square-one": Fte,
  "phosphor/number-square-three": Pte,
  "phosphor/number-square-two": kte,
  "phosphor/paint-bucket": Ote,
  "phosphor/palette": Vte,
  "phosphor/paper-plane-right": $te,
  "phosphor/paperclip": Ute,
  "phosphor/pencil-line": qte,
  "phosphor/pencil-simple": ene,
  "phosphor/pencil-simple-line": Qte,
  "phosphor/phone": one,
  "phosphor/plug": rne,
  "phosphor/plus": hne,
  "phosphor/plus-circle": dne,
  "phosphor/printer": fne,
  "phosphor/push-pin": Cne,
  "phosphor/question": bne,
  "phosphor/rows": Pne,
  "phosphor/rows-plus-bottom": Rne,
  "phosphor/rows-plus-top": Fne,
  "phosphor/scissors": kne,
  "phosphor/selection-all": One,
  "phosphor/sigma": Vne,
  "phosphor/sign-in": $ne,
  "phosphor/sign-out": Une,
  "phosphor/sketch-logo": qne,
  "phosphor/sliders-horizontal": Qne,
  "phosphor/sparkle": eoe,
  "phosphor/split-horizontal": ooe,
  "phosphor/square": roe,
  "phosphor/stack": Coe,
  "phosphor/stack-minus": doe,
  "phosphor/stack-overflow-logo": hoe,
  "phosphor/stack-plus": foe,
  "phosphor/star": boe,
  "phosphor/star-fill": qZ,
  "phosphor/suitcase-simple": Roe,
  "phosphor/swap": Foe,
  "phosphor/table": Poe,
  "phosphor/text-align-center": koe,
  "phosphor/text-align-justify": Ooe,
  "phosphor/text-align-left": Voe,
  "phosphor/text-align-right": $oe,
  "phosphor/text-b": Uoe,
  "phosphor/text-columns": qoe,
  "phosphor/text-h": Qoe,
  "phosphor/text-indent": ese,
  "phosphor/text-italic": ose,
  "phosphor/text-outdent": rse,
  "phosphor/text-strikethrough": dse,
  "phosphor/text-subscript": hse,
  "phosphor/text-superscript": fse,
  "phosphor/text-t": bse,
  "phosphor/text-t-slash": Cse,
  "phosphor/text-underline": Rse,
  "phosphor/textbox": Fse,
  "phosphor/timer": Pse,
  "phosphor/trash": kse,
  "phosphor/tree-structure": Ose,
  "phosphor/tree-view": Vse,
  "phosphor/upload-simple": $se,
  "phosphor/user": eie,
  "phosphor/user-circle-dashed": Use,
  "phosphor/user-gear": qse,
  "phosphor/user-plus": Qse,
  "phosphor/users": rie,
  "phosphor/users-three": oie,
  "phosphor/warning": fie,
  "phosphor/warning-circle": die,
  "phosphor/warning-diamond": hie,
  "phosphor/warning-diamond-fill": QZ,
  "phosphor/warning-fill": eq,
  "phosphor/x": bie,
  "phosphor/x-circle": Cie
}, xie = /* @__PURE__ */ Object.assign({
  "../../assets/icons/generic/add-to-folder.svg": bK,
  "../../assets/icons/generic/calendar-time.svg": RK,
  "../../assets/icons/generic/columns-minus.svg": FK,
  "../../assets/icons/generic/create-folder.svg": PK,
  "../../assets/icons/generic/dossier-module.svg": kK,
  "../../assets/icons/generic/dossier.svg": OK,
  "../../assets/icons/generic/dot.svg": VK,
  "../../assets/icons/generic/file-psd.svg": $K,
  "../../assets/icons/generic/initial-avatar.svg": UK,
  "../../assets/icons/generic/mail-draft.svg": qK,
  "../../assets/icons/generic/mail-inbox.svg": QK,
  "../../assets/icons/generic/mail-sent.svg": eZ,
  "../../assets/icons/generic/row-groups.svg": oZ,
  "../../assets/icons/generic/rows-minus.svg": rZ,
  "../../assets/icons/generic/scayla-logo-text.svg": dZ,
  "../../assets/icons/generic/scayla-logo.svg": hZ,
  "../../assets/icons/generic/size-l.svg": fZ,
  "../../assets/icons/generic/size-m.svg": CZ,
  "../../assets/icons/generic/size-s.svg": bZ,
  "../../assets/icons/generic/text-italic-x.svg": RZ
}), Rie = (e) => e.replace(/^.*\/icons\/|\.svg$/g, ""), sg = new Map([
  ...Object.entries(Sie),
  ...Object.entries(xie).map(([e, t]) => [Rie(e), t])
]), Eie = "phosphor/question", X0 = /* @__PURE__ */ new Set(), Aie = (e) => {
  if (!e) return;
  const t = sg.get(e);
  return t || (X0.has(e) || (X0.add(e), aA().logger.warn(`Unknown icon "${e}"`)()), sg.get(Eie));
}, Fie = de({
  name: "SCASvgIcon"
}), Mie = /* @__PURE__ */ de({
  ...Fie,
  props: {
    size: { default: "20px" },
    icon: {},
    mirrorX: { type: Boolean, default: !1 },
    mirrorY: { type: Boolean, default: !1 },
    color: { default: void 0 }
  },
  setup(e) {
    Ls((s) => ({
      v2d3b5d04: n.value
    }));
    const t = e, n = D(() => t.size), o = D(() => Aie(t.icon));
    return (s, i) => (v(), z(Ot(o.value), {
      key: e.icon,
      "aria-hidden": "true",
      class: x([s.$style.icon, { [s.$style.mirrorX]: e.mirrorX, [s.$style.mirrorY]: e.mirrorY }]),
      style: Ke(e.color ? { "--sca-icon-color": e.color, color: e.color } : void 0)
    }, null, 8, ["class", "style"]));
  }
}), Iie = "_icon_16bdd_11", Pie = "_mirrorX_16bdd_20", Die = "_mirrorY_16bdd_23", Tie = {
  icon: Iie,
  mirrorX: Pie,
  mirrorY: Die
}, kie = {
  $style: Tie
}, Fe = /* @__PURE__ */ we(Mie, [["__cssModules", kie]]), Lie = ["href", "target", "rel"], Bie = /* @__PURE__ */ de({
  __name: "SCATooltip",
  props: {
    id: {},
    target: {},
    text: {},
    delay: {},
    helpLink: {},
    linkLabel: {},
    styles: {},
    scrollable: { type: Boolean },
    alwaysVisible: { type: Boolean }
  },
  emits: ["link-click"],
  setup(e, { emit: t }) {
    const n = e, o = t, { t: s } = fn(), i = rn(), r = D(() => !!n.helpLink || !!n.linkLabel || !!n.scrollable || !!i.default);
    function a(H) {
      n.helpLink || (H.preventDefault(), o("link-click"));
    }
    function l(H) {
      const _ = H.trim().split(/\s+/);
      return _.length === 1 ? { top: _[0], right: _[0], bottom: _[0], left: _[0] } : _.length === 2 ? { top: _[0], right: _[1], bottom: _[0], left: _[1] } : _.length === 3 ? { top: _[0], right: _[1], bottom: _[2], left: _[1] } : { top: _[0], right: _[1], bottom: _[2], left: _[3] };
    }
    const d = D(() => {
      const H = n.styles, _ = {};
      if (H != null && H.fontSize && (_.fontSize = H.fontSize), H != null && H.textColor && (_.color = H.textColor), H != null && H.maxWidth && (_.maxWidth = H.maxWidth), H != null && H.padding && (_.padding = H.padding), n.scrollable && (H != null && H.contentPadding)) {
        const ne = l(H.contentPadding);
        _.paddingTop = ne.top, _.paddingBottom = ne.bottom;
      }
      return _;
    }), c = D(() => {
      if (!n.scrollable) return {};
      const H = n.styles, _ = {};
      if (H != null && H.maxHeight && (_.maxHeight = H.maxHeight), H != null && H.contentPadding) {
        const ne = l(H.contentPadding);
        _.padding = `0 ${ne.right} 0 ${ne.left}`;
      }
      return _;
    }), u = W(null), h = W(null), g = W(null), p = W("top"), f = W(!1);
    let m = null, C = null;
    const w = () => n.target ?? (n.id ? document.getElementById(n.id) : null), b = () => {
      const H = w(), _ = u.value, ne = h.value, ce = g.value;
      if (!H || !_ || !ne || !ce) return;
      const me = H.getBoundingClientRect(), L = (_.offsetWidth > 0 ? _.getBoundingClientRect() : null) ?? ne.getBoundingClientRect(), oe = 8, K = 20;
      let G = me.left + me.width / 2 - L.width / 2, le = me.bottom + 6;
      const be = window.innerWidth - L.width - oe;
      G = Math.max(oe, Math.min(G, be));
      const Me = window.innerHeight - L.height - oe;
      le > Me ? (le = me.top - L.height - 8, p.value = "bottom") : p.value = "top", _.style.right = "auto", _.style.bottom = "auto", _.style.left = `${Math.round(G)}px`, _.style.top = `${Math.round(le)}px`;
      const Be = me.left + me.width / 2, qe = G + L.width / 2, he = Be - qe;
      let Pe = L.width / 2 + he;
      Pe = Math.max(K, Math.min(L.width - K, Pe)), ce.style.left = `${Math.round(Pe)}px`, ce.style.transform = "translateX(-50%)";
    }, A = async () => {
      var H, _;
      m = null, f.value = !0, await Xe(), b(), (_ = (H = u.value) == null ? void 0 : H.showPopover) == null || _.call(H), b();
    }, S = () => {
      m && clearTimeout(m), m = window.setTimeout(() => {
        A();
      }, n.delay ?? 600);
    }, F = () => {
      var H, _;
      n.alwaysVisible || (C && (clearTimeout(C), C = null), (_ = (H = u.value) == null ? void 0 : H.hidePopover) == null || _.call(H), f.value = !1);
    }, E = () => {
      if (m && (clearTimeout(m), m = null), r.value) {
        C && clearTimeout(C), C = window.setTimeout(F, 120);
        return;
      }
      F();
    }, M = () => {
      r.value && C && (clearTimeout(C), C = null);
    }, I = () => {
      r.value && F();
    }, P = (H) => {
      H.addEventListener("mouseenter", S), H.addEventListener("mouseleave", E), H.addEventListener("mousedown", E), H.addEventListener("click", E);
    }, k = (H) => {
      H.removeEventListener("mouseenter", S), H.removeEventListener("mouseleave", E), H.removeEventListener("mousedown", E), H.removeEventListener("click", E);
    };
    let B = null, j = null;
    const N = () => {
      if (!n.id) return !1;
      const H = document.getElementById(n.id);
      return H ? (P(H), j = H, !0) : !1;
    }, re = () => {
      f.value && b();
    };
    return Et(() => {
      n.id && !N() && (B = new MutationObserver(() => {
        N() && (B == null || B.disconnect(), B = null);
      }), B.observe(document.body, { childList: !0, subtree: !0 })), window.addEventListener("scroll", re, !0), window.addEventListener("resize", re), n.alwaysVisible && A();
    }), Re(
      () => n.target,
      (H, _) => {
        _ && k(_), H && P(H), H && f.value && Xe().then(b);
      },
      { immediate: !0 }
    ), io(() => {
      j && k(j), n.target && k(n.target), B == null || B.disconnect(), B = null, m && clearTimeout(m), C && clearTimeout(C), window.removeEventListener("scroll", re, !0), window.removeEventListener("resize", re);
    }), (H, _) => (v(), y(Se, null, [
      f.value ? (v(), y("div", {
        key: 0,
        ref_key: "measureRef",
        ref: h,
        class: x([H.$style.tooltip, { [H.$style.interactive]: r.value, [H.$style.scrollableTooltip]: !!e.scrollable }]),
        style: Ke([d.value, { position: "fixed", top: "-9999px", left: "-9999px", visibility: "hidden" }]),
        "aria-hidden": "true"
      }, [
        R("div", {
          class: x([H.$style.content, { [H.$style.scrollableContent]: !!e.scrollable }]),
          style: Ke(c.value)
        }, [
          R("div", {
            class: x(H.$style.text)
          }, [
            ve(H.$slots, "default", {}, () => [
              Oe(se(e.text), 1)
            ])
          ], 2),
          e.helpLink || e.linkLabel ? (v(), y("a", {
            key: 0,
            class: x(H.$style.helpLink)
          }, se(e.linkLabel ?? T(s)("common.label.help")), 3)) : V("", !0)
        ], 6)
      ], 6)) : V("", !0),
      f.value ? (v(), z(qi, {
        key: 1,
        to: "body"
      }, [
        R("div", {
          ref_key: "tooltipRef",
          ref: u,
          class: x([H.$style.tooltip, { [H.$style.interactive]: r.value, [H.$style.scrollableTooltip]: !!e.scrollable }]),
          style: Ke(d.value),
          popover: "manual",
          onMouseenter: M,
          onMouseleave: I
        }, [
          R("div", {
            class: x([H.$style.content, { [H.$style.scrollableContent]: !!e.scrollable }]),
            style: Ke(c.value)
          }, [
            R("div", {
              class: x(H.$style.text)
            }, [
              ve(H.$slots, "default", {}, () => [
                Oe(se(e.text), 1)
              ])
            ], 2),
            e.helpLink || e.linkLabel ? (v(), y("a", {
              key: 0,
              class: x(H.$style.helpLink),
              href: e.helpLink,
              target: e.helpLink ? "_blank" : void 0,
              rel: e.helpLink ? "noopener noreferrer" : void 0,
              onClick: a
            }, se(e.linkLabel ?? T(s)("common.label.help")), 11, Lie)) : V("", !0)
          ], 6),
          R("div", {
            ref_key: "arrowRef",
            ref: g,
            class: x([H.$style.arrow, p.value === "top" ? H.$style.arrowTop : H.$style.arrowBottom]),
            "aria-hidden": "true"
          }, [..._[0] || (_[0] = [
            R("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "10",
              height: "5",
              viewBox: "0 0 10 5",
              preserveAspectRatio: "none"
            }, [
              R("path", {
                d: "M0.515137 4.05811H9.51514L6.0758 0.618764C5.49001 0.0329781 4.54026 0.0329795 3.95448 0.618766L0.515137 4.05811Z",
                fill: "currentColor"
              })
            ], -1)
          ])], 2)
        ], 38)
      ])) : V("", !0)
    ], 64));
  }
}), Oie = "_tooltip_gibwv_1", Gie = "_scrollableTooltip_gibwv_22", Hie = "_scrollableContent_gibwv_26", Vie = "_interactive_gibwv_32", _ie = "_content_gibwv_32", Nie = "_text_gibwv_40", $ie = "_helpLink_gibwv_45", zie = "_arrow_gibwv_52", Wie = "_arrowTop_gibwv_66", Uie = "_arrowBottom_gibwv_73", Kie = {
  tooltip: Oie,
  scrollableTooltip: Gie,
  scrollableContent: Hie,
  interactive: Vie,
  content: _ie,
  text: Nie,
  helpLink: $ie,
  arrow: zie,
  arrowTop: Wie,
  arrowBottom: Uie
}, Zie = {
  $style: Kie
}, zt = /* @__PURE__ */ we(Bie, [["__cssModules", Zie]]), qie = /* @__PURE__ */ de({
  __name: "SCAButton",
  props: {
    type: { default: "default" },
    size: { default: "medium" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    iconSize: { default: void 0 },
    iconMirrorX: { type: Boolean, default: !1 },
    iconMirrorY: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    hasDropdown: { type: Boolean, default: !1 },
    intent: { default: "none" },
    loading: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    appearance: { default: "primary" },
    shadow: { type: Boolean, default: !0 },
    title: { default: void 0 },
    tooltip: { default: void 0 },
    gap: { default: "8px" },
    paddingLeft: { default: void 0 },
    paddingRight: { default: void 0 },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, n = `btn-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 8)}`, o = D(() => t.as === "button"), s = D(() => !o.value && (t.disabled || t.loading)), i = D(() => t.tooltip ?? t.title), r = D(() => ({
      "--button-gap": t.gap,
      "--button-padding-left": t.paddingLeft ?? "12px",
      "--button-padding-right": t.paddingRight ?? "12px"
    }));
    return (a, l) => (v(), z(Ot(e.as), {
      id: n,
      class: x([
        a.$style.button,
        {
          [a.$style.typeDefault]: e.type === "default",
          [a.$style.typeGhost]: e.type === "ghost",
          [a.$style.typeBare]: e.type === "bare",
          [a.$style.typeToggle]: e.type === "toggle",
          [a.$style.primary]: e.appearance === "primary",
          [a.$style.secondary]: e.appearance === "secondary",
          [a.$style.inverted]: e.appearance === "inverted",
          [a.$style.reverseInverted]: e.appearance === "reverseInverted",
          [a.$style.sizeSmall]: e.size === "xsmall",
          [a.$style.sizeSmall]: e.size === "small",
          [a.$style.sizeMedium]: e.size === "medium",
          [a.$style.sizeLarge]: e.size === "large",
          [a.$style.intentNone]: e.intent === "none",
          [a.$style.intentSuccess]: e.intent === "success",
          [a.$style.intentDestructive]: e.intent === "destructive",
          [a.$style.shadow]: e.shadow,
          [a.$style.selected]: e.selected,
          [a.$style.hasIconLeft]: !!e.iconLeft,
          [a.$style.inert]: s.value
        }
      ]),
      style: Ke(r.value),
      "data-type": e.type,
      type: o.value ? "button" : void 0,
      disabled: o.value ? e.disabled || e.loading : void 0,
      "aria-disabled": s.value || void 0,
      tabindex: s.value ? -1 : void 0
    }, {
      default: Q(() => [
        e.iconLeft && !e.loading ? (v(), z(Fe, {
          key: 0,
          icon: e.iconLeft,
          size: e.iconSize,
          "mirror-x": e.iconMirrorX,
          "mirror-y": e.iconMirrorY
        }, null, 8, ["icon", "size", "mirror-x", "mirror-y"])) : V("", !0),
        e.iconLeft && e.loading ? (v(), z(rl, {
          key: 1,
          size: "small",
          appearance: e.appearance === "inverted" || e.type === "default" && e.appearance === "primary" ? "white" : "greyscale",
          indeterminate: ""
        }, null, 8, ["appearance"])) : V("", !0),
        a.$slots.default ? (v(), y("span", {
          key: 2,
          class: x(a.$style.label)
        }, [
          ve(a.$slots, "default")
        ], 2)) : V("", !0),
        ve(a.$slots, "special"),
        e.iconRight ? (v(), z(Fe, {
          key: 3,
          icon: e.iconRight,
          size: e.iconSize
        }, null, 8, ["icon", "size"])) : V("", !0),
        e.hasDropdown ? (v(), z(Fe, {
          key: 4,
          icon: "phosphor/caret-down",
          size: "12px"
        })) : V("", !0),
        e.tooltip || e.title ? (v(), z(zt, {
          key: 5,
          id: n,
          text: i.value ?? ""
        }, null, 8, ["text"])) : V("", !0)
      ]),
      _: 3
    }, 8, ["class", "style", "data-type", "type", "disabled", "aria-disabled", "tabindex"]));
  }
}), jie = "_button_ymu3q_747", Yie = "_sizeSmall_ymu3q_759", Qie = "_hasIconLeft_ymu3q_769", Jie = "_sizeMedium_ymu3q_772", Xie = "_sizeLarge_ymu3q_781", ere = "_inert_ymu3q_796", tre = "_typeDefault_ymu3q_803", nre = "_shadow_ymu3q_808", ore = "_primary_ymu3q_811", sre = "_intentNone_ymu3q_811", ire = "_selected_ymu3q_817", rre = "_intentSuccess_ymu3q_820", are = "_intentDestructive_ymu3q_832", lre = "_secondary_ymu3q_844", dre = "_inverted_ymu3q_893", cre = "_typeGhost_ymu3q_904", ure = "_reverseInverted_ymu3q_988", hre = "_typeBare_ymu3q_999", gre = "_typeToggle_ymu3q_1095", pre = "_label_ymu3q_1142", fre = {
  button: jie,
  sizeSmall: Yie,
  hasIconLeft: Qie,
  sizeMedium: Jie,
  sizeLarge: Xie,
  inert: ere,
  typeDefault: tre,
  shadow: nre,
  primary: ore,
  intentNone: sre,
  selected: ire,
  intentSuccess: rre,
  intentDestructive: are,
  secondary: lre,
  inverted: dre,
  typeGhost: cre,
  reverseInverted: ure,
  typeBare: hre,
  typeToggle: gre,
  label: pre
}, mre = {
  $style: fre
}, Zt = /* @__PURE__ */ we(qie, [["__cssModules", mre]]), vre = /* @__PURE__ */ de({
  __name: "SCAIconButton",
  props: {
    type: { default: "default" },
    size: { default: "medium" },
    icon: { default: void 0 },
    iconSize: { default: void 0 },
    iconMirrorX: { type: Boolean, default: !1 },
    iconMirrorY: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    hasDropdown: { type: Boolean, default: !1 },
    intent: { default: "none" },
    loading: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    appearance: { default: "primary" },
    as: { default: "button" }
  },
  setup(e) {
    return (t, n) => (v(), z(Zt, {
      as: e.as,
      class: x([
        t.$style.button,
        {
          [t.$style.typeBare]: e.type === "bare",
          [t.$style.xsmall]: e.size === "xsmall",
          [t.$style.sizeSmall]: e.size === "small",
          [t.$style.sizeMedium]: e.size === "medium",
          [t.$style.sizeLarge]: e.size === "large",
          [t.$style.dropDown]: e.hasDropdown
        }
      ]),
      "icon-left": e.icon,
      "icon-size": e.iconSize,
      "icon-mirror-x": e.iconMirrorX,
      "icon-mirror-y": e.iconMirrorY,
      type: e.type,
      size: e.size,
      disabled: e.disabled,
      "has-dropdown": e.hasDropdown,
      intent: e.intent,
      selected: e.selected,
      appearance: e.appearance
    }, null, 8, ["as", "class", "icon-left", "icon-size", "icon-mirror-x", "icon-mirror-y", "type", "size", "disabled", "has-dropdown", "intent", "selected", "appearance"]));
  }
}), Cre = "_button_129ut_747", wre = "_typeBare_129ut_751", yre = "_xsmall_129ut_751", bre = "_dropDown_129ut_756", Sre = "_sizeSmall_129ut_759", xre = "_sizeMedium_129ut_767", Rre = "_sizeLarge_129ut_775", Ere = {
  button: Cre,
  typeBare: wre,
  xsmall: yre,
  dropDown: bre,
  sizeSmall: Sre,
  sizeMedium: xre,
  sizeLarge: Rre
}, Are = {
  $style: Ere
}, ut = /* @__PURE__ */ we(vre, [["__cssModules", Are]]);
function MS(e) {
  const t = e == null ? void 0 : e.closest("[data-dropdown-anchor], [popover]");
  return t instanceof HTMLElement && t.hasAttribute("data-dropdown-anchor") ? t : null;
}
function Fre(e) {
  return e.startsWith("left") || e.startsWith("right");
}
function ev({ elements: e }) {
  const { marginTop: t, marginBottom: n } = getComputedStyle(e.floating);
  return { bottom: (parseFloat(t) || 0) + (parseFloat(n) || 0) };
}
const Mre = 150;
function Ire(e) {
  const t = W(!1);
  let n;
  function o(i) {
    var r;
    i.target instanceof Node && ((r = xe(e.ignoreWithin)) != null && r.contains(i.target)) || (t.value = !0, clearTimeout(n), n = setTimeout(() => t.value = !1, Mre));
  }
  function s() {
    document.removeEventListener("scroll", o, { capture: !0 }), clearTimeout(n), t.value = !1;
  }
  return Re(
    () => xe(e.active),
    (i) => {
      i ? document.addEventListener("scroll", o, { capture: !0, passive: !0 }) : s();
    },
    { immediate: !0 }
  ), ro(s), { scrolling: t };
}
const Pre = ["id", "data-popover-open"], Yu = 300, tv = 8, Dre = /* @__PURE__ */ de({
  __name: "SCADropdown",
  props: {
    placement: { default: "bottom-start" },
    offsetX: { default: void 0 },
    offsetY: { default: void 0 },
    matchTriggerWidth: { default: void 0 },
    scrollUp: { type: Boolean, default: !1 },
    scrollDown: { type: Boolean, default: !1 },
    triggerAlign: { default: "horizontal" },
    isOpen: { type: Boolean, default: !1 },
    lessBorder: { type: Boolean, default: !1 },
    noBorder: { type: Boolean, default: !1 },
    noPadding: { type: Boolean, default: !1 },
    morePadding: { type: Boolean, default: !1 },
    shadowVariant: { default: "default" },
    trigger: { default: "click" },
    noMobileMargin: { type: Boolean, default: !1 },
    toolbarOffset: { type: Boolean, default: !1 },
    width: { default: void 0 },
    paddingUpset: { type: Boolean },
    gap: { default: void 0 }
  },
  emits: ["opened", "closed", "positioned", "update:isOpen"],
  setup(e, { expose: t, emit: n }) {
    const o = {
      horizontal: "phosphor/dots-three",
      vertical: "phosphor/dots-three-vertical"
    }, s = e, i = n, r = sK(), a = W(), l = W(), d = W(), c = W(), u = W(), h = Bn(s, "isOpen", i, { passive: !0 }), g = Q0(c), p = Q0(u), f = W(!1), m = W(!1), C = W(!1), { scrolling: w } = Ire({ active: h, ignoreWithin: a });
    let b, A, S;
    const F = W(null), E = W(null), M = W(!1), I = W(!1);
    function P() {
      var ie;
      h.value && ((ie = a.value) == null || ie.hidePopover());
    }
    t({
      popoverId: r,
      hideNow: P
    });
    function k(ie) {
      var ee;
      (ee = a.value) == null || ee.togglePopover(ie == null ? void 0 : ie.force);
    }
    function B(ie) {
      ie.newState === "open" && (C.value = !0);
    }
    function j(ie) {
      if (h.value = ie.newState === "open", ie.newState === "closed" && (C.value = !1), ie.newState === ie.oldState) {
        ie.newState === "open" && (C.value = !1);
        return;
      }
      if (ie.newState === "open") {
        i("opened"), S = setTimeout(() => m.value = !0, Yu);
        return;
      }
      clearTimeout(S), f.value = !1, i("closed"), m.value = !1;
    }
    Re(h, (ie) => {
      clearTimeout(A), f.value = ie, ie && (A = setTimeout(() => f.value = !1, Yu));
    });
    const N = D(() => s.matchTriggerWidth === "exact" ? "width" : s.matchTriggerWidth === "min" ? "min-width" : s.matchTriggerWidth === "max" ? "max-width" : void 0), re = () => {
      var ie;
      b && (clearTimeout(b), b = void 0), (ie = a.value) == null || ie.showPopover();
    }, H = () => {
      b && clearTimeout(b), b = setTimeout(() => {
        var ie;
        (ie = a.value) == null || ie.hidePopover();
      }, 200);
    }, _ = D(() => s.placement);
    function ne() {
      const ie = a.value;
      ie && (ie.style.maxHeight = "", ie.style.width = "", ie.style.minWidth = "", ie.style.maxWidth = "");
    }
    const ce = D(() => {
      const ie = s.offsetY ?? (s.toolbarOffset ? 7.5 : void 0);
      return [
        CS({ mainAxis: ie, crossAxis: s.offsetX }),
        yS({
          fallbackStrategy: "bestFit"
        }),
        // A side submenu on a narrow screen fits neither side; shifting it sideways keeps it on screen.
        wS((ee) => ({
          crossAxis: Fre(s.placement),
          padding: { ...ev(ee), left: tv, right: tv }
        })),
        wU((ee) => ({
          padding: ev(ee),
          apply({ rects: ae, elements: _e, availableHeight: Ne }) {
            N.value && Object.assign(_e.floating.style, {
              [N.value]: `${ae.reference.width}px`
            }), Object.assign(_e.floating.style, {
              maxHeight: `${Math.max(0, Ne)}px`
            });
          }
        }))
      ];
    }), me = W(null), Ie = D(() => me.value ?? d.value);
    function L() {
      me.value = MS(d.value);
    }
    Et(L);
    const {
      x: oe,
      y: K,
      floatingStyles: G,
      update: le,
      placement: be
    } = xU(Ie, a, {
      placement: _,
      middleware: ce,
      strategy: "fixed"
    });
    Re([oe, K, be], ([ie, ee, ae], [_e, Ne, At]) => {
      var pt;
      ae === At || !m.value || !w.value || (pt = a.value) == null || pt.animate([{ translate: `${_e - ie}px ${Ne - ee}px` }, { translate: "0px 0px" }], {
        duration: Yu,
        easing: "ease",
        composite: "add"
      });
    }), Re(a, () => {
      a.value && le();
    });
    let Me, Be = 0;
    Re(h, (ie, ee) => {
      if (ie ? document.addEventListener("touchstart", ge, { capture: !0, passive: !0 }) : document.removeEventListener("touchstart", ge, { capture: !0 }), ie !== ee && (h.value && (C.value = !0), k({ force: h.value })), !h.value) {
        Me == null || Me(), Me = void 0;
        return;
      }
      if (Me == null || Me(), L(), h.value && Ie.value && a.value) {
        const ae = ++Be;
        Xe(() => {
          requestAnimationFrame(() => {
            !h.value || !Ie.value || !a.value || (ne(), Promise.resolve(le()).then(() => Xe()).then(() => {
              ae === Be && (C.value = !1, Xe(() => i("positioned")));
            }), Me = ng(Ie.value, a.value, le, {
              animationFrame: !0
            }));
          });
        });
        return;
      }
      C.value = !1;
    });
    function qe(ie) {
      var ee;
      s.trigger === "hover" && h.value && (ee = ie.target) != null && ee.closest("button[popovertarget], input[popovertarget]") && ie.preventDefault();
    }
    function he(ie) {
      I.value = ie.pointerType !== "mouse";
    }
    function Pe(ie) {
      I.value && ie.preventDefault();
    }
    function J() {
      s.trigger === "hover" && (E.value = Date.now(), M.value = !1, F.value = setTimeout(() => {
        M.value || re();
      }, 500));
    }
    function Y() {
      M.value = !0, F.value && clearTimeout(F.value);
    }
    function q(ie) {
      F.value && clearTimeout(F.value), E.value && s.trigger === "hover" && Date.now() - E.value >= 500 && !M.value && ie.cancelable && ie.preventDefault(), E.value = null, M.value = !1;
    }
    const ge = (ie) => {
      d.value && !d.value.contains(ie.target) && h.value && H();
    };
    return ks(() => {
      document.removeEventListener("touchstart", ge, { capture: !0 }), Me == null || Me();
    }), (ie, ee) => (v(), y("div", {
      ref_key: "dropdownRef",
      ref: d,
      class: x(ie.$style.dropdown)
    }, [
      R("div", {
        ref_key: "triggerRef",
        ref: l,
        class: x([ie.$style.trigger, T(h) && ie.$style.triggerOpen]),
        onMouseenter: ee[2] || (ee[2] = (ae) => s.trigger === "hover" ? re() : null),
        onMouseleave: ee[3] || (ee[3] = (ae) => s.trigger === "hover" ? H() : null),
        onClickCapture: qe,
        onPointerdownPassive: he,
        onTouchstartPassive: J,
        onTouchmovePassive: Y,
        onTouchend: q,
        onContextmenu: Pe
      }, [
        ve(ie.$slots, "trigger", {
          target: T(r),
          isOpen: T(h),
          togglePopover: k,
          popover: a.value,
          onMouseenter: ee[0] || (ee[0] = (ae) => s.trigger === "hover" ? re() : null),
          onMouseleave: ee[1] || (ee[1] = (ae) => s.trigger === "hover" ? H() : null)
        }, () => [
          te(ut, {
            popovertarget: T(r),
            size: "small",
            type: "ghost",
            appearance: "secondary",
            icon: o[e.triggerAlign]
          }, null, 8, ["popovertarget", "icon"])
        ])
      ], 34),
      R("div", {
        id: T(r),
        ref_key: "popoverRef",
        ref: a,
        class: x([
          ie.$style.popover,
          e.lessBorder && ie.$style.lessBorder,
          e.noBorder && ie.$style.noBorder,
          (e.noPadding || e.paddingUpset) && ie.$style.noPadding,
          e.shadowVariant === "upward" && ie.$style.shadowUpward,
          m.value && !T(w) && ie.$style.withTransition,
          e.noMobileMargin && ie.$style.noMobileMargin,
          C.value && ie.$style.positioning
        ]),
        popover: "",
        "data-popover-open": T(h) || void 0,
        style: Ke({ transform: T(G).transform }),
        onBeforetoggle: B,
        onToggle: j,
        onMouseenter: ee[4] || (ee[4] = (ae) => s.trigger === "hover" ? re() : null),
        onMouseleave: ee[5] || (ee[5] = (ae) => s.trigger === "hover" ? H() : null)
      }, [
        T(h) ? (v(), y("div", {
          key: 0,
          class: x([ie.$style.inner, f.value && ie.$style.animate]),
          style: Ke(s.width ? { width: s.width } : void 0)
        }, [
          e.scrollUp ? (v(), z(Fe, {
            key: 0,
            class: x([ie.$style.scrollIconTop, { [ie.$style.hidden]: T(g) }]),
            icon: "phosphor/caret-up",
            size: "16px"
          }, null, 8, ["class"])) : V("", !0),
          R("div", {
            class: x([ie.$style.content, e.paddingUpset && ie.$style.paddingUnset, e.morePadding && ie.$style.morePadding])
          }, [
            R("div", {
              ref_key: "topRef",
              ref: c
            }, null, 512),
            R("div", {
              class: x(ie.$style.items),
              style: Ke(s.gap ? { gap: `${s.gap}px` } : void 0)
            }, [
              ve(ie.$slots, "default", { popover: a.value })
            ], 6),
            R("div", {
              ref_key: "bottomRef",
              ref: u
            }, null, 512)
          ], 2),
          e.scrollDown ? (v(), z(Fe, {
            key: 1,
            class: x([ie.$style.scrollIconBottom, { [ie.$style.hidden]: T(p) }]),
            icon: "phosphor/caret-down",
            size: "16px"
          }, null, 8, ["class"])) : V("", !0)
        ], 6)) : V("", !0)
      ], 46, Pre)
    ], 2));
  }
}), Tre = "_dropdown_ck2ty_1", kre = "_trigger_ck2ty_8", Lre = "_popover_ck2ty_12", Bre = "_withTransition_ck2ty_33", Ore = "_positioning_ck2ty_37", Gre = "_inner_ck2ty_41", Hre = "_animate_ck2ty_45", Vre = "_lessBorder_ck2ty_56", _re = "_noBorder_ck2ty_60", Nre = "_noPadding_ck2ty_64", $re = "_shadowUpward_ck2ty_69", zre = "_scrollIconTop_ck2ty_73", Wre = "_scrollIconBottom_ck2ty_74", Ure = "_hidden_ck2ty_88", Kre = "_content_ck2ty_92", Zre = "_morePadding_ck2ty_97", qre = "_items_ck2ty_103", jre = "_paddingUnset_ck2ty_109", Yre = "_noMobileMargin_ck2ty_119", Qre = {
  dropdown: Tre,
  trigger: kre,
  popover: Lre,
  withTransition: Bre,
  positioning: Ore,
  inner: Gre,
  animate: Hre,
  lessBorder: Vre,
  noBorder: _re,
  noPadding: Nre,
  shadowUpward: $re,
  scrollIconTop: zre,
  scrollIconBottom: Wre,
  hidden: Ure,
  content: Kre,
  morePadding: Zre,
  items: qre,
  paddingUnset: jre,
  noMobileMargin: Yre
}, Jre = {
  $style: Qre
}, Yt = /* @__PURE__ */ we(Dre, [["__cssModules", Jre]]);
function hf(e) {
  const t = e.attribute ?? "data-drag-id";
  return {
    locateHover(n) {
      const o = n.target, s = o == null ? void 0 : o.closest(`[${t}]`);
      if (!(s instanceof HTMLElement)) return null;
      const i = s.getAttribute(t), r = i ? e.findItem(i) : null;
      return r ? { item: r, el: s } : null;
    },
    getElement(n) {
      const o = e.container();
      return o ? o.querySelector(`[${t}="${CSS.escape(e.getId(n))}"]`) : null;
    }
  };
}
function IS(e, t) {
  let n = e.position;
  for (const o of t.rules ?? []) {
    const s = o({ ...e, position: n }), i = typeof s == "boolean" ? { allowed: s } : s;
    if (!i.allowed) return { allowed: !1, reason: i.reason };
    i.position && (n = i.position);
  }
  return { allowed: !0, position: n };
}
function PS(e, t) {
  if (e.position === "none") return null;
  const n = IS(e, t);
  if (!n.allowed) return null;
  const o = n.position ?? e.position, { getId: s } = t, i = new Set(e.source.map(s)), r = e.level.filter((l) => !i.has(s(l)));
  let a;
  if (o === "inside" || !e.target)
    a = r.length;
  else {
    const l = r.findIndex((d) => s(d) === s(e.target));
    if (l === -1) return null;
    a = o === "below" ? l + 1 : l;
  }
  return {
    source: e.source,
    target: e.target,
    position: o,
    parent: o === "inside" ? e.target : null,
    index: a
  };
}
function nv(e, t, n) {
  const o = n.axis ?? "vertical", s = o === "horizontal" ? t.left : t.top, i = o === "horizontal" ? t.width : t.height, r = o === "horizontal" ? e.x : e.y;
  if (i <= 0) return "none";
  const a = r - s;
  if (!n.acceptsInside)
    return a < i * 0.5 ? "above" : "below";
  const d = (1 - (n.insideBand ?? 0.5)) / 2;
  return a < i * d ? "above" : a > i * (1 - d) ? "below" : "inside";
}
const Xre = "_line_j4xqg_1", eae = "_lineVertical_j4xqg_10", tae = "_dropInside_j4xqg_19", nae = "_lineEdgeStart_j4xqg_25", oae = "_lineEdgeEnd_j4xqg_29", sae = "_dropZoneOverlay_j4xqg_41", iae = "_indicatorAbove_j4xqg_51", rae = "_indicatorBelow_j4xqg_52", aae = "_indicatorEdge_j4xqg_78", lae = "_indicatorBefore_j4xqg_83", dae = "_indicatorAfter_j4xqg_84", cae = "_indicatorInsideSection_j4xqg_103", uae = "_indicatorInsideSectionLeft_j4xqg_107", hae = "_indicatorInsideSectionRight_j4xqg_112", vt = {
  line: Xre,
  lineVertical: eae,
  dropInside: tae,
  lineEdgeStart: nae,
  lineEdgeEnd: oae,
  dropZoneOverlay: sae,
  indicatorAbove: iae,
  indicatorBelow: rae,
  indicatorEdge: aae,
  indicatorBefore: lae,
  indicatorAfter: dae,
  indicatorInsideSection: cae,
  indicatorInsideSectionLeft: uae,
  indicatorInsideSectionRight: hae
}, ov = [
  vt.indicatorAbove,
  vt.indicatorBelow,
  vt.indicatorInsideSection,
  vt.indicatorInsideSectionLeft,
  vt.indicatorInsideSectionRight,
  vt.indicatorEdge
];
function PMe(e, t, n) {
  const o = e.length;
  for (let s = 0; s < o; s++) {
    const i = e[s];
    t === "above" ? (i.classList.add(vt.indicatorAbove), n === "start" && i.classList.add(vt.indicatorEdge)) : t === "below" ? (i.classList.add(vt.indicatorBelow), n === "end" && i.classList.add(vt.indicatorEdge)) : (i.classList.add(vt.indicatorInsideSection), s === 0 && i.classList.add(vt.indicatorInsideSectionLeft), s === o - 1 && i.classList.add(vt.indicatorInsideSectionRight));
  }
}
function DMe(e = document) {
  e.querySelectorAll(ov.map((t) => `.${t}`).join(",")).forEach((t) => {
    t.classList.remove(...ov);
  });
}
function TMe(e, t, n) {
  if (!e) return null;
  if (e.side === "below") {
    const o = (t == null ? void 0 : t(e.item)) ?? null;
    return o ? { item: o, side: "above" } : t ? { ...e, edge: "end" } : e;
  }
  return e.side === "above" && n && !n(e.item) ? { ...e, edge: "start" } : e;
}
const $a = vt;
function gf(e, t, n = "vertical") {
  if (!(!e || e.item !== t))
    return e.side === "inside" ? vt.dropInside : n === "horizontal" ? e.side === "below" ? vt.indicatorAfter : vt.indicatorBefore : e.side === "below" ? vt.indicatorBelow : vt.indicatorAbove;
}
const en = { allowed: !0 };
function Ds(e) {
  return { allowed: !1, reason: e };
}
function Vc(e) {
  return (t) => {
    const { source: n, target: o, position: s, level: i } = t, r = new Set(n.map(e));
    if (!r.size) return en;
    if (o && r.has(e(o))) return Ds();
    if (o && (s === "inside" || s === "none")) return en;
    const a = i.filter((h) => r.has(e(h)));
    if (a.length !== r.size) return en;
    const l = i.filter((h) => !r.has(e(h)));
    let d;
    if (!o)
      d = l.length;
    else {
      const h = l.findIndex((g) => e(g) === e(o));
      if (h === -1) return en;
      d = s === "below" ? h + 1 : h;
    }
    const c = [...l.slice(0, d), ...a, ...l.slice(d)];
    return c.length === i.length && c.every((h, g) => e(h) === e(i[g])) ? Ds() : en;
  };
}
function kMe(e) {
  return (t) => t.position !== "inside" || t.target && e(t.target) ? en : Ds();
}
function LMe(e, t, n) {
  return (o) => {
    const { source: s, target: i } = o;
    if (!i || !s.length) return en;
    const r = new Set(s.map(e));
    return r.has(e(i)) || t(i).some((a) => r.has(a)) ? Ds(n) : en;
  };
}
function BMe(e) {
  return (t) => t.position !== "above" && t.position !== "below" || !t.target || !e(t.target) ? en : t.source.length > 0 && t.source.every((o) => !e(o)) ? Ds() : en;
}
function OMe(e, t) {
  return (n) => n.position !== "below" || !n.target ? en : e(n.target) && t(n.target) ? Ds() : en;
}
function GMe(e) {
  return (t) => {
    if (t.position !== "below" || !t.target) return en;
    const n = t.level[t.level.length - 1];
    return n && e(n) === e(t.target) ? en : Ds();
  };
}
const gae = de({
  name: "SCADragGhost"
}), pae = /* @__PURE__ */ de({
  ...gae,
  props: {
    item: {},
    totalCount: {},
    stack: {}
  },
  setup(e) {
    const t = "phosphor/dots-six-vertical", o = e, s = D(() => {
      var a;
      return ((a = o.item) == null ? void 0 : a.icon) ?? t;
    }), i = D(() => {
      var a;
      return (a = o.stack) != null && a.length ? o.stack.slice(0, 5) : [];
    }), r = D(() => i.value.length ? o.stack.length - i.value.length : 0);
    return (a, l) => {
      var d;
      return v(), y("div", {
        class: x(a.$style.surface),
        "test-id": "drag-ghost"
      }, [
        i.value.length ? (v(), y("div", {
          key: 0,
          class: x(a.$style.stack)
        }, [
          (v(!0), y(Se, null, We(i.value, (c, u) => (v(), y("div", {
            key: u,
            class: x(a.$style.stackRow)
          }, [
            te(Fe, {
              icon: c.icon ?? t,
              color: c.iconColor,
              size: "16px"
            }, null, 8, ["icon", "color"]),
            R("span", {
              class: x(a.$style.label)
            }, se(c.label), 3)
          ], 2))), 128)),
          r.value > 0 ? (v(), y("div", {
            key: 0,
            class: x([a.$style.stackRow, a.$style.stackMore])
          }, se(T(Un)("common.label.moreDragged", { count: r.value })), 3)) : V("", !0)
        ], 2)) : (v(), y("div", {
          key: 1,
          class: x(a.$style.card)
        }, [
          s.value ? (v(), z(Fe, {
            key: 0,
            icon: s.value,
            color: (d = e.item) == null ? void 0 : d.iconColor,
            size: "16px"
          }, null, 8, ["icon", "color"])) : V("", !0),
          e.item ? (v(), y("span", {
            key: 1,
            class: x(a.$style.label)
          }, se(e.item.label), 3)) : V("", !0),
          e.totalCount > 1 ? (v(), y("span", {
            key: 2,
            class: x(a.$style.badge)
          }, se(e.totalCount), 3)) : V("", !0)
        ], 2))
      ], 2);
    };
  }
}), fae = "_surface_1mz29_1", mae = "_card_1mz29_6", vae = "_stack_1mz29_18", Cae = "_stackRow_1mz29_33", wae = "_stackMore_1mz29_45", yae = "_label_1mz29_57", bae = "_badge_1mz29_69", Sae = {
  surface: fae,
  card: mae,
  stack: vae,
  stackRow: Cae,
  stackMore: wae,
  label: yae,
  badge: bae
}, xae = {
  $style: Sae
}, Rae = /* @__PURE__ */ we(pae, [["__cssModules", xae]]), ig = 4, Eae = 120, sv = 180, Aae = "cubic-bezier(0.2, 0, 0, 1)", iv = "cubic-bezier(0.32, 0, 0.67, 0)", xn = { capture: !0, passive: !0 }, Fae = 5e3, Mae = 1e3, Ol = 64, zd = typeof document > "u" ? null : new Image();
zd && (zd.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBTAA7");
let It = null, za = null, fa = null, Fr = 0, Wa = 0, DS = 0, TS = 0, ma = null, _c = !1, Ei = !1, va = null, kS = !1, pf = 0, sd = null, ys = null;
function Iae(e) {
  !e.dataTransfer || !zd || e.dataTransfer.setDragImage(zd, 0, 0);
}
function LS(e) {
  var n;
  if (Lae(), Iae(e.event), _c = !1, Ei = !1, kS = ((n = window.matchMedia) == null ? void 0 : n.call(window, "(prefers-reduced-motion: reduce)").matches) ?? !1, Fr = e.event.clientX, Wa = e.event.clientY, It = document.createElement("div"), It.style.cssText = "position:fixed;top:0;left:0;right:auto;bottom:auto;margin:0;padding:0;border:none;background:transparent;overflow:visible;z-index:10000;pointer-events:none;will-change:transform;contain:layout style;transform-origin:0 0;", document.body.appendChild(It), typeof It.showPopover == "function") {
    It.setAttribute("popover", "manual");
    try {
      It.showPopover();
    } catch {
    }
  }
  const t = It.getBoundingClientRect();
  DS = t.left, TS = t.top, ff(), dr(vo(Rae, { item: e.item, totalCount: e.totalCount ?? 1, stack: e.stack }), It), za = It.firstElementChild, rg(za, { transform: ["scale(0.92)", "scale(1)"], opacity: [0, 1] }, Eae, Aae), document.addEventListener("dragover", VS, xn), document.addEventListener("drag", NS, xn), document.addEventListener("dragleave", $S, xn), document.addEventListener("dragend", Ai, xn), document.addEventListener("drop", WS, xn), document.addEventListener("keydown", zS, xn), ys = e.event.target, ys == null || ys.addEventListener("dragend", Ai, xn), pf = Date.now(), sd = setInterval(Tae, Mae);
}
function BS(e, t) {
  return `translate3d(${e - DS}px, ${t - TS}px, 0)`;
}
function ff() {
  ma = null, It && (It.style.transform = BS(Fr + ig, Wa + ig));
}
function Pae(e) {
  return e.clientX === 0 && e.clientY === 0 ? !1 : !(e.screenX === 0 && e.screenY === 0);
}
function OS(e) {
  return e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight;
}
function GS(e) {
  return pf = Date.now(), Pae(e) ? (Fr = e.clientX, Wa = e.clientY, ma ?? (ma = requestAnimationFrame(ff)), !0) : !1;
}
function Dae() {
  return Fr < Ol || Wa < Ol || Fr > window.innerWidth - Ol || Wa > window.innerHeight - Ol;
}
function HS() {
  va !== null && (clearTimeout(va), va = null);
}
function VS(e) {
  HS(), GS(e), !(!Ei || !It) && (Ei = !1, ff(), It.style.visibility = "");
}
function _S() {
  Ei || !It || (Ei = !0, It.style.visibility = "hidden");
}
function NS(e) {
  const t = e;
  GS(t) && OS(t) && _S();
}
function $S(e) {
  !OS(e) && !Dae() || (va ?? (va = setTimeout(() => {
    va = null, _S();
  }, 0)));
}
function Ai() {
  US(), kae();
}
function Tae() {
  Date.now() - pf < Fae || Ai();
}
function zS(e) {
  e.key === "Escape" && Ai();
}
function WS() {
  _c = !0;
  const e = It;
  setTimeout(() => {
    e && It === e && Ai();
  }, 0);
}
function US() {
  document.removeEventListener("dragover", VS, xn), document.removeEventListener("drag", NS, xn), document.removeEventListener("dragleave", $S, xn), HS(), document.removeEventListener("dragend", Ai, xn), document.removeEventListener("drop", WS, xn), document.removeEventListener("keydown", zS, xn), ys == null || ys.removeEventListener("dragend", Ai, xn), ys = null, ma !== null && (cancelAnimationFrame(ma), ma = null), sd !== null && (clearInterval(sd), sd = null);
}
function kae() {
  const e = It, t = za;
  if (!e) return;
  if (It = null, za = null, kS || Ei) {
    Ca(e);
    return;
  }
  const n = e.style.transform, o = _c ? `${n} scale(0.4)` : `${BS(Fr + ig, window.innerHeight)} scale(0.4)`, s = rg(e, { transform: [n, o] }, sv, iv);
  if (rg(t, { opacity: [1, 0] }, sv, iv), !s) {
    Ca(e);
    return;
  }
  fa = e;
  const i = () => {
    fa === e && (fa = null), Ca(e);
  };
  s.onfinish = i, s.oncancel = i;
}
function rg(e, t, n, o) {
  return !e || typeof e.animate != "function" ? null : e.animate(t, { duration: n, easing: o, fill: "forwards" });
}
function Ca(e) {
  var t;
  try {
    (t = e.hidePopover) == null || t.call(e);
  } catch {
  }
  dr(null, e), e.remove();
}
function Lae() {
  US();
  const e = It, t = fa;
  It = null, za = null, fa = null, _c = !1, Ei = !1, e && Ca(e), t && Ca(t);
}
const ag = "application/x-scayla-drag-item/", KS = (e) => `application/x-scayla-drag-group/${e}`.toLowerCase();
function ZS(e) {
  return Wd(e)[0] ?? null;
}
function Wd(e) {
  var t;
  return (((t = e.dataTransfer) == null ? void 0 : t.types) ?? []).filter((n) => n.startsWith(ag)).map((n) => n.slice(ag.length));
}
function Ua(e, t) {
  var n;
  return !!((n = e.dataTransfer) != null && n.types.includes(KS(t)));
}
function Nc(e) {
  const t = W([]);
  function n() {
    t.value = [];
  }
  $n() && (Et(() => document.addEventListener("dragend", n, { passive: !0 })), ks(() => document.removeEventListener("dragend", n)));
  function o(s) {
    return {
      draggable: !xe(e.disabled),
      onDragstart: (i) => {
        var d, c;
        if (xe(e.disabled) || !i.dataTransfer) return;
        const r = ((d = e.resolveItems) == null ? void 0 : d.call(e, s)) ?? [s], a = ((c = e.normalize) == null ? void 0 : c.call(e, r)) ?? r;
        if (!a.length) {
          i.preventDefault();
          return;
        }
        i.dataTransfer.effectAllowed = "move";
        for (const u of a)
          i.dataTransfer.setData(`${ag}${e.getId(u)}`, "");
        i.dataTransfer.setData(KS(e.dragGroup), ""), t.value = a;
        const l = (u) => {
          var h, g;
          return {
            label: e.ghostLabel(u),
            icon: (h = e.ghostIcon) == null ? void 0 : h.call(e, u),
            iconColor: (g = e.ghostIconColor) == null ? void 0 : g.call(e, u)
          };
        };
        LS({
          event: i,
          item: l(s),
          totalCount: a.length > 1 ? a.length : void 0,
          stack: e.ghostStack ? a.map(l) : void 0
        });
      },
      onDragend: n
    };
  }
  return {
    isDragging: D(() => t.value.length > 0),
    draggedItems: t,
    dragHandlers: o
  };
}
function $c(e) {
  const t = /* @__PURE__ */ new Map(), n = W(null), o = W("vertical"), s = W(null), i = D(() => {
    const _ = o.value === "horizontal" ? vt.lineVertical : vt.line;
    return s.value === "start" ? `${_} ${vt.lineEdgeStart}` : s.value === "end" ? `${_} ${vt.lineEdgeEnd}` : _;
  }), r = W(null), a = W(null), l = W(!0), d = W(!1), c = e.indicator === "rowClass";
  let u = null;
  function h(_) {
    const ne = e.getId(_);
    return (ce) => {
      ce instanceof HTMLElement ? t.set(ne, ce) : t.delete(ne);
    };
  }
  function g(_) {
    return e.rowLocator ? e.rowLocator.getElement(_) ?? void 0 : t.get(e.getId(_));
  }
  function p(_) {
    return typeof e.axis == "function" ? e.axis(_) : e.axis ?? "vertical";
  }
  function f(_, ne) {
    let ce = ne.get(_);
    return ce || (ce = _.getBoundingClientRect(), ne.set(_, ce)), ce;
  }
  function m(_, ne, ce) {
    return ne === "horizontal" ? { start: _.left, end: _.right, pointer: ce.x } : { start: _.top, end: _.bottom, pointer: ce.y };
  }
  function C(_) {
    u = _, r.value = _ ? e.getId(_) : null;
  }
  function w() {
    n.value = null, a.value = null, C(null), l.value = !0, d.value = !1;
  }
  function b(_, ne, ce) {
    var G;
    const me = _.map((le) => ({ item: le, el: t.get(e.getId(le)) })).filter((le) => le.el);
    if (!me.length) return null;
    for (let le = 0; le < me.length; le++) {
      const { item: be, el: Me } = me[le], Be = p(be), qe = f(Me, ce), { start: he, end: Pe, pointer: J } = m(qe, Be, ne);
      if (J >= he && J <= Pe) {
        const q = ((G = e.acceptsInside) == null ? void 0 : G.call(e, be)) ?? !1;
        return { item: be, position: nv(ne, qe, { acceptsInside: q, axis: Be }) };
      }
      const Y = me[le + 1];
      if (Y) {
        const q = m(f(Y.el, ce), Be, ne).start;
        if (J > Pe && J < q) return { item: be, position: "below" };
      }
    }
    const Ie = p(me[0].item), L = m(f(me[0].el, ce), Ie, ne), oe = p(me[me.length - 1].item), K = m(f(me[me.length - 1].el, ce), oe, ne);
    return L.pointer < L.start ? { item: me[0].item, position: "above" } : K.pointer > K.end ? { item: me[me.length - 1].item, position: "below" } : null;
  }
  function A(_, ne, ce) {
    var Ie;
    const me = { x: ne.clientX, y: ne.clientY };
    if (e.rowLocator) {
      const L = e.rowLocator.locateHover(ne);
      if (!L) return null;
      const oe = ((Ie = e.acceptsInside) == null ? void 0 : Ie.call(e, L.item)) ?? !1, K = p(L.item), G = f(L.el, ce);
      return { item: L.item, position: nv(me, G, { acceptsInside: oe, axis: K }) };
    }
    return b(_, me, ce);
  }
  function S(_, ne) {
    if (!Ua(_, e.dragGroup)) return null;
    const ce = new Set(Wd(_));
    if (!ce.size) return null;
    const me = ne.filter((Ie) => ce.has(e.getId(Ie).toLowerCase()));
    return me.length ? me : null;
  }
  function F(_) {
    if (xe(e.disabled)) return null;
    const ne = xe(e.items), ce = (e.resolveSource ?? S)(_, ne);
    return ce != null && ce.length ? { pool: ne, source: ce } : null;
  }
  function E(_, ne, ce) {
    var Ie;
    const me = ((Ie = e.getLevel) == null ? void 0 : Ie.call(e, ce.item, ce.position)) ?? _;
    return { source: ne, target: ce.item, position: ce.position, level: me };
  }
  function M(_) {
    const ne = F(_);
    if (!ne) return null;
    const ce = A(ne.pool, _, /* @__PURE__ */ new Map());
    return ce ? E(ne.pool, ne.source, ce) : null;
  }
  function I(_) {
    var ne;
    return e.foreignDrag ? e.foreignDrag.test ? e.foreignDrag.test(_) : !!((ne = _.dataTransfer) != null && ne.types.includes("Files")) : !1;
  }
  function P(_) {
    return PS(_, { getId: e.getId, rules: e.rules });
  }
  function k(_, ne, ce, me, Ie) {
    const L = new Set(ne.map(e.getId)), oe = _.filter((he) => !L.has(e.getId(he))), K = ce > 0 ? g(oe[ce - 1]) : void 0, G = ce < oe.length ? g(oe[ce]) : void 0, le = K ?? G;
    if (!le) return { style: null, edge: null };
    const be = K && f(K, Ie), Me = G && f(G, Ie), Be = be && Me ? (be.bottom + Me.top) / 2 : be ? be.bottom : Me.top, qe = f(le, Ie);
    return {
      style: {
        top: `${Be - me.top}px`,
        left: `${qe.left - me.left}px`,
        width: `${qe.width}px`
      },
      // No `beforeRect` means this is the very top of the level (insert-before-first); no
      // `afterRect` means the very bottom (insert-after-last) — both genuine list boundaries, vs.
      // the ordinary case where both neighbours exist and the line has room on either side.
      edge: be ? Me ? null : "end" : "start"
    };
  }
  function B(_, ne) {
    const ce = g(_.item);
    if (!ce) return { style: null, edge: null };
    const me = ce.getBoundingClientRect(), Ie = _.position === "above" ? me.left : me.right, L = Math.max(ne.left, Math.min(Ie, ne.right)) - ne.left, oe = _.position === "above" && Math.abs(me.left - ne.left) < 1 ? "start" : _.position === "below" && Math.abs(me.right - ne.right) < 1 ? "end" : null;
    return {
      style: {
        top: `${me.top - ne.top}px`,
        left: `${L}px`,
        height: `${me.height}px`
      },
      edge: oe
    };
  }
  function j(_) {
    if (I(_)) {
      _.preventDefault();
      return;
    }
    F(_) && (_.preventDefault(), _.dataTransfer && (_.dataTransfer.dropEffect = "move"));
  }
  function N(_) {
    var le, be;
    if (I(_)) {
      w(), _.preventDefault(), (be = (le = e.foreignDrag).onDragover) == null || be.call(le, _);
      return;
    }
    const ne = F(_);
    if (!ne) {
      w();
      return;
    }
    _.preventDefault();
    const ce = /* @__PURE__ */ new Map(), me = A(ne.pool, _, ce);
    if (!me) {
      _.dataTransfer && (_.dataTransfer.dropEffect = "none"), w();
      return;
    }
    const Ie = E(ne.pool, ne.source, me), L = P(Ie);
    if (_.dataTransfer && (_.dataTransfer.dropEffect = L ? "move" : "none"), l.value = L !== null, d.value = !0, me.position === "inside") {
      C(L ? me.item : null), n.value = null, a.value = c && L ? { item: me.item, side: "inside" } : null;
      return;
    }
    if (C(null), !L) {
      n.value = null, a.value = null;
      return;
    }
    if (c) {
      n.value = null, a.value = { item: me.item, side: me.position === "below" ? "below" : "above" };
      return;
    }
    const oe = _.currentTarget.getBoundingClientRect(), K = p(me.item);
    o.value = K;
    const G = K === "horizontal" ? B(me, oe) : k(Ie.level, Ie.source, L.index, oe, ce);
    n.value = G.style, s.value = G.edge;
  }
  function re(_) {
    const ne = _.currentTarget, ce = _.relatedTarget;
    ce && ne.contains(ce) || w();
  }
  function H(_) {
    var Ie;
    if (_.preventDefault(), I(_)) {
      w(), e.foreignDrag.onDrop(_);
      return;
    }
    const ne = M(_);
    if (w(), !ne) return;
    const ce = IS(ne, { getId: e.getId, rules: e.rules });
    if (!ce.allowed) {
      ce.reason && ((Ie = e.onRejected) == null || Ie.call(e, ce, _));
      return;
    }
    const me = P(ne);
    me && e.onDrop(me, _);
  }
  if (e.autoExpand) {
    const _ = e.autoExpand;
    let ne = null;
    Re(
      r,
      (ce) => {
        if (ne && (clearTimeout(ne), ne = null), !ce || !u || _.isExpanded(u)) return;
        const me = u;
        ne = setTimeout(() => {
          _.expand(me), ne = null;
        }, _.delayMs ?? 500);
      },
      { flush: "sync" }
    );
  }
  return {
    containerHandlers: { onDragenter: j, onDragover: N, onDragleave: re, onDrop: H },
    registerRow: h,
    lineStyle: n,
    lineClass: i,
    insideTargetId: r,
    rowIndicator: a,
    indicatorClass: (_) => e.getId(_) === r.value ? vt.dropInside : void 0,
    insideClass: vt.dropInside,
    isActiveInvalid: D(() => d.value && !l.value)
  };
}
function HMe(e) {
  const t = W(!1);
  function n(r) {
    t.value = !e.rowLocator.locateHover(r);
  }
  function o(r) {
    const a = r.currentTarget, l = r.relatedTarget;
    l && a.contains(l) || (t.value = !1);
  }
  function s() {
    t.value = !1;
  }
  function i() {
    t.value = !0;
  }
  return { isOver: t, overlayClass: vt.dropZoneOverlay, onDragover: n, onDragleave: o, reset: s, show: i };
}
const Gn = { capture: !0, passive: !0 }, Bae = 5e3, Oae = 1e3;
function Gae(e) {
  let t = Date.now(), n = null, o = !1;
  function s(h) {
    o || (u(), e(h));
  }
  function i() {
    t = Date.now();
  }
  function r() {
    s("dragend");
  }
  function a() {
    n ?? (n = setTimeout(() => s("drop"), 0));
  }
  function l(h) {
    h.key === "Escape" && s("escape");
  }
  function d() {
    s("pointerdown");
  }
  const c = setInterval(() => {
    Date.now() - t >= Bae && s("stale");
  }, Oae);
  function u() {
    o = !0, document.removeEventListener("dragover", i, Gn), document.removeEventListener("drag", i, Gn), document.removeEventListener("dragend", r, Gn), document.removeEventListener("drop", a, Gn), document.removeEventListener("keydown", l, Gn), document.removeEventListener("pointerdown", d, Gn), clearInterval(c), n !== null && clearTimeout(n);
  }
  return document.addEventListener("dragover", i, Gn), document.addEventListener("drag", i, Gn), document.addEventListener("dragend", r, Gn), document.addEventListener("drop", a, Gn), document.addEventListener("keydown", l, Gn), document.addEventListener("pointerdown", d, Gn), u;
}
const Hae = "button, input, textarea, select, a[href]", Vae = "a[href], img";
function VMe(e) {
  const t = W([]), n = W(!1);
  let o = null;
  const s = [Hae, e.ignoredInteractiveSelector].filter(Boolean).join(", ");
  function i(p) {
    var f;
    return !!p.closest(s) || !!((f = e.isIgnoredTarget) != null && f.call(e, p));
  }
  function r(p) {
    return e.rowOf ? e.rowOf(p) : p.closest(e.rowSelector);
  }
  function a(p) {
    var w;
    if (xe(e.disabled)) return;
    const f = p.target, m = r(f);
    if (!m || (w = e.isExcluded) != null && w.call(e, m)) return;
    m.getAttribute("draggable") !== "true" && m.setAttribute("draggable", "true");
    const C = f.closest(Vae);
    C && m.contains(C) && C.setAttribute("draggable", "false");
  }
  function l(p) {
    if (xe(e.disabled)) return;
    const f = p.target;
    i(f) || r(f) && p.stopPropagation();
  }
  function d(p) {
    var C;
    if (n.value) {
      p.stopPropagation(), p.preventDefault();
      return;
    }
    if (xe(e.disabled)) return;
    const f = p.target;
    if (i(f) || p instanceof MouseEvent && (p.metaKey || p.ctrlKey)) return;
    const m = r(f);
    m && ((C = e.onRowMouseup) == null || C.call(e, p, m));
  }
  function c(p) {
    n.value && (p.stopPropagation(), p.preventDefault());
  }
  function u(p) {
    var A, S, F, E, M;
    if (xe(e.disabled)) {
      p.preventDefault();
      return;
    }
    const f = p.target, m = r(f);
    if (m && ((A = e.isExcluded) != null && A.call(e, m))) {
      p.preventDefault();
      return;
    }
    if (!m || !p.dataTransfer) return;
    const C = e.resolveItem(m);
    if (!C) return;
    const w = ((S = e.resolveItems) == null ? void 0 : S.call(e, C)) ?? [C], b = ((F = e.normalize) == null ? void 0 : F.call(e, w)) ?? w;
    if (!b.length) {
      p.preventDefault();
      return;
    }
    if (e.isValidDrag && !e.isValidDrag(b)) {
      (E = e.onInvalidDrag) == null || E.call(e, b), p.preventDefault(), p.stopPropagation();
      return;
    }
    n.value = !0, t.value = b, (M = e.onDraggingChange) == null || M.call(e, !0), e.write(p, b), LS({ event: p, item: e.ghostItem(C), totalCount: b.length > 1 ? b.length : void 0 }), o == null || o(), o = Gae(h);
  }
  function h(p) {
    var f;
    if (o == null || o(), o = null, t.value = [], p === "pointerdown") {
      n.value = !1, (f = e.onDraggingChange) == null || f.call(e, !1);
      return;
    }
    setTimeout(() => {
      var m;
      n.value = !1, (m = e.onDraggingChange) == null || m.call(e, !1);
    }, 100);
  }
  function g(p) {
    const f = p.target, m = r(f);
    m == null || m.removeAttribute("draggable"), h("dragend");
  }
  return Yd() && ro(() => o == null ? void 0 : o()), {
    containerHandlers: {
      onMouseoverCapture: a,
      onMousedownCapture: l,
      onPointerdownCapture: l,
      onMouseupCapture: d,
      onPointerupCapture: d,
      onClickCapture: c,
      onDragstartCapture: u,
      onDragendCapture: g
    },
    isDragging: D(() => t.value.length > 0)
  };
}
const _ae = /* @__PURE__ */ de({
  __name: "SCAAvatar",
  props: {
    initials: { default: void 0 },
    size: { default: "medium" },
    shape: { default: "rounded" },
    appearance: { default: "blue" },
    emphasis: { default: "high" },
    bordered: { type: Boolean, default: !1 },
    colorIdx: { default: void 0 },
    hovered: { type: Boolean, default: !1 },
    useHoverColors: { type: Boolean, default: !1 },
    borderColor: { default: void 0 },
    borderWidth: { default: void 0 }
  },
  setup(e) {
    const t = e, n = D(() => t.colorIdx !== void 0 ? r8[t.colorIdx] : void 0), o = D(() => t.initials ? t.size === "x3small" ? t.initials.charAt(0) : t.initials : "");
    return (s, i) => {
      var r, a, l, d;
      return v(), y("div", {
        class: x([
          s.$style.avatar,
          s.$style[`size_${e.size}`],
          {
            [s.$style[`appearance_${e.appearance}_${e.emphasis}`]]: n.value === void 0,
            [s.$style.square]: e.shape === "square",
            [s.$style.hovered]: e.hovered
          },
          { [s.$style.bordered]: e.bordered }
        ]),
        style: Ke({
          ...n.value ? {
            "--color": e.useHoverColors ? (r = n.value) == null ? void 0 : r.hoverBgColor : (a = n.value) == null ? void 0 : a.bgColor,
            "--text-color": e.useHoverColors ? (l = n.value) == null ? void 0 : l.hoverTextColor : (d = n.value) == null ? void 0 : d.textColor
          } : {},
          ...e.borderColor ? { "--border-color-override": e.borderColor } : {},
          ...e.borderWidth ? { "--border-width-override": e.borderWidth } : {}
        })
      }, [
        ve(s.$slots, "default", {}, () => [
          Oe(se(o.value), 1)
        ])
      ], 6);
    };
  }
}), Nae = "_avatar_dtgga_747", $ae = "_bordered_dtgga_769", zae = "_size_xlarge_dtgga_775", Wae = "_size_large_dtgga_787", Uae = "_size_medium_dtgga_797", Kae = "_size_small_dtgga_806", Zae = "_size_xsmall_dtgga_818", qae = "_size_x2small_dtgga_828", jae = "_size_x3small_dtgga_838", Yae = "_size_80_dtgga_848", Qae = "_hovered_dtgga_858", Jae = "_square_dtgga_861", Xae = "_appearance_blue_high_dtgga_870", ele = "_appearance_blue_medium_dtgga_874", tle = "_appearance_blue_low_dtgga_878", nle = "_appearance_green_high_dtgga_882", ole = "_appearance_green_medium_dtgga_886", sle = "_appearance_green_low_dtgga_890", ile = "_appearance_grey_high_dtgga_894", rle = "_appearance_grey_medium_dtgga_898", ale = "_appearance_grey_low_dtgga_902", lle = "_appearance_red_high_dtgga_906", dle = "_appearance_red_medium_dtgga_910", cle = "_appearance_red_low_dtgga_914", ule = "_appearance_orange_high_dtgga_918", hle = "_appearance_orange_medium_dtgga_922", gle = "_appearance_orange_low_dtgga_926", ple = "_appearance_raspberry_high_dtgga_930", fle = "_appearance_raspberry_medium_dtgga_934", mle = "_appearance_raspberry_low_dtgga_938", vle = "_appearance_magenta_high_dtgga_942", Cle = "_appearance_magenta_medium_dtgga_946", wle = "_appearance_magenta_low_dtgga_950", yle = "_appearance_purple_high_dtgga_954", ble = "_appearance_purple_medium_dtgga_958", Sle = "_appearance_purple_low_dtgga_962", xle = "_appearance_grape_high_dtgga_966", Rle = "_appearance_grape_medium_dtgga_970", Ele = "_appearance_grape_low_dtgga_974", Ale = "_appearance_violet_high_dtgga_978", Fle = "_appearance_violet_medium_dtgga_982", Mle = "_appearance_violet_low_dtgga_986", Ile = "_appearance_cyan_high_dtgga_990", Ple = "_appearance_cyan_medium_dtgga_994", Dle = "_appearance_cyan_low_dtgga_998", Tle = "_appearance_teal_high_dtgga_1002", kle = "_appearance_teal_medium_dtgga_1006", Lle = "_appearance_teal_low_dtgga_1010", Ble = "_appearance_aquamarine_high_dtgga_1014", Ole = "_appearance_aquamarine_medium_dtgga_1018", Gle = "_appearance_aquamarine_low_dtgga_1022", Hle = "_appearance_emerald_high_dtgga_1026", Vle = "_appearance_emerald_medium_dtgga_1030", _le = "_appearance_emerald_low_dtgga_1034", Nle = "_appearance_white_high_dtgga_1038", $le = "_appearance_white_medium_dtgga_1042", zle = "_appearance_white_low_dtgga_1046", Wle = {
  avatar: Nae,
  bordered: $ae,
  size_xlarge: zae,
  size_large: Wae,
  size_medium: Uae,
  size_small: Kae,
  size_xsmall: Zae,
  size_x2small: qae,
  size_x3small: jae,
  size_80: Yae,
  hovered: Qae,
  square: Jae,
  appearance_blue_high: Xae,
  appearance_blue_medium: ele,
  appearance_blue_low: tle,
  appearance_green_high: nle,
  appearance_green_medium: ole,
  appearance_green_low: sle,
  appearance_grey_high: ile,
  appearance_grey_medium: rle,
  appearance_grey_low: ale,
  appearance_red_high: lle,
  appearance_red_medium: dle,
  appearance_red_low: cle,
  appearance_orange_high: ule,
  appearance_orange_medium: hle,
  appearance_orange_low: gle,
  appearance_raspberry_high: ple,
  appearance_raspberry_medium: fle,
  appearance_raspberry_low: mle,
  appearance_magenta_high: vle,
  appearance_magenta_medium: Cle,
  appearance_magenta_low: wle,
  appearance_purple_high: yle,
  appearance_purple_medium: ble,
  appearance_purple_low: Sle,
  appearance_grape_high: xle,
  appearance_grape_medium: Rle,
  appearance_grape_low: Ele,
  appearance_violet_high: Ale,
  appearance_violet_medium: Fle,
  appearance_violet_low: Mle,
  appearance_cyan_high: Ile,
  appearance_cyan_medium: Ple,
  appearance_cyan_low: Dle,
  appearance_teal_high: Tle,
  appearance_teal_medium: kle,
  appearance_teal_low: Lle,
  appearance_aquamarine_high: Ble,
  appearance_aquamarine_medium: Ole,
  appearance_aquamarine_low: Gle,
  appearance_emerald_high: Hle,
  appearance_emerald_medium: Vle,
  appearance_emerald_low: _le,
  appearance_white_high: Nle,
  appearance_white_medium: $le,
  appearance_white_low: zle
}, Ule = {
  $style: Wle
}, Li = /* @__PURE__ */ we(_ae, [["__cssModules", Ule]]), Kle = ["src"], Zle = /* @__PURE__ */ de({
  __name: "SCATag",
  props: {
    disabled: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    removable: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    icon: { default: void 0 },
    iconSize: { default: "12px" },
    iconColor: { default: void 0 },
    variant: { default: "default" },
    overflow: { default: "hidden" },
    truncateTooltip: { type: Boolean, default: !1 },
    unavailable: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    as: { default: "div" }
  },
  emits: ["remove", "update:selected"],
  setup(e, { emit: t }) {
    Ls((h) => ({
      v75fa032b: o.value
    }));
    const n = e, o = D(() => n.overflow), s = t, i = rn(), r = W(null), a = W(!1), l = W(""), d = (h) => h.scrollWidth > h.clientWidth;
    Hc(r, () => {
      var g;
      if (!n.truncateTooltip) return;
      const h = r.value;
      h && (a.value = d(h) || Array.from(h.querySelectorAll("*")).some(d), l.value = ((g = h.textContent) == null ? void 0 : g.trim()) ?? "");
    });
    const u = () => {
      n.disabled || s("update:selected", !n.selected);
    };
    return (h, g) => (v(), z(Ot(e.as), {
      tabindex: "0",
      class: x([
        h.$style.tag,
        {
          [h.$style.disabled]: e.disabled,
          [h.$style.selected]: e.selected,
          [h.$style.error]: e.error,
          [h.$style.unavailable]: e.unavailable,
          [h.$style.avatar]: e.avatar,
          [h.$style.iconLeft]: T(i).iconLeft,
          [h.$style.iconRight]: e.removable || T(i).iconRight,
          [h.$style.variantUnderline]: e.variant === "underline",
          [h.$style.variantBreadcrumb]: e.variant === "breadcrumb",
          [h.$style.variantGhost]: e.variant === "ghost"
        }
      ]),
      onClick: u
    }, {
      default: Q(() => {
        var p, f, m, C, w, b;
        return [
          e.avatar ? (v(), z(Li, {
            key: 0,
            size: "x3small",
            initials: (p = e.avatar) == null ? void 0 : p.initials,
            shape: (f = e.avatar) == null ? void 0 : f.shape,
            appearance: (m = e.avatar) == null ? void 0 : m.appearance,
            emphasis: (C = e.avatar) == null ? void 0 : C.emphasis,
            bordered: !!((w = e.avatar) != null && w.image),
            "color-idx": (b = e.avatar) == null ? void 0 : b.colorIdx,
            "use-hover-colors": !0
          }, {
            default: Q(() => {
              var A, S;
              return [
                (A = e.avatar) != null && A.image ? (v(), y("img", {
                  key: 0,
                  src: (S = e.avatar) == null ? void 0 : S.image,
                  loading: "lazy",
                  alt: "avatar"
                }, null, 8, Kle)) : V("", !0)
              ];
            }),
            _: 1
          }, 8, ["initials", "shape", "appearance", "emphasis", "bordered", "color-idx"])) : V("", !0),
          e.icon ? (v(), z(Fe, {
            key: 1,
            class: x(h.$style.leadingIcon),
            icon: e.icon,
            size: e.iconSize,
            color: e.iconColor
          }, null, 8, ["class", "icon", "size", "color"])) : V("", !0),
          T(i).iconLeft ? (v(), y("div", {
            key: 2,
            class: x(h.$style.iconContainer)
          }, [
            ve(h.$slots, "iconLeft")
          ], 2)) : V("", !0),
          e.variant === "breadcrumb" ? (v(), z(Fe, {
            key: 3,
            size: "12px",
            class: x(h.$style.breadcrumbIcon),
            icon: "phosphor/caret-right"
          }, null, 8, ["class"])) : V("", !0),
          R("div", {
            ref_key: "contentRef",
            ref: r,
            class: x(h.$style.content)
          }, [
            ve(h.$slots, "default")
          ], 2),
          T(i).iconRight ? (v(), y("div", {
            key: 4,
            class: x(h.$style.iconContainer)
          }, [
            ve(h.$slots, "iconRight")
          ], 2)) : V("", !0),
          e.removable ? (v(), z(Fe, {
            key: 5,
            class: x(h.$style.button),
            size: "12px",
            icon: "phosphor/x",
            onClick: g[0] || (g[0] = Ge((A) => s("remove"), ["stop"]))
          }, null, 8, ["class"])) : V("", !0),
          e.tooltip || e.truncateTooltip && a.value ? (v(), z(zt, {
            key: 6,
            target: r.value,
            text: e.tooltip ?? l.value
          }, null, 8, ["target", "text"])) : V("", !0)
        ];
      }),
      _: 3
    }, 8, ["class"]));
  }
}), qle = "_tag_1d96m_747", jle = "_disabled_1d96m_768", Yle = "_button_1d96m_773", Qle = "_unavailable_1d96m_782", Jle = "_leadingIcon_1d96m_782", Xle = "_error_1d96m_789", ede = "_variantUnderline_1d96m_801", tde = "_selected_1d96m_812", nde = "_content_1d96m_816", ode = "_variantBreadcrumb_1d96m_826", sde = "_breadcrumbIcon_1d96m_841", ide = "_variantGhost_1d96m_857", rde = "_avatar_1d96m_862", ade = "_iconLeft_1d96m_865", lde = "_iconRight_1d96m_868", dde = "_iconContainer_1d96m_881", cde = {
  tag: qle,
  disabled: jle,
  button: Yle,
  unavailable: Qle,
  leadingIcon: Jle,
  error: Xle,
  variantUnderline: ede,
  selected: tde,
  content: nde,
  variantBreadcrumb: ode,
  breadcrumbIcon: sde,
  variantGhost: ide,
  avatar: rde,
  iconLeft: ade,
  iconRight: lde,
  iconContainer: dde
}, ude = {
  $style: cde
}, no = /* @__PURE__ */ we(Zle, [["__cssModules", ude]]), hde = ["data-drag-id"], gde = /* @__PURE__ */ de({
  __name: "AgGridRowGroupChipList",
  props: {
    chips: {},
    dragGroup: {}
  },
  emits: ["ungroup", "move"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = (c) => c.colId, i = tn("list"), r = Nc({
      getId: s,
      ghostLabel: (c) => c.label,
      dragGroup: n.dragGroup
    }), a = $c({
      items: () => n.chips,
      getId: s,
      dragGroup: n.dragGroup,
      rowLocator: hf({
        container: () => i.value,
        getId: s,
        findItem: (c) => n.chips.find((u) => u.colId === c)
      }),
      indicator: "rowClass",
      rules: [Vc(s)],
      onDrop: (c) => {
        const u = c.source[0];
        u && o("move", u.colId, c.index);
      }
    }), l = (c) => r.draggedItems.value.includes(c);
    function d(c) {
      const u = r.isDragging.value ? a.rowIndicator.value : null;
      if ((u == null ? void 0 : u.item.colId) === c.colId)
        return gf(u, u.item);
    }
    return (c, u) => (v(), y("div", at({
      ref_key: "list",
      ref: i,
      class: c.$style.chips
    }, T(a).containerHandlers), [
      (v(!0), y(Se, null, We(e.chips, (h) => (v(), y("div", at({
        key: h.colId,
        "data-drag-id": h.colId,
        class: [c.$style.chip, l(h) && c.$style.dragging, d(h)]
      }, { ref_for: !0 }, T(r).dragHandlers(h)), [
        te(no, {
          icon: "phosphor/dots-six",
          "icon-size": "16px",
          removable: "",
          "test-id": "row-groups-overflow-chip",
          onRemove: (g) => o("ungroup", h.colId)
        }, {
          default: Q(() => [
            Oe(se(h.label), 1)
          ]),
          _: 2
        }, 1032, ["onRemove"])
      ], 16, hde))), 128))
    ], 16));
  }
}), pde = "_chips_b8oe2_1", fde = "_chip_b8oe2_1", mde = "_dragging_b8oe2_14", vde = {
  chips: pde,
  chip: fde,
  dragging: mde
}, Cde = {
  $style: vde
}, qS = /* @__PURE__ */ we(gde, [["__cssModules", Cde]]), wde = /* @__PURE__ */ de({
  __name: "SCADropdownDivider",
  props: {
    fullWidth: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x([t.$style.root, { [t.$style.fullWidth]: e.fullWidth, [t.$style.compact]: e.compact }])
    }, [
      R("div", {
        class: x(t.$style.itemDiv)
      }, null, 2)
    ], 2));
  }
}), yde = "_root_1c9vu_747", bde = "_compact_1c9vu_755", Sde = "_fullWidth_1c9vu_759", xde = "_itemDiv_1c9vu_763", Rde = {
  root: yde,
  compact: bde,
  fullWidth: Sde,
  itemDiv: xde
}, Ede = {
  $style: Rde
}, Ade = /* @__PURE__ */ we(wde, [["__cssModules", Ede]]), Fde = {
  ArrowDown: 1,
  ArrowRight: 1,
  ArrowUp: -1,
  ArrowLeft: -1
};
function jS(e, t) {
  const n = e.target;
  return !(n instanceof HTMLInputElement) || n.type !== t || n.disabled || n.tabIndex < 0 ? null : n;
}
function YS(e, t) {
  e.preventDefault(), t.click();
}
function Mde(e) {
  if (!e.name) return [];
  const t = e.form ?? e.getRootNode();
  return Array.from(
    t.querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]:not([disabled])`)
  );
}
function rv(e, t) {
  const n = Mde(e), o = n.indexOf(e);
  if (o < 0) return !1;
  for (let s = o + t; s >= 0 && s < n.length; s += t)
    if (n[s].focus(), document.activeElement === n[s]) return !0;
  return !1;
}
function av(e) {
  if (e.key !== "Enter") return;
  const t = jS(e, "checkbox");
  t && YS(e, t);
}
function lv(e) {
  const t = jS(e, "radio");
  if (!t) return;
  if (e.key === "Enter") {
    YS(e, t);
    return;
  }
  const n = Fde[e.key];
  if (n) {
    e.preventDefault(), rv(t, n);
    return;
  }
  e.key === "Tab" && rv(t, e.shiftKey ? -1 : 1) && e.preventDefault();
}
const Ide = /* @__PURE__ */ de({
  __name: "SCACheckboxBase",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    deselect: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x([
        t.$style.root,
        {
          [t.$style.disabled]: e.disabled,
          [t.$style.alert]: e.alert,
          [t.$style.deselect]: e.deselect
        }
      ]),
      onKeydown: n[0] || (n[0] = //@ts-ignore
      (...o) => T(av) && T(av)(...o))
    }, [
      ve(t.$slots, "default", { checked: e.checked })
    ], 34));
  }
}), Pde = "_root_1yc0t_1", Dde = "_deselect_1yc0t_21", Tde = "_disabled_1yc0t_41", kde = "_alert_1yc0t_58", Lde = {
  root: Pde,
  deselect: Dde,
  disabled: Tde,
  alert: kde
}, Bde = {
  $style: Lde
}, Ts = /* @__PURE__ */ we(Ide, [["__cssModules", Bde]]), Ode = /* @__PURE__ */ de({
  __name: "SCARadioButtonBase",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x([
        t.$style.root,
        {
          [t.$style.disabled]: e.disabled,
          [t.$style.alert]: e.alert
        }
      ]),
      onKeydown: n[0] || (n[0] = //@ts-ignore
      (...o) => T(lv) && T(lv)(...o))
    }, [
      ve(t.$slots, "default", { checked: e.checked })
    ], 34));
  }
}), Gde = "_root_hgldm_1", Hde = "_disabled_hgldm_27", Vde = "_alert_hgldm_40", _de = {
  root: Gde,
  disabled: Hde,
  alert: Vde
}, Nde = {
  $style: _de
}, QS = /* @__PURE__ */ we(Ode, [["__cssModules", Nde]]), $de = { key: 1 }, zde = /* @__PURE__ */ de({
  __name: "SCAHelperText",
  props: {
    intent: { default: void 0 },
    hasNoneIntentIcon: { type: Boolean, default: !1 },
    showIcon: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = D(() => {
      switch (t.intent) {
        case "alert":
          return "phosphor/info";
        case "success":
          return "phosphor/check";
        case "warning":
          return "phosphor/warning-fill";
        default:
          return "phosphor/info-fill";
      }
    });
    return (o, s) => (v(), y("div", {
      class: x([
        o.$style.helperText,
        {
          [o.$style.alert]: e.intent === "alert",
          [o.$style.success]: e.intent === "success",
          [o.$style.warning]: e.intent === "warning"
        }
      ])
    }, [
      (e.intent || e.hasNoneIntentIcon) && e.showIcon ? (v(), z(Fe, {
        key: 0,
        class: x([
          o.$style.svg,
          {
            [o.$style.alert]: e.intent === "alert",
            [o.$style.success]: e.intent === "success",
            [o.$style.warning]: e.intent === "warning"
          }
        ]),
        icon: n.value,
        size: "12px"
      }, null, 8, ["class", "icon"])) : V("", !0),
      o.$slots.default ? (v(), y("span", $de, [
        ve(o.$slots, "default")
      ])) : V("", !0)
    ], 2));
  }
}), Wde = "_helperText_1xivz_747", Ude = "_alert_1xivz_764", Kde = "_success_1xivz_768", Zde = "_warning_1xivz_772", qde = {
  helperText: Wde,
  alert: Ude,
  success: Kde,
  warning: Zde
}, jde = {
  $style: qde
}, Gr = /* @__PURE__ */ we(zde, [["__cssModules", jde]]), Yde = ["disabled"], Qde = /* @__PURE__ */ de({
  __name: "SCAToggle",
  props: {
    disabled: { type: Boolean, default: !1 },
    modelValue: { type: [Boolean, null], default: null },
    alert: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    required: { type: Boolean, default: !1 },
    noGap: { type: Boolean, default: !1 },
    noPadding: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const s = Bn(e, "modelValue", t, { passive: !0 });
    return (i, r) => (v(), y("label", {
      class: x([i.$style.label, e.disabled && i.$style.disabled])
    }, [
      R("div", {
        class: x([i.$style.grid, e.noGap && i.$style.gapUnset, e.noPadding && i.$style.paddingUnset])
      }, [
        R("div", {
          class: x(i.$style.root)
        }, [
          R("button", {
            class: x([
              i.$style.toggler,
              {
                [i.$style.unchecked]: e.modelValue === !1,
                [i.$style.checked]: e.modelValue === !0,
                [i.$style.indeterminate]: e.modelValue === null
              }
            ]),
            type: "button",
            disabled: e.disabled,
            onClick: r[0] || (r[0] = () => {
              s.value = !T(s);
            })
          }, null, 10, Yde)
        ], 2),
        R("span", {
          class: x([{ [i.$style.required]: e.required }])
        }, se(e.label), 3)
      ], 2),
      e.helperText ? (v(), z(Gr, {
        key: 0,
        intent: e.alert ? "alert" : void 0,
        class: x(i.$style.helperText)
      }, {
        default: Q(() => [
          Oe(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["intent", "class"])) : V("", !0)
    ], 2));
  }
}), Jde = "_label_8vsmk_747", Xde = "_disabled_8vsmk_751", ece = "_grid_8vsmk_755", tce = "_gapUnset_8vsmk_767", nce = "_paddingUnset_8vsmk_771", oce = "_helperText_8vsmk_775", sce = "_root_8vsmk_780", ice = "_toggler_8vsmk_786", rce = "_unchecked_8vsmk_813", ace = "_checked_8vsmk_825", lce = "_indeterminate_8vsmk_825", dce = {
  label: Jde,
  disabled: Xde,
  grid: ece,
  gapUnset: tce,
  paddingUnset: nce,
  helperText: oce,
  root: sce,
  toggler: ice,
  unchecked: rce,
  checked: ace,
  indeterminate: lce
}, cce = {
  $style: dce
}, JS = /* @__PURE__ */ we(Qde, [["__cssModules", cce]]), uce = { key: 0 }, hce = /* @__PURE__ */ de({
  __name: "SCADropdownItem",
  props: /* @__PURE__ */ dt({
    type: { default: void 0 },
    label: {},
    icon: { default: void 0 },
    avatarInitials: { default: void 0 },
    captionPosition: { default: "horizontal" },
    caption: { default: void 0 },
    expandable: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    useSmallerVerticalPadding: { type: Boolean, default: !1 },
    useSmallPadding: { type: Boolean, default: !1 },
    useHigherOption: { type: Boolean, default: !1 },
    iconSize: { default: "20px" },
    unsetAll: { type: Boolean, default: !1 },
    unsetGap: { type: Boolean, default: !1 },
    useNeutralIconFill: { type: Boolean, default: !1 }
  }, {
    selected: { type: Boolean, default: !1 },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(e) {
    const t = e, n = lt(e, "selected"), o = (s) => {
      if (t.disabled) {
        s.stopPropagation(), s.preventDefault();
        return;
      }
      t.type === "selectable" && (n.value = !n.value);
    };
    return (s, i) => (v(), z(Ot(e.type === "toggle" ? "div" : "label"), {
      class: x([
        s.$style.root,
        {
          [s.$style.vertical]: e.captionPosition === "vertical",
          [s.$style.clickable]: !e.disabled && (e.type === "action" || e.type === "toggle"),
          [s.$style.isDisabled]: e.disabled
        }
      ]),
      onClickCapture: o
    }, {
      default: Q(() => [
        R("div", {
          class: x([
            s.$style.itemDiv,
            {
              [s.$style.vertical]: e.captionPosition === "vertical",
              [s.$style.isDisabled]: e.disabled,
              [s.$style.selected]: n.value,
              [s.$style.active]: e.active,
              [s.$style.isRadio]: e.type === "radio",
              [s.$style.isToggle]: e.type === "toggle",
              [s.$style.useSmallerVerticalPadding]: e.useSmallerVerticalPadding,
              [s.$style.useSmallPadding]: e.useSmallPadding,
              [s.$style.useHigherOption]: e.useHigherOption,
              [s.$style.unsetAll]: e.unsetAll,
              [s.$style.unsetGap]: e.unsetGap,
              [s.$style.useNeutralIconFill]: e.useNeutralIconFill
            }
          ])
        }, [
          R("div", {
            class: x([
              s.$style.contentDiv,
              {
                [s.$style.selectPadding]: !n.value && e.type === "selectable"
              }
            ])
          }, [
            e.type === "dropdowntarget" ? (v(), y("button", uce)) : V("", !0),
            e.type === "selectable" && n.value ? (v(), z(Fe, {
              key: 1,
              icon: "phosphor/check"
            })) : V("", !0),
            e.type === "checkbox" ? (v(), z(Ts, {
              key: 2,
              checked: e.checked,
              disabled: e.disabled,
              class: x(s.$style.checkbox)
            }, {
              default: Q(() => [
                ve(s.$slots, "default")
              ]),
              _: 3
            }, 8, ["checked", "disabled", "class"])) : V("", !0),
            e.type === "radio" ? (v(), z(QS, {
              key: 3,
              checked: e.checked,
              disabled: e.disabled,
              class: x(s.$style.radio)
            }, {
              default: Q(() => [
                ve(s.$slots, "default")
              ]),
              _: 3
            }, 8, ["checked", "disabled", "class"])) : V("", !0),
            e.icon ? (v(), z(Fe, {
              key: 4,
              icon: e.icon,
              size: e.iconSize
            }, null, 8, ["icon", "size"])) : V("", !0),
            s.$slots.avatar || e.avatarInitials ? (v(), z(Li, {
              key: 5,
              size: "xsmall",
              initials: e.avatarInitials
            }, {
              default: Q(() => [
                ve(s.$slots, "avatar")
              ]),
              _: 3
            }, 8, ["initials"])) : V("", !0),
            R("div", {
              class: x([s.$style.textDiv, { [s.$style.withLargeIcon]: e.icon && e.iconSize === "20px" }])
            }, [
              R("span", {
                class: x(s.$style.label)
              }, [
                ve(s.$slots, "tag", {}, () => [
                  ve(s.$slots, "label", {}, () => [
                    Oe(se(e.label), 1)
                  ])
                ])
              ], 2),
              e.caption && e.captionPosition === "vertical" ? (v(), y("span", {
                key: 0,
                class: x(s.$style.caption)
              }, se(e.caption), 3)) : V("", !0)
            ], 2),
            e.type === "toggle" ? (v(), z(JS, {
              key: 6,
              "model-value": e.checked,
              disabled: e.disabled,
              class: x(s.$style.checkbox),
              "no-padding": "",
              "no-gap": e.unsetGap
            }, null, 8, ["model-value", "disabled", "class", "no-gap"])) : V("", !0)
          ], 2),
          e.caption && e.captionPosition === "horizontal" ? (v(), y("span", {
            key: 0,
            class: x(s.$style.caption)
          }, se(e.caption), 3)) : V("", !0),
          e.expandable ? (v(), z(Fe, {
            key: 1,
            icon: "phosphor/caret-right",
            size: e.iconSize
          }, null, 8, ["size"])) : V("", !0)
        ], 2)
      ]),
      _: 3
    }, 40, ["class"]));
  }
}), gce = "_root_e6ofi_747", pce = "_vertical_e6ofi_753", fce = "_clickable_e6ofi_756", mce = "_isDisabled_e6ofi_759", vce = "_itemDiv_e6ofi_763", Cce = "_useNeutralIconFill_e6ofi_786", wce = "_selected_e6ofi_790", yce = "_active_e6ofi_801", bce = "_isRadio_e6ofi_804", Sce = "_isToggle_e6ofi_807", xce = "_checkbox_e6ofi_807", Rce = "_useSmallerVerticalPadding_e6ofi_814", Ece = "_useSmallPadding_e6ofi_818", Ace = "_useHigherOption_e6ofi_821", Fce = "_unsetAll_e6ofi_828", Mce = "_unsetGap_e6ofi_836", Ice = "_contentDiv_e6ofi_840", Pce = "_selectPadding_e6ofi_847", Dce = "_gapSmaller_e6ofi_851", Tce = "_textDiv_e6ofi_856", kce = "_withLargeIcon_e6ofi_862", Lce = "_label_e6ofi_862", Bce = "_caption_e6ofi_879", Oce = "_paddingUnset_e6ofi_889", Gce = {
  root: gce,
  vertical: pce,
  clickable: fce,
  isDisabled: mce,
  itemDiv: vce,
  useNeutralIconFill: Cce,
  selected: wce,
  active: yce,
  isRadio: bce,
  isToggle: Sce,
  checkbox: xce,
  useSmallerVerticalPadding: Rce,
  useSmallPadding: Ece,
  useHigherOption: Ace,
  unsetAll: Fce,
  unsetGap: Mce,
  contentDiv: Ice,
  selectPadding: Pce,
  gapSmaller: Dce,
  textDiv: Tce,
  withLargeIcon: kce,
  label: Lce,
  caption: Bce,
  paddingUnset: Oce
}, Hce = {
  $style: Gce
}, lg = /* @__PURE__ */ we(hce, [["__cssModules", Hce]]), Vce = /* @__PURE__ */ de({
  __name: "AgGridRowGroupMenuContent",
  props: {
    chips: {},
    hasColumns: { type: Boolean },
    dragGroup: {}
  },
  emits: ["hide-panel", "discard", "ungroup", "move"],
  setup(e, { emit: t }) {
    const n = t, { t: o } = fn();
    return (s, i) => (v(), y(Se, null, [
      e.chips.length > 0 ? (v(), y(Se, { key: 0 }, [
        te(qS, {
          chips: e.chips,
          "drag-group": e.dragGroup,
          class: x(s.$style.chips),
          onUngroup: i[0] || (i[0] = (r) => n("ungroup", r)),
          onMove: i[1] || (i[1] = (r, a) => n("move", r, a))
        }, null, 8, ["chips", "drag-group", "class"]),
        te(Ade, {
          "full-width": "",
          compact: ""
        })
      ], 64)) : V("", !0),
      te(lg, {
        label: T(o)("common.action.hideRowGroup"),
        icon: "phosphor/eye-slash",
        "icon-size": "16px",
        "use-smaller-vertical-padding": "",
        appearance: "secondary",
        disabled: !e.hasColumns,
        "test-id": "row-groups-hide-panel",
        onClick: i[2] || (i[2] = (r) => n("hide-panel"))
      }, null, 8, ["label", "disabled"]),
      te(lg, {
        label: T(o)("common.action.discardAllGroups"),
        icon: "phosphor/broom",
        "icon-size": "16px",
        "use-smaller-vertical-padding": "",
        appearance: "secondary",
        disabled: !e.hasColumns,
        "test-id": "row-groups-discard",
        onClick: i[3] || (i[3] = (r) => n("discard"))
      }, null, 8, ["label", "disabled"])
    ], 64));
  }
}), _ce = "_chips_qy8km_1", Nce = {
  chips: _ce
}, $ce = {
  $style: Nce
}, zce = /* @__PURE__ */ we(Vce, [["__cssModules", $ce]]), dv = /* @__PURE__ */ de({
  __name: "AgGridRowGroupMenu",
  props: {
    chips: {},
    hasColumns: { type: Boolean },
    dragGroup: {}
  },
  emits: ["hide-panel", "discard", "ungroup", "move"],
  setup(e, { emit: t }) {
    const { t: n } = fn(), o = t;
    function s(r) {
      o("hide-panel"), r == null || r.hidePopover();
    }
    function i(r) {
      o("discard"), r == null || r.hidePopover();
    }
    return (r, a) => (v(), z(Yt, { width: "220px" }, {
      trigger: Q(({ target: l }) => [
        te(ut, {
          size: "small",
          type: "ghost",
          appearance: "secondary",
          icon: "generic/row-groups",
          popovertarget: l,
          title: T(n)("common.label.rowGroups"),
          "test-id": "row-groups-menu"
        }, null, 8, ["popovertarget", "title"])
      ]),
      default: Q(({ popover: l }) => [
        te(zce, {
          chips: e.chips,
          "has-columns": e.hasColumns,
          "drag-group": e.dragGroup,
          onHidePanel: (d) => s(l),
          onDiscard: (d) => i(l),
          onUngroup: a[0] || (a[0] = (d) => o("ungroup", d)),
          onMove: a[1] || (a[1] = (d, c) => o("move", d, c))
        }, null, 8, ["chips", "has-columns", "drag-group", "onHidePanel", "onDiscard"])
      ]),
      _: 1
    }));
  }
}), Wce = /* @__PURE__ */ de({
  __name: "AgGridRowGroupControls",
  props: {
    menuHost: {},
    overflowHost: {},
    menu: {},
    chips: {},
    hiddenChips: {},
    hasColumns: { type: Boolean },
    dragGroup: {}
  },
  emits: ["hide-panel", "discard", "ungroup", "move"],
  setup(e, { emit: t }) {
    const n = e, o = t, { t: s } = fn(), i = D(() => n.chips.length > 0 && n.hiddenChips.length === n.chips.length);
    function r() {
      var l;
      o("hide-panel"), (l = n.menu) == null || l.close();
    }
    function a() {
      var l;
      o("discard"), (l = n.menu) == null || l.close();
    }
    return (l, d) => (v(), y(Se, null, [
      (v(), z(qi, { to: e.menuHost }, [
        te(dv, {
          chips: i.value ? e.chips : [],
          "has-columns": e.hasColumns,
          "drag-group": e.dragGroup,
          onHidePanel: d[0] || (d[0] = (c) => o("hide-panel")),
          onDiscard: d[1] || (d[1] = (c) => o("discard")),
          onUngroup: d[2] || (d[2] = (c) => o("ungroup", c)),
          onMove: d[3] || (d[3] = (c, u) => o("move", c, u))
        }, null, 8, ["chips", "has-columns", "drag-group"])
      ], 8, ["to"])),
      e.overflowHost && e.hiddenChips.length > 0 && !i.value ? (v(), z(qi, {
        key: 0,
        to: e.overflowHost
      }, [
        te(Yt, null, {
          trigger: Q(({ target: c }) => [
            te(ut, {
              size: "small",
              type: "ghost",
              appearance: "secondary",
              icon: "phosphor/dots-three",
              popovertarget: c,
              title: T(s)("common.label.rowGroups"),
              "test-id": "row-groups-overflow"
            }, null, 8, ["popovertarget", "title"])
          ]),
          default: Q(() => [
            te(qS, {
              chips: e.hiddenChips,
              "drag-group": e.dragGroup,
              onUngroup: d[4] || (d[4] = (c) => o("ungroup", c)),
              onMove: d[5] || (d[5] = (c, u) => o("move", c, u + e.chips.length - e.hiddenChips.length))
            }, null, 8, ["chips", "drag-group"])
          ]),
          _: 1
        })
      ], 8, ["to"])) : V("", !0),
      e.menu ? (v(), z(qi, {
        key: 1,
        to: e.menu.element
      }, [
        te(dv, {
          chips: e.chips,
          "has-columns": e.hasColumns,
          "drag-group": e.dragGroup,
          onHidePanel: r,
          onDiscard: a,
          onUngroup: d[6] || (d[6] = (c) => o("ungroup", c)),
          onMove: d[7] || (d[7] = (c, u) => o("move", c, u))
        }, null, 8, ["chips", "has-columns", "drag-group"])
      ], 8, ["to"])) : V("", !0)
    ], 64));
  }
}), dg = /* @__PURE__ */ de({
  __name: "SCASkeletonItem",
  props: {
    width: { default: "100%" },
    height: { default: "24px" },
    baseColor: { default: "var(--color-border-default)" },
    shineColor: { default: "var(--color-coolGrey-p3)" },
    borderRadius: { default: "var(--border-radius-large)" }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: "skeleton",
      style: Ke({
        width: e.width,
        height: e.height,
        "--skeleton-base": e.baseColor,
        "--skeleton-shine": e.shineColor,
        "--skeleton-radius": e.borderRadius
      })
    }, null, 4));
  }
}), Uce = { class: "sca-loading-cell" }, XS = /* @__PURE__ */ de({
  __name: "AgGridLoadingCell",
  setup(e) {
    return (t, n) => (v(), y("div", Uce, [
      te(dg, { height: "14px" })
    ]));
  }
}), e2 = /* @__PURE__ */ de({
  __name: "AgGridRowGroupLabel",
  props: {
    params: {}
  },
  setup(e) {
    return (t, n) => {
      var o;
      return v(), y("span", null, se((o = e.params) == null ? void 0 : o.text), 1);
    };
  }
}), Mr = "__empty__";
function t2(e, t) {
  return +(e === Mr) - +(t === Mr);
}
function cv(e, t) {
  var i;
  const n = (i = t.allLeafChildren) == null ? void 0 : i[0];
  if (!(n != null && n.data) || typeof e.valueGetter == "string") return;
  const o = n.data, s = e.valueGetter ? e.valueGetter({
    data: o,
    node: n,
    colDef: e,
    getValue: (r) => hr(o, r)
  }) : e.field && hr(o, e.field);
  return { row: n, value: s };
}
function Kce(e) {
  const t = e.comparator;
  return (n, o, s, i, r) => {
    if (!oo(s) || !oo(i)) return (t == null ? void 0 : t(n, o, s, i, r)) ?? 0;
    const a = t2(s.key, i.key);
    if (a !== 0) return r ? -a : a;
    const l = t && cv(e, s), d = t && cv(e, i);
    return (l && d ? t(l.value, d.value, l.row, d.row, r) : 0) || String(s.key).localeCompare(String(i.key));
  };
}
function Zce(e, t) {
  return e == null || t == null ? +(e != null) - +(t != null) : typeof e == "number" && typeof t == "number" ? e - t : typeof e == "string" && typeof t == "string" ? e.localeCompare(t, void 0, { numeric: !0 }) : 0;
}
function qce(e) {
  return (t, n, o, s, i) => {
    var a, l, d;
    const r = o.rowGroupColumn;
    return r && oo(o) && oo(s) ? ((l = (a = r.getColDef()).comparator) == null ? void 0 : l.call(a, t, n, o, s, i)) ?? 0 : ((d = e.comparator) == null ? void 0 : d.call(e, t, n, o, s, i)) ?? Zce(t, n);
  };
}
const jce = "sca-row-group-cell", Yce = {
  rowGroupPanel: "generic/row-groups",
  columnMoveGroup: "generic/row-groups",
  // The drag handle and the remove button of a row-group chip.
  columnDrag: "phosphor/dots-six",
  cancel: "phosphor/x",
  menuAddRowGroup: "generic/row-groups",
  // "Discard all groups" / "Ungroup by" in the Group column's menu, as in the panel's menu.
  menuRemoveRowGroup: "phosphor/broom",
  groupContracted: "phosphor/caret-right",
  groupExpanded: "phosphor/caret-down"
};
function Qce({ value: e, data: t, node: n, colDef: o }) {
  if (e != null || typeof o.cellRendererParams != "function") return e;
  const s = o.cellRendererParams({ value: e, data: t, node: n });
  return (s == null ? void 0 : s.value) ?? (s == null ? void 0 : s.label);
}
const uv = /* @__PURE__ */ new WeakMap();
function Jce(e = WR) {
  let t = uv.get(e);
  return t || (t = (n) => e(Qce(n)) ?? Mr, uv.set(e, t)), t;
}
const Ka = (e) => e.colId ?? e.field;
function n2(e, t) {
  return t != null && t.enabled ? t.columns.filter((n) => e.some((o) => Ka(o) === n)) : [];
}
function Xce(e) {
  return !!(e != null && e.enabled) && e.columns.length > 0;
}
function o2(e, t) {
  const n = t == null ? void 0 : t.leafColumn;
  return e.find((o) => !!n && !o.hide && Ka(o) === n && !(t != null && t.columns.includes(n)));
}
function eue(e, t) {
  if (!t) return e;
  const n = n2(e, t), o = n.length > 0 ? o2(e, t) : void 0;
  return e.map((s) => {
    const i = n.indexOf(Ka(s) ?? ""), r = i >= 0, a = s.cellRendererSelector;
    return {
      ...s,
      // A caller's `false` keeps a column it cannot group by out of "Group by". While grouping is off
      // the column menu shows "Group by" disabled; with the panel hidden a column has nowhere to drop.
      enableRowGroup: s.enableRowGroup !== !1,
      rowGroup: r,
      rowGroupIndex: r ? i : null,
      keyCreator: t.enabled ? Jce(t.groupKey) : s.keyCreator,
      comparator: r ? Kce(s) : s.comparator,
      hide: !!s.hide || r || s === o,
      // The Group column carries this column's sort while it stands in for it.
      ...s === o && { sort: null, sortIndex: null },
      cellRendererSelector: t.enabled ? (l) => (
        // The Group column renders a server-side group's value with its sample row as `data`.
        oo(l.node) && (!l.data || gr(l.data)) ? { component: e2 } : a == null ? void 0 : a(l)
      ) : a
    };
  });
}
function Qu(e, t) {
  var s;
  const n = (s = e.cellRendererSelector) == null ? void 0 : s.call(e, t);
  if (n) return n;
  if (!e.cellRenderer) return;
  const o = e.cellRendererParams;
  return {
    component: e.cellRenderer,
    params: typeof o == "function" ? o(t) : o
  };
}
function tue(e, t) {
  return {
    filter: e.filter,
    // AG Grid turns the filter off on a Group column without a field of its own (grouped by its leaf column).
    filterValueGetter: (n) => n.getValue(t),
    filterParams: e.filterParams,
    floatingFilter: e.floatingFilter,
    suppressFloatingFilterButton: e.suppressFloatingFilterButton,
    suppressHeaderFilterButton: e.suppressHeaderFilterButton,
    floatingFilterComponentParams: { ...e.floatingFilterComponentParams, originalHiddenColId: t }
  };
}
function nue(e, t, n) {
  const [o] = n2(e, t);
  if (o === void 0) return;
  const s = o2(e, t), i = e.find((a) => Ka(a) === o), r = s && Ka(s);
  return {
    headerName: n.header,
    // Lets the column-state sync tell which column the Group column stands in for.
    field: r,
    width: s == null ? void 0 : s.width,
    pinned: s == null ? void 0 : s.pinned,
    autoHeight: s == null ? void 0 : s.autoHeight,
    wrapText: s == null ? void 0 : s.wrapText,
    // The field above is the leaf's id, not its data path (`CATEGORY_NAME` reads `name.default`).
    valueGetter: r ? (a) => a.getValue(r) : void 0,
    valueFormatter: s == null ? void 0 : s.valueFormatter,
    // The total row's settings for the column the Group column stands in for.
    context: s == null ? void 0 : s.context,
    sortable: !!s && s.sortable !== !1,
    sort: s == null ? void 0 : s.sort,
    sortIndex: s == null ? void 0 : s.sortIndex,
    comparator: s && qce(s),
    ...i && tue(i, o),
    // AG Grid drops its group renderer (arrow, count) once the table adds a cellRendererSelector.
    cellRenderer: "agGroupCellRenderer",
    loadingCellRenderer: XS,
    cellClass: jce,
    cellRendererParams: {
      suppressDoubleClickExpand: !0,
      innerRendererSelector: (a) => {
        var p;
        if (!a.node.group) return s ? Qu(s, a) : void 0;
        if (a.node.key === Mr)
          return { component: e2, params: { text: n.empty } };
        const l = a.node.rowGroupColumn, d = gr(a.node.data);
        if (d) {
          if (!l) return;
          const f = l.getColDef(), m = d.row, C = vR(f, m, a), w = Qu(f, { ...a, data: m, value: C });
          return w && { ...w, params: { data: m, value: C, ...w.params } };
        }
        const c = (p = a.node.allLeafChildren) == null ? void 0 : p[0];
        if (!l || !(c != null && c.data)) return;
        const u = c.data, h = a.api.getCellValue({ rowNode: c, colKey: l }), g = Qu(l.getColDef(), { ...a, node: c, data: u, value: h });
        return g && { ...g, params: { data: u, value: h, ...g.params } };
      }
    }
  };
}
function s2(e, t, n = Object.is) {
  return e.length === t.length && e.every((o, s) => n(o, t[s]));
}
function mf(e) {
  return !!(e != null && e.enabled) && !e.panelHidden;
}
function oue(e) {
  return e ? {
    rowGroupPanelShow: mf(e) ? "always" : "never",
    // The caller owns column visibility (saved per filterset): grouping hides a column by its colDef.
    suppressGroupChangesColumnVisibility: !0,
    // AG Grid reads it only when the grid is created, so it is set before any column is grouped.
    initialGroupOrderComparator: (t) => t2(t.nodeA.key, t.nodeB.key)
  } : {};
}
function sue(e, t) {
  return !Xce(t) || (e == null ? void 0 : e.mode) !== "multiRow" ? e : { ...e, groupSelects: "descendants" };
}
function hv(e) {
  return e === "rowGroup" || e === "rowUnGroup";
}
function iue(e) {
  return {
    groupBy: e("common.action.groupBy"),
    ungroupBy: e("common.action.ungroupBy"),
    ungroupAll: e("common.action.discardAllGroups"),
    group: e("common.label.rowGroupColumn"),
    rowGroupColumnsEmptyMessage: e("common.label.rowGroupsDropZone")
  };
}
function rue(e) {
  return Object.fromEntries(Object.entries(Yce).map(([t, n]) => [t, e(n)]));
}
const i2 = 50, aue = "sca-row-loading", lue = "", due = (e) => e ?? Mr, cue = (e) => e === Mr ? null : e;
function uue(e) {
  return !!(e != null && e.source) && e.enabled && e.columns.length > 0;
}
function hue(e) {
  return {
    getRows(t) {
      const n = e();
      if (!n) {
        t.fail();
        return;
      }
      const { groupKeys: o, rowGroupCols: s, startRow: i = 0, endRow: r } = t.request, a = i, l = (r ?? i + i2) - i, d = o.map((h, g) => ({
        columnId: s[g].id,
        key: cue(h)
      })), c = o.length;
      (c < s.length ? n.loadGroups({ path: d, columnId: s[c].id, offset: a, limit: l }).then(({ groups: h, total: g }) => ({
        rowData: h.map(
          (p) => mR({ key: due(p.key), count: p.count, row: p.row })
        ),
        rowCount: g
      })) : n.loadRows({ path: d, offset: a, limit: l }).then(({ rows: h }) => ({
        rowData: h,
        // A short block is the last one; otherwise the group's count sizes the scrollbar.
        rowCount: h.length < l ? a + h.length : t.parentNode.allChildrenCount ?? void 0
      }))).then(
        (h) => t.success(h),
        () => t.fail()
      );
    }
  };
}
function gue(e) {
  if (typeof e.valueGetter == "string" || !(e.enableRowGroup || e.rowGroup)) return e;
  const t = e.colId ?? e.field, n = e.valueGetter;
  return {
    ...e,
    valueGetter: (o) => {
      var i, r;
      const s = gr(o.data);
      return s ? ((r = (i = o.node) == null ? void 0 : i.rowGroupColumn) == null ? void 0 : r.getColId()) === t ? s.key : void 0 : n ? n(o) : e.field ? hr(o.data, e.field) : void 0;
    }
  };
}
function pue(e) {
  return e.map((t) => ({ ...gue(t), loadingCellRenderer: XS }));
}
function fue(e, t) {
  const { getRowId: n, rowClassRules: o, ...s } = e;
  return {
    ...s,
    rowClassRules: { ...o, [aue]: (i) => !!i.node.stub },
    initialGroupOrderComparator: void 0,
    rowModelType: "serverSide",
    serverSideDatasource: t,
    cacheBlockSize: i2,
    suppressServerSideFullWidthLoadingRow: !0,
    ssrmExpandAllAffectsAllRows: !0,
    getChildCount: (i) => {
      var r;
      return ((r = gr(i)) == null ? void 0 : r.count) ?? 0;
    },
    getRowId: (i) => {
      const r = gr(i.data);
      return r ? ["__row_group__", ...i.parentKeys ?? [], r.key].join(lue) : n ? n(i) : String(i.data.id);
    }
  };
}
function mue(e) {
  if ((e == null ? void 0 : e.mode) !== "multiRow") return e;
  const t = e.isRowSelectable;
  return {
    ...e,
    groupSelects: "self",
    headerCheckbox: !1,
    hideDisabledCheckboxes: !0,
    isRowSelectable: (n) => oo(n) || ((t == null ? void 0 : t(n)) ?? !0)
  };
}
function vue(e) {
  Gh.registerModules([Pz, Dz]);
  const t = () => {
    var s;
    return (s = xe(e.rowGroups)) == null ? void 0 : s.source;
  }, n = D(() => uue(xe(e.rowGroups))), o = hue(t);
  return Re(t, (s, i) => {
    const r = e.gridApi.value;
    !s || !i || !r || r.isDestroyed() || r.getGridOption("rowModelType") === "serverSide" && r.refreshServerSide({ purge: !0 });
  }), {
    /** AG Grid sets the row model only on creation: the grid is recreated when it changes. */
    rowModel: D(() => n.value ? "serverSide" : "clientSide"),
    rowData: (s) => n.value ? void 0 : s,
    colDefs: (s) => n.value ? pue(s) : s,
    rowSelection: (s) => n.value ? mue(s) : s,
    gridOptions: (s) => n.value ? fue(s, o) : s
  };
}
const id = ".ag-column-drop-cell:not(.ag-column-drop-cell-ghost)", r2 = "sca-row-group-chip-overflowed";
function Cue(e) {
  const t = Qe(null), n = Qe([]), o = Qe([]);
  let s = null, i = 0;
  const r = () => {
    i || (i = requestAnimationFrame(d));
  }, a = new ResizeObserver(r), l = new MutationObserver(r);
  function d() {
    i = 0;
    const h = s == null ? void 0 : s.querySelector(".ag-column-drop-horizontal"), g = e.value;
    if (!s || !h || !t.value || !g || g.isDestroyed()) return;
    const p = [...h.querySelectorAll(id)], f = s.getBoundingClientRect().left, m = (E) => E.getBoundingClientRect().right - f, C = m(h), w = parseFloat(getComputedStyle(h.querySelector(".ag-column-drop-list") ?? h).columnGap) || 0, b = p.at(-1);
    let A = p.length;
    if (b && m(b) > C) {
      const E = C - w - t.value.offsetWidth;
      A = p.findIndex((M) => m(M) > E);
    }
    p.forEach((E, M) => E.classList.toggle(r2, M >= A));
    const S = p[A - 1];
    t.value.style.left = `${S ? m(S) + w : h.offsetLeft}px`;
    const F = g.getRowGroupColumns().map((E) => ({ colId: E.getColId(), label: g.getDisplayNameForColumn(E, "header") ?? E.getColId() }));
    gv(n, F), gv(o, F.slice(A));
  }
  function c(h) {
    u(), s = h;
    const g = document.createElement("div");
    g.className = "sca-row-group-overflow-host", s.append(g), t.value = g, a.observe(s), l.observe(s, { childList: !0, subtree: !0 }), r();
  }
  function u() {
    var h;
    cancelAnimationFrame(i), i = 0, a.disconnect(), l.disconnect(), (h = t.value) == null || h.remove(), t.value = null, n.value = [], o.value = [], s = null;
  }
  return { host: t, chips: n, hiddenChips: o, attach: c, detach: u, remeasure: r };
}
const wue = (e, t) => e.colId === t.colId && e.label === t.label;
function gv(e, t) {
  s2(e.value, t, wue) || (e.value = t);
}
const yue = [$a.indicatorBefore, $a.indicatorAfter], bue = ".ag-column-drop-horizontal", Ju = (e) => e instanceof Element && !!e.closest(bue);
function Sue(e, t, n) {
  const o = e.findIndex((i) => i.toLowerCase() === t);
  if (o === -1) return null;
  const s = o < n ? n - 1 : n;
  return s === o ? null : { from: o, to: s };
}
function xue(e, t) {
  let n = null;
  function o() {
    n == null || n.querySelectorAll(id).forEach((u) => u.classList.remove(...yue));
  }
  function s(u) {
    var C;
    const h = [...(n == null ? void 0 : n.querySelectorAll(id)) ?? []].filter(
      (w) => !w.classList.contains(r2)
    ), g = (C = u.target) == null ? void 0 : C.closest(id), p = g ? h.indexOf(g) : -1;
    if (!g || p === -1) {
      const w = h.at(-1);
      return w ? { chip: w, before: !1, slot: h.length } : null;
    }
    const f = g.getBoundingClientRect(), m = u.clientX < f.left + f.width / 2;
    return { chip: g, before: m, slot: m ? p : p + 1 };
  }
  function i(u) {
    const h = e.value, g = ZS(u), p = s(u);
    if (!h || h.isDestroyed() || !g || !p) return null;
    const f = h.getRowGroupColumns().map((C) => C.getColId()), m = Sue(f, g, p.slot);
    return m && { ...m, ...p, api: h };
  }
  function r(u) {
    if (!Ju(u.target) || !Ua(u, t)) return;
    u.preventDefault();
    const h = i(u);
    u.dataTransfer && (u.dataTransfer.dropEffect = h ? "move" : "none"), o(), h == null || h.chip.classList.add(h.before ? $a.indicatorBefore : $a.indicatorAfter);
  }
  function a(u) {
    Ju(u.relatedTarget) || o();
  }
  function l(u) {
    if (!Ju(u.target) || !Ua(u, t)) return;
    u.preventDefault();
    const h = i(u);
    o(), h == null || h.api.moveRowGroupColumn(h.from, h.to);
  }
  function d(u) {
    c(), n = u, n.addEventListener("dragover", r), n.addEventListener("dragleave", a), n.addEventListener("drop", l);
  }
  function c() {
    o(), n == null || n.removeEventListener("dragover", r), n == null || n.removeEventListener("dragleave", a), n == null || n.removeEventListener("drop", l), n = null;
  }
  return { attach: d, detach: c };
}
let Rue = 0;
function Eue(e) {
  const t = Qe(null), n = Cue(e.gridApi), o = `rowGroupChips-${++Rue}`, s = xue(e.gridApi, o);
  let i = null;
  const r = () => {
    var u;
    return !!i && !((u = e.gridWrapper.value) != null && u.contains(i));
  };
  function a() {
    var g;
    const u = (g = e.gridWrapper.value) == null ? void 0 : g.querySelector("[class*='ag-theme-params-']");
    if (!i || !u) return;
    const h = (p) => p.startsWith("ag-theme-");
    [...i.classList].filter(h).forEach((p) => i == null ? void 0 : i.classList.remove(p)), [...u.classList].filter(h).forEach((p) => i == null ? void 0 : i.classList.add(p));
  }
  function l() {
    var h, g;
    if (!i) return;
    if (((h = t.value) == null ? void 0 : h.parentElement) !== i) {
      const p = document.createElement("div");
      p.className = "sca-row-group-menu-host", i.prepend(p), t.value = p, n.attach(i), s.attach(i);
    }
    i.classList.add("sca-row-group-panel");
    const u = (g = xe(e.rowGroups)) == null ? void 0 : g.panelTarget;
    !u || i.parentElement === u || (a(), u.appendChild(i), n.remeasure());
  }
  function d() {
    var u;
    c(), xe(e.rowGroups) && (i = ((u = e.gridWrapper.value) == null ? void 0 : u.querySelector(".ag-column-drop-wrapper")) ?? null, l());
  }
  function c() {
    r() && (i == null || i.remove()), n.detach(), s.detach(), i = null, t.value = null;
  }
  return Re(
    () => mf(xe(e.rowGroups)),
    (u) => {
      const h = e.gridApi.value;
      !h || h.isDestroyed() || (h.setGridOption("rowGroupPanelShow", u ? "always" : "never"), u && Xe(l));
    }
  ), Re(
    () => {
      var u;
      return (u = xe(e.rowGroups)) == null ? void 0 : u.panelTarget;
    },
    () => void Xe(l)
  ), Re(
    () => xe(e.theme),
    () => void Xe(() => r() && a())
  ), ro(c), {
    menuHost: t,
    overflowHost: n.host,
    chips: n.chips,
    hiddenChips: n.hiddenChips,
    dragGroup: o,
    attach: d,
    detach: c
  };
}
function Aue(e) {
  const t = () => xe(e.rowGroups), n = Eue(e), o = vue(e), s = D((r) => {
    const a = t();
    if (!a) return;
    const { enabled: l, columns: d, leafColumn: c, groupKey: u } = a, h = { enabled: l, columns: d, leafColumn: c, groupKey: u };
    return (r == null ? void 0 : r.enabled) === h.enabled && r.leafColumn === h.leafColumn && r.groupKey === h.groupKey && s2(r.columns, h.columns) ? r : h;
  });
  return Re(
    () => {
      var r;
      return (r = s.value) != null && r.enabled ? s.value.columns[0] : void 0;
    },
    (r, a) => {
      const l = e.gridApi.value;
      if (a === void 0 || !l || l.isDestroyed()) return;
      const { [Ea]: d, ...c } = l.getFilterModel() ?? {};
      d && (l.setFilterModel(c), e.onFilterDrop(Object.values(c).flat()));
    }
  ), {
    controls: D(
      () => {
        var r, a;
        return mf(t()) && n.menuHost.value ? {
          menuHost: n.menuHost.value,
          overflowHost: n.overflowHost.value,
          menu: ((r = t()) == null ? void 0 : r.menuTarget) ?? null,
          chips: n.chips.value,
          hiddenChips: n.hiddenChips.value,
          dragGroup: n.dragGroup,
          hasColumns: (((a = s.value) == null ? void 0 : a.columns.length) ?? 0) > 0,
          onHidePanel: e.onHidePanel,
          onDiscard: () => {
            var l;
            return (l = e.gridApi.value) == null ? void 0 : l.setRowGroupColumns([]);
          },
          onUngroup: (l) => {
            var d;
            return (d = e.gridApi.value) == null ? void 0 : d.removeRowGroupColumns([l]);
          },
          onMove: (l, d) => {
            const c = e.gridApi.value, u = (c == null ? void 0 : c.getRowGroupColumns().findIndex((h) => h.getColId() === l)) ?? -1;
            c && u !== -1 && c.moveRowGroupColumn(u, d);
          }
        } : void 0;
      }
    ),
    attachPanel: n.attach,
    detachPanel: n.detach,
    isGroupRow: oo,
    rowModel: o.rowModel,
    rowData: o.rowData,
    colDefs: (r) => o.colDefs(eue(r, s.value)),
    autoGroupColumnDef: (r) => nue(r, s.value, {
      header: e.t("common.label.rowGroupColumn"),
      empty: e.t("common.label.rowGroupEmpty")
    }),
    rowSelection: (r) => o.rowSelection(sue(r, s.value)),
    gridOptions: () => oue(t()),
    /** The table's final grid options, switched to the server-side model while groups come from a source. */
    withRowModel: o.gridOptions,
    localeText: () => iue(e.t),
    isMenuItem: hv,
    /** The column menu cannot hide the caller's `suppressed` columns, nor the Group column while grouping. */
    cannotHide: (r, a) => {
      var l;
      return !!r && (!!(a != null && a.includes(r)) || r === Ea && !!((l = s.value) != null && l.enabled) && s.value.columns.length > 0);
    },
    /** A click on a group row expands or collapses it, unless it hit the row's checkbox; true for a group row. */
    toggleOnClick: ({ node: r, event: a }) => oo(r) ? ((a == null ? void 0 : a.target) instanceof Element && !!a.target.closest(".ag-selection-checkbox") || r.setExpanded(!r.expanded), !0) : !1,
    /**
     * "Group by" / "Un-group by" from AG Grid's defaults while the panel is shown; a disabled "Group by"
     * while grouping is off or its panel hidden, as the toolbar's toggle then shows it.
     */
    menuItems: ({ defaultItems: r, column: a, api: l }) => {
      var u, h, g;
      if ((u = s.value) != null && u.enabled && !((h = t()) != null && h.panelHidden)) return r.filter(hv);
      if (!s.value || !(a != null && a.getColDef().enableRowGroup)) return [];
      const d = `${e.t("common.action.groupBy")} ${l.getDisplayNameForColumn(a, "header")}`, c = (g = l.getGridOption("icons")) == null ? void 0 : g.menuAddRowGroup;
      return [{ name: d, disabled: !0, icon: typeof c == "string" ? c : void 0 }];
    },
    onColumnRowGroupChanged: (r) => {
      r.source !== "gridOptionsChanged" && e.onColumnsChange(r.api.getRowGroupColumns().map((a) => a.getColId()));
    }
  };
}
const Ud = "dd.MM.yyyy";
function pv(e, t) {
  if (t && t !== Ud) {
    const s = Xf(e, t);
    if (s) return s;
  }
  const n = Xf(e, Ud);
  if (n) return n;
  const o = new Date(e);
  return isNaN(o.getTime()) ? void 0 : o;
}
function Fue(e) {
  return {
    number: {
      baseDataType: "number",
      extendsDataType: "number",
      // Preserve raw value from cell editor without AG Grid's built-in numeric coercion
      valueParser: (t) => t.newValue
    },
    dateString: {
      baseDataType: "dateString",
      extendsDataType: "dateString",
      dateParser: (t) => {
        if (t)
          return pv(t, e);
      },
      dateFormatter: (t) => {
        if (!(!t || !vg(t)))
          return Og(t, e ?? Ud);
      },
      valueParser: (t) => {
        if (!t.newValue) return As(/* @__PURE__ */ new Date(), "yyyy-MM-dd");
        const n = pv(String(t.newValue), e);
        return As(n ?? /* @__PURE__ */ new Date(), "yyyy-MM-dd");
      }
    }
  };
}
const Mue = /^\d{4}-\d{2}-\d{2}/;
function a2(e, t) {
  if (!e) return null;
  if ("conditions" in e && Array.isArray(e.conditions)) {
    let o = !1;
    const s = e.conditions.map((i) => {
      const r = a2(i, t);
      return r && (o = !0), r ?? i;
    });
    return o ? { ...e, conditions: s } : null;
  }
  const n = e;
  if (n.filterType === "dateString" && typeof n.filter == "string" && Mue.test(n.filter)) {
    const o = new Date(n.filter);
    if (!isNaN(o.getTime()))
      return { ...e, filter: Og(o, t ?? Ud) };
  }
  return null;
}
function Ir(e) {
  var t;
  return (t = e.floatingFilterComponentParams) == null ? void 0 : t.columnDataType;
}
function fv(e) {
  var t;
  if (Ir(e) === void 0 || (t = e.floatingFilterComponentParams) != null && t.hide) return !1;
  switch (Ir(e)) {
    case "number":
      return "agNumberColumnFilter";
    case "date":
      return "agDateColumnFilter";
    case "datetime":
      return "agDateColumnFilter";
    case "customList":
      return !1;
    // Not AG Grid's boolean data type: that one offers only "is true"/"is false"/"is blank", while
    // the value travels to the API as the text "true"/"false" and reads better as equals/not equals.
    case "boolean":
      return "agTextColumnFilter";
    default:
      return "agTextColumnFilter";
  }
}
function mv(e) {
  var n;
  const t = (n = e.floatingFilterComponentParams) == null ? void 0 : n.filterConfig;
  return t && x8(t).includes(De.BLANK) ? ["blank", "notBlank"] : [];
}
function vv(e) {
  if (Ir(e) === void 0)
    return {
      filterOptions: []
    };
  switch (Ir(e)) {
    case "number":
      return {
        filterOptions: [
          "equals",
          "notEqual",
          "greaterThan",
          "lessThan",
          "greaterThanOrEqual",
          "lessThanOrEqual",
          ...mv(e)
        ]
      };
    case "date":
      return {
        filterOptions: ["equals", "notEqual", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual"]
      };
    case "customList":
      return {
        filterOptions: []
      };
    case "datetime":
      return {
        filterOptions: ["equals", "notEqual", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual"]
      };
    // filterOptions doubles as the advanced filter's operator allowlist — a Yes/No column compares
    // for equality only.
    case "boolean":
      return {
        filterOptions: ["equals", "notEqual"]
      };
    default:
      return {
        filterOptions: ["contains", "notContains", "equals", "notEqual", ...mv(e)]
      };
  }
}
function Cv(e) {
  if (Ir(e) !== void 0)
    switch (Ir(e)) {
      case "number":
        return "number";
      case "date":
        return "dateString";
      case "datetime":
        return "dateString";
      // See getColumnFilter: compared as the text "true"/"false", not as AG Grid's boolean type.
      case "boolean":
        return "text";
      case "customList":
        return;
      default:
        return "text";
    }
}
const Iue = {
  showMoveButtons: !0,
  suppressFullScreenButton: !0,
  buttons: ["clear", "apply", "cancel"]
}, Pue = { suppressBuilderButton: !0, buttons: [] };
class wv {
  constructor() {
    Ae(this, "model", null);
    Ae(this, "params");
  }
  init(t) {
    this.params = t;
  }
  getModel() {
    return this.model;
  }
  setModel(t) {
    this.model = t, this.params.filterChangedCallback();
  }
  isFilterActive() {
    return this.model != null && this.model.length > 0;
  }
  doesFilterPass() {
    return !0;
  }
  getGui() {
    const t = document.createElement("div");
    return t.style.display = "none", t;
  }
}
const wa = /* @__PURE__ */ new Map();
let Xu;
function Due() {
  wa.forEach((e) => e.forEach((t) => t()));
}
function yv() {
  var e;
  return Xu || (Xu = new ResizeObserver((t) => {
    var n;
    for (const { target: o } of t) (n = wa.get(o)) == null || n.forEach((s) => s());
  }), (e = document.fonts) == null || e.addEventListener("loadingdone", Due)), Xu;
}
function Tue(e, t) {
  const n = wa.get(e) ?? /* @__PURE__ */ new Set();
  return n.add(t), wa.set(e, n), yv().observe(e), () => {
    n.delete(t), !(n.size > 0) && (wa.delete(e), yv().unobserve(e));
  };
}
function al(e, t) {
  const n = W(!1);
  if (typeof ResizeObserver > "u") return n;
  function o(s) {
    const i = s.scrollWidth > s.clientWidth;
    i !== n.value && (n.value = i);
  }
  return Re(
    () => xe(e),
    (s, i, r) => {
      if (!s) {
        n.value = !1;
        return;
      }
      r(Tue(s, () => o(s)));
    },
    { immediate: !0, flush: "post" }
  ), t && Re(
    t,
    () => {
      const s = xe(e);
      s && o(s);
    },
    { flush: "post" }
  ), n;
}
const kue = Array.from({ length: 101 }, (e, t) => t / 100);
function Lue(e) {
  typeof IntersectionObserver > "u" || Re(
    [() => xe(e.open), () => xe(e.anchor)],
    ([t, n], o, s) => {
      if (!t || !n) return;
      let i = 0;
      const r = new IntersectionObserver(
        (a) => {
          for (const { intersectionRatio: l } of a) {
            if (l < i) {
              r.disconnect(), e.close();
              return;
            }
            i = l;
          }
        },
        { threshold: kue }
      );
      r.observe(n), s(() => r.disconnect());
    },
    { immediate: !0 }
  );
}
const Bue = ["test-id"], Oue = de({ inheritAttrs: !1 }), Gue = /* @__PURE__ */ de({
  ...Oue,
  __name: "ColumnFilterCell",
  props: /* @__PURE__ */ dt({
    summary: {},
    active: { type: Boolean },
    hovered: { type: Boolean },
    testIdPrefix: {},
    paddingUpset: { type: Boolean }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["positioned", "closed", "clear"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, o = t, s = lt(e, "open"), i = W(null);
    Lue({
      open: s,
      anchor: () => MS(i.value),
      close: () => s.value = !1
    });
    const r = W(null), a = al(r, () => n.summary), l = D(() => n.hovered || n.active || s.value), d = D(() => n.active && (n.hovered || s.value));
    return (c, u) => (v(), y(Se, null, [
      te(Yt, {
        "is-open": s.value,
        "onUpdate:isOpen": u[0] || (u[0] = (h) => s.value = h),
        "padding-upset": e.paddingUpset,
        placement: "bottom-start",
        "offset-y": T(A8),
        trigger: "click",
        "no-mobile-margin": "",
        style: Ke(e.active ? {} : { width: "100%" }),
        onPositioned: u[1] || (u[1] = (h) => o("positioned")),
        onClosed: u[2] || (u[2] = (h) => o("closed"))
      }, {
        trigger: Q(({ target: h }) => [
          R("div", {
            class: x([c.$style.trigger, (s.value || e.hovered) && c.$style.triggerHighlighted])
          }, [
            te(Zt, {
              popovertarget: h,
              type: "bare",
              size: "xsmall",
              intent: "none",
              appearance: "secondary",
              class: x(c.$style.button),
              "icon-left": "phosphor/funnel",
              style: Ke({ opacity: l.value ? 1 : 0 }),
              "test-id": `${e.testIdPrefix}-trigger`
            }, null, 8, ["popovertarget", "class", "style", "test-id"])
          ], 2)
        ]),
        default: Q(() => [
          ve(c.$slots, "default")
        ]),
        _: 3
      }, 8, ["is-open", "padding-upset", "offset-y", "style"]),
      R("div", {
        ref_key: "hitAreaRef",
        ref: i,
        class: x(c.$style.hitArea),
        onClick: u[3] || (u[3] = (h) => s.value = !0)
      }, null, 2),
      R("div", {
        class: x(c.$style.value),
        onClick: u[4] || (u[4] = (h) => s.value = !0)
      }, [
        R("span", {
          ref_key: "summaryRef",
          ref: r,
          class: x(c.$style.summary),
          "test-id": `${e.testIdPrefix}-summary`
        }, se(e.summary), 11, Bue),
        T(a) ? (v(), z(zt, {
          key: 0,
          target: r.value,
          text: e.summary
        }, null, 8, ["target", "text"])) : V("", !0)
      ], 2),
      te(Fe, {
        class: x(c.$style.clear),
        style: Ke({ opacity: d.value ? 1 : 0, pointerEvents: d.value ? "auto" : "none" }),
        size: "12px",
        icon: "phosphor/x",
        "test-id": `${e.testIdPrefix}-clear`,
        onClick: u[5] || (u[5] = (h) => o("clear"))
      }, null, 8, ["class", "style", "test-id"])
    ], 64));
  }
}), Hue = "_trigger_rs8wy_1", Vue = "_triggerHighlighted_rs8wy_19", _ue = "_button_rs8wy_24", Nue = "_clear_rs8wy_36", $ue = "_hitArea_rs8wy_51", zue = "_value_rs8wy_56", Wue = "_summary_rs8wy_74", Uue = {
  trigger: Hue,
  triggerHighlighted: Vue,
  button: _ue,
  clear: Nue,
  hitArea: $ue,
  value: zue,
  summary: Wue
}, Kue = {
  $style: Uue
}, l2 = /* @__PURE__ */ we(Gue, [["__cssModules", Kue]]);
function Zue(e, t = "date") {
  return e === "number" ? bv(Number) : e === "date" ? bv((n) => {
    var o;
    return ((o = xg(n, t)) == null ? void 0 : o.getTime()) ?? NaN;
  }) : () => 0;
}
function bv(e) {
  return (t, n) => {
    const o = e(t) - e(n);
    return Number.isNaN(o) ? 0 : o;
  };
}
function cg(e, t) {
  return e.operator === De.IN_RANGE && e.term !== "" && e.termTo !== "" && t(e.term, e.termTo) > 0;
}
function que(e, t) {
  return { operator: e, term: "", termTo: "", join: t };
}
function Pr(e, t) {
  return fi(e.operator) ? !0 : e.operator === De.IN_RANGE ? e.term !== "" && e.termTo !== "" && !(t && cg(e, t)) : e.term !== "";
}
function d2(e, t) {
  return e.filter((n) => Pr(n, t)).map(
    (n, o) => o === 0 && n.join !== ot.AND ? { ...n, join: ot.AND } : n
  );
}
function ug(e, t) {
  const n = [];
  for (const l of t.filter((d) => Pr(d))) {
    const d = n.at(-1);
    d && l.join === ot.AND ? d.push(l) : n.push([l]);
  }
  if (n.length === 0) return null;
  const o = (l, d) => ({
    colKey: e,
    logicalOperator: l,
    conditions: d
  }), s = (l, d) => ({ colKey: e, filterTerm: d, operator: l }), i = (l) => l.operator === De.IN_RANGE ? o(ot.AND, [
    s(De.GREATER_OR_EQUALS, l.term),
    s(De.LESS_OR_EQUALS, l.termTo)
  ]) : s(l.operator, fi(l.operator) ? "" : l.term), r = (l) => l.length === 1 ? i(l[0]) : o(ot.AND, l.map(i));
  if (n.length > 1) return o(ot.OR, n.map(r));
  const a = r(n[0]);
  return to(a) ? a : o(ot.AND, [a]);
}
function c2(e, t) {
  return e ? u2(e, ot.AND, t) : [];
}
function u2(e, t, n) {
  if (!to(e)) return [jue(e, t, n)];
  const o = Que(e, t, n);
  if (o) return [o];
  const s = [];
  for (const i of e.conditions)
    s.push(...u2(i, s.length === 0 ? t : e.logicalOperator, n));
  return s;
}
function jue(e, t, n) {
  const o = e.operator ?? n.defaultOperator, s = fi(o) ? "" : Za(e, n);
  return { operator: o, term: s, termTo: "", join: t };
}
function Yue(e) {
  return e === "date" || e === "number";
}
function Que(e, t, n) {
  if (e.conditions.length !== 2) return null;
  const o = e.conditions.filter((i) => !to(i)), s = (i) => o.find((r) => r.operator === i);
  return e.logicalOperator === ot.AND ? Yue(n.kind) ? Jue(s, t, n) : null : n.kind === "date" ? Xue(s, t, n) : null;
}
function Jue(e, t, n) {
  const o = e(De.GREATER_OR_EQUALS), s = e(De.LESS_OR_EQUALS);
  if (!o || !s) return null;
  const i = Za(o, n), r = Za(s, n);
  return n.kind === "date" && i && i === r ? { operator: De.EQUALS, term: i, termTo: "", join: t } : { operator: De.IN_RANGE, term: i, termTo: r, join: t };
}
function Xue(e, t, n) {
  const o = e(De.LESS_THAN), s = e(De.GREATER_THAN);
  if (!o || !s) return null;
  const i = Za(s, n);
  return i && i === Za(o, n) ? { operator: De.NOT_EQUALS, term: i, termTo: "", join: t } : null;
}
function Za(e, t) {
  const n = e.filterTerm ?? "";
  return t.normalizeTerm ? t.normalizeTerm(n) : n;
}
function h2(e, {
  formatTerm: t = (s) => s,
  operatorLabel: n = mg,
  joinLabel: o = ld
} = {}) {
  const s = e.filter((r) => Pr(r)), i = (r) => fi(r.operator) ? n(r.operator) : r.operator === De.IN_RANGE ? `${t(r.term, { shortYear: !0 })} – ${t(r.termTo, { shortYear: !0 })}` : t(r.term);
  return s.map((r, a) => a === 0 ? i(r) : `${o(r.join)} ${i(r)}`).join(" ");
}
const ehe = ["underline-override"], the = /* @__PURE__ */ de({
  __name: "SCAInputBase",
  props: {
    alert: { type: Boolean, default: !1 },
    appearance: { default: void 0 },
    fixedWidth: { type: Boolean, default: !1 },
    underlineOverride: { type: Boolean, default: void 0 },
    fixedHeight: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    inverted: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = rn();
    return (n, o) => (v(), y("div", {
      class: x([
        n.$style.root,
        {
          [n.$style.fixedWidth]: e.fixedWidth
        }
      ])
    }, [
      R("div", {
        class: x([
          n.$style.inputBase,
          {
            [n.$style.alert]: e.alert,
            [n.$style.focused]: e.focused,
            [n.$style.fixedWidth]: e.fixedWidth,
            [n.$style.fixedHeight]: e.fixedHeight,
            [n.$style.hasBefore]: T(t).before,
            [n.$style.hasAfter]: T(t).after,
            [n.$style.appearanceBorder]: e.appearance === "border",
            [n.$style.appearanceTypoHeaderXlarge]: e.appearance === "typo-header-xlarge",
            [n.$style.appearanceNoBorder]: e.appearance === "no-border",
            [n.$style.appearanceBottomBorder]: e.appearance === "bottom-border",
            [n.$style.inverted]: e.inverted
          }
        ])
      }, [
        ve(n.$slots, "before"),
        R("div", {
          ref: "inputContainer",
          class: x(n.$style.inputContainer),
          "underline-override": e.underlineOverride
        }, [
          ve(n.$slots, "default")
        ], 10, ehe),
        ve(n.$slots, "after")
      ], 2),
      T(t).footer ? (v(), y("div", {
        key: 0,
        class: x(n.$style.footer)
      }, [
        ve(n.$slots, "footer")
      ], 2)) : V("", !0)
    ], 2));
  }
}), nhe = "_root_1qu0z_752", ohe = "_fixedWidth_1qu0z_757", she = "_inputBase_1qu0z_762", ihe = "_hasBefore_1qu0z_781", rhe = "_hasAfter_1qu0z_784", ahe = "_inputContainer_1qu0z_787", lhe = "_appearanceBorder_1qu0z_901", dhe = "_alert_1qu0z_904", che = "_focused_1qu0z_904", uhe = "_inverted_1qu0z_945", hhe = "_appearanceTypoHeaderXlarge_1qu0z_972", ghe = "_appearanceBottomBorder_1qu0z_1009", phe = "_appearanceNoBorder_1qu0z_1037", fhe = "_fixedHeight_1qu0z_1041", mhe = "_footer_1qu0z_1045", vhe = {
  root: nhe,
  fixedWidth: ohe,
  inputBase: she,
  hasBefore: ihe,
  hasAfter: rhe,
  inputContainer: ahe,
  appearanceBorder: lhe,
  alert: dhe,
  focused: che,
  inverted: uhe,
  appearanceTypoHeaderXlarge: hhe,
  appearanceBottomBorder: ghe,
  appearanceNoBorder: phe,
  fixedHeight: fhe,
  footer: mhe
}, Che = {
  $style: vhe
}, Fi = /* @__PURE__ */ we(the, [["__cssModules", Che]]), whe = {
  maxMonths: 12,
  showWeekNumbers: !0,
  weekStartsOn: 1,
  min: null,
  max: null,
  disabledDate: void 0,
  minuteStep: 15
}, yhe = ["dateRange", "datetimeRange", "timeRange"], bhe = ["time", "datetime", "datetimeRange", "timeRange"], She = ["date", "datetime", "dateRange", "datetimeRange"];
function g2(e) {
  return yhe.includes(e);
}
function Js(e) {
  return bhe.includes(e);
}
function Sv(e) {
  return She.includes(e);
}
const xv = Symbol("SCAInputAccessory");
function _Me(e, t, n, o) {
  return {
    columnClass: e,
    render: t,
    nested: o,
    claim() {
      return n.value ? !1 : (n.value = !0, !0);
    },
    release() {
      n.value = !1;
    }
  };
}
function NMe(e, t) {
  return {
    columnClass: e,
    render: t,
    claim: () => !0,
    // Nothing to release: no claim is exclusive.
    release: () => {
    }
  };
}
const xhe = ["for"], Rhe = /* @__PURE__ */ de({
  __name: "SCALabel",
  props: {
    appearance: { default: void 0 },
    optional: { type: Boolean, default: !1 },
    optionalText: { default: void 0 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    highlited: { type: Boolean, default: !1 },
    tooltipType: { default: "default" },
    tooltipId: { default: void 0 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 }
  },
  setup(e) {
    const t = e, n = D(() => {
      var u;
      return !!((u = t.tooltip) != null && u.trim());
    }), o = W(null), s = W("");
    function i() {
      var u;
      s.value = ((u = o.value) == null ? void 0 : u.textContent) ?? "";
    }
    Et(i), j2(i);
    const r = al(o, s), a = rn(), l = `lbl-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 8)}`, d = D(() => {
      const u = a.labelIcon;
      return u ? u({}).some((g) => !(!g || Array.isArray(g.children) && g.children.length === 0)) : !1;
    }), c = D(() => {
      var h;
      const u = (h = a.labelActionLabel) == null ? void 0 : h.call(a, {});
      return u ? u.filter((g) => g.type !== Comment).length : 0;
    });
    return (u, h) => {
      const g = gg("tooltip");
      return v(), y("div", {
        class: x(u.$style.root)
      }, [
        R("label", {
          class: x([
            u.$style.label,
            {
              [u.$style.appearanceTop]: e.appearance === "top",
              [u.$style.highlighted]: e.highlited
            }
          ]),
          for: e.htmlFor
        }, [
          R("div", {
            class: x(u.$style.labelContent)
          }, [
            Tn((v(), y("span", {
              id: l,
              ref_key: "textRef",
              ref: o,
              class: x([u.$style.labelText, { [u.$style.required]: e.required }])
            }, [
              ve(u.$slots, "default")
            ], 2)), [
              [g, e.tooltipId]
            ]),
            t.optionalText || t.optional ? (v(), y("span", {
              key: 0,
              class: x(u.$style.optional)
            }, se(e.optionalText ?? u.$t("common.label.optional")), 3)) : V("", !0),
            d.value ? (v(), y("div", {
              key: 1,
              class: x(u.$style.labelIcon)
            }, [
              ve(u.$slots, "labelIcon")
            ], 2)) : V("", !0)
          ], 2),
          e.tooltipType === "default" && (n.value || T(r)) ? (v(), z(zt, {
            key: 0,
            id: l,
            text: n.value ? e.tooltip ?? "" : s.value,
            "help-link": n.value ? e.helpLink : void 0
          }, null, 8, ["text", "help-link"])) : V("", !0)
        ], 10, xhe),
        u.$slots.labelActionLabel ? (v(), y("div", {
          key: 0,
          class: x([u.$style.labelActionContainer, c.value < 2 ? u.$style.noGap : ""])
        }, [
          ve(u.$slots, "labelActionLabel")
        ], 2)) : V("", !0)
      ], 2);
    };
  }
}), Ehe = "_root_vz4ql_1", Ahe = "_labelActionContainer_vz4ql_7", Fhe = "_noGap_vz4ql_13", Mhe = "_label_vz4ql_7", Ihe = "_labelContent_vz4ql_33", Phe = "_labelText_vz4ql_39", Dhe = "_optional_vz4ql_47", The = "_labelIcon_vz4ql_52", khe = "_highlighted_vz4ql_57", Lhe = "_appearanceTop_vz4ql_70", Bhe = {
  root: Ehe,
  labelActionContainer: Ahe,
  noGap: Fhe,
  label: Mhe,
  labelContent: Ihe,
  labelText: Phe,
  optional: Dhe,
  labelIcon: The,
  highlighted: khe,
  appearanceTop: Lhe
}, Ohe = {
  $style: Bhe
}, Ghe = /* @__PURE__ */ we(Rhe, [["__cssModules", Ohe]]), Hhe = ["data-has-error", "data-label-position"], Vhe = /* @__PURE__ */ de({
  __name: "SCAInputWrapper",
  props: {
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    optionalLabelText: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    highlightLabel: { type: Boolean, default: !1 },
    tooltipType: { default: "default" },
    tooltipId: { default: void 0 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 }
  },
  emits: ["labelClick"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Mi(xv, null), i = !!(s != null && s.claim());
    pg(xv, (s == null ? void 0 : s.nested) ?? null), io(() => {
      i && (s == null || s.release());
    });
    const r = D(
      () => n.labelPosition !== "hidden" && (n.label !== void 0 || n.optionalLabelText !== void 0)
    );
    return (a, l) => {
      var d;
      return v(), y("div", {
        class: x([
          a.$style.root,
          {
            [a.$style.hasLabel]: r.value,
            [a.$style.hasHelperText]: e.helperText,
            [a.$style.labelPositionTop]: e.labelPosition === "top",
            [a.$style.appearanceTypoHeaderXlarge]: e.appearance === "typo-header-xlarge"
          }
        ]),
        "data-has-error": e.validationError || void 0,
        "data-label-position": r.value ? e.labelPosition === "top" ? "top" : "side" : "none"
      }, [
        r.value ? (v(), z(Ghe, {
          key: 0,
          class: x([a.$style.label, { [a.$style.highlightLabel]: e.highlightLabel }]),
          "optional-text": e.optionalLabelText,
          required: e.required,
          appearance: e.labelPosition === "top" ? "top" : e.appearance === "typo-header-xlarge" ? "typo-header-xlarge" : void 0,
          "html-for": e.htmlFor,
          highlited: e.highlightLabel,
          "tooltip-type": e.tooltipType,
          "tooltip-id": e.tooltipId,
          tooltip: e.tooltip,
          "help-link": e.helpLink,
          onClick: l[0] || (l[0] = (c) => o("labelClick", c))
        }, {
          labelActionLabel: Q(() => [
            ve(a.$slots, "labelActionWrapper")
          ]),
          labelIcon: Q(() => [
            ve(a.$slots, "labelIcon")
          ]),
          default: Q(() => [
            Oe(se(e.label) + " ", 1)
          ]),
          _: 3
        }, 8, ["class", "optional-text", "required", "appearance", "html-for", "highlited", "tooltip-type", "tooltip-id", "tooltip", "help-link"])) : V("", !0),
        R("div", {
          class: x(i ? [a.$style.accessoryColumn, (d = T(s)) == null ? void 0 : d.columnClass()] : void 0)
        }, [
          ve(a.$slots, "default"),
          i && T(s) ? (v(), z(Ot(T(s).render), { key: 0 })) : V("", !0),
          e.helperText ? (v(), z(Gr, {
            key: 1,
            intent: e.validationError ? "alert" : void 0,
            "show-icon": !1,
            class: x(a.$style.helperText)
          }, {
            default: Q(() => [
              Oe(se(e.helperText), 1)
            ]),
            _: 1
          }, 8, ["intent", "class"])) : V("", !0)
        ], 2)
      ], 10, Hhe);
    };
  }
}), _he = "_root_7wa54_1", Nhe = "_hasLabel_7wa54_9", $he = "_label_7wa54_13", zhe = "_input_7wa54_17", Whe = "_helperText_7wa54_21", Uhe = "_hasHelperText_7wa54_25", Khe = "_labelPositionTop_7wa54_28", Zhe = "_accessoryColumn_7wa54_64", qhe = "_appearanceTypoHeaderXlarge_7wa54_68", jhe = {
  root: _he,
  hasLabel: Nhe,
  label: $he,
  input: zhe,
  helperText: Whe,
  hasHelperText: Uhe,
  labelPositionTop: Khe,
  accessoryColumn: Zhe,
  appearanceTypoHeaderXlarge: qhe
}, Yhe = {
  $style: jhe
}, zc = /* @__PURE__ */ we(Vhe, [["__cssModules", Yhe]]), Qhe = /* @__PURE__ */ de({
  __name: "SCAInput",
  props: {
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    optionalLabelText: { default: void 0 },
    htmlFor: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    prefix: { default: void 0 },
    highlightLabel: { type: Boolean, default: !1 },
    tooltipType: { default: "default" },
    tooltipId: { default: void 0 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 },
    focused: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = rn();
    return (n, o) => (v(), z(zc, {
      label: e.label,
      "label-position": e.labelPosition,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "optional-label-text": e.optionalLabelText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor,
      "highlight-label": e.highlightLabel,
      "tooltip-type": e.tooltipType,
      "tooltip-id": e.tooltipId,
      tooltip: e.tooltip,
      "help-link": e.helpLink
    }, {
      labelActionWrapper: Q(() => [
        ve(n.$slots, "labelAction")
      ]),
      labelIcon: Q(() => [
        ve(n.$slots, "labelIcon")
      ]),
      default: Q(() => [
        R("div", {
          class: x([n.$style.inputWrapper, { [n.$style.hasPrefixIcon]: T(t).prefixIcon }])
        }, [
          te(Fi, {
            alert: e.validationError,
            appearance: e.appearance,
            focused: e.focused
          }, Wn({
            default: Q(() => [
              ve(n.$slots, "default")
            ]),
            _: 2
          }, [
            e.prefix !== void 0 ? {
              name: "before",
              fn: Q(() => [
                R("div", {
                  class: x(n.$style.prefix)
                }, se(e.prefix), 3)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["alert", "appearance", "focused"]),
          T(t).prefixIcon ? (v(), y("div", {
            key: 0,
            class: x(n.$style.prefixIcon)
          }, [
            ve(n.$slots, "prefixIcon")
          ], 2)) : V("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "validation-error", "required", "html-for", "highlight-label", "tooltip-type", "tooltip-id", "tooltip", "help-link"]));
  }
}), Jhe = "_inputWrapper_1iaqg_1", Xhe = "_prefix_1iaqg_7", ege = "_prefixIcon_1iaqg_16", tge = "_hasPrefixIcon_1iaqg_27", nge = {
  inputWrapper: Jhe,
  prefix: Xhe,
  prefixIcon: ege,
  hasPrefixIcon: tge
}, oge = {
  $style: nge
}, vf = /* @__PURE__ */ we(Qhe, [["__cssModules", oge]]), sge = { key: 0 }, ige = { key: 2 }, rge = /* @__PURE__ */ de({
  __name: "SCANoItems",
  props: {
    title: { default: "No items" },
    icon: { default: "phosphor/list-bullets" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x(t.$style.noItems)
    }, [
      e.title || e.icon ? (v(), y("h2", sge, [
        e.loading ? (v(), z(rl, {
          key: 0,
          size: "small"
        })) : V("", !0),
        !e.loading && e.icon ? (v(), z(Fe, {
          key: 1,
          icon: e.icon,
          size: "16px"
        }, null, 8, ["icon"])) : V("", !0),
        e.title ? (v(), y("span", ige, se(e.title), 1)) : V("", !0)
      ])) : V("", !0),
      ve(t.$slots, "default")
    ], 2));
  }
}), age = "_noItems_kov9c_1", lge = {
  noItems: age
}, dge = {
  $style: lge
}, ll = /* @__PURE__ */ we(rge, [["__cssModules", dge]]);
function Cf(e) {
  const t = W(-1);
  function n(m) {
    return t.value === m;
  }
  function o() {
    var w, b;
    const m = e.items.value.length;
    if (m === 0) return -1;
    if ((w = e.searchTerm) != null && w.value) return 0;
    const C = ((b = e.initialIndex) == null ? void 0 : b.call(e)) ?? 0;
    return C >= 0 && C < m ? C : 0;
  }
  function s(m = !1) {
    Xe(() => {
      const C = e.listEl.value, w = t.value;
      if (!C || w < 0) return;
      const b = C.children[w];
      if (!b) return;
      if (m) {
        C.scrollTop = b.offsetTop - C.clientHeight / 2 + b.offsetHeight / 2;
        return;
      }
      const A = C.scrollTop, S = A + C.clientHeight, F = b.offsetTop, E = F + b.offsetHeight;
      F < A ? C.scrollTop = F : E > S && (C.scrollTop = E - C.clientHeight);
    });
  }
  function i(m) {
    const C = e.items.value.length;
    if (C === 0) return;
    const w = t.value < 0 ? 0 : (t.value + m + C) % C;
    t.value = w, s();
  }
  let r = !1, a = !1, l = !1;
  function d() {
    r = !0;
  }
  function c() {
    a || r || l || e.open();
  }
  An(document, ["pointerup", "pointercancel"], () => {
    r = !1;
  });
  function u() {
    var C;
    const m = (C = e.focusAnchor) == null ? void 0 : C.call(e);
    if (!(!m || document.activeElement === m)) {
      a = !0;
      try {
        m.focus();
      } finally {
        a = !1;
      }
    }
  }
  function h() {
    const m = document.activeElement;
    return !(m instanceof HTMLElement) || m === document.body || !m.isConnected ? !1 : typeof m.checkVisibility == "function" ? m.checkVisibility() : m.offsetParent !== null;
  }
  function g(m) {
    e.commit(m), Xe(() => {
      h() || u();
    });
  }
  function p() {
    var m, C;
    (m = e.hideList) == null || m.call(e), e.isOpen.value = !1, (C = e.onClose) == null || C.call(e), u();
  }
  function f(m) {
    if (!e.isInert())
      switch (m.key) {
        case "ArrowDown":
          if (m.preventDefault(), !e.isOpen.value) {
            e.open();
            return;
          }
          i(1);
          break;
        case "ArrowUp":
          if (!e.isOpen.value) return;
          m.preventDefault(), i(-1);
          break;
        case "Enter": {
          if (!e.isOpen.value) {
            m.preventDefault(), e.open();
            return;
          }
          const C = e.items.value[t.value];
          if (C === void 0) return;
          m.preventDefault(), g(C);
          break;
        }
        case "Escape":
          if (!e.isOpen.value) return;
          m.preventDefault(), p();
          break;
        // Deliberately *not* prevented: the press closes the list and then travels on, so a single Tab
        // both dismisses the options and moves to the next field. That is only safe because `hideList`
        // has already taken the popover out of the tab order.
        case "Tab":
          if (!e.isOpen.value) return;
          p();
          break;
      }
  }
  return Re(e.isOpen, (m) => {
    if (!m) {
      t.value = -1, l = !0, Xe(() => {
        l = !1;
      });
      return;
    }
    t.value = o(), s(!0);
  }), e.searchTerm && Re(e.searchTerm, () => {
    e.isOpen.value && (t.value = o());
  }), Re(
    () => e.items.value.length,
    (m) => {
      if (e.isOpen.value) {
        if (m === 0) {
          t.value = -1;
          return;
        }
        if (t.value < 0) {
          t.value = o(), s(!0);
          return;
        }
        t.value > m - 1 && (t.value = m - 1);
      }
    }
  ), {
    highlightedIndex: t,
    isHighlighted: n,
    handleKeyDown: f,
    handleFocus: c,
    handlePointerDown: d,
    /**
     * Moves focus to the field's own tab stop without the list treating it as "the user asked for me".
     *
     * For a component that is about to remove the element holding focus — a single-select tag input
     * hiding its inline input the moment the field is full — calling this first is what keeps the caret
     * (and therefore the field's focused underline) on the field instead of dropping it to `<body>`.
     */
    focusField: u
  };
}
function cge(e) {
  return !!e && typeof e.hideNow == "function";
}
function wf() {
  const e = Qe(null);
  return {
    setDropdown(t) {
      e.value = cge(t) ? t : null;
    },
    hideList() {
      var t;
      (t = e.value) == null || t.hideNow();
    }
  };
}
const uge = ["id", "value", "placeholder", "disabled", "readonly"], hge = /* @__PURE__ */ de({
  __name: "SCASelectBase",
  props: {
    modelValue: { default: void 0 },
    items: {},
    search: { default: void 0 },
    searchTerm: { default: "" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    icon: { default: void 0 },
    htmlFor: { default: void 0 },
    alert: { type: Boolean, default: !1 },
    hidePopoverOnValueChange: { type: Boolean, default: !0 },
    appearance: { default: void 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    disableHoverColorTag: { type: Boolean, default: !1 },
    useSmallerVerticalPadding: { type: Boolean, default: !1 },
    itemIconSize: { default: void 0 },
    noMobileMargin: { type: Boolean, default: !1 },
    truncateClosedTag: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:searchTerm", "opened", "closed", "loadMore"],
  setup(e, { emit: t }) {
    Ls((L) => ({
      bea8c366: w.value,
      v898932b6: b.value,
      v981b97aa: A.value,
      v1733fd03: S.value
    }));
    const n = e, o = t, s = W(!1), i = W(n.searchTerm || ""), r = rn(), a = D(() => !!r.tag), l = tn("itemsWrapper"), { setDropdown: d, hideList: c } = wf(), u = D(() => n.items.find((L) => L.id === n.modelValue)), h = D(() => E.value.findIndex((L) => L.id === n.modelValue)), g = D(() => {
      var L;
      return !!((L = u.value) != null && L.color) && !s.value;
    }), p = W(!1);
    function f() {
      p.value = !0, B();
    }
    const m = D(
      () => {
        var L;
        return a.value && !!((L = u.value) != null && L.label) && !s.value && !p.value;
      }
    ), C = D(() => {
      var L;
      return g.value ? "" : s.value && n.search ? i.value : ((L = u.value) == null ? void 0 : L.label) ?? "";
    }), w = D(
      () => {
        var L, oe;
        return ((oe = (L = u.value) == null ? void 0 : L.color) == null ? void 0 : oe.bgColor) ?? "var(--color-interaction-neutral-subtle-normal)";
      }
    ), b = D(() => {
      var L, oe;
      return ((oe = (L = u.value) == null ? void 0 : L.color) == null ? void 0 : oe.textColor) ?? "var(--color-content-primary)";
    }), A = D(() => {
      var L, oe;
      return (oe = (L = u.value) == null ? void 0 : L.color) == null ? void 0 : oe.hoverBgColor;
    }), S = D(() => {
      var L, oe;
      return (oe = (L = u.value) == null ? void 0 : L.color) == null ? void 0 : oe.hoverTextColor;
    }), F = D(() => {
      var L, oe;
      return ((oe = (L = u.value) == null ? void 0 : L.color) == null ? void 0 : oe.bgColor) === "transparent";
    }), E = D(() => {
      const L = n.items.filter((oe) => !oe.hidden);
      return !n.search || n.search === "custom" ? L : L.filter((oe) => oe.label.toLocaleLowerCase().includes(i.value.toLocaleLowerCase()));
    });
    Re(
      () => n.searchTerm,
      (L) => {
        L !== i.value && (i.value = L || "");
      }
    ), Re(i, (L) => {
      o("update:searchTerm", L);
    }), Re(
      () => n.modelValue,
      () => {
        n.hidePopoverOnValueChange && (s.value = !1, i.value = "");
      }
    );
    function M(L) {
      i.value = L.target.value, !s.value && !n.disabled && (s.value = !0);
    }
    function I(L) {
      var oe;
      n.disabled || (oe = n.items.find((K) => K.id === L)) != null && oe.disabled || (o("update:modelValue", L), i.value = "", s.value = !1);
    }
    const { isHighlighted: P, handleKeyDown: k, handleFocus: B, handlePointerDown: j } = Cf({
      isOpen: s,
      items: E,
      listEl: l,
      searchTerm: i,
      open: N,
      commit: (L) => I(L.id),
      isInert: () => n.disabled,
      initialIndex: () => h.value,
      hideList: c
    });
    function N() {
      n.disabled || (E.value.length > 0 || i.value) && (s.value = !0);
    }
    const re = tn("inputSlot");
    function H(L) {
      var oe;
      return L instanceof Node && !!((oe = re.value) != null && oe.contains(L));
    }
    function _(L) {
      H(L.relatedTarget) || f();
    }
    function ne(L) {
      H(L.relatedTarget) || (p.value = !1, c(), s.value = !1);
    }
    function ce(L) {
      s.value && (L.preventDefault(), c(), s.value = !1);
    }
    function me() {
      var oe;
      N();
      const L = re.value;
      !L || n.disabled || L.contains(document.activeElement) || (oe = L.querySelector('input:not([tabindex="-1"])')) == null || oe.focus();
    }
    function Ie() {
      const L = l.value;
      !L || !n.hasMore || n.loadingMore || L.scrollHeight - L.scrollTop - L.clientHeight < 50 && o("loadMore");
    }
    return (L, oe) => (v(), z(Yt, {
      ref: T(d),
      "is-open": s.value,
      "onUpdate:isOpen": oe[3] || (oe[3] = (K) => s.value = K),
      "match-trigger-width": "min",
      "no-mobile-margin": e.noMobileMargin,
      class: x([L.$style.dropdown, { [L.$style.hovered]: a.value }]),
      onOpened: oe[4] || (oe[4] = (K) => L.$emit("opened")),
      onClosed: oe[5] || (oe[5] = (K) => L.$emit("closed"))
    }, {
      trigger: Q(() => [
        te(Fi, {
          appearance: m.value ? "no-border" : e.appearance,
          placeholder: e.placeholder,
          disabled: e.disabled,
          "underline-override": !0,
          class: x({ [L.$style.inert]: e.disabled && !!L.$slots.input }),
          onClick: me,
          onPointerdown: T(j)
        }, {
          default: Q(() => {
            var K;
            return [
              L.$slots.triggerContent ? ve(L.$slots, "triggerContent", { key: 0 }) : (v(), y(Se, { key: 1 }, [
                e.icon ? (v(), z(Fe, {
                  key: 0,
                  icon: e.icon,
                  size: "16px"
                }, null, 8, ["icon"])) : V("", !0),
                (K = u.value) != null && K.avatarInitials ? (v(), z(Li, {
                  key: 1,
                  size: "x3small",
                  initials: u.value.avatarInitials[0],
                  class: "me-component-gap-xSmall"
                }, null, 8, ["initials"])) : V("", !0),
                g.value && a.value ? (v(), z(no, {
                  key: 2,
                  tabindex: "-1",
                  class: x([
                    L.$style.tag,
                    L.$style.active,
                    {
                      [L.$style.noHover]: e.disableHoverColorTag,
                      [L.$style.unsetPadding]: e.disableHoverColorTag && F.value,
                      [L.$style.truncate]: e.truncateClosedTag
                    }
                  ]),
                  "truncate-tooltip": e.truncateClosedTag
                }, {
                  default: Q(() => {
                    var G;
                    return [
                      Oe(se((G = u.value) == null ? void 0 : G.label), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["class", "truncate-tooltip"])) : V("", !0),
                L.$slots.input ? (v(), y("div", {
                  key: 3,
                  ref: "inputSlot",
                  class: x(L.$style.inputSlot),
                  onFocusin: _,
                  onFocusout: ne,
                  onKeydown: Uo(ce, ["enter"])
                }, [
                  e.disabled ? (v(), y("input", {
                    key: 0,
                    disabled: "",
                    tabindex: "-1",
                    "aria-hidden": "true",
                    class: x(L.$style.styleProbe)
                  }, null, 2)) : V("", !0),
                  ve(L.$slots, "input")
                ], 34)) : (v(), y("input", {
                  key: 4,
                  id: e.htmlFor,
                  value: C.value,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: !e.search,
                  onInput: M,
                  onKeydown: oe[0] || (oe[0] = //@ts-ignore
                  (...G) => T(k) && T(k)(...G)),
                  onFocus: f,
                  onBlur: oe[1] || (oe[1] = (G) => p.value = !1)
                }, null, 40, uge)),
                e.disabled ? V("", !0) : (v(), z(Fe, {
                  key: 5,
                  icon: "phosphor/caret-down",
                  class: x([L.$style.iconColor, L.$style.arrow, { [L.$style.arrowOpen]: s.value }]),
                  size: "12px"
                }, null, 8, ["class"])),
                ve(L.$slots, "after")
              ], 64))
            ];
          }),
          _: 3
        }, 8, ["appearance", "placeholder", "disabled", "class", "onPointerdown"])
      ]),
      default: Q(() => [
        R("div", {
          ref: "itemsWrapper",
          class: x(L.$style.itemsWrapper),
          onScroll: Ie
        }, [
          (v(!0), y(Se, null, We(E.value, (K, G) => (v(), z(lg, {
            key: K.id,
            label: K.label,
            class: x([
              L.$style.items,
              { [L.$style.selectedItem]: K.id === e.modelValue },
              { [L.$style.highlighted]: T(P)(G) },
              { [L.$style.unset]: a.value }
            ]),
            icon: K.icon,
            "icon-size": e.itemIconSize,
            "avatar-initials": K.avatarInitials,
            disabled: K.disabled,
            "unset-all": a.value,
            "use-smaller-vertical-padding": e.useSmallerVerticalPadding,
            type: "action",
            onMousedown: oe[2] || (oe[2] = Ge(() => {
            }, ["prevent"])),
            onClick: (le) => I(K.id)
          }, Wn({ _: 2 }, [
            L.$slots.avatar ? {
              name: "avatar",
              fn: Q(() => [
                ve(L.$slots, "avatar", { item: K })
              ]),
              key: "0"
            } : void 0,
            L.$slots.tag ? {
              name: "tag",
              fn: Q(() => [
                ve(L.$slots, "tag", { item: K })
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["label", "class", "icon", "icon-size", "avatar-initials", "disabled", "unset-all", "use-smaller-vertical-padding", "onClick"]))), 128)),
          E.value.length === 0 ? (v(), z(ll, { key: 0 })) : V("", !0)
        ], 34)
      ]),
      _: 3
    }, 8, ["is-open", "no-mobile-margin", "class"]));
  }
}), gge = "_dropdown_5347f_747", pge = "_arrow_5347f_750", fge = "_hovered_5347f_754", mge = "_itemsWrapper_5347f_759", vge = "_items_5347f_759", Cge = "_highlighted_5347f_773", wge = "_selectedItem_5347f_776", yge = "_unset_5347f_780", bge = "_alert_5347f_784", Sge = "_inputSlot_5347f_789", xge = "_styleProbe_5347f_797", Rge = "_inert_5347f_810", Ege = "_iconColor_5347f_814", Age = "_arrowOpen_5347f_825", Fge = "_tag_5347f_832", Mge = "_unsetPadding_5347f_840", Ige = "_active_5347f_849", Pge = "_noHover_5347f_855", Dge = "_truncate_5347f_860", Tge = {
  dropdown: gge,
  arrow: pge,
  hovered: fge,
  itemsWrapper: mge,
  items: vge,
  highlighted: Cge,
  selectedItem: wge,
  unset: yge,
  alert: bge,
  inputSlot: Sge,
  styleProbe: xge,
  inert: Rge,
  iconColor: Ege,
  arrowOpen: Age,
  tag: Fge,
  unsetPadding: Mge,
  active: Ige,
  noHover: Pge,
  truncate: Dge
}, kge = {
  $style: Tge
}, p2 = /* @__PURE__ */ we(hge, [["__cssModules", kge]]), Lge = /* @__PURE__ */ de({
  __name: "SCASelect",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    optionalLabelText: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    items: {},
    search: { default: void 0 },
    searchTerm: { default: "" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    icon: { default: void 0 },
    htmlFor: { default: void 0 },
    alert: { type: Boolean, default: !1 },
    hidePopoverOnValueChange: { type: Boolean, default: !0 },
    required: { type: Boolean, default: !1 },
    labelPosition: { default: void 0 },
    appearance: { default: void 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 },
    disableHoverColorTag: { type: Boolean, default: !1 },
    useSmallerVerticalPadding: { type: Boolean, default: !1 },
    itemIconSize: { default: void 0 },
    noMobileMargin: { type: Boolean, default: !1 },
    truncateClosedTag: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:searchTerm", "opened", "closed", "loadMore"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Bn(n, "modelValue", o, { passive: !0 }), i = Bn(n, "searchTerm", o, { passive: !0 }), r = D(() => n.items.find((a) => a.id === s.value));
    return (a, l) => (v(), z(zc, {
      label: e.label,
      "label-position": e.labelPosition,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "optional-label-text": e.optionalLabelText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor,
      tooltip: e.tooltip,
      "help-link": e.helpLink
    }, {
      default: Q(() => [
        te(p2, {
          modelValue: T(s),
          "onUpdate:modelValue": l[0] || (l[0] = (d) => Yo(s) ? s.value = d : null),
          "search-term": T(i),
          "onUpdate:searchTerm": l[1] || (l[1] = (d) => Yo(i) ? i.value = d : null),
          items: e.items,
          search: e.search,
          disabled: e.disabled,
          placeholder: e.placeholder,
          icon: e.icon,
          alert: e.alert,
          appearance: e.appearance,
          "hide-popover-on-value-change": e.hidePopoverOnValueChange,
          "has-more": e.hasMore,
          "loading-more": e.loadingMore,
          "html-for": e.htmlFor,
          "disable-hover-color-tag": e.disableHoverColorTag,
          "use-smaller-vertical-padding": e.useSmallerVerticalPadding,
          "item-icon-size": e.itemIconSize,
          "no-mobile-margin": e.noMobileMargin,
          "truncate-closed-tag": e.truncateClosedTag,
          onOpened: l[2] || (l[2] = (d) => o("opened")),
          onClosed: l[3] || (l[3] = (d) => o("closed")),
          onLoadMore: l[4] || (l[4] = (d) => o("loadMore"))
        }, Wn({ _: 2 }, [
          a.$slots.triggerContent ? {
            name: "triggerContent",
            fn: Q(() => [
              ve(a.$slots, "triggerContent", { item: r.value })
            ]),
            key: "0"
          } : void 0,
          a.$slots.input ? {
            name: "input",
            fn: Q(() => [
              ve(a.$slots, "input")
            ]),
            key: "1"
          } : void 0,
          a.$slots.after ? {
            name: "after",
            fn: Q(() => [
              ve(a.$slots, "after")
            ]),
            key: "2"
          } : void 0,
          a.$slots.tag ? {
            name: "tag",
            fn: Q(({ item: d }) => [
              ve(a.$slots, "tag", { item: d })
            ]),
            key: "3"
          } : void 0
        ]), 1032, ["modelValue", "search-term", "items", "search", "disabled", "placeholder", "icon", "alert", "appearance", "hide-popover-on-value-change", "has-more", "loading-more", "html-for", "disable-hover-color-tag", "use-smaller-vertical-padding", "item-icon-size", "no-mobile-margin", "truncate-closed-tag"])
      ]),
      _: 3
    }, 8, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "validation-error", "required", "html-for", "tooltip", "help-link"]));
  }
}), Bge = "_root_eqy14_747", Oge = "_validationError_eqy14_754", Gge = "_label_eqy14_758", Hge = {
  root: Bge,
  validationError: Oge,
  label: Gge
}, Vge = {
  $style: Hge
}, Wc = /* @__PURE__ */ we(Lge, [["__cssModules", Vge]]), _ge = ["disabled", "aria-pressed", "aria-current", "tabindex", "test-id"], Nge = /* @__PURE__ */ de({
  __name: "CalendarDayCell",
  props: {
    cell: {},
    state: {},
    isRowStart: { type: Boolean, default: !1 },
    isRowEnd: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    testId: { default: void 0 }
  },
  emits: ["select", "hover"],
  setup(e) {
    const t = e, n = D(() => t.state.selected || t.state.rangeStart || t.state.rangeEnd), o = W(null);
    return Re(
      () => t.state.flash,
      (s) => {
        const i = o.value;
        !s || !i || (i.style.animation = "none", i.offsetWidth, i.style.animation = "");
      },
      { flush: "post" }
    ), (s, i) => (v(), y("button", {
      type: "button",
      class: x([
        s.$style.cell,
        {
          [s.$style.otherMonth]: !e.cell.inCurrentMonth,
          [s.$style.disabled]: e.cell.disabled,
          [s.$style.readonly]: e.readonly,
          [s.$style.weekend]: e.cell.isWeekend && e.cell.inCurrentMonth && !n.value
        }
      ]),
      disabled: e.cell.disabled,
      "aria-pressed": e.state.selected || e.state.rangeStart || e.state.rangeEnd,
      "aria-current": e.cell.isToday ? "date" : void 0,
      tabindex: e.cell.inCurrentMonth && !e.cell.disabled ? 0 : -1,
      "test-id": e.testId,
      onClick: i[0] || (i[0] = (r) => s.$emit("select", e.cell.date)),
      onMouseenter: i[1] || (i[1] = (r) => s.$emit("hover", e.cell.date)),
      onFocus: i[2] || (i[2] = (r) => s.$emit("hover", e.cell.date))
    }, [
      R("span", {
        ref_key: "circleRef",
        ref: o,
        class: x([
          s.$style.circle,
          {
            [s.$style.selected]: e.state.selected || e.state.rangeStart || e.state.rangeEnd,
            [s.$style.today]: e.cell.isToday && !n.value,
            [s.$style.flash]: e.state.flash,
            [s.$style.previewEndpoint]: (e.state.previewStart || e.state.previewEnd) && !n.value
          }
        ])
      }, se(e.cell.day), 3)
    ], 42, _ge));
  }
}), $ge = "_cell_17vvj_747", zge = "_circle_17vvj_762", Wge = "_disabled_17vvj_782", Uge = "_readonly_17vvj_782", Kge = "_selected_17vvj_782", Zge = "_previewEndpoint_17vvj_782", qge = "_today_17vvj_798", jge = "_flash_17vvj_803", Yge = "_otherMonth_17vvj_820", Qge = "_weekend_17vvj_824", Jge = {
  cell: $ge,
  circle: zge,
  disabled: Wge,
  readonly: Uge,
  selected: Kge,
  previewEndpoint: Zge,
  today: qge,
  flash: jge,
  "day-flash": "_day-flash_17vvj_1",
  otherMonth: Yge,
  weekend: Qge
}, Xge = {
  $style: Jge
}, epe = /* @__PURE__ */ we(Nge, [["__cssModules", Xge]]);
function tpe(e) {
  return { weekStartsOn: e, firstWeekContainsDate: 4 };
}
function npe(e, t, n) {
  const o = Yr(e), s = Mo(o, { weekStartsOn: t }), i = e1(o, s), r = I6(G8(e)), a = Math.ceil((i + r) / 7), l = o.getMonth(), d = [];
  let c = s;
  for (let u = 0; u < a; u++) {
    const h = [];
    for (let p = 0; p < 7; p++) {
      const f = ji(c, p);
      h.push({
        date: f,
        day: f.getDate(),
        inCurrentMonth: f.getMonth() === l,
        isToday: Ix(f),
        isWeekend: T8(f),
        disabled: n ? n(f) : !1
      });
    }
    const g = ji(c, (4 - t + 7) % 7);
    d.push({ weekNumber: yg(g, tpe(t)), days: h }), c = ji(c, 7);
  }
  return d;
}
function ope(e, t) {
  const n = Mo(new Date(2024, 0, 1), { weekStartsOn: e });
  return Array.from({ length: 7 }, (o, s) => As(ji(n, s), "EEEEEE", { locale: t }));
}
const spe = ["popovertarget", "test-id"], ipe = ["test-id", "onClick"], rpe = /* @__PURE__ */ de({
  __name: "CalendarMonthGrid",
  props: {
    month: {},
    weekStartsOn: {},
    showWeekNumbers: { type: Boolean },
    weekdays: {},
    weekLabel: {},
    monthLabel: {},
    years: {},
    yearSelectable: { type: Boolean },
    isDisabled: {},
    getDayState: {},
    readonly: { type: Boolean, default: !1 },
    testId: { default: "sca-calendar-month" }
  },
  emits: ["select", "hover", "selectYear"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = W(!1), i = W(null), r = W(null);
    function a(g, p) {
      p === d.value && (r.value = (g == null ? void 0 : g.$el) ?? g);
    }
    const l = D(() => npe(n.month, n.weekStartsOn, n.isDisabled)), d = D(() => n.month.getFullYear());
    Re(s, async (g) => {
      if (!g) return;
      await Xe();
      const p = i.value, f = r.value;
      !p || !f || (p.scrollTop = f.offsetTop - p.clientHeight / 2 + f.clientHeight / 2);
    });
    function c(g) {
      s.value = !1, o("selectYear", g);
    }
    function u(g) {
      return g.rangeStart && g.rangeEnd ? "none" : g.previewStart || g.previewEnd ? "full" : g.rangeStart ? "right" : g.rangeEnd ? "left" : g.inRange || g.preview ? "full" : "none";
    }
    function h(g) {
      const p = g.days.length;
      let f = null, m = null, C;
      for (const [w, b] of g.days.entries()) {
        const A = n.getDayState(b.date);
        C ?? (C = A.previewDirection);
        const S = u(A);
        if (S === "none") continue;
        const F = S === "right" ? w + 0.5 : w, E = S === "left" ? w + 0.5 : w + 1;
        (f === null || F < f) && (f = F), (m === null || E > m) && (m = E);
      }
      return f === null || m === null ? { left: C === "backward" ? "100%" : "0%", width: "0%" } : { left: `${f / p * 100}%`, width: `${(m - f) / p * 100}%` };
    }
    return (g, p) => (v(), y("div", {
      class: x(g.$style.month)
    }, [
      R("div", {
        class: x(g.$style.periodHeader)
      }, [
        e.yearSelectable ? (v(), z(Yt, {
          key: 0,
          "is-open": s.value,
          "onUpdate:isOpen": p[0] || (p[0] = (f) => s.value = f),
          placement: "bottom",
          class: x(g.$style.yearDropdown)
        }, {
          trigger: Q(({ target: f }) => [
            R("button", {
              type: "button",
              class: x(g.$style.periodLabel),
              popovertarget: f,
              "test-id": `${e.testId}-period`
            }, [
              Oe(se(e.monthLabel) + " ", 1),
              te(Fe, {
                class: x([g.$style.caret, { [g.$style.caretOpen]: s.value }]),
                icon: "phosphor/caret-down",
                size: "12px"
              }, null, 8, ["class"])
            ], 10, spe)
          ]),
          default: Q(() => [
            R("div", {
              ref_key: "yearListEl",
              ref: i,
              class: x(g.$style.yearList)
            }, [
              (v(!0), y(Se, null, We(e.years, (f) => (v(), y("button", {
                key: f,
                ref_for: !0,
                ref: (m) => a(m, f),
                type: "button",
                class: x([g.$style.yearItem, { [g.$style.yearActive]: f === d.value }]),
                "test-id": `${e.testId}-year-${f}`,
                onClick: (m) => c(f)
              }, se(f), 11, ipe))), 128))
            ], 2)
          ]),
          _: 1
        }, 8, ["is-open", "class"])) : (v(), y("span", {
          key: 1,
          class: x(g.$style.periodLabelStatic)
        }, se(e.monthLabel), 3))
      ], 2),
      R("div", {
        class: x(g.$style.grid)
      }, [
        R("div", {
          class: x(g.$style.weekdayRow)
        }, [
          e.showWeekNumbers ? (v(), y("div", {
            key: 0,
            class: x([g.$style.weekdayCell, g.$style.weekColumn])
          }, se(e.weekLabel), 3)) : V("", !0),
          (v(!0), y(Se, null, We(e.weekdays, (f, m) => (v(), y("div", {
            key: m,
            class: x(g.$style.weekdayCell)
          }, se(f), 3))), 128))
        ], 2),
        (v(!0), y(Se, null, We(l.value, (f, m) => (v(), y("div", {
          key: m,
          class: x(g.$style.weekRow)
        }, [
          e.showWeekNumbers ? (v(), y("div", {
            key: 0,
            class: x(g.$style.weekNumber)
          }, se(f.weekNumber), 3)) : V("", !0),
          R("div", {
            class: x(g.$style.daysWrap)
          }, [
            R("span", {
              class: x(g.$style.rangeBar),
              style: Ke(h(f))
            }, null, 6),
            (v(!0), y(Se, null, We(f.days, (C, w) => (v(), z(epe, {
              key: C.date.getTime(),
              cell: C,
              state: e.getDayState(C.date),
              "is-row-start": w === 0,
              "is-row-end": w === f.days.length - 1,
              readonly: e.readonly,
              "test-id": `${e.testId}-day-${C.date.getFullYear()}-${C.date.getMonth() + 1}-${C.day}`,
              onSelect: p[1] || (p[1] = (b) => g.$emit("select", b)),
              onHover: p[2] || (p[2] = (b) => g.$emit("hover", b))
            }, null, 8, ["cell", "state", "is-row-start", "is-row-end", "readonly", "test-id"]))), 128))
          ], 2)
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), ape = "_month_1g29w_747", lpe = "_periodHeader_1g29w_752", dpe = "_yearDropdown_1g29w_765", cpe = "_periodLabel_1g29w_769", upe = "_periodLabelStatic_1g29w_770", hpe = "_caret_1g29w_793", gpe = "_caretOpen_1g29w_803", ppe = "_yearList_1g29w_811", fpe = "_yearItem_1g29w_821", mpe = "_yearActive_1g29w_840", vpe = "_grid_1g29w_847", Cpe = "_weekdayRow_1g29w_853", wpe = "_weekRow_1g29w_854", ype = "_daysWrap_1g29w_859", bpe = "_rangeBar_1g29w_865", Spe = "_weekdayCell_1g29w_874", xpe = "_weekColumn_1g29w_890", Rpe = "_weekNumber_1g29w_896", Epe = {
  month: ape,
  periodHeader: lpe,
  yearDropdown: dpe,
  periodLabel: cpe,
  periodLabelStatic: upe,
  caret: hpe,
  caretOpen: gpe,
  yearList: ppe,
  yearItem: fpe,
  yearActive: mpe,
  grid: vpe,
  weekdayRow: Cpe,
  weekRow: wpe,
  daysWrap: ype,
  rangeBar: bpe,
  weekdayCell: Spe,
  weekColumn: xpe,
  weekNumber: Rpe
}, Ape = {
  $style: Epe
}, Fpe = /* @__PURE__ */ we(rpe, [["__cssModules", Ape]]), Mpe = ["test-id"], Ipe = ["tabindex", "readonly", "aria-label", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-valuetext", "aria-invalid", "test-id", "inputmode", "onFocus", "onKeydown"], Ppe = /* @__PURE__ */ de({
  __name: "SCADatetimeInputInline",
  props: /* @__PURE__ */ dt({
    format: {},
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    testId: { default: void 0 }
  }, {
    modelValue: { default: null },
    modelModifiers: {},
    invalid: { type: Boolean, default: !1 },
    invalidModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["next", "prev"], ["update:modelValue", "update:invalid"]),
  setup(e, { expose: t, emit: n }) {
    const o = e, s = lt(e, "modelValue"), i = lt(e, "invalid"), r = n, { t: a, locale: l } = fn(), d = D(() => c1(o.format)), c = D(() => u1(d.value)), u = D(() => c.value.some((J) => J.type === "meridiem")), h = D(() => nc(l.value));
    function g(J) {
      return Array.from(
        { length: 12 },
        (Y, q) => As(new Date(2e3, q, 1), J, { locale: h.value })
      );
    }
    const p = D(() => g("MMMM")), f = D(() => g("MMM"));
    function m(J) {
      return J === "long" ? p.value : f.value;
    }
    const C = W({}), w = W(0), b = W(""), A = W(null), S = W(), F = /* @__PURE__ */ new Map();
    function E(J, Y) {
      Y ? F.set(J, Y) : F.delete(J);
    }
    const M = [
      "day",
      "month",
      "year",
      "hours",
      "minutes",
      "seconds",
      "milliseconds",
      "meridiem"
    ];
    function I(J, Y) {
      return M.every((q) => (J[q] ?? null) === (Y[q] ?? null));
    }
    let P;
    function k(J) {
      P = (J == null ? void 0 : J.getTime()) ?? null, s.value = J;
    }
    function B() {
      C.value = s.value ? Zc(s.value, c.value) : {}, w.value = 0, b.value = "", i.value = !1, P = void 0;
    }
    Re(
      s,
      (J) => {
        if (((J == null ? void 0 : J.getTime()) ?? null) !== P && !(A.value !== null && (w.value > 0 || b.value !== ""))) {
          if (J && I(Zc(J, c.value), C.value)) {
            P = void 0;
            return;
          }
          B();
        }
      },
      { immediate: !0 }
    ), Re(c, B);
    const j = D(() => c.value.every((J) => C.value[J.type] != null));
    function N() {
      if (j.value) {
        const J = Of(c.value, C.value);
        if (J) {
          i.value = !1, k(J);
          return;
        }
      }
      Bf(c.value, C.value) === "empty" && (i.value = !1), s.value !== null && k(null);
    }
    function re() {
      A.value = null, w.value = 0, b.value = "";
      const J = Bf(c.value, C.value);
      if (J === "empty") {
        i.value = !1, s.value !== null && k(null);
        return;
      }
      if (J === "complete") {
        const Y = Of(c.value, C.value);
        if (Y) {
          C.value = Zc(Y, c.value), i.value = !1, k(Y);
          return;
        }
      }
      i.value = !0;
    }
    function H(J) {
      const Y = C.value[J.type];
      if (Y != null) {
        const q = J.type === "month" && J.monthStyle ? m(J.monthStyle) : void 0;
        return Gx(J, Y, q);
      }
      return _(J);
    }
    function _(J) {
      return J.type === "meridiem" ? "AM" : J.type === "month" && J.monthStyle ? J.token : J.type === "day" || J.type === "month" || J.type === "year" ? a(`datetimePicker.sectionChars.${J.type}`).repeat(J.padLength) : J.token[0].repeat(J.padLength);
    }
    function ne(J, Y) {
      C.value = { ...C.value, [J]: Y };
    }
    function ce(J) {
      const Y = d.value[J];
      if ((Y == null ? void 0 : Y.kind) !== "section") return;
      const q = C.value[Y.type];
      if (q == null) return;
      const ge = Hr(Y, C.value);
      let ie;
      Y.type === "year" && Y.maxDigits === 4 && q > 0 && q < 100 ? ie = h1(q) : ie = Ox(q, ge), ie !== q && (ne(Y.type, ie), N());
    }
    function me(J) {
      A.value !== null && A.value !== J && ce(A.value), A.value !== J && (w.value = 0, b.value = ""), A.value = J;
    }
    function Ie(J) {
      var q;
      const Y = J.relatedTarget;
      Y && ((q = S.value) != null && q.contains(Y)) || re();
    }
    function L() {
      return d.value.flatMap((J, Y) => J.kind === "section" ? [Y] : []);
    }
    function oe(J) {
      var Y;
      (Y = F.get(J)) == null || Y.focus();
    }
    function K(J, Y) {
      const q = L(), ge = q.indexOf(J), ie = q[ge + Y];
      ie !== void 0 ? oe(ie) : r(Y === 1 ? "next" : "prev");
    }
    function G() {
      const J = L(), q = J.find((ge) => {
        const ie = d.value[ge];
        return ie.kind === "section" && C.value[ie.type] == null;
      }) ?? J[0];
      q !== void 0 && oe(q);
    }
    function le() {
      const J = L(), Y = J[J.length - 1];
      Y !== void 0 && oe(Y);
    }
    const be = [".", ",", "/", "-", ":", " "];
    function Me(J, Y, q) {
      if (o.disabled || o.readonly) return;
      const ge = J.key;
      if (ge === "Enter") {
        re(), A.value = q;
        return;
      }
      if (ge === "ArrowLeft" || ge === "ArrowRight") {
        J.preventDefault(), K(q, ge === "ArrowRight" ? 1 : -1);
        return;
      }
      if (ge === "Home" || ge === "End") {
        J.preventDefault();
        const ie = L();
        oe(ge === "Home" ? ie[0] : ie[ie.length - 1]);
        return;
      }
      if (ge === "ArrowUp" || ge === "ArrowDown") {
        J.preventDefault();
        const ie = Hr(Y, C.value);
        ne(Y.type, Bx(C.value[Y.type] ?? null, ge === "ArrowUp" ? 1 : -1, ie)), w.value = 0, b.value = "", N();
        return;
      }
      if (ge === "Backspace" || ge === "Delete") {
        J.preventDefault(), ne(Y.type, null), w.value = 0, b.value = "", N();
        return;
      }
      if (/^[0-9]$/.test(ge)) {
        if (J.preventDefault(), Y.type === "meridiem") return;
        const ie = Hr(Y, C.value), ee = Lx(
          C.value[Y.type] ?? null,
          w.value,
          Number(ge),
          ie,
          Y.maxDigits
        );
        ne(Y.type, ee.value), w.value = ee.typed, b.value = "", N(), ee.complete && K(q, 1);
        return;
      }
      if (Y.type === "month" && Y.monthStyle && new RegExp("^\\p{L}$", "u").test(ge)) {
        J.preventDefault();
        const ie = p.value, ee = Hf(b.value + ge, ie), ae = ee ?? Hf(ge, ie);
        b.value = ee ? b.value + ge : ae ? ge : "", ae && (ne("month", ae.month), w.value = 0, N(), ae.complete && K(q, 1));
        return;
      }
      if (u.value && (ge === "a" || ge === "A" || ge === "p" || ge === "P")) {
        J.preventDefault(), ne("meridiem", ge === "a" || ge === "A" ? 0 : 1), N();
        return;
      }
      if (be.includes(ge)) {
        J.preventDefault(), C.value[Y.type] != null && K(q, 1);
        return;
      }
      ge.length === 1 && !J.ctrlKey && !J.metaKey && J.preventDefault();
    }
    function Be(J) {
      return J.type === "meridiem" || J.type === "month" && J.monthStyle ? "text" : "numeric";
    }
    function qe(J) {
      J.preventDefault();
      const Y = J.inputType.startsWith("delete") ? ["Backspace"] : [...J.data ?? ""];
      for (const q of Y) {
        const ge = A.value, ie = ge === null ? void 0 : d.value[ge];
        if ((ie == null ? void 0 : ie.kind) !== "section" || ge === null) return;
        Me(new KeyboardEvent("keydown", { key: q }), ie, ge);
      }
    }
    function he(J) {
      const Y = J.target;
      Y.value !== "" && (Y.value = "");
    }
    function Pe(J) {
      o.disabled || J.target.closest('[role="spinbutton"]') || (J.preventDefault(), G());
    }
    return t({ focus: G, focusLast: le, reset: B }), (J, Y) => (v(), y("div", {
      ref_key: "rootRef",
      ref: S,
      class: x([J.$style.root, { [J.$style.disabled]: e.disabled }]),
      role: "group",
      "test-id": e.testId,
      onFocusout: Ie,
      onMousedown: Pe
    }, [
      (v(!0), y(Se, null, We(d.value, (q, ge) => (v(), y(Se, {
        key: `${e.format}-${ge}`
      }, [
        q.kind === "literal" ? (v(), y("span", {
          key: 0,
          class: x(J.$style.literal),
          "aria-hidden": "true"
        }, se(q.text), 3)) : (v(), y("span", {
          key: 1,
          class: x(J.$style.sectionWrap)
        }, [
          R("span", {
            class: x([J.$style.section, { [J.$style.empty]: C.value[q.type] == null }]),
            "aria-hidden": "true"
          }, se(H(q)), 3),
          R("input", {
            ref_for: !0,
            ref: (ie) => E(ge, ie),
            type: "text",
            role: "spinbutton",
            tabindex: e.disabled ? -1 : 0,
            readonly: e.disabled || e.readonly,
            class: x(J.$style.sectionInput),
            "aria-label": T(a)(`datetimePicker.sectionNames.${q.type}`),
            "aria-valuemin": T(Hr)(q, C.value).min,
            "aria-valuemax": T(Hr)(q, C.value).max,
            "aria-valuenow": C.value[q.type] ?? void 0,
            "aria-valuetext": q.type === "month" && q.monthStyle && C.value[q.type] != null ? H(q) : void 0,
            "aria-invalid": i.value || void 0,
            "test-id": `datetime-section-${q.type}`,
            inputmode: Be(q),
            autocomplete: "off",
            onFocus: (ie) => me(ge),
            onKeydown: (ie) => Me(ie, q, ge),
            onBeforeinput: Y[0] || (Y[0] = (ie) => qe(ie)),
            onInput: Y[1] || (Y[1] = (ie) => he(ie))
          }, null, 42, Ipe)
        ], 2))
      ], 64))), 128))
    ], 42, Mpe));
  }
}), Dpe = "_root_s666o_1", Tpe = "_disabled_s666o_15", kpe = "_sectionWrap_s666o_19", Lpe = "_section_s666o_19", Bpe = "_empty_s666o_28", Ope = "_sectionInput_s666o_32", Gpe = "_literal_s666o_47", Hpe = {
  root: Dpe,
  disabled: Tpe,
  sectionWrap: kpe,
  section: Lpe,
  empty: Bpe,
  sectionInput: Ope,
  literal: Gpe
}, Vpe = {
  $style: Hpe
}, ya = /* @__PURE__ */ we(Ppe, [["__cssModules", Vpe]]), _pe = /* @__PURE__ */ de({
  __name: "TimeCombinedSelect",
  props: {
    modelValue: {},
    minuteStep: { default: 15 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    width: { default: 100 },
    testId: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    Ls((h) => ({
      a63c95a4: `${h.width}px`
    }));
    const n = e, o = t, s = W();
    function i(h) {
      return String(h).padStart(2, "0");
    }
    const r = D(() => {
      const h = [];
      for (let p = 0; p < 24; p++)
        for (let f = 0; f < 60; f += n.minuteStep)
          h.push({ id: p * 60 + f, label: `${i(p)}:${i(f)}` });
      const g = n.modelValue;
      return g && !h.some((p) => p.id === g.hours * 60 + g.minutes) && (h.push({ id: g.hours * 60 + g.minutes, label: `${i(g.hours)}:${i(g.minutes)}` }), h.sort((p, f) => Number(p.id) - Number(f.id))), h;
    }), a = D(() => {
      if (n.modelValue)
        return n.modelValue.hours * 60 + n.modelValue.minutes;
    }), l = D(() => n.modelValue ? new Date(2e3, 0, 1, n.modelValue.hours, n.modelValue.minutes) : null);
    function d(h) {
      if (h === void 0) return;
      const g = Number(h);
      o("update:modelValue", { hours: Math.floor(g / 60), minutes: g % 60, seconds: 0 });
    }
    function c(h) {
      h && o("update:modelValue", { hours: h.getHours(), minutes: h.getMinutes(), seconds: 0 });
    }
    function u(h) {
      const g = h.currentTarget;
      h.relatedTarget instanceof Node && g.contains(h.relatedTarget) || Xe(() => {
        var p;
        return (p = s.value) == null ? void 0 : p.reset();
      });
    }
    return (h, g) => (v(), z(Wc, {
      class: x(h.$style.select),
      label: e.label,
      items: r.value,
      "model-value": a.value,
      disabled: e.disabled,
      "test-id": e.testId,
      "onUpdate:modelValue": d
    }, {
      input: Q(() => [
        te(ya, {
          ref_key: "editor",
          ref: s,
          "model-value": l.value,
          format: "HH:mm",
          disabled: e.disabled,
          "onUpdate:modelValue": c,
          onFocusout: u
        }, null, 8, ["model-value", "disabled"])
      ]),
      _: 1
    }, 8, ["class", "label", "items", "model-value", "disabled", "test-id"]));
  }
}), Npe = "_select_q0z5s_1", $pe = {
  select: Npe
}, zpe = {
  $style: $pe
}, Rv = /* @__PURE__ */ we(_pe, [["__cssModules", zpe]]), Wpe = /* @__PURE__ */ de({
  __name: "TimeUnitSelect",
  props: {
    modelValue: {},
    unit: {},
    step: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    testId: { default: void 0 },
    label: { default: void 0 },
    labelSize: { default: 52 },
    width: { default: 136 },
    gap: { default: 12 }
  },
  emits: ["update:modelValue", "next", "prev"],
  setup(e, { expose: t, emit: n }) {
    Ls((u) => ({
      v71262154: `${u.width}px`,
      v3e9348a5: `${u.labelSize}px`,
      v25ee0cb4: `${u.gap}px`
    }));
    const o = e, s = n, i = W(), r = D(() => {
      const u = o.unit === "hours" ? 23 : 59, h = [];
      for (let g = 0; g <= u; g += o.step)
        h.push({ id: g, label: String(g).padStart(2, "0") });
      return h;
    }), a = D(() => {
      if (o.modelValue == null) return null;
      const u = new Date(2e3, 0, 1);
      return o.unit === "hours" ? u.setHours(o.modelValue) : u.setMinutes(o.modelValue), u;
    });
    function l(u) {
      u !== void 0 && s("update:modelValue", Number(u));
    }
    function d(u) {
      u && s("update:modelValue", o.unit === "hours" ? u.getHours() : u.getMinutes());
    }
    function c(u) {
      const h = u.currentTarget;
      u.relatedTarget instanceof Node && h.contains(u.relatedTarget) || Xe(() => {
        var g;
        return (g = i.value) == null ? void 0 : g.reset();
      });
    }
    return t({
      focus: () => {
        var u;
        return (u = i.value) == null ? void 0 : u.focus();
      },
      focusLast: () => {
        var u;
        return (u = i.value) == null ? void 0 : u.focusLast();
      }
    }), (u, h) => (v(), z(Wc, {
      class: x(u.$style.select),
      label: e.label,
      items: r.value,
      "model-value": e.modelValue ?? void 0,
      disabled: e.disabled,
      "test-id": e.testId,
      "onUpdate:modelValue": l
    }, {
      input: Q(() => [
        te(ya, {
          ref_key: "editor",
          ref: i,
          "model-value": a.value,
          format: e.unit === "hours" ? "HH" : "mm",
          disabled: e.disabled,
          "onUpdate:modelValue": d,
          onFocusout: c,
          onNext: h[0] || (h[0] = (g) => s("next")),
          onPrev: h[1] || (h[1] = (g) => s("prev"))
        }, null, 8, ["model-value", "format", "disabled"])
      ]),
      _: 1
    }, 8, ["class", "label", "items", "model-value", "disabled", "test-id"]));
  }
}), Upe = "_select_153zy_1", Kpe = {
  select: Upe
}, Zpe = {
  $style: Kpe
}, Gl = /* @__PURE__ */ we(Wpe, [["__cssModules", Zpe]]), qpe = { key: 0 }, jpe = 100, Ype = 100, Qpe = 4, Jpe = /* @__PURE__ */ de({
  __name: "SCACalendarPanel",
  props: /* @__PURE__ */ dt({
    mode: {},
    inline: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    config: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {},
    allDay: { type: Boolean, default: !1 },
    allDayModifiers: {},
    months: { default: 1 },
    monthsModifiers: {},
    columns: { default: 1 },
    columnsModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["selectionComplete"], ["update:modelValue", "update:allDay", "update:months", "update:columns"]),
  setup(e, { expose: t, emit: n }) {
    const o = e, s = { ...whe, ...o.config }, i = n, r = lt(e, "modelValue"), { t: a, locale: l } = fn(), d = D(() => nc(l.value)), c = D(() => g2(o.mode)), u = D(() => Sv(o.mode)), h = D(() => Js(o.mode)), g = { hours: 0, minutes: 0, seconds: 0 }, p = { hours: 23, minutes: 59, seconds: 59 }, f = W(null), m = W(null), C = W(null), w = W(null), b = W(null), A = W(null), S = W(), F = W(), E = lt(e, "allDay"), M = D(() => E.value ? g : w.value), I = D(() => E.value ? p : b.value);
    function P(pe) {
      if (o.readonly) return;
      const Ce = pe ?? !1;
      E.value = Ce, lo(Ce);
    }
    const k = W(Yr(/* @__PURE__ */ new Date())), B = lt(e, "months"), j = lt(e, "columns"), N = W(!1);
    Re(B, (pe) => {
      j.value > pe && (j.value = pe);
    });
    const re = D(
      () => Array.from({ length: Math.min(B.value, s.maxMonths) }, (pe, Ce) => If(k.value, Ce))
    ), H = D(() => ({
      gridTemplateColumns: `repeat(${j.value}, max-content)`
    })), _ = D(() => ope(s.weekStartsOn, d.value)), ne = D(() => {
      const pe = (/* @__PURE__ */ new Date()).getFullYear(), Ce = k.value.getFullYear(), nt = s.min ? s.min.getFullYear() : Math.min(pe - jpe, Ce), St = s.max ? s.max.getFullYear() : Math.max(pe + Ype, Ce), Ft = [];
      for (let Wt = nt; Wt <= St; Wt++) Ft.push(Wt);
      return Ft;
    }), ce = D(
      () => Array.from({ length: s.maxMonths }, (pe, Ce) => ({ id: Ce + 1, label: String(Ce + 1) }))
    );
    function me(pe, Ce = !1) {
      return As(pe, Ce ? "LLL yyyy" : "LLLL yyyy", { locale: d.value });
    }
    function Ie(pe) {
      const Ce = re.value;
      return Ce.length <= 1 ? me(Ce[0], pe) : `${me(Ce[0], pe)} - ${me(Ce[Ce.length - 1], pe)}`;
    }
    const L = W(!1), oe = D(() => Ie(!1)), K = D(() => L.value ? Ie(!0) : oe.value), G = bA();
    function le(pe) {
      return G.value ? oc(G.value, pe ? "dd.MM.yyyy, HH:mm" : fA(l.value), {
        locale: l.value
      }) : "";
    }
    const be = W(!1), Me = D(() => le(!1)), Be = D(() => be.value ? le(!0) : Me.value), qe = W(null), he = W(null), Pe = W(null);
    let J = null;
    function Y(pe, Ce) {
      return pe ? pe.getBoundingClientRect().width <= Ce - Qpe : !0;
    }
    function q() {
      const pe = qe.value;
      if (!pe) return;
      const Ce = pe.getBoundingClientRect().width;
      L.value = !Y(he.value, Ce), be.value = !Y(Pe.value, Ce);
    }
    Et(() => {
      typeof ResizeObserver < "u" && qe.value && (J = new ResizeObserver(() => q()), J.observe(qe.value)), Xe(q);
    }), io(() => {
      J == null || J.disconnect(), J = null;
    }), Re([oe, Me], () => void Xe(q));
    function ge(pe) {
      return s.min && fl(mt(pe), mt(s.min)) || s.max && pl(mt(pe), mt(s.max)) ? !0 : s.disabledDate ? s.disabledDate(pe) : !1;
    }
    function ie(pe) {
      const Ce = {
        selected: !1,
        rangeStart: !1,
        rangeEnd: !1,
        inRange: !1,
        preview: !1,
        previewStart: !1,
        previewEnd: !1,
        flash: gs(pe, /* @__PURE__ */ new Date()) ? Ne.value : 0
      };
      if (!c.value)
        return { ...Ce, selected: f.value ? gs(pe, f.value) : !1 };
      const nt = m.value, St = C.value, Ft = { ...Ce };
      if (nt && gs(pe, nt) && (Ft.rangeStart = !0), St && gs(pe, St) && (Ft.rangeEnd = !0), nt && St && pl(mt(pe), mt(nt)) && fl(mt(pe), mt(St)) && (Ft.inRange = !0), nt && !St && A.value && !ge(A.value)) {
        const Wt = A.value, [Ze, $] = ee(nt, Wt), fe = mt(pe), ye = fl(mt(Wt), mt(nt));
        Ft.previewDirection = ye ? "backward" : "forward", pl(fe, mt(Ze)) && fl(fe, mt($)) && (Ft.preview = !0), gs(Wt, nt) || (gs(pe, nt) && ye && (Ft.rangeStart = !1, Ft.rangeEnd = !0), gs(pe, Wt) && (Ft.preview = !0, ye ? Ft.previewStart = !0 : Ft.previewEnd = !0));
      }
      return Ft;
    }
    function ee(pe, Ce) {
      return pl(pe, Ce) ? [Ce, pe] : [pe, Ce];
    }
    function ae(pe) {
      k.value = If(k.value, pe);
    }
    function _e() {
      const pe = /* @__PURE__ */ new Date(), Ce = mt(pe);
      if (k.value = Yr(Ce), Ne.value++, o.readonly || ge(Ce)) return;
      const nt = { hours: pe.getHours(), minutes: pe.getMinutes(), seconds: pe.getSeconds() };
      c.value ? (m.value = Ce, C.value = Ce, A.value = null, Js(o.mode) && (w.value = { ...nt }, b.value = { ...nt }), lo(), o.mode === "dateRange" && i("selectionComplete")) : (f.value = Ce, Js(o.mode) && (w.value = { ...nt }), lo(), o.mode === "date" && i("selectionComplete"));
    }
    const Ne = W(0);
    function At(pe) {
      k.value = new Date(pe, k.value.getMonth(), 1);
    }
    function pt(pe) {
      c.value && m.value && !C.value && (A.value = pe);
    }
    function Uc(pe) {
      if (o.readonly || ge(pe)) return;
      const Ce = mt(pe), nt = /* @__PURE__ */ new Date(), St = { hours: nt.getHours(), minutes: nt.getMinutes(), seconds: nt.getSeconds() };
      if (!c.value) {
        f.value = Ce, Js(o.mode) && (w.value = { ...St }), lo(), o.mode === "date" && i("selectionComplete");
        return;
      }
      if (!m.value || m.value && C.value)
        m.value = Ce, C.value = null, A.value = null;
      else {
        const [Ft, Wt] = ee(m.value, Ce);
        m.value = Ft, C.value = Wt, A.value = null, Js(o.mode) && (w.value = { ...St }, b.value = { ...St });
      }
      lo(), o.mode === "dateRange" && m.value && C.value && i("selectionComplete");
    }
    function cl(pe, Ce) {
      pe === "start" ? w.value = Ce : b.value = Ce, lo();
    }
    function $s(pe, Ce) {
      const nt = w.value ? { ...w.value } : { hours: 0, minutes: 0, seconds: 0 };
      nt[pe] = Ce, w.value = nt, lo();
    }
    function is(pe, Ce) {
      const nt = new Date(pe);
      return nt.setHours((Ce == null ? void 0 : Ce.hours) ?? 0, (Ce == null ? void 0 : Ce.minutes) ?? 0, (Ce == null ? void 0 : Ce.seconds) ?? 0, 0), nt;
    }
    function Kc() {
      return o.mode === "date" ? f.value : o.mode === "datetime" ? f.value ? is(f.value, w.value) : null : o.mode === "time" && w.value ? is(mt(/* @__PURE__ */ new Date()), w.value) : null;
    }
    function ul(pe) {
      if (o.mode === "dateRange") return [m.value, C.value];
      if (o.mode === "timeRange") {
        const Ce = mt(/* @__PURE__ */ new Date());
        return pe ? [mt(Ce), Pf(Ce)] : [
          w.value ? is(Ce, w.value) : null,
          b.value ? is(Ce, b.value) : null
        ];
      }
      return pe ? [m.value ? mt(m.value) : null, C.value ? Pf(C.value) : null] : [
        m.value ? is(m.value, w.value) : null,
        C.value ? is(C.value, b.value) : null
      ];
    }
    let Bi = !1;
    function lo(pe) {
      const Ce = c.value ? ul(pe ?? E.value) : Kc();
      Bi = !0, r.value = Ce;
    }
    function hl() {
      if (Bi) {
        Bi = !1;
        return;
      }
      if (c.value) {
        const [pe, Ce] = r.value ?? [null, null];
        m.value = pe ? mt(pe) : null, C.value = Ce ? mt(Ce) : null, w.value = pe ? zs(pe) : w.value, b.value = Ce ? zs(Ce) : b.value, pe && (k.value = Yr(pe));
      } else {
        const pe = r.value;
        f.value = pe ? mt(pe) : null, pe && Js(o.mode) && (w.value = zs(pe)), pe && Sv(o.mode) && (k.value = Yr(pe));
      }
    }
    function zs(pe) {
      return { hours: pe.getHours(), minutes: pe.getMinutes(), seconds: pe.getSeconds() };
    }
    return Re(r, hl, { immediate: !0 }), t({ goToToday: _e }), (pe, Ce) => {
      var nt, St, Ft, Wt;
      return v(), y("div", {
        class: x([pe.$style.panel, { [pe.$style.inline]: e.inline }]),
        "test-id": "sca-calendar-panel"
      }, [
        u.value ? (v(), y("div", {
          key: 0,
          class: x(pe.$style.toolbar)
        }, [
          R("div", {
            class: x(pe.$style.toolbarControls)
          }, [
            te(ut, {
              icon: "phosphor/caret-left",
              size: "small",
              type: "default",
              appearance: "secondary",
              title: T(a)("datetimePicker.previousMonth"),
              "test-id": "sca-calendar-prev",
              onClick: Ce[0] || (Ce[0] = (Ze) => ae(-1))
            }, null, 8, ["title"]),
            te(ut, {
              icon: "phosphor/caret-right",
              size: "small",
              type: "default",
              appearance: "secondary",
              title: T(a)("datetimePicker.nextMonth"),
              "test-id": "sca-calendar-next",
              onClick: Ce[1] || (Ce[1] = (Ze) => ae(1))
            }, null, 8, ["title"]),
            s.maxMonths > 1 ? (v(), z(Yt, {
              key: 0,
              "is-open": N.value,
              "onUpdate:isOpen": Ce[3] || (Ce[3] = (Ze) => N.value = Ze),
              "offset-y": 5,
              placement: "bottom-start",
              "padding-upset": ""
            }, {
              trigger: Q(({ togglePopover: Ze }) => [
                te(ut, {
                  icon: "phosphor/gear",
                  size: "small",
                  type: "default",
                  appearance: "secondary",
                  title: T(a)("datetimePicker.settings"),
                  "test-id": "sca-calendar-settings",
                  onClick: ($) => Ze()
                }, null, 8, ["title", "onClick"])
              ]),
              default: Q(() => [
                R("div", {
                  class: x(pe.$style.settings)
                }, [
                  te(Wc, {
                    modelValue: B.value,
                    "onUpdate:modelValue": Ce[2] || (Ce[2] = (Ze) => B.value = Ze),
                    label: T(a)("datetimePicker.months"),
                    items: ce.value,
                    "test-id": "sca-calendar-months-select"
                  }, null, 8, ["modelValue", "label", "items"]),
                  R("div", {
                    class: x(pe.$style.columnsField)
                  }, [
                    te(vf, {
                      label: T(a)("datetimePicker.columns")
                    }, {
                      default: Q(() => [
                        R("div", {
                          class: x(pe.$style.columnsRow)
                        }, [
                          (v(), y(Se, null, We(4, (Ze) => te(Zt, {
                            key: Ze,
                            class: x(pe.$style.columnsButton),
                            size: "small",
                            type: "toggle",
                            appearance: j.value === Ze ? "primary" : "secondary",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            selected: j.value === Ze,
                            disabled: Ze > B.value,
                            "test-id": `sca-calendar-columns-${Ze}`,
                            onClick: ($) => j.value = Ze
                          }, {
                            default: Q(() => [
                              Oe(se(Ze), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "appearance", "selected", "disabled", "test-id", "onClick"])), 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ], 2)
                ], 2)
              ]),
              _: 1
            }, 8, ["is-open"])) : V("", !0),
            te(Zt, {
              size: "small",
              type: "default",
              appearance: "secondary",
              "padding-left": "8px",
              "padding-right": "8px",
              onClick: _e
            }, {
              default: Q(() => [
                Oe(se(T(a)("datetimePicker.today")), 1)
              ]),
              _: 1
            })
          ], 2),
          R("div", {
            ref_key: "toolbarContentRef",
            ref: qe,
            class: x(pe.$style.toolbarContent)
          }, [
            R("span", {
              class: x(pe.$style.rangeLabel)
            }, se(K.value), 3),
            R("span", {
              ref_key: "rangeProbeRef",
              ref: he,
              class: x([pe.$style.rangeLabel, pe.$style.rangeProbe]),
              "aria-hidden": "true"
            }, se(oe.value), 3),
            R("span", {
              class: x(pe.$style.selectionLabel),
              "test-id": "sca-calendar-now"
            }, se(Be.value), 3),
            R("span", {
              ref_key: "nowProbeRef",
              ref: Pe,
              class: x([pe.$style.selectionLabel, pe.$style.rangeProbe]),
              "aria-hidden": "true"
            }, se(Me.value), 3)
          ], 2)
        ], 2)) : V("", !0),
        u.value ? (v(), y("div", {
          key: 1,
          class: x([pe.$style.months, { [pe.$style.readonly]: e.readonly }]),
          style: Ke(H.value)
        }, [
          (v(!0), y(Se, null, We(re.value, (Ze, $) => (v(), z(Fpe, {
            key: Ze.getTime(),
            month: Ze,
            "week-starts-on": s.weekStartsOn,
            "show-week-numbers": s.showWeekNumbers,
            weekdays: _.value,
            "week-label": T(a)("datetimePicker.weekShort"),
            "month-label": me(Ze),
            years: ne.value,
            "year-selectable": !0,
            "is-disabled": ge,
            "get-day-state": ie,
            readonly: e.readonly,
            "test-id": `sca-calendar-month-${$}`,
            onSelect: Uc,
            onHover: pt,
            onSelectYear: At,
            onMouseleave: Ce[4] || (Ce[4] = (fe) => A.value = null)
          }, null, 8, ["month", "week-starts-on", "show-week-numbers", "weekdays", "week-label", "month-label", "years", "readonly", "test-id"]))), 128))
        ], 6)) : V("", !0),
        h.value ? (v(), y("div", {
          key: 2,
          class: x([pe.$style.timeArea, { [pe.$style.noBorder]: !u.value, [pe.$style.stacked]: e.mode === "time" }]),
          "test-id": "sca-calendar-time"
        }, [
          e.mode === "time" ? (v(), y("div", qpe, [
            te(Gl, {
              ref_key: "hoursSelect",
              ref: S,
              "model-value": ((nt = w.value) == null ? void 0 : nt.hours) ?? null,
              label: T(a)("datetimePicker.hours"),
              unit: "hours",
              "test-id": "sca-time-hours",
              "onUpdate:modelValue": Ce[5] || (Ce[5] = (Ze) => $s("hours", Ze)),
              onNext: Ce[6] || (Ce[6] = (Ze) => {
                var $;
                return ($ = F.value) == null ? void 0 : $.focus();
              })
            }, null, 8, ["model-value", "label"]),
            te(Gl, {
              ref_key: "minutesSelect",
              ref: F,
              "model-value": ((St = w.value) == null ? void 0 : St.minutes) ?? null,
              label: T(a)("datetimePicker.minutes"),
              unit: "minutes",
              step: 1,
              "test-id": "sca-time-minutes",
              "onUpdate:modelValue": Ce[7] || (Ce[7] = (Ze) => $s("minutes", Ze)),
              onPrev: Ce[8] || (Ce[8] = (Ze) => {
                var $;
                return ($ = S.value) == null ? void 0 : $.focusLast();
              })
            }, null, 8, ["model-value", "label"])
          ])) : e.mode === "datetime" ? (v(), y("div", {
            key: 1,
            class: x(pe.$style.timeUnitRow)
          }, [
            te(Gl, {
              ref_key: "hoursSelect",
              ref: S,
              "model-value": ((Ft = w.value) == null ? void 0 : Ft.hours) ?? null,
              label: T(a)("datetimePicker.h"),
              unit: "hours",
              "test-id": "sca-time-hours",
              "label-size": 20,
              width: 85,
              gap: 4,
              "onUpdate:modelValue": Ce[9] || (Ce[9] = (Ze) => $s("hours", Ze)),
              onNext: Ce[10] || (Ce[10] = (Ze) => {
                var $;
                return ($ = F.value) == null ? void 0 : $.focus();
              })
            }, null, 8, ["model-value", "label"]),
            te(Gl, {
              ref_key: "minutesSelect",
              ref: F,
              "model-value": ((Wt = w.value) == null ? void 0 : Wt.minutes) ?? null,
              label: T(a)("datetimePicker.m"),
              unit: "minutes",
              step: 1,
              "test-id": "sca-time-minutes",
              "label-size": 32,
              width: 105,
              gap: 4,
              "onUpdate:modelValue": Ce[11] || (Ce[11] = (Ze) => $s("minutes", Ze)),
              onPrev: Ce[12] || (Ce[12] = (Ze) => {
                var $;
                return ($ = S.value) == null ? void 0 : $.focusLast();
              })
            }, null, 8, ["model-value", "label"])
          ], 2)) : (v(), y(Se, { key: 2 }, [
            te(Rv, {
              "model-value": M.value,
              label: T(a)("datetimePicker.start"),
              "minute-step": s.minuteStep,
              disabled: E.value,
              "test-id": "sca-time-start",
              width: 104,
              "onUpdate:modelValue": Ce[13] || (Ce[13] = (Ze) => cl("start", Ze))
            }, null, 8, ["model-value", "label", "minute-step", "disabled"]),
            te(Rv, {
              "model-value": I.value,
              label: T(a)("datetimePicker.end"),
              "minute-step": s.minuteStep,
              disabled: E.value,
              "test-id": "sca-time-end",
              width: 100,
              "onUpdate:modelValue": Ce[14] || (Ce[14] = (Ze) => cl("end", Ze))
            }, null, 8, ["model-value", "label", "minute-step", "disabled"]),
            R("div", {
              class: x(pe.$style.allDayField)
            }, [
              R("span", {
                class: x(pe.$style.allDayLable)
              }, se(T(a)("datetimePicker.allDay")), 3),
              te(JS, {
                "model-value": E.value,
                class: x(pe.$style.allDayToggle),
                "no-padding": "",
                "test-id": "sca-time-allday",
                "onUpdate:modelValue": P
              }, null, 8, ["model-value", "class"])
            ], 2)
          ], 64))
        ], 2)) : V("", !0)
      ], 2);
    };
  }
}), Xpe = "_panel_62ll1_747", efe = "_inline_62ll1_753", tfe = "_toolbar_62ll1_757", nfe = "_toolbarControls_62ll1_773", ofe = "_toolbarContent_62ll1_779", sfe = "_rangeLabel_62ll1_786", ife = "_selectionLabel_62ll1_800", rfe = "_rangeProbe_62ll1_815", afe = "_months_62ll1_823", lfe = "_settings_62ll1_829", dfe = "_columnsField_62ll1_838", cfe = "_columnsLabel_62ll1_847", ufe = "_columnsRow_62ll1_857", hfe = "_columnsButton_62ll1_862", gfe = "_timeArea_62ll1_869", pfe = "_noBorder_62ll1_879", ffe = "_stacked_62ll1_889", mfe = "_timeUnitRow_62ll1_896", vfe = "_allDayField_62ll1_902", Cfe = "_allDayLable_62ll1_907", wfe = "_allDayToggle_62ll1_920", yfe = {
  panel: Xpe,
  inline: efe,
  toolbar: tfe,
  toolbarControls: nfe,
  toolbarContent: ofe,
  rangeLabel: sfe,
  selectionLabel: ife,
  rangeProbe: rfe,
  months: afe,
  settings: lfe,
  columnsField: dfe,
  columnsLabel: cfe,
  columnsRow: ufe,
  columnsButton: hfe,
  timeArea: gfe,
  noBorder: pfe,
  stacked: ffe,
  timeUnitRow: mfe,
  allDayField: vfe,
  allDayLable: Cfe,
  allDayToggle: wfe
}, bfe = {
  $style: yfe
}, Ev = /* @__PURE__ */ we(Jpe, [["__cssModules", bfe]]), Sfe = ["aria-expanded"], xfe = ["id", "popovertarget", "disabled", "aria-label"], Rfe = -4, Efe = 16, Afe = /* @__PURE__ */ de({
  __name: "SCADatetimePicker",
  props: /* @__PURE__ */ dt({
    mode: { default: "date" },
    inline: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    appearance: { default: void 0 },
    config: { default: void 0 },
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" },
    datePrecision: { default: void 0 },
    timePrecision: { default: void 0 },
    clearable: { type: Boolean, default: !0 },
    placeholder: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    alert: { type: Boolean, default: !1 },
    manualInput: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: null },
    modelModifiers: {},
    allDay: { type: Boolean, default: !1 },
    allDayModifiers: {},
    months: { default: 1 },
    monthsModifiers: {},
    columns: { default: 1 },
    columnsModifiers: {},
    isOpen: { type: Boolean, default: !1 },
    isOpenModifiers: {},
    invalid: { type: Boolean, default: !1 },
    invalidModifiers: {}
  }),
  emits: ["update:modelValue", "update:allDay", "update:months", "update:columns", "update:isOpen", "update:invalid"],
  setup(e, { expose: t }) {
    const n = e, { locale: o } = fn(), s = D(() => nc(o.value)), i = lt(e, "modelValue"), r = lt(e, "allDay"), a = lt(e, "months"), l = lt(e, "columns"), d = lt(e, "isOpen"), c = lt(e, "invalid"), u = D(() => g2(n.mode)), h = W(), g = W(null);
    function p() {
      if (!h.value) return;
      const K = getComputedStyle(h.value).getPropertyValue("--sca-label-size").trim(), G = Number.parseFloat(K);
      g.value = Number.isFinite(G) ? G : null;
    }
    const f = D(() => g.value != null ? -(g.value + Efe) : Rfe);
    Et(p), Re(d, (K) => K && p());
    const m = W(!1), C = W(), w = W(), b = W();
    function A() {
      var K;
      n.manualInput && ((K = u.value ? w.value : C.value) == null || K.focus());
    }
    t({ focus: A });
    const S = W(!1), F = W(!1), E = W(!1);
    jd(() => {
      c.value = n.manualInput && (S.value || F.value || E.value);
    });
    const M = D({
      get: () => u.value ? null : i.value ?? null,
      set: (K) => {
        i.value = K;
      }
    }), I = D({
      get: () => (i.value ?? [null, null])[0] ?? null,
      set: (K) => {
        const G = i.value ?? [null, null];
        i.value = [K, G[1]];
      }
    }), P = D({
      get: () => (i.value ?? [null, null])[1] ?? null,
      set: (K) => {
        const G = i.value ?? [null, null];
        i.value = [G[0], K];
      }
    }), k = D(() => tc(n.dateFormat, n.datePrecision)), B = D(() => Lg(n.timeFormat, n.timePrecision)), j = D(() => n.mode === "time" || n.mode === "timeRange" ? B.value : Js(n.mode) ? `${k.value} ${B.value}` : k.value);
    function N(K) {
      return K ? As(K, j.value, { locale: s.value }) : "";
    }
    const re = D(() => {
      if (u.value) {
        const [K, G] = i.value ?? [null, null];
        return !!K || !!G;
      }
      return !!i.value;
    }), H = D(() => n.clearable && re.value && !n.disabled), _ = D(() => N((i.value ?? [null, null])[0])), ne = D(() => N((i.value ?? [null, null])[1])), ce = D(() => u.value ? !_.value && !ne.value ? "" : `${_.value} – ${ne.value}` : N(i.value));
    function me() {
      d.value = !1;
    }
    function Ie(K, G = !1) {
      var le;
      K.defaultPrevented || !d.value || (le = K.target) != null && le.closest('[role="spinbutton"]') && (S.value || F.value || E.value || (K.preventDefault(), d.value = !1, G && A()));
    }
    function L(K) {
      const G = K.relatedTarget;
      !d.value || !(G instanceof HTMLElement) || G.getAttribute("tabindex") === "-1" || K.currentTarget.contains(G) || (d.value = !1);
    }
    function oe() {
      i.value = u.value ? [null, null] : null;
    }
    return (K, G) => e.inline ? (v(), z(Ev, {
      key: 0,
      modelValue: i.value,
      "onUpdate:modelValue": G[0] || (G[0] = (le) => i.value = le),
      "all-day": r.value,
      "onUpdate:allDay": G[1] || (G[1] = (le) => r.value = le),
      months: a.value,
      "onUpdate:months": G[2] || (G[2] = (le) => a.value = le),
      columns: l.value,
      "onUpdate:columns": G[3] || (G[3] = (le) => l.value = le),
      mode: e.mode,
      readonly: e.readonly || e.disabled,
      config: e.config,
      inline: "",
      class: x({ [K.$style.disabledPanel]: e.disabled })
    }, null, 8, ["modelValue", "all-day", "months", "columns", "mode", "readonly", "config", "class"])) : (v(), z(Yt, {
      key: 1,
      "is-open": d.value,
      "onUpdate:isOpen": G[20] || (G[20] = (le) => d.value = le),
      class: x(K.$style.dropdown),
      placement: "bottom-start",
      "padding-upset": "",
      "no-mobile-margin": "",
      "offset-x": f.value,
      "offset-y": 5,
      onFocusout: L
    }, {
      trigger: Q(({ target: le }) => [
        e.manualInput ? (v(), z(Fi, {
          key: 0,
          "underline-override": "",
          appearance: e.appearance,
          focused: d.value || m.value,
          alert: e.alert || c.value
        }, {
          default: Q(() => [
            R("div", {
              ref_key: "offsetScope",
              ref: h,
              class: x(K.$style.manualTrigger),
              onFocusin: G[12] || (G[12] = (be) => m.value = !0),
              onFocusout: G[13] || (G[13] = (be) => m.value = !1),
              onKeydown: Uo(Ie, ["enter"])
            }, [
              R("input", {
                readonly: "",
                inert: "",
                class: x(K.$style.styleProbe)
              }, null, 2),
              R("div", {
                class: x([K.$style.manualContent, { [K.$style.withClear]: H.value }])
              }, [
                u.value ? (v(), y("div", {
                  key: 0,
                  class: x(K.$style.manualRangeGroup)
                }, [
                  te(ya, {
                    ref_key: "startEditor",
                    ref: w,
                    modelValue: I.value,
                    "onUpdate:modelValue": G[4] || (G[4] = (be) => I.value = be),
                    invalid: F.value,
                    "onUpdate:invalid": G[5] || (G[5] = (be) => F.value = be),
                    format: j.value,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "test-id": "datetime-manual-start",
                    onNext: G[6] || (G[6] = (be) => {
                      var Me;
                      return (Me = b.value) == null ? void 0 : Me.focus();
                    })
                  }, null, 8, ["modelValue", "invalid", "format", "disabled", "readonly"]),
                  R("span", {
                    class: x(K.$style.manualRangeSeparator)
                  }, "–", 2),
                  te(ya, {
                    ref_key: "endEditor",
                    ref: b,
                    modelValue: P.value,
                    "onUpdate:modelValue": G[7] || (G[7] = (be) => P.value = be),
                    invalid: E.value,
                    "onUpdate:invalid": G[8] || (G[8] = (be) => E.value = be),
                    format: j.value,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "test-id": "datetime-manual-end",
                    onPrev: G[9] || (G[9] = (be) => {
                      var Me;
                      return (Me = w.value) == null ? void 0 : Me.focusLast();
                    })
                  }, null, 8, ["modelValue", "invalid", "format", "disabled", "readonly"])
                ], 2)) : (v(), z(ya, {
                  key: 1,
                  ref_key: "singleEditor",
                  ref: C,
                  modelValue: M.value,
                  "onUpdate:modelValue": G[10] || (G[10] = (be) => M.value = be),
                  invalid: S.value,
                  "onUpdate:invalid": G[11] || (G[11] = (be) => S.value = be),
                  format: j.value,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  "test-id": "datetime-manual"
                }, null, 8, ["modelValue", "invalid", "format", "disabled", "readonly"])),
                H.value ? (v(), y("button", {
                  key: 2,
                  type: "button",
                  tabindex: "-1",
                  class: x(K.$style.clearButton),
                  onClick: Ge(oe, ["stop"])
                }, [
                  te(Fe, {
                    icon: "phosphor/x",
                    size: "12px",
                    class: x(K.$style.clearIcon)
                  }, null, 8, ["class"])
                ], 2)) : V("", !0),
                ve(K.$slots, "default")
              ], 2)
            ], 34)
          ]),
          _: 3
        }, 8, ["appearance", "focused", "alert"])) : (v(), z(Fi, {
          key: 1,
          "underline-override": "",
          appearance: e.appearance,
          focused: d.value,
          alert: e.alert
        }, {
          default: Q(() => [
            R("div", {
              ref_key: "offsetScope",
              ref: h,
              class: x([K.$style.dropdownTrigger, { [K.$style.disabled]: e.disabled }])
            }, [
              R("input", {
                readonly: "",
                "aria-haspopup": !0,
                "aria-expanded": d.value,
                onKeydown: G[14] || (G[14] = Uo(Ge((be) => d.value = !0, ["prevent"]), ["enter"]))
              }, null, 40, Sfe),
              R("button", {
                id: e.htmlFor,
                type: "button",
                tabindex: "-1",
                popovertarget: le,
                disabled: e.disabled,
                "aria-label": e.placeholder,
                class: x(K.$style.triggerButton)
              }, null, 10, xfe),
              R("div", {
                class: x([K.$style.content, { [K.$style.withClear]: H.value }])
              }, [
                re.value ? (v(), y(Se, { key: 0 }, [
                  u.value ? (v(), y("div", {
                    key: 0,
                    class: x(K.$style.rangeGroup)
                  }, [
                    R("span", {
                      class: x(_.value ? K.$style.value : K.$style.placeholder)
                    }, se(_.value || j.value), 3),
                    R("span", {
                      class: x(K.$style.rangeSeparator)
                    }, "–", 2),
                    R("span", {
                      class: x(ne.value ? K.$style.value : K.$style.placeholder)
                    }, se(ne.value || j.value), 3)
                  ], 2)) : (v(), y("span", {
                    key: 1,
                    class: x(K.$style.value)
                  }, se(ce.value), 3)),
                  H.value ? (v(), y("button", {
                    key: 2,
                    type: "button",
                    tabindex: "-1",
                    class: x(K.$style.clearButton),
                    onClick: Ge(oe, ["stop"])
                  }, [
                    te(Fe, {
                      icon: "phosphor/x",
                      size: "12px",
                      class: x(K.$style.clearIcon)
                    }, null, 8, ["class"])
                  ], 2)) : V("", !0)
                ], 64)) : (v(), y("span", {
                  key: 1,
                  class: x(K.$style.placeholder)
                }, se(e.placeholder), 3)),
                ve(K.$slots, "default")
              ], 2)
            ], 2)
          ]),
          _: 2
        }, 1032, ["appearance", "focused", "alert"]))
      ]),
      default: Q(() => [
        te(Ev, {
          modelValue: i.value,
          "onUpdate:modelValue": G[15] || (G[15] = (le) => i.value = le),
          "all-day": r.value,
          "onUpdate:allDay": G[16] || (G[16] = (le) => r.value = le),
          months: a.value,
          "onUpdate:months": G[17] || (G[17] = (le) => a.value = le),
          columns: l.value,
          "onUpdate:columns": G[18] || (G[18] = (le) => l.value = le),
          mode: e.mode,
          readonly: e.readonly || e.disabled,
          config: e.config,
          onSelectionComplete: me,
          onKeydown: G[19] || (G[19] = Uo((le) => Ie(le, !0), ["enter"]))
        }, null, 8, ["modelValue", "all-day", "months", "columns", "mode", "readonly", "config"])
      ]),
      _: 3
    }, 8, ["is-open", "class", "offset-x"]));
  }
}), Ffe = "_disabledPanel_2kivm_1", Mfe = "_dropdown_2kivm_6", Ife = "_manualTrigger_2kivm_10", Pfe = "_styleProbe_2kivm_14", Dfe = "_manualContent_2kivm_26", Tfe = "_withClear_2kivm_36", kfe = "_manualRangeGroup_2kivm_39", Lfe = "_manualRangeSeparator_2kivm_46", Bfe = "_dropdownTrigger_2kivm_56", Ofe = "_disabled_2kivm_1", Gfe = "_triggerButton_2kivm_66", Hfe = "_content_2kivm_81", Vfe = "_rangeGroup_2kivm_95", _fe = "_value_2kivm_102", Nfe = "_placeholder_2kivm_103", $fe = "_rangeSeparator_2kivm_126", zfe = "_clearButton_2kivm_136", Wfe = "_clearIcon_2kivm_161", Ufe = {
  disabledPanel: Ffe,
  dropdown: Mfe,
  manualTrigger: Ife,
  styleProbe: Pfe,
  manualContent: Dfe,
  withClear: Tfe,
  manualRangeGroup: kfe,
  manualRangeSeparator: Lfe,
  dropdownTrigger: Bfe,
  disabled: Ofe,
  triggerButton: Gfe,
  content: Hfe,
  rangeGroup: Vfe,
  value: _fe,
  placeholder: Nfe,
  rangeSeparator: $fe,
  clearButton: zfe,
  clearIcon: Wfe
}, Kfe = {
  $style: Ufe
}, Zfe = /* @__PURE__ */ we(Afe, [["__cssModules", Kfe]]), qfe = ["aria-label", "title"], jfe = /* @__PURE__ */ de({
  __name: "ConditionRemoveButton",
  emits: ["remove"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, s) => (v(), y("button", {
      type: "button",
      tabindex: "-1",
      class: x(o.$style.root),
      "aria-label": T(Un)("columnFilter.condition.remove"),
      title: T(Un)("columnFilter.condition.remove"),
      "test-id": "column-filter-remove",
      onPointerdown: s[0] || (s[0] = Ge(() => {
      }, ["stop"])),
      onMousedown: s[1] || (s[1] = Ge(() => {
      }, ["prevent"])),
      onClick: s[2] || (s[2] = Ge((i) => n("remove"), ["stop"]))
    }, [
      te(Fe, {
        icon: "phosphor/trash",
        size: "12px"
      })
    ], 42, qfe));
  }
}), Yfe = "_root_1izer_1", Qfe = {
  root: Yfe
}, Jfe = {
  $style: Qfe
}, yf = /* @__PURE__ */ we(jfe, [["__cssModules", Jfe]]), Xfe = {
  date: "dateRange",
  datetime: "datetimeRange",
  time: "timeRange"
};
function f2(e) {
  const t = D(() => xe(e.kind)), n = D(
    () => tc(xe(e.dateFormat), xe(e.datePrecision))
  ), o = D(
    () => Lg(xe(e.timeFormat), xe(e.timePrecision))
  ), s = D(() => $x(t.value, n.value, o.value)), i = D(() => t.value === "time" ? "time" : t.value === "datetime" && Vf(s.value) ? "datetime" : "date"), r = D(() => Xfe[i.value]);
  function a(u) {
    return u ? p1(u, t.value, s.value) : "";
  }
  function l(u) {
    return xg(u, t.value);
  }
  function d(u) {
    return Ux(u, t.value, s.value);
  }
  function c(u, { shortYear: h = !1 } = {}) {
    const g = l(u);
    if (!g) return u;
    let p;
    return t.value === "time" ? p = o.value : Vf(s.value) ? p = `${n.value} ${o.value}` : p = n.value, oc(g, h ? p.replace(/yyyy/g, "yy") : p);
  }
  return { shape: s, pickerMode: i, rangePickerMode: r, toTerm: a, toDate: l, normalizeTerm: d, formatTerm: c };
}
const eme = ["aria-expanded"], tme = /* @__PURE__ */ de({
  __name: "DateConditionInput",
  props: /* @__PURE__ */ dt({
    kind: {},
    dateFormat: {},
    timeFormat: {},
    datePrecision: { default: void 0 },
    timePrecision: { default: void 0 },
    range: { type: Boolean, default: !1 },
    removable: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 }
  }, {
    start: { required: !0 },
    startModifiers: {},
    end: { default: "" },
    endModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["remove", "submit"], ["update:start", "update:end"]),
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, i = lt(e, "start"), r = lt(e, "end"), { pickerMode: a, rangePickerMode: l, toDate: d, toTerm: c } = f2({
      kind: () => o.kind,
      dateFormat: () => o.dateFormat,
      timeFormat: () => o.timeFormat,
      datePrecision: () => o.datePrecision,
      timePrecision: () => o.timePrecision
    }), u = D(() => o.kind === "time" ? "phosphor/clock" : "phosphor/calendar-blank"), h = W(null), g = W(!1), p = W(!1), f = Qe(null), m = D(() => o.range ? f.value ?? [d(i.value), d(r.value)] : d(i.value));
    function C([b, A]) {
      f.value = null, i.value = c(b), r.value = c(A);
    }
    function w(b) {
      if (!Array.isArray(b)) {
        i.value = c(b);
        return;
      }
      const A = b[0] === null != (b[1] === null);
      p.value && A ? f.value = b : C(b);
    }
    return Re(p, (b) => {
      !b && f.value && C(f.value);
    }), t({ focus: () => {
      var b;
      return (b = h.value) == null ? void 0 : b.focus();
    } }), (b, A) => (v(), y("div", {
      class: x(b.$style.root)
    }, [
      te(Fi, {
        class: x(b.$style.row),
        "data-dropdown-anchor": "",
        alert: e.alert,
        focused: g.value || p.value,
        onFocusin: A[3] || (A[3] = (S) => g.value = !0),
        onFocusout: A[4] || (A[4] = (S) => g.value = !1),
        onKeydown: A[5] || (A[5] = Uo(Ge((S) => s("submit"), ["prevent"]), ["enter"]))
      }, {
        before: Q(() => [
          R("button", {
            type: "button",
            tabindex: "-1",
            class: x([b.$style.calendar, p.value && b.$style.calendarOpen]),
            "aria-expanded": p.value,
            "test-id": "column-filter-date-calendar",
            onClick: A[0] || (A[0] = (S) => p.value = !p.value)
          }, [
            te(Fe, {
              icon: u.value,
              size: "16px"
            }, null, 8, ["icon"])
          ], 10, eme)
        ]),
        after: Q(() => [
          te(yf, {
            style: Ke(e.removable ? void 0 : { visibility: "hidden" }),
            onRemove: A[2] || (A[2] = (S) => s("remove"))
          }, null, 8, ["style"])
        ]),
        default: Q(() => [
          te(Zfe, {
            ref_key: "picker",
            ref: h,
            "is-open": p.value,
            "onUpdate:isOpen": A[1] || (A[1] = (S) => p.value = S),
            class: x(b.$style.picker),
            "model-value": m.value,
            mode: e.range ? T(l) : T(a),
            "date-format": e.dateFormat,
            "time-format": e.timeFormat,
            "date-precision": e.datePrecision,
            "time-precision": e.timePrecision,
            clearable: !1,
            appearance: "no-border",
            "manual-input": "",
            "test-id": e.range ? "column-filter-date-range" : "column-filter-date-start",
            "onUpdate:modelValue": w
          }, null, 8, ["is-open", "class", "model-value", "mode", "date-format", "time-format", "date-precision", "time-precision", "test-id"])
        ]),
        _: 1
      }, 8, ["class", "alert", "focused"])
    ], 2));
  }
}), nme = "_root_3eak7_1", ome = "_row_3eak7_7", sme = "_picker_3eak7_11", ime = "_calendar_3eak7_15", rme = "_calendarOpen_3eak7_36", ame = {
  root: nme,
  row: ome,
  picker: sme,
  calendar: ime,
  calendarOpen: rme
}, lme = {
  $style: ame
}, dme = /* @__PURE__ */ we(tme, [["__cssModules", lme]]), cme = ["aria-label"], ume = /* @__PURE__ */ de({
  __name: "ConditionJoinToggle",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = lt(e, "modelValue"), n = D(() => [
      { value: ot.AND, label: ld(ot.AND), testId: "column-filter-join-and" },
      { value: ot.OR, label: ld(ot.OR), testId: "column-filter-join-or" }
    ]), o = D(() => n.value.map((s) => s.label).join(" / "));
    return (s, i) => (v(), y("div", {
      class: x(s.$style.root),
      role: "radiogroup",
      "aria-label": o.value
    }, [
      (v(!0), y(Se, null, We(n.value, (r) => (v(), z(Zt, {
        key: r.value,
        type: "toggle",
        appearance: t.value === r.value ? "primary" : "secondary",
        size: "small",
        shadow: !1,
        "padding-left": "4px",
        "padding-right": "4px",
        role: "radio",
        "aria-checked": t.value === r.value,
        selected: t.value === r.value,
        class: x(s.$style.option),
        "test-id": r.testId,
        onClick: (a) => t.value = r.value
      }, {
        default: Q(() => [
          Oe(se(r.label), 1)
        ]),
        _: 2
      }, 1032, ["appearance", "aria-checked", "selected", "class", "test-id", "onClick"]))), 128))
    ], 10, cme));
  }
}), hme = "_root_cd5u3_1", gme = "_option_cd5u3_8", pme = {
  root: hme,
  option: gme
}, fme = {
  $style: pme
}, mme = /* @__PURE__ */ we(ume, [["__cssModules", fme]]), vme = /* @__PURE__ */ de({
  __name: "ConditionOperatorSelect",
  props: /* @__PURE__ */ dt({
    options: {},
    removable: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["remove"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, s = lt(e, "modelValue"), i = D(() => {
      const l = n.options.map((d) => ({
        id: d.value,
        label: d.label,
        icon: d.icon,
        disabled: d.disabled
      }));
      return l.some((d) => d.id === s.value) ? l : [{ id: s.value, label: mg(s.value), icon: xa[s.value].icon }, ...l];
    }), r = D(() => {
      var l;
      return (l = i.value.find((d) => d.id === s.value)) == null ? void 0 : l.icon;
    });
    function a(l) {
      s.value = l;
    }
    return (l, d) => (v(), z(Wc, {
      "model-value": s.value,
      items: i.value,
      icon: r.value,
      "use-smaller-vertical-padding": "",
      "item-icon-size": "16px",
      "no-mobile-margin": "",
      class: x(l.$style.root),
      "test-id": "column-filter-operator",
      "onUpdate:modelValue": a
    }, Wn({ _: 2 }, [
      e.removable ? {
        name: "after",
        fn: Q(() => [
          te(yf, {
            class: x(l.$style.remove),
            onRemove: d[0] || (d[0] = (c) => o("remove"))
          }, null, 8, ["class"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["model-value", "items", "icon", "class"]));
  }
}), Cme = "_root_2b8wv_1", wme = "_remove_2b8wv_19", yme = {
  root: Cme,
  remove: wme
}, bme = {
  $style: yme
}, Sme = /* @__PURE__ */ we(vme, [["__cssModules", bme]]), xme = ["value", "type", "min", "step", "placeholder", "name", "test-id", "onInput"], Rme = /* @__PURE__ */ de({
  __name: "ConditionTextInput",
  props: /* @__PURE__ */ dt({
    numeric: { type: Boolean, default: !1 },
    range: { type: Boolean, default: !1 },
    removable: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 }
  }, {
    start: { required: !0 },
    startModifiers: {},
    end: { default: "" },
    endModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["remove", "submit"], ["update:start", "update:end"]),
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, i = lt(e, "start"), r = lt(e, "end"), a = D(() => {
      const u = {
        key: "start",
        model: i,
        placeholder: o.range ? Un("columnFilter.range.from") : Un("common.action.enterValue"),
        name: "column-filter-term",
        testId: "column-filter-input",
        last: !o.range
      };
      return o.range ? [
        u,
        {
          key: "end",
          model: r,
          placeholder: Un("columnFilter.range.to"),
          name: "column-filter-term-to",
          testId: "column-filter-input-to",
          last: !0
        }
      ] : [u];
    });
    function l(u, h) {
      u.value = h.target.value;
    }
    const d = /* @__PURE__ */ new Map();
    function c(u, h) {
      h instanceof HTMLInputElement ? d.set(u, h) : d.delete(u);
    }
    return t({ focus: () => {
      var u;
      return (u = d.get("start")) == null ? void 0 : u.focus();
    } }), (u, h) => (v(), y("div", {
      class: x(u.$style.root)
    }, [
      (v(!0), y(Se, null, We(a.value, (g) => (v(), z(Fi, {
        key: g.key,
        alert: e.alert
      }, Wn({
        default: Q(() => [
          R("input", {
            ref_for: !0,
            ref: (p) => c(g.key, p),
            value: g.model.value,
            type: e.numeric ? "number" : "text",
            min: e.numeric ? 0 : void 0,
            step: e.numeric ? "any" : void 0,
            placeholder: g.placeholder,
            name: g.name,
            autocomplete: "off",
            "data-lpignore": "true",
            "data-form-type": "other",
            "test-id": g.testId,
            onInput: (p) => l(g.model, p),
            onKeydown: h[0] || (h[0] = Uo(Ge((p) => s("submit"), ["prevent"]), ["enter"]))
          }, null, 40, xme)
        ]),
        _: 2
      }, [
        e.removable && g.last ? {
          name: "after",
          fn: Q(() => [
            te(yf, {
              onRemove: h[1] || (h[1] = (p) => s("remove"))
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["alert"]))), 128))
    ], 2));
  }
}), Eme = "_root_34qs8_1", Ame = {
  root: Eme
}, Fme = {
  $style: Ame
}, Mme = /* @__PURE__ */ we(Rme, [["__cssModules", Fme]]), Ime = "input, textarea, select, button, [tabindex]";
function Pme(e, t) {
  const n = Array.from(e.querySelectorAll(Ime)).filter(
    (o) => o.tabIndex >= 0 && !o.matches(":disabled") && !o.closest("[inert]") && o.checkVisibility({ checkVisibilityCSS: !0 })
  );
  return t !== null && n.at(-1) === t;
}
const Dme = (e) => e.term === "" && e.termTo === "";
function Tme(e) {
  const t = W([]), n = D(() => t.value.map((C) => C.row)), o = D(() => t.value.map((C) => C.key));
  let s = 0;
  const i = (C) => Pr(C, T(e.compare)), r = (C) => Pr(C);
  function a(C) {
    return { key: s++, row: que(xe(e.defaultOperator), C) };
  }
  function l(C) {
    C.length === 0 && C.push(a(ot.AND)), C[0].row.join !== ot.AND && (C[0] = { ...C[0], row: { ...C[0].row, join: ot.AND } });
    const w = () => C[C.length - 1].row;
    for (; C.length > 1 && Dme(w()) && !r(C[C.length - 2].row); ) C.pop();
    r(w()) && C.push(a(ot.OR)), t.value = C;
  }
  function d(C, w) {
    t.value[C] && l(t.value.map((b, A) => A === C ? { ...b, row: { ...b.row, ...w } } : b));
  }
  function c(C, w) {
    const b = n.value[C];
    if (!b) return;
    const A = fi(w);
    d(C, {
      operator: w,
      term: A ? "" : b.term,
      termTo: w === De.IN_RANGE ? b.termTo : ""
    });
  }
  function u(C, w, b = "term") {
    d(C, { [b]: w });
  }
  function h(C, w) {
    C > 0 && d(C, { join: w });
  }
  function g(C) {
    l(t.value.filter((w, b) => b !== C));
  }
  function p(C) {
    l(C.map((w) => ({ key: s++, row: { ...w } })));
  }
  const f = D(() => d2(n.value, T(e.compare))), m = D(
    () => Math.max(
      0,
      n.value.findIndex((C) => !i(C))
    )
  );
  return l([]), {
    rows: n,
    keys: o,
    completeRows: f,
    focusIndex: m,
    setOperator: c,
    setTerm: u,
    setJoin: h,
    removeRow: g,
    replaceAll: p
  };
}
const kme = ["onFocusout"], Lme = /* @__PURE__ */ de({
  __name: "SCAConditionBuilder",
  props: {
    kind: {},
    operatorOptions: {},
    defaultOperator: {},
    dateFormat: {},
    rows: {}
  },
  emits: ["change", "submit"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, i = D(() => {
      var E;
      return Zue(o.kind, (E = o.dateFormat) == null ? void 0 : E.valueKind);
    }), r = Tme({ defaultOperator: () => o.defaultOperator, compare: i }), a = Uv(/* @__PURE__ */ new Set()), l = D(
      () => r.rows.value.map((E, M) => {
        const I = r.keys.value[M];
        return {
          row: E,
          index: M,
          key: I,
          valueless: fi(E.operator),
          complete: Pr(E),
          range: E.operator === De.IN_RANGE,
          rangeError: cg(E, i.value) && !a.has(I)
        };
      })
    ), d = D(
      () => o.kind === "date" ? Un("columnFilter.range.invalidDate") : Un("columnFilter.range.invalidNumber")
    );
    let c;
    function u() {
      const E = r.completeRows.value, M = JSON.stringify(E);
      M !== c && (c = M, s("change", E));
    }
    function h(E, M) {
      r.setOperator(E, M), u();
      const I = fi(M) ? r.rows.value.length - 1 : E;
      Xe(() => S(I));
    }
    function g(E, M, I) {
      a.add(r.keys.value[E]), r.setTerm(E, M, I), u();
    }
    function p(E, M) {
      M.currentTarget.contains(M.relatedTarget) || a.delete(E);
    }
    function f() {
      a.clear(), !r.rows.value.some((E) => cg(E, i.value)) && s("submit");
    }
    function m(E, M) {
      r.setJoin(E, M), u();
    }
    function C(E) {
      r.removeRow(E), u();
    }
    Re(
      () => o.rows,
      (E) => {
        const M = JSON.stringify(E);
        M !== c && (c = M, r.replaceAll(E));
      },
      { deep: !0, immediate: !0 }
    );
    const w = /* @__PURE__ */ new Map();
    function b(E, M) {
      M ? w.set(E, M) : w.delete(E);
    }
    function A(E) {
      E.defaultPrevented || !Pme(E.currentTarget, E.target) || (E.preventDefault(), f());
    }
    function S(E) {
      var M;
      (M = w.get(r.keys.value[E])) == null || M.focus();
    }
    async function F() {
      await Xe(), S(r.focusIndex.value);
    }
    return t({ focus: F }), (E, M) => (v(), z(Y2, {
      tag: "div",
      "enter-from-class": E.$style.collapsed,
      "leave-to-class": E.$style.collapsed,
      "enter-active-class": E.$style.collapsibleAnimating,
      "leave-active-class": E.$style.collapsibleAnimating,
      "test-id": "column-filter-builder",
      onKeydown: Uo(Ge(A, ["exact"]), ["tab"])
    }, {
      default: Q(() => [
        (v(!0), y(Se, null, We(l.value, (I) => (v(), y("div", {
          key: I.key,
          class: x([E.$style.collapsible, E.$style.row]),
          onFocusout: (P) => p(I.key, P)
        }, [
          R("div", {
            class: x([E.$style.collapsibleContent, E.$style.content])
          }, [
            I.index > 0 ? (v(), z(mme, {
              key: 0,
              class: x(E.$style.join),
              "model-value": I.row.join,
              "onUpdate:modelValue": (P) => m(I.index, P)
            }, null, 8, ["class", "model-value", "onUpdate:modelValue"])) : V("", !0),
            R("div", {
              class: x(E.$style.operatorLine)
            }, [
              te(Sme, {
                class: x(E.$style.operator),
                options: e.operatorOptions,
                "model-value": I.row.operator,
                removable: I.valueless,
                "onUpdate:modelValue": (P) => h(I.index, P),
                onRemove: (P) => C(I.index)
              }, null, 8, ["class", "options", "model-value", "removable", "onUpdate:modelValue", "onRemove"])
            ], 2),
            I.valueless ? V("", !0) : (v(), y(Se, { key: 1 }, [
              e.dateFormat ? (v(), z(dme, {
                key: 0,
                ref_for: !0,
                ref: (P) => b(I.key, P),
                kind: e.dateFormat.valueKind,
                "date-format": e.dateFormat.dateFormat,
                "time-format": e.dateFormat.timeFormat,
                "date-precision": e.dateFormat.datePrecision,
                "time-precision": e.dateFormat.timePrecision,
                range: I.range,
                removable: I.complete,
                alert: I.rangeError,
                start: I.row.term,
                end: I.row.termTo,
                "onUpdate:start": (P) => g(I.index, P, "term"),
                "onUpdate:end": (P) => g(I.index, P, "termTo"),
                onRemove: (P) => C(I.index),
                onSubmit: f
              }, null, 8, ["kind", "date-format", "time-format", "date-precision", "time-precision", "range", "removable", "alert", "start", "end", "onUpdate:start", "onUpdate:end", "onRemove"])) : (v(), z(Mme, {
                key: 1,
                ref_for: !0,
                ref: (P) => b(I.key, P),
                numeric: e.kind === "number",
                range: I.range,
                removable: I.complete,
                alert: I.rangeError,
                start: I.row.term,
                end: I.row.termTo,
                "onUpdate:start": (P) => g(I.index, P, "term"),
                "onUpdate:end": (P) => g(I.index, P, "termTo"),
                onRemove: (P) => C(I.index),
                onSubmit: f
              }, null, 8, ["numeric", "range", "removable", "alert", "start", "end", "onUpdate:start", "onUpdate:end", "onRemove"])),
              I.rangeError ? (v(), z(Gr, {
                key: 2,
                intent: "alert",
                "show-icon": !1,
                "test-id": "column-filter-range-error"
              }, {
                default: Q(() => [
                  Oe(se(d.value), 1)
                ]),
                _: 1
              })) : V("", !0)
            ], 64))
          ], 2)
        ], 42, kme))), 128))
      ]),
      _: 1
    }, 8, ["enter-from-class", "leave-to-class", "enter-active-class", "leave-active-class", "onKeydown"]));
  }
}), Bme = "_collapsible_4io9g_1", Ome = "_collapsibleContent_4io9g_12", Gme = "_collapsibleAnimating_4io9g_16", Hme = "_collapsed_4io9g_20", Vme = "_row_4io9g_25", _me = "_content_4io9g_34", Nme = "_join_4io9g_39", $me = "_operatorLine_4io9g_43", zme = "_operator_4io9g_43", Wme = {
  collapsible: Bme,
  collapsibleContent: Ome,
  collapsibleAnimating: Gme,
  collapsed: Hme,
  row: Vme,
  content: _me,
  join: Nme,
  operatorLine: $me,
  operator: zme
}, Ume = {
  $style: Wme
}, m2 = /* @__PURE__ */ we(Lme, [["__cssModules", Ume]]), eh = (e) => JSON.stringify(e ?? null);
function v2(e) {
  let t, n = !1, o;
  function s() {
    n = !1, clearTimeout(o);
  }
  function i(h) {
    const g = eh(h);
    g !== t && (t = g, e.onModelChange(h));
  }
  function r() {
    s(), i(e.build());
  }
  function a() {
    n = !0, clearTimeout(o), o = setTimeout(l, F8);
  }
  function l() {
    n && r();
  }
  ro(l);
  function d() {
    s(), i(null);
  }
  function c(h) {
    s(), t = eh(h), e.adopt(h);
  }
  function u() {
    c(xe(e.model));
  }
  return Re(
    () => xe(e.model),
    (h) => {
      eh(h) !== t && c(h);
    },
    { deep: !0, immediate: !0 }
  ), { stage: a, apply: r, flush: l, clear: d, readopt: u };
}
function Kme(e) {
  const t = D(() => xe(e.config)), n = D(() => t.value.kind === "date" ? t.value : null), o = D(
    () => t.value.kind === "date" ? De.EQUALS : t.value.defaultOperator
  ), s = f2({
    kind: () => {
      var c;
      return ((c = n.value) == null ? void 0 : c.valueKind) ?? "date";
    },
    dateFormat: () => {
      var c;
      return ((c = n.value) == null ? void 0 : c.dateFormat) ?? R8;
    },
    timeFormat: () => {
      var c;
      return ((c = n.value) == null ? void 0 : c.timeFormat) ?? E8;
    },
    datePrecision: () => {
      var c;
      return (c = n.value) == null ? void 0 : c.datePrecision;
    },
    timePrecision: () => {
      var c;
      return (c = n.value) == null ? void 0 : c.timePrecision;
    }
  }), i = W([]), r = v2({
    model: e.model,
    onModelChange: e.onModelChange,
    build: () => {
      const c = xe(e.colKey), u = c ? ug(c, i.value) : null;
      return u ? [u] : null;
    },
    adopt: (c) => {
      const u = xe(e.colKey), h = (c == null ? void 0 : c.find((g) => g.colKey === u)) ?? (c == null ? void 0 : c[0]);
      i.value = c2(h, {
        kind: t.value.kind,
        defaultOperator: o.value,
        normalizeTerm: n.value ? s.normalizeTerm : void 0
      });
    }
  });
  function a(c) {
    i.value = [...c], r.stage();
  }
  function l() {
    i.value = [], r.clear();
  }
  Re(s.shape, () => {
    n.value && r.readopt();
  });
  const d = D(() => n.value ? s.formatTerm : void 0);
  return {
    rows: Qo(i),
    defaultOperator: o,
    formatTerm: d,
    change: a,
    flush: r.flush,
    clear: l
  };
}
const Zme = /* @__PURE__ */ de({
  __name: "SCAConditionFilter",
  props: {
    colKey: {},
    config: {},
    model: {},
    hovered: { type: Boolean }
  },
  emits: ["model-change"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = W(!1), i = W(null), r = Kme({
      colKey: () => n.colKey,
      config: () => n.config,
      model: () => n.model,
      onModelChange: (c) => o("model-change", c)
    }), a = D(
      () => n.config.kind === "date" ? oh("date") : oh(n.config.kind, n.config.excludedOperators, n.config.disabledOperators)
    ), l = D(() => h2(r.rows.value, { formatTerm: r.formatTerm.value })), d = D(() => l.value !== "");
    return (c, u) => (v(), z(l2, {
      open: s.value,
      "onUpdate:open": u[1] || (u[1] = (h) => s.value = h),
      summary: l.value,
      active: d.value,
      hovered: e.hovered,
      "test-id-prefix": "column-filter",
      onPositioned: u[2] || (u[2] = (h) => {
        var g;
        return (g = i.value) == null ? void 0 : g.focus();
      }),
      onClosed: u[3] || (u[3] = (h) => T(r).flush()),
      onClear: T(r).clear
    }, {
      default: Q(() => [
        R("div", {
          class: x([c.$style.popup, e.config.kind === "date" && c.$style.popupDate]),
          "test-id": "column-filter-popup"
        }, [
          te(m2, {
            ref_key: "builder",
            ref: i,
            kind: e.config.kind,
            "operator-options": a.value,
            "default-operator": T(r).defaultOperator.value,
            "date-format": e.config.kind === "date" ? e.config : void 0,
            rows: T(r).rows.value,
            onChange: T(r).change,
            onSubmit: u[0] || (u[0] = (h) => s.value = !1)
          }, null, 8, ["kind", "operator-options", "default-operator", "date-format", "rows", "onChange"])
        ], 2)
      ]),
      _: 1
    }, 8, ["open", "summary", "active", "hovered", "onClear"]));
  }
}), qme = "_popup_13xx8_1", jme = "_popupDate_13xx8_5", Yme = {
  popup: qme,
  popupDate: jme
}, Qme = {
  $style: Yme
}, Jme = /* @__PURE__ */ we(Zme, [["__cssModules", Qme]]), Xme = /* @__PURE__ */ de({
  __name: "SCASearchInput",
  props: {
    disabled: { type: Boolean, default: !1 },
    appearance: { default: void 0 },
    fixedWidth: { type: Boolean, default: !1 },
    showClearIcon: { type: Boolean, default: !0 },
    isNavBarSearch: { type: Boolean, default: !1 },
    showShadow: { type: Boolean, default: !1 },
    inverted: { type: Boolean, default: !1 }
  },
  emits: ["clear"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, s) => (v(), z(Fi, {
      appearance: e.appearance,
      inverted: e.inverted,
      disabled: e.disabled,
      "fixed-width": e.fixedWidth,
      class: x([o.$style.inputBase, { [o.$style.inputBaseNavBar]: e.isNavBarSearch, [o.$style.shadowed]: e.showShadow }]),
      "fixed-height": e.isNavBarSearch
    }, Wn({
      default: Q(() => [
        ve(o.$slots, "default"),
        ve(o.$slots, "after")
      ]),
      _: 2
    }, [
      e.showClearIcon ? {
        name: "after",
        fn: Q(() => [
          te(Fe, {
            class: x({
              [o.$style.clearIcon]: !e.disabled,
              [o.$style.borderAppearanceMargin]: e.appearance === "border",
              [o.$style.navBarIconClear]: e.isNavBarSearch
            }),
            disabled: e.disabled || !e.showClearIcon,
            size: "12px",
            icon: "phosphor/x",
            onClick: s[0] || (s[0] = (i) => n("clear", i))
          }, null, 8, ["class", "disabled"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["appearance", "inverted", "disabled", "fixed-width", "class", "fixed-height"]));
  }
}), e0e = "_searchIcon_spqs5_1", t0e = "_clearIcon_spqs5_6", n0e = "_borderAppearanceMargin_spqs5_15", o0e = "_inputBase_spqs5_19", s0e = "_inputBaseNavBar_spqs5_26", i0e = "_navBarIconSearch_spqs5_30", r0e = "_navBarIconClear_spqs5_36", a0e = "_shadowed_spqs5_41", l0e = {
  searchIcon: e0e,
  clearIcon: t0e,
  borderAppearanceMargin: n0e,
  inputBase: o0e,
  inputBaseNavBar: s0e,
  navBarIconSearch: i0e,
  navBarIconClear: r0e,
  shadowed: a0e
}, d0e = {
  $style: l0e
}, bf = /* @__PURE__ */ we(Xme, [["__cssModules", d0e]]), c0e = /* @__PURE__ */ de({
  __name: "ColumnFilterDropdownToolbar",
  props: {
    resetDisabled: { type: Boolean }
  },
  emits: ["apply", "reset"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, s) => (v(), y("div", {
      class: x(o.$style.toolbar)
    }, [
      te(ut, {
        class: x(o.$style.button),
        size: "small",
        appearance: "secondary",
        icon: "phosphor/check",
        "aria-label": o.$t("common.action.apply"),
        title: o.$t("common.action.apply"),
        "test-id": "column-filter-apply",
        onClick: s[0] || (s[0] = (i) => n("apply"))
      }, null, 8, ["class", "aria-label", "title"]),
      te(ut, {
        class: x(o.$style.button),
        size: "small",
        appearance: "secondary",
        icon: "phosphor/arrow-counter-clockwise",
        "aria-label": o.$t("common.action.clear"),
        title: o.$t("common.action.clear"),
        disabled: e.resetDisabled,
        "test-id": "column-filter-reset",
        onClick: s[1] || (s[1] = (i) => n("reset"))
      }, null, 8, ["class", "aria-label", "title", "disabled"]),
      R("div", {
        class: x(o.$style.content)
      }, [
        ve(o.$slots, "default")
      ], 2),
      ve(o.$slots, "trailing")
    ], 2));
  }
}), u0e = "_toolbar_120vu_1", h0e = "_button_120vu_12", g0e = "_content_120vu_17", p0e = {
  toolbar: u0e,
  button: h0e,
  content: g0e
}, f0e = {
  $style: p0e
}, m0e = /* @__PURE__ */ we(c0e, [["__cssModules", f0e]]), v0e = /* @__PURE__ */ de({
  __name: "ListConditionsPanel",
  props: {
    disabled: { type: Boolean },
    disabledOperators: {},
    rows: {}
  },
  emits: ["change", "closed", "submit"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = W(!1), i = W(null);
    function r() {
      s.value = !1, o("submit");
    }
    const a = D(() => oh("text", [], n.disabledOperators));
    return (l, d) => (v(), z(Yt, {
      "is-open": s.value,
      "onUpdate:isOpen": d[1] || (d[1] = (c) => s.value = c),
      placement: "right-start",
      "offset-y": 6.75,
      trigger: "click",
      onPositioned: d[2] || (d[2] = (c) => {
        var u;
        return (u = i.value) == null ? void 0 : u.focus();
      }),
      onClosed: d[3] || (d[3] = (c) => o("closed"))
    }, {
      trigger: Q(({ target: c }) => [
        te(ut, {
          popovertarget: c,
          class: x(l.$style.trigger),
          disabled: e.disabled,
          size: "small",
          appearance: "secondary",
          icon: "phosphor/caret-right",
          "aria-label": l.$t("columnFilter.list.openConditions"),
          title: l.$t("columnFilter.list.openConditions"),
          "test-id": "column-filter-list-conditions"
        }, null, 8, ["popovertarget", "class", "disabled", "aria-label", "title"])
      ]),
      default: Q(() => [
        R("div", {
          class: x(l.$style.panel),
          "test-id": "column-filter-list-conditions-panel"
        }, [
          te(m2, {
            ref_key: "builder",
            ref: i,
            kind: "text",
            "operator-options": a.value,
            "default-operator": T(jv),
            rows: e.rows,
            onChange: d[0] || (d[0] = (c) => o("change", c)),
            onSubmit: r
          }, null, 8, ["operator-options", "default-operator", "rows"])
        ], 2)
      ]),
      _: 1
    }, 8, ["is-open"]));
  }
}), C0e = "_trigger_asd3v_1", w0e = "_panel_asd3v_6", y0e = {
  trigger: C0e,
  panel: w0e
}, b0e = {
  $style: y0e
}, S0e = /* @__PURE__ */ we(v0e, [["__cssModules", b0e]]), x0e = /* @__PURE__ */ de({
  __name: "SCATextHighlighter",
  props: {
    text: { type: [String, Number, Boolean, Array, null], default: "" },
    searchTerm: { default: "" },
    startLength: { default: 0 }
  },
  setup(e) {
    const t = e, n = D(() => {
      let o = "";
      return t.text == null ? o = "" : typeof t.text == "string" || typeof t.text == "number" ? o = String(t.text) : typeof t.text == "boolean" ? o = t.text ? "true" : "false" : Array.isArray(t.text) ? o = t.text.join(", ") : o = "", !t.searchTerm || t.startLength !== void 0 && t.searchTerm.length <= t.startLength ? [o] : yA(o, t.searchTerm);
    });
    return (o, s) => (v(), y("span", {
      class: x(o.$style.label)
    }, [
      (v(!0), y(Se, null, We(n.value, (i, r) => (v(), y(Se, { key: r }, [
        typeof i == "object" ? (v(), y("span", {
          key: 0,
          class: x(o.$style.highlight)
        }, se(i.highlight), 3)) : (v(), y(Se, { key: 1 }, [
          Oe(se(i), 1)
        ], 64))
      ], 64))), 128))
    ], 2));
  }
}), R0e = "_highlight_jk56p_1", E0e = {
  highlight: R0e
}, A0e = {
  $style: E0e
}, gi = /* @__PURE__ */ we(x0e, [["__cssModules", A0e]]), F0e = ["test-id", "checked"], M0e = /* @__PURE__ */ de({
  __name: "ListFilterOption",
  props: {
    label: {},
    checked: { type: Boolean },
    indeterminate: { type: Boolean, default: !1 },
    searchTerm: { default: "" },
    testId: { default: void 0 },
    color: { default: void 0 }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = D(() => n.checked || n.indeterminate);
    function i(l) {
      const d = l.target;
      o("change", d.checked), d.checked = s.value;
    }
    const r = W(null), a = al(r, () => n.label);
    return (l, d) => (v(), y("label", {
      class: x(l.$style.option)
    }, [
      te(Ts, {
        checked: s.value,
        deselect: e.indeterminate
      }, {
        default: Q(() => [
          R("input", {
            type: "checkbox",
            "test-id": e.testId,
            checked: s.value,
            onChange: i
          }, null, 40, F0e)
        ]),
        _: 1
      }, 8, ["checked", "deselect"]),
      e.color ? (v(), z(no, {
        key: 0,
        class: x(l.$style.tag),
        style: Ke({ color: e.color.textColor, backgroundColor: e.color.bgColor }),
        tabindex: "-1"
      }, {
        default: Q(() => [
          R("span", {
            ref_key: "textRef",
            ref: r,
            class: x(l.$style.text)
          }, [
            te(gi, {
              text: e.label,
              "search-term": e.searchTerm
            }, null, 8, ["text", "search-term"])
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "style"])) : (v(), y("span", {
        key: 1,
        ref_key: "textRef",
        ref: r,
        class: x(l.$style.text)
      }, [
        te(gi, {
          text: e.label,
          "search-term": e.searchTerm
        }, null, 8, ["text", "search-term"])
      ], 2)),
      T(a) ? (v(), z(zt, {
        key: 2,
        target: r.value,
        text: e.label
      }, null, 8, ["target", "text"])) : V("", !0)
    ], 2));
  }
}), I0e = "_option_6k7tk_1", P0e = "_tag_6k7tk_19", D0e = "_text_6k7tk_28", T0e = {
  option: I0e,
  tag: P0e,
  text: D0e
}, k0e = {
  $style: T0e
}, th = /* @__PURE__ */ we(M0e, [["__cssModules", k0e]]), L0e = /* @__PURE__ */ de({
  __name: "ListOptionsSkeleton",
  setup(e) {
    const t = [72, 104, 56, 88];
    return (n, o) => (v(), y("div", {
      class: x(n.$style.skeleton),
      "aria-hidden": "true",
      "test-id": "column-filter-list-skeleton"
    }, [
      (v(), y(Se, null, We(t, (s) => R("div", {
        key: s,
        class: x(n.$style.row)
      }, [
        te(dg, {
          width: "16px",
          height: "16px",
          "border-radius": "var(--border-radius-small)"
        }),
        te(dg, {
          width: `${s}px`,
          height: "var(--size-2xSmall)",
          "border-radius": "var(--border-radius-medium)"
        }, null, 8, ["width"])
      ], 2)), 64))
    ], 2));
  }
}), B0e = "_skeleton_16w2i_1", O0e = "_row_16w2i_7", G0e = {
  skeleton: B0e,
  row: O0e
}, H0e = {
  $style: G0e
}, V0e = /* @__PURE__ */ we(L0e, [["__cssModules", H0e]]);
function _0e(e, t, n, { blankOption: o = !1, multiValue: s = !1 } = {}) {
  const i = new Set(e), r = n.filter((u) => i.has(u)), a = n.filter((u) => !i.has(u)), l = o && t, d = r.length + (l ? 1 : 0), c = a.length + (o && !l ? 1 : 0);
  return c === 0 ? null : d === 0 ? "none" : a.length === 0 || !s && c <= d ? { mode: "exclude", ids: a, blank: l } : { mode: "include", ids: r, blank: l };
}
function N0e(e) {
  const { colKey: t, selection: n, conditionRows: o, searchColKey: s } = e, i = n ? $0e(t, n, e) : null;
  if (s) {
    const a = [i, ug(s, o)].filter(
      (l) => l !== null
    );
    return a.length > 0 ? a : null;
  }
  const r = ug(t, o);
  return r ? [
    { colKey: t, logicalOperator: ot.AND, conditions: i ? [i, r] : [r] }
  ] : i ? [i] : null;
}
function $0e(e, t, n) {
  const o = t.mode === "exclude", s = t.ids.map((i) => z0e(e, i, n.pairColKey, o));
  if (n.blankOption && t.blank !== o) {
    const i = rd(e, o ? De.NOT_BLANK : De.BLANK, "");
    o ? s.unshift(i) : s.push(i);
  }
  return s.length === 0 ? null : { colKey: e, logicalOperator: o ? ot.AND : ot.OR, conditions: s };
}
function z0e(e, t, n, o) {
  const s = o ? De.NOT_EQUALS : De.EQUALS, i = n ? m1(t) : null;
  return !n || !i ? rd(e, s, t) : {
    colKey: e,
    logicalOperator: o ? ot.OR : ot.AND,
    conditions: [rd(e, s, i.term), rd(n, s, i.pairTerm)]
  };
}
function rd(e, t, n) {
  return { colKey: e, filterTerm: n, operator: t };
}
function W0e(e, t, n = {}) {
  const { searchColKey: o } = n, s = e == null ? void 0 : e.find((l) => l.colKey === t), { selection: i, conditionRows: r } = U0e(s, t, n);
  if (!o) return { selection: i, conditionRows: r };
  const a = e == null ? void 0 : e.find((l) => l.colKey === o);
  return { selection: i, conditionRows: ea(a) };
}
function U0e(e, t, n) {
  if (!e || e.conditions.length === 0) return { selection: null, conditionRows: [] };
  const o = Av(e, t, n);
  if (o !== void 0) return { selection: o, conditionRows: [] };
  const [s, i] = e.conditions;
  if (!e.conditions.some(to)) {
    const r = e.conditions, a = r.filter(Kd).map((l) => l.filterTerm).filter(Boolean);
    return {
      selection: a.length > 0 ? { mode: "include", ids: a, blank: !1 } : null,
      conditionRows: ea({ ...e, conditions: r.filter((l) => !Kd(l)) })
    };
  }
  if (e.logicalOperator === ot.AND && e.conditions.length === 1 && to(s))
    return { selection: null, conditionRows: ea(s) };
  if (e.logicalOperator === ot.AND && e.conditions.length === 2 && to(i)) {
    const r = Av(s, t, n);
    if (r !== void 0) return { selection: r, conditionRows: ea(i) };
  }
  return { selection: null, conditionRows: ea(e) };
}
function Av(e, t, n) {
  if (!to(e) || e.conditions.length === 0) return;
  const o = e.conditions.length === 1, s = o || e.logicalOperator === ot.OR ? Fv(e, "include", t, n) : void 0;
  return s !== void 0 ? s : o || e.logicalOperator === ot.AND ? Fv(e, "exclude", t, n) : void 0;
}
function Fv(e, t, n, { pairColKey: o, blankOption: s }) {
  const i = t === "exclude", r = i ? w2 : Kd, a = i ? De.NOT_BLANK : De.BLANK, l = [];
  let d = 0;
  for (const h of e.conditions)
    if (s && C2(h, a))
      d += 1;
    else if (r(h))
      h.filterTerm && l.push(h.filterTerm);
    else {
      const g = K0e(h, n, o, i);
      if (!g) return;
      l.push(Xx(g.term, g.pairTerm));
    }
  if (d > 1) return;
  const c = i ? d === 0 : d === 1;
  return (i ? l.length === 0 && c : l.length === 0 && !c) ? null : { mode: t, ids: l, blank: c };
}
function C2(e, t) {
  return !to(e) && e.operator === t;
}
function Kd(e) {
  return !to(e) && (!e.operator || e.operator === De.EQUALS);
}
function w2(e) {
  return C2(e, De.NOT_EQUALS);
}
function K0e(e, t, n, o) {
  const s = o ? ot.OR : ot.AND;
  if (!n || !to(e) || e.logicalOperator !== s) return null;
  const i = o ? w2 : Kd;
  if (e.conditions.length !== 2 || !e.conditions.every(i)) return null;
  const r = e.conditions, a = r.find((d) => d.colKey === t), l = r.find((d) => d.colKey === n);
  return !(a != null && a.filterTerm) || !(l != null && l.filterTerm) ? null : { term: a.filterTerm, pairTerm: l.filterTerm };
}
function ea(e) {
  return d2(
    c2(e, { kind: "text", defaultOperator: jv })
  );
}
const Z0e = 150;
function q0e(e) {
  const t = D(() => xe(e.loadOptions)), n = Qe(null), o = W(!1), s = W(!1), i = W(!1);
  let r = 0, a;
  const l = D(() => n.value ?? xe(e.options)), d = D(() => !t.value || n.value !== null), c = D(() => o.value && n.value === null);
  function u() {
    clearTimeout(a), a = void 0;
  }
  Re(
    c,
    (g) => {
      u(), i.value = !1, g && (a = setTimeout(() => i.value = !0, Z0e));
    },
    { flush: "sync" }
  ), Re(
    t,
    () => {
      r++, n.value = null, o.value = !1, s.value = !1;
    },
    { flush: "sync" }
  ), ro(() => {
    r++, u();
  });
  async function h() {
    const g = t.value;
    if (!g) return;
    const p = ++r;
    s.value = !1, o.value = !0;
    let f = null;
    try {
      f = await new Promise((m) => m(g()));
    } catch {
    }
    p === r && (o.value = !1, f ? n.value = f : s.value = n.value === null);
  }
  return {
    options: l,
    ready: d,
    busy: c,
    skeleton: Qo(i),
    /** The last load rejected and nothing has loaded for this loader. */
    failed: Qo(s),
    load: h
  };
}
const Mv = { mode: "include", ids: [], blank: !1 }, j0e = 3;
function Iv(e) {
  return (e == null ? void 0 : e.mode) === "include" && e.ids.length === 0 && !e.blank;
}
function Y0e(e) {
  const t = D(() => xe(e.config)), n = q0e({
    options: () => t.value.options,
    loadOptions: () => t.value.loadOptions
  }), o = n.options, s = D(() => !!t.value.blankOption), i = D(() => ({
    searchColKey: t.value.searchColKey,
    pairColKey: t.value.pairColKey,
    blankOption: s.value
  })), r = Qe(null), a = W([]), l = W(""), d = D(() => Iv(r.value) ? null : r.value), c = v2({
    model: e.model,
    onModelChange: e.onModelChange,
    build: () => N0e({
      colKey: xe(e.colKey),
      selection: d.value,
      conditionRows: a.value,
      ...i.value
    }),
    adopt: (G) => {
      const le = W0e(G, xe(e.colKey), i.value);
      r.value = le.selection, a.value = le.conditionRows;
    }
  });
  function u(G) {
    var le;
    return t.value.pairColKey ? ((le = m1(G)) == null ? void 0 : le.term) ?? G : G;
  }
  const h = D(() => {
    var le;
    const G = new Set(o.value.map((be) => be.id));
    return (((le = r.value) == null ? void 0 : le.ids) ?? []).filter((be) => !G.has(be)).map((be) => ({ id: be, label: u(be) }));
  }), g = D(() => [...h.value, ...o.value]), p = D(() => g.value.map((G) => G.id));
  function f(G) {
    return !l.value || G.toLowerCase().includes(l.value.toLowerCase());
  }
  const m = D(() => g.value.filter((G) => f(G.label))), C = D(() => Un("columnFilter.list.blank")), w = D(() => s.value && f(C.value));
  function b(G) {
    const le = r.value;
    return le ? le.mode === "include" ? le.ids.includes(G) : !le.ids.includes(G) : !0;
  }
  const A = D(() => {
    var G;
    return ((G = r.value) == null ? void 0 : G.blank) ?? !0;
  }), S = D(() => p.value.filter(b)), F = D(() => p.value.length + (s.value ? 1 : 0)), E = D(() => S.value.length + (s.value && A.value ? 1 : 0)), M = D(() => F.value > 0 && E.value === F.value), I = D(() => E.value > 0 && !M.value), P = D(() => [
    ...g.value.filter((G) => b(G.id)).map((G) => G.label),
    ...s.value && A.value ? [C.value] : []
  ]), k = D(() => {
    const G = d.value;
    if (!G) return "";
    const le = new Map(g.value.map((he) => [he.id, he.label])), be = G.ids.map((he) => le.get(he) ?? he), Me = G.mode === "exclude";
    if (s.value && G.blank !== Me && be.push(C.value), !Me) return be.join(", ");
    const Be = P.value;
    return n.ready.value && Be.length > 0 && (Be.length <= j0e || Be.length <= be.length) ? Be.join(", ") : Un("columnFilter.list.allExcept", { values: be.join(", ") });
  }), B = D(() => h2(a.value)), j = D(
    () => [k.value, B.value].filter(Boolean).join(` ${ld(ot.AND)} `)
  ), N = D(() => d.value !== null || a.value.length > 0), re = D(() => !!t.value.textConditions || a.value.length > 0), H = D(() => qv(t.value)), _ = D(() => n.skeleton.value ? "skeleton" : n.busy.value || n.failed.value ? "none" : g.value.length > 0 || s.value && n.ready.value ? "options" : "empty");
  function ne(G, le, be) {
    const Me = _0e(G, le, be, {
      blankOption: s.value,
      multiValue: t.value.multiValue
    });
    r.value = Me === "none" ? Mv : Me, c.stage();
  }
  function ce() {
    n.ready.value && (r.value = M.value ? Mv : null, c.apply());
  }
  function me(G, le) {
    if (!n.ready.value || b(G) === le) return;
    const Me = h.value.some((Be) => Be.id === G) ? p.value.filter((Be) => Be !== G) : p.value;
    ne(
      Me.filter((Be) => Be === G ? le : b(Be)),
      A.value,
      Me
    );
  }
  function Ie(G) {
    !n.ready.value || !s.value || A.value === G || ne(S.value, G, p.value);
  }
  function L(G) {
    a.value = [...G], c.stage();
  }
  function oe() {
    c.flush(), Iv(r.value) && (r.value = null);
  }
  function K() {
    r.value = null, a.value = [], c.clear();
  }
  return {
    selection: Qo(r),
    conditionRows: Qo(a),
    isSelected: b,
    blankChecked: A,
    blankLabel: C,
    blankOptionVisible: w,
    listSearchTerm: l,
    filteredOptions: m,
    optionsView: _,
    optionsSkeleton: n.skeleton,
    loadOptions: n.load,
    allSelected: M,
    someSelected: I,
    summaryText: j,
    hasActiveFilter: N,
    conditionsEnabled: re,
    conditionDisabledOperators: H,
    toggleSelectAll: ce,
    toggleItem: me,
    toggleBlank: Ie,
    changeConditions: L,
    flush: c.flush,
    endEditing: oe,
    clear: K
  };
}
const Q0e = ["placeholder"], J0e = ["aria-busy"], X0e = /* @__PURE__ */ de({
  __name: "SCAListFilter",
  props: {
    colKey: {},
    config: {},
    model: {},
    hovered: { type: Boolean }
  },
  emits: ["model-change"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = W(!1), i = W(null), {
      isSelected: r,
      blankChecked: a,
      blankLabel: l,
      blankOptionVisible: d,
      listSearchTerm: c,
      filteredOptions: u,
      optionsView: h,
      optionsSkeleton: g,
      loadOptions: p,
      allSelected: f,
      someSelected: m,
      summaryText: C,
      hasActiveFilter: w,
      conditionsEnabled: b,
      conditionDisabledOperators: A,
      conditionRows: S,
      toggleSelectAll: F,
      toggleItem: E,
      toggleBlank: M,
      changeConditions: I,
      flush: P,
      endEditing: k,
      clear: B
    } = Y0e({
      colKey: () => n.colKey,
      config: () => n.config,
      model: () => n.model,
      onModelChange: (j) => o("model-change", j)
    });
    return Re(s, (j) => {
      j && p();
    }), (j, N) => (v(), z(l2, {
      open: s.value,
      "onUpdate:open": N[5] || (N[5] = (re) => s.value = re),
      summary: T(C),
      active: T(w),
      hovered: e.hovered,
      "test-id-prefix": "column-filter-list",
      "padding-upset": "",
      onPositioned: N[6] || (N[6] = (re) => {
        var H;
        return (H = i.value) == null ? void 0 : H.focus();
      }),
      onClosed: T(k),
      onClear: T(B)
    }, {
      default: Q(() => [
        R("div", {
          class: x(j.$style.listDropdown)
        }, [
          te(m0e, {
            "reset-disabled": !T(w),
            onApply: N[3] || (N[3] = (re) => s.value = !1),
            onReset: T(B)
          }, {
            trailing: Q(() => [
              te(S0e, {
                rows: T(S),
                disabled: !T(b),
                "disabled-operators": T(A),
                onChange: T(I),
                onClosed: T(P),
                onSubmit: N[2] || (N[2] = (re) => s.value = !1)
              }, null, 8, ["rows", "disabled", "disabled-operators", "onChange", "onClosed"])
            ]),
            default: Q(() => [
              te(bf, {
                appearance: "border",
                "show-clear-icon": T(c).length > 0,
                onClear: N[1] || (N[1] = (re) => c.value = "")
              }, {
                default: Q(() => [
                  Tn(R("input", {
                    ref_key: "searchInput",
                    ref: i,
                    "onUpdate:modelValue": N[0] || (N[0] = (re) => Yo(c) ? c.value = re : null),
                    type: "text",
                    placeholder: j.$t("common.action.search"),
                    "test-id": "column-filter-list-search",
                    class: x(j.$style.searchInput)
                  }, null, 10, Q0e), [
                    [Qd, T(c)]
                  ])
                ]),
                _: 1
              }, 8, ["show-clear-icon"])
            ]),
            _: 1
          }, 8, ["reset-disabled", "onReset"]),
          R("div", {
            class: x(j.$style.listBody),
            "aria-busy": T(g) || void 0
          }, [
            te(ad, {
              "enter-from-class": j.$style.collapsed,
              "leave-to-class": j.$style.collapsed,
              "enter-active-class": j.$style.collapsibleAnimating,
              "leave-active-class": j.$style.collapsibleAnimating
            }, {
              default: Q(() => [
                T(h) === "skeleton" ? (v(), y("div", {
                  key: "skeleton",
                  class: x(j.$style.collapsible)
                }, [
                  R("div", {
                    class: x(j.$style.collapsibleContent)
                  }, [
                    te(V0e)
                  ], 2)
                ], 2)) : T(h) === "options" ? (v(), y("div", {
                  key: "options",
                  class: x([j.$style.collapsible, j.$style.optionsBlock])
                }, [
                  R("div", {
                    class: x([j.$style.collapsibleContent, j.$style.optionsContent])
                  }, [
                    te(th, {
                      label: j.$t("common.action.selectAll"),
                      checked: T(f),
                      indeterminate: T(m),
                      "test-id": "column-filter-list-select-all",
                      onChange: N[4] || (N[4] = (re) => T(F)())
                    }, null, 8, ["label", "checked", "indeterminate"]),
                    T(d) ? (v(), z(th, {
                      key: 0,
                      label: T(l),
                      checked: T(a),
                      "search-term": T(c),
                      "test-id": "column-filter-list-blank",
                      onChange: T(M)
                    }, null, 8, ["label", "checked", "search-term", "onChange"])) : V("", !0),
                    R("div", {
                      class: x(j.$style.itemsList)
                    }, [
                      (v(!0), y(Se, null, We(T(u), (re) => (v(), z(th, {
                        key: re.id,
                        label: re.label,
                        color: re.color,
                        checked: T(r)(re.id),
                        "search-term": T(c),
                        "test-id": `column-filter-list-option-${re.id}`,
                        onChange: (H) => T(E)(re.id, H)
                      }, null, 8, ["label", "color", "checked", "search-term", "test-id", "onChange"]))), 128))
                    ], 2)
                  ], 2)
                ], 2)) : T(h) === "empty" ? (v(), y("div", {
                  key: "empty",
                  class: x(j.$style.collapsible)
                }, [
                  R("div", {
                    class: x(j.$style.collapsibleContent)
                  }, [
                    R("div", {
                      class: x(j.$style.empty),
                      "test-id": "column-filter-list-empty"
                    }, se(j.$t("columnFilter.list.noOptions")), 3)
                  ], 2)
                ], 2)) : V("", !0)
              ]),
              _: 1
            }, 8, ["enter-from-class", "leave-to-class", "enter-active-class", "leave-active-class"])
          ], 10, J0e)
        ], 2)
      ]),
      _: 1
    }, 8, ["open", "summary", "active", "hovered", "onClosed", "onClear"]));
  }
}), eve = "_collapsible_2lcef_1", tve = "_collapsibleContent_2lcef_12", nve = "_collapsibleAnimating_2lcef_16", ove = "_collapsed_2lcef_20", sve = "_searchInput_2lcef_25", ive = "_listDropdown_2lcef_31", rve = "_listBody_2lcef_38", ave = "_optionsBlock_2lcef_46", lve = "_optionsContent_2lcef_57", dve = "_empty_2lcef_63", cve = "_itemsList_2lcef_77", uve = {
  collapsible: eve,
  collapsibleContent: tve,
  collapsibleAnimating: nve,
  collapsed: ove,
  searchInput: sve,
  listDropdown: ive,
  listBody: rve,
  optionsBlock: ave,
  optionsContent: lve,
  empty: dve,
  itemsList: cve
}, hve = {
  $style: uve
}, gve = /* @__PURE__ */ we(X0e, [["__cssModules", hve]]), pve = /* @__PURE__ */ de({
  __name: "SCAColumnFilter",
  props: {
    colKey: {},
    config: {},
    model: {}
  },
  emits: ["model-change"],
  setup(e, { emit: t }) {
    const n = t, o = W(!1);
    function s(i) {
      n("model-change", i);
    }
    return (i, r) => (v(), y("div", {
      "data-column-filter": "",
      "data-dropdown-anchor": "",
      class: x([i.$style.cell, e.config && i.$style.interactive]),
      onMouseenter: r[0] || (r[0] = (a) => o.value = !0),
      onMouseleave: r[1] || (r[1] = (a) => o.value = !1)
    }, [
      e.config ? (v(), y("div", {
        key: 0,
        class: x(i.$style.row)
      }, [
        e.config.kind === "text" || e.config.kind === "number" || e.config.kind === "date" ? (v(), z(Jme, {
          key: 0,
          "col-key": e.colKey,
          config: e.config,
          model: e.model,
          hovered: o.value,
          onModelChange: s
        }, null, 8, ["col-key", "config", "model", "hovered"])) : e.config.kind === "list" ? (v(), z(gve, {
          key: 1,
          "col-key": e.colKey,
          config: e.config,
          model: e.model,
          hovered: o.value,
          onModelChange: s
        }, null, 8, ["col-key", "config", "model", "hovered"])) : V("", !0)
      ], 2)) : V("", !0)
    ], 34));
  }
}), fve = "_cell_1a2ff_1", mve = "_interactive_1a2ff_12", vve = "_row_1a2ff_21", Cve = {
  cell: fve,
  interactive: mve,
  row: vve
}, wve = {
  $style: Cve
}, yve = /* @__PURE__ */ we(pve, [["__cssModules", wve]]), bve = "ag-Grid-AutoColumn";
function Sve(e) {
  var n, o;
  const t = ((o = (n = e.column) == null ? void 0 : n.getColId) == null ? void 0 : o.call(n)) ?? "";
  return typeof e.filterColKey == "string" && e.filterColKey ? e.filterColKey : t === bve && typeof e.originalHiddenColId == "string" && e.originalHiddenColId ? e.originalHiddenColId : t;
}
function xve(e) {
  return e.filterConfig ?? null;
}
const y2 = (() => {
  const e = Q2({ render: () => null });
  return e.use(fg), e._context;
})();
function $Me(e, t) {
  y2.directives[e] = t;
}
function Rve({ event: e }) {
  return e.key === "Tab" && e.target instanceof Element && e.target.closest("[popover]") !== null;
}
class Eve {
  constructor() {
    Ae(this, "eGui");
    Ae(this, "container");
    Ae(this, "params");
    Ae(this, "paramsRef", Qe(null));
    Ae(this, "vnodeRoot");
    Ae(this, "modelRef", W(null));
    Ae(this, "focusHandler");
  }
  init(t) {
    this.params = t, this.paramsRef.value = t, this.eGui = document.createElement("div"), this.container = document.createElement("div"), this.eGui.appendChild(this.container), this.modelRef.value = t.currentParentModel() ?? null, this.renderComponent();
  }
  renderComponent() {
    const t = (n) => {
      this.params.parentFilterInstance((o) => {
        o.setModel(n);
      });
    };
    this.vnodeRoot = vo({
      render: () => {
        const n = this.paramsRef.value;
        return vo(yve, {
          colKey: Sve(n),
          config: xve(n),
          model: this.modelRef.value,
          onModelChange: t
        });
      }
    }), this.vnodeRoot.appContext = y2, dr(this.vnodeRoot, this.container);
  }
  refresh(t) {
    return this.params = t, this.paramsRef.value = t, !0;
  }
  onParentModelChanged(t) {
    this.modelRef.value = t;
  }
  getGui() {
    return this.eGui;
  }
  /**
   * Called by AG Grid after the floating filter GUI has been attached to the DOM.
   * We use this hook to implement focus redirection: AG Grid intentionally focuses
   * the header cell container (.ag-header-cell) for keyboard navigation and accessibility
   * after any UI changes (e.g., when the user enters search text).
   * However, for our custom floating filters, focus should return to the element that held it —
   * the input the user is typing in, or the list option checkbox they just clicked.
   */
  afterGuiAttached(t) {
    if (t != null && t.suppressFocus)
      return;
    let n = this.eGui;
    for (; n && !n.classList.contains("ag-header-cell"); )
      n = n.parentElement;
    n && (this.focusHandler = (o) => {
      const s = o.relatedTarget;
      !s || !this.eGui.contains(s) || o.target === n && s.focus();
    }, n.addEventListener("focusin", this.focusHandler));
  }
  destroy() {
    if (dr(null, this.container), this.focusHandler) {
      let t = this.eGui;
      for (; t && !t.classList.contains("ag-header-cell"); )
        t = t.parentElement;
      t && this.focusHandler && t.removeEventListener("focusin", this.focusHandler);
    }
  }
}
const Ave = ["left", "center", "right"];
function b2(e) {
  switch (e) {
    case "center":
      return "center";
    case "right":
      return "flex-end";
    default:
      return "flex-start";
  }
}
function zMe(e) {
  return { justifyContent: b2(e), textAlign: e ?? "left" };
}
function Fve(e, t) {
  var l;
  const n = Object.fromEntries(
    Ave.map((d) => [`sca-cell-align-${d}`, () => t() === d])
  ), { cellRendererParams: o, headerClass: s } = e, i = (l = e.context) == null ? void 0 : l.defaultAlignment, r = typeof o == "function" ? (d) => {
    const c = o(d), u = t();
    return u ? { ...c, horizontalAlign: u } : c;
  } : Object.defineProperty({ ...o }, "horizontalAlign", { get: t, enumerable: !0 }), a = (d) => {
    const c = typeof s == "function" ? s(d) : s, u = c === void 0 ? [] : Array.isArray(c) ? c : [c], h = t() ?? i;
    return h ? [...u, `sca-header-align-${h}`] : u;
  };
  return {
    ...e,
    cellClassRules: { ...e.cellClassRules, ...n },
    cellRendererParams: r,
    headerClass: a
  };
}
const Mve = /* @__PURE__ */ de({
  __name: "DefaultDetailRenderer",
  props: {
    params: {}
  },
  setup(e) {
    return (t, n) => (v(), y("div", null, "details component"));
  }
}), Ive = { class: "sca-ag-grid-header-tooltip" }, Pve = /* @__PURE__ */ de({
  __name: "SCAAgGridHeaderTooltip",
  props: {
    params: {}
  },
  setup(e) {
    return (t, n) => (v(), y("div", Ive, se(e.params.value), 1));
  }
}), Dve = /* @__PURE__ */ de({
  __name: "TotalRowSelectionIcon",
  props: {
    params: {}
  },
  setup(e) {
    const { t } = fn(), n = W(null), o = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      paddingRight: "var(--space-component-padding-xSmall)"
    };
    return (s, i) => (v(), y("div", {
      ref_key: "iconEl",
      ref: n,
      style: o
    }, [
      te(Fe, {
        icon: "phosphor/sigma",
        size: "20px"
      }),
      te(zt, {
        target: n.value,
        text: T(t)("common.label.totalRowTooltip"),
        "link-label": T(t)("common.label.openColumnManager"),
        onLinkClick: i[0] || (i[0] = (r) => e.params.onManageColumns())
      }, null, 8, ["target", "text", "link-label"])
    ], 512));
  }
}), Tve = { key: 1 }, kve = /* @__PURE__ */ de({
  __name: "TotalRowValueCell",
  props: {
    params: {}
  },
  setup(e) {
    const t = e, n = D(() => ({
      display: "flex",
      alignItems: "center",
      justifyContent: b2(t.params.align),
      gap: "4px",
      width: "100%",
      height: "100%"
    })), o = D(() => t.params.icon), s = D(() => t.params.iconSize ?? "20px"), i = D(() => {
      let r = t.params.value;
      if (r !== null && typeof r == "object" && "value" in r && (r = r.value), r == null || r === "") return "";
      if (t.params.formatValue) return t.params.formatValue(r);
      const a = typeof r == "number" ? r : typeof r == "string" ? Number(r) : NaN;
      return Number.isNaN(a) ? "" : String(a);
    });
    return (r, a) => (v(), y("span", {
      style: Ke(n.value)
    }, [
      o.value ? (v(), z(Fe, {
        key: 0,
        icon: o.value,
        size: s.value
      }, null, 8, ["icon", "size"])) : V("", !0),
      i.value ? (v(), y("span", Tve, se(i.value), 1)) : V("", !0)
    ], 4));
  }
}), Lve = 'a[href], [col-id="ag-Grid-SelectionColumn"]', Bve = /* @__PURE__ */ de({
  __name: "SCAAgGridTable",
  props: {
    colDefs: {},
    rowData: {},
    rowSelection: {},
    pagination: { type: Boolean },
    paginationPageSize: {},
    treeMode: { type: Boolean },
    filterRow: { type: Boolean },
    masterDetail: { type: Boolean },
    getRowNodeId: {},
    autoGroupColumnDef: {},
    licenseKey: {},
    getDataPath: { type: Function },
    domLayout: {},
    gridOptions: {},
    minRowCount: {},
    compactBody: { type: Boolean },
    suppressColumnHide: { type: Boolean },
    columnIdsSuppressHide: {},
    suppressColumnReset: { type: Boolean },
    suppressExpandCollapseMenuItems: { type: Boolean },
    suppressRowFocus: { type: Boolean },
    selectedRowId: {},
    advancedFilterOpen: { type: Boolean },
    userDateFormat: {},
    agGridHeaderStickyTop: {},
    filterRowReadOnly: { type: Boolean },
    tableColumnLayout: {},
    transitioning: { type: Boolean },
    totalRowState: {},
    hasEligibleTotalRowColumn: { type: Boolean },
    columnAlignment: {},
    folderSortMode: {},
    combineWithLabel: {},
    rowGroups: {},
    detailCellRendererComponent: {},
    detailCellRendererParams: { type: [Object, Function] },
    selectionCellRendererSelector: { type: Function }
  },
  emits: ["update:modelValue", "grid-ready", "column-moved", "column-visible", "row-click", "sort-changed", "selection-changed", "filter-changed", "column-resized", "reset-columns", "advanced-filter-changed", "expand-all", "collapse-all", "update:column-alignment", "update:total-row-state", "manage-columns", "update:folder-sort-mode", "update:row-group-columns", "hide-row-group-panel"],
  setup(e, { expose: t, emit: n }) {
    Ls(($) => ({
      v7dfeb7da: N.value
    }));
    const { t: o } = fn(), s = e, i = n, r = D(() => Fue(s.userDateFormat));
    let a = !1;
    a || (wb.setLicenseKey(s.licenseKey), a = !0, Gh.registerModules([o7]), Gh.registerModules([
      nz,
      t$,
      TN,
      n$,
      w$,
      C9,
      w9,
      D9,
      h_
    ]));
    const l = W(/* @__PURE__ */ new Set()), d = W(null), c = W(null), u = W(null), h = Qe(null), g = Qe(null), p = {
      pinned: "left",
      suppressSizeToFit: !0,
      width: 30,
      minWidth: 30,
      maxWidth: 30,
      cellRendererSelector: ($) => {
        var fe;
        return ((fe = s.selectionCellRendererSelector) == null ? void 0 : fe.call(s, $)) ?? ($.node.rowPinned && s.totalRowState !== void 0 ? { component: Dve, params: { onManageColumns: () => i("manage-columns") } } : void 0);
      },
      // The Σ icon on the pinned total row is a static summary, not an interactive cell.
      suppressNavigable: ($) => !!$.node.rowPinned
    }, f = Qe(null), m = Qe(null), C = Qe(null), w = W(!1), b = W(!0), A = {
      sortable: !0,
      resizable: !0,
      filter: wv,
      floatingFilterComponent: Eve,
      suppressHeaderKeyboardEvent: Rve,
      suppressFloatingFilterButton: !0,
      cellDataType: !1,
      // Grid-wide header tooltip for truncated column labels.
      tooltipComponent: Pve,
      // Keeps keyboard Tab from landing on the pinned total row (click-focus is blocked separately
      // via CSS — see ag-grid-theme.scss's .ag-row-pinned .ag-cell border rule).
      suppressNavigable: ($) => !!$.node.rowPinned
    };
    function S($) {
      const fe = $.cellRendererSelector;
      return {
        ...$,
        cellRendererSelector: (ye) => {
          var Ve, Ye;
          if (ye.node.rowPinned && s.totalRowState !== void 0) {
            const et = $.context ?? {};
            return {
              component: kve,
              params: {
                icon: et.totalRowIcon,
                iconSize: et.totalRowIconSize,
                formatValue: et.totalRowValueFormatter,
                align: ((Ye = s.columnAlignment) == null ? void 0 : Ye[((Ve = ye.column) == null ? void 0 : Ve.getColId()) ?? ""]) ?? et.defaultAlignment
              }
            };
          }
          return fe == null ? void 0 : fe(ye);
        }
      };
    }
    function F($) {
      return $.headerTooltip === void 0 && typeof $.headerName == "string" && ($.headerTooltip = $.headerName), $;
    }
    const E = D(() => {
      const $ = H.autoGroupColumnDef(s.colDefs), fe = s.autoGroupColumnDef ?? ($ && S($));
      return fe ? F({ ...fe }) : void 0;
    }), M = D(() => s.columnAlignment !== void 0), I = D(
      () => H.colDefs(s.colDefs).map(($) => {
        var Ye, et;
        let fe = F(S({ ...$ }));
        fe.colId ?? (fe.colId = fe.field);
        const ye = fe.colId, Ve = (Ye = $.context) == null ? void 0 : Ye.defaultAlignment;
        return (M.value || Ve) && ye && (fe = Fve(fe, () => {
          var Jt;
          return ((Jt = s.columnAlignment) == null ? void 0 : Jt[ye]) ?? Ve;
        })), s.advancedFilterOpen ? fe.hide ? (s.treeMode && fe.field && fe.field === ((et = s.autoGroupColumnDef) == null ? void 0 : et.field) ? (fe.filter = fv($), fe.filterParams = vv($), fe.cellDataType = Cv($)) : fe.filter = !1, fe) : (fe.filter = fv($), fe.filterParams = vv($), fe.cellDataType = Cv($), fe) : (fe.filter = wv, fe);
      })
    ), P = D(() => {
      if (s.rowSelection) {
        if (s.rowSelection === "single")
          return { mode: "singleRow", pinned: "left", lockPosition: !0 };
        if (s.rowSelection === "multiple") {
          const $ = { mode: "multiRow", pinned: "left", lockPosition: !0 };
          return H.rowSelection($);
        }
        return H.rowSelection(s.rowSelection);
      }
    }), k = W("#6792f4");
    let B = null;
    Et(() => {
      const $ = () => getComputedStyle(document.documentElement).getPropertyValue("--color-blue-p1").trim();
      k.value = $(), B = new MutationObserver(() => {
        k.value = $();
      }), B.observe(document.documentElement, {
        attributes: !0,
        attributeFilter: ["class", "data-theme", "style"]
      }), requestAnimationFrame(() => {
        nt();
      });
    });
    const j = {
      sortAscending: Zi("phosphor/arrow-up"),
      sortDescending: Zi("phosphor/arrow-down"),
      menuAlt: Zi("phosphor/dots-three-vertical"),
      ...rue(Zi)
    }, N = D(() => `url("${Kt("phosphor/sigma")}")`), re = D(() => LW(k.value)), H = Aue({
      gridWrapper: d,
      gridApi: f,
      rowGroups: () => s.rowGroups,
      theme: re,
      t: o,
      onColumnsChange: ($) => i("update:row-group-columns", $),
      onHidePanel: () => i("hide-row-group-panel"),
      onFilterDrop: ($) => i("filter-changed", $)
    }), { controls: _, rowModel: ne } = H;
    function ce($) {
      i("update:total-row-state", $);
    }
    function me($, fe) {
      i("update:column-alignment", { colId: $, alignment: fe });
    }
    Re(
      () => s.columnAlignment,
      ($, fe) => {
        const ye = f.value;
        if (!ye || ye.isDestroyed()) return;
        const Ve = [.../* @__PURE__ */ new Set([...Object.keys($ ?? {}), ...Object.keys(fe ?? {})])].filter(
          (Ye) => ($ == null ? void 0 : $[Ye]) !== (fe == null ? void 0 : fe[Ye])
        );
        Ve.length && (ye.refreshCells({ columns: Ve, force: !0 }), ye.refreshHeader());
      }
    );
    function Ie($) {
      i("update:folder-sort-mode", $);
    }
    const L = D(
      () => I.value.some(($) => {
        var ye;
        const fe = $.context;
        return fe != null && fe.totalRowExcluded ? !1 : $.cellDataType === "number" || ((ye = $.floatingFilterComponentParams) == null ? void 0 : ye.columnDataType) === "number" || (fe == null ? void 0 : fe.totalRowForced);
      })
    ), oe = D(() => {
      var $;
      return ($ = s.gridOptions) == null ? void 0 : $.pinnedTopRowData;
    }), K = D(() => {
      var $;
      return ($ = s.gridOptions) == null ? void 0 : $.pinnedBottomRowData;
    }), G = ($) => {
      var Sf, xf, Rf, Ef, Af;
      const fe = (ft) => $.defaultItems.includes(ft), ye = (Sf = $.column) == null ? void 0 : Sf.getColId(), Ve = ["sortAscending", "sortDescending", "sortUnSort"].filter(fe), Ye = s.folderSortMode !== void 0;
      if (Ye || Ve.length > 0) {
        const ft = !Ye;
        Ve.push({
          name: o("common.label.sortBy"),
          icon: '<span class="ag-icon ag-icon-sortBy"></span>',
          disabled: ft,
          // AG Grid doesn't propagate a parent item's disabled into its subMenu — repeat per entry.
          subMenu: _0([
            {
              name: o("common.label.foldersOnTop"),
              checked: s.folderSortMode === "foldersOnTop",
              disabled: ft,
              action: () => Ie("foldersOnTop")
            },
            {
              name: s.combineWithLabel ?? o("common.label.combineWithAttachments"),
              checked: s.folderSortMode === "combined",
              disabled: ft,
              action: () => Ie("combined")
            }
          ])
        });
      }
      const et = [];
      if (s.columnAlignment !== void 0) {
        const ft = (ye ? s.columnAlignment[ye] : void 0) ?? ((Rf = (xf = $.column) == null ? void 0 : xf.getColDef().context) == null ? void 0 : Rf.defaultAlignment) ?? "left", Ht = ye === "ag-Grid-AutoColumn", Vt = !!((Af = (Ef = $.column) == null ? void 0 : Ef.getColDef().context) != null && Af.alignmentExcluded), gl = Ht || Vt;
        et.push({
          name: o("common.label.columnAlignment"),
          icon: '<span class="ag-icon ag-icon-alignLeft"></span>',
          disabled: gl,
          // AG Grid doesn't propagate a parent item's disabled into its subMenu — repeat per entry.
          subMenu: _0([
            {
              name: o("common.label.alignLeft"),
              checked: ft === "left",
              disabled: gl,
              action: () => me(ye ?? "", "left")
            },
            {
              name: o("common.label.alignCenter"),
              checked: ft === "center",
              disabled: gl,
              action: () => me(ye ?? "", "center")
            },
            {
              name: o("common.label.alignRight"),
              checked: ft === "right",
              disabled: gl,
              action: () => me(ye ?? "", "right")
            }
          ])
        });
      }
      fe("pinSubMenu") && et.push("pinSubMenu");
      {
        const ft = s.totalRowState ?? { enabled: !1, position: "bottom" }, Ht = !L.value || s.totalRowState === void 0 || s.hasEligibleTotalRowColumn === !1;
        et.push({
          name: o("common.label.totalRow"),
          icon: '<span class="ag-icon ag-icon-sigma"></span>',
          disabled: Ht,
          // AG Grid doesn't propagate a parent MenuItemDef's `disabled` down into its subMenu — each
          // entry has its own independent `action`, so without repeating the flag here the submenu still
          // opens and "Top"/"Bottom" still fire setTotalRowState even though the parent row reads disabled.
          subMenu: [
            {
              name: o("common.label.noTotalRow"),
              checked: !ft.enabled,
              disabled: Ht,
              action: () => ce({ enabled: !1, position: ft.position })
            },
            {
              name: o("common.label.totalRowOnTop"),
              checked: ft.enabled && ft.position === "top",
              disabled: Ht,
              action: () => ce({ enabled: !0, position: "top" })
            },
            {
              name: o("common.label.totalRowAtBottom"),
              checked: ft.enabled && ft.position === "bottom",
              disabled: Ht,
              action: () => ce({ enabled: !0, position: "bottom" })
            }
          ]
        });
      }
      et.push(...H.menuItems($));
      const Jt = [];
      if (fe("autoSizeThis") && Jt.push({
        name: o("common.label.autosizeColumn"),
        icon: '<span class="ag-icon ag-icon-autosize"></span>',
        action: () => {
          ye && ($.api.autoSizeColumns([ye]), l.value.add(ye));
        },
        disabled: ye ? l.value.has(ye) : !1
      }), fe("autoSizeAll")) {
        const ft = $.api.getColumns() ?? [], Ht = ft.length > 0 && ft.every((Vt) => l.value.has(Vt.getColId()));
        Jt.push({
          name: o("common.label.autosizeColumns"),
          icon: '<span class="ag-icon ag-icon-autosizeall"></span>',
          action: () => {
            $.api.autoSizeAllColumns(!1), l.value.clear(), ft.forEach((Vt) => {
              l.value.add(Vt.getColId());
            });
          },
          disabled: Ht
        });
      }
      const ln = [];
      if (!s.suppressExpandCollapseMenuItems && (fe("expandAll") || fe("contractAll"))) {
        let ft = !1;
        if ($.api.forEachNode((Ht) => {
          Ht.data && "template" in Ht.data && (ft = !0);
        }), fe("expandAll")) {
          let Ht = !0;
          ft ? $.api.forEachNode((Vt) => {
            Vt.data && "template" in Vt.data && !Vt.expanded && (Ht = !1);
          }) : $.api.forEachNode((Vt) => {
            Vt.isExpandable() && !Vt.expanded && (Ht = !1);
          }), ln.push({
            name: o("common.action.expandRow"),
            icon: '<span class="ag-icon ag-icon-expandall"></span>',
            action: () => {
              i("expand-all"), ft || $.api.expandAll();
            },
            disabled: Ht
          });
        }
        if (fe("contractAll")) {
          let Ht = !0;
          ft ? $.api.forEachNode((Vt) => {
            Vt.data && "template" in Vt.data && Vt.expanded && (Ht = !1);
          }) : $.api.forEachNode((Vt) => {
            Vt.expanded && (Ht = !1);
          }), ln.push({
            name: o("common.action.collapseRow"),
            icon: '<span class="ag-icon ag-icon-collapseall"></span>',
            action: () => {
              i("collapse-all"), ft || $.api.collapseAll();
            },
            disabled: Ht
          });
        }
      }
      const _2 = [
        {
          name: o("common.action.hideColumn"),
          icon: '<span class="ag-icon ag-icon-hidecolumn"></span>',
          action: () => {
            ye !== "ag-Grid-AutoColumn" ? $.api.setColumnsVisible([ye ?? ""], !1) : i("column-visible", {
              visible: !1,
              column: $.column,
              columns: [$.column],
              source: "columnMenu",
              api: $.api,
              context: $.context,
              type: "columnVisible"
            });
          },
          disabled: s.suppressColumnHide || H.cannotHide(ye, s.columnIdsSuppressHide)
        },
        {
          name: o("common.action.resetColumns"),
          icon: '<span class="ag-icon ag-icon-reset"></span>',
          action: () => {
            i("reset-columns");
          },
          disabled: s.suppressColumnHide || s.suppressColumnReset
        }
      ];
      return Zz([Ve, et, Jt, ln, _2]);
    }, le = ($) => $.replace(/ /g, " "), be = D(() => ({
      sortAscending: o("common.action.sortAscending"),
      sortDescending: o("common.action.sortDescending"),
      pinLeft: o("common.label.pinLeft"),
      pinRight: o("common.label.pinRight"),
      noPin: o("common.label.pin"),
      pinColumn: o("common.label.pinColumn"),
      ...H.localeText(),
      advancedFilterContains: le(o("common.label.contains")),
      advancedFilterNotContains: le(o("common.label.contains2")),
      advancedFilterTextEquals: le(o("record.src.label.equals")),
      advancedFilterTextNotEqual: le(o("common.label.equals")),
      advancedFilterEquals: le(o("record.src.label.equals")),
      advancedFilterNotEqual: le(o("common.label.equals")),
      advancedFilterGreaterThan: le(o("record.src.label.greater")),
      advancedFilterGreaterThanOrEqual: le(o("common.label.greaterEquals")),
      advancedFilterLessThan: le(o("record.src.label.less")),
      advancedFilterLessThanOrEqual: le(o("common.label.lessEquals")),
      advancedFilterBlank: le(o("columnFilter.operator.blank")),
      advancedFilterNotBlank: le(o("columnFilter.operator.notBlank")),
      advancedFilterAnd: o("common.label.and"),
      advancedFilterOr: o("common.label.or"),
      advancedFilterBuilderAddJoin: o("common.action.addGroup2"),
      advancedFilterBuilderAddCondition: o("common.action.addFilter"),
      advancedFilterBuilderSelectColumn: o("common.action.selectColumn"),
      advancedFilterBuilderSelectOption: o("common.action.selectOption"),
      advancedFilterBuilderEnterValue: o("common.action.enterValue"),
      advancedFilterBuilderClear: o("common.action.clear"),
      advancedFilterBuilderApply: o("common.action.apply"),
      advancedFilterBuilderCancel: o("common.action.cancel"),
      advancedFilterBuilderAddButtonTooltip: o("common.action.addFilter2"),
      advancedFilterBuilderRemoveButtonTooltip: o("common.action.remove"),
      advancedFilterBuilderMoveUpButtonTooltip: o("common.action.moveUp"),
      advancedFilterBuilderMoveDownButtonTooltip: o("common.action.moveDown")
    })), Me = D(() => s.filterRow && !s.advancedFilterOpen ? 28 : 0), Be = D(() => {
      var fe;
      const $ = {
        headerHeight: 28,
        // Headers (unlike cells) render through ag-Grid's own default markup, not a custom
        // cellRenderer, so its built-in truncation check against .ag-header-cell-text is accurate.
        tooltipShowMode: "whenTruncated",
        tooltipShowDelay: 600,
        icons: j,
        getMainMenuItems: G,
        detailCellRenderer: s.detailCellRendererComponent ?? Mve,
        detailCellRendererParams: s.detailCellRendererParams,
        getRowHeight: (ye) => {
          var et;
          if (!((et = ye == null ? void 0 : ye.node) != null && et.detail)) return;
          const Ve = s.filterRow && !s.advancedFilterOpen ? 80 : 40, Ye = ye == null ? void 0 : ye.node;
          return ye.node.level === 1 ? 1 : Math.min((Ye.__visibleRows ?? 1) * 40 + Ve + 4, 494);
        },
        detailRowAutoHeight: !0,
        suppressScrollOnNewData: !0,
        // Pinned rows are synthetic and may not carry the caller's own `path` convention — give
        // them a stable id directly instead of crashing on `.path` being undefined.
        getRowId: (ye) => ye.rowPinned ? `__pinned_${ye.rowPinned}__` : ye.data.path.join(">"),
        animateRows: !1,
        localeText: be.value,
        suppressContextMenu: !0,
        suppressDragLeaveHidesColumns: !0,
        processUnpinnedColumns: () => [],
        enableAdvancedFilter: s.filterRow && s.advancedFilterOpen,
        advancedFilterBuilderParams: Iue,
        advancedFilterParams: Pue,
        onAdvancedFilterBuilderVisibleChanged: (ye) => {
          w.value = ye.visible;
        },
        dataTypeDefinitions: r.value,
        alwaysPassFilter: () => !0,
        includeHiddenColumnsInAdvancedFilter: !0,
        ...H.gridOptions(),
        rowClassRules: {
          "row-selected-custom": (ye) => {
            if (H.isGroupRow(ye.node)) return !1;
            const Ve = s.selectedRowId ?? q.value;
            return Ve !== void 0 ? ge(ye.data, Ve) : ye.data === J.value;
          },
          "row-draft": (ye) => {
            var Ve, Ye;
            return ((Ye = (Ve = ye.data) == null ? void 0 : Ve.record) == null ? void 0 : Ye.state) === "draft";
          }
        }
      };
      return H.withRowModel({
        ...$,
        ...s.gridOptions,
        localeText: {
          ...be.value,
          ...((fe = s.gridOptions) == null ? void 0 : fe.localeText) ?? {}
        }
      });
    }), qe = W(0), he = () => {
      requestAnimationFrame(() => {
        var fe;
        let $ = 0;
        f.value && !f.value.isDestroyed() && ($ = ((fe = f.value) == null ? void 0 : fe.getDisplayedRowCount()) ?? 0), qe.value = $;
      });
    }, Pe = D(() => {
      const $ = s.filterRow && !s.advancedFilterOpen ? "60px" : "28px", fe = s.filterRow && !s.advancedFilterOpen ? 80 : 40, ye = qe.value || 2;
      return {
        "--floating-height": $,
        "--sticky-top": s.filterRow ? "60px" : "28px",
        ...s.pagination ? {} : {
          display: "grid"
        },
        ...s.minRowCount ? {
          minHeight: Math.min((ye ?? 1) * 40 + fe + 4, 494) + "px"
        } : {}
      };
    }), J = W(void 0), Y = W(null), q = W(s.selectedRowId), ge = ($, fe) => {
      var Ve;
      if (fe === void 0 || $ == null) return !1;
      const ye = $;
      return ((Ve = ye.record) == null ? void 0 : Ve.id) === fe || ye.id === fe || ye.uiId === fe;
    }, ie = ($) => {
      var Ye;
      if ((Ye = $.node) != null && Ye.rowPinned || H.toggleOnClick($) || ul($.event) || s.suppressRowFocus || Bi($.event) || !zs($.rowIndex)) return;
      if (s.selectedRowId !== void 0) {
        i("row-click", $);
        return;
      }
      const fe = Y.value ?? null, ye = $.node ?? null;
      J.value = $.data, Y.value = ye;
      const Ve = [];
      if (f.value) {
        if ((fe == null ? void 0 : fe.rowIndex) != null) {
          const et = f.value.getDisplayedRowAtIndex(fe.rowIndex);
          et && Ve.push(et);
        }
        if ((ye == null ? void 0 : ye.rowIndex) != null) {
          const et = f.value.getDisplayedRowAtIndex(ye.rowIndex);
          et && Ve.push(et);
        }
        Ve.length && f.value.redrawRows({ rowNodes: Ve });
      }
      i("row-click", $);
    }, ee = ($) => {
      i("selection-changed", $);
    }, ae = ($) => {
      i("column-moved", $);
    }, _e = ($) => {
      i("column-visible", $);
    }, Ne = async ($) => {
      const { api: fe } = $;
      if (f.value = $.api, await Xe(), St(), $.api.addEventListener("columnResized", St), $.api.addEventListener("columnMoved", St), $.api.addEventListener("gridSizeChanged", St), $.api.addEventListener("gridColumnsChanged", Ft), s.advancedFilterOpen && m.value) {
        const ye = a2(m.value, s.userDateFormat) ?? m.value;
        fe.setAdvancedFilterModel(ye);
      }
      s.filterRow && !s.advancedFilterOpen && C.value && fe.setFilterModel(C.value), requestAnimationFrame(() => {
        nt();
      }), H.attachPanel(), requestAnimationFrame(() => {
        i("grid-ready", { api: fe });
      });
    }, At = ($) => {
      H.detachPanel(), $.api.removeEventListener("columnResized", St), $.api.removeEventListener("columnMoved", St), $.api.removeEventListener("gridSizeChanged", St), $.api.removeEventListener("gridColumnsChanged", Ft);
    }, pt = ($) => {
      i("sort-changed", $);
    }, Uc = ($) => {
      $.finished && $.source !== "autosizeColumns" && ($.column ? [$.column] : $.columns ?? []).forEach((ye) => l.value.delete(ye.getColId())), i("column-resized", $);
    }, cl = () => {
      var Ve, Ye, et;
      const $ = Object.values(((Ve = f.value) == null ? void 0 : Ve.getFilterModel()) ?? {}).flat(), fe = (Ye = f.value) == null ? void 0 : Ye.getFilterModel(), ye = fe != null && Object.keys(fe).length > 0;
      if (s.filterRow && s.advancedFilterOpen) {
        const Jt = (et = f.value) == null ? void 0 : et.getAdvancedFilterModel();
        m.value = Jt ?? null, Jt ? i("advanced-filter-changed", Jt) : i("advanced-filter-changed", { filterType: "join", type: "AND", conditions: [] });
      }
      s.filterRow && !s.advancedFilterOpen ? (C.value = ye ? fe : null, i("filter-changed", $)) : s.filterRow || (ye ? i("filter-changed", $) : C.value = null);
    };
    Re(
      () => s.selectedRowId,
      ($, fe) => {
        const ye = $ === void 0 && fe !== void 0, Ve = fe ?? q.value, Ye = J.value;
        ye || ($ !== void 0 && (q.value = $), J.value = void 0, Y.value = null), !((s.selectedRowId ?? q.value) === Ve && Ye === J.value) && $s();
      }
    );
    function $s() {
      Xe(() => {
        !f.value || f.value.isDestroyed() || f.value.setGridOption("rowClassRules", Be.value.rowClassRules);
      });
    }
    function is() {
      q.value = void 0, J.value = void 0, Y.value = null, $s();
    }
    t({ clearSelectedRow: is }), Re(
      () => s.advancedFilterOpen,
      async ($) => {
        $ || (m.value = null), $ && (C.value = null), Be.value.enableAdvancedFilter = s.filterRow && s.advancedFilterOpen, b.value = !1, await Xe(), nt(), b.value = !0;
      }
    ), Re(
      () => [oe.value, K.value],
      ([$, fe]) => {
        setTimeout(() => {
          if (!f.value || f.value.isDestroyed()) return;
          f.value.setGridOption("pinnedTopRowData", $), f.value.setGridOption("pinnedBottomRowData", fe);
          const ye = [];
          for (let Ve = 0; Ve < f.value.getPinnedTopRowCount(); Ve++) {
            const Ye = f.value.getPinnedTopRow(Ve);
            Ye && ye.push(Ye);
          }
          for (let Ve = 0; Ve < f.value.getPinnedBottomRowCount(); Ve++) {
            const Ye = f.value.getPinnedBottomRow(Ve);
            Ye && ye.push(Ye);
          }
          ye.length && f.value.redrawRows({ rowNodes: ye });
        }, 0);
      }
    );
    const Kc = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, ul = ($) => $ ? $ && $ instanceof MouseEvent && $.button === 2 : !1, Bi = ($) => {
      const fe = $ == null ? void 0 : $.target;
      return fe instanceof Element && !!fe.closest(Lve);
    };
    let lo = 0, hl = null;
    function zs($) {
      const fe = $ ?? null, ye = Date.now();
      return fe !== null && fe === hl && ye - lo < 50 ? !1 : (hl = fe, lo = ye, !0);
    }
    const pe = ($) => {
      var et, Jt;
      if ($.rowPinned || Kc() || ul($.sourceEvent) || s.suppressRowFocus || !f.value || $.rowIndex == null || $.column && typeof $.column != "string" && $.column.getColId() === "ag-Grid-SelectionColumn" || Bi($.sourceEvent) || !$.sourceEvent && $.preventScrollOnBrowserFocus) return;
      const fe = (et = Y.value) == null ? void 0 : et.rowIndex;
      let ye;
      const Ve = f.value.getDisplayedRowAtIndex($.rowIndex);
      if (!Ve || H.isGroupRow(Ve)) return;
      if (s.selectedRowId !== void 0) {
        if (!zs($.rowIndex)) return;
        i("row-click", { data: Ve.data, type: "rowClicked", event: $.sourceEvent ?? null });
        return;
      }
      if (((Jt = Y.value) == null ? void 0 : Jt.rowIndex) === $.rowIndex || (fe != null && (ye = f.value.getDisplayedRowAtIndex(fe)), !Ve)) return;
      J.value = Ve.data, Y.value = Ve;
      const Ye = [];
      ye && Ye.push(ye), Ye.push(Ve), f.value.redrawRows({ rowNodes: Ye }), zs($.rowIndex), i("row-click", {
        data: Ve.data,
        type: "rowClicked",
        event: $.sourceEvent ?? null
      });
    }, Ce = () => {
      h.value && (h.value.removeEventListener("click", Wt), h.value.remove(), h.value = null), g.value && (g.value.removeEventListener("click", Ze), g.value.remove(), g.value = null);
    }, nt = () => {
      var et, Jt;
      const $ = d.value;
      if (!$) return;
      const fe = $.querySelector(".ag-advanced-filter-header");
      if (!fe) return;
      const ye = fe.querySelector(".ag-advanced-filter");
      if (!ye) return;
      Ce();
      const Ve = (et = c.value) == null ? void 0 : et.$el, Ye = (Jt = u.value) == null ? void 0 : Jt.$el;
      if (Ve) {
        const ln = Ve.cloneNode(!0);
        ln.classList.add("SCAOpenFilterBuilder-clone"), ln.style.display = "inline-flex", ln.addEventListener("click", Wt), fe.insertBefore(ln, ye), h.value = ln;
      }
      if (Ye) {
        const ln = Ye.cloneNode(!0);
        ln.classList.add("SCAClearFilter-clone"), ln.style.display = "inline-flex", ln.addEventListener("click", Ze), fe.appendChild(ln), g.value = ln;
      }
    };
    io(() => {
      B == null || B.disconnect(), Ce();
    });
    const St = () => {
      const $ = d.value;
      if (!$) return;
      const fe = $.querySelector(".ag-header"), ye = $.querySelector(".ag-advanced-filter-header");
      !fe || !ye || (ye.style.width = fe.offsetWidth + "px");
    }, Ft = () => requestAnimationFrame(St), Wt = () => {
      var $;
      ($ = f.value) == null || $.showAdvancedFilterBuilder();
    }, Ze = () => {
      var $;
      ($ = f.value) == null || $.setAdvancedFilterModel(null);
    };
    return ($, fe) => {
      var ye, Ve;
      return v(), y("div", {
        ref_key: "gridWrapperRef",
        ref: d,
        class: x([
          $.$style.gridWrapper,
          e.transitioning && $.$style.transitioning,
          e.agGridHeaderStickyTop && $.$style.gridHeaderSticky,
          e.filterRowReadOnly && $.$style.filterRowReadOnly
        ]),
        style: Ke({
          "--ag-header-sticky-top": e.agGridHeaderStickyTop ?? "initial",
          "--auto-height-valign": e.tableColumnLayout === "top" ? "flex-start" : void 0
        })
      }, [
        b.value ? (v(), z(T(Uz), {
          key: T(ne),
          class: x([
            $.$style.grid,
            e.compactBody && $.$style.gridCompact,
            s.totalRowState !== void 0 && $.$style.gridHasTotalRow,
            s.totalRowState !== void 0 && (((ye = oe.value) == null ? void 0 : ye.length) ?? 0) > 0 && $.$style.hasPinnedTop,
            s.totalRowState !== void 0 && (((Ve = K.value) == null ? void 0 : Ve.length) ?? 0) > 0 && $.$style.hasPinnedBottom
          ]),
          style: Ke(Pe.value),
          "column-defs": I.value,
          "default-col-def": A,
          "row-data": T(H).rowData(e.rowData),
          theme: re.value,
          "row-selection": P.value,
          pagination: e.pagination,
          "pagination-page-size": e.paginationPageSize ?? 1,
          "tree-data": e.treeMode,
          "floating-filter": !e.advancedFilterOpen,
          "floating-filters-height": Me.value,
          icons: j,
          "get-row-node-id": e.getRowNodeId,
          "get-data-path": e.getDataPath,
          "auto-group-column-def": E.value,
          "grid-options": Be.value,
          "selection-column-def": p,
          "dom-layout": e.domLayout,
          "master-detail": e.masterDetail ?? !1,
          onRowClicked: ie,
          onSelectionChanged: ee,
          onGridReady: Ne,
          onGridPreDestroyed: At,
          onColumnMoved: ae,
          onSortChanged: pt,
          onColumnVisible: _e,
          onColumnResized: Uc,
          onColumnRowGroupChanged: T(H).onColumnRowGroupChanged,
          onCellFocused: pe,
          onFilterChanged: cl,
          onModelUpdated: he
        }, null, 8, ["class", "style", "column-defs", "row-data", "theme", "row-selection", "pagination", "pagination-page-size", "tree-data", "floating-filter", "floating-filters-height", "get-row-node-id", "get-data-path", "auto-group-column-def", "grid-options", "dom-layout", "master-detail", "onColumnRowGroupChanged"])) : V("", !0),
        Tn(te(Zt, {
          ref_key: "builderButtonRef",
          ref: c,
          appearance: "secondary",
          size: "small",
          "icon-left": "phosphor/funnel-simple",
          "padding-left": "8px",
          "padding-right": "8px",
          onClick: Wt
        }, {
          default: Q(() => [
            Oe(se(T(o)("common.label.builder")), 1)
          ]),
          _: 1
        }, 512), [
          [cr, !1]
        ]),
        Tn(te(Fe, {
          ref_key: "clearButtonRef",
          ref: u,
          size: "12px",
          color: "var(--color-coolGrey-m3)",
          style: {
            position: "absolute",
            right: "8px",
            backgroundColor: "transparent"
          },
          icon: "phosphor/x",
          onClick: Ze
        }, null, 512), [
          [cr, !1]
        ]),
        T(_) ? (v(), z(Wce, pi(at({ key: 1 }, T(_))), null, 16)) : V("", !0),
        (v(), z(qi, { to: "body" }, [
          w.value ? (v(), y("div", {
            key: 0,
            class: x($.$style.filterBuilderBackdrop),
            onClick: fe[0] || (fe[0] = (Ye) => {
              var et;
              return (et = f.value) == null ? void 0 : et.hideAdvancedFilterBuilder();
            })
          }, null, 2)) : V("", !0)
        ]))
      ], 6);
    };
  }
}), Ove = "_grid_ixk3x_71", Gve = "_gridHasTotalRow_ixk3x_606", Hve = "_gridCompact_ixk3x_640", Vve = "_filterBuilderBackdrop_ixk3x_650", _ve = "_hasPinnedBottom_ixk3x_666", Nve = "_hasPinnedTop_ixk3x_687", $ve = "_gridHeaderSticky_ixk3x_774", zve = "_gridWrapper_ixk3x_837", Wve = "_transitioning_ixk3x_842", Uve = "_filterRowReadOnly_ixk3x_866", Kve = {
  grid: Ove,
  "ag-header-cell-resize-ghost": "_ag-header-cell-resize-ghost_ixk3x_302",
  gridHasTotalRow: Gve,
  gridCompact: Hve,
  filterBuilderBackdrop: Vve,
  hasPinnedBottom: _ve,
  hasPinnedTop: Nve,
  gridHeaderSticky: $ve,
  gridWrapper: zve,
  transitioning: Wve,
  filterRowReadOnly: Uve
}, Zve = {
  $style: Kve
}, qve = /* @__PURE__ */ we(Bve, [["__cssModules", Zve]]), jve = ["aria-label"], Yve = { class: "sca-grid-row-edit-info-keys" }, Qve = { key: 0 }, Jve = { class: "sca-grid-row-edit-info-key" }, Xve = /* @__PURE__ */ de({
  __name: "SCAGridRowEditInfo",
  setup(e) {
    const { t } = fn(), n = W(null), o = W(!1), s = { padding: "0" }, i = D(() => {
      const a = { icon: "phosphor/arrow-line-right", text: t("common.table.keys.tab") };
      return [
        { label: t("common.table.shortcuts.focusNext"), keys: [a] },
        {
          label: t("common.table.shortcuts.focusPrevious"),
          keys: [{ icon: "phosphor/arrow-fat-up", text: t("common.table.keys.shift") }, a]
        },
        {
          label: t("common.table.shortcuts.saveAndExit"),
          keys: [{ icon: "phosphor/arrow-elbow-down-left", text: t("common.table.keys.enter") }]
        },
        { label: t("common.table.shortcuts.discardChanges"), keys: [{ text: t("common.table.keys.escape") }] }
      ];
    }), r = D(
      () => i.value.map(({ label: a, keys: l }) => `${a}: ${l.map((d) => d.text).join("+")}`).join(", ")
    );
    return (a, l) => (v(), y("div", {
      ref_key: "root",
      ref: n,
      class: x(["sca-grid-row-edit-info", { "sca-grid-row-edit-info-active": o.value }]),
      "test-id": "row-edit-info",
      role: "img",
      "aria-label": r.value
    }, [
      te(Fe, {
        icon: "phosphor/info",
        size: "16px"
      }),
      te(zt, {
        target: n.value,
        styles: s
      }, {
        default: Q(() => [
          R("div", {
            class: "sca-grid-row-edit-info-shortcuts",
            onMouseenter: l[0] || (l[0] = (d) => o.value = !0),
            onMouseleave: l[1] || (l[1] = (d) => o.value = !1)
          }, [
            (v(!0), y(Se, null, We(i.value, (d) => (v(), y(Se, {
              key: d.label
            }, [
              R("span", null, se(d.label), 1),
              R("span", Yve, [
                (v(!0), y(Se, null, We(d.keys, (c, u) => (v(), y(Se, { key: u }, [
                  u > 0 ? (v(), y("span", Qve, "+")) : V("", !0),
                  R("span", Jve, [
                    c.icon ? (v(), z(Fe, {
                      key: 0,
                      icon: c.icon,
                      size: "12px"
                    }, null, 8, ["icon"])) : (v(), y(Se, { key: 1 }, [
                      Oe(se(c.text), 1)
                    ], 64))
                  ])
                ], 64))), 128))
              ])
            ], 64))), 128))
          ], 32)
        ]),
        _: 1
      }, 8, ["target"])
    ], 10, jve));
  }
}), e1e = { class: "sca-grid-overlay" }, Pv = /* @__PURE__ */ de({
  __name: "AgGridOverlayBridge",
  props: {
    params: {}
  },
  setup(e) {
    const t = e, n = D(() => t.params.overlay());
    return (o, s) => (v(), y("div", e1e, [
      n.value ? (v(), z(Ot(n.value.component), {
        key: 0,
        options: n.value.props ?? {}
      }, null, 8, ["options"])) : V("", !0)
    ]));
  }
});
function t1e(e) {
  const { noRows: t, loadingOverlay: n } = e();
  return {
    ...t && { noRowsOverlayComponent: Pv, noRowsOverlayComponentParams: { overlay: () => e().noRows } },
    ...n && {
      loadingOverlayComponent: Pv,
      loadingOverlayComponentParams: { overlay: () => e().loadingOverlay }
    }
  };
}
function n1e(e) {
  const t = e().fullWidthRow;
  return t ? {
    isFullWidthRow: ({ rowNode: n }) => {
      var o;
      return !!n.data && !n.rowPinned && !!((o = e().fullWidthRow) != null && o.match(n.data));
    },
    fullWidthCellRenderer: V1,
    fullWidthCellRendererParams: {
      fullWidth: { component: t.component, options: () => {
        var n;
        return ((n = e().fullWidthRow) == null ? void 0 : n.props) ?? {};
      } }
    }
  } : {};
}
function o1e(e, t) {
  return (e == null ? void 0 : e.height) !== void 0 && e.match(t) ? e.height : void 0;
}
function s1e(e, t) {
  if (!t) return;
  const n = new Map(e.map((s) => [s.data, s])), o = t(e.map((s) => s.data)).map((s) => n.get(s));
  o.length !== e.length || o.some((s) => !s) || e.splice(0, e.length, ...o);
}
function i1e(e) {
  return e().reorderAfterSort ? {
    postSortRows: (t) => s1e(t.nodes, e().reorderAfterSort)
  } : {};
}
const r1e = "__total__", a1e = "total-column-header";
function l1e(e) {
  return {
    totalRowState: e ? { enabled: e.enabled, position: e.position } : void 0,
    hasEligibleTotalRowColumn: e == null ? void 0 : e.hasEligibleColumn
  };
}
function d1e(e) {
  const t = e != null && e.enabled && e.values ? [{ id: r1e, ...e.values }] : void 0;
  return {
    pinnedTopRowData: (e == null ? void 0 : e.position) === "top" ? t : void 0,
    pinnedBottomRowData: (e == null ? void 0 : e.position) === "bottom" ? t : void 0
  };
}
function c1e(e, t) {
  var n;
  return !!((n = e == null ? void 0 : e.includedColumnIds) != null && n.includes(t));
}
const u1e = de({ inheritAttrs: !1 }), h1e = /* @__PURE__ */ de({
  ...u1e,
  __name: "GridTreeCell",
  props: {
    row: {},
    rowId: {},
    value: {},
    formatted: {},
    columnId: {},
    align: {},
    options: {},
    editing: { type: Boolean },
    getCellElement: { type: Function },
    tree: {},
    groupRow: { type: Boolean }
  },
  setup(e) {
    const n = e, o = D(() => !!n.tree && (n.options.arrow ?? n.tree.hasChildren)), s = D(
      () => {
        var l;
        return `${(((l = n.tree) == null ? void 0 : l.level) ?? 0) * (n.options.indentPerLevel ?? 16)}px`;
      }
    ), i = D(() => ({ ...n, options: n.options.innerOptions ?? {} }));
    function r() {
      var d, c;
      if (!n.tree) return;
      const l = !n.tree.expanded;
      n.tree.setExpanded(l), (c = (d = n.options).onExpandedChange) == null || c.call(d, n.rowId, l);
    }
    function a() {
      n.options.expandOnCellClick && o.value && r();
    }
    return (l, d) => {
      var c;
      return v(), y("div", {
        class: x([l.$style.cell, e.options.inset && l.$style.inset]),
        style: Ke({ "--grid-tree-indent": s.value }),
        "test-id": "grid-tree-cell",
        onMousedown: a
      }, [
        R("span", {
          class: x(l.$style.arrow),
          onClick: d[0] || (d[0] = Ge(() => {
          }, ["stop"]))
        }, [
          o.value ? (v(), z(ut, {
            key: 0,
            size: "xsmall",
            icon: (c = e.tree) != null && c.expanded ? "phosphor/caret-down" : "phosphor/caret-right",
            appearance: "secondary",
            type: "bare",
            "test-id": "grid-tree-cell-toggle",
            onMousedown: Ge(r, ["stop", "prevent"])
          }, null, 8, ["icon"])) : V("", !0)
        ], 2),
        e.options.dragHandle && e.options.dragHandle !== "hidden" ? (v(), z(Fe, {
          key: 0,
          size: "24px",
          icon: "phosphor/dots-six-vertical",
          class: x({ [l.$style.gripDisabled]: e.options.dragHandle === "disabled" })
        }, null, 8, ["class"])) : V("", !0),
        R("span", {
          class: x(l.$style.content)
        }, [
          e.options.inner ? (v(), z(Ot(e.options.inner), pi(at({ key: 0 }, { ...l.$attrs, ...i.value })), null, 16)) : (v(), y(Se, { key: 1 }, [
            Oe(se(e.formatted), 1)
          ], 64))
        ], 2)
      ], 38);
    };
  }
}), g1e = "_cell_48u2f_1", p1e = "_inset_48u2f_9", f1e = "_content_48u2f_12", m1e = "_arrow_48u2f_16", v1e = "_gripDisabled_48u2f_28", C1e = {
  cell: g1e,
  inset: p1e,
  content: f1e,
  arrow: m1e,
  gripDisabled: v1e
}, w1e = {
  $style: C1e
}, y1e = /* @__PURE__ */ we(h1e, [["__cssModules", w1e]]);
function b1e(e) {
  switch (e.kind) {
    case "number":
      return "number";
    case "date":
      return e.valueKind === "time" ? "text" : e.valueKind;
    case "list":
      return "customList";
    default:
      return "text";
  }
}
const S1e = "grid-cell-invalid", x1e = "grid-cell-clearable";
function Rs(e) {
  return Object.fromEntries(Object.entries(e).filter(([, t]) => t !== void 0));
}
const ps = (e) => !!(e != null && e.rowPinned);
function R1e(e) {
  return (t) => {
    if (!t.data || ps(t.node) || !e(t.data)) return 1;
    const n = t.api.getAllDisplayedColumns();
    return Math.max(1, n.length - n.indexOf(t.column));
  };
}
function E1e({
  filter: e,
  filterColumnId: t,
  filterDataType: n
}) {
  return e ? Rs({
    filterConfig: e,
    columnDataType: n ?? b1e(e),
    filterColKey: t
  }) : n ? { columnDataType: n } : void 0;
}
function Zd(e) {
  const { props: t } = e;
  return {
    gridCell: {
      component: e.component,
      options: (n) => typeof t == "function" ? t(n.data, { groupRow: oo(n.node) }) : t ?? {}
    }
  };
}
function S2(e, t = {}) {
  const { value: n, format: o, parse: s, setValue: i, compare: r, invalid: a, cellClass: l, total: d, editor: c, renderer: u, filter: h } = e, g = c === !1 ? void 0 : c, p = !!g, f = c === !1 || t.editing === !1 ? !1 : e.editable ?? p, m = e.field ?? e.id, C = Rs({
    navigable: e.navigable ?? p,
    control: e.navigable && !p ? !0 : void 0,
    defaultAlignment: e.align,
    totalRowExcluded: d === !1 ? !0 : void 0,
    totalRowForced: d ? d.forced : void 0,
    totalRowValueFormatter: d ? d.format : void 0,
    totalRowIcon: d ? d.icon : void 0,
    totalRowIconSize: d ? d.iconSize : void 0
  }), w = Rs({
    colId: e.id,
    field: e.field ?? (n ? void 0 : e.id),
    headerName: e.header,
    width: e.width,
    minWidth: e.minWidth,
    maxWidth: e.maxWidth,
    hide: e.hidden,
    pinned: e.pinned,
    suppressSizeToFit: e.fitWidth === !1 ? !0 : void 0,
    sortable: e.sortable,
    resizable: e.resizable,
    suppressMovable: e.movable === void 0 ? void 0 : !e.movable,
    suppressHeaderMenuButton: e.menu === void 0 ? void 0 : !e.menu,
    floatingFilter: !!h,
    suppressHeaderFilterButton: !0,
    floatingFilterComponentParams: E1e(e),
    enableRowGroup: e.groupable === !1 ? !1 : void 0,
    headerClass: t.totalIncluded ? () => {
      var S;
      return (S = t.totalIncluded) != null && S.call(t, e.id) ? a1e : void 0;
    } : void 0,
    // A pinned row is the total row: its data is keyed by field and is not a TRow.
    valueGetter: n ? (S) => {
      if (S.data)
        return ps(S.node) ? S.data[m] : n(S.data);
    } : void 0,
    valueFormatter: o ? (S) => !S.data || ps(S.node) ? Aa(S.value) : o(S.value, S.data) : void 0,
    valueParser: s ? (S) => s(S.newValue, S.oldValue, S.data) : void 0,
    valueSetter: i ? (S) => i(S.data, S.newValue) : void 0,
    comparator: t.sorting === "server" ? () => 0 : r ? (S, F, E, M) => r(S, F, E.data, M.data) : void 0,
    editable: typeof f == "function" ? (S) => !ps(S.node) && !!S.data && f(S.data) : f ? (S) => !ps(S.node) : void 0,
    cellEditor: g ? H1 : void 0,
    cellEditorParams: g ? Zd(g) : void 0,
    cellRenderer: u ? Fg : void 0,
    cellRendererParams: u ? Zd(u) : void 0,
    cellClass: typeof l == "function" ? (S) => ps(S.node) || !S.data ? void 0 : l(S.data) : l,
    cellClassRules: a || e.clearable ? Rs({
      [S1e]: a ? (S) => !ps(S.node) && !!S.data && a(S1(S.api, S.node.id, S.data)) : void 0,
      [x1e]: e.clearable ? (S) => !ps(S.node) : void 0
    }) : void 0,
    wrapText: e.wrap ? !0 : void 0,
    autoHeight: e.wrap || e.autoHeight ? !0 : void 0,
    colSpan: e.spanToEnd ? R1e(e.spanToEnd) : void 0,
    suppressKeyboardEvent: e.multilineEdit ? (S) => S.editing && S.event.key === "Enter" && S.event.shiftKey : void 0,
    context: C
  });
  if (!e.agGrid) return w;
  const { context: b, ...A } = e.agGrid;
  return { ...w, ...A, context: { ...C, ...b } };
}
function A1e(e, t = {}) {
  return e.map((n) => S2(n, t));
}
function Dv(e, t, n = !1) {
  return {
    component: y1e,
    props: (o, s) => {
      var r, a;
      const i = t == null ? void 0 : t.props;
      return Rs({
        arrow: (r = e.arrow) == null ? void 0 : r.call(e, o),
        dragHandle: n || (a = e.dragHandle) == null ? void 0 : a.call(e, o),
        expandOnCellClick: e.expandOnCellClick,
        indentPerLevel: e.indentPerLevel,
        onExpandedChange: e.onExpandedChange,
        inset: n || void 0,
        inner: t == null ? void 0 : t.component,
        innerOptions: typeof i == "function" ? i(o, s) : i
      });
    }
  };
}
function F1e(e, t) {
  return t ? e.map((n) => n.colId === t.groupColumnId ? { ...n, hide: !0 } : n) : e;
}
function M1e(e, t, n) {
  const o = t && e.find((i) => i.id === t.groupColumnId);
  if (!t || !o) return { treeMode: void 0, getDataPath: void 0, autoGroupColumnDef: void 0 };
  const s = S2(o, n);
  return delete s.colId, delete s.hide, {
    treeMode: !0,
    getDataPath: (i) => t.path(i),
    autoGroupColumnDef: {
      ...s,
      cellRenderer: Fg,
      cellRendererParams: Zd(t.cell ?? Dv(t, o.renderer)),
      // The editor goes inside the same tree cell, without the drag handle, so the indent stays put while editing.
      ...s.cellEditor && o.editor && !t.cell ? { cellEditorParams: Zd(Dv(t, o.editor, !0)) } : {},
      floatingFilterComponentParams: { ...s.floatingFilterComponentParams, originalHiddenColId: o.id }
    }
  };
}
function x2(e) {
  return {
    isGroupOpenByDefault: (t) => {
      var s;
      const n = (s = e().tree) == null ? void 0 : s.expandedByDefault;
      if (n) return !!t.rowNode.data && n(t.rowNode.data);
      const o = t.api.getGridOption("groupDefaultExpanded") ?? 0;
      return o === -1 || t.level < o;
    }
  };
}
const I1e = 40;
function R2(e, t) {
  return e.rowId ? e.rowId(t) : t.id;
}
function P1e(e) {
  if (!e) return;
  const { selectable: t, checkbox: n } = e, o = Rs({
    isRowSelectable: t ? (s) => s.data !== void 0 && !s.rowPinned && t(s.data) : void 0,
    checkboxes: typeof n == "function" ? (s) => s.data !== void 0 && n(s.data) : n
  });
  return e.mode === "single" ? { mode: "singleRow", ...o } : { mode: "multiRow", ...o };
}
function E2(e) {
  return {
    sorting: e.sorting,
    editing: e.editMode !== "none",
    totalIncluded: (t) => c1e(e.totalRow, t)
  };
}
function A2(e) {
  return F1e(A1e(e.columns, E2(e)), e.tree);
}
function F2(e) {
  return M1e(e.columns, e.tree, E2(e));
}
function D1e(e, t = {}) {
  const { colDefs: n = A2(e), tree: o = F2(e) } = t;
  return {
    ...o,
    ...l1e(e.totalRow),
    colDefs: n,
    rowData: e.rows,
    filterRowReadOnly: e.filterRowReadOnly,
    columnAlignment: e.columnAlignment,
    agGridHeaderStickyTop: e.stickyHeaderTop,
    rowSelection: P1e(e.selection),
    filterRow: e.filterRow,
    advancedFilterOpen: e.advancedFilterOpen,
    userDateFormat: e.dateFormat,
    domLayout: e.autoHeight ? "autoHeight" : void 0,
    compactBody: e.compact,
    tableColumnLayout: e.valign,
    transitioning: e.transitioning,
    suppressRowFocus: e.rowClick === !1,
    selectedRowId: e.activeRowId,
    suppressColumnHide: e.columnHide === !1,
    columnIdsSuppressHide: e.alwaysVisibleColumnIds,
    suppressColumnReset: e.columnReset === !1,
    rowGroups: e.rowGroups
  };
}
function T1e(e, t, n, o) {
  const s = e();
  return {
    ...L1e(e, t),
    ...k1e(s, t, n, o),
    ...s.agGridOptions
  };
}
function k1e({ editMode: e, editTrigger: t }, n, o, s) {
  if (!e || e === "none") return {};
  const i = (d) => d.api.refreshCells({ rowNodes: [d.node], force: !0 }), r = (d) => {
    s == null || s.add(d.node), i(d);
    const c = T1(d);
    c && n.rowEditStarted(c);
  }, a = (d) => {
    s == null || s.remove(d.node), i(d);
    const c = k1(d);
    c && n.rowEditStopped(c);
  }, l = Rs({ singleClickEdit: t === "click" ? !0 : void 0 });
  return e === "cell" ? {
    ...l,
    stopEditingWhenCellsLoseFocus: !0,
    onCellEditingStarted: r,
    onCellEditingStopped: a
  } : {
    ...l,
    editType: "fullRow",
    suppressRowTransform: !0,
    onRowEditingStarted: (d) => {
      o == null || o.onRowEditingStarted(d), r(d);
    },
    onRowEditingStopped: (d) => {
      o == null || o.onRowEditingStopped(d), a(d);
    }
  };
}
function L1e(e, t) {
  const n = e(), { rowHeight: o, rowClass: s } = n, i = (r) => {
    e().fitColumns && r.sizeColumnsToFit();
  };
  return Rs({
    popupParent: document.body,
    getRowId: (r) => r.rowPinned ? `__pinned_${r.rowPinned}__` : R2(e(), r.data),
    rowHeight: typeof o == "number" ? o : void 0,
    getRowHeight: (r) => {
      const { rowHeight: a, fullWidthRow: l } = e();
      if (r.node.rowPinned) return a === void 0 ? I1e : void 0;
      if (r.data)
        return o1e(l, r.data) ?? (typeof a == "function" ? a(r.data) : void 0);
    },
    ...n1e(e),
    ...t1e(e),
    ...i1e(e),
    getRowClass: s ? (r) => {
      var a, l;
      return !r.data || r.node.rowPinned || (l = (a = e()).rowClass) == null ? void 0 : l.call(a, r.data);
    } : void 0,
    ...x2(e),
    enableCellTextSelection: n.textSelection ? !0 : void 0,
    suppressMovableColumns: n.columnsMovable === !1 ? !0 : void 0,
    suppressNoRowsOverlay: n.noRowsOverlay === !1 ? !0 : void 0,
    localeText: n.noRowsText === void 0 ? void 0 : { noRowsToShow: n.noRowsText },
    onGridSizeChanged: (r) => i(r.api),
    onColumnResized: (r) => {
      r.finished && r.source === "uiColumnResized" && i(r.api);
    },
    onCellClicked: (r) => {
      const a = ER(r);
      a && t.cellClick(a);
    },
    onRowDoubleClicked: (r) => {
      const a = RR(r);
      a && t.rowDoubleClick(a);
    },
    onCellValueChanged: (r) => {
      const a = D1(r);
      a && t.cellValueChanged(a);
    }
  });
}
function B1e() {
  const e = /* @__PURE__ */ new Set();
  return {
    add: (t) => t.id != null && e.add(t.id),
    remove: (t) => t.id != null && e.delete(t.id),
    has: (t) => !t.rowPinned && t.id != null && e.has(t.id)
  };
}
function O1e(e, t, n) {
  if (!(!e || e === "none"))
    return (o) => n.has(o.node) ? { component: t } : void 0;
}
const G1e = /* @__PURE__ */ de({
  __name: "AgGridAdapter",
  props: {
    columns: {},
    rows: {},
    rowId: { type: Function },
    selection: {},
    activeRowId: {},
    rowClick: { type: Boolean },
    filterRow: { type: Boolean },
    filterRowReadOnly: { type: Boolean },
    advancedFilterOpen: { type: Boolean },
    dateFormat: {},
    tree: {},
    totalRow: {},
    columnAlignment: {},
    stickyHeaderTop: {},
    fullWidthRow: {},
    reorderAfterSort: { type: Function },
    sorting: {},
    autoHeight: { type: Boolean },
    compact: { type: Boolean },
    valign: {},
    transitioning: { type: Boolean },
    editMode: {},
    editTrigger: {},
    rowHeight: { type: [Number, Function] },
    rowClass: { type: Function },
    fitColumns: { type: Boolean },
    columnsMovable: { type: Boolean },
    columnHide: { type: Boolean },
    alwaysVisibleColumnIds: {},
    columnReset: { type: Boolean },
    noRowsText: {},
    noRowsOverlay: { type: Boolean },
    noRows: {},
    loadingOverlay: {},
    textSelection: { type: Boolean },
    rowGroups: {},
    agGridOptions: {}
  },
  emits: ["ready", "filter-changed", "advanced-filter-changed", "column-resized", "column-moved", "column-visible", "sort-changed", "selection-changed", "row-click", "row-double-click", "cell-click", "cell-value-changed", "row-edit-started", "row-edit-stopped", "reset-columns", "manage-columns", "update:column-alignment", "update:total-row-state", "expand-all", "collapse-all", "update:row-group-columns", "hide-row-group-panel"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = tn("table"), i = B1e(), r = D(() => A2(n)), a = D(() => F2(n)), l = D(() => ({
      ...D1e(n, { colDefs: r.value, tree: a.value }),
      selectionCellRendererSelector: O1e(n.editMode, Xve, i)
    })), d = GR({
      minRowHeight: () => typeof n.rowHeight == "number" ? n.rowHeight : void 0
    }), c = T1e(
      () => n,
      {
        cellClick: (P) => o("cell-click", P),
        rowDoubleClick: (P) => o("row-double-click", P),
        cellValueChanged: (P) => o("cell-value-changed", P),
        rowEditStarted: (P) => o("row-edit-started", P),
        rowEditStopped: (P) => o("row-edit-stopped", P)
      },
      d,
      i
    ), u = D(() => ({
      ...c,
      ...x2(() => n),
      ...d1e(n.totalRow)
    })), h = D(() => n.columns.some((P) => P.wrap && !P.hidden)), g = Qe(null), p = () => g.value && !g.value.isDestroyed() ? g.value : null;
    function f({ api: P }) {
      g.value = P;
      const k = BR(P, {
        root: () => {
          var B;
          return ((B = s.value) == null ? void 0 : B.$el) ?? null;
        },
        editMode: () => n.editMode ?? "none",
        clearActiveRow: () => {
          var B;
          return (B = s.value) == null ? void 0 : B.clearSelectedRow();
        }
      });
      n.fitColumns && k.sizeColumnsToFit(), o("ready", k);
    }
    const m = (P) => o("filter-changed", P), C = (P) => o("advanced-filter-changed", P), w = (P) => o("column-resized", M1(P)), b = (P) => o("column-moved", F1(P)), A = (P) => o("column-visible", A1(P)), S = (P) => o("sort-changed", E1(P)), F = (P) => o("selection-changed", P1(P));
    function E(P) {
      const k = xR(P, (B) => R2(n, B));
      k && o("row-click", k);
    }
    Re(
      () => n.rowHeight,
      (P) => {
        var k;
        typeof P == "number" && ((k = p()) == null || k.setGridOption("rowHeight", P));
      }
    );
    const M = (P) => o("update:total-row-state", P);
    function I({ colId: P, alignment: k }) {
      o("update:column-alignment", { columnId: P, alignment: k });
    }
    return Re(
      () => {
        var P, k;
        return (k = (P = n.totalRow) == null ? void 0 : P.includedColumnIds) == null ? void 0 : k.join(",");
      },
      () => {
        var P;
        return (P = p()) == null ? void 0 : P.refreshHeader();
      }
    ), Re(
      () => n.columnsMovable,
      (P) => {
        var k;
        return (k = p()) == null ? void 0 : k.setGridOption("suppressMovableColumns", !P);
      }
    ), (P, k) => (v(), z(qve, at({
      ref_key: "table",
      ref: s,
      class: [
        "sca-data-grid",
        P.$style.dataGrid,
        n.valign === "top" && P.$style.valignTop,
        h.value && P.$style.wrappedRows
      ]
    }, l.value, {
      "license-key": T($A).licenseKey,
      "grid-options": u.value,
      onGridReady: f,
      onFilterChanged: m,
      onAdvancedFilterChanged: C,
      onColumnResized: w,
      onColumnMoved: b,
      onColumnVisible: A,
      onSortChanged: S,
      onSelectionChanged: F,
      onRowClick: E,
      onResetColumns: k[0] || (k[0] = (B) => o("reset-columns")),
      onManageColumns: k[1] || (k[1] = (B) => o("manage-columns")),
      "onUpdate:columnAlignment": I,
      "onUpdate:totalRowState": M,
      onExpandAll: k[2] || (k[2] = (B) => o("expand-all")),
      onCollapseAll: k[3] || (k[3] = (B) => o("collapse-all")),
      "onUpdate:rowGroupColumns": k[4] || (k[4] = (B) => o("update:row-group-columns", B)),
      onHideRowGroupPanel: k[5] || (k[5] = (B) => o("hide-row-group-panel"))
    }), null, 16, ["class", "license-key", "grid-options"]));
  }
}), H1e = "_dataGrid_s0ufy_1", V1e = "_valignTop_s0ufy_48", _1e = "_wrappedRows_s0ufy_57", N1e = {
  dataGrid: H1e,
  valignTop: V1e,
  wrappedRows: _1e
}, $1e = {
  $style: N1e
}, z1e = /* @__PURE__ */ we(G1e, [["__cssModules", $1e]]), WMe = /* @__PURE__ */ de({
  __name: "SCADataGrid",
  props: {
    columns: {},
    rows: {},
    rowId: {},
    selection: {},
    activeRowId: {},
    rowClick: { type: Boolean, default: !0 },
    filterRow: { type: Boolean },
    filterRowReadOnly: { type: Boolean },
    advancedFilterOpen: { type: Boolean },
    dateFormat: {},
    tree: {},
    totalRow: {},
    columnAlignment: {},
    stickyHeaderTop: {},
    fullWidthRow: {},
    reorderAfterSort: {},
    sorting: { default: "client" },
    autoHeight: { type: Boolean },
    compact: { type: Boolean },
    valign: {},
    transitioning: { type: Boolean },
    editMode: { default: "none" },
    editTrigger: { default: "doubleClick" },
    rowHeight: {},
    rowClass: {},
    fitColumns: { type: Boolean },
    columnsMovable: { type: Boolean, default: !0 },
    columnHide: { type: Boolean, default: !0 },
    alwaysVisibleColumnIds: {},
    columnReset: { type: Boolean, default: !0 },
    noRowsText: {},
    noRowsOverlay: { type: Boolean, default: !0 },
    noRows: {},
    loadingOverlay: {},
    textSelection: { type: Boolean },
    rowGroups: {},
    agGridOptions: {}
  },
  emits: ["ready", "filter-changed", "advanced-filter-changed", "column-resized", "column-moved", "column-visible", "sort-changed", "selection-changed", "row-click", "row-double-click", "cell-click", "cell-value-changed", "row-edit-started", "row-edit-stopped", "reset-columns", "manage-columns", "update:column-alignment", "update:total-row-state", "expand-all", "collapse-all", "update:row-group-columns", "hide-row-group-panel"],
  setup(e, { emit: t }) {
    const n = e, o = t;
    return (s, i) => (v(), z(Ot(T(z1e)), at(n, {
      onReady: i[0] || (i[0] = (r) => o("ready", r)),
      onFilterChanged: i[1] || (i[1] = (r) => o("filter-changed", r)),
      onAdvancedFilterChanged: i[2] || (i[2] = (r) => o("advanced-filter-changed", r)),
      onColumnResized: i[3] || (i[3] = (r) => o("column-resized", r)),
      onColumnMoved: i[4] || (i[4] = (r) => o("column-moved", r)),
      onColumnVisible: i[5] || (i[5] = (r) => o("column-visible", r)),
      onSortChanged: i[6] || (i[6] = (r) => o("sort-changed", r)),
      onSelectionChanged: i[7] || (i[7] = (r) => o("selection-changed", r)),
      onRowClick: i[8] || (i[8] = (r) => o("row-click", r)),
      onRowDoubleClick: i[9] || (i[9] = (r) => o("row-double-click", r)),
      onCellClick: i[10] || (i[10] = (r) => o("cell-click", r)),
      onCellValueChanged: i[11] || (i[11] = (r) => o("cell-value-changed", r)),
      onRowEditStarted: i[12] || (i[12] = (r) => o("row-edit-started", r)),
      onRowEditStopped: i[13] || (i[13] = (r) => o("row-edit-stopped", r)),
      onResetColumns: i[14] || (i[14] = (r) => o("reset-columns")),
      onManageColumns: i[15] || (i[15] = (r) => o("manage-columns")),
      "onUpdate:columnAlignment": i[16] || (i[16] = (r) => o("update:column-alignment", r)),
      "onUpdate:totalRowState": i[17] || (i[17] = (r) => o("update:total-row-state", r)),
      onExpandAll: i[18] || (i[18] = (r) => o("expand-all")),
      onCollapseAll: i[19] || (i[19] = (r) => o("collapse-all")),
      "onUpdate:rowGroupColumns": i[20] || (i[20] = (r) => o("update:row-group-columns", r)),
      onHideRowGroupPanel: i[21] || (i[21] = (r) => o("hide-row-group-panel"))
    }), null, 16));
  }
}), Hl = [];
function M2(e) {
  const t = Symbol("dialog");
  Hl.push(t), ro(() => {
    const n = Hl.indexOf(t);
    n !== -1 && Hl.splice(n, 1);
  }), An(window, "keydown", (n) => {
    var o;
    if (Hl.at(-1) === t)
      switch (n.key) {
        case "Escape":
          e.onEscape();
          break;
        case "Enter":
          (o = e.onEnter) == null || o.call(e);
          break;
      }
  });
}
const W1e = /* @__PURE__ */ de({
  __name: "SCAAvatarDialog",
  props: {
    title: {},
    isPreview: { type: Boolean, default: !1 }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = t, o = rn();
    return M2({
      onEscape: () => n("close"),
      onEnter: () => n("confirm")
    }), (s, i) => (v(), y("div", {
      class: x(s.$style.root)
    }, [
      R("div", {
        class: x(s.$style.dialogHeader)
      }, [
        te(ut, {
          class: x(s.$style.closeButton),
          icon: "phosphor/x",
          type: "bare",
          appearance: "secondary",
          title: s.$t("common.action.close"),
          onClick: i[0] || (i[0] = (r) => n("close"))
        }, null, 8, ["class", "title"]),
        e.isPreview ? V("", !0) : (v(), z(Zt, {
          key: 0,
          "icon-left": "phosphor/floppy-disk",
          size: "small",
          onClick: i[1] || (i[1] = (r) => n("confirm"))
        }, {
          default: Q(() => [
            Oe(se(s.$t("common.action.save")), 1)
          ]),
          _: 1
        })),
        e.isPreview ? V("", !0) : ve(s.$slots, "toolBar", { key: 1 }),
        R("div", {
          class: x([s.$style.title, { [s.$style.show]: e.isPreview }])
        }, se(e.title), 3)
      ], 2),
      T(o).default ? (v(), y("div", {
        key: 0,
        class: x(s.$style.content)
      }, [
        ve(s.$slots, "default")
      ], 2)) : V("", !0),
      T(o).actions ? (v(), y("div", {
        key: 1,
        class: x([s.$style.dialogHeader, s.$style.border, s.$style.center])
      }, [
        ve(s.$slots, "actions")
      ], 2)) : V("", !0)
    ], 2));
  }
}), U1e = "_root_1qtm8_747", K1e = "_dialogHeader_1qtm8_785", Z1e = "_title_1qtm8_798", q1e = "_show_1qtm8_809", j1e = "_border_1qtm8_819", Y1e = "_center_1qtm8_824", Q1e = "_content_1qtm8_828", J1e = "_closeButton_1qtm8_832", X1e = {
  root: U1e,
  dialogHeader: K1e,
  title: Z1e,
  show: q1e,
  border: j1e,
  center: Y1e,
  content: Q1e,
  closeButton: J1e
}, eCe = {
  $style: X1e
}, UMe = /* @__PURE__ */ we(W1e, [["__cssModules", eCe]]), tCe = ["value", "placeholder"], nCe = { key: 0 }, oCe = /* @__PURE__ */ de({
  __name: "SCADialog",
  props: {
    title: { default: void 0 },
    size: { default: "medium" },
    padding: { default: "medium" },
    hasCloseIcon: { type: Boolean, default: !0 },
    confirmOnEnter: { type: Boolean, default: !0 },
    headerAppearance: { default: "brand" },
    searchTerm: { default: void 0 }
  },
  emits: ["close", "confirm", "update:searchTerm"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = rn();
    return M2({
      onEscape: () => o("close"),
      onEnter: () => {
        n.confirmOnEnter && o("confirm");
      }
    }), (i, r) => (v(), y("div", {
      class: x([
        i.$style.root,
        {
          [i.$style.sizeSmall]: e.size === "small",
          [i.$style.sizeLarge]: e.size === "large",
          [i.$style.paddingLarge]: e.padding === "large",
          [i.$style.headerPlain]: e.headerAppearance === "plain"
        }
      ])
    }, [
      R("div", {
        class: x(i.$style.dialogHeader)
      }, [
        R("div", {
          class: x(i.$style.actions)
        }, [
          e.hasCloseIcon ? (v(), z(ut, {
            key: 0,
            class: x(i.$style.closeButton),
            icon: "phosphor/x",
            type: "ghost",
            appearance: e.headerAppearance === "plain" ? "secondary" : "inverted",
            size: "small",
            title: i.$t("common.action.close"),
            onClick: r[0] || (r[0] = (a) => o("close"))
          }, null, 8, ["class", "appearance", "title"])) : V("", !0),
          T(s).actions ? ve(i.$slots, "actions", { key: 1 }) : V("", !0),
          e.searchTerm !== void 0 ? (v(), z(bf, {
            key: 2,
            appearance: "border",
            inverted: "",
            class: x(i.$style.search),
            "show-clear-icon": e.searchTerm.length > 0,
            onClear: r[2] || (r[2] = (a) => o("update:searchTerm", ""))
          }, {
            default: Q(() => [
              R("input", {
                value: e.searchTerm,
                placeholder: i.$t("common.action.search"),
                onInput: r[1] || (r[1] = (a) => o("update:searchTerm", a.target.value))
              }, null, 40, tCe)
            ]),
            _: 1
          }, 8, ["class", "show-clear-icon"])) : V("", !0)
        ], 2),
        T(s).dialogHeader ? (v(), y("div", {
          key: 0,
          class: x(i.$style.headerSlot)
        }, [
          ve(i.$slots, "dialogHeader")
        ], 2)) : V("", !0),
        e.title ? (v(), y("div", {
          key: 1,
          class: x(i.$style.title)
        }, se(e.title), 3)) : V("", !0)
      ], 2),
      T(s).contentHeader ? (v(), y("div", nCe, [
        ve(i.$slots, "contentHeader")
      ])) : V("", !0),
      T(s).default ? (v(), y("div", {
        key: 1,
        class: x(i.$style.content)
      }, [
        ve(i.$slots, "default")
      ], 2)) : V("", !0),
      T(s).footer ? (v(), y("div", {
        key: 2,
        class: x(i.$style.footer)
      }, [
        ve(i.$slots, "footer")
      ], 2)) : V("", !0)
    ], 2));
  }
}), sCe = "_root_ucbg3_747", iCe = "_sizeSmall_ucbg3_768", rCe = "_sizeLarge_ucbg3_771", aCe = "_paddingLarge_ucbg3_774", lCe = "_dialogHeader_ucbg3_777", dCe = "_headerPlain_ucbg3_783", cCe = "_actions_ucbg3_817", uCe = "_title_ucbg3_825", hCe = "_closeButton_ucbg3_838", gCe = "_content_ucbg3_850", pCe = "_headerSlot_ucbg3_858", fCe = "_search_ucbg3_864", mCe = "_footer_ucbg3_870", vCe = {
  root: sCe,
  sizeSmall: iCe,
  sizeLarge: rCe,
  paddingLarge: aCe,
  dialogHeader: lCe,
  headerPlain: dCe,
  actions: cCe,
  title: uCe,
  closeButton: hCe,
  content: gCe,
  headerSlot: pCe,
  search: fCe,
  footer: mCe
}, CCe = {
  $style: vCe
}, wCe = /* @__PURE__ */ we(oCe, [["__cssModules", CCe]]), yCe = { key: 0 }, bCe = /* @__PURE__ */ de({
  __name: "SCAConfirmationDialog",
  props: {
    title: { default: void 0 },
    text: { default: void 0 },
    showDeleteSecondaryText: { type: Boolean, default: !0 },
    confirmationText: { default: void 0 },
    cancelText: { default: void 0 },
    discardText: { default: void 0 },
    discardIcon: { default: void 0 },
    confirmIcon: { default: void 0 },
    type: { default: "alert" },
    customComponent: { default: void 0 },
    customComponentProps: { default: () => ({}) }
  },
  setup(e) {
    const { t } = fn(), n = e, o = D(
      () => n.title ?? {
        alert: t("common.label.pleaseConfirmAction"),
        save: t("common.action.saveChanges"),
        discard: t("settings.tableBar.label.discardChanges2"),
        delete: t("common.action.deleteRecord")
      }[n.type]
    ), s = D(() => {
      const { text: d, type: c, showDeleteSecondaryText: u } = n;
      if (d)
        return {
          primary: d,
          secondary: c === "delete" && u ? t("common.label.stepCannotUndone") : void 0
        };
      if (c === "discard")
        return { primary: t("common.message.confirmDiscardChanges"), secondary: void 0 };
      if (c === "save")
        return { primary: t("common.label.unsavedChangesLike"), secondary: void 0 };
    }), i = o8(), r = W(void 0), a = (d) => {
      r.value = d;
    }, l = (d, c) => {
      const u = c !== void 0 ? c : r.value;
      u ? i.close({
        action: d,
        payload: u
      }) : i.close(d);
    };
    return (d, c) => (v(), z(wCe, {
      title: o.value,
      size: "small",
      padding: "large",
      "header-appearance": "plain",
      onClose: c[7] || (c[7] = (u) => l("cancel")),
      onConfirm: c[8] || (c[8] = (u) => l("confirm"))
    }, {
      footer: Q(() => [
        R("div", {
          class: x(d.$style.actions)
        }, [
          R("div", {
            class: x(d.$style.left)
          }, [
            e.type === "alert" ? (v(), z(Zt, {
              key: 0,
              size: "small",
              "icon-left": e.confirmIcon ?? "phosphor/check",
              onClick: c[0] || (c[0] = (u) => l("confirm"))
            }, {
              default: Q(() => [
                Oe(se(e.confirmationText ?? T(t)("common.action.ok")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : e.type === "save" ? (v(), z(Zt, {
              key: 1,
              "icon-left": e.confirmIcon ?? "phosphor/floppy-disk",
              size: "small",
              onClick: c[1] || (c[1] = (u) => l("confirm"))
            }, {
              default: Q(() => [
                Oe(se(e.confirmationText ?? T(t)("common.action.save")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : e.type === "delete" ? (v(), z(Zt, {
              key: 2,
              "icon-left": e.confirmIcon ?? "phosphor/trash",
              size: "small",
              intent: "destructive",
              onClick: c[2] || (c[2] = (u) => l("confirm"))
            }, {
              default: Q(() => [
                Oe(se(e.confirmationText ?? T(t)("common.action.delete")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : e.type === "discard" ? (v(), z(Zt, {
              key: 3,
              size: "small",
              intent: "destructive",
              "icon-left": e.confirmIcon ?? e.discardIcon ?? "phosphor/broom",
              onClick: c[3] || (c[3] = (u) => l("confirm"))
            }, {
              default: Q(() => [
                Oe(se(e.confirmationText ?? T(t)("settings.tableBar.label.discard")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : V("", !0),
            e.type === "save" ? (v(), z(Zt, {
              key: 4,
              size: "small",
              appearance: "secondary",
              onClick: c[4] || (c[4] = (u) => l("abort"))
            }, {
              default: Q(() => [
                Oe(se(e.discardText ?? T(t)("settings.tableBar.label.discard")), 1)
              ]),
              _: 1
            })) : V("", !0),
            e.type === "delete" || e.type === "discard" || e.type === "alert" ? (v(), z(Zt, {
              key: 5,
              size: "small",
              appearance: "secondary",
              onClick: c[5] || (c[5] = (u) => l("cancel"))
            }, {
              default: Q(() => [
                Oe(se(e.discardText ?? T(t)("common.action.cancel")), 1)
              ]),
              _: 1
            })) : V("", !0)
          ], 2),
          R("div", {
            class: x(d.$style.right)
          }, [
            e.type === "save" ? (v(), z(Zt, {
              key: 0,
              size: "small",
              appearance: "secondary",
              onClick: c[6] || (c[6] = (u) => l("cancel"))
            }, {
              default: Q(() => [
                Oe(se(e.cancelText ?? T(t)("common.action.continueEditing")), 1)
              ]),
              _: 1
            })) : V("", !0)
          ], 2)
        ], 2)
      ]),
      default: Q(() => [
        s.value ? (v(), y("div", {
          key: 0,
          class: x(d.$style.message)
        }, [
          R("span", null, se(s.value.primary), 1),
          s.value.secondary ? (v(), y("span", yCe, " " + se(s.value.secondary), 1)) : V("", !0)
        ], 2)) : V("", !0),
        ve(d.$slots, "content", {
          setPayload: a,
          close: l
        }),
        e.customComponent ? (v(), z(Ot(e.customComponent), at({ key: 1 }, e.customComponentProps, {
          "set-payload": a,
          onClose: l
        }), null, 16)) : V("", !0)
      ]),
      _: 3
    }, 8, ["title"]));
  }
}), SCe = "_actions_10kl1_1", xCe = "_left_10kl1_6", RCe = "_right_10kl1_10", ECe = "_message_10kl1_14", ACe = {
  actions: SCe,
  left: xCe,
  right: RCe,
  message: ECe
}, FCe = {
  $style: ACe
}, KMe = /* @__PURE__ */ we(bCe, [["__cssModules", FCe]]), MCe = /* @__PURE__ */ de({
  __name: "SCADropdownGroupHeader",
  props: {
    header: {}
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x(t.$style.root)
    }, [
      R("span", null, se(e.header), 1)
    ], 2));
  }
}), ICe = "_root_h74c5_747", PCe = {
  root: ICe
}, DCe = {
  $style: PCe
}, ZMe = /* @__PURE__ */ we(MCe, [["__cssModules", DCe]]), TCe = /* @__PURE__ */ de({
  __name: "SCAToast",
  props: {
    text: {},
    intent: { default: "none" },
    emphasis: { default: "low" },
    closeable: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = s8(), o = D(() => t.emphasis !== "high" ? "secondary" : "inverted"), s = D(() => t.emphasis !== "high" ? {
      appearance: "primary",
      type: "bare"
    } : t.intent === "warning" ? {
      appearance: "reverseInverted",
      type: "bare"
    } : {
      appearance: "inverted",
      type: "bare"
    }), i = D(() => {
      switch (t.intent) {
        case "none":
          return;
        case "info":
          return "phosphor/check-circle-fill";
        case "success":
          return "phosphor/check-circle-fill";
        case "warning":
          return "phosphor/warning-fill";
        case "error":
          return "phosphor/warning-diamond-fill";
        default:
          return "phosphor/info";
      }
    });
    return (r, a) => (v(), y("div", {
      class: x([
        r.$style.toast,
        r.$style[t.emphasis],
        r.$style[t.intent],
        { [r.$style.hasIcon]: t.intent !== "none", [r.$style.isCloseable]: t.closeable }
      ])
    }, [
      R("div", {
        class: x(r.$style.content)
      }, [
        i.value ? (v(), z(Fe, {
          key: 0,
          class: x(r.$style.icon),
          icon: i.value
        }, null, 8, ["class", "icon"])) : V("", !0),
        Oe(" " + se(e.text), 1)
      ], 2),
      r.$slots.default ? (v(), y("div", {
        key: 0,
        class: x(r.$style.actions)
      }, [
        ve(r.$slots, "default", { buttonProps: s.value })
      ], 2)) : V("", !0),
      e.closeable ? (v(), z(ut, {
        key: 1,
        type: "bare",
        appearance: o.value,
        icon: "phosphor/x",
        onClick: T(n).close
      }, null, 8, ["appearance", "onClick"])) : V("", !0)
    ], 2));
  }
}), kCe = "_toast_8xxth_747", LCe = "_content_8xxth_765", BCe = "_actions_8xxth_770", OCe = "_info_8xxth_774", GCe = "_success_8xxth_777", HCe = "_warning_8xxth_780", VCe = "_error_8xxth_783", _Ce = "_hasIcon_8xxth_786", NCe = "_isCloseable_8xxth_789", $Ce = "_low_8xxth_792", zCe = "_icon_8xxth_797", WCe = "_high_8xxth_801", UCe = {
  toast: kCe,
  content: LCe,
  actions: BCe,
  info: OCe,
  success: GCe,
  warning: HCe,
  error: VCe,
  hasIcon: _Ce,
  isCloseable: NCe,
  low: $Ce,
  icon: zCe,
  high: WCe
}, KCe = {
  $style: UCe
}, ZCe = /* @__PURE__ */ we(TCe, [["__cssModules", KCe]]), qCe = 5e3;
function Tv(e, t) {
  return i8().push(
    ZCe,
    {
      text: e,
      closeable: !0,
      emphasis: "high",
      intent: t
    },
    void 0,
    { time: qCe }
  );
}
const jCe = ["accept", "multiple"], YCe = /* @__PURE__ */ de({
  __name: "SCADragAndDropField",
  props: {
    extended: { type: Boolean, default: !1 },
    caption: { default: void 0 },
    dataTypes: { default: void 0 },
    multiple: { type: Boolean, default: !0 },
    alert: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 }
  },
  emits: ["files"],
  setup(e, { emit: t }) {
    const { t: n } = fn(), o = e, s = t, i = W(), r = D(() => {
      if (o.caption !== void 0) return o.caption;
      const h = [];
      if (o.dataTypes && o.dataTypes.length > 0) {
        const g = o.dataTypes.map((p) => {
          const f = p.split("/");
          return f.length === 2 ? f[1] : f[0].replace(".", "");
        });
        if (g.length > 0) {
          const p = [];
          if (g.length > 1) {
            const f = g.pop();
            f && p.push(f);
          }
          p.unshift(g.join(", ")), h.push(p.join(` ${n("common.label.or2")} `));
        }
      }
      return o.maxSize && h.push(n("common.label.maxSizeOf", { size: ch(o.maxSize) })), h.join(". ");
    }), { isOverDropZone: a } = YU(i, {
      // specify the types of data to be received.
      dataTypes: o.dataTypes,
      // control multi-file drop
      multiple: o.multiple,
      // whether to prevent default behavior for unhandled events
      preventDefaultForUnhandled: !1,
      // A dropped folder only exists in dataTransfer.items; useDropZone's own file list comes from
      // dataTransfer.files, where it shows up as one unreadable entry and its contents are lost.
      onDrop: (h, g) => void u(g)
    });
    function l(h) {
      if (h.size === 0)
        return Tv(n("common.info.fileParamEmpty", { filename: h.name }), "warning"), !1;
      if (o.maxSize !== void 0 && h.size > o.maxSize) {
        const g = n("common.info.fileParamToo", {
          filename: h.name,
          maxSize: ch(o.maxSize)
        });
        return Tv(g, "warning"), !1;
      }
      return !0;
    }
    function d(h) {
      const g = h.filter(l);
      g.length > 0 && s("files", g);
    }
    function c(h) {
      const g = h.target;
      g.files && (d(Array.from(g.files)), g.value = "");
    }
    async function u(h) {
      const g = await vA(h);
      d(o.multiple ? g : g.slice(0, 1));
    }
    return (h, g) => {
      var p;
      return v(), y("div", {
        ref_key: "dropZoneRef",
        ref: i,
        class: x([
          h.$style.dragAndDropField,
          {
            [h.$style.isOverDropZone]: T(a),
            [h.$style.alert]: e.alert,
            [h.$style.disabled]: e.disabled,
            [h.$style.extended]: e.extended
          }
        ])
      }, [
        te(Fe, {
          icon: "phosphor/upload-simple",
          size: "20px",
          class: x(h.$style.icon)
        }, null, 8, ["class"]),
        R("div", {
          class: x(h.$style.content)
        }, [
          R("h6", {
            class: x(h.$style.title)
          }, [
            Oe(se(T(n)("common.action.dragDrop")) + " ", 1),
            R("a", {
              class: x(h.$style.chooseFile)
            }, [
              Oe(se(T(n)("common.placeholder.file")) + " ", 1),
              R("input", {
                type: "file",
                accept: (p = e.dataTypes) == null ? void 0 : p.join(", "),
                multiple: e.multiple,
                onInput: c
              }, null, 40, jCe)
            ], 2),
            Oe(" " + se(T(n)("common.action.upload2")), 1)
          ], 2),
          e.extended ? (v(), y("small", {
            key: 0,
            class: x(h.$style.small)
          }, se(r.value), 3)) : V("", !0)
        ], 2)
      ], 2);
    };
  }
}), QCe = "_dragAndDropField_qljqn_1", JCe = "_extended_qljqn_14", XCe = "_alert_qljqn_21", ewe = "_disabled_qljqn_24", twe = "_isOverDropZone_qljqn_37", nwe = "_icon_qljqn_41", owe = "_content_qljqn_45", swe = "_title_qljqn_52", iwe = "_small_qljqn_61", rwe = "_chooseFile_qljqn_70", awe = {
  dragAndDropField: QCe,
  extended: JCe,
  alert: XCe,
  disabled: ewe,
  isOverDropZone: twe,
  icon: nwe,
  content: owe,
  title: swe,
  small: iwe,
  chooseFile: rwe
}, lwe = {
  $style: awe
}, dwe = /* @__PURE__ */ we(YCe, [["__cssModules", lwe]]), cwe = {
  csv: { icon: "phosphor/file-csv", color: "var(--color-coolGrey-0)" },
  doc: { icon: "phosphor/microsoft-word-logo", color: "var(--color-brand-word)" },
  figma: { icon: "phosphor/figma-logo", color: "var(--color-brand-figma)" },
  file: { icon: "phosphor/file", color: "var(--color-coolGrey-0)" },
  image: { icon: "phosphor/image-square", color: "var(--color-grape-0)" },
  pdf: { icon: "phosphor/file-pdf", color: "var(--color-brand-pdf)" },
  ppt: { icon: "phosphor/file-ppt", color: "var(--color-brand-ppt)" },
  psd: { icon: "generic/file-psd", color: "var(--color-brand-psd)" },
  sketch: { icon: "phosphor/sketch-logo", color: "var(--color-brand-sketch)" },
  txt: { icon: "phosphor/file-txt", color: "var(--color-coolGrey-0)" },
  video: { icon: "phosphor/file-video", color: "var(--color-orange-0)" },
  xls: { icon: "phosphor/microsoft-excel-logo", color: "var(--color-brand-excel)" },
  zip: { icon: "phosphor/file-zip", color: "var(--color-teal-0)" }
}, uwe = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xls",
  "application/vnd.oasis.opendocument.spreadsheet": "xls",
  "text/csv": "csv",
  "application/rtf": "txt",
  "application/vnd.oasis.opendocument.text": "txt",
  "text/html": "txt",
  "text/markdown": "txt",
  "text/plain": "txt",
  "application/vnd.ms-powerpoint": "ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "ppt",
  "application/gzip": "zip",
  "application/vnd.rar": "zip",
  "application/x-7z-compressed": "zip",
  "application/x-rar-compressed": "zip",
  "application/x-tar": "zip",
  "application/x-zip-compressed": "zip",
  "application/zip": "zip",
  "application/x-photoshop": "psd",
  "image/vnd.adobe.photoshop": "psd",
  "application/vnd.sketch": "sketch",
  "application/x-sketch": "sketch",
  "application/x-figma": "figma",
  "video/mp4": "video",
  "video/webm": "video",
  "video/x-msvideo": "video"
}, hwe = {
  avif: "image",
  bmp: "image",
  gif: "image",
  heic: "image",
  jpeg: "image",
  jpg: "image",
  png: "image",
  svg: "image",
  tif: "image",
  tiff: "image",
  webp: "image",
  doc: "doc",
  docx: "doc",
  xls: "xls",
  xlsx: "xls",
  ods: "xls",
  csv: "csv",
  pdf: "pdf",
  htm: "txt",
  html: "txt",
  md: "txt",
  odt: "txt",
  rtf: "txt",
  txt: "txt",
  ppt: "ppt",
  pptx: "ppt",
  mp4: "video",
  webm: "video",
  avi: "video",
  "7z": "zip",
  gz: "zip",
  rar: "zip",
  tar: "zip",
  zip: "zip",
  psd: "psd",
  sketch: "sketch",
  fig: "figma",
  jam: "figma"
}, kv = (e) => {
  const t = e.toLowerCase();
  return uwe[t] ?? (t.startsWith("image/") ? "image" : void 0);
}, Lv = (e) => hwe[e.replace(/^\./, "").toLowerCase()], gwe = (e) => e.includes(".") ? e.split(".").pop() ?? "" : "", pwe = ({
  mimeType: e,
  extension: t,
  fileName: n
}) => cwe[kv(e ?? "") ?? kv(t ?? "") ?? Lv(t ?? "") ?? Lv(gwe(n ?? "")) ?? "file"], fwe = /* @__PURE__ */ de({
  __name: "SCAFileItem",
  props: {
    file: { default: void 0 },
    inverted: { type: Boolean, default: !0 },
    extended: { type: Boolean, default: !0 },
    thumbnail: { type: Boolean, default: !0 },
    percentage: { default: void 0 }
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = D(() => {
      var i, r;
      return pwe({ mimeType: (i = n.file) == null ? void 0 : i.type, fileName: (r = n.file) == null ? void 0 : r.name });
    });
    return (i, r) => (v(), y("div", {
      class: x([i.$style.fileItem, { [i.$style.inverted]: e.inverted }])
    }, [
      e.extended && e.thumbnail ? (v(), z(Fe, {
        key: 0,
        class: x(i.$style.thumbnail),
        icon: s.value.icon,
        color: s.value.color,
        size: "40px"
      }, null, 8, ["class", "icon", "color"])) : V("", !0),
      R("div", {
        class: x(i.$style.info)
      }, [
        R("div", {
          class: x(i.$style.infoTop)
        }, [
          R("div", {
            class: x(i.$style.fileName)
          }, se(e.file.name), 3),
          te(ut, {
            class: x(i.$style.cancel),
            type: "bare",
            size: "medium",
            appearance: "secondary",
            icon: "phosphor/x",
            onClick: r[0] || (r[0] = (a) => o("remove"))
          }, null, 8, ["class"])
        ], 2),
        e.extended ? (v(), y("div", {
          key: 0,
          class: x(i.$style.infoBottom)
        }, [
          R("div", {
            class: x(i.$style.details)
          }, [
            R("div", null, se(T(ch)(e.file.size)), 1)
          ], 2),
          e.percentage ? (v(), y("div", {
            key: 0,
            class: x(i.$style.percentage)
          }, se(e.percentage) + "%", 3)) : V("", !0)
        ], 2)) : V("", !0)
      ], 2)
    ], 2));
  }
}), mwe = "_fileItem_tatyq_1", vwe = "_isUploaded_tatyq_17", Cwe = "_inverted_tatyq_20", wwe = "_thumbnail_tatyq_26", ywe = "_info_tatyq_30", bwe = "_infoTop_tatyq_38", Swe = "_fileName_tatyq_43", xwe = "_cancel_tatyq_50", Rwe = "_infoBottom_tatyq_54", Ewe = "_details_tatyq_64", Awe = "_percentage_tatyq_82", Fwe = {
  fileItem: mwe,
  isUploaded: vwe,
  inverted: Cwe,
  thumbnail: wwe,
  info: ywe,
  infoTop: bwe,
  fileName: Swe,
  cancel: xwe,
  infoBottom: Rwe,
  details: Ewe,
  percentage: Awe
}, Mwe = {
  $style: Fwe
}, Iwe = /* @__PURE__ */ we(fwe, [["__cssModules", Mwe]]), Pwe = /* @__PURE__ */ de({
  __name: "SCAFileUploader",
  props: {
    extended: { type: Boolean, default: !1 },
    dataTypes: { default: void 0 },
    multiple: { type: Boolean, default: !0 },
    alert: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    maxSize: { default: void 0 },
    modelValue: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const s = Bn(e, "modelValue", t, { passive: !0 });
    function i(a) {
      s.value = [...s.value, ...a];
    }
    function r(a) {
      const l = [...s.value];
      l.splice(a, 1), s.value = l;
    }
    return (a, l) => (v(), y("div", {
      class: x([a.$style.fileUploader, { [a.$style.extended]: e.extended }])
    }, [
      e.label ? (v(), y("label", {
        key: 0,
        class: x(a.$style.label)
      }, se(e.label), 3)) : V("", !0),
      te(dwe, {
        extended: e.extended,
        "data-types": e.dataTypes,
        multiple: e.multiple,
        alert: e.alert,
        disabled: e.disabled,
        "max-size": e.maxSize,
        onFiles: i
      }, null, 8, ["extended", "data-types", "multiple", "alert", "disabled", "max-size"]),
      e.helperText ? (v(), z(Gr, {
        key: 1,
        class: x(a.$style.helperText)
      }, {
        default: Q(() => [
          Oe(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["class"])) : V("", !0),
      T(s).length > 0 ? (v(), y("div", {
        key: 2,
        class: x(a.$style.items)
      }, [
        (v(!0), y(Se, null, We(T(s), (d, c) => (v(), z(Iwe, {
          key: `${c}_${d.name}`,
          file: d,
          extended: e.extended && T(s).length <= 3,
          onRemove: (u) => r(c)
        }, null, 8, ["file", "extended", "onRemove"]))), 128))
      ], 2)) : V("", !0)
    ], 2));
  }
}), Dwe = "_fileUploader_1o85o_1", Twe = "_extended_1o85o_7", kwe = "_items_1o85o_7", Lwe = "_label_1o85o_17", Bwe = {
  fileUploader: Dwe,
  extended: Twe,
  items: kwe,
  label: Lwe
}, Owe = {
  $style: Bwe
}, qMe = /* @__PURE__ */ we(Pwe, [["__cssModules", Owe]]);
function I2(e, t, n = {}) {
  const o = Bn(e, "searchTerm", t, { passive: !0 }), s = Bn(e, "items", t, { passive: !0, deep: !0 }), i = tn("searchResultsInfiniteRef"), r = Mi("inSidebar", W(!0)), a = D(() => r.value), l = D(
    () => !e.disabled && (!e.maxItems || s.value.length < e.maxItems)
  );
  function d(f, m) {
    return f.id != null ? String(f.id) : f.label ? `${f.label}_${m ?? ""}` : JSON.stringify(f);
  }
  function c(f) {
    return s.value.some((m) => d(m) === d(f));
  }
  function u(f) {
    var m;
    return (m = n.isSingleSelect) != null && m.value ? !1 : !c(f) && !l.value;
  }
  const h = D(() => {
    const f = e.inlineSelected ? e.searchResults ?? [] : (e.searchResults ?? []).filter(
      (m) => !s.value.some((C) => d(C) === d(m))
    );
    return e.preserveOrder ? f : f.sort((m, C) => {
      const w = String(m.label ?? ""), b = String(C.label ?? "");
      return w.localeCompare(b, void 0, { sensitivity: "base", numeric: !0 });
    });
  });
  function g(f) {
    if (e.disabled || e.readonly) return;
    const m = s.value[f], C = [...s.value];
    C.splice(f, 1), s.value = C;
    const w = (e.searchResults ?? []).find((b) => d(b) === d(m));
    w && (w.selected = !1);
  }
  function p() {
    if (!e.hasMore || e.loadingMore) return;
    const f = i.value;
    f && f.scrollHeight - f.scrollTop - f.clientHeight < 50 && t("loadMore");
  }
  return {
    searchTerm: o,
    selectedItems: s,
    searchResultsInfiniteRef: i,
    inSideBar: a,
    canAddMore: l,
    getItemKey: d,
    isSelected: c,
    isDisabledForSelection: u,
    availableItems: h,
    removeSelectedItem: g,
    onScroll: p
  };
}
const Gwe = ["data-drag-id"], Hwe = ["id", "placeholder", "disabled"], Vwe = { key: 1 }, _we = ["placeholder"], Nwe = ["disabled", "checked", "onChange"], $we = ["disabled", "checked", "onChange"], zwe = de({ inheritAttrs: !1 }), Wwe = /* @__PURE__ */ de({
  ...zwe,
  __name: "SCAInputTags",
  props: {
    helperText: { default: void 0 },
    isDraggable: { type: Boolean, default: !1 },
    showArrow: { type: Boolean, default: !1 },
    useDropdownMode: { type: Boolean, default: !1 },
    dropdownWidth: { default: void 0 },
    searchTerm: { default: "" },
    items: {},
    searchResults: { default: () => [] },
    maxItems: { default: void 0 },
    placeholder: { default: "" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    minSearchLength: { default: 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    isOpenByDefault: { type: Boolean, default: !1 },
    showTooltip: { type: Boolean, default: !1 },
    preserveOrder: { type: Boolean, default: !1 },
    inlineSelected: { type: Boolean, default: !1 },
    renderKey: {},
    label: {},
    labelPosition: {},
    appearance: {},
    optionalLabelText: {},
    htmlFor: {},
    validationError: { type: Boolean },
    required: { type: Boolean },
    prefix: {},
    highlightLabel: { type: Boolean },
    tooltipType: {},
    tooltipId: {},
    tooltip: {},
    helpLink: {},
    focused: { type: Boolean }
  },
  emits: ["update:searchTerm", "update:items", "init", "loadMore", "close", "apply"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = 3, i = 3, r = W(!1), a = W(!1), l = W(!1), d = W(!1), {
      searchTerm: c,
      selectedItems: u,
      searchResultsInfiniteRef: h,
      inSideBar: g,
      getItemKey: p,
      isSelected: f,
      isDisabledForSelection: m,
      availableItems: C,
      removeSelectedItem: w,
      onScroll: b
    } = I2(n, o), A = tn("placeholderCalcRef"), S = tn("searchInputRef"), F = tn("contentRef"), { setDropdown: E, hideList: M } = wf(), { width: I } = QU(A), { isDesktop: P } = HA(), k = D(() => {
      const q = P.value ? 8 : 32;
      return `${Math.max(I.value, q)}px`;
    }), B = D(
      () => a.value ? u.value : u.value.slice(0, s)
    ), j = D(() => c.value ? u.value.filter((q) => q.label.toLowerCase().includes(c.value.toLowerCase())).length : u.value.length), N = D(() => {
      let q = u.value;
      return c.value && (q = q.filter((ge) => ge.label.toLowerCase().includes(c.value.toLowerCase()))), l.value || (q = q.slice(0, i)), q;
    });
    function re() {
      n.disabled || n.readonly || r.value || (r.value = !0, o("init"));
    }
    function H(q) {
      if (m(q)) return;
      const ge = p(q), ie = [...u.value], ee = ie.findIndex((_e) => p(_e) === ge);
      ee > -1 ? ie.splice(ee, 1) : ie.unshift(q), u.value = ie;
      const ae = n.searchResults.find((_e) => p(_e) === ge);
      ae && (ae.selected = ee === -1);
    }
    const { isHighlighted: _, handleKeyDown: ne, handleFocus: ce, handlePointerDown: me } = Cf({
      isOpen: r,
      items: C,
      listEl: h,
      searchTerm: c,
      open: re,
      commit: H,
      isInert: () => n.disabled || n.readonly,
      focusAnchor: () => F.value,
      hideList: M
    }), Ie = W(!1), L = D(() => !n.disabled && !n.readonly && (Ie.value || r.value));
    function oe() {
      Ie.value = !0, ce();
    }
    function K(q) {
      var ie;
      const ge = q.relatedTarget;
      ge && ((ie = F.value) != null && ie.contains(ge)) || (Ie.value = !1);
    }
    Et(() => {
      n.isOpenByDefault && (r.value = !0);
    }), Re(r, (q) => {
      if (q) return;
      c.value = "";
      const ge = F.value;
      ge && !ge.matches(":hover") || (d.value = !1, o("close"));
    });
    function G(q) {
      return String(u.value.indexOf(q));
    }
    const le = D(() => n.disabled || n.readonly || !n.isDraggable), be = `inputTags-${Es()}`, Me = Nc({
      getId: G,
      ghostLabel: (q) => q.label,
      ghostIcon: (q) => q.icon,
      dragGroup: be,
      disabled: le
    });
    function Be(q) {
      const ge = Me.dragHandlers(q);
      return { ...ge, draggable: ge.draggable && !q.disabled };
    }
    function qe(q) {
      return Me.draggedItems.value.includes(q);
    }
    const he = tn("tagsRef"), Pe = hf({
      container: () => he.value,
      getId: G,
      findItem: (q) => u.value[Number(q)] ?? null
    }), J = $c({
      items: u,
      getId: G,
      dragGroup: be,
      axis: "horizontal",
      rowLocator: Pe,
      indicator: "rowClass",
      rules: [Vc(G)],
      disabled: le,
      onDrop: (q) => {
        const ge = q.source[0];
        if (!ge) return;
        const ie = [...u.value], ee = ie.indexOf(ge);
        ee !== -1 && (ie.splice(ee, 1), ie.splice(q.index, 0, ge), u.value = ie);
      }
    });
    function Y(q) {
      if (Me.isDragging.value)
        return gf(J.rowIndicator.value, q, "horizontal");
    }
    return (q, ge) => {
      const ie = gg("tooltip");
      return v(), y(Se, null, [
        te(vf, at(q.$attrs, {
          label: e.label,
          "label-position": e.labelPosition,
          appearance: T(u).length > 0 && T(g) || e.useDropdownMode || e.disabled && !e.showArrow ? "no-border" : e.appearance,
          "helper-text": n.useDropdownMode ? void 0 : e.helperText,
          "optional-label-text": e.optionalLabelText,
          "html-for": e.htmlFor,
          "validation-error": e.validationError,
          required: e.required,
          prefix: e.prefix,
          "highlight-label": e.highlightLabel !== void 0 ? e.highlightLabel : !e.disabled && (d.value || r.value),
          tooltip: e.tooltip,
          "help-link": e.helpLink,
          style: { "--sca-label-align": "start", "--sca-input-field-wrapper-padding": "0px", position: "relative" },
          focused: L.value,
          onMouseenter: ge[12] || (ge[12] = (ee) => d.value = !0),
          onMouseleave: ge[13] || (ge[13] = (ee) => d.value = !1)
        }), {
          labelAction: Q(() => [
            ve(q.$slots, "labelAction")
          ]),
          default: Q(() => [
            R("div", {
              ref: "contentRef",
              class: x([q.$style.content, !e.disabled && !e.readonly && !e.useDropdownMode && d.value && q.$style.hovered]),
              tabindex: "0",
              onClick: re,
              onKeydown: ge[10] || (ge[10] = //@ts-ignore
              (...ee) => T(ne) && T(ne)(...ee)),
              onFocusin: oe,
              onFocusout: K,
              onPointerdown: ge[11] || (ge[11] = //@ts-ignore
              (...ee) => T(me) && T(me)(...ee))
            }, [
              r.value && !e.useDropdownMode ? (v(), y("div", {
                key: 0,
                class: x(q.$style.baseInfo)
              }, [
                R("span", null, se(q.$t("common.label.selected")), 1),
                R("span", {
                  class: x([q.$style.badgePlaceholder])
                }, "(" + se(T(u).length) + ")", 3)
              ], 2)) : e.useDropdownMode ? V("", !0) : (v(), y("div", at({
                key: 1,
                ref: "tagsRef",
                class: q.$style.tags
              }, T(J).containerHandlers), [
                T(u).length === 0 && e.placeholder ? (v(), y("span", {
                  key: 0,
                  class: x(q.$style.placeholderText)
                }, se(e.placeholder), 3)) : V("", !0),
                (v(!0), y(Se, null, We(B.value, (ee, ae) => (v(), y("div", at({
                  key: T(p)(ee, ae),
                  "data-drag-id": G(ee),
                  class: [
                    q.$style.tagWrapper,
                    e.isDraggable && qe(ee) && q.$style.dragging,
                    e.isDraggable && Y(ee)
                  ]
                }, { ref_for: !0 }, e.isDraggable && !e.disabled && !e.readonly ? Be(ee) : void 0), [
                  Tn((v(), z(no, {
                    tabindex: "-1",
                    removable: !e.disabled && !ee.disabled && !e.readonly,
                    disabled: ee.disabled,
                    selected: ee.selected,
                    avatar: ee.avatar,
                    icon: ee.iconFramed ? void 0 : ee.icon,
                    "icon-size": ee.iconSize,
                    "icon-color": ee.iconColor,
                    "truncate-tooltip": !e.showTooltip,
                    unavailable: ee.unavailable,
                    tooltip: ee.tooltip,
                    onRemove: (_e) => T(w)(ae)
                  }, Wn({
                    default: Q(() => [
                      R("div", {
                        class: x(q.$style.tag)
                      }, [
                        e.isDraggable && !e.disabled && !e.readonly && !ee.disabled ? (v(), y("div", {
                          key: 0,
                          class: x(q.$style.tagIcon)
                        }, [
                          te(Fe, {
                            icon: "phosphor/dots-six-vertical",
                            size: "16px"
                          })
                        ], 2)) : V("", !0),
                        R("div", {
                          class: x(q.$style.tagLabel)
                        }, se(ee.label), 3)
                      ], 2)
                    ]),
                    _: 2
                  }, [
                    ee.iconFramed && ee.icon ? {
                      name: "iconLeft",
                      fn: Q(() => [
                        R("div", {
                          class: x(q.$style.iconFrame)
                        }, [
                          te(Fe, {
                            icon: ee.icon,
                            size: "12px",
                            color: ee.iconColor
                          }, null, 8, ["icon", "color"])
                        ], 2)
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1032, ["removable", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "truncate-tooltip", "unavailable", "tooltip", "onRemove"])), [
                    [ie, e.showTooltip && !ee.tooltip ? ee.id : null]
                  ])
                ], 16, Gwe))), 128)),
                T(u).length > s ? (v(), y("button", {
                  key: 1,
                  class: x([q.$style.showAllButton, q.$style.lessMargin]),
                  onClick: ge[0] || (ge[0] = Ge((ee) => a.value = !a.value, ["prevent", "stop"]))
                }, [
                  R("span", {
                    class: x(q.$style.buttonText)
                  }, se(a.value ? q.$t("common.action.showLess") : q.$t("common.action.show")), 3),
                  a.value ? V("", !0) : (v(), y("span", {
                    key: 0,
                    class: x(q.$style.badge)
                  }, " (" + se(T(u).length - s) + ") ", 3))
                ], 2)) : V("", !0),
                R("input", {
                  id: e.htmlFor,
                  placeholder: e.placeholder,
                  disabled: e.showArrow && e.disabled,
                  style: Ke({ minWidth: k.value }),
                  class: x(q.$style.searchInputHidden),
                  tabindex: "-1",
                  onClick: re
                }, null, 14, Hwe)
              ], 16)),
              R("div", {
                class: x(e.useDropdownMode ? q.$style.searchInputContainer : q.$style.dropdownAnchor),
                style: Ke(e.dropdownWidth ? { "--input-tags-results-width": e.dropdownWidth } : void 0)
              }, [
                e.loading ? (v(), z(rl, {
                  key: 0,
                  class: x(q.$style.loader),
                  size: "small",
                  indeterminate: ""
                }, null, 8, ["class"])) : V("", !0),
                te(Yt, {
                  ref: T(E),
                  "is-open": r.value,
                  "onUpdate:isOpen": ge[8] || (ge[8] = (ee) => r.value = ee),
                  "no-padding": !0,
                  "more-padding": !0,
                  "offset-y": 2,
                  width: e.dropdownWidth,
                  onPositioned: ge[9] || (ge[9] = (ee) => {
                    var ae;
                    return (ae = S.value) == null ? void 0 : ae.focus();
                  })
                }, {
                  trigger: Q(({ togglePopover: ee }) => [
                    e.useDropdownMode ? (v(), z(ut, {
                      key: 0,
                      size: "small",
                      appearance: "secondary",
                      icon: "phosphor/plus",
                      disabled: e.disabled,
                      class: x({ [q.$style.active]: r.value }),
                      title: "Add user",
                      onClick: Ge(ee, ["stop"])
                    }, null, 8, ["disabled", "class", "onClick"])) : (v(), y("div", Vwe))
                  ]),
                  default: Q(() => {
                    var ee;
                    return [
                      R("div", {
                        class: x(q.$style.header)
                      }, [
                        te(ut, {
                          class: x(q.$style.iconButton),
                          title: q.$t("common.action.apply"),
                          icon: "phosphor/check",
                          appearance: "secondary",
                          size: "small",
                          onClick: ge[1] || (ge[1] = Ge((ae) => {
                            r.value = !1, q.$emit("apply");
                          }, ["stop", "prevent"]))
                        }, null, 8, ["class", "title"]),
                        te(bf, {
                          appearance: "border",
                          "show-clear-icon": T(c).length > 0,
                          class: x(q.$style.searchInput),
                          onClear: ge[3] || (ge[3] = Ge((ae) => c.value = "", ["prevent", "stop"]))
                        }, {
                          default: Q(() => [
                            Tn(R("input", {
                              ref: "searchInputRef",
                              "onUpdate:modelValue": ge[2] || (ge[2] = (ae) => Yo(c) ? c.value = ae : null),
                              readonly: !1,
                              placeholder: q.$t("common.action.search")
                            }, null, 8, _we), [
                              [Qd, T(c)]
                            ])
                          ]),
                          _: 1
                        }, 8, ["show-clear-icon", "class"])
                      ], 2),
                      R("div", {
                        class: x(q.$style.borderFull)
                      }, null, 2),
                      ve(q.$slots, "beforeSearchResults"),
                      e.inlineSelected ? V("", !0) : (v(), y(Se, { key: 0 }, [
                        R("div", {
                          class: x([q.$style.searchResults, N.value.length === 0 && q.$style.displayNone])
                        }, [
                          (v(!0), y(Se, null, We(N.value, (ae, _e) => (v(), y("div", {
                            key: T(p)(ae, _e),
                            class: x(q.$style.item)
                          }, [
                            te(Ts, {
                              checked: T(f)(ae),
                              disabled: T(m)(ae)
                            }, {
                              default: Q(() => [
                                R("input", {
                                  type: "checkbox",
                                  disabled: T(m)(ae),
                                  checked: T(f)(ae),
                                  onChange: (Ne) => H(ae)
                                }, null, 40, Nwe)
                              ]),
                              _: 2
                            }, 1032, ["checked", "disabled"]),
                            te(no, {
                              id: T(p)(ae, _e),
                              disabled: T(m)(ae),
                              selected: T(f)(ae),
                              avatar: ae.avatar,
                              icon: ae.iconFramed ? void 0 : ae.icon,
                              "icon-size": ae.iconSize,
                              "icon-color": ae.iconColor,
                              style: { minWidth: 0 },
                              onMousedown: ge[4] || (ge[4] = Ge(() => {
                              }, ["prevent"])),
                              onClick: Ge((Ne) => H(ae), ["prevent"])
                            }, Wn({
                              default: Q(() => [
                                T(c) ? (v(), z(gi, {
                                  key: 0,
                                  text: ae.label,
                                  "search-term": T(c)
                                }, null, 8, ["text", "search-term"])) : (v(), y(Se, { key: 1 }, [
                                  Oe(se(ae.label), 1)
                                ], 64)),
                                ae.label.length > 30 ? (v(), z(zt, {
                                  key: 2,
                                  id: T(p)(ae, _e),
                                  text: ae.label
                                }, null, 8, ["id", "text"])) : V("", !0)
                              ]),
                              _: 2
                            }, [
                              ae.iconFramed && ae.icon ? {
                                name: "iconLeft",
                                fn: Q(() => [
                                  R("div", {
                                    class: x(q.$style.iconFrame)
                                  }, [
                                    te(Fe, {
                                      icon: ae.icon,
                                      size: "12px",
                                      color: ae.iconColor
                                    }, null, 8, ["icon", "color"])
                                  ], 2)
                                ]),
                                key: "0"
                              } : void 0
                            ]), 1032, ["id", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "onClick"])
                          ], 2))), 128)),
                          j.value > i ? (v(), y("button", {
                            key: 0,
                            class: x([q.$style.showAllButton, q.$style.morePadding]),
                            onClick: ge[5] || (ge[5] = Ge((ae) => l.value = !l.value, ["prevent", "stop"]))
                          }, [
                            R("span", {
                              class: x(q.$style.buttonText)
                            }, se(l.value ? q.$t("common.action.showLess") : q.$t("common.action.show")), 3),
                            l.value ? V("", !0) : (v(), y("span", {
                              key: 0,
                              class: x(q.$style.badge)
                            }, " (" + se(j.value - i) + ") ", 3))
                          ], 2)) : V("", !0)
                        ], 2),
                        N.value.length > 0 ? (v(), y("div", {
                          key: 0,
                          class: x(q.$style.border)
                        }, null, 2)) : V("", !0)
                      ], 64)),
                      R("div", {
                        ref_key: "searchResultsInfiniteRef",
                        ref: h,
                        class: x(q.$style.searchResults),
                        onScroll: ge[7] || (ge[7] = //@ts-ignore
                        (...ae) => T(b) && T(b)(...ae))
                      }, [
                        (v(!0), y(Se, null, We(T(C), (ae, _e) => (v(), y("div", {
                          key: n.renderKey !== void 0 ? `${T(p)(ae, _e)}-${n.renderKey}` : T(p)(ae, _e),
                          class: x([q.$style.item, T(_)(_e) && q.$style.highlighted])
                        }, [
                          te(Ts, {
                            checked: T(f)(ae) || !!ae.indeterminate,
                            deselect: !!ae.indeterminate,
                            disabled: T(m)(ae)
                          }, {
                            default: Q(() => [
                              R("input", {
                                type: "checkbox",
                                disabled: T(m)(ae),
                                checked: T(f)(ae) || !!ae.indeterminate,
                                onChange: (Ne) => H(ae)
                              }, null, 40, $we)
                            ]),
                            _: 2
                          }, 1032, ["checked", "deselect", "disabled"]),
                          te(no, {
                            id: T(p)(ae, _e),
                            disabled: T(m)(ae),
                            selected: T(f)(ae),
                            avatar: ae.avatar,
                            icon: ae.iconFramed ? void 0 : ae.icon,
                            "icon-size": ae.iconSize,
                            "icon-color": ae.iconColor,
                            style: Ke({ minWidth: 0, marginLeft: ae.level ? `${ae.level * 16}px` : void 0 }),
                            onMousedown: ge[6] || (ge[6] = Ge(() => {
                            }, ["prevent"])),
                            onClick: Ge((Ne) => H(ae), ["prevent"])
                          }, Wn({
                            default: Q(() => [
                              te(gi, {
                                text: ae.label,
                                "search-term": T(c)
                              }, null, 8, ["text", "search-term"]),
                              ae.label.length > 30 ? (v(), z(zt, {
                                key: 0,
                                id: T(p)(ae, _e),
                                text: ae.label
                              }, null, 8, ["id", "text"])) : V("", !0)
                            ]),
                            _: 2
                          }, [
                            ae.iconFramed && ae.icon ? {
                              name: "iconLeft",
                              fn: Q(() => [
                                R("div", {
                                  class: x(q.$style.iconFrame)
                                }, [
                                  te(Fe, {
                                    icon: ae.icon,
                                    size: "12px",
                                    color: ae.iconColor
                                  }, null, 8, ["icon", "color"])
                                ], 2)
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1032, ["id", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "style", "onClick"])
                        ], 2))), 128)),
                        ((ee = e.searchResults) == null ? void 0 : ee.length) === 0 && T(c).length >= n.minSearchLength ? (v(), z(ll, {
                          key: 0,
                          loading: n.loading
                        }, null, 8, ["loading"])) : V("", !0)
                      ], 34)
                    ];
                  }),
                  _: 3
                }, 8, ["is-open", "width"])
              ], 6)
            ], 34),
            e.showArrow && d.value && !e.disabled ? (v(), z(Fe, {
              key: 0,
              icon: r.value ? "phosphor/caret-up" : "phosphor/caret-down",
              class: x(q.$style.arrowIcon),
              size: "12px"
            }, null, 8, ["icon", "class"])) : V("", !0)
          ]),
          _: 3
        }, 16, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "html-for", "validation-error", "required", "prefix", "highlight-label", "tooltip", "help-link", "focused"]),
        e.placeholder ? (v(), y("span", {
          key: 0,
          ref: "placeholderCalcRef",
          class: x(q.$style.placeholderCalculator)
        }, se(e.placeholder ?? ""), 3)) : V("", !0)
      ], 64);
    };
  }
}), Uwe = "_content_1nf9q_1", Kwe = "_hovered_1nf9q_12", Zwe = "_disabled_1nf9q_17", qwe = "_tags_1nf9q_22", jwe = "_placeholderText_1nf9q_29", Ywe = "_dropdownAnchor_1nf9q_33", Qwe = "_searchInputHidden_1nf9q_43", Jwe = "_searchResults_1nf9q_55", Xwe = "_displayNone_1nf9q_73", eye = "_header_1nf9q_77", tye = "_item_1nf9q_83", nye = "_highlighted_1nf9q_96", oye = "_searchInput_1nf9q_43", sye = "_border_1nf9q_105", iye = "_borderFull_1nf9q_110", rye = "_showAllButton_1nf9q_115", aye = "_buttonText_1nf9q_131", lye = "_badge_1nf9q_131", dye = "_lessMargin_1nf9q_161", cye = "_morePadding_1nf9q_165", uye = "_baseInfo_1nf9q_169", hye = "_badgePlaceholder_1nf9q_179", gye = "_placeholderCalculator_1nf9q_183", pye = "_iconButton_1nf9q_189", fye = "_tagWrapper_1nf9q_194", mye = "_dragging_1nf9q_199", vye = "_tag_1nf9q_22", Cye = "_tagIcon_1nf9q_206", wye = "_tagLabel_1nf9q_209", yye = "_active_1nf9q_215", bye = "_arrowIcon_1nf9q_219", Sye = "_iconFrame_1nf9q_228", xye = {
  content: Uwe,
  hovered: Kwe,
  disabled: Zwe,
  tags: qwe,
  placeholderText: jwe,
  dropdownAnchor: Ywe,
  searchInputHidden: Qwe,
  searchResults: Jwe,
  displayNone: Xwe,
  header: eye,
  item: tye,
  highlighted: nye,
  searchInput: oye,
  border: sye,
  borderFull: iye,
  showAllButton: rye,
  buttonText: aye,
  badge: lye,
  lessMargin: dye,
  morePadding: cye,
  baseInfo: uye,
  badgePlaceholder: hye,
  placeholderCalculator: gye,
  iconButton: pye,
  tagWrapper: fye,
  dragging: mye,
  tag: vye,
  tagIcon: Cye,
  tagLabel: wye,
  active: yye,
  arrowIcon: bye,
  iconFrame: Sye
}, Rye = {
  $style: xye
}, jMe = /* @__PURE__ */ we(Wwe, [["__cssModules", Rye]]), Eye = ["tabindex"], Aye = ["id", "placeholder"], Fye = ["id", "onClick"], Mye = ["src"], Iye = /* @__PURE__ */ de({
  __name: "SCAInputTagsInline",
  props: {
    isEmail: { type: Boolean, default: !1 },
    resultsAsTags: { type: Boolean, default: !1 },
    showArrow: { type: Boolean, default: !1 },
    keepOpenOnSelect: { type: Boolean, default: !1 },
    searchTerm: { default: "" },
    items: {},
    searchResults: { default: () => [] },
    maxItems: { default: void 0 },
    placeholder: { default: "" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    minSearchLength: { default: 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    isOpenByDefault: { type: Boolean, default: !1 },
    showTooltip: { type: Boolean, default: !1 },
    preserveOrder: { type: Boolean },
    inlineSelected: { type: Boolean },
    renderKey: {},
    label: {},
    labelPosition: {},
    appearance: {},
    helperText: {},
    optionalLabelText: {},
    htmlFor: {},
    validationError: { type: Boolean },
    required: { type: Boolean },
    prefix: {},
    highlightLabel: { type: Boolean },
    tooltipType: {},
    tooltipId: {},
    tooltip: {},
    helpLink: {},
    focused: { type: Boolean }
  },
  emits: ["update:searchTerm", "update:items", "init", "loadMore", "close"],
  setup(e, { emit: t }) {
    const n = e, o = tn("contentRef"), s = t, i = W(!1), r = W(!0), a = W(!1), l = D(() => n.maxItems === 1), {
      searchTerm: d,
      selectedItems: c,
      searchResultsInfiniteRef: u,
      inSideBar: h,
      canAddMore: g,
      getItemKey: p,
      isSelected: f,
      isDisabledForSelection: m,
      availableItems: C,
      removeSelectedItem: w,
      onScroll: b
    } = I2(n, s, { isSingleSelect: l }), A = tn("searchInputRef"), { setDropdown: S, hideList: F } = wf(), E = D(() => g.value || l.value && n.isEmail), M = D(() => E.value && !n.readonly && !n.disabled);
    function I() {
      var he;
      n.disabled || n.readonly || (i.value = !0, (he = A.value) == null || he.focus());
    }
    function P(he) {
      var ge;
      if (m(he)) return;
      if (l.value) {
        c.value = [he], i.value = !1, d.value = "";
        return;
      }
      const Pe = p(he), J = [...c.value], Y = J.findIndex((ie) => p(ie) === Pe);
      Y > -1 ? J.splice(Y, 1) : J.push(he), c.value = J;
      const q = n.searchResults.find((ie) => p(ie) === Pe);
      q && (q.selected = Y === -1), n.keepOpenOnSelect || (i.value = !1, d.value = ""), window.innerWidth > 768 && ((ge = A.value) == null || ge.focus());
    }
    function k(he) {
      var Y;
      const Pe = he.relatedTarget, J = u.value;
      Pe && (J != null && J.contains(Pe) || (Y = o.value) != null && Y.contains(Pe)) || (_(), i.value = !1, d.value = "", a.value = !1);
    }
    const B = (he) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(he), j = (he) => n.isEmail && he.includes("@");
    function N(he) {
      var J;
      const Pe = ((J = he.id) == null ? void 0 : J.toString()) ?? "";
      return j(Pe) && !B(Pe);
    }
    function re(he) {
      return B(he) ? n.isEmail : j(he) && C.value.length === 0;
    }
    function H(he) {
      const Pe = he.trim().toLowerCase();
      return n.searchResults.find((Y) => {
        var q;
        return ((q = Y.email) == null ? void 0 : q.toLowerCase()) === Pe;
      }) ?? { label: he, id: he };
    }
    function _() {
      if (!j(d.value)) return;
      const he = H(d.value);
      !f(he) && !m(he) && (c.value = l.value ? [he] : [...c.value, he]), d.value = "";
    }
    function ne(he) {
      const Pe = H(he);
      if (f(Pe)) {
        d.value = "";
        return;
      }
      P(Pe);
    }
    function ce(he) {
      const Pe = c.value[he];
      !Pe || !N(Pe) || n.disabled || n.readonly || (w(he), d.value = Pe.label, Xe(() => {
        var J;
        return (J = A.value) == null ? void 0 : J.focus();
      }));
    }
    const me = /* @__PURE__ */ new Set(["Enter", " ", ",", ";"]), { isHighlighted: Ie, handleKeyDown: L, handleFocus: oe, handlePointerDown: K, focusField: G } = Cf({
      isOpen: i,
      items: C,
      listEl: u,
      searchTerm: d,
      open: I,
      commit: P,
      isInert: () => n.disabled || n.readonly,
      initialIndex: () => l.value ? C.value.findIndex((he) => f(he)) : 0,
      focusAnchor: () => (E.value ? A.value : null) ?? o.value,
      hideList: F,
      onClose: () => {
        d.value = "";
      }
    }), le = W(!1), be = D(() => !n.disabled && !n.readonly && (le.value || i.value));
    function Me() {
      le.value = !0, oe();
    }
    function Be(he) {
      var J;
      const Pe = he.relatedTarget;
      Pe && ((J = o.value) != null && J.contains(Pe)) || (le.value = !1);
    }
    Re(E, (he) => {
      he || !le.value || G();
    });
    function qe(he) {
      var J;
      if (n.disabled || n.readonly) return;
      if ((J = A.value) == null || J.focus(), he.key === "Backspace" && d.value === "") {
        const Y = c.value.map((q) => !q.disabled).lastIndexOf(!0);
        if (Y > -1) {
          he.preventDefault(), w(Y);
          return;
        }
      }
      const Pe = he.key.length === 1 && !he.ctrlKey && !he.metaKey && !he.altKey;
      if (!r.value && Pe) {
        r.value = !0, I();
        return;
      }
      if (me.has(he.key) && re(d.value)) {
        he.preventDefault(), ne(d.value);
        return;
      }
      he.key === "Tab" && re(d.value) && ne(d.value), L(he);
    }
    return VU(o, () => {
      _(), i.value && (i.value = !1, d.value = "", a.value = !1);
    }), Et(() => {
      n.isOpenByDefault && (i.value = !0, Xe(() => {
        var he;
        return (he = A.value) == null ? void 0 : he.focus();
      }));
    }), Re(d, () => {
      d.value.length > 0 && (i.value = !0);
    }), Re(i, (he) => {
      he && s("init");
    }), (he, Pe) => {
      const J = gg("tooltip");
      return v(), z(vf, {
        label: e.label,
        "label-position": e.labelPosition,
        appearance: T(c).length > 0 && T(h) || e.disabled ? "no-border" : e.appearance,
        "helper-text": e.helperText,
        "optional-label-text": e.optionalLabelText,
        "html-for": e.htmlFor,
        "validation-error": e.validationError,
        required: e.required,
        prefix: e.prefix,
        "highlight-label": e.highlightLabel !== void 0 ? e.highlightLabel : !e.disabled && (a.value || i.value),
        tooltip: e.tooltip,
        "help-link": e.helpLink,
        style: {
          "--sca-label-align": "start",
          "--sca-input-field-wrapper-padding": "0px",
          position: "relative"
        },
        focused: be.value,
        onMouseenter: Pe[6] || (Pe[6] = (Y) => a.value = !0),
        onMouseleave: Pe[7] || (Pe[7] = (Y) => a.value = !1),
        onBlur: k
      }, {
        labelAction: Q(() => [
          ve(he.$slots, "labelAction")
        ]),
        default: Q(() => [
          R("div", {
            ref_key: "contentRef",
            ref: o,
            class: x([
              he.$style.content,
              !e.disabled && !e.validationError && a.value && he.$style.hovered,
              !e.validationError && be.value && he.$style.contentHasFocus
            ]),
            tabindex: M.value ? -1 : 0,
            onClick: I,
            onKeydown: qe,
            onFocusin: Me,
            onFocusout: Be,
            onPointerdown: Pe[5] || (Pe[5] = //@ts-ignore
            (...Y) => T(K) && T(K)(...Y))
          }, [
            R("div", {
              class: x(he.$style.tags)
            }, [
              R("div", {
                class: x(he.$style.tagsContainer)
              }, [
                (v(!0), y(Se, null, We(T(c), (Y, q) => {
                  var ge, ie, ee, ae;
                  return Tn((v(), z(no, {
                    key: T(p)(Y, q),
                    tabindex: "-1",
                    removable: !e.disabled && !e.readonly && !Y.disabled,
                    disabled: Y.disabled,
                    selected: Y.selected,
                    avatar: (ge = Y.id) != null && ge.toString().includes("@") ? void 0 : Y.avatar,
                    icon: Y.iconFramed ? void 0 : Y.icon,
                    "icon-size": Y.iconSize,
                    "icon-color": Y.iconColor,
                    "truncate-tooltip": !(e.showTooltip && !((ie = Y.id) != null && ie.toString().includes("@"))),
                    unavailable: Y.unavailable,
                    tooltip: Y.tooltip,
                    error: N(Y),
                    onRemove: (_e) => T(w)(q),
                    onDblclick: (_e) => ce(q)
                  }, Wn({
                    default: Q(() => [
                      Oe(" " + se(Y.label), 1)
                    ]),
                    _: 2
                  }, [
                    N(Y) ? {
                      name: "iconLeft",
                      fn: Q(() => [
                        te(Fe, {
                          icon: "phosphor/warning-circle",
                          size: "16px"
                        })
                      ]),
                      key: "0"
                    } : (ee = Y.id) != null && ee.toString().includes("@") ? {
                      name: "iconLeft",
                      fn: Q(() => [
                        R("div", {
                          class: x(he.$style.emailIconWrapper)
                        }, [
                          te(Fe, {
                            icon: "phosphor/user",
                            size: "12px"
                          })
                        ], 2)
                      ]),
                      key: "1"
                    } : Y.iconFramed ? {
                      name: "iconLeft",
                      fn: Q(() => [
                        R("div", {
                          class: x(he.$style.iconFrame)
                        }, [
                          Y.icon ? (v(), z(Fe, {
                            key: 0,
                            icon: Y.icon,
                            size: "12px",
                            color: Y.iconColor
                          }, null, 8, ["icon", "color"])) : V("", !0)
                        ], 2)
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["removable", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "truncate-tooltip", "unavailable", "tooltip", "error", "onRemove", "onDblclick"])), [
                    [J, e.showTooltip && !Y.tooltip && !((ae = Y.id) != null && ae.toString().includes("@")) ? Y.id : null]
                  ]);
                }), 128)),
                R("div", {
                  class: x([
                    he.$style.searchInputWrapper,
                    {
                      [he.$style.hidden]: !E.value || e.readonly || e.disabled,
                      [he.$style.collapsed]: T(c).length > 0 && !T(d) && !be.value
                    }
                  ])
                }, [
                  !e.readonly && !e.disabled ? Tn((v(), y("input", {
                    key: 0,
                    id: e.htmlFor,
                    ref: "searchInputRef",
                    "onUpdate:modelValue": Pe[0] || (Pe[0] = (Y) => Yo(d) ? d.value = Y : null),
                    placeholder: T(c).length === 0 ? e.placeholder : "",
                    class: x([he.$style.searchInput, T(c).length > 0 && he.$style.hasTags]),
                    autocomplete: "new-password",
                    onBlur: k
                  }, null, 42, Aye)), [
                    [Qd, T(d)]
                  ]) : V("", !0),
                  R("span", {
                    class: x(he.$style.inputSizer),
                    "aria-hidden": "true"
                  }, se(T(d)), 3)
                ], 2)
              ], 2)
            ], 2),
            R("div", {
              class: x(he.$style.dropdownAnchor)
            }, [
              e.loading ? (v(), z(rl, {
                key: 0,
                class: x(he.$style.loader),
                size: "small",
                indeterminate: ""
              }, null, 8, ["class"])) : V("", !0),
              te(Yt, {
                ref: T(S),
                "is-open": i.value,
                "onUpdate:isOpen": Pe[4] || (Pe[4] = (Y) => i.value = Y),
                "padding-upset": !0,
                "offset-y": 2,
                "match-trigger-width": "min"
              }, {
                trigger: Q(() => [...Pe[8] || (Pe[8] = [
                  R("div", null, null, -1)
                ])]),
                default: Q(() => [
                  R("div", {
                    class: x(he.$style.searchResultsFrame)
                  }, [
                    R("div", {
                      ref_key: "searchResultsInfiniteRef",
                      ref: u,
                      class: x(he.$style.searchResults),
                      onScroll: Pe[3] || (Pe[3] = //@ts-ignore
                      (...Y) => T(b) && T(b)(...Y))
                    }, [
                      (v(!0), y(Se, null, We(T(C), (Y, q) => {
                        var ge, ie, ee, ae, _e, Ne;
                        return v(), y("div", {
                          key: T(p)(Y, q),
                          class: x([e.resultsAsTags && he.$style.tagRow, T(Ie)(q) && he.$style.resultHighlighted]),
                          style: Ke(Y.level ? { paddingLeft: `${Y.level * 16}px` } : void 0)
                        }, [
                          e.resultsAsTags ? (v(), z(no, {
                            key: 0,
                            avatar: Y.avatar,
                            icon: Y.iconFramed ? void 0 : Y.icon,
                            "icon-color": Y.iconColor,
                            selected: T(f)(Y),
                            onMousedown: Pe[1] || (Pe[1] = Ge(() => {
                            }, ["prevent"])),
                            onClick: Ge((At) => P(Y), ["prevent", "stop"])
                          }, Wn({
                            default: Q(() => [
                              T(d) ? (v(), z(gi, {
                                key: 0,
                                text: Y.label,
                                "search-term": T(d)
                              }, null, 8, ["text", "search-term"])) : (v(), y(Se, { key: 1 }, [
                                Oe(se(Y.label), 1)
                              ], 64))
                            ]),
                            _: 2
                          }, [
                            Y.iconFramed && Y.icon ? {
                              name: "iconLeft",
                              fn: Q(() => [
                                R("div", {
                                  class: x(he.$style.iconFrame)
                                }, [
                                  te(Fe, {
                                    icon: Y.icon,
                                    size: "12px",
                                    color: Y.iconColor
                                  }, null, 8, ["icon", "color"])
                                ], 2)
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1032, ["avatar", "icon", "icon-color", "selected", "onClick"])) : (v(), y("div", {
                            key: 1,
                            id: T(p)(Y, q),
                            class: x(he.$style.itemContainer),
                            onMousedown: Pe[2] || (Pe[2] = Ge(() => {
                            }, ["prevent"])),
                            onClick: Ge((At) => P(Y), ["prevent", "stop"])
                          }, [
                            Y.avatar ? (v(), z(Li, {
                              key: 0,
                              size: "xsmall",
                              initials: (ge = Y.avatar) == null ? void 0 : ge.initials,
                              shape: (ie = Y.avatar) == null ? void 0 : ie.shape,
                              appearance: (ee = Y.avatar) == null ? void 0 : ee.appearance,
                              emphasis: (ae = Y.avatar) == null ? void 0 : ae.emphasis,
                              bordered: !!((_e = Y.avatar) != null && _e.image),
                              "color-idx": (Ne = Y.avatar) == null ? void 0 : Ne.colorIdx,
                              "use-hover-colors": !0
                            }, {
                              default: Q(() => {
                                var At, pt;
                                return [
                                  (At = Y.avatar) != null && At.image ? (v(), y("img", {
                                    key: 0,
                                    src: (pt = Y.avatar) == null ? void 0 : pt.image,
                                    loading: "lazy",
                                    alt: "avatar"
                                  }, null, 8, Mye)) : V("", !0)
                                ];
                              }),
                              _: 2
                            }, 1032, ["initials", "shape", "appearance", "emphasis", "bordered", "color-idx"])) : V("", !0),
                            R("div", {
                              class: x(he.$style.itemContent)
                            }, [
                              te(gi, {
                                text: Y.label,
                                "search-term": T(d)
                              }, null, 8, ["text", "search-term"]),
                              Y.secondaryLabel ? (v(), y(Se, { key: 0 }, [
                                Pe[9] || (Pe[9] = Oe(se(" ") + " ", -1)),
                                te(gi, {
                                  text: Y.secondaryLabel,
                                  "search-term": T(d),
                                  class: x(he.$style.itemSecondaryLabel)
                                }, null, 8, ["text", "search-term", "class"])
                              ], 64)) : V("", !0)
                            ], 2),
                            Y.label.length > 30 ? (v(), z(zt, {
                              key: 1,
                              id: T(p)(Y, q),
                              text: Y.label
                            }, null, 8, ["id", "text"])) : V("", !0)
                          ], 42, Fye))
                        ], 6);
                      }), 128)),
                      e.searchResults.length === 0 && T(d).length >= n.minSearchLength ? (v(), z(ll, {
                        key: 0,
                        loading: n.loading
                      }, null, 8, ["loading"])) : V("", !0)
                    ], 34)
                  ], 2)
                ]),
                _: 1
              }, 8, ["is-open"])
            ], 2)
          ], 42, Eye),
          e.showArrow && a.value && !e.disabled ? (v(), z(Fe, {
            key: 0,
            icon: i.value ? "phosphor/caret-up" : "phosphor/caret-down",
            class: x(he.$style.arrowIcon),
            size: "12px"
          }, null, 8, ["icon", "class"])) : V("", !0)
        ]),
        _: 3
      }, 8, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "html-for", "validation-error", "required", "prefix", "highlight-label", "tooltip", "help-link", "focused"]);
    };
  }
}), Pye = "_content_1jw4l_1", Dye = "_hovered_1jw4l_12", Tye = "_disabled_1jw4l_28", kye = "_tags_1jw4l_33", Lye = "_dropdownAnchor_1jw4l_40", Bye = "_searchResultsFrame_1jw4l_50", Oye = "_searchResults_1jw4l_50", Gye = "_tagsContainer_1jw4l_72", Hye = "_tagRow_1jw4l_81", Vye = "_itemContainer_1jw4l_91", _ye = "_resultHighlighted_1jw4l_105", Nye = "_searchInputWrapper_1jw4l_118", $ye = "_collapsed_1jw4l_134", zye = "_searchInput_1jw4l_118", Wye = "_hasTags_1jw4l_155", Uye = "_inputSizer_1jw4l_174", Kye = "_itemContent_1jw4l_189", Zye = "_itemSecondaryLabel_1jw4l_194", qye = "_iconFrame_1jw4l_199", jye = "_emailIconWrapper_1jw4l_211", Yye = "_contentHasFocus_1jw4l_229", Qye = "_hidden_1jw4l_233", Jye = "_arrowIcon_1jw4l_237", Xye = {
  content: Pye,
  hovered: Dye,
  disabled: Tye,
  tags: kye,
  dropdownAnchor: Lye,
  searchResultsFrame: Bye,
  searchResults: Oye,
  tagsContainer: Gye,
  tagRow: Hye,
  itemContainer: Vye,
  resultHighlighted: _ye,
  searchInputWrapper: Nye,
  collapsed: $ye,
  searchInput: zye,
  hasTags: Wye,
  inputSizer: Uye,
  itemContent: Kye,
  itemSecondaryLabel: Zye,
  iconFrame: qye,
  emailIconWrapper: jye,
  contentHasFocus: Yye,
  hidden: Qye,
  arrowIcon: Jye
}, ebe = {
  $style: Xye
}, YMe = /* @__PURE__ */ we(Iye, [["__cssModules", ebe]]), tbe = Symbol("SCAOverflowMenu"), nbe = /* @__PURE__ */ new Set([
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "base",
  "meta"
]), obe = /* @__PURE__ */ new Set(["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"]), sbe = (e, { image: t = !1 } = {}) => {
  var r;
  const n = e.replace(/[\t\n\r]/g, "");
  let o = 0;
  for (; n.charCodeAt(o) <= 32; ) o++;
  const s = n.slice(o), i = (r = /^([a-z][a-z0-9+.-]*):/i.exec(s)) == null ? void 0 : r[1].toLowerCase();
  return i === void 0 || obe.has(i) ? !1 : !(t && i === "data" && /^data:image\//i.test(s));
}, ibe = /* @__PURE__ */ new Set(["href", "src", "action", "formaction", "xlink:href", "background", "data"]), rbe = /* @__PURE__ */ new Set(["src", "background"]), abe = (e, t) => !e.startsWith("on") && e !== "srcdoc" && !(ibe.has(e) && sbe(t, { image: rbe.has(e) })), QMe = (e, t = abe) => {
  const n = document.createElement("template");
  n.innerHTML = e;
  let o = !1;
  return n.content.querySelectorAll([...nbe].join(", ")).forEach((s) => {
    s.remove(), o = !0;
  }), n.content.querySelectorAll("*").forEach(
    (s) => Array.from(s.attributes).filter((i) => !t(i.name.toLowerCase(), i.value)).forEach((i) => {
      s.removeAttribute(i.name), o = !0;
    })
  ), o ? n.innerHTML : e;
}, lbe = Symbol("richTextEngine"), dbe = /* @__PURE__ */ de({
  __name: "SCAInlineMessage",
  props: {
    type: { default: "informative" },
    title: {}
  },
  setup(e) {
    const t = e, n = rn(), o = D(() => {
      switch (t.type) {
        case "informative":
          return "phosphor/info-fill";
        case "success":
          return "phosphor/check-circle-fill";
        case "warning":
          return "phosphor/warning-fill";
        case "error":
          return "phosphor/warning-diamond-fill";
        default:
          return "phosphor/info";
      }
    });
    return (s, i) => (v(), y("div", {
      class: x([
        s.$style.root,
        {
          [s.$style.typeInformative]: e.type === "informative",
          [s.$style.typeSuccess]: e.type === "success",
          [s.$style.typeWarning]: e.type === "warning",
          [s.$style.typeError]: e.type === "error"
        }
      ])
    }, [
      te(Fe, {
        class: x(s.$style.icon),
        icon: o.value
      }, null, 8, ["class", "icon"]),
      R("div", null, [
        e.title ? (v(), y("span", {
          key: 0,
          class: x([s.$style.title, { [s.$style.defaultSlot]: T(n).default }])
        }, se(e.title), 3)) : V("", !0),
        ve(s.$slots, "default")
      ])
    ], 2));
  }
}), cbe = "_root_5kgk6_747", ube = "_icon_5kgk6_760", hbe = "_title_5kgk6_766", gbe = "_defaultSlot_5kgk6_766", pbe = "_typeInformative_5kgk6_769", fbe = "_typeSuccess_5kgk6_777", mbe = "_typeWarning_5kgk6_784", vbe = "_typeError_5kgk6_791", Cbe = {
  root: cbe,
  icon: ube,
  title: hbe,
  defaultSlot: gbe,
  typeInformative: pbe,
  typeSuccess: fbe,
  typeWarning: mbe,
  typeError: vbe
}, wbe = {
  $style: Cbe
}, ybe = /* @__PURE__ */ we(dbe, [["__cssModules", wbe]]), bbe = ["value", "readonly"], Sbe = /* @__PURE__ */ de({
  __name: "SCARichTextPlain",
  props: /* @__PURE__ */ dt({
    readOnly: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    minHeight: {},
    maxHeight: { default: void 0 }
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, { t: n } = fn(), o = lt(e, "modelValue"), s = D(() => ({
      minHeight: `${t.minHeight}px`,
      ...t.maxHeight === void 0 ? {} : { maxHeight: `${t.maxHeight}px` }
    })), i = (r) => {
      o.value = r.target.value;
    };
    return (r, a) => (v(), y("div", {
      class: x(r.$style.container),
      style: Ke(s.value)
    }, [
      te(ybe, {
        class: x(r.$style.notice),
        type: "warning",
        title: T(n)("richText.plainFallbackNotice")
      }, null, 8, ["class", "title"]),
      R("textarea", {
        class: x([r.$style.plain, e.resizable ? r.$style.resizable : ""]),
        value: o.value ?? "",
        readonly: t.readOnly,
        spellcheck: "false",
        "test-id": "rich-text-plain-fallback",
        onInput: i
      }, null, 42, bbe)
    ], 6));
  }
}), xbe = "_container_8m4hg_1", Rbe = "_notice_8m4hg_7", Ebe = "_plain_8m4hg_11", Abe = "_resizable_8m4hg_30", Fbe = {
  container: xbe,
  notice: Rbe,
  plain: Ebe,
  resizable: Abe
}, Mbe = {
  $style: Fbe
}, Ibe = /* @__PURE__ */ we(Sbe, [["__cssModules", Mbe]]);
var Pbe = [
  "onActivate",
  "onAddUndo",
  "onBeforeAddUndo",
  "onBeforeExecCommand",
  "onBeforeGetContent",
  "onBeforeRenderUI",
  "onBeforeSetContent",
  "onBeforePaste",
  "onBlur",
  "onChange",
  "onClearUndos",
  "onClick",
  "onContextMenu",
  "onCommentChange",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onCopy",
  "onCut",
  "onDblclick",
  "onDeactivate",
  "onDirty",
  "onDrag",
  "onDragDrop",
  "onDragEnd",
  "onDragGesture",
  "onDragOver",
  "onDrop",
  "onExecCommand",
  "onFocus",
  "onFocusIn",
  "onFocusOut",
  "onGetContent",
  "onHide",
  "onInit",
  "onInput",
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  "onLoadContent",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onNodeChange",
  "onObjectResizeStart",
  "onObjectResized",
  "onObjectSelected",
  "onPaste",
  "onPostProcess",
  "onPostRender",
  "onPreProcess",
  "onProgressState",
  "onRedo",
  "onRemove",
  "onReset",
  "onSaveContent",
  "onSelectionChange",
  "onSetAttrib",
  "onSetContent",
  "onShow",
  "onSubmit",
  "onUndo",
  "onVisualAid"
], Dbe = function(e) {
  return Pbe.map(function(t) {
    return t.toLowerCase();
  }).indexOf(e.toLowerCase()) !== -1;
}, Tbe = function(e, t, n) {
  Object.keys(t).filter(Dbe).forEach(function(o) {
    var s = t[o];
    typeof s == "function" && (o === "onInit" ? s(e, n) : n.on(o.substring(2), function(i) {
      return s(i, n);
    }));
  });
}, kbe = function(e, t, n, o) {
  var s = e.modelEvents ? e.modelEvents : null, i = Array.isArray(s) ? s.join(" ") : s;
  Re(o, function(r, a) {
    n && typeof r == "string" && r !== a && r !== n.getContent({ format: e.outputFormat }) && n.setContent(r);
  }), n.on(i || "change input undo redo", function() {
    t.emit("update:modelValue", n.getContent({ format: e.outputFormat }));
  });
}, Lbe = function(e, t, n, o, s, i) {
  o.setContent(i()), n.attrs["onUpdate:modelValue"] && kbe(t, n, o, s), Tbe(e, n.attrs, o);
}, Bv = 0, P2 = function(e) {
  var t = Date.now(), n = Math.floor(Math.random() * 1e9);
  return Bv++, e + "_" + n + Bv + String(t);
}, Bbe = function(e) {
  return e !== null && e.tagName.toLowerCase() === "textarea";
}, Ov = function(e) {
  return typeof e > "u" || e === "" ? [] : Array.isArray(e) ? e : e.split(" ");
}, Obe = function(e, t) {
  return Ov(e).concat(Ov(t));
}, Gbe = function(e) {
  return e == null;
}, Gv = function() {
  return {
    listeners: [],
    scriptId: P2("tiny-script"),
    scriptLoaded: !1
  };
}, Hbe = function() {
  var e = Gv(), t = function(s, i, r, a) {
    var l = i.createElement("script");
    l.referrerPolicy = "origin", l.type = "application/javascript", l.id = s, l.src = r;
    var d = function() {
      l.removeEventListener("load", d), a();
    };
    l.addEventListener("load", d), i.head && i.head.appendChild(l);
  }, n = function(s, i, r) {
    e.scriptLoaded ? r() : (e.listeners.push(r), s.getElementById(e.scriptId) || t(e.scriptId, s, i, function() {
      e.listeners.forEach(function(a) {
        return a();
      }), e.scriptLoaded = !0;
    }));
  }, o = function() {
    e = Gv();
  };
  return {
    load: n,
    reinitialize: o
  };
}, Vbe = Hbe(), _be = function() {
  return typeof window < "u" ? window : global;
}, Ks = function() {
  var e = _be();
  return e && e.tinymce ? e.tinymce : null;
}, Nbe = {
  apiKey: String,
  licenseKey: String,
  cloudChannel: String,
  id: String,
  init: Object,
  initialValue: String,
  inline: Boolean,
  modelEvents: [String, Array],
  plugins: [String, Array],
  tagName: String,
  toolbar: [String, Array],
  modelValue: String,
  disabled: Boolean,
  tinymceScriptSrc: String,
  outputFormat: {
    type: String,
    validator: function(e) {
      return e === "html" || e === "text";
    }
  }
}, po = function() {
  return po = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, po.apply(this, arguments);
}, $be = function(e, t, n, o) {
  return e(o || "div", {
    id: t,
    ref: n
  });
}, zbe = function(e, t, n) {
  return e("textarea", {
    id: t,
    visibility: "hidden",
    ref: n
  });
}, nh = { selector: void 0, target: void 0 }, Wbe = de({
  props: Nbe,
  setup: function(e, t) {
    var n = e.init ? po(po({}, e.init), nh) : po({}, nh), o = Kv(e), s = o.disabled, i = o.modelValue, r = o.tagName, a = W(null), l = null, d = e.id || P2("tiny-vue"), c = e.init && e.init.inline || e.inline, u = !!t.attrs["onUpdate:modelValue"], h = !0, g = e.initialValue ? e.initialValue : "", p = "", f = function(w) {
      return u ? function() {
        return i != null && i.value ? i.value : "";
      } : function() {
        return w ? g : p;
      };
    }, m = function() {
      var w = f(h), b = po(po({}, n), { readonly: e.disabled, target: a.value, plugins: Obe(n.plugins, e.plugins), toolbar: e.toolbar || n.toolbar, inline: c, license_key: e.licenseKey, setup: function(A) {
        l = A, A.on("init", function(S) {
          return Lbe(S, e, t, A, i, w);
        }), typeof n.setup == "function" && n.setup(A);
      } });
      Bbe(a.value) && (a.value.style.visibility = ""), Ks().init(b), h = !1;
    };
    Re(s, function(w) {
      var b;
      l !== null && (typeof ((b = l.mode) === null || b === void 0 ? void 0 : b.set) == "function" ? l.mode.set(w ? "readonly" : "design") : l.setMode(w ? "readonly" : "design"));
    }), Re(r, function(w) {
      var b;
      u || (p = l.getContent()), (b = Ks()) === null || b === void 0 || b.remove(l), Xe(function() {
        return m();
      });
    }), Et(function() {
      if (Ks() !== null)
        m();
      else if (a.value && a.value.ownerDocument) {
        var w = e.cloudChannel ? e.cloudChannel : "7", b = e.apiKey ? e.apiKey : "no-api-key", A = Gbe(e.tinymceScriptSrc) ? "https://cdn.tiny.cloud/1/".concat(b, "/tinymce/").concat(w, "/tinymce.min.js") : e.tinymceScriptSrc;
        Vbe.load(a.value.ownerDocument, A, m);
      }
    }), io(function() {
      Ks() !== null && Ks().remove(l);
    }), c || (J2(function() {
      h || m();
    }), X2(function() {
      var w;
      u || (p = l.getContent()), (w = Ks()) === null || w === void 0 || w.remove(l);
    }));
    var C = function(w) {
      var b;
      p = l.getContent(), (b = Ks()) === null || b === void 0 || b.remove(l), n = po(po(po({}, n), w), nh), Xe(function() {
        return m();
      });
    };
    return t.expose({
      rerender: C,
      getEditor: function() {
        return l;
      }
    }), function() {
      return c ? $be(vo, d, a, e.tagName) : zbe(vo, d, a);
    };
  }
});
const Ube = ":root{--color-coolGrey-m4: #1b242c;--color-coolGrey-m3: #272e35;--color-coolGrey-m2: #3a424a;--color-coolGrey-m1: #4a545e;--color-coolGrey-0: #555f6d;--color-coolGrey-p1: #7e8c9a;--color-coolGrey-p2: #9ea8b3;--color-coolGrey-p3: #cfd6dd;--color-coolGrey-p4: #dee3e7;--color-coolGrey-p5: #eaedf0;--color-coolGrey-p6: #f0f3f5;--color-coolGrey-p7: #f5f7f9;--color-coolGrey-p8: #fcfcfd;--color-coolGreyA-m4: #0a141ced;--color-coolGreyA-m3: #0a1219e0;--color-coolGreyA-m2: #1a232ddb;--color-coolGreyA-m1: #1d2936cc;--color-coolGreyA-0: #19273abd;--color-coolGreyA-p1: #1830488f;--color-coolGreyA-p2: #0d264066;--color-coolGreyA-p3: #10305433;--color-coolGreyA-p4: #04294421;--color-coolGreyA-p5: #10284817;--color-coolGreyA-p6: #022f520f;--color-coolGreyA-p7: #002b5e0a;--color-coolGreyA-p8: #1f529e05;--color-neutralGrey-m4: #222222;--color-neutralGrey-m3: #2d2d2d;--color-neutralGrey-m2: #404040;--color-neutralGrey-m1: #525252;--color-neutralGrey-0: #5e5e5e;--color-neutralGrey-p1: #898989;--color-neutralGrey-p2: #a6a6a6;--color-neutralGrey-p3: #d5d5d5;--color-neutralGrey-p4: #e2e2e2;--color-neutralGrey-p5: #ebebeb;--color-neutralGrey-p6: #f2f2f2;--color-neutralGrey-p7: #f7f7f7;--color-neutralGrey-p8: #fcfcfc;--color-neutralGreyA-m4: #111111ed;--color-neutralGreyA-m3: #101010e0;--color-neutralGreyA-m2: #212121db;--color-neutralGreyA-m1: #262626cc;--color-neutralGreyA-0: #252526bd;--color-neutralGreyA-p1: #2c2c2c8f;--color-neutralGreyA-p2: #20202066;--color-neutralGreyA-p3: #2e2e2e33;--color-neutralGreyA-p4: #1f1f1f21;--color-neutralGreyA-p5: #1c1c1c17;--color-neutralGreyA-p6: #2020200f;--color-neutralGreyA-p7: #2e2e2e0a;--color-neutralGreyA-p8: #52525205;--color-warmGrey-m4: #232321;--color-warmGrey-m3: #2f2f2b;--color-warmGrey-m2: #40403a;--color-warmGrey-m1: #52524c;--color-warmGrey-0: #5f5f58;--color-warmGrey-p1: #8b8b84;--color-warmGrey-p2: #a8a89f;--color-warmGrey-p3: #d8d8d2;--color-warmGrey-p4: #e4e4e0;--color-warmGrey-p5: #eaeae6;--color-warmGrey-p6: #f3f3f1;--color-warmGrey-p7: #f7f7f7;--color-warmGrey-p8: #fcfcfc;--color-warmGreyA-m4: #121210ed;--color-warmGreyA-m3: #13130ee0;--color-warmGreyA-m2: #21211adb;--color-warmGreyA-m1: #272720cc;--color-warmGreyA-0: #27271dbd;--color-warmGreyA-p1: #2f2f238f;--color-warmGreyA-p2: #26261066;--color-warmGreyA-p3: #3e3e1d33;--color-warmGreyA-p4: #32321421;--color-warmGreyA-p5: #22220217;--color-warmGreyA-p6: #2f2f0e0f;--color-warmGreyA-p7: #2f2f2c0a;--color-warmGreyA-p8: #52525205;--color-whiteA-m12: #ffffff05;--color-whiteA-m11: #ffffff08;--color-whiteA-m10: #ffffff0d;--color-whiteA-m9: #ffffff14;--color-whiteA-m8: #ffffff1a;--color-whiteA-m7: #ffffff1f;--color-whiteA-m6: #ffffff3d;--color-whiteA-m5: #ffffff66;--color-whiteA-m4: #ffffffa3;--color-whiteA-m3: #ffffffad;--color-whiteA-m2: #ffffffb8;--color-whiteA-m1: #ffffffd1;--color-whiteA-0: #ffffff;--color-transparent: #ffffff00;--color-red-m4: #4a0d0d;--color-red-m3: #6f2020;--color-red-m2: #952d2d;--color-red-m1: #a13636;--color-red-0: #c53434;--color-red-p1: #f26464;--color-red-p2: #f49090;--color-red-p3: #fccfcf;--color-red-p4: #fcd9d9;--color-red-p5: #fee6e6;--color-red-p6: #ffebeb;--color-red-p7: #fef5f5;--color-red-p8: #fffafa;--color-raspberry-m4: #450c1f;--color-raspberry-m3: #671e36;--color-raspberry-m2: #912b4d;--color-raspberry-m1: #9d3457;--color-raspberry-0: #c03060;--color-raspberry-p1: #e4628d;--color-raspberry-p2: #ec8dad;--color-raspberry-p3: #f8cedc;--color-raspberry-p4: #fbd5e2;--color-raspberry-p5: #fde3eb;--color-raspberry-p6: #fdedf2;--color-raspberry-p7: #fef5f8;--color-raspberry-p8: #fffafc;--color-magenta-m4: #410b2f;--color-magenta-m3: #671e4e;--color-magenta-m2: #892969;--color-magenta-m1: #953274;--color-magenta-0: #b12f86;--color-magenta-p1: #de5eb3;--color-magenta-p2: #ec89cb;--color-magenta-p3: #f7cae8;--color-magenta-p4: #fbd5ee;--color-magenta-p5: #fde3f4;--color-magenta-p6: #fdedf8;--color-magenta-p7: #fef5fb;--color-magenta-p8: #fffafd;--color-purple-m4: #410b2f;--color-purple-m3: #5b1e67;--color-purple-m2: #792989;--color-purple-m1: #853295;--color-purple-0: #9939ac;--color-purple-p1: #c466db;--color-purple-p2: #d98dec;--color-purple-p3: #f4caf7;--color-purple-p4: #f5d5fb;--color-purple-p5: #f8e3fd;--color-purple-p6: #faedfd;--color-purple-p7: #fdf5ff;--color-purple-p8: #fefaff;--color-grape-m4: #2e0e4e;--color-grape-m3: #4c2277;--color-grape-m2: #662f9d;--color-grape-m1: #7339ac;--color-grape-0: #8040bf;--color-grape-p1: #ad71ea;--color-grape-p2: #c494f4;--color-grape-p3: #e5d0fb;--color-grape-p4: #eddbff;--color-grape-p5: #f2e5ff;--color-grape-p6: #f6f0ff;--color-grape-p7: #faf5ff;--color-grape-p8: #fcfaff;--color-violet-m4: #1f1264;--color-violet-m3: #39288a;--color-violet-m2: #4e38bc;--color-violet-m1: #573fcf;--color-violet-0: #634eca;--color-violet-p1: #917ef1;--color-violet-p2: #aba2fb;--color-violet-p3: #dcd6ff;--color-violet-p4: #e3e0ff;--color-violet-p5: #eeebff;--color-violet-p6: #f3f0ff;--color-violet-p7: #f7f5ff;--color-violet-p8: #fbfaff;--color-blue-m4: #05205e;--color-blue-m3: #113997;--color-blue-m2: #1e50c0;--color-blue-m1: #2759cd;--color-blue-0: #3062d4;--color-blue-p1: #6792f4;--color-blue-p2: #8db0fb;--color-blue-p3: #cdddff;--color-blue-p4: #d7e4ff;--color-blue-p5: #e5eeff;--color-blue-p6: #edf2ff;--color-blue-p7: #f5f8ff;--color-blue-p8: #fafbff;--color-cyan-m4: #002742;--color-cyan-m3: #0c456e;--color-cyan-m2: #165b8d;--color-cyan-m1: #1b679d;--color-cyan-0: #0870ba;--color-cyan-p1: #5699dc;--color-cyan-p2: #79bcf6;--color-cyan-p3: #c2e3ff;--color-cyan-p4: #cce7ff;--color-cyan-p5: #e0f1ff;--color-cyan-p6: #ebf5ff;--color-cyan-p7: #f0f9ff;--color-cyan-p8: #fafdff;--color-teal-m4: #012a37;--color-teal-m3: #0a495c;--color-teal-m2: #196076;--color-teal-m1: #196c85;--color-teal-0: #077597;--color-teal-p1: #4f9eba;--color-teal-p2: #7ac0dc;--color-teal-p3: #b8e8f5;--color-teal-p4: #c5ecf7;--color-teal-p5: #e0f3fa;--color-teal-p6: #e8f7fc;--color-teal-p7: #f0fbff;--color-teal-p8: #fafeff;--color-aquamarine-m4: #012d26;--color-aquamarine-m3: #0d4a42;--color-aquamarine-m2: #15655a;--color-aquamarine-m1: #1a7061;--color-aquamarine-0: #097c69;--color-aquamarine-p1: #3da497;--color-aquamarine-p2: #6ec9bf;--color-aquamarine-p3: #bee9e4;--color-aquamarine-p4: #c5f2ec;--color-aquamarine-p5: #daf6f3;--color-aquamarine-p6: #e2f8f5;--color-aquamarine-p7: #f0faf9;--color-aquamarine-p8: #fbfefe;--color-green-m4: #062d1b;--color-green-m3: #0e4e30;--color-green-m2: #196742;--color-green-m1: #1e714a;--color-green-0: #1d7c4d;--color-green-p1: #4aa578;--color-green-p2: #75cc9e;--color-green-p3: #c2ebd5;--color-green-p4: #c6f1da;--color-green-p5: #d8f8e7;--color-green-p6: #e6f9ef;--color-green-p7: #f4fbf7;--color-green-p8: #fbfefc;--color-emerald-m4: #0a2e0b;--color-emerald-m3: #135315;--color-emerald-m2: #246626;--color-emerald-m1: #2f6f2f;--color-emerald-0: #347434;--color-emerald-p1: #55a555;--color-emerald-p2: #87c987;--color-emerald-p3: #c6ecc6;--color-emerald-p4: #cff2cf;--color-emerald-p5: #dff6df;--color-emerald-p6: #e6f9e6;--color-emerald-p7: #f4fbf4;--color-emerald-p8: #fbfefb;--color-orange-m4: #482909;--color-orange-m3: #7a4510;--color-orange-m2: #a05c1c;--color-orange-m1: #b4610e;--color-orange-0: #f59638;--color-orange-p1: #f6a351;--color-orange-p2: #feb872;--color-orange-p3: #ffd4a8;--color-orange-p4: #fcdec0;--color-orange-p5: #ffe8d1;--color-orange-p6: #fff0e0;--color-orange-p7: #fff5eb;--color-orange-p8: #fffcfa;--color-semantic-brand-m4: var(--color-blue-m4);--color-semantic-brand-m3: var(--color-blue-m3);--color-semantic-brand-m2: var(--color-blue-m2);--color-semantic-brand-m1: var(--color-blue-m1);--color-semantic-brand-0: var(--color-blue-0);--color-semantic-brand-p1: var(--color-blue-p1);--color-semantic-brand-p2: var(--color-blue-p2);--color-semantic-brand-p3: var(--color-blue-p3);--color-semantic-brand-p4: var(--color-blue-p4);--color-semantic-brand-p5: var(--color-blue-p5);--color-semantic-brand-p6: var(--color-blue-p6);--color-semantic-brand-p7: var(--color-blue-p7);--color-semantic-brand-p8: var(--color-blue-p8);--color-semantic-neutral-m4: var(--color-coolGrey-m4);--color-semantic-neutral-m3: var(--color-coolGrey-m3);--color-semantic-neutral-m2: var(--color-coolGrey-m2);--color-semantic-neutral-m1: var(--color-coolGrey-m1);--color-semantic-neutral-0: var(--color-coolGrey-0);--color-semantic-neutral-p1: var(--color-coolGrey-p1);--color-semantic-neutral-p2: var(--color-coolGrey-p2);--color-semantic-neutral-p3: var(--color-coolGrey-p3);--color-semantic-neutral-p4: var(--color-coolGrey-p4);--color-semantic-neutral-p5: var(--color-coolGrey-p5);--color-semantic-neutral-p6: var(--color-coolGrey-p6);--color-semantic-neutral-p7: var(--color-coolGrey-p7);--color-semantic-neutral-p8: var(--color-coolGrey-p8);--color-semantic-neutralA-m4: var(--color-coolGreyA-m4);--color-semantic-neutralA-m3: var(--color-coolGreyA-m3);--color-semantic-neutralA-m2: var(--color-coolGreyA-m2);--color-semantic-neutralA-m1: var(--color-coolGreyA-m1);--color-semantic-neutralA-0: var(--color-coolGreyA-0);--color-semantic-neutralA-p1: var(--color-coolGreyA-p1);--color-semantic-neutralA-p2: var(--color-coolGreyA-p2);--color-semantic-neutralA-p3: var(--color-coolGreyA-p3);--color-semantic-neutralA-p4: var(--color-coolGreyA-p4);--color-semantic-neutralA-p5: var(--color-coolGreyA-p5);--color-semantic-neutralA-p6: var(--color-coolGreyA-p6);--color-semantic-neutralA-p7: var(--color-coolGreyA-p7);--color-semantic-neutralA-p8: var(--color-coolGreyA-p8);--color-semantic-informative-m4: var(--color-blue-m4);--border-radius-25: 2px;--border-radius-50: 4px;--border-radius-100: 8px;--border-radius-999: 9999px;--color-semantic-informative-m3: var(--color-blue-m3);--color-semantic-informative-m2: var(--color-blue-m2);--color-semantic-informative-m1: var(--color-blue-m1);--color-semantic-informative-0: var(--color-blue-0);--color-semantic-informative-p1: var(--color-blue-p1);--color-semantic-informative-p2: var(--color-blue-p2);--color-semantic-informative-p3: var(--color-blue-p3);--color-semantic-informative-p4: var(--color-blue-p4);--color-semantic-informative-p5: var(--color-blue-p5);--color-semantic-informative-p6: var(--color-blue-p6);--color-semantic-informative-p7: var(--color-blue-p7);--color-semantic-informative-p8: var(--color-blue-p8);--color-semantic-positive-m4: var(--color-green-m4);--color-semantic-positive-m3: var(--color-green-m3);--color-semantic-positive-m2: var(--color-green-m2);--color-semantic-positive-m1: var(--color-green-m1);--color-semantic-positive-0: var(--color-green-0);--color-semantic-positive-p1: var(--color-green-p1);--color-semantic-positive-p2: var(--color-green-p2);--color-semantic-positive-p3: var(--color-green-p3);--color-semantic-positive-p4: var(--color-green-p4);--color-semantic-positive-p5: var(--color-green-p5);--color-semantic-positive-p6: var(--color-green-p6);--color-semantic-positive-p7: var(--color-green-p7);--color-semantic-positive-p8: var(--color-green-p8);--color-semantic-warning-m4: var(--color-orange-m4);--color-semantic-warning-m3: var(--color-orange-m3);--color-semantic-warning-m2: var(--color-orange-m2);--color-semantic-warning-m1: var(--color-orange-m1);--color-semantic-warning-0: var(--color-orange-0);--color-semantic-warning-p1: var(--color-orange-p1);--color-semantic-warning-p2: var(--color-orange-p2);--color-semantic-warning-p3: var(--color-orange-p3);--color-semantic-warning-p4: var(--color-orange-p4);--color-semantic-warning-p5: var(--color-orange-p5);--color-semantic-warning-p6: var(--color-orange-p6);--color-semantic-warning-p7: var(--color-orange-p7);--color-semantic-warning-p8: var(--color-orange-p8);--color-semantic-negative-m4: var(--color-red-m4);--color-semantic-negative-m3: var(--color-red-m3);--color-semantic-negative-m2: var(--color-red-m2);--color-semantic-negative-m1: var(--color-red-m1);--color-semantic-negative-0: var(--color-red-0);--color-semantic-negative-p1: var(--color-red-p1);--color-semantic-negative-p2: var(--color-red-p2);--color-semantic-negative-p3: var(--color-red-p3);--color-semantic-negative-p4: var(--color-red-p4);--color-semantic-negative-p5: var(--color-red-p5);--color-semantic-negative-p6: var(--color-red-p6);--color-semantic-negative-p7: var(--color-red-p7);--color-semantic-negative-p8: var(--color-red-p8);--color-content-primary: var(--color-semantic-neutral-m3);--color-content-secondary: var(--color-semantic-neutral-0);--color-content-tertiary: var(--color-semantic-neutral-p1);--color-content-disabled: var(--color-semantic-neutral-p2);--color-content-primary-inverted: var(--color-whiteA-0);--color-content-secondary-inverted: var(--color-whiteA-m4);--color-content-tertiary-inverted: var(--color-whiteA-m5);--color-content-disabled-inverted: var(--color-whiteA-m6);--color-content-informative-primary: var(--color-semantic-informative-m3);--color-content-informative-secondary: var(--color-semantic-informative-0);--color-content-positive-primary: var(--color-semantic-positive-m3);--color-content-positive-secondary: var(--color-semantic-positive-0);--color-content-warning-primary: var(--color-semantic-warning-m3);--color-content-warning-secondary: var(--color-semantic-warning-0);--color-content-negative-primary: var(--color-semantic-negative-m3);--color-content-negative-secondary: var(--color-semantic-negative-0);--color-content-brand-primary: var(--color-semantic-brand-m3);--color-content-brand-secondary: var(--color-semantic-brand-0);--color-border-default: var(--color-semantic-neutral-p5);--color-border-defaultA: var(--color-semantic-neutralA-p5);--color-border-inverted: var(--color-whiteA-0);--color-border-neutral-strong: var(--color-semantic-neutral-0);--color-border-neutral-subtle: var(--color-semantic-neutral-p3);--color-border-informative-strong: var(--color-semantic-informative-0);--color-border-informative-subtle: var(--color-semantic-informative-p3);--color-border-positive-strong: var(--color-semantic-positive-0);--color-border-positive-subtle: var(--color-semantic-positive-p3);--color-border-warning-strong: var(--color-semantic-warning-0);--color-border-warning-subtle: var(--color-semantic-warning-p3);--color-border-negative-strong: var(--color-semantic-negative-0);--color-border-negative-subtle: var(--color-semantic-negative-p3);--color-border-brand-strong: var(--color-semantic-brand-0);--color-border-brand-subtle: var(--color-semantic-brand-p3);--color-background-default: var(--color-whiteA-0);--color-background-inverted: var(--color-semantic-neutral-m3);--color-background-neutral-strong: var(--color-semantic-neutral-0);--color-background-neutral-muted: var(--color-semantic-neutral-p4);--color-background-neutral-onSubtle: var(--color-semantic-neutral-p5);--color-background-neutral-subtle: var(--color-semantic-neutral-p7);--color-background-neutral-surface: var(--color-semantic-neutral-p8);--color-background-informative-strong: var(--color-semantic-informative-0);--color-background-informative-muted: var(--color-semantic-informative-p4);--color-background-informative-onSubtle: var(--color-semantic-informative-p5);--color-background-informative-subtle: var(--color-semantic-informative-p7);--color-background-informative-surface: var(--color-semantic-informative-p8);--color-background-positive-strong: var(--color-semantic-positive-0);--color-background-positive-muted: var(--color-semantic-positive-p4);--color-background-positive-onSubtle: var(--color-semantic-positive-p5);--color-background-positive-subtle: var(--color-semantic-positive-p7);--color-background-positive-surface: var(--color-semantic-positive-p8);--color-background-warning-strong: var(--color-semantic-warning-0);--color-background-warning-muted: var(--color-semantic-warning-p4);--color-background-warning-onSubtle: var(--color-semantic-warning-p5);--color-background-warning-subtle: var(--color-semantic-warning-p7);--color-background-warning-surface: var(--color-semantic-warning-p8);--color-background-negative-strong: var(--color-semantic-negative-0);--color-background-negative-muted: var(--color-semantic-negative-p4);--color-background-negative-onSubtle: var(--color-semantic-negative-p5);--color-background-negative-subtle: var(--color-semantic-negative-p7);--color-background-negative-surface: var(--color-semantic-negative-p8);--color-background-brand-strong: var(--color-semantic-brand-0);--color-background-brand-muted: var(--color-semantic-brand-p4);--color-background-brand-onSubtle: var(--color-semantic-brand-p5);--color-background-brand-subtle: var(--color-semantic-brand-p7);--color-background-brand-surface: var(--color-semantic-brand-p8);--color-action-primary-normal: var(--color-semantic-brand-0);--color-action-primary-hover: var(--color-semantic-brand-m2);--color-action-primary-active: var(--color-semantic-brand-m3);--color-action-primary-selected: var(--color-semantic-brand-m2);--color-action-primary-subtle-normal: var(--color-semantic-brand-p6);--color-action-primary-subtle-hover: var(--color-semantic-brand-p5);--color-action-primary-subtle-active: var(--color-semantic-brand-p3);--color-action-primary-subtle-selected: var(--color-semantic-brand-p5);--color-action-neutral-normal: var(--color-semantic-neutral-m1);--color-action-neutral-hover: var(--color-semantic-neutral-m2);--color-action-neutral-active: var(--color-semantic-neutral-m3);--color-action-neutral-selected: var(--color-semantic-neutral-m2);--color-action-neutral-subtle-normal: var(--color-semantic-neutral-p6);--color-action-neutral-subtle-hover: var(--color-semantic-neutral-p5);--color-action-neutral-subtle-active: var(--color-semantic-neutral-p3);--color-action-neutral-subtle-selected: var(--color-semantic-neutral-p5);--color-action-success-normal: var(--color-semantic-positive-0);--color-action-success-hover: var(--color-semantic-positive-m2);--color-action-success-active: var(--color-semantic-positive-m3);--color-action-success-selected: var(--color-semantic-positive-m2);--color-action-success-subtle-normal: var(--color-semantic-positive-p6);--color-action-success-subtle-hover: var(--color-semantic-positive-p5);--color-action-success-subtle-active: var(--color-semantic-positive-p3);--color-action-success-subtle-selected: var(--color-semantic-positive-p5);--color-action-destructive-normal: var(--color-semantic-negative-0);--color-action-destructive-hover: var(--color-semantic-negative-m2);--color-action-destructive-active: var(--color-semantic-negative-m3);--color-action-destructive-selected: var(--color-semantic-negative-m2);--color-action-destructive-subtle-normal: var(--color-semantic-negative-p6);--color-action-destructive-subtle-hover: var(--color-semantic-negative-p5);--color-action-destructive-subtle-active: var(--color-semantic-negative-p3);--color-action-destructive-subtle-selected: var(--color-semantic-negative-p5);--color-action-ghost-normal: var(--color-transparent);--color-action-ghost-hover: var(--color-semantic-neutralA-p6);--color-action-ghost-active: var(--color-semantic-neutralA-p5);--color-action-ghost-selected: var(--color-semantic-neutralA-p6);--color-action-ghost-inverted-hover: var(--color-whiteA-m8);--color-action-ghost-inverted-active: var(--color-whiteA-m7);--color-action-ghost-inverted-selected: var(--color-whiteA-m8);--color-action-ghost-destructive-hover: var(--color-semantic-negative-p6);--color-action-ghost-destructive-active: var(--color-semantic-negative-p5);--color-action-ghost-destructive-selected: var(--color-semantic-negative-p6);--color-action-outline-normal: var(--color-semantic-neutral-p3);--color-action-outline-hover: var(--color-semantic-neutral-p2);--color-action-outline-active: var(--color-semantic-neutral-p1);--color-action-outline-selected: var(--color-semantic-neutral-p2);--color-action-inverted-normal: var(--color-whiteA-0);--color-action-inverted-hover: var(--color-whiteA-m1);--color-action-inverted-active: var(--color-whiteA-m2);--color-action-inverted-selected: var(--color-whiteA-m1);--color-action-reverseInverted-normal: var(--color-semantic-neutralA-m3);--color-action-reverseInverted-hover: var(--color-semantic-neutralA-m1);--color-action-reverseInverted-active: var(--color-semantic-neutralA-0);--color-action-reverseInverted-selected: var(--color-semantic-neutralA-m1);--color-interaction-default-normal: var(--color-blue-0);--color-interaction-default-hover: var(--color-blue-m2);--color-interaction-default-active: var(--color-blue-m3);--color-interaction-default-selected: var(--color-blue-m2);--color-interaction-default-subtle-normal: var(--color-blue-p6);--color-interaction-default-subtle-hover: var(--color-blue-p5);--color-interaction-default-subtle-active: var(--color-blue-p3);--color-interaction-default-subtle-selected: var(--color-blue-p5);--color-interaction-neutral-normal: var(--color-semantic-neutral-m1);--color-interaction-neutral-hover: var(--color-semantic-neutral-m2);--color-interaction-neutral-active: var(--color-semantic-neutral-m3);--color-interaction-neutral-selected: var(--color-semantic-neutral-m2);--color-interaction-neutral-subtle-normal: var(--color-semantic-neutral-p6);--color-interaction-neutral-subtle-hover: var(--color-semantic-neutral-p5);--color-interaction-neutral-subtle-active: var(--color-semantic-neutral-p3);--color-interaction-neutral-subtle-selected: var(--color-semantic-neutral-p5);--color-interaction-alert-normal: var(--color-semantic-negative-0);--color-interaction-alert-hover: var(--color-semantic-negative-m2);--color-interaction-alert-active: var(--color-semantic-negative-m3);--color-interaction-alert-selected: var(--color-semantic-negative-m2);--color-interaction-alert-subtle-normal: var(--color-semantic-negative-p6);--color-interaction-alert-subtle-hover: var(--color-semantic-negative-p5);--color-interaction-alert-subtle-active: var(--color-semantic-negative-p3);--color-interaction-alert-subtle-selected: var(--color-semantic-negative-p5);--color-interaction-ghost-normal: var(--color-transparent);--color-interaction-ghost-hover: var(--color-semantic-neutralA-p6);--color-interaction-ghost-active: var(--color-semantic-neutralA-p5);--color-interaction-ghost-selected: var(--color-semantic-neutralA-p6);--color-interaction-ghost-inverted-hover: var(--color-whiteA-m8);--color-interaction-ghost-inverted-normal: var(--color-whiteA-m7);--color-interaction-ghost-inverted-selected: var(--color-whiteA-m8);--color-interaction-ghost-destructive-selected: var(--color-semantic-negative-p6);--color-interaction-ghost-destructive-normal: var(--color-semantic-negative-p5);--color-interaction-ghost-destructive-hover: var(--color-semantic-negative-p6);--color-interaction-disabled-normal: var(--color-semantic-neutral-p2);--color-interaction-disabled-hover: var(--color-semantic-neutral-p1);--color-interaction-disabled-active: var(--color-semantic-neutral-0);--color-interaction-disabled-subtle-normal: var(--color-semantic-neutral-p5);--color-interaction-disabled-subtle-hover: var(--color-semantic-neutral-p4);--color-interaction-disabled-subtle-active: var(--color-semantic-neutral-p3);--color-interaction-border-normal: var(--color-blue-p2);--color-interaction-border-hover: var(--color-blue-p1);--color-interaction-border-active: var(--color-blue-m1);--color-interaction-border-selected: var(--color-blue-0);--color-interaction-border-neutral-normal: var(--color-semantic-neutral-p3);--color-interaction-border-neutral-hover: var(--color-semantic-neutral-p2);--color-interaction-border-neutral-active: var(--color-semantic-neutral-p1);--color-interaction-border-neutral-selected: var(--color-semantic-neutral-p2);--color-interaction-border-alert: var(--color-semantic-negative-p1);--color-interaction-background-modal: var(--color-background-default);--color-interaction-background-modeless: var(--color-background-default);--color-interaction-background-modeless-inverted: var(--color-background-inverted);--color-interaction-background-sidepanel: var(--color-background-default);--color-interaction-background-formField: var(--color-background-default);--color-interaction-background-dimmer: var(--color-semantic-neutralA-0);--color-interaction-inverted-normal: var(--color-whiteA-0);--color-interaction-inverted-hover: var(--color-whiteA-m1);--color-interaction-inverted-active: var(--color-whiteA-m2);--color-interaction-inverted-selected: var(--color-whiteA-m1);--color-interaction-focus-default: var(--color-blue-p1);--color-nonSemantic-grey-content-primary: var(--color-semantic-neutral-m3);--color-nonSemantic-grey-content-secondary: var(--color-semantic-neutral-0);--color-nonSemantic-grey-border-default: var(--color-semantic-neutral-p5);--color-nonSemantic-grey-border-strong: var(--color-semantic-neutral-0);--color-nonSemantic-grey-border-subtle: var(--color-semantic-neutral-p3);--color-nonSemantic-grey-background-strong: var(--color-semantic-neutral-0);--color-nonSemantic-grey-background-muted: var(--color-semantic-neutral-p4);--color-nonSemantic-grey-background-onSubtle: var(--color-semantic-neutral-p5);--color-nonSemantic-grey-background-subtle: var(--color-semantic-neutral-p7);--color-nonSemantic-grey-background-surface: var(--color-semantic-neutral-p8);--color-nonSemantic-white-content-primary: var(--color-whiteA-0);--color-nonSemantic-white-content-secondary: var(--color-whiteA-m4);--color-nonSemantic-white-border-default: var(--color-whiteA-m5);--color-nonSemantic-white-border-strong: var(--color-whiteA-0);--color-nonSemantic-white-border-subtle: var(--color-whiteA-m3);--color-nonSemantic-white-background-strong: var(--color-whiteA-0);--color-nonSemantic-white-background-muted: var(--color-whiteA-m4);--color-nonSemantic-white-background-onSubtle: var(--color-whiteA-m5);--color-nonSemantic-white-background-subtle: var(--color-whiteA-m7);--color-nonSemantic-white-background-surface: var(--color-whiteA-m8);--color-nonSemantic-red-content-primary: var(--color-red-m3);--color-nonSemantic-red-content-secondary: var(--color-red-0);--color-nonSemantic-red-border-default: var(--color-red-p5);--color-nonSemantic-red-border-strong: var(--color-red-0);--color-nonSemantic-red-border-subtle: var(--color-red-p3);--color-nonSemantic-red-background-strong: var(--color-red-0);--color-nonSemantic-red-background-muted: var(--color-red-p4);--color-nonSemantic-red-background-onSubtle: var(--color-red-p5);--color-nonSemantic-red-background-subtle: var(--color-red-p7);--color-nonSemantic-red-background-surface: var(--color-red-p8);--color-nonSemantic-raspberry-content-primary: var(--color-raspberry-m3);--color-nonSemantic-raspberry-content-secondary: var(--color-raspberry-0);--color-nonSemantic-raspberry-border-default: var(--color-raspberry-p5);--color-nonSemantic-raspberry-border-strong: var(--color-raspberry-0);--color-nonSemantic-raspberry-border-subtle: var(--color-raspberry-p3);--color-nonSemantic-raspberry-background-strong: var(--color-raspberry-0);--color-nonSemantic-raspberry-background-muted: var(--color-raspberry-p4);--color-nonSemantic-raspberry-background-onSubtle: var(--color-raspberry-p5);--color-nonSemantic-raspberry-background-subtle: var(--color-raspberry-p7);--color-nonSemantic-raspberry-background-surface: var(--color-raspberry-p8);--color-nonSemantic-magenta-content-primary: var(--color-magenta-m3);--color-nonSemantic-magenta-content-secondary: var(--color-magenta-0);--color-nonSemantic-magenta-border-default: var(--color-magenta-p5);--color-nonSemantic-magenta-border-strong: var(--color-magenta-0);--color-nonSemantic-magenta-border-subtle: var(--color-magenta-p3);--color-nonSemantic-magenta-background-strong: var(--color-magenta-0);--color-nonSemantic-magenta-background-muted: var(--color-magenta-p4);--color-nonSemantic-magenta-background-onSubtle: var(--color-magenta-p5);--color-nonSemantic-magenta-background-subtle: var(--color-magenta-p7);--color-nonSemantic-magenta-background-surface: var(--color-magenta-p8);--color-nonSemantic-purple-content-primary: var(--color-purple-m3);--color-nonSemantic-purple-content-secondary: var(--color-purple-0);--color-nonSemantic-purple-border-default: var(--color-purple-p5);--color-nonSemantic-purple-border-strong: var(--color-purple-0);--color-nonSemantic-purple-border-subtle: var(--color-purple-p3);--color-nonSemantic-purple-background-strong: var(--color-purple-0);--color-nonSemantic-purple-background-muted: var(--color-purple-p4);--color-nonSemantic-purple-background-onSubtle: var(--color-purple-p5);--color-nonSemantic-purple-background-subtle: var(--color-purple-p7);--color-nonSemantic-purple-background-surface: var(--color-purple-p8);--color-nonSemantic-grape-content-primary: var(--color-grape-m3);--color-nonSemantic-grape-content-secondary: var(--color-grape-0);--color-nonSemantic-grape-border-default: var(--color-grape-p5);--color-nonSemantic-grape-border-strong: var(--color-grape-0);--color-nonSemantic-grape-border-subtle: var(--color-grape-p3);--color-nonSemantic-grape-background-strong: var(--color-grape-0);--color-nonSemantic-grape-background-muted: var(--color-grape-p4);--color-nonSemantic-grape-background-onSubtle: var(--color-grape-p5);--color-nonSemantic-grape-background-subtle: var(--color-grape-p7);--color-nonSemantic-grape-background-surface: var(--color-grape-p8);--color-nonSemantic-violet-content-primary: var(--color-violet-m3);--color-nonSemantic-violet-content-secondary: var(--color-violet-0);--color-nonSemantic-violet-border-default: var(--color-violet-p5);--color-nonSemantic-violet-border-strong: var(--color-violet-0);--color-nonSemantic-violet-border-subtle: var(--color-violet-p3);--color-nonSemantic-violet-background-strong: var(--color-violet-0);--color-nonSemantic-violet-background-muted: var(--color-violet-p4);--color-nonSemantic-violet-background-onSubtle: var(--color-violet-p5);--color-nonSemantic-violet-background-subtle: var(--color-violet-p7);--color-nonSemantic-violet-background-surface: var(--color-violet-p8);--color-nonSemantic-blue-content-primary: var(--color-blue-m3);--color-nonSemantic-blue-content-secondary: var(--color-blue-0);--color-nonSemantic-blue-border-default: var(--color-blue-p5);--color-nonSemantic-blue-border-strong: var(--color-blue-0);--color-nonSemantic-blue-border-subtle: var(--color-blue-p3);--color-nonSemantic-blue-background-strong: var(--color-blue-0);--color-nonSemantic-blue-background-muted: var(--color-blue-p4);--color-nonSemantic-blue-background-onSubtle: var(--color-blue-p5);--color-nonSemantic-blue-background-subtle: var(--color-blue-p7);--color-nonSemantic-blue-background-surface: var(--color-blue-p8);--color-nonSemantic-cyan-content-primary: var(--color-cyan-m3);--color-nonSemantic-cyan-content-secondary: var(--color-cyan-0);--color-nonSemantic-cyan-border-default: var(--color-cyan-p5);--color-nonSemantic-cyan-border-strong: var(--color-cyan-0);--color-nonSemantic-cyan-border-subtle: var(--color-cyan-p3);--color-nonSemantic-cyan-background-strong: var(--color-cyan-0);--color-nonSemantic-cyan-background-muted: var(--color-cyan-p4);--color-nonSemantic-cyan-background-onSubtle: var(--color-cyan-p5);--color-nonSemantic-cyan-background-subtle: var(--color-cyan-p7);--color-nonSemantic-cyan-background-surface: var(--color-cyan-p8);--color-nonSemantic-teal-content-primary: var(--color-teal-m3);--color-nonSemantic-teal-content-secondary: var(--color-teal-0);--color-nonSemantic-teal-border-default: var(--color-teal-p5);--color-nonSemantic-teal-border-strong: var(--color-teal-0);--color-nonSemantic-teal-border-subtle: var(--color-teal-p3);--color-nonSemantic-teal-background-strong: var(--color-teal-0);--color-nonSemantic-teal-background-muted: var(--color-teal-p4);--color-nonSemantic-teal-background-onSubtle: var(--color-teal-p5);--color-nonSemantic-teal-background-subtle: var(--color-teal-p7);--color-nonSemantic-teal-background-surface: var(--color-teal-p8);--color-nonSemantic-aquamarine-content-primary: var(--color-aquamarine-m3);--color-nonSemantic-aquamarine-content-secondary: var(--color-aquamarine-0);--color-nonSemantic-aquamarine-border-default: var(--color-aquamarine-p5);--color-nonSemantic-aquamarine-border-strong: var(--color-aquamarine-0);--color-nonSemantic-aquamarine-border-subtle: var(--color-aquamarine-p3);--color-nonSemantic-aquamarine-background-strong: var(--color-aquamarine-0);--color-nonSemantic-aquamarine-background-muted: var(--color-aquamarine-p4);--color-nonSemantic-aquamarine-background-onSubtle: var(--color-aquamarine-p5);--color-nonSemantic-aquamarine-background-subtle: var(--color-aquamarine-p7);--color-nonSemantic-aquamarine-background-surface: var(--color-aquamarine-p8);--color-nonSemantic-green-content-primary: var(--color-green-m3);--color-nonSemantic-green-content-secondary: var(--color-green-0);--color-nonSemantic-green-border-default: var(--color-green-p5);--color-nonSemantic-green-border-strong: var(--color-green-0);--color-nonSemantic-green-border-subtle: var(--color-green-p3);--color-nonSemantic-green-background-strong: var(--color-green-0);--color-nonSemantic-green-background-muted: var(--color-green-p4);--color-nonSemantic-green-background-onSubtle: var(--color-green-p5);--color-nonSemantic-green-background-subtle: var(--color-green-p7);--color-nonSemantic-green-background-surface: var(--color-green-p8);--color-nonSemantic-emerald-content-primary: var(--color-emerald-m3);--color-nonSemantic-emerald-content-secondary: var(--color-emerald-0);--color-nonSemantic-emerald-border-default: var(--color-emerald-p5);--color-nonSemantic-emerald-border-strong: var(--color-emerald-0);--color-nonSemantic-emerald-border-subtle: var(--color-emerald-p3);--color-nonSemantic-emerald-background-strong: var(--color-emerald-0);--color-nonSemantic-emerald-background-muted: var(--color-emerald-p4);--color-nonSemantic-emerald-background-onSubtle: var(--color-emerald-p5);--color-nonSemantic-emerald-background-subtle: var(--color-emerald-p7);--color-nonSemantic-emerald-background-surface: var(--color-emerald-p8);--color-nonSemantic-orange-content-primary: var(--color-orange-m3);--color-nonSemantic-orange-content-secondary: var(--color-orange-0);--color-nonSemantic-orange-border-default: var(--color-orange-p5);--color-nonSemantic-orange-border-strong: var(--color-orange-0);--color-nonSemantic-orange-border-subtle: var(--color-orange-p3);--color-nonSemantic-orange-background-strong: var(--color-orange-0);--color-nonSemantic-orange-background-muted: var(--color-orange-p4);--color-nonSemantic-orange-background-onSubtle: var(--color-orange-p5);--color-nonSemantic-orange-background-subtle: var(--color-orange-p7);--color-nonSemantic-orange-background-surface: var(--color-orange-p8);--border-radius-small: var(--border-radius-25);--border-radius-medium: var(--border-radius-50);--border-radius-large: var(--border-radius-100);--space-component-padding-null: var(--dimension-0);--space-component-padding-xSmall: var(--dimension-50);--space-component-padding-small: var(--dimension-100);--space-component-padding-medium: var(--dimension-150);--space-component-padding-large: var(--dimension-200);--space-component-padding-2xLarge: var(--dimension-300);--space-component-gap-null: var(--dimension-0);--space-component-gap-2xSmall: var(--dimension-25);--space-component-gap-xSmall: var(--dimension-50);--space-component-gap-small: var(--dimension-100);--space-component-gap-medium: var(--dimension-150);--space-component-gap-large: var(--dimension-200);--space-component-gap-2xLarge: var(--dimension-400);--size-2xLarge: var(--dimension-800);--size-large: var(--dimension-600);--size-medium: var(--dimension-500);--size-small: var(--dimension-400);--size-xSmall: var(--dimension-300);--size-2xSmall: var(--dimension-250);--size-3xSmall: var(--dimension-200);--space-component-gap-xLarge: var(--dimension-250);--space-component-padding-3xLarge: var(--dimension-400);--space-component-padding-4xLarge: var(--dimension-500);--space-component-padding-6xLarge: var(--dimension-800);--space-component-padding-2xSmall: var(--dimension-25);--border-radius-full: var(--border-radius-999);--space-component-padding-xLarge: var(--dimension-250);--border-radius-150: 12px;--border-radius-xLarge: var(--border-radius-150);--dimension-0: 0px;--dimension-25: 2px;--dimension-50: 4px;--dimension-100: 8px;--dimension-150: 12px;--dimension-200: 16px;--dimension-250: 20px;--dimension-300: 24px;--dimension-350: 28px;--dimension-400: 32px;--dimension-500: 40px;--dimension-600: 48px;--dimension-700: 56px;--dimension-800: 64px;--dimension-1000: 80px;--dimension-1200: 96px;--dimension-1500: 120px;--dimension-1600: 128px;--dimension-550: 44px;--space-component-padding-5xLarge: var(--dimension-550);--space-component-gap-3xLarge: var(--dimension-550);--size-xLarge: var(--dimension-700);--dimension-900: 72px;--size-3xLarge: var(--dimension-900);--color-interaction-background-sidebarNav: var(--color-background-default);--color-interaction-background-topNav: var(--color-background-default)}html,body{font-family:Inter,sans-serif;font-weight:450;font-size:12px;line-height:16px;letter-spacing:.32px;text-decoration:none}a{cursor:pointer}", Kbe = "7", Zbe = 1e4, qbe = /\/1\/invalid-[\w-]+\//;
let hg, D2 = !1;
const jbe = () => window.tinymce, T2 = () => {
  var t;
  const e = (t = jbe()) == null ? void 0 : t.baseURL;
  return typeof e != "string" || qbe.test(e);
}, Ybe = () => {
  D2 = !0;
}, Qbe = () => new Promise((e) => {
  const t = document.createElement("script");
  t.referrerPolicy = "origin", t.type = "application/javascript", t.src = `https://cdn.tiny.cloud/1/${Hg.apiKey}/tinymce/${Kbe}/tinymce.min.js`;
  const n = () => {
    t.removeEventListener("load", o), t.removeEventListener("error", s);
  }, o = () => {
    window.clearTimeout(i), n(), e(!T2());
  }, s = () => {
    window.clearTimeout(i), n(), t.remove(), hg = void 0, e(!1);
  }, i = window.setTimeout(s, Zbe);
  t.addEventListener("load", o), t.addEventListener("error", s), document.head.appendChild(t);
}), Jbe = () => D2 || !Hg.apiKey ? Promise.resolve(!1) : (hg ?? (hg = Qbe()), hg), Xbe = {
  undo: "phosphor/arrow-bend-up-left",
  redo: "phosphor/arrow-bend-up-right",
  bold: "phosphor/text-b",
  italic: "phosphor/text-italic",
  "highlight-bg-color": "phosphor/pencil-simple-line",
  link: "phosphor/link",
  "align-left": "phosphor/text-align-left",
  "align-center": "phosphor/text-align-center",
  "align-right": "phosphor/text-align-right",
  "align-justify": "phosphor/text-align-justify",
  "unordered-list": "phosphor/list-plus",
  "ordered-list": "phosphor/list-numbers",
  outdent: "phosphor/text-outdent",
  indent: "phosphor/text-indent",
  "remove-formatting": "generic/text-italic-x",
  help: "phosphor/question",
  sourcecode: "phosphor/code",
  "chevron-down": "phosphor/caret-down"
}, eSe = 10, tSe = "undo redo | formatselect | bold italic backcolor | link |      alignleft aligncenter alignright alignjustify |      bullist numlist outdent indent | removeformat | help | code", nSe = /* @__PURE__ */ de({
  __name: "SCATinyMCEEditor",
  props: /* @__PURE__ */ dt({
    readOnly: { type: Boolean, default: !1 },
    locale: { default: "en" },
    stickyToolbarTop: { default: void 0 },
    unlimitedHeight: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    menubarDisabled: { type: Boolean, default: !1 },
    minHeight: {},
    maxHeight: { default: void 0 }
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["unusable"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = /tiny\.cloud\/docs\/tinymce\/[^\s"')]+\/invalid-api-key/, o = e, s = t, i = D(() => o.locale === "de" ? "de" : "en"), r = lt(e, "modelValue"), a = W(null);
    let l;
    const d = () => {
      var m, C;
      const f = (C = (m = a.value) == null ? void 0 : m.getBody) == null ? void 0 : C.call(m);
      f && (f.style.caretColor = o.readOnly ? "transparent" : "");
    }, c = () => {
      var f, m, C, w;
      (w = (C = (m = (f = a.value) == null ? void 0 : f.getContainer) == null ? void 0 : m.call(f)) == null ? void 0 : C.querySelector(".tox-menubar")) == null || w.toggleAttribute("inert", o.menubarDisabled);
    }, u = (f) => {
      var m, C;
      return (((C = (m = f.notificationManager) == null ? void 0 : m.getNotifications) == null ? void 0 : C.call(m)) ?? []).some(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (w) => {
          var b, A, S;
          return n.test(
            String(((b = w == null ? void 0 : w.settings) == null ? void 0 : b.text) ?? ((S = (A = w == null ? void 0 : w.getEl) == null ? void 0 : A.call(w)) == null ? void 0 : S.textContent) ?? "")
          );
        }
      );
    }, h = (f) => {
      var m, C;
      return T2() || u(f) || // A legitimately disabled editor also reports "readonly" here, so this half of the check must
      // stay opt-in — it only tells us something is wrong when we asked for an editable instance.
      !o.readOnly && ((C = (m = f.mode) == null ? void 0 : m.get) == null ? void 0 : C.call(m)) === "readonly";
    }, g = D(() => ({
      branding: !1,
      icons: "thin",
      skin: "borderless",
      content_style: Ube,
      onboarding: !1,
      plugins: "autoresize",
      min_height: o.minHeight,
      ...o.maxHeight === void 0 ? {} : { max_height: o.maxHeight },
      autoresize_bottom_margin: eSe,
      statusbar: !1,
      language: i.value,
      mobile: {
        menubar: !0
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setup: (f) => {
        a.value = f;
        const m = () => {
          Object.entries(Xbe).forEach(([C, w]) => {
            const b = C === "chevron-down" ? 12 : 20;
            f.ui.registry.addIcon(C, Zi(w, b));
          });
        };
        f.on("init", () => {
          if (h(f)) {
            a.value = null, Ybe(), l = window.setTimeout(() => {
              f.remove(), s("unusable");
            });
            return;
          }
          m(), d(), c();
          const C = f.getBody();
          C && (C.style.overflowY = o.stickyToolbarTop !== void 0 ? "hidden" : "");
        }), f.on("click", (C) => {
          const w = C.target;
          w.tagName === "A" && window.open(w.href, "_blank");
        });
      }
    }));
    Re(() => o.readOnly, d), Re(() => o.menubarDisabled, c), Re(
      () => o.stickyToolbarTop,
      (f) => {
        var C, w;
        const m = (w = (C = a.value) == null ? void 0 : C.getBody) == null ? void 0 : w.call(C);
        m && (m.style.overflowY = f !== void 0 ? "hidden" : "");
      }
    ), io(() => window.clearTimeout(l));
    const p = D(
      () => "autoresize advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime table code help wordcount"
    );
    return (f, m) => (v(), y("div", {
      class: x([
        f.$style.editor,
        e.stickyToolbarTop ? f.$style.stickyToolbar : "",
        e.unlimitedHeight ? f.$style.unlimitedHeight : "",
        e.resizable ? f.$style.resizable : "",
        e.menubarDisabled ? f.$style.menubarDisabled : ""
      ]),
      style: Ke(e.stickyToolbarTop ? { "--notes-sticky-top": e.stickyToolbarTop } : void 0)
    }, [
      (v(), z(T(Wbe), {
        key: i.value,
        modelValue: r.value,
        "onUpdate:modelValue": m[0] || (m[0] = (C) => r.value = C),
        init: g.value,
        disabled: e.readOnly,
        plugins: p.value,
        toolbar: tSe,
        "api-key": T(Hg).apiKey
      }, null, 8, ["modelValue", "init", "disabled", "plugins", "api-key"]))
    ], 6));
  }
}), oSe = "_editor_89hqa_747", sSe = "_menubarDisabled_89hqa_819", iSe = "_unlimitedHeight_89hqa_823", rSe = "_resizable_89hqa_827", aSe = "_stickyToolbar_89hqa_835", lSe = {
  editor: oSe,
  menubarDisabled: sSe,
  unlimitedHeight: iSe,
  resizable: rSe,
  stickyToolbar: aSe
}, dSe = {
  $style: lSe
}, cSe = /* @__PURE__ */ we(nSe, [["__cssModules", dSe]]), Vl = 191, _l = 500, uSe = /* @__PURE__ */ de({
  __name: "SCARichText",
  props: /* @__PURE__ */ dt({
    placeholder: { default: "" },
    readOnly: { type: Boolean, default: !1 },
    locale: { default: "en" },
    stickyToolbarTop: { default: void 0 },
    unlimitedHeight: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    menubarDisabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e8(() => import("./SCATiptapEditor-BYoj0yyI.js")), n = e, o = lt(e, "modelValue"), s = Mi(lbe, "tinymce"), i = D(() => xe(s) === "tiptap"), r = D(() => xe(s) === "tinymce"), a = W("pending"), l = D(() => ({
      minHeight: `${Vl}px`,
      ...n.unlimitedHeight ? {} : { maxHeight: `${_l}px` }
    }));
    return Re(
      r,
      async (d) => {
        !d || a.value !== "pending" || (a.value = await Jbe() ? "cloud" : "plain");
      },
      { immediate: !0 }
    ), (d, c) => i.value ? (v(), z(T(t), {
      key: 0,
      modelValue: o.value,
      "onUpdate:modelValue": c[0] || (c[0] = (u) => o.value = u),
      "read-only": e.readOnly,
      "menubar-disabled": e.menubarDisabled,
      "min-height": Vl,
      "max-height": e.unlimitedHeight ? void 0 : _l,
      "sticky-toolbar-top": e.stickyToolbarTop,
      resizable: e.resizable,
      "test-id": "rich-text-new-editor"
    }, null, 8, ["modelValue", "read-only", "menubar-disabled", "max-height", "sticky-toolbar-top", "resizable"])) : a.value === "pending" ? (v(), y("div", {
      key: 1,
      class: x(d.$style.pending),
      style: Ke(l.value)
    }, null, 6)) : a.value === "plain" ? (v(), z(Ibe, {
      key: 2,
      modelValue: o.value,
      "onUpdate:modelValue": c[1] || (c[1] = (u) => o.value = u),
      "read-only": e.readOnly,
      resizable: e.resizable,
      "min-height": Vl,
      "max-height": e.unlimitedHeight ? void 0 : _l
    }, null, 8, ["modelValue", "read-only", "resizable", "max-height"])) : a.value === "cloud" ? (v(), z(cSe, {
      key: 3,
      modelValue: o.value,
      "onUpdate:modelValue": c[2] || (c[2] = (u) => o.value = u),
      "read-only": e.readOnly,
      "menubar-disabled": e.menubarDisabled,
      locale: e.locale,
      "sticky-toolbar-top": e.stickyToolbarTop,
      "unlimited-height": e.unlimitedHeight,
      resizable: e.resizable,
      "min-height": Vl,
      "max-height": e.unlimitedHeight ? void 0 : _l,
      onUnusable: c[3] || (c[3] = (u) => a.value = "plain")
    }, null, 8, ["modelValue", "read-only", "menubar-disabled", "locale", "sticky-toolbar-top", "unlimited-height", "resizable", "max-height"])) : V("", !0);
  }
}), hSe = "_pending_xivjc_1", gSe = {
  pending: hSe
}, pSe = {
  $style: gSe
}, JMe = /* @__PURE__ */ we(uSe, [["__cssModules", pSe]]), fSe = /* @__PURE__ */ de({
  __name: "SCAAlertBanner",
  props: {
    type: { default: void 0 },
    text: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = D(() => {
      switch (n.type) {
        case "success":
          return "phosphor/check-circle-fill";
        case "warning":
          return "phosphor/warning-fill";
        case "error":
          return "phosphor/warning-diamond-fill";
        default:
          return "phosphor/info-fill";
      }
    });
    return (i, r) => (v(), y("div", {
      class: x([
        i.$style.root,
        {
          [i.$style.typeSuccess]: e.type === "success",
          [i.$style.typeWarning]: e.type === "warning",
          [i.$style.typeError]: e.type === "error"
        }
      ])
    }, [
      R("div", {
        class: x(i.$style.infoActionContainer)
      }, [
        R("div", {
          class: x(i.$style.container)
        }, [
          te(Fe, {
            class: x(i.$style.icon),
            icon: s.value
          }, null, 8, ["class", "icon"]),
          e.text ? (v(), y("div", {
            key: 0,
            class: x(i.$style.label)
          }, se(e.text), 3)) : V("", !0)
        ], 2),
        R("div", {
          class: x(i.$style.container)
        }, [
          ve(i.$slots, "default")
        ], 2)
      ], 2),
      te(ut, {
        icon: "phosphor/x",
        type: "ghost",
        appearance: e.type === "warning" ? "reverseInverted" : "inverted",
        onClick: r[0] || (r[0] = (a) => o("close"))
      }, null, 8, ["appearance"])
    ], 2));
  }
}), mSe = "_root_y6hjr_747", vSe = "_typeSuccess_y6hjr_763", CSe = "_typeWarning_y6hjr_766", wSe = "_typeError_y6hjr_770", ySe = "_infoActionContainer_y6hjr_774", bSe = "_container_y6hjr_781", SSe = "_icon_y6hjr_787", xSe = {
  root: mSe,
  typeSuccess: vSe,
  typeWarning: CSe,
  typeError: wSe,
  infoActionContainer: ySe,
  container: bSe,
  icon: SSe
}, RSe = {
  $style: xSe
}, XMe = /* @__PURE__ */ we(fSe, [["__cssModules", RSe]]), ESe = { key: 1 }, ASe = /* @__PURE__ */ de({
  __name: "SCABadge",
  props: {
    appearance: { default: "blue" },
    emphasis: { default: "high" },
    iconBefore: { default: void 0 },
    iconAfter: { default: void 0 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = e, n = rn(), o = D(() => !!n.default), s = D(() => t.size === "small" ? "10px" : "16px");
    return (i, r) => (v(), y("div", {
      class: x([
        i.$style.badge,
        i.$style[`appearance_${e.appearance}_${e.emphasis}`],
        { [i.$style.iconOnly]: !o.value, [i.$style.small]: e.size === "small" }
      ])
    }, [
      e.iconBefore ? (v(), z(Fe, {
        key: 0,
        icon: e.iconBefore,
        size: s.value
      }, null, 8, ["icon", "size"])) : V("", !0),
      o.value ? (v(), y("div", ESe, [
        ve(i.$slots, "default")
      ])) : V("", !0),
      e.iconAfter ? (v(), z(Fe, {
        key: 2,
        icon: e.iconAfter,
        size: s.value
      }, null, 8, ["icon", "size"])) : V("", !0)
    ], 2));
  }
}), FSe = "_badge_cjqw0_747", MSe = "_appearance_blue_high_cjqw0_763", ISe = "_appearance_blue_medium_cjqw0_767", PSe = "_appearance_blue_low_cjqw0_771", DSe = "_appearance_green_high_cjqw0_775", TSe = "_appearance_green_medium_cjqw0_779", kSe = "_appearance_green_low_cjqw0_783", LSe = "_appearance_grey_high_cjqw0_787", BSe = "_appearance_grey_medium_cjqw0_791", OSe = "_appearance_grey_low_cjqw0_795", GSe = "_appearance_red_high_cjqw0_799", HSe = "_appearance_red_medium_cjqw0_803", VSe = "_appearance_red_low_cjqw0_807", _Se = "_appearance_orange_high_cjqw0_811", NSe = "_appearance_orange_medium_cjqw0_815", $Se = "_appearance_orange_low_cjqw0_819", zSe = "_appearance_raspberry_high_cjqw0_823", WSe = "_appearance_raspberry_medium_cjqw0_827", USe = "_appearance_raspberry_low_cjqw0_831", KSe = "_appearance_magenta_high_cjqw0_835", ZSe = "_appearance_magenta_medium_cjqw0_839", qSe = "_appearance_magenta_low_cjqw0_843", jSe = "_appearance_purple_high_cjqw0_847", YSe = "_appearance_purple_medium_cjqw0_851", QSe = "_appearance_purple_low_cjqw0_855", JSe = "_appearance_grape_high_cjqw0_859", XSe = "_appearance_grape_medium_cjqw0_863", e2e = "_appearance_grape_low_cjqw0_867", t2e = "_appearance_violet_high_cjqw0_871", n2e = "_appearance_violet_medium_cjqw0_875", o2e = "_appearance_violet_low_cjqw0_879", s2e = "_appearance_cyan_high_cjqw0_883", i2e = "_appearance_cyan_medium_cjqw0_887", r2e = "_appearance_cyan_low_cjqw0_891", a2e = "_appearance_teal_high_cjqw0_895", l2e = "_appearance_teal_medium_cjqw0_899", d2e = "_appearance_teal_low_cjqw0_903", c2e = "_appearance_aquamarine_high_cjqw0_907", u2e = "_appearance_aquamarine_medium_cjqw0_911", h2e = "_appearance_aquamarine_low_cjqw0_915", g2e = "_appearance_emerald_high_cjqw0_919", p2e = "_appearance_emerald_medium_cjqw0_923", f2e = "_appearance_emerald_low_cjqw0_927", m2e = "_appearance_white_high_cjqw0_931", v2e = "_appearance_white_medium_cjqw0_935", C2e = "_appearance_white_low_cjqw0_939", w2e = "_iconOnly_cjqw0_943", y2e = "_small_cjqw0_946", b2e = {
  badge: FSe,
  appearance_blue_high: MSe,
  appearance_blue_medium: ISe,
  appearance_blue_low: PSe,
  appearance_green_high: DSe,
  appearance_green_medium: TSe,
  appearance_green_low: kSe,
  appearance_grey_high: LSe,
  appearance_grey_medium: BSe,
  appearance_grey_low: OSe,
  appearance_red_high: GSe,
  appearance_red_medium: HSe,
  appearance_red_low: VSe,
  appearance_orange_high: _Se,
  appearance_orange_medium: NSe,
  appearance_orange_low: $Se,
  appearance_raspberry_high: zSe,
  appearance_raspberry_medium: WSe,
  appearance_raspberry_low: USe,
  appearance_magenta_high: KSe,
  appearance_magenta_medium: ZSe,
  appearance_magenta_low: qSe,
  appearance_purple_high: jSe,
  appearance_purple_medium: YSe,
  appearance_purple_low: QSe,
  appearance_grape_high: JSe,
  appearance_grape_medium: XSe,
  appearance_grape_low: e2e,
  appearance_violet_high: t2e,
  appearance_violet_medium: n2e,
  appearance_violet_low: o2e,
  appearance_cyan_high: s2e,
  appearance_cyan_medium: i2e,
  appearance_cyan_low: r2e,
  appearance_teal_high: a2e,
  appearance_teal_medium: l2e,
  appearance_teal_low: d2e,
  appearance_aquamarine_high: c2e,
  appearance_aquamarine_medium: u2e,
  appearance_aquamarine_low: h2e,
  appearance_emerald_high: g2e,
  appearance_emerald_medium: p2e,
  appearance_emerald_low: f2e,
  appearance_white_high: m2e,
  appearance_white_medium: v2e,
  appearance_white_low: C2e,
  iconOnly: w2e,
  small: y2e
}, S2e = {
  $style: b2e
}, eIe = /* @__PURE__ */ we(ASe, [["__cssModules", S2e]]), x2e = /* @__PURE__ */ de({
  __name: "SCAButtonGroup",
  setup(e) {
    const t = rn();
    return (n, o) => (v(), y("div", {
      class: x(n.$style.buttonGroup)
    }, [
      t.default ? ve(n.$slots, "default", { key: 0 }) : V("", !0)
    ], 2));
  }
}), R2e = "_buttonGroup_1fuhz_747", E2e = {
  buttonGroup: R2e
}, A2e = {
  $style: E2e
}, tIe = /* @__PURE__ */ we(x2e, [["__cssModules", A2e]]), F2e = /* @__PURE__ */ de({
  __name: "SCACheckbox",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("label", null, [
      R("div", {
        class: x(t.$style.grid)
      }, [
        te(Ts, {
          checked: e.checked,
          disabled: e.disabled,
          alert: e.alert
        }, {
          default: Q(() => [
            ve(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["checked", "disabled", "alert"]),
        R("span", {
          class: x([{ [t.$style.required]: e.required }])
        }, se(e.label), 3)
      ], 2),
      e.helperText ? (v(), z(Gr, {
        key: 0,
        intent: e.alert ? "alert" : void 0,
        class: x(t.$style.helperText)
      }, {
        default: Q(() => [
          Oe(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["intent", "class"])) : V("", !0)
    ]));
  }
}), M2e = "_grid_rfxsu_747", I2e = "_helperText_rfxsu_762", P2e = "_disabled_rfxsu_767", D2e = {
  grid: M2e,
  helperText: I2e,
  disabled: P2e
}, T2e = {
  $style: D2e
}, nIe = /* @__PURE__ */ we(F2e, [["__cssModules", T2e]]), k2e = /* @__PURE__ */ de({
  __name: "SCACheckboxGroup",
  props: {
    columns: { default: void 0 },
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    optionalLabelText: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 }
  },
  setup(e) {
    Ls((o) => ({
      v6c9f31bf: n.value
    }));
    const t = e, n = D(() => t.columns ?? 1);
    return (o, s) => (v(), z(zc, {
      label: e.label,
      "label-position": e.labelPosition,
      "optional-label-text": e.optionalLabelText,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor,
      style: { "--sca-label-align": "flex-start" }
    }, {
      default: Q(() => [
        R("div", {
          class: x([o.$style.checkboxGrid, { [o.$style.columns]: e.columns }])
        }, [
          ve(o.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["label", "label-position", "optional-label-text", "appearance", "helper-text", "validation-error", "required", "html-for"]));
  }
}), L2e = "_checkboxGrid_1015t_747", B2e = "_columns_1015t_753", O2e = {
  checkboxGrid: L2e,
  columns: B2e
}, G2e = {
  $style: O2e
}, oIe = /* @__PURE__ */ we(k2e, [["__cssModules", G2e]]), H2e = /* @__PURE__ */ de({
  __name: "SCADivider",
  props: {
    direction: { default: "horizontal" },
    appearance: { default: "default" },
    margin: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, o) => (v(), y("div", {
      class: x([
        n.$style.root,
        {
          [n.$style.vertical]: t.direction === "vertical",
          [n.$style.appearanceBorder]: t.appearance === "border"
        }
      ]),
      style: Ke({ margin: e.margin }),
      role: "separator"
    }, null, 6));
  }
}), V2e = "_root_2roj9_747", _2e = "_vertical_2roj9_753", N2e = "_appearanceBorder_2roj9_756", $2e = {
  root: V2e,
  vertical: _2e,
  appearanceBorder: N2e
}, z2e = {
  $style: $2e
}, ba = /* @__PURE__ */ we(H2e, [["__cssModules", z2e]]), k2 = "application/x-sca-drag-and-drop-list-keys";
function W2e(e, t) {
  e.setData(k2, JSON.stringify(t));
}
function Hv(e) {
  const t = e == null ? void 0 : e.getData(k2);
  if (!t) return [];
  try {
    const n = JSON.parse(t);
    return Array.isArray(n) ? n.filter((o) => typeof o == "string") : [];
  } catch {
    return [];
  }
}
function U2e(e, t, n, o = []) {
  if (!n.includes(e)) return [e];
  const s = new Set(n), i = new Set(o);
  return t.filter((r) => s.has(r) && !i.has(r));
}
function K2e(e, t, n) {
  const o = new Set(t);
  return e.filter((i) => !o.has(i))[n] ?? null;
}
const Z2e = ["onClick", "onMouseenter"], Vv = "sca-drag-and-drop-list", q2e = /* @__PURE__ */ de({
  __name: "SCADragAndDropList",
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    dropGroup: { default: void 0 },
    itemClass: { default: void 0 },
    selectedId: { default: null },
    selectedIds: { default: void 0 },
    appearance: { default: "default" },
    isMobile: { type: Boolean, default: !1 },
    disabledForeignKeys: { default: void 0 },
    ghostLabel: { type: Function, default: void 0 },
    itemPadding: { default: "small" }
  },
  emits: ["update:modelValue", "reordered", "select", "drag-start", "drag-end", "drop-foreign", "drop"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Bn(n, "modelValue", o, { passive: !0 }), i = W(null), r = W(!1), a = W(!1);
    Et(() => document.addEventListener("dragend", l, { passive: !0 })), ks(() => document.removeEventListener("dragend", l));
    function l() {
      a.value = !1;
    }
    const d = () => n.disabled;
    function c(M) {
      var I;
      return n.selectedId === M.key || !!((I = n.selectedIds) != null && I.includes(M.key));
    }
    function u(M) {
      a.value = !0, M.shiftKey && M.preventDefault();
    }
    const h = Nc({
      getId: (M) => M.key,
      ghostLabel: (M) => {
        var I;
        return ((I = n.ghostLabel) == null ? void 0 : I.call(n, M)) ?? M.key;
      },
      dragGroup: n.dropGroup ?? Vv,
      disabled: d,
      ghostStack: !0,
      resolveItems: (M) => {
        var P;
        if (!((P = n.selectedIds) != null && P.length)) return [M];
        const I = U2e(
          M.key,
          s.value.map((k) => k.key),
          n.selectedIds,
          s.value.filter((k) => k.disabled).map((k) => k.key)
        );
        return s.value.filter((k) => I.includes(k.key));
      }
    });
    function g(M) {
      const I = h.dragHandlers(M);
      return {
        ...I,
        draggable: I.draggable && a.value && !M.disabled,
        onDragstart: (P) => {
          I.onDragstart(P), P.dataTransfer && W2e(
            P.dataTransfer,
            h.draggedItems.value.map((k) => k.key)
          );
        },
        onDragend: () => {
          I.onDragend(), a.value = !1;
        }
      };
    }
    function p(M) {
      return h.isDragging.value && h.draggedItems.value.some((I) => I.key === M.key);
    }
    Re(h.isDragging, (M) => {
      o(M ? "drag-start" : "drag-end");
    });
    const f = (M) => {
      const I = n.disabledForeignKeys;
      return I != null && I.length ? M.source.some((P) => !I.some((k) => k.toLowerCase() === P.key.toLowerCase())) : !0;
    }, m = (M) => {
      var I;
      return !((I = M.target) != null && I.disabled && M.position === "above");
    }, C = (M, I) => {
      if (n.dropGroup && !Ua(M, n.dropGroup)) return null;
      const P = Wd(M);
      return P.length ? P.map((k) => I.find((B) => B.key.toLowerCase() === k) ?? { key: k, data: void 0 }) : null;
    }, w = $c({
      items: s,
      getId: (M) => M.key,
      dragGroup: n.dropGroup ?? Vv,
      rules: [Vc((M) => M.key), f, m],
      disabled: d,
      resolveSource: C,
      onDrop: (M, I) => {
        const P = Hv(I.dataTransfer), k = P.length ? P : [M.source[0].key];
        if (o(
          "drop",
          k,
          K2e(
            s.value.map((N) => N.key),
            k,
            M.index
          )
        ), k.length > 1) return;
        const [B] = k, j = s.value.findIndex((N) => N.key === B);
        j !== -1 ? o("reordered", B, j, M.index) : o("drop-foreign", B, M.index);
      }
    });
    function b(M) {
      return n.dropGroup && !Ua(M, n.dropGroup) ? !1 : ZS(M) !== null;
    }
    function A(M) {
      const I = n.disabledForeignKeys;
      if (!(I != null && I.length)) return !1;
      const P = Wd(M);
      return P.length > 0 && P.every((k) => I.some((B) => B.toLowerCase() === k));
    }
    const S = (M) => {
      if (!(n.disabled || !M.dataTransfer)) {
        if (!b(M)) {
          M.dataTransfer.dropEffect = "none", r.value = !1;
          return;
        }
        if (A(M)) {
          M.dataTransfer.dropEffect = "none", document.body.style.cursor = "not-allowed", r.value = !1;
          return;
        }
        M.dataTransfer.dropEffect = "move", document.body.style.cursor = "", r.value = !0;
      }
    }, F = () => {
      r.value = !1, document.body.style.cursor = "";
    }, E = (M) => {
      if (r.value = !1, n.disabled || !M.dataTransfer || !b(M)) return;
      if (A(M)) {
        document.body.style.cursor = "";
        return;
      }
      const I = Hv(M.dataTransfer);
      I.length && (o("drop", I, null), I.length === 1 && o("drop-foreign", I[0], 0), document.body.style.cursor = "");
    };
    return (M, I) => (v(), y("div", {
      class: x(M.$style.root)
    }, [
      T(s).length > 0 ? (v(), y("div", at({
        key: 0,
        class: M.$style.dropzone
      }, T(w).containerHandlers), [
        T(w).lineStyle.value ? (v(), y("div", {
          key: 0,
          class: x(T(w).lineClass.value),
          style: Ke(T(w).lineStyle.value)
        }, null, 6)) : V("", !0),
        (v(!0), y(Se, null, We(T(s), (P, k) => (v(), y("div", at({
          key: P.key,
          ref_for: !0,
          ref: T(w).registerRow(P),
          class: [
            M.$style.element,
            e.itemClass,
            {
              [M.$style.selected]: c(P),
              [M.$style.paddingXSmall]: e.itemPadding === "xSmall"
            }
          ]
        }, { ref_for: !0 }, g(P), {
          onClick: (B) => M.$emit("select", P.key, B),
          onMousedown: u,
          onMouseup: I[0] || (I[0] = (B) => a.value = !1),
          onMouseenter: (B) => i.value = P.key,
          onMouseleave: I[1] || (I[1] = (B) => i.value = null)
        }), [
          !e.isMobile && !e.disabled && (e.appearance === "default" || i.value === P.key || p(P)) ? (v(), y("div", {
            key: 0,
            "data-handle": "true",
            class: x([M.$style.dragHandle, { [M.$style.dragHandleDisabled]: P.disabled }])
          }, [
            te(Fe, { icon: "phosphor/dots-six-vertical" })
          ], 2)) : V("", !0),
          e.isMobile || e.appearance === "minimal" && !(i.value === P.key || p(P)) ? (v(), y("div", {
            key: 1,
            class: x(M.$style.index)
          }, se(P.ordinal ?? k + 1), 3)) : V("", !0),
          ve(M.$slots, "default", {
            key: P.key,
            index: k,
            data: P.data
          }, () => [
            R("div", null, se(P.key), 1)
          ])
        ], 16, Z2e))), 128))
      ], 16)) : (v(), y("div", {
        key: 1,
        class: x([M.$style.emptyDropzone, { [M.$style.emptyDropzoneActive]: r.value }]),
        onDrop: E,
        onDragenter: I[2] || (I[2] = Ge((P) => r.value = !0, ["prevent"])),
        onDragover: Ge(S, ["prevent"]),
        onDragleave: Ge(F, ["prevent"])
      }, [
        ve(M.$slots, "empty", { isDragOver: r.value }, () => [
          te(T(ll))
        ])
      ], 34))
    ], 2));
  }
}), j2e = "_root_qofkf_1", Y2e = "_dropzone_qofkf_6", Q2e = "_emptyDropzone_qofkf_11", J2e = "_emptyDropzoneActive_qofkf_22", X2e = "_element_qofkf_27", e8e = "_paddingXSmall_qofkf_36", t8e = "_dragHandle_qofkf_39", n8e = "_dragHandleDisabled_qofkf_46", o8e = "_index_qofkf_50", s8e = "_selected_qofkf_56", i8e = {
  root: j2e,
  dropzone: Y2e,
  emptyDropzone: Q2e,
  emptyDropzoneActive: J2e,
  element: X2e,
  paddingXSmall: e8e,
  dragHandle: t8e,
  dragHandleDisabled: n8e,
  index: o8e,
  selected: s8e
}, r8e = {
  $style: i8e
}, sIe = /* @__PURE__ */ we(q2e, [["__cssModules", r8e]]), a8e = ["data-drag-id"], l8e = ["onClick"], d8e = { class: "icon" }, c8e = ["checked", "onClick"], u8e = /* @__PURE__ */ de({
  __name: "SCAFileGallery",
  props: {
    items: {},
    keyExtractor: {},
    iconExtractor: {},
    nameExtractor: {},
    isFolder: {},
    selectedItems: {},
    loading: { type: Boolean, default: !1 },
    busy: { type: Boolean, default: !1 },
    gridHandlers: {},
    lineStyle: { default: null },
    lineClass: { default: "" },
    insideTargetId: { default: null }
  },
  emits: ["update:selected-items", "item-click"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, i = W(null);
    t({ galleryGridEl: i });
    function r(l) {
      const d = o.selectedItems.indexOf(l);
      let c;
      d === -1 ? c = [...o.selectedItems, l] : c = o.selectedItems.filter((u) => u !== l), s("update:selected-items", c);
    }
    function a(l) {
      s("item-click", l);
    }
    return (l, d) => (v(), z(T(L2), {
      loading: e.loading,
      busy: e.busy,
      overlay: "",
      class: x(l.$style.galleryContainer)
    }, {
      default: Q(() => [
        R("div", at({
          ref_key: "galleryGridEl",
          ref: i,
          class: l.$style.galleryGrid
        }, e.gridHandlers), [
          (v(!0), y(Se, null, We(e.items, (c) => (v(), y("div", {
            key: e.keyExtractor(c),
            "data-drag-id": e.keyExtractor(c),
            class: x(l.$style.gallerySlot)
          }, [
            R("div", {
              class: x([
                l.$style.galleryItem,
                { [l.$style.selected]: e.selectedItems.includes(e.keyExtractor(c)) },
                e.insideTargetId === e.keyExtractor(c) && T($a).dropInside
              ]),
              onClick: (u) => a(c)
            }, [
              te(T(Fe), at({ ref_for: !0 }, e.iconExtractor(c), { size: "45px" }), null, 16),
              R("div", d8e, [
                te(T(Ts), {
                  checked: e.selectedItems.includes(e.keyExtractor(c)),
                  class: x(l.$style.checkbox),
                  onClick: Ge((u) => r(e.keyExtractor(c)), ["stop"])
                }, {
                  default: Q(() => [
                    R("input", {
                      type: "checkbox",
                      checked: e.selectedItems.includes(e.keyExtractor(c)),
                      onClick: Ge((u) => r(e.keyExtractor(c)), ["stop"])
                    }, null, 8, c8e)
                  ]),
                  _: 2
                }, 1032, ["checked", "class", "onClick"])
              ]),
              R("div", {
                class: x(l.$style.name)
              }, se(e.nameExtractor(c)), 3)
            ], 10, l8e)
          ], 10, a8e))), 128)),
          e.lineStyle ? (v(), y("div", {
            key: 0,
            class: x(e.lineClass),
            style: Ke(e.lineStyle)
          }, null, 6)) : V("", !0)
        ], 16),
        e.items.length === 0 && !e.loading ? (v(), y("div", {
          key: 0,
          class: x(l.$style.empty)
        }, [
          te(T(ll), {
            title: l.$t("common.emptyState.empty2")
          }, null, 8, ["title"])
        ], 2)) : V("", !0)
      ]),
      _: 1
    }, 8, ["loading", "busy", "class"]));
  }
}), h8e = "_galleryContainer_1sk8v_1", g8e = "_galleryGrid_1sk8v_6", p8e = "_gallerySlot_1sk8v_12", f8e = "_galleryItem_1sk8v_16", m8e = "_selected_1sk8v_29", v8e = "_icon_1sk8v_36", C8e = "_name_1sk8v_41", w8e = "_checkbox_1sk8v_57", y8e = "_empty_1sk8v_63", b8e = {
  galleryContainer: h8e,
  galleryGrid: g8e,
  gallerySlot: p8e,
  galleryItem: f8e,
  selected: m8e,
  icon: v8e,
  name: C8e,
  checkbox: w8e,
  empty: y8e
}, S8e = {
  $style: b8e
}, iIe = /* @__PURE__ */ we(u8e, [["__cssModules", S8e]]), x8e = de({ inheritAttrs: !1 }), R8e = /* @__PURE__ */ de({
  ...x8e,
  __name: "SCAFilterSetItem",
  props: {
    disabled: { type: Boolean, default: !1 },
    isMobile: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    as: { default: "div" }
  },
  emits: ["click", "edit"],
  setup(e, { emit: t }) {
    const n = t8(), o = Es(), s = W(!1), i = t;
    return (r, a) => (v(), y(Se, null, [
      (v(), z(Ot(e.as), at({ id: T(o) }, T(n), {
        tabindex: "0",
        class: [
          r.$style.filterSetItem,
          {
            [r.$style.selected]: e.selected,
            [r.$style.hovered]: s.value,
            [r.$style.mobile]: e.isMobile
          }
        ],
        onClick: a[1] || (a[1] = (l) => i("click", l)),
        onMouseover: a[2] || (a[2] = (l) => s.value = !0),
        onMouseleave: a[3] || (a[3] = (l) => s.value = !1)
      }), {
        default: Q(() => [
          R("div", {
            class: x(r.$style.content)
          }, [
            ve(r.$slots, "default")
          ], 2),
          Tn(R("div", {
            class: x([
              r.$style.editIcon,
              {
                [r.$style.selected]: e.selected,
                [r.$style.hovered]: s.value,
                [r.$style.mobile]: e.isMobile
              }
            ]),
            onClick: a[0] || (a[0] = Ge((l) => i("edit"), ["stop"]))
          }, [
            te(Fe, {
              icon: "phosphor/pencil-simple",
              size: "12px"
            })
          ], 2), [
            [cr, e.editable && (s.value || e.isMobile)]
          ])
        ]),
        _: 3
      }, 16, ["id", "class"])),
      e.tooltip ? (v(), z(zt, {
        key: 0,
        id: T(o),
        text: e.tooltip ?? ""
      }, null, 8, ["id", "text"])) : V("", !0)
    ], 64));
  }
}), E8e = "_filterSetItem_1pyvu_747", A8e = "_content_1pyvu_769", F8e = "_editIcon_1pyvu_775", M8e = "_mobile_1pyvu_794", I8e = "_hovered_1pyvu_806", P8e = "_selected_1pyvu_815", D8e = {
  filterSetItem: E8e,
  content: A8e,
  editIcon: F8e,
  mobile: M8e,
  hovered: I8e,
  selected: P8e
}, T8e = {
  $style: D8e
}, Nl = /* @__PURE__ */ we(R8e, [["__cssModules", T8e]]), k8e = /* @__PURE__ */ de({
  __name: "SCAInlineBanner",
  props: {
    type: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    hasCloseButton: { type: Boolean, default: !1 },
    noIcon: { type: Boolean, default: !1 },
    icon: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = D(() => {
      if (n.icon)
        return n.icon;
      switch (n.type) {
        case "informative":
          return "phosphor/info-fill";
        case "success":
          return "phosphor/check-circle-fill";
        case "warning":
          return "phosphor/warning-fill";
        case "error":
          return "phosphor/warning-diamond-fill";
        default:
          return "phosphor/info-fill";
      }
    });
    return (i, r) => (v(), y("div", {
      class: x([
        i.$style.root,
        {
          [i.$style.typeInformative]: e.type === "informative",
          [i.$style.typeSuccess]: e.type === "success",
          [i.$style.typeWarning]: e.type === "warning",
          [i.$style.typeError]: e.type === "error",
          [i.$style.closeButtonPadding]: e.hasCloseButton
        }
      ])
    }, [
      e.noIcon ? V("", !0) : (v(), z(Fe, {
        key: 0,
        class: x(i.$style.icon),
        icon: s.value
      }, null, 8, ["class", "icon"])),
      R("div", {
        class: x(i.$style.contentContainer)
      }, [
        e.title || e.description ? (v(), y(Se, { key: 0 }, [
          e.title ? (v(), y("div", {
            key: 0,
            class: x(i.$style.title)
          }, se(e.title), 3)) : V("", !0),
          e.description ? (v(), y("div", {
            key: 1,
            class: x(i.$style.description)
          }, se(e.description), 3)) : V("", !0)
        ], 64)) : V("", !0),
        R("div", {
          class: x(i.$style.actionContainer)
        }, [
          i.$slots.default ? ve(i.$slots, "default", { key: 0 }) : V("", !0)
        ], 2)
      ], 2),
      e.hasCloseButton ? (v(), z(ut, {
        key: 1,
        class: x(i.$style.closeButton),
        icon: "phosphor/x",
        type: "ghost",
        appearance: "secondary",
        size: "small",
        onClick: r[0] || (r[0] = (a) => o("close"))
      }, null, 8, ["class"])) : V("", !0)
    ], 2));
  }
}), L8e = "_root_1hc8d_747", B8e = "_closeButtonPadding_1hc8d_766", O8e = "_typeInformative_1hc8d_769", G8e = "_title_1hc8d_774", H8e = "_typeSuccess_1hc8d_777", V8e = "_typeWarning_1hc8d_785", _8e = "_typeError_1hc8d_793", N8e = "_description_1hc8d_812", $8e = "_contentContainer_1hc8d_822", z8e = "_closeButton_1hc8d_766", W8e = "_actionContainer_1hc8d_836", U8e = "_icon_1hc8d_855", K8e = {
  root: L8e,
  closeButtonPadding: B8e,
  typeInformative: O8e,
  title: G8e,
  typeSuccess: H8e,
  typeWarning: V8e,
  typeError: _8e,
  description: N8e,
  contentContainer: $8e,
  closeButton: z8e,
  actionContainer: W8e,
  icon: U8e
}, Z8e = {
  $style: K8e
}, q8e = /* @__PURE__ */ we(k8e, [["__cssModules", Z8e]]), j8e = de({
  name: "SCALogo"
}), rIe = /* @__PURE__ */ de({
  ...j8e,
  props: {
    variant: {}
  },
  setup(e) {
    const t = {
      mark: "generic/scayla-logo",
      wordmark: "generic/scayla-logo-text"
    }, n = e, o = D(() => sg.get(t[n.variant]));
    return (s, i) => (v(), z(Ot(o.value)));
  }
}), Y8e = /* @__PURE__ */ de({
  __name: "SCAOverflowMenuScope",
  props: {
    close: { type: Function }
  },
  setup(e) {
    const t = e;
    return pg(tbe, { close: () => t.close() }), (n, o) => ve(n.$slots, "default");
  }
}), Q8e = ["disabled"], J8e = ["data-text"], X8e = /* @__PURE__ */ de({
  __name: "SCATab",
  props: {
    icon: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    type: { default: "default" },
    dot: { type: Boolean, default: !1 },
    label: { default: void 0 }
  },
  setup(e) {
    const t = rn();
    return (n, o) => (v(), y("button", {
      class: x([
        n.$style.button,
        {
          [n.$style.typeDefault]: e.type === "default",
          [n.$style.typeGhost]: e.type === "ghost",
          [n.$style.selected]: e.selected
        }
      ]),
      type: "button",
      disabled: e.disabled
    }, [
      R("div", {
        class: x(n.$style.container)
      }, [
        e.icon ? (v(), z(Fe, {
          key: 0,
          size: "20px",
          class: x(n.$style.icon),
          icon: e.icon
        }, null, 8, ["class", "icon"])) : V("", !0),
        T(t).default ? (v(), y("div", {
          key: 1,
          class: x(n.$style.lblContainer)
        }, [
          R("span", {
            class: x(n.$style.lblText),
            "data-text": e.label
          }, [
            R("span", {
              class: x(n.$style.lblTextInner)
            }, [
              ve(n.$slots, "default")
            ], 2)
          ], 10, J8e),
          e.dot ? (v(), y("div", {
            key: 0,
            class: x(n.$style.dotContainer)
          }, [
            te(Fe, {
              class: x(n.$style.dotIcon),
              size: "12px",
              icon: "generic/dot"
            }, null, 8, ["class"])
          ], 2)) : V("", !0)
        ], 2)) : V("", !0)
      ], 2)
    ], 10, Q8e));
  }
}), e6e = "_icon_60o83_747", t6e = "_dotIcon_60o83_755", n6e = "_dotContainer_60o83_759", o6e = "_lblContainer_60o83_766", s6e = "_lblText_60o83_770", i6e = "_lblTextInner_60o83_785", r6e = "_container_60o83_789", a6e = "_button_60o83_796", l6e = "_typeDefault_60o83_809", d6e = "_selected_60o83_824", c6e = "_typeGhost_60o83_844", u6e = {
  icon: e6e,
  dotIcon: t6e,
  dotContainer: n6e,
  lblContainer: o6e,
  lblText: s6e,
  lblTextInner: i6e,
  container: r6e,
  button: a6e,
  typeDefault: l6e,
  selected: d6e,
  typeGhost: c6e
}, h6e = {
  $style: u6e
}, g6e = /* @__PURE__ */ we(X8e, [["__cssModules", h6e]]), p6e = /* @__PURE__ */ de({
  __name: "SCATabGroup",
  props: {
    icon: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    alignItemsStretch: { type: Boolean, default: !1 },
    type: { default: "default" },
    noBorder: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x([
        t.$style.tabGroup,
        {
          [t.$style.typeGhost]: e.type === "ghost",
          [t.$style.alignItemsStretch]: e.alignItemsStretch,
          [t.$style.noBorder]: e.noBorder
        }
      ])
    }, [
      ve(t.$slots, "default")
    ], 2));
  }
}), f6e = "_tabGroup_152fv_747", m6e = "_noBorder_152fv_754", v6e = "_alignItemsStretch_152fv_757", C6e = "_typeGhost_152fv_764", w6e = {
  tabGroup: f6e,
  noBorder: m6e,
  alignItemsStretch: v6e,
  typeGhost: C6e
}, y6e = {
  $style: w6e
}, b6e = /* @__PURE__ */ we(p6e, [["__cssModules", y6e]]), S6e = ["data-sca-overflow-index", "data-sca-overflow-grow"], x6e = ["popovertarget", "data-selected"], R6e = ["data-sca-overflow-index"], E6e = /* @__PURE__ */ de({
  __name: "SCAOverflowContainer",
  props: {
    type: { default: void 0 },
    items: { default: () => [] },
    actions: { default: () => [] },
    dropdownActions: { default: () => [] },
    isRecordView: { type: Boolean, default: !1 },
    lessGap: { type: Boolean, default: !1 },
    filterItems: { default: () => [] },
    linkComponent: { default: void 0 },
    observeItems: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = W(!1), o = W(/* @__PURE__ */ new Set()), s = W(/* @__PURE__ */ new Set()), i = W(/* @__PURE__ */ new Set()), r = tn("itemsContainer"), a = D(() => t.items.filter((L, oe) => o.value.has(oe))), l = D(() => t.items.map((L) => ({ ...L, props: L.props }))), d = D(
      () => {
        var L;
        return l.value.length > 0 && ((L = l.value[0]) != null && L.props) && "type" in l.value[0].props ? l.value[0].props.type : "default";
      }
    ), c = D(() => t.dropdownActions), u = D(() => t.actions), h = (L) => (L == null ? void 0 : L.isDropdownTrigger) === !0, g = D(() => !t.actions || s.value.size === 0 ? [] : Array.from(s.value).sort((L, oe) => L - oe).map((L) => {
      var K;
      const oe = (K = t.actions) == null ? void 0 : K[L];
      return oe ? { ...oe, __originalIndex: L } : void 0;
    }).filter((L) => !!L)), p = D(() => {
      var L;
      return (L = a.value) == null ? void 0 : L.some((oe) => {
        var K;
        return ((K = oe == null ? void 0 : oe.props) == null ? void 0 : K.selected) === !0;
      });
    }), f = rn(), m = D(() => {
      var L;
      return (((L = f.default) == null ? void 0 : L.call(f)) ?? []).filter((oe) => oe.type !== Zv);
    }), C = D(() => m.value.length > 0), w = D(() => s.value.size === 0 ? [] : m.value.filter(
      (L, oe) => !S(L) && s.value.has(oe)
    )), b = D(
      () => (t.filterItems ?? []).filter((L, oe) => i.value.has(oe))
    ), A = (L, oe) => "props" in L && L.props && oe in L.props ? !0 : "type" in L && typeof L.type == "object" && "props" in L.type && oe in L.type.props, S = (L) => A(L, "ignore-overflow"), F = (L) => A(L, "overflow-grow"), E = (L) => {
      typeof (L == null ? void 0 : L.onClick) == "function" && L.onClick();
    }, M = (L, oe) => {
      L.to || (oe.preventDefault(), oe.stopPropagation(), E(L));
    }, I = (L) => L.metaKey || L.ctrlKey || L.shiftKey || L.altKey || L.button !== 0, P = (L, oe) => {
      L.href && I(oe) || (oe.preventDefault(), oe.stopPropagation(), E(L));
    }, k = (L) => {
      typeof (L == null ? void 0 : L.onEdit) == "function" && L.onEdit();
    }, B = (L, oe) => {
      const K = L.value;
      return K.size === oe.size && [...oe].every((G) => K.has(G)) ? !1 : (L.value = oe, !0);
    };
    function j() {
      const L = /* @__PURE__ */ new Set(), oe = /* @__PURE__ */ new Set(), K = /* @__PURE__ */ new Set(), G = r.value;
      if (G) {
        const le = G.getBoundingClientRect();
        G.querySelectorAll("[data-sca-overflow-container-item]").forEach((be) => {
          const Me = be.getAttribute("data-sca-overflow-index"), Be = Me !== null ? parseInt(Me, 10) : -1;
          if (Be < 0) return;
          const qe = be.getBoundingClientRect(), he = qe.left - le.left + qe.width, Pe = be.hasAttribute("data-sca-overflow-grow") ? -0.5 : 1;
          if (le.width - he >= Pe) return;
          const J = be.getAttribute("data-sca-overflow-type") ?? "item";
          J === "action" ? oe.add(Be) : J === "filter" ? K.add(Be) : L.add(Be);
        });
      }
      return { items: L, actions: oe, filters: K };
    }
    function N(L) {
      const oe = B(o, L.items), K = B(s, L.actions), G = B(i, L.filters);
      return oe || K || G;
    }
    let re = 0, H;
    const _ = (L) => {
      H = L, !re && (re = requestAnimationFrame(() => {
        re = 0, H && N(H), H = void 0;
      }));
    };
    let ne = 0;
    async function ce() {
      const L = ++ne;
      cancelAnimationFrame(re), re = 0, H = void 0;
      for (let oe = 0; oe < 3; oe++)
        if (!N(j()) || (await Xe(), L !== ne)) return;
    }
    const me = new ResizeObserver(() => _(j()));
    function Ie() {
      var L;
      me.disconnect(), t.observeItems && ((L = r.value) == null || L.querySelectorAll("[data-sca-overflow-container-item]").forEach((oe) => me.observe(oe)));
    }
    return Et(() => {
      Ie(), ce();
    }), Re(
      [() => t.items, () => t.filterItems, () => m.value, () => t.observeItems],
      () => {
        Ie(), ce();
      },
      { flush: "post" }
    ), Hc(r, () => _(j())), io(() => {
      cancelAnimationFrame(re), me.disconnect();
    }), (L, oe) => (v(), y("div", {
      class: x([
        L.$style.root,
        {
          [L.$style.moreGap]: e.isRecordView
        }
      ])
    }, [
      R("div", {
        ref: "itemsContainer",
        class: x([L.$style.items, { [L.$style.filterSetGap]: e.type === "SCAFilterSetItem" }])
      }, [
        e.type === "SCATag" ? (v(!0), y(Se, { key: 0 }, We(e.items, (K, G) => (v(), z(no, at({
          key: `item_${G}`
        }, { ref_for: !0 }, K.props, {
          as: K.to ? t.linkComponent : void 0,
          to: K.to,
          overflow: "visible",
          "data-sca-overflow-container-item": "",
          onClick: (le) => M(K, le)
        }), {
          default: Q(() => [
            Oe(se(K.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "to", "onClick"]))), 128)) : e.type === "SCATab" ? (v(), z(b6e, {
          key: 1,
          class: x({ [L.$style.items]: !0, [L.$style.lessGap]: e.lessGap }),
          type: d.value
        }, {
          default: Q(() => [
            e.isRecordView && u.value.length > 0 ? (v(), y(Se, { key: 0 }, [
              R("div", {
                class: x(L.$style.inner)
              }, [
                (v(!0), y(Se, null, We(u.value, (K, G) => {
                  var le, be;
                  return v(), y(Se, {
                    key: `action_${G}`
                  }, [
                    h(K) ? (v(), z(Yt, {
                      key: `dropdown_action_${G}`,
                      "no-padding": "",
                      class: x({ [L.$style.hidden]: e.isRecordView && s.value.has(G) })
                    }, {
                      trigger: Q(({ target: Me }) => [
                        te(ut, {
                          size: "xsmall",
                          appearance: "secondary",
                          icon: "phosphor/dots-three",
                          title: L.$t("common.label.options"),
                          popovertarget: Me,
                          "data-sca-overflow-container-item": "",
                          "data-sca-overflow-index": G,
                          "data-sca-overflow-type": "action"
                        }, null, 8, ["title", "popovertarget", "data-sca-overflow-index"])
                      ]),
                      default: Q(({ popover: Me }) => [
                        (v(!0), y(Se, null, We(c.value, (Be, qe) => {
                          var he;
                          return v(), z(Zt, at({
                            key: `dr_action_${qe}`
                          }, { ref_for: !0 }, Be.props, {
                            class: L.$style.action,
                            disabled: ((he = Be == null ? void 0 : Be.props) == null ? void 0 : he.disabled) ?? !1,
                            onClick: Ge((Pe) => {
                              E(Be), Me == null || Me.hidePopover();
                            }, ["prevent", "stop"])
                          }), {
                            default: Q(() => [
                              Oe(se(Be.label), 1)
                            ]),
                            _: 2
                          }, 1040, ["class", "disabled", "onClick"]);
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class"])) : (v(), z(ut, at({
                      key: `action_${G}`,
                      size: "small",
                      appearance: "secondary",
                      class: { [L.$style.hidden]: e.isRecordView && s.value.has(G) }
                    }, { ref_for: !0 }, K.props, {
                      icon: (le = K == null ? void 0 : K.props) == null ? void 0 : le.icon,
                      disabled: ((be = K == null ? void 0 : K.props) == null ? void 0 : be.disabled) ?? !1,
                      "data-sca-overflow-container-item": "",
                      "data-sca-overflow-index": G,
                      "data-sca-overflow-type": "action",
                      onClick: Ge((Me) => E(K), ["prevent", "stop"])
                    }), null, 16, ["class", "icon", "disabled", "data-sca-overflow-index", "onClick"]))
                  ], 64);
                }), 128))
              ], 2),
              te(ba, {
                direction: "vertical",
                class: "mx-component-gap-2xSmall"
              })
            ], 64)) : V("", !0),
            (v(!0), y(Se, null, We(l.value, (K, G) => (v(), z(g6e, at({
              key: `item_${G}`
            }, { ref_for: !0 }, K.props, {
              label: K.label,
              class: { [L.$style.hidden]: e.isRecordView && o.value.has(G) },
              "data-sca-overflow-container-item": "",
              "data-sca-overflow-index": G,
              "data-sca-overflow-type": "item",
              onClick: Ge((le) => E(K), ["prevent", "stop"])
            }), {
              default: Q(() => [
                R("span", {
                  class: x(L.$style.labelWithCount)
                }, [
                  Oe(se(K.label) + " ", 1),
                  e.isRecordView && K.count ? (v(), y("span", {
                    key: 0,
                    class: x(L.$style.count)
                  }, se(K.count), 3)) : V("", !0)
                ], 2)
              ]),
              _: 2
            }, 1040, ["label", "class", "data-sca-overflow-index", "onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["class", "type"])) : C.value && m.value.length > 0 ? (v(!0), y(Se, { key: 2 }, We(m.value, (K, G) => (v(), y(Se, {
          key: `slot_${G}`
        }, [
          K.type === ba ? (v(), z(Ot(K), { key: 0 })) : (v(), y("div", {
            key: 1,
            "data-sca-overflow-container-item": "",
            "data-sca-overflow-index": S(K) ? void 0 : G,
            "data-sca-overflow-type": "action",
            "data-sca-overflow-grow": F(K) || void 0,
            class: x({ [L.$style.hidden]: s.value.has(G), [L.$style.grow]: F(K) })
          }, [
            (v(), z(Ot(K)))
          ], 10, S6e))
        ], 64))), 128)) : e.type === "SCAFilterSetItem" ? (v(!0), y(Se, { key: 3 }, We(e.items, (K, G) => (v(), z(Nl, at({
          key: `item_${G}`
        }, { ref_for: !0 }, K.props, {
          as: K.href ? "a" : void 0,
          href: K.href,
          class: { [L.$style.hidden]: o.value.has(G) },
          "data-sca-overflow-container-item": "",
          "data-sca-overflow-index": G,
          "data-sca-overflow-type": "item",
          onClick: (le) => P(K, le),
          onEdit: (le) => k(K)
        }), {
          default: Q(() => [
            Oe(se(K.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "href", "class", "data-sca-overflow-index", "onClick", "onEdit"]))), 128)) : V("", !0),
        (v(!0), y(Se, null, We(t.filterItems ?? [], (K, G) => (v(), z(Nl, at({
          key: `filterItem_${G}`
        }, { ref_for: !0 }, K.props, {
          as: K.href ? "a" : void 0,
          href: K.href,
          class: [L.$style.filterItem, { [L.$style.hidden]: i.value.has(G) }],
          "data-sca-overflow-container-item": "",
          "data-sca-overflow-index": G,
          "data-sca-overflow-type": "filter",
          onClick: (le) => P(K, le),
          onEdit: (le) => k(K)
        }), {
          default: Q(() => [
            Oe(se(K.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "href", "class", "data-sca-overflow-index", "onClick", "onEdit"]))), 128))
      ], 2),
      a.value && a.value.length > 0 || w.value.length > 0 || b.value.length > 0 ? (v(), z(Yt, {
        key: 0,
        "is-open": n.value,
        "onUpdate:isOpen": oe[1] || (oe[1] = (K) => n.value = K),
        "no-padding": ""
      }, {
        trigger: Q(({ target: K }) => [
          R("button", {
            type: "button",
            popovertarget: K,
            class: x([L.$style.trigger, { [L.$style.recordTrigger]: e.isRecordView || C.value }]),
            "data-selected": p.value,
            onClick: oe[0] || (oe[0] = Ge(() => {
            }, ["stop"]))
          }, [
            te(Fe, { icon: "phosphor/dots-three" })
          ], 10, x6e)
        ]),
        default: Q(({ popover: K }) => [
          R("div", {
            class: x([L.$style.hiddenItems, { [L.$style.hiddenItemsSlots]: C.value }])
          }, [
            e.type === "SCAFilterSetItem" ? (v(!0), y(Se, { key: 0 }, We(a.value, (G, le) => {
              var be, Me;
              return v(), y("div", {
                key: `hiddenItem_${le}`,
                class: "flex items-center gap-component-padding-xSmall"
              }, [
                te(Nl, at({ ref_for: !0 }, G.props, {
                  as: G.href ? "a" : void 0,
                  href: G.href,
                  selected: ((be = G == null ? void 0 : G.props) == null ? void 0 : be.selected) ?? !1,
                  disabled: ((Me = G == null ? void 0 : G.props) == null ? void 0 : Me.disabled) ?? !1,
                  onClick: (Be) => P(G, Be),
                  onEdit: (Be) => k(G)
                }), {
                  default: Q(() => [
                    Oe(se(G.label), 1)
                  ]),
                  _: 2
                }, 1040, ["as", "href", "selected", "disabled", "onClick", "onEdit"])
              ]);
            }), 128)) : C.value ? (v(), y(Se, { key: 1 }, [
              (v(!0), y(Se, null, We(w.value, (G, le) => (v(), y("div", {
                key: `overflow_slot_${le}`,
                "data-sca-overflow-container-item": "",
                "data-sca-overflow-index": le,
                "data-sca-overflow-type": "action"
              }, [
                te(Y8e, {
                  close: () => K == null ? void 0 : K.hidePopover()
                }, {
                  default: Q(() => [
                    (v(), z(Ot(G)))
                  ]),
                  _: 2
                }, 1032, ["close"])
              ], 8, R6e))), 128)),
              b.value.length > 0 ? (v(), y("div", {
                key: 0,
                class: x([L.$style.hiddenFilterItems, { [L.$style.hiddenFilterItemsBorder]: w.value.length > 0 }])
              }, [
                (v(!0), y(Se, null, We(b.value, (G, le) => {
                  var be, Me;
                  return v(), y("div", {
                    key: `hiddenFilter_${le}`,
                    class: x(L.$style.hiddenFilterItem)
                  }, [
                    te(Nl, at({ ref_for: !0 }, G.props, {
                      as: G.href ? "a" : void 0,
                      href: G.href,
                      selected: ((be = G == null ? void 0 : G.props) == null ? void 0 : be.selected) ?? !1,
                      disabled: ((Me = G == null ? void 0 : G.props) == null ? void 0 : Me.disabled) ?? !1,
                      onClick: (Be) => P(G, Be),
                      onEdit: (Be) => k(G)
                    }), {
                      default: Q(() => [
                        Oe(se(G.label), 1)
                      ]),
                      _: 2
                    }, 1040, ["as", "href", "selected", "disabled", "onClick", "onEdit"])
                  ], 2);
                }), 128))
              ], 2)) : V("", !0)
            ], 64)) : (v(), y(Se, { key: 2 }, [
              e.isRecordView && g.value.length > 0 ? (v(), y(Se, { key: 0 }, [
                R("div", {
                  class: x([L.$style.inner, { [L.$style.hide]: g.value.length === 0 }])
                }, [
                  (v(!0), y(Se, null, We(g.value, (G, le) => {
                    var be, Me;
                    return v(), y(Se, {
                      key: `hidden_action_${le}`
                    }, [
                      h(G) ? (v(), z(Yt, {
                        key: 1,
                        "no-padding": ""
                      }, {
                        trigger: Q(({ target: Be }) => [
                          te(ut, {
                            size: "xsmall",
                            appearance: "secondary",
                            icon: "phosphor/dots-three",
                            title: L.$t("common.label.options"),
                            popovertarget: Be,
                            "data-sca-overflow-container-item": "",
                            "data-sca-overflow-index": G.__originalIndex ?? le,
                            "data-sca-overflow-type": "action"
                          }, null, 8, ["title", "popovertarget", "data-sca-overflow-index"])
                        ]),
                        default: Q(({ popover: Be }) => [
                          (v(!0), y(Se, null, We(c.value, (qe, he) => {
                            var Pe;
                            return v(), z(Zt, at({
                              key: `hidden_dr_action_${he}`
                            }, { ref_for: !0 }, qe.props, {
                              class: L.$style.action,
                              disabled: ((Pe = qe == null ? void 0 : qe.props) == null ? void 0 : Pe.disabled) ?? !1,
                              onClick: Ge((J) => {
                                E(qe), Be == null || Be.hidePopover(), K == null || K.hidePopover();
                              }, ["prevent", "stop"])
                            }), {
                              default: Q(() => [
                                Oe(se(qe.label), 1)
                              ]),
                              _: 2
                            }, 1040, ["class", "disabled", "onClick"]);
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)) : (v(), z(ut, at({
                        key: 0,
                        size: "small",
                        appearance: "secondary"
                      }, { ref_for: !0 }, G.props, {
                        icon: (be = G == null ? void 0 : G.props) == null ? void 0 : be.icon,
                        disabled: ((Me = G == null ? void 0 : G.props) == null ? void 0 : Me.disabled) ?? !1,
                        "data-sca-overflow-container-item": "",
                        "data-sca-overflow-index": G.__originalIndex ?? le,
                        "data-sca-overflow-type": "action",
                        onClick: Ge((Be) => {
                          E(G), K == null || K.hidePopover();
                        }, ["prevent", "stop"])
                      }), null, 16, ["icon", "disabled", "data-sca-overflow-index", "onClick"]))
                    ], 64);
                  }), 128))
                ], 2),
                te(ba, {
                  class: x([L.$style.divider, u.value.length === 0 && L.$style.hide]),
                  appearance: "border"
                }, null, 8, ["class"])
              ], 64)) : V("", !0),
              (v(!0), y(Se, null, We(a.value, (G, le) => {
                var be, Me, Be;
                return v(), z(Zt, {
                  key: `hiddenItem_${le}`,
                  size: "small",
                  intent: "none",
                  appearance: "secondary",
                  type: "ghost",
                  class: x({
                    [L.$style.hiddenItemButton]: e.isRecordView,
                    [L.$style.selected]: e.isRecordView && ((be = G == null ? void 0 : G.props) == null ? void 0 : be.selected)
                  }),
                  selected: ((Me = G == null ? void 0 : G.props) == null ? void 0 : Me.selected) ?? !1,
                  disabled: ((Be = G == null ? void 0 : G.props) == null ? void 0 : Be.disabled) ?? !1,
                  onClick: Ge((qe) => {
                    E(G), K == null || K.hidePopover();
                  }, ["prevent", "stop"])
                }, {
                  default: Q(() => [
                    R("span", {
                      class: x(L.$style.labelWithCount)
                    }, [
                      Oe(se(G.label) + " ", 1),
                      e.isRecordView && G.count ? (v(), y("span", {
                        key: 0,
                        class: x(L.$style.count)
                      }, se(G.count), 3)) : V("", !0)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["class", "selected", "disabled", "onClick"]);
              }), 128))
            ], 64))
          ], 2)
        ]),
        _: 1
      }, 8, ["is-open"])) : V("", !0)
    ], 2));
  }
}), A6e = "_root_rlp20_1", F6e = "_moreGap_rlp20_9", M6e = "_items_rlp20_13", I6e = "_filterSetGap_rlp20_25", P6e = "_lessGap_rlp20_29", D6e = "_labelWithCount_rlp20_33", T6e = "_count_rlp20_39", k6e = "_hiddenItems_rlp20_44", L6e = "_hiddenItemsSlots_rlp20_52", B6e = "_filterItem_rlp20_60", O6e = "_hiddenFilterItems_rlp20_64", G6e = "_hiddenFilterItemsBorder_rlp20_74", H6e = "_hiddenFilterItem_rlp20_64", V6e = "_hiddenItemButton_rlp20_85", _6e = "_selected_rlp20_90", N6e = "_trigger_rlp20_95", $6e = "_recordTrigger_rlp20_123", z6e = "_grow_rlp20_134", W6e = "_hidden_rlp20_44", U6e = "_divider_rlp20_145", K6e = "_action_rlp20_150", Z6e = "_inner_rlp20_161", q6e = "_hide_rlp20_167", j6e = {
  root: A6e,
  moreGap: F6e,
  items: M6e,
  filterSetGap: I6e,
  lessGap: P6e,
  labelWithCount: D6e,
  count: T6e,
  hiddenItems: k6e,
  hiddenItemsSlots: L6e,
  filterItem: B6e,
  hiddenFilterItems: O6e,
  hiddenFilterItemsBorder: G6e,
  hiddenFilterItem: H6e,
  hiddenItemButton: V6e,
  selected: _6e,
  trigger: N6e,
  recordTrigger: $6e,
  grow: z6e,
  hidden: W6e,
  divider: U6e,
  action: K6e,
  inner: Z6e,
  hide: q6e
}, Y6e = {
  $style: j6e
}, aIe = /* @__PURE__ */ we(E6e, [["__cssModules", Y6e]]), Q6e = ["title"], J6e = /* @__PURE__ */ de({
  __name: "SCAPagination",
  props: {
    currentIdx: { default: 0 },
    numOfPages: { default: void 0 },
    pageMaxItems: { default: 25 },
    childItemCount: { default: 0 },
    paginationOptions: { default: () => [25, 50, 100, 200] },
    maxItems: {},
    maxItemsTotal: { default: 0 }
  },
  emits: ["update:currentIdx", "update:pageMaxItems"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Bn(n, "currentIdx", void 0, { passive: !0 }), i = Bn(n, "pageMaxItems", o, { passive: !0 }), r = (c) => {
      let u = Math.max(0, c);
      n.numOfPages != null && (u = Math.min(u, n.numOfPages)), s.value = u;
    }, a = D(
      () => n.paginationOptions.map((c) => ({ id: c, label: c.toString() }))
    ), l = D(() => s.value * i.value), d = D(() => n.maxItems === void 0 ? s.value * i.value + i.value : n.maxItems ? Math.min(n.maxItems, s.value * i.value + i.value) : s.value);
    return Et(() => {
      var c;
      i.value = ((c = a.value.find((u) => u.id === n.pageMaxItems)) == null ? void 0 : c.id) ?? a.value[0].id;
    }), (c, u) => (v(), y("div", {
      class: x(c.$style.container)
    }, [
      R("div", {
        class: x(c.$style.pagination)
      }, [
        te(ut, {
          disabled: T(s) === 0,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "phosphor/arrow-line-left",
          onClick: u[0] || (u[0] = (h) => r(0))
        }, null, 8, ["disabled"]),
        te(ut, {
          disabled: T(s) === 0,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "phosphor/caret-left",
          onClick: u[1] || (u[1] = (h) => r((T(s) ?? 0) - 1))
        }, null, 8, ["disabled"]),
        c.$slots.summary ? (v(), y("span", {
          key: 0,
          class: x(c.$style.text),
          "test-id": "pagination-summary"
        }, [
          ve(c.$slots, "summary", {
            from: l.value,
            to: d.value
          })
        ], 2)) : e.maxItemsTotal ? (v(), y("span", {
          key: 1,
          class: x([c.$style.text, c.$style.help]),
          title: c.$t("common.label.valuesBracketsRepresent")
        }, [
          Oe(se(l.value) + " - " + se(d.value) + " ", 1),
          e.childItemCount > 0 ? (v(), y(Se, { key: 0 }, [
            Oe(" (+" + se(e.childItemCount) + ") ", 1)
          ], 64)) : V("", !0),
          n.maxItems !== void 0 ? (v(), y(Se, { key: 1 }, [
            n.maxItems < n.maxItemsTotal ? (v(), y(Se, { key: 0 }, [
              Oe(se(c.$t("common.label.paramParamResults", { max: n.maxItems, maxTotal: n.maxItemsTotal })), 1)
            ], 64)) : (v(), y(Se, { key: 1 }, [
              Oe(se(c.$t("common.label.paramResults", { max: n.maxItems })), 1)
            ], 64))
          ], 64)) : V("", !0)
        ], 10, Q6e)) : (v(), y("span", {
          key: 2,
          class: x(c.$style.text)
        }, [
          Oe(se(l.value) + " - " + se(d.value) + " ", 1),
          n.maxItems !== void 0 ? (v(), y(Se, { key: 0 }, [
            Oe(se(c.$t("common.label.paramResults", { max: n.maxItems })), 1)
          ], 64)) : V("", !0)
        ], 2)),
        te(ut, {
          disabled: T(s) === void 0 || e.numOfPages !== void 0 && T(s) >= e.numOfPages - 1,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "phosphor/caret-right",
          "test-id": "pagination-next",
          onClick: u[2] || (u[2] = (h) => r((T(s) ?? 0) + 1))
        }, null, 8, ["disabled"]),
        te(ut, {
          disabled: T(s) === void 0 || e.numOfPages === void 0 || T(s) >= e.numOfPages - 1,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "phosphor/arrow-line-right",
          onClick: u[3] || (u[3] = (h) => r(e.numOfPages - 1))
        }, null, 8, ["disabled"])
      ], 2),
      te(p2, {
        modelValue: T(i),
        "onUpdate:modelValue": u[4] || (u[4] = (h) => Yo(i) ? i.value = h : null),
        items: a.value,
        search: "client",
        "label-position": "hidden",
        "test-id": "pagination-page-size"
      }, {
        triggerContent: Q(() => [
          R("div", {
            class: x(c.$style.paginationSelection)
          }, [
            Oe(se(T(i)) + " ", 1),
            te(Fe, {
              icon: "phosphor/caret-down",
              class: x(c.$style.iconColor),
              size: "16px"
            }, null, 8, ["class"])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue", "items"])
    ], 2));
  }
}), X6e = "_pagination_1pdo4_1", exe = "_text_1pdo4_6", txe = "_pageBtn_1pdo4_16", nxe = "_pageGroup_1pdo4_19", oxe = "_help_1pdo4_24", sxe = "_container_1pdo4_28", ixe = "_paginationSelection_1pdo4_37", rxe = "_iconColor_1pdo4_46", axe = {
  pagination: X6e,
  text: exe,
  pageBtn: txe,
  pageGroup: nxe,
  help: oxe,
  container: sxe,
  paginationSelection: ixe,
  iconColor: rxe
}, lxe = {
  $style: axe
}, lIe = /* @__PURE__ */ we(J6e, [["__cssModules", lxe]]), dxe = { key: 0 }, cxe = { key: 1 }, uxe = /* @__PURE__ */ de({
  __name: "SCAPill",
  props: {
    type: { default: "boolean" },
    selected: { type: Boolean, default: !1 },
    appearance: { default: "default" },
    icon: { default: void 0 },
    avatar: { type: Boolean, default: !1 },
    label: {},
    value: { default: void 0 },
    prefix: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, s) => (v(), y("label", {
      class: x([
        o.$style.main,
        {
          [o.$style.inverted]: e.appearance === "inverted",
          [o.$style.selectable]: e.type === "selectable",
          [o.$style.selected]: e.selected,
          [o.$style.avatar]: e.avatar,
          [o.$style.disabled]: e.disabled,
          [o.$style.hasPrefix]: e.prefix
        }
      ]),
      onClick: s[0] || (s[0] = (i) => n("click"))
    }, [
      e.selected && e.type === "boolean" ? (v(), z(Fe, {
        key: 0,
        icon: "phosphor/check",
        class: x(o.$style.checkbox)
      }, null, 8, ["class"])) : V("", !0),
      e.icon ? (v(), z(Fe, {
        key: 1,
        class: x(o.$style.icon),
        icon: e.icon
      }, null, 8, ["class", "icon"])) : V("", !0),
      R("div", {
        class: x(o.$style.contentDiv)
      }, [
        e.prefix ? (v(), y("span", {
          key: 0,
          class: x(o.$style.prefix)
        }, se(e.prefix), 3)) : V("", !0),
        e.avatar ? (v(), z(Li, {
          key: 1,
          size: "xsmall"
        })) : V("", !0),
        R("div", {
          class: x(o.$style.iconDiv)
        }, [
          e.value ? V("", !0) : (v(), y("span", dxe, se(e.label), 1)),
          e.value ? (v(), y("span", cxe, se(e.value), 1)) : V("", !0),
          e.type === "selectable" ? (v(), z(Fe, {
            key: 2,
            icon: e.value ? "phosphor/x" : "phosphor/caret-down"
          }, null, 8, ["icon"])) : V("", !0)
        ], 2)
      ], 2)
    ], 2));
  }
}), hxe = "_contentDiv_32390_747", gxe = "_iconDiv_32390_754", pxe = "_prefix_32390_760", fxe = "_main_32390_764", mxe = "_avatar_32390_780", vxe = "_hasPrefix_32390_780", Cxe = "_disabled_32390_783", wxe = "_inverted_32390_795", yxe = "_selected_32390_809", bxe = "_selectable_32390_824", Sxe = {
  contentDiv: hxe,
  iconDiv: gxe,
  prefix: pxe,
  main: fxe,
  avatar: mxe,
  hasPrefix: vxe,
  disabled: Cxe,
  inverted: wxe,
  selected: yxe,
  selectable: bxe
}, xxe = {
  $style: Sxe
}, dIe = /* @__PURE__ */ we(uxe, [["__cssModules", xxe]]), Rxe = ["aria-valuenow"], Exe = /* @__PURE__ */ de({
  __name: "SCAProgressBar",
  props: {
    value: { default: 0 },
    alert: { type: Boolean, default: !1 },
    appearance: { default: "default" }
  },
  setup(e) {
    const t = e, n = D(() => Math.min(100, Math.max(0, Math.round(t.value))));
    return (o, s) => (v(), y("div", {
      class: x([o.$style.track, { [o.$style.inverted]: e.appearance === "inverted" }]),
      role: "progressbar",
      "aria-valuenow": n.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      R("div", {
        class: x([o.$style.fill, { [o.$style.alert]: e.alert }]),
        style: Ke({ width: `${n.value}%` })
      }, null, 6)
    ], 10, Rxe));
  }
}), Axe = "_track_6gzs7_1", Fxe = "_inverted_6gzs7_8", Mxe = "_fill_6gzs7_12", Ixe = "_alert_6gzs7_18", Pxe = {
  track: Axe,
  inverted: Fxe,
  fill: Mxe,
  alert: Ixe
}, Dxe = {
  $style: Pxe
}, cIe = /* @__PURE__ */ we(Exe, [["__cssModules", Dxe]]), Txe = /* @__PURE__ */ de({
  __name: "SCARadioButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    noGap: { type: Boolean, default: !1 },
    noPadding: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (v(), y("label", null, [
      R("div", {
        class: x([t.$style.grid, { [t.$style.noGap]: e.noGap }])
      }, [
        te(QS, {
          checked: e.checked,
          disabled: e.disabled,
          alert: e.alert,
          class: x(t.$style.radio)
        }, {
          default: Q(() => [
            ve(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["checked", "disabled", "alert", "class"]),
        R("span", {
          class: x([{ [t.$style.required]: e.required }])
        }, se(e.label), 3)
      ], 2),
      e.helperText ? (v(), z(Gr, {
        key: 0,
        intent: e.alert ? "alert" : void 0,
        class: x([t.$style.helperText, { [t.$style.noPadding]: e.noPadding }])
      }, {
        default: Q(() => [
          Oe(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["intent", "class"])) : V("", !0)
    ]));
  }
}), kxe = "_grid_dcy3i_747", Lxe = "_noGap_dcy3i_761", Bxe = "_helperText_dcy3i_765", Oxe = "_noPadding_dcy3i_769", Gxe = "_disabled_dcy3i_773", Hxe = {
  grid: kxe,
  noGap: Lxe,
  helperText: Bxe,
  noPadding: Oxe,
  disabled: Gxe
}, Vxe = {
  $style: Hxe
}, uIe = /* @__PURE__ */ we(Txe, [["__cssModules", Vxe]]), _xe = /* @__PURE__ */ de({
  __name: "SCARadioButtonGroup",
  props: {
    columns: { default: void 0 },
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    optionalLabelText: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    rowGap: { default: "0" }
  },
  setup(e) {
    Ls((s) => ({
      v197a7040: o.value,
      v6d2d08e9: n.value
    }));
    const t = e, n = D(() => t.columns ?? 1), o = D(() => t.rowGap);
    return (s, i) => (v(), z(zc, {
      label: e.label,
      "label-position": e.labelPosition,
      "optional-label-text": e.optionalLabelText,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor
    }, {
      default: Q(() => [
        R("div", {
          class: x([s.$style.radioGrid, { [s.$style.columns]: e.columns }])
        }, [
          ve(s.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["label", "label-position", "optional-label-text", "appearance", "helper-text", "validation-error", "required", "html-for"]));
  }
}), Nxe = "_radioGrid_13nlw_747", $xe = "_columns_13nlw_753", zxe = {
  radioGrid: Nxe,
  columns: $xe
}, Wxe = {
  $style: zxe
}, hIe = /* @__PURE__ */ we(_xe, [["__cssModules", Wxe]]), Uxe = ["id"], Kxe = { key: 0 }, Zxe = de({
  inheritAttrs: !1
}), qxe = /* @__PURE__ */ de({
  ...Zxe,
  __name: "SCASidebarNavigationItem",
  props: {
    label: {},
    expandable: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    as: { default: "button" },
    level: { default: 0 },
    favorite: { type: Boolean, default: !1 },
    isMini: { type: Boolean, default: !1 }
  },
  emits: ["update:expanded"],
  setup(e, { emit: t }) {
    const n = n8(), o = e, s = t, i = rn(), r = Es(), a = D(() => !!i.default), l = D(() => !!i.actions), d = W(null), c = al(d), u = W(null), h = W(!1), g = FS("(hover: hover)"), p = D(() => navigator.maxTouchPoints > 0), f = D(() => h.value ? !0 : p.value && o.isActive);
    function m() {
      o.disabled || g.value && (h.value = !0);
    }
    function C() {
      g.value && (h.value = !1);
    }
    const w = Bn(o, "expanded", s, { passive: !0 }), b = D(() => [
      n.sidebarNavItem,
      {
        [n.selected]: o.selected,
        [n.disabled]: o.disabled,
        [n.nested]: o.level > 0,
        [n.isExpanded]: w.value,
        [n.isExpandable]: o.expandable
      }
    ]), A = D(() => [
      n.inner,
      {
        [n.nested]: o.level > 0,
        [n.isExpandable]: o.expandable
      }
    ]), S = D(() => [n.expander, { [n.isExpanded]: w.value }]), F = D(() => [n.children, { [n.hasIcon]: !!o.icon }]), E = D(() => ({
      "--indent-level": o.level,
      "--initial-padding": o.isMini ? "16px" : "40px",
      "--min-height": o.isMini ? "24px" : "32px"
    })), M = () => {
      w.value = !w.value;
    }, I = () => {
      o.expandable && (o.selected ? w.value = !0 : M());
    }, P = W(null), k = W(null), B = W(!1), j = W(!1);
    function N() {
      j.value = !0, !(o.disabled || !l.value) && (k.value = Date.now(), B.value = !1, P.value = setTimeout(() => {
        B.value || (h.value = !0);
      }, 500));
    }
    function re() {
      B.value = !0, P.value && clearTimeout(P.value);
    }
    function H(ce) {
      P.value && clearTimeout(P.value), k.value && Date.now() - k.value >= 500 && !B.value && ce.cancelable && ce.preventDefault(), k.value = null, B.value = !1, j.value = !1;
    }
    function _(ce) {
      j.value && ce.preventDefault();
    }
    const ne = (ce) => {
      u.value && !u.value.contains(ce.target) && (h.value = !1);
    };
    return Re(h, (ce) => {
      ce ? Xe(() => {
        document.addEventListener("touchstart", ne, { capture: !0, passive: !0 });
      }) : document.removeEventListener("touchstart", ne, { capture: !0 });
    }), ks(() => {
      document.removeEventListener("touchstart", ne, { capture: !0 });
    }), (ce, me) => (v(), y("div", null, [
      R("div", {
        ref_key: "itemRef",
        ref: u,
        class: x(b.value),
        style: Ke(E.value),
        onClick: I,
        onMouseenter: m,
        onMouseleave: C,
        onTouchstartPassive: N,
        onTouchmovePassive: re,
        onTouchend: H,
        onContextmenu: _
      }, [
        (v(), z(Ot(e.as), at(ce.$attrs, { class: A.value }), {
          default: Q(() => [
            R("span", {
              class: x(ce.$style.expanderContainer)
            }, [
              e.expandable ? (v(), z(Fe, {
                key: 0,
                icon: "phosphor/caret-right",
                size: "12px",
                class: x([...S.value, { [ce.$style.iconActive]: o.isActive }]),
                onClick: Ge(M, ["stop", "prevent"])
              }, null, 8, ["class"])) : V("", !0)
            ], 2),
            e.icon ? (v(), z(Fe, {
              key: 0,
              icon: e.icon,
              class: x([ce.$style.icon, { [ce.$style.iconActive]: o.isActive }]),
              size: "20px"
            }, null, 8, ["icon", "class"])) : V("", !0),
            R("div", {
              id: T(r),
              ref_key: "labelRef",
              ref: d,
              class: x(ce.$style.label)
            }, [
              typeof e.label == "string" ? (v(), y(Se, { key: 0 }, [
                Oe(se(e.label), 1)
              ], 64)) : (v(!0), y(Se, { key: 1 }, We(e.label, (Ie, L) => (v(), y(Se, { key: L }, [
                typeof Ie == "object" ? (v(), y("span", Kxe, se(Ie.highlight), 1)) : (v(), y(Se, { key: 1 }, [
                  Oe(se(Ie), 1)
                ], 64))
              ], 64))), 128)),
              T(c) ? (v(), z(zt, {
                key: 2,
                id: T(r),
                text: typeof e.label == "string" ? e.label : Array.isArray(e.label) ? e.label.map((Ie) => typeof Ie == "object" ? Ie.highlight : Ie).join("") : ""
              }, null, 8, ["id", "text"])) : V("", !0)
            ], 10, Uxe),
            l.value && f.value ? (v(), z(Yt, {
              key: 1,
              class: x(ce.$style.actions),
              "less-border": "",
              onClosed: me[0] || (me[0] = (Ie) => h.value = !1)
            }, {
              trigger: Q(({ target: Ie, togglePopover: L }) => [
                te(ut, {
                  type: "ghost",
                  icon: "phosphor/dots-three",
                  size: "small",
                  class: x(ce.$style.actionButton),
                  popovertarget: Ie,
                  onClick: Ge(L, ["prevent", "stop"])
                }, null, 8, ["class", "popovertarget", "onClick"])
              ]),
              default: Q(() => [
                R("div", {
                  class: x(ce.$style.actionButtons)
                }, [
                  ve(ce.$slots, "actions", {}, () => [
                    me[1] || (me[1] = Oe("No actions", -1))
                  ])
                ], 2)
              ]),
              _: 3
            }, 8, ["class"])) : V("", !0)
          ]),
          _: 3
        }, 16, ["class"]))
      ], 38),
      a.value ? Tn((v(), y("div", {
        key: 0,
        class: x(F.value)
      }, [
        ve(ce.$slots, "default")
      ], 2)), [
        [cr, T(w)]
      ]) : V("", !0)
    ]));
  }
}), jxe = "_sidebarNavItem_aar5p_747", Yxe = "_isExpanded_aar5p_754", Qxe = "_nested_aar5p_754", Jxe = "_children_aar5p_754", Xxe = "_inner_aar5p_754", eRe = "_disabled_aar5p_758", tRe = "_selected_aar5p_758", nRe = "_isExpandable_aar5p_770", oRe = "_label_aar5p_776", sRe = "_icon_aar5p_793", iRe = "_iconActive_aar5p_798", rRe = "_expander_aar5p_799", aRe = "_actionButton_aar5p_831", lRe = "_expanderContainer_aar5p_846", dRe = "_actionButtons_aar5p_884", cRe = "_favoriteIcon_aar5p_890", uRe = {
  sidebarNavItem: jxe,
  isExpanded: Yxe,
  nested: Qxe,
  children: Jxe,
  inner: Xxe,
  disabled: eRe,
  selected: tRe,
  isExpandable: nRe,
  label: oRe,
  icon: sRe,
  iconActive: iRe,
  expander: rRe,
  actionButton: aRe,
  expanderContainer: lRe,
  actionButtons: dRe,
  favoriteIcon: cRe
}, hRe = {
  $style: uRe
}, gIe = /* @__PURE__ */ we(qxe, [["__cssModules", hRe]]), gRe = /* @__PURE__ */ de({
  __name: "SCAStateBox",
  props: {
    overlay: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    overflow: { type: Boolean, default: !0 },
    loadingDebounce: { default: 0 },
    busy: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = LU(xS(t, "loading"), t.loadingDebounce), o = D(() => t.loading && n.value), s = D(() => t.hasError ? !1 : t.overlay && t.loading), i = D(() => !t.hasError && (!o.value || s.value)), r = D(() => t.hasError || o.value);
    return (a, l) => (v(), y("div", {
      class: x([a.$style.stateBox, { [a.$style.noOverflow]: !e.overflow }])
    }, [
      r.value ? (v(), y("div", {
        key: 0,
        class: x([{ [a.$style.overlay]: s.value }, "d-flex align-items-center justify-content-center p-4"])
      }, [
        e.hasError ? (v(), z(q8e, {
          key: 0,
          type: "error",
          title: a.$t("common.message.errorError2"),
          description: a.$t("common.message.componentLoadError")
        }, {
          default: Q(() => [
            a.$slots.action ? ve(a.$slots, "action", { key: 0 }) : V("", !0)
          ]),
          _: 3
        }, 8, ["title", "description"])) : o.value ? (v(), z(rl, {
          key: 1,
          class: x(a.$style.loader)
        }, null, 8, ["class"])) : V("", !0)
      ], 2)) : V("", !0),
      i.value ? ve(a.$slots, "default", { key: 1 }) : V("", !0),
      e.busy ? (v(), y("div", {
        key: 2,
        class: x(a.$style.busyOverlay),
        "test-id": "state-box-busy-overlay"
      }, null, 2)) : V("", !0)
    ], 2));
  }
}), pRe = "_stateBox_1nnvu_1", fRe = "_noOverflow_1nnvu_6", mRe = "_overlay_1nnvu_9", vRe = "_loader_1nnvu_19", CRe = "_busyOverlay_1nnvu_24", wRe = {
  stateBox: pRe,
  noOverflow: fRe,
  overlay: mRe,
  loader: vRe,
  busyOverlay: CRe
}, yRe = {
  $style: wRe
}, L2 = /* @__PURE__ */ we(gRe, [["__cssModules", yRe]]), bRe = { key: 1 }, SRe = /* @__PURE__ */ de({
  __name: "SCAStatus",
  props: {
    appearance: { default: "blue" },
    emphasis: { default: "medium" },
    hideDot: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = rn(), n = D(() => !!t.default);
    return (o, s) => (v(), y("div", {
      class: x([
        o.$style.status,
        o.$style[`appearance_${e.appearance}_${e.emphasis}`],
        {
          [o.$style.dotOnly]: !n.value
        }
      ])
    }, [
      e.hideDot ? V("", !0) : (v(), z(Fe, {
        key: 0,
        class: x(o.$style.dot),
        icon: "generic/dot",
        size: "16px"
      }, null, 8, ["class"])),
      n.value ? (v(), y("div", bRe, [
        ve(o.$slots, "default")
      ])) : V("", !0)
    ], 2));
  }
}), xRe = "_status_hqg60_747", RRe = "_appearance_blue_high_hqg60_763", ERe = "_appearance_blue_medium_hqg60_767", ARe = "_appearance_blue_low_hqg60_771", FRe = "_appearance_green_high_hqg60_775", MRe = "_appearance_green_medium_hqg60_779", IRe = "_appearance_green_low_hqg60_783", PRe = "_appearance_grey_high_hqg60_787", DRe = "_appearance_grey_medium_hqg60_791", TRe = "_appearance_grey_low_hqg60_795", kRe = "_appearance_red_high_hqg60_799", LRe = "_appearance_red_medium_hqg60_803", BRe = "_appearance_red_low_hqg60_807", ORe = "_appearance_orange_high_hqg60_811", GRe = "_appearance_orange_medium_hqg60_815", HRe = "_appearance_orange_low_hqg60_819", VRe = "_appearance_raspberry_high_hqg60_823", _Re = "_appearance_raspberry_medium_hqg60_827", NRe = "_appearance_raspberry_low_hqg60_831", $Re = "_appearance_magenta_high_hqg60_835", zRe = "_appearance_magenta_medium_hqg60_839", WRe = "_appearance_magenta_low_hqg60_843", URe = "_appearance_purple_high_hqg60_847", KRe = "_appearance_purple_medium_hqg60_851", ZRe = "_appearance_purple_low_hqg60_855", qRe = "_appearance_grape_high_hqg60_859", jRe = "_appearance_grape_medium_hqg60_863", YRe = "_appearance_grape_low_hqg60_867", QRe = "_appearance_violet_high_hqg60_871", JRe = "_appearance_violet_medium_hqg60_875", XRe = "_appearance_violet_low_hqg60_879", eEe = "_appearance_cyan_high_hqg60_883", tEe = "_appearance_cyan_medium_hqg60_887", nEe = "_appearance_cyan_low_hqg60_891", oEe = "_appearance_teal_high_hqg60_895", sEe = "_appearance_teal_medium_hqg60_899", iEe = "_appearance_teal_low_hqg60_903", rEe = "_appearance_aquamarine_high_hqg60_907", aEe = "_appearance_aquamarine_medium_hqg60_911", lEe = "_appearance_aquamarine_low_hqg60_915", dEe = "_appearance_emerald_high_hqg60_919", cEe = "_appearance_emerald_medium_hqg60_923", uEe = "_appearance_emerald_low_hqg60_927", hEe = "_appearance_white_high_hqg60_931", gEe = "_appearance_white_medium_hqg60_935", pEe = "_appearance_white_low_hqg60_939", fEe = "_dotOnly_hqg60_943", mEe = "_dot_hqg60_943", vEe = {
  status: xRe,
  appearance_blue_high: RRe,
  appearance_blue_medium: ERe,
  appearance_blue_low: ARe,
  appearance_green_high: FRe,
  appearance_green_medium: MRe,
  appearance_green_low: IRe,
  appearance_grey_high: PRe,
  appearance_grey_medium: DRe,
  appearance_grey_low: TRe,
  appearance_red_high: kRe,
  appearance_red_medium: LRe,
  appearance_red_low: BRe,
  appearance_orange_high: ORe,
  appearance_orange_medium: GRe,
  appearance_orange_low: HRe,
  appearance_raspberry_high: VRe,
  appearance_raspberry_medium: _Re,
  appearance_raspberry_low: NRe,
  appearance_magenta_high: $Re,
  appearance_magenta_medium: zRe,
  appearance_magenta_low: WRe,
  appearance_purple_high: URe,
  appearance_purple_medium: KRe,
  appearance_purple_low: ZRe,
  appearance_grape_high: qRe,
  appearance_grape_medium: jRe,
  appearance_grape_low: YRe,
  appearance_violet_high: QRe,
  appearance_violet_medium: JRe,
  appearance_violet_low: XRe,
  appearance_cyan_high: eEe,
  appearance_cyan_medium: tEe,
  appearance_cyan_low: nEe,
  appearance_teal_high: oEe,
  appearance_teal_medium: sEe,
  appearance_teal_low: iEe,
  appearance_aquamarine_high: rEe,
  appearance_aquamarine_medium: aEe,
  appearance_aquamarine_low: lEe,
  appearance_emerald_high: dEe,
  appearance_emerald_medium: cEe,
  appearance_emerald_low: uEe,
  appearance_white_high: hEe,
  appearance_white_medium: gEe,
  appearance_white_low: pEe,
  dotOnly: fEe,
  dot: mEe
}, CEe = {
  $style: vEe
}, pIe = /* @__PURE__ */ we(SRe, [["__cssModules", CEe]]), wEe = de({
  inheritAttrs: !1
}), yEe = /* @__PURE__ */ de({
  ...wEe,
  __name: "SCATopNavigationItem",
  props: {
    label: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    as: { default: "button" },
    appearance: { default: "normal" },
    viewMode: { default: "text" },
    actionIconActive: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = rn(), o = D(() => t.viewMode === "symbolAndText" ? "14px" : "20px"), s = D(() => {
      var r;
      const i = (r = n.actionIcon) == null ? void 0 : r.call(n, {});
      return i ? i.some((a) => a.type !== Zv) : !1;
    });
    return (i, r) => (v(), z(Ot(e.as), at(i.$attrs, {
      class: [
        i.$style.topNavItem,
        {
          [i.$style.selected]: e.selected,
          [i.$style.disabled]: e.disabled,
          [i.$style.appearanceInverted]: e.appearance === "inverted",
          [i.$style.hasIcon]: e.icon,
          [i.$style.modeSymbolAndText]: e.viewMode === "symbolAndText",
          [i.$style.modeSymbol]: e.viewMode === "symbol",
          [i.$style.active]: e.active
        }
      ]
    }), {
      default: Q(() => [
        e.icon ? (v(), z(Fe, {
          key: 0,
          icon: e.icon,
          size: o.value
        }, null, 8, ["icon", "size"])) : V("", !0),
        e.label ? (v(), y("span", {
          key: 1,
          class: x([i.$style.label, { [i.$style.labelCompact]: e.viewMode === "symbolAndText" }])
        }, se(e.label), 3)) : V("", !0),
        s.value ? (v(), y("div", {
          key: 2,
          class: x([
            i.$style.actionIcon,
            {
              [i.$style.actionIconActive]: e.actionIconActive,
              [i.$style.modeSymbolAndText]: e.viewMode === "symbolAndText",
              [i.$style.modeSymbol]: e.viewMode === "symbol"
            }
          ])
        }, [
          ve(i.$slots, "actionIcon")
        ], 2)) : V("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), bEe = "_topNavItem_1g65b_747", SEe = "_hasIcon_1g65b_766", xEe = "_modeSymbolAndText_1g65b_769", REe = "_modeSymbol_1g65b_769", EEe = "_actionIcon_1g65b_782", AEe = "_disabled_1g65b_786", FEe = "_active_1g65b_786", MEe = "_selected_1g65b_790", IEe = "_appearanceInverted_1g65b_800", PEe = "_labelCompact_1g65b_823", DEe = "_actionIconActive_1g65b_869", TEe = {
  topNavItem: bEe,
  hasIcon: SEe,
  modeSymbolAndText: xEe,
  modeSymbol: REe,
  actionIcon: EEe,
  disabled: AEe,
  active: FEe,
  selected: MEe,
  appearanceInverted: IEe,
  labelCompact: PEe,
  actionIconActive: DEe
}, kEe = {
  $style: TEe
}, fIe = /* @__PURE__ */ we(yEe, [["__cssModules", kEe]]), LEe = /* @__PURE__ */ de({
  __name: "SCAWorkspaceItem",
  props: {
    title: {},
    subtitle: {},
    selected: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    expandable: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    level: { default: 0 }
  },
  emits: ["click", "toggle-expand"],
  setup(e) {
    const t = e, n = D(() => `${4 + t.level * 28}px`), o = W(null), s = W(null), i = al(s);
    return (r, a) => (v(), y("button", {
      ref_key: "rootRef",
      ref: o,
      tabindex: "0",
      class: x([
        r.$style.workspaceItem,
        {
          [r.$style.selected]: e.selected,
          [r.$style.highlighted]: e.highlighted,
          [r.$style.focused]: e.focused
        }
      ]),
      style: Ke({ paddingLeft: n.value }),
      onClick: a[1] || (a[1] = (l) => r.$emit("click"))
    }, [
      R("div", {
        class: x(r.$style.inner)
      }, [
        R("div", {
          class: x(r.$style.avatarAndTitles)
        }, [
          ve(r.$slots, "avatar", {}, () => [
            te(Li, {
              size: "small",
              shape: "square",
              appearance: e.selected || e.focused ? "blue" : "white",
              bordered: !e.selected && !e.focused,
              initials: T(fd)(e.title)
            }, {
              default: Q(() => [
                e.icon ? (v(), z(Fe, {
                  key: 0,
                  icon: e.icon,
                  class: x(r.$style.avatarIcon)
                }, null, 8, ["icon", "class"])) : V("", !0)
              ]),
              _: 1
            }, 8, ["appearance", "bordered", "initials"])
          ]),
          R("div", {
            class: x(r.$style.titles)
          }, [
            te(ad, {
              name: "slide-scale",
              mode: "out-in"
            }, {
              default: Q(() => [
                (v(), y("div", {
                  key: e.title,
                  ref_key: "titleRef",
                  ref: s,
                  class: x(r.$style.title)
                }, se(e.title), 3))
              ]),
              _: 1
            }),
            T(i) ? (v(), z(zt, {
              key: 0,
              target: o.value,
              text: e.title
            }, null, 8, ["target", "text"])) : V("", !0),
            te(ad, {
              name: "slide-scale",
              mode: "out-in"
            }, {
              default: Q(() => [
                (v(), y("div", {
                  key: e.subtitle,
                  class: x(r.$style.subtitle)
                }, se(e.subtitle), 3))
              ]),
              _: 1
            })
          ], 2)
        ], 2),
        R("div", {
          class: x(r.$style.expanderIconContainer)
        }, [
          e.expandable ? (v(), z(Fe, {
            key: 0,
            icon: "phosphor/caret-down",
            class: x([r.$style.expanderIcon, { [r.$style.expandedIcon]: e.expanded }]),
            size: "16px",
            onClick: a[0] || (a[0] = Ge((l) => r.$emit("toggle-expand"), ["stop"]))
          }, null, 8, ["class"])) : V("", !0)
        ], 2)
      ], 2)
    ], 6));
  }
}), BEe = "_workspaceItem_2kopo_747", OEe = "_inner_2kopo_757", GEe = "_avatarIcon_2kopo_765", HEe = "_expanderIconContainer_2kopo_769", VEe = "_expanderIcon_2kopo_769", _Ee = "_expandedIcon_2kopo_780", NEe = "_selected_2kopo_783", $Ee = "_highlighted_2kopo_795", zEe = "_focused_2kopo_804", WEe = "_avatarAndTitles_2kopo_817", UEe = "_titles_2kopo_826", KEe = "_title_2kopo_826", ZEe = "_subtitle_2kopo_850", qEe = {
  workspaceItem: BEe,
  inner: OEe,
  avatarIcon: GEe,
  expanderIconContainer: HEe,
  expanderIcon: VEe,
  expandedIcon: _Ee,
  selected: NEe,
  highlighted: $Ee,
  focused: zEe,
  avatarAndTitles: WEe,
  titles: UEe,
  title: KEe,
  subtitle: ZEe
}, jEe = {
  $style: qEe
}, mIe = /* @__PURE__ */ we(LEe, [["__cssModules", jEe]]), YEe = /* @__PURE__ */ de({
  __name: "SCASplitter",
  emits: ["resize"],
  setup(e, { expose: t, emit: n }) {
    const o = n, s = W(), i = W([]), r = W(!1), a = W(null), { width: l } = XU(), d = D(() => i.value.filter((S) => S.visible && !S.isOverlay));
    pg("splitterContext", {
      registerPanel: (S) => {
        const F = i.value.findIndex((E) => E.id === S.id);
        F === -1 ? i.value.push(S) : i.value[F] = { ...S }, b();
      },
      unregisterPanel: (S) => {
        i.value = i.value.filter((F) => F.id !== S), b();
      },
      updatePanelSizes: (S) => {
        let F = !1;
        for (const [E, M] of Object.entries(S)) {
          const I = i.value.find((B) => B.id === E);
          if (!I) continue;
          const P = I.minSize ?? 0, k = I.maxSize ?? 1 / 0;
          I.size = Math.max(P, Math.min(k, M)), F = !0;
        }
        F && (b(), o("resize", { panels: [...i.value] }));
      },
      onResizeStart: (S) => {
        r.value = !0, a.value = S;
      },
      onResizeEnd: () => {
        r.value = !1, a.value = null;
      },
      get panels() {
        return Qo(i.value);
      }
    }), Re(
      () => d.value.length,
      () => m()
    );
    const m = () => {
      if (!s.value) return;
      const S = l.value, M = (d.value.length - 1) * 12, I = S - M;
      let P = 0;
      if (d.value.forEach((k) => {
        k.size ? P += k.size : P += k.minSize ?? 0;
      }), P > I) {
        const k = d.value.filter((B) => !B.collapsible && B.size && B.size > (B.minSize ?? 0));
        if (k.length > 0) {
          const B = P - I;
          k.sort((N, re) => (re.size ?? 0) - (N.size ?? 0));
          let j = B;
          for (const N of k) {
            const re = N.minSize ?? 0, H = N.size ?? 0, _ = H - re;
            if (_ > 0) {
              const ne = Math.min(j, _);
              if (N.size = H - ne, j -= ne, j <= 0) break;
            }
          }
        }
      }
      b();
    }, C = (S) => {
      let M = S.reduce((P, k) => P + (k.size ?? k.minSize ?? 0), 0) + Math.max(S.length - 1, 0) * 12 - l.value;
      const I = /* @__PURE__ */ new Map();
      for (const P of S) {
        if (M <= 0) break;
        if (!P.collapsible || !P.size) continue;
        const k = Math.min(M, P.size);
        I.set(P.id, P.size - k), M -= k;
      }
      return I;
    };
    let w;
    const b = () => {
      if (!s.value) return;
      const S = i.value.filter((P) => (P.visible || P.isTransitioning) && !P.isOverlay).sort((P, k) => (P.order ?? 0) - (k.order ?? 0)), F = "12px", E = C(S.filter((P) => P.visible)), M = [];
      S.forEach((P, k) => {
        !P.visible && P.isTransitioning ? M.push("0") : P.size !== void 0 && P.size !== null ? P.isOverlay ? M.push("0") : M.push(`${E.get(P.id) ?? P.size}px`) : P.minSize ? M.push(`minmax(${P.minSize}px, 1fr)`) : M.push("1fr"), k < S.length - 1 && M.push(P.isTransitioning && !P.visible ? "0" : F);
      });
      const I = M.join(" ");
      I !== w && (w = I, s.value.style.gridTemplateColumns = I, s.value.style.gridTemplateRows = "100%");
    }, A = D(() => ({
      display: "grid",
      width: "100%",
      height: "100%",
      gap: "0px"
    }));
    return Re(l, () => {
      r.value || b();
    }), Et(() => {
      b();
    }), t({
      updateGridTemplate: b,
      panels: Qo(i)
    }), (S, F) => (v(), y("div", {
      ref_key: "containerRef",
      ref: s,
      class: x([S.$style.splitter, { [S.$style.resizing]: r.value }]),
      style: Ke(A.value)
    }, [
      ve(S.$slots, "default")
    ], 6));
  }
}), QEe = "_splitter_1raod_1", JEe = "_resizing_1raod_6", XEe = {
  splitter: QEe,
  resizing: JEe
}, eAe = {
  $style: XEe
}, vIe = /* @__PURE__ */ we(YEe, [["__cssModules", eAe]]), tAe = ["data-panel-id"], nAe = /* @__PURE__ */ de({
  __name: "SCASplitterPanel",
  props: {
    id: {},
    size: { default: void 0 },
    minSize: { default: void 0 },
    maxSize: { default: void 0 },
    visible: { type: Boolean, default: !0 },
    autofill: { type: Boolean, default: !1 },
    isOverlay: { type: Boolean, default: !1 },
    order: { default: void 0 },
    isTransitioning: { type: Boolean, default: !1 },
    collapsible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = Mi("splitterContext"), o = D(() => ({
      overflow: "hidden",
      display: t.visible ? "block" : "none"
    }));
    return Et(() => {
      n && n.registerPanel({
        id: t.id,
        size: t.size,
        minSize: t.minSize,
        maxSize: t.maxSize,
        visible: t.visible,
        isOverlay: t.isOverlay,
        order: t.order,
        isTransitioning: t.isTransitioning,
        collapsible: t.collapsible
      });
    }), ks(() => {
      n && n.unregisterPanel(t.id);
    }), Re(
      () => t.visible,
      (s) => {
        n && n.registerPanel({
          id: t.id,
          size: t.size,
          minSize: t.minSize,
          maxSize: t.maxSize,
          visible: s,
          isOverlay: t.isOverlay,
          order: t.order,
          isTransitioning: t.isTransitioning,
          collapsible: t.collapsible
        });
      }
    ), Re(
      [
        () => t.size,
        () => t.minSize,
        () => t.maxSize,
        () => t.isOverlay,
        () => t.isTransitioning,
        () => t.collapsible
      ],
      () => {
        n && n.registerPanel({
          id: t.id,
          size: t.size,
          minSize: t.minSize,
          maxSize: t.maxSize,
          visible: t.visible,
          isOverlay: t.isOverlay,
          order: t.order,
          isTransitioning: t.isTransitioning,
          collapsible: t.collapsible
        });
      }
    ), (s, i) => (v(), y("div", {
      class: x(s.$style.splitterPanel),
      style: Ke(e.isTransitioning ? null : o.value),
      "data-panel-id": e.id
    }, [
      ve(s.$slots, "default")
    ], 14, tAe));
  }
}), oAe = "_splitterPanel_19hrh_1", sAe = {
  splitterPanel: oAe
}, iAe = {
  $style: sAe
}, CIe = /* @__PURE__ */ we(nAe, [["__cssModules", iAe]]), _v = "SCASplitterResizer-active", rAe = /* @__PURE__ */ de({
  __name: "SCASplitterResizer",
  props: {
    leftPanelId: {},
    rightPanelId: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Mi("splitterContext"), o = W(!1), s = W(0), i = W(0), r = W(0);
    let a = null, l = null;
    const d = D(() => n == null ? void 0 : n.panels.find((m) => m.id === t.leftPanelId)), c = D(() => n == null ? void 0 : n.panels.find((m) => m.id === t.rightPanelId)), u = (m) => {
      t.disabled || !n || !d.value || !c.value || (o.value = !0, s.value = m.clientX, i.value = d.value.size ?? 0, r.value = c.value.size ?? 0, n.onResizeStart(t.leftPanelId), document.body.classList.add(_v), document.addEventListener("mousemove", h), document.addEventListener("mouseup", f));
    }, h = (m) => {
      a = m.clientX, l ?? (l = requestAnimationFrame(g));
    }, g = () => {
      if (l = null, a === null) return;
      const m = a;
      a = null, p(m);
    }, p = (m) => {
      if (!o.value || !n || !d.value || !c.value) return;
      let C = m - s.value;
      const w = d.value.size === void 0, b = c.value.size === void 0, A = d.value.minSize ?? 0, S = d.value.maxSize ?? 1 / 0, F = c.value.minSize ?? 0, E = c.value.maxSize ?? 1 / 0;
      let M = i.value + C, I = r.value - C;
      w || (M > S && (C -= M - S, M = S, I = r.value - C), M < A && (C += A - M, M = A, I = r.value - C)), b || (I > E && (C -= I - E, I = E, M = i.value + C), I < F && (C += F - I, I = F, M = i.value + C));
      const P = n.panels.filter((re) => re.visible && !re.isOverlay), k = Math.max(P.length - 1, 0) * 12, B = P.reduce((re, H) => H.id === d.value.id ? re + (w ? H.size ?? H.minSize ?? 0 : M) : H.id === c.value.id ? re + (b ? H.size ?? H.minSize ?? 0 : I) : re + (H.size ?? H.minSize ?? 0), 0), j = window.innerWidth - k;
      if (B > j) {
        const re = B - j;
        w ? b || (I -= re, I < F && (I = F), M = i.value + (r.value - I)) : (M -= re, M < A && (M = A), I = r.value - (M - i.value));
      }
      const N = {};
      w || (N[t.leftPanelId] = M), b || (N[t.rightPanelId] = I), n.updatePanelSizes(N);
    }, f = () => {
      n && (l !== null && (cancelAnimationFrame(l), g()), o.value = !1, n.onResizeEnd(t.leftPanelId), document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", f), document.body.classList.remove(_v));
    };
    return io(() => {
      o.value && f();
    }), (m, C) => (v(), y("div", {
      class: x([
        m.$style.splitterResizer,
        {
          [m.$style.resizer]: o.value,
          [m.$style.disabled]: e.disabled
        }
      ]),
      onMousedown: u
    }, [
      R("div", {
        class: x(m.$style.resizerHandle)
      }, null, 2)
    ], 34));
  }
}), aAe = "_splitterResizer_qg4g9_7", lAe = "_disabled_qg4g9_19", dAe = "_resizerHandle_qg4g9_22", cAe = "_resizer_qg4g9_22", uAe = {
  splitterResizer: aAe,
  disabled: lAe,
  resizerHandle: dAe,
  resizer: cAe
}, hAe = {
  $style: uAe
}, wIe = /* @__PURE__ */ we(rAe, [["__cssModules", hAe]]), gAe = /* @__PURE__ */ de({
  __name: "SCATableRowField",
  props: {
    colType: { default: "text" },
    value: {},
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" }
  },
  setup(e) {
    const t = e, n = D(() => t.value), o = D(() => t.value), s = D(() => t.value), i = D(() => t.value), r = D(() => {
      if (t.colType !== "attachment_amount")
        return !1;
      switch (typeof t.value) {
        case "string":
          return parseInt(t.value, 10) > 0;
        case "number":
          return t.value > 0;
        default:
          return !1;
      }
    });
    return (a, l) => e.colType === "datetime" && typeof e.value == "string" ? (v(), y("span", {
      key: 0,
      class: x(a.$style.text)
    }, se(T(mA)(e.value, t.dateFormat, t.timeFormat)), 3)) : e.colType === "date" && typeof e.value == "string" ? (v(), y("span", {
      key: 1,
      class: x(a.$style.text)
    }, se(T(Og)(e.value, t.dateFormat)), 3)) : e.colType === "recordReferences" ? (v(), y("span", {
      key: 2,
      class: x(a.$style.text)
    }, [
      (v(!0), y(Se, null, We(i.value, (d) => (v(), z(no, {
        key: d.id,
        avatar: { initials: T(fd)(d.name, { charCount: 1 }) },
        class: x(a.$style.tag)
      }, {
        default: Q(() => [
          Oe(se(d.name), 1)
        ]),
        _: 2
      }, 1032, ["avatar", "class"]))), 128))
    ], 2)) : e.colType === "list" ? (v(), y("span", {
      key: 3,
      class: x(a.$style.text)
    }, se(o.value ? o.value.label : ""), 3)) : e.colType === "typedText" ? (v(), y("span", {
      key: 4,
      class: x(a.$style.text)
    }, se(s.value && s.value.length > 0 ? s.value[0].value : ""), 3)) : e.colType === "attachment_amount" ? (v(), y("span", {
      key: 5,
      class: x([a.$style.text, a.$style.spanGap])
    }, [
      te(Fe, {
        class: x(r.value ? "" : a.$style.disabled),
        icon: "phosphor/paperclip",
        size: "20px"
      }, null, 8, ["class"]),
      Oe(" " + se(n.value), 1)
    ], 2)) : e.colType === "translated_objects" ? (v(), y("span", {
      key: 6,
      class: x([a.$style.text, a.$style.spanGap])
    }, [
      (v(!0), y(Se, null, We(i.value, (d) => (v(), z(no, {
        key: d.id,
        avatar: { initials: T(fd)(d.name, { charCount: 1 }) }
      }, {
        default: Q(() => [
          Oe(se(d.name), 1)
        ]),
        _: 2
      }, 1032, ["avatar"]))), 128))
    ], 2)) : (v(), y("span", {
      key: 7,
      class: x(a.$style.text)
    }, se(n.value), 3));
  }
}), pAe = "_spanGap_107mc_1", fAe = "_text_107mc_7", mAe = "_disabled_107mc_14", vAe = "_tag_107mc_18", CAe = {
  spanGap: pAe,
  text: fAe,
  disabled: mAe,
  tag: vAe
}, wAe = {
  $style: CAe
}, Nv = /* @__PURE__ */ we(gAe, [["__cssModules", wAe]]), Xs = (e, t) => {
  if (t)
    return hr(e, t);
}, yAe = ["checked"], bAe = /* @__PURE__ */ de({
  __name: "SCATableRow",
  props: {
    row: {},
    indent: {},
    selectedKeys: {},
    cols: {},
    keyProp: {},
    rowsClickable: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    hierarchy: { type: Boolean, default: !1 },
    childrenKeyProp: { default: void 0 },
    hasChildren: { type: Function, default: void 0 },
    expanded: { type: Boolean, default: !1 },
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" }
  },
  emits: ["update:expanded", "rowClick", "toggleSelect"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = W(n.selectedKeys), i = D(() => n.cols[0]);
    Re(
      () => n.selectedKeys,
      () => {
        s.value = n.selectedKeys;
      }
    );
    const r = D(() => {
      if (!n.childrenKeyProp)
        return !1;
      const l = Xs(n.row, n.childrenKeyProp);
      return n.childrenKeyProp in n.row && Array.isArray(l) && l.length > 0 ? !0 : n.hasChildren ? n.hasChildren(n.row) : !1;
    });
    function a(l) {
      return typeof n.keyProp == "function" ? n.keyProp(l) : l[n.keyProp];
    }
    return (l, d) => (v(), y("div", {
      role: "gridrow",
      class: x([
        l.$style.row,
        {
          [l.$style.clickable]: e.rowsClickable,
          [l.$style.selected]: s.value.includes(a(e.row)),
          [l.$style.expanded]: e.expanded
        }
      ]),
      onClick: d[4] || (d[4] = (c) => o("rowClick", e.row))
    }, [
      R("div", {
        role: "gridcell",
        class: x([l.$style.td, l.$style.tdGap])
      }, [
        e.hierarchy ? (v(), y(Se, { key: 0 }, [
          e.indent ? (v(), y("div", {
            key: 0,
            class: x([l.$style.indented, l.$style.noShrink]),
            style: Ke(`--indent: ${n.indent}`)
          }, null, 6)) : V("", !0),
          r.value ? (v(), z(ut, {
            key: 1,
            size: "small",
            icon: e.expanded ? "phosphor/caret-down-fill" : "phosphor/caret-right-fill",
            appearance: "secondary",
            type: "bare",
            class: x(l.$style.noShrink),
            onClick: [
              d[0] || (d[0] = Ge(() => {
              }, ["stop"])),
              d[1] || (d[1] = (c) => o("update:expanded", !e.expanded))
            ]
          }, null, 8, ["icon", "class"])) : (v(), y("div", {
            key: 2,
            class: x(l.$style.noShrink),
            style: "width: 20px"
          }, null, 2))
        ], 64)) : V("", !0),
        e.selectable ? (v(), z(Ts, {
          key: 1,
          class: x(l.$style.checkbox)
        }, {
          default: Q(() => [
            R("input", {
              checked: s.value.includes(a(e.row)),
              type: "checkbox",
              onClick: d[2] || (d[2] = Ge(() => {
              }, ["stop"])),
              onChange: d[3] || (d[3] = (c) => o("toggleSelect", a(e.row)))
            }, null, 40, yAe)
          ]),
          _: 1
        }, 8, ["class"])) : V("", !0),
        i.value ? ve(l.$slots, i.value.key, {
          key: 2,
          col: i.value,
          row: e.row,
          value: T(Xs)(e.row, i.value.property)
        }, () => [
          te(Nv, {
            "col-type": i.value.type,
            value: T(Xs)(e.row, i.value.property),
            "date-format": n.dateFormat,
            "time-format": n.timeFormat
          }, null, 8, ["col-type", "value", "date-format", "time-format"])
        ]) : V("", !0)
      ], 2),
      (v(!0), y(Se, null, We(e.cols.slice(1), (c) => (v(), y("div", {
        key: `${c.key}`,
        role: "gridcell",
        class: x(l.$style.td)
      }, [
        ve(l.$slots, c.key, {
          col: c,
          row: e.row,
          value: T(Xs)(e.row, c.property)
        }, () => [
          te(Nv, {
            "col-type": c.type,
            value: T(Xs)(e.row, c.property),
            "date-format": n.dateFormat,
            "time-format": n.timeFormat
          }, null, 8, ["col-type", "value", "date-format", "time-format"])
        ])
      ], 2))), 128))
    ], 2));
  }
}), SAe = "_row_1o39d_747", xAe = "_clickable_1o39d_750", RAe = "_td_1o39d_753", EAe = "_expanded_1o39d_756", AAe = "_selected_1o39d_759", FAe = "_value_1o39d_785", MAe = "_tdGap_1o39d_792", IAe = "_indented_1o39d_796", PAe = "_noShrink_1o39d_801", DAe = "_checkbox_1o39d_805", TAe = {
  row: SAe,
  clickable: xAe,
  td: RAe,
  expanded: EAe,
  selected: AAe,
  value: FAe,
  tdGap: MAe,
  indented: IAe,
  noShrink: PAe,
  checkbox: DAe
}, kAe = {
  $style: TAe
}, LAe = /* @__PURE__ */ we(bAe, [["__cssModules", kAe]]), BAe = {
  key: 0,
  style: "width: 20px"
}, OAe = ["checked"], GAe = ["title"], HAe = ["title"], VAe = ["onClick"], _Ae = /* @__PURE__ */ de({
  __name: "SCATable",
  props: {
    items: { default: () => [] },
    selectedKeys: { default: () => [] },
    cols: {},
    keyProp: {},
    rowsClickable: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    sortState: { default: void 0 },
    selectable: { type: Boolean, default: !1 },
    hierarchy: { type: Boolean, default: !1 },
    childrenKeyProp: { default: void 0 },
    colFilters: { default: () => [] },
    hasChildren: { type: Function, default: void 0 },
    hideHeader: { type: Boolean, default: !1 },
    initiallyExpanded: { type: Boolean, default: !1 },
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" }
  },
  emits: ["rowClick", "update:selectedKeys", "update:sortState", "update:colFilters", "loadChildren"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Bn(n, "selectedKeys", o, { passive: !0 }), i = W({}), r = W({}), a = W({});
    function l(E, M) {
      const I = w(E);
      r.value[I] = M, M && !a.value[I] && (o("loadChildren", E), a.value[I] = !0);
    }
    function d(E) {
      return n.childrenKeyProp ? Xs(E, n.childrenKeyProp) ?? [] : [];
    }
    Re(
      () => n.items,
      () => {
        i.value = {}, c(n.items, 0);
      },
      { immediate: !0, deep: !0 }
    );
    function c(E, M = 0) {
      E && E.forEach((I) => {
        const P = w(I);
        if (i.value[P] = M, n.childrenKeyProp) {
          const k = d(I);
          c(k, M + 1);
        }
      });
    }
    Re(
      () => n.items,
      (E) => {
        s.value = s.value.filter((M) => E.find((I) => w(I) === M));
      }
    );
    const u = D(() => h(n.items));
    function h(E) {
      return E.reduce((M, I) => [...M, I, ...g(I) ? h(d(I)) : []], []);
    }
    function g(E) {
      return !!r.value[w(E)];
    }
    {
      let E = function(P) {
        return P.reduce((k, B) => [...k, B, ...E(d(B))], []);
      }, M = function(P, k) {
        Object.entries(k.value).forEach(([B]) => {
          P.find((N) => w(N) === B) || delete k.value[B];
        });
      }, I = function(P) {
        const k = E(P);
        M(k, i), M(k, r), M(k, a);
      };
      Re(
        () => n.items,
        (P) => {
          I(P);
        },
        { deep: !0 }
      );
    }
    Re(
      () => n.items,
      (E) => {
        i.value = {}, c(E, 0), n.initiallyExpanded && p(E);
      },
      { immediate: !0, deep: !0 }
    );
    function p(E) {
      for (const M of E) {
        const I = w(M);
        r.value[I] = !0, a.value[I] = !0;
        const P = d(M);
        P != null && P.length && p(P);
      }
    }
    const f = Bn(n, "sortState", o, { passive: !0, deep: !0 }), m = D(() => n.cols.map((E) => `${E.width ?? "minmax(min-content, 1fr)"}`).join(" "));
    function C(E) {
      o("rowClick", E);
    }
    function w(E) {
      return typeof n.keyProp == "function" ? n.keyProp(E) : E[n.keyProp];
    }
    function b(E) {
      return E.reduce((M, I) => {
        const P = d(I);
        return [...M, I, ...b(P)];
      }, []);
    }
    function A() {
      if (s.value.length > 0) {
        s.value = [];
        return;
      }
      s.value = b(n.items).map((E) => w(E));
    }
    function S(E) {
      const M = s.value.indexOf(E);
      if (M >= 0) {
        s.value.splice(M, 1);
        return;
      }
      s.value.push(E);
    }
    function F(E) {
      var M;
      if (eo(E, "col"), !!E.sortable) {
        if (((M = f.value) == null ? void 0 : M.colKey) === E.key) {
          switch (f.value.asc) {
            case !1:
              f.value.asc = !0;
              break;
            case !0:
              f.value = void 0;
              break;
          }
          return;
        }
        f.value = {
          colKey: E.key,
          asc: !1
        };
      }
    }
    return (E, M) => (v(), z(L2, {
      class: x([E.$style.wrapper, "w-full"]),
      loading: e.loading,
      overlay: ""
    }, {
      default: Q(() => {
        var I, P;
        return [
          (v(), y("div", {
            key: e.cols.length,
            role: "grid",
            class: x(E.$style.table),
            style: Ke({ gridTemplateColumns: m.value })
          }, [
            !e.hideHeader && e.cols[0] ? (v(), y("div", {
              key: 0,
              class: x(E.$style.headerRow)
            }, [
              R("div", {
                class: x(E.$style.th)
              }, [
                R("div", {
                  role: "heading",
                  class: x(E.$style.firstHeader)
                }, [
                  e.hierarchy ? (v(), y("div", BAe)) : V("", !0),
                  e.selectable ? (v(), z(Ts, {
                    key: 1,
                    deselect: "",
                    class: x(E.$style.checkbox),
                    onClick: A
                  }, {
                    default: Q(() => [
                      R("input", {
                        checked: T(s).length > 0,
                        type: "checkbox"
                      }, null, 8, OAe)
                    ]),
                    _: 1
                  }, 8, ["class"])) : V("", !0),
                  R("div", {
                    title: e.cols[0].caption
                  }, [
                    R("div", {
                      class: x([E.$style.thLabel, { [E.$style.sortable]: e.cols[0].sortable }]),
                      onClick: M[0] || (M[0] = (k) => F(e.cols[0]))
                    }, [
                      Tn(te(Fe, {
                        size: "20px",
                        icon: (I = T(f)) != null && I.asc ? "phosphor/arrow-up" : "phosphor/arrow-down"
                      }, null, 8, ["icon"]), [
                        [cr, ((P = T(f)) == null ? void 0 : P.colKey) === e.cols[0].key]
                      ]),
                      ve(E.$slots, `${e.cols[0].key}_header`, {
                        col: e.cols[0]
                      }, () => [
                        Oe(se(e.cols[0].caption), 1)
                      ])
                    ], 2)
                  ], 8, GAe)
                ], 2)
              ], 2),
              (v(!0), y(Se, null, We(e.cols.slice(1), (k) => {
                var B, j;
                return v(), y("div", {
                  key: k.key,
                  class: x(E.$style.th)
                }, [
                  R("div", {
                    role: "heading",
                    title: k.caption
                  }, [
                    R("div", {
                      class: x([E.$style.thLabel, { [E.$style.sortable]: k.sortable }]),
                      onClick: (N) => F(k)
                    }, [
                      Tn(te(Fe, {
                        size: "20px",
                        icon: (B = T(f)) != null && B.asc ? "phosphor/arrow-up" : "phosphor/arrow-down"
                      }, null, 8, ["icon"]), [
                        [cr, ((j = T(f)) == null ? void 0 : j.colKey) === k.key]
                      ]),
                      ve(E.$slots, `${k.key}_header`, { col: k }, () => [
                        Oe(se(k.caption), 1)
                      ])
                    ], 10, VAe)
                  ], 8, HAe)
                ], 2);
              }), 128))
            ], 2)) : V("", !0),
            (v(!0), y(Se, null, We(u.value, (k) => (v(), z(LAe, {
              key: `${String(w(k))}`,
              "selected-keys": T(s),
              row: k,
              cols: e.cols,
              indent: i.value[w(k)],
              expanded: r.value[w(k)],
              "key-prop": e.keyProp,
              "children-key-prop": e.childrenKeyProp,
              hierarchy: e.hierarchy,
              selectable: e.selectable,
              "rows-clickable": e.rowsClickable,
              "has-children": e.hasChildren,
              "date-format": e.dateFormat,
              "time-format": e.timeFormat,
              onToggleSelect: S,
              onRowClick: C,
              "onUpdate:expanded": (B) => l(k, B)
            }, Wn({ _: 2 }, [
              We(e.cols, (B) => ({
                name: B.key,
                fn: Q(() => [
                  ve(E.$slots, B.key, {
                    col: B,
                    row: k,
                    value: T(Xs)(k, B.property)
                  })
                ])
              }))
            ]), 1032, ["selected-keys", "row", "cols", "indent", "expanded", "key-prop", "children-key-prop", "hierarchy", "selectable", "rows-clickable", "has-children", "date-format", "time-format", "onUpdate:expanded"]))), 128)),
            e.items.length === 0 && !e.loading ? (v(), y("div", {
              key: 1,
              class: x(E.$style.empty),
              style: Ke({ gridColumn: `span ${e.cols.length}` })
            }, [
              ve(E.$slots, "_empty")
            ], 6)) : V("", !0)
          ], 6))
        ];
      }),
      _: 3
    }, 8, ["class", "loading"]));
  }
}), NAe = "_wrapper_ri9sy_747", $Ae = "_table_ri9sy_751", zAe = "_headerRow_ri9sy_757", WAe = "_th_ri9sy_760", UAe = "_firstHeader_ri9sy_785", KAe = "_thLabel_ri9sy_790", ZAe = "_sortable_ri9sy_795", qAe = "_empty_ri9sy_798", jAe = "_loadingIndicator_ri9sy_802", YAe = "_checkbox_ri9sy_808", QAe = {
  wrapper: NAe,
  table: $Ae,
  headerRow: zAe,
  th: WAe,
  firstHeader: UAe,
  thLabel: KAe,
  sortable: ZAe,
  empty: qAe,
  loadingIndicator: jAe,
  checkbox: YAe
}, JAe = {
  $style: QAe
}, yIe = /* @__PURE__ */ we(_Ae, [["__cssModules", JAe]]);
function dl(e) {
  return !!e.isFixed;
}
function qa(e) {
  return e.draggable ?? !dl(e);
}
function XAe(e) {
  return e.some(dl);
}
function B2(e, t) {
  return e.label || t;
}
function e3e(e, t) {
  const n = B2(e, t);
  return e.labelSuffix ? `${n} ${e.labelSuffix}` : n;
}
function O2(e, t) {
  return !e || t.readonly ? !1 : !dl(e) || !!e.isEditable;
}
function t3e(e, t) {
  return !e || t.readonly || dl(e) ? !1 : t.tabCount > 1 || t.hasFixedTabs;
}
function n3e(e, t) {
  return !e || t.readonly || t.isEditing ? !1 : qa(e) && !e.disabled;
}
function o3e(e) {
  let t = -1, n = -1;
  return e.forEach((o, s) => {
    qa(o) && (t === -1 && (t = s), n = s);
  }), { first: t, last: n };
}
function s3e(e, t) {
  return t.first === -1 ? e : Math.min(Math.max(e, t.first), t.last);
}
function i3e(e) {
  const t = W(null), n = W(""), o = W(null);
  function s(l) {
    const d = xe(e.tabs)[l];
    !d || !O2(d, { readonly: xe(e.readonly) }) || (n.value = d.label, t.value = d.key);
  }
  const i = D(() => {
    const l = t.value, d = n.value.trim();
    if (l === null || !d || !e.validateLabel) return null;
    const c = xe(e.tabs).findIndex((u) => u.key === l);
    return c === -1 || e.validateLabel(c, d) ? null : l;
  });
  function r() {
    var u, h;
    const l = t.value;
    if (l === null) return;
    if (i.value === l) {
      const g = xe(e.tabs).findIndex((p) => p.key === l);
      g !== -1 && ((u = e.onInvalidCommit) == null || u.call(e, g, n.value.trim()));
      return;
    }
    t.value = null;
    const d = (h = n.value) == null ? void 0 : h.trim(), c = xe(e.tabs).findIndex((g) => g.key === l);
    !d || c === -1 || e.onRename(c, d);
  }
  const a = D(() => o.value ?? e.pendingEditKey.value);
  return Re([a, () => xe(e.tabs)], ([l, d]) => {
    if (!l) return;
    const c = d.findIndex((u) => u.key === l);
    c !== -1 && (o.value = null, e.pendingEditKey.value = null, s(c));
  }), Re(n, () => e.onLabelResize(t.value)), Re(
    () => xe(e.readonly),
    (l) => {
      l && (o.value = null, e.pendingEditKey.value = null, t.value = null);
    }
  ), {
    editingKey: t,
    editingLabel: n,
    invalidKey: i,
    isEditing: (l) => t.value === l,
    startEdit: s,
    queueRename: (l) => {
      o.value = l;
    },
    commitEdit: r,
    cancelEdit: () => {
      t.value = null;
    }
  };
}
const _i = (e) => e.key;
function r3e(e) {
  return !e.target || qa(e.target);
}
function a3e(e) {
  const t = [r3e, Vc(_i)], n = (h) => e.isHidden(h.key) ? "vertical" : "horizontal", o = Nc({
    getId: _i,
    ghostLabel: (h) => h.label,
    ghostIcon: (h) => h.icon,
    dragGroup: "editableTabs",
    disabled: e.readonly
  }), s = hf({
    container: e.container,
    getId: _i,
    findItem: (h) => xe(e.tabs).find((g) => g.key === h)
  }), i = $c({
    items: e.tabs,
    getId: _i,
    dragGroup: "editableTabs",
    disabled: e.readonly,
    axis: n,
    rowLocator: s,
    indicator: "rowClass",
    rules: t,
    // Never reached from `onDrop` below — that path resolves and applies the plan itself, off the
    // already-validated hover state, rather than replaying a `DragEvent` through this callback (see
    // `onDrop`'s own comment). Still required so `containerHandlers.onDragover` computes a real
    // `DropPlan` to decide `dropEffect`/`rowIndicator` on every hover.
    onDrop: (h) => {
      const p = xe(e.tabs).findIndex((f) => f.key === _i(h.source[0]));
      p !== -1 && e.onReorder(p, h.index);
    }
  });
  function r(h, g) {
    const p = xe(e.tabs)[g];
    if (xe(e.readonly) || !p || !qa(p)) {
      h.preventDefault();
      return;
    }
    o.dragHandlers(p).onDragstart(h);
  }
  function a(h) {
    o.isDragging.value && i.containerHandlers.onDragover(h);
  }
  function l() {
    if (!o.isDragging.value) return;
    const h = o.draggedItems.value[0], g = i.rowIndicator.value;
    if (h && g) {
      const p = xe(e.tabs), f = p.findIndex((m) => m.key === h.key);
      if (f !== -1) {
        const m = {
          source: [h],
          target: g.item,
          position: g.side === "below" ? "below" : "above",
          level: p
        }, C = PS(m, { getId: _i, rules: t });
        C && e.onReorder(f, C.index);
      }
    }
    d();
  }
  function d() {
    const h = o.draggedItems.value[0];
    h && o.dragHandlers(h).onDragend();
  }
  function c() {
    const h = o.draggedItems.value[0];
    if (!h || !qa(h)) return;
    const g = xe(e.tabs), p = g.findIndex((S) => S.key === h.key);
    if (p === -1) return;
    const f = i.rowIndicator.value, m = f ? g.findIndex((S) => S.key === f.item.key) : -1, C = e.firstHiddenIndex(), w = Math.max(0, (C === -1 ? g.length : C) - 1), A = s3e(m === -1 ? w : m, o3e(g));
    A !== p && e.onReorder(p, A);
  }
  function u() {
    return o.isDragging.value ? i.rowIndicator.value : null;
  }
  return {
    isDragging: o.isDragging,
    dragOverKey: D(() => {
      var h;
      return ((h = u()) == null ? void 0 : h.item.key) ?? null;
    }),
    dropIndicatorClass: (h) => {
      const g = u();
      if (!(!g || g.item.key !== h))
        return gf(g, g.item, n(g.item));
    },
    onDragStart: r,
    onDragOver: a,
    onDrop: l,
    onDragEnd: d,
    onBarDragOver: (h) => {
      o.isDragging.value && (h.preventDefault(), h.dataTransfer && (h.dataTransfer.dropEffect = "move"));
    },
    onBarDrop: c
  };
}
function l3e(e, t, n) {
  return e === t ? n : t < e && e <= n ? e - 1 : n <= e && e < t ? e + 1 : e;
}
function d3e(e) {
  const { emits: t } = e;
  function n() {
    const r = { label: xe(e.newTabLabel), key: e.createKey() }, a = [...xe(e.tabs), r];
    return t.updateTabs(a), t.selectTab(a.length - 1), r.key;
  }
  async function o(r) {
    const a = xe(e.tabs)[r];
    if (!a || dl(a)) return;
    const l = e.beforeRemoveTab();
    if (l && !await l(r)) return;
    const d = xe(e.tabs), c = d.findIndex((h) => h.key === a.key);
    if (c === -1) return;
    const u = d.filter((h, g) => g !== c);
    t.updateTabs(u), t.removed({ index: c, key: a.key }), xe(e.selectedIndex) >= u.length && t.selectTab(Math.max(0, u.length - 1));
  }
  function s(r, a) {
    var c;
    const l = xe(e.tabs), d = (c = l[r]) == null ? void 0 : c.key;
    t.updateTabs(l.map((u, h) => h === r ? { ...u, label: a } : u)), d && t.renamed({ index: r, key: d, label: a });
  }
  function i(r, a) {
    const l = [...xe(e.tabs)], [d] = l.splice(r, 1);
    if (!d) return;
    l.splice(a, 0, d), t.updateTabs(l), t.reordered({ fromIndex: r, toIndex: a, key: d.key });
    const c = xe(e.selectedIndex), u = l3e(c, r, a);
    u !== c && t.selectTab(u);
  }
  return { addTab: n, removeTab: o, renameTab: s, reorderTabs: i };
}
const c3e = 100;
function u3e(e) {
  const t = W(/* @__PURE__ */ new Set()), n = W(null);
  let o = /* @__PURE__ */ new Set(), s = null;
  function i() {
    const l = e.container();
    if (!l) {
      t.value = /* @__PURE__ */ new Set(), n.value = null;
      return;
    }
    const d = l.style.maxWidth;
    l.style.maxWidth = "";
    const c = l.offsetWidth, u = /* @__PURE__ */ new Set();
    let h = 0;
    for (const g of l.children) {
      const { dataset: p, offsetLeft: f, offsetWidth: m } = g;
      if (!p.tabKey) continue;
      const C = f + m;
      C - c > 1 ? u.add(p.tabKey) : h = Math.max(h, C);
    }
    l.style.maxWidth = d, t.value = u, n.value = u.size > 0 ? h : null;
  }
  function r() {
    s === null && (s = requestAnimationFrame(() => {
      s = null, i();
    }));
  }
  Re(
    () => xe(e.tabs),
    (l) => {
      const d = new Set(l.map((c) => c.key));
      if (t.value.size > 0) {
        const c = /* @__PURE__ */ new Set();
        for (const u of t.value) d.has(u) && c.add(u);
        for (const u of d) o.has(u) || c.add(u);
        t.value = c;
      }
      o = d, Xe(r);
    },
    { immediate: !0 }
  );
  const a = AS(r, c3e);
  return Hc(e.bar, () => void a()), ro(() => {
    s !== null && cancelAnimationFrame(s);
  }), {
    hiddenKeys: t,
    hasOverflow: D(() => t.value.size > 0),
    overflowTabs: D(() => {
      const l = t.value;
      if (l.size === 0) return [];
      const d = [];
      return xe(e.tabs).forEach((c, u) => {
        l.has(c.key) && d.push({ tab: c, originalIndex: u });
      }), d;
    }),
    containerStyle: D(() => n.value === null ? void 0 : { maxWidth: `${n.value}px` }),
    isHidden: (l) => l == null ? !1 : t.value.has(l),
    firstHiddenIndex: D(() => {
      const l = t.value;
      return l.size === 0 ? -1 : xe(e.tabs).findIndex((d) => l.has(d.key));
    }),
    remeasure: r
  };
}
const h3e = ["popovertarget", "test-id"], g3e = ["id"], p3e = /* @__PURE__ */ de({
  __name: "TabActions",
  props: {
    tab: {},
    index: {},
    variant: {},
    canRename: { type: Boolean },
    canRemove: { type: Boolean },
    readonly: { type: Boolean },
    editing: { type: Boolean },
    hasMenuSlot: { type: Boolean },
    deleteTitle: {},
    menuWidth: { default: void 0 },
    testId: { default: void 0 },
    menuClass: { default: void 0 },
    deleteClass: { default: void 0 }
  },
  emits: ["rename", "remove", "opened", "closed"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Es(), i = D(() => n.variant === "overflow" ? "16px" : "12px");
    return (r, a) => !e.readonly && !e.editing && e.hasMenuSlot && e.tab.hasMenu ? (v(), z(Yt, {
      key: 0,
      placement: "bottom-start",
      width: e.menuWidth,
      class: x(e.menuClass),
      onClick: a[0] || (a[0] = Ge(() => {
      }, ["stop"])),
      onOpened: a[1] || (a[1] = (l) => o("opened")),
      onClosed: a[2] || (a[2] = (l) => o("closed"))
    }, {
      trigger: Q(({ target: l, isOpen: d }) => [
        R("button", {
          class: x([r.$style.triggerBtn, { [r.$style.triggerOpen]: d }]),
          type: "button",
          popovertarget: l,
          "test-id": e.testId ? `${e.testId}-tab-menu-trigger-${e.tab.key}` : void 0
        }, [
          te(Fe, {
            icon: "phosphor/dots-three-circle",
            size: i.value,
            class: x(r.$style.hoveredIcon)
          }, null, 8, ["size", "class"])
        ], 10, h3e)
      ]),
      default: Q(({ popover: l }) => [
        ve(r.$slots, "tabMenu", {
          tab: e.tab,
          index: e.index,
          canRename: e.canRename,
          canRemove: e.canRemove,
          rename: () => o("rename"),
          remove: () => o("remove"),
          close: () => l == null ? void 0 : l.hidePopover()
        })
      ]),
      _: 3
    }, 8, ["width", "class"])) : e.canRemove ? (v(), y("button", {
      key: 1,
      id: T(s),
      type: "button",
      class: x([r.$style.removeBtn, e.deleteClass]),
      onClick: a[3] || (a[3] = Ge((l) => o("remove"), ["stop"]))
    }, [
      te(Fe, {
        icon: "phosphor/minus-circle",
        size: i.value,
        class: x(e.variant === "overflow" ? r.$style.rowIcon : r.$style.hoveredIcon)
      }, null, 8, ["size", "class"]),
      te(zt, {
        id: T(s),
        text: e.deleteTitle
      }, null, 8, ["id", "text"])
    ], 10, g3e)) : V("", !0);
  }
}), f3e = "_triggerBtn_1eowt_1", m3e = "_removeBtn_1eowt_11", v3e = "_hoveredIcon_1eowt_23", C3e = "_rowIcon_1eowt_29", w3e = "_triggerOpen_1eowt_40", y3e = {
  triggerBtn: f3e,
  removeBtn: m3e,
  hoveredIcon: v3e,
  rowIcon: C3e,
  triggerOpen: w3e
}, b3e = {
  $style: y3e
}, G2 = /* @__PURE__ */ we(p3e, [["__cssModules", b3e]]), S3e = /* @__PURE__ */ de({
  __name: "TabDot",
  props: {
    selected: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (v(), y("span", {
      class: x(t.$style.dotContainer)
    }, [
      R("span", {
        class: x([t.$style.dotMarker, { [t.$style.selected]: e.selected }])
      }, null, 2)
    ], 2));
  }
}), x3e = "_dotContainer_13kb3_1", R3e = "_dotMarker_13kb3_13", E3e = "_selected_13kb3_24", A3e = {
  dotContainer: x3e,
  dotMarker: R3e,
  selected: E3e
}, F3e = {
  $style: A3e
}, H2 = /* @__PURE__ */ we(S3e, [["__cssModules", F3e]]), M3e = ["data-text"], I3e = ["maxlength", "test-id"], P3e = /* @__PURE__ */ de({
  __name: "TabRenameInput",
  props: /* @__PURE__ */ dt({
    variant: {},
    invalid: { type: Boolean, default: !1 },
    maxLength: { default: void 0 },
    testId: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["commit", "cancel"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = lt(e, "modelValue"), s = tn("input");
    return Et(() => {
      var i, r;
      (i = s.value) == null || i.focus(), (r = s.value) == null || r.select();
    }), (i, r) => (v(), y("span", {
      class: x([i.$style.sizer, e.variant === "overflow" ? i.$style.overflowSizer : i.$style.stripSizer]),
      "data-text": o.value || " "
    }, [
      Tn(R("input", {
        ref: "input",
        "onUpdate:modelValue": r[0] || (r[0] = (a) => o.value = a),
        class: x([
          i.$style.input,
          e.variant === "overflow" ? i.$style.overflowInput : i.$style.stripInput,
          { [i.$style.invalid]: e.invalid }
        ]),
        type: "text",
        size: "1",
        maxlength: e.maxLength,
        "test-id": e.testId,
        onBlur: r[1] || (r[1] = (a) => n("commit")),
        onKeydown: [
          r[2] || (r[2] = Uo((a) => n("commit"), ["enter"])),
          r[3] || (r[3] = Uo((a) => n("cancel"), ["escape"]))
        ],
        onClick: r[4] || (r[4] = Ge(() => {
        }, ["stop"])),
        onDblclick: r[5] || (r[5] = Ge(() => {
        }, ["stop"]))
      }, null, 42, I3e), [
        [Qd, o.value]
      ])
    ], 10, M3e));
  }
}), D3e = "_sizer_12329_1", T3e = "_stripSizer_12329_21", k3e = "_overflowSizer_12329_29", L3e = "_input_12329_37", B3e = "_stripInput_12329_56", O3e = "_overflowInput_12329_63", G3e = "_invalid_12329_67", H3e = {
  sizer: D3e,
  stripSizer: T3e,
  overflowSizer: k3e,
  input: L3e,
  stripInput: B3e,
  overflowInput: O3e,
  invalid: G3e
}, V3e = {
  $style: H3e
}, V2 = /* @__PURE__ */ we(P3e, [["__cssModules", V3e]]), _3e = ["data-tab-key", "data-drag-id", "draggable"], N3e = ["disabled", "test-id"], $3e = ["id"], z3e = ["id", "data-text"], W3e = ["data-text"], U3e = /* @__PURE__ */ de({
  __name: "EditableTab",
  props: /* @__PURE__ */ dt({
    tab: {},
    index: {},
    state: {},
    hidden: { type: Boolean },
    menuOpen: { type: Boolean },
    hasMenuSlot: { type: Boolean },
    newTabLabel: {},
    deleteTitle: {},
    maxLabelLength: { default: void 0 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    editingLabel: { required: !0 },
    editingLabelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["select", "startEdit", "commitEdit", "cancelEdit", "remove", "menuOpened", "menuClosed"], ["update:editingLabel"]),
  setup(e, { emit: t }) {
    const n = e, o = t, s = lt(e, "editingLabel"), { t: i } = fn(), r = Es(), a = Es(), l = D(() => B2(n.tab, n.newTabLabel)), d = D(() => n.state.canRename && n.state.draggable);
    return (c, u) => (v(), y("div", {
      class: x([
        c.$style.tabItem,
        {
          [c.$style.selected]: e.state.selected,
          [c.$style.editing]: e.state.editing,
          [c.$style.invalid]: e.state.labelInvalid,
          [c.$style.tabItemMenuOpen]: e.menuOpen,
          [c.$style.hiddenTab]: e.hidden
        },
        e.state.dropIndicatorClass
      ]),
      "data-tab-key": e.tab.key,
      "data-drag-id": e.tab.key,
      draggable: e.state.draggable,
      onClick: u[9] || (u[9] = Ge(() => {
      }, ["stop"]))
    }, [
      e.state.externalDropTarget ? (v(), y("span", {
        key: 0,
        class: x(c.$style.externalDropOverlay),
        "aria-hidden": "true"
      }, null, 2)) : V("", !0),
      e.state.editing ? (v(), y(Se, { key: 2 }, [
        e.tab.icon ? (v(), y("span", {
          key: 0,
          class: x([
            c.$style.leadingIconWrapper,
            c.$style.editingLeadingIcon,
            { [c.$style.selected]: e.state.selected, [c.$style.invalid]: e.state.labelInvalid }
          ])
        }, [
          te(Fe, {
            icon: e.tab.icon,
            size: "16px",
            class: x(c.$style.leadingIcon)
          }, null, 8, ["icon", "class"])
        ], 2)) : V("", !0),
        te(V2, {
          modelValue: s.value,
          "onUpdate:modelValue": u[2] || (u[2] = (h) => s.value = h),
          variant: "strip",
          invalid: e.state.labelInvalid,
          "max-length": e.maxLabelLength,
          "test-id": e.testId ? `${e.testId}-tab-input-${e.tab.key}` : void 0,
          onCommit: u[3] || (u[3] = (h) => o("commitEdit")),
          onCancel: u[4] || (u[4] = (h) => o("cancelEdit"))
        }, null, 8, ["modelValue", "invalid", "max-length", "test-id"])
      ], 64)) : (v(), y("button", {
        key: 1,
        type: "button",
        class: x([c.$style.tabButton, { [c.$style.selected]: e.state.selected, [c.$style.disabledTab]: e.tab.disabled }]),
        disabled: e.tab.disabled,
        "test-id": e.testId ? `${e.testId}-tab-${e.tab.key}` : void 0,
        onClick: u[0] || (u[0] = (h) => !e.tab.disabled && o("select")),
        onDblclick: u[1] || (u[1] = (h) => !e.tab.disabled && o("startEdit"))
      }, [
        e.tab.icon ? (v(), y("span", {
          key: 0,
          id: e.tab.iconTitle ? T(r) : void 0,
          class: x(c.$style.leadingIconWrapper)
        }, [
          te(Fe, {
            icon: e.tab.icon,
            size: "16px",
            class: x(c.$style.leadingIcon)
          }, null, 8, ["icon", "class"]),
          e.tab.iconTitle ? (v(), z(zt, {
            key: 0,
            id: T(r),
            text: e.tab.iconTitle
          }, null, 8, ["id", "text"])) : V("", !0)
        ], 10, $3e)) : V("", !0),
        R("span", {
          id: d.value ? T(a) : void 0,
          class: x(c.$style.label),
          "data-text": l.value
        }, se(l.value), 11, z3e),
        d.value ? (v(), z(zt, {
          key: 1,
          id: T(a),
          text: T(i)("common.label.tabRenameReorderHint")
        }, null, 8, ["id", "text"])) : V("", !0),
        e.tab.labelSuffix ? (v(), y("span", {
          key: 2,
          class: x(c.$style.labelSuffix),
          "data-text": e.tab.labelSuffix
        }, se(e.tab.labelSuffix), 11, W3e)) : V("", !0),
        e.tab.dot ? (v(), z(H2, {
          key: 3,
          selected: e.state.selected
        }, null, 8, ["selected"])) : V("", !0)
      ], 42, N3e)),
      te(G2, {
        tab: e.tab,
        index: e.index,
        variant: "strip",
        "can-rename": e.state.canRename,
        "can-remove": e.state.canRemove,
        readonly: e.state.readonly,
        editing: e.state.editing,
        "has-menu-slot": e.hasMenuSlot,
        "menu-width": e.menuWidth,
        "delete-title": e.deleteTitle,
        "test-id": e.testId,
        "menu-class": c.$style.menuBtn,
        "delete-class": c.$style.deleteBtn,
        onRename: u[5] || (u[5] = (h) => o("startEdit")),
        onRemove: u[6] || (u[6] = (h) => o("remove")),
        onOpened: u[7] || (u[7] = (h) => o("menuOpened")),
        onClosed: u[8] || (u[8] = (h) => o("menuClosed"))
      }, {
        tabMenu: Q((h) => [
          ve(c.$slots, "tabMenu", pi(Sa(h)))
        ]),
        _: 3
      }, 8, ["tab", "index", "can-rename", "can-remove", "readonly", "editing", "has-menu-slot", "menu-width", "delete-title", "test-id", "menu-class", "delete-class"])
    ], 10, _3e));
  }
}), K3e = "_tabItem_i8vme_1", Z3e = "_selected_i8vme_14", q3e = "_editing_i8vme_17", j3e = "_invalid_i8vme_20", Y3e = "_deleteBtn_i8vme_23", Q3e = "_menuBtn_i8vme_23", J3e = "_tabButton_i8vme_28", X3e = "_disabledTab_i8vme_62", eFe = "_leadingIconWrapper_i8vme_67", tFe = "_editingLeadingIcon_i8vme_72", nFe = "_leadingIcon_i8vme_67", oFe = "_label_i8vme_89", sFe = "_labelSuffix_i8vme_105", iFe = "_externalDropOverlay_i8vme_122", rFe = "_hiddenTab_i8vme_134", aFe = "_tabItemMenuOpen_i8vme_161", lFe = {
  tabItem: K3e,
  selected: Z3e,
  editing: q3e,
  invalid: j3e,
  deleteBtn: Y3e,
  menuBtn: Q3e,
  tabButton: J3e,
  disabledTab: X3e,
  leadingIconWrapper: eFe,
  editingLeadingIcon: tFe,
  leadingIcon: nFe,
  label: oFe,
  labelSuffix: sFe,
  externalDropOverlay: iFe,
  hiddenTab: rFe,
  tabItemMenuOpen: aFe
}, dFe = {
  $style: lFe
}, cFe = /* @__PURE__ */ we(U3e, [["__cssModules", dFe]]), uFe = ["data-drag-id", "draggable"], hFe = /* @__PURE__ */ de({
  __name: "EditableTabOverflowRow",
  props: /* @__PURE__ */ dt({
    tab: {},
    index: {},
    state: {},
    hasMenuSlot: { type: Boolean },
    newTabLabel: {},
    deleteTitle: {},
    maxLabelLength: { default: void 0 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    editingLabel: { required: !0 },
    editingLabelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["select", "startEdit", "commitEdit", "cancelEdit", "remove"], ["update:editingLabel"]),
  setup(e, { emit: t }) {
    const n = e, o = t, s = lt(e, "editingLabel"), i = D(() => e3e(n.tab, n.newTabLabel)), r = W(!1);
    function a() {
      r.value = !1, o("startEdit");
    }
    return (l, d) => (v(), y("div", {
      class: x([
        l.$style.overflowItem,
        {
          [l.$style.overflowItemSelected]: e.state.selected,
          [l.$style.overflowItemDisabled]: e.tab.disabled,
          [l.$style.overflowItemMenuOpen]: r.value,
          [l.$style.externalDropTarget]: e.state.externalDropTarget
        },
        e.state.dropIndicatorClass
      ]),
      "data-drag-id": e.tab.key,
      draggable: e.state.draggable,
      onClick: d[6] || (d[6] = (c) => !e.tab.disabled && !e.state.editing && o("select")),
      onDblclick: d[7] || (d[7] = Ge((c) => !e.tab.disabled && o("startEdit"), ["prevent", "stop"]))
    }, [
      e.tab.icon ? (v(), z(Fe, {
        key: 0,
        icon: e.tab.icon,
        size: "16px",
        class: x([l.$style.leadingIcon, { [l.$style.editingIcon]: e.state.editing, [l.$style.invalidIcon]: e.state.labelInvalid }])
      }, null, 8, ["icon", "class"])) : V("", !0),
      e.state.editing ? (v(), z(V2, {
        key: 2,
        modelValue: s.value,
        "onUpdate:modelValue": d[0] || (d[0] = (c) => s.value = c),
        variant: "overflow",
        invalid: e.state.labelInvalid,
        "max-length": e.maxLabelLength,
        "test-id": e.testId ? `${e.testId}-tab-input-${e.tab.key}` : void 0,
        onCommit: d[1] || (d[1] = (c) => o("commitEdit")),
        onCancel: d[2] || (d[2] = (c) => o("cancelEdit"))
      }, null, 8, ["modelValue", "invalid", "max-length", "test-id"])) : (v(), y("span", {
        key: 1,
        class: x(l.$style.overflowItemLabel)
      }, [
        R("span", {
          class: x(l.$style.overflowItemLabelText)
        }, se(i.value), 3),
        e.tab.dot ? (v(), z(H2, {
          key: 0,
          selected: e.state.selected
        }, null, 8, ["selected"])) : V("", !0)
      ], 2)),
      te(G2, {
        tab: e.tab,
        index: e.index,
        variant: "overflow",
        "can-rename": e.state.canRename,
        "can-remove": e.state.canRemove,
        readonly: e.state.readonly,
        editing: e.state.editing,
        "has-menu-slot": e.hasMenuSlot,
        "menu-width": e.menuWidth,
        "delete-title": e.deleteTitle,
        "test-id": e.testId,
        "menu-class": l.$style.overflowRowMenu,
        "delete-class": l.$style.overflowRowBtn,
        onRename: a,
        onRemove: d[3] || (d[3] = (c) => o("remove")),
        onOpened: d[4] || (d[4] = (c) => r.value = !0),
        onClosed: d[5] || (d[5] = (c) => r.value = !1)
      }, {
        tabMenu: Q((c) => [
          ve(l.$slots, "tabMenu", pi(Sa(c)))
        ]),
        _: 3
      }, 8, ["tab", "index", "can-rename", "can-remove", "readonly", "editing", "has-menu-slot", "menu-width", "delete-title", "test-id", "menu-class", "delete-class"])
    ], 42, uFe));
  }
}), gFe = "_overflowItem_7extn_1", pFe = "_overflowItemSelected_7extn_26", fFe = "_overflowItemDisabled_7extn_31", mFe = "_overflowItemLabel_7extn_37", vFe = "_overflowItemLabelText_7extn_45", CFe = "_leadingIcon_7extn_52", wFe = "_editingIcon_7extn_57", yFe = "_invalidIcon_7extn_62", bFe = "_overflowRowMenu_7extn_67", SFe = "_overflowItemMenuOpen_7extn_82", xFe = "_overflowRowBtn_7extn_87", RFe = "_externalDropTarget_7extn_91", EFe = {
  overflowItem: gFe,
  overflowItemSelected: pFe,
  overflowItemDisabled: fFe,
  overflowItemLabel: mFe,
  overflowItemLabelText: vFe,
  leadingIcon: CFe,
  editingIcon: wFe,
  invalidIcon: yFe,
  overflowRowMenu: bFe,
  overflowItemMenuOpen: SFe,
  overflowRowBtn: xFe,
  externalDropTarget: RFe
}, AFe = {
  $style: EFe
}, FFe = /* @__PURE__ */ we(hFe, [["__cssModules", AFe]]), MFe = ["test-id"], IFe = 200, PFe = /* @__PURE__ */ de({
  __name: "EditableTabsOverflowMenu",
  props: /* @__PURE__ */ dt({
    rows: {},
    rowState: {},
    readonly: { type: Boolean },
    hasSelectedTab: { type: Boolean },
    hasMenuSlot: { type: Boolean },
    addMenu: { type: Boolean },
    addTabTitle: {},
    deleteTitle: {},
    newTabLabel: {},
    maxLabelLength: { default: void 0 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    editingLabel: { required: !0 },
    editingLabelModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["select", "startEdit", "commitEdit", "cancelEdit", "remove", "add", "rowDragStart", "rowDragOver", "rowDragLeave", "rowDrop", "rowDragEnd"], ["update:editingLabel"]),
  setup(e, { emit: t }) {
    const n = e, o = t, s = lt(e, "editingLabel"), i = W(), r = W(!1);
    function a() {
      var f;
      (f = i.value) == null || f.hideNow();
    }
    let l;
    function d() {
      l && (clearTimeout(l), l = void 0);
    }
    function c(f) {
      o("select", f), d(), l = setTimeout(a, IFe);
    }
    function u(f) {
      d(), o("startEdit", f);
    }
    io(d);
    function h(f) {
      a(), o("remove", f);
    }
    function g() {
      if (n.addMenu) {
        r.value = !r.value;
        return;
      }
      o("add");
    }
    function p() {
      r.value = !1;
    }
    return (f, m) => (v(), z(Yt, {
      ref_key: "dropdownRef",
      ref: i,
      "no-padding": "",
      placement: "bottom-end",
      onClick: m[4] || (m[4] = Ge(() => {
      }, ["stop"])),
      onClosed: m[5] || (m[5] = (C) => r.value = !1)
    }, {
      trigger: Q(({ target: C }) => [
        te(ut, {
          class: x({ [f.$style.triggerSelected]: e.hasSelectedTab }),
          size: "small",
          type: "ghost",
          appearance: "secondary",
          icon: "phosphor/dots-three",
          popovertarget: C,
          "test-id": e.testId ? `${e.testId}-overflow-trigger` : void 0
        }, null, 8, ["class", "popovertarget", "test-id"])
      ]),
      default: Q(() => [
        R("div", {
          class: x(f.$style.menu),
          style: Ke({ minWidth: e.menuWidth })
        }, [
          (v(!0), y(Se, null, We(e.rows, (C) => (v(), z(FFe, {
            key: C.tab.key,
            "editing-label": s.value,
            "onUpdate:editingLabel": m[0] || (m[0] = (w) => s.value = w),
            tab: C.tab,
            index: C.originalIndex,
            state: e.rowState(C.tab, C.originalIndex),
            "has-menu-slot": e.hasMenuSlot,
            "new-tab-label": e.newTabLabel,
            "delete-title": e.deleteTitle,
            "max-label-length": e.maxLabelLength,
            "menu-width": e.menuWidth,
            "test-id": e.testId,
            onSelect: (w) => c(C.originalIndex),
            onStartEdit: (w) => u(C.originalIndex),
            onCommitEdit: m[1] || (m[1] = (w) => o("commitEdit")),
            onCancelEdit: m[2] || (m[2] = (w) => o("cancelEdit")),
            onRemove: (w) => h(C.originalIndex),
            onDragstart: (w) => o("rowDragStart", w, C.originalIndex),
            onDragover: (w) => o("rowDragOver", w, C.originalIndex),
            onDragleave: (w) => o("rowDragLeave", w, C.originalIndex),
            onDrop: Ge((w) => o("rowDrop", w, C.originalIndex), ["stop", "prevent"]),
            onDragend: m[3] || (m[3] = (w) => o("rowDragEnd"))
          }, {
            tabMenu: Q((w) => [
              ve(f.$slots, "tabMenu", at({ ref_for: !0 }, w))
            ]),
            _: 3
          }, 8, ["editing-label", "tab", "index", "state", "has-menu-slot", "new-tab-label", "delete-title", "max-label-length", "menu-width", "test-id", "onSelect", "onStartEdit", "onRemove", "onDragstart", "onDragover", "onDragleave", "onDrop"]))), 128)),
          e.readonly ? V("", !0) : (v(), z(ba, {
            key: 0,
            appearance: "border",
            class: x(f.$style.divider)
          }, null, 8, ["class"])),
          e.readonly ? V("", !0) : (v(), y("div", {
            key: 1,
            class: x(f.$style.addItem),
            "test-id": e.testId ? `${e.testId}-overflow-add` : void 0,
            onClick: Ge(g, ["stop"])
          }, [
            te(Fe, {
              icon: "phosphor/plus",
              size: "16px"
            }),
            R("span", null, se(e.addTabTitle), 1)
          ], 10, MFe)),
          !e.readonly && e.addMenu && r.value ? (v(), y(Se, { key: 2 }, [
            te(ba, {
              appearance: "border",
              class: x(f.$style.divider)
            }, null, 8, ["class"]),
            R("div", {
              class: x(f.$style.addMenu)
            }, [
              ve(f.$slots, "addMenu", { close: p })
            ], 2)
          ], 64)) : V("", !0)
        ], 6)
      ]),
      _: 3
    }, 512));
  }
}), DFe = "_triggerSelected_npyfu_1", TFe = "_menu_npyfu_6", kFe = "_divider_npyfu_14", LFe = "_addMenu_npyfu_18", BFe = "_addItem_npyfu_25", OFe = {
  triggerSelected: DFe,
  menu: TFe,
  divider: kFe,
  addMenu: LFe,
  addItem: BFe
}, GFe = {
  $style: OFe
}, HFe = /* @__PURE__ */ we(PFe, [["__cssModules", GFe]]), VFe = ["id", "popovertarget", "test-id"], _Fe = ["id", "test-id"], NFe = /* @__PURE__ */ de({
  __name: "SCATabsBar",
  props: /* @__PURE__ */ dt({
    modelValue: {},
    selectedIndex: {},
    readonly: { type: Boolean, default: !1 },
    newTabLabel: { default: void 0 },
    addTabTitle: { default: void 0 },
    deleteTabTitle: { default: void 0 },
    beforeRemoveTab: { type: Function, default: void 0 },
    validateLabel: { type: Function, default: void 0 },
    maxLabelLength: { default: void 0 },
    addMenu: { type: Boolean, default: !1 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 },
    externalDropTargetKey: { default: null }
  }, {
    pendingEditKey: { default: null },
    pendingEditKeyModifiers: {},
    editingInvalid: { type: Boolean, default: !1 },
    editingInvalidModifiers: {}
  }),
  emits: /* @__PURE__ */ dt(["update:modelValue", "update:selectedIndex", "rename-tab", "reorder-tab", "remove-tab", "invalid-commit", "external-drag-over", "external-drag-leave", "external-drop"], ["update:pendingEditKey", "update:editingInvalid"]),
  setup(e, { emit: t }) {
    const n = t, { t: o } = fn(), s = e, i = lt(e, "pendingEditKey"), r = lt(e, "editingInvalid"), a = D(() => s.newTabLabel ?? o("common.label.tabLabel")), l = D(() => s.addTabTitle ?? o("common.action.addTab2")), d = D(() => s.deleteTabTitle ?? o("common.action.removeTab")), c = tn("bar"), u = tn("container"), h = Es(), g = Es();
    let p = 0;
    const f = () => s.modelValue, m = D(() => XAe(s.modelValue)), { hasOverflow: C, overflowTabs: w, containerStyle: b, isHidden: A, firstHiddenIndex: S, remeasure: F } = u3e({
      tabs: f,
      bar: () => c.value,
      container: () => u.value
    }), { addTab: E, removeTab: M, renameTab: I, reorderTabs: P } = d3e({
      tabs: f,
      selectedIndex: () => s.selectedIndex,
      newTabLabel: a,
      beforeRemoveTab: () => s.beforeRemoveTab,
      createKey: () => `${g}-tab-${++p}`,
      emits: {
        updateTabs: (ee) => n("update:modelValue", ee),
        selectTab: (ee) => n("update:selectedIndex", ee),
        renamed: (ee) => n("rename-tab", ee),
        reordered: (ee) => n("reorder-tab", ee),
        removed: (ee) => n("remove-tab", ee)
      }
    }), { editingKey: k, editingLabel: B, invalidKey: j, isEditing: N, startEdit: re, queueRename: H, commitEdit: _, cancelEdit: ne } = i3e({
      tabs: f,
      readonly: () => s.readonly,
      pendingEditKey: i,
      onRename: I,
      validateLabel: (ee, ae) => {
        const _e = s.modelValue[ee];
        return !s.validateLabel || s.validateLabel({ index: ee, key: _e.key, label: ae });
      },
      onInvalidCommit: (ee, ae) => {
        const _e = s.modelValue[ee];
        n("invalid-commit", { index: ee, key: _e.key, label: ae });
      },
      onLabelResize: (ee) => {
        A(ee) || F();
      }
    });
    function ce(ee) {
      k.value === null && n("update:selectedIndex", ee);
    }
    jd(() => {
      r.value = j.value !== null;
    });
    const { isDragging: me, dropIndicatorClass: Ie, onDragStart: L, onDragOver: oe, onDrop: K, onDragEnd: G, onBarDragOver: le, onBarDrop: be } = a3e({
      tabs: f,
      readonly: () => s.readonly,
      isHidden: A,
      firstHiddenIndex: () => S.value,
      onReorder: P,
      container: () => c.value
    });
    function Me(ee, ae) {
      const _e = s.modelValue[ae];
      return _e ? { event: ee, index: ae, key: _e.key } : null;
    }
    function Be(ee, ae) {
      if (me.value) {
        ee.preventDefault(), oe(ee, ae);
        return;
      }
      const _e = Me(ee, ae);
      _e && n("external-drag-over", _e);
    }
    function qe(ee, ae) {
      if (me.value) return;
      const _e = Me(ee, ae);
      _e && n("external-drag-leave", _e);
    }
    function he(ee, ae) {
      if (me.value) {
        K(ae);
        return;
      }
      const _e = Me(ee, ae);
      _e && n("external-drop", _e);
    }
    const Pe = W(null);
    function J(ee) {
      Pe.value === ee && (Pe.value = null);
    }
    function Y(ee) {
      const ae = s.modelValue[ee];
      ae && Pe.value === ae.key && (Pe.value = null), re(ee);
    }
    function q(ee, ae) {
      const _e = N(ee.key), Ne = s.readonly;
      return {
        selected: s.selectedIndex === ae,
        editing: _e,
        labelInvalid: j.value === ee.key,
        readonly: Ne,
        draggable: n3e(ee, { readonly: Ne, isEditing: _e }),
        canRename: O2(ee, { readonly: Ne }),
        canRemove: !_e && t3e(ee, {
          readonly: Ne,
          tabCount: s.modelValue.length,
          hasFixedTabs: m.value
        }),
        dropIndicatorClass: Ie(ee.key) ?? null,
        externalDropTarget: s.externalDropTargetKey === ee.key
      };
    }
    function ge() {
      H(E());
    }
    function ie(ee) {
      M(ee);
    }
    return (ee, ae) => {
      var _e;
      return v(), y("div", {
        ref: "bar",
        class: x(ee.$style.tabsBar),
        onDragover: ae[6] || (ae[6] = //@ts-ignore
        (...Ne) => T(le) && T(le)(...Ne)),
        onDrop: ae[7] || (ae[7] = Ge(
          //@ts-ignore
          (...Ne) => T(be) && T(be)(...Ne),
          ["prevent"]
        ))
      }, [
        R("div", {
          class: x(ee.$style.tabsClip)
        }, [
          R("div", {
            ref: "container",
            class: x(ee.$style.tabsContainer),
            style: Ke(T(b))
          }, [
            (v(!0), y(Se, null, We(e.modelValue, (Ne, At) => (v(), z(cFe, {
              key: Ne.key,
              "editing-label": T(B),
              "onUpdate:editingLabel": ae[0] || (ae[0] = (pt) => Yo(B) ? B.value = pt : null),
              tab: Ne,
              index: At,
              state: q(Ne, At),
              hidden: T(A)(Ne.key),
              "menu-open": Pe.value === Ne.key,
              "has-menu-slot": !!ee.$slots.tabMenu,
              "new-tab-label": a.value,
              "delete-title": d.value,
              "max-label-length": e.maxLabelLength,
              "menu-width": e.menuWidth,
              "test-id": e.testId,
              onSelect: (pt) => ce(At),
              onStartEdit: (pt) => Y(At),
              onCommitEdit: T(_),
              onCancelEdit: T(ne),
              onRemove: (pt) => ie(At),
              onMenuOpened: (pt) => Pe.value = Ne.key,
              onMenuClosed: (pt) => J(Ne.key),
              onDragstart: (pt) => T(L)(pt, At),
              onDragover: (pt) => Be(pt, At),
              onDragleave: (pt) => qe(pt, At),
              onDrop: Ge((pt) => he(pt, At), ["stop", "prevent"]),
              onDragend: T(G)
            }, {
              tabMenu: Q((pt) => [
                ve(ee.$slots, "tabMenu", at({ ref_for: !0 }, pt))
              ]),
              _: 3
            }, 8, ["editing-label", "tab", "index", "state", "hidden", "menu-open", "has-menu-slot", "new-tab-label", "delete-title", "max-label-length", "menu-width", "test-id", "onSelect", "onStartEdit", "onCommitEdit", "onCancelEdit", "onRemove", "onMenuOpened", "onMenuClosed", "onDragstart", "onDragover", "onDragleave", "onDrop", "onDragend"]))), 128))
          ], 6)
        ], 2),
        T(C) ? (v(), z(HFe, {
          key: 0,
          "editing-label": T(B),
          "onUpdate:editingLabel": ae[1] || (ae[1] = (Ne) => Yo(B) ? B.value = Ne : null),
          rows: T(w),
          "row-state": q,
          readonly: e.readonly,
          "has-selected-tab": T(A)((_e = e.modelValue[e.selectedIndex]) == null ? void 0 : _e.key),
          "has-menu-slot": !!ee.$slots.tabMenu,
          "add-menu": e.addMenu,
          "add-tab-title": l.value,
          "delete-title": d.value,
          "new-tab-label": a.value,
          "max-label-length": e.maxLabelLength,
          "menu-width": e.menuWidth,
          "test-id": e.testId,
          onSelect: ae[2] || (ae[2] = (Ne) => ce(Ne)),
          onStartEdit: ae[3] || (ae[3] = (Ne) => T(re)(Ne)),
          onCommitEdit: T(_),
          onCancelEdit: T(ne),
          onRemove: ae[4] || (ae[4] = (Ne) => ie(Ne)),
          onAdd: ge,
          onRowDragStart: T(L),
          onRowDragOver: Be,
          onRowDragLeave: qe,
          onRowDrop: he,
          onRowDragEnd: T(G)
        }, {
          tabMenu: Q((Ne) => [
            ve(ee.$slots, "tabMenu", pi(Sa(Ne)))
          ]),
          addMenu: Q((Ne) => [
            ve(ee.$slots, "addMenu", pi(Sa(Ne)))
          ]),
          _: 3
        }, 8, ["editing-label", "rows", "readonly", "has-selected-tab", "has-menu-slot", "add-menu", "add-tab-title", "delete-title", "new-tab-label", "max-label-length", "menu-width", "test-id", "onCommitEdit", "onCancelEdit", "onRowDragStart", "onRowDragEnd"])) : V("", !0),
        !e.readonly && !T(C) && e.addMenu ? (v(), z(Yt, {
          key: 1,
          placement: "bottom-start",
          width: e.menuWidth,
          class: x(ee.$style.addDropdown),
          onClick: ae[5] || (ae[5] = Ge(() => {
          }, ["stop"]))
        }, {
          trigger: Q(({ target: Ne, isOpen: At }) => [
            R("button", {
              id: T(h),
              class: x([ee.$style.addBtn, { [ee.$style.triggerOpen]: At }]),
              type: "button",
              popovertarget: Ne,
              "test-id": e.testId ? `${e.testId}-add` : void 0
            }, [
              te(Fe, {
                icon: "phosphor/plus-circle",
                size: "12px",
                class: x(ee.$style.hoveredIcon)
              }, null, 8, ["class"]),
              te(zt, {
                id: T(h),
                text: l.value
              }, null, 8, ["id", "text"])
            ], 10, VFe)
          ]),
          default: Q(({ popover: Ne }) => [
            ve(ee.$slots, "addMenu", {
              close: () => Ne == null ? void 0 : Ne.hidePopover()
            })
          ]),
          _: 3
        }, 8, ["width", "class"])) : !e.readonly && !T(C) ? (v(), y("button", {
          key: 2,
          id: T(h),
          class: x(ee.$style.addBtn),
          type: "button",
          "test-id": e.testId ? `${e.testId}-add` : void 0,
          onClick: Ge(ge, ["stop"])
        }, [
          te(Fe, {
            icon: "phosphor/plus-circle",
            size: "12px",
            class: x(ee.$style.hoveredIcon)
          }, null, 8, ["class"]),
          te(zt, {
            id: T(h),
            text: l.value
          }, null, 8, ["id", "text"])
        ], 10, _Fe)) : V("", !0)
      ], 34);
    };
  }
}), $Fe = "_tabsBar_i50em_1", zFe = "_tabsClip_i50em_10", WFe = "_tabsContainer_i50em_20", UFe = "_addBtn_i50em_28", KFe = "_hoveredIcon_i50em_41", ZFe = "_triggerOpen_i50em_53", qFe = "_addDropdown_i50em_68", jFe = {
  tabsBar: $Fe,
  tabsClip: zFe,
  tabsContainer: WFe,
  addBtn: UFe,
  hoveredIcon: KFe,
  triggerOpen: ZFe,
  addDropdown: qFe
}, YFe = {
  $style: jFe
}, bIe = /* @__PURE__ */ we(NFe, [["__cssModules", YFe]]);
var bn = /* @__PURE__ */ ((e) => (e.EMAIL = "email", e.PHONE = "phone", e.ADDRESS = "address", e.TEMPLATE = "template", e.PARENT = "parent", e.OTHER = "other", e))(bn || {});
const QFe = ["href"], JFe = ["src", "alt"], XFe = /* @__PURE__ */ de({
  __name: "SCADetailsTooltip",
  props: {
    visible: { type: Boolean },
    content: {},
    targetRect: {},
    placement: {},
    loading: { type: Boolean },
    avatarType: {},
    instant: { type: Boolean },
    onMouseEnter: { type: Function },
    onMouseLeave: { type: Function },
    onNavigate: { type: Function },
    href: {}
  },
  emits: ["mouseEnter", "mouseLeave"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = W(!1), i = D(() => (n.avatarType ?? "initials") === "special" && !u()), r = () => {
      s.value = !0;
    }, a = () => {
      s.value = !1;
    }, l = (N) => {
      switch (N) {
        case bn.EMAIL:
          return "phosphor/envelope";
        case bn.PHONE:
          return "phosphor/phone";
        case bn.ADDRESS:
          return "phosphor/map-pin-simple-area";
        case bn.TEMPLATE:
          return "phosphor/notebook";
        case bn.PARENT:
          return "phosphor/tree-view";
        default:
          return "phosphor/clipboard-text";
      }
    }, d = (N) => {
      switch (N.type) {
        case bn.EMAIL:
          return {
            render: () => vo("a", { href: N.href ?? `mailto:${N.text}` }, N.text)
          };
        case bn.PHONE:
          return {
            render: () => vo("a", { href: `tel:${N.text}` }, N.text)
          };
        case bn.ADDRESS:
          return {
            render: () => {
              const re = Array.isArray(N.text) ? N.text.filter(Boolean) : [N.text], H = re.join(", ");
              return vo(
                "a",
                {
                  href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(H)}`,
                  target: "_blank",
                  rel: "noopener noreferrer"
                },
                re.map((_, ne) => ne < re.length - 1 ? [_, vo("br")] : _)
              );
            }
          };
        default:
          return {
            render: () => vo("div", N.text)
          };
      }
    }, c = () => n.loading ? "" : n.content.title, u = () => n.loading ? void 0 : n.content.avatarUrl, h = () => n.loading ? void 0 : n.content.avatarColorIdx, g = D(() => n.loading ? void 0 : n.content.defaultModuleIcon), p = async () => {
      var N;
      await ((N = n.onNavigate) == null ? void 0 : N.call(n));
    }, f = (N, re) => {
      N.stopPropagation(), re.action && (N.defaultPrevented || N.button !== 0 || N.metaKey || N.ctrlKey || N.shiftKey || N.altKey || (N.preventDefault(), re.action()));
    }, m = W(null), C = W(null), w = W({ position: "absolute", top: "0", left: "0" }), b = W({ position: "absolute", top: "0", left: "0" }), A = W(null);
    let S = null;
    const F = () => {
      E();
    }, E = async () => {
      if (!m.value || !A.value) return;
      const { x: N, y: re, middlewareData: H, placement: _ } = await bS(A.value, m.value, {
        placement: n.placement,
        middleware: [
          CS({ mainAxis: 14, crossAxis: -20 }),
          yS(),
          wS({ padding: 0 }),
          SU({ element: C.value })
        ]
      });
      w.value = {
        position: "absolute",
        top: `${re}px`,
        left: `${N}px`
      };
      const ne = H.arrow;
      if (ne) {
        const { x: ce, y: me } = ne, Ie = _.split("-")[0], L = M(Ie), oe = I(Ie);
        b.value = {
          position: "absolute",
          left: ce != null ? `${ce}px` : "",
          top: me != null ? `${me}px` : "",
          [L]: "-8px",
          transform: `rotate(${oe}deg)`
        };
      }
    }, M = (N) => {
      switch (N.split("-")[0]) {
        case "top":
          return "bottom";
        case "bottom":
          return "top";
        case "left":
          return "right";
        case "right":
          return "left";
        default:
          return "bottom";
      }
    }, I = (N) => {
      switch (N) {
        case "top":
          return 0;
        case "bottom":
          return 180;
        case "left":
          return 90;
        case "right":
          return -90;
        default:
          return 0;
      }
    };
    Re(
      () => n.visible,
      async (N) => {
        N ? (n.targetRect && (A.value = {
          getBoundingClientRect: () => n.targetRect
        }), await E(), m.value && A.value && (await Xe(), S = ng(A.value, m.value, F)), document.addEventListener("click", B)) : (A.value = null, S && S(), document.removeEventListener("click", B));
      }
    );
    const P = () => {
      n.onMouseEnter(), o("mouseEnter");
    }, k = () => {
      n.onMouseLeave(), o("mouseLeave");
    }, B = (N) => {
      m.value && !m.value.contains(N.target) && n.onMouseLeave();
    }, j = (N) => [
      bn.EMAIL,
      bn.PHONE,
      bn.ADDRESS
    ].includes(N.type) || !!N.action;
    return Et(async () => {
      n.visible && n.targetRect && (A.value = {
        getBoundingClientRect: () => n.targetRect
      }, await E(), m.value && A.value && (await Xe(), S = ng(A.value, m.value, F)), document.addEventListener("click", B));
    }), ks(() => {
      A.value = null, S && S(), document.removeEventListener("click", B);
    }), (N, re) => (v(), z(qi, { to: "body" }, [
      te(ad, {
        name: e.instant ? "tooltip-instant" : "tooltip-fade",
        appear: ""
      }, {
        default: Q(() => {
          var H, _;
          return [
            e.visible && !e.loading ? (v(), y("div", {
              key: 0,
              ref_key: "popoverRef",
              ref: m,
              class: x(N.$style.popover),
              style: Ke(w.value),
              onMouseenter: P,
              onMouseleave: k
            }, [
              R("a", {
                class: x([N.$style.avatarAndTitle, { [N.$style.withBorder]: (_ = (H = e.content) == null ? void 0 : H.items) == null ? void 0 : _.length }]),
                href: n.href || void 0,
                role: "link",
                onClick: Ge(p, ["prevent"]),
                onMouseenter: r,
                onMouseleave: a
              }, [
                i.value ? (v(), y(Se, { key: 0 }, [
                  e.content.specialIcon ? (v(), z(Fe, {
                    key: 0,
                    class: x(N.$style.specAvatarIcon),
                    icon: e.content.specialIcon,
                    size: "80px"
                  }, null, 8, ["class", "icon"])) : V("", !0)
                ], 64)) : (v(), z(Li, {
                  key: 1,
                  initials: T(fd)(c()),
                  "color-idx": h(),
                  shape: "rounded",
                  size: "80",
                  bordered: !!u(),
                  hovered: s.value
                }, {
                  default: Q(() => [
                    u() ? (v(), y("img", {
                      key: 0,
                      src: u(),
                      alt: c(),
                      loading: "lazy"
                    }, null, 8, JFe)) : !c() && g.value ? (v(), z(Fe, {
                      key: 1,
                      icon: g.value,
                      size: "36px"
                    }, null, 8, ["icon"])) : V("", !0)
                  ]),
                  _: 1
                }, 8, ["initials", "color-idx", "bordered", "hovered"])),
                R("div", {
                  class: x(N.$style.title)
                }, se(c()), 3)
              ], 42, QFe),
              e.content.items.length ? (v(), y("div", {
                key: 0,
                class: x(N.$style.content)
              }, [
                (v(!0), y(Se, null, We(e.content.items, (ne, ce) => (v(), y("div", {
                  key: ce,
                  class: x([N.$style.contentItem, { [N.$style.interactive]: j(ne) }])
                }, [
                  R("div", {
                    class: x(N.$style.itemIconContainer)
                  }, [
                    te(Fe, {
                      class: x(N.$style.itemIcon),
                      icon: l(ne.type)
                    }, null, 8, ["class", "icon"])
                  ], 2),
                  (v(), z(Ot(d(ne)), {
                    item: ne,
                    class: x([
                      N.$style.itemText,
                      {
                        [N.$style.nowrap]: ne.type === T(bn).EMAIL || ne.type === T(bn).PHONE,
                        [N.$style.hasAction]: j(ne)
                      }
                    ]),
                    onClick: (me) => f(me, ne)
                  }, null, 8, ["item", "class", "onClick"]))
                ], 2))), 128))
              ], 2)) : V("", !0),
              R("div", {
                ref_key: "arrowRef",
                ref: C,
                class: x(N.$style.arrow),
                style: Ke(b.value)
              }, null, 6)
            ], 38)) : V("", !0)
          ];
        }),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), eMe = "_popover_7rvs6_2", tMe = "_arrow_7rvs6_18", nMe = "_avatarAndTitle_7rvs6_27", oMe = "_specAvatarIcon_7rvs6_40", sMe = "_withBorder_7rvs6_45", iMe = "_title_7rvs6_49", rMe = "_content_7rvs6_61", aMe = "_contentItem_7rvs6_71", lMe = "_itemIconContainer_7rvs6_78", dMe = "_itemIcon_7rvs6_78", cMe = "_interactive_7rvs6_92", uMe = "_itemText_7rvs6_96", hMe = "_hasAction_7rvs6_122", gMe = "_nowrap_7rvs6_128", pMe = {
  popover: eMe,
  arrow: tMe,
  avatarAndTitle: nMe,
  specAvatarIcon: oMe,
  withBorder: sMe,
  title: iMe,
  content: rMe,
  contentItem: aMe,
  itemIconContainer: lMe,
  itemIcon: dMe,
  interactive: cMe,
  itemText: uMe,
  hasAction: hMe,
  nowrap: gMe
}, fMe = {
  $style: pMe
}, SIe = /* @__PURE__ */ we(XFe, [["__cssModules", fMe]]), xIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  ybe as $,
  nbe as A,
  eIe as B,
  zf as C,
  R8 as D,
  Zt as E,
  De as F,
  SMe as G,
  tIe as H,
  Ts as I,
  oIe as J,
  KMe as K,
  WMe as L,
  ya as M,
  Zfe as N,
  SIe as O,
  dwe as P,
  sIe as Q,
  Ade as R,
  lg as S,
  ZMe as T,
  iIe as U,
  Iwe as V,
  qMe as W,
  Nl as X,
  Gr as Y,
  q8e as Z,
  we as _,
  abe as a,
  nv as a$,
  Fi as a0,
  jMe as a1,
  YMe as a2,
  zc as a3,
  Ghe as a4,
  rl as a5,
  rIe as a6,
  ll as a7,
  aIe as a8,
  lIe as a9,
  qCe as aA,
  Yv as aB,
  RMe as aC,
  AMe as aD,
  EMe as aE,
  zMe as aF,
  b2 as aG,
  PMe as aH,
  r8 as aI,
  GMe as aJ,
  TMe as aK,
  DMe as aL,
  b8 as aM,
  g8 as aN,
  y8 as aO,
  kMe as aP,
  BR as aQ,
  NMe as aR,
  _Me as aS,
  hf as aT,
  LS as aU,
  IS as aV,
  pwe as aW,
  BMe as aX,
  b1 as aY,
  MMe as aZ,
  xIe as a_,
  dIe as aa,
  cIe as ab,
  uIe as ac,
  QS as ad,
  hIe as ae,
  JMe as af,
  bf as ag,
  p2 as ah,
  gIe as ai,
  dg as aj,
  vIe as ak,
  CIe as al,
  wIe as am,
  L2 as an,
  pIe as ao,
  yIe as ap,
  bIe as aq,
  no as ar,
  gi as as,
  ZCe as at,
  JS as au,
  fIe as av,
  mIe as aw,
  xv as ax,
  tbe as ay,
  lbe as az,
  ba as b,
  to as b0,
  oo as b1,
  FMe as b2,
  y1 as b3,
  xMe as b4,
  fi as b5,
  bMe as b6,
  OMe as b7,
  LMe as b8,
  Vc as b9,
  Xx as ba,
  WR as bb,
  PS as bc,
  $Me as bd,
  N1 as be,
  gf as bf,
  yMe as bg,
  Nc as bh,
  $c as bi,
  HMe as bj,
  wf as bk,
  Cf as bl,
  VMe as bm,
  Gae as bn,
  Fve as bo,
  Yt as c,
  Fe as d,
  ut as e,
  zt as f,
  wCe as g,
  vf as h,
  sbe as i,
  nIe as j,
  b6e as k,
  g6e as l,
  Wc as m,
  Ube as n,
  Tv as o,
  AS as p,
  E8 as q,
  bn as r,
  QMe as s,
  B1 as t,
  IMe as u,
  Ea as v,
  qve as w,
  XMe as x,
  Li as y,
  UMe as z
};
